webpackJsonp([18],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Created by andrey on 07.06.16.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	//Common
	__webpack_require__(2887);


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(206), __webpack_require__(222), __webpack_require__(236), __webpack_require__(240), __webpack_require__(211)) :
		typeof define === 'function' && define.amd ? define('@angular/core', ['exports', 'rxjs/Observable', 'rxjs/observable/merge', 'rxjs/operator/share', 'rxjs/Subject', 'rxjs/Subscription'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.core = {}),global.Rx,global.Rx.Observable,global.Rx.Observable.prototype,global.Rx,global.Rx));
	}(this, (function (exports,rxjs_Observable,rxjs_observable_merge,rxjs_operator_share,rxjs_Subject,rxjs_Subscription) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Creates a token that can be used in a DI Provider.
	 *
	 * Use an `InjectionToken` whenever the type you are injecting is not reified (does not have a
	 * runtime representation) such as when injecting an interface, callable type, array or
	 * parametrized type.
	 *
	 * `InjectionToken` is parameterized on `T` which is the type of object which will be returned by
	 * the `Injector`. This provides additional level of type safety.
	 *
	 * ```
	 * interface MyInterface {...}
	 * var myInterface = injector.get(new InjectionToken<MyInterface>('SomeToken'));
	 * // myInterface is inferred to be MyInterface.
	 * ```
	 *
	 * ### Example
	 *
	 * {\@example core/di/ts/injector_spec.ts region='InjectionToken'}
	 *
	 * \@stable
	 * @template T
	 */
	var InjectionToken = /** @class */ (function () {
	    function InjectionToken(_desc) {
	        this._desc = _desc;
	        /**
	         * \@internal
	         */
	        this.ngMetadataName = 'InjectionToken';
	    }
	    /**
	     * @return {?}
	     */
	    InjectionToken.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return "InjectionToken " + this._desc; };
	    return InjectionToken;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An interface implemented by all Angular type decorators, which allows them to be used as ES7
	 * decorators as well as
	 * Angular DSL syntax.
	 *
	 * ES7 syntax:
	 *
	 * ```
	 * \@ng.Component({...})
	 * class MyClass {...}
	 * ```
	 * \@stable
	 * @record
	 */
	
	var ANNOTATIONS = '__annotations__';
	var PARAMETERS = '__paramaters__';
	var PROP_METADATA = '__prop__metadata__';
	/**
	 * @suppress {globalThis}
	 * @param {?} name
	 * @param {?=} props
	 * @param {?=} parentClass
	 * @param {?=} chainFn
	 * @return {?}
	 */
	function makeDecorator(name, props, parentClass, chainFn) {
	    var /** @type {?} */ metaCtor = makeMetadataCtor(props);
	    /**
	     * @param {?} objOrType
	     * @return {?}
	     */
	    function DecoratorFactory(objOrType) {
	        if (this instanceof DecoratorFactory) {
	            metaCtor.call(this, objOrType);
	            return this;
	        }
	        var /** @type {?} */ annotationInstance = new (/** @type {?} */ (DecoratorFactory))(objOrType);
	        var /** @type {?} */ TypeDecorator = /** @type {?} */ (function TypeDecorator(cls) {
	            // Use of Object.defineProperty is important since it creates non-enumerable property which
	            // prevents the property is copied during subclassing.
	            var /** @type {?} */ annotations = cls.hasOwnProperty(ANNOTATIONS) ?
	                (/** @type {?} */ (cls))[ANNOTATIONS] :
	                Object.defineProperty(cls, ANNOTATIONS, { value: [] })[ANNOTATIONS];
	            annotations.push(annotationInstance);
	            return cls;
	        });
	        if (chainFn)
	            chainFn(TypeDecorator);
	        return TypeDecorator;
	    }
	    if (parentClass) {
	        DecoratorFactory.prototype = Object.create(parentClass.prototype);
	    }
	    DecoratorFactory.prototype.ngMetadataName = name;
	    (/** @type {?} */ (DecoratorFactory)).annotationCls = DecoratorFactory;
	    return /** @type {?} */ (DecoratorFactory);
	}
	/**
	 * @param {?=} props
	 * @return {?}
	 */
	function makeMetadataCtor(props) {
	    return function ctor() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (props) {
	            var /** @type {?} */ values = props.apply(void 0, args);
	            for (var /** @type {?} */ propName in values) {
	                this[propName] = values[propName];
	            }
	        }
	    };
	}
	/**
	 * @param {?} name
	 * @param {?=} props
	 * @param {?=} parentClass
	 * @return {?}
	 */
	function makeParamDecorator(name, props, parentClass) {
	    var /** @type {?} */ metaCtor = makeMetadataCtor(props);
	    /**
	     * @param {...?} args
	     * @return {?}
	     */
	    function ParamDecoratorFactory() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (this instanceof ParamDecoratorFactory) {
	            metaCtor.apply(this, args);
	            return this;
	        }
	        var /** @type {?} */ annotationInstance = new ((_a = (/** @type {?} */ (ParamDecoratorFactory))).bind.apply(_a, [void 0].concat(args)))();
	        (/** @type {?} */ (ParamDecorator)).annotation = annotationInstance;
	        return ParamDecorator;
	        /**
	         * @param {?} cls
	         * @param {?} unusedKey
	         * @param {?} index
	         * @return {?}
	         */
	        function ParamDecorator(cls, unusedKey, index) {
	            // Use of Object.defineProperty is important since it creates non-enumerable property which
	            // prevents the property is copied during subclassing.
	            var /** @type {?} */ parameters = cls.hasOwnProperty(PARAMETERS) ?
	                (/** @type {?} */ (cls))[PARAMETERS] :
	                Object.defineProperty(cls, PARAMETERS, { value: [] })[PARAMETERS];
	            // there might be gaps if some in between parameters do not have annotations.
	            // we pad with nulls.
	            while (parameters.length <= index) {
	                parameters.push(null);
	            }
	            (parameters[index] = parameters[index] || []).push(annotationInstance);
	            return cls;
	        }
	        var _a;
	    }
	    if (parentClass) {
	        ParamDecoratorFactory.prototype = Object.create(parentClass.prototype);
	    }
	    ParamDecoratorFactory.prototype.ngMetadataName = name;
	    (/** @type {?} */ (ParamDecoratorFactory)).annotationCls = ParamDecoratorFactory;
	    return ParamDecoratorFactory;
	}
	/**
	 * @param {?} name
	 * @param {?=} props
	 * @param {?=} parentClass
	 * @return {?}
	 */
	function makePropDecorator(name, props, parentClass) {
	    var /** @type {?} */ metaCtor = makeMetadataCtor(props);
	    /**
	     * @param {...?} args
	     * @return {?}
	     */
	    function PropDecoratorFactory() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (this instanceof PropDecoratorFactory) {
	            metaCtor.apply(this, args);
	            return this;
	        }
	        var /** @type {?} */ decoratorInstance = new ((_a = (/** @type {?} */ (PropDecoratorFactory))).bind.apply(_a, [void 0].concat(args)))();
	        return function PropDecorator(target, name) {
	            var /** @type {?} */ constructor = target.constructor;
	            // Use of Object.defineProperty is important since it creates non-enumerable property which
	            // prevents the property is copied during subclassing.
	            var /** @type {?} */ meta = constructor.hasOwnProperty(PROP_METADATA) ?
	                (/** @type {?} */ (constructor))[PROP_METADATA] :
	                Object.defineProperty(constructor, PROP_METADATA, { value: {} })[PROP_METADATA];
	            meta[name] = meta.hasOwnProperty(name) && meta[name] || [];
	            meta[name].unshift(decoratorInstance);
	        };
	        var _a;
	    }
	    if (parentClass) {
	        PropDecoratorFactory.prototype = Object.create(parentClass.prototype);
	    }
	    PropDecoratorFactory.prototype.ngMetadataName = name;
	    (/** @type {?} */ (PropDecoratorFactory)).annotationCls = PropDecoratorFactory;
	    return PropDecoratorFactory;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * This token can be used to create a virtual provider that will populate the
	 * `entryComponents` fields of components and ng modules based on its `useValue`.
	 * All components that are referenced in the `useValue` value (either directly
	 * or in a nested array or map) will be added to the `entryComponents` property.
	 *
	 * ### Example
	 * The following example shows how the router can populate the `entryComponents`
	 * field of an NgModule based on the router configuration which refers
	 * to components.
	 *
	 * ```typescript
	 * // helper function inside the router
	 * function provideRoutes(routes) {
	 *   return [
	 *     {provide: ROUTES, useValue: routes},
	 *     {provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: routes, multi: true}
	 *   ];
	 * }
	 *
	 * // user code
	 * let routes = [
	 *   {path: '/root', component: RootComp},
	 *   {path: '/teams', component: TeamsComp}
	 * ];
	 *
	 * \@NgModule({
	 *   providers: [provideRoutes(routes)]
	 * })
	 * class ModuleWithRoutes {}
	 * ```
	 *
	 * \@experimental
	 */
	var ANALYZE_FOR_ENTRY_COMPONENTS = new InjectionToken('AnalyzeForEntryComponents');
	/**
	 * Type of the Attribute decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Attribute decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Attribute = makeParamDecorator('Attribute', function (attributeName) { return ({ attributeName: attributeName }); });
	/**
	 * Base class for query metadata.
	 *
	 * See {\@link ContentChildren}, {\@link ContentChild}, {\@link ViewChildren}, {\@link ViewChild} for
	 * more information.
	 *
	 * \@stable
	 * @abstract
	 */
	var Query = /** @class */ (function () {
	    function Query() {
	    }
	    return Query;
	}());
	/**
	 * Type of the ContentChildren decorator / constructor function.
	 *
	 * See {\@link ContentChildren}.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * ContentChildren decorator and metadata.
	 *
	 *  \@stable
	 *  \@Annotation
	 */
	var ContentChildren = makePropDecorator('ContentChildren', function (selector, data) {
	    if (data === void 0) { data = {}; }
	    return (__assign({ selector: selector, first: false, isViewQuery: false, descendants: false }, data));
	}, Query);
	/**
	 * Type of the ContentChild decorator / constructor function.
	 *
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * ContentChild decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var ContentChild = makePropDecorator('ContentChild', function (selector, data) {
	    if (data === void 0) { data = {}; }
	    return (__assign({ selector: selector, first: true, isViewQuery: false, descendants: true }, data));
	}, Query);
	/**
	 * Type of the ViewChildren decorator / constructor function.
	 *
	 * See {\@link ViewChildren}.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * ViewChildren decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var ViewChildren = makePropDecorator('ViewChildren', function (selector, data) {
	    if (data === void 0) { data = {}; }
	    return (__assign({ selector: selector, first: false, isViewQuery: true, descendants: true }, data));
	}, Query);
	/**
	 * Type of the ViewChild decorator / constructor function.
	 *
	 * See {\@link ViewChild}
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * ViewChild decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var ViewChild = makePropDecorator('ViewChild', function (selector, data) {
	    return (__assign({ selector: selector, first: true, isViewQuery: true, descendants: true }, data));
	}, Query);
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var ChangeDetectionStrategy = {
	    /**
	       * `OnPush` means that the change detector's mode will be initially set to `CheckOnce`.
	       */
	    OnPush: 0,
	    /**
	       * `Default` means that the change detector's mode will be initially set to `CheckAlways`.
	       */
	    Default: 1,
	};
	ChangeDetectionStrategy[ChangeDetectionStrategy.OnPush] = "OnPush";
	ChangeDetectionStrategy[ChangeDetectionStrategy.Default] = "Default";
	/** @enum {number} */
	var ChangeDetectorStatus = {
	    /**
	       * `CheckOnce` means that after calling detectChanges the mode of the change detector
	       * will become `Checked`.
	       */
	    CheckOnce: 0,
	    /**
	       * `Checked` means that the change detector should be skipped until its mode changes to
	       * `CheckOnce`.
	       */
	    Checked: 1,
	    /**
	       * `CheckAlways` means that after calling detectChanges the mode of the change detector
	       * will remain `CheckAlways`.
	       */
	    CheckAlways: 2,
	    /**
	       * `Detached` means that the change detector sub tree is not a part of the main tree and
	       * should be skipped.
	       */
	    Detached: 3,
	    /**
	       * `Errored` means that the change detector encountered an error checking a binding
	       * or calling a directive lifecycle method and is now in an inconsistent state. Change
	       * detectors in this state will no longer detect changes.
	       */
	    Errored: 4,
	    /**
	       * `Destroyed` means that the change detector is destroyed.
	       */
	    Destroyed: 5,
	};
	ChangeDetectorStatus[ChangeDetectorStatus.CheckOnce] = "CheckOnce";
	ChangeDetectorStatus[ChangeDetectorStatus.Checked] = "Checked";
	ChangeDetectorStatus[ChangeDetectorStatus.CheckAlways] = "CheckAlways";
	ChangeDetectorStatus[ChangeDetectorStatus.Detached] = "Detached";
	ChangeDetectorStatus[ChangeDetectorStatus.Errored] = "Errored";
	ChangeDetectorStatus[ChangeDetectorStatus.Destroyed] = "Destroyed";
	/**
	 * @param {?} changeDetectionStrategy
	 * @return {?}
	 */
	function isDefaultChangeDetectionStrategy(changeDetectionStrategy) {
	    return changeDetectionStrategy == null ||
	        changeDetectionStrategy === ChangeDetectionStrategy.Default;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Type of the Directive decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Directive decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Directive = makeDecorator('Directive', function (dir) {
	    if (dir === void 0) { dir = {}; }
	    return dir;
	});
	/**
	 * Type of the Component decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Component decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Component = makeDecorator('Component', function (c) {
	    if (c === void 0) { c = {}; }
	    return (__assign({ changeDetection: ChangeDetectionStrategy.Default }, c));
	}, Directive);
	/**
	 * Type of the Pipe decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Pipe decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Pipe = makeDecorator('Pipe', function (p) { return (__assign({ pure: true }, p)); });
	/**
	 * Type of the Input decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Input decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Input = makePropDecorator('Input', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
	/**
	 * Type of the Output decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Output decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Output = makePropDecorator('Output', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
	/**
	 * Type of the HostBinding decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * HostBinding decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var HostBinding = makePropDecorator('HostBinding', function (hostPropertyName) { return ({ hostPropertyName: hostPropertyName }); });
	/**
	 * Type of the HostListener decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * HostListener decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var HostListener = makePropDecorator('HostListener', function (eventName, args) { return ({ eventName: eventName, args: args }); });
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A wrapper around a module that also includes the providers.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Interface for schema definitions in \@NgModules.
	 *
	 * \@experimental
	 * @record
	 */
	
	/**
	 * Defines a schema that will allow:
	 * - any non-Angular elements with a `-` in their name,
	 * - any properties on elements with a `-` in their name which is the common rule for custom
	 * elements.
	 *
	 * \@stable
	 */
	var CUSTOM_ELEMENTS_SCHEMA = {
	    name: 'custom-elements'
	};
	/**
	 * Defines a schema that will allow any property on any element.
	 *
	 * \@experimental
	 */
	var NO_ERRORS_SCHEMA = {
	    name: 'no-errors-schema'
	};
	/**
	 * Type of the NgModule decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * NgModule decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var NgModule = makeDecorator('NgModule', function (ngModule) { return ngModule; });
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var ViewEncapsulation = {
	    /**
	       * Emulate `Native` scoping of styles by adding an attribute containing surrogate id to the Host
	       * Element and pre-processing the style rules provided via {@link Component#styles styles} or
	       * {@link Component#styleUrls styleUrls}, and adding the new Host Element attribute to all
	       * selectors.
	       *
	       * This is the default option.
	       */
	    Emulated: 0,
	    /**
	       * Use the native encapsulation mechanism of the renderer.
	       *
	       * For the DOM this means using [Shadow DOM](https://w3c.github.io/webcomponents/spec/shadow/) and
	       * creating a ShadowRoot for Component's Host Element.
	       */
	    Native: 1,
	    /**
	       * Don't provide any template or style encapsulation.
	       */
	    None: 2,
	};
	ViewEncapsulation[ViewEncapsulation.Emulated] = "Emulated";
	ViewEncapsulation[ViewEncapsulation.Native] = "Native";
	ViewEncapsulation[ViewEncapsulation.None] = "None";
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Represents the version of Angular
	 *
	 * \@stable
	 */
	var Version = /** @class */ (function () {
	    function Version(full) {
	        this.full = full;
	        this.major = full.split('.')[0];
	        this.minor = full.split('.')[1];
	        this.patch = full.split('.').slice(2).join('.');
	    }
	    return Version;
	}());
	/**
	 * \@stable
	 */
	var VERSION = new Version('5.2.11');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Type of the Inject decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Inject decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Inject = makeParamDecorator('Inject', function (token) { return ({ token: token }); });
	/**
	 * Type of the Optional decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Optional decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Optional = makeParamDecorator('Optional');
	/**
	 * Type of the Injectable decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Injectable decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Injectable = makeDecorator('Injectable');
	/**
	 * Type of the Self decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Self decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Self = makeParamDecorator('Self');
	/**
	 * Type of the SkipSelf decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * SkipSelf decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var SkipSelf = makeParamDecorator('SkipSelf');
	/**
	 * Type of the Host decorator / constructor function.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Host decorator and metadata.
	 *
	 * \@stable
	 * \@Annotation
	 */
	var Host = makeParamDecorator('Host');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof global !== 'undefined' && global;
	var _global = __window || __global || __self;
	var promise = Promise.resolve(0);
	var _symbolIterator = null;
	/**
	 * @return {?}
	 */
	function getSymbolIterator() {
	    if (!_symbolIterator) {
	        var /** @type {?} */ Symbol_1 = _global['Symbol'];
	        if (Symbol_1 && Symbol_1.iterator) {
	            _symbolIterator = Symbol_1.iterator;
	        }
	        else {
	            // es6-shim specific logic
	            var /** @type {?} */ keys = Object.getOwnPropertyNames(Map.prototype);
	            for (var /** @type {?} */ i = 0; i < keys.length; ++i) {
	                var /** @type {?} */ key = keys[i];
	                if (key !== 'entries' && key !== 'size' &&
	                    (/** @type {?} */ (Map)).prototype[key] === Map.prototype['entries']) {
	                    _symbolIterator = key;
	                }
	            }
	        }
	    }
	    return _symbolIterator;
	}
	/**
	 * @param {?} fn
	 * @return {?}
	 */
	function scheduleMicroTask(fn) {
	    if (typeof Zone === 'undefined') {
	        // use promise to schedule microTask instead of use Zone
	        promise.then(function () { fn && fn.apply(null, null); });
	    }
	    else {
	        Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
	    }
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function looseIdentical(a, b) {
	    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
	}
	/**
	 * @param {?} token
	 * @return {?}
	 */
	function stringify(token) {
	    if (typeof token === 'string') {
	        return token;
	    }
	    if (token instanceof Array) {
	        return '[' + token.map(stringify).join(', ') + ']';
	    }
	    if (token == null) {
	        return '' + token;
	    }
	    if (token.overriddenName) {
	        return "" + token.overriddenName;
	    }
	    if (token.name) {
	        return "" + token.name;
	    }
	    var /** @type {?} */ res = token.toString();
	    if (res == null) {
	        return '' + res;
	    }
	    var /** @type {?} */ newLineIndex = res.indexOf('\n');
	    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An interface that a function passed into {\@link forwardRef} has to implement.
	 *
	 * ### Example
	 *
	 * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref_fn'}
	 * \@experimental
	 * @record
	 */
	
	/**
	 * Allows to refer to references which are not yet defined.
	 *
	 * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
	 * DI is declared,
	 * but not yet defined. It is also used when the `token` which we use when creating a query is not
	 * yet defined.
	 *
	 * ### Example
	 * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref'}
	 * \@experimental
	 * @param {?} forwardRefFn
	 * @return {?}
	 */
	function forwardRef(forwardRefFn) {
	    (/** @type {?} */ (forwardRefFn)).__forward_ref__ = forwardRef;
	    (/** @type {?} */ (forwardRefFn)).toString = function () { return stringify(this()); };
	    return (/** @type {?} */ (/** @type {?} */ (forwardRefFn)));
	}
	/**
	 * Lazily retrieves the reference value from a forwardRef.
	 *
	 * Acts as the identity function when given a non-forward-ref value.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/GU72mJrk1fiodChcmiDR?p=preview))
	 *
	 * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='resolve_forward_ref'}
	 *
	 * See: {\@link forwardRef}
	 * \@experimental
	 * @param {?} type
	 * @return {?}
	 */
	function resolveForwardRef(type) {
	    if (typeof type === 'function' && type.hasOwnProperty('__forward_ref__') &&
	        type.__forward_ref__ === forwardRef) {
	        return (/** @type {?} */ (type))();
	    }
	    else {
	        return type;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SOURCE = '__source';
	var _THROW_IF_NOT_FOUND = new Object();
	var THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
	var _NullInjector = /** @class */ (function () {
	    function _NullInjector() {
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    _NullInjector.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        if (notFoundValue === void 0) { notFoundValue = _THROW_IF_NOT_FOUND; }
	        if (notFoundValue === _THROW_IF_NOT_FOUND) {
	            throw new Error("NullInjectorError: No provider for " + stringify(token) + "!");
	        }
	        return notFoundValue;
	    };
	    return _NullInjector;
	}());
	/**
	 * \@whatItDoes Injector interface
	 * \@howToUse
	 * ```
	 * const injector: Injector = ...;
	 * injector.get(...);
	 * ```
	 *
	 * \@description
	 * For more details, see the {\@linkDocs guide/dependency-injection "Dependency Injection Guide"}.
	 *
	 * ### Example
	 *
	 * {\@example core/di/ts/injector_spec.ts region='Injector'}
	 *
	 * `Injector` returns itself when given `Injector` as a token:
	 * {\@example core/di/ts/injector_spec.ts region='injectInjector'}
	 *
	 * \@stable
	 * @abstract
	 */
	var Injector = /** @class */ (function () {
	    function Injector() {
	    }
	    /**
	     * Create a new Injector which is configure using `StaticProvider`s.
	     *
	     * ### Example
	     *
	     * {@example core/di/ts/provider_spec.ts region='ConstructorProvider'}
	     */
	    /**
	     * Create a new Injector which is configure using `StaticProvider`s.
	     *
	     * ### Example
	     *
	     * {\@example core/di/ts/provider_spec.ts region='ConstructorProvider'}
	     * @param {?} options
	     * @param {?=} parent
	     * @return {?}
	     */
	    Injector.create = /**
	     * Create a new Injector which is configure using `StaticProvider`s.
	     *
	     * ### Example
	     *
	     * {\@example core/di/ts/provider_spec.ts region='ConstructorProvider'}
	     * @param {?} options
	     * @param {?=} parent
	     * @return {?}
	     */
	    function (options, parent) {
	        if (Array.isArray(options)) {
	            return new StaticInjector(options, parent);
	        }
	        else {
	            return new StaticInjector(options.providers, options.parent, options.name || null);
	        }
	    };
	    Injector.THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
	    Injector.NULL = new _NullInjector();
	    return Injector;
	}());
	var IDENT = function (value) {
	    return value;
	};
	var EMPTY = /** @type {?} */ ([]);
	var CIRCULAR = IDENT;
	var MULTI_PROVIDER_FN = function () {
	    return Array.prototype.slice.call(arguments);
	};
	var GET_PROPERTY_NAME = /** @type {?} */ ({});
	var ɵ2 = GET_PROPERTY_NAME;
	var USE_VALUE = getClosureSafeProperty({ provide: String, useValue: ɵ2 });
	var NG_TOKEN_PATH = 'ngTokenPath';
	var NG_TEMP_TOKEN_PATH = 'ngTempTokenPath';
	var NULL_INJECTOR = Injector.NULL;
	var NEW_LINE = /\n/gm;
	var NO_NEW_LINE = 'ɵ';
	var StaticInjector = /** @class */ (function () {
	    function StaticInjector(providers, parent, source) {
	        if (parent === void 0) { parent = NULL_INJECTOR; }
	        if (source === void 0) { source = null; }
	        this.parent = parent;
	        this.source = source;
	        var /** @type {?} */ records = this._records = new Map();
	        records.set(Injector, /** @type {?} */ ({ token: Injector, fn: IDENT, deps: EMPTY, value: this, useNew: false }));
	        recursivelyProcessProviders(records, providers);
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    StaticInjector.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        var /** @type {?} */ record = this._records.get(token);
	        try {
	            return tryResolveToken(token, record, this._records, this.parent, notFoundValue);
	        }
	        catch (/** @type {?} */ e) {
	            var /** @type {?} */ tokenPath = e[NG_TEMP_TOKEN_PATH];
	            if (token[SOURCE]) {
	                tokenPath.unshift(token[SOURCE]);
	            }
	            e.message = formatError('\n' + e.message, tokenPath, this.source);
	            e[NG_TOKEN_PATH] = tokenPath;
	            e[NG_TEMP_TOKEN_PATH] = null;
	            throw e;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    StaticInjector.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ tokens = /** @type {?} */ ([]), /** @type {?} */ records = this._records;
	        records.forEach(function (v, token) { return tokens.push(stringify(token)); });
	        return "StaticInjector[" + tokens.join(', ') + "]";
	    };
	    return StaticInjector;
	}());
	/**
	 * @param {?} provider
	 * @return {?}
	 */
	function resolveProvider(provider) {
	    var /** @type {?} */ deps = computeDeps(provider);
	    var /** @type {?} */ fn = IDENT;
	    var /** @type {?} */ value = EMPTY;
	    var /** @type {?} */ useNew = false;
	    var /** @type {?} */ provide = resolveForwardRef(provider.provide);
	    if (USE_VALUE in provider) {
	        // We need to use USE_VALUE in provider since provider.useValue could be defined as undefined.
	        value = (/** @type {?} */ (provider)).useValue;
	    }
	    else if ((/** @type {?} */ (provider)).useFactory) {
	        fn = (/** @type {?} */ (provider)).useFactory;
	    }
	    else if ((/** @type {?} */ (provider)).useExisting) {
	        // Just use IDENT
	    }
	    else if ((/** @type {?} */ (provider)).useClass) {
	        useNew = true;
	        fn = resolveForwardRef((/** @type {?} */ (provider)).useClass);
	    }
	    else if (typeof provide == 'function') {
	        useNew = true;
	        fn = provide;
	    }
	    else {
	        throw staticError('StaticProvider does not have [useValue|useFactory|useExisting|useClass] or [provide] is not newable', provider);
	    }
	    return { deps: deps, fn: fn, useNew: useNew, value: value };
	}
	/**
	 * @param {?} token
	 * @return {?}
	 */
	function multiProviderMixError(token) {
	    return staticError('Cannot mix multi providers and regular providers', token);
	}
	/**
	 * @param {?} records
	 * @param {?} provider
	 * @return {?}
	 */
	function recursivelyProcessProviders(records, provider) {
	    if (provider) {
	        provider = resolveForwardRef(provider);
	        if (provider instanceof Array) {
	            // if we have an array recurse into the array
	            for (var /** @type {?} */ i = 0; i < provider.length; i++) {
	                recursivelyProcessProviders(records, provider[i]);
	            }
	        }
	        else if (typeof provider === 'function') {
	            // Functions were supported in ReflectiveInjector, but are not here. For safety give useful
	            // error messages
	            throw staticError('Function/Class not supported', provider);
	        }
	        else if (provider && typeof provider === 'object' && provider.provide) {
	            // At this point we have what looks like a provider: {provide: ?, ....}
	            var /** @type {?} */ token = resolveForwardRef(provider.provide);
	            var /** @type {?} */ resolvedProvider = resolveProvider(provider);
	            if (provider.multi === true) {
	                // This is a multi provider.
	                var /** @type {?} */ multiProvider = records.get(token);
	                if (multiProvider) {
	                    if (multiProvider.fn !== MULTI_PROVIDER_FN) {
	                        throw multiProviderMixError(token);
	                    }
	                }
	                else {
	                    // Create a placeholder factory which will look up the constituents of the multi provider.
	                    records.set(token, multiProvider = /** @type {?} */ ({
	                        token: provider.provide,
	                        deps: [],
	                        useNew: false,
	                        fn: MULTI_PROVIDER_FN,
	                        value: EMPTY
	                    }));
	                }
	                // Treat the provider as the token.
	                token = provider;
	                multiProvider.deps.push({ token: token, options: 6 /* Default */ });
	            }
	            var /** @type {?} */ record = records.get(token);
	            if (record && record.fn == MULTI_PROVIDER_FN) {
	                throw multiProviderMixError(token);
	            }
	            records.set(token, resolvedProvider);
	        }
	        else {
	            throw staticError('Unexpected provider', provider);
	        }
	    }
	}
	/**
	 * @param {?} token
	 * @param {?} record
	 * @param {?} records
	 * @param {?} parent
	 * @param {?} notFoundValue
	 * @return {?}
	 */
	function tryResolveToken(token, record, records, parent, notFoundValue) {
	    try {
	        return resolveToken(token, record, records, parent, notFoundValue);
	    }
	    catch (/** @type {?} */ e) {
	        // ensure that 'e' is of type Error.
	        if (!(e instanceof Error)) {
	            e = new Error(e);
	        }
	        var /** @type {?} */ path = e[NG_TEMP_TOKEN_PATH] = e[NG_TEMP_TOKEN_PATH] || [];
	        path.unshift(token);
	        if (record && record.value == CIRCULAR) {
	            // Reset the Circular flag.
	            record.value = EMPTY;
	        }
	        throw e;
	    }
	}
	/**
	 * @param {?} token
	 * @param {?} record
	 * @param {?} records
	 * @param {?} parent
	 * @param {?} notFoundValue
	 * @return {?}
	 */
	function resolveToken(token, record, records, parent, notFoundValue) {
	    var /** @type {?} */ value;
	    if (record) {
	        // If we don't have a record, this implies that we don't own the provider hence don't know how
	        // to resolve it.
	        value = record.value;
	        if (value == CIRCULAR) {
	            throw Error(NO_NEW_LINE + 'Circular dependency');
	        }
	        else if (value === EMPTY) {
	            record.value = CIRCULAR;
	            var /** @type {?} */ obj = undefined;
	            var /** @type {?} */ useNew = record.useNew;
	            var /** @type {?} */ fn = record.fn;
	            var /** @type {?} */ depRecords = record.deps;
	            var /** @type {?} */ deps = EMPTY;
	            if (depRecords.length) {
	                deps = [];
	                for (var /** @type {?} */ i = 0; i < depRecords.length; i++) {
	                    var /** @type {?} */ depRecord = depRecords[i];
	                    var /** @type {?} */ options = depRecord.options;
	                    var /** @type {?} */ childRecord = options & 2 /* CheckSelf */ ? records.get(depRecord.token) : undefined;
	                    deps.push(tryResolveToken(
	                    // Current Token to resolve
	                    depRecord.token, childRecord, records, 
	                    // If we don't know how to resolve dependency and we should not check parent for it,
	                    // than pass in Null injector.
	                    !childRecord && !(options & 4 /* CheckParent */) ? NULL_INJECTOR : parent, options & 1 /* Optional */ ? null : Injector.THROW_IF_NOT_FOUND));
	                }
	            }
	            record.value = value = useNew ? new ((_a = (/** @type {?} */ (fn))).bind.apply(_a, [void 0].concat(deps)))() : fn.apply(obj, deps);
	        }
	    }
	    else {
	        value = parent.get(token, notFoundValue);
	    }
	    return value;
	    var _a;
	}
	/**
	 * @param {?} provider
	 * @return {?}
	 */
	function computeDeps(provider) {
	    var /** @type {?} */ deps = EMPTY;
	    var /** @type {?} */ providerDeps = (/** @type {?} */ (provider)).deps;
	    if (providerDeps && providerDeps.length) {
	        deps = [];
	        for (var /** @type {?} */ i = 0; i < providerDeps.length; i++) {
	            var /** @type {?} */ options = 6;
	            var /** @type {?} */ token = resolveForwardRef(providerDeps[i]);
	            if (token instanceof Array) {
	                for (var /** @type {?} */ j = 0, /** @type {?} */ annotations = token; j < annotations.length; j++) {
	                    var /** @type {?} */ annotation = annotations[j];
	                    if (annotation instanceof Optional || annotation == Optional) {
	                        options = options | 1 /* Optional */;
	                    }
	                    else if (annotation instanceof SkipSelf || annotation == SkipSelf) {
	                        options = options & ~2 /* CheckSelf */;
	                    }
	                    else if (annotation instanceof Self || annotation == Self) {
	                        options = options & ~4 /* CheckParent */;
	                    }
	                    else if (annotation instanceof Inject) {
	                        token = (/** @type {?} */ (annotation)).token;
	                    }
	                    else {
	                        token = resolveForwardRef(annotation);
	                    }
	                }
	            }
	            deps.push({ token: token, options: options });
	        }
	    }
	    else if ((/** @type {?} */ (provider)).useExisting) {
	        var /** @type {?} */ token = resolveForwardRef((/** @type {?} */ (provider)).useExisting);
	        deps = [{ token: token, options: 6 /* Default */ }];
	    }
	    else if (!providerDeps && !(USE_VALUE in provider)) {
	        // useValue & useExisting are the only ones which are exempt from deps all others need it.
	        throw staticError('\'deps\' required', provider);
	    }
	    return deps;
	}
	/**
	 * @param {?} text
	 * @param {?} obj
	 * @param {?=} source
	 * @return {?}
	 */
	function formatError(text, obj, source) {
	    if (source === void 0) { source = null; }
	    text = text && text.charAt(0) === '\n' && text.charAt(1) == NO_NEW_LINE ? text.substr(2) : text;
	    var /** @type {?} */ context = stringify(obj);
	    if (obj instanceof Array) {
	        context = obj.map(stringify).join(' -> ');
	    }
	    else if (typeof obj === 'object') {
	        var /** @type {?} */ parts = /** @type {?} */ ([]);
	        for (var /** @type {?} */ key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                var /** @type {?} */ value = obj[key];
	                parts.push(key + ':' + (typeof value === 'string' ? JSON.stringify(value) : stringify(value)));
	            }
	        }
	        context = "{" + parts.join(', ') + "}";
	    }
	    return "StaticInjectorError" + (source ? '(' + source + ')' : '') + "[" + context + "]: " + text.replace(NEW_LINE, '\n  ');
	}
	/**
	 * @param {?} text
	 * @param {?} obj
	 * @return {?}
	 */
	function staticError(text, obj) {
	    return new Error(formatError(text, obj));
	}
	/**
	 * @template T
	 * @param {?} objWithPropertyToExtract
	 * @return {?}
	 */
	function getClosureSafeProperty(objWithPropertyToExtract) {
	    for (var /** @type {?} */ key in objWithPropertyToExtract) {
	        if (objWithPropertyToExtract[key] === GET_PROPERTY_NAME) {
	            return key;
	        }
	    }
	    throw Error('!prop');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	var ERROR_DEBUG_CONTEXT = 'ngDebugContext';
	var ERROR_ORIGINAL_ERROR = 'ngOriginalError';
	var ERROR_LOGGER = 'ngErrorLogger';
	/**
	 * @param {?} error
	 * @return {?}
	 */
	
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function getDebugContext(error) {
	    return (/** @type {?} */ (error))[ERROR_DEBUG_CONTEXT];
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function getOriginalError(error) {
	    return (/** @type {?} */ (error))[ERROR_ORIGINAL_ERROR];
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function getErrorLogger(error) {
	    return (/** @type {?} */ (error))[ERROR_LOGGER] || defaultErrorLogger;
	}
	/**
	 * @param {?} console
	 * @param {...?} values
	 * @return {?}
	 */
	function defaultErrorLogger(console) {
	    var values = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        values[_i - 1] = arguments[_i];
	    }
	    console.error.apply(console, values);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Provides a hook for centralized exception handling.
	 *
	 * \@description
	 *
	 * The default implementation of `ErrorHandler` prints error messages to the `console`. To
	 * intercept error handling, write a custom exception handler that replaces this default as
	 * appropriate for your app.
	 *
	 * ### Example
	 *
	 * ```
	 * class MyErrorHandler implements ErrorHandler {
	 *   handleError(error) {
	 *     // do something with the exception
	 *   }
	 * }
	 *
	 * \@NgModule({
	 *   providers: [{provide: ErrorHandler, useClass: MyErrorHandler}]
	 * })
	 * class MyModule {}
	 * ```
	 *
	 * \@stable
	 */
	var ErrorHandler = /** @class */ (function () {
	    function ErrorHandler() {
	        /**
	         * \@internal
	         */
	        this._console = console;
	    }
	    /**
	     * @param {?} error
	     * @return {?}
	     */
	    ErrorHandler.prototype.handleError = /**
	     * @param {?} error
	     * @return {?}
	     */
	    function (error) {
	        var /** @type {?} */ originalError = this._findOriginalError(error);
	        var /** @type {?} */ context = this._findContext(error);
	        // Note: Browser consoles show the place from where console.error was called.
	        // We can use this to give users additional information about the error.
	        var /** @type {?} */ errorLogger = getErrorLogger(error);
	        errorLogger(this._console, "ERROR", error);
	        if (originalError) {
	            errorLogger(this._console, "ORIGINAL ERROR", originalError);
	        }
	        if (context) {
	            errorLogger(this._console, 'ERROR CONTEXT', context);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} error
	     * @return {?}
	     */
	    ErrorHandler.prototype._findContext = /**
	     * \@internal
	     * @param {?} error
	     * @return {?}
	     */
	    function (error) {
	        if (error) {
	            return getDebugContext(error) ? getDebugContext(error) :
	                this._findContext(getOriginalError(error));
	        }
	        return null;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} error
	     * @return {?}
	     */
	    ErrorHandler.prototype._findOriginalError = /**
	     * \@internal
	     * @param {?} error
	     * @return {?}
	     */
	    function (error) {
	        var /** @type {?} */ e = getOriginalError(error);
	        while (e && getOriginalError(e)) {
	            e = getOriginalError(e);
	        }
	        return e;
	    };
	    return ErrorHandler;
	}());
	/**
	 * @param {?} message
	 * @param {?} originalError
	 * @return {?}
	 */
	function wrappedError(message, originalError) {
	    var /** @type {?} */ msg = message + " caused by: " + (originalError instanceof Error ? originalError.message : originalError);
	    var /** @type {?} */ error = Error(msg);
	    (/** @type {?} */ (error))[ERROR_ORIGINAL_ERROR] = originalError;
	    return error;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} keys
	 * @return {?}
	 */
	function findFirstClosedCycle(keys) {
	    var /** @type {?} */ res = [];
	    for (var /** @type {?} */ i = 0; i < keys.length; ++i) {
	        if (res.indexOf(keys[i]) > -1) {
	            res.push(keys[i]);
	            return res;
	        }
	        res.push(keys[i]);
	    }
	    return res;
	}
	/**
	 * @param {?} keys
	 * @return {?}
	 */
	function constructResolvingPath(keys) {
	    if (keys.length > 1) {
	        var /** @type {?} */ reversed = findFirstClosedCycle(keys.slice().reverse());
	        var /** @type {?} */ tokenStrs = reversed.map(function (k) { return stringify(k.token); });
	        return ' (' + tokenStrs.join(' -> ') + ')';
	    }
	    return '';
	}
	/**
	 * @record
	 */
	
	/**
	 * @param {?} injector
	 * @param {?} key
	 * @param {?} constructResolvingMessage
	 * @param {?=} originalError
	 * @return {?}
	 */
	function injectionError(injector, key, constructResolvingMessage, originalError) {
	    var /** @type {?} */ keys = [key];
	    var /** @type {?} */ errMsg = constructResolvingMessage(keys);
	    var /** @type {?} */ error = /** @type {?} */ ((originalError ? wrappedError(errMsg, originalError) : Error(errMsg)));
	    error.addKey = addKey;
	    error.keys = keys;
	    error.injectors = [injector];
	    error.constructResolvingMessage = constructResolvingMessage;
	    (/** @type {?} */ (error))[ERROR_ORIGINAL_ERROR] = originalError;
	    return error;
	}
	/**
	 * @this {?}
	 * @param {?} injector
	 * @param {?} key
	 * @return {?}
	 */
	function addKey(injector, key) {
	    this.injectors.push(injector);
	    this.keys.push(key);
	    // Note: This updated message won't be reflected in the `.stack` property
	    this.message = this.constructResolvingMessage(this.keys);
	}
	/**
	 * Thrown when trying to retrieve a dependency by key from {\@link Injector}, but the
	 * {\@link Injector} does not have a {\@link Provider} for the given key.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/vq8D3FRB9aGbnWJqtEPE?p=preview))
	 *
	 * ```typescript
	 * class A {
	 *   constructor(b:B) {}
	 * }
	 *
	 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
	 * ```
	 * @param {?} injector
	 * @param {?} key
	 * @return {?}
	 */
	function noProviderError(injector, key) {
	    return injectionError(injector, key, function (keys) {
	        var /** @type {?} */ first = stringify(keys[0].token);
	        return "No provider for " + first + "!" + constructResolvingPath(keys);
	    });
	}
	/**
	 * Thrown when dependencies form a cycle.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/wYQdNos0Tzql3ei1EV9j?p=info))
	 *
	 * ```typescript
	 * var injector = Injector.resolveAndCreate([
	 *   {provide: "one", useFactory: (two) => "two", deps: [[new Inject("two")]]},
	 *   {provide: "two", useFactory: (one) => "one", deps: [[new Inject("one")]]}
	 * ]);
	 *
	 * expect(() => injector.get("one")).toThrowError();
	 * ```
	 *
	 * Retrieving `A` or `B` throws a `CyclicDependencyError` as the graph above cannot be constructed.
	 * @param {?} injector
	 * @param {?} key
	 * @return {?}
	 */
	function cyclicDependencyError(injector, key) {
	    return injectionError(injector, key, function (keys) {
	        return "Cannot instantiate cyclic dependency!" + constructResolvingPath(keys);
	    });
	}
	/**
	 * Thrown when a constructing type returns with an Error.
	 *
	 * The `InstantiationError` class contains the original error plus the dependency graph which caused
	 * this object to be instantiated.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/7aWYdcqTQsP0eNqEdUAf?p=preview))
	 *
	 * ```typescript
	 * class A {
	 *   constructor() {
	 *     throw new Error('message');
	 *   }
	 * }
	 *
	 * var injector = Injector.resolveAndCreate([A]);
	 * try {
	 *   injector.get(A);
	 * } catch (e) {
	 *   expect(e instanceof InstantiationError).toBe(true);
	 *   expect(e.originalException.message).toEqual("message");
	 *   expect(e.originalStack).toBeDefined();
	 * }
	 * ```
	 * @param {?} injector
	 * @param {?} originalException
	 * @param {?} originalStack
	 * @param {?} key
	 * @return {?}
	 */
	function instantiationError(injector, originalException, originalStack, key) {
	    return injectionError(injector, key, function (keys) {
	        var /** @type {?} */ first = stringify(keys[0].token);
	        return originalException.message + ": Error during instantiation of " + first + "!" + constructResolvingPath(keys) + ".";
	    }, originalException);
	}
	/**
	 * Thrown when an object other then {\@link Provider} (or `Type`) is passed to {\@link Injector}
	 * creation.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/YatCFbPAMCL0JSSQ4mvH?p=preview))
	 *
	 * ```typescript
	 * expect(() => Injector.resolveAndCreate(["not a type"])).toThrowError();
	 * ```
	 * @param {?} provider
	 * @return {?}
	 */
	function invalidProviderError(provider) {
	    return Error("Invalid provider - only instances of Provider and Type are allowed, got: " + provider);
	}
	/**
	 * Thrown when the class has no annotation information.
	 *
	 * Lack of annotation information prevents the {\@link Injector} from determining which dependencies
	 * need to be injected into the constructor.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/rHnZtlNS7vJOPQ6pcVkm?p=preview))
	 *
	 * ```typescript
	 * class A {
	 *   constructor(b) {}
	 * }
	 *
	 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
	 * ```
	 *
	 * This error is also thrown when the class not marked with {\@link Injectable} has parameter types.
	 *
	 * ```typescript
	 * class B {}
	 *
	 * class A {
	 *   constructor(b:B) {} // no information about the parameter types of A is available at runtime.
	 * }
	 *
	 * expect(() => Injector.resolveAndCreate([A,B])).toThrowError();
	 * ```
	 * \@stable
	 * @param {?} typeOrFunc
	 * @param {?} params
	 * @return {?}
	 */
	function noAnnotationError(typeOrFunc, params) {
	    var /** @type {?} */ signature = [];
	    for (var /** @type {?} */ i = 0, /** @type {?} */ ii = params.length; i < ii; i++) {
	        var /** @type {?} */ parameter = params[i];
	        if (!parameter || parameter.length == 0) {
	            signature.push('?');
	        }
	        else {
	            signature.push(parameter.map(stringify).join(' '));
	        }
	    }
	    return Error('Cannot resolve all parameters for \'' + stringify(typeOrFunc) + '\'(' +
	        signature.join(', ') + '). ' +
	        'Make sure that all the parameters are decorated with Inject or have valid type annotations and that \'' +
	        stringify(typeOrFunc) + '\' is decorated with Injectable.');
	}
	/**
	 * Thrown when getting an object by index.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/bRs0SX2OTQiJzqvjgl8P?p=preview))
	 *
	 * ```typescript
	 * class A {}
	 *
	 * var injector = Injector.resolveAndCreate([A]);
	 *
	 * expect(() => injector.getAt(100)).toThrowError();
	 * ```
	 * \@stable
	 * @param {?} index
	 * @return {?}
	 */
	function outOfBoundsError(index) {
	    return Error("Index " + index + " is out-of-bounds.");
	}
	/**
	 * Thrown when a multi provider and a regular provider are bound to the same token.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * expect(() => Injector.resolveAndCreate([
	 *   { provide: "Strings", useValue: "string1", multi: true},
	 *   { provide: "Strings", useValue: "string2", multi: false}
	 * ])).toThrowError();
	 * ```
	 * @param {?} provider1
	 * @param {?} provider2
	 * @return {?}
	 */
	function mixingMultiProvidersWithRegularProvidersError(provider1, provider2) {
	    return Error("Cannot mix multi providers and regular providers, got: " + provider1 + " " + provider2);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A unique object used for retrieving items from the {\@link ReflectiveInjector}.
	 *
	 * Keys have:
	 * - a system-wide unique `id`.
	 * - a `token`.
	 *
	 * `Key` is used internally by {\@link ReflectiveInjector} because its system-wide unique `id` allows
	 * the
	 * injector to store created objects in a more efficient way.
	 *
	 * `Key` should not be created directly. {\@link ReflectiveInjector} creates keys automatically when
	 * resolving
	 * providers.
	 * @deprecated No replacement
	 */
	var ReflectiveKey = /** @class */ (function () {
	    /**
	     * Private
	     */
	    function ReflectiveKey(token, id) {
	        this.token = token;
	        this.id = id;
	        if (!token) {
	            throw new Error('Token must be defined!');
	        }
	        this.displayName = stringify(this.token);
	    }
	    /**
	     * Retrieves a `Key` for a token.
	     */
	    /**
	     * Retrieves a `Key` for a token.
	     * @param {?} token
	     * @return {?}
	     */
	    ReflectiveKey.get = /**
	     * Retrieves a `Key` for a token.
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        return _globalKeyRegistry.get(resolveForwardRef(token));
	    };
	    Object.defineProperty(ReflectiveKey, "numberOfKeys", {
	        /**
	         * @returns the number of keys registered in the system.
	         */
	        get: /**
	         * @return {?} the number of keys registered in the system.
	         */
	        function () { return _globalKeyRegistry.numberOfKeys; },
	        enumerable: true,
	        configurable: true
	    });
	    return ReflectiveKey;
	}());
	var KeyRegistry = /** @class */ (function () {
	    function KeyRegistry() {
	        this._allKeys = new Map();
	    }
	    /**
	     * @param {?} token
	     * @return {?}
	     */
	    KeyRegistry.prototype.get = /**
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        if (token instanceof ReflectiveKey)
	            return token;
	        if (this._allKeys.has(token)) {
	            return /** @type {?} */ ((this._allKeys.get(token)));
	        }
	        var /** @type {?} */ newKey = new ReflectiveKey(token, ReflectiveKey.numberOfKeys);
	        this._allKeys.set(token, newKey);
	        return newKey;
	    };
	    Object.defineProperty(KeyRegistry.prototype, "numberOfKeys", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._allKeys.size; },
	        enumerable: true,
	        configurable: true
	    });
	    return KeyRegistry;
	}());
	var _globalKeyRegistry = new KeyRegistry();
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Represents a type that a Component or other object is instances of.
	 *
	 * \@description
	 *
	 * An example of a `Type` is `MyCustomComponent` class, which in JavaScript is be represented by
	 * the `MyCustomComponent` constructor function.
	 *
	 * \@stable
	 */
	var Type = Function;
	/**
	 * @param {?} v
	 * @return {?}
	 */
	function isType(v) {
	    return typeof v === 'function';
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Attention: These regex has to hold even if the code is minified!
	 */
	var DELEGATE_CTOR = /^function\s+\S+\(\)\s*{[\s\S]+\.apply\(this,\s*arguments\)/;
	var INHERITED_CLASS = /^class\s+[A-Za-z\d$_]*\s*extends\s+[A-Za-z\d$_]+\s*{/;
	var INHERITED_CLASS_WITH_CTOR = /^class\s+[A-Za-z\d$_]*\s*extends\s+[A-Za-z\d$_]+\s*{[\s\S]*constructor\s*\(/;
	var ReflectionCapabilities = /** @class */ (function () {
	    function ReflectionCapabilities(reflect) {
	        this._reflect = reflect || _global['Reflect'];
	    }
	    /**
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.isReflectionEnabled = /**
	     * @return {?}
	     */
	    function () { return true; };
	    /**
	     * @template T
	     * @param {?} t
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.factory = /**
	     * @template T
	     * @param {?} t
	     * @return {?}
	     */
	    function (t) { return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return new (t.bind.apply(t, [void 0].concat(args)))();
	    }; };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} paramTypes
	     * @param {?} paramAnnotations
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype._zipTypesAndAnnotations = /**
	     * \@internal
	     * @param {?} paramTypes
	     * @param {?} paramAnnotations
	     * @return {?}
	     */
	    function (paramTypes, paramAnnotations) {
	        var /** @type {?} */ result;
	        if (typeof paramTypes === 'undefined') {
	            result = new Array(paramAnnotations.length);
	        }
	        else {
	            result = new Array(paramTypes.length);
	        }
	        for (var /** @type {?} */ i = 0; i < result.length; i++) {
	            // TS outputs Object for parameters without types, while Traceur omits
	            // the annotations. For now we preserve the Traceur behavior to aid
	            // migration, but this can be revisited.
	            if (typeof paramTypes === 'undefined') {
	                result[i] = [];
	            }
	            else if (paramTypes[i] != Object) {
	                result[i] = [paramTypes[i]];
	            }
	            else {
	                result[i] = [];
	            }
	            if (paramAnnotations && paramAnnotations[i] != null) {
	                result[i] = result[i].concat(paramAnnotations[i]);
	            }
	        }
	        return result;
	    };
	    /**
	     * @param {?} type
	     * @param {?} parentCtor
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype._ownParameters = /**
	     * @param {?} type
	     * @param {?} parentCtor
	     * @return {?}
	     */
	    function (type, parentCtor) {
	        var /** @type {?} */ typeStr = type.toString();
	        // If we have no decorators, we only have function.length as metadata.
	        // In that case, to detect whether a child class declared an own constructor or not,
	        // we need to look inside of that constructor to check whether it is
	        // just calling the parent.
	        // This also helps to work around for https://github.com/Microsoft/TypeScript/issues/12439
	        // that sets 'design:paramtypes' to []
	        // if a class inherits from another class but has no ctor declared itself.
	        if (DELEGATE_CTOR.exec(typeStr) ||
	            (INHERITED_CLASS.exec(typeStr) && !INHERITED_CLASS_WITH_CTOR.exec(typeStr))) {
	            return null;
	        }
	        // Prefer the direct API.
	        if ((/** @type {?} */ (type)).parameters && (/** @type {?} */ (type)).parameters !== parentCtor.parameters) {
	            return (/** @type {?} */ (type)).parameters;
	        }
	        // API of tsickle for lowering decorators to properties on the class.
	        var /** @type {?} */ tsickleCtorParams = (/** @type {?} */ (type)).ctorParameters;
	        if (tsickleCtorParams && tsickleCtorParams !== parentCtor.ctorParameters) {
	            // Newer tsickle uses a function closure
	            // Retain the non-function case for compatibility with older tsickle
	            var /** @type {?} */ ctorParameters = typeof tsickleCtorParams === 'function' ? tsickleCtorParams() : tsickleCtorParams;
	            var /** @type {?} */ paramTypes_1 = ctorParameters.map(function (ctorParam) { return ctorParam && ctorParam.type; });
	            var /** @type {?} */ paramAnnotations_1 = ctorParameters.map(function (ctorParam) {
	                return ctorParam && convertTsickleDecoratorIntoMetadata(ctorParam.decorators);
	            });
	            return this._zipTypesAndAnnotations(paramTypes_1, paramAnnotations_1);
	        }
	        // API for metadata created by invoking the decorators.
	        var /** @type {?} */ paramAnnotations = type.hasOwnProperty(PARAMETERS) && (/** @type {?} */ (type))[PARAMETERS];
	        var /** @type {?} */ paramTypes = this._reflect && this._reflect.getOwnMetadata &&
	            this._reflect.getOwnMetadata('design:paramtypes', type);
	        if (paramTypes || paramAnnotations) {
	            return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
	        }
	        // If a class has no decorators, at least create metadata
	        // based on function.length.
	        // Note: We know that this is a real constructor as we checked
	        // the content of the constructor above.
	        return new Array((/** @type {?} */ (type.length))).fill(undefined);
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.parameters = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        // Note: only report metadata if we have at least one class decorator
	        // to stay in sync with the static reflector.
	        if (!isType(type)) {
	            return [];
	        }
	        var /** @type {?} */ parentCtor = getParentCtor(type);
	        var /** @type {?} */ parameters = this._ownParameters(type, parentCtor);
	        if (!parameters && parentCtor !== Object) {
	            parameters = this.parameters(parentCtor);
	        }
	        return parameters || [];
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @param {?} parentCtor
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype._ownAnnotations = /**
	     * @param {?} typeOrFunc
	     * @param {?} parentCtor
	     * @return {?}
	     */
	    function (typeOrFunc, parentCtor) {
	        // Prefer the direct API.
	        if ((/** @type {?} */ (typeOrFunc)).annotations && (/** @type {?} */ (typeOrFunc)).annotations !== parentCtor.annotations) {
	            var /** @type {?} */ annotations = (/** @type {?} */ (typeOrFunc)).annotations;
	            if (typeof annotations === 'function' && annotations.annotations) {
	                annotations = annotations.annotations;
	            }
	            return annotations;
	        }
	        // API of tsickle for lowering decorators to properties on the class.
	        if ((/** @type {?} */ (typeOrFunc)).decorators && (/** @type {?} */ (typeOrFunc)).decorators !== parentCtor.decorators) {
	            return convertTsickleDecoratorIntoMetadata((/** @type {?} */ (typeOrFunc)).decorators);
	        }
	        // API for metadata created by invoking the decorators.
	        if (typeOrFunc.hasOwnProperty(ANNOTATIONS)) {
	            return (/** @type {?} */ (typeOrFunc))[ANNOTATIONS];
	        }
	        return null;
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.annotations = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        if (!isType(typeOrFunc)) {
	            return [];
	        }
	        var /** @type {?} */ parentCtor = getParentCtor(typeOrFunc);
	        var /** @type {?} */ ownAnnotations = this._ownAnnotations(typeOrFunc, parentCtor) || [];
	        var /** @type {?} */ parentAnnotations = parentCtor !== Object ? this.annotations(parentCtor) : [];
	        return parentAnnotations.concat(ownAnnotations);
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @param {?} parentCtor
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype._ownPropMetadata = /**
	     * @param {?} typeOrFunc
	     * @param {?} parentCtor
	     * @return {?}
	     */
	    function (typeOrFunc, parentCtor) {
	        // Prefer the direct API.
	        if ((/** @type {?} */ (typeOrFunc)).propMetadata &&
	            (/** @type {?} */ (typeOrFunc)).propMetadata !== parentCtor.propMetadata) {
	            var /** @type {?} */ propMetadata = (/** @type {?} */ (typeOrFunc)).propMetadata;
	            if (typeof propMetadata === 'function' && propMetadata.propMetadata) {
	                propMetadata = propMetadata.propMetadata;
	            }
	            return propMetadata;
	        }
	        // API of tsickle for lowering decorators to properties on the class.
	        if ((/** @type {?} */ (typeOrFunc)).propDecorators &&
	            (/** @type {?} */ (typeOrFunc)).propDecorators !== parentCtor.propDecorators) {
	            var /** @type {?} */ propDecorators_1 = (/** @type {?} */ (typeOrFunc)).propDecorators;
	            var /** @type {?} */ propMetadata_1 = /** @type {?} */ ({});
	            Object.keys(propDecorators_1).forEach(function (prop) {
	                propMetadata_1[prop] = convertTsickleDecoratorIntoMetadata(propDecorators_1[prop]);
	            });
	            return propMetadata_1;
	        }
	        // API for metadata created by invoking the decorators.
	        if (typeOrFunc.hasOwnProperty(PROP_METADATA)) {
	            return (/** @type {?} */ (typeOrFunc))[PROP_METADATA];
	        }
	        return null;
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.propMetadata = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        if (!isType(typeOrFunc)) {
	            return {};
	        }
	        var /** @type {?} */ parentCtor = getParentCtor(typeOrFunc);
	        var /** @type {?} */ propMetadata = {};
	        if (parentCtor !== Object) {
	            var /** @type {?} */ parentPropMetadata_1 = this.propMetadata(parentCtor);
	            Object.keys(parentPropMetadata_1).forEach(function (propName) {
	                propMetadata[propName] = parentPropMetadata_1[propName];
	            });
	        }
	        var /** @type {?} */ ownPropMetadata = this._ownPropMetadata(typeOrFunc, parentCtor);
	        if (ownPropMetadata) {
	            Object.keys(ownPropMetadata).forEach(function (propName) {
	                var /** @type {?} */ decorators = [];
	                if (propMetadata.hasOwnProperty(propName)) {
	                    decorators.push.apply(decorators, propMetadata[propName]);
	                }
	                decorators.push.apply(decorators, ownPropMetadata[propName]);
	                propMetadata[propName] = decorators;
	            });
	        }
	        return propMetadata;
	    };
	    /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.hasLifecycleHook = /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    function (type, lcProperty) {
	        return type instanceof Type && lcProperty in type.prototype;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.guards = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return {}; };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.getter = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return /** @type {?} */ (new Function('o', 'return o.' + name + ';')); };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.setter = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        return /** @type {?} */ (new Function('o', 'v', 'return o.' + name + ' = v;'));
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.method = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var /** @type {?} */ functionBody = "if (!o." + name + ") throw new Error('\"" + name + "\" is undefined');\n        return o." + name + ".apply(o, args);";
	        return /** @type {?} */ (new Function('o', 'args', functionBody));
	    };
	    // There is not a concept of import uri in Js, but this is useful in developing Dart applications.
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.importUri = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        // StaticSymbol
	        if (typeof type === 'object' && type['filePath']) {
	            return type['filePath'];
	        }
	        // Runtime type
	        return "./" + stringify(type);
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.resourceUri = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return "./" + stringify(type); };
	    /**
	     * @param {?} name
	     * @param {?} moduleUrl
	     * @param {?} members
	     * @param {?} runtime
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.resolveIdentifier = /**
	     * @param {?} name
	     * @param {?} moduleUrl
	     * @param {?} members
	     * @param {?} runtime
	     * @return {?}
	     */
	    function (name, moduleUrl, members, runtime) {
	        return runtime;
	    };
	    /**
	     * @param {?} enumIdentifier
	     * @param {?} name
	     * @return {?}
	     */
	    ReflectionCapabilities.prototype.resolveEnum = /**
	     * @param {?} enumIdentifier
	     * @param {?} name
	     * @return {?}
	     */
	    function (enumIdentifier, name) { return enumIdentifier[name]; };
	    return ReflectionCapabilities;
	}());
	/**
	 * @param {?} decoratorInvocations
	 * @return {?}
	 */
	function convertTsickleDecoratorIntoMetadata(decoratorInvocations) {
	    if (!decoratorInvocations) {
	        return [];
	    }
	    return decoratorInvocations.map(function (decoratorInvocation) {
	        var /** @type {?} */ decoratorType = decoratorInvocation.type;
	        var /** @type {?} */ annotationCls = decoratorType.annotationCls;
	        var /** @type {?} */ annotationArgs = decoratorInvocation.args ? decoratorInvocation.args : [];
	        return new (annotationCls.bind.apply(annotationCls, [void 0].concat(annotationArgs)))();
	    });
	}
	/**
	 * @param {?} ctor
	 * @return {?}
	 */
	function getParentCtor(ctor) {
	    var /** @type {?} */ parentProto = ctor.prototype ? Object.getPrototypeOf(ctor.prototype) : null;
	    var /** @type {?} */ parentCtor = parentProto ? parentProto.constructor : null;
	    // Note: We always use `Object` as the null value
	    // to simplify checking later on.
	    return parentCtor || Object;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Provides access to reflection data about symbols. Used internally by Angular
	 * to power dependency injection and compilation.
	 */
	var Reflector = /** @class */ (function () {
	    function Reflector(reflectionCapabilities) {
	        this.reflectionCapabilities = reflectionCapabilities;
	    }
	    /**
	     * @param {?} caps
	     * @return {?}
	     */
	    Reflector.prototype.updateCapabilities = /**
	     * @param {?} caps
	     * @return {?}
	     */
	    function (caps) { this.reflectionCapabilities = caps; };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    Reflector.prototype.factory = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return this.reflectionCapabilities.factory(type); };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    Reflector.prototype.parameters = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        return this.reflectionCapabilities.parameters(typeOrFunc);
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    Reflector.prototype.annotations = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        return this.reflectionCapabilities.annotations(typeOrFunc);
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    Reflector.prototype.propMetadata = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        return this.reflectionCapabilities.propMetadata(typeOrFunc);
	    };
	    /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    Reflector.prototype.hasLifecycleHook = /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    function (type, lcProperty) {
	        return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    Reflector.prototype.getter = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return this.reflectionCapabilities.getter(name); };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    Reflector.prototype.setter = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return this.reflectionCapabilities.setter(name); };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    Reflector.prototype.method = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return this.reflectionCapabilities.method(name); };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    Reflector.prototype.importUri = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return this.reflectionCapabilities.importUri(type); };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    Reflector.prototype.resourceUri = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return this.reflectionCapabilities.resourceUri(type); };
	    /**
	     * @param {?} name
	     * @param {?} moduleUrl
	     * @param {?} members
	     * @param {?} runtime
	     * @return {?}
	     */
	    Reflector.prototype.resolveIdentifier = /**
	     * @param {?} name
	     * @param {?} moduleUrl
	     * @param {?} members
	     * @param {?} runtime
	     * @return {?}
	     */
	    function (name, moduleUrl, members, runtime) {
	        return this.reflectionCapabilities.resolveIdentifier(name, moduleUrl, members, runtime);
	    };
	    /**
	     * @param {?} identifier
	     * @param {?} name
	     * @return {?}
	     */
	    Reflector.prototype.resolveEnum = /**
	     * @param {?} identifier
	     * @param {?} name
	     * @return {?}
	     */
	    function (identifier, name) {
	        return this.reflectionCapabilities.resolveEnum(identifier, name);
	    };
	    return Reflector;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * The {\@link Reflector} used internally in Angular to access metadata
	 * about symbols.
	 */
	var reflector = new Reflector(new ReflectionCapabilities());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * `Dependency` is used by the framework to extend DI.
	 * This is internal to Angular and should not be used directly.
	 */
	var ReflectiveDependency = /** @class */ (function () {
	    function ReflectiveDependency(key, optional, visibility) {
	        this.key = key;
	        this.optional = optional;
	        this.visibility = visibility;
	    }
	    /**
	     * @param {?} key
	     * @return {?}
	     */
	    ReflectiveDependency.fromKey = /**
	     * @param {?} key
	     * @return {?}
	     */
	    function (key) {
	        return new ReflectiveDependency(key, false, null);
	    };
	    return ReflectiveDependency;
	}());
	var _EMPTY_LIST = [];
	/**
	 * An internal resolved representation of a {\@link Provider} used by the {\@link Injector}.
	 *
	 * It is usually created automatically by `Injector.resolveAndCreate`.
	 *
	 * It can be created manually, as follows:
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/RfEnhh8kUEI0G3qsnIeT?p%3Dpreview&p=preview))
	 *
	 * ```typescript
	 * var resolvedProviders = Injector.resolve([{ provide: 'message', useValue: 'Hello' }]);
	 * var injector = Injector.fromResolvedProviders(resolvedProviders);
	 *
	 * expect(injector.get('message')).toEqual('Hello');
	 * ```
	 *
	 * \@experimental
	 * @record
	 */
	
	var ResolvedReflectiveProvider_ = /** @class */ (function () {
	    function ResolvedReflectiveProvider_(key, resolvedFactories, multiProvider) {
	        this.key = key;
	        this.resolvedFactories = resolvedFactories;
	        this.multiProvider = multiProvider;
	        this.resolvedFactory = this.resolvedFactories[0];
	    }
	    return ResolvedReflectiveProvider_;
	}());
	/**
	 * An internal resolved representation of a factory function created by resolving {\@link
	 * Provider}.
	 * \@experimental
	 */
	var ResolvedReflectiveFactory = /** @class */ (function () {
	    function ResolvedReflectiveFactory(factory, dependencies) {
	        this.factory = factory;
	        this.dependencies = dependencies;
	    }
	    return ResolvedReflectiveFactory;
	}());
	/**
	 * Resolve a single provider.
	 * @param {?} provider
	 * @return {?}
	 */
	function resolveReflectiveFactory(provider) {
	    var /** @type {?} */ factoryFn;
	    var /** @type {?} */ resolvedDeps;
	    if (provider.useClass) {
	        var /** @type {?} */ useClass = resolveForwardRef(provider.useClass);
	        factoryFn = reflector.factory(useClass);
	        resolvedDeps = _dependenciesFor(useClass);
	    }
	    else if (provider.useExisting) {
	        factoryFn = function (aliasInstance) { return aliasInstance; };
	        resolvedDeps = [ReflectiveDependency.fromKey(ReflectiveKey.get(provider.useExisting))];
	    }
	    else if (provider.useFactory) {
	        factoryFn = provider.useFactory;
	        resolvedDeps = constructDependencies(provider.useFactory, provider.deps);
	    }
	    else {
	        factoryFn = function () { return provider.useValue; };
	        resolvedDeps = _EMPTY_LIST;
	    }
	    return new ResolvedReflectiveFactory(factoryFn, resolvedDeps);
	}
	/**
	 * Converts the {\@link Provider} into {\@link ResolvedProvider}.
	 *
	 * {\@link Injector} internally only uses {\@link ResolvedProvider}, {\@link Provider} contains
	 * convenience provider syntax.
	 * @param {?} provider
	 * @return {?}
	 */
	function resolveReflectiveProvider(provider) {
	    return new ResolvedReflectiveProvider_(ReflectiveKey.get(provider.provide), [resolveReflectiveFactory(provider)], provider.multi || false);
	}
	/**
	 * Resolve a list of Providers.
	 * @param {?} providers
	 * @return {?}
	 */
	function resolveReflectiveProviders(providers) {
	    var /** @type {?} */ normalized = _normalizeProviders(providers, []);
	    var /** @type {?} */ resolved = normalized.map(resolveReflectiveProvider);
	    var /** @type {?} */ resolvedProviderMap = mergeResolvedReflectiveProviders(resolved, new Map());
	    return Array.from(resolvedProviderMap.values());
	}
	/**
	 * Merges a list of ResolvedProviders into a list where
	 * each key is contained exactly once and multi providers
	 * have been merged.
	 * @param {?} providers
	 * @param {?} normalizedProvidersMap
	 * @return {?}
	 */
	function mergeResolvedReflectiveProviders(providers, normalizedProvidersMap) {
	    for (var /** @type {?} */ i = 0; i < providers.length; i++) {
	        var /** @type {?} */ provider = providers[i];
	        var /** @type {?} */ existing = normalizedProvidersMap.get(provider.key.id);
	        if (existing) {
	            if (provider.multiProvider !== existing.multiProvider) {
	                throw mixingMultiProvidersWithRegularProvidersError(existing, provider);
	            }
	            if (provider.multiProvider) {
	                for (var /** @type {?} */ j = 0; j < provider.resolvedFactories.length; j++) {
	                    existing.resolvedFactories.push(provider.resolvedFactories[j]);
	                }
	            }
	            else {
	                normalizedProvidersMap.set(provider.key.id, provider);
	            }
	        }
	        else {
	            var /** @type {?} */ resolvedProvider = void 0;
	            if (provider.multiProvider) {
	                resolvedProvider = new ResolvedReflectiveProvider_(provider.key, provider.resolvedFactories.slice(), provider.multiProvider);
	            }
	            else {
	                resolvedProvider = provider;
	            }
	            normalizedProvidersMap.set(provider.key.id, resolvedProvider);
	        }
	    }
	    return normalizedProvidersMap;
	}
	/**
	 * @param {?} providers
	 * @param {?} res
	 * @return {?}
	 */
	function _normalizeProviders(providers, res) {
	    providers.forEach(function (b) {
	        if (b instanceof Type) {
	            res.push({ provide: b, useClass: b });
	        }
	        else if (b && typeof b == 'object' && (/** @type {?} */ (b)).provide !== undefined) {
	            res.push(/** @type {?} */ (b));
	        }
	        else if (b instanceof Array) {
	            _normalizeProviders(b, res);
	        }
	        else {
	            throw invalidProviderError(b);
	        }
	    });
	    return res;
	}
	/**
	 * @param {?} typeOrFunc
	 * @param {?=} dependencies
	 * @return {?}
	 */
	function constructDependencies(typeOrFunc, dependencies) {
	    if (!dependencies) {
	        return _dependenciesFor(typeOrFunc);
	    }
	    else {
	        var /** @type {?} */ params_1 = dependencies.map(function (t) { return [t]; });
	        return dependencies.map(function (t) { return _extractToken(typeOrFunc, t, params_1); });
	    }
	}
	/**
	 * @param {?} typeOrFunc
	 * @return {?}
	 */
	function _dependenciesFor(typeOrFunc) {
	    var /** @type {?} */ params = reflector.parameters(typeOrFunc);
	    if (!params)
	        return [];
	    if (params.some(function (p) { return p == null; })) {
	        throw noAnnotationError(typeOrFunc, params);
	    }
	    return params.map(function (p) { return _extractToken(typeOrFunc, p, params); });
	}
	/**
	 * @param {?} typeOrFunc
	 * @param {?} metadata
	 * @param {?} params
	 * @return {?}
	 */
	function _extractToken(typeOrFunc, metadata, params) {
	    var /** @type {?} */ token = null;
	    var /** @type {?} */ optional = false;
	    if (!Array.isArray(metadata)) {
	        if (metadata instanceof Inject) {
	            return _createDependency(metadata.token, optional, null);
	        }
	        else {
	            return _createDependency(metadata, optional, null);
	        }
	    }
	    var /** @type {?} */ visibility = null;
	    for (var /** @type {?} */ i = 0; i < metadata.length; ++i) {
	        var /** @type {?} */ paramMetadata = metadata[i];
	        if (paramMetadata instanceof Type) {
	            token = paramMetadata;
	        }
	        else if (paramMetadata instanceof Inject) {
	            token = paramMetadata.token;
	        }
	        else if (paramMetadata instanceof Optional) {
	            optional = true;
	        }
	        else if (paramMetadata instanceof Self || paramMetadata instanceof SkipSelf) {
	            visibility = paramMetadata;
	        }
	        else if (paramMetadata instanceof InjectionToken) {
	            token = paramMetadata;
	        }
	    }
	    token = resolveForwardRef(token);
	    if (token != null) {
	        return _createDependency(token, optional, visibility);
	    }
	    else {
	        throw noAnnotationError(typeOrFunc, params);
	    }
	}
	/**
	 * @param {?} token
	 * @param {?} optional
	 * @param {?} visibility
	 * @return {?}
	 */
	function _createDependency(token, optional, visibility) {
	    return new ReflectiveDependency(ReflectiveKey.get(token), optional, visibility);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// Threshold for the dynamic version
	var UNDEFINED = new Object();
	/**
	 * A ReflectiveDependency injection container used for instantiating objects and resolving
	 * dependencies.
	 *
	 * An `Injector` is a replacement for a `new` operator, which can automatically resolve the
	 * constructor dependencies.
	 *
	 * In typical use, application code asks for the dependencies in the constructor and they are
	 * resolved by the `Injector`.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/jzjec0?p=preview))
	 *
	 * The following example creates an `Injector` configured to create `Engine` and `Car`.
	 *
	 * ```typescript
	 * \@Injectable()
	 * class Engine {
	 * }
	 *
	 * \@Injectable()
	 * class Car {
	 *   constructor(public engine:Engine) {}
	 * }
	 *
	 * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
	 * var car = injector.get(Car);
	 * expect(car instanceof Car).toBe(true);
	 * expect(car.engine instanceof Engine).toBe(true);
	 * ```
	 *
	 * Notice, we don't use the `new` operator because we explicitly want to have the `Injector`
	 * resolve all of the object's dependencies automatically.
	 *
	 * @deprecated from v5 - slow and brings in a lot of code, Use `Injector.create` instead.
	 * @abstract
	 */
	var ReflectiveInjector = /** @class */ (function () {
	    function ReflectiveInjector() {
	    }
	    /**
	     * Turns an array of provider definitions into an array of resolved providers.
	     *
	     * A resolution is a process of flattening multiple nested arrays and converting individual
	     * providers into an array of {@link ResolvedReflectiveProvider}s.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/AiXTHi?p=preview))
	     *
	     * ```typescript
	     * @Injectable()
	     * class Engine {
	     * }
	     *
	     * @Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
	     *
	     * expect(providers.length).toEqual(2);
	     *
	     * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
	     * expect(providers[0].key.displayName).toBe("Car");
	     * expect(providers[0].dependencies.length).toEqual(1);
	     * expect(providers[0].factory).toBeDefined();
	     *
	     * expect(providers[1].key.displayName).toBe("Engine");
	     * });
	     * ```
	     *
	     * See {@link ReflectiveInjector#fromResolvedProviders fromResolvedProviders} for more info.
	     */
	    /**
	     * Turns an array of provider definitions into an array of resolved providers.
	     *
	     * A resolution is a process of flattening multiple nested arrays and converting individual
	     * providers into an array of {\@link ResolvedReflectiveProvider}s.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/AiXTHi?p=preview))
	     *
	     * ```typescript
	     * \@Injectable()
	     * class Engine {
	     * }
	     *
	     * \@Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
	     *
	     * expect(providers.length).toEqual(2);
	     *
	     * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
	     * expect(providers[0].key.displayName).toBe("Car");
	     * expect(providers[0].dependencies.length).toEqual(1);
	     * expect(providers[0].factory).toBeDefined();
	     *
	     * expect(providers[1].key.displayName).toBe("Engine");
	     * });
	     * ```
	     *
	     * See {\@link ReflectiveInjector#fromResolvedProviders fromResolvedProviders} for more info.
	     * @param {?} providers
	     * @return {?}
	     */
	    ReflectiveInjector.resolve = /**
	     * Turns an array of provider definitions into an array of resolved providers.
	     *
	     * A resolution is a process of flattening multiple nested arrays and converting individual
	     * providers into an array of {\@link ResolvedReflectiveProvider}s.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/AiXTHi?p=preview))
	     *
	     * ```typescript
	     * \@Injectable()
	     * class Engine {
	     * }
	     *
	     * \@Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
	     *
	     * expect(providers.length).toEqual(2);
	     *
	     * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
	     * expect(providers[0].key.displayName).toBe("Car");
	     * expect(providers[0].dependencies.length).toEqual(1);
	     * expect(providers[0].factory).toBeDefined();
	     *
	     * expect(providers[1].key.displayName).toBe("Engine");
	     * });
	     * ```
	     *
	     * See {\@link ReflectiveInjector#fromResolvedProviders fromResolvedProviders} for more info.
	     * @param {?} providers
	     * @return {?}
	     */
	    function (providers) {
	        return resolveReflectiveProviders(providers);
	    };
	    /**
	     * Resolves an array of providers and creates an injector from those providers.
	     *
	     * The passed-in providers can be an array of `Type`, {@link Provider},
	     * or a recursive array of more providers.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/ePOccA?p=preview))
	     *
	     * ```typescript
	     * @Injectable()
	     * class Engine {
	     * }
	     *
	     * @Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
	     * expect(injector.get(Car) instanceof Car).toBe(true);
	     * ```
	     *
	     * This function is slower than the corresponding `fromResolvedProviders`
	     * because it needs to resolve the passed-in providers first.
	     * See {@link ReflectiveInjector#resolve resolve} and
	     * {@link ReflectiveInjector#fromResolvedProviders fromResolvedProviders}.
	     */
	    /**
	     * Resolves an array of providers and creates an injector from those providers.
	     *
	     * The passed-in providers can be an array of `Type`, {\@link Provider},
	     * or a recursive array of more providers.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/ePOccA?p=preview))
	     *
	     * ```typescript
	     * \@Injectable()
	     * class Engine {
	     * }
	     *
	     * \@Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
	     * expect(injector.get(Car) instanceof Car).toBe(true);
	     * ```
	     *
	     * This function is slower than the corresponding `fromResolvedProviders`
	     * because it needs to resolve the passed-in providers first.
	     * See {\@link ReflectiveInjector#resolve resolve} and
	     * {\@link ReflectiveInjector#fromResolvedProviders fromResolvedProviders}.
	     * @param {?} providers
	     * @param {?=} parent
	     * @return {?}
	     */
	    ReflectiveInjector.resolveAndCreate = /**
	     * Resolves an array of providers and creates an injector from those providers.
	     *
	     * The passed-in providers can be an array of `Type`, {\@link Provider},
	     * or a recursive array of more providers.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/ePOccA?p=preview))
	     *
	     * ```typescript
	     * \@Injectable()
	     * class Engine {
	     * }
	     *
	     * \@Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
	     * expect(injector.get(Car) instanceof Car).toBe(true);
	     * ```
	     *
	     * This function is slower than the corresponding `fromResolvedProviders`
	     * because it needs to resolve the passed-in providers first.
	     * See {\@link ReflectiveInjector#resolve resolve} and
	     * {\@link ReflectiveInjector#fromResolvedProviders fromResolvedProviders}.
	     * @param {?} providers
	     * @param {?=} parent
	     * @return {?}
	     */
	    function (providers, parent) {
	        var /** @type {?} */ ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
	        return ReflectiveInjector.fromResolvedProviders(ResolvedReflectiveProviders, parent);
	    };
	    /**
	     * Creates an injector from previously resolved providers.
	     *
	     * This API is the recommended way to construct injectors in performance-sensitive parts.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/KrSMci?p=preview))
	     *
	     * ```typescript
	     * @Injectable()
	     * class Engine {
	     * }
	     *
	     * @Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var providers = ReflectiveInjector.resolve([Car, Engine]);
	     * var injector = ReflectiveInjector.fromResolvedProviders(providers);
	     * expect(injector.get(Car) instanceof Car).toBe(true);
	     * ```
	     * @experimental
	     */
	    /**
	     * Creates an injector from previously resolved providers.
	     *
	     * This API is the recommended way to construct injectors in performance-sensitive parts.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/KrSMci?p=preview))
	     *
	     * ```typescript
	     * \@Injectable()
	     * class Engine {
	     * }
	     *
	     * \@Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var providers = ReflectiveInjector.resolve([Car, Engine]);
	     * var injector = ReflectiveInjector.fromResolvedProviders(providers);
	     * expect(injector.get(Car) instanceof Car).toBe(true);
	     * ```
	     * \@experimental
	     * @param {?} providers
	     * @param {?=} parent
	     * @return {?}
	     */
	    ReflectiveInjector.fromResolvedProviders = /**
	     * Creates an injector from previously resolved providers.
	     *
	     * This API is the recommended way to construct injectors in performance-sensitive parts.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/KrSMci?p=preview))
	     *
	     * ```typescript
	     * \@Injectable()
	     * class Engine {
	     * }
	     *
	     * \@Injectable()
	     * class Car {
	     *   constructor(public engine:Engine) {}
	     * }
	     *
	     * var providers = ReflectiveInjector.resolve([Car, Engine]);
	     * var injector = ReflectiveInjector.fromResolvedProviders(providers);
	     * expect(injector.get(Car) instanceof Car).toBe(true);
	     * ```
	     * \@experimental
	     * @param {?} providers
	     * @param {?=} parent
	     * @return {?}
	     */
	    function (providers, parent) {
	        return new ReflectiveInjector_(providers, parent);
	    };
	    return ReflectiveInjector;
	}());
	var ReflectiveInjector_ = /** @class */ (function () {
	    /**
	     * Private
	     */
	    function ReflectiveInjector_(_providers, _parent) {
	        /**
	         * \@internal
	         */
	        this._constructionCounter = 0;
	        this._providers = _providers;
	        this.parent = _parent || null;
	        var /** @type {?} */ len = _providers.length;
	        this.keyIds = new Array(len);
	        this.objs = new Array(len);
	        for (var /** @type {?} */ i = 0; i < len; i++) {
	            this.keyIds[i] = _providers[i].key.id;
	            this.objs[i] = UNDEFINED;
	        }
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        if (notFoundValue === void 0) { notFoundValue = THROW_IF_NOT_FOUND; }
	        return this._getByKey(ReflectiveKey.get(token), null, notFoundValue);
	    };
	    /**
	     * @param {?} providers
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.resolveAndCreateChild = /**
	     * @param {?} providers
	     * @return {?}
	     */
	    function (providers) {
	        var /** @type {?} */ ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
	        return this.createChildFromResolved(ResolvedReflectiveProviders);
	    };
	    /**
	     * @param {?} providers
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.createChildFromResolved = /**
	     * @param {?} providers
	     * @return {?}
	     */
	    function (providers) {
	        var /** @type {?} */ inj = new ReflectiveInjector_(providers);
	        (/** @type {?} */ (inj)).parent = this;
	        return inj;
	    };
	    /**
	     * @param {?} provider
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.resolveAndInstantiate = /**
	     * @param {?} provider
	     * @return {?}
	     */
	    function (provider) {
	        return this.instantiateResolved(ReflectiveInjector.resolve([provider])[0]);
	    };
	    /**
	     * @param {?} provider
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.instantiateResolved = /**
	     * @param {?} provider
	     * @return {?}
	     */
	    function (provider) {
	        return this._instantiateProvider(provider);
	    };
	    /**
	     * @param {?} index
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.getProviderAtIndex = /**
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        if (index < 0 || index >= this._providers.length) {
	            throw outOfBoundsError(index);
	        }
	        return this._providers[index];
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} provider
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._new = /**
	     * \@internal
	     * @param {?} provider
	     * @return {?}
	     */
	    function (provider) {
	        if (this._constructionCounter++ > this._getMaxNumberOfObjects()) {
	            throw cyclicDependencyError(this, provider.key);
	        }
	        return this._instantiateProvider(provider);
	    };
	    /**
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._getMaxNumberOfObjects = /**
	     * @return {?}
	     */
	    function () { return this.objs.length; };
	    /**
	     * @param {?} provider
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._instantiateProvider = /**
	     * @param {?} provider
	     * @return {?}
	     */
	    function (provider) {
	        if (provider.multiProvider) {
	            var /** @type {?} */ res = new Array(provider.resolvedFactories.length);
	            for (var /** @type {?} */ i = 0; i < provider.resolvedFactories.length; ++i) {
	                res[i] = this._instantiate(provider, provider.resolvedFactories[i]);
	            }
	            return res;
	        }
	        else {
	            return this._instantiate(provider, provider.resolvedFactories[0]);
	        }
	    };
	    /**
	     * @param {?} provider
	     * @param {?} ResolvedReflectiveFactory
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._instantiate = /**
	     * @param {?} provider
	     * @param {?} ResolvedReflectiveFactory
	     * @return {?}
	     */
	    function (provider, ResolvedReflectiveFactory$$1) {
	        var _this = this;
	        var /** @type {?} */ factory = ResolvedReflectiveFactory$$1.factory;
	        var /** @type {?} */ deps;
	        try {
	            deps =
	                ResolvedReflectiveFactory$$1.dependencies.map(function (dep) { return _this._getByReflectiveDependency(dep); });
	        }
	        catch (/** @type {?} */ e) {
	            if (e.addKey) {
	                e.addKey(this, provider.key);
	            }
	            throw e;
	        }
	        var /** @type {?} */ obj;
	        try {
	            obj = factory.apply(void 0, deps);
	        }
	        catch (/** @type {?} */ e) {
	            throw instantiationError(this, e, e.stack, provider.key);
	        }
	        return obj;
	    };
	    /**
	     * @param {?} dep
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._getByReflectiveDependency = /**
	     * @param {?} dep
	     * @return {?}
	     */
	    function (dep) {
	        return this._getByKey(dep.key, dep.visibility, dep.optional ? null : THROW_IF_NOT_FOUND);
	    };
	    /**
	     * @param {?} key
	     * @param {?} visibility
	     * @param {?} notFoundValue
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._getByKey = /**
	     * @param {?} key
	     * @param {?} visibility
	     * @param {?} notFoundValue
	     * @return {?}
	     */
	    function (key, visibility, notFoundValue) {
	        if (key === ReflectiveInjector_.INJECTOR_KEY) {
	            return this;
	        }
	        if (visibility instanceof Self) {
	            return this._getByKeySelf(key, notFoundValue);
	        }
	        else {
	            return this._getByKeyDefault(key, notFoundValue, visibility);
	        }
	    };
	    /**
	     * @param {?} keyId
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._getObjByKeyId = /**
	     * @param {?} keyId
	     * @return {?}
	     */
	    function (keyId) {
	        for (var /** @type {?} */ i = 0; i < this.keyIds.length; i++) {
	            if (this.keyIds[i] === keyId) {
	                if (this.objs[i] === UNDEFINED) {
	                    this.objs[i] = this._new(this._providers[i]);
	                }
	                return this.objs[i];
	            }
	        }
	        return UNDEFINED;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} key
	     * @param {?} notFoundValue
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._throwOrNull = /**
	     * \@internal
	     * @param {?} key
	     * @param {?} notFoundValue
	     * @return {?}
	     */
	    function (key, notFoundValue) {
	        if (notFoundValue !== THROW_IF_NOT_FOUND) {
	            return notFoundValue;
	        }
	        else {
	            throw noProviderError(this, key);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} key
	     * @param {?} notFoundValue
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._getByKeySelf = /**
	     * \@internal
	     * @param {?} key
	     * @param {?} notFoundValue
	     * @return {?}
	     */
	    function (key, notFoundValue) {
	        var /** @type {?} */ obj = this._getObjByKeyId(key.id);
	        return (obj !== UNDEFINED) ? obj : this._throwOrNull(key, notFoundValue);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} key
	     * @param {?} notFoundValue
	     * @param {?} visibility
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype._getByKeyDefault = /**
	     * \@internal
	     * @param {?} key
	     * @param {?} notFoundValue
	     * @param {?} visibility
	     * @return {?}
	     */
	    function (key, notFoundValue, visibility) {
	        var /** @type {?} */ inj;
	        if (visibility instanceof SkipSelf) {
	            inj = this.parent;
	        }
	        else {
	            inj = this;
	        }
	        while (inj instanceof ReflectiveInjector_) {
	            var /** @type {?} */ inj_ = /** @type {?} */ (inj);
	            var /** @type {?} */ obj = inj_._getObjByKeyId(key.id);
	            if (obj !== UNDEFINED)
	                return obj;
	            inj = inj_.parent;
	        }
	        if (inj !== null) {
	            return inj.get(key.token, notFoundValue);
	        }
	        else {
	            return this._throwOrNull(key, notFoundValue);
	        }
	    };
	    Object.defineProperty(ReflectiveInjector_.prototype, "displayName", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ providers = _mapProviders(this, function (b) { return ' "' + b.key.displayName + '" '; })
	                .join(', ');
	            return "ReflectiveInjector(providers: [" + providers + "])";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    ReflectiveInjector_.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return this.displayName; };
	    ReflectiveInjector_.INJECTOR_KEY = ReflectiveKey.get(Injector);
	    return ReflectiveInjector_;
	}());
	/**
	 * @param {?} injector
	 * @param {?} fn
	 * @return {?}
	 */
	function _mapProviders(injector, fn) {
	    var /** @type {?} */ res = new Array(injector._providers.length);
	    for (var /** @type {?} */ i = 0; i < injector._providers.length; ++i) {
	        res[i] = fn(injector.getProviderAtIndex(i));
	    }
	    return res;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @module
	 * @description
	 * The `di` module provides dependency injection container services.
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Determine if the argument is shaped like a Promise
	 * @param {?} obj
	 * @return {?}
	 */
	function isPromise(obj) {
	    // allow any Promise/A+ compliant thenable.
	    // It's up to the caller to ensure that obj.then conforms to the spec
	    return !!obj && typeof obj.then === 'function';
	}
	/**
	 * Determine if the argument is an Observable
	 * @param {?} obj
	 * @return {?}
	 */
	function isObservable(obj) {
	    // TODO: use Symbol.observable when https://github.com/ReactiveX/rxjs/issues/2415 will be resolved
	    return !!obj && typeof obj.subscribe === 'function';
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A function that will be executed when an application is initialized.
	 * \@experimental
	 */
	var APP_INITIALIZER = new InjectionToken('Application Initializer');
	/**
	 * A class that reflects the state of running {\@link APP_INITIALIZER}s.
	 *
	 * \@experimental
	 */
	var ApplicationInitStatus = /** @class */ (function () {
	    function ApplicationInitStatus(appInits) {
	        var _this = this;
	        this.appInits = appInits;
	        this.initialized = false;
	        this.done = false;
	        this.donePromise = new Promise(function (res, rej) {
	            _this.resolve = res;
	            _this.reject = rej;
	        });
	    }
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    ApplicationInitStatus.prototype.runInitializers = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.initialized) {
	            return;
	        }
	        var /** @type {?} */ asyncInitPromises = [];
	        var /** @type {?} */ complete = function () {
	            (/** @type {?} */ (_this)).done = true;
	            _this.resolve();
	        };
	        if (this.appInits) {
	            for (var /** @type {?} */ i = 0; i < this.appInits.length; i++) {
	                var /** @type {?} */ initResult = this.appInits[i]();
	                if (isPromise(initResult)) {
	                    asyncInitPromises.push(initResult);
	                }
	            }
	        }
	        Promise.all(asyncInitPromises).then(function () { complete(); }).catch(function (e) { _this.reject(e); });
	        if (asyncInitPromises.length === 0) {
	            complete();
	        }
	        this.initialized = true;
	    };
	    ApplicationInitStatus.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    ApplicationInitStatus.ctorParameters = function () { return [
	        { type: Array, decorators: [{ type: Inject, args: [APP_INITIALIZER,] }, { type: Optional },] },
	    ]; };
	    return ApplicationInitStatus;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A DI Token representing a unique string id assigned to the application by Angular and used
	 * primarily for prefixing application attributes and CSS styles when
	 * {\@link ViewEncapsulation#Emulated ViewEncapsulation.Emulated} is being used.
	 *
	 * If you need to avoid randomly generated value to be used as an application id, you can provide
	 * a custom value via a DI provider <!-- TODO: provider --> configuring the root {\@link Injector}
	 * using this token.
	 * \@experimental
	 */
	var APP_ID = new InjectionToken('AppId');
	/**
	 * @return {?}
	 */
	function _appIdRandomProviderFactory() {
	    return "" + _randomChar() + _randomChar() + _randomChar();
	}
	/**
	 * Providers that will generate a random APP_ID_TOKEN.
	 * \@experimental
	 */
	var APP_ID_RANDOM_PROVIDER = {
	    provide: APP_ID,
	    useFactory: _appIdRandomProviderFactory,
	    deps: /** @type {?} */ ([]),
	};
	/**
	 * @return {?}
	 */
	function _randomChar() {
	    return String.fromCharCode(97 + Math.floor(Math.random() * 25));
	}
	/**
	 * A function that will be executed when a platform is initialized.
	 * \@experimental
	 */
	var PLATFORM_INITIALIZER = new InjectionToken('Platform Initializer');
	/**
	 * A token that indicates an opaque platform id.
	 * \@experimental
	 */
	var PLATFORM_ID = new InjectionToken('Platform ID');
	/**
	 * All callbacks provided via this token will be called for every component that is bootstrapped.
	 * Signature of the callback:
	 *
	 * `(componentRef: ComponentRef) => void`.
	 *
	 * \@experimental
	 */
	var APP_BOOTSTRAP_LISTENER = new InjectionToken('appBootstrapListener');
	/**
	 * A token which indicates the root directory of the application
	 * \@experimental
	 */
	var PACKAGE_ROOT_URL = new InjectionToken('Application Packages Root URL');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var Console = /** @class */ (function () {
	    function Console() {
	    }
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Console.prototype.log = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) {
	        // tslint:disable-next-line:no-console
	        console.log(message);
	    };
	    // Note: for reporting errors use `DOM.logError()` as it is platform specific
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Console.prototype.warn = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) {
	        // tslint:disable-next-line:no-console
	        console.warn(message);
	    };
	    Console.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    Console.ctorParameters = function () { return []; };
	    return Console;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Combination of NgModuleFactory and ComponentFactorys.
	 *
	 * \@experimental
	 * @template T
	 */
	var ModuleWithComponentFactories = /** @class */ (function () {
	    function ModuleWithComponentFactories(ngModuleFactory, componentFactories) {
	        this.ngModuleFactory = ngModuleFactory;
	        this.componentFactories = componentFactories;
	    }
	    return ModuleWithComponentFactories;
	}());
	/**
	 * @return {?}
	 */
	function _throwError() {
	    throw new Error("Runtime compiler is not loaded");
	}
	/**
	 * Low-level service for running the angular compiler during runtime
	 * to create {\@link ComponentFactory}s, which
	 * can later be used to create and render a Component instance.
	 *
	 * Each `\@NgModule` provides an own `Compiler` to its injector,
	 * that will use the directives/pipes of the ng module for compilation
	 * of components.
	 * \@stable
	 */
	var Compiler = /** @class */ (function () {
	    function Compiler() {
	    }
	    /**
	     * Compiles the given NgModule and all of its components. All templates of the components listed
	     * in `entryComponents` have to be inlined.
	     */
	    /**
	     * Compiles the given NgModule and all of its components. All templates of the components listed
	     * in `entryComponents` have to be inlined.
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    Compiler.prototype.compileModuleSync = /**
	     * Compiles the given NgModule and all of its components. All templates of the components listed
	     * in `entryComponents` have to be inlined.
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) { throw _throwError(); };
	    /**
	     * Compiles the given NgModule and all of its components
	     */
	    /**
	     * Compiles the given NgModule and all of its components
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    Compiler.prototype.compileModuleAsync = /**
	     * Compiles the given NgModule and all of its components
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) { throw _throwError(); };
	    /**
	     * Same as {@link #compileModuleSync} but also creates ComponentFactories for all components.
	     */
	    /**
	     * Same as {\@link #compileModuleSync} but also creates ComponentFactories for all components.
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    Compiler.prototype.compileModuleAndAllComponentsSync = /**
	     * Same as {\@link #compileModuleSync} but also creates ComponentFactories for all components.
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        throw _throwError();
	    };
	    /**
	     * Same as {@link #compileModuleAsync} but also creates ComponentFactories for all components.
	     */
	    /**
	     * Same as {\@link #compileModuleAsync} but also creates ComponentFactories for all components.
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    Compiler.prototype.compileModuleAndAllComponentsAsync = /**
	     * Same as {\@link #compileModuleAsync} but also creates ComponentFactories for all components.
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        throw _throwError();
	    };
	    /**
	     * Clears all caches.
	     */
	    /**
	     * Clears all caches.
	     * @return {?}
	     */
	    Compiler.prototype.clearCache = /**
	     * Clears all caches.
	     * @return {?}
	     */
	    function () { };
	    /**
	     * Clears the cache for the given component/ngModule.
	     */
	    /**
	     * Clears the cache for the given component/ngModule.
	     * @param {?} type
	     * @return {?}
	     */
	    Compiler.prototype.clearCacheFor = /**
	     * Clears the cache for the given component/ngModule.
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { };
	    Compiler.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    Compiler.ctorParameters = function () { return []; };
	    return Compiler;
	}());
	/**
	 * Token to provide CompilerOptions in the platform injector.
	 *
	 * \@experimental
	 */
	var COMPILER_OPTIONS = new InjectionToken('compilerOptions');
	/**
	 * A factory for creating a Compiler
	 *
	 * \@experimental
	 * @abstract
	 */
	var CompilerFactory = /** @class */ (function () {
	    function CompilerFactory() {
	    }
	    return CompilerFactory;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Represents an instance of a Component created via a {\@link ComponentFactory}.
	 *
	 * `ComponentRef` provides access to the Component Instance as well other objects related to this
	 * Component Instance and allows you to destroy the Component Instance via the {\@link #destroy}
	 * method.
	 * \@stable
	 * @abstract
	 * @template C
	 */
	var ComponentRef = /** @class */ (function () {
	    function ComponentRef() {
	    }
	    return ComponentRef;
	}());
	/**
	 * \@stable
	 * @abstract
	 * @template C
	 */
	var ComponentFactory = /** @class */ (function () {
	    function ComponentFactory() {
	    }
	    return ComponentFactory;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} component
	 * @return {?}
	 */
	function noComponentFactoryError(component) {
	    var /** @type {?} */ error = Error("No component factory found for " + stringify(component) + ". Did you add it to @NgModule.entryComponents?");
	    (/** @type {?} */ (error))[ERROR_COMPONENT] = component;
	    return error;
	}
	var ERROR_COMPONENT = 'ngComponent';
	/**
	 * @param {?} error
	 * @return {?}
	 */
	
	var _NullComponentFactoryResolver = /** @class */ (function () {
	    function _NullComponentFactoryResolver() {
	    }
	    /**
	     * @template T
	     * @param {?} component
	     * @return {?}
	     */
	    _NullComponentFactoryResolver.prototype.resolveComponentFactory = /**
	     * @template T
	     * @param {?} component
	     * @return {?}
	     */
	    function (component) {
	        throw noComponentFactoryError(component);
	    };
	    return _NullComponentFactoryResolver;
	}());
	/**
	 * \@stable
	 * @abstract
	 */
	var ComponentFactoryResolver = /** @class */ (function () {
	    function ComponentFactoryResolver() {
	    }
	    ComponentFactoryResolver.NULL = new _NullComponentFactoryResolver();
	    return ComponentFactoryResolver;
	}());
	var CodegenComponentFactoryResolver = /** @class */ (function () {
	    function CodegenComponentFactoryResolver(factories, _parent, _ngModule) {
	        this._parent = _parent;
	        this._ngModule = _ngModule;
	        this._factories = new Map();
	        for (var /** @type {?} */ i = 0; i < factories.length; i++) {
	            var /** @type {?} */ factory = factories[i];
	            this._factories.set(factory.componentType, factory);
	        }
	    }
	    /**
	     * @template T
	     * @param {?} component
	     * @return {?}
	     */
	    CodegenComponentFactoryResolver.prototype.resolveComponentFactory = /**
	     * @template T
	     * @param {?} component
	     * @return {?}
	     */
	    function (component) {
	        var /** @type {?} */ factory = this._factories.get(component);
	        if (!factory && this._parent) {
	            factory = this._parent.resolveComponentFactory(component);
	        }
	        if (!factory) {
	            throw noComponentFactoryError(component);
	        }
	        return new ComponentFactoryBoundToModule(factory, this._ngModule);
	    };
	    return CodegenComponentFactoryResolver;
	}());
	/**
	 * @template C
	 */
	var ComponentFactoryBoundToModule = /** @class */ (function (_super) {
	    __extends(ComponentFactoryBoundToModule, _super);
	    function ComponentFactoryBoundToModule(factory, ngModule) {
	        var _this = _super.call(this) || this;
	        _this.factory = factory;
	        _this.ngModule = ngModule;
	        _this.selector = factory.selector;
	        _this.componentType = factory.componentType;
	        _this.ngContentSelectors = factory.ngContentSelectors;
	        _this.inputs = factory.inputs;
	        _this.outputs = factory.outputs;
	        return _this;
	    }
	    /**
	     * @param {?} injector
	     * @param {?=} projectableNodes
	     * @param {?=} rootSelectorOrNode
	     * @param {?=} ngModule
	     * @return {?}
	     */
	    ComponentFactoryBoundToModule.prototype.create = /**
	     * @param {?} injector
	     * @param {?=} projectableNodes
	     * @param {?=} rootSelectorOrNode
	     * @param {?=} ngModule
	     * @return {?}
	     */
	    function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
	        return this.factory.create(injector, projectableNodes, rootSelectorOrNode, ngModule || this.ngModule);
	    };
	    return ComponentFactoryBoundToModule;
	}(ComponentFactory));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Represents an instance of an NgModule created via a {\@link NgModuleFactory}.
	 *
	 * `NgModuleRef` provides access to the NgModule Instance as well other objects related to this
	 * NgModule Instance.
	 *
	 * \@stable
	 * @abstract
	 * @template T
	 */
	var NgModuleRef = /** @class */ (function () {
	    function NgModuleRef() {
	    }
	    return NgModuleRef;
	}());
	/**
	 * @record
	 * @template T
	 */
	
	/**
	 * \@experimental
	 * @abstract
	 * @template T
	 */
	var NgModuleFactory = /** @class */ (function () {
	    function NgModuleFactory() {
	    }
	    return NgModuleFactory;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A scope function for the Web Tracing Framework (WTF).
	 *
	 * \@experimental
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	var trace;
	var events;
	/**
	 * @return {?}
	 */
	function detectWTF() {
	    var /** @type {?} */ wtf = (/** @type {?} */ (_global /** TODO #9100 */) /** TODO #9100 */)['wtf'];
	    if (wtf) {
	        trace = wtf['trace'];
	        if (trace) {
	            events = trace['events'];
	            return true;
	        }
	    }
	    return false;
	}
	/**
	 * @param {?} signature
	 * @param {?=} flags
	 * @return {?}
	 */
	function createScope(signature, flags) {
	    if (flags === void 0) { flags = null; }
	    return events.createScope(signature, flags);
	}
	/**
	 * @template T
	 * @param {?} scope
	 * @param {?=} returnValue
	 * @return {?}
	 */
	function leave(scope, returnValue) {
	    trace.leaveScope(scope, returnValue);
	    return returnValue;
	}
	/**
	 * @param {?} rangeType
	 * @param {?} action
	 * @return {?}
	 */
	function startTimeRange(rangeType, action) {
	    return trace.beginTimeRange(rangeType, action);
	}
	/**
	 * @param {?} range
	 * @return {?}
	 */
	function endTimeRange(range) {
	    trace.endTimeRange(range);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * True if WTF is enabled.
	 */
	var wtfEnabled = detectWTF();
	/**
	 * @param {?=} arg0
	 * @param {?=} arg1
	 * @return {?}
	 */
	function noopScope(arg0, arg1) {
	    return null;
	}
	/**
	 * Create trace scope.
	 *
	 * Scopes must be strictly nested and are analogous to stack frames, but
	 * do not have to follow the stack frames. Instead it is recommended that they follow logical
	 * nesting. You may want to use
	 * [Event
	 * Signatures](http://google.github.io/tracing-framework/instrumenting-code.html#custom-events)
	 * as they are defined in WTF.
	 *
	 * Used to mark scope entry. The return value is used to leave the scope.
	 *
	 *     var myScope = wtfCreateScope('MyClass#myMethod(ascii someVal)');
	 *
	 *     someMethod() {
	 *        var s = myScope('Foo'); // 'Foo' gets stored in tracing UI
	 *        // DO SOME WORK HERE
	 *        return wtfLeave(s, 123); // Return value 123
	 *     }
	 *
	 * Note, adding try-finally block around the work to ensure that `wtfLeave` gets called can
	 * negatively impact the performance of your application. For this reason we recommend that
	 * you don't add them to ensure that `wtfLeave` gets called. In production `wtfLeave` is a noop and
	 * so try-finally block has no value. When debugging perf issues, skipping `wtfLeave`, do to
	 * exception, will produce incorrect trace, but presence of exception signifies logic error which
	 * needs to be fixed before the app should be profiled. Add try-finally only when you expect that
	 * an exception is expected during normal execution while profiling.
	 *
	 * \@experimental
	 */
	var wtfCreateScope = wtfEnabled ? createScope : function (signature, flags) { return noopScope; };
	/**
	 * Used to mark end of Scope.
	 *
	 * - `scope` to end.
	 * - `returnValue` (optional) to be passed to the WTF.
	 *
	 * Returns the `returnValue for easy chaining.
	 * \@experimental
	 */
	var wtfLeave = wtfEnabled ? leave : function (s, r) { return r; };
	/**
	 * Used to mark Async start. Async are similar to scope but they don't have to be strictly nested.
	 * The return value is used in the call to [endAsync]. Async ranges only work if WTF has been
	 * enabled.
	 *
	 *     someMethod() {
	 *        var s = wtfStartTimeRange('HTTP:GET', 'some.url');
	 *        var future = new Future.delay(5).then((_) {
	 *          wtfEndTimeRange(s);
	 *        });
	 *     }
	 * \@experimental
	 */
	var wtfStartTimeRange = wtfEnabled ? startTimeRange : function (rangeType, action) { return null; };
	/**
	 * Ends a async time range operation.
	 * [range] is the return value from [wtfStartTimeRange] Async ranges only work if WTF has been
	 * enabled.
	 * \@experimental
	 */
	var wtfEndTimeRange = wtfEnabled ? endTimeRange : function (r) { return null; };
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Use by directives and components to emit custom Events.
	 *
	 * ### Examples
	 *
	 * In the following example, `Zippy` alternatively emits `open` and `close` events when its
	 * title gets clicked:
	 *
	 * ```
	 * \@Component({
	 *   selector: 'zippy',
	 *   template: `
	 *   <div class="zippy">
	 *     <div (click)="toggle()">Toggle</div>
	 *     <div [hidden]="!visible">
	 *       <ng-content></ng-content>
	 *     </div>
	 *  </div>`})
	 * export class Zippy {
	 *   visible: boolean = true;
	 *   \@Output() open: EventEmitter<any> = new EventEmitter();
	 *   \@Output() close: EventEmitter<any> = new EventEmitter();
	 *
	 *   toggle() {
	 *     this.visible = !this.visible;
	 *     if (this.visible) {
	 *       this.open.emit(null);
	 *     } else {
	 *       this.close.emit(null);
	 *     }
	 *   }
	 * }
	 * ```
	 *
	 * The events payload can be accessed by the parameter `$event` on the components output event
	 * handler:
	 *
	 * ```
	 * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
	 * ```
	 *
	 * Uses Rx.Observable but provides an adapter to make it work as specified here:
	 * https://github.com/jhusain/observable-spec
	 *
	 * Once a reference implementation of the spec is available, switch to it.
	 * \@stable
	 * @template T
	 */
	var EventEmitter = /** @class */ (function (_super) {
	    __extends(EventEmitter, _super);
	    /**
	     * Creates an instance of {@link EventEmitter}, which depending on `isAsync`,
	     * delivers events synchronously or asynchronously.
	     *
	     * @param isAsync By default, events are delivered synchronously (default value: `false`).
	     * Set to `true` for asynchronous event delivery.
	     */
	    function EventEmitter(isAsync) {
	        if (isAsync === void 0) { isAsync = false; }
	        var _this = _super.call(this) || this;
	        _this.__isAsync = isAsync;
	        return _this;
	    }
	    /**
	     * @param {?=} value
	     * @return {?}
	     */
	    EventEmitter.prototype.emit = /**
	     * @param {?=} value
	     * @return {?}
	     */
	    function (value) { _super.prototype.next.call(this, value); };
	    /**
	     * @param {?=} generatorOrNext
	     * @param {?=} error
	     * @param {?=} complete
	     * @return {?}
	     */
	    EventEmitter.prototype.subscribe = /**
	     * @param {?=} generatorOrNext
	     * @param {?=} error
	     * @param {?=} complete
	     * @return {?}
	     */
	    function (generatorOrNext, error, complete) {
	        var /** @type {?} */ schedulerFn;
	        var /** @type {?} */ errorFn = function (err) { return null; };
	        var /** @type {?} */ completeFn = function () { return null; };
	        if (generatorOrNext && typeof generatorOrNext === 'object') {
	            schedulerFn = this.__isAsync ? function (value) {
	                setTimeout(function () { return generatorOrNext.next(value); });
	            } : function (value) { generatorOrNext.next(value); };
	            if (generatorOrNext.error) {
	                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
	                    function (err) { generatorOrNext.error(err); };
	            }
	            if (generatorOrNext.complete) {
	                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
	                    function () { generatorOrNext.complete(); };
	            }
	        }
	        else {
	            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
	                function (value) { generatorOrNext(value); };
	            if (error) {
	                errorFn =
	                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
	            }
	            if (complete) {
	                completeFn =
	                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
	            }
	        }
	        var /** @type {?} */ sink = _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
	        if (generatorOrNext instanceof rxjs_Subscription.Subscription) {
	            generatorOrNext.add(sink);
	        }
	        return sink;
	    };
	    return EventEmitter;
	}(rxjs_Subject.Subject));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An injectable service for executing work inside or outside of the Angular zone.
	 *
	 * The most common use of this service is to optimize performance when starting a work consisting of
	 * one or more asynchronous tasks that don't require UI updates or error handling to be handled by
	 * Angular. Such tasks can be kicked off via {\@link #runOutsideAngular} and if needed, these tasks
	 * can reenter the Angular zone via {\@link #run}.
	 *
	 * <!-- TODO: add/fix links to:
	 *   - docs explaining zones and the use of zones in Angular and change-detection
	 *   - link to runOutsideAngular/run (throughout this file!)
	 *   -->
	 *
	 * ### Example
	 *
	 * ```
	 * import {Component, NgZone} from '\@angular/core';
	 * import {NgIf} from '\@angular/common';
	 *
	 * \@Component({
	 *   selector: 'ng-zone-demo',
	 *   template: `
	 *     <h2>Demo: NgZone</h2>
	 *
	 *     <p>Progress: {{progress}}%</p>
	 *     <p *ngIf="progress >= 100">Done processing {{label}} of Angular zone!</p>
	 *
	 *     <button (click)="processWithinAngularZone()">Process within Angular zone</button>
	 *     <button (click)="processOutsideOfAngularZone()">Process outside of Angular zone</button>
	 *   `,
	 * })
	 * export class NgZoneDemo {
	 *   progress: number = 0;
	 *   label: string;
	 *
	 *   constructor(private _ngZone: NgZone) {}
	 *
	 *   // Loop inside the Angular zone
	 *   // so the UI DOES refresh after each setTimeout cycle
	 *   processWithinAngularZone() {
	 *     this.label = 'inside';
	 *     this.progress = 0;
	 *     this._increaseProgress(() => console.log('Inside Done!'));
	 *   }
	 *
	 *   // Loop outside of the Angular zone
	 *   // so the UI DOES NOT refresh after each setTimeout cycle
	 *   processOutsideOfAngularZone() {
	 *     this.label = 'outside';
	 *     this.progress = 0;
	 *     this._ngZone.runOutsideAngular(() => {
	 *       this._increaseProgress(() => {
	 *         // reenter the Angular zone and display done
	 *         this._ngZone.run(() => { console.log('Outside Done!'); });
	 *       });
	 *     });
	 *   }
	 *
	 *   _increaseProgress(doneCallback: () => void) {
	 *     this.progress += 1;
	 *     console.log(`Current progress: ${this.progress}%`);
	 *
	 *     if (this.progress < 100) {
	 *       window.setTimeout(() => this._increaseProgress(doneCallback), 10);
	 *     } else {
	 *       doneCallback();
	 *     }
	 *   }
	 * }
	 * ```
	 *
	 * \@experimental
	 */
	var NgZone = /** @class */ (function () {
	    function NgZone(_a) {
	        var _b = _a.enableLongStackTrace, enableLongStackTrace = _b === void 0 ? false : _b;
	        this.hasPendingMicrotasks = false;
	        this.hasPendingMacrotasks = false;
	        /**
	         * Whether there are no outstanding microtasks or macrotasks.
	         */
	        this.isStable = true;
	        /**
	         * Notifies when code enters Angular Zone. This gets fired first on VM Turn.
	         */
	        this.onUnstable = new EventEmitter(false);
	        /**
	         * Notifies when there is no more microtasks enqueued in the current VM Turn.
	         * This is a hint for Angular to do change detection, which may enqueue more microtasks.
	         * For this reason this event can fire multiple times per VM Turn.
	         */
	        this.onMicrotaskEmpty = new EventEmitter(false);
	        /**
	         * Notifies when the last `onMicrotaskEmpty` has run and there are no more microtasks, which
	         * implies we are about to relinquish VM turn.
	         * This event gets called just once.
	         */
	        this.onStable = new EventEmitter(false);
	        /**
	         * Notifies that an error has been delivered.
	         */
	        this.onError = new EventEmitter(false);
	        if (typeof Zone == 'undefined') {
	            throw new Error("In this configuration Angular requires Zone.js");
	        }
	        Zone.assertZonePatched();
	        var /** @type {?} */ self = /** @type {?} */ ((this));
	        self._nesting = 0;
	        self._outer = self._inner = Zone.current;
	        if ((/** @type {?} */ (Zone))['wtfZoneSpec']) {
	            self._inner = self._inner.fork((/** @type {?} */ (Zone))['wtfZoneSpec']);
	        }
	        if (enableLongStackTrace && (/** @type {?} */ (Zone))['longStackTraceZoneSpec']) {
	            self._inner = self._inner.fork((/** @type {?} */ (Zone))['longStackTraceZoneSpec']);
	        }
	        forkInnerZoneWithAngularBehavior(self);
	    }
	    /**
	     * @return {?}
	     */
	    NgZone.isInAngularZone = /**
	     * @return {?}
	     */
	    function () { return Zone.current.get('isAngularZone') === true; };
	    /**
	     * @return {?}
	     */
	    NgZone.assertInAngularZone = /**
	     * @return {?}
	     */
	    function () {
	        if (!NgZone.isInAngularZone()) {
	            throw new Error('Expected to be in Angular Zone, but it is not!');
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NgZone.assertNotInAngularZone = /**
	     * @return {?}
	     */
	    function () {
	        if (NgZone.isInAngularZone()) {
	            throw new Error('Expected to not be in Angular Zone, but it is!');
	        }
	    };
	    /**
	     * Executes the `fn` function synchronously within the Angular zone and returns value returned by
	     * the function.
	     *
	     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
	     * outside of the Angular zone (typically started via {@link #runOutsideAngular}).
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * within the Angular zone.
	     *
	     * If a synchronous error happens it will be rethrown and not reported via `onError`.
	     */
	    /**
	     * Executes the `fn` function synchronously within the Angular zone and returns value returned by
	     * the function.
	     *
	     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
	     * outside of the Angular zone (typically started via {\@link #runOutsideAngular}).
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * within the Angular zone.
	     *
	     * If a synchronous error happens it will be rethrown and not reported via `onError`.
	     * @template T
	     * @param {?} fn
	     * @param {?=} applyThis
	     * @param {?=} applyArgs
	     * @return {?}
	     */
	    NgZone.prototype.run = /**
	     * Executes the `fn` function synchronously within the Angular zone and returns value returned by
	     * the function.
	     *
	     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
	     * outside of the Angular zone (typically started via {\@link #runOutsideAngular}).
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * within the Angular zone.
	     *
	     * If a synchronous error happens it will be rethrown and not reported via `onError`.
	     * @template T
	     * @param {?} fn
	     * @param {?=} applyThis
	     * @param {?=} applyArgs
	     * @return {?}
	     */
	    function (fn, applyThis, applyArgs) {
	        return /** @type {?} */ ((/** @type {?} */ ((this)))._inner.run(fn, applyThis, applyArgs));
	    };
	    /**
	     * Executes the `fn` function synchronously within the Angular zone as a task and returns value
	     * returned by the function.
	     *
	     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
	     * outside of the Angular zone (typically started via {@link #runOutsideAngular}).
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * within the Angular zone.
	     *
	     * If a synchronous error happens it will be rethrown and not reported via `onError`.
	     */
	    /**
	     * Executes the `fn` function synchronously within the Angular zone as a task and returns value
	     * returned by the function.
	     *
	     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
	     * outside of the Angular zone (typically started via {\@link #runOutsideAngular}).
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * within the Angular zone.
	     *
	     * If a synchronous error happens it will be rethrown and not reported via `onError`.
	     * @template T
	     * @param {?} fn
	     * @param {?=} applyThis
	     * @param {?=} applyArgs
	     * @param {?=} name
	     * @return {?}
	     */
	    NgZone.prototype.runTask = /**
	     * Executes the `fn` function synchronously within the Angular zone as a task and returns value
	     * returned by the function.
	     *
	     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
	     * outside of the Angular zone (typically started via {\@link #runOutsideAngular}).
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * within the Angular zone.
	     *
	     * If a synchronous error happens it will be rethrown and not reported via `onError`.
	     * @template T
	     * @param {?} fn
	     * @param {?=} applyThis
	     * @param {?=} applyArgs
	     * @param {?=} name
	     * @return {?}
	     */
	    function (fn, applyThis, applyArgs, name) {
	        var /** @type {?} */ zone = (/** @type {?} */ ((this)))._inner;
	        var /** @type {?} */ task = zone.scheduleEventTask('NgZoneEvent: ' + name, fn, EMPTY_PAYLOAD, noop, noop);
	        try {
	            return /** @type {?} */ (zone.runTask(task, applyThis, applyArgs));
	        }
	        finally {
	            zone.cancelTask(task);
	        }
	    };
	    /**
	     * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
	     * rethrown.
	     */
	    /**
	     * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
	     * rethrown.
	     * @template T
	     * @param {?} fn
	     * @param {?=} applyThis
	     * @param {?=} applyArgs
	     * @return {?}
	     */
	    NgZone.prototype.runGuarded = /**
	     * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
	     * rethrown.
	     * @template T
	     * @param {?} fn
	     * @param {?=} applyThis
	     * @param {?=} applyArgs
	     * @return {?}
	     */
	    function (fn, applyThis, applyArgs) {
	        return /** @type {?} */ ((/** @type {?} */ ((this)))._inner.runGuarded(fn, applyThis, applyArgs));
	    };
	    /**
	     * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
	     * the function.
	     *
	     * Running functions via {@link #runOutsideAngular} allows you to escape Angular's zone and do
	     * work that
	     * doesn't trigger Angular change-detection or is subject to Angular's error handling.
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * outside of the Angular zone.
	     *
	     * Use {@link #run} to reenter the Angular zone and do work that updates the application model.
	     */
	    /**
	     * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
	     * the function.
	     *
	     * Running functions via {\@link #runOutsideAngular} allows you to escape Angular's zone and do
	     * work that
	     * doesn't trigger Angular change-detection or is subject to Angular's error handling.
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * outside of the Angular zone.
	     *
	     * Use {\@link #run} to reenter the Angular zone and do work that updates the application model.
	     * @template T
	     * @param {?} fn
	     * @return {?}
	     */
	    NgZone.prototype.runOutsideAngular = /**
	     * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
	     * the function.
	     *
	     * Running functions via {\@link #runOutsideAngular} allows you to escape Angular's zone and do
	     * work that
	     * doesn't trigger Angular change-detection or is subject to Angular's error handling.
	     *
	     * Any future tasks or microtasks scheduled from within this function will continue executing from
	     * outside of the Angular zone.
	     *
	     * Use {\@link #run} to reenter the Angular zone and do work that updates the application model.
	     * @template T
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        return /** @type {?} */ ((/** @type {?} */ ((this)))._outer.run(fn));
	    };
	    return NgZone;
	}());
	/**
	 * @return {?}
	 */
	function noop() { }
	var EMPTY_PAYLOAD = {};
	/**
	 * @param {?} zone
	 * @return {?}
	 */
	function checkStable(zone) {
	    if (zone._nesting == 0 && !zone.hasPendingMicrotasks && !zone.isStable) {
	        try {
	            zone._nesting++;
	            zone.onMicrotaskEmpty.emit(null);
	        }
	        finally {
	            zone._nesting--;
	            if (!zone.hasPendingMicrotasks) {
	                try {
	                    zone.runOutsideAngular(function () { return zone.onStable.emit(null); });
	                }
	                finally {
	                    zone.isStable = true;
	                }
	            }
	        }
	    }
	}
	/**
	 * @param {?} zone
	 * @return {?}
	 */
	function forkInnerZoneWithAngularBehavior(zone) {
	    zone._inner = zone._inner.fork({
	        name: 'angular',
	        properties: /** @type {?} */ ({ 'isAngularZone': true }),
	        onInvokeTask: function (delegate, current, target, task, applyThis, applyArgs) {
	            try {
	                onEnter(zone);
	                return delegate.invokeTask(target, task, applyThis, applyArgs);
	            }
	            finally {
	                onLeave(zone);
	            }
	        },
	        onInvoke: function (delegate, current, target, callback, applyThis, applyArgs, source) {
	            try {
	                onEnter(zone);
	                return delegate.invoke(target, callback, applyThis, applyArgs, source);
	            }
	            finally {
	                onLeave(zone);
	            }
	        },
	        onHasTask: function (delegate, current, target, hasTaskState) {
	            delegate.hasTask(target, hasTaskState);
	            if (current === target) {
	                // We are only interested in hasTask events which originate from our zone
	                // (A child hasTask event is not interesting to us)
	                if (hasTaskState.change == 'microTask') {
	                    zone.hasPendingMicrotasks = hasTaskState.microTask;
	                    checkStable(zone);
	                }
	                else if (hasTaskState.change == 'macroTask') {
	                    zone.hasPendingMacrotasks = hasTaskState.macroTask;
	                }
	            }
	        },
	        onHandleError: function (delegate, current, target, error) {
	            delegate.handleError(target, error);
	            zone.runOutsideAngular(function () { return zone.onError.emit(error); });
	            return false;
	        }
	    });
	}
	/**
	 * @param {?} zone
	 * @return {?}
	 */
	function onEnter(zone) {
	    zone._nesting++;
	    if (zone.isStable) {
	        zone.isStable = false;
	        zone.onUnstable.emit(null);
	    }
	}
	/**
	 * @param {?} zone
	 * @return {?}
	 */
	function onLeave(zone) {
	    zone._nesting--;
	    checkStable(zone);
	}
	/**
	 * Provides a noop implementation of `NgZone` which does nothing. This zone requires explicit calls
	 * to framework to perform rendering.
	 */
	var NoopNgZone = /** @class */ (function () {
	    function NoopNgZone() {
	        this.hasPendingMicrotasks = false;
	        this.hasPendingMacrotasks = false;
	        this.isStable = true;
	        this.onUnstable = new EventEmitter();
	        this.onMicrotaskEmpty = new EventEmitter();
	        this.onStable = new EventEmitter();
	        this.onError = new EventEmitter();
	    }
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopNgZone.prototype.run = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { return fn(); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopNgZone.prototype.runGuarded = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { return fn(); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopNgZone.prototype.runOutsideAngular = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { return fn(); };
	    /**
	     * @template T
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopNgZone.prototype.runTask = /**
	     * @template T
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { return fn(); };
	    return NoopNgZone;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * The Testability service provides testing hooks that can be accessed from
	 * the browser and by services such as Protractor. Each bootstrapped Angular
	 * application on the page will have an instance of Testability.
	 * \@experimental
	 */
	var Testability = /** @class */ (function () {
	    function Testability(_ngZone) {
	        this._ngZone = _ngZone;
	        /**
	         * \@internal
	         */
	        this._pendingCount = 0;
	        /**
	         * \@internal
	         */
	        this._isZoneStable = true;
	        /**
	         * Whether any work was done since the last 'whenStable' callback. This is
	         * useful to detect if this could have potentially destabilized another
	         * component while it is stabilizing.
	         * \@internal
	         */
	        this._didWork = false;
	        /**
	         * \@internal
	         */
	        this._callbacks = [];
	        this._watchAngularEvents();
	    }
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    Testability.prototype._watchAngularEvents = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._ngZone.onUnstable.subscribe({
	            next: function () {
	                _this._didWork = true;
	                _this._isZoneStable = false;
	            }
	        });
	        this._ngZone.runOutsideAngular(function () {
	            _this._ngZone.onStable.subscribe({
	                next: function () {
	                    NgZone.assertNotInAngularZone();
	                    scheduleMicroTask(function () {
	                        _this._isZoneStable = true;
	                        _this._runCallbacksIfReady();
	                    });
	                }
	            });
	        });
	    };
	    /**
	     * Increases the number of pending request
	     */
	    /**
	     * Increases the number of pending request
	     * @return {?}
	     */
	    Testability.prototype.increasePendingRequestCount = /**
	     * Increases the number of pending request
	     * @return {?}
	     */
	    function () {
	        this._pendingCount += 1;
	        this._didWork = true;
	        return this._pendingCount;
	    };
	    /**
	     * Decreases the number of pending request
	     */
	    /**
	     * Decreases the number of pending request
	     * @return {?}
	     */
	    Testability.prototype.decreasePendingRequestCount = /**
	     * Decreases the number of pending request
	     * @return {?}
	     */
	    function () {
	        this._pendingCount -= 1;
	        if (this._pendingCount < 0) {
	            throw new Error('pending async requests below zero');
	        }
	        this._runCallbacksIfReady();
	        return this._pendingCount;
	    };
	    /**
	     * Whether an associated application is stable
	     */
	    /**
	     * Whether an associated application is stable
	     * @return {?}
	     */
	    Testability.prototype.isStable = /**
	     * Whether an associated application is stable
	     * @return {?}
	     */
	    function () {
	        return this._isZoneStable && this._pendingCount == 0 && !this._ngZone.hasPendingMacrotasks;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    Testability.prototype._runCallbacksIfReady = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.isStable()) {
	            // Schedules the call backs in a new frame so that it is always async.
	            scheduleMicroTask(function () {
	                while (_this._callbacks.length !== 0) {
	                    (/** @type {?} */ ((_this._callbacks.pop())))(_this._didWork);
	                }
	                _this._didWork = false;
	            });
	        }
	        else {
	            // Not Ready
	            this._didWork = true;
	        }
	    };
	    /**
	     * Run callback when the application is stable
	     * @param callback function to be called after the application is stable
	     */
	    /**
	     * Run callback when the application is stable
	     * @param {?} callback function to be called after the application is stable
	     * @return {?}
	     */
	    Testability.prototype.whenStable = /**
	     * Run callback when the application is stable
	     * @param {?} callback function to be called after the application is stable
	     * @return {?}
	     */
	    function (callback) {
	        this._callbacks.push(callback);
	        this._runCallbacksIfReady();
	    };
	    /**
	     * Get the number of pending requests
	     */
	    /**
	     * Get the number of pending requests
	     * @return {?}
	     */
	    Testability.prototype.getPendingRequestCount = /**
	     * Get the number of pending requests
	     * @return {?}
	     */
	    function () { return this._pendingCount; };
	    /**
	     * Find providers by name
	     * @param using The root element to search from
	     * @param provider The name of binding variable
	     * @param exactMatch Whether using exactMatch
	     */
	    /**
	     * Find providers by name
	     * @param {?} using The root element to search from
	     * @param {?} provider The name of binding variable
	     * @param {?} exactMatch Whether using exactMatch
	     * @return {?}
	     */
	    Testability.prototype.findProviders = /**
	     * Find providers by name
	     * @param {?} using The root element to search from
	     * @param {?} provider The name of binding variable
	     * @param {?} exactMatch Whether using exactMatch
	     * @return {?}
	     */
	    function (using, provider, exactMatch) {
	        // TODO(juliemr): implement.
	        return [];
	    };
	    Testability.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    Testability.ctorParameters = function () { return [
	        { type: NgZone, },
	    ]; };
	    return Testability;
	}());
	/**
	 * A global registry of {\@link Testability} instances for specific elements.
	 * \@experimental
	 */
	var TestabilityRegistry = /** @class */ (function () {
	    function TestabilityRegistry() {
	        /**
	         * \@internal
	         */
	        this._applications = new Map();
	        _testabilityGetter.addToWindow(this);
	    }
	    /**
	     * Registers an application with a testability hook so that it can be tracked
	     * @param token token of application, root element
	     * @param testability Testability hook
	     */
	    /**
	     * Registers an application with a testability hook so that it can be tracked
	     * @param {?} token token of application, root element
	     * @param {?} testability Testability hook
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.registerApplication = /**
	     * Registers an application with a testability hook so that it can be tracked
	     * @param {?} token token of application, root element
	     * @param {?} testability Testability hook
	     * @return {?}
	     */
	    function (token, testability) {
	        this._applications.set(token, testability);
	    };
	    /**
	     * Unregisters an application.
	     * @param token token of application, root element
	     */
	    /**
	     * Unregisters an application.
	     * @param {?} token token of application, root element
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.unregisterApplication = /**
	     * Unregisters an application.
	     * @param {?} token token of application, root element
	     * @return {?}
	     */
	    function (token) { this._applications.delete(token); };
	    /**
	     * Unregisters all applications
	     */
	    /**
	     * Unregisters all applications
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.unregisterAllApplications = /**
	     * Unregisters all applications
	     * @return {?}
	     */
	    function () { this._applications.clear(); };
	    /**
	     * Get a testability hook associated with the application
	     * @param elem root element
	     */
	    /**
	     * Get a testability hook associated with the application
	     * @param {?} elem root element
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.getTestability = /**
	     * Get a testability hook associated with the application
	     * @param {?} elem root element
	     * @return {?}
	     */
	    function (elem) { return this._applications.get(elem) || null; };
	    /**
	     * Get all registered testabilities
	     */
	    /**
	     * Get all registered testabilities
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.getAllTestabilities = /**
	     * Get all registered testabilities
	     * @return {?}
	     */
	    function () { return Array.from(this._applications.values()); };
	    /**
	     * Get all registered applications(root elements)
	     */
	    /**
	     * Get all registered applications(root elements)
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.getAllRootElements = /**
	     * Get all registered applications(root elements)
	     * @return {?}
	     */
	    function () { return Array.from(this._applications.keys()); };
	    /**
	     * Find testability of a node in the Tree
	     * @param elem node
	     * @param findInAncestors whether finding testability in ancestors if testability was not found in
	     * current node
	     */
	    /**
	     * Find testability of a node in the Tree
	     * @param {?} elem node
	     * @param {?=} findInAncestors whether finding testability in ancestors if testability was not found in
	     * current node
	     * @return {?}
	     */
	    TestabilityRegistry.prototype.findTestabilityInTree = /**
	     * Find testability of a node in the Tree
	     * @param {?} elem node
	     * @param {?=} findInAncestors whether finding testability in ancestors if testability was not found in
	     * current node
	     * @return {?}
	     */
	    function (elem, findInAncestors) {
	        if (findInAncestors === void 0) { findInAncestors = true; }
	        return _testabilityGetter.findTestabilityInTree(this, elem, findInAncestors);
	    };
	    TestabilityRegistry.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    TestabilityRegistry.ctorParameters = function () { return []; };
	    return TestabilityRegistry;
	}());
	/**
	 * Adapter interface for retrieving the `Testability` service associated for a
	 * particular context.
	 *
	 * \@experimental Testability apis are primarily intended to be used by e2e test tool vendors like
	 * the Protractor team.
	 * @record
	 */
	
	var _NoopGetTestability = /** @class */ (function () {
	    function _NoopGetTestability() {
	    }
	    /**
	     * @param {?} registry
	     * @return {?}
	     */
	    _NoopGetTestability.prototype.addToWindow = /**
	     * @param {?} registry
	     * @return {?}
	     */
	    function (registry) { };
	    /**
	     * @param {?} registry
	     * @param {?} elem
	     * @param {?} findInAncestors
	     * @return {?}
	     */
	    _NoopGetTestability.prototype.findTestabilityInTree = /**
	     * @param {?} registry
	     * @param {?} elem
	     * @param {?} findInAncestors
	     * @return {?}
	     */
	    function (registry, elem, findInAncestors) {
	        return null;
	    };
	    return _NoopGetTestability;
	}());
	/**
	 * Set the {\@link GetTestability} implementation used by the Angular testing framework.
	 * \@experimental
	 * @param {?} getter
	 * @return {?}
	 */
	function setTestabilityGetter(getter) {
	    _testabilityGetter = getter;
	}
	var _testabilityGetter = new _NoopGetTestability();
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _devMode = true;
	var _runModeLocked = false;
	var _platform;
	var ALLOW_MULTIPLE_PLATFORMS = new InjectionToken('AllowMultipleToken');
	/**
	 * Disable Angular's development mode, which turns off assertions and other
	 * checks within the framework.
	 *
	 * One important assertion this disables verifies that a change detection pass
	 * does not result in additional changes to any bindings (also known as
	 * unidirectional data flow).
	 *
	 * \@stable
	 * @return {?}
	 */
	function enableProdMode() {
	    if (_runModeLocked) {
	        throw new Error('Cannot enable prod mode after platform setup.');
	    }
	    _devMode = false;
	}
	/**
	 * Returns whether Angular is in development mode. After called once,
	 * the value is locked and won't change any more.
	 *
	 * By default, this is true, unless a user calls `enableProdMode` before calling this.
	 *
	 * \@experimental APIs related to application bootstrap are currently under review.
	 * @return {?}
	 */
	function isDevMode() {
	    _runModeLocked = true;
	    return _devMode;
	}
	/**
	 * A token for third-party components that can register themselves with NgProbe.
	 *
	 * \@experimental
	 */
	var NgProbeToken = /** @class */ (function () {
	    function NgProbeToken(name, token) {
	        this.name = name;
	        this.token = token;
	    }
	    return NgProbeToken;
	}());
	/**
	 * Creates a platform.
	 * Platforms have to be eagerly created via this function.
	 *
	 * \@experimental APIs related to application bootstrap are currently under review.
	 * @param {?} injector
	 * @return {?}
	 */
	function createPlatform(injector) {
	    if (_platform && !_platform.destroyed &&
	        !_platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
	        throw new Error('There can be only one platform. Destroy the previous one to create a new one.');
	    }
	    _platform = injector.get(PlatformRef);
	    var /** @type {?} */ inits = injector.get(PLATFORM_INITIALIZER, null);
	    if (inits)
	        inits.forEach(function (init) { return init(); });
	    return _platform;
	}
	/**
	 * Creates a factory for a platform
	 *
	 * \@experimental APIs related to application bootstrap are currently under review.
	 * @param {?} parentPlatformFactory
	 * @param {?} name
	 * @param {?=} providers
	 * @return {?}
	 */
	function createPlatformFactory(parentPlatformFactory, name, providers) {
	    if (providers === void 0) { providers = []; }
	    var /** @type {?} */ desc = "Platform: " + name;
	    var /** @type {?} */ marker = new InjectionToken(desc);
	    return function (extraProviders) {
	        if (extraProviders === void 0) { extraProviders = []; }
	        var /** @type {?} */ platform = getPlatform();
	        if (!platform || platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
	            if (parentPlatformFactory) {
	                parentPlatformFactory(providers.concat(extraProviders).concat({ provide: marker, useValue: true }));
	            }
	            else {
	                var /** @type {?} */ injectedProviders = providers.concat(extraProviders).concat({ provide: marker, useValue: true });
	                createPlatform(Injector.create({ providers: injectedProviders, name: desc }));
	            }
	        }
	        return assertPlatform(marker);
	    };
	}
	/**
	 * Checks that there currently is a platform which contains the given token as a provider.
	 *
	 * \@experimental APIs related to application bootstrap are currently under review.
	 * @param {?} requiredToken
	 * @return {?}
	 */
	function assertPlatform(requiredToken) {
	    var /** @type {?} */ platform = getPlatform();
	    if (!platform) {
	        throw new Error('No platform exists!');
	    }
	    if (!platform.injector.get(requiredToken, null)) {
	        throw new Error('A platform with a different configuration has been created. Please destroy it first.');
	    }
	    return platform;
	}
	/**
	 * Destroy the existing platform.
	 *
	 * \@experimental APIs related to application bootstrap are currently under review.
	 * @return {?}
	 */
	function destroyPlatform() {
	    if (_platform && !_platform.destroyed) {
	        _platform.destroy();
	    }
	}
	/**
	 * Returns the current platform.
	 *
	 * \@experimental APIs related to application bootstrap are currently under review.
	 * @return {?}
	 */
	function getPlatform() {
	    return _platform && !_platform.destroyed ? _platform : null;
	}
	/**
	 * Provides additional options to the bootstraping process.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * The Angular platform is the entry point for Angular on a web page. Each page
	 * has exactly one platform, and services (such as reflection) which are common
	 * to every Angular application running on the page are bound in its scope.
	 *
	 * A page's platform is initialized implicitly when a platform is created via a platform factory
	 * (e.g. {\@link platformBrowser}), or explicitly by calling the {\@link createPlatform} function.
	 *
	 * \@stable
	 */
	var PlatformRef = /** @class */ (function () {
	    /** @internal */
	    function PlatformRef(_injector) {
	        this._injector = _injector;
	        this._modules = [];
	        this._destroyListeners = [];
	        this._destroyed = false;
	    }
	    /**
	     * Creates an instance of an `@NgModule` for the given platform
	     * for offline compilation.
	     *
	     * ## Simple Example
	     *
	     * ```typescript
	     * my_module.ts:
	     *
	     * @NgModule({
	     *   imports: [BrowserModule]
	     * })
	     * class MyModule {}
	     *
	     * main.ts:
	     * import {MyModuleNgFactory} from './my_module.ngfactory';
	     * import {platformBrowser} from '@angular/platform-browser';
	     *
	     * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
	     * ```
	     *
	     * @experimental APIs related to application bootstrap are currently under review.
	     */
	    /**
	     * Creates an instance of an `\@NgModule` for the given platform
	     * for offline compilation.
	     *
	     * ## Simple Example
	     *
	     * ```typescript
	     * my_module.ts:
	     *
	     * \@NgModule({
	     *   imports: [BrowserModule]
	     * })
	     * class MyModule {}
	     *
	     * main.ts:
	     * import {MyModuleNgFactory} from './my_module.ngfactory';
	     * import {platformBrowser} from '\@angular/platform-browser';
	     *
	     * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
	     * ```
	     *
	     * \@experimental APIs related to application bootstrap are currently under review.
	     * @template M
	     * @param {?} moduleFactory
	     * @param {?=} options
	     * @return {?}
	     */
	    PlatformRef.prototype.bootstrapModuleFactory = /**
	     * Creates an instance of an `\@NgModule` for the given platform
	     * for offline compilation.
	     *
	     * ## Simple Example
	     *
	     * ```typescript
	     * my_module.ts:
	     *
	     * \@NgModule({
	     *   imports: [BrowserModule]
	     * })
	     * class MyModule {}
	     *
	     * main.ts:
	     * import {MyModuleNgFactory} from './my_module.ngfactory';
	     * import {platformBrowser} from '\@angular/platform-browser';
	     *
	     * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
	     * ```
	     *
	     * \@experimental APIs related to application bootstrap are currently under review.
	     * @template M
	     * @param {?} moduleFactory
	     * @param {?=} options
	     * @return {?}
	     */
	    function (moduleFactory, options) {
	        var _this = this;
	        // Note: We need to create the NgZone _before_ we instantiate the module,
	        // as instantiating the module creates some providers eagerly.
	        // So we create a mini parent injector that just contains the new NgZone and
	        // pass that as parent to the NgModuleFactory.
	        var /** @type {?} */ ngZoneOption = options ? options.ngZone : undefined;
	        var /** @type {?} */ ngZone = getNgZone(ngZoneOption);
	        var /** @type {?} */ providers = [{ provide: NgZone, useValue: ngZone }];
	        // Attention: Don't use ApplicationRef.run here,
	        // as we want to be sure that all possible constructor calls are inside `ngZone.run`!
	        return ngZone.run(function () {
	            var /** @type {?} */ ngZoneInjector = Injector.create({ providers: providers, parent: _this.injector, name: moduleFactory.moduleType.name });
	            var /** @type {?} */ moduleRef = /** @type {?} */ (moduleFactory.create(ngZoneInjector));
	            var /** @type {?} */ exceptionHandler = moduleRef.injector.get(ErrorHandler, null);
	            if (!exceptionHandler) {
	                throw new Error('No ErrorHandler. Is platform module (BrowserModule) included?');
	            }
	            moduleRef.onDestroy(function () { return remove(_this._modules, moduleRef); }); /** @type {?} */
	            ((ngZone)).runOutsideAngular(function () { return ((ngZone)).onError.subscribe({ next: function (error) { exceptionHandler.handleError(error); } }); });
	            return _callAndReportToErrorHandler(exceptionHandler, /** @type {?} */ ((ngZone)), function () {
	                var /** @type {?} */ initStatus = moduleRef.injector.get(ApplicationInitStatus);
	                initStatus.runInitializers();
	                return initStatus.donePromise.then(function () {
	                    _this._moduleDoBootstrap(moduleRef);
	                    return moduleRef;
	                });
	            });
	        });
	    };
	    /**
	     * Creates an instance of an `@NgModule` for a given platform using the given runtime compiler.
	     *
	     * ## Simple Example
	     *
	     * ```typescript
	     * @NgModule({
	     *   imports: [BrowserModule]
	     * })
	     * class MyModule {}
	     *
	     * let moduleRef = platformBrowser().bootstrapModule(MyModule);
	     * ```
	     * @stable
	     */
	    /**
	     * Creates an instance of an `\@NgModule` for a given platform using the given runtime compiler.
	     *
	     * ## Simple Example
	     *
	     * ```typescript
	     * \@NgModule({
	     *   imports: [BrowserModule]
	     * })
	     * class MyModule {}
	     *
	     * let moduleRef = platformBrowser().bootstrapModule(MyModule);
	     * ```
	     * \@stable
	     * @template M
	     * @param {?} moduleType
	     * @param {?=} compilerOptions
	     * @return {?}
	     */
	    PlatformRef.prototype.bootstrapModule = /**
	     * Creates an instance of an `\@NgModule` for a given platform using the given runtime compiler.
	     *
	     * ## Simple Example
	     *
	     * ```typescript
	     * \@NgModule({
	     *   imports: [BrowserModule]
	     * })
	     * class MyModule {}
	     *
	     * let moduleRef = platformBrowser().bootstrapModule(MyModule);
	     * ```
	     * \@stable
	     * @template M
	     * @param {?} moduleType
	     * @param {?=} compilerOptions
	     * @return {?}
	     */
	    function (moduleType, compilerOptions) {
	        var _this = this;
	        if (compilerOptions === void 0) { compilerOptions = []; }
	        var /** @type {?} */ compilerFactory = this.injector.get(CompilerFactory);
	        var /** @type {?} */ options = optionsReducer({}, compilerOptions);
	        var /** @type {?} */ compiler = compilerFactory.createCompiler([options]);
	        return compiler.compileModuleAsync(moduleType)
	            .then(function (moduleFactory) { return _this.bootstrapModuleFactory(moduleFactory, options); });
	    };
	    /**
	     * @param {?} moduleRef
	     * @return {?}
	     */
	    PlatformRef.prototype._moduleDoBootstrap = /**
	     * @param {?} moduleRef
	     * @return {?}
	     */
	    function (moduleRef) {
	        var /** @type {?} */ appRef = /** @type {?} */ (moduleRef.injector.get(ApplicationRef));
	        if (moduleRef._bootstrapComponents.length > 0) {
	            moduleRef._bootstrapComponents.forEach(function (f) { return appRef.bootstrap(f); });
	        }
	        else if (moduleRef.instance.ngDoBootstrap) {
	            moduleRef.instance.ngDoBootstrap(appRef);
	        }
	        else {
	            throw new Error("The module " + stringify(moduleRef.instance.constructor) + " was bootstrapped, but it does not declare \"@NgModule.bootstrap\" components nor a \"ngDoBootstrap\" method. " +
	                "Please define one of these.");
	        }
	        this._modules.push(moduleRef);
	    };
	    /**
	     * Register a listener to be called when the platform is disposed.
	     */
	    /**
	     * Register a listener to be called when the platform is disposed.
	     * @param {?} callback
	     * @return {?}
	     */
	    PlatformRef.prototype.onDestroy = /**
	     * Register a listener to be called when the platform is disposed.
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) { this._destroyListeners.push(callback); };
	    Object.defineProperty(PlatformRef.prototype, "injector", {
	        /**
	         * Retrieve the platform {@link Injector}, which is the parent injector for
	         * every Angular application on the page and provides singleton providers.
	         */
	        get: /**
	         * Retrieve the platform {\@link Injector}, which is the parent injector for
	         * every Angular application on the page and provides singleton providers.
	         * @return {?}
	         */
	        function () { return this._injector; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Destroy the Angular platform and all Angular applications on the page.
	     */
	    /**
	     * Destroy the Angular platform and all Angular applications on the page.
	     * @return {?}
	     */
	    PlatformRef.prototype.destroy = /**
	     * Destroy the Angular platform and all Angular applications on the page.
	     * @return {?}
	     */
	    function () {
	        if (this._destroyed) {
	            throw new Error('The platform has already been destroyed!');
	        }
	        this._modules.slice().forEach(function (module) { return module.destroy(); });
	        this._destroyListeners.forEach(function (listener) { return listener(); });
	        this._destroyed = true;
	    };
	    Object.defineProperty(PlatformRef.prototype, "destroyed", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._destroyed; },
	        enumerable: true,
	        configurable: true
	    });
	    PlatformRef.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    PlatformRef.ctorParameters = function () { return [
	        { type: Injector, },
	    ]; };
	    return PlatformRef;
	}());
	/**
	 * @param {?=} ngZoneOption
	 * @return {?}
	 */
	function getNgZone(ngZoneOption) {
	    var /** @type {?} */ ngZone;
	    if (ngZoneOption === 'noop') {
	        ngZone = new NoopNgZone();
	    }
	    else {
	        ngZone = (ngZoneOption === 'zone.js' ? undefined : ngZoneOption) ||
	            new NgZone({ enableLongStackTrace: isDevMode() });
	    }
	    return ngZone;
	}
	/**
	 * @param {?} errorHandler
	 * @param {?} ngZone
	 * @param {?} callback
	 * @return {?}
	 */
	function _callAndReportToErrorHandler(errorHandler, ngZone, callback) {
	    try {
	        var /** @type {?} */ result = callback();
	        if (isPromise(result)) {
	            return result.catch(function (e) {
	                ngZone.runOutsideAngular(function () { return errorHandler.handleError(e); });
	                // rethrow as the exception handler might not do it
	                throw e;
	            });
	        }
	        return result;
	    }
	    catch (/** @type {?} */ e) {
	        ngZone.runOutsideAngular(function () { return errorHandler.handleError(e); });
	        // rethrow as the exception handler might not do it
	        throw e;
	    }
	}
	/**
	 * @template T
	 * @param {?} dst
	 * @param {?} objs
	 * @return {?}
	 */
	function optionsReducer(dst, objs) {
	    if (Array.isArray(objs)) {
	        dst = objs.reduce(optionsReducer, dst);
	    }
	    else {
	        dst = __assign({}, dst, (/** @type {?} */ (objs)));
	    }
	    return dst;
	}
	/**
	 * A reference to an Angular application running on a page.
	 *
	 * \@stable
	 */
	var ApplicationRef = /** @class */ (function () {
	    /** @internal */
	    function ApplicationRef(_zone, _console, _injector, _exceptionHandler, _componentFactoryResolver, _initStatus) {
	        var _this = this;
	        this._zone = _zone;
	        this._console = _console;
	        this._injector = _injector;
	        this._exceptionHandler = _exceptionHandler;
	        this._componentFactoryResolver = _componentFactoryResolver;
	        this._initStatus = _initStatus;
	        this._bootstrapListeners = [];
	        this._views = [];
	        this._runningTick = false;
	        this._enforceNoNewChanges = false;
	        this._stable = true;
	        /**
	         * Get a list of component types registered to this application.
	         * This list is populated even before the component is created.
	         */
	        this.componentTypes = [];
	        /**
	         * Get a list of components registered to this application.
	         */
	        this.components = [];
	        this._enforceNoNewChanges = isDevMode();
	        this._zone.onMicrotaskEmpty.subscribe({ next: function () { _this._zone.run(function () { _this.tick(); }); } });
	        var /** @type {?} */ isCurrentlyStable = new rxjs_Observable.Observable(function (observer) {
	            _this._stable = _this._zone.isStable && !_this._zone.hasPendingMacrotasks &&
	                !_this._zone.hasPendingMicrotasks;
	            _this._zone.runOutsideAngular(function () {
	                observer.next(_this._stable);
	                observer.complete();
	            });
	        });
	        var /** @type {?} */ isStable = new rxjs_Observable.Observable(function (observer) {
	            // Create the subscription to onStable outside the Angular Zone so that
	            // the callback is run outside the Angular Zone.
	            var /** @type {?} */ stableSub;
	            _this._zone.runOutsideAngular(function () {
	                stableSub = _this._zone.onStable.subscribe(function () {
	                    NgZone.assertNotInAngularZone();
	                    // Check whether there are no pending macro/micro tasks in the next tick
	                    // to allow for NgZone to update the state.
	                    scheduleMicroTask(function () {
	                        if (!_this._stable && !_this._zone.hasPendingMacrotasks &&
	                            !_this._zone.hasPendingMicrotasks) {
	                            _this._stable = true;
	                            observer.next(true);
	                        }
	                    });
	                });
	            });
	            var /** @type {?} */ unstableSub = _this._zone.onUnstable.subscribe(function () {
	                NgZone.assertInAngularZone();
	                if (_this._stable) {
	                    _this._stable = false;
	                    _this._zone.runOutsideAngular(function () { observer.next(false); });
	                }
	            });
	            return function () {
	                stableSub.unsubscribe();
	                unstableSub.unsubscribe();
	            };
	        });
	        (/** @type {?} */ (this)).isStable =
	            rxjs_observable_merge.merge(isCurrentlyStable, rxjs_operator_share.share.call(isStable));
	    }
	    /**
	     * Bootstrap a new component at the root level of the application.
	     *
	     * ### Bootstrap process
	     *
	     * When bootstrapping a new root component into an application, Angular mounts the
	     * specified application component onto DOM elements identified by the [componentType]'s
	     * selector and kicks off automatic change detection to finish initializing the component.
	     *
	     * Optionally, a component can be mounted onto a DOM element that does not match the
	     * [componentType]'s selector.
	     *
	     * ### Example
	     * {@example core/ts/platform/platform.ts region='longform'}
	     */
	    /**
	     * Bootstrap a new component at the root level of the application.
	     *
	     * ### Bootstrap process
	     *
	     * When bootstrapping a new root component into an application, Angular mounts the
	     * specified application component onto DOM elements identified by the [componentType]'s
	     * selector and kicks off automatic change detection to finish initializing the component.
	     *
	     * Optionally, a component can be mounted onto a DOM element that does not match the
	     * [componentType]'s selector.
	     *
	     * ### Example
	     * {\@example core/ts/platform/platform.ts region='longform'}
	     * @template C
	     * @param {?} componentOrFactory
	     * @param {?=} rootSelectorOrNode
	     * @return {?}
	     */
	    ApplicationRef.prototype.bootstrap = /**
	     * Bootstrap a new component at the root level of the application.
	     *
	     * ### Bootstrap process
	     *
	     * When bootstrapping a new root component into an application, Angular mounts the
	     * specified application component onto DOM elements identified by the [componentType]'s
	     * selector and kicks off automatic change detection to finish initializing the component.
	     *
	     * Optionally, a component can be mounted onto a DOM element that does not match the
	     * [componentType]'s selector.
	     *
	     * ### Example
	     * {\@example core/ts/platform/platform.ts region='longform'}
	     * @template C
	     * @param {?} componentOrFactory
	     * @param {?=} rootSelectorOrNode
	     * @return {?}
	     */
	    function (componentOrFactory, rootSelectorOrNode) {
	        var _this = this;
	        if (!this._initStatus.done) {
	            throw new Error('Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module.');
	        }
	        var /** @type {?} */ componentFactory;
	        if (componentOrFactory instanceof ComponentFactory) {
	            componentFactory = componentOrFactory;
	        }
	        else {
	            componentFactory =
	                /** @type {?} */ ((this._componentFactoryResolver.resolveComponentFactory(componentOrFactory)));
	        }
	        this.componentTypes.push(componentFactory.componentType);
	        // Create a factory associated with the current module if it's not bound to some other
	        var /** @type {?} */ ngModule = componentFactory instanceof ComponentFactoryBoundToModule ?
	            null :
	            this._injector.get(NgModuleRef);
	        var /** @type {?} */ selectorOrNode = rootSelectorOrNode || componentFactory.selector;
	        var /** @type {?} */ compRef = componentFactory.create(Injector.NULL, [], selectorOrNode, ngModule);
	        compRef.onDestroy(function () { _this._unloadComponent(compRef); });
	        var /** @type {?} */ testability = compRef.injector.get(Testability, null);
	        if (testability) {
	            compRef.injector.get(TestabilityRegistry)
	                .registerApplication(compRef.location.nativeElement, testability);
	        }
	        this._loadComponent(compRef);
	        if (isDevMode()) {
	            this._console.log("Angular is running in the development mode. Call enableProdMode() to enable the production mode.");
	        }
	        return compRef;
	    };
	    /**
	     * Invoke this method to explicitly process change detection and its side-effects.
	     *
	     * In development mode, `tick()` also performs a second change detection cycle to ensure that no
	     * further changes are detected. If additional changes are picked up during this second cycle,
	     * bindings in the app have side-effects that cannot be resolved in a single change detection
	     * pass.
	     * In this case, Angular throws an error, since an Angular application can only have one change
	     * detection pass during which all change detection must complete.
	     */
	    /**
	     * Invoke this method to explicitly process change detection and its side-effects.
	     *
	     * In development mode, `tick()` also performs a second change detection cycle to ensure that no
	     * further changes are detected. If additional changes are picked up during this second cycle,
	     * bindings in the app have side-effects that cannot be resolved in a single change detection
	     * pass.
	     * In this case, Angular throws an error, since an Angular application can only have one change
	     * detection pass during which all change detection must complete.
	     * @return {?}
	     */
	    ApplicationRef.prototype.tick = /**
	     * Invoke this method to explicitly process change detection and its side-effects.
	     *
	     * In development mode, `tick()` also performs a second change detection cycle to ensure that no
	     * further changes are detected. If additional changes are picked up during this second cycle,
	     * bindings in the app have side-effects that cannot be resolved in a single change detection
	     * pass.
	     * In this case, Angular throws an error, since an Angular application can only have one change
	     * detection pass during which all change detection must complete.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._runningTick) {
	            throw new Error('ApplicationRef.tick is called recursively');
	        }
	        var /** @type {?} */ scope = ApplicationRef._tickScope();
	        try {
	            this._runningTick = true;
	            this._views.forEach(function (view) { return view.detectChanges(); });
	            if (this._enforceNoNewChanges) {
	                this._views.forEach(function (view) { return view.checkNoChanges(); });
	            }
	        }
	        catch (/** @type {?} */ e) {
	            // Attention: Don't rethrow as it could cancel subscriptions to Observables!
	            this._zone.runOutsideAngular(function () { return _this._exceptionHandler.handleError(e); });
	        }
	        finally {
	            this._runningTick = false;
	            wtfLeave(scope);
	        }
	    };
	    /**
	     * Attaches a view so that it will be dirty checked.
	     * The view will be automatically detached when it is destroyed.
	     * This will throw if the view is already attached to a ViewContainer.
	     */
	    /**
	     * Attaches a view so that it will be dirty checked.
	     * The view will be automatically detached when it is destroyed.
	     * This will throw if the view is already attached to a ViewContainer.
	     * @param {?} viewRef
	     * @return {?}
	     */
	    ApplicationRef.prototype.attachView = /**
	     * Attaches a view so that it will be dirty checked.
	     * The view will be automatically detached when it is destroyed.
	     * This will throw if the view is already attached to a ViewContainer.
	     * @param {?} viewRef
	     * @return {?}
	     */
	    function (viewRef) {
	        var /** @type {?} */ view = (/** @type {?} */ (viewRef));
	        this._views.push(view);
	        view.attachToAppRef(this);
	    };
	    /**
	     * Detaches a view from dirty checking again.
	     */
	    /**
	     * Detaches a view from dirty checking again.
	     * @param {?} viewRef
	     * @return {?}
	     */
	    ApplicationRef.prototype.detachView = /**
	     * Detaches a view from dirty checking again.
	     * @param {?} viewRef
	     * @return {?}
	     */
	    function (viewRef) {
	        var /** @type {?} */ view = (/** @type {?} */ (viewRef));
	        remove(this._views, view);
	        view.detachFromAppRef();
	    };
	    /**
	     * @param {?} componentRef
	     * @return {?}
	     */
	    ApplicationRef.prototype._loadComponent = /**
	     * @param {?} componentRef
	     * @return {?}
	     */
	    function (componentRef) {
	        this.attachView(componentRef.hostView);
	        this.tick();
	        this.components.push(componentRef);
	        // Get the listeners lazily to prevent DI cycles.
	        var /** @type {?} */ listeners = this._injector.get(APP_BOOTSTRAP_LISTENER, []).concat(this._bootstrapListeners);
	        listeners.forEach(function (listener) { return listener(componentRef); });
	    };
	    /**
	     * @param {?} componentRef
	     * @return {?}
	     */
	    ApplicationRef.prototype._unloadComponent = /**
	     * @param {?} componentRef
	     * @return {?}
	     */
	    function (componentRef) {
	        this.detachView(componentRef.hostView);
	        remove(this.components, componentRef);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    ApplicationRef.prototype.ngOnDestroy = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        // TODO(alxhub): Dispose of the NgZone.
	        this._views.slice().forEach(function (view) { return view.destroy(); });
	    };
	    Object.defineProperty(ApplicationRef.prototype, "viewCount", {
	        /**
	         * Returns the number of attached views.
	         */
	        get: /**
	         * Returns the number of attached views.
	         * @return {?}
	         */
	        function () { return this._views.length; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * \@internal
	     */
	    ApplicationRef._tickScope = wtfCreateScope('ApplicationRef#tick()');
	    ApplicationRef.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    ApplicationRef.ctorParameters = function () { return [
	        { type: NgZone, },
	        { type: Console, },
	        { type: Injector, },
	        { type: ErrorHandler, },
	        { type: ComponentFactoryResolver, },
	        { type: ApplicationInitStatus, },
	    ]; };
	    return ApplicationRef;
	}());
	/**
	 * @template T
	 * @param {?} list
	 * @param {?} el
	 * @return {?}
	 */
	function remove(list, el) {
	    var /** @type {?} */ index = list.indexOf(el);
	    if (index > -1) {
	        list.splice(index, 1);
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @deprecated Use `RendererType2` (and `Renderer2`) instead.
	 */
	var RenderComponentType = /** @class */ (function () {
	    function RenderComponentType(id, templateUrl, slotCount, encapsulation, styles, animations) {
	        this.id = id;
	        this.templateUrl = templateUrl;
	        this.slotCount = slotCount;
	        this.encapsulation = encapsulation;
	        this.styles = styles;
	        this.animations = animations;
	    }
	    return RenderComponentType;
	}());
	/**
	 * @deprecated Debug info is handeled internally in the view engine now.
	 * @abstract
	 */
	var RenderDebugInfo = /** @class */ (function () {
	    function RenderDebugInfo() {
	    }
	    return RenderDebugInfo;
	}());
	/**
	 * @deprecated Use the `Renderer2` instead.
	 * @record
	 */
	
	/**
	 * @deprecated Use the `Renderer2` instead.
	 * @abstract
	 */
	var Renderer = /** @class */ (function () {
	    function Renderer() {
	    }
	    return Renderer;
	}());
	var Renderer2Interceptor = new InjectionToken('Renderer2Interceptor');
	/**
	 * Injectable service that provides a low-level interface for modifying the UI.
	 *
	 * Use this service to bypass Angular's templating and make custom UI changes that can't be
	 * expressed declaratively. For example if you need to set a property or an attribute whose name is
	 * not statically known, use {\@link Renderer#setElementProperty setElementProperty} or
	 * {\@link Renderer#setElementAttribute setElementAttribute} respectively.
	 *
	 * If you are implementing a custom renderer, you must implement this interface.
	 *
	 * The default Renderer implementation is `DomRenderer`. Also available is `WebWorkerRenderer`.
	 *
	 * @deprecated Use `RendererFactory2` instead.
	 * @abstract
	 */
	var RootRenderer = /** @class */ (function () {
	    function RootRenderer() {
	    }
	    return RootRenderer;
	}());
	/**
	 * \@experimental
	 * @record
	 */
	
	/**
	 * \@experimental
	 * @abstract
	 */
	var RendererFactory2 = /** @class */ (function () {
	    function RendererFactory2() {
	    }
	    return RendererFactory2;
	}());
	/** @enum {number} */
	var RendererStyleFlags2 = {
	    Important: 1,
	    DashCase: 2,
	};
	RendererStyleFlags2[RendererStyleFlags2.Important] = "Important";
	RendererStyleFlags2[RendererStyleFlags2.DashCase] = "DashCase";
	/**
	 * \@experimental
	 * @abstract
	 */
	var Renderer2 = /** @class */ (function () {
	    function Renderer2() {
	    }
	    return Renderer2;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A wrapper around a native element inside of a View.
	 *
	 * An `ElementRef` is backed by a render-specific element. In the browser, this is usually a DOM
	 * element.
	 *
	 * \@security Permitting direct access to the DOM can make your application more vulnerable to
	 * XSS attacks. Carefully review any use of `ElementRef` in your code. For more detail, see the
	 * [Security Guide](http://g.co/ng/security).
	 *
	 * \@stable
	 */
	var ElementRef = /** @class */ (function () {
	    function ElementRef(nativeElement) {
	        this.nativeElement = nativeElement;
	    }
	    return ElementRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Used to load ng module factories.
	 * \@stable
	 * @abstract
	 */
	var NgModuleFactoryLoader = /** @class */ (function () {
	    function NgModuleFactoryLoader() {
	    }
	    return NgModuleFactoryLoader;
	}());
	var moduleFactories = new Map();
	/**
	 * Registers a loaded module. Should only be called from generated NgModuleFactory code.
	 * \@experimental
	 * @param {?} id
	 * @param {?} factory
	 * @return {?}
	 */
	function registerModuleFactory(id, factory) {
	    var /** @type {?} */ existing = moduleFactories.get(id);
	    if (existing) {
	        throw new Error("Duplicate module registered for " + id + " - " + existing.moduleType.name + " vs " + factory.moduleType.name);
	    }
	    moduleFactories.set(id, factory);
	}
	/**
	 * @return {?}
	 */
	
	/**
	 * Returns the NgModuleFactory with the given id, if it exists and has been loaded.
	 * Factories for modules that do not specify an `id` cannot be retrieved. Throws if the module
	 * cannot be found.
	 * \@experimental
	 * @param {?} id
	 * @return {?}
	 */
	function getModuleFactory(id) {
	    var /** @type {?} */ factory = moduleFactories.get(id);
	    if (!factory)
	        throw new Error("No module with ID " + id + " loaded");
	    return factory;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An unmodifiable list of items that Angular keeps up to date when the state
	 * of the application changes.
	 *
	 * The type of object that {\@link ViewChildren}, {\@link ContentChildren}, and {\@link QueryList}
	 * provide.
	 *
	 * Implements an iterable interface, therefore it can be used in both ES6
	 * javascript `for (var i of items)` loops as well as in Angular templates with
	 * `*ngFor="let i of myList"`.
	 *
	 * Changes can be observed by subscribing to the changes `Observable`.
	 *
	 * NOTE: In the future this class will implement an `Observable` interface.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/RX8sJnQYl9FWuSCWme5z?p=preview))
	 * ```typescript
	 * \@Component({...})
	 * class Container {
	 *   \@ViewChildren(Item) items:QueryList<Item>;
	 * }
	 * ```
	 * \@stable
	 * @template T
	 */
	var QueryList = /** @class */ (function () {
	    function QueryList() {
	        this.dirty = true;
	        this._results = [];
	        this.changes = new EventEmitter();
	        this.length = 0;
	    }
	    /**
	     * See
	     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
	     */
	    /**
	     * See
	     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
	     * @template U
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList.prototype.map = /**
	     * See
	     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
	     * @template U
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { return this._results.map(fn); };
	    /**
	     * See
	     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
	     */
	    /**
	     * See
	     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList.prototype.filter = /**
	     * See
	     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        return this._results.filter(fn);
	    };
	    /**
	     * See
	     * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
	     */
	    /**
	     * See
	     * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList.prototype.find = /**
	     * See
	     * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        return this._results.find(fn);
	    };
	    /**
	     * See
	     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
	     */
	    /**
	     * See
	     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
	     * @template U
	     * @param {?} fn
	     * @param {?} init
	     * @return {?}
	     */
	    QueryList.prototype.reduce = /**
	     * See
	     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
	     * @template U
	     * @param {?} fn
	     * @param {?} init
	     * @return {?}
	     */
	    function (fn, init) {
	        return this._results.reduce(fn, init);
	    };
	    /**
	     * See
	     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
	     */
	    /**
	     * See
	     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList.prototype.forEach = /**
	     * See
	     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._results.forEach(fn); };
	    /**
	     * See
	     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
	     */
	    /**
	     * See
	     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList.prototype.some = /**
	     * See
	     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        return this._results.some(fn);
	    };
	    /**
	     * @return {?}
	     */
	    QueryList.prototype.toArray = /**
	     * @return {?}
	     */
	    function () { return this._results.slice(); };
	    /**
	     * @return {?}
	     */
	    QueryList.prototype[getSymbolIterator()] = /**
	     * @return {?}
	     */
	    function () { return (/** @type {?} */ (this._results))[getSymbolIterator()](); };
	    /**
	     * @return {?}
	     */
	    QueryList.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return this._results.toString(); };
	    /**
	     * @param {?} res
	     * @return {?}
	     */
	    QueryList.prototype.reset = /**
	     * @param {?} res
	     * @return {?}
	     */
	    function (res) {
	        this._results = flatten(res);
	        (/** @type {?} */ (this)).dirty = false;
	        (/** @type {?} */ (this)).length = this._results.length;
	        (/** @type {?} */ (this)).last = this._results[this.length - 1];
	        (/** @type {?} */ (this)).first = this._results[0];
	    };
	    /**
	     * @return {?}
	     */
	    QueryList.prototype.notifyOnChanges = /**
	     * @return {?}
	     */
	    function () { (/** @type {?} */ (this.changes)).emit(this); };
	    /** internal */
	    /**
	     * internal
	     * @return {?}
	     */
	    QueryList.prototype.setDirty = /**
	     * internal
	     * @return {?}
	     */
	    function () { (/** @type {?} */ (this)).dirty = true; };
	    /** internal */
	    /**
	     * internal
	     * @return {?}
	     */
	    QueryList.prototype.destroy = /**
	     * internal
	     * @return {?}
	     */
	    function () {
	        (/** @type {?} */ (this.changes)).complete();
	        (/** @type {?} */ (this.changes)).unsubscribe();
	    };
	    return QueryList;
	}());
	/**
	 * @template T
	 * @param {?} list
	 * @return {?}
	 */
	function flatten(list) {
	    return list.reduce(function (flat, item) {
	        var /** @type {?} */ flatItem = Array.isArray(item) ? flatten(item) : item;
	        return (/** @type {?} */ (flat)).concat(flatItem);
	    }, []);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _SEPARATOR = '#';
	var FACTORY_CLASS_SUFFIX = 'NgFactory';
	/**
	 * Configuration for SystemJsNgModuleLoader.
	 * token.
	 *
	 * \@experimental
	 * @abstract
	 */
	var SystemJsNgModuleLoaderConfig = /** @class */ (function () {
	    function SystemJsNgModuleLoaderConfig() {
	    }
	    return SystemJsNgModuleLoaderConfig;
	}());
	var DEFAULT_CONFIG = {
	    factoryPathPrefix: '',
	    factoryPathSuffix: '.ngfactory',
	};
	/**
	 * NgModuleFactoryLoader that uses SystemJS to load NgModuleFactory
	 * \@experimental
	 */
	var SystemJsNgModuleLoader = /** @class */ (function () {
	    function SystemJsNgModuleLoader(_compiler, config) {
	        this._compiler = _compiler;
	        this._config = config || DEFAULT_CONFIG;
	    }
	    /**
	     * @param {?} path
	     * @return {?}
	     */
	    SystemJsNgModuleLoader.prototype.load = /**
	     * @param {?} path
	     * @return {?}
	     */
	    function (path) {
	        var /** @type {?} */ offlineMode = this._compiler instanceof Compiler;
	        return offlineMode ? this.loadFactory(path) : this.loadAndCompile(path);
	    };
	    /**
	     * @param {?} path
	     * @return {?}
	     */
	    SystemJsNgModuleLoader.prototype.loadAndCompile = /**
	     * @param {?} path
	     * @return {?}
	     */
	    function (path) {
	        var _this = this;
	        var _a = path.split(_SEPARATOR), module = _a[0], exportName = _a[1];
	        if (exportName === undefined) {
	            exportName = 'default';
	        }
	        return System.import(module)
	            .then(function (module) { return module[exportName]; })
	            .then(function (type) { return checkNotEmpty(type, module, exportName); })
	            .then(function (type) { return _this._compiler.compileModuleAsync(type); });
	    };
	    /**
	     * @param {?} path
	     * @return {?}
	     */
	    SystemJsNgModuleLoader.prototype.loadFactory = /**
	     * @param {?} path
	     * @return {?}
	     */
	    function (path) {
	        var _a = path.split(_SEPARATOR), module = _a[0], exportName = _a[1];
	        var /** @type {?} */ factoryClassSuffix = FACTORY_CLASS_SUFFIX;
	        if (exportName === undefined) {
	            exportName = 'default';
	            factoryClassSuffix = '';
	        }
	        return System.import(this._config.factoryPathPrefix + module + this._config.factoryPathSuffix)
	            .then(function (module) { return module[exportName + factoryClassSuffix]; })
	            .then(function (factory) { return checkNotEmpty(factory, module, exportName); });
	    };
	    SystemJsNgModuleLoader.decorators = [
	        { type: Injectable },
	    ];
	    /** @nocollapse */
	    SystemJsNgModuleLoader.ctorParameters = function () { return [
	        { type: Compiler, },
	        { type: SystemJsNgModuleLoaderConfig, decorators: [{ type: Optional },] },
	    ]; };
	    return SystemJsNgModuleLoader;
	}());
	/**
	 * @param {?} value
	 * @param {?} modulePath
	 * @param {?} exportName
	 * @return {?}
	 */
	function checkNotEmpty(value, modulePath, exportName) {
	    if (!value) {
	        throw new Error("Cannot find '" + exportName + "' in '" + modulePath + "'");
	    }
	    return value;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Represents an Embedded Template that can be used to instantiate Embedded Views.
	 *
	 * You can access a `TemplateRef`, in two ways. Via a directive placed on a `<ng-template>` element
	 * (or directive prefixed with `*`) and have the `TemplateRef` for this Embedded View injected into
	 * the constructor of the directive using the `TemplateRef` Token. Alternatively you can query for
	 * the `TemplateRef` from a Component or a Directive via {\@link Query}.
	 *
	 * To instantiate Embedded Views based on a Template, use {\@link ViewContainerRef#
	 * createEmbeddedView}, which will create the View and attach it to the View Container.
	 * \@stable
	 * @abstract
	 * @template C
	 */
	var TemplateRef = /** @class */ (function () {
	    function TemplateRef() {
	    }
	    return TemplateRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Represents a container where one or more Views can be attached.
	 *
	 * The container can contain two kinds of Views. Host Views, created by instantiating a
	 * {\@link Component} via {\@link #createComponent}, and Embedded Views, created by instantiating an
	 * {\@link TemplateRef Embedded Template} via {\@link #createEmbeddedView}.
	 *
	 * The location of the View Container within the containing View is specified by the Anchor
	 * `element`. Each View Container can have only one Anchor Element and each Anchor Element can only
	 * have a single View Container.
	 *
	 * Root elements of Views attached to this container become siblings of the Anchor Element in
	 * the Rendered View.
	 *
	 * To access a `ViewContainerRef` of an Element, you can either place a {\@link Directive} injected
	 * with `ViewContainerRef` on the Element, or you obtain it via a {\@link ViewChild} query.
	 * \@stable
	 * @abstract
	 */
	var ViewContainerRef = /** @class */ (function () {
	    function ViewContainerRef() {
	    }
	    return ViewContainerRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 * @abstract
	 */
	var ChangeDetectorRef = /** @class */ (function () {
	    function ChangeDetectorRef() {
	    }
	    return ChangeDetectorRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 * @abstract
	 */
	var ViewRef = /** @class */ (function (_super) {
	    __extends(ViewRef, _super);
	    function ViewRef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ViewRef;
	}(ChangeDetectorRef));
	/**
	 * Represents an Angular View.
	 *
	 * <!-- TODO: move the next two paragraphs to the dev guide -->
	 * A View is a fundamental building block of the application UI. It is the smallest grouping of
	 * Elements which are created and destroyed together.
	 *
	 * Properties of elements in a View can change, but the structure (number and order) of elements in
	 * a View cannot. Changing the structure of Elements can only be done by inserting, moving or
	 * removing nested Views via a {\@link ViewContainerRef}. Each View can contain many View Containers.
	 * <!-- /TODO -->
	 *
	 * ### Example
	 *
	 * Given this template...
	 *
	 * ```
	 * Count: {{items.length}}
	 * <ul>
	 *   <li *ngFor="let  item of items">{{item}}</li>
	 * </ul>
	 * ```
	 *
	 * We have two {\@link TemplateRef}s:
	 *
	 * Outer {\@link TemplateRef}:
	 * ```
	 * Count: {{items.length}}
	 * <ul>
	 *   <ng-template ngFor let-item [ngForOf]="items"></ng-template>
	 * </ul>
	 * ```
	 *
	 * Inner {\@link TemplateRef}:
	 * ```
	 *   <li>{{item}}</li>
	 * ```
	 *
	 * Notice that the original template is broken down into two separate {\@link TemplateRef}s.
	 *
	 * The outer/inner {\@link TemplateRef}s are then assembled into views like so:
	 *
	 * ```
	 * <!-- ViewRef: outer-0 -->
	 * Count: 2
	 * <ul>
	 *   <ng-template view-container-ref></ng-template>
	 *   <!-- ViewRef: inner-1 --><li>first</li><!-- /ViewRef: inner-1 -->
	 *   <!-- ViewRef: inner-2 --><li>second</li><!-- /ViewRef: inner-2 -->
	 * </ul>
	 * <!-- /ViewRef: outer-0 -->
	 * ```
	 * \@experimental
	 * @abstract
	 * @template C
	 */
	var EmbeddedViewRef = /** @class */ (function (_super) {
	    __extends(EmbeddedViewRef, _super);
	    function EmbeddedViewRef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return EmbeddedViewRef;
	}(ViewRef));
	/**
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var EventListener = /** @class */ (function () {
	    function EventListener(name, callback) {
	        this.name = name;
	        this.callback = callback;
	    }
	    return EventListener;
	}());
	/**
	 * \@experimental All debugging apis are currently experimental.
	 */
	var DebugNode = /** @class */ (function () {
	    function DebugNode(nativeNode, parent, _debugContext) {
	        this._debugContext = _debugContext;
	        this.nativeNode = nativeNode;
	        if (parent && parent instanceof DebugElement) {
	            parent.addChild(this);
	        }
	        else {
	            this.parent = null;
	        }
	        this.listeners = [];
	    }
	    Object.defineProperty(DebugNode.prototype, "injector", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._debugContext.injector; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugNode.prototype, "componentInstance", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._debugContext.component; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugNode.prototype, "context", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._debugContext.context; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugNode.prototype, "references", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._debugContext.references; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugNode.prototype, "providerTokens", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._debugContext.providerTokens; },
	        enumerable: true,
	        configurable: true
	    });
	    return DebugNode;
	}());
	/**
	 * \@experimental All debugging apis are currently experimental.
	 */
	var DebugElement = /** @class */ (function (_super) {
	    __extends(DebugElement, _super);
	    function DebugElement(nativeNode, parent, _debugContext) {
	        var _this = _super.call(this, nativeNode, parent, _debugContext) || this;
	        _this.properties = {};
	        _this.attributes = {};
	        _this.classes = {};
	        _this.styles = {};
	        _this.childNodes = [];
	        _this.nativeElement = nativeNode;
	        return _this;
	    }
	    /**
	     * @param {?} child
	     * @return {?}
	     */
	    DebugElement.prototype.addChild = /**
	     * @param {?} child
	     * @return {?}
	     */
	    function (child) {
	        if (child) {
	            this.childNodes.push(child);
	            child.parent = this;
	        }
	    };
	    /**
	     * @param {?} child
	     * @return {?}
	     */
	    DebugElement.prototype.removeChild = /**
	     * @param {?} child
	     * @return {?}
	     */
	    function (child) {
	        var /** @type {?} */ childIndex = this.childNodes.indexOf(child);
	        if (childIndex !== -1) {
	            child.parent = null;
	            this.childNodes.splice(childIndex, 1);
	        }
	    };
	    /**
	     * @param {?} child
	     * @param {?} newChildren
	     * @return {?}
	     */
	    DebugElement.prototype.insertChildrenAfter = /**
	     * @param {?} child
	     * @param {?} newChildren
	     * @return {?}
	     */
	    function (child, newChildren) {
	        var _this = this;
	        var /** @type {?} */ siblingIndex = this.childNodes.indexOf(child);
	        if (siblingIndex !== -1) {
	            (_a = this.childNodes).splice.apply(_a, [siblingIndex + 1, 0].concat(newChildren));
	            newChildren.forEach(function (c) {
	                if (c.parent) {
	                    c.parent.removeChild(c);
	                }
	                c.parent = _this;
	            });
	        }
	        var _a;
	    };
	    /**
	     * @param {?} refChild
	     * @param {?} newChild
	     * @return {?}
	     */
	    DebugElement.prototype.insertBefore = /**
	     * @param {?} refChild
	     * @param {?} newChild
	     * @return {?}
	     */
	    function (refChild, newChild) {
	        var /** @type {?} */ refIndex = this.childNodes.indexOf(refChild);
	        if (refIndex === -1) {
	            this.addChild(newChild);
	        }
	        else {
	            if (newChild.parent) {
	                newChild.parent.removeChild(newChild);
	            }
	            newChild.parent = this;
	            this.childNodes.splice(refIndex, 0, newChild);
	        }
	    };
	    /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    DebugElement.prototype.query = /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    function (predicate) {
	        var /** @type {?} */ results = this.queryAll(predicate);
	        return results[0] || null;
	    };
	    /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    DebugElement.prototype.queryAll = /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    function (predicate) {
	        var /** @type {?} */ matches = [];
	        _queryElementChildren(this, predicate, matches);
	        return matches;
	    };
	    /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    DebugElement.prototype.queryAllNodes = /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    function (predicate) {
	        var /** @type {?} */ matches = [];
	        _queryNodeChildren(this, predicate, matches);
	        return matches;
	    };
	    Object.defineProperty(DebugElement.prototype, "children", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return /** @type {?} */ (this.childNodes.filter(function (node) { return node instanceof DebugElement; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} eventName
	     * @param {?} eventObj
	     * @return {?}
	     */
	    DebugElement.prototype.triggerEventHandler = /**
	     * @param {?} eventName
	     * @param {?} eventObj
	     * @return {?}
	     */
	    function (eventName, eventObj) {
	        this.listeners.forEach(function (listener) {
	            if (listener.name == eventName) {
	                listener.callback(eventObj);
	            }
	        });
	    };
	    return DebugElement;
	}(DebugNode));
	/**
	 * \@experimental
	 * @param {?} debugEls
	 * @return {?}
	 */
	function asNativeElements(debugEls) {
	    return debugEls.map(function (el) { return el.nativeElement; });
	}
	/**
	 * @param {?} element
	 * @param {?} predicate
	 * @param {?} matches
	 * @return {?}
	 */
	function _queryElementChildren(element, predicate, matches) {
	    element.childNodes.forEach(function (node) {
	        if (node instanceof DebugElement) {
	            if (predicate(node)) {
	                matches.push(node);
	            }
	            _queryElementChildren(node, predicate, matches);
	        }
	    });
	}
	/**
	 * @param {?} parentNode
	 * @param {?} predicate
	 * @param {?} matches
	 * @return {?}
	 */
	function _queryNodeChildren(parentNode, predicate, matches) {
	    if (parentNode instanceof DebugElement) {
	        parentNode.childNodes.forEach(function (node) {
	            if (predicate(node)) {
	                matches.push(node);
	            }
	            if (node instanceof DebugElement) {
	                _queryNodeChildren(node, predicate, matches);
	            }
	        });
	    }
	}
	// Need to keep the nodes in a global Map so that multiple angular apps are supported.
	var _nativeNodeToDebugNode = new Map();
	/**
	 * \@experimental
	 * @param {?} nativeNode
	 * @return {?}
	 */
	function getDebugNode(nativeNode) {
	    return _nativeNodeToDebugNode.get(nativeNode) || null;
	}
	/**
	 * @return {?}
	 */
	
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function indexDebugNode(node) {
	    _nativeNodeToDebugNode.set(node.nativeNode, node);
	}
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function removeDebugNodeFromIndex(node) {
	    _nativeNodeToDebugNode.delete(node.nativeNode);
	}
	/**
	 * A boolean-valued function over a value, possibly including context information
	 * regarding that value's position in an array.
	 *
	 * \@experimental All debugging apis are currently experimental.
	 * @record
	 * @template T
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function devModeEqual(a, b) {
	    var /** @type {?} */ isListLikeIterableA = isListLikeIterable(a);
	    var /** @type {?} */ isListLikeIterableB = isListLikeIterable(b);
	    if (isListLikeIterableA && isListLikeIterableB) {
	        return areIterablesEqual(a, b, devModeEqual);
	    }
	    else {
	        var /** @type {?} */ isAObject = a && (typeof a === 'object' || typeof a === 'function');
	        var /** @type {?} */ isBObject = b && (typeof b === 'object' || typeof b === 'function');
	        if (!isListLikeIterableA && isAObject && !isListLikeIterableB && isBObject) {
	            return true;
	        }
	        else {
	            return looseIdentical(a, b);
	        }
	    }
	}
	/**
	 * Indicates that the result of a {\@link Pipe} transformation has changed even though the
	 * reference has not changed.
	 *
	 * Wrapped values are unwrapped automatically during the change detection, and the unwrapped value
	 * is stored.
	 *
	 * Example:
	 *
	 * ```
	 * if (this._latestValue === this._latestReturnedValue) {
	 *    return this._latestReturnedValue;
	 *  } else {
	 *    this._latestReturnedValue = this._latestValue;
	 *    return WrappedValue.wrap(this._latestValue); // this will force update
	 *  }
	 * ```
	 * \@stable
	 */
	var WrappedValue = /** @class */ (function () {
	    function WrappedValue(value) {
	        this.wrapped = value;
	    }
	    /** Creates a wrapped value. */
	    /**
	     * Creates a wrapped value.
	     * @param {?} value
	     * @return {?}
	     */
	    WrappedValue.wrap = /**
	     * Creates a wrapped value.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return new WrappedValue(value); };
	    /**
	     * Returns the underlying value of a wrapped value.
	     * Returns the given `value` when it is not wrapped.
	     **/
	    /**
	     * Returns the underlying value of a wrapped value.
	     * Returns the given `value` when it is not wrapped.
	     *
	     * @param {?} value
	     * @return {?}
	     */
	    WrappedValue.unwrap = /**
	     * Returns the underlying value of a wrapped value.
	     * Returns the given `value` when it is not wrapped.
	     *
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return WrappedValue.isWrapped(value) ? value.wrapped : value; };
	    /** Returns true if `value` is a wrapped value. */
	    /**
	     * Returns true if `value` is a wrapped value.
	     * @param {?} value
	     * @return {?}
	     */
	    WrappedValue.isWrapped = /**
	     * Returns true if `value` is a wrapped value.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return value instanceof WrappedValue; };
	    return WrappedValue;
	}());
	/**
	 * Represents a basic change from a previous to a new value.
	 * \@stable
	 */
	var SimpleChange = /** @class */ (function () {
	    function SimpleChange(previousValue, currentValue, firstChange) {
	        this.previousValue = previousValue;
	        this.currentValue = currentValue;
	        this.firstChange = firstChange;
	    }
	    /**
	     * Check whether the new value is the first value assigned.
	     */
	    /**
	     * Check whether the new value is the first value assigned.
	     * @return {?}
	     */
	    SimpleChange.prototype.isFirstChange = /**
	     * Check whether the new value is the first value assigned.
	     * @return {?}
	     */
	    function () { return this.firstChange; };
	    return SimpleChange;
	}());
	/**
	 * @param {?} obj
	 * @return {?}
	 */
	function isListLikeIterable(obj) {
	    if (!isJsObject(obj))
	        return false;
	    return Array.isArray(obj) ||
	        (!(obj instanceof Map) && // JS Map are iterables but return entries as [k, v]
	            // JS Map are iterables but return entries as [k, v]
	            getSymbolIterator() in obj); // JS Iterable have a Symbol.iterator prop
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @param {?} comparator
	 * @return {?}
	 */
	function areIterablesEqual(a, b, comparator) {
	    var /** @type {?} */ iterator1 = a[getSymbolIterator()]();
	    var /** @type {?} */ iterator2 = b[getSymbolIterator()]();
	    while (true) {
	        var /** @type {?} */ item1 = iterator1.next();
	        var /** @type {?} */ item2 = iterator2.next();
	        if (item1.done && item2.done)
	            return true;
	        if (item1.done || item2.done)
	            return false;
	        if (!comparator(item1.value, item2.value))
	            return false;
	    }
	}
	/**
	 * @param {?} obj
	 * @param {?} fn
	 * @return {?}
	 */
	function iterateListLike(obj, fn) {
	    if (Array.isArray(obj)) {
	        for (var /** @type {?} */ i = 0; i < obj.length; i++) {
	            fn(obj[i]);
	        }
	    }
	    else {
	        var /** @type {?} */ iterator = obj[getSymbolIterator()]();
	        var /** @type {?} */ item = void 0;
	        while (!((item = iterator.next()).done)) {
	            fn(item.value);
	        }
	    }
	}
	/**
	 * @param {?} o
	 * @return {?}
	 */
	function isJsObject(o) {
	    return o !== null && (typeof o === 'function' || typeof o === 'object');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var DefaultIterableDifferFactory = /** @class */ (function () {
	    function DefaultIterableDifferFactory() {
	    }
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    DefaultIterableDifferFactory.prototype.supports = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) { return isListLikeIterable(obj); };
	    /**
	     * @template V
	     * @param {?=} trackByFn
	     * @return {?}
	     */
	    DefaultIterableDifferFactory.prototype.create = /**
	     * @template V
	     * @param {?=} trackByFn
	     * @return {?}
	     */
	    function (trackByFn) {
	        return new DefaultIterableDiffer(trackByFn);
	    };
	    return DefaultIterableDifferFactory;
	}());
	var trackByIdentity = function (index, item) { return item; };
	/**
	 * @deprecated v4.0.0 - Should not be part of public API.
	 * @template V
	 */
	var DefaultIterableDiffer = /** @class */ (function () {
	    function DefaultIterableDiffer(trackByFn) {
	        this.length = 0;
	        this._linkedRecords = null;
	        this._unlinkedRecords = null;
	        this._previousItHead = null;
	        this._itHead = null;
	        this._itTail = null;
	        this._additionsHead = null;
	        this._additionsTail = null;
	        this._movesHead = null;
	        this._movesTail = null;
	        this._removalsHead = null;
	        this._removalsTail = null;
	        this._identityChangesHead = null;
	        this._identityChangesTail = null;
	        this._trackByFn = trackByFn || trackByIdentity;
	    }
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._itHead; record !== null; record = record._next) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachOperation = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ nextIt = this._itHead;
	        var /** @type {?} */ nextRemove = this._removalsHead;
	        var /** @type {?} */ addRemoveOffset = 0;
	        var /** @type {?} */ moveOffsets = null;
	        while (nextIt || nextRemove) {
	            // Figure out which is the next record to process
	            // Order: remove, add, move
	            var /** @type {?} */ record = !nextRemove ||
	                nextIt && /** @type {?} */ ((nextIt.currentIndex)) < getPreviousIndex(nextRemove, addRemoveOffset, moveOffsets) ? /** @type {?} */
	                ((nextIt)) :
	                nextRemove;
	            var /** @type {?} */ adjPreviousIndex = getPreviousIndex(record, addRemoveOffset, moveOffsets);
	            var /** @type {?} */ currentIndex = record.currentIndex;
	            // consume the item, and adjust the addRemoveOffset and update moveDistance if necessary
	            if (record === nextRemove) {
	                addRemoveOffset--;
	                nextRemove = nextRemove._nextRemoved;
	            }
	            else {
	                nextIt = /** @type {?} */ ((nextIt))._next;
	                if (record.previousIndex == null) {
	                    addRemoveOffset++;
	                }
	                else {
	                    // INVARIANT:  currentIndex < previousIndex
	                    if (!moveOffsets)
	                        moveOffsets = [];
	                    var /** @type {?} */ localMovePreviousIndex = adjPreviousIndex - addRemoveOffset;
	                    var /** @type {?} */ localCurrentIndex = /** @type {?} */ ((currentIndex)) - addRemoveOffset;
	                    if (localMovePreviousIndex != localCurrentIndex) {
	                        for (var /** @type {?} */ i = 0; i < localMovePreviousIndex; i++) {
	                            var /** @type {?} */ offset = i < moveOffsets.length ? moveOffsets[i] : (moveOffsets[i] = 0);
	                            var /** @type {?} */ index = offset + i;
	                            if (localCurrentIndex <= index && index < localMovePreviousIndex) {
	                                moveOffsets[i] = offset + 1;
	                            }
	                        }
	                        var /** @type {?} */ previousIndex = record.previousIndex;
	                        moveOffsets[previousIndex] = localCurrentIndex - localMovePreviousIndex;
	                    }
	                }
	            }
	            if (adjPreviousIndex !== currentIndex) {
	                fn(record, adjPreviousIndex, currentIndex);
	            }
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachPreviousItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._previousItHead; record !== null; record = record._nextPrevious) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachAddedItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachMovedItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._movesHead; record !== null; record = record._nextMoved) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachRemovedItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.forEachIdentityChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._identityChangesHead; record !== null; record = record._nextIdentityChange) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} collection
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.diff = /**
	     * @param {?} collection
	     * @return {?}
	     */
	    function (collection) {
	        if (collection == null)
	            collection = [];
	        if (!isListLikeIterable(collection)) {
	            throw new Error("Error trying to diff '" + stringify(collection) + "'. Only arrays and iterables are allowed");
	        }
	        if (this.check(collection)) {
	            return this;
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.onDestroy = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @param {?} collection
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype.check = /**
	     * @param {?} collection
	     * @return {?}
	     */
	    function (collection) {
	        var _this = this;
	        this._reset();
	        var /** @type {?} */ record = this._itHead;
	        var /** @type {?} */ mayBeDirty = false;
	        var /** @type {?} */ index;
	        var /** @type {?} */ item;
	        var /** @type {?} */ itemTrackBy;
	        if (Array.isArray(collection)) {
	            (/** @type {?} */ (this)).length = collection.length;
	            for (var /** @type {?} */ index_1 = 0; index_1 < this.length; index_1++) {
	                item = collection[index_1];
	                itemTrackBy = this._trackByFn(index_1, item);
	                if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
	                    record = this._mismatch(record, item, itemTrackBy, index_1);
	                    mayBeDirty = true;
	                }
	                else {
	                    if (mayBeDirty) {
	                        // TODO(misko): can we limit this to duplicates only?
	                        record = this._verifyReinsertion(record, item, itemTrackBy, index_1);
	                    }
	                    if (!looseIdentical(record.item, item))
	                        this._addIdentityChange(record, item);
	                }
	                record = record._next;
	            }
	        }
	        else {
	            index = 0;
	            iterateListLike(collection, function (item) {
	                itemTrackBy = _this._trackByFn(index, item);
	                if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
	                    record = _this._mismatch(record, item, itemTrackBy, index);
	                    mayBeDirty = true;
	                }
	                else {
	                    if (mayBeDirty) {
	                        // TODO(misko): can we limit this to duplicates only?
	                        record = _this._verifyReinsertion(record, item, itemTrackBy, index);
	                    }
	                    if (!looseIdentical(record.item, item))
	                        _this._addIdentityChange(record, item);
	                }
	                record = record._next;
	                index++;
	            });
	            (/** @type {?} */ (this)).length = index;
	        }
	        this._truncate(record);
	        (/** @type {?} */ (this)).collection = collection;
	        return this.isDirty;
	    };
	    Object.defineProperty(DefaultIterableDiffer.prototype, "isDirty", {
	        /* CollectionChanges is considered dirty if it has any additions, moves, removals, or identity
	         * changes.
	         */
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._additionsHead !== null || this._movesHead !== null ||
	                this._removalsHead !== null || this._identityChangesHead !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Reset the state of the change objects to show no changes. This means set previousKey to
	     * currentKey, and clear all of the queues (additions, moves, removals).
	     * Set the previousIndexes of moved and added items to their currentIndexes
	     * Reset the list of additions, moves and removals
	     *
	     * @internal
	     */
	    /**
	     * Reset the state of the change objects to show no changes. This means set previousKey to
	     * currentKey, and clear all of the queues (additions, moves, removals).
	     * Set the previousIndexes of moved and added items to their currentIndexes
	     * Reset the list of additions, moves and removals
	     *
	     * \@internal
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._reset = /**
	     * Reset the state of the change objects to show no changes. This means set previousKey to
	     * currentKey, and clear all of the queues (additions, moves, removals).
	     * Set the previousIndexes of moved and added items to their currentIndexes
	     * Reset the list of additions, moves and removals
	     *
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        if (this.isDirty) {
	            var /** @type {?} */ record = void 0;
	            var /** @type {?} */ nextRecord = void 0;
	            for (record = this._previousItHead = this._itHead; record !== null; record = record._next) {
	                record._nextPrevious = record._next;
	            }
	            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
	                record.previousIndex = record.currentIndex;
	            }
	            this._additionsHead = this._additionsTail = null;
	            for (record = this._movesHead; record !== null; record = nextRecord) {
	                record.previousIndex = record.currentIndex;
	                nextRecord = record._nextMoved;
	            }
	            this._movesHead = this._movesTail = null;
	            this._removalsHead = this._removalsTail = null;
	            this._identityChangesHead = this._identityChangesTail = null;
	            // TODO(vicb): when assert gets supported
	            // assert(!this.isDirty);
	        }
	    };
	    /**
	     * This is the core function which handles differences between collections.
	     *
	     * - `record` is the record which we saw at this position last time. If null then it is a new
	     *   item.
	     * - `item` is the current item in the collection
	     * - `index` is the position of the item in the collection
	     *
	     * @internal
	     */
	    /**
	     * This is the core function which handles differences between collections.
	     *
	     * - `record` is the record which we saw at this position last time. If null then it is a new
	     *   item.
	     * - `item` is the current item in the collection
	     * - `index` is the position of the item in the collection
	     *
	     * \@internal
	     * @param {?} record
	     * @param {?} item
	     * @param {?} itemTrackBy
	     * @param {?} index
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._mismatch = /**
	     * This is the core function which handles differences between collections.
	     *
	     * - `record` is the record which we saw at this position last time. If null then it is a new
	     *   item.
	     * - `item` is the current item in the collection
	     * - `index` is the position of the item in the collection
	     *
	     * \@internal
	     * @param {?} record
	     * @param {?} item
	     * @param {?} itemTrackBy
	     * @param {?} index
	     * @return {?}
	     */
	    function (record, item, itemTrackBy, index) {
	        // The previous record after which we will append the current one.
	        var /** @type {?} */ previousRecord;
	        if (record === null) {
	            previousRecord = this._itTail;
	        }
	        else {
	            previousRecord = record._prev;
	            // Remove the record from the collection since we know it does not match the item.
	            this._remove(record);
	        }
	        // Attempt to see if we have seen the item before.
	        record = this._linkedRecords === null ? null : this._linkedRecords.get(itemTrackBy, index);
	        if (record !== null) {
	            // We have seen this before, we need to move it forward in the collection.
	            // But first we need to check if identity changed, so we can update in view if necessary
	            if (!looseIdentical(record.item, item))
	                this._addIdentityChange(record, item);
	            this._moveAfter(record, previousRecord, index);
	        }
	        else {
	            // Never seen it, check evicted list.
	            record = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
	            if (record !== null) {
	                // It is an item which we have evicted earlier: reinsert it back into the list.
	                // But first we need to check if identity changed, so we can update in view if necessary
	                if (!looseIdentical(record.item, item))
	                    this._addIdentityChange(record, item);
	                this._reinsertAfter(record, previousRecord, index);
	            }
	            else {
	                // It is a new item: add it.
	                record =
	                    this._addAfter(new IterableChangeRecord_(item, itemTrackBy), previousRecord, index);
	            }
	        }
	        return record;
	    };
	    /**
	     * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
	     *
	     * Use case: `[a, a]` => `[b, a, a]`
	     *
	     * If we did not have this check then the insertion of `b` would:
	     *   1) evict first `a`
	     *   2) insert `b` at `0` index.
	     *   3) leave `a` at index `1` as is. <-- this is wrong!
	     *   3) reinsert `a` at index 2. <-- this is wrong!
	     *
	     * The correct behavior is:
	     *   1) evict first `a`
	     *   2) insert `b` at `0` index.
	     *   3) reinsert `a` at index 1.
	     *   3) move `a` at from `1` to `2`.
	     *
	     *
	     * Double check that we have not evicted a duplicate item. We need to check if the item type may
	     * have already been removed:
	     * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
	     * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
	     * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
	     * at the end.
	     *
	     * @internal
	     */
	    /**
	     * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
	     *
	     * Use case: `[a, a]` => `[b, a, a]`
	     *
	     * If we did not have this check then the insertion of `b` would:
	     *   1) evict first `a`
	     *   2) insert `b` at `0` index.
	     *   3) leave `a` at index `1` as is. <-- this is wrong!
	     *   3) reinsert `a` at index 2. <-- this is wrong!
	     *
	     * The correct behavior is:
	     *   1) evict first `a`
	     *   2) insert `b` at `0` index.
	     *   3) reinsert `a` at index 1.
	     *   3) move `a` at from `1` to `2`.
	     *
	     *
	     * Double check that we have not evicted a duplicate item. We need to check if the item type may
	     * have already been removed:
	     * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
	     * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
	     * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
	     * at the end.
	     *
	     * \@internal
	     * @param {?} record
	     * @param {?} item
	     * @param {?} itemTrackBy
	     * @param {?} index
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._verifyReinsertion = /**
	     * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
	     *
	     * Use case: `[a, a]` => `[b, a, a]`
	     *
	     * If we did not have this check then the insertion of `b` would:
	     *   1) evict first `a`
	     *   2) insert `b` at `0` index.
	     *   3) leave `a` at index `1` as is. <-- this is wrong!
	     *   3) reinsert `a` at index 2. <-- this is wrong!
	     *
	     * The correct behavior is:
	     *   1) evict first `a`
	     *   2) insert `b` at `0` index.
	     *   3) reinsert `a` at index 1.
	     *   3) move `a` at from `1` to `2`.
	     *
	     *
	     * Double check that we have not evicted a duplicate item. We need to check if the item type may
	     * have already been removed:
	     * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
	     * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
	     * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
	     * at the end.
	     *
	     * \@internal
	     * @param {?} record
	     * @param {?} item
	     * @param {?} itemTrackBy
	     * @param {?} index
	     * @return {?}
	     */
	    function (record, item, itemTrackBy, index) {
	        var /** @type {?} */ reinsertRecord = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
	        if (reinsertRecord !== null) {
	            record = this._reinsertAfter(reinsertRecord, /** @type {?} */ ((record._prev)), index);
	        }
	        else if (record.currentIndex != index) {
	            record.currentIndex = index;
	            this._addToMoves(record, index);
	        }
	        return record;
	    };
	    /**
	     * Get rid of any excess {@link IterableChangeRecord_}s from the previous collection
	     *
	     * - `record` The first excess {@link IterableChangeRecord_}.
	     *
	     * @internal
	     */
	    /**
	     * Get rid of any excess {\@link IterableChangeRecord_}s from the previous collection
	     *
	     * - `record` The first excess {\@link IterableChangeRecord_}.
	     *
	     * \@internal
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._truncate = /**
	     * Get rid of any excess {\@link IterableChangeRecord_}s from the previous collection
	     *
	     * - `record` The first excess {\@link IterableChangeRecord_}.
	     *
	     * \@internal
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        // Anything after that needs to be removed;
	        while (record !== null) {
	            var /** @type {?} */ nextRecord = record._next;
	            this._addToRemovals(this._unlink(record));
	            record = nextRecord;
	        }
	        if (this._unlinkedRecords !== null) {
	            this._unlinkedRecords.clear();
	        }
	        if (this._additionsTail !== null) {
	            this._additionsTail._nextAdded = null;
	        }
	        if (this._movesTail !== null) {
	            this._movesTail._nextMoved = null;
	        }
	        if (this._itTail !== null) {
	            this._itTail._next = null;
	        }
	        if (this._removalsTail !== null) {
	            this._removalsTail._nextRemoved = null;
	        }
	        if (this._identityChangesTail !== null) {
	            this._identityChangesTail._nextIdentityChange = null;
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._reinsertAfter = /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    function (record, prevRecord, index) {
	        if (this._unlinkedRecords !== null) {
	            this._unlinkedRecords.remove(record);
	        }
	        var /** @type {?} */ prev = record._prevRemoved;
	        var /** @type {?} */ next = record._nextRemoved;
	        if (prev === null) {
	            this._removalsHead = next;
	        }
	        else {
	            prev._nextRemoved = next;
	        }
	        if (next === null) {
	            this._removalsTail = prev;
	        }
	        else {
	            next._prevRemoved = prev;
	        }
	        this._insertAfter(record, prevRecord, index);
	        this._addToMoves(record, index);
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._moveAfter = /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    function (record, prevRecord, index) {
	        this._unlink(record);
	        this._insertAfter(record, prevRecord, index);
	        this._addToMoves(record, index);
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._addAfter = /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    function (record, prevRecord, index) {
	        this._insertAfter(record, prevRecord, index);
	        if (this._additionsTail === null) {
	            // TODO(vicb):
	            // assert(this._additionsHead === null);
	            this._additionsTail = this._additionsHead = record;
	        }
	        else {
	            // TODO(vicb):
	            // assert(_additionsTail._nextAdded === null);
	            // assert(record._nextAdded === null);
	            this._additionsTail = this._additionsTail._nextAdded = record;
	        }
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._insertAfter = /**
	     * \@internal
	     * @param {?} record
	     * @param {?} prevRecord
	     * @param {?} index
	     * @return {?}
	     */
	    function (record, prevRecord, index) {
	        // TODO(vicb):
	        // assert(record != prevRecord);
	        // assert(record._next === null);
	        // assert(record._prev === null);
	        var /** @type {?} */ next = prevRecord === null ? this._itHead : prevRecord._next;
	        // TODO(vicb):
	        // assert(next != record);
	        // assert(prevRecord != record);
	        record._next = next;
	        record._prev = prevRecord;
	        if (next === null) {
	            this._itTail = record;
	        }
	        else {
	            next._prev = record;
	        }
	        if (prevRecord === null) {
	            this._itHead = record;
	        }
	        else {
	            prevRecord._next = record;
	        }
	        if (this._linkedRecords === null) {
	            this._linkedRecords = new _DuplicateMap();
	        }
	        this._linkedRecords.put(record);
	        record.currentIndex = index;
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._remove = /**
	     * \@internal
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        return this._addToRemovals(this._unlink(record));
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._unlink = /**
	     * \@internal
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        if (this._linkedRecords !== null) {
	            this._linkedRecords.remove(record);
	        }
	        var /** @type {?} */ prev = record._prev;
	        var /** @type {?} */ next = record._next;
	        // TODO(vicb):
	        // assert((record._prev = null) === null);
	        // assert((record._next = null) === null);
	        if (prev === null) {
	            this._itHead = next;
	        }
	        else {
	            prev._next = next;
	        }
	        if (next === null) {
	            this._itTail = prev;
	        }
	        else {
	            next._prev = prev;
	        }
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @param {?} toIndex
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._addToMoves = /**
	     * \@internal
	     * @param {?} record
	     * @param {?} toIndex
	     * @return {?}
	     */
	    function (record, toIndex) {
	        // TODO(vicb):
	        // assert(record._nextMoved === null);
	        if (record.previousIndex === toIndex) {
	            return record;
	        }
	        if (this._movesTail === null) {
	            // TODO(vicb):
	            // assert(_movesHead === null);
	            this._movesTail = this._movesHead = record;
	        }
	        else {
	            // TODO(vicb):
	            // assert(_movesTail._nextMoved === null);
	            this._movesTail = this._movesTail._nextMoved = record;
	        }
	        return record;
	    };
	    /**
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._addToRemovals = /**
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        if (this._unlinkedRecords === null) {
	            this._unlinkedRecords = new _DuplicateMap();
	        }
	        this._unlinkedRecords.put(record);
	        record.currentIndex = null;
	        record._nextRemoved = null;
	        if (this._removalsTail === null) {
	            // TODO(vicb):
	            // assert(_removalsHead === null);
	            this._removalsTail = this._removalsHead = record;
	            record._prevRemoved = null;
	        }
	        else {
	            // TODO(vicb):
	            // assert(_removalsTail._nextRemoved === null);
	            // assert(record._nextRemoved === null);
	            record._prevRemoved = this._removalsTail;
	            this._removalsTail = this._removalsTail._nextRemoved = record;
	        }
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} record
	     * @param {?} item
	     * @return {?}
	     */
	    DefaultIterableDiffer.prototype._addIdentityChange = /**
	     * \@internal
	     * @param {?} record
	     * @param {?} item
	     * @return {?}
	     */
	    function (record, item) {
	        record.item = item;
	        if (this._identityChangesTail === null) {
	            this._identityChangesTail = this._identityChangesHead = record;
	        }
	        else {
	            this._identityChangesTail = this._identityChangesTail._nextIdentityChange = record;
	        }
	        return record;
	    };
	    return DefaultIterableDiffer;
	}());
	/**
	 * \@stable
	 * @template V
	 */
	var IterableChangeRecord_ = /** @class */ (function () {
	    function IterableChangeRecord_(item, trackById) {
	        this.item = item;
	        this.trackById = trackById;
	        this.currentIndex = null;
	        this.previousIndex = null;
	        /**
	         * \@internal
	         */
	        this._nextPrevious = null;
	        /**
	         * \@internal
	         */
	        this._prev = null;
	        /**
	         * \@internal
	         */
	        this._next = null;
	        /**
	         * \@internal
	         */
	        this._prevDup = null;
	        /**
	         * \@internal
	         */
	        this._nextDup = null;
	        /**
	         * \@internal
	         */
	        this._prevRemoved = null;
	        /**
	         * \@internal
	         */
	        this._nextRemoved = null;
	        /**
	         * \@internal
	         */
	        this._nextAdded = null;
	        /**
	         * \@internal
	         */
	        this._nextMoved = null;
	        /**
	         * \@internal
	         */
	        this._nextIdentityChange = null;
	    }
	    return IterableChangeRecord_;
	}());
	/**
	 * @template V
	 */
	var _DuplicateItemRecordList = /** @class */ (function () {
	    function _DuplicateItemRecordList() {
	        /**
	         * \@internal
	         */
	        this._head = null;
	        /**
	         * \@internal
	         */
	        this._tail = null;
	    }
	    /**
	     * Append the record to the list of duplicates.
	     *
	     * Note: by design all records in the list of duplicates hold the same value in record.item.
	     */
	    /**
	     * Append the record to the list of duplicates.
	     *
	     * Note: by design all records in the list of duplicates hold the same value in record.item.
	     * @param {?} record
	     * @return {?}
	     */
	    _DuplicateItemRecordList.prototype.add = /**
	     * Append the record to the list of duplicates.
	     *
	     * Note: by design all records in the list of duplicates hold the same value in record.item.
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        if (this._head === null) {
	            this._head = this._tail = record;
	            record._nextDup = null;
	            record._prevDup = null;
	        }
	        else {
	            /** @type {?} */ ((
	            // TODO(vicb):
	            // assert(record.item ==  _head.item ||
	            //       record.item is num && record.item.isNaN && _head.item is num && _head.item.isNaN);
	            this._tail))._nextDup = record;
	            record._prevDup = this._tail;
	            record._nextDup = null;
	            this._tail = record;
	        }
	    };
	    // Returns a IterableChangeRecord_ having IterableChangeRecord_.trackById == trackById and
	    // IterableChangeRecord_.currentIndex >= atOrAfterIndex
	    /**
	     * @param {?} trackById
	     * @param {?} atOrAfterIndex
	     * @return {?}
	     */
	    _DuplicateItemRecordList.prototype.get = /**
	     * @param {?} trackById
	     * @param {?} atOrAfterIndex
	     * @return {?}
	     */
	    function (trackById, atOrAfterIndex) {
	        var /** @type {?} */ record;
	        for (record = this._head; record !== null; record = record._nextDup) {
	            if ((atOrAfterIndex === null || atOrAfterIndex <= /** @type {?} */ ((record.currentIndex))) &&
	                looseIdentical(record.trackById, trackById)) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove one {@link IterableChangeRecord_} from the list of duplicates.
	     *
	     * Returns whether the list of duplicates is empty.
	     */
	    /**
	     * Remove one {\@link IterableChangeRecord_} from the list of duplicates.
	     *
	     * Returns whether the list of duplicates is empty.
	     * @param {?} record
	     * @return {?}
	     */
	    _DuplicateItemRecordList.prototype.remove = /**
	     * Remove one {\@link IterableChangeRecord_} from the list of duplicates.
	     *
	     * Returns whether the list of duplicates is empty.
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        // TODO(vicb):
	        // assert(() {
	        //  // verify that the record being removed is in the list.
	        //  for (IterableChangeRecord_ cursor = _head; cursor != null; cursor = cursor._nextDup) {
	        //    if (identical(cursor, record)) return true;
	        //  }
	        //  return false;
	        //});
	        var /** @type {?} */ prev = record._prevDup;
	        var /** @type {?} */ next = record._nextDup;
	        if (prev === null) {
	            this._head = next;
	        }
	        else {
	            prev._nextDup = next;
	        }
	        if (next === null) {
	            this._tail = prev;
	        }
	        else {
	            next._prevDup = prev;
	        }
	        return this._head === null;
	    };
	    return _DuplicateItemRecordList;
	}());
	/**
	 * @template V
	 */
	var _DuplicateMap = /** @class */ (function () {
	    function _DuplicateMap() {
	        this.map = new Map();
	    }
	    /**
	     * @param {?} record
	     * @return {?}
	     */
	    _DuplicateMap.prototype.put = /**
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        var /** @type {?} */ key = record.trackById;
	        var /** @type {?} */ duplicates = this.map.get(key);
	        if (!duplicates) {
	            duplicates = new _DuplicateItemRecordList();
	            this.map.set(key, duplicates);
	        }
	        duplicates.add(record);
	    };
	    /**
	     * Retrieve the `value` using key. Because the IterableChangeRecord_ value may be one which we
	     * have already iterated over, we use the `atOrAfterIndex` to pretend it is not there.
	     *
	     * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
	     * have any more `a`s needs to return the second `a`.
	     */
	    /**
	     * Retrieve the `value` using key. Because the IterableChangeRecord_ value may be one which we
	     * have already iterated over, we use the `atOrAfterIndex` to pretend it is not there.
	     *
	     * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
	     * have any more `a`s needs to return the second `a`.
	     * @param {?} trackById
	     * @param {?} atOrAfterIndex
	     * @return {?}
	     */
	    _DuplicateMap.prototype.get = /**
	     * Retrieve the `value` using key. Because the IterableChangeRecord_ value may be one which we
	     * have already iterated over, we use the `atOrAfterIndex` to pretend it is not there.
	     *
	     * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
	     * have any more `a`s needs to return the second `a`.
	     * @param {?} trackById
	     * @param {?} atOrAfterIndex
	     * @return {?}
	     */
	    function (trackById, atOrAfterIndex) {
	        var /** @type {?} */ key = trackById;
	        var /** @type {?} */ recordList = this.map.get(key);
	        return recordList ? recordList.get(trackById, atOrAfterIndex) : null;
	    };
	    /**
	     * Removes a {@link IterableChangeRecord_} from the list of duplicates.
	     *
	     * The list of duplicates also is removed from the map if it gets empty.
	     */
	    /**
	     * Removes a {\@link IterableChangeRecord_} from the list of duplicates.
	     *
	     * The list of duplicates also is removed from the map if it gets empty.
	     * @param {?} record
	     * @return {?}
	     */
	    _DuplicateMap.prototype.remove = /**
	     * Removes a {\@link IterableChangeRecord_} from the list of duplicates.
	     *
	     * The list of duplicates also is removed from the map if it gets empty.
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        var /** @type {?} */ key = record.trackById;
	        var /** @type {?} */ recordList = /** @type {?} */ ((this.map.get(key)));
	        // Remove the list of duplicates when it gets empty
	        if (recordList.remove(record)) {
	            this.map.delete(key);
	        }
	        return record;
	    };
	    Object.defineProperty(_DuplicateMap.prototype, "isEmpty", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.map.size === 0; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    _DuplicateMap.prototype.clear = /**
	     * @return {?}
	     */
	    function () { this.map.clear(); };
	    return _DuplicateMap;
	}());
	/**
	 * @param {?} item
	 * @param {?} addRemoveOffset
	 * @param {?} moveOffsets
	 * @return {?}
	 */
	function getPreviousIndex(item, addRemoveOffset, moveOffsets) {
	    var /** @type {?} */ previousIndex = item.previousIndex;
	    if (previousIndex === null)
	        return previousIndex;
	    var /** @type {?} */ moveOffset = 0;
	    if (moveOffsets && previousIndex < moveOffsets.length) {
	        moveOffset = moveOffsets[previousIndex];
	    }
	    return previousIndex + addRemoveOffset + moveOffset;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @template K, V
	 */
	var DefaultKeyValueDifferFactory = /** @class */ (function () {
	    function DefaultKeyValueDifferFactory() {
	    }
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    DefaultKeyValueDifferFactory.prototype.supports = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) { return obj instanceof Map || isJsObject(obj); };
	    /**
	     * @template K, V
	     * @return {?}
	     */
	    DefaultKeyValueDifferFactory.prototype.create = /**
	     * @template K, V
	     * @return {?}
	     */
	    function () { return new DefaultKeyValueDiffer(); };
	    return DefaultKeyValueDifferFactory;
	}());
	/**
	 * @template K, V
	 */
	var DefaultKeyValueDiffer = /** @class */ (function () {
	    function DefaultKeyValueDiffer() {
	        this._records = new Map();
	        this._mapHead = null;
	        this._appendAfter = null;
	        this._previousMapHead = null;
	        this._changesHead = null;
	        this._changesTail = null;
	        this._additionsHead = null;
	        this._additionsTail = null;
	        this._removalsHead = null;
	        this._removalsTail = null;
	    }
	    Object.defineProperty(DefaultKeyValueDiffer.prototype, "isDirty", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._additionsHead !== null || this._changesHead !== null ||
	                this._removalsHead !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.forEachItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._mapHead; record !== null; record = record._next) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.forEachPreviousItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.forEachChangedItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._changesHead; record !== null; record = record._nextChanged) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.forEachAddedItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.forEachRemovedItem = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var /** @type {?} */ record;
	        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
	            fn(record);
	        }
	    };
	    /**
	     * @param {?=} map
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.diff = /**
	     * @param {?=} map
	     * @return {?}
	     */
	    function (map) {
	        if (!map) {
	            map = new Map();
	        }
	        else if (!(map instanceof Map || isJsObject(map))) {
	            throw new Error("Error trying to diff '" + stringify(map) + "'. Only maps and objects are allowed");
	        }
	        return this.check(map) ? this : null;
	    };
	    /**
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.onDestroy = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * Check the current state of the map vs the previous.
	     * The algorithm is optimised for when the keys do no change.
	     */
	    /**
	     * Check the current state of the map vs the previous.
	     * The algorithm is optimised for when the keys do no change.
	     * @param {?} map
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype.check = /**
	     * Check the current state of the map vs the previous.
	     * The algorithm is optimised for when the keys do no change.
	     * @param {?} map
	     * @return {?}
	     */
	    function (map) {
	        var _this = this;
	        this._reset();
	        var /** @type {?} */ insertBefore = this._mapHead;
	        this._appendAfter = null;
	        this._forEach(map, function (value, key) {
	            if (insertBefore && insertBefore.key === key) {
	                _this._maybeAddToChanges(insertBefore, value);
	                _this._appendAfter = insertBefore;
	                insertBefore = insertBefore._next;
	            }
	            else {
	                var /** @type {?} */ record = _this._getOrCreateRecordForKey(key, value);
	                insertBefore = _this._insertBeforeOrAppend(insertBefore, record);
	            }
	        });
	        // Items remaining at the end of the list have been deleted
	        if (insertBefore) {
	            if (insertBefore._prev) {
	                insertBefore._prev._next = null;
	            }
	            this._removalsHead = insertBefore;
	            for (var /** @type {?} */ record = insertBefore; record !== null; record = record._nextRemoved) {
	                if (record === this._mapHead) {
	                    this._mapHead = null;
	                }
	                this._records.delete(record.key);
	                record._nextRemoved = record._next;
	                record.previousValue = record.currentValue;
	                record.currentValue = null;
	                record._prev = null;
	                record._next = null;
	            }
	        }
	        // Make sure tails have no next records from previous runs
	        if (this._changesTail)
	            this._changesTail._nextChanged = null;
	        if (this._additionsTail)
	            this._additionsTail._nextAdded = null;
	        return this.isDirty;
	    };
	    /**
	     * Inserts a record before `before` or append at the end of the list when `before` is null.
	     *
	     * Notes:
	     * - This method appends at `this._appendAfter`,
	     * - This method updates `this._appendAfter`,
	     * - The return value is the new value for the insertion pointer.
	     * @param {?} before
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._insertBeforeOrAppend = /**
	     * Inserts a record before `before` or append at the end of the list when `before` is null.
	     *
	     * Notes:
	     * - This method appends at `this._appendAfter`,
	     * - This method updates `this._appendAfter`,
	     * - The return value is the new value for the insertion pointer.
	     * @param {?} before
	     * @param {?} record
	     * @return {?}
	     */
	    function (before, record) {
	        if (before) {
	            var /** @type {?} */ prev = before._prev;
	            record._next = before;
	            record._prev = prev;
	            before._prev = record;
	            if (prev) {
	                prev._next = record;
	            }
	            if (before === this._mapHead) {
	                this._mapHead = record;
	            }
	            this._appendAfter = before;
	            return before;
	        }
	        if (this._appendAfter) {
	            this._appendAfter._next = record;
	            record._prev = this._appendAfter;
	        }
	        else {
	            this._mapHead = record;
	        }
	        this._appendAfter = record;
	        return null;
	    };
	    /**
	     * @param {?} key
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._getOrCreateRecordForKey = /**
	     * @param {?} key
	     * @param {?} value
	     * @return {?}
	     */
	    function (key, value) {
	        if (this._records.has(key)) {
	            var /** @type {?} */ record_1 = /** @type {?} */ ((this._records.get(key)));
	            this._maybeAddToChanges(record_1, value);
	            var /** @type {?} */ prev = record_1._prev;
	            var /** @type {?} */ next = record_1._next;
	            if (prev) {
	                prev._next = next;
	            }
	            if (next) {
	                next._prev = prev;
	            }
	            record_1._next = null;
	            record_1._prev = null;
	            return record_1;
	        }
	        var /** @type {?} */ record = new KeyValueChangeRecord_(key);
	        this._records.set(key, record);
	        record.currentValue = value;
	        this._addToAdditions(record);
	        return record;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._reset = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        if (this.isDirty) {
	            var /** @type {?} */ record = void 0;
	            // let `_previousMapHead` contain the state of the map before the changes
	            this._previousMapHead = this._mapHead;
	            for (record = this._previousMapHead; record !== null; record = record._next) {
	                record._nextPrevious = record._next;
	            }
	            // Update `record.previousValue` with the value of the item before the changes
	            // We need to update all changed items (that's those which have been added and changed)
	            for (record = this._changesHead; record !== null; record = record._nextChanged) {
	                record.previousValue = record.currentValue;
	            }
	            for (record = this._additionsHead; record != null; record = record._nextAdded) {
	                record.previousValue = record.currentValue;
	            }
	            this._changesHead = this._changesTail = null;
	            this._additionsHead = this._additionsTail = null;
	            this._removalsHead = null;
	        }
	    };
	    /**
	     * @param {?} record
	     * @param {?} newValue
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._maybeAddToChanges = /**
	     * @param {?} record
	     * @param {?} newValue
	     * @return {?}
	     */
	    function (record, newValue) {
	        if (!looseIdentical(newValue, record.currentValue)) {
	            record.previousValue = record.currentValue;
	            record.currentValue = newValue;
	            this._addToChanges(record);
	        }
	    };
	    /**
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._addToAdditions = /**
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        if (this._additionsHead === null) {
	            this._additionsHead = this._additionsTail = record;
	        }
	        else {
	            /** @type {?} */ ((this._additionsTail))._nextAdded = record;
	            this._additionsTail = record;
	        }
	    };
	    /**
	     * @param {?} record
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._addToChanges = /**
	     * @param {?} record
	     * @return {?}
	     */
	    function (record) {
	        if (this._changesHead === null) {
	            this._changesHead = this._changesTail = record;
	        }
	        else {
	            /** @type {?} */ ((this._changesTail))._nextChanged = record;
	            this._changesTail = record;
	        }
	    };
	    /**
	     * \@internal
	     * @template K, V
	     * @param {?} obj
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultKeyValueDiffer.prototype._forEach = /**
	     * \@internal
	     * @template K, V
	     * @param {?} obj
	     * @param {?} fn
	     * @return {?}
	     */
	    function (obj, fn) {
	        if (obj instanceof Map) {
	            obj.forEach(fn);
	        }
	        else {
	            Object.keys(obj).forEach(function (k) { return fn(obj[k], k); });
	        }
	    };
	    return DefaultKeyValueDiffer;
	}());
	/**
	 * \@stable
	 * @template K, V
	 */
	var KeyValueChangeRecord_ = /** @class */ (function () {
	    function KeyValueChangeRecord_(key) {
	        this.key = key;
	        this.previousValue = null;
	        this.currentValue = null;
	        /**
	         * \@internal
	         */
	        this._nextPrevious = null;
	        /**
	         * \@internal
	         */
	        this._next = null;
	        /**
	         * \@internal
	         */
	        this._prev = null;
	        /**
	         * \@internal
	         */
	        this._nextAdded = null;
	        /**
	         * \@internal
	         */
	        this._nextRemoved = null;
	        /**
	         * \@internal
	         */
	        this._nextChanged = null;
	    }
	    return KeyValueChangeRecord_;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A strategy for tracking changes over time to an iterable. Used by {\@link NgForOf} to
	 * respond to changes in an iterable by effecting equivalent changes in the DOM.
	 *
	 * \@stable
	 * @record
	 * @template V
	 */
	
	/**
	 * An object describing the changes in the `Iterable` collection since last time
	 * `IterableDiffer#diff()` was invoked.
	 *
	 * \@stable
	 * @record
	 * @template V
	 */
	
	/**
	 * Record representing the item change information.
	 *
	 * \@stable
	 * @record
	 * @template V
	 */
	
	/**
	 * @deprecated v4.0.0 - Use IterableChangeRecord instead.
	 * @record
	 * @template V
	 */
	
	/**
	 * An optional function passed into {\@link NgForOf} that defines how to track
	 * items in an iterable (e.g. fby index or id)
	 *
	 * \@stable
	 * @record
	 * @template T
	 */
	
	/**
	 * Provides a factory for {\@link IterableDiffer}.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * A repository of different iterable diffing strategies used by NgFor, NgClass, and others.
	 * \@stable
	 */
	var IterableDiffers = /** @class */ (function () {
	    function IterableDiffers(factories) {
	        this.factories = factories;
	    }
	    /**
	     * @param {?} factories
	     * @param {?=} parent
	     * @return {?}
	     */
	    IterableDiffers.create = /**
	     * @param {?} factories
	     * @param {?=} parent
	     * @return {?}
	     */
	    function (factories, parent) {
	        if (parent != null) {
	            var /** @type {?} */ copied = parent.factories.slice();
	            factories = factories.concat(copied);
	            return new IterableDiffers(factories);
	        }
	        else {
	            return new IterableDiffers(factories);
	        }
	    };
	    /**
	     * Takes an array of {@link IterableDifferFactory} and returns a provider used to extend the
	     * inherited {@link IterableDiffers} instance with the provided factories and return a new
	     * {@link IterableDiffers} instance.
	     *
	     * The following example shows how to extend an existing list of factories,
	     * which will only be applied to the injector for this component and its children.
	     * This step is all that's required to make a new {@link IterableDiffer} available.
	     *
	     * ### Example
	     *
	     * ```
	     * @Component({
	     *   viewProviders: [
	     *     IterableDiffers.extend([new ImmutableListDiffer()])
	     *   ]
	     * })
	     * ```
	     */
	    /**
	     * Takes an array of {\@link IterableDifferFactory} and returns a provider used to extend the
	     * inherited {\@link IterableDiffers} instance with the provided factories and return a new
	     * {\@link IterableDiffers} instance.
	     *
	     * The following example shows how to extend an existing list of factories,
	     * which will only be applied to the injector for this component and its children.
	     * This step is all that's required to make a new {\@link IterableDiffer} available.
	     *
	     * ### Example
	     *
	     * ```
	     * \@Component({
	     *   viewProviders: [
	     *     IterableDiffers.extend([new ImmutableListDiffer()])
	     *   ]
	     * })
	     * ```
	     * @param {?} factories
	     * @return {?}
	     */
	    IterableDiffers.extend = /**
	     * Takes an array of {\@link IterableDifferFactory} and returns a provider used to extend the
	     * inherited {\@link IterableDiffers} instance with the provided factories and return a new
	     * {\@link IterableDiffers} instance.
	     *
	     * The following example shows how to extend an existing list of factories,
	     * which will only be applied to the injector for this component and its children.
	     * This step is all that's required to make a new {\@link IterableDiffer} available.
	     *
	     * ### Example
	     *
	     * ```
	     * \@Component({
	     *   viewProviders: [
	     *     IterableDiffers.extend([new ImmutableListDiffer()])
	     *   ]
	     * })
	     * ```
	     * @param {?} factories
	     * @return {?}
	     */
	    function (factories) {
	        return {
	            provide: IterableDiffers,
	            useFactory: function (parent) {
	                if (!parent) {
	                    // Typically would occur when calling IterableDiffers.extend inside of dependencies passed
	                    // to
	                    // bootstrap(), which would override default pipes instead of extending them.
	                    throw new Error('Cannot extend IterableDiffers without a parent injector');
	                }
	                return IterableDiffers.create(factories, parent);
	            },
	            // Dependency technically isn't optional, but we can provide a better error message this way.
	            deps: [[IterableDiffers, new SkipSelf(), new Optional()]]
	        };
	    };
	    /**
	     * @param {?} iterable
	     * @return {?}
	     */
	    IterableDiffers.prototype.find = /**
	     * @param {?} iterable
	     * @return {?}
	     */
	    function (iterable) {
	        var /** @type {?} */ factory = this.factories.find(function (f) { return f.supports(iterable); });
	        if (factory != null) {
	            return factory;
	        }
	        else {
	            throw new Error("Cannot find a differ supporting object '" + iterable + "' of type '" + getTypeNameForDebugging(iterable) + "'");
	        }
	    };
	    return IterableDiffers;
	}());
	/**
	 * @param {?} type
	 * @return {?}
	 */
	function getTypeNameForDebugging(type) {
	    return type['name'] || typeof type;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A differ that tracks changes made to an object over time.
	 *
	 * \@stable
	 * @record
	 * @template K, V
	 */
	
	/**
	 * An object describing the changes in the `Map` or `{[k:string]: string}` since last time
	 * `KeyValueDiffer#diff()` was invoked.
	 *
	 * \@stable
	 * @record
	 * @template K, V
	 */
	
	/**
	 * Record representing the item change information.
	 *
	 * \@stable
	 * @record
	 * @template K, V
	 */
	
	/**
	 * Provides a factory for {\@link KeyValueDiffer}.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * A repository of different Map diffing strategies used by NgClass, NgStyle, and others.
	 * \@stable
	 */
	var KeyValueDiffers = /** @class */ (function () {
	    function KeyValueDiffers(factories) {
	        this.factories = factories;
	    }
	    /**
	     * @template S
	     * @param {?} factories
	     * @param {?=} parent
	     * @return {?}
	     */
	    KeyValueDiffers.create = /**
	     * @template S
	     * @param {?} factories
	     * @param {?=} parent
	     * @return {?}
	     */
	    function (factories, parent) {
	        if (parent) {
	            var /** @type {?} */ copied = parent.factories.slice();
	            factories = factories.concat(copied);
	        }
	        return new KeyValueDiffers(factories);
	    };
	    /**
	     * Takes an array of {@link KeyValueDifferFactory} and returns a provider used to extend the
	     * inherited {@link KeyValueDiffers} instance with the provided factories and return a new
	     * {@link KeyValueDiffers} instance.
	     *
	     * The following example shows how to extend an existing list of factories,
	     * which will only be applied to the injector for this component and its children.
	     * This step is all that's required to make a new {@link KeyValueDiffer} available.
	     *
	     * ### Example
	     *
	     * ```
	     * @Component({
	     *   viewProviders: [
	     *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
	     *   ]
	     * })
	     * ```
	     */
	    /**
	     * Takes an array of {\@link KeyValueDifferFactory} and returns a provider used to extend the
	     * inherited {\@link KeyValueDiffers} instance with the provided factories and return a new
	     * {\@link KeyValueDiffers} instance.
	     *
	     * The following example shows how to extend an existing list of factories,
	     * which will only be applied to the injector for this component and its children.
	     * This step is all that's required to make a new {\@link KeyValueDiffer} available.
	     *
	     * ### Example
	     *
	     * ```
	     * \@Component({
	     *   viewProviders: [
	     *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
	     *   ]
	     * })
	     * ```
	     * @template S
	     * @param {?} factories
	     * @return {?}
	     */
	    KeyValueDiffers.extend = /**
	     * Takes an array of {\@link KeyValueDifferFactory} and returns a provider used to extend the
	     * inherited {\@link KeyValueDiffers} instance with the provided factories and return a new
	     * {\@link KeyValueDiffers} instance.
	     *
	     * The following example shows how to extend an existing list of factories,
	     * which will only be applied to the injector for this component and its children.
	     * This step is all that's required to make a new {\@link KeyValueDiffer} available.
	     *
	     * ### Example
	     *
	     * ```
	     * \@Component({
	     *   viewProviders: [
	     *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
	     *   ]
	     * })
	     * ```
	     * @template S
	     * @param {?} factories
	     * @return {?}
	     */
	    function (factories) {
	        return {
	            provide: KeyValueDiffers,
	            useFactory: function (parent) {
	                if (!parent) {
	                    // Typically would occur when calling KeyValueDiffers.extend inside of dependencies passed
	                    // to bootstrap(), which would override default pipes instead of extending them.
	                    throw new Error('Cannot extend KeyValueDiffers without a parent injector');
	                }
	                return KeyValueDiffers.create(factories, parent);
	            },
	            // Dependency technically isn't optional, but we can provide a better error message this way.
	            deps: [[KeyValueDiffers, new SkipSelf(), new Optional()]]
	        };
	    };
	    /**
	     * @param {?} kv
	     * @return {?}
	     */
	    KeyValueDiffers.prototype.find = /**
	     * @param {?} kv
	     * @return {?}
	     */
	    function (kv) {
	        var /** @type {?} */ factory = this.factories.find(function (f) { return f.supports(kv); });
	        if (factory) {
	            return factory;
	        }
	        throw new Error("Cannot find a differ supporting object '" + kv + "'");
	    };
	    return KeyValueDiffers;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Structural diffing for `Object`s and `Map`s.
	 */
	var keyValDiff = [new DefaultKeyValueDifferFactory()];
	/**
	 * Structural diffing for `Iterable` types such as `Array`s.
	 */
	var iterableDiff = [new DefaultIterableDifferFactory()];
	var defaultIterableDiffers = new IterableDiffers(iterableDiff);
	var defaultKeyValueDiffers = new KeyValueDiffers(keyValDiff);
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _CORE_PLATFORM_PROVIDERS = [
	    // Set a default platform name for platforms that don't set it explicitly.
	    { provide: PLATFORM_ID, useValue: 'unknown' },
	    { provide: PlatformRef, deps: [Injector] },
	    { provide: TestabilityRegistry, deps: [] },
	    { provide: Console, deps: [] },
	];
	/**
	 * This platform has to be included in any other platform
	 *
	 * \@experimental
	 */
	var platformCore = createPlatformFactory(null, 'core', _CORE_PLATFORM_PROVIDERS);
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Provide this token to set the locale of your application.
	 * It is used for i18n extraction, by i18n pipes (DatePipe, I18nPluralPipe, CurrencyPipe,
	 * DecimalPipe and PercentPipe) and by ICU expressions.
	 *
	 * See the {\@linkDocs guide/i18n#setting-up-locale i18n guide} for more information.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * import { LOCALE_ID } from '\@angular/core';
	 * import { platformBrowserDynamic } from '\@angular/platform-browser-dynamic';
	 * import { AppModule } from './app/app.module';
	 *
	 * platformBrowserDynamic().bootstrapModule(AppModule, {
	 *   providers: [{provide: LOCALE_ID, useValue: 'en-US' }]
	 * });
	 * ```
	 *
	 * \@experimental i18n support is experimental.
	 */
	var LOCALE_ID = new InjectionToken('LocaleId');
	/**
	 * Use this token at bootstrap to provide the content of your translation file (`xtb`,
	 * `xlf` or `xlf2`) when you want to translate your application in another language.
	 *
	 * See the {\@linkDocs guide/i18n#merge i18n guide} for more information.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * import { TRANSLATIONS } from '\@angular/core';
	 * import { platformBrowserDynamic } from '\@angular/platform-browser-dynamic';
	 * import { AppModule } from './app/app.module';
	 *
	 * // content of your translation file
	 * const translations = '....';
	 *
	 * platformBrowserDynamic().bootstrapModule(AppModule, {
	 *   providers: [{provide: TRANSLATIONS, useValue: translations }]
	 * });
	 * ```
	 *
	 * \@experimental i18n support is experimental.
	 */
	var TRANSLATIONS = new InjectionToken('Translations');
	/**
	 * Provide this token at bootstrap to set the format of your {\@link TRANSLATIONS}: `xtb`,
	 * `xlf` or `xlf2`.
	 *
	 * See the {\@linkDocs guide/i18n#merge i18n guide} for more information.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * import { TRANSLATIONS_FORMAT } from '\@angular/core';
	 * import { platformBrowserDynamic } from '\@angular/platform-browser-dynamic';
	 * import { AppModule } from './app/app.module';
	 *
	 * platformBrowserDynamic().bootstrapModule(AppModule, {
	 *   providers: [{provide: TRANSLATIONS_FORMAT, useValue: 'xlf' }]
	 * });
	 * ```
	 *
	 * \@experimental i18n support is experimental.
	 */
	var TRANSLATIONS_FORMAT = new InjectionToken('TranslationsFormat');
	/** @enum {number} */
	var MissingTranslationStrategy = {
	    Error: 0,
	    Warning: 1,
	    Ignore: 2,
	};
	MissingTranslationStrategy[MissingTranslationStrategy.Error] = "Error";
	MissingTranslationStrategy[MissingTranslationStrategy.Warning] = "Warning";
	MissingTranslationStrategy[MissingTranslationStrategy.Ignore] = "Ignore";
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @return {?}
	 */
	function _iterableDiffersFactory() {
	    return defaultIterableDiffers;
	}
	/**
	 * @return {?}
	 */
	function _keyValueDiffersFactory() {
	    return defaultKeyValueDiffers;
	}
	/**
	 * @param {?=} locale
	 * @return {?}
	 */
	function _localeFactory(locale) {
	    return locale || 'en-US';
	}
	/**
	 * This module includes the providers of \@angular/core that are needed
	 * to bootstrap components via `ApplicationRef`.
	 *
	 * \@experimental
	 */
	var ApplicationModule = /** @class */ (function () {
	    // Inject ApplicationRef to make it eager...
	    function ApplicationModule(appRef) {
	    }
	    ApplicationModule.decorators = [
	        { type: NgModule, args: [{
	                    providers: [
	                        ApplicationRef,
	                        ApplicationInitStatus,
	                        Compiler,
	                        APP_ID_RANDOM_PROVIDER,
	                        { provide: IterableDiffers, useFactory: _iterableDiffersFactory },
	                        { provide: KeyValueDiffers, useFactory: _keyValueDiffersFactory },
	                        {
	                            provide: LOCALE_ID,
	                            useFactory: _localeFactory,
	                            deps: [[new Inject(LOCALE_ID), new Optional(), new SkipSelf()]]
	                        },
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    ApplicationModule.ctorParameters = function () { return [
	        { type: ApplicationRef, },
	    ]; };
	    return ApplicationModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var SecurityContext = {
	    NONE: 0,
	    HTML: 1,
	    STYLE: 2,
	    SCRIPT: 3,
	    URL: 4,
	    RESOURCE_URL: 5,
	};
	SecurityContext[SecurityContext.NONE] = "NONE";
	SecurityContext[SecurityContext.HTML] = "HTML";
	SecurityContext[SecurityContext.STYLE] = "STYLE";
	SecurityContext[SecurityContext.SCRIPT] = "SCRIPT";
	SecurityContext[SecurityContext.URL] = "URL";
	SecurityContext[SecurityContext.RESOURCE_URL] = "RESOURCE_URL";
	/**
	 * Sanitizer is used by the views to sanitize potentially dangerous values.
	 *
	 * \@stable
	 * @abstract
	 */
	var Sanitizer = /** @class */ (function () {
	    function Sanitizer() {
	    }
	    return Sanitizer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// unsupported: template constraints.
	/**
	 * Factory for ViewDefinitions/NgModuleDefinitions.
	 * We use a function so we can reexeute it in case an error happens and use the given logger
	 * function to log the error from the definition of the node, which is shown in all browser
	 * logs.
	 * @record
	 * @template D
	 */
	
	/**
	 * Function to call console.error at the right source location. This is an indirection
	 * via another function as browser will log the location that actually called
	 * `console.error`.
	 * @record
	 */
	
	// unsupported: template constraints.
	/**
	 * @record
	 * @template DF
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * A node definition in the view.
	 *
	 * Note: We use one type for all nodes so that loops that loop over all nodes
	 * of a ViewDefinition stay monomorphic!
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * View instance data.
	 * Attention: Adding fields to this is performance sensitive!
	 * @record
	 */
	
	/**
	 * @param {?} view
	 * @param {?} priorInitState
	 * @param {?} newInitState
	 * @return {?}
	 */
	function shiftInitState(view, priorInitState, newInitState) {
	    // Only update the InitState if we are currently in the prior state.
	    // For example, only move into CallingInit if we are in BeforeInit. Only
	    // move into CallingContentInit if we are in CallingInit. Normally this will
	    // always be true because of how checkCycle is called in checkAndUpdateView.
	    // However, if checkAndUpdateView is called recursively or if an exception is
	    // thrown while checkAndUpdateView is running, checkAndUpdateView starts over
	    // from the beginning. This ensures the state is monotonically increasing,
	    // terminating in the AfterInit state, which ensures the Init methods are called
	    // at least once and only once.
	    var /** @type {?} */ state = view.state;
	    var /** @type {?} */ initState = state & 1792;
	    if (initState === priorInitState) {
	        view.state = (state & ~1792 /* InitState_Mask */) | newInitState;
	        view.initIndex = -1;
	        return true;
	    }
	    return initState === newInitState;
	}
	/**
	 * @param {?} view
	 * @param {?} initState
	 * @param {?} index
	 * @return {?}
	 */
	function shouldCallLifecycleInitHook(view, initState, index) {
	    if ((view.state & 1792 /* InitState_Mask */) === initState && view.initIndex <= index) {
	        view.initIndex = index + 1;
	        return true;
	    }
	    return false;
	}
	/**
	 * @record
	 */
	
	/**
	 * Data for an instantiated NodeType.Text.
	 *
	 * Attention: Adding fields to this is performance sensitive!
	 * @record
	 */
	
	/**
	 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
	 * @param {?} view
	 * @param {?} index
	 * @return {?}
	 */
	function asTextData(view, index) {
	    return /** @type {?} */ (view.nodes[index]);
	}
	/**
	 * Data for an instantiated NodeType.Element.
	 *
	 * Attention: Adding fields to this is performance sensitive!
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
	 * @param {?} view
	 * @param {?} index
	 * @return {?}
	 */
	function asElementData(view, index) {
	    return /** @type {?} */ (view.nodes[index]);
	}
	/**
	 * Data for an instantiated NodeType.Provider.
	 *
	 * Attention: Adding fields to this is performance sensitive!
	 * @record
	 */
	
	/**
	 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
	 * @param {?} view
	 * @param {?} index
	 * @return {?}
	 */
	function asProviderData(view, index) {
	    return /** @type {?} */ (view.nodes[index]);
	}
	/**
	 * Data for an instantiated NodeType.PureExpression.
	 *
	 * Attention: Adding fields to this is performance sensitive!
	 * @record
	 */
	
	/**
	 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
	 * @param {?} view
	 * @param {?} index
	 * @return {?}
	 */
	function asPureExpressionData(view, index) {
	    return /** @type {?} */ (view.nodes[index]);
	}
	/**
	 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
	 * @param {?} view
	 * @param {?} index
	 * @return {?}
	 */
	function asQueryList(view, index) {
	    return /** @type {?} */ (view.nodes[index]);
	}
	/**
	 * @record
	 */
	
	/**
	 * @abstract
	 */
	var DebugContext = /** @class */ (function () {
	    function DebugContext() {
	    }
	    return DebugContext;
	}());
	/**
	 * @record
	 */
	
	/**
	 * This object is used to prevent cycles in the source files and to have a place where
	 * debug mode can hook it. It is lazily filled when `isDevMode` is known.
	 */
	var Services = {
	    setCurrentNode: /** @type {?} */ ((undefined)),
	    createRootView: /** @type {?} */ ((undefined)),
	    createEmbeddedView: /** @type {?} */ ((undefined)),
	    createComponentView: /** @type {?} */ ((undefined)),
	    createNgModuleRef: /** @type {?} */ ((undefined)),
	    overrideProvider: /** @type {?} */ ((undefined)),
	    overrideComponentView: /** @type {?} */ ((undefined)),
	    clearOverrides: /** @type {?} */ ((undefined)),
	    checkAndUpdateView: /** @type {?} */ ((undefined)),
	    checkNoChangesView: /** @type {?} */ ((undefined)),
	    destroyView: /** @type {?} */ ((undefined)),
	    resolveDep: /** @type {?} */ ((undefined)),
	    createDebugContext: /** @type {?} */ ((undefined)),
	    handleEvent: /** @type {?} */ ((undefined)),
	    updateDirectives: /** @type {?} */ ((undefined)),
	    updateRenderer: /** @type {?} */ ((undefined)),
	    dirtyParentQueries: /** @type {?} */ ((undefined)),
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} context
	 * @param {?} oldValue
	 * @param {?} currValue
	 * @param {?} isFirstCheck
	 * @return {?}
	 */
	function expressionChangedAfterItHasBeenCheckedError(context, oldValue, currValue, isFirstCheck) {
	    var /** @type {?} */ msg = "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
	    if (isFirstCheck) {
	        msg +=
	            " It seems like the view has been created after its parent and its children have been dirty checked." +
	                " Has it been created in a change detection hook ?";
	    }
	    return viewDebugError(msg, context);
	}
	/**
	 * @param {?} err
	 * @param {?} context
	 * @return {?}
	 */
	function viewWrappedDebugError(err, context) {
	    if (!(err instanceof Error)) {
	        // errors that are not Error instances don't have a stack,
	        // so it is ok to wrap them into a new Error object...
	        err = new Error(err.toString());
	    }
	    _addDebugContext(err, context);
	    return err;
	}
	/**
	 * @param {?} msg
	 * @param {?} context
	 * @return {?}
	 */
	function viewDebugError(msg, context) {
	    var /** @type {?} */ err = new Error(msg);
	    _addDebugContext(err, context);
	    return err;
	}
	/**
	 * @param {?} err
	 * @param {?} context
	 * @return {?}
	 */
	function _addDebugContext(err, context) {
	    (/** @type {?} */ (err))[ERROR_DEBUG_CONTEXT] = context;
	    (/** @type {?} */ (err))[ERROR_LOGGER] = context.logError.bind(context);
	}
	/**
	 * @param {?} err
	 * @return {?}
	 */
	function isViewDebugError(err) {
	    return !!getDebugContext(err);
	}
	/**
	 * @param {?} action
	 * @return {?}
	 */
	function viewDestroyedError(action) {
	    return new Error("ViewDestroyedError: Attempt to use a destroyed view: " + action);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NOOP = function () { };
	var _tokenKeyCache = new Map();
	/**
	 * @param {?} token
	 * @return {?}
	 */
	function tokenKey(token) {
	    var /** @type {?} */ key = _tokenKeyCache.get(token);
	    if (!key) {
	        key = stringify(token) + '_' + _tokenKeyCache.size;
	        _tokenKeyCache.set(token, key);
	    }
	    return key;
	}
	/**
	 * @param {?} view
	 * @param {?} nodeIdx
	 * @param {?} bindingIdx
	 * @param {?} value
	 * @return {?}
	 */
	function unwrapValue(view, nodeIdx, bindingIdx, value) {
	    if (WrappedValue.isWrapped(value)) {
	        value = WrappedValue.unwrap(value);
	        var /** @type {?} */ globalBindingIdx = view.def.nodes[nodeIdx].bindingIndex + bindingIdx;
	        var /** @type {?} */ oldValue = WrappedValue.unwrap(view.oldValues[globalBindingIdx]);
	        view.oldValues[globalBindingIdx] = new WrappedValue(oldValue);
	    }
	    return value;
	}
	var UNDEFINED_RENDERER_TYPE_ID = '$$undefined';
	var EMPTY_RENDERER_TYPE_ID = '$$empty';
	/**
	 * @param {?} values
	 * @return {?}
	 */
	function createRendererType2(values) {
	    return {
	        id: UNDEFINED_RENDERER_TYPE_ID,
	        styles: values.styles,
	        encapsulation: values.encapsulation,
	        data: values.data
	    };
	}
	var _renderCompCount = 0;
	/**
	 * @param {?=} type
	 * @return {?}
	 */
	function resolveRendererType2(type) {
	    if (type && type.id === UNDEFINED_RENDERER_TYPE_ID) {
	        // first time we see this RendererType2. Initialize it...
	        var /** @type {?} */ isFilled = ((type.encapsulation != null && type.encapsulation !== ViewEncapsulation.None) ||
	            type.styles.length || Object.keys(type.data).length);
	        if (isFilled) {
	            type.id = "c" + _renderCompCount++;
	        }
	        else {
	            type.id = EMPTY_RENDERER_TYPE_ID;
	        }
	    }
	    if (type && type.id === EMPTY_RENDERER_TYPE_ID) {
	        type = null;
	    }
	    return type || null;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} bindingIdx
	 * @param {?} value
	 * @return {?}
	 */
	function checkBinding(view, def, bindingIdx, value) {
	    var /** @type {?} */ oldValues = view.oldValues;
	    if ((view.state & 2 /* FirstCheck */) ||
	        !looseIdentical(oldValues[def.bindingIndex + bindingIdx], value)) {
	        return true;
	    }
	    return false;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} bindingIdx
	 * @param {?} value
	 * @return {?}
	 */
	function checkAndUpdateBinding(view, def, bindingIdx, value) {
	    if (checkBinding(view, def, bindingIdx, value)) {
	        view.oldValues[def.bindingIndex + bindingIdx] = value;
	        return true;
	    }
	    return false;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} bindingIdx
	 * @param {?} value
	 * @return {?}
	 */
	function checkBindingNoChanges(view, def, bindingIdx, value) {
	    var /** @type {?} */ oldValue = view.oldValues[def.bindingIndex + bindingIdx];
	    if ((view.state & 1 /* BeforeFirstCheck */) || !devModeEqual(oldValue, value)) {
	        var /** @type {?} */ bindingName = def.bindings[bindingIdx].name;
	        throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, def.nodeIndex), bindingName + ": " + oldValue, bindingName + ": " + value, (view.state & 1 /* BeforeFirstCheck */) !== 0);
	    }
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function markParentViewsForCheck(view) {
	    var /** @type {?} */ currView = view;
	    while (currView) {
	        if (currView.def.flags & 2 /* OnPush */) {
	            currView.state |= 8 /* ChecksEnabled */;
	        }
	        currView = currView.viewContainerParent || currView.parent;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} endView
	 * @return {?}
	 */
	function markParentViewsForCheckProjectedViews(view, endView) {
	    var /** @type {?} */ currView = view;
	    while (currView && currView !== endView) {
	        currView.state |= 64 /* CheckProjectedViews */;
	        currView = currView.viewContainerParent || currView.parent;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeIndex
	 * @param {?} eventName
	 * @param {?} event
	 * @return {?}
	 */
	function dispatchEvent(view, nodeIndex, eventName, event) {
	    try {
	        var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
	        var /** @type {?} */ startView = nodeDef.flags & 33554432 /* ComponentView */ ?
	            asElementData(view, nodeIndex).componentView :
	            view;
	        markParentViewsForCheck(startView);
	        return Services.handleEvent(view, nodeIndex, eventName, event);
	    }
	    catch (/** @type {?} */ e) {
	        // Attention: Don't rethrow, as it would cancel Observable subscriptions!
	        view.root.errorHandler.handleError(e);
	    }
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function declaredViewContainer(view) {
	    if (view.parent) {
	        var /** @type {?} */ parentView = view.parent;
	        return asElementData(parentView, /** @type {?} */ ((view.parentNodeDef)).nodeIndex);
	    }
	    return null;
	}
	/**
	 * for component views, this is the host element.
	 * for embedded views, this is the index of the parent node
	 * that contains the view container.
	 * @param {?} view
	 * @return {?}
	 */
	function viewParentEl(view) {
	    var /** @type {?} */ parentView = view.parent;
	    if (parentView) {
	        return /** @type {?} */ ((view.parentNodeDef)).parent;
	    }
	    else {
	        return null;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function renderNode(view, def) {
	    switch (def.flags & 201347067 /* Types */) {
	        case 1 /* TypeElement */:
	            return asElementData(view, def.nodeIndex).renderElement;
	        case 2 /* TypeText */:
	            return asTextData(view, def.nodeIndex).renderText;
	    }
	}
	/**
	 * @param {?} target
	 * @param {?} name
	 * @return {?}
	 */
	function elementEventFullName(target, name) {
	    return target ? target + ":" + name : name;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function isComponentView(view) {
	    return !!view.parent && !!(/** @type {?} */ ((view.parentNodeDef)).flags & 32768 /* Component */);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function isEmbeddedView(view) {
	    return !!view.parent && !(/** @type {?} */ ((view.parentNodeDef)).flags & 32768 /* Component */);
	}
	/**
	 * @param {?} queryId
	 * @return {?}
	 */
	function filterQueryId(queryId) {
	    return 1 << (queryId % 32);
	}
	/**
	 * @param {?} matchedQueriesDsl
	 * @return {?}
	 */
	function splitMatchedQueriesDsl(matchedQueriesDsl) {
	    var /** @type {?} */ matchedQueries = {};
	    var /** @type {?} */ matchedQueryIds = 0;
	    var /** @type {?} */ references = {};
	    if (matchedQueriesDsl) {
	        matchedQueriesDsl.forEach(function (_a) {
	            var queryId = _a[0], valueType = _a[1];
	            if (typeof queryId === 'number') {
	                matchedQueries[queryId] = valueType;
	                matchedQueryIds |= filterQueryId(queryId);
	            }
	            else {
	                references[queryId] = valueType;
	            }
	        });
	    }
	    return { matchedQueries: matchedQueries, references: references, matchedQueryIds: matchedQueryIds };
	}
	/**
	 * @param {?} deps
	 * @param {?=} sourceName
	 * @return {?}
	 */
	function splitDepsDsl(deps, sourceName) {
	    return deps.map(function (value) {
	        var /** @type {?} */ token;
	        var /** @type {?} */ flags;
	        if (Array.isArray(value)) {
	            flags = value[0], token = value[1];
	        }
	        else {
	            flags = 0 /* None */;
	            token = value;
	        }
	        if (token && (typeof token === 'function' || typeof token === 'object') && sourceName) {
	            Object.defineProperty(token, SOURCE, { value: sourceName, configurable: true });
	        }
	        return { flags: flags, token: token, tokenKey: tokenKey(token) };
	    });
	}
	/**
	 * @param {?} view
	 * @param {?} renderHost
	 * @param {?} def
	 * @return {?}
	 */
	function getParentRenderElement(view, renderHost, def) {
	    var /** @type {?} */ renderParent = def.renderParent;
	    if (renderParent) {
	        if ((renderParent.flags & 1 /* TypeElement */) === 0 ||
	            (renderParent.flags & 33554432 /* ComponentView */) === 0 ||
	            (/** @type {?} */ ((renderParent.element)).componentRendererType && /** @type {?} */ ((/** @type {?} */ ((renderParent.element)).componentRendererType)).encapsulation === ViewEncapsulation.Native)) {
	            // only children of non components, or children of components with native encapsulation should
	            // be attached.
	            return asElementData(view, /** @type {?} */ ((def.renderParent)).nodeIndex).renderElement;
	        }
	    }
	    else {
	        return renderHost;
	    }
	}
	var DEFINITION_CACHE = new WeakMap();
	/**
	 * @template D
	 * @param {?} factory
	 * @return {?}
	 */
	function resolveDefinition(factory) {
	    var /** @type {?} */ value = /** @type {?} */ (((DEFINITION_CACHE.get(factory))));
	    if (!value) {
	        value = factory(function () { return NOOP; });
	        value.factory = factory;
	        DEFINITION_CACHE.set(factory, value);
	    }
	    return value;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function rootRenderNodes(view) {
	    var /** @type {?} */ renderNodes = [];
	    visitRootRenderNodes(view, 0 /* Collect */, undefined, undefined, renderNodes);
	    return renderNodes;
	}
	/**
	 * @param {?} view
	 * @param {?} action
	 * @param {?} parentNode
	 * @param {?} nextSibling
	 * @param {?=} target
	 * @return {?}
	 */
	function visitRootRenderNodes(view, action, parentNode, nextSibling, target) {
	    // We need to re-compute the parent node in case the nodes have been moved around manually
	    if (action === 3 /* RemoveChild */) {
	        parentNode = view.renderer.parentNode(renderNode(view, /** @type {?} */ ((view.def.lastRenderRootNode))));
	    }
	    visitSiblingRenderNodes(view, action, 0, view.def.nodes.length - 1, parentNode, nextSibling, target);
	}
	/**
	 * @param {?} view
	 * @param {?} action
	 * @param {?} startIndex
	 * @param {?} endIndex
	 * @param {?} parentNode
	 * @param {?} nextSibling
	 * @param {?=} target
	 * @return {?}
	 */
	function visitSiblingRenderNodes(view, action, startIndex, endIndex, parentNode, nextSibling, target) {
	    for (var /** @type {?} */ i = startIndex; i <= endIndex; i++) {
	        var /** @type {?} */ nodeDef = view.def.nodes[i];
	        if (nodeDef.flags & (1 /* TypeElement */ | 2 /* TypeText */ | 8 /* TypeNgContent */)) {
	            visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target);
	        }
	        // jump to next sibling
	        i += nodeDef.childCount;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} ngContentIndex
	 * @param {?} action
	 * @param {?} parentNode
	 * @param {?} nextSibling
	 * @param {?=} target
	 * @return {?}
	 */
	function visitProjectedRenderNodes(view, ngContentIndex, action, parentNode, nextSibling, target) {
	    var /** @type {?} */ compView = view;
	    while (compView && !isComponentView(compView)) {
	        compView = compView.parent;
	    }
	    var /** @type {?} */ hostView = /** @type {?} */ ((compView)).parent;
	    var /** @type {?} */ hostElDef = viewParentEl(/** @type {?} */ ((compView)));
	    var /** @type {?} */ startIndex = /** @type {?} */ ((hostElDef)).nodeIndex + 1;
	    var /** @type {?} */ endIndex = /** @type {?} */ ((hostElDef)).nodeIndex + /** @type {?} */ ((hostElDef)).childCount;
	    for (var /** @type {?} */ i = startIndex; i <= endIndex; i++) {
	        var /** @type {?} */ nodeDef = /** @type {?} */ ((hostView)).def.nodes[i];
	        if (nodeDef.ngContentIndex === ngContentIndex) {
	            visitRenderNode(/** @type {?} */ ((hostView)), nodeDef, action, parentNode, nextSibling, target);
	        }
	        // jump to next sibling
	        i += nodeDef.childCount;
	    }
	    if (!/** @type {?} */ ((hostView)).parent) {
	        // a root view
	        var /** @type {?} */ projectedNodes = view.root.projectableNodes[ngContentIndex];
	        if (projectedNodes) {
	            for (var /** @type {?} */ i = 0; i < projectedNodes.length; i++) {
	                execRenderNodeAction(view, projectedNodes[i], action, parentNode, nextSibling, target);
	            }
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} action
	 * @param {?} parentNode
	 * @param {?} nextSibling
	 * @param {?=} target
	 * @return {?}
	 */
	function visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target) {
	    if (nodeDef.flags & 8 /* TypeNgContent */) {
	        visitProjectedRenderNodes(view, /** @type {?} */ ((nodeDef.ngContent)).index, action, parentNode, nextSibling, target);
	    }
	    else {
	        var /** @type {?} */ rn = renderNode(view, nodeDef);
	        if (action === 3 /* RemoveChild */ && (nodeDef.flags & 33554432 /* ComponentView */) &&
	            (nodeDef.bindingFlags & 48 /* CatSyntheticProperty */)) {
	            // Note: we might need to do both actions.
	            if (nodeDef.bindingFlags & (16 /* SyntheticProperty */)) {
	                execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
	            }
	            if (nodeDef.bindingFlags & (32 /* SyntheticHostProperty */)) {
	                var /** @type {?} */ compView = asElementData(view, nodeDef.nodeIndex).componentView;
	                execRenderNodeAction(compView, rn, action, parentNode, nextSibling, target);
	            }
	        }
	        else {
	            execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
	        }
	        if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
	            var /** @type {?} */ embeddedViews = /** @type {?} */ ((asElementData(view, nodeDef.nodeIndex).viewContainer))._embeddedViews;
	            for (var /** @type {?} */ k = 0; k < embeddedViews.length; k++) {
	                visitRootRenderNodes(embeddedViews[k], action, parentNode, nextSibling, target);
	            }
	        }
	        if (nodeDef.flags & 1 /* TypeElement */ && !/** @type {?} */ ((nodeDef.element)).name) {
	            visitSiblingRenderNodes(view, action, nodeDef.nodeIndex + 1, nodeDef.nodeIndex + nodeDef.childCount, parentNode, nextSibling, target);
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} renderNode
	 * @param {?} action
	 * @param {?} parentNode
	 * @param {?} nextSibling
	 * @param {?=} target
	 * @return {?}
	 */
	function execRenderNodeAction(view, renderNode, action, parentNode, nextSibling, target) {
	    var /** @type {?} */ renderer = view.renderer;
	    switch (action) {
	        case 1 /* AppendChild */:
	            renderer.appendChild(parentNode, renderNode);
	            break;
	        case 2 /* InsertBefore */:
	            renderer.insertBefore(parentNode, renderNode, nextSibling);
	            break;
	        case 3 /* RemoveChild */:
	            renderer.removeChild(parentNode, renderNode);
	            break;
	        case 0 /* Collect */:
	            /** @type {?} */ ((target)).push(renderNode);
	            break;
	    }
	}
	var NS_PREFIX_RE = /^:([^:]+):(.+)$/;
	/**
	 * @param {?} name
	 * @return {?}
	 */
	function splitNamespace(name) {
	    if (name[0] === ':') {
	        var /** @type {?} */ match = /** @type {?} */ ((name.match(NS_PREFIX_RE)));
	        return [match[1], match[2]];
	    }
	    return ['', name];
	}
	/**
	 * @param {?} bindings
	 * @return {?}
	 */
	function calcBindingFlags(bindings) {
	    var /** @type {?} */ flags = 0;
	    for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
	        flags |= bindings[i].flags;
	    }
	    return flags;
	}
	/**
	 * @param {?} valueCount
	 * @param {?} constAndInterp
	 * @return {?}
	 */
	function interpolate(valueCount, constAndInterp) {
	    var /** @type {?} */ result = '';
	    for (var /** @type {?} */ i = 0; i < valueCount * 2; i = i + 2) {
	        result = result + constAndInterp[i] + _toStringWithNull(constAndInterp[i + 1]);
	    }
	    return result + constAndInterp[valueCount * 2];
	}
	/**
	 * @param {?} valueCount
	 * @param {?} c0
	 * @param {?} a1
	 * @param {?} c1
	 * @param {?=} a2
	 * @param {?=} c2
	 * @param {?=} a3
	 * @param {?=} c3
	 * @param {?=} a4
	 * @param {?=} c4
	 * @param {?=} a5
	 * @param {?=} c5
	 * @param {?=} a6
	 * @param {?=} c6
	 * @param {?=} a7
	 * @param {?=} c7
	 * @param {?=} a8
	 * @param {?=} c8
	 * @param {?=} a9
	 * @param {?=} c9
	 * @return {?}
	 */
	function inlineInterpolate(valueCount, c0, a1, c1, a2, c2, a3, c3, a4, c4, a5, c5, a6, c6, a7, c7, a8, c8, a9, c9) {
	    switch (valueCount) {
	        case 1:
	            return c0 + _toStringWithNull(a1) + c1;
	        case 2:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2;
	        case 3:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3;
	        case 4:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3 + _toStringWithNull(a4) + c4;
	        case 5:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5;
	        case 6:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) + c6;
	        case 7:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
	                c6 + _toStringWithNull(a7) + c7;
	        case 8:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
	                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8;
	        case 9:
	            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
	                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
	                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8 + _toStringWithNull(a9) + c9;
	        default:
	            throw new Error("Does not support more than 9 expressions");
	    }
	}
	/**
	 * @param {?} v
	 * @return {?}
	 */
	function _toStringWithNull(v) {
	    return v != null ? v.toString() : '';
	}
	var EMPTY_ARRAY = [];
	var EMPTY_MAP = {};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} flags
	 * @param {?} matchedQueriesDsl
	 * @param {?} ngContentIndex
	 * @param {?} childCount
	 * @param {?=} handleEvent
	 * @param {?=} templateFactory
	 * @return {?}
	 */
	function anchorDef(flags, matchedQueriesDsl, ngContentIndex, childCount, handleEvent, templateFactory) {
	    flags |= 1 /* TypeElement */;
	    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
	    var /** @type {?} */ template = templateFactory ? resolveDefinition(templateFactory) : null;
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        flags: flags,
	        checkIndex: -1,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
	        bindings: [],
	        bindingFlags: 0,
	        outputs: [],
	        element: {
	            ns: null,
	            name: null,
	            attrs: null, template: template,
	            componentProvider: null,
	            componentView: null,
	            componentRendererType: null,
	            publicProviders: null,
	            allProviders: null,
	            handleEvent: handleEvent || NOOP
	        },
	        provider: null,
	        text: null,
	        query: null,
	        ngContent: null
	    };
	}
	/**
	 * @param {?} checkIndex
	 * @param {?} flags
	 * @param {?} matchedQueriesDsl
	 * @param {?} ngContentIndex
	 * @param {?} childCount
	 * @param {?} namespaceAndName
	 * @param {?=} fixedAttrs
	 * @param {?=} bindings
	 * @param {?=} outputs
	 * @param {?=} handleEvent
	 * @param {?=} componentView
	 * @param {?=} componentRendererType
	 * @return {?}
	 */
	function elementDef(checkIndex, flags, matchedQueriesDsl, ngContentIndex, childCount, namespaceAndName, fixedAttrs, bindings, outputs, handleEvent, componentView, componentRendererType) {
	    if (fixedAttrs === void 0) { fixedAttrs = []; }
	    if (!handleEvent) {
	        handleEvent = NOOP;
	    }
	    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
	    var /** @type {?} */ ns = /** @type {?} */ ((null));
	    var /** @type {?} */ name = /** @type {?} */ ((null));
	    if (namespaceAndName) {
	        _b = splitNamespace(namespaceAndName), ns = _b[0], name = _b[1];
	    }
	    bindings = bindings || [];
	    var /** @type {?} */ bindingDefs = new Array(bindings.length);
	    for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
	        var _c = bindings[i], bindingFlags = _c[0], namespaceAndName_1 = _c[1], suffixOrSecurityContext = _c[2];
	        var _d = splitNamespace(namespaceAndName_1), ns_1 = _d[0], name_1 = _d[1];
	        var /** @type {?} */ securityContext = /** @type {?} */ ((undefined));
	        var /** @type {?} */ suffix = /** @type {?} */ ((undefined));
	        switch (bindingFlags & 15 /* Types */) {
	            case 4 /* TypeElementStyle */:
	                suffix = /** @type {?} */ (suffixOrSecurityContext);
	                break;
	            case 1 /* TypeElementAttribute */:
	            case 8 /* TypeProperty */:
	                securityContext = /** @type {?} */ (suffixOrSecurityContext);
	                break;
	        }
	        bindingDefs[i] =
	            { flags: bindingFlags, ns: ns_1, name: name_1, nonMinifiedName: name_1, securityContext: securityContext, suffix: suffix };
	    }
	    outputs = outputs || [];
	    var /** @type {?} */ outputDefs = new Array(outputs.length);
	    for (var /** @type {?} */ i = 0; i < outputs.length; i++) {
	        var _e = outputs[i], target = _e[0], eventName = _e[1];
	        outputDefs[i] = {
	            type: 0 /* ElementOutput */,
	            target: /** @type {?} */ (target), eventName: eventName,
	            propName: null
	        };
	    }
	    fixedAttrs = fixedAttrs || [];
	    var /** @type {?} */ attrs = /** @type {?} */ (fixedAttrs.map(function (_a) {
	        var namespaceAndName = _a[0], value = _a[1];
	        var _b = splitNamespace(namespaceAndName), ns = _b[0], name = _b[1];
	        return [ns, name, value];
	    }));
	    componentRendererType = resolveRendererType2(componentRendererType);
	    if (componentView) {
	        flags |= 33554432 /* ComponentView */;
	    }
	    flags |= 1 /* TypeElement */;
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        checkIndex: checkIndex,
	        flags: flags,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
	        bindings: bindingDefs,
	        bindingFlags: calcBindingFlags(bindingDefs),
	        outputs: outputDefs,
	        element: {
	            ns: ns,
	            name: name,
	            attrs: attrs,
	            template: null,
	            // will bet set by the view definition
	            componentProvider: null,
	            componentView: componentView || null,
	            componentRendererType: componentRendererType,
	            publicProviders: null,
	            allProviders: null,
	            handleEvent: handleEvent || NOOP,
	        },
	        provider: null,
	        text: null,
	        query: null,
	        ngContent: null
	    };
	    var _b;
	}
	/**
	 * @param {?} view
	 * @param {?} renderHost
	 * @param {?} def
	 * @return {?}
	 */
	function createElement(view, renderHost, def) {
	    var /** @type {?} */ elDef = /** @type {?} */ ((def.element));
	    var /** @type {?} */ rootSelectorOrNode = view.root.selectorOrNode;
	    var /** @type {?} */ renderer = view.renderer;
	    var /** @type {?} */ el;
	    if (view.parent || !rootSelectorOrNode) {
	        if (elDef.name) {
	            el = renderer.createElement(elDef.name, elDef.ns);
	        }
	        else {
	            el = renderer.createComment('');
	        }
	        var /** @type {?} */ parentEl = getParentRenderElement(view, renderHost, def);
	        if (parentEl) {
	            renderer.appendChild(parentEl, el);
	        }
	    }
	    else {
	        el = renderer.selectRootElement(rootSelectorOrNode);
	    }
	    if (elDef.attrs) {
	        for (var /** @type {?} */ i = 0; i < elDef.attrs.length; i++) {
	            var _a = elDef.attrs[i], ns = _a[0], name_2 = _a[1], value = _a[2];
	            renderer.setAttribute(el, name_2, value, ns);
	        }
	    }
	    return el;
	}
	/**
	 * @param {?} view
	 * @param {?} compView
	 * @param {?} def
	 * @param {?} el
	 * @return {?}
	 */
	function listenToElementOutputs(view, compView, def, el) {
	    for (var /** @type {?} */ i = 0; i < def.outputs.length; i++) {
	        var /** @type {?} */ output = def.outputs[i];
	        var /** @type {?} */ handleEventClosure = renderEventHandlerClosure(view, def.nodeIndex, elementEventFullName(output.target, output.eventName));
	        var /** @type {?} */ listenTarget = output.target;
	        var /** @type {?} */ listenerView = view;
	        if (output.target === 'component') {
	            listenTarget = null;
	            listenerView = compView;
	        }
	        var /** @type {?} */ disposable = /** @type {?} */ (listenerView.renderer.listen(listenTarget || el, output.eventName, handleEventClosure)); /** @type {?} */
	        ((view.disposables))[def.outputIndex + i] = disposable;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} index
	 * @param {?} eventName
	 * @return {?}
	 */
	function renderEventHandlerClosure(view, index, eventName) {
	    return function (event) { return dispatchEvent(view, index, eventName, event); };
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} v0
	 * @param {?} v1
	 * @param {?} v2
	 * @param {?} v3
	 * @param {?} v4
	 * @param {?} v5
	 * @param {?} v6
	 * @param {?} v7
	 * @param {?} v8
	 * @param {?} v9
	 * @return {?}
	 */
	function checkAndUpdateElementInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ bindLen = def.bindings.length;
	    var /** @type {?} */ changed = false;
	    if (bindLen > 0 && checkAndUpdateElementValue(view, def, 0, v0))
	        changed = true;
	    if (bindLen > 1 && checkAndUpdateElementValue(view, def, 1, v1))
	        changed = true;
	    if (bindLen > 2 && checkAndUpdateElementValue(view, def, 2, v2))
	        changed = true;
	    if (bindLen > 3 && checkAndUpdateElementValue(view, def, 3, v3))
	        changed = true;
	    if (bindLen > 4 && checkAndUpdateElementValue(view, def, 4, v4))
	        changed = true;
	    if (bindLen > 5 && checkAndUpdateElementValue(view, def, 5, v5))
	        changed = true;
	    if (bindLen > 6 && checkAndUpdateElementValue(view, def, 6, v6))
	        changed = true;
	    if (bindLen > 7 && checkAndUpdateElementValue(view, def, 7, v7))
	        changed = true;
	    if (bindLen > 8 && checkAndUpdateElementValue(view, def, 8, v8))
	        changed = true;
	    if (bindLen > 9 && checkAndUpdateElementValue(view, def, 9, v9))
	        changed = true;
	    return changed;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} values
	 * @return {?}
	 */
	function checkAndUpdateElementDynamic(view, def, values) {
	    var /** @type {?} */ changed = false;
	    for (var /** @type {?} */ i = 0; i < values.length; i++) {
	        if (checkAndUpdateElementValue(view, def, i, values[i]))
	            changed = true;
	    }
	    return changed;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} bindingIdx
	 * @param {?} value
	 * @return {?}
	 */
	function checkAndUpdateElementValue(view, def, bindingIdx, value) {
	    if (!checkAndUpdateBinding(view, def, bindingIdx, value)) {
	        return false;
	    }
	    var /** @type {?} */ binding = def.bindings[bindingIdx];
	    var /** @type {?} */ elData = asElementData(view, def.nodeIndex);
	    var /** @type {?} */ renderNode$$1 = elData.renderElement;
	    var /** @type {?} */ name = /** @type {?} */ ((binding.name));
	    switch (binding.flags & 15 /* Types */) {
	        case 1 /* TypeElementAttribute */:
	            setElementAttribute(view, binding, renderNode$$1, binding.ns, name, value);
	            break;
	        case 2 /* TypeElementClass */:
	            setElementClass(view, renderNode$$1, name, value);
	            break;
	        case 4 /* TypeElementStyle */:
	            setElementStyle(view, binding, renderNode$$1, name, value);
	            break;
	        case 8 /* TypeProperty */:
	            var /** @type {?} */ bindView = (def.flags & 33554432 /* ComponentView */ &&
	                binding.flags & 32 /* SyntheticHostProperty */) ?
	                elData.componentView :
	                view;
	            setElementProperty(bindView, binding, renderNode$$1, name, value);
	            break;
	    }
	    return true;
	}
	/**
	 * @param {?} view
	 * @param {?} binding
	 * @param {?} renderNode
	 * @param {?} ns
	 * @param {?} name
	 * @param {?} value
	 * @return {?}
	 */
	function setElementAttribute(view, binding, renderNode$$1, ns, name, value) {
	    var /** @type {?} */ securityContext = binding.securityContext;
	    var /** @type {?} */ renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
	    renderValue = renderValue != null ? renderValue.toString() : null;
	    var /** @type {?} */ renderer = view.renderer;
	    if (value != null) {
	        renderer.setAttribute(renderNode$$1, name, renderValue, ns);
	    }
	    else {
	        renderer.removeAttribute(renderNode$$1, name, ns);
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} renderNode
	 * @param {?} name
	 * @param {?} value
	 * @return {?}
	 */
	function setElementClass(view, renderNode$$1, name, value) {
	    var /** @type {?} */ renderer = view.renderer;
	    if (value) {
	        renderer.addClass(renderNode$$1, name);
	    }
	    else {
	        renderer.removeClass(renderNode$$1, name);
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} binding
	 * @param {?} renderNode
	 * @param {?} name
	 * @param {?} value
	 * @return {?}
	 */
	function setElementStyle(view, binding, renderNode$$1, name, value) {
	    var /** @type {?} */ renderValue = view.root.sanitizer.sanitize(SecurityContext.STYLE, /** @type {?} */ (value));
	    if (renderValue != null) {
	        renderValue = renderValue.toString();
	        var /** @type {?} */ unit = binding.suffix;
	        if (unit != null) {
	            renderValue = renderValue + unit;
	        }
	    }
	    else {
	        renderValue = null;
	    }
	    var /** @type {?} */ renderer = view.renderer;
	    if (renderValue != null) {
	        renderer.setStyle(renderNode$$1, name, renderValue);
	    }
	    else {
	        renderer.removeStyle(renderNode$$1, name);
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} binding
	 * @param {?} renderNode
	 * @param {?} name
	 * @param {?} value
	 * @return {?}
	 */
	function setElementProperty(view, binding, renderNode$$1, name, value) {
	    var /** @type {?} */ securityContext = binding.securityContext;
	    var /** @type {?} */ renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
	    view.renderer.setProperty(renderNode$$1, name, renderValue);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var UNDEFINED_VALUE = new Object();
	var InjectorRefTokenKey$1 = tokenKey(Injector);
	var NgModuleRefTokenKey = tokenKey(NgModuleRef);
	/**
	 * @param {?} flags
	 * @param {?} token
	 * @param {?} value
	 * @param {?} deps
	 * @return {?}
	 */
	function moduleProvideDef(flags, token, value, deps) {
	    // Need to resolve forwardRefs as e.g. for `useValue` we
	    // lowered the expression and then stopped evaluating it,
	    // i.e. also didn't unwrap it.
	    value = resolveForwardRef(value);
	    var /** @type {?} */ depDefs = splitDepsDsl(deps, stringify(token));
	    return {
	        // will bet set by the module definition
	        index: -1,
	        deps: depDefs, flags: flags, token: token, value: value
	    };
	}
	/**
	 * @param {?} providers
	 * @return {?}
	 */
	function moduleDef(providers) {
	    var /** @type {?} */ providersByKey = {};
	    for (var /** @type {?} */ i = 0; i < providers.length; i++) {
	        var /** @type {?} */ provider = providers[i];
	        provider.index = i;
	        providersByKey[tokenKey(provider.token)] = provider;
	    }
	    return {
	        // Will be filled later...
	        factory: null,
	        providersByKey: providersByKey,
	        providers: providers
	    };
	}
	/**
	 * @param {?} data
	 * @return {?}
	 */
	function initNgModule(data) {
	    var /** @type {?} */ def = data._def;
	    var /** @type {?} */ providers = data._providers = new Array(def.providers.length);
	    for (var /** @type {?} */ i = 0; i < def.providers.length; i++) {
	        var /** @type {?} */ provDef = def.providers[i];
	        if (!(provDef.flags & 4096 /* LazyProvider */)) {
	            providers[i] = _createProviderInstance$1(data, provDef);
	        }
	    }
	}
	/**
	 * @param {?} data
	 * @param {?} depDef
	 * @param {?=} notFoundValue
	 * @return {?}
	 */
	function resolveNgModuleDep(data, depDef, notFoundValue) {
	    if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
	    if (depDef.flags & 8 /* Value */) {
	        return depDef.token;
	    }
	    if (depDef.flags & 2 /* Optional */) {
	        notFoundValue = null;
	    }
	    if (depDef.flags & 1 /* SkipSelf */) {
	        return data._parent.get(depDef.token, notFoundValue);
	    }
	    var /** @type {?} */ tokenKey$$1 = depDef.tokenKey;
	    switch (tokenKey$$1) {
	        case InjectorRefTokenKey$1:
	        case NgModuleRefTokenKey:
	            return data;
	    }
	    var /** @type {?} */ providerDef = data._def.providersByKey[tokenKey$$1];
	    if (providerDef) {
	        var /** @type {?} */ providerInstance = data._providers[providerDef.index];
	        if (providerInstance === undefined) {
	            providerInstance = data._providers[providerDef.index] =
	                _createProviderInstance$1(data, providerDef);
	        }
	        return providerInstance === UNDEFINED_VALUE ? undefined : providerInstance;
	    }
	    return data._parent.get(depDef.token, notFoundValue);
	}
	/**
	 * @param {?} ngModule
	 * @param {?} providerDef
	 * @return {?}
	 */
	function _createProviderInstance$1(ngModule, providerDef) {
	    var /** @type {?} */ injectable;
	    switch (providerDef.flags & 201347067 /* Types */) {
	        case 512 /* TypeClassProvider */:
	            injectable = _createClass(ngModule, providerDef.value, providerDef.deps);
	            break;
	        case 1024 /* TypeFactoryProvider */:
	            injectable = _callFactory(ngModule, providerDef.value, providerDef.deps);
	            break;
	        case 2048 /* TypeUseExistingProvider */:
	            injectable = resolveNgModuleDep(ngModule, providerDef.deps[0]);
	            break;
	        case 256 /* TypeValueProvider */:
	            injectable = providerDef.value;
	            break;
	    }
	    return injectable === undefined ? UNDEFINED_VALUE : injectable;
	}
	/**
	 * @param {?} ngModule
	 * @param {?} ctor
	 * @param {?} deps
	 * @return {?}
	 */
	function _createClass(ngModule, ctor, deps) {
	    var /** @type {?} */ len = deps.length;
	    switch (len) {
	        case 0:
	            return new ctor();
	        case 1:
	            return new ctor(resolveNgModuleDep(ngModule, deps[0]));
	        case 2:
	            return new ctor(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]));
	        case 3:
	            return new ctor(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]), resolveNgModuleDep(ngModule, deps[2]));
	        default:
	            var /** @type {?} */ depValues = new Array(len);
	            for (var /** @type {?} */ i = 0; i < len; i++) {
	                depValues[i] = resolveNgModuleDep(ngModule, deps[i]);
	            }
	            return new (ctor.bind.apply(ctor, [void 0].concat(depValues)))();
	    }
	}
	/**
	 * @param {?} ngModule
	 * @param {?} factory
	 * @param {?} deps
	 * @return {?}
	 */
	function _callFactory(ngModule, factory, deps) {
	    var /** @type {?} */ len = deps.length;
	    switch (len) {
	        case 0:
	            return factory();
	        case 1:
	            return factory(resolveNgModuleDep(ngModule, deps[0]));
	        case 2:
	            return factory(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]));
	        case 3:
	            return factory(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]), resolveNgModuleDep(ngModule, deps[2]));
	        default:
	            var /** @type {?} */ depValues = Array(len);
	            for (var /** @type {?} */ i = 0; i < len; i++) {
	                depValues[i] = resolveNgModuleDep(ngModule, deps[i]);
	            }
	            return factory.apply(void 0, depValues);
	    }
	}
	/**
	 * @param {?} ngModule
	 * @param {?} lifecycles
	 * @return {?}
	 */
	function callNgModuleLifecycle(ngModule, lifecycles) {
	    var /** @type {?} */ def = ngModule._def;
	    for (var /** @type {?} */ i = 0; i < def.providers.length; i++) {
	        var /** @type {?} */ provDef = def.providers[i];
	        if (provDef.flags & 131072 /* OnDestroy */) {
	            var /** @type {?} */ instance = ngModule._providers[i];
	            if (instance && instance !== UNDEFINED_VALUE) {
	                instance.ngOnDestroy();
	            }
	        }
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} parentView
	 * @param {?} elementData
	 * @param {?} viewIndex
	 * @param {?} view
	 * @return {?}
	 */
	function attachEmbeddedView(parentView, elementData, viewIndex, view) {
	    var /** @type {?} */ embeddedViews = /** @type {?} */ ((elementData.viewContainer))._embeddedViews;
	    if (viewIndex === null || viewIndex === undefined) {
	        viewIndex = embeddedViews.length;
	    }
	    view.viewContainerParent = parentView;
	    addToArray(embeddedViews, /** @type {?} */ ((viewIndex)), view);
	    attachProjectedView(elementData, view);
	    Services.dirtyParentQueries(view);
	    var /** @type {?} */ prevView = /** @type {?} */ ((viewIndex)) > 0 ? embeddedViews[/** @type {?} */ ((viewIndex)) - 1] : null;
	    renderAttachEmbeddedView(elementData, prevView, view);
	}
	/**
	 * @param {?} vcElementData
	 * @param {?} view
	 * @return {?}
	 */
	function attachProjectedView(vcElementData, view) {
	    var /** @type {?} */ dvcElementData = declaredViewContainer(view);
	    if (!dvcElementData || dvcElementData === vcElementData ||
	        view.state & 16 /* IsProjectedView */) {
	        return;
	    }
	    // Note: For performance reasons, we
	    // - add a view to template._projectedViews only 1x throughout its lifetime,
	    //   and remove it not until the view is destroyed.
	    //   (hard, as when a parent view is attached/detached we would need to attach/detach all
	    //    nested projected views as well, even accross component boundaries).
	    // - don't track the insertion order of views in the projected views array
	    //   (hard, as when the views of the same template are inserted different view containers)
	    view.state |= 16 /* IsProjectedView */;
	    var /** @type {?} */ projectedViews = dvcElementData.template._projectedViews;
	    if (!projectedViews) {
	        projectedViews = dvcElementData.template._projectedViews = [];
	    }
	    projectedViews.push(view);
	    // Note: we are changing the NodeDef here as we cannot calculate
	    // the fact whether a template is used for projection during compilation.
	    markNodeAsProjectedTemplate(/** @type {?} */ ((view.parent)).def, /** @type {?} */ ((view.parentNodeDef)));
	}
	/**
	 * @param {?} viewDef
	 * @param {?} nodeDef
	 * @return {?}
	 */
	function markNodeAsProjectedTemplate(viewDef, nodeDef) {
	    if (nodeDef.flags & 4 /* ProjectedTemplate */) {
	        return;
	    }
	    viewDef.nodeFlags |= 4 /* ProjectedTemplate */;
	    nodeDef.flags |= 4 /* ProjectedTemplate */;
	    var /** @type {?} */ parentNodeDef = nodeDef.parent;
	    while (parentNodeDef) {
	        parentNodeDef.childFlags |= 4 /* ProjectedTemplate */;
	        parentNodeDef = parentNodeDef.parent;
	    }
	}
	/**
	 * @param {?} elementData
	 * @param {?=} viewIndex
	 * @return {?}
	 */
	function detachEmbeddedView(elementData, viewIndex) {
	    var /** @type {?} */ embeddedViews = /** @type {?} */ ((elementData.viewContainer))._embeddedViews;
	    if (viewIndex == null || viewIndex >= embeddedViews.length) {
	        viewIndex = embeddedViews.length - 1;
	    }
	    if (viewIndex < 0) {
	        return null;
	    }
	    var /** @type {?} */ view = embeddedViews[viewIndex];
	    view.viewContainerParent = null;
	    removeFromArray(embeddedViews, viewIndex);
	    // See attachProjectedView for why we don't update projectedViews here.
	    Services.dirtyParentQueries(view);
	    renderDetachView(view);
	    return view;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function detachProjectedView(view) {
	    if (!(view.state & 16 /* IsProjectedView */)) {
	        return;
	    }
	    var /** @type {?} */ dvcElementData = declaredViewContainer(view);
	    if (dvcElementData) {
	        var /** @type {?} */ projectedViews = dvcElementData.template._projectedViews;
	        if (projectedViews) {
	            removeFromArray(projectedViews, projectedViews.indexOf(view));
	            Services.dirtyParentQueries(view);
	        }
	    }
	}
	/**
	 * @param {?} elementData
	 * @param {?} oldViewIndex
	 * @param {?} newViewIndex
	 * @return {?}
	 */
	function moveEmbeddedView(elementData, oldViewIndex, newViewIndex) {
	    var /** @type {?} */ embeddedViews = /** @type {?} */ ((elementData.viewContainer))._embeddedViews;
	    var /** @type {?} */ view = embeddedViews[oldViewIndex];
	    removeFromArray(embeddedViews, oldViewIndex);
	    if (newViewIndex == null) {
	        newViewIndex = embeddedViews.length;
	    }
	    addToArray(embeddedViews, newViewIndex, view);
	    // Note: Don't need to change projectedViews as the order in there
	    // as always invalid...
	    Services.dirtyParentQueries(view);
	    renderDetachView(view);
	    var /** @type {?} */ prevView = newViewIndex > 0 ? embeddedViews[newViewIndex - 1] : null;
	    renderAttachEmbeddedView(elementData, prevView, view);
	    return view;
	}
	/**
	 * @param {?} elementData
	 * @param {?} prevView
	 * @param {?} view
	 * @return {?}
	 */
	function renderAttachEmbeddedView(elementData, prevView, view) {
	    var /** @type {?} */ prevRenderNode = prevView ? renderNode(prevView, /** @type {?} */ ((prevView.def.lastRenderRootNode))) :
	        elementData.renderElement;
	    var /** @type {?} */ parentNode = view.renderer.parentNode(prevRenderNode);
	    var /** @type {?} */ nextSibling = view.renderer.nextSibling(prevRenderNode);
	    // Note: We can't check if `nextSibling` is present, as on WebWorkers it will always be!
	    // However, browsers automatically do `appendChild` when there is no `nextSibling`.
	    visitRootRenderNodes(view, 2 /* InsertBefore */, parentNode, nextSibling, undefined);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function renderDetachView(view) {
	    visitRootRenderNodes(view, 3 /* RemoveChild */, null, null, undefined);
	}
	/**
	 * @param {?} arr
	 * @param {?} index
	 * @param {?} value
	 * @return {?}
	 */
	function addToArray(arr, index, value) {
	    // perf: array.push is faster than array.splice!
	    if (index >= arr.length) {
	        arr.push(value);
	    }
	    else {
	        arr.splice(index, 0, value);
	    }
	}
	/**
	 * @param {?} arr
	 * @param {?} index
	 * @return {?}
	 */
	function removeFromArray(arr, index) {
	    // perf: array.pop is faster than array.splice!
	    if (index >= arr.length - 1) {
	        arr.pop();
	    }
	    else {
	        arr.splice(index, 1);
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var EMPTY_CONTEXT = new Object();
	/**
	 * @param {?} selector
	 * @param {?} componentType
	 * @param {?} viewDefFactory
	 * @param {?} inputs
	 * @param {?} outputs
	 * @param {?} ngContentSelectors
	 * @return {?}
	 */
	function createComponentFactory(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors) {
	    return new ComponentFactory_(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors);
	}
	/**
	 * @param {?} componentFactory
	 * @return {?}
	 */
	function getComponentViewDefinitionFactory(componentFactory) {
	    return (/** @type {?} */ (componentFactory)).viewDefFactory;
	}
	var ComponentFactory_ = /** @class */ (function (_super) {
	    __extends(ComponentFactory_, _super);
	    function ComponentFactory_(selector, componentType, viewDefFactory, _inputs, _outputs, ngContentSelectors) {
	        var _this = 
	        // Attention: this ctor is called as top level function.
	        // Putting any logic in here will destroy closure tree shaking!
	        _super.call(this) || this;
	        _this.selector = selector;
	        _this.componentType = componentType;
	        _this._inputs = _inputs;
	        _this._outputs = _outputs;
	        _this.ngContentSelectors = ngContentSelectors;
	        _this.viewDefFactory = viewDefFactory;
	        return _this;
	    }
	    Object.defineProperty(ComponentFactory_.prototype, "inputs", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ inputsArr = [];
	            var /** @type {?} */ inputs = /** @type {?} */ ((this._inputs));
	            for (var /** @type {?} */ propName in inputs) {
	                var /** @type {?} */ templateName = inputs[propName];
	                inputsArr.push({ propName: propName, templateName: templateName });
	            }
	            return inputsArr;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ComponentFactory_.prototype, "outputs", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ outputsArr = [];
	            for (var /** @type {?} */ propName in this._outputs) {
	                var /** @type {?} */ templateName = this._outputs[propName];
	                outputsArr.push({ propName: propName, templateName: templateName });
	            }
	            return outputsArr;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Creates a new component.
	     */
	    /**
	     * Creates a new component.
	     * @param {?} injector
	     * @param {?=} projectableNodes
	     * @param {?=} rootSelectorOrNode
	     * @param {?=} ngModule
	     * @return {?}
	     */
	    ComponentFactory_.prototype.create = /**
	     * Creates a new component.
	     * @param {?} injector
	     * @param {?=} projectableNodes
	     * @param {?=} rootSelectorOrNode
	     * @param {?=} ngModule
	     * @return {?}
	     */
	    function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
	        if (!ngModule) {
	            throw new Error('ngModule should be provided');
	        }
	        var /** @type {?} */ viewDef = resolveDefinition(this.viewDefFactory);
	        var /** @type {?} */ componentNodeIndex = /** @type {?} */ ((/** @type {?} */ ((viewDef.nodes[0].element)).componentProvider)).nodeIndex;
	        var /** @type {?} */ view = Services.createRootView(injector, projectableNodes || [], rootSelectorOrNode, viewDef, ngModule, EMPTY_CONTEXT);
	        var /** @type {?} */ component = asProviderData(view, componentNodeIndex).instance;
	        if (rootSelectorOrNode) {
	            view.renderer.setAttribute(asElementData(view, 0).renderElement, 'ng-version', VERSION.full);
	        }
	        return new ComponentRef_(view, new ViewRef_(view), component);
	    };
	    return ComponentFactory_;
	}(ComponentFactory));
	var ComponentRef_ = /** @class */ (function (_super) {
	    __extends(ComponentRef_, _super);
	    function ComponentRef_(_view, _viewRef, _component) {
	        var _this = _super.call(this) || this;
	        _this._view = _view;
	        _this._viewRef = _viewRef;
	        _this._component = _component;
	        _this._elDef = _this._view.def.nodes[0];
	        _this.hostView = _viewRef;
	        _this.changeDetectorRef = _viewRef;
	        _this.instance = _component;
	        return _this;
	    }
	    Object.defineProperty(ComponentRef_.prototype, "location", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return new ElementRef(asElementData(this._view, this._elDef.nodeIndex).renderElement);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ComponentRef_.prototype, "injector", {
	        get: /**
	         * @return {?}
	         */
	        function () { return new Injector_(this._view, this._elDef); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ComponentRef_.prototype, "componentType", {
	        get: /**
	         * @return {?}
	         */
	        function () { return /** @type {?} */ (this._component.constructor); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    ComponentRef_.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { this._viewRef.destroy(); };
	    /**
	     * @param {?} callback
	     * @return {?}
	     */
	    ComponentRef_.prototype.onDestroy = /**
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) { this._viewRef.onDestroy(callback); };
	    return ComponentRef_;
	}(ComponentRef));
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @param {?} elData
	 * @return {?}
	 */
	function createViewContainerData(view, elDef, elData) {
	    return new ViewContainerRef_(view, elDef, elData);
	}
	var ViewContainerRef_ = /** @class */ (function () {
	    function ViewContainerRef_(_view, _elDef, _data) {
	        this._view = _view;
	        this._elDef = _elDef;
	        this._data = _data;
	        /**
	         * \@internal
	         */
	        this._embeddedViews = [];
	    }
	    Object.defineProperty(ViewContainerRef_.prototype, "element", {
	        get: /**
	         * @return {?}
	         */
	        function () { return new ElementRef(this._data.renderElement); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ViewContainerRef_.prototype, "injector", {
	        get: /**
	         * @return {?}
	         */
	        function () { return new Injector_(this._view, this._elDef); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ViewContainerRef_.prototype, "parentInjector", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ view = this._view;
	            var /** @type {?} */ elDef = this._elDef.parent;
	            while (!elDef && view) {
	                elDef = viewParentEl(view);
	                view = /** @type {?} */ ((view.parent));
	            }
	            return view ? new Injector_(view, elDef) : new Injector_(this._view, null);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.clear = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ len = this._embeddedViews.length;
	        for (var /** @type {?} */ i = len - 1; i >= 0; i--) {
	            var /** @type {?} */ view = /** @type {?} */ ((detachEmbeddedView(this._data, i)));
	            Services.destroyView(view);
	        }
	    };
	    /**
	     * @param {?} index
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.get = /**
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ view = this._embeddedViews[index];
	        if (view) {
	            var /** @type {?} */ ref = new ViewRef_(view);
	            ref.attachToViewContainerRef(this);
	            return ref;
	        }
	        return null;
	    };
	    Object.defineProperty(ViewContainerRef_.prototype, "length", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._embeddedViews.length; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @template C
	     * @param {?} templateRef
	     * @param {?=} context
	     * @param {?=} index
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.createEmbeddedView = /**
	     * @template C
	     * @param {?} templateRef
	     * @param {?=} context
	     * @param {?=} index
	     * @return {?}
	     */
	    function (templateRef, context, index) {
	        var /** @type {?} */ viewRef = templateRef.createEmbeddedView(context || /** @type {?} */ ({}));
	        this.insert(viewRef, index);
	        return viewRef;
	    };
	    /**
	     * @template C
	     * @param {?} componentFactory
	     * @param {?=} index
	     * @param {?=} injector
	     * @param {?=} projectableNodes
	     * @param {?=} ngModuleRef
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.createComponent = /**
	     * @template C
	     * @param {?} componentFactory
	     * @param {?=} index
	     * @param {?=} injector
	     * @param {?=} projectableNodes
	     * @param {?=} ngModuleRef
	     * @return {?}
	     */
	    function (componentFactory, index, injector, projectableNodes, ngModuleRef) {
	        var /** @type {?} */ contextInjector = injector || this.parentInjector;
	        if (!ngModuleRef && !(componentFactory instanceof ComponentFactoryBoundToModule)) {
	            ngModuleRef = contextInjector.get(NgModuleRef);
	        }
	        var /** @type {?} */ componentRef = componentFactory.create(contextInjector, projectableNodes, undefined, ngModuleRef);
	        this.insert(componentRef.hostView, index);
	        return componentRef;
	    };
	    /**
	     * @param {?} viewRef
	     * @param {?=} index
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.insert = /**
	     * @param {?} viewRef
	     * @param {?=} index
	     * @return {?}
	     */
	    function (viewRef, index) {
	        if (viewRef.destroyed) {
	            throw new Error('Cannot insert a destroyed View in a ViewContainer!');
	        }
	        var /** @type {?} */ viewRef_ = /** @type {?} */ (viewRef);
	        var /** @type {?} */ viewData = viewRef_._view;
	        attachEmbeddedView(this._view, this._data, index, viewData);
	        viewRef_.attachToViewContainerRef(this);
	        return viewRef;
	    };
	    /**
	     * @param {?} viewRef
	     * @param {?} currentIndex
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.move = /**
	     * @param {?} viewRef
	     * @param {?} currentIndex
	     * @return {?}
	     */
	    function (viewRef, currentIndex) {
	        if (viewRef.destroyed) {
	            throw new Error('Cannot move a destroyed View in a ViewContainer!');
	        }
	        var /** @type {?} */ previousIndex = this._embeddedViews.indexOf(viewRef._view);
	        moveEmbeddedView(this._data, previousIndex, currentIndex);
	        return viewRef;
	    };
	    /**
	     * @param {?} viewRef
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.indexOf = /**
	     * @param {?} viewRef
	     * @return {?}
	     */
	    function (viewRef) {
	        return this._embeddedViews.indexOf((/** @type {?} */ (viewRef))._view);
	    };
	    /**
	     * @param {?=} index
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.remove = /**
	     * @param {?=} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ viewData = detachEmbeddedView(this._data, index);
	        if (viewData) {
	            Services.destroyView(viewData);
	        }
	    };
	    /**
	     * @param {?=} index
	     * @return {?}
	     */
	    ViewContainerRef_.prototype.detach = /**
	     * @param {?=} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ view = detachEmbeddedView(this._data, index);
	        return view ? new ViewRef_(view) : null;
	    };
	    return ViewContainerRef_;
	}());
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function createChangeDetectorRef(view) {
	    return new ViewRef_(view);
	}
	var ViewRef_ = /** @class */ (function () {
	    function ViewRef_(_view) {
	        this._view = _view;
	        this._viewContainerRef = null;
	        this._appRef = null;
	    }
	    Object.defineProperty(ViewRef_.prototype, "rootNodes", {
	        get: /**
	         * @return {?}
	         */
	        function () { return rootRenderNodes(this._view); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ViewRef_.prototype, "context", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._view.context; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ViewRef_.prototype, "destroyed", {
	        get: /**
	         * @return {?}
	         */
	        function () { return (this._view.state & 128 /* Destroyed */) !== 0; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.markForCheck = /**
	     * @return {?}
	     */
	    function () { markParentViewsForCheck(this._view); };
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.detach = /**
	     * @return {?}
	     */
	    function () { this._view.state &= ~4 /* Attached */; };
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.detectChanges = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ fs = this._view.root.rendererFactory;
	        if (fs.begin) {
	            fs.begin();
	        }
	        try {
	            Services.checkAndUpdateView(this._view);
	        }
	        finally {
	            if (fs.end) {
	                fs.end();
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.checkNoChanges = /**
	     * @return {?}
	     */
	    function () { Services.checkNoChangesView(this._view); };
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.reattach = /**
	     * @return {?}
	     */
	    function () { this._view.state |= 4 /* Attached */; };
	    /**
	     * @param {?} callback
	     * @return {?}
	     */
	    ViewRef_.prototype.onDestroy = /**
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) {
	        if (!this._view.disposables) {
	            this._view.disposables = [];
	        }
	        this._view.disposables.push(/** @type {?} */ (callback));
	    };
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._appRef) {
	            this._appRef.detachView(this);
	        }
	        else if (this._viewContainerRef) {
	            this._viewContainerRef.detach(this._viewContainerRef.indexOf(this));
	        }
	        Services.destroyView(this._view);
	    };
	    /**
	     * @return {?}
	     */
	    ViewRef_.prototype.detachFromAppRef = /**
	     * @return {?}
	     */
	    function () {
	        this._appRef = null;
	        renderDetachView(this._view);
	        Services.dirtyParentQueries(this._view);
	    };
	    /**
	     * @param {?} appRef
	     * @return {?}
	     */
	    ViewRef_.prototype.attachToAppRef = /**
	     * @param {?} appRef
	     * @return {?}
	     */
	    function (appRef) {
	        if (this._viewContainerRef) {
	            throw new Error('This view is already attached to a ViewContainer!');
	        }
	        this._appRef = appRef;
	    };
	    /**
	     * @param {?} vcRef
	     * @return {?}
	     */
	    ViewRef_.prototype.attachToViewContainerRef = /**
	     * @param {?} vcRef
	     * @return {?}
	     */
	    function (vcRef) {
	        if (this._appRef) {
	            throw new Error('This view is already attached directly to the ApplicationRef!');
	        }
	        this._viewContainerRef = vcRef;
	    };
	    return ViewRef_;
	}());
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function createTemplateData(view, def) {
	    return new TemplateRef_(view, def);
	}
	var TemplateRef_ = /** @class */ (function (_super) {
	    __extends(TemplateRef_, _super);
	    function TemplateRef_(_parentView, _def) {
	        var _this = _super.call(this) || this;
	        _this._parentView = _parentView;
	        _this._def = _def;
	        return _this;
	    }
	    /**
	     * @param {?} context
	     * @return {?}
	     */
	    TemplateRef_.prototype.createEmbeddedView = /**
	     * @param {?} context
	     * @return {?}
	     */
	    function (context) {
	        return new ViewRef_(Services.createEmbeddedView(this._parentView, this._def, /** @type {?} */ ((/** @type {?} */ ((this._def.element)).template)), context));
	    };
	    Object.defineProperty(TemplateRef_.prototype, "elementRef", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return new ElementRef(asElementData(this._parentView, this._def.nodeIndex).renderElement);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return TemplateRef_;
	}(TemplateRef));
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @return {?}
	 */
	function createInjector(view, elDef) {
	    return new Injector_(view, elDef);
	}
	var Injector_ = /** @class */ (function () {
	    function Injector_(view, elDef) {
	        this.view = view;
	        this.elDef = elDef;
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    Injector_.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
	        var /** @type {?} */ allowPrivateServices = this.elDef ? (this.elDef.flags & 33554432 /* ComponentView */) !== 0 : false;
	        return Services.resolveDep(this.view, this.elDef, allowPrivateServices, { flags: 0 /* None */, token: token, tokenKey: tokenKey(token) }, notFoundValue);
	    };
	    return Injector_;
	}());
	/**
	 * @param {?} view
	 * @param {?} index
	 * @return {?}
	 */
	function nodeValue(view, index) {
	    var /** @type {?} */ def = view.def.nodes[index];
	    if (def.flags & 1 /* TypeElement */) {
	        var /** @type {?} */ elData = asElementData(view, def.nodeIndex);
	        return /** @type {?} */ ((def.element)).template ? elData.template : elData.renderElement;
	    }
	    else if (def.flags & 2 /* TypeText */) {
	        return asTextData(view, def.nodeIndex).renderText;
	    }
	    else if (def.flags & (20224 /* CatProvider */ | 16 /* TypePipe */)) {
	        return asProviderData(view, def.nodeIndex).instance;
	    }
	    throw new Error("Illegal state: read nodeValue for node index " + index);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function createRendererV1(view) {
	    return new RendererAdapter(view.renderer);
	}
	var RendererAdapter = /** @class */ (function () {
	    function RendererAdapter(delegate) {
	        this.delegate = delegate;
	    }
	    /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    RendererAdapter.prototype.selectRootElement = /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    function (selectorOrNode) {
	        return this.delegate.selectRootElement(selectorOrNode);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} namespaceAndName
	     * @return {?}
	     */
	    RendererAdapter.prototype.createElement = /**
	     * @param {?} parent
	     * @param {?} namespaceAndName
	     * @return {?}
	     */
	    function (parent, namespaceAndName) {
	        var _a = splitNamespace(namespaceAndName), ns = _a[0], name = _a[1];
	        var /** @type {?} */ el = this.delegate.createElement(name, ns);
	        if (parent) {
	            this.delegate.appendChild(parent, el);
	        }
	        return el;
	    };
	    /**
	     * @param {?} hostElement
	     * @return {?}
	     */
	    RendererAdapter.prototype.createViewRoot = /**
	     * @param {?} hostElement
	     * @return {?}
	     */
	    function (hostElement) { return hostElement; };
	    /**
	     * @param {?} parentElement
	     * @return {?}
	     */
	    RendererAdapter.prototype.createTemplateAnchor = /**
	     * @param {?} parentElement
	     * @return {?}
	     */
	    function (parentElement) {
	        var /** @type {?} */ comment = this.delegate.createComment('');
	        if (parentElement) {
	            this.delegate.appendChild(parentElement, comment);
	        }
	        return comment;
	    };
	    /**
	     * @param {?} parentElement
	     * @param {?} value
	     * @return {?}
	     */
	    RendererAdapter.prototype.createText = /**
	     * @param {?} parentElement
	     * @param {?} value
	     * @return {?}
	     */
	    function (parentElement, value) {
	        var /** @type {?} */ node = this.delegate.createText(value);
	        if (parentElement) {
	            this.delegate.appendChild(parentElement, node);
	        }
	        return node;
	    };
	    /**
	     * @param {?} parentElement
	     * @param {?} nodes
	     * @return {?}
	     */
	    RendererAdapter.prototype.projectNodes = /**
	     * @param {?} parentElement
	     * @param {?} nodes
	     * @return {?}
	     */
	    function (parentElement, nodes) {
	        for (var /** @type {?} */ i = 0; i < nodes.length; i++) {
	            this.delegate.appendChild(parentElement, nodes[i]);
	        }
	    };
	    /**
	     * @param {?} node
	     * @param {?} viewRootNodes
	     * @return {?}
	     */
	    RendererAdapter.prototype.attachViewAfter = /**
	     * @param {?} node
	     * @param {?} viewRootNodes
	     * @return {?}
	     */
	    function (node, viewRootNodes) {
	        var /** @type {?} */ parentElement = this.delegate.parentNode(node);
	        var /** @type {?} */ nextSibling = this.delegate.nextSibling(node);
	        for (var /** @type {?} */ i = 0; i < viewRootNodes.length; i++) {
	            this.delegate.insertBefore(parentElement, viewRootNodes[i], nextSibling);
	        }
	    };
	    /**
	     * @param {?} viewRootNodes
	     * @return {?}
	     */
	    RendererAdapter.prototype.detachView = /**
	     * @param {?} viewRootNodes
	     * @return {?}
	     */
	    function (viewRootNodes) {
	        for (var /** @type {?} */ i = 0; i < viewRootNodes.length; i++) {
	            var /** @type {?} */ node = viewRootNodes[i];
	            var /** @type {?} */ parentElement = this.delegate.parentNode(node);
	            this.delegate.removeChild(parentElement, node);
	        }
	    };
	    /**
	     * @param {?} hostElement
	     * @param {?} viewAllNodes
	     * @return {?}
	     */
	    RendererAdapter.prototype.destroyView = /**
	     * @param {?} hostElement
	     * @param {?} viewAllNodes
	     * @return {?}
	     */
	    function (hostElement, viewAllNodes) {
	        for (var /** @type {?} */ i = 0; i < viewAllNodes.length; i++) {
	            /** @type {?} */ ((this.delegate.destroyNode))(viewAllNodes[i]);
	        }
	    };
	    /**
	     * @param {?} renderElement
	     * @param {?} name
	     * @param {?} callback
	     * @return {?}
	     */
	    RendererAdapter.prototype.listen = /**
	     * @param {?} renderElement
	     * @param {?} name
	     * @param {?} callback
	     * @return {?}
	     */
	    function (renderElement, name, callback) {
	        return this.delegate.listen(renderElement, name, /** @type {?} */ (callback));
	    };
	    /**
	     * @param {?} target
	     * @param {?} name
	     * @param {?} callback
	     * @return {?}
	     */
	    RendererAdapter.prototype.listenGlobal = /**
	     * @param {?} target
	     * @param {?} name
	     * @param {?} callback
	     * @return {?}
	     */
	    function (target, name, callback) {
	        return this.delegate.listen(target, name, /** @type {?} */ (callback));
	    };
	    /**
	     * @param {?} renderElement
	     * @param {?} propertyName
	     * @param {?} propertyValue
	     * @return {?}
	     */
	    RendererAdapter.prototype.setElementProperty = /**
	     * @param {?} renderElement
	     * @param {?} propertyName
	     * @param {?} propertyValue
	     * @return {?}
	     */
	    function (renderElement, propertyName, propertyValue) {
	        this.delegate.setProperty(renderElement, propertyName, propertyValue);
	    };
	    /**
	     * @param {?} renderElement
	     * @param {?} namespaceAndName
	     * @param {?} attributeValue
	     * @return {?}
	     */
	    RendererAdapter.prototype.setElementAttribute = /**
	     * @param {?} renderElement
	     * @param {?} namespaceAndName
	     * @param {?} attributeValue
	     * @return {?}
	     */
	    function (renderElement, namespaceAndName, attributeValue) {
	        var _a = splitNamespace(namespaceAndName), ns = _a[0], name = _a[1];
	        if (attributeValue != null) {
	            this.delegate.setAttribute(renderElement, name, attributeValue, ns);
	        }
	        else {
	            this.delegate.removeAttribute(renderElement, name, ns);
	        }
	    };
	    /**
	     * @param {?} renderElement
	     * @param {?} propertyName
	     * @param {?} propertyValue
	     * @return {?}
	     */
	    RendererAdapter.prototype.setBindingDebugInfo = /**
	     * @param {?} renderElement
	     * @param {?} propertyName
	     * @param {?} propertyValue
	     * @return {?}
	     */
	    function (renderElement, propertyName, propertyValue) { };
	    /**
	     * @param {?} renderElement
	     * @param {?} className
	     * @param {?} isAdd
	     * @return {?}
	     */
	    RendererAdapter.prototype.setElementClass = /**
	     * @param {?} renderElement
	     * @param {?} className
	     * @param {?} isAdd
	     * @return {?}
	     */
	    function (renderElement, className, isAdd) {
	        if (isAdd) {
	            this.delegate.addClass(renderElement, className);
	        }
	        else {
	            this.delegate.removeClass(renderElement, className);
	        }
	    };
	    /**
	     * @param {?} renderElement
	     * @param {?} styleName
	     * @param {?} styleValue
	     * @return {?}
	     */
	    RendererAdapter.prototype.setElementStyle = /**
	     * @param {?} renderElement
	     * @param {?} styleName
	     * @param {?} styleValue
	     * @return {?}
	     */
	    function (renderElement, styleName, styleValue) {
	        if (styleValue != null) {
	            this.delegate.setStyle(renderElement, styleName, styleValue);
	        }
	        else {
	            this.delegate.removeStyle(renderElement, styleName);
	        }
	    };
	    /**
	     * @param {?} renderElement
	     * @param {?} methodName
	     * @param {?} args
	     * @return {?}
	     */
	    RendererAdapter.prototype.invokeElementMethod = /**
	     * @param {?} renderElement
	     * @param {?} methodName
	     * @param {?} args
	     * @return {?}
	     */
	    function (renderElement, methodName, args) {
	        (/** @type {?} */ (renderElement))[methodName].apply(renderElement, args);
	    };
	    /**
	     * @param {?} renderNode
	     * @param {?} text
	     * @return {?}
	     */
	    RendererAdapter.prototype.setText = /**
	     * @param {?} renderNode
	     * @param {?} text
	     * @return {?}
	     */
	    function (renderNode$$1, text) { this.delegate.setValue(renderNode$$1, text); };
	    /**
	     * @return {?}
	     */
	    RendererAdapter.prototype.animate = /**
	     * @return {?}
	     */
	    function () { throw new Error('Renderer.animate is no longer supported!'); };
	    return RendererAdapter;
	}());
	/**
	 * @param {?} moduleType
	 * @param {?} parent
	 * @param {?} bootstrapComponents
	 * @param {?} def
	 * @return {?}
	 */
	function createNgModuleRef(moduleType, parent, bootstrapComponents, def) {
	    return new NgModuleRef_(moduleType, parent, bootstrapComponents, def);
	}
	var NgModuleRef_ = /** @class */ (function () {
	    function NgModuleRef_(_moduleType, _parent, _bootstrapComponents, _def) {
	        this._moduleType = _moduleType;
	        this._parent = _parent;
	        this._bootstrapComponents = _bootstrapComponents;
	        this._def = _def;
	        this._destroyListeners = [];
	        this._destroyed = false;
	        this.injector = this;
	        initNgModule(this);
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    NgModuleRef_.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
	        return resolveNgModuleDep(this, { token: token, tokenKey: tokenKey(token), flags: 0 /* None */ }, notFoundValue);
	    };
	    Object.defineProperty(NgModuleRef_.prototype, "instance", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.get(this._moduleType); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModuleRef_.prototype, "componentFactoryResolver", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.get(ComponentFactoryResolver); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    NgModuleRef_.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._destroyed) {
	            throw new Error("The ng module " + stringify(this.instance.constructor) + " has already been destroyed.");
	        }
	        this._destroyed = true;
	        callNgModuleLifecycle(this, 131072 /* OnDestroy */);
	        this._destroyListeners.forEach(function (listener) { return listener(); });
	    };
	    /**
	     * @param {?} callback
	     * @return {?}
	     */
	    NgModuleRef_.prototype.onDestroy = /**
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) { this._destroyListeners.push(callback); };
	    return NgModuleRef_;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var RendererV1TokenKey = tokenKey(Renderer);
	var Renderer2TokenKey = tokenKey(Renderer2);
	var ElementRefTokenKey = tokenKey(ElementRef);
	var ViewContainerRefTokenKey = tokenKey(ViewContainerRef);
	var TemplateRefTokenKey = tokenKey(TemplateRef);
	var ChangeDetectorRefTokenKey = tokenKey(ChangeDetectorRef);
	var InjectorRefTokenKey = tokenKey(Injector);
	/**
	 * @param {?} checkIndex
	 * @param {?} flags
	 * @param {?} matchedQueries
	 * @param {?} childCount
	 * @param {?} ctor
	 * @param {?} deps
	 * @param {?=} props
	 * @param {?=} outputs
	 * @return {?}
	 */
	function directiveDef(checkIndex, flags, matchedQueries, childCount, ctor, deps, props, outputs) {
	    var /** @type {?} */ bindings = [];
	    if (props) {
	        for (var /** @type {?} */ prop in props) {
	            var _a = props[prop], bindingIndex = _a[0], nonMinifiedName = _a[1];
	            bindings[bindingIndex] = {
	                flags: 8 /* TypeProperty */,
	                name: prop, nonMinifiedName: nonMinifiedName,
	                ns: null,
	                securityContext: null,
	                suffix: null
	            };
	        }
	    }
	    var /** @type {?} */ outputDefs = [];
	    if (outputs) {
	        for (var /** @type {?} */ propName in outputs) {
	            outputDefs.push({ type: 1 /* DirectiveOutput */, propName: propName, target: null, eventName: outputs[propName] });
	        }
	    }
	    flags |= 16384 /* TypeDirective */;
	    return _def(checkIndex, flags, matchedQueries, childCount, ctor, ctor, deps, bindings, outputDefs);
	}
	/**
	 * @param {?} flags
	 * @param {?} ctor
	 * @param {?} deps
	 * @return {?}
	 */
	function pipeDef(flags, ctor, deps) {
	    flags |= 16 /* TypePipe */;
	    return _def(-1, flags, null, 0, ctor, ctor, deps);
	}
	/**
	 * @param {?} flags
	 * @param {?} matchedQueries
	 * @param {?} token
	 * @param {?} value
	 * @param {?} deps
	 * @return {?}
	 */
	function providerDef(flags, matchedQueries, token, value, deps) {
	    return _def(-1, flags, matchedQueries, 0, token, value, deps);
	}
	/**
	 * @param {?} checkIndex
	 * @param {?} flags
	 * @param {?} matchedQueriesDsl
	 * @param {?} childCount
	 * @param {?} token
	 * @param {?} value
	 * @param {?} deps
	 * @param {?=} bindings
	 * @param {?=} outputs
	 * @return {?}
	 */
	function _def(checkIndex, flags, matchedQueriesDsl, childCount, token, value, deps, bindings, outputs) {
	    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
	    if (!outputs) {
	        outputs = [];
	    }
	    if (!bindings) {
	        bindings = [];
	    }
	    // Need to resolve forwardRefs as e.g. for `useValue` we
	    // lowered the expression and then stopped evaluating it,
	    // i.e. also didn't unwrap it.
	    value = resolveForwardRef(value);
	    var /** @type {?} */ depDefs = splitDepsDsl(deps, stringify(token));
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        checkIndex: checkIndex,
	        flags: flags,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references,
	        ngContentIndex: -1, childCount: childCount, bindings: bindings,
	        bindingFlags: calcBindingFlags(bindings), outputs: outputs,
	        element: null,
	        provider: { token: token, value: value, deps: depDefs },
	        text: null,
	        query: null,
	        ngContent: null
	    };
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function createProviderInstance(view, def) {
	    return _createProviderInstance(view, def);
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function createPipeInstance(view, def) {
	    // deps are looked up from component.
	    var /** @type {?} */ compView = view;
	    while (compView.parent && !isComponentView(compView)) {
	        compView = compView.parent;
	    }
	    // pipes can see the private services of the component
	    var /** @type {?} */ allowPrivateServices = true;
	    // pipes are always eager and classes!
	    return createClass(/** @type {?} */ ((compView.parent)), /** @type {?} */ ((viewParentEl(compView))), allowPrivateServices, /** @type {?} */ ((def.provider)).value, /** @type {?} */ ((def.provider)).deps);
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function createDirectiveInstance(view, def) {
	    // components can see other private services, other directives can't.
	    var /** @type {?} */ allowPrivateServices = (def.flags & 32768 /* Component */) > 0;
	    // directives are always eager and classes!
	    var /** @type {?} */ instance = createClass(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((def.provider)).value, /** @type {?} */ ((def.provider)).deps);
	    if (def.outputs.length) {
	        for (var /** @type {?} */ i = 0; i < def.outputs.length; i++) {
	            var /** @type {?} */ output = def.outputs[i];
	            var /** @type {?} */ subscription = instance[/** @type {?} */ ((output.propName))].subscribe(eventHandlerClosure(view, /** @type {?} */ ((def.parent)).nodeIndex, output.eventName)); /** @type {?} */
	            ((view.disposables))[def.outputIndex + i] = subscription.unsubscribe.bind(subscription);
	        }
	    }
	    return instance;
	}
	/**
	 * @param {?} view
	 * @param {?} index
	 * @param {?} eventName
	 * @return {?}
	 */
	function eventHandlerClosure(view, index, eventName) {
	    return function (event) { return dispatchEvent(view, index, eventName, event); };
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} v0
	 * @param {?} v1
	 * @param {?} v2
	 * @param {?} v3
	 * @param {?} v4
	 * @param {?} v5
	 * @param {?} v6
	 * @param {?} v7
	 * @param {?} v8
	 * @param {?} v9
	 * @return {?}
	 */
	function checkAndUpdateDirectiveInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ providerData = asProviderData(view, def.nodeIndex);
	    var /** @type {?} */ directive = providerData.instance;
	    var /** @type {?} */ changed = false;
	    var /** @type {?} */ changes = /** @type {?} */ ((undefined));
	    var /** @type {?} */ bindLen = def.bindings.length;
	    if (bindLen > 0 && checkBinding(view, def, 0, v0)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 0, v0, changes);
	    }
	    if (bindLen > 1 && checkBinding(view, def, 1, v1)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 1, v1, changes);
	    }
	    if (bindLen > 2 && checkBinding(view, def, 2, v2)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 2, v2, changes);
	    }
	    if (bindLen > 3 && checkBinding(view, def, 3, v3)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 3, v3, changes);
	    }
	    if (bindLen > 4 && checkBinding(view, def, 4, v4)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 4, v4, changes);
	    }
	    if (bindLen > 5 && checkBinding(view, def, 5, v5)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 5, v5, changes);
	    }
	    if (bindLen > 6 && checkBinding(view, def, 6, v6)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 6, v6, changes);
	    }
	    if (bindLen > 7 && checkBinding(view, def, 7, v7)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 7, v7, changes);
	    }
	    if (bindLen > 8 && checkBinding(view, def, 8, v8)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 8, v8, changes);
	    }
	    if (bindLen > 9 && checkBinding(view, def, 9, v9)) {
	        changed = true;
	        changes = updateProp(view, providerData, def, 9, v9, changes);
	    }
	    if (changes) {
	        directive.ngOnChanges(changes);
	    }
	    if ((def.flags & 65536 /* OnInit */) &&
	        shouldCallLifecycleInitHook(view, 256 /* InitState_CallingOnInit */, def.nodeIndex)) {
	        directive.ngOnInit();
	    }
	    if (def.flags & 262144 /* DoCheck */) {
	        directive.ngDoCheck();
	    }
	    return changed;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} values
	 * @return {?}
	 */
	function checkAndUpdateDirectiveDynamic(view, def, values) {
	    var /** @type {?} */ providerData = asProviderData(view, def.nodeIndex);
	    var /** @type {?} */ directive = providerData.instance;
	    var /** @type {?} */ changed = false;
	    var /** @type {?} */ changes = /** @type {?} */ ((undefined));
	    for (var /** @type {?} */ i = 0; i < values.length; i++) {
	        if (checkBinding(view, def, i, values[i])) {
	            changed = true;
	            changes = updateProp(view, providerData, def, i, values[i], changes);
	        }
	    }
	    if (changes) {
	        directive.ngOnChanges(changes);
	    }
	    if ((def.flags & 65536 /* OnInit */) &&
	        shouldCallLifecycleInitHook(view, 256 /* InitState_CallingOnInit */, def.nodeIndex)) {
	        directive.ngOnInit();
	    }
	    if (def.flags & 262144 /* DoCheck */) {
	        directive.ngDoCheck();
	    }
	    return changed;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function _createProviderInstance(view, def) {
	    // private services can see other private services
	    var /** @type {?} */ allowPrivateServices = (def.flags & 8192 /* PrivateProvider */) > 0;
	    var /** @type {?} */ providerDef = def.provider;
	    switch (def.flags & 201347067 /* Types */) {
	        case 512 /* TypeClassProvider */:
	            return createClass(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((providerDef)).value, /** @type {?} */ ((providerDef)).deps);
	        case 1024 /* TypeFactoryProvider */:
	            return callFactory(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((providerDef)).value, /** @type {?} */ ((providerDef)).deps);
	        case 2048 /* TypeUseExistingProvider */:
	            return resolveDep(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((providerDef)).deps[0]);
	        case 256 /* TypeValueProvider */:
	            return /** @type {?} */ ((providerDef)).value;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @param {?} allowPrivateServices
	 * @param {?} ctor
	 * @param {?} deps
	 * @return {?}
	 */
	function createClass(view, elDef, allowPrivateServices, ctor, deps) {
	    var /** @type {?} */ len = deps.length;
	    switch (len) {
	        case 0:
	            return new ctor();
	        case 1:
	            return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]));
	        case 2:
	            return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
	        case 3:
	            return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
	        default:
	            var /** @type {?} */ depValues = new Array(len);
	            for (var /** @type {?} */ i = 0; i < len; i++) {
	                depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
	            }
	            return new (ctor.bind.apply(ctor, [void 0].concat(depValues)))();
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @param {?} allowPrivateServices
	 * @param {?} factory
	 * @param {?} deps
	 * @return {?}
	 */
	function callFactory(view, elDef, allowPrivateServices, factory, deps) {
	    var /** @type {?} */ len = deps.length;
	    switch (len) {
	        case 0:
	            return factory();
	        case 1:
	            return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]));
	        case 2:
	            return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
	        case 3:
	            return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
	        default:
	            var /** @type {?} */ depValues = Array(len);
	            for (var /** @type {?} */ i = 0; i < len; i++) {
	                depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
	            }
	            return factory.apply(void 0, depValues);
	    }
	}
	// This default value is when checking the hierarchy for a token.
	//
	// It means both:
	// - the token is not provided by the current injector,
	// - only the element injectors should be checked (ie do not check module injectors
	//
	//          mod1
	//         /
	//       el1   mod2
	//         \  /
	//         el2
	//
	// When requesting el2.injector.get(token), we should check in the following order and return the
	// first found value:
	// - el2.injector.get(token, default)
	// - el1.injector.get(token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) -> do not check the module
	// - mod2.injector.get(token, default)
	var NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR = {};
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @param {?} allowPrivateServices
	 * @param {?} depDef
	 * @param {?=} notFoundValue
	 * @return {?}
	 */
	function resolveDep(view, elDef, allowPrivateServices, depDef, notFoundValue) {
	    if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
	    if (depDef.flags & 8 /* Value */) {
	        return depDef.token;
	    }
	    var /** @type {?} */ startView = view;
	    if (depDef.flags & 2 /* Optional */) {
	        notFoundValue = null;
	    }
	    var /** @type {?} */ tokenKey$$1 = depDef.tokenKey;
	    if (tokenKey$$1 === ChangeDetectorRefTokenKey) {
	        // directives on the same element as a component should be able to control the change detector
	        // of that component as well.
	        allowPrivateServices = !!(elDef && /** @type {?} */ ((elDef.element)).componentView);
	    }
	    if (elDef && (depDef.flags & 1 /* SkipSelf */)) {
	        allowPrivateServices = false;
	        elDef = /** @type {?} */ ((elDef.parent));
	    }
	    while (view) {
	        if (elDef) {
	            switch (tokenKey$$1) {
	                case RendererV1TokenKey: {
	                    var /** @type {?} */ compView = findCompView(view, elDef, allowPrivateServices);
	                    return createRendererV1(compView);
	                }
	                case Renderer2TokenKey: {
	                    var /** @type {?} */ compView = findCompView(view, elDef, allowPrivateServices);
	                    return compView.renderer;
	                }
	                case ElementRefTokenKey:
	                    return new ElementRef(asElementData(view, elDef.nodeIndex).renderElement);
	                case ViewContainerRefTokenKey:
	                    return asElementData(view, elDef.nodeIndex).viewContainer;
	                case TemplateRefTokenKey: {
	                    if (/** @type {?} */ ((elDef.element)).template) {
	                        return asElementData(view, elDef.nodeIndex).template;
	                    }
	                    break;
	                }
	                case ChangeDetectorRefTokenKey: {
	                    var /** @type {?} */ cdView = findCompView(view, elDef, allowPrivateServices);
	                    return createChangeDetectorRef(cdView);
	                }
	                case InjectorRefTokenKey:
	                    return createInjector(view, elDef);
	                default:
	                    var /** @type {?} */ providerDef_1 = /** @type {?} */ (((allowPrivateServices ? /** @type {?} */ ((elDef.element)).allProviders : /** @type {?} */ ((elDef.element)).publicProviders)))[tokenKey$$1];
	                    if (providerDef_1) {
	                        var /** @type {?} */ providerData = asProviderData(view, providerDef_1.nodeIndex);
	                        if (!providerData) {
	                            providerData = { instance: _createProviderInstance(view, providerDef_1) };
	                            view.nodes[providerDef_1.nodeIndex] = /** @type {?} */ (providerData);
	                        }
	                        return providerData.instance;
	                    }
	            }
	        }
	        allowPrivateServices = isComponentView(view);
	        elDef = /** @type {?} */ ((viewParentEl(view)));
	        view = /** @type {?} */ ((view.parent));
	    }
	    var /** @type {?} */ value = startView.root.injector.get(depDef.token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR);
	    if (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR ||
	        notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) {
	        // Return the value from the root element injector when
	        // - it provides it
	        //   (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
	        // - the module injector should not be checked
	        //   (notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
	        return value;
	    }
	    return startView.root.ngModule.injector.get(depDef.token, notFoundValue);
	}
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @param {?} allowPrivateServices
	 * @return {?}
	 */
	function findCompView(view, elDef, allowPrivateServices) {
	    var /** @type {?} */ compView;
	    if (allowPrivateServices) {
	        compView = asElementData(view, elDef.nodeIndex).componentView;
	    }
	    else {
	        compView = view;
	        while (compView.parent && !isComponentView(compView)) {
	            compView = compView.parent;
	        }
	    }
	    return compView;
	}
	/**
	 * @param {?} view
	 * @param {?} providerData
	 * @param {?} def
	 * @param {?} bindingIdx
	 * @param {?} value
	 * @param {?} changes
	 * @return {?}
	 */
	function updateProp(view, providerData, def, bindingIdx, value, changes) {
	    if (def.flags & 32768 /* Component */) {
	        var /** @type {?} */ compView = asElementData(view, /** @type {?} */ ((def.parent)).nodeIndex).componentView;
	        if (compView.def.flags & 2 /* OnPush */) {
	            compView.state |= 8 /* ChecksEnabled */;
	        }
	    }
	    var /** @type {?} */ binding = def.bindings[bindingIdx];
	    var /** @type {?} */ propName = /** @type {?} */ ((binding.name));
	    // Note: This is still safe with Closure Compiler as
	    // the user passed in the property name as an object has to `providerDef`,
	    // so Closure Compiler will have renamed the property correctly already.
	    providerData.instance[propName] = value;
	    if (def.flags & 524288 /* OnChanges */) {
	        changes = changes || {};
	        var /** @type {?} */ oldValue = WrappedValue.unwrap(view.oldValues[def.bindingIndex + bindingIdx]);
	        var /** @type {?} */ binding_1 = def.bindings[bindingIdx];
	        changes[/** @type {?} */ ((binding_1.nonMinifiedName))] =
	            new SimpleChange(oldValue, value, (view.state & 2 /* FirstCheck */) !== 0);
	    }
	    view.oldValues[def.bindingIndex + bindingIdx] = value;
	    return changes;
	}
	/**
	 * @param {?} view
	 * @param {?} lifecycles
	 * @return {?}
	 */
	function callLifecycleHooksChildrenFirst(view, lifecycles) {
	    if (!(view.def.nodeFlags & lifecycles)) {
	        return;
	    }
	    var /** @type {?} */ nodes = view.def.nodes;
	    var /** @type {?} */ initIndex = 0;
	    for (var /** @type {?} */ i = 0; i < nodes.length; i++) {
	        var /** @type {?} */ nodeDef = nodes[i];
	        var /** @type {?} */ parent_1 = nodeDef.parent;
	        if (!parent_1 && nodeDef.flags & lifecycles) {
	            // matching root node (e.g. a pipe)
	            callProviderLifecycles(view, i, nodeDef.flags & lifecycles, initIndex++);
	        }
	        if ((nodeDef.childFlags & lifecycles) === 0) {
	            // no child matches one of the lifecycles
	            i += nodeDef.childCount;
	        }
	        while (parent_1 && (parent_1.flags & 1 /* TypeElement */) &&
	            i === parent_1.nodeIndex + parent_1.childCount) {
	            // last child of an element
	            if (parent_1.directChildFlags & lifecycles) {
	                initIndex = callElementProvidersLifecycles(view, parent_1, lifecycles, initIndex);
	            }
	            parent_1 = parent_1.parent;
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} elDef
	 * @param {?} lifecycles
	 * @param {?} initIndex
	 * @return {?}
	 */
	function callElementProvidersLifecycles(view, elDef, lifecycles, initIndex) {
	    for (var /** @type {?} */ i = elDef.nodeIndex + 1; i <= elDef.nodeIndex + elDef.childCount; i++) {
	        var /** @type {?} */ nodeDef = view.def.nodes[i];
	        if (nodeDef.flags & lifecycles) {
	            callProviderLifecycles(view, i, nodeDef.flags & lifecycles, initIndex++);
	        }
	        // only visit direct children
	        i += nodeDef.childCount;
	    }
	    return initIndex;
	}
	/**
	 * @param {?} view
	 * @param {?} index
	 * @param {?} lifecycles
	 * @param {?} initIndex
	 * @return {?}
	 */
	function callProviderLifecycles(view, index, lifecycles, initIndex) {
	    var /** @type {?} */ providerData = asProviderData(view, index);
	    if (!providerData) {
	        return;
	    }
	    var /** @type {?} */ provider = providerData.instance;
	    if (!provider) {
	        return;
	    }
	    Services.setCurrentNode(view, index);
	    if (lifecycles & 1048576 /* AfterContentInit */ &&
	        shouldCallLifecycleInitHook(view, 512 /* InitState_CallingAfterContentInit */, initIndex)) {
	        provider.ngAfterContentInit();
	    }
	    if (lifecycles & 2097152 /* AfterContentChecked */) {
	        provider.ngAfterContentChecked();
	    }
	    if (lifecycles & 4194304 /* AfterViewInit */ &&
	        shouldCallLifecycleInitHook(view, 768 /* InitState_CallingAfterViewInit */, initIndex)) {
	        provider.ngAfterViewInit();
	    }
	    if (lifecycles & 8388608 /* AfterViewChecked */) {
	        provider.ngAfterViewChecked();
	    }
	    if (lifecycles & 131072 /* OnDestroy */) {
	        provider.ngOnDestroy();
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} flags
	 * @param {?} id
	 * @param {?} bindings
	 * @return {?}
	 */
	function queryDef(flags, id, bindings) {
	    var /** @type {?} */ bindingDefs = [];
	    for (var /** @type {?} */ propName in bindings) {
	        var /** @type {?} */ bindingType = bindings[propName];
	        bindingDefs.push({ propName: propName, bindingType: bindingType });
	    }
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        // TODO(vicb): check
	        checkIndex: -1, flags: flags,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0,
	        ngContentIndex: -1,
	        matchedQueries: {},
	        matchedQueryIds: 0,
	        references: {},
	        childCount: 0,
	        bindings: [],
	        bindingFlags: 0,
	        outputs: [],
	        element: null,
	        provider: null,
	        text: null,
	        query: { id: id, filterId: filterQueryId(id), bindings: bindingDefs },
	        ngContent: null
	    };
	}
	/**
	 * @return {?}
	 */
	function createQuery() {
	    return new QueryList();
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function dirtyParentQueries(view) {
	    var /** @type {?} */ queryIds = view.def.nodeMatchedQueries;
	    while (view.parent && isEmbeddedView(view)) {
	        var /** @type {?} */ tplDef = /** @type {?} */ ((view.parentNodeDef));
	        view = view.parent;
	        // content queries
	        var /** @type {?} */ end = tplDef.nodeIndex + tplDef.childCount;
	        for (var /** @type {?} */ i = 0; i <= end; i++) {
	            var /** @type {?} */ nodeDef = view.def.nodes[i];
	            if ((nodeDef.flags & 67108864 /* TypeContentQuery */) &&
	                (nodeDef.flags & 536870912 /* DynamicQuery */) &&
	                (/** @type {?} */ ((nodeDef.query)).filterId & queryIds) === /** @type {?} */ ((nodeDef.query)).filterId) {
	                asQueryList(view, i).setDirty();
	            }
	            if ((nodeDef.flags & 1 /* TypeElement */ && i + nodeDef.childCount < tplDef.nodeIndex) ||
	                !(nodeDef.childFlags & 67108864 /* TypeContentQuery */) ||
	                !(nodeDef.childFlags & 536870912 /* DynamicQuery */)) {
	                // skip elements that don't contain the template element or no query.
	                i += nodeDef.childCount;
	            }
	        }
	    }
	    // view queries
	    if (view.def.nodeFlags & 134217728 /* TypeViewQuery */) {
	        for (var /** @type {?} */ i = 0; i < view.def.nodes.length; i++) {
	            var /** @type {?} */ nodeDef = view.def.nodes[i];
	            if ((nodeDef.flags & 134217728 /* TypeViewQuery */) && (nodeDef.flags & 536870912 /* DynamicQuery */)) {
	                asQueryList(view, i).setDirty();
	            }
	            // only visit the root nodes
	            i += nodeDef.childCount;
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @return {?}
	 */
	function checkAndUpdateQuery(view, nodeDef) {
	    var /** @type {?} */ queryList = asQueryList(view, nodeDef.nodeIndex);
	    if (!queryList.dirty) {
	        return;
	    }
	    var /** @type {?} */ directiveInstance;
	    var /** @type {?} */ newValues = /** @type {?} */ ((undefined));
	    if (nodeDef.flags & 67108864 /* TypeContentQuery */) {
	        var /** @type {?} */ elementDef = /** @type {?} */ ((/** @type {?} */ ((nodeDef.parent)).parent));
	        newValues = calcQueryValues(view, elementDef.nodeIndex, elementDef.nodeIndex + elementDef.childCount, /** @type {?} */ ((nodeDef.query)), []);
	        directiveInstance = asProviderData(view, /** @type {?} */ ((nodeDef.parent)).nodeIndex).instance;
	    }
	    else if (nodeDef.flags & 134217728 /* TypeViewQuery */) {
	        newValues = calcQueryValues(view, 0, view.def.nodes.length - 1, /** @type {?} */ ((nodeDef.query)), []);
	        directiveInstance = view.component;
	    }
	    queryList.reset(newValues);
	    var /** @type {?} */ bindings = /** @type {?} */ ((nodeDef.query)).bindings;
	    var /** @type {?} */ notify = false;
	    for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
	        var /** @type {?} */ binding = bindings[i];
	        var /** @type {?} */ boundValue = void 0;
	        switch (binding.bindingType) {
	            case 0 /* First */:
	                boundValue = queryList.first;
	                break;
	            case 1 /* All */:
	                boundValue = queryList;
	                notify = true;
	                break;
	        }
	        directiveInstance[binding.propName] = boundValue;
	    }
	    if (notify) {
	        queryList.notifyOnChanges();
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} startIndex
	 * @param {?} endIndex
	 * @param {?} queryDef
	 * @param {?} values
	 * @return {?}
	 */
	function calcQueryValues(view, startIndex, endIndex, queryDef, values) {
	    for (var /** @type {?} */ i = startIndex; i <= endIndex; i++) {
	        var /** @type {?} */ nodeDef = view.def.nodes[i];
	        var /** @type {?} */ valueType = nodeDef.matchedQueries[queryDef.id];
	        if (valueType != null) {
	            values.push(getQueryValue(view, nodeDef, valueType));
	        }
	        if (nodeDef.flags & 1 /* TypeElement */ && /** @type {?} */ ((nodeDef.element)).template &&
	            (/** @type {?} */ ((/** @type {?} */ ((nodeDef.element)).template)).nodeMatchedQueries & queryDef.filterId) ===
	                queryDef.filterId) {
	            var /** @type {?} */ elementData = asElementData(view, i);
	            // check embedded views that were attached at the place of their template,
	            // but process child nodes first if some match the query (see issue #16568)
	            if ((nodeDef.childMatchedQueries & queryDef.filterId) === queryDef.filterId) {
	                calcQueryValues(view, i + 1, i + nodeDef.childCount, queryDef, values);
	                i += nodeDef.childCount;
	            }
	            if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
	                var /** @type {?} */ embeddedViews = /** @type {?} */ ((elementData.viewContainer))._embeddedViews;
	                for (var /** @type {?} */ k = 0; k < embeddedViews.length; k++) {
	                    var /** @type {?} */ embeddedView = embeddedViews[k];
	                    var /** @type {?} */ dvc = declaredViewContainer(embeddedView);
	                    if (dvc && dvc === elementData) {
	                        calcQueryValues(embeddedView, 0, embeddedView.def.nodes.length - 1, queryDef, values);
	                    }
	                }
	            }
	            var /** @type {?} */ projectedViews = elementData.template._projectedViews;
	            if (projectedViews) {
	                for (var /** @type {?} */ k = 0; k < projectedViews.length; k++) {
	                    var /** @type {?} */ projectedView = projectedViews[k];
	                    calcQueryValues(projectedView, 0, projectedView.def.nodes.length - 1, queryDef, values);
	                }
	            }
	        }
	        if ((nodeDef.childMatchedQueries & queryDef.filterId) !== queryDef.filterId) {
	            // if no child matches the query, skip the children.
	            i += nodeDef.childCount;
	        }
	    }
	    return values;
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} queryValueType
	 * @return {?}
	 */
	function getQueryValue(view, nodeDef, queryValueType) {
	    if (queryValueType != null) {
	        // a match
	        switch (queryValueType) {
	            case 1 /* RenderElement */:
	                return asElementData(view, nodeDef.nodeIndex).renderElement;
	            case 0 /* ElementRef */:
	                return new ElementRef(asElementData(view, nodeDef.nodeIndex).renderElement);
	            case 2 /* TemplateRef */:
	                return asElementData(view, nodeDef.nodeIndex).template;
	            case 3 /* ViewContainerRef */:
	                return asElementData(view, nodeDef.nodeIndex).viewContainer;
	            case 4 /* Provider */:
	                return asProviderData(view, nodeDef.nodeIndex).instance;
	        }
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} ngContentIndex
	 * @param {?} index
	 * @return {?}
	 */
	function ngContentDef(ngContentIndex, index) {
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        checkIndex: -1,
	        flags: 8 /* TypeNgContent */,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0,
	        matchedQueries: {},
	        matchedQueryIds: 0,
	        references: {}, ngContentIndex: ngContentIndex,
	        childCount: 0,
	        bindings: [],
	        bindingFlags: 0,
	        outputs: [],
	        element: null,
	        provider: null,
	        text: null,
	        query: null,
	        ngContent: { index: index }
	    };
	}
	/**
	 * @param {?} view
	 * @param {?} renderHost
	 * @param {?} def
	 * @return {?}
	 */
	function appendNgContent(view, renderHost, def) {
	    var /** @type {?} */ parentEl = getParentRenderElement(view, renderHost, def);
	    if (!parentEl) {
	        // Nothing to do if there is no parent element.
	        return;
	    }
	    var /** @type {?} */ ngContentIndex = /** @type {?} */ ((def.ngContent)).index;
	    visitProjectedRenderNodes(view, ngContentIndex, 1 /* AppendChild */, parentEl, null, undefined);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} checkIndex
	 * @param {?} argCount
	 * @return {?}
	 */
	function purePipeDef(checkIndex, argCount) {
	    // argCount + 1 to include the pipe as first arg
	    return _pureExpressionDef(128 /* TypePurePipe */, checkIndex, new Array(argCount + 1));
	}
	/**
	 * @param {?} checkIndex
	 * @param {?} argCount
	 * @return {?}
	 */
	function pureArrayDef(checkIndex, argCount) {
	    return _pureExpressionDef(32 /* TypePureArray */, checkIndex, new Array(argCount));
	}
	/**
	 * @param {?} checkIndex
	 * @param {?} propToIndex
	 * @return {?}
	 */
	function pureObjectDef(checkIndex, propToIndex) {
	    var /** @type {?} */ keys = Object.keys(propToIndex);
	    var /** @type {?} */ nbKeys = keys.length;
	    var /** @type {?} */ propertyNames = new Array(nbKeys);
	    for (var /** @type {?} */ i = 0; i < nbKeys; i++) {
	        var /** @type {?} */ key = keys[i];
	        var /** @type {?} */ index = propToIndex[key];
	        propertyNames[index] = key;
	    }
	    return _pureExpressionDef(64 /* TypePureObject */, checkIndex, propertyNames);
	}
	/**
	 * @param {?} flags
	 * @param {?} checkIndex
	 * @param {?} propertyNames
	 * @return {?}
	 */
	function _pureExpressionDef(flags, checkIndex, propertyNames) {
	    var /** @type {?} */ bindings = new Array(propertyNames.length);
	    for (var /** @type {?} */ i = 0; i < propertyNames.length; i++) {
	        var /** @type {?} */ prop = propertyNames[i];
	        bindings[i] = {
	            flags: 8 /* TypeProperty */,
	            name: prop,
	            ns: null,
	            nonMinifiedName: prop,
	            securityContext: null,
	            suffix: null
	        };
	    }
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        checkIndex: checkIndex,
	        flags: flags,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0,
	        matchedQueries: {},
	        matchedQueryIds: 0,
	        references: {},
	        ngContentIndex: -1,
	        childCount: 0, bindings: bindings,
	        bindingFlags: calcBindingFlags(bindings),
	        outputs: [],
	        element: null,
	        provider: null,
	        text: null,
	        query: null,
	        ngContent: null
	    };
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @return {?}
	 */
	function createPureExpression(view, def) {
	    return { value: undefined };
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} v0
	 * @param {?} v1
	 * @param {?} v2
	 * @param {?} v3
	 * @param {?} v4
	 * @param {?} v5
	 * @param {?} v6
	 * @param {?} v7
	 * @param {?} v8
	 * @param {?} v9
	 * @return {?}
	 */
	function checkAndUpdatePureExpressionInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ bindings = def.bindings;
	    var /** @type {?} */ changed = false;
	    var /** @type {?} */ bindLen = bindings.length;
	    if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
	        changed = true;
	    if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
	        changed = true;
	    if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
	        changed = true;
	    if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
	        changed = true;
	    if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
	        changed = true;
	    if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
	        changed = true;
	    if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
	        changed = true;
	    if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
	        changed = true;
	    if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
	        changed = true;
	    if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
	        changed = true;
	    if (changed) {
	        var /** @type {?} */ data = asPureExpressionData(view, def.nodeIndex);
	        var /** @type {?} */ value = void 0;
	        switch (def.flags & 201347067 /* Types */) {
	            case 32 /* TypePureArray */:
	                value = new Array(bindings.length);
	                if (bindLen > 0)
	                    value[0] = v0;
	                if (bindLen > 1)
	                    value[1] = v1;
	                if (bindLen > 2)
	                    value[2] = v2;
	                if (bindLen > 3)
	                    value[3] = v3;
	                if (bindLen > 4)
	                    value[4] = v4;
	                if (bindLen > 5)
	                    value[5] = v5;
	                if (bindLen > 6)
	                    value[6] = v6;
	                if (bindLen > 7)
	                    value[7] = v7;
	                if (bindLen > 8)
	                    value[8] = v8;
	                if (bindLen > 9)
	                    value[9] = v9;
	                break;
	            case 64 /* TypePureObject */:
	                value = {};
	                if (bindLen > 0)
	                    value[/** @type {?} */ ((bindings[0].name))] = v0;
	                if (bindLen > 1)
	                    value[/** @type {?} */ ((bindings[1].name))] = v1;
	                if (bindLen > 2)
	                    value[/** @type {?} */ ((bindings[2].name))] = v2;
	                if (bindLen > 3)
	                    value[/** @type {?} */ ((bindings[3].name))] = v3;
	                if (bindLen > 4)
	                    value[/** @type {?} */ ((bindings[4].name))] = v4;
	                if (bindLen > 5)
	                    value[/** @type {?} */ ((bindings[5].name))] = v5;
	                if (bindLen > 6)
	                    value[/** @type {?} */ ((bindings[6].name))] = v6;
	                if (bindLen > 7)
	                    value[/** @type {?} */ ((bindings[7].name))] = v7;
	                if (bindLen > 8)
	                    value[/** @type {?} */ ((bindings[8].name))] = v8;
	                if (bindLen > 9)
	                    value[/** @type {?} */ ((bindings[9].name))] = v9;
	                break;
	            case 128 /* TypePurePipe */:
	                var /** @type {?} */ pipe = v0;
	                switch (bindLen) {
	                    case 1:
	                        value = pipe.transform(v0);
	                        break;
	                    case 2:
	                        value = pipe.transform(v1);
	                        break;
	                    case 3:
	                        value = pipe.transform(v1, v2);
	                        break;
	                    case 4:
	                        value = pipe.transform(v1, v2, v3);
	                        break;
	                    case 5:
	                        value = pipe.transform(v1, v2, v3, v4);
	                        break;
	                    case 6:
	                        value = pipe.transform(v1, v2, v3, v4, v5);
	                        break;
	                    case 7:
	                        value = pipe.transform(v1, v2, v3, v4, v5, v6);
	                        break;
	                    case 8:
	                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7);
	                        break;
	                    case 9:
	                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8);
	                        break;
	                    case 10:
	                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8, v9);
	                        break;
	                }
	                break;
	        }
	        data.value = value;
	    }
	    return changed;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} values
	 * @return {?}
	 */
	function checkAndUpdatePureExpressionDynamic(view, def, values) {
	    var /** @type {?} */ bindings = def.bindings;
	    var /** @type {?} */ changed = false;
	    for (var /** @type {?} */ i = 0; i < values.length; i++) {
	        // Note: We need to loop over all values, so that
	        // the old values are updates as well!
	        if (checkAndUpdateBinding(view, def, i, values[i])) {
	            changed = true;
	        }
	    }
	    if (changed) {
	        var /** @type {?} */ data = asPureExpressionData(view, def.nodeIndex);
	        var /** @type {?} */ value = void 0;
	        switch (def.flags & 201347067 /* Types */) {
	            case 32 /* TypePureArray */:
	                value = values;
	                break;
	            case 64 /* TypePureObject */:
	                value = {};
	                for (var /** @type {?} */ i = 0; i < values.length; i++) {
	                    value[/** @type {?} */ ((bindings[i].name))] = values[i];
	                }
	                break;
	            case 128 /* TypePurePipe */:
	                var /** @type {?} */ pipe = values[0];
	                var /** @type {?} */ params = values.slice(1);
	                value = pipe.transform.apply(pipe, params);
	                break;
	        }
	        data.value = value;
	    }
	    return changed;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} checkIndex
	 * @param {?} ngContentIndex
	 * @param {?} staticText
	 * @return {?}
	 */
	function textDef(checkIndex, ngContentIndex, staticText) {
	    var /** @type {?} */ bindings = new Array(staticText.length - 1);
	    for (var /** @type {?} */ i = 1; i < staticText.length; i++) {
	        bindings[i - 1] = {
	            flags: 8 /* TypeProperty */,
	            name: null,
	            ns: null,
	            nonMinifiedName: null,
	            securityContext: null,
	            suffix: staticText[i],
	        };
	    }
	    return {
	        // will bet set by the view definition
	        nodeIndex: -1,
	        parent: null,
	        renderParent: null,
	        bindingIndex: -1,
	        outputIndex: -1,
	        // regular values
	        checkIndex: checkIndex,
	        flags: 2 /* TypeText */,
	        childFlags: 0,
	        directChildFlags: 0,
	        childMatchedQueries: 0,
	        matchedQueries: {},
	        matchedQueryIds: 0,
	        references: {}, ngContentIndex: ngContentIndex,
	        childCount: 0, bindings: bindings,
	        bindingFlags: 8 /* TypeProperty */,
	        outputs: [],
	        element: null,
	        provider: null,
	        text: { prefix: staticText[0] },
	        query: null,
	        ngContent: null,
	    };
	}
	/**
	 * @param {?} view
	 * @param {?} renderHost
	 * @param {?} def
	 * @return {?}
	 */
	function createText(view, renderHost, def) {
	    var /** @type {?} */ renderNode$$1;
	    var /** @type {?} */ renderer = view.renderer;
	    renderNode$$1 = renderer.createText(/** @type {?} */ ((def.text)).prefix);
	    var /** @type {?} */ parentEl = getParentRenderElement(view, renderHost, def);
	    if (parentEl) {
	        renderer.appendChild(parentEl, renderNode$$1);
	    }
	    return { renderText: renderNode$$1 };
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} v0
	 * @param {?} v1
	 * @param {?} v2
	 * @param {?} v3
	 * @param {?} v4
	 * @param {?} v5
	 * @param {?} v6
	 * @param {?} v7
	 * @param {?} v8
	 * @param {?} v9
	 * @return {?}
	 */
	function checkAndUpdateTextInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ changed = false;
	    var /** @type {?} */ bindings = def.bindings;
	    var /** @type {?} */ bindLen = bindings.length;
	    if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
	        changed = true;
	    if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
	        changed = true;
	    if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
	        changed = true;
	    if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
	        changed = true;
	    if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
	        changed = true;
	    if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
	        changed = true;
	    if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
	        changed = true;
	    if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
	        changed = true;
	    if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
	        changed = true;
	    if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
	        changed = true;
	    if (changed) {
	        var /** @type {?} */ value = /** @type {?} */ ((def.text)).prefix;
	        if (bindLen > 0)
	            value += _addInterpolationPart(v0, bindings[0]);
	        if (bindLen > 1)
	            value += _addInterpolationPart(v1, bindings[1]);
	        if (bindLen > 2)
	            value += _addInterpolationPart(v2, bindings[2]);
	        if (bindLen > 3)
	            value += _addInterpolationPart(v3, bindings[3]);
	        if (bindLen > 4)
	            value += _addInterpolationPart(v4, bindings[4]);
	        if (bindLen > 5)
	            value += _addInterpolationPart(v5, bindings[5]);
	        if (bindLen > 6)
	            value += _addInterpolationPart(v6, bindings[6]);
	        if (bindLen > 7)
	            value += _addInterpolationPart(v7, bindings[7]);
	        if (bindLen > 8)
	            value += _addInterpolationPart(v8, bindings[8]);
	        if (bindLen > 9)
	            value += _addInterpolationPart(v9, bindings[9]);
	        var /** @type {?} */ renderNode$$1 = asTextData(view, def.nodeIndex).renderText;
	        view.renderer.setValue(renderNode$$1, value);
	    }
	    return changed;
	}
	/**
	 * @param {?} view
	 * @param {?} def
	 * @param {?} values
	 * @return {?}
	 */
	function checkAndUpdateTextDynamic(view, def, values) {
	    var /** @type {?} */ bindings = def.bindings;
	    var /** @type {?} */ changed = false;
	    for (var /** @type {?} */ i = 0; i < values.length; i++) {
	        // Note: We need to loop over all values, so that
	        // the old values are updates as well!
	        if (checkAndUpdateBinding(view, def, i, values[i])) {
	            changed = true;
	        }
	    }
	    if (changed) {
	        var /** @type {?} */ value = '';
	        for (var /** @type {?} */ i = 0; i < values.length; i++) {
	            value = value + _addInterpolationPart(values[i], bindings[i]);
	        }
	        value = /** @type {?} */ ((def.text)).prefix + value;
	        var /** @type {?} */ renderNode$$1 = asTextData(view, def.nodeIndex).renderText;
	        view.renderer.setValue(renderNode$$1, value);
	    }
	    return changed;
	}
	/**
	 * @param {?} value
	 * @param {?} binding
	 * @return {?}
	 */
	function _addInterpolationPart(value, binding) {
	    var /** @type {?} */ valueStr = value != null ? value.toString() : '';
	    return valueStr + binding.suffix;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} flags
	 * @param {?} nodes
	 * @param {?=} updateDirectives
	 * @param {?=} updateRenderer
	 * @return {?}
	 */
	function viewDef(flags, nodes, updateDirectives, updateRenderer) {
	    // clone nodes and set auto calculated values
	    var /** @type {?} */ viewBindingCount = 0;
	    var /** @type {?} */ viewDisposableCount = 0;
	    var /** @type {?} */ viewNodeFlags = 0;
	    var /** @type {?} */ viewRootNodeFlags = 0;
	    var /** @type {?} */ viewMatchedQueries = 0;
	    var /** @type {?} */ currentParent = null;
	    var /** @type {?} */ currentRenderParent = null;
	    var /** @type {?} */ currentElementHasPublicProviders = false;
	    var /** @type {?} */ currentElementHasPrivateProviders = false;
	    var /** @type {?} */ lastRenderRootNode = null;
	    for (var /** @type {?} */ i = 0; i < nodes.length; i++) {
	        var /** @type {?} */ node = nodes[i];
	        node.nodeIndex = i;
	        node.parent = currentParent;
	        node.bindingIndex = viewBindingCount;
	        node.outputIndex = viewDisposableCount;
	        node.renderParent = currentRenderParent;
	        viewNodeFlags |= node.flags;
	        viewMatchedQueries |= node.matchedQueryIds;
	        if (node.element) {
	            var /** @type {?} */ elDef = node.element;
	            elDef.publicProviders =
	                currentParent ? /** @type {?} */ ((currentParent.element)).publicProviders : Object.create(null);
	            elDef.allProviders = elDef.publicProviders;
	            // Note: We assume that all providers of an element are before any child element!
	            currentElementHasPublicProviders = false;
	            currentElementHasPrivateProviders = false;
	            if (node.element.template) {
	                viewMatchedQueries |= node.element.template.nodeMatchedQueries;
	            }
	        }
	        validateNode(currentParent, node, nodes.length);
	        viewBindingCount += node.bindings.length;
	        viewDisposableCount += node.outputs.length;
	        if (!currentRenderParent && (node.flags & 3 /* CatRenderNode */)) {
	            lastRenderRootNode = node;
	        }
	        if (node.flags & 20224 /* CatProvider */) {
	            if (!currentElementHasPublicProviders) {
	                currentElementHasPublicProviders = true; /** @type {?} */
	                ((/** @type {?} */ ((currentParent)).element)).publicProviders = Object.create(/** @type {?} */ ((/** @type {?} */ ((currentParent)).element)).publicProviders); /** @type {?} */
	                ((/** @type {?} */ ((currentParent)).element)).allProviders = /** @type {?} */ ((/** @type {?} */ ((currentParent)).element)).publicProviders;
	            }
	            var /** @type {?} */ isPrivateService = (node.flags & 8192 /* PrivateProvider */) !== 0;
	            var /** @type {?} */ isComponent = (node.flags & 32768 /* Component */) !== 0;
	            if (!isPrivateService || isComponent) {
	                /** @type {?} */ ((/** @type {?} */ ((/** @type {?} */ ((currentParent)).element)).publicProviders))[tokenKey(/** @type {?} */ ((node.provider)).token)] = node;
	            }
	            else {
	                if (!currentElementHasPrivateProviders) {
	                    currentElementHasPrivateProviders = true; /** @type {?} */
	                    ((/** @type {?} */ ((currentParent)).element)).allProviders = Object.create(/** @type {?} */ ((/** @type {?} */ ((currentParent)).element)).publicProviders);
	                } /** @type {?} */
	                ((/** @type {?} */ ((/** @type {?} */ ((currentParent)).element)).allProviders))[tokenKey(/** @type {?} */ ((node.provider)).token)] = node;
	            }
	            if (isComponent) {
	                /** @type {?} */ ((/** @type {?} */ ((currentParent)).element)).componentProvider = node;
	            }
	        }
	        if (currentParent) {
	            currentParent.childFlags |= node.flags;
	            currentParent.directChildFlags |= node.flags;
	            currentParent.childMatchedQueries |= node.matchedQueryIds;
	            if (node.element && node.element.template) {
	                currentParent.childMatchedQueries |= node.element.template.nodeMatchedQueries;
	            }
	        }
	        else {
	            viewRootNodeFlags |= node.flags;
	        }
	        if (node.childCount > 0) {
	            currentParent = node;
	            if (!isNgContainer(node)) {
	                currentRenderParent = node;
	            }
	        }
	        else {
	            // When the current node has no children, check if it is the last children of its parent.
	            // When it is, propagate the flags up.
	            // The loop is required because an element could be the last transitive children of several
	            // elements. We loop to either the root or the highest opened element (= with remaining
	            // children)
	            while (currentParent && i === currentParent.nodeIndex + currentParent.childCount) {
	                var /** @type {?} */ newParent = currentParent.parent;
	                if (newParent) {
	                    newParent.childFlags |= currentParent.childFlags;
	                    newParent.childMatchedQueries |= currentParent.childMatchedQueries;
	                }
	                currentParent = newParent;
	                // We also need to update the render parent & account for ng-container
	                if (currentParent && isNgContainer(currentParent)) {
	                    currentRenderParent = currentParent.renderParent;
	                }
	                else {
	                    currentRenderParent = currentParent;
	                }
	            }
	        }
	    }
	    var /** @type {?} */ handleEvent = function (view, nodeIndex, eventName, event) { return ((/** @type {?} */ ((nodes[nodeIndex].element)).handleEvent))(view, eventName, event); };
	    return {
	        // Will be filled later...
	        factory: null,
	        nodeFlags: viewNodeFlags,
	        rootNodeFlags: viewRootNodeFlags,
	        nodeMatchedQueries: viewMatchedQueries, flags: flags,
	        nodes: nodes,
	        updateDirectives: updateDirectives || NOOP,
	        updateRenderer: updateRenderer || NOOP, handleEvent: handleEvent,
	        bindingCount: viewBindingCount,
	        outputCount: viewDisposableCount, lastRenderRootNode: lastRenderRootNode
	    };
	}
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function isNgContainer(node) {
	    return (node.flags & 1 /* TypeElement */) !== 0 && /** @type {?} */ ((node.element)).name === null;
	}
	/**
	 * @param {?} parent
	 * @param {?} node
	 * @param {?} nodeCount
	 * @return {?}
	 */
	function validateNode(parent, node, nodeCount) {
	    var /** @type {?} */ template = node.element && node.element.template;
	    if (template) {
	        if (!template.lastRenderRootNode) {
	            throw new Error("Illegal State: Embedded templates without nodes are not allowed!");
	        }
	        if (template.lastRenderRootNode &&
	            template.lastRenderRootNode.flags & 16777216 /* EmbeddedViews */) {
	            throw new Error("Illegal State: Last root node of a template can't have embedded views, at index " + node.nodeIndex + "!");
	        }
	    }
	    if (node.flags & 20224 /* CatProvider */) {
	        var /** @type {?} */ parentFlags = parent ? parent.flags : 0;
	        if ((parentFlags & 1 /* TypeElement */) === 0) {
	            throw new Error("Illegal State: StaticProvider/Directive nodes need to be children of elements or anchors, at index " + node.nodeIndex + "!");
	        }
	    }
	    if (node.query) {
	        if (node.flags & 67108864 /* TypeContentQuery */ &&
	            (!parent || (parent.flags & 16384 /* TypeDirective */) === 0)) {
	            throw new Error("Illegal State: Content Query nodes need to be children of directives, at index " + node.nodeIndex + "!");
	        }
	        if (node.flags & 134217728 /* TypeViewQuery */ && parent) {
	            throw new Error("Illegal State: View Query nodes have to be top level nodes, at index " + node.nodeIndex + "!");
	        }
	    }
	    if (node.childCount) {
	        var /** @type {?} */ parentEnd = parent ? parent.nodeIndex + parent.childCount : nodeCount - 1;
	        if (node.nodeIndex <= parentEnd && node.nodeIndex + node.childCount > parentEnd) {
	            throw new Error("Illegal State: childCount of node leads outside of parent, at index " + node.nodeIndex + "!");
	        }
	    }
	}
	/**
	 * @param {?} parent
	 * @param {?} anchorDef
	 * @param {?} viewDef
	 * @param {?=} context
	 * @return {?}
	 */
	function createEmbeddedView(parent, anchorDef$$1, viewDef, context) {
	    // embedded views are seen as siblings to the anchor, so we need
	    // to get the parent of the anchor and use it as parentIndex.
	    var /** @type {?} */ view = createView(parent.root, parent.renderer, parent, anchorDef$$1, viewDef);
	    initView(view, parent.component, context);
	    createViewNodes(view);
	    return view;
	}
	/**
	 * @param {?} root
	 * @param {?} def
	 * @param {?=} context
	 * @return {?}
	 */
	function createRootView(root, def, context) {
	    var /** @type {?} */ view = createView(root, root.renderer, null, null, def);
	    initView(view, context, context);
	    createViewNodes(view);
	    return view;
	}
	/**
	 * @param {?} parentView
	 * @param {?} nodeDef
	 * @param {?} viewDef
	 * @param {?} hostElement
	 * @return {?}
	 */
	function createComponentView(parentView, nodeDef, viewDef, hostElement) {
	    var /** @type {?} */ rendererType = /** @type {?} */ ((nodeDef.element)).componentRendererType;
	    var /** @type {?} */ compRenderer;
	    if (!rendererType) {
	        compRenderer = parentView.root.renderer;
	    }
	    else {
	        compRenderer = parentView.root.rendererFactory.createRenderer(hostElement, rendererType);
	    }
	    return createView(parentView.root, compRenderer, parentView, /** @type {?} */ ((nodeDef.element)).componentProvider, viewDef);
	}
	/**
	 * @param {?} root
	 * @param {?} renderer
	 * @param {?} parent
	 * @param {?} parentNodeDef
	 * @param {?} def
	 * @return {?}
	 */
	function createView(root, renderer, parent, parentNodeDef, def) {
	    var /** @type {?} */ nodes = new Array(def.nodes.length);
	    var /** @type {?} */ disposables = def.outputCount ? new Array(def.outputCount) : null;
	    var /** @type {?} */ view = {
	        def: def,
	        parent: parent,
	        viewContainerParent: null, parentNodeDef: parentNodeDef,
	        context: null,
	        component: null, nodes: nodes,
	        state: 13 /* CatInit */, root: root, renderer: renderer,
	        oldValues: new Array(def.bindingCount), disposables: disposables,
	        initIndex: -1
	    };
	    return view;
	}
	/**
	 * @param {?} view
	 * @param {?} component
	 * @param {?} context
	 * @return {?}
	 */
	function initView(view, component, context) {
	    view.component = component;
	    view.context = context;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function createViewNodes(view) {
	    var /** @type {?} */ renderHost;
	    if (isComponentView(view)) {
	        var /** @type {?} */ hostDef = view.parentNodeDef;
	        renderHost = asElementData(/** @type {?} */ ((view.parent)), /** @type {?} */ ((/** @type {?} */ ((hostDef)).parent)).nodeIndex).renderElement;
	    }
	    var /** @type {?} */ def = view.def;
	    var /** @type {?} */ nodes = view.nodes;
	    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
	        var /** @type {?} */ nodeDef = def.nodes[i];
	        Services.setCurrentNode(view, i);
	        var /** @type {?} */ nodeData = void 0;
	        switch (nodeDef.flags & 201347067 /* Types */) {
	            case 1 /* TypeElement */:
	                var /** @type {?} */ el = /** @type {?} */ (createElement(view, renderHost, nodeDef));
	                var /** @type {?} */ componentView = /** @type {?} */ ((undefined));
	                if (nodeDef.flags & 33554432 /* ComponentView */) {
	                    var /** @type {?} */ compViewDef = resolveDefinition(/** @type {?} */ ((/** @type {?} */ ((nodeDef.element)).componentView)));
	                    componentView = Services.createComponentView(view, nodeDef, compViewDef, el);
	                }
	                listenToElementOutputs(view, componentView, nodeDef, el);
	                nodeData = /** @type {?} */ ({
	                    renderElement: el,
	                    componentView: componentView,
	                    viewContainer: null,
	                    template: /** @type {?} */ ((nodeDef.element)).template ? createTemplateData(view, nodeDef) : undefined
	                });
	                if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
	                    nodeData.viewContainer = createViewContainerData(view, nodeDef, nodeData);
	                }
	                break;
	            case 2 /* TypeText */:
	                nodeData = /** @type {?} */ (createText(view, renderHost, nodeDef));
	                break;
	            case 512 /* TypeClassProvider */:
	            case 1024 /* TypeFactoryProvider */:
	            case 2048 /* TypeUseExistingProvider */:
	            case 256 /* TypeValueProvider */: {
	                nodeData = nodes[i];
	                if (!nodeData && !(nodeDef.flags & 4096 /* LazyProvider */)) {
	                    var /** @type {?} */ instance = createProviderInstance(view, nodeDef);
	                    nodeData = /** @type {?} */ ({ instance: instance });
	                }
	                break;
	            }
	            case 16 /* TypePipe */: {
	                var /** @type {?} */ instance = createPipeInstance(view, nodeDef);
	                nodeData = /** @type {?} */ ({ instance: instance });
	                break;
	            }
	            case 16384 /* TypeDirective */: {
	                nodeData = nodes[i];
	                if (!nodeData) {
	                    var /** @type {?} */ instance = createDirectiveInstance(view, nodeDef);
	                    nodeData = /** @type {?} */ ({ instance: instance });
	                }
	                if (nodeDef.flags & 32768 /* Component */) {
	                    var /** @type {?} */ compView = asElementData(view, /** @type {?} */ ((nodeDef.parent)).nodeIndex).componentView;
	                    initView(compView, nodeData.instance, nodeData.instance);
	                }
	                break;
	            }
	            case 32 /* TypePureArray */:
	            case 64 /* TypePureObject */:
	            case 128 /* TypePurePipe */:
	                nodeData = /** @type {?} */ (createPureExpression(view, nodeDef));
	                break;
	            case 67108864 /* TypeContentQuery */:
	            case 134217728 /* TypeViewQuery */:
	                nodeData = /** @type {?} */ (createQuery());
	                break;
	            case 8 /* TypeNgContent */:
	                appendNgContent(view, renderHost, nodeDef);
	                // no runtime data needed for NgContent...
	                nodeData = undefined;
	                break;
	        }
	        nodes[i] = nodeData;
	    }
	    // Create the ViewData.nodes of component views after we created everything else,
	    // so that e.g. ng-content works
	    execComponentViewsAction(view, ViewAction.CreateViewNodes);
	    // fill static content and view queries
	    execQueriesAction(view, 67108864 /* TypeContentQuery */ | 134217728 /* TypeViewQuery */, 268435456 /* StaticQuery */, 0 /* CheckAndUpdate */);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function checkNoChangesView(view) {
	    markProjectedViewsForCheck(view);
	    Services.updateDirectives(view, 1 /* CheckNoChanges */);
	    execEmbeddedViewsAction(view, ViewAction.CheckNoChanges);
	    Services.updateRenderer(view, 1 /* CheckNoChanges */);
	    execComponentViewsAction(view, ViewAction.CheckNoChanges);
	    // Note: We don't check queries for changes as we didn't do this in v2.x.
	    // TODO(tbosch): investigate if we can enable the check again in v5.x with a nicer error message.
	    view.state &= ~(64 /* CheckProjectedViews */ | 32 /* CheckProjectedView */);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function checkAndUpdateView(view) {
	    if (view.state & 1 /* BeforeFirstCheck */) {
	        view.state &= ~1 /* BeforeFirstCheck */;
	        view.state |= 2 /* FirstCheck */;
	    }
	    else {
	        view.state &= ~2 /* FirstCheck */;
	    }
	    shiftInitState(view, 0 /* InitState_BeforeInit */, 256 /* InitState_CallingOnInit */);
	    markProjectedViewsForCheck(view);
	    Services.updateDirectives(view, 0 /* CheckAndUpdate */);
	    execEmbeddedViewsAction(view, ViewAction.CheckAndUpdate);
	    execQueriesAction(view, 67108864 /* TypeContentQuery */, 536870912 /* DynamicQuery */, 0 /* CheckAndUpdate */);
	    var /** @type {?} */ callInit = shiftInitState(view, 256 /* InitState_CallingOnInit */, 512 /* InitState_CallingAfterContentInit */);
	    callLifecycleHooksChildrenFirst(view, 2097152 /* AfterContentChecked */ | (callInit ? 1048576 /* AfterContentInit */ : 0));
	    Services.updateRenderer(view, 0 /* CheckAndUpdate */);
	    execComponentViewsAction(view, ViewAction.CheckAndUpdate);
	    execQueriesAction(view, 134217728 /* TypeViewQuery */, 536870912 /* DynamicQuery */, 0 /* CheckAndUpdate */);
	    callInit = shiftInitState(view, 512 /* InitState_CallingAfterContentInit */, 768 /* InitState_CallingAfterViewInit */);
	    callLifecycleHooksChildrenFirst(view, 8388608 /* AfterViewChecked */ | (callInit ? 4194304 /* AfterViewInit */ : 0));
	    if (view.def.flags & 2 /* OnPush */) {
	        view.state &= ~8 /* ChecksEnabled */;
	    }
	    view.state &= ~(64 /* CheckProjectedViews */ | 32 /* CheckProjectedView */);
	    shiftInitState(view, 768 /* InitState_CallingAfterViewInit */, 1024 /* InitState_AfterInit */);
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} argStyle
	 * @param {?=} v0
	 * @param {?=} v1
	 * @param {?=} v2
	 * @param {?=} v3
	 * @param {?=} v4
	 * @param {?=} v5
	 * @param {?=} v6
	 * @param {?=} v7
	 * @param {?=} v8
	 * @param {?=} v9
	 * @return {?}
	 */
	function checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    if (argStyle === 0 /* Inline */) {
	        return checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	    }
	    else {
	        return checkAndUpdateNodeDynamic(view, nodeDef, v0);
	    }
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function markProjectedViewsForCheck(view) {
	    var /** @type {?} */ def = view.def;
	    if (!(def.nodeFlags & 4 /* ProjectedTemplate */)) {
	        return;
	    }
	    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
	        var /** @type {?} */ nodeDef = def.nodes[i];
	        if (nodeDef.flags & 4 /* ProjectedTemplate */) {
	            var /** @type {?} */ projectedViews = asElementData(view, i).template._projectedViews;
	            if (projectedViews) {
	                for (var /** @type {?} */ i_1 = 0; i_1 < projectedViews.length; i_1++) {
	                    var /** @type {?} */ projectedView = projectedViews[i_1];
	                    projectedView.state |= 32 /* CheckProjectedView */;
	                    markParentViewsForCheckProjectedViews(projectedView, view);
	                }
	            }
	        }
	        else if ((nodeDef.childFlags & 4 /* ProjectedTemplate */) === 0) {
	            // a parent with leafs
	            // no child is a component,
	            // then skip the children
	            i += nodeDef.childCount;
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?=} v0
	 * @param {?=} v1
	 * @param {?=} v2
	 * @param {?=} v3
	 * @param {?=} v4
	 * @param {?=} v5
	 * @param {?=} v6
	 * @param {?=} v7
	 * @param {?=} v8
	 * @param {?=} v9
	 * @return {?}
	 */
	function checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    switch (nodeDef.flags & 201347067 /* Types */) {
	        case 1 /* TypeElement */:
	            return checkAndUpdateElementInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	        case 2 /* TypeText */:
	            return checkAndUpdateTextInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	        case 16384 /* TypeDirective */:
	            return checkAndUpdateDirectiveInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	        case 32 /* TypePureArray */:
	        case 64 /* TypePureObject */:
	        case 128 /* TypePurePipe */:
	            return checkAndUpdatePureExpressionInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	        default:
	            throw 'unreachable';
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} values
	 * @return {?}
	 */
	function checkAndUpdateNodeDynamic(view, nodeDef, values) {
	    switch (nodeDef.flags & 201347067 /* Types */) {
	        case 1 /* TypeElement */:
	            return checkAndUpdateElementDynamic(view, nodeDef, values);
	        case 2 /* TypeText */:
	            return checkAndUpdateTextDynamic(view, nodeDef, values);
	        case 16384 /* TypeDirective */:
	            return checkAndUpdateDirectiveDynamic(view, nodeDef, values);
	        case 32 /* TypePureArray */:
	        case 64 /* TypePureObject */:
	        case 128 /* TypePurePipe */:
	            return checkAndUpdatePureExpressionDynamic(view, nodeDef, values);
	        default:
	            throw 'unreachable';
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} argStyle
	 * @param {?=} v0
	 * @param {?=} v1
	 * @param {?=} v2
	 * @param {?=} v3
	 * @param {?=} v4
	 * @param {?=} v5
	 * @param {?=} v6
	 * @param {?=} v7
	 * @param {?=} v8
	 * @param {?=} v9
	 * @return {?}
	 */
	function checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    if (argStyle === 0 /* Inline */) {
	        checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	    }
	    else {
	        checkNoChangesNodeDynamic(view, nodeDef, v0);
	    }
	    // Returning false is ok here as we would have thrown in case of a change.
	    return false;
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} v0
	 * @param {?} v1
	 * @param {?} v2
	 * @param {?} v3
	 * @param {?} v4
	 * @param {?} v5
	 * @param {?} v6
	 * @param {?} v7
	 * @param {?} v8
	 * @param {?} v9
	 * @return {?}
	 */
	function checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ bindLen = nodeDef.bindings.length;
	    if (bindLen > 0)
	        checkBindingNoChanges(view, nodeDef, 0, v0);
	    if (bindLen > 1)
	        checkBindingNoChanges(view, nodeDef, 1, v1);
	    if (bindLen > 2)
	        checkBindingNoChanges(view, nodeDef, 2, v2);
	    if (bindLen > 3)
	        checkBindingNoChanges(view, nodeDef, 3, v3);
	    if (bindLen > 4)
	        checkBindingNoChanges(view, nodeDef, 4, v4);
	    if (bindLen > 5)
	        checkBindingNoChanges(view, nodeDef, 5, v5);
	    if (bindLen > 6)
	        checkBindingNoChanges(view, nodeDef, 6, v6);
	    if (bindLen > 7)
	        checkBindingNoChanges(view, nodeDef, 7, v7);
	    if (bindLen > 8)
	        checkBindingNoChanges(view, nodeDef, 8, v8);
	    if (bindLen > 9)
	        checkBindingNoChanges(view, nodeDef, 9, v9);
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} values
	 * @return {?}
	 */
	function checkNoChangesNodeDynamic(view, nodeDef, values) {
	    for (var /** @type {?} */ i = 0; i < values.length; i++) {
	        checkBindingNoChanges(view, nodeDef, i, values[i]);
	    }
	}
	/**
	 * Workaround https://github.com/angular/tsickle/issues/497
	 * @suppress {misplacedTypeAnnotation}
	 * @param {?} view
	 * @param {?} nodeDef
	 * @return {?}
	 */
	function checkNoChangesQuery(view, nodeDef) {
	    var /** @type {?} */ queryList = asQueryList(view, nodeDef.nodeIndex);
	    if (queryList.dirty) {
	        throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, nodeDef.nodeIndex), "Query " + (/** @type {?} */ ((nodeDef.query))).id + " not dirty", "Query " + (/** @type {?} */ ((nodeDef.query))).id + " dirty", (view.state & 1 /* BeforeFirstCheck */) !== 0);
	    }
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function destroyView(view) {
	    if (view.state & 128 /* Destroyed */) {
	        return;
	    }
	    execEmbeddedViewsAction(view, ViewAction.Destroy);
	    execComponentViewsAction(view, ViewAction.Destroy);
	    callLifecycleHooksChildrenFirst(view, 131072 /* OnDestroy */);
	    if (view.disposables) {
	        for (var /** @type {?} */ i = 0; i < view.disposables.length; i++) {
	            view.disposables[i]();
	        }
	    }
	    detachProjectedView(view);
	    if (view.renderer.destroyNode) {
	        destroyViewNodes(view);
	    }
	    if (isComponentView(view)) {
	        view.renderer.destroy();
	    }
	    view.state |= 128 /* Destroyed */;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function destroyViewNodes(view) {
	    var /** @type {?} */ len = view.def.nodes.length;
	    for (var /** @type {?} */ i = 0; i < len; i++) {
	        var /** @type {?} */ def = view.def.nodes[i];
	        if (def.flags & 1 /* TypeElement */) {
	            /** @type {?} */ ((view.renderer.destroyNode))(asElementData(view, i).renderElement);
	        }
	        else if (def.flags & 2 /* TypeText */) {
	            /** @type {?} */ ((view.renderer.destroyNode))(asTextData(view, i).renderText);
	        }
	        else if (def.flags & 67108864 /* TypeContentQuery */ || def.flags & 134217728 /* TypeViewQuery */) {
	            asQueryList(view, i).destroy();
	        }
	    }
	}
	/** @enum {number} */
	var ViewAction = {
	    CreateViewNodes: 0,
	    CheckNoChanges: 1,
	    CheckNoChangesProjectedViews: 2,
	    CheckAndUpdate: 3,
	    CheckAndUpdateProjectedViews: 4,
	    Destroy: 5,
	};
	ViewAction[ViewAction.CreateViewNodes] = "CreateViewNodes";
	ViewAction[ViewAction.CheckNoChanges] = "CheckNoChanges";
	ViewAction[ViewAction.CheckNoChangesProjectedViews] = "CheckNoChangesProjectedViews";
	ViewAction[ViewAction.CheckAndUpdate] = "CheckAndUpdate";
	ViewAction[ViewAction.CheckAndUpdateProjectedViews] = "CheckAndUpdateProjectedViews";
	ViewAction[ViewAction.Destroy] = "Destroy";
	/**
	 * @param {?} view
	 * @param {?} action
	 * @return {?}
	 */
	function execComponentViewsAction(view, action) {
	    var /** @type {?} */ def = view.def;
	    if (!(def.nodeFlags & 33554432 /* ComponentView */)) {
	        return;
	    }
	    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
	        var /** @type {?} */ nodeDef = def.nodes[i];
	        if (nodeDef.flags & 33554432 /* ComponentView */) {
	            // a leaf
	            callViewAction(asElementData(view, i).componentView, action);
	        }
	        else if ((nodeDef.childFlags & 33554432 /* ComponentView */) === 0) {
	            // a parent with leafs
	            // no child is a component,
	            // then skip the children
	            i += nodeDef.childCount;
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} action
	 * @return {?}
	 */
	function execEmbeddedViewsAction(view, action) {
	    var /** @type {?} */ def = view.def;
	    if (!(def.nodeFlags & 16777216 /* EmbeddedViews */)) {
	        return;
	    }
	    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
	        var /** @type {?} */ nodeDef = def.nodes[i];
	        if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
	            // a leaf
	            var /** @type {?} */ embeddedViews = /** @type {?} */ ((asElementData(view, i).viewContainer))._embeddedViews;
	            for (var /** @type {?} */ k = 0; k < embeddedViews.length; k++) {
	                callViewAction(embeddedViews[k], action);
	            }
	        }
	        else if ((nodeDef.childFlags & 16777216 /* EmbeddedViews */) === 0) {
	            // a parent with leafs
	            // no child is a component,
	            // then skip the children
	            i += nodeDef.childCount;
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} action
	 * @return {?}
	 */
	function callViewAction(view, action) {
	    var /** @type {?} */ viewState = view.state;
	    switch (action) {
	        case ViewAction.CheckNoChanges:
	            if ((viewState & 128 /* Destroyed */) === 0) {
	                if ((viewState & 12 /* CatDetectChanges */) === 12 /* CatDetectChanges */) {
	                    checkNoChangesView(view);
	                }
	                else if (viewState & 64 /* CheckProjectedViews */) {
	                    execProjectedViewsAction(view, ViewAction.CheckNoChangesProjectedViews);
	                }
	            }
	            break;
	        case ViewAction.CheckNoChangesProjectedViews:
	            if ((viewState & 128 /* Destroyed */) === 0) {
	                if (viewState & 32 /* CheckProjectedView */) {
	                    checkNoChangesView(view);
	                }
	                else if (viewState & 64 /* CheckProjectedViews */) {
	                    execProjectedViewsAction(view, action);
	                }
	            }
	            break;
	        case ViewAction.CheckAndUpdate:
	            if ((viewState & 128 /* Destroyed */) === 0) {
	                if ((viewState & 12 /* CatDetectChanges */) === 12 /* CatDetectChanges */) {
	                    checkAndUpdateView(view);
	                }
	                else if (viewState & 64 /* CheckProjectedViews */) {
	                    execProjectedViewsAction(view, ViewAction.CheckAndUpdateProjectedViews);
	                }
	            }
	            break;
	        case ViewAction.CheckAndUpdateProjectedViews:
	            if ((viewState & 128 /* Destroyed */) === 0) {
	                if (viewState & 32 /* CheckProjectedView */) {
	                    checkAndUpdateView(view);
	                }
	                else if (viewState & 64 /* CheckProjectedViews */) {
	                    execProjectedViewsAction(view, action);
	                }
	            }
	            break;
	        case ViewAction.Destroy:
	            // Note: destroyView recurses over all views,
	            // so we don't need to special case projected views here.
	            destroyView(view);
	            break;
	        case ViewAction.CreateViewNodes:
	            createViewNodes(view);
	            break;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} action
	 * @return {?}
	 */
	function execProjectedViewsAction(view, action) {
	    execEmbeddedViewsAction(view, action);
	    execComponentViewsAction(view, action);
	}
	/**
	 * @param {?} view
	 * @param {?} queryFlags
	 * @param {?} staticDynamicQueryFlag
	 * @param {?} checkType
	 * @return {?}
	 */
	function execQueriesAction(view, queryFlags, staticDynamicQueryFlag, checkType) {
	    if (!(view.def.nodeFlags & queryFlags) || !(view.def.nodeFlags & staticDynamicQueryFlag)) {
	        return;
	    }
	    var /** @type {?} */ nodeCount = view.def.nodes.length;
	    for (var /** @type {?} */ i = 0; i < nodeCount; i++) {
	        var /** @type {?} */ nodeDef = view.def.nodes[i];
	        if ((nodeDef.flags & queryFlags) && (nodeDef.flags & staticDynamicQueryFlag)) {
	            Services.setCurrentNode(view, nodeDef.nodeIndex);
	            switch (checkType) {
	                case 0 /* CheckAndUpdate */:
	                    checkAndUpdateQuery(view, nodeDef);
	                    break;
	                case 1 /* CheckNoChanges */:
	                    checkNoChangesQuery(view, nodeDef);
	                    break;
	            }
	        }
	        if (!(nodeDef.childFlags & queryFlags) || !(nodeDef.childFlags & staticDynamicQueryFlag)) {
	            // no child has a matching query
	            // then skip the children
	            i += nodeDef.childCount;
	        }
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var initialized = false;
	/**
	 * @return {?}
	 */
	function initServicesIfNeeded() {
	    if (initialized) {
	        return;
	    }
	    initialized = true;
	    var /** @type {?} */ services = isDevMode() ? createDebugServices() : createProdServices();
	    Services.setCurrentNode = services.setCurrentNode;
	    Services.createRootView = services.createRootView;
	    Services.createEmbeddedView = services.createEmbeddedView;
	    Services.createComponentView = services.createComponentView;
	    Services.createNgModuleRef = services.createNgModuleRef;
	    Services.overrideProvider = services.overrideProvider;
	    Services.overrideComponentView = services.overrideComponentView;
	    Services.clearOverrides = services.clearOverrides;
	    Services.checkAndUpdateView = services.checkAndUpdateView;
	    Services.checkNoChangesView = services.checkNoChangesView;
	    Services.destroyView = services.destroyView;
	    Services.resolveDep = resolveDep;
	    Services.createDebugContext = services.createDebugContext;
	    Services.handleEvent = services.handleEvent;
	    Services.updateDirectives = services.updateDirectives;
	    Services.updateRenderer = services.updateRenderer;
	    Services.dirtyParentQueries = dirtyParentQueries;
	}
	/**
	 * @return {?}
	 */
	function createProdServices() {
	    return {
	        setCurrentNode: function () { },
	        createRootView: createProdRootView,
	        createEmbeddedView: createEmbeddedView,
	        createComponentView: createComponentView,
	        createNgModuleRef: createNgModuleRef,
	        overrideProvider: NOOP,
	        overrideComponentView: NOOP,
	        clearOverrides: NOOP,
	        checkAndUpdateView: checkAndUpdateView,
	        checkNoChangesView: checkNoChangesView,
	        destroyView: destroyView,
	        createDebugContext: function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); },
	        handleEvent: function (view, nodeIndex, eventName, event) {
	            return view.def.handleEvent(view, nodeIndex, eventName, event);
	        },
	        updateDirectives: function (view, checkType) {
	            return view.def.updateDirectives(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
	                prodCheckNoChangesNode, view);
	        },
	        updateRenderer: function (view, checkType) {
	            return view.def.updateRenderer(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
	                prodCheckNoChangesNode, view);
	        },
	    };
	}
	/**
	 * @return {?}
	 */
	function createDebugServices() {
	    return {
	        setCurrentNode: debugSetCurrentNode,
	        createRootView: debugCreateRootView,
	        createEmbeddedView: debugCreateEmbeddedView,
	        createComponentView: debugCreateComponentView,
	        createNgModuleRef: debugCreateNgModuleRef,
	        overrideProvider: debugOverrideProvider,
	        overrideComponentView: debugOverrideComponentView,
	        clearOverrides: debugClearOverrides,
	        checkAndUpdateView: debugCheckAndUpdateView,
	        checkNoChangesView: debugCheckNoChangesView,
	        destroyView: debugDestroyView,
	        createDebugContext: function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); },
	        handleEvent: debugHandleEvent,
	        updateDirectives: debugUpdateDirectives,
	        updateRenderer: debugUpdateRenderer,
	    };
	}
	/**
	 * @param {?} elInjector
	 * @param {?} projectableNodes
	 * @param {?} rootSelectorOrNode
	 * @param {?} def
	 * @param {?} ngModule
	 * @param {?=} context
	 * @return {?}
	 */
	function createProdRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
	    var /** @type {?} */ rendererFactory = ngModule.injector.get(RendererFactory2);
	    return createRootView(createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode), def, context);
	}
	/**
	 * @param {?} elInjector
	 * @param {?} projectableNodes
	 * @param {?} rootSelectorOrNode
	 * @param {?} def
	 * @param {?} ngModule
	 * @param {?=} context
	 * @return {?}
	 */
	function debugCreateRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
	    var /** @type {?} */ rendererFactory = ngModule.injector.get(RendererFactory2);
	    var /** @type {?} */ root = createRootData(elInjector, ngModule, new DebugRendererFactory2(rendererFactory), projectableNodes, rootSelectorOrNode);
	    var /** @type {?} */ defWithOverride = applyProviderOverridesToView(def);
	    return callWithDebugContext(DebugAction.create, createRootView, null, [root, defWithOverride, context]);
	}
	/**
	 * @param {?} elInjector
	 * @param {?} ngModule
	 * @param {?} rendererFactory
	 * @param {?} projectableNodes
	 * @param {?} rootSelectorOrNode
	 * @return {?}
	 */
	function createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode) {
	    var /** @type {?} */ sanitizer = ngModule.injector.get(Sanitizer);
	    var /** @type {?} */ errorHandler = ngModule.injector.get(ErrorHandler);
	    var /** @type {?} */ renderer = rendererFactory.createRenderer(null, null);
	    return {
	        ngModule: ngModule,
	        injector: elInjector, projectableNodes: projectableNodes,
	        selectorOrNode: rootSelectorOrNode, sanitizer: sanitizer, rendererFactory: rendererFactory, renderer: renderer, errorHandler: errorHandler
	    };
	}
	/**
	 * @param {?} parentView
	 * @param {?} anchorDef
	 * @param {?} viewDef
	 * @param {?=} context
	 * @return {?}
	 */
	function debugCreateEmbeddedView(parentView, anchorDef, viewDef$$1, context) {
	    var /** @type {?} */ defWithOverride = applyProviderOverridesToView(viewDef$$1);
	    return callWithDebugContext(DebugAction.create, createEmbeddedView, null, [parentView, anchorDef, defWithOverride, context]);
	}
	/**
	 * @param {?} parentView
	 * @param {?} nodeDef
	 * @param {?} viewDef
	 * @param {?} hostElement
	 * @return {?}
	 */
	function debugCreateComponentView(parentView, nodeDef, viewDef$$1, hostElement) {
	    var /** @type {?} */ overrideComponentView = viewDefOverrides.get(/** @type {?} */ ((/** @type {?} */ ((/** @type {?} */ ((nodeDef.element)).componentProvider)).provider)).token);
	    if (overrideComponentView) {
	        viewDef$$1 = overrideComponentView;
	    }
	    else {
	        viewDef$$1 = applyProviderOverridesToView(viewDef$$1);
	    }
	    return callWithDebugContext(DebugAction.create, createComponentView, null, [parentView, nodeDef, viewDef$$1, hostElement]);
	}
	/**
	 * @param {?} moduleType
	 * @param {?} parentInjector
	 * @param {?} bootstrapComponents
	 * @param {?} def
	 * @return {?}
	 */
	function debugCreateNgModuleRef(moduleType, parentInjector, bootstrapComponents, def) {
	    var /** @type {?} */ defWithOverride = applyProviderOverridesToNgModule(def);
	    return createNgModuleRef(moduleType, parentInjector, bootstrapComponents, defWithOverride);
	}
	var providerOverrides = new Map();
	var viewDefOverrides = new Map();
	/**
	 * @param {?} override
	 * @return {?}
	 */
	function debugOverrideProvider(override) {
	    providerOverrides.set(override.token, override);
	}
	/**
	 * @param {?} comp
	 * @param {?} compFactory
	 * @return {?}
	 */
	function debugOverrideComponentView(comp, compFactory) {
	    var /** @type {?} */ hostViewDef = resolveDefinition(getComponentViewDefinitionFactory(compFactory));
	    var /** @type {?} */ compViewDef = resolveDefinition(/** @type {?} */ ((/** @type {?} */ ((hostViewDef.nodes[0].element)).componentView)));
	    viewDefOverrides.set(comp, compViewDef);
	}
	/**
	 * @return {?}
	 */
	function debugClearOverrides() {
	    providerOverrides.clear();
	    viewDefOverrides.clear();
	}
	/**
	 * @param {?} def
	 * @return {?}
	 */
	function applyProviderOverridesToView(def) {
	    if (providerOverrides.size === 0) {
	        return def;
	    }
	    var /** @type {?} */ elementIndicesWithOverwrittenProviders = findElementIndicesWithOverwrittenProviders(def);
	    if (elementIndicesWithOverwrittenProviders.length === 0) {
	        return def;
	    }
	    // clone the whole view definition,
	    // as it maintains references between the nodes that are hard to update.
	    def = /** @type {?} */ ((def.factory))(function () { return NOOP; });
	    for (var /** @type {?} */ i = 0; i < elementIndicesWithOverwrittenProviders.length; i++) {
	        applyProviderOverridesToElement(def, elementIndicesWithOverwrittenProviders[i]);
	    }
	    return def;
	    /**
	     * @param {?} def
	     * @return {?}
	     */
	    function findElementIndicesWithOverwrittenProviders(def) {
	        var /** @type {?} */ elIndicesWithOverwrittenProviders = [];
	        var /** @type {?} */ lastElementDef = null;
	        for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
	            var /** @type {?} */ nodeDef = def.nodes[i];
	            if (nodeDef.flags & 1 /* TypeElement */) {
	                lastElementDef = nodeDef;
	            }
	            if (lastElementDef && nodeDef.flags & 3840 /* CatProviderNoDirective */ &&
	                providerOverrides.has(/** @type {?} */ ((nodeDef.provider)).token)) {
	                elIndicesWithOverwrittenProviders.push(/** @type {?} */ ((lastElementDef)).nodeIndex);
	                lastElementDef = null;
	            }
	        }
	        return elIndicesWithOverwrittenProviders;
	    }
	    /**
	     * @param {?} viewDef
	     * @param {?} elIndex
	     * @return {?}
	     */
	    function applyProviderOverridesToElement(viewDef$$1, elIndex) {
	        for (var /** @type {?} */ i = elIndex + 1; i < viewDef$$1.nodes.length; i++) {
	            var /** @type {?} */ nodeDef = viewDef$$1.nodes[i];
	            if (nodeDef.flags & 1 /* TypeElement */) {
	                // stop at the next element
	                return;
	            }
	            if (nodeDef.flags & 3840 /* CatProviderNoDirective */) {
	                var /** @type {?} */ provider = /** @type {?} */ ((nodeDef.provider));
	                var /** @type {?} */ override = providerOverrides.get(provider.token);
	                if (override) {
	                    nodeDef.flags = (nodeDef.flags & ~3840 /* CatProviderNoDirective */) | override.flags;
	                    provider.deps = splitDepsDsl(override.deps);
	                    provider.value = override.value;
	                }
	            }
	        }
	    }
	}
	/**
	 * @param {?} def
	 * @return {?}
	 */
	function applyProviderOverridesToNgModule(def) {
	    var _a = calcHasOverrides(def), hasOverrides = _a.hasOverrides, hasDeprecatedOverrides = _a.hasDeprecatedOverrides;
	    if (!hasOverrides) {
	        return def;
	    }
	    // clone the whole view definition,
	    // as it maintains references between the nodes that are hard to update.
	    def = /** @type {?} */ ((def.factory))(function () { return NOOP; });
	    applyProviderOverrides(def);
	    return def;
	    /**
	     * @param {?} def
	     * @return {?}
	     */
	    function calcHasOverrides(def) {
	        var /** @type {?} */ hasOverrides = false;
	        var /** @type {?} */ hasDeprecatedOverrides = false;
	        if (providerOverrides.size === 0) {
	            return { hasOverrides: hasOverrides, hasDeprecatedOverrides: hasDeprecatedOverrides };
	        }
	        def.providers.forEach(function (node) {
	            var /** @type {?} */ override = providerOverrides.get(node.token);
	            if ((node.flags & 3840 /* CatProviderNoDirective */) && override) {
	                hasOverrides = true;
	                hasDeprecatedOverrides = hasDeprecatedOverrides || override.deprecatedBehavior;
	            }
	        });
	        return { hasOverrides: hasOverrides, hasDeprecatedOverrides: hasDeprecatedOverrides };
	    }
	    /**
	     * @param {?} def
	     * @return {?}
	     */
	    function applyProviderOverrides(def) {
	        for (var /** @type {?} */ i = 0; i < def.providers.length; i++) {
	            var /** @type {?} */ provider = def.providers[i];
	            if (hasDeprecatedOverrides) {
	                // We had a bug where me made
	                // all providers lazy. Keep this logic behind a flag
	                // for migrating existing users.
	                provider.flags |= 4096 /* LazyProvider */;
	            }
	            var /** @type {?} */ override = providerOverrides.get(provider.token);
	            if (override) {
	                provider.flags = (provider.flags & ~3840 /* CatProviderNoDirective */) | override.flags;
	                provider.deps = splitDepsDsl(override.deps);
	                provider.value = override.value;
	            }
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} checkIndex
	 * @param {?} argStyle
	 * @param {?=} v0
	 * @param {?=} v1
	 * @param {?=} v2
	 * @param {?=} v3
	 * @param {?=} v4
	 * @param {?=} v5
	 * @param {?=} v6
	 * @param {?=} v7
	 * @param {?=} v8
	 * @param {?=} v9
	 * @return {?}
	 */
	function prodCheckAndUpdateNode(view, checkIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ nodeDef = view.def.nodes[checkIndex];
	    checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	    return (nodeDef.flags & 224 /* CatPureExpression */) ?
	        asPureExpressionData(view, checkIndex).value :
	        undefined;
	}
	/**
	 * @param {?} view
	 * @param {?} checkIndex
	 * @param {?} argStyle
	 * @param {?=} v0
	 * @param {?=} v1
	 * @param {?=} v2
	 * @param {?=} v3
	 * @param {?=} v4
	 * @param {?=} v5
	 * @param {?=} v6
	 * @param {?=} v7
	 * @param {?=} v8
	 * @param {?=} v9
	 * @return {?}
	 */
	function prodCheckNoChangesNode(view, checkIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	    var /** @type {?} */ nodeDef = view.def.nodes[checkIndex];
	    checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	    return (nodeDef.flags & 224 /* CatPureExpression */) ?
	        asPureExpressionData(view, checkIndex).value :
	        undefined;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function debugCheckAndUpdateView(view) {
	    return callWithDebugContext(DebugAction.detectChanges, checkAndUpdateView, null, [view]);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function debugCheckNoChangesView(view) {
	    return callWithDebugContext(DebugAction.checkNoChanges, checkNoChangesView, null, [view]);
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function debugDestroyView(view) {
	    return callWithDebugContext(DebugAction.destroy, destroyView, null, [view]);
	}
	/** @enum {number} */
	var DebugAction = {
	    create: 0,
	    detectChanges: 1,
	    checkNoChanges: 2,
	    destroy: 3,
	    handleEvent: 4,
	};
	DebugAction[DebugAction.create] = "create";
	DebugAction[DebugAction.detectChanges] = "detectChanges";
	DebugAction[DebugAction.checkNoChanges] = "checkNoChanges";
	DebugAction[DebugAction.destroy] = "destroy";
	DebugAction[DebugAction.handleEvent] = "handleEvent";
	var _currentAction;
	var _currentView;
	var _currentNodeIndex;
	/**
	 * @param {?} view
	 * @param {?} nodeIndex
	 * @return {?}
	 */
	function debugSetCurrentNode(view, nodeIndex) {
	    _currentView = view;
	    _currentNodeIndex = nodeIndex;
	}
	/**
	 * @param {?} view
	 * @param {?} nodeIndex
	 * @param {?} eventName
	 * @param {?} event
	 * @return {?}
	 */
	function debugHandleEvent(view, nodeIndex, eventName, event) {
	    debugSetCurrentNode(view, nodeIndex);
	    return callWithDebugContext(DebugAction.handleEvent, view.def.handleEvent, null, [view, nodeIndex, eventName, event]);
	}
	/**
	 * @param {?} view
	 * @param {?} checkType
	 * @return {?}
	 */
	function debugUpdateDirectives(view, checkType) {
	    if (view.state & 128 /* Destroyed */) {
	        throw viewDestroyedError(DebugAction[_currentAction]);
	    }
	    debugSetCurrentNode(view, nextDirectiveWithBinding(view, 0));
	    return view.def.updateDirectives(debugCheckDirectivesFn, view);
	    /**
	     * @param {?} view
	     * @param {?} nodeIndex
	     * @param {?} argStyle
	     * @param {...?} values
	     * @return {?}
	     */
	    function debugCheckDirectivesFn(view, nodeIndex, argStyle) {
	        var values = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            values[_i - 3] = arguments[_i];
	        }
	        var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
	        if (checkType === 0 /* CheckAndUpdate */) {
	            debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
	        }
	        else {
	            debugCheckNoChangesNode(view, nodeDef, argStyle, values);
	        }
	        if (nodeDef.flags & 16384 /* TypeDirective */) {
	            debugSetCurrentNode(view, nextDirectiveWithBinding(view, nodeIndex));
	        }
	        return (nodeDef.flags & 224 /* CatPureExpression */) ?
	            asPureExpressionData(view, nodeDef.nodeIndex).value :
	            undefined;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} checkType
	 * @return {?}
	 */
	function debugUpdateRenderer(view, checkType) {
	    if (view.state & 128 /* Destroyed */) {
	        throw viewDestroyedError(DebugAction[_currentAction]);
	    }
	    debugSetCurrentNode(view, nextRenderNodeWithBinding(view, 0));
	    return view.def.updateRenderer(debugCheckRenderNodeFn, view);
	    /**
	     * @param {?} view
	     * @param {?} nodeIndex
	     * @param {?} argStyle
	     * @param {...?} values
	     * @return {?}
	     */
	    function debugCheckRenderNodeFn(view, nodeIndex, argStyle) {
	        var values = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            values[_i - 3] = arguments[_i];
	        }
	        var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
	        if (checkType === 0 /* CheckAndUpdate */) {
	            debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
	        }
	        else {
	            debugCheckNoChangesNode(view, nodeDef, argStyle, values);
	        }
	        if (nodeDef.flags & 3 /* CatRenderNode */) {
	            debugSetCurrentNode(view, nextRenderNodeWithBinding(view, nodeIndex));
	        }
	        return (nodeDef.flags & 224 /* CatPureExpression */) ?
	            asPureExpressionData(view, nodeDef.nodeIndex).value :
	            undefined;
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} argStyle
	 * @param {?} givenValues
	 * @return {?}
	 */
	function debugCheckAndUpdateNode(view, nodeDef, argStyle, givenValues) {
	    var /** @type {?} */ changed = (/** @type {?} */ (checkAndUpdateNode)).apply(void 0, [view, nodeDef, argStyle].concat(givenValues));
	    if (changed) {
	        var /** @type {?} */ values = argStyle === 1 /* Dynamic */ ? givenValues[0] : givenValues;
	        if (nodeDef.flags & 16384 /* TypeDirective */) {
	            var /** @type {?} */ bindingValues = {};
	            for (var /** @type {?} */ i = 0; i < nodeDef.bindings.length; i++) {
	                var /** @type {?} */ binding = nodeDef.bindings[i];
	                var /** @type {?} */ value = values[i];
	                if (binding.flags & 8 /* TypeProperty */) {
	                    bindingValues[normalizeDebugBindingName(/** @type {?} */ ((binding.nonMinifiedName)))] =
	                        normalizeDebugBindingValue(value);
	                }
	            }
	            var /** @type {?} */ elDef = /** @type {?} */ ((nodeDef.parent));
	            var /** @type {?} */ el = asElementData(view, elDef.nodeIndex).renderElement;
	            if (!/** @type {?} */ ((elDef.element)).name) {
	                // a comment.
	                view.renderer.setValue(el, "bindings=" + JSON.stringify(bindingValues, null, 2));
	            }
	            else {
	                // a regular element.
	                for (var /** @type {?} */ attr in bindingValues) {
	                    var /** @type {?} */ value = bindingValues[attr];
	                    if (value != null) {
	                        view.renderer.setAttribute(el, attr, value);
	                    }
	                    else {
	                        view.renderer.removeAttribute(el, attr);
	                    }
	                }
	            }
	        }
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} argStyle
	 * @param {?} values
	 * @return {?}
	 */
	function debugCheckNoChangesNode(view, nodeDef, argStyle, values) {
	    (/** @type {?} */ (checkNoChangesNode)).apply(void 0, [view, nodeDef, argStyle].concat(values));
	}
	/**
	 * @param {?} name
	 * @return {?}
	 */
	function normalizeDebugBindingName(name) {
	    // Attribute names with `$` (eg `x-y$`) are valid per spec, but unsupported by some browsers
	    name = camelCaseToDashCase(name.replace(/[$@]/g, '_'));
	    return "ng-reflect-" + name;
	}
	var CAMEL_CASE_REGEXP = /([A-Z])/g;
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function camelCaseToDashCase(input) {
	    return input.replace(CAMEL_CASE_REGEXP, function () {
	        var m = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            m[_i] = arguments[_i];
	        }
	        return '-' + m[1].toLowerCase();
	    });
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function normalizeDebugBindingValue(value) {
	    try {
	        // Limit the size of the value as otherwise the DOM just gets polluted.
	        return value != null ? value.toString().slice(0, 30) : value;
	    }
	    catch (/** @type {?} */ e) {
	        return '[ERROR] Exception while trying to serialize the value';
	    }
	}
	/**
	 * @param {?} view
	 * @param {?} nodeIndex
	 * @return {?}
	 */
	function nextDirectiveWithBinding(view, nodeIndex) {
	    for (var /** @type {?} */ i = nodeIndex; i < view.def.nodes.length; i++) {
	        var /** @type {?} */ nodeDef = view.def.nodes[i];
	        if (nodeDef.flags & 16384 /* TypeDirective */ && nodeDef.bindings && nodeDef.bindings.length) {
	            return i;
	        }
	    }
	    return null;
	}
	/**
	 * @param {?} view
	 * @param {?} nodeIndex
	 * @return {?}
	 */
	function nextRenderNodeWithBinding(view, nodeIndex) {
	    for (var /** @type {?} */ i = nodeIndex; i < view.def.nodes.length; i++) {
	        var /** @type {?} */ nodeDef = view.def.nodes[i];
	        if ((nodeDef.flags & 3 /* CatRenderNode */) && nodeDef.bindings && nodeDef.bindings.length) {
	            return i;
	        }
	    }
	    return null;
	}
	var DebugContext_ = /** @class */ (function () {
	    function DebugContext_(view, nodeIndex) {
	        this.view = view;
	        this.nodeIndex = nodeIndex;
	        if (nodeIndex == null) {
	            this.nodeIndex = nodeIndex = 0;
	        }
	        this.nodeDef = view.def.nodes[nodeIndex];
	        var /** @type {?} */ elDef = this.nodeDef;
	        var /** @type {?} */ elView = view;
	        while (elDef && (elDef.flags & 1 /* TypeElement */) === 0) {
	            elDef = /** @type {?} */ ((elDef.parent));
	        }
	        if (!elDef) {
	            while (!elDef && elView) {
	                elDef = /** @type {?} */ ((viewParentEl(elView)));
	                elView = /** @type {?} */ ((elView.parent));
	            }
	        }
	        this.elDef = elDef;
	        this.elView = elView;
	    }
	    Object.defineProperty(DebugContext_.prototype, "elOrCompView", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            // Has to be done lazily as we use the DebugContext also during creation of elements...
	            return asElementData(this.elView, this.elDef.nodeIndex).componentView || this.view;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "injector", {
	        get: /**
	         * @return {?}
	         */
	        function () { return createInjector(this.elView, this.elDef); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "component", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.elOrCompView.component; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "context", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.elOrCompView.context; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "providerTokens", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ tokens = [];
	            if (this.elDef) {
	                for (var /** @type {?} */ i = this.elDef.nodeIndex + 1; i <= this.elDef.nodeIndex + this.elDef.childCount; i++) {
	                    var /** @type {?} */ childDef = this.elView.def.nodes[i];
	                    if (childDef.flags & 20224 /* CatProvider */) {
	                        tokens.push(/** @type {?} */ ((childDef.provider)).token);
	                    }
	                    i += childDef.childCount;
	                }
	            }
	            return tokens;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "references", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ references = {};
	            if (this.elDef) {
	                collectReferences(this.elView, this.elDef, references);
	                for (var /** @type {?} */ i = this.elDef.nodeIndex + 1; i <= this.elDef.nodeIndex + this.elDef.childCount; i++) {
	                    var /** @type {?} */ childDef = this.elView.def.nodes[i];
	                    if (childDef.flags & 20224 /* CatProvider */) {
	                        collectReferences(this.elView, childDef, references);
	                    }
	                    i += childDef.childCount;
	                }
	            }
	            return references;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "componentRenderElement", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ elData = findHostElement(this.elOrCompView);
	            return elData ? elData.renderElement : undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DebugContext_.prototype, "renderNode", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this.nodeDef.flags & 2 /* TypeText */ ? renderNode(this.view, this.nodeDef) :
	                renderNode(this.elView, this.elDef);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} console
	     * @param {...?} values
	     * @return {?}
	     */
	    DebugContext_.prototype.logError = /**
	     * @param {?} console
	     * @param {...?} values
	     * @return {?}
	     */
	    function (console) {
	        var values = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            values[_i - 1] = arguments[_i];
	        }
	        var /** @type {?} */ logViewDef;
	        var /** @type {?} */ logNodeIndex;
	        if (this.nodeDef.flags & 2 /* TypeText */) {
	            logViewDef = this.view.def;
	            logNodeIndex = this.nodeDef.nodeIndex;
	        }
	        else {
	            logViewDef = this.elView.def;
	            logNodeIndex = this.elDef.nodeIndex;
	        }
	        // Note: we only generate a log function for text and element nodes
	        // to make the generated code as small as possible.
	        var /** @type {?} */ renderNodeIndex = getRenderNodeIndex(logViewDef, logNodeIndex);
	        var /** @type {?} */ currRenderNodeIndex = -1;
	        var /** @type {?} */ nodeLogger = function () {
	            currRenderNodeIndex++;
	            if (currRenderNodeIndex === renderNodeIndex) {
	                return (_a = console.error).bind.apply(_a, [console].concat(values));
	            }
	            else {
	                return NOOP;
	            }
	            var _a;
	        }; /** @type {?} */
	        ((logViewDef.factory))(nodeLogger);
	        if (currRenderNodeIndex < renderNodeIndex) {
	            console.error('Illegal state: the ViewDefinitionFactory did not call the logger!');
	            console.error.apply(console, values);
	        }
	    };
	    return DebugContext_;
	}());
	/**
	 * @param {?} viewDef
	 * @param {?} nodeIndex
	 * @return {?}
	 */
	function getRenderNodeIndex(viewDef$$1, nodeIndex) {
	    var /** @type {?} */ renderNodeIndex = -1;
	    for (var /** @type {?} */ i = 0; i <= nodeIndex; i++) {
	        var /** @type {?} */ nodeDef = viewDef$$1.nodes[i];
	        if (nodeDef.flags & 3 /* CatRenderNode */) {
	            renderNodeIndex++;
	        }
	    }
	    return renderNodeIndex;
	}
	/**
	 * @param {?} view
	 * @return {?}
	 */
	function findHostElement(view) {
	    while (view && !isComponentView(view)) {
	        view = /** @type {?} */ ((view.parent));
	    }
	    if (view.parent) {
	        return asElementData(view.parent, /** @type {?} */ ((viewParentEl(view))).nodeIndex);
	    }
	    return null;
	}
	/**
	 * @param {?} view
	 * @param {?} nodeDef
	 * @param {?} references
	 * @return {?}
	 */
	function collectReferences(view, nodeDef, references) {
	    for (var /** @type {?} */ refName in nodeDef.references) {
	        references[refName] = getQueryValue(view, nodeDef, nodeDef.references[refName]);
	    }
	}
	/**
	 * @param {?} action
	 * @param {?} fn
	 * @param {?} self
	 * @param {?} args
	 * @return {?}
	 */
	function callWithDebugContext(action, fn, self, args) {
	    var /** @type {?} */ oldAction = _currentAction;
	    var /** @type {?} */ oldView = _currentView;
	    var /** @type {?} */ oldNodeIndex = _currentNodeIndex;
	    try {
	        _currentAction = action;
	        var /** @type {?} */ result = fn.apply(self, args);
	        _currentView = oldView;
	        _currentNodeIndex = oldNodeIndex;
	        _currentAction = oldAction;
	        return result;
	    }
	    catch (/** @type {?} */ e) {
	        if (isViewDebugError(e) || !_currentView) {
	            throw e;
	        }
	        throw viewWrappedDebugError(e, /** @type {?} */ ((getCurrentDebugContext())));
	    }
	}
	/**
	 * @return {?}
	 */
	function getCurrentDebugContext() {
	    return _currentView ? new DebugContext_(_currentView, _currentNodeIndex) : null;
	}
	var DebugRendererFactory2 = /** @class */ (function () {
	    function DebugRendererFactory2(delegate) {
	        this.delegate = delegate;
	    }
	    /**
	     * @param {?} element
	     * @param {?} renderData
	     * @return {?}
	     */
	    DebugRendererFactory2.prototype.createRenderer = /**
	     * @param {?} element
	     * @param {?} renderData
	     * @return {?}
	     */
	    function (element, renderData) {
	        return new DebugRenderer2(this.delegate.createRenderer(element, renderData));
	    };
	    /**
	     * @return {?}
	     */
	    DebugRendererFactory2.prototype.begin = /**
	     * @return {?}
	     */
	    function () {
	        if (this.delegate.begin) {
	            this.delegate.begin();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    DebugRendererFactory2.prototype.end = /**
	     * @return {?}
	     */
	    function () {
	        if (this.delegate.end) {
	            this.delegate.end();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    DebugRendererFactory2.prototype.whenRenderingDone = /**
	     * @return {?}
	     */
	    function () {
	        if (this.delegate.whenRenderingDone) {
	            return this.delegate.whenRenderingDone();
	        }
	        return Promise.resolve(null);
	    };
	    return DebugRendererFactory2;
	}());
	var DebugRenderer2 = /** @class */ (function () {
	    function DebugRenderer2(delegate) {
	        this.delegate = delegate;
	        this.data = this.delegate.data;
	    }
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    DebugRenderer2.prototype.destroyNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        removeDebugNodeFromIndex(/** @type {?} */ ((getDebugNode(node))));
	        if (this.delegate.destroyNode) {
	            this.delegate.destroyNode(node);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    DebugRenderer2.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { this.delegate.destroy(); };
	    /**
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    DebugRenderer2.prototype.createElement = /**
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (name, namespace) {
	        var /** @type {?} */ el = this.delegate.createElement(name, namespace);
	        var /** @type {?} */ debugCtx = getCurrentDebugContext();
	        if (debugCtx) {
	            var /** @type {?} */ debugEl = new DebugElement(el, null, debugCtx);
	            debugEl.name = name;
	            indexDebugNode(debugEl);
	        }
	        return el;
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DebugRenderer2.prototype.createComment = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ comment = this.delegate.createComment(value);
	        var /** @type {?} */ debugCtx = getCurrentDebugContext();
	        if (debugCtx) {
	            indexDebugNode(new DebugNode(comment, null, debugCtx));
	        }
	        return comment;
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DebugRenderer2.prototype.createText = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ text = this.delegate.createText(value);
	        var /** @type {?} */ debugCtx = getCurrentDebugContext();
	        if (debugCtx) {
	            indexDebugNode(new DebugNode(text, null, debugCtx));
	        }
	        return text;
	    };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    DebugRenderer2.prototype.appendChild = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    function (parent, newChild) {
	        var /** @type {?} */ debugEl = getDebugNode(parent);
	        var /** @type {?} */ debugChildEl = getDebugNode(newChild);
	        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
	            debugEl.addChild(debugChildEl);
	        }
	        this.delegate.appendChild(parent, newChild);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    DebugRenderer2.prototype.insertBefore = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    function (parent, newChild, refChild) {
	        var /** @type {?} */ debugEl = getDebugNode(parent);
	        var /** @type {?} */ debugChildEl = getDebugNode(newChild);
	        var /** @type {?} */ debugRefEl = /** @type {?} */ ((getDebugNode(refChild)));
	        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
	            debugEl.insertBefore(debugRefEl, debugChildEl);
	        }
	        this.delegate.insertBefore(parent, newChild, refChild);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    DebugRenderer2.prototype.removeChild = /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    function (parent, oldChild) {
	        var /** @type {?} */ debugEl = getDebugNode(parent);
	        var /** @type {?} */ debugChildEl = getDebugNode(oldChild);
	        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
	            debugEl.removeChild(debugChildEl);
	        }
	        this.delegate.removeChild(parent, oldChild);
	    };
	    /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    DebugRenderer2.prototype.selectRootElement = /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    function (selectorOrNode) {
	        var /** @type {?} */ el = this.delegate.selectRootElement(selectorOrNode);
	        var /** @type {?} */ debugCtx = getCurrentDebugContext();
	        if (debugCtx) {
	            indexDebugNode(new DebugElement(el, null, debugCtx));
	        }
	        return el;
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @param {?=} namespace
	     * @return {?}
	     */
	    DebugRenderer2.prototype.setAttribute = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (el, name, value, namespace) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            var /** @type {?} */ fullName = namespace ? namespace + ':' + name : name;
	            debugEl.attributes[fullName] = value;
	        }
	        this.delegate.setAttribute(el, name, value, namespace);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    DebugRenderer2.prototype.removeAttribute = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (el, name, namespace) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            var /** @type {?} */ fullName = namespace ? namespace + ':' + name : name;
	            debugEl.attributes[fullName] = null;
	        }
	        this.delegate.removeAttribute(el, name, namespace);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    DebugRenderer2.prototype.addClass = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            debugEl.classes[name] = true;
	        }
	        this.delegate.addClass(el, name);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    DebugRenderer2.prototype.removeClass = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            debugEl.classes[name] = false;
	        }
	        this.delegate.removeClass(el, name);
	    };
	    /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} value
	     * @param {?} flags
	     * @return {?}
	     */
	    DebugRenderer2.prototype.setStyle = /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} value
	     * @param {?} flags
	     * @return {?}
	     */
	    function (el, style, value, flags) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            debugEl.styles[style] = value;
	        }
	        this.delegate.setStyle(el, style, value, flags);
	    };
	    /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} flags
	     * @return {?}
	     */
	    DebugRenderer2.prototype.removeStyle = /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} flags
	     * @return {?}
	     */
	    function (el, style, flags) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            debugEl.styles[style] = null;
	        }
	        this.delegate.removeStyle(el, style, flags);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    DebugRenderer2.prototype.setProperty = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, name, value) {
	        var /** @type {?} */ debugEl = getDebugNode(el);
	        if (debugEl && debugEl instanceof DebugElement) {
	            debugEl.properties[name] = value;
	        }
	        this.delegate.setProperty(el, name, value);
	    };
	    /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    DebugRenderer2.prototype.listen = /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    function (target, eventName, callback) {
	        if (typeof target !== 'string') {
	            var /** @type {?} */ debugEl = getDebugNode(target);
	            if (debugEl) {
	                debugEl.listeners.push(new EventListener(eventName, callback));
	            }
	        }
	        return this.delegate.listen(target, eventName, callback);
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    DebugRenderer2.prototype.parentNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return this.delegate.parentNode(node); };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    DebugRenderer2.prototype.nextSibling = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return this.delegate.nextSibling(node); };
	    /**
	     * @param {?} node
	     * @param {?} value
	     * @return {?}
	     */
	    DebugRenderer2.prototype.setValue = /**
	     * @param {?} node
	     * @param {?} value
	     * @return {?}
	     */
	    function (node, value) { return this.delegate.setValue(node, value); };
	    return DebugRenderer2;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} override
	 * @return {?}
	 */
	function overrideProvider(override) {
	    initServicesIfNeeded();
	    return Services.overrideProvider(override);
	}
	/**
	 * @param {?} comp
	 * @param {?} componentFactory
	 * @return {?}
	 */
	function overrideComponentView(comp, componentFactory) {
	    initServicesIfNeeded();
	    return Services.overrideComponentView(comp, componentFactory);
	}
	/**
	 * @return {?}
	 */
	function clearOverrides() {
	    initServicesIfNeeded();
	    return Services.clearOverrides();
	}
	/**
	 * @param {?} ngModuleType
	 * @param {?} bootstrapComponents
	 * @param {?} defFactory
	 * @return {?}
	 */
	function createNgModuleFactory(ngModuleType, bootstrapComponents, defFactory) {
	    return new NgModuleFactory_(ngModuleType, bootstrapComponents, defFactory);
	}
	var NgModuleFactory_ = /** @class */ (function (_super) {
	    __extends(NgModuleFactory_, _super);
	    function NgModuleFactory_(moduleType, _bootstrapComponents, _ngModuleDefFactory) {
	        var _this = 
	        // Attention: this ctor is called as top level function.
	        // Putting any logic in here will destroy closure tree shaking!
	        _super.call(this) || this;
	        _this.moduleType = moduleType;
	        _this._bootstrapComponents = _bootstrapComponents;
	        _this._ngModuleDefFactory = _ngModuleDefFactory;
	        return _this;
	    }
	    /**
	     * @param {?} parentInjector
	     * @return {?}
	     */
	    NgModuleFactory_.prototype.create = /**
	     * @param {?} parentInjector
	     * @return {?}
	     */
	    function (parentInjector) {
	        initServicesIfNeeded();
	        var /** @type {?} */ def = resolveDefinition(this._ngModuleDefFactory);
	        return Services.createNgModuleRef(this.moduleType, parentInjector || Injector.NULL, this._bootstrapComponents, def);
	    };
	    return NgModuleFactory_;
	}(NgModuleFactory));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// The functions in this file verify that the assumptions we are making
	// about state in an instruction are correct before implementing any logic.
	// They are meant only to be called in dev mode as sanity checks.
	/**
	 * Stringifies values such that strings are wrapped in explicit quotation marks and
	 * other types are stringified normally. Used in error messages (e.g. assertThrow)
	 * to make it clear that certain values are of the string type when comparing.
	 *
	 * e.g. `expected "3" to be 3` is easier to understand than `expected 3 to be 3`.
	 *
	 * @param {?} value The value to be stringified
	 * @return {?} The stringified value
	 */
	function stringifyValueForError(value) {
	    return typeof value === 'string' ? "\"" + value + "\"" : '' + value;
	}
	/**
	 * @param {?} actual
	 * @param {?} name
	 * @return {?}
	 */
	
	/**
	 * @template T
	 * @param {?} actual
	 * @param {?} expected
	 * @param {?} name
	 * @param {?=} serializer
	 * @return {?}
	 */
	function assertEqual(actual, expected, name, serializer) {
	    (actual != expected) && assertThrow(actual, expected, name, '==', serializer);
	}
	/**
	 * @template T
	 * @param {?} actual
	 * @param {?} expected
	 * @param {?} name
	 * @return {?}
	 */
	function assertLessThan(actual, expected, name) {
	    (actual < expected) && assertThrow(actual, expected, name, '>');
	}
	/**
	 * @template T
	 * @param {?} actual
	 * @param {?} name
	 * @return {?}
	 */
	function assertNotNull(actual, name) {
	    assertNotEqual(actual, null, name);
	}
	/**
	 * @template T
	 * @param {?} actual
	 * @param {?} expected
	 * @param {?} name
	 * @return {?}
	 */
	function assertNotEqual(actual, expected, name) {
	    (actual == expected) && assertThrow(actual, expected, name, '!=');
	}
	/**
	 * Throws an error with a message constructed from the arguments.
	 *
	 * @template T
	 * @param {?} actual The actual value (e.g. 3)
	 * @param {?} expected The expected value (e.g. 5)
	 * @param {?} name The name of the value being checked (e.g. attrs.length)
	 * @param {?} operator The comparison operator (e.g. <, >, ==)
	 * @param {?=} serializer Function that maps a value to its display value
	 * @return {?}
	 */
	function assertThrow(actual, expected, name, operator, serializer) {
	    if (serializer === void 0) { serializer = stringifyValueForError; }
	    throw new Error("ASSERT: expected " + name + " " + operator + " " + serializer(expected) + " but was " + serializer(actual) + "!");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	if (typeof ngDevMode == 'undefined') {
	    if (typeof window != 'undefined')
	        (/** @type {?} */ (window)).ngDevMode = true;
	    if (typeof self != 'undefined')
	        (/** @type {?} */ (self)).ngDevMode = true;
	    if (typeof global != 'undefined')
	        (/** @type {?} */ (global)).ngDevMode = true;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} node
	 * @param {?} type
	 * @return {?}
	 */
	function assertNodeType(node, type) {
	    assertNotEqual(node, null, 'node');
	    assertEqual(node.flags & 3 /* TYPE_MASK */, type, 'Node.type', typeSerializer);
	}
	/**
	 * @param {?} node
	 * @param {...?} types
	 * @return {?}
	 */
	
	/**
	 * @param {?} type
	 * @return {?}
	 */
	function typeSerializer(type) {
	    if (type == 1 /* Projection */)
	        return 'Projection';
	    if (type == 0 /* Container */)
	        return 'Container';
	    if (type == 2 /* View */)
	        return 'View';
	    if (type == 3 /* Element */)
	        return 'Element';
	    return '??? ' + type + ' ???';
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Finds the closest DOM node above a given container in the hierarchy.
	 *
	 * This is necessary to add or remove elements from the DOM when a view
	 * is added or removed from the container. e.g. parent.removeChild(...)
	 *
	 * @param {?} containerNode The container node whose parent must be found
	 * @return {?} Closest DOM node above the container
	 */
	function findNativeParent(containerNode) {
	    var /** @type {?} */ container = containerNode;
	    while (container) {
	        ngDevMode && assertNodeType(container, 0 /* Container */);
	        var /** @type {?} */ renderParent = container.data.renderParent;
	        if (renderParent !== null) {
	            return renderParent.native;
	        }
	        var /** @type {?} */ viewOrElement = /** @type {?} */ ((container.parent));
	        ngDevMode && assertNotNull(viewOrElement, 'container.parent');
	        if ((viewOrElement.flags & 3 /* TYPE_MASK */) === 3 /* Element */) {
	            // we are an LElement, which means we are past the last LContainer.
	            // This means than we have not been projected so just ignore.
	            return null;
	        }
	        ngDevMode && assertNodeType(viewOrElement, 2 /* View */);
	        container = (/** @type {?} */ (viewOrElement)).parent;
	    }
	    return null;
	}
	/**
	 * Finds the DOM element before which a certain view should be inserting its
	 * child elements.
	 *
	 * If the view has a next (e.g. for loop), elements should be inserted before
	 * the next view's first child element. Otherwise, the container's comment
	 * anchor is the marker.
	 *
	 * @param {?} index The index of the view to check
	 * @param {?} state ContainerState of the parent container
	 * @param {?} native Comment anchor for container
	 * @return {?} The DOM element for which the view should insert elements
	 */
	function findBeforeNode(index, state, native) {
	    var /** @type {?} */ views = state.views;
	    // Find the node to insert in front of
	    return index + 1 < views.length ?
	        (/** @type {?} */ (views[index + 1].child)).native :
	        native;
	}
	/**
	 * @param {?} container
	 * @param {?} rootNode
	 * @param {?} insertMode
	 * @param {?=} beforeNode
	 * @return {?}
	 */
	function addRemoveViewFromContainer(container, rootNode, insertMode, beforeNode) {
	    ngDevMode && assertNodeType(container, 0 /* Container */);
	    ngDevMode && assertNodeType(rootNode, 2 /* View */);
	    var /** @type {?} */ parent = findNativeParent(container);
	    var /** @type {?} */ node = rootNode.child;
	    if (parent) {
	        while (node) {
	            var /** @type {?} */ type = node.flags & 3;
	            var /** @type {?} */ nextNode = null;
	            var /** @type {?} */ renderer = container.view.renderer;
	            var /** @type {?} */ isFnRenderer = (/** @type {?} */ (renderer)).listen;
	            if (type === 3 /* Element */) {
	                insertMode ? (isFnRenderer ? /** @type {?} */ (((/** @type {?} */ (renderer))
	                    .insertBefore))(parent, /** @type {?} */ ((node.native)), /** @type {?} */ (beforeNode)) :
	                    parent.insertBefore(/** @type {?} */ ((node.native)), /** @type {?} */ (beforeNode), true)) :
	                    (isFnRenderer ? /** @type {?} */ (((/** @type {?} */ (renderer))
	                        .removeChild))(/** @type {?} */ (parent), /** @type {?} */ ((node.native))) :
	                        parent.removeChild(/** @type {?} */ ((node.native))));
	                nextNode = node.next;
	            }
	            else if (type === 0 /* Container */) {
	                // if we get to a container, it must be a root node of a view because we are only
	                // propagating down into child views / containers and not child elements
	                var /** @type {?} */ childContainerData = (/** @type {?} */ (node)).data;
	                insertMode ? (isFnRenderer ? /** @type {?} */ (((/** @type {?} */ (renderer))
	                    .appendChild))(/** @type {?} */ (parent), /** @type {?} */ ((node.native))) :
	                    parent.appendChild(/** @type {?} */ ((node.native)))) :
	                    (isFnRenderer ? /** @type {?} */ (((/** @type {?} */ (renderer))
	                        .removeChild))(/** @type {?} */ (parent), /** @type {?} */ ((node.native))) :
	                        parent.removeChild(/** @type {?} */ ((node.native))));
	                nextNode = childContainerData.views.length ? childContainerData.views[0].child : null;
	            }
	            else if (type === 1 /* Projection */) {
	                nextNode = (/** @type {?} */ (node)).data[0];
	            }
	            else {
	                nextNode = (/** @type {?} */ (node)).child;
	            }
	            if (nextNode === null) {
	                while (node && !node.next) {
	                    node = node.parent;
	                    if (node === rootNode)
	                        node = null;
	                }
	                node = node && node.next;
	            }
	            else {
	                node = nextNode;
	            }
	        }
	    }
	}
	/**
	 * Traverses the tree of component views and containers to remove listeners and
	 * call onDestroy callbacks.
	 *
	 * Notes:
	 *  - Because it's used for onDestroy calls, it needs to be bottom-up.
	 *  - Must process containers instead of their views to avoid splicing
	 *  when views are destroyed and re-added.
	 *  - Using a while loop because it's faster than recursion
	 *  - Destroy only called on movement to sibling or movement to parent (laterally or up)
	 *
	 *  \@param rootView The view to destroy
	 * @param {?} rootView
	 * @return {?}
	 */
	function destroyViewTree(rootView) {
	    var /** @type {?} */ viewOrContainerState = rootView;
	    while (viewOrContainerState) {
	        var /** @type {?} */ next = null;
	        if (viewOrContainerState.views && viewOrContainerState.views.length) {
	            next = viewOrContainerState.views[0].data;
	        }
	        else if (viewOrContainerState.child) {
	            next = viewOrContainerState.child;
	        }
	        else if (viewOrContainerState.next) {
	            cleanUpView(/** @type {?} */ (viewOrContainerState));
	            next = viewOrContainerState.next;
	        }
	        if (next == null) {
	            while (viewOrContainerState && !/** @type {?} */ ((viewOrContainerState)).next) {
	                cleanUpView(/** @type {?} */ (viewOrContainerState));
	                viewOrContainerState = getParentState(viewOrContainerState, rootView);
	            }
	            cleanUpView(/** @type {?} */ (viewOrContainerState) || rootView);
	            next = viewOrContainerState && viewOrContainerState.next;
	        }
	        viewOrContainerState = next;
	    }
	}
	/**
	 * Inserts a view into a container.
	 *
	 * This adds the view to the container's array of active views in the correct
	 * position. It also adds the view's elements to the DOM if the container isn't a
	 * root node of another view (in that case, the view's elements will be added when
	 * the container's parent view is added later).
	 *
	 * @param {?} container The container into which the view should be inserted
	 * @param {?} newView The view to insert
	 * @param {?} index The index at which to insert the view
	 * @return {?} The inserted view
	 */
	function insertView(container, newView, index) {
	    var /** @type {?} */ state = container.data;
	    var /** @type {?} */ views = state.views;
	    if (index > 0) {
	        // This is a new view, we need to add it to the children.
	        setViewNext(views[index - 1], newView);
	    }
	    if (index < views.length && views[index].data.id !== newView.data.id) {
	        // View ID change replace the view.
	        setViewNext(newView, views[index]);
	        views.splice(index, 0, newView);
	    }
	    else if (index >= views.length) {
	        views.push(newView);
	    }
	    if (state.nextIndex <= index) {
	        state.nextIndex++;
	    }
	    // If the container's renderParent is null, we know that it is a root node of its own parent view
	    // and we should wait until that parent processes its nodes (otherwise, we will insert this view's
	    // nodes twice - once now and once when its parent inserts its views).
	    if (container.data.renderParent !== null) {
	        addRemoveViewFromContainer(container, newView, true, findBeforeNode(index, state, container.native));
	    }
	    // Notify query that view has been inserted
	    container.query && container.query.insertView(container, newView, index);
	    return newView;
	}
	/**
	 * Removes a view from a container.
	 *
	 * This method splices the view from the container's array of active views. It also
	 * removes the view's elements from the DOM and conducts cleanup (e.g. removing
	 * listeners, calling onDestroys).
	 *
	 * @param {?} container The container from which to remove a view
	 * @param {?} removeIndex The index of the view to remove
	 * @return {?} The removed view
	 */
	function removeView(container, removeIndex) {
	    var /** @type {?} */ views = container.data.views;
	    var /** @type {?} */ viewNode = views[removeIndex];
	    if (removeIndex > 0) {
	        setViewNext(views[removeIndex - 1], viewNode.next);
	    }
	    views.splice(removeIndex, 1);
	    destroyViewTree(viewNode.data);
	    addRemoveViewFromContainer(container, viewNode, false);
	    // Notify query that view has been removed
	    container.query && container.query.removeView(container, viewNode, removeIndex);
	    return viewNode;
	}
	/**
	 * Sets a next on the view node, so views in for loops can easily jump from
	 * one view to the next to add/remove elements. Also adds the ViewState (view.data)
	 * to the view tree for easy traversal when cleaning up the view.
	 *
	 * @param {?} view The view to set up
	 * @param {?} next The view's new next
	 * @return {?}
	 */
	function setViewNext(view, next) {
	    view.next = next;
	    view.data.next = next ? next.data : null;
	}
	/**
	 * Determines which ViewOrContainerState to jump to when traversing back up the
	 * tree in destroyViewTree.
	 *
	 * Normally, the view's parent ViewState should be checked, but in the case of
	 * embedded views, the container (which is the view node's parent, but not the
	 * ViewState's parent) needs to be checked for a possible next property.
	 *
	 * @param {?} state The ViewOrContainerState for which we need a parent state
	 * @param {?} rootView The rootView, so we don't propagate too far up the view tree
	 * @return {?} The correct parent ViewOrContainerState
	 */
	function getParentState(state, rootView) {
	    var /** @type {?} */ node;
	    if ((node = /** @type {?} */ (((/** @type {?} */ (state)))).node) &&
	        (node.flags & 3 /* TYPE_MASK */) === 2 /* View */) {
	        // if it's an embedded view, the state needs to go up to the container, in case the
	        // container has a next
	        return /** @type {?} */ (((node.parent)).data);
	    }
	    else {
	        // otherwise, use parent view for containers or component views
	        return state.parent === rootView ? null : state.parent;
	    }
	}
	/**
	 * Removes all listeners and call all onDestroys in a given view.
	 *
	 * @param {?} viewState The ViewState of the view to clean up
	 * @return {?}
	 */
	function cleanUpView(viewState) {
	    if (!viewState.cleanup)
	        return;
	    var /** @type {?} */ cleanup = /** @type {?} */ ((viewState.cleanup));
	    for (var /** @type {?} */ i = 0; i < cleanup.length - 1; i += 2) {
	        if (typeof cleanup[i] === 'string') {
	            /** @type {?} */ ((cleanup))[i + 1].removeEventListener(cleanup[i], cleanup[i + 2], cleanup[i + 3]);
	            i += 2;
	        }
	        else {
	            cleanup[i].call(cleanup[i + 1]);
	        }
	    }
	    viewState.cleanup = null;
	}
	/**
	 * Appends the provided child element to the provided parent, if appropriate.
	 *
	 * If the parent is a view, the element will be appended as part of viewEnd(), so
	 * the element should not be appended now. Similarly, if the child is a content child
	 * of a parent component, the child will be appended to the right position later by
	 * the content projection system. Otherwise, append normally.
	 *
	 * @param {?} parent The parent to which to append the child
	 * @param {?} child The child that should be appended
	 * @param {?} currentView The current view's ViewState
	 * @return {?} Whether or not the child was appended
	 */
	function appendChild(parent, child, currentView) {
	    // Only add native child element to parent element if the parent element is regular Element.
	    // If parent is:
	    // - Regular element => add child
	    // - Component host element =>
	    //    - Current View, and parent view same => content => don't add -> parent component will
	    //    re-project if needed.
	    //    - Current View, and parent view different => view => add Child
	    // - View element => View's get added separately.
	    if (child !== null && (parent.flags & 3 /* TYPE_MASK */) === 3 /* Element */ &&
	        (parent.view !==
	            currentView /* Crossing View Boundaries, it is Component, but add Element of View */
	            || parent.data === null /* Regular Element. */)) {
	        // We only add element if not in View or not projected.
	        var /** @type {?} */ renderer = currentView.renderer;
	        (/** @type {?} */ (renderer)).listen ? /** @type {?} */ (((/** @type {?} */ (renderer)).appendChild))(/** @type {?} */ (((parent.native))), child) : /** @type {?} */ ((parent.native)).appendChild(child);
	        return true;
	    }
	    return false;
	}
	/**
	 * Inserts the provided node before the correct element in the DOM, if appropriate.
	 *
	 * If the parent is a view, the element will be inserted as part of viewEnd(), so
	 * the element should not be inserted now. Similarly, if the child is a content child
	 * of a parent component, the child will be inserted to the right position later by
	 * the content projection system. Otherwise, insertBefore normally.
	 *
	 * @param {?} node Node to insert
	 * @param {?} currentView The current view's ViewState
	 * @return {?}
	 */
	function insertChild(node, currentView) {
	    var /** @type {?} */ parent = /** @type {?} */ ((node.parent));
	    // Only add child element to parent element if the parent element is regular Element.
	    // If parent is:
	    // - Normal element => add child
	    // - Component element =>
	    //    - Current View, and parent view same => content don't add -> parent component will
	    //    re-project if needed.
	    //    - Current View, and parent view different => view => add Child
	    // - View element => View's get added separately.
	    if ((parent.flags & 3 /* TYPE_MASK */) === 3 /* Element */ &&
	        (parent.view !==
	            currentView /* Crossing View Boundaries, its Component, but add Element of View */
	            || parent.data === null /* Regular Element. */)) {
	        // We only add element if not in View or not projected.
	        var /** @type {?} */ sibling = node.next;
	        var /** @type {?} */ nativeSibling = null;
	        while (sibling && (nativeSibling = sibling.native) === null) {
	            sibling = sibling.next;
	        }
	        var /** @type {?} */ renderer = currentView.renderer;
	        (/** @type {?} */ (renderer)).listen ? /** @type {?} */ (((/** @type {?} */ (renderer))
	            .insertBefore))(/** @type {?} */ ((parent.native)), /** @type {?} */ ((node.native)), nativeSibling) : /** @type {?} */ ((parent.native)).insertBefore(/** @type {?} */ ((node.native)), nativeSibling, false);
	    }
	}
	/**
	 * Appends a projected node to the DOM, or in the case of a projected container,
	 * appends the nodes from all of the container's active views to the DOM. Also stores the
	 * node in the given projectedNodes array.
	 *
	 * @param {?} projectedNodes Array to store the projected node
	 * @param {?} node The node to process
	 * @param {?} currentParent The last parent element to be processed
	 * @param {?} currentView The current view's ViewState
	 * @return {?}
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A utility function to match an Ivy node static data against a simple CSS selector
	 *
	 * @param {?} lNodeStaticData
	 * @param {?} selector
	 * @return {?} true if node matches the selector.
	 */
	
	/**
	 * @param {?} lNodeStaticData
	 * @param {?} selector
	 * @return {?}
	 */
	
	/**
	 * @param {?} lNodeStaticData
	 * @param {?} selector
	 * @return {?}
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Must use this method for CD (instead of === ) since NaN !== NaN
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function isDifferent(a, b) {
	    // NaN is the only value that is not equal to itself so the first
	    // test checks if both a and b are not NaN
	    return !(a !== a && b !== b) && a !== b;
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function stringify$1(value) {
	    if (typeof value == 'function')
	        return value.name || value;
	    if (typeof value == 'string')
	        return value;
	    if (value == null)
	        return '';
	    return '' + value;
	}
	/**
	 * Creates an ElementRef for a given node injector and stores it on the injector.
	 * Or, if the ElementRef already exists, retrieves the existing ElementRef.
	 *
	 * @param {?} di The node injector where we should store a created ElementRef
	 * @return {?} The ElementRef instance to use
	 */
	
	/**
	 * Creates a TemplateRef and stores it on the injector. Or, if the TemplateRef already
	 * exists, retrieves the existing TemplateRef.
	 *
	 * @template T
	 * @param {?} di The node injector where we should store a created TemplateRef
	 * @return {?} The TemplateRef instance to use
	 */
	
	/**
	 * Creates a ViewContainerRef and stores it on the injector. Or, if the ViewContainerRef
	 * already exists, retrieves the existing ViewContainerRef.
	 *
	 * @param {?} di
	 * @return {?} The ViewContainerRef instance to use
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A predicate which determines if a given element/directive should be included in the query
	 * @record
	 * @template T
	 */
	
	/**
	 * @template T
	 */
	var QueryList_ = /** @class */ (function () {
	    function QueryList_() {
	        this.dirty = false;
	        /**
	         * \@internal
	         */
	        this._valuesTree = null;
	        /**
	         * \@internal
	         */
	        this._values = null;
	    }
	    Object.defineProperty(QueryList_.prototype, "length", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            ngDevMode && assertNotNull(this._values, 'refreshed');
	            return /** @type {?} */ ((this._values)).length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QueryList_.prototype, "first", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            ngDevMode && assertNotNull(this._values, 'refreshed');
	            var /** @type {?} */ values = /** @type {?} */ ((this._values));
	            return values.length ? values[0] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QueryList_.prototype, "last", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            ngDevMode && assertNotNull(this._values, 'refreshed');
	            var /** @type {?} */ values = /** @type {?} */ ((this._values));
	            return values.length ? values[values.length - 1] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    QueryList_.prototype._refresh = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        // TODO(misko): needs more logic to flatten tree.
	        if (this._values === null) {
	            this._values = this._valuesTree;
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @template U
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList_.prototype.map = /**
	     * @template U
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList_.prototype.filter = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList_.prototype.find = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @template U
	     * @param {?} fn
	     * @param {?} init
	     * @return {?}
	     */
	    QueryList_.prototype.reduce = /**
	     * @template U
	     * @param {?} fn
	     * @param {?} init
	     * @return {?}
	     */
	    function (fn, init) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList_.prototype.forEach = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    QueryList_.prototype.some = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @return {?}
	     */
	    QueryList_.prototype.toArray = /**
	     * @return {?}
	     */
	    function () {
	        ngDevMode && assertNotNull(this._values, 'refreshed');
	        return /** @type {?} */ ((this._values));
	    };
	    /**
	     * @return {?}
	     */
	    QueryList_.prototype.toString = /**
	     * @return {?}
	     */
	    function () { throw new Error('Method not implemented.'); };
	    /**
	     * @param {?} res
	     * @return {?}
	     */
	    QueryList_.prototype.reset = /**
	     * @param {?} res
	     * @return {?}
	     */
	    function (res) { throw new Error('Method not implemented.'); };
	    /**
	     * @return {?}
	     */
	    QueryList_.prototype.notifyOnChanges = /**
	     * @return {?}
	     */
	    function () { throw new Error('Method not implemented.'); };
	    /**
	     * @return {?}
	     */
	    QueryList_.prototype.setDirty = /**
	     * @return {?}
	     */
	    function () { throw new Error('Method not implemented.'); };
	    /**
	     * @return {?}
	     */
	    QueryList_.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { throw new Error('Method not implemented.'); };
	    return QueryList_;
	}());
	
	/**
	 * @param {?} query
	 * @return {?}
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var RendererStyleFlags3 = {
	    Important: 1,
	    DashCase: 2,
	};
	RendererStyleFlags3[RendererStyleFlags3.Important] = "Important";
	RendererStyleFlags3[RendererStyleFlags3.DashCase] = "DashCase";
	/**
	 * Object Oriented style of API needed to create elements and text nodes.
	 *
	 * This is the native browser API style, e.g. operations are methods on individual objects
	 * like HTMLElement. With this style, no additional code is needed as a facade
	 * (reducing payload size).
	 *
	 * @record
	 */
	
	/**
	 * Procedural style of API needed to create elements and text nodes.
	 *
	 * In non-native browser environments (e.g. platforms such as web-workers), this is the
	 * facade that enables element manipulation. This also facilitates backwards compatibility
	 * with Renderer2.
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	var domRendererFactory3 = {
	    createRenderer: function (hostElement, rendererType) { return document; }
	};
	/**
	 * Subset of API needed for appending elements and text nodes.
	 * @record
	 */
	
	/**
	 * Subset of API needed for writing attributes, properties, and setting up
	 * listeners on Element.
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Directive (D) sets a property on all component instances using this constant as a key and the
	 * component's host node (LElement) as the value. This is used in methods like detectChanges to
	 * facilitate jumping from an instance to the host node.
	 */
	var NG_HOST_SYMBOL = '__ngHostLNode__';
	/**
	 * This property gets set before entering a template.
	 *
	 * This renderer can be one of two varieties of Renderer3:
	 *
	 * - ObjectedOrientedRenderer3
	 *
	 * This is the native browser API style, e.g. operations are methods on individual objects
	 * like HTMLElement. With this style, no additional code is needed as a facade (reducing payload
	 * size).
	 *
	 * - ProceduralRenderer3
	 *
	 * In non-native browser environments (e.g. platforms such as web-workers), this is the facade
	 * that enables element manipulation. This also facilitates backwards compatibility with
	 * Renderer2.
	 */
	var renderer;
	var rendererFactory;
	/**
	 * Used to set the parent property when nodes are created.
	 */
	var previousOrParentNode;
	/**
	 * If `isParent` is:
	 *  - `true`: then `previousOrParentNode` points to a parent node.
	 *  - `false`: then `previousOrParentNode` points to previous node (sibling).
	 */
	var isParent;
	/**
	 * The current template's static data (shared between all templates of a
	 * given type).
	 *
	 * Each node's static data is stored at the same index that it's stored
	 * in the data array. Any nodes that do not have static data store a null
	 * value to avoid a sparse array.
	 */
	var ngStaticData;
	/**
	 * State of the current view being processed.
	 */
	var currentView;
	// The initialization has to be after the `let`, otherwise `createViewState` can't see `let`.
	currentView = createViewState(/** @type {?} */ ((null)), /** @type {?} */ ((null)), []);
	var currentQuery;
	/**
	 * This property gets set before entering a template.
	 */
	var creationMode;
	/**
	 * An array of nodes (text, element, container, etc), their bindings, and
	 * any local variables that need to be stored between invocations.
	 */
	var data;
	/**
	 * Points to the next binding index to read or write to.
	 */
	var bindingIndex;
	/**
	 * When a view is destroyed, listeners need to be released
	 * and onDestroy callbacks need to be called. This cleanup array
	 * stores both listener data (in chunks of 4) and onDestroy data
	 * (in chunks of 2), as they'll be processed at the same time.
	 *
	 * If it's a listener being stored:
	 * 1st index is: event name to remove
	 * 2nd index is: native element
	 * 3rd index is: listener function
	 * 4th index is: useCapture boolean
	 *
	 * If it's an onDestroy function:
	 * 1st index is: onDestroy function
	 * 2nd index is: context for function
	 */
	var cleanup;
	/**
	 * Index in the data array at which view hooks begin to be stored.
	 */
	var viewHookStartIndex;
	/**
	 * Swap the current state with a new state.
	 *
	 * For performance reasons we store the state in the top level of the module.
	 * This way we minimize the number of properties to read. Whenever a new view
	 * is entered we have to store the state for later, and when the view is
	 * exited the state has to be restored
	 *
	 * @param {?} newViewState New state to become active
	 * @param {?} host Element to which the View is a child of
	 * @return {?} the previous state;
	 */
	function enterView(newViewState, host) {
	    var /** @type {?} */ oldViewState = currentView;
	    data = newViewState.data;
	    bindingIndex = newViewState.bindingStartIndex || 0;
	    ngStaticData = newViewState.ngStaticData;
	    creationMode = newViewState.creationMode;
	    viewHookStartIndex = newViewState.viewHookStartIndex;
	    cleanup = newViewState.cleanup;
	    renderer = newViewState.renderer;
	    if (host != null) {
	        previousOrParentNode = host;
	        isParent = true;
	    }
	    currentView = newViewState;
	    return /** @type {?} */ ((oldViewState));
	}
	/**
	 * Used in lieu of enterView to make it clear when we are exiting a child view. This makes
	 * the direction of traversal (up or down the view tree) a bit clearer.
	 * @param {?} newViewState
	 * @return {?}
	 */
	function leaveView(newViewState) {
	    executeViewHooks();
	    enterView(newViewState, null);
	}
	/**
	 * @param {?} viewId
	 * @param {?} renderer
	 * @param {?} ngStaticData
	 * @return {?}
	 */
	function createViewState(viewId, renderer, ngStaticData) {
	    var /** @type {?} */ newView = {
	        parent: currentView,
	        id: viewId,
	        // -1 for component views
	        node: /** @type {?} */ ((null)),
	        // until we initialize it in createNode.
	        data: [],
	        ngStaticData: ngStaticData,
	        cleanup: null,
	        renderer: renderer,
	        child: null,
	        tail: null,
	        next: null,
	        bindingStartIndex: null,
	        creationMode: true,
	        viewHookStartIndex: null
	    };
	    return newView;
	}
	/**
	 * @param {?} index
	 * @param {?} type
	 * @param {?} native
	 * @param {?=} state
	 * @return {?}
	 */
	function createLNode(index, type, native, state) {
	    var /** @type {?} */ parent = isParent ? previousOrParentNode :
	        previousOrParentNode && /** @type {?} */ (previousOrParentNode.parent);
	    var /** @type {?} */ query = (isParent ? currentQuery : previousOrParentNode && previousOrParentNode.query) ||
	        parent && parent.query && parent.query.child();
	    var /** @type {?} */ isState = state != null;
	    var /** @type {?} */ node = {
	        flags: type,
	        native: /** @type {?} */ (native),
	        view: currentView,
	        parent: /** @type {?} */ (parent),
	        child: null,
	        next: null,
	        nodeInjector: parent ? parent.nodeInjector : null,
	        data: isState ? /** @type {?} */ (state) : null,
	        query: query,
	        staticData: null
	    };
	    if ((type & 2 /* ViewOrElement */) === 2 /* ViewOrElement */ && isState) {
	        // Bit of a hack to bust through the readonly because there is a circular dep between
	        // ViewState and LNode.
	        ngDevMode && assertEqual((/** @type {?} */ (state)).node, null, 'viewState.node');
	        (/** @type {?} */ ((state))).node = node;
	    }
	    if (index != null) {
	        // We are Element or Container
	        ngDevMode && assertEqual(data.length, index, 'data.length not in sequence');
	        data[index] = node;
	        // Every node adds a value to the static data array to avoid a sparse array
	        if (index >= ngStaticData.length) {
	            ngStaticData[index] = null;
	        }
	        else {
	            node.staticData = /** @type {?} */ (ngStaticData[index]);
	        }
	        // Now link ourselves into the tree.
	        if (isParent) {
	            currentQuery = null;
	            if (previousOrParentNode.view === currentView ||
	                (previousOrParentNode.flags & 3 /* TYPE_MASK */) === 2 /* View */) {
	                // We are in the same view, which means we are adding content node to the parent View.
	                ngDevMode && assertEqual(previousOrParentNode.child, null, 'previousNode.child');
	                previousOrParentNode.child = node;
	            }
	            else {
	                // We are adding component view, so we don't link parent node child to this node.
	            }
	        }
	        else if (previousOrParentNode) {
	            ngDevMode && assertEqual(previousOrParentNode.next, null, 'previousNode.next');
	            previousOrParentNode.next = node;
	        }
	    }
	    previousOrParentNode = node;
	    isParent = true;
	    return node;
	}
	/**
	 * Resets the application state.
	 * @return {?}
	 */
	function resetApplicationState() {
	    isParent = false;
	    previousOrParentNode = /** @type {?} */ ((null));
	}
	/**
	 *
	 * @template T
	 * @param {?} hostNode
	 * @param {?} template Template function with the instructions.
	 * @param {?} context to pass into the template.
	 * @param {?} providedRendererFactory
	 * @param {?} host Existing node to render into.
	 * @return {?}
	 */
	
	/**
	 * @template T
	 * @param {?} node
	 * @param {?} viewState
	 * @param {?} componentOrContext
	 * @param {?=} template
	 * @return {?}
	 */
	function renderComponentOrTemplate(node, viewState, componentOrContext, template) {
	    var /** @type {?} */ oldView = enterView(viewState, node);
	    try {
	        if (rendererFactory.begin) {
	            rendererFactory.begin();
	        }
	        if (template) {
	            ngStaticData = template.ngStaticData || (template.ngStaticData = /** @type {?} */ ([]));
	            template(/** @type {?} */ ((componentOrContext)), creationMode);
	        }
	        else {
	            // Element was stored at 0 and directive was stored at 1 in renderComponent
	            // so to refresh the component, r() needs to be called with (1, 0)
	            (/** @type {?} */ (componentOrContext.constructor)).ngComponentDef.r(1, 0);
	        }
	    }
	    finally {
	        if (rendererFactory.end) {
	            rendererFactory.end();
	        }
	        viewState.creationMode = false;
	        leaveView(oldView);
	    }
	}
	/**
	 * @return {?}
	 */
	
	/**
	 * Makes a directive public to the DI system by adding it to an injector's bloom filter.
	 *
	 * @param {?} def The definition of the directive to be made public
	 * @return {?}
	 */
	
	/**
	 * Searches for an instance of the given directive type up the injector tree and returns
	 * that instance if found.
	 *
	 * If not found, it will propagate up to the next parent injector until the token
	 * is found or the top is reached.
	 *
	 * Usage example (in factory function):
	 *
	 * class SomeDirective {
	 *   constructor(directive: DirectiveA) {}
	 *
	 *   static ngDirectiveDef = defineDirective({
	 *     type: SomeDirective,
	 *     factory: () => new SomeDirective(inject(DirectiveA))
	 *   });
	 * }
	 *
	 * @template T
	 * @param {?} token The directive type to search for
	 * @param {?=} flags Injection flags (e.g. CheckParent)
	 * @return {?} The instance found
	 */
	
	/**
	 * Creates an ElementRef and stores it on the injector.
	 * Or, if the ElementRef already exists, retrieves the existing ElementRef.
	 *
	 * @return {?} The ElementRef instance to use
	 */
	
	/**
	 * Creates a TemplateRef and stores it on the injector. Or, if the TemplateRef already
	 * exists, retrieves the existing TemplateRef.
	 *
	 * @template T
	 * @return {?} The TemplateRef instance to use
	 */
	
	/**
	 * Creates a ViewContainerRef and stores it on the injector. Or, if the ViewContainerRef
	 * already exists, retrieves the existing ViewContainerRef.
	 *
	 * @return {?} The ViewContainerRef instance to use
	 */
	
	/**
	 * Create DOM element. The instruction must later be followed by `elementEnd()` call.
	 *
	 * @param {?} index Index of the element in the data array
	 * @param {?=} nameOrComponentDef Name of the DOM Node or `ComponentDef`.
	 * @param {?=} attrs Statically bound set of attributes to be written into the DOM element on creation.
	 * @param {?=} localName A name under which a given element is exported.
	 *
	 * Attributes are passed as an array of strings where elements with an even index hold an attribute
	 * name and elements with an odd index hold an attribute value, ex.:
	 * ['id', 'warning5', 'class', 'alert']
	 * @return {?}
	 */
	function elementStart(index, nameOrComponentDef, attrs, localName) {
	    var /** @type {?} */ node;
	    var /** @type {?} */ native;
	    if (nameOrComponentDef == null) {
	        // native node retrieval - used for exporting elements as tpl local variables (<div #foo>)
	        var /** @type {?} */ node_1 = /** @type {?} */ ((data[index]));
	        native = node_1 && (/** @type {?} */ (node_1)).native;
	    }
	    else {
	        ngDevMode && assertEqual(currentView.bindingStartIndex, null, 'bindingStartIndex');
	        var /** @type {?} */ isHostElement = typeof nameOrComponentDef !== 'string';
	        var /** @type {?} */ name_1 = isHostElement ? (/** @type {?} */ (nameOrComponentDef)).tag : /** @type {?} */ (nameOrComponentDef);
	        if (name_1 === null) {
	            // TODO: future support for nameless components.
	            throw 'for now name is required';
	        }
	        else {
	            native = renderer.createElement(name_1);
	            var /** @type {?} */ componentView = null;
	            if (isHostElement) {
	                var /** @type {?} */ ngStaticData_1 = getTemplateStatic((/** @type {?} */ (nameOrComponentDef)).template);
	                componentView = addToViewTree(createViewState(-1, rendererFactory.createRenderer(native, (/** @type {?} */ (nameOrComponentDef)).rendererType), ngStaticData_1));
	            }
	            // Only component views should be added to the view tree directly. Embedded views are
	            // accessed through their containers because they may be removed / re-added later.
	            node = createLNode(index, 3 /* Element */, native, componentView);
	            if (node.staticData == null) {
	                ngDevMode && assertDataInRange(index - 1);
	                node.staticData = ngStaticData[index] =
	                    createNodeStatic(name_1, attrs || null, null, localName || null);
	            }
	            if (attrs)
	                setUpAttributes(native, attrs);
	            appendChild(/** @type {?} */ ((node.parent)), native, currentView);
	        }
	    }
	    return native;
	}
	/**
	 * Gets static data from a template function or creates a new static
	 * data array if it doesn't already exist.
	 *
	 * @param {?} template The template from which to get static data
	 * @return {?} NgStaticData
	 */
	function getTemplateStatic(template) {
	    return template.ngStaticData || (template.ngStaticData = /** @type {?} */ ([]));
	}
	/**
	 * @param {?} native
	 * @param {?} attrs
	 * @return {?}
	 */
	function setUpAttributes(native, attrs) {
	    ngDevMode && assertEqual(attrs.length % 2, 0, 'attrs.length % 2');
	    var /** @type {?} */ isProceduralRenderer = (/** @type {?} */ (renderer)).setAttribute;
	    for (var /** @type {?} */ i = 0; i < attrs.length; i += 2) {
	        isProceduralRenderer ? /** @type {?} */ (((/** @type {?} */ (renderer)).setAttribute))(native, attrs[i], attrs[i | 1]) :
	            native.setAttribute(attrs[i], attrs[i | 1]);
	    }
	}
	/**
	 * @param {?} text
	 * @param {?} token
	 * @return {?}
	 */
	function createError(text, token) {
	    return new Error("Renderer: " + text + " [" + stringify$1(token) + "]");
	}
	/**
	 * Locates the host native element, used for bootstrapping existing nodes into rendering pipeline.
	 *
	 * @param {?} factory
	 * @param {?} elementOrSelector Render element or CSS selector to locate the element.
	 * @return {?}
	 */
	function locateHostElement(factory, elementOrSelector) {
	    ngDevMode && assertDataInRange(-1);
	    rendererFactory = factory;
	    var /** @type {?} */ defaultRenderer = factory.createRenderer(null, null);
	    var /** @type {?} */ rNode = typeof elementOrSelector === 'string' ?
	        ((/** @type {?} */ (defaultRenderer)).selectRootElement ?
	            (/** @type {?} */ (defaultRenderer)).selectRootElement(elementOrSelector) : /** @type {?} */ (((/** @type {?} */ (defaultRenderer)).querySelector))(elementOrSelector)) :
	        elementOrSelector;
	    if (ngDevMode && !rNode) {
	        if (typeof elementOrSelector === 'string') {
	            throw createError('Host node with selector not found:', elementOrSelector);
	        }
	        else {
	            throw createError('Host node is required:', elementOrSelector);
	        }
	    }
	    return rNode;
	}
	/**
	 * Creates the host LNode..
	 *
	 * @param {?} rNode Render host element.
	 * @param {?} def
	 * @return {?}
	 */
	function hostElement(rNode, def) {
	    resetApplicationState();
	    createLNode(0, 3 /* Element */, rNode, createViewState(-1, renderer, getTemplateStatic(def.template)));
	}
	/**
	 * Adds an event listener to the current node.
	 *
	 * If an output exists on one of the node's directives, it also subscribes to the output
	 * and saves the subscription for later cleanup.
	 *
	 * @param {?} eventName Name of the event
	 * @param {?} listener The function to be called when event emits
	 * @param {?=} useCapture Whether or not to use capture in event listener.
	 * @return {?}
	 */
	
	/**
	 * Mark the end of the element.
	 * @return {?}
	 */
	function elementEnd() {
	    if (isParent) {
	        isParent = false;
	    }
	    else {
	        ngDevMode && assertHasParent();
	        previousOrParentNode = /** @type {?} */ ((previousOrParentNode.parent));
	    }
	    ngDevMode && assertNodeType(previousOrParentNode, 3 /* Element */);
	    var /** @type {?} */ query = previousOrParentNode.query;
	    query && query.addNode(previousOrParentNode);
	}
	/**
	 * Update an attribute on an Element. This is used with a `bind` instruction.
	 *
	 * @param {?} index The index of the element to update in the data array
	 * @param {?} attrName Name of attribute. Because it is going to DOM, this is not subject to
	 *        renaming as port of minification.
	 * @param {?} value Value to write. This value will go through stringification.
	 * @return {?}
	 */
	
	/**
	 * Update a property on an Element.
	 *
	 * If the property name also exists as an input property on one of the element's directives,
	 * the component property will be set instead of the element property. This check must
	 * be conducted at runtime so child components that add new \@Inputs don't have to be re-compiled.
	 *
	 * @template T
	 * @param {?} index The index of the element to update in the data array
	 * @param {?} propName Name of property. Because it is going to DOM, this is not subject to
	 *        renaming as part of minification.
	 * @param {?} value New value to write.
	 * @return {?}
	 */
	function elementProperty(index, propName, value) {
	    if (value === NO_CHANGE)
	        return;
	    var /** @type {?} */ node = /** @type {?} */ (data[index]);
	    var /** @type {?} */ staticData = /** @type {?} */ ((node.staticData));
	    // if staticData.inputs is undefined, a listener has created output staticData, but inputs haven't
	    // yet been checked
	    if (staticData.inputs === undefined) {
	        // mark inputs as checked
	        staticData.inputs = null;
	        staticData = generatePropertyAliases(node.flags, staticData, true);
	    }
	    var /** @type {?} */ inputData = staticData.inputs;
	    var /** @type {?} */ dataValue;
	    if (inputData && (dataValue = inputData[propName])) {
	        setInputsForProperty(dataValue, value);
	    }
	    else {
	        var /** @type {?} */ native = node.native;
	        (/** @type {?} */ (renderer)).setProperty ?
	            (/** @type {?} */ (renderer)).setProperty(native, propName, value) :
	            native.setProperty ? native.setProperty(propName, value) :
	                (/** @type {?} */ (native))[propName] = value;
	    }
	}
	/**
	 * Constructs a LNodeStatic object from the arguments.
	 *
	 * @param {?} tagName
	 * @param {?} attrs
	 * @param {?} containerStatic
	 * @param {?} localName
	 * @return {?} the LNodeStatic object
	 */
	function createNodeStatic(tagName, attrs, containerStatic, localName) {
	    return {
	        tagName: tagName,
	        attrs: attrs,
	        localNames: localName ? [localName, -1] : null,
	        initialInputs: undefined,
	        inputs: undefined,
	        outputs: undefined,
	        containerStatic: containerStatic
	    };
	}
	/**
	 * Given a list of directive indices and minified input names, sets the
	 * input properties on the corresponding directives.
	 * @param {?} inputs
	 * @param {?} value
	 * @return {?}
	 */
	function setInputsForProperty(inputs, value) {
	    for (var /** @type {?} */ i = 0; i < inputs.length; i += 2) {
	        ngDevMode && assertDataInRange(/** @type {?} */ (inputs[i]));
	        data[/** @type {?} */ (inputs[i])][inputs[i | 1]] = value;
	    }
	}
	/**
	 * This function consolidates all the inputs or outputs defined by directives
	 * on this node into one object and stores it in ngStaticData so it can
	 * be shared between all templates of this type.
	 *
	 * @param {?} flags
	 * @param {?} data
	 * @param {?=} isInputData
	 * @return {?}
	 */
	function generatePropertyAliases(flags, data, isInputData) {
	    if (isInputData === void 0) { isInputData = false; }
	    var /** @type {?} */ start = flags >> 12;
	    var /** @type {?} */ size = (flags & 4092 /* SIZE_MASK */) >> 2;
	    for (var /** @type {?} */ i = start, /** @type {?} */ ii = start + size; i < ii; i++) {
	        var /** @type {?} */ directiveDef = /** @type {?} */ (((ngStaticData))[i]);
	        var /** @type {?} */ propertyAliasMap = isInputData ? directiveDef.inputs : directiveDef.outputs;
	        for (var /** @type {?} */ publicName in propertyAliasMap) {
	            if (propertyAliasMap.hasOwnProperty(publicName)) {
	                var /** @type {?} */ internalName = propertyAliasMap[publicName];
	                var /** @type {?} */ staticDirData = isInputData ? (data.inputs || (data.inputs = {})) :
	                    (data.outputs || (data.outputs = {}));
	                var /** @type {?} */ hasProperty = staticDirData.hasOwnProperty(publicName);
	                hasProperty ? staticDirData[publicName].push(i, internalName) :
	                    (staticDirData[publicName] = [i, internalName]);
	            }
	        }
	    }
	    return data;
	}
	/**
	 * Add or remove a class in a classList.
	 *
	 * This instruction is meant to handle the [class.foo]="exp" case
	 *
	 * @template T
	 * @param {?} index The index of the element to update in the data array
	 * @param {?} className Name of class to toggle. Because it is going to DOM, this is not subject to
	 *        renaming as part of minification.
	 * @param {?} value A value indicating if a given class should be added or removed.
	 * @return {?}
	 */
	
	/**
	 * Update a given style on an Element.
	 *
	 * @template T
	 * @param {?} index Index of the element to change in the data array
	 * @param {?} styleName Name of property. Because it is going to DOM this is not subject to
	 *        renaming as part of minification.
	 * @param {?} value New value to write (null to remove).
	 * @param {?=} suffix Suffix to add to style's value (optional).
	 * @return {?}
	 */
	function elementStyle(index, styleName, value, suffix) {
	    if (value !== NO_CHANGE) {
	        var /** @type {?} */ lElement = /** @type {?} */ (data[index]);
	        if (value == null) {
	            (/** @type {?} */ (renderer)).removeStyle ?
	                (/** @type {?} */ (renderer))
	                    .removeStyle(lElement.native, styleName, RendererStyleFlags3.DashCase) :
	                lElement.native.style.removeProperty(styleName);
	        }
	        else {
	            (/** @type {?} */ (renderer)).setStyle ?
	                (/** @type {?} */ (renderer))
	                    .setStyle(lElement.native, styleName, suffix ? stringify$1(value) + suffix : stringify$1(value), RendererStyleFlags3.DashCase) :
	                lElement.native.style.setProperty(styleName, suffix ? stringify$1(value) + suffix : stringify$1(value));
	        }
	    }
	}
	/**
	 * Create static text node
	 *
	 * @param {?} index Index of the node in the data array.
	 * @param {?=} value Value to write. This value will be stringified.
	 *   If value is not provided than the actual creation of the text node is delayed.
	 * @return {?}
	 */
	function text(index, value) {
	    ngDevMode && assertEqual(currentView.bindingStartIndex, null, 'bindingStartIndex');
	    var /** @type {?} */ textNode = value != null ?
	        ((/** @type {?} */ (renderer)).createText ?
	            (/** @type {?} */ (renderer)).createText(stringify$1(value)) : /** @type {?} */ (((/** @type {?} */ (renderer)).createTextNode))(stringify$1(value))) :
	        null;
	    var /** @type {?} */ node = createLNode(index, 3 /* Element */, textNode);
	    // Text nodes are self closing.
	    isParent = false;
	    appendChild(/** @type {?} */ ((node.parent)), textNode, currentView);
	}
	/**
	 * Create text node with binding
	 * Bindings should be handled externally with the proper bind(1-8) method
	 *
	 * @template T
	 * @param {?} index Index of the node in the data array.
	 * @param {?} value Stringified value to write.
	 * @return {?}
	 */
	function textBinding(index, value) {
	    // TODO(misko): I don't think index < nodes.length check is needed here.
	    var /** @type {?} */ existingNode = index < data.length && /** @type {?} */ (data[index]);
	    if (existingNode && existingNode.native) {
	        // If DOM node exists and value changed, update textContent
	        value !== NO_CHANGE &&
	            ((/** @type {?} */ (renderer)).setValue ?
	                (/** @type {?} */ (renderer)).setValue(existingNode.native, stringify$1(value)) :
	                existingNode.native.textContent = stringify$1(value));
	    }
	    else if (existingNode) {
	        // Node was created but DOM node creation was delayed. Create and append now.
	        existingNode.native =
	            ((/** @type {?} */ (renderer)).createText ?
	                (/** @type {?} */ (renderer)).createText(stringify$1(value)) : /** @type {?} */ (((/** @type {?} */ (renderer)).createTextNode))(stringify$1(value)));
	        insertChild(existingNode, currentView);
	    }
	    else {
	        text(index, value);
	    }
	}
	/**
	 * @template T
	 * @param {?} index
	 * @param {?=} directive
	 * @param {?=} directiveDef
	 * @param {?=} localName
	 * @return {?}
	 */
	function directive(index, directive, directiveDef, localName) {
	    var /** @type {?} */ instance;
	    if (directive == null) {
	        // return existing
	        ngDevMode && assertDataInRange(index);
	        instance = data[index];
	    }
	    else {
	        ngDevMode && assertEqual(currentView.bindingStartIndex, null, 'bindingStartIndex');
	        ngDevMode && assertPreviousIsParent();
	        var /** @type {?} */ flags = /** @type {?} */ ((previousOrParentNode)).flags;
	        var /** @type {?} */ size = flags & 4092;
	        if (size === 0) {
	            flags =
	                (index << 12 /* INDX_SHIFT */) | 4 /* SIZE_SKIP */ | flags & 3 /* TYPE_MASK */;
	        }
	        else {
	            flags += 4 /* SIZE_SKIP */;
	        } /** @type {?} */
	        ((previousOrParentNode)).flags = flags;
	        ngDevMode && assertDataInRange(index - 1);
	        Object.defineProperty(directive, NG_HOST_SYMBOL, { enumerable: false, value: previousOrParentNode });
	        data[index] = instance = directive;
	        if (index >= ngStaticData.length) {
	            ngStaticData[index] = /** @type {?} */ ((directiveDef));
	            if (localName) {
	                ngDevMode &&
	                    assertNotNull(previousOrParentNode.staticData, 'previousOrParentNode.staticData');
	                var /** @type {?} */ nodeStaticData = /** @type {?} */ ((/** @type {?} */ ((previousOrParentNode)).staticData));
	                (nodeStaticData.localNames || (nodeStaticData.localNames = [])).push(localName, index);
	            }
	        }
	        var /** @type {?} */ diPublic_1 = /** @type {?} */ ((directiveDef)).diPublic;
	        if (diPublic_1) {
	            diPublic_1(/** @type {?} */ ((directiveDef)));
	        }
	        var /** @type {?} */ staticData = /** @type {?} */ ((previousOrParentNode.staticData));
	        if (staticData && staticData.attrs) {
	            setInputsFromAttrs(instance, /** @type {?} */ ((directiveDef)).inputs, staticData);
	        }
	    }
	    return instance;
	}
	/**
	 * Sets initial input properties on directive instances from attribute data
	 *
	 * @template T
	 * @param {?} instance Instance of the directive on which to set the initial inputs
	 * @param {?} inputs The list of inputs from the directive def
	 * @param {?} staticData The static data for this node
	 * @return {?}
	 */
	function setInputsFromAttrs(instance, inputs, staticData) {
	    var /** @type {?} */ directiveIndex = ((previousOrParentNode.flags & 4092 /* SIZE_MASK */) >> 2 /* SIZE_SHIFT */) - 1;
	    var /** @type {?} */ initialInputData = /** @type {?} */ (staticData.initialInputs);
	    if (initialInputData === undefined || directiveIndex >= initialInputData.length) {
	        initialInputData = generateInitialInputs(directiveIndex, inputs, staticData);
	    }
	    var /** @type {?} */ initialInputs = initialInputData[directiveIndex];
	    if (initialInputs) {
	        for (var /** @type {?} */ i = 0; i < initialInputs.length; i += 2) {
	            (/** @type {?} */ (instance))[initialInputs[i]] = initialInputs[i | 1];
	        }
	    }
	}
	/**
	 * Generates initialInputData for a node and stores it in the template's static storage
	 * so subsequent template invocations don't have to recalculate it.
	 *
	 * initialInputData is an array containing values that need to be set as input properties
	 * for directives on this node, but only once on creation. We need this array to support
	 * the case where you set an \@Input property of a directive using attribute-like syntax.
	 * e.g. if you have a `name` \@Input, you can set it once like this:
	 *
	 * <my-component name="Bess"></my-component>
	 *
	 * @param {?} directiveIndex Index to store the initial input data
	 * @param {?} inputs The list of inputs from the directive def
	 * @param {?} staticData The static data on this node
	 * @return {?}
	 */
	function generateInitialInputs(directiveIndex, inputs, staticData) {
	    var /** @type {?} */ initialInputData = staticData.initialInputs || (staticData.initialInputs = []);
	    initialInputData[directiveIndex] = null;
	    var /** @type {?} */ attrs = /** @type {?} */ ((staticData.attrs));
	    for (var /** @type {?} */ i = 0; i < attrs.length; i += 2) {
	        var /** @type {?} */ attrName = attrs[i];
	        var /** @type {?} */ minifiedInputName = inputs[attrName];
	        if (minifiedInputName !== undefined) {
	            var /** @type {?} */ inputsToStore = initialInputData[directiveIndex] || (initialInputData[directiveIndex] = []);
	            inputsToStore.push(minifiedInputName, attrs[i | 1]);
	        }
	    }
	    return initialInputData;
	}
	/**
	 * @param {?} lifecycle
	 * @param {?=} self
	 * @param {?=} method
	 * @return {?}
	 */
	
	/**
	 * Iterates over view hook functions and calls them.
	 * @return {?}
	 */
	function executeViewHooks() {
	    if (viewHookStartIndex == null)
	        return;
	    // Instead of using splice to remove init hooks after their first run (expensive), we
	    // shift over the AFTER_CHECKED hooks as we call them and truncate once at the end.
	    var /** @type {?} */ checkIndex = /** @type {?} */ (viewHookStartIndex);
	    var /** @type {?} */ writeIndex = checkIndex;
	    while (checkIndex < data.length) {
	        // Call lifecycle hook with its context
	        data[checkIndex + 1].call(data[checkIndex + 2]);
	        if (data[checkIndex] === 16 /* AFTER_VIEW_CHECKED */) {
	            // We know if the writeIndex falls behind that there is an init that needs to
	            // be overwritten.
	            if (writeIndex < checkIndex) {
	                data[writeIndex] = data[checkIndex];
	                data[writeIndex + 1] = data[checkIndex + 1];
	                data[writeIndex + 2] = data[checkIndex + 2];
	            }
	            writeIndex += 3;
	        }
	        checkIndex += 3;
	    }
	    // Truncate once at the writeIndex
	    data.length = writeIndex;
	}
	/**
	 * Creates an LContainer.
	 *
	 * Only `LView`s can go into `LContainer`.
	 *
	 * @param {?} index The index of the container in the data array
	 * @param {?=} template Optional inline template
	 * @param {?=} tagName The name of the container element, if applicable
	 * @param {?=} attrs The attrs attached to the container, if applicable
	 * @param {?=} localName
	 * @return {?}
	 */
	function containerStart(index, template, tagName, attrs, localName) {
	    ngDevMode && assertEqual(currentView.bindingStartIndex, null, 'bindingStartIndex');
	    // If the direct parent of the container is a view, its views (including its comment)
	    // will need to be added through insertView() when its parent view is being inserted.
	    // For now, it is marked "headless" so we know to append its views later.
	    var /** @type {?} */ comment = renderer.createComment(ngDevMode ? 'container' : '');
	    var /** @type {?} */ renderParent = null;
	    var /** @type {?} */ currentParent = isParent ? previousOrParentNode : /** @type {?} */ ((previousOrParentNode.parent));
	    ngDevMode && assertNotEqual(currentParent, null, 'currentParent');
	    if (appendChild(currentParent, comment, currentView)) {
	        // we are adding to an Element which is either:
	        // - Not a component (will not be re-projected, just added)
	        // - View of the Component
	        renderParent = /** @type {?} */ (currentParent);
	    }
	    var /** @type {?} */ node = createLNode(index, 0 /* Container */, comment, /** @type {?} */ ({
	        views: [],
	        nextIndex: 0, renderParent: renderParent,
	        template: template == null ? null : template,
	        next: null,
	        parent: currentView
	    }));
	    if (node.staticData == null) {
	        node.staticData = ngStaticData[index] =
	            createNodeStatic(tagName || null, attrs || null, [], localName || null);
	    }
	    // Containers are added to the current view tree instead of their embedded views
	    // because views can be removed and re-inserted.
	    addToViewTree(node.data);
	}
	/**
	 * @return {?}
	 */
	function containerEnd() {
	    if (isParent) {
	        isParent = false;
	    }
	    else {
	        ngDevMode && assertHasParent();
	        previousOrParentNode = /** @type {?} */ ((previousOrParentNode.parent));
	    }
	    ngDevMode && assertNodeType(previousOrParentNode, 0 /* Container */);
	    var /** @type {?} */ query = previousOrParentNode.query;
	    query && query.addNode(previousOrParentNode);
	}
	/**
	 * Sets a container up to receive views.
	 *
	 * @param {?} index The index of the container in the data array
	 * @return {?}
	 */
	function containerRefreshStart(index) {
	    ngDevMode && assertDataInRange(index);
	    previousOrParentNode = /** @type {?} */ (data[index]);
	    ngDevMode && assertNodeType(previousOrParentNode, 0 /* Container */);
	    isParent = true;
	    (/** @type {?} */ (previousOrParentNode)).data.nextIndex = 0;
	}
	/**
	 * Marks the end of the LContainer.
	 *
	 * Marking the end of ViewContainer is the time when to child Views get inserted or removed.
	 * @return {?}
	 */
	function containerRefreshEnd() {
	    if (isParent) {
	        isParent = false;
	    }
	    else {
	        ngDevMode && assertNodeType(previousOrParentNode, 2 /* View */);
	        ngDevMode && assertHasParent();
	        previousOrParentNode = /** @type {?} */ ((previousOrParentNode.parent));
	    }
	    ngDevMode && assertNodeType(previousOrParentNode, 0 /* Container */);
	    var /** @type {?} */ container = /** @type {?} */ (previousOrParentNode);
	    ngDevMode && assertNodeType(container, 0 /* Container */);
	    var /** @type {?} */ nextIndex = container.data.nextIndex;
	    while (nextIndex < container.data.views.length) {
	        // remove extra view.
	        removeView(container, nextIndex);
	    }
	}
	/**
	 * Creates an LView.
	 *
	 * @param {?} viewBlockId The ID of this view
	 * @return {?} Whether or not this view is in creation mode
	 */
	function viewStart(viewBlockId) {
	    var /** @type {?} */ container = /** @type {?} */ ((isParent ? previousOrParentNode : /** @type {?} */ ((previousOrParentNode.parent))));
	    ngDevMode && assertNodeType(container, 0 /* Container */);
	    var /** @type {?} */ containerState = container.data;
	    var /** @type {?} */ views = containerState.views;
	    var /** @type {?} */ existingView = !creationMode && containerState.nextIndex < views.length && views[containerState.nextIndex];
	    var /** @type {?} */ viewUpdateMode = existingView && viewBlockId === (/** @type {?} */ (existingView)).data.id;
	    if (viewUpdateMode) {
	        previousOrParentNode = views[containerState.nextIndex++];
	        ngDevMode && assertNodeType(previousOrParentNode, 2 /* View */);
	        isParent = true;
	        enterView((/** @type {?} */ (existingView)).data, /** @type {?} */ (previousOrParentNode));
	    }
	    else {
	        // When we create a new View, we always reset the state of the instructions.
	        var /** @type {?} */ newViewState = createViewState(viewBlockId, renderer, initViewStaticData(viewBlockId, container));
	        enterView(newViewState, createLNode(null, 2 /* View */, null, newViewState));
	        containerState.nextIndex++;
	    }
	    return !viewUpdateMode;
	}
	/**
	 * Initialize the static data for the active view.
	 *
	 * Each embedded view needs to set the global ngStaticData variable to the static data for
	 * that view. Otherwise, the view's static data for a particular node would overwrite
	 * the staticdata for a node in the view above it with the same index (since it's in the
	 * same template).
	 *
	 * @param {?} viewIndex The index of the view's static data in containerStatic
	 * @param {?} parent The parent container in which to look for the view's static data
	 * @return {?} NgStaticData
	 */
	function initViewStaticData(viewIndex, parent) {
	    ngDevMode && assertNodeType(parent, 0 /* Container */);
	    var /** @type {?} */ containerStatic = (/** @type {?} */ (((parent)).staticData)).containerStatic;
	    if (viewIndex >= containerStatic.length || containerStatic[viewIndex] == null) {
	        containerStatic[viewIndex] = [];
	    }
	    return containerStatic[viewIndex];
	}
	/**
	 * Marks the end of the LView.
	 * @return {?}
	 */
	function viewEnd() {
	    isParent = false;
	    var /** @type {?} */ viewNode = previousOrParentNode = /** @type {?} */ (currentView.node);
	    var /** @type {?} */ container = /** @type {?} */ (previousOrParentNode.parent);
	    ngDevMode && assertNodeType(viewNode, 2 /* View */);
	    ngDevMode && assertNodeType(container, 0 /* Container */);
	    var /** @type {?} */ containerState = container.data;
	    var /** @type {?} */ previousView = containerState.nextIndex <= containerState.views.length ? /** @type {?} */ (containerState.views[containerState.nextIndex - 1]) :
	        null;
	    var /** @type {?} */ viewIdChanged = previousView == null ? true : previousView.data.id !== viewNode.data.id;
	    if (viewIdChanged) {
	        insertView(container, viewNode, containerState.nextIndex - 1);
	        currentView.creationMode = false;
	    }
	    leaveView(/** @type {?} */ ((/** @type {?} */ ((currentView)).parent)));
	    ngDevMode && assertEqual(isParent, false, 'isParent');
	    ngDevMode && assertNodeType(previousOrParentNode, 2 /* View */);
	}
	/**
	 * Refreshes the component view.
	 *
	 * In other words, enters the component's view and processes it to update bindings, queries, etc.
	 *
	 * @param directiveIndex
	 * @param elementIndex
	 * @param template
	 */
	var componentRefresh = function (directiveIndex, elementIndex, template) {
	    ngDevMode && assertDataInRange(elementIndex);
	    var /** @type {?} */ element = /** @type {?} */ (((data))[elementIndex]);
	    ngDevMode && assertNodeType(element, 3 /* Element */);
	    ngDevMode && assertNotEqual(element.data, null, 'isComponent');
	    ngDevMode && assertDataInRange(directiveIndex);
	    var /** @type {?} */ hostView = /** @type {?} */ ((element.data));
	    ngDevMode && assertNotEqual(hostView, null, 'hostView');
	    var /** @type {?} */ directive = data[directiveIndex];
	    var /** @type {?} */ oldView = enterView(hostView, element);
	    try {
	        template(directive, creationMode);
	    }
	    finally {
	        hostView.creationMode = false;
	        leaveView(oldView);
	    }
	};
	/**
	 * Instruction to distribute projectable nodes among <ng-content> occurrences in a given template.
	 * It takes all the selectors from the entire component's template and decides where
	 * each projected node belongs (it re-distributes nodes among "buckets" where each "bucket" is
	 * backed by a selector).
	 *
	 * @param {?=} selectors
	 * @return {?}
	 */
	
	/**
	 * Inserts previously re-distributed projected nodes. This instruction must be preceded by a call
	 * to the projectionDef instruction.
	 *
	 * @param {?} nodeIndex
	 * @param {?} localIndex - index under which distribution of projected nodes was memorized
	 * @param {?=} selectorIndex - 0 means <ng-content> without any selector
	 * @return {?}
	 */
	
	/**
	 * Adds a ViewState or a ContainerState to the end of the current view tree.
	 *
	 * This structure will be used to traverse through nested views to remove listeners
	 * and call onDestroy callbacks.
	 *
	 * @template T
	 * @param {?} state The ViewState or ContainerState to add to the view tree
	 * @return {?} The state passed in
	 */
	function addToViewTree(state) {
	    currentView.tail ? (currentView.tail.next = state) : (currentView.child = state);
	    currentView.tail = state;
	    return state;
	}
	/**
	 * A special value which designates that a value has not changed.
	 */
	var NO_CHANGE = /** @type {?} */ ({});
	/**
	 * Create interpolation bindings with variable number of arguments.
	 *
	 * If any of the arguments change, then the interpolation is concatenated
	 * and causes an update.
	 *
	 * @param {?} values an array of values to diff.
	 * @return {?}
	 */
	
	/**
	 * Create a single value binding without interpolation.
	 *
	 * @template T
	 * @param {?} value Value to diff
	 * @return {?}
	 */
	function bind(value) {
	    var /** @type {?} */ different;
	    if (different = creationMode) {
	        if (typeof currentView.bindingStartIndex !== 'number') {
	            bindingIndex = currentView.bindingStartIndex = data.length;
	        }
	        data[bindingIndex++] = value;
	    }
	    else {
	        if (different = value !== NO_CHANGE && isDifferent(data[bindingIndex], value)) {
	            data[bindingIndex] = value;
	        }
	        bindingIndex++;
	    }
	    return different ? value : NO_CHANGE;
	}
	/**
	 * Create an interpolation bindings with 1 arguments.
	 *
	 * @param {?} prefix static value used for concatenation only.
	 * @param {?} value value checked for change.
	 * @param {?} suffix static value used for concatenation only.
	 * @return {?}
	 */
	function bind1(prefix, value, suffix) {
	    return bind(value) === NO_CHANGE ? NO_CHANGE : prefix + stringify$1(value) + suffix;
	}
	/**
	 * Create an interpolation bindings with 2 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0 value checked for change
	 * @param {?} i0
	 * @param {?} v1 value checked for change
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * Create an interpolation bindings with 3 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0
	 * @param {?} i0
	 * @param {?} v1
	 * @param {?} i1
	 * @param {?} v2
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * Create an interpolation binding with 4 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0
	 * @param {?} i0
	 * @param {?} v1
	 * @param {?} i1
	 * @param {?} v2
	 * @param {?} i2
	 * @param {?} v3
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * Create an interpolation binding with 5 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0
	 * @param {?} i0
	 * @param {?} v1
	 * @param {?} i1
	 * @param {?} v2
	 * @param {?} i2
	 * @param {?} v3
	 * @param {?} i3
	 * @param {?} v4
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * Create an interpolation binding with 6 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0
	 * @param {?} i0
	 * @param {?} v1
	 * @param {?} i1
	 * @param {?} v2
	 * @param {?} i2
	 * @param {?} v3
	 * @param {?} i3
	 * @param {?} v4
	 * @param {?} i4
	 * @param {?} v5
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * Create an interpolation binding with 7 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0
	 * @param {?} i0
	 * @param {?} v1
	 * @param {?} i1
	 * @param {?} v2
	 * @param {?} i2
	 * @param {?} v3
	 * @param {?} i3
	 * @param {?} v4
	 * @param {?} i4
	 * @param {?} v5
	 * @param {?} i5
	 * @param {?} v6
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * Create an interpolation binding with 8 arguments.
	 *
	 * @param {?} prefix
	 * @param {?} v0
	 * @param {?} i0
	 * @param {?} v1
	 * @param {?} i1
	 * @param {?} v2
	 * @param {?} i2
	 * @param {?} v3
	 * @param {?} i3
	 * @param {?} v4
	 * @param {?} i4
	 * @param {?} v5
	 * @param {?} i5
	 * @param {?} v6
	 * @param {?} i6
	 * @param {?} v7
	 * @param {?} suffix
	 * @return {?}
	 */
	
	/**
	 * @template T
	 * @param {?} index
	 * @param {?=} value
	 * @return {?}
	 */
	
	/**
	 * @template T
	 * @param {?} predicate
	 * @param {?=} descend
	 * @param {?=} read
	 * @return {?}
	 */
	
	/**
	 * @return {?}
	 */
	function assertPreviousIsParent() {
	    assertEqual(isParent, true, 'isParent');
	}
	/**
	 * @return {?}
	 */
	function assertHasParent() {
	    assertNotEqual(previousOrParentNode.parent, null, 'isParent');
	}
	/**
	 * @param {?} index
	 * @param {?=} arr
	 * @return {?}
	 */
	function assertDataInRange(index, arr) {
	    if (arr == null)
	        arr = data;
	    assertLessThan(arr ? arr.length : 0, index, 'data.length');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Options that control how the component should be bootstrapped.
	 * @record
	 */
	
	/**
	 * Bootstraps a component, then creates and returns a `ComponentRef` for that component.
	 *
	 * @template T
	 * @param {?} componentType Component to bootstrap
	 * @param {?} opts
	 * @return {?}
	 */
	
	// TODO: A hack to not pull in the NullInjector from @angular/core.
	
	/**
	 * Bootstraps a Component into an existing host element and returns an instance
	 * of the component.
	 *
	 * @template T
	 * @param {?} componentType Component to bootstrap
	 * @param {?=} opts
	 * @return {?}
	 */
	function renderComponent(componentType, opts) {
	    if (opts === void 0) { opts = {}; }
	    var /** @type {?} */ rendererFactory = opts.rendererFactory || domRendererFactory3;
	    var /** @type {?} */ componentDef = componentType.ngComponentDef;
	    var /** @type {?} */ component;
	    var /** @type {?} */ hostNode = locateHostElement(rendererFactory, opts.host || componentDef.tag);
	    var /** @type {?} */ oldView = enterView(createViewState(-1, rendererFactory.createRenderer(hostNode, componentDef.rendererType), []), /** @type {?} */ ((null)));
	    try {
	        // Create element node at index 0 in data array
	        hostElement(hostNode, componentDef);
	        // Create directive instance with n() and store at index 1 in data array (el is 0)
	        component = directive(1, componentDef.n(), componentDef);
	    }
	    finally {
	        leaveView(oldView);
	    }
	    opts.features && opts.features.forEach(function (feature) { return feature(component, componentDef); });
	    detectChanges(component);
	    return component;
	}
	/**
	 * @template T
	 * @param {?} component
	 * @return {?}
	 */
	function detectChanges(component) {
	    ngDevMode && assertNotNull(component, 'component');
	    var /** @type {?} */ hostNode = /** @type {?} */ ((/** @type {?} */ (component))[NG_HOST_SYMBOL]);
	    if (ngDevMode && !hostNode) {
	        createError('Not a directive instance', component);
	    }
	    ngDevMode && assertNotNull(hostNode.data, 'hostNode.data');
	    renderComponentOrTemplate(hostNode, hostNode.view, component);
	    isDirty = false;
	}
	var isDirty = false;
	/**
	 * @template T
	 * @param {?} component
	 * @param {?=} scheduler
	 * @return {?}
	 */
	
	/**
	 * @template T
	 * @param {?} component
	 * @return {?}
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Create a component definition object.
	 *
	 *
	 * # Example
	 * ```
	 * class MyDirective {
	 *   // Generated by Angular Template Compiler
	 *   // [Symbol] syntax will not be supported by TypeScript until v2.7
	 *   static [COMPONENT_DEF_SYMBOL] = defineComponent({
	 *     ...
	 *   });
	 * }
	 * ```
	 * @template T
	 * @param {?} componentDefinition
	 * @return {?}
	 */
	function defineComponent(componentDefinition) {
	    var /** @type {?} */ def = /** @type {?} */ ({
	        type: componentDefinition.type,
	        diPublic: null,
	        n: componentDefinition.factory,
	        tag: (/** @type {?} */ (componentDefinition)).tag || /** @type {?} */ ((null)),
	        template: (/** @type {?} */ (componentDefinition)).template || /** @type {?} */ ((null)),
	        r: componentDefinition.refresh ||
	            function (d, e) { componentRefresh(d, e, componentDefinition.template); },
	        h: componentDefinition.hostBindings || noop$1,
	        inputs: invertObject(componentDefinition.inputs),
	        outputs: invertObject(componentDefinition.outputs),
	        methods: invertObject(componentDefinition.methods),
	        rendererType: resolveRendererType2(componentDefinition.rendererType) || null,
	    });
	    var /** @type {?} */ feature = componentDefinition.features;
	    feature && feature.forEach(function (fn) { return fn(def); });
	    return def;
	}
	/**
	 * @template T
	 * @param {?} definition
	 * @return {?}
	 */
	
	/**
	 * @template T
	 * @param {?} definition
	 * @return {?}
	 */
	
	var EMPTY$1 = {};
	/**
	 * @return {?}
	 */
	function noop$1() { }
	/**
	 * Swaps the keys and values of an object.
	 * @param {?} obj
	 * @return {?}
	 */
	function invertObject(obj) {
	    if (obj == null)
	        return EMPTY$1;
	    var /** @type {?} */ newObj = {};
	    for (var /** @type {?} */ minifiedKey in obj) {
	        newObj[obj[minifiedKey]] = minifiedKey;
	    }
	    return newObj;
	}
	/**
	 * Create a directive definition object.
	 *
	 * # Example
	 * ```
	 * class MyDirective {
	 *   // Generated by Angular Template Compiler
	 *   // [Symbol] syntax will not be supported by TypeScript until v2.7
	 *   static [DIRECTIVE_DEF_SYMBOL] = defineDirective({
	 *     ...
	 *   });
	 * }
	 * ```
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	// clang-format on
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link trigger trigger animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link state state animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link transition transition animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link keyframes keyframes animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link style style animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link animate animate animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link animateChild animateChild animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link useAnimation useAnimation animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link sequence sequence animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link group group animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link stagger stagger animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * `trigger` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the
	 * {\@link Component#animations component animations metadata page} to gain a better
	 * understanding of how animations in Angular are used.
	 *
	 * `trigger` Creates an animation trigger which will a list of {\@link state state} and
	 * {\@link transition transition} entries that will be evaluated when the expression
	 * bound to the trigger changes.
	 *
	 * Triggers are registered within the component annotation data under the
	 * {\@link Component#animations animations section}. An animation trigger can be placed on an element
	 * within a template by referencing the name of the trigger followed by the expression value that
	 * the
	 * trigger is bound to (in the form of `[\@triggerName]="expression"`.
	 *
	 * Animation trigger bindings strigify values and then match the previous and current values against
	 * any linked transitions. If a boolean value is provided into the trigger binding then it will both
	 * be represented as `1` or `true` and `0` or `false` for a true and false boolean values
	 * respectively.
	 *
	 * ### Usage
	 *
	 * `trigger` will create an animation trigger reference based on the provided `name` value. The
	 * provided `animation` value is expected to be an array consisting of {\@link state state} and
	 * {\@link transition transition} declarations.
	 *
	 * ```typescript
	 * \@Component({
	 *   selector: 'my-component',
	 *   templateUrl: 'my-component-tpl.html',
	 *   animations: [
	 *     trigger("myAnimationTrigger", [
	 *       state(...),
	 *       state(...),
	 *       transition(...),
	 *       transition(...)
	 *     ])
	 *   ]
	 * })
	 * class MyComponent {
	 *   myStatusExp = "something";
	 * }
	 * ```
	 *
	 * The template associated with this component will make use of the `myAnimationTrigger` animation
	 * trigger by binding to an element within its template code.
	 *
	 * ```html
	 * <!-- somewhere inside of my-component-tpl.html -->
	 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
	 * ```
	 *
	 * ## Disable Animations
	 * A special animation control binding called `\@.disabled` can be placed on an element which will
	 * then disable animations for any inner animation triggers situated within the element as well as
	 * any animations on the element itself.
	 *
	 * When true, the `\@.disabled` binding will prevent all animations from rendering. The example
	 * below shows how to use this feature:
	 *
	 * ```ts
	 * \@Component({
	 *   selector: 'my-component',
	 *   template: `
	 *     <div [\@.disabled]="isDisabled">
	 *       <div [\@childAnimation]="exp"></div>
	 *     </div>
	 *   `,
	 *   animations: [
	 *     trigger("childAnimation", [
	 *       // ...
	 *     ])
	 *   ]
	 * })
	 * class MyComponent {
	 *   isDisabled = true;
	 *   exp = '...';
	 * }
	 * ```
	 *
	 * The `\@childAnimation` trigger will not animate because `\@.disabled` prevents it from happening
	 * (when true).
	 *
	 * Note that `\@.disabled` will only disable all animations (this means any animations running on
	 * the same element will also be disabled).
	 *
	 * ### Disabling Animations Application-wide
	 * When an area of the template is set to have animations disabled, **all** inner components will
	 * also have their animations disabled as well. This means that all animations for an angular
	 * application can be disabled by placing a host binding set on `\@.disabled` on the topmost Angular
	 * component.
	 *
	 * ```ts
	 * import {Component, HostBinding} from '\@angular/core';
	 *
	 * \@Component({
	 *   selector: 'app-component',
	 *   templateUrl: 'app.component.html',
	 * })
	 * class AppComponent {
	 *   \@HostBinding('\@.disabled')
	 *   public animationsDisabled = true;
	 * }
	 * ```
	 *
	 * ### What about animations that us `query()` and `animateChild()`?
	 * Despite inner animations being disabled, a parent animation can {\@link query query} for inner
	 * elements located in disabled areas of the template and still animate them as it sees fit. This is
	 * also the case for when a sub animation is queried by a parent and then later animated using {\@link
	 * animateChild animateChild}.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} name
	 * @param {?} definitions
	 * @return {?}
	 */
	function trigger$1(name, definitions) {
	    return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
	}
	/**
	 * `animate` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `animate` specifies an animation step that will apply the provided `styles` data for a given
	 * amount of time based on the provided `timing` expression value. Calls to `animate` are expected
	 * to be used within {\@link sequence an animation sequence}, {\@link group group}, or {\@link
	 * transition transition}.
	 *
	 * ### Usage
	 *
	 * The `animate` function accepts two input parameters: `timing` and `styles`:
	 *
	 * - `timing` is a string based value that can be a combination of a duration with optional delay
	 * and easing values. The format for the expression breaks down to `duration delay easing`
	 * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
	 * delay=100, easing=ease-out`. If a numeric value is provided then that will be used as the
	 * `duration` value in millisecond form.
	 * - `styles` is the style input data which can either be a call to {\@link style style} or {\@link
	 * keyframes keyframes}. If left empty then the styles from the destination state will be collected
	 * and used (this is useful when describing an animation step that will complete an animation by
	 * {\@link transition#the-final-animate-call animating to the final state}).
	 *
	 * ```typescript
	 * // various functions for specifying timing data
	 * animate(500, style(...))
	 * animate("1s", style(...))
	 * animate("100ms 0.5s", style(...))
	 * animate("5s ease", style(...))
	 * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
	 *
	 * // either style() of keyframes() can be used
	 * animate(500, style({ background: "red" }))
	 * animate(500, keyframes([
	 *   style({ background: "blue" })),
	 *   style({ background: "red" }))
	 * ])
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} timings
	 * @param {?=} styles
	 * @return {?}
	 */
	function animate$1(timings, styles) {
	    if (styles === void 0) { styles = null; }
	    return { type: 4 /* Animate */, styles: styles, timings: timings };
	}
	/**
	 * `group` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `group` specifies a list of animation steps that are all run in parallel. Grouped animations are
	 * useful when a series of styles must be animated/closed off at different starting/ending times.
	 *
	 * The `group` function can either be used within a {\@link sequence sequence} or a {\@link transition
	 * transition} and it will only continue to the next instruction once all of the inner animation
	 * steps have completed.
	 *
	 * ### Usage
	 *
	 * The `steps` data that is passed into the `group` animation function can either consist of {\@link
	 * style style} or {\@link animate animate} function calls. Each call to `style()` or `animate()`
	 * within a group will be executed instantly (use {\@link keyframes keyframes} or a {\@link
	 * animate#usage animate() with a delay value} to offset styles to be applied at a later time).
	 *
	 * ```typescript
	 * group([
	 *   animate("1s", { background: "black" }))
	 *   animate("2s", { color: "white" }))
	 * ])
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function group$1(steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 3 /* Group */, steps: steps, options: options };
	}
	/**
	 * `sequence` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used by
	 * default when an array is passed as animation data into {\@link transition transition}.)
	 *
	 * The `sequence` function can either be used within a {\@link group group} or a {\@link transition
	 * transition} and it will only continue to the next instruction once each of the inner animation
	 * steps have completed.
	 *
	 * To perform animation styling in parallel with other animation steps then have a look at the
	 * {\@link group group} animation function.
	 *
	 * ### Usage
	 *
	 * The `steps` data that is passed into the `sequence` animation function can either consist of
	 * {\@link style style} or {\@link animate animate} function calls. A call to `style()` will apply the
	 * provided styling data immediately while a call to `animate()` will apply its styling data over a
	 * given time depending on its timing data.
	 *
	 * ```typescript
	 * sequence([
	 *   style({ opacity: 0 })),
	 *   animate("1s", { opacity: 1 }))
	 * ])
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function sequence$1(steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 2 /* Sequence */, steps: steps, options: options };
	}
	/**
	 * `style` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `style` declares a key/value object containing CSS properties/styles that can then be used for
	 * {\@link state animation states}, within an {\@link sequence animation sequence}, or as styling data
	 * for both {\@link animate animate} and {\@link keyframes keyframes}.
	 *
	 * ### Usage
	 *
	 * `style` takes in a key/value string map as data and expects one or more CSS property/value pairs
	 * to be defined.
	 *
	 * ```typescript
	 * // string values are used for css properties
	 * style({ background: "red", color: "blue" })
	 *
	 * // numerical (pixel) values are also supported
	 * style({ width: 100, height: 0 })
	 * ```
	 *
	 * #### Auto-styles (using `*`)
	 *
	 * When an asterix (`*`) character is used as a value then it will be detected from the element
	 * being animated and applied as animation data when the animation starts.
	 *
	 * This feature proves useful for a state depending on layout and/or environment factors; in such
	 * cases the styles are calculated just before the animation starts.
	 *
	 * ```typescript
	 * // the steps below will animate from 0 to the
	 * // actual height of the element
	 * style({ height: 0 }),
	 * animate("1s", style({ height: "*" }))
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} tokens
	 * @return {?}
	 */
	function style$1(tokens) {
	    return { type: 6 /* Style */, styles: tokens, offset: null };
	}
	/**
	 * `state` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `state` declares an animation state within the given trigger. When a state is active within a
	 * component then its associated styles will persist on the element that the trigger is attached to
	 * (even when the animation ends).
	 *
	 * To animate between states, have a look at the animation {\@link transition transition} DSL
	 * function. To register states to an animation trigger please have a look at the {\@link trigger
	 * trigger} function.
	 *
	 * #### The `void` state
	 *
	 * The `void` state value is a reserved word that angular uses to determine when the element is not
	 * apart of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
	 * associated element is void).
	 *
	 * #### The `*` (default) state
	 *
	 * The `*` state (when styled) is a fallback state that will be used if the state that is being
	 * animated is not declared within the trigger.
	 *
	 * ### Usage
	 *
	 * `state` will declare an animation state with its associated styles
	 * within the given trigger.
	 *
	 * - `stateNameExpr` can be one or more state names separated by commas.
	 * - `styles` refers to the {\@link style styling data} that will be persisted on the element once
	 * the state has been reached.
	 *
	 * ```typescript
	 * // "void" is a reserved name for a state and is used to represent
	 * // the state in which an element is detached from from the application.
	 * state("void", style({ height: 0 }))
	 *
	 * // user-defined states
	 * state("closed", style({ height: 0 }))
	 * state("open, visible", style({ height: "*" }))
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} name
	 * @param {?} styles
	 * @param {?=} options
	 * @return {?}
	 */
	function state$1(name, styles, options) {
	    return { type: 0 /* State */, name: name, styles: styles, options: options };
	}
	/**
	 * `keyframes` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `keyframes` specifies a collection of {\@link style style} entries each optionally characterized
	 * by an `offset` value.
	 *
	 * ### Usage
	 *
	 * The `keyframes` animation function is designed to be used alongside the {\@link animate animate}
	 * animation function. Instead of applying animations from where they are currently to their
	 * destination, keyframes can describe how each style entry is applied and at what point within the
	 * animation arc (much like CSS Keyframe Animations do).
	 *
	 * For each `style()` entry an `offset` value can be set. Doing so allows to specifiy at what
	 * percentage of the animate time the styles will be applied.
	 *
	 * ```typescript
	 * // the provided offset values describe when each backgroundColor value is applied.
	 * animate("5s", keyframes([
	 *   style({ backgroundColor: "red", offset: 0 }),
	 *   style({ backgroundColor: "blue", offset: 0.2 }),
	 *   style({ backgroundColor: "orange", offset: 0.3 }),
	 *   style({ backgroundColor: "black", offset: 1 })
	 * ]))
	 * ```
	 *
	 * Alternatively, if there are no `offset` values used within the style entries then the offsets
	 * will be calculated automatically.
	 *
	 * ```typescript
	 * animate("5s", keyframes([
	 *   style({ backgroundColor: "red" }) // offset = 0
	 *   style({ backgroundColor: "blue" }) // offset = 0.33
	 *   style({ backgroundColor: "orange" }) // offset = 0.66
	 *   style({ backgroundColor: "black" }) // offset = 1
	 * ]))
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @return {?}
	 */
	function keyframes$1(steps) {
	    return { type: 5 /* Keyframes */, steps: steps };
	}
	/**
	 * `transition` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `transition` declares the {\@link sequence sequence of animation steps} that will be run when the
	 * provided `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 =>
	 * state2` which consists of two known states (use an asterix (`*`) to refer to a dynamic starting
	 * and/or ending state).
	 *
	 * A function can also be provided as the `stateChangeExpr` argument for a transition and this
	 * function will be executed each time a state change occurs. If the value returned within the
	 * function is true then the associated animation will be run.
	 *
	 * Animation transitions are placed within an {\@link trigger animation trigger}. For an transition
	 * to animate to a state value and persist its styles then one or more {\@link state animation
	 * states} is expected to be defined.
	 *
	 * ### Usage
	 *
	 * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
	 * what the previous state is and what the current state has become. In other words, if a transition
	 * is defined that matches the old/current state criteria then the associated animation will be
	 * triggered.
	 *
	 * ```typescript
	 * // all transition/state changes are defined within an animation trigger
	 * trigger("myAnimationTrigger", [
	 *   // if a state is defined then its styles will be persisted when the
	 *   // animation has fully completed itself
	 *   state("on", style({ background: "green" })),
	 *   state("off", style({ background: "grey" })),
	 *
	 *   // a transition animation that will be kicked off when the state value
	 *   // bound to "myAnimationTrigger" changes from "on" to "off"
	 *   transition("on => off", animate(500)),
	 *
	 *   // it is also possible to do run the same animation for both directions
	 *   transition("on <=> off", animate(500)),
	 *
	 *   // or to define multiple states pairs separated by commas
	 *   transition("on => off, off => void", animate(500)),
	 *
	 *   // this is a catch-all state change for when an element is inserted into
	 *   // the page and the destination state is unknown
	 *   transition("void => *", [
	 *     style({ opacity: 0 }),
	 *     animate(500)
	 *   ]),
	 *
	 *   // this will capture a state change between any states
	 *   transition("* => *", animate("1s 0s")),
	 *
	 *   // you can also go full out and include a function
	 *   transition((fromState, toState) => {
	 *     // when `true` then it will allow the animation below to be invoked
	 *     return fromState == "off" && toState == "on";
	 *   }, animate("1s 0s"))
	 * ])
	 * ```
	 *
	 * The template associated with this component will make use of the `myAnimationTrigger` animation
	 * trigger by binding to an element within its template code.
	 *
	 * ```html
	 * <!-- somewhere inside of my-component-tpl.html -->
	 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
	 * ```
	 *
	 * #### The final `animate` call
	 *
	 * If the final step within the transition steps is a call to `animate()` that **only** uses a
	 * timing value with **no style data** then it will be automatically used as the final animation arc
	 * for the element to animate itself to the final state. This involves an automatic mix of
	 * adding/removing CSS styles so that the element will be in the exact state it should be for the
	 * applied state to be presented correctly.
	 *
	 * ```
	 * // start off by hiding the element, but make sure that it animates properly to whatever state
	 * // is currently active for "myAnimationTrigger"
	 * transition("void => *", [
	 *   style({ opacity: 0 }),
	 *   animate(500)
	 * ])
	 * ```
	 *
	 * ### Using :enter and :leave
	 *
	 * Given that enter (insertion) and leave (removal) animations are so common, the `transition`
	 * function accepts both `:enter` and `:leave` values which are aliases for the `void => *` and `*
	 * => void` state changes.
	 *
	 * ```
	 * transition(":enter", [
	 *   style({ opacity: 0 }),
	 *   animate(500, style({ opacity: 1 }))
	 * ]),
	 * transition(":leave", [
	 *   animate(500, style({ opacity: 0 }))
	 * ])
	 * ```
	 *
	 * ### Boolean values
	 * if a trigger binding value is a boolean value then it can be matched using a transition
	 * expression that compares `true` and `false` or `1` and `0`.
	 *
	 * ```
	 * // in the template
	 * <div [\@openClose]="open ? true : false">...</div>
	 *
	 * // in the component metadata
	 * trigger('openClose', [
	 *   state('true', style({ height: '*' })),
	 *   state('false', style({ height: '0px' })),
	 *   transition('false <=> true', animate(500))
	 * ])
	 * ```
	 *
	 * ### Using :increment and :decrement
	 * In addition to the :enter and :leave transition aliases, the :increment and :decrement aliases
	 * can be used to kick off a transition when a numeric value has increased or decreased in value.
	 *
	 * ```
	 * import {group, animate, query, transition, style, trigger} from '\@angular/animations';
	 * import {Component} from '\@angular/core';
	 *
	 * \@Component({
	 *   selector: 'banner-carousel-component',
	 *   styles: [`
	 *     .banner-container {
	 *        position:relative;
	 *        height:500px;
	 *        overflow:hidden;
	 *      }
	 *     .banner-container > .banner {
	 *        position:absolute;
	 *        left:0;
	 *        top:0;
	 *        font-size:200px;
	 *        line-height:500px;
	 *        font-weight:bold;
	 *        text-align:center;
	 *        width:100%;
	 *      }
	 *   `],
	 *   template: `
	 *     <button (click)="previous()">Previous</button>
	 *     <button (click)="next()">Next</button>
	 *     <hr>
	 *     <div [\@bannerAnimation]="selectedIndex" class="banner-container">
	 *       <div class="banner" *ngFor="let banner of banners"> {{ banner }} </div>
	 *     </div>
	 *   `,
	 *   animations: [
	 *     trigger('bannerAnimation', [
	 *       transition(":increment", group([
	 *         query(':enter', [
	 *           style({ left: '100%' }),
	 *           animate('0.5s ease-out', style('*'))
	 *         ]),
	 *         query(':leave', [
	 *           animate('0.5s ease-out', style({ left: '-100%' }))
	 *         ])
	 *       ])),
	 *       transition(":decrement", group([
	 *         query(':enter', [
	 *           style({ left: '-100%' }),
	 *           animate('0.5s ease-out', style('*'))
	 *         ]),
	 *         query(':leave', [
	 *           animate('0.5s ease-out', style({ left: '100%' }))
	 *         ])
	 *       ]))
	 *     ])
	 *   ]
	 * })
	 * class BannerCarouselComponent {
	 *   allBanners: string[] = ['1', '2', '3', '4'];
	 *   selectedIndex: number = 0;
	 *
	 *   get banners() {
	 *      return [this.allBanners[this.selectedIndex]];
	 *   }
	 *
	 *   previous() {
	 *     this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
	 *   }
	 *
	 *   next() {
	 *     this.selectedIndex = Math.min(this.selectedIndex + 1, this.allBanners.length - 1);
	 *   }
	 * }
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} stateChangeExpr
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function transition$1(stateChangeExpr, steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
	}
	/**
	 * `animation` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language.
	 *
	 * `var myAnimation = animation(...)` is designed to produce a reusable animation that can be later
	 * invoked in another animation or sequence. Reusable animations are designed to make use of
	 * animation parameters and the produced animation can be used via the `useAnimation` method.
	 *
	 * ```
	 * var fadeAnimation = animation([
	 *   style({ opacity: '{{ start }}' }),
	 *   animate('{{ time }}',
	 *     style({ opacity: '{{ end }}'}))
	 * ], { params: { time: '1000ms', start: 0, end: 1 }});
	 * ```
	 *
	 * If parameters are attached to an animation then they act as **default parameter values**. When an
	 * animation is invoked via `useAnimation` then parameter values are allowed to be passed in
	 * directly. If any of the passed in parameter values are missing then the default values will be
	 * used.
	 *
	 * ```
	 * useAnimation(fadeAnimation, {
	 *   params: {
	 *     time: '2s',
	 *     start: 1,
	 *     end: 0
	 *   }
	 * })
	 * ```
	 *
	 * If one or more parameter values are missing before animated then an error will be thrown.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	
	/**
	 * `animateChild` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. It works by allowing a queried element to execute its own
	 * animation within the animation sequence.
	 *
	 * Each time an animation is triggered in angular, the parent animation
	 * will always get priority and any child animations will be blocked. In order
	 * for a child animation to run, the parent animation must query each of the elements
	 * containing child animations and then allow the animations to run using `animateChild`.
	 *
	 * The example HTML code below shows both parent and child elements that have animation
	 * triggers that will execute at the same time.
	 *
	 * ```html
	 * <!-- parent-child.component.html -->
	 * <button (click)="exp =! exp">Toggle</button>
	 * <hr>
	 *
	 * <div [\@parentAnimation]="exp">
	 *   <header>Hello</header>
	 *   <div [\@childAnimation]="exp">
	 *       one
	 *   </div>
	 *   <div [\@childAnimation]="exp">
	 *       two
	 *   </div>
	 *   <div [\@childAnimation]="exp">
	 *       three
	 *   </div>
	 * </div>
	 * ```
	 *
	 * Now when the `exp` value changes to true, only the `parentAnimation` animation will animate
	 * because it has priority. However, using `query` and `animateChild` each of the inner animations
	 * can also fire:
	 *
	 * ```ts
	 * // parent-child.component.ts
	 * import {trigger, transition, animate, style, query, animateChild} from '\@angular/animations';
	 * \@Component({
	 *   selector: 'parent-child-component',
	 *   animations: [
	 *     trigger('parentAnimation', [
	 *       transition('false => true', [
	 *         query('header', [
	 *           style({ opacity: 0 }),
	 *           animate(500, style({ opacity: 1 }))
	 *         ]),
	 *         query('\@childAnimation', [
	 *           animateChild()
	 *         ])
	 *       ])
	 *     ]),
	 *     trigger('childAnimation', [
	 *       transition('false => true', [
	 *         style({ opacity: 0 }),
	 *         animate(500, style({ opacity: 1 }))
	 *       ])
	 *     ])
	 *   ]
	 * })
	 * class ParentChildCmp {
	 *   exp: boolean = false;
	 * }
	 * ```
	 *
	 * In the animation code above, when the `parentAnimation` transition kicks off it first queries to
	 * find the header element and fades it in. It then finds each of the sub elements that contain the
	 * `\@childAnimation` trigger and then allows for their animations to fire.
	 *
	 * This example can be further extended by using stagger:
	 *
	 * ```ts
	 * query('\@childAnimation', stagger(100, [
	 *   animateChild()
	 * ]))
	 * ```
	 *
	 * Now each of the sub animations start off with respect to the `100ms` staggering step.
	 *
	 * ## The first frame of child animations
	 * When sub animations are executed using `animateChild` the animation engine will always apply the
	 * first frame of every sub animation immediately at the start of the animation sequence. This way
	 * the parent animation does not need to set any initial styling data on the sub elements before the
	 * sub animations kick off.
	 *
	 * In the example above the first frame of the `childAnimation`'s `false => true` transition
	 * consists of a style of `opacity: 0`. This is applied immediately when the `parentAnimation`
	 * animation transition sequence starts. Only then when the `\@childAnimation` is queried and called
	 * with `animateChild` will it then animate to its destination of `opacity: 1`.
	 *
	 * Note that this feature designed to be used alongside {\@link query query()} and it will only work
	 * with animations that are assigned using the Angular animation DSL (this means that CSS keyframes
	 * and transitions are not handled by this API).
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?=} options
	 * @return {?}
	 */
	
	/**
	 * `useAnimation` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. It is used to kick off a reusable animation that is created using {\@link
	 * animation animation()}.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} animation
	 * @param {?=} options
	 * @return {?}
	 */
	
	/**
	 * `query` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language.
	 *
	 * query() is used to find one or more inner elements within the current element that is
	 * being animated within the sequence. The provided animation steps are applied
	 * to the queried element (by default, an array is provided, then this will be
	 * treated as an animation sequence).
	 *
	 * ### Usage
	 *
	 * query() is designed to collect mutiple elements and works internally by using
	 * `element.querySelectorAll`. An additional options object can be provided which
	 * can be used to limit the total amount of items to be collected.
	 *
	 * ```js
	 * query('div', [
	 *   animate(...),
	 *   animate(...)
	 * ], { limit: 1 })
	 * ```
	 *
	 * query(), by default, will throw an error when zero items are found. If a query
	 * has the `optional` flag set to true then this error will be ignored.
	 *
	 * ```js
	 * query('.some-element-that-may-not-be-there', [
	 *   animate(...),
	 *   animate(...)
	 * ], { optional: true })
	 * ```
	 *
	 * ### Special Selector Values
	 *
	 * The selector value within a query can collect elements that contain angular-specific
	 * characteristics
	 * using special pseudo-selectors tokens.
	 *
	 * These include:
	 *
	 *  - Querying for newly inserted/removed elements using `query(":enter")`/`query(":leave")`
	 *  - Querying all currently animating elements using `query(":animating")`
	 *  - Querying elements that contain an animation trigger using `query("\@triggerName")`
	 *  - Querying all elements that contain an animation triggers using `query("\@*")`
	 *  - Including the current element into the animation sequence using `query(":self")`
	 *
	 *
	 *  Each of these pseudo-selector tokens can be merged together into a combined query selector
	 * string:
	 *
	 *  ```
	 *  query(':self, .record:enter, .record:leave, \@subTrigger', [...])
	 *  ```
	 *
	 * ### Demo
	 *
	 * ```
	 * \@Component({
	 *   selector: 'inner',
	 *   template: `
	 *     <div [\@queryAnimation]="exp">
	 *       <h1>Title</h1>
	 *       <div class="content">
	 *         Blah blah blah
	 *       </div>
	 *     </div>
	 *   `,
	 *   animations: [
	 *    trigger('queryAnimation', [
	 *      transition('* => goAnimate', [
	 *        // hide the inner elements
	 *        query('h1', style({ opacity: 0 })),
	 *        query('.content', style({ opacity: 0 })),
	 *
	 *        // animate the inner elements in, one by one
	 *        query('h1', animate(1000, style({ opacity: 1 })),
	 *        query('.content', animate(1000, style({ opacity: 1 })),
	 *      ])
	 *    ])
	 *  ]
	 * })
	 * class Cmp {
	 *   exp = '';
	 *
	 *   goAnimate() {
	 *     this.exp = 'goAnimate';
	 *   }
	 * }
	 * ```
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} selector
	 * @param {?} animation
	 * @param {?=} options
	 * @return {?}
	 */
	
	/**
	 * `stagger` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. It is designed to be used inside of an animation {\@link query query()}
	 * and works by issuing a timing gap between after each queried item is animated.
	 *
	 * ### Usage
	 *
	 * In the example below there is a container element that wraps a list of items stamped out
	 * by an ngFor. The container element contains an animation trigger that will later be set
	 * to query for each of the inner items.
	 *
	 * ```html
	 * <!-- list.component.html -->
	 * <button (click)="toggle()">Show / Hide Items</button>
	 * <hr />
	 * <div [\@listAnimation]="items.length">
	 *   <div *ngFor="let item of items">
	 *     {{ item }}
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The component code for this looks as such:
	 *
	 * ```ts
	 * import {trigger, transition, style, animate, query, stagger} from '\@angular/animations';
	 * \@Component({
	 *   templateUrl: 'list.component.html',
	 *   animations: [
	 *     trigger('listAnimation', [
	 *        //...
	 *     ])
	 *   ]
	 * })
	 * class ListComponent {
	 *   items = [];
	 *
	 *   showItems() {
	 *     this.items = [0,1,2,3,4];
	 *   }
	 *
	 *   hideItems() {
	 *     this.items = [];
	 *   }
	 *
	 *   toggle() {
	 *     this.items.length ? this.hideItems() : this.showItems();
	 *   }
	 * }
	 * ```
	 *
	 * And now for the animation trigger code:
	 *
	 * ```ts
	 * trigger('listAnimation', [
	 *   transition('* => *', [ // each time the binding value changes
	 *     query(':leave', [
	 *       stagger(100, [
	 *         animate('0.5s', style({ opacity: 0 }))
	 *       ])
	 *     ]),
	 *     query(':enter', [
	 *       style({ opacity: 0 }),
	 *       stagger(100, [
	 *         animate('0.5s', style({ opacity: 1 }))
	 *       ])
	 *     ])
	 *   ])
	 * ])
	 * ```
	 *
	 * Now each time the items are added/removed then either the opacity
	 * fade-in animation will run or each removed item will be faded out.
	 * When either of these animations occur then a stagger effect will be
	 * applied after each item's animation is started.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} timings
	 * @param {?} animation
	 * @return {?}
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 */
	var AUTO_STYLE = '*';
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @record
	 */
	
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} name
	 * @param {?} definitions
	 * @return {?}
	 */
	function trigger$$1(name, definitions) {
	    return trigger$1(name, definitions);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} timings
	 * @param {?=} styles
	 * @return {?}
	 */
	function animate$$1(timings, styles) {
	    return animate$1(timings, styles);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} steps
	 * @return {?}
	 */
	function group$$1(steps) {
	    return group$1(steps);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} steps
	 * @return {?}
	 */
	function sequence$$1(steps) {
	    return sequence$1(steps);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} tokens
	 * @return {?}
	 */
	function style$$1(tokens) {
	    return style$1(tokens);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} name
	 * @param {?} styles
	 * @return {?}
	 */
	function state$$1(name, styles) {
	    return state$1(name, styles);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} steps
	 * @return {?}
	 */
	function keyframes$$1(steps) {
	    return keyframes$1(steps);
	}
	/**
	 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
	 * @param {?} stateChangeExpr
	 * @param {?} steps
	 * @return {?}
	 */
	function transition$$1(stateChangeExpr, steps) {
	    return transition$1(stateChangeExpr, steps);
	}
	
	exports.createPlatform = createPlatform;
	exports.assertPlatform = assertPlatform;
	exports.destroyPlatform = destroyPlatform;
	exports.getPlatform = getPlatform;
	exports.PlatformRef = PlatformRef;
	exports.ApplicationRef = ApplicationRef;
	exports.enableProdMode = enableProdMode;
	exports.isDevMode = isDevMode;
	exports.createPlatformFactory = createPlatformFactory;
	exports.NgProbeToken = NgProbeToken;
	exports.APP_ID = APP_ID;
	exports.PACKAGE_ROOT_URL = PACKAGE_ROOT_URL;
	exports.PLATFORM_INITIALIZER = PLATFORM_INITIALIZER;
	exports.PLATFORM_ID = PLATFORM_ID;
	exports.APP_BOOTSTRAP_LISTENER = APP_BOOTSTRAP_LISTENER;
	exports.APP_INITIALIZER = APP_INITIALIZER;
	exports.ApplicationInitStatus = ApplicationInitStatus;
	exports.DebugElement = DebugElement;
	exports.DebugNode = DebugNode;
	exports.asNativeElements = asNativeElements;
	exports.getDebugNode = getDebugNode;
	exports.Testability = Testability;
	exports.TestabilityRegistry = TestabilityRegistry;
	exports.setTestabilityGetter = setTestabilityGetter;
	exports.TRANSLATIONS = TRANSLATIONS;
	exports.TRANSLATIONS_FORMAT = TRANSLATIONS_FORMAT;
	exports.LOCALE_ID = LOCALE_ID;
	exports.MissingTranslationStrategy = MissingTranslationStrategy;
	exports.ApplicationModule = ApplicationModule;
	exports.wtfCreateScope = wtfCreateScope;
	exports.wtfLeave = wtfLeave;
	exports.wtfStartTimeRange = wtfStartTimeRange;
	exports.wtfEndTimeRange = wtfEndTimeRange;
	exports.Type = Type;
	exports.EventEmitter = EventEmitter;
	exports.ErrorHandler = ErrorHandler;
	exports.Sanitizer = Sanitizer;
	exports.SecurityContext = SecurityContext;
	exports.ANALYZE_FOR_ENTRY_COMPONENTS = ANALYZE_FOR_ENTRY_COMPONENTS;
	exports.Attribute = Attribute;
	exports.ContentChild = ContentChild;
	exports.ContentChildren = ContentChildren;
	exports.Query = Query;
	exports.ViewChild = ViewChild;
	exports.ViewChildren = ViewChildren;
	exports.Component = Component;
	exports.Directive = Directive;
	exports.HostBinding = HostBinding;
	exports.HostListener = HostListener;
	exports.Input = Input;
	exports.Output = Output;
	exports.Pipe = Pipe;
	exports.CUSTOM_ELEMENTS_SCHEMA = CUSTOM_ELEMENTS_SCHEMA;
	exports.NO_ERRORS_SCHEMA = NO_ERRORS_SCHEMA;
	exports.NgModule = NgModule;
	exports.ViewEncapsulation = ViewEncapsulation;
	exports.Version = Version;
	exports.VERSION = VERSION;
	exports.forwardRef = forwardRef;
	exports.resolveForwardRef = resolveForwardRef;
	exports.Injector = Injector;
	exports.ReflectiveInjector = ReflectiveInjector;
	exports.ResolvedReflectiveFactory = ResolvedReflectiveFactory;
	exports.ReflectiveKey = ReflectiveKey;
	exports.InjectionToken = InjectionToken;
	exports.Inject = Inject;
	exports.Optional = Optional;
	exports.Injectable = Injectable;
	exports.Self = Self;
	exports.SkipSelf = SkipSelf;
	exports.Host = Host;
	exports.NgZone = NgZone;
	exports.RenderComponentType = RenderComponentType;
	exports.Renderer = Renderer;
	exports.Renderer2 = Renderer2;
	exports.RendererFactory2 = RendererFactory2;
	exports.RendererStyleFlags2 = RendererStyleFlags2;
	exports.RootRenderer = RootRenderer;
	exports.COMPILER_OPTIONS = COMPILER_OPTIONS;
	exports.Compiler = Compiler;
	exports.CompilerFactory = CompilerFactory;
	exports.ModuleWithComponentFactories = ModuleWithComponentFactories;
	exports.ComponentFactory = ComponentFactory;
	exports.ComponentRef = ComponentRef;
	exports.ComponentFactoryResolver = ComponentFactoryResolver;
	exports.ElementRef = ElementRef;
	exports.NgModuleFactory = NgModuleFactory;
	exports.NgModuleRef = NgModuleRef;
	exports.NgModuleFactoryLoader = NgModuleFactoryLoader;
	exports.getModuleFactory = getModuleFactory;
	exports.QueryList = QueryList;
	exports.SystemJsNgModuleLoader = SystemJsNgModuleLoader;
	exports.SystemJsNgModuleLoaderConfig = SystemJsNgModuleLoaderConfig;
	exports.TemplateRef = TemplateRef;
	exports.ViewContainerRef = ViewContainerRef;
	exports.EmbeddedViewRef = EmbeddedViewRef;
	exports.ViewRef = ViewRef;
	exports.ChangeDetectionStrategy = ChangeDetectionStrategy;
	exports.ChangeDetectorRef = ChangeDetectorRef;
	exports.DefaultIterableDiffer = DefaultIterableDiffer;
	exports.IterableDiffers = IterableDiffers;
	exports.KeyValueDiffers = KeyValueDiffers;
	exports.SimpleChange = SimpleChange;
	exports.WrappedValue = WrappedValue;
	exports.platformCore = platformCore;
	exports.ɵALLOW_MULTIPLE_PLATFORMS = ALLOW_MULTIPLE_PLATFORMS;
	exports.ɵAPP_ID_RANDOM_PROVIDER = APP_ID_RANDOM_PROVIDER;
	exports.ɵdevModeEqual = devModeEqual;
	exports.ɵisListLikeIterable = isListLikeIterable;
	exports.ɵChangeDetectorStatus = ChangeDetectorStatus;
	exports.ɵisDefaultChangeDetectionStrategy = isDefaultChangeDetectionStrategy;
	exports.ɵConsole = Console;
	exports.ɵComponentFactory = ComponentFactory;
	exports.ɵCodegenComponentFactoryResolver = CodegenComponentFactoryResolver;
	exports.ɵReflectionCapabilities = ReflectionCapabilities;
	exports.ɵRenderDebugInfo = RenderDebugInfo;
	exports.ɵglobal = _global;
	exports.ɵlooseIdentical = looseIdentical;
	exports.ɵstringify = stringify;
	exports.ɵmakeDecorator = makeDecorator;
	exports.ɵisObservable = isObservable;
	exports.ɵisPromise = isPromise;
	exports.ɵclearOverrides = clearOverrides;
	exports.ɵoverrideComponentView = overrideComponentView;
	exports.ɵoverrideProvider = overrideProvider;
	exports.ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR = NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR;
	exports.ɵdefineComponent = defineComponent;
	exports.ɵdetectChanges = detectChanges;
	exports.ɵrenderComponent = renderComponent;
	exports.ɵC = containerStart;
	exports.ɵD = directive;
	exports.ɵE = elementStart;
	exports.ɵT = text;
	exports.ɵV = viewStart;
	exports.ɵb = bind;
	exports.ɵb1 = bind1;
	exports.ɵc = containerEnd;
	exports.ɵcR = containerRefreshStart;
	exports.ɵcr = containerRefreshEnd;
	exports.ɵe = elementEnd;
	exports.ɵp = elementProperty;
	exports.ɵs = elementStyle;
	exports.ɵt = textBinding;
	exports.ɵv = viewEnd;
	exports.ɵregisterModuleFactory = registerModuleFactory;
	exports.ɵEMPTY_ARRAY = EMPTY_ARRAY;
	exports.ɵEMPTY_MAP = EMPTY_MAP;
	exports.ɵand = anchorDef;
	exports.ɵccf = createComponentFactory;
	exports.ɵcmf = createNgModuleFactory;
	exports.ɵcrt = createRendererType2;
	exports.ɵdid = directiveDef;
	exports.ɵeld = elementDef;
	exports.ɵelementEventFullName = elementEventFullName;
	exports.ɵgetComponentViewDefinitionFactory = getComponentViewDefinitionFactory;
	exports.ɵinlineInterpolate = inlineInterpolate;
	exports.ɵinterpolate = interpolate;
	exports.ɵmod = moduleDef;
	exports.ɵmpd = moduleProvideDef;
	exports.ɵncd = ngContentDef;
	exports.ɵnov = nodeValue;
	exports.ɵpid = pipeDef;
	exports.ɵprd = providerDef;
	exports.ɵpad = pureArrayDef;
	exports.ɵpod = pureObjectDef;
	exports.ɵppd = purePipeDef;
	exports.ɵqud = queryDef;
	exports.ɵted = textDef;
	exports.ɵunv = unwrapValue;
	exports.ɵvid = viewDef;
	exports.AUTO_STYLE = AUTO_STYLE;
	exports.trigger = trigger$$1;
	exports.animate = animate$$1;
	exports.group = group$$1;
	exports.sequence = sequence$$1;
	exports.style = style$$1;
	exports.state = state$$1;
	exports.keyframes = keyframes$$1;
	exports.transition = transition$$1;
	exports.ɵbf = animate$1;
	exports.ɵbg = group$1;
	exports.ɵbk = keyframes$1;
	exports.ɵbh = sequence$1;
	exports.ɵbj = state$1;
	exports.ɵbi = style$1;
	exports.ɵbl = transition$1;
	exports.ɵbe = trigger$1;
	exports.ɵn = _iterableDiffersFactory;
	exports.ɵo = _keyValueDiffersFactory;
	exports.ɵq = _localeFactory;
	exports.ɵi = _appIdRandomProviderFactory;
	exports.ɵj = defaultIterableDiffers;
	exports.ɵk = defaultKeyValueDiffers;
	exports.ɵl = DefaultIterableDifferFactory;
	exports.ɵm = DefaultKeyValueDifferFactory;
	exports.ɵf = ReflectiveInjector_;
	exports.ɵg = ReflectiveDependency;
	exports.ɵh = resolveReflectiveProviders;
	exports.ɵr = wtfEnabled;
	exports.ɵw = createScope;
	exports.ɵu = detectWTF;
	exports.ɵz = endTimeRange;
	exports.ɵx = leave;
	exports.ɵy = startTimeRange;
	exports.ɵbc = stringify$1;
	exports.ɵa = makeParamDecorator;
	exports.ɵd = makePropDecorator;
	exports.ɵba = _def;
	exports.ɵbb = DebugContext;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=core.umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	var toSubscriber_1 = __webpack_require__(208);
	var observable_1 = __webpack_require__(219);
	var pipe_1 = __webpack_require__(220);
	/**
	 * A representation of any set of values over any amount of time. This is the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    /**
	     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
	     *
	     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
	     *
	     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
	     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
	     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
	     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
	     * thought.
	     *
	     * Apart from starting the execution of an Observable, this method allows you to listen for values
	     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
	     * following ways.
	     *
	     * The first way is creating an object that implements {@link Observer} interface. It should have methods
	     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
	     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
	     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
	     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
	     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
	     * be left uncaught.
	     *
	     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
	     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
	     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
	     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
	     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
	     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
	     *
	     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
	     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
	     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
	     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
	     *
	     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
	     * It is an Observable itself that decides when these functions will be called. For example {@link of}
	     * by default emits all its values synchronously. Always check documentation for how given Observable
	     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
	     *
	     * @example <caption>Subscribe with an Observer</caption>
	     * const sumObserver = {
	     *   sum: 0,
	     *   next(value) {
	     *     console.log('Adding: ' + value);
	     *     this.sum = this.sum + value;
	     *   },
	     *   error() { // We actually could just remove this method,
	     *   },        // since we do not really care about errors right now.
	     *   complete() {
	     *     console.log('Sum equals: ' + this.sum);
	     *   }
	     * };
	     *
	     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
	     * .subscribe(sumObserver);
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Subscribe with functions</caption>
	     * let sum = 0;
	     *
	     * Rx.Observable.of(1, 2, 3)
	     * .subscribe(
	     *   function(value) {
	     *     console.log('Adding: ' + value);
	     *     sum = sum + value;
	     *   },
	     *   undefined,
	     *   function() {
	     *     console.log('Sum equals: ' + sum);
	     *   }
	     * );
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Cancel a subscription</caption>
	     * const subscription = Rx.Observable.interval(1000).subscribe(
	     *   num => console.log(num),
	     *   undefined,
	     *   () => console.log('completed!') // Will not be called, even
	     * );                                // when cancelling subscription
	     *
	     *
	     * setTimeout(() => {
	     *   subscription.unsubscribe();
	     *   console.log('unsubscribed!');
	     * }, 2500);
	     *
	     * // Logs:
	     * // 0 after 1s
	     * // 1 after 2s
	     * // "unsubscribed!" after 2.5s
	     *
	     *
	     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
	     *  Observable.
	     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled.
	     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     * @method subscribe
	     */
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this.source);
	        }
	        else {
	            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.syncErrorThrown = true;
	            sink.syncErrorValue = err;
	            sink.error(err);
	        }
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            // Must be declared in a separate statement to avoid a RefernceError when
	            // accessing subscription below in the closure due to Temporal Dead Zone.
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    /** @deprecated internal use only */ Observable.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    /* tslint:enable:max-line-length */
	    /**
	     * Used to stitch together functional operators into a chain.
	     * @method pipe
	     * @return {Observable} the Observable result of all of the operators having
	     * been called in the order they were passed in.
	     *
	     * @example
	     *
	     * import { map, filter, scan } from 'rxjs/operators';
	     *
	     * Rx.Observable.interval(1000)
	     *   .pipe(
	     *     filter(x => x % 2 === 0),
	     *     map(x => x + x),
	     *     scan((acc, x) => acc + x)
	     *   )
	     *   .subscribe(x => console.log(x))
	     */
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i - 0] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    /* tslint:enable:max-line-length */
	    Observable.prototype.toPromise = function (PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	//# sourceMappingURL=Observable.js.map

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	// CommonJS / Node have global context exposed as "global" variable.
	// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
	// the global "global" var for now.
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof global !== 'undefined' && global;
	var _root = __window || __global || __self;
	exports.root = _root;
	// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
	// This is needed when used with angular/tsickle which inserts a goog.module statement.
	// Wrap in IIFE
	(function () {
	    if (!_root) {
	        throw new Error('RxJS could not find any global context (window, self, global)');
	    }
	})();
	//# sourceMappingURL=root.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subscriber_1 = __webpack_require__(209);
	var rxSubscriber_1 = __webpack_require__(218);
	var Observer_1 = __webpack_require__(217);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer_1.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	//# sourceMappingURL=toSubscriber.js.map

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(210);
	var Subscription_1 = __webpack_require__(211);
	var Observer_1 = __webpack_require__(217);
	var rxSubscriber_1 = __webpack_require__(218);
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    // HACK(benlesh): To resolve an issue where Node users may have multiple
	                    // copies of rxjs in their node_modules directory.
	                    if (isTrustedSubscriber(destinationOrNext)) {
	                        var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
	                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
	                        this.destination = trustedSubscriber;
	                        trustedSubscriber.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        this._parent = null;
	        this._parents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parent = _parent;
	        this._parents = _parents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer_1.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = this.unsubscribe.bind(this);
	            }
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._error) {
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parentSubscriber.syncErrorValue = err;
	                _parentSubscriber.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	function isTrustedSubscriber(obj) {
	    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber]);
	}
	//# sourceMappingURL=Subscriber.js.map

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	"use strict";
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(212);
	var isObject_1 = __webpack_require__(213);
	var isFunction_1 = __webpack_require__(210);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var UnsubscriptionError_1 = __webpack_require__(216);
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        this._parent = null;
	        this._parents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parent = null;
	        this._parents = null;
	        // null out _subscriptions first so any child subscriptions that attempt
	        // to remove themselves from this subscription will noop
	        this._subscriptions = null;
	        var index = -1;
	        var len = _parents ? _parents.length : 0;
	        // if this._parent is null, then so is this._parents, and we
	        // don't have to remove ourselves from any parent subscriptions.
	        while (_parent) {
	            _parent.remove(this);
	            // if this._parents is null or index >= len,
	            // then _parent is set to null, and the loop exits
	            _parent = ++index < len && _parents[index] || null;
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject_1.errorObject) {
	                hasErrors = true;
	                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
	                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            index = -1;
	            len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject_1.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject_1.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var subscription = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        var subscriptions = this._subscriptions || (this._subscriptions = []);
	        subscriptions.push(subscription);
	        subscription._addParent(this);
	        return subscription;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        if (!_parent || _parent === parent) {
	            // If we don't have a parent, or the new parent is the same as the
	            // current parent, then set this._parent to the new parent.
	            this._parent = parent;
	        }
	        else if (!_parents) {
	            // If there's already one parent, but not multiple, allocate an Array to
	            // store the rest of the parent Subscriptions.
	            this._parents = [parent];
	        }
	        else if (_parents.indexOf(parent) === -1) {
	            // Only add the new parent to the _parents list if it's not already there.
	            _parents.push(parent);
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

	"use strict";
	exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArray.js.map

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

	"use strict";
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	exports.isObject = isObject;
	//# sourceMappingURL=isObject.js.map

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errorObject_1 = __webpack_require__(215);
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject_1.errorObject.e = e;
	        return errorObject_1.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	exports.tryCatch = tryCatch;
	;
	//# sourceMappingURL=tryCatch.js.map

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

	"use strict";
	// typeof any so that it we don't have to cast when comparing a result to the error object
	exports.errorObject = { e: {} };
	//# sourceMappingURL=errorObject.js.map

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	exports.UnsubscriptionError = UnsubscriptionError;
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	"use strict";
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	//# sourceMappingURL=Observer.js.map

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	var Symbol = root_1.root.Symbol;
	exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	    Symbol.for('rxSubscriber') : '@@rxSubscriber';
	/**
	 * @deprecated use rxSubscriber instead
	 */
	exports.$$rxSubscriber = exports.rxSubscriber;
	//# sourceMappingURL=rxSubscriber.js.map

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	function getSymbolObservable(context) {
	    var $$observable;
	    var Symbol = context.Symbol;
	    if (typeof Symbol === 'function') {
	        if (Symbol.observable) {
	            $$observable = Symbol.observable;
	        }
	        else {
	            $$observable = Symbol('observable');
	            Symbol.observable = $$observable;
	        }
	    }
	    else {
	        $$observable = '@@observable';
	    }
	    return $$observable;
	}
	exports.getSymbolObservable = getSymbolObservable;
	exports.observable = getSymbolObservable(root_1.root);
	/**
	 * @deprecated use observable instead
	 */
	exports.$$observable = exports.observable;
	//# sourceMappingURL=observable.js.map

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var noop_1 = __webpack_require__(221);
	/* tslint:enable:max-line-length */
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i - 0] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	/* @internal */
	function pipeFromArray(fns) {
	    if (!fns) {
	        return noop_1.noop;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	"use strict";
	/* tslint:disable:no-empty */
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var ArrayObservable_1 = __webpack_require__(223);
	var isScheduler_1 = __webpack_require__(226);
	var mergeAll_1 = __webpack_require__(227);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (as arguments), and simply
	 * forwards (without doing any transformation) all the values from all the input
	 * Observables to the output Observable. The output Observable only completes
	 * once all input Observables have completed. Any error delivered by an input
	 * Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // timer will emit ascending values, one every second(1000ms) to console
	 * // clicks logs MouseEvents to console everytime the "document" is clicked
	 * // Since the two streams are merged you see these happening
	 * // as they occur.
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - First timer1 and timer2 will run concurrently
	 * // - timer1 will emit a value every 1000ms for 10 iterations
	 * // - timer2 will emit a value every 2000ms for 6 iterations
	 * // - after timer1 hits it's max iteration, timer2 will
	 * //   continue, and timer3 will start to run concurrently with timer2
	 * // - when timer2 hits it's max iteration it terminates, and
	 * //   timer3 will continue to emit a value every 500ms until it is complete
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {...ObservableInput} observables Input Observables to merge together.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} an Observable that emits items that are the result of
	 * every input Observable.
	 * @static true
	 * @name merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var concurrent = Number.POSITIVE_INFINITY;
	    var scheduler = null;
	    var last = observables[observables.length - 1];
	    if (isScheduler_1.isScheduler(last)) {
	        scheduler = observables.pop();
	        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
	            concurrent = observables.pop();
	        }
	    }
	    else if (typeof last === 'number') {
	        concurrent = observables.pop();
	    }
	    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
	        return observables[0];
	    }
	    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var ScalarObservable_1 = __webpack_require__(224);
	var EmptyObservable_1 = __webpack_require__(225);
	var isScheduler_1 = __webpack_require__(226);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayObservable = (function (_super) {
	    __extends(ArrayObservable, _super);
	    function ArrayObservable(array, scheduler) {
	        _super.call(this);
	        this.array = array;
	        this.scheduler = scheduler;
	        if (!scheduler && array.length === 1) {
	            this._isScalar = true;
	            this.value = array[0];
	        }
	    }
	    ArrayObservable.create = function (array, scheduler) {
	        return new ArrayObservable(array, scheduler);
	    };
	    /**
	     * Creates an Observable that emits some values you specify as arguments,
	     * immediately one after the other, and then emits a complete notification.
	     *
	     * <span class="informal">Emits the arguments you provide, then completes.
	     * </span>
	     *
	     * <img src="./img/of.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the arguments given, and the complete notification thereafter. It can
	     * be used for composing with other Observables, such as with {@link concat}.
	     * By default, it uses a `null` IScheduler, which means the `next`
	     * notifications are sent synchronously, although with a different IScheduler
	     * it is possible to determine when those notifications will be delivered.
	     *
	     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
	     * var numbers = Rx.Observable.of(10, 20, 30);
	     * var letters = Rx.Observable.of('a', 'b', 'c');
	     * var interval = Rx.Observable.interval(1000);
	     * var result = numbers.concat(letters).concat(interval);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link throw}
	     *
	     * @param {...T} values Arguments that represent `next` values to be emitted.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the `next` notifications.
	     * @return {Observable<T>} An Observable that emits each given input value.
	     * @static true
	     * @name of
	     * @owner Observable
	     */
	    ArrayObservable.of = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i - 0] = arguments[_i];
	        }
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len > 1) {
	            return new ArrayObservable(array, scheduler);
	        }
	        else if (len === 1) {
	            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
	        }
	        else {
	            return new EmptyObservable_1.EmptyObservable(scheduler);
	        }
	    };
	    ArrayObservable.dispatch = function (state) {
	        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(array[index]);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var array = this.array;
	        var count = array.length;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ArrayObservable.dispatch, 0, {
	                array: array, index: index, count: count, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < count && !subscriber.closed; i++) {
	                subscriber.next(array[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayObservable;
	}(Observable_1.Observable));
	exports.ArrayObservable = ArrayObservable;
	//# sourceMappingURL=ArrayObservable.js.map

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ScalarObservable = (function (_super) {
	    __extends(ScalarObservable, _super);
	    function ScalarObservable(value, scheduler) {
	        _super.call(this);
	        this.value = value;
	        this.scheduler = scheduler;
	        this._isScalar = true;
	        if (scheduler) {
	            this._isScalar = false;
	        }
	    }
	    ScalarObservable.create = function (value, scheduler) {
	        return new ScalarObservable(value, scheduler);
	    };
	    ScalarObservable.dispatch = function (state) {
	        var done = state.done, value = state.value, subscriber = state.subscriber;
	        if (done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        state.done = true;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function (subscriber) {
	        var value = this.value;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ScalarObservable.dispatch, 0, {
	                done: false, value: value, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.next(value);
	            if (!subscriber.closed) {
	                subscriber.complete();
	            }
	        }
	    };
	    return ScalarObservable;
	}(Observable_1.Observable));
	exports.ScalarObservable = ScalarObservable;
	//# sourceMappingURL=ScalarObservable.js.map

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var EmptyObservable = (function (_super) {
	    __extends(EmptyObservable, _super);
	    function EmptyObservable(scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits a complete notification.
	     *
	     * <span class="informal">Just emits 'complete', and nothing else.
	     * </span>
	     *
	     * <img src="./img/empty.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the complete notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then complete.</caption>
	     * var result = Rx.Observable.empty().startWith(7);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
	     * );
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following to the console:
	     * // x is equal to the count on the interval eg(0,1,2,3,...)
	     * // x will occur every 1000ms
	     * // if x % 2 is equal to 1 print abc
	     * // if x % 2 is not equal to 1 nothing will be output
	     *
	     * @see {@link create}
	     * @see {@link never}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the complete notification.
	     * @return {Observable} An "empty" Observable: emits only the complete
	     * notification.
	     * @static true
	     * @name empty
	     * @owner Observable
	     */
	    EmptyObservable.create = function (scheduler) {
	        return new EmptyObservable(scheduler);
	    };
	    EmptyObservable.dispatch = function (arg) {
	        var subscriber = arg.subscriber;
	        subscriber.complete();
	    };
	    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function (subscriber) {
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
	        }
	        else {
	            subscriber.complete();
	        }
	    };
	    return EmptyObservable;
	}(Observable_1.Observable));
	exports.EmptyObservable = EmptyObservable;
	//# sourceMappingURL=EmptyObservable.js.map

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	"use strict";
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(228);
	var identity_1 = __webpack_require__(235);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function mergeMapOperatorFunction(source) {
	        if (typeof resultSelector === 'number') {
	            concurrent = resultSelector;
	            resultSelector = null;
	        }
	        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
	    };
	}
	exports.mergeMap = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	exports.MergeMapOperator = MergeMapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapSubscriber = (function (_super) {
	    __extends(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result, value, index);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapSubscriber = MergeMapSubscriber;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	var isArrayLike_1 = __webpack_require__(230);
	var isPromise_1 = __webpack_require__(231);
	var isObject_1 = __webpack_require__(213);
	var Observable_1 = __webpack_require__(206);
	var iterator_1 = __webpack_require__(232);
	var InnerSubscriber_1 = __webpack_require__(233);
	var observable_1 = __webpack_require__(219);
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
	    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    if (destination.closed) {
	        return null;
	    }
	    if (result instanceof Observable_1.Observable) {
	        if (result._isScalar) {
	            destination.next(result.value);
	            destination.complete();
	            return null;
	        }
	        else {
	            destination.syncErrorThrowable = true;
	            return result.subscribe(destination);
	        }
	    }
	    else if (isArrayLike_1.isArrayLike(result)) {
	        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
	            destination.next(result[i]);
	        }
	        if (!destination.closed) {
	            destination.complete();
	        }
	    }
	    else if (isPromise_1.isPromise(result)) {
	        result.then(function (value) {
	            if (!destination.closed) {
	                destination.next(value);
	                destination.complete();
	            }
	        }, function (err) { return destination.error(err); })
	            .then(null, function (err) {
	            // Escaping the Promise trap: globally throw unhandled errors
	            root_1.root.setTimeout(function () { throw err; });
	        });
	        return destination;
	    }
	    else if (result && typeof result[iterator_1.iterator] === 'function') {
	        var iterator = result[iterator_1.iterator]();
	        do {
	            var item = iterator.next();
	            if (item.done) {
	                destination.complete();
	                break;
	            }
	            destination.next(item.value);
	            if (destination.closed) {
	                break;
	            }
	        } while (true);
	    }
	    else if (result && typeof result[observable_1.observable] === 'function') {
	        var obs = result[observable_1.observable]();
	        if (typeof obs.subscribe !== 'function') {
	            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
	        }
	        else {
	            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
	        }
	    }
	    else {
	        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = ("You provided " + value + " where a stream was expected.")
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        destination.error(new TypeError(msg));
	    }
	    return null;
	}
	exports.subscribeToResult = subscribeToResult;
	//# sourceMappingURL=subscribeToResult.js.map

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	"use strict";
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	"use strict";
	function isPromise(value) {
	    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	function symbolIteratorPonyfill(root) {
	    var Symbol = root.Symbol;
	    if (typeof Symbol === 'function') {
	        if (!Symbol.iterator) {
	            Symbol.iterator = Symbol('iterator polyfill');
	        }
	        return Symbol.iterator;
	    }
	    else {
	        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
	        var Set_1 = root.Set;
	        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
	            return '@@iterator';
	        }
	        var Map_1 = root.Map;
	        // required for compatability with es6-shim
	        if (Map_1) {
	            var keys = Object.getOwnPropertyNames(Map_1.prototype);
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
	                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
	                    return key;
	                }
	            }
	        }
	        return '@@iterator';
	    }
	}
	exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
	exports.iterator = symbolIteratorPonyfill(root_1.root);
	/**
	 * @deprecated use iterator instead
	 */
	exports.$$iterator = exports.iterator;
	//# sourceMappingURL=iterator.js.map

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerSubscriber = (function (_super) {
	    __extends(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        _super.call(this);
	        this.parent = parent;
	        this.outerValue = outerValue;
	        this.outerIndex = outerIndex;
	        this.index = 0;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.InnerSubscriber = InnerSubscriber;
	//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var OuterSubscriber = (function (_super) {
	    __extends(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        _super.apply(this, arguments);
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OuterSubscriber = OuterSubscriber;
	//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	"use strict";
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var share_1 = __webpack_require__(237);
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 *
	 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
	 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
	 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
	 * re-emit "test" to new subscriptions.
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return share_1.share()(this);
	}
	exports.share = share;
	;
	//# sourceMappingURL=share.js.map

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var multicast_1 = __webpack_require__(238);
	var refCount_1 = __webpack_require__(243);
	var Subject_1 = __webpack_require__(240);
	function shareSubjectFactory() {
	    return new Subject_1.Subject();
	}
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 * This is an alias for .multicast(() => new Subject()).refCount().
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return function (source) { return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source)); };
	}
	exports.share = share;
	;
	//# sourceMappingURL=share.js.map

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ConnectableObservable_1 = __webpack_require__(239);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the results of invoking a specified selector on items
	 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
	 * which the source sequence's elements will be multicast to the selector function
	 * or Subject to push source elements into.
	 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the given source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable} An Observable that emits the results of invoking the selector
	 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
	 * the underlying stream.
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    return function multicastOperatorFunction(source) {
	        var subjectFactory;
	        if (typeof subjectOrSubjectFactory === 'function') {
	            subjectFactory = subjectOrSubjectFactory;
	        }
	        else {
	            subjectFactory = function subjectFactory() {
	                return subjectOrSubjectFactory;
	            };
	        }
	        if (typeof selector === 'function') {
	            return source.lift(new MulticastOperator(subjectFactory, selector));
	        }
	        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
	        connectable.source = source;
	        connectable.subjectFactory = subjectFactory;
	        return connectable;
	    };
	}
	exports.multicast = multicast;
	var MulticastOperator = (function () {
	    function MulticastOperator(subjectFactory, selector) {
	        this.subjectFactory = subjectFactory;
	        this.selector = selector;
	    }
	    MulticastOperator.prototype.call = function (subscriber, source) {
	        var selector = this.selector;
	        var subject = this.subjectFactory();
	        var subscription = selector(subject).subscribe(subscriber);
	        subscription.add(source.subscribe(subject));
	        return subscription;
	    };
	    return MulticastOperator;
	}());
	exports.MulticastOperator = MulticastOperator;
	//# sourceMappingURL=multicast.js.map

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var Observable_1 = __webpack_require__(206);
	var Subscriber_1 = __webpack_require__(209);
	var Subscription_1 = __webpack_require__(211);
	var refCount_1 = __webpack_require__(243);
	/**
	 * @class ConnectableObservable<T>
	 */
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(/** @deprecated internal use only */ source, 
	        /** @deprecated internal use only */ subjectFactory) {
	        _super.call(this);
	        this.source = source;
	        this.subjectFactory = subjectFactory;
	        /** @deprecated internal use only */ this._refCount = 0;
	        this._isComplete = false;
	    }
	    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var connection = this._connection;
	        if (!connection) {
	            this._isComplete = false;
	            connection = this._connection = new Subscription_1.Subscription();
	            connection.add(this.source
	                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	            else {
	                this._connection = connection;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount_1.refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	var connectableProto = ConnectableObservable.prototype;
	exports.connectableObservableDescriptor = {
	    operator: { value: null },
	    _refCount: { value: 0, writable: true },
	    _subject: { value: null, writable: true },
	    _connection: { value: null, writable: true },
	    _subscribe: { value: connectableProto._subscribe },
	    _isComplete: { value: connectableProto._isComplete, writable: true },
	    getSubject: { value: connectableProto.getSubject },
	    connect: { value: connectableProto.connect },
	    refCount: { value: connectableProto.refCount }
	};
	var ConnectableSubscriber = (function (_super) {
	    __extends(ConnectableSubscriber, _super);
	    function ConnectableSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    ConnectableSubscriber.prototype._error = function (err) {
	        this._unsubscribe();
	        _super.prototype._error.call(this, err);
	    };
	    ConnectableSubscriber.prototype._complete = function () {
	        this.connectable._isComplete = true;
	        this._unsubscribe();
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (connectable) {
	            this.connectable = null;
	            var connection = connectable._connection;
	            connectable._refCount = 0;
	            connectable._subject = null;
	            connectable._connection = null;
	            if (connection) {
	                connection.unsubscribe();
	            }
	        }
	    };
	    return ConnectableSubscriber;
	}(Subject_1.SubjectSubscriber));
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var Subscriber_1 = __webpack_require__(209);
	var Subscription_1 = __webpack_require__(211);
	var ObjectUnsubscribedError_1 = __webpack_require__(241);
	var SubjectSubscription_1 = __webpack_require__(242);
	var rxSubscriber_1 = __webpack_require__(218);
	/**
	 * @class SubjectSubscriber<T>
	 */
	var SubjectSubscriber = (function (_super) {
	    __extends(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        _super.call(this, destination);
	        this.destination = destination;
	    }
	    return SubjectSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SubjectSubscriber = SubjectSubscriber;
	/**
	 * @class Subject<T>
	 */
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        _super.call(this);
	        this.observers = [];
	        this.closed = false;
	        this.isStopped = false;
	        this.hasError = false;
	        this.thrownError = null;
	    }
	    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._trySubscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return _super.prototype._trySubscribe.call(this, subscriber);
	        }
	    };
	    /** @deprecated internal use only */ Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	/**
	 * @class AnonymousSubject<T>
	 */
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        _super.call(this);
	        this.destination = destination;
	        this.source = source;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an action is invalid because the object has been
	 * unsubscribed.
	 *
	 * @see {@link Subject}
	 * @see {@link BehaviorSubject}
	 *
	 * @class ObjectUnsubscribedError
	 */
	var ObjectUnsubscribedError = (function (_super) {
	    __extends(ObjectUnsubscribedError, _super);
	    function ObjectUnsubscribedError() {
	        var err = _super.call(this, 'object unsubscribed');
	        this.name = err.name = 'ObjectUnsubscribedError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ObjectUnsubscribedError;
	}(Error));
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(211);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubjectSubscription = (function (_super) {
	    __extends(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        _super.call(this);
	        this.subject = subject;
	        this.subscriber = subscriber;
	        this.closed = false;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription_1.Subscription));
	exports.SubjectSubscription = SubjectSubscription;
	//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	function refCount() {
	    return function refCountOperatorFunction(source) {
	        return source.lift(new RefCountOperator(source));
	    };
	}
	exports.refCount = refCount;
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=refCount.js.map

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(245), __webpack_require__(205), __webpack_require__(246), __webpack_require__(247)) :
		typeof define === 'function' && define.amd ? define('@angular/platform-browser-dynamic', ['exports', '@angular/compiler', '@angular/core', '@angular/common', '@angular/platform-browser'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.platformBrowserDynamic = {}),global.ng.compiler,global.ng.core,global.ng.common,global.ng.platformBrowser));
	}(this, (function (exports,_angular_compiler,_angular_core,_angular_common,_angular_platformBrowser) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var MODULE_SUFFIX = '';
	var builtinExternalReferences = createBuiltinExternalReferencesMap();
	var JitReflector = /** @class */ (function () {
	    function JitReflector() {
	        this.builtinExternalReferences = new Map();
	        this.reflectionCapabilities = new _angular_core.ɵReflectionCapabilities();
	    }
	    /**
	     * @param {?} type
	     * @param {?} cmpMetadata
	     * @return {?}
	     */
	    JitReflector.prototype.componentModuleUrl = /**
	     * @param {?} type
	     * @param {?} cmpMetadata
	     * @return {?}
	     */
	    function (type, cmpMetadata) {
	        var /** @type {?} */ moduleId = cmpMetadata.moduleId;
	        if (typeof moduleId === 'string') {
	            var /** @type {?} */ scheme = _angular_compiler.getUrlScheme(moduleId);
	            return scheme ? moduleId : "package:" + moduleId + MODULE_SUFFIX;
	        }
	        else if (moduleId !== null && moduleId !== void 0) {
	            throw _angular_compiler.syntaxError("moduleId should be a string in \"" + _angular_core.ɵstringify(type) + "\". See https://goo.gl/wIDDiL for more information.\n" +
	                "If you're using Webpack you should inline the template and the styles, see https://goo.gl/X2J8zc.");
	        }
	        return "./" + _angular_core.ɵstringify(type);
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    JitReflector.prototype.parameters = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        return this.reflectionCapabilities.parameters(typeOrFunc);
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    JitReflector.prototype.annotations = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        return this.reflectionCapabilities.annotations(typeOrFunc);
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    JitReflector.prototype.propMetadata = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        return this.reflectionCapabilities.propMetadata(typeOrFunc);
	    };
	    /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    JitReflector.prototype.hasLifecycleHook = /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    function (type, lcProperty) {
	        return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    JitReflector.prototype.guards = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return this.reflectionCapabilities.guards(type); };
	    /**
	     * @param {?} ref
	     * @return {?}
	     */
	    JitReflector.prototype.resolveExternalReference = /**
	     * @param {?} ref
	     * @return {?}
	     */
	    function (ref) {
	        return builtinExternalReferences.get(ref) || ref.runtime;
	    };
	    return JitReflector;
	}());
	/**
	 * @return {?}
	 */
	function createBuiltinExternalReferencesMap() {
	    var /** @type {?} */ map = new Map();
	    map.set(_angular_compiler.Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS, _angular_core.ANALYZE_FOR_ENTRY_COMPONENTS);
	    map.set(_angular_compiler.Identifiers.ElementRef, _angular_core.ElementRef);
	    map.set(_angular_compiler.Identifiers.NgModuleRef, _angular_core.NgModuleRef);
	    map.set(_angular_compiler.Identifiers.ViewContainerRef, _angular_core.ViewContainerRef);
	    map.set(_angular_compiler.Identifiers.ChangeDetectorRef, _angular_core.ChangeDetectorRef);
	    map.set(_angular_compiler.Identifiers.QueryList, _angular_core.QueryList);
	    map.set(_angular_compiler.Identifiers.TemplateRef, _angular_core.TemplateRef);
	    map.set(_angular_compiler.Identifiers.CodegenComponentFactoryResolver, _angular_core.ɵCodegenComponentFactoryResolver);
	    map.set(_angular_compiler.Identifiers.ComponentFactoryResolver, _angular_core.ComponentFactoryResolver);
	    map.set(_angular_compiler.Identifiers.ComponentFactory, _angular_core.ComponentFactory);
	    map.set(_angular_compiler.Identifiers.ComponentRef, _angular_core.ComponentRef);
	    map.set(_angular_compiler.Identifiers.NgModuleFactory, _angular_core.NgModuleFactory);
	    map.set(_angular_compiler.Identifiers.createModuleFactory, _angular_core.ɵcmf);
	    map.set(_angular_compiler.Identifiers.moduleDef, _angular_core.ɵmod);
	    map.set(_angular_compiler.Identifiers.moduleProviderDef, _angular_core.ɵmpd);
	    map.set(_angular_compiler.Identifiers.RegisterModuleFactoryFn, _angular_core.ɵregisterModuleFactory);
	    map.set(_angular_compiler.Identifiers.Injector, _angular_core.Injector);
	    map.set(_angular_compiler.Identifiers.ViewEncapsulation, _angular_core.ViewEncapsulation);
	    map.set(_angular_compiler.Identifiers.ChangeDetectionStrategy, _angular_core.ChangeDetectionStrategy);
	    map.set(_angular_compiler.Identifiers.SecurityContext, _angular_core.SecurityContext);
	    map.set(_angular_compiler.Identifiers.LOCALE_ID, _angular_core.LOCALE_ID);
	    map.set(_angular_compiler.Identifiers.TRANSLATIONS_FORMAT, _angular_core.TRANSLATIONS_FORMAT);
	    map.set(_angular_compiler.Identifiers.inlineInterpolate, _angular_core.ɵinlineInterpolate);
	    map.set(_angular_compiler.Identifiers.interpolate, _angular_core.ɵinterpolate);
	    map.set(_angular_compiler.Identifiers.EMPTY_ARRAY, _angular_core.ɵEMPTY_ARRAY);
	    map.set(_angular_compiler.Identifiers.EMPTY_MAP, _angular_core.ɵEMPTY_MAP);
	    map.set(_angular_compiler.Identifiers.Renderer, _angular_core.Renderer);
	    map.set(_angular_compiler.Identifiers.viewDef, _angular_core.ɵvid);
	    map.set(_angular_compiler.Identifiers.elementDef, _angular_core.ɵeld);
	    map.set(_angular_compiler.Identifiers.anchorDef, _angular_core.ɵand);
	    map.set(_angular_compiler.Identifiers.textDef, _angular_core.ɵted);
	    map.set(_angular_compiler.Identifiers.directiveDef, _angular_core.ɵdid);
	    map.set(_angular_compiler.Identifiers.providerDef, _angular_core.ɵprd);
	    map.set(_angular_compiler.Identifiers.queryDef, _angular_core.ɵqud);
	    map.set(_angular_compiler.Identifiers.pureArrayDef, _angular_core.ɵpad);
	    map.set(_angular_compiler.Identifiers.pureObjectDef, _angular_core.ɵpod);
	    map.set(_angular_compiler.Identifiers.purePipeDef, _angular_core.ɵppd);
	    map.set(_angular_compiler.Identifiers.pipeDef, _angular_core.ɵpid);
	    map.set(_angular_compiler.Identifiers.nodeValue, _angular_core.ɵnov);
	    map.set(_angular_compiler.Identifiers.ngContentDef, _angular_core.ɵncd);
	    map.set(_angular_compiler.Identifiers.unwrapValue, _angular_core.ɵunv);
	    map.set(_angular_compiler.Identifiers.createRendererType2, _angular_core.ɵcrt);
	    map.set(_angular_compiler.Identifiers.createComponentFactory, _angular_core.ɵccf);
	    return map;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ERROR_COLLECTOR_TOKEN = new _angular_core.InjectionToken('ErrorCollector');
	/**
	 * A default provider for {\@link PACKAGE_ROOT_URL} that maps to '/'.
	 */
	var DEFAULT_PACKAGE_URL_PROVIDER = {
	    provide: _angular_core.PACKAGE_ROOT_URL,
	    useValue: '/'
	};
	var _NO_RESOURCE_LOADER = {
	    get: /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        throw new Error("No ResourceLoader implementation has been provided. Can't read the url \"" + url + "\"");
	    }
	};
	var baseHtmlParser = new _angular_core.InjectionToken('HtmlParser');
	var CompilerImpl = /** @class */ (function () {
	    function CompilerImpl(injector, _metadataResolver, templateParser, styleCompiler, viewCompiler, ngModuleCompiler, summaryResolver, compileReflector, compilerConfig, console) {
	        this._metadataResolver = _metadataResolver;
	        this._delegate = new _angular_compiler.JitCompiler(_metadataResolver, templateParser, styleCompiler, viewCompiler, ngModuleCompiler, summaryResolver, compileReflector, compilerConfig, console, this.getExtraNgModuleProviders.bind(this));
	        this.injector = injector;
	    }
	    /**
	     * @return {?}
	     */
	    CompilerImpl.prototype.getExtraNgModuleProviders = /**
	     * @return {?}
	     */
	    function () {
	        return [this._metadataResolver.getProviderMetadata(new _angular_compiler.ProviderMeta(_angular_core.Compiler, { useValue: this }))];
	    };
	    /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    CompilerImpl.prototype.compileModuleSync = /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return /** @type {?} */ (this._delegate.compileModuleSync(moduleType));
	    };
	    /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    CompilerImpl.prototype.compileModuleAsync = /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return /** @type {?} */ (this._delegate.compileModuleAsync(moduleType));
	    };
	    /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    CompilerImpl.prototype.compileModuleAndAllComponentsSync = /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        var /** @type {?} */ result = this._delegate.compileModuleAndAllComponentsSync(moduleType);
	        return {
	            ngModuleFactory: /** @type {?} */ (result.ngModuleFactory),
	            componentFactories: /** @type {?} */ (result.componentFactories),
	        };
	    };
	    /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    CompilerImpl.prototype.compileModuleAndAllComponentsAsync = /**
	     * @template T
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return this._delegate.compileModuleAndAllComponentsAsync(moduleType)
	            .then(function (result) {
	            return ({
	                ngModuleFactory: /** @type {?} */ (result.ngModuleFactory),
	                componentFactories: /** @type {?} */ (result.componentFactories),
	            });
	        });
	    };
	    /**
	     * @param {?} summaries
	     * @return {?}
	     */
	    CompilerImpl.prototype.loadAotSummaries = /**
	     * @param {?} summaries
	     * @return {?}
	     */
	    function (summaries) { this._delegate.loadAotSummaries(summaries); };
	    /**
	     * @param {?} ref
	     * @return {?}
	     */
	    CompilerImpl.prototype.hasAotSummary = /**
	     * @param {?} ref
	     * @return {?}
	     */
	    function (ref) { return this._delegate.hasAotSummary(ref); };
	    /**
	     * @template T
	     * @param {?} component
	     * @return {?}
	     */
	    CompilerImpl.prototype.getComponentFactory = /**
	     * @template T
	     * @param {?} component
	     * @return {?}
	     */
	    function (component) {
	        return /** @type {?} */ (this._delegate.getComponentFactory(component));
	    };
	    /**
	     * @return {?}
	     */
	    CompilerImpl.prototype.clearCache = /**
	     * @return {?}
	     */
	    function () { this._delegate.clearCache(); };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompilerImpl.prototype.clearCacheFor = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { this._delegate.clearCacheFor(type); };
	    return CompilerImpl;
	}());
	/**
	 * A set of providers that provide `JitCompiler` and its dependencies to use for
	 * template compilation.
	 */
	var COMPILER_PROVIDERS = /** @type {?} */ ([
	    { provide: _angular_compiler.CompileReflector, useValue: new JitReflector() },
	    { provide: _angular_compiler.ResourceLoader, useValue: _NO_RESOURCE_LOADER },
	    { provide: _angular_compiler.JitSummaryResolver, deps: [] },
	    { provide: _angular_compiler.SummaryResolver, useExisting: _angular_compiler.JitSummaryResolver },
	    { provide: _angular_core.ɵConsole, deps: [] },
	    { provide: _angular_compiler.Lexer, deps: [] },
	    { provide: _angular_compiler.Parser, deps: [_angular_compiler.Lexer] },
	    {
	        provide: baseHtmlParser,
	        useClass: _angular_compiler.HtmlParser,
	        deps: [],
	    },
	    {
	        provide: _angular_compiler.I18NHtmlParser,
	        useFactory: function (parser, translations, format, config, console) {
	            translations = translations || '';
	            var /** @type {?} */ missingTranslation = translations ? /** @type {?} */ ((config.missingTranslation)) : _angular_core.MissingTranslationStrategy.Ignore;
	            return new _angular_compiler.I18NHtmlParser(parser, translations, format, missingTranslation, console);
	        },
	        deps: [
	            baseHtmlParser,
	            [new _angular_core.Optional(), new _angular_core.Inject(_angular_core.TRANSLATIONS)],
	            [new _angular_core.Optional(), new _angular_core.Inject(_angular_core.TRANSLATIONS_FORMAT)],
	            [_angular_compiler.CompilerConfig],
	            [_angular_core.ɵConsole],
	        ]
	    },
	    {
	        provide: _angular_compiler.HtmlParser,
	        useExisting: _angular_compiler.I18NHtmlParser,
	    },
	    {
	        provide: _angular_compiler.TemplateParser, deps: [_angular_compiler.CompilerConfig, _angular_compiler.CompileReflector,
	            _angular_compiler.Parser, _angular_compiler.ElementSchemaRegistry,
	            _angular_compiler.I18NHtmlParser, _angular_core.ɵConsole]
	    },
	    { provide: _angular_compiler.DirectiveNormalizer, deps: [_angular_compiler.ResourceLoader, _angular_compiler.UrlResolver, _angular_compiler.HtmlParser, _angular_compiler.CompilerConfig] },
	    { provide: _angular_compiler.CompileMetadataResolver, deps: [_angular_compiler.CompilerConfig, _angular_compiler.HtmlParser, _angular_compiler.NgModuleResolver,
	            _angular_compiler.DirectiveResolver, _angular_compiler.PipeResolver,
	            _angular_compiler.SummaryResolver,
	            _angular_compiler.ElementSchemaRegistry,
	            _angular_compiler.DirectiveNormalizer, _angular_core.ɵConsole,
	            [_angular_core.Optional, _angular_compiler.StaticSymbolCache],
	            _angular_compiler.CompileReflector,
	            [_angular_core.Optional, ERROR_COLLECTOR_TOKEN]] },
	    DEFAULT_PACKAGE_URL_PROVIDER,
	    { provide: _angular_compiler.StyleCompiler, deps: [_angular_compiler.UrlResolver] },
	    { provide: _angular_compiler.ViewCompiler, deps: [_angular_compiler.CompileReflector] },
	    { provide: _angular_compiler.NgModuleCompiler, deps: [_angular_compiler.CompileReflector] },
	    { provide: _angular_compiler.CompilerConfig, useValue: new _angular_compiler.CompilerConfig() },
	    { provide: _angular_core.Compiler, useClass: CompilerImpl, deps: [_angular_core.Injector, _angular_compiler.CompileMetadataResolver,
	            _angular_compiler.TemplateParser, _angular_compiler.StyleCompiler,
	            _angular_compiler.ViewCompiler, _angular_compiler.NgModuleCompiler,
	            _angular_compiler.SummaryResolver, _angular_compiler.CompileReflector, _angular_compiler.CompilerConfig,
	            _angular_core.ɵConsole] },
	    { provide: _angular_compiler.DomElementSchemaRegistry, deps: [] },
	    { provide: _angular_compiler.ElementSchemaRegistry, useExisting: _angular_compiler.DomElementSchemaRegistry },
	    { provide: _angular_compiler.UrlResolver, deps: [_angular_core.PACKAGE_ROOT_URL] },
	    { provide: _angular_compiler.DirectiveResolver, deps: [_angular_compiler.CompileReflector] },
	    { provide: _angular_compiler.PipeResolver, deps: [_angular_compiler.CompileReflector] },
	    { provide: _angular_compiler.NgModuleResolver, deps: [_angular_compiler.CompileReflector] },
	]);
	/**
	 * \@experimental
	 */
	var JitCompilerFactory = /** @class */ (function () {
	    /* @internal */
	    function JitCompilerFactory(defaultOptions) {
	        var /** @type {?} */ compilerOptions = {
	            useJit: true,
	            defaultEncapsulation: _angular_core.ViewEncapsulation.Emulated,
	            missingTranslation: _angular_core.MissingTranslationStrategy.Warning,
	            enableLegacyTemplate: false,
	        };
	        this._defaultOptions = [compilerOptions].concat(defaultOptions);
	    }
	    /**
	     * @param {?=} options
	     * @return {?}
	     */
	    JitCompilerFactory.prototype.createCompiler = /**
	     * @param {?=} options
	     * @return {?}
	     */
	    function (options) {
	        if (options === void 0) { options = []; }
	        var /** @type {?} */ opts = _mergeOptions(this._defaultOptions.concat(options));
	        var /** @type {?} */ injector = _angular_core.Injector.create([
	            COMPILER_PROVIDERS, {
	                provide: _angular_compiler.CompilerConfig,
	                useFactory: function () {
	                    return new _angular_compiler.CompilerConfig({
	                        // let explicit values from the compiler options overwrite options
	                        // from the app providers
	                        useJit: opts.useJit,
	                        jitDevMode: _angular_core.isDevMode(),
	                        // let explicit values from the compiler options overwrite options
	                        // from the app providers
	                        defaultEncapsulation: opts.defaultEncapsulation,
	                        missingTranslation: opts.missingTranslation,
	                        enableLegacyTemplate: opts.enableLegacyTemplate,
	                        preserveWhitespaces: opts.preserveWhitespaces,
	                    });
	                },
	                deps: []
	            },
	            /** @type {?} */ ((opts.providers))
	        ]);
	        return injector.get(_angular_core.Compiler);
	    };
	    return JitCompilerFactory;
	}());
	/**
	 * @param {?} optionsArr
	 * @return {?}
	 */
	function _mergeOptions(optionsArr) {
	    return {
	        useJit: _lastDefined(optionsArr.map(function (options) { return options.useJit; })),
	        defaultEncapsulation: _lastDefined(optionsArr.map(function (options) { return options.defaultEncapsulation; })),
	        providers: _mergeArrays(optionsArr.map(function (options) { return ((options.providers)); })),
	        missingTranslation: _lastDefined(optionsArr.map(function (options) { return options.missingTranslation; })),
	        enableLegacyTemplate: _lastDefined(optionsArr.map(function (options) { return options.enableLegacyTemplate; })),
	        preserveWhitespaces: _lastDefined(optionsArr.map(function (options) { return options.preserveWhitespaces; })),
	    };
	}
	/**
	 * @template T
	 * @param {?} args
	 * @return {?}
	 */
	function _lastDefined(args) {
	    for (var /** @type {?} */ i = args.length - 1; i >= 0; i--) {
	        if (args[i] !== undefined) {
	            return args[i];
	        }
	    }
	    return undefined;
	}
	/**
	 * @param {?} parts
	 * @return {?}
	 */
	function _mergeArrays(parts) {
	    var /** @type {?} */ result = [];
	    parts.forEach(function (part) { return part && result.push.apply(result, part); });
	    return result;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A platform that included corePlatform and the compiler.
	 *
	 * \@experimental
	 */
	var platformCoreDynamic = _angular_core.createPlatformFactory(_angular_core.platformCore, 'coreDynamic', [
	    { provide: _angular_core.COMPILER_OPTIONS, useValue: {}, multi: true },
	    { provide: _angular_core.CompilerFactory, useClass: JitCompilerFactory, deps: [_angular_core.COMPILER_OPTIONS] },
	]);
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ResourceLoaderImpl = /** @class */ (function (_super) {
	    __extends(ResourceLoaderImpl, _super);
	    function ResourceLoaderImpl() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    ResourceLoaderImpl.prototype.get = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        var /** @type {?} */ resolve;
	        var /** @type {?} */ reject;
	        var /** @type {?} */ promise = new Promise(function (res, rej) {
	            resolve = res;
	            reject = rej;
	        });
	        var /** @type {?} */ xhr = new XMLHttpRequest();
	        xhr.open('GET', url, true);
	        xhr.responseType = 'text';
	        xhr.onload = function () {
	            // responseText is the old-school way of retrieving response (supported by IE8 & 9)
	            // response/responseType properties were introduced in ResourceLoader Level2 spec (supported
	            // by IE10)
	            var /** @type {?} */ response = xhr.response || xhr.responseText;
	            // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	            var /** @type {?} */ status = xhr.status === 1223 ? 204 : xhr.status;
	            // fix status code when it is 0 (0 status is undocumented).
	            // Occurs when accessing file resources or on Android 4.1 stock browser
	            // while retrieving files from application cache.
	            if (status === 0) {
	                status = response ? 200 : 0;
	            }
	            if (200 <= status && status <= 300) {
	                resolve(response);
	            }
	            else {
	                reject("Failed to load " + url);
	            }
	        };
	        xhr.onerror = function () { reject("Failed to load " + url); };
	        xhr.send();
	        return promise;
	    };
	    ResourceLoaderImpl.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ResourceLoaderImpl.ctorParameters = function () { return []; };
	    return ResourceLoaderImpl;
	}(_angular_compiler.ResourceLoader));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS = [
	    _angular_platformBrowser.ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS,
	    {
	        provide: _angular_core.COMPILER_OPTIONS,
	        useValue: { providers: [{ provide: _angular_compiler.ResourceLoader, useClass: ResourceLoaderImpl, deps: [] }] },
	        multi: true
	    },
	    { provide: _angular_core.PLATFORM_ID, useValue: _angular_common.ɵPLATFORM_BROWSER_ID },
	];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An implementation of ResourceLoader that uses a template cache to avoid doing an actual
	 * ResourceLoader.
	 *
	 * The template cache needs to be built and loaded into window.$templateCache
	 * via a separate mechanism.
	 */
	var CachedResourceLoader = /** @class */ (function (_super) {
	    __extends(CachedResourceLoader, _super);
	    function CachedResourceLoader() {
	        var _this = _super.call(this) || this;
	        _this._cache = (/** @type {?} */ (_angular_core.ɵglobal)).$templateCache;
	        if (_this._cache == null) {
	            throw new Error('CachedResourceLoader: Template cache was not found in $templateCache.');
	        }
	        return _this;
	    }
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    CachedResourceLoader.prototype.get = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        if (this._cache.hasOwnProperty(url)) {
	            return Promise.resolve(this._cache[url]);
	        }
	        else {
	            return /** @type {?} */ (Promise.reject('CachedResourceLoader: Did not find cached template for ' + url));
	        }
	    };
	    return CachedResourceLoader;
	}(_angular_compiler.ResourceLoader));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var VERSION = new _angular_core.Version('5.2.11');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@experimental
	 */
	var RESOURCE_CACHE_PROVIDER = [{ provide: _angular_compiler.ResourceLoader, useClass: CachedResourceLoader, deps: [] }];
	/**
	 * \@stable
	 */
	var platformBrowserDynamic = _angular_core.createPlatformFactory(platformCoreDynamic, 'browserDynamic', INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS);
	
	exports.VERSION = VERSION;
	exports.JitCompilerFactory = JitCompilerFactory;
	exports.RESOURCE_CACHE_PROVIDER = RESOURCE_CACHE_PROVIDER;
	exports.platformBrowserDynamic = platformBrowserDynamic;
	exports.ɵCompilerImpl = CompilerImpl;
	exports.ɵplatformCoreDynamic = platformCoreDynamic;
	exports.ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS = INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS;
	exports.ɵResourceLoaderImpl = ResourceLoaderImpl;
	exports.ɵa = CachedResourceLoader;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=platform-browser-dynamic.umd.js.map


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define('@angular/compiler', ['exports'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.compiler = {})));
	}(this, (function (exports) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// Attention:
	// This file duplicates types and values from @angular/core
	// so that we are able to make @angular/compiler independent of @angular/core.
	// This is important to prevent a build cycle, as @angular/core needs to
	// be compiled with the compiler.
	/**
	 * @record
	 */
	function Inject() { }
	var createInject = makeMetadataFactory('Inject', function (token) { return ({ token: token }); });
	var createInjectionToken = makeMetadataFactory('InjectionToken', function (desc) { return ({ _desc: desc }); });
	/**
	 * @record
	 */
	function Attribute() { }
	var createAttribute = makeMetadataFactory('Attribute', function (attributeName) { return ({ attributeName: attributeName }); });
	/**
	 * @record
	 */
	function Query() { }
	var createContentChildren = makeMetadataFactory('ContentChildren', function (selector, data) {
	    if (data === void 0) { data = {}; }
	    return (__assign({ selector: selector, first: false, isViewQuery: false, descendants: false }, data));
	});
	var createContentChild = makeMetadataFactory('ContentChild', function (selector, data) {
	    if (data === void 0) { data = {}; }
	    return (__assign({ selector: selector, first: true, isViewQuery: false, descendants: true }, data));
	});
	var createViewChildren = makeMetadataFactory('ViewChildren', function (selector, data) {
	    if (data === void 0) { data = {}; }
	    return (__assign({ selector: selector, first: false, isViewQuery: true, descendants: true }, data));
	});
	var createViewChild = makeMetadataFactory('ViewChild', function (selector, data) {
	    return (__assign({ selector: selector, first: true, isViewQuery: true, descendants: true }, data));
	});
	/**
	 * @record
	 */
	function Directive() { }
	var createDirective = makeMetadataFactory('Directive', function (dir) {
	    if (dir === void 0) { dir = {}; }
	    return dir;
	});
	/**
	 * @record
	 */
	function Component() { }
	/** @enum {number} */
	var ViewEncapsulation = {
	    Emulated: 0,
	    Native: 1,
	    None: 2,
	};
	ViewEncapsulation[ViewEncapsulation.Emulated] = "Emulated";
	ViewEncapsulation[ViewEncapsulation.Native] = "Native";
	ViewEncapsulation[ViewEncapsulation.None] = "None";
	/** @enum {number} */
	var ChangeDetectionStrategy = {
	    OnPush: 0,
	    Default: 1,
	};
	ChangeDetectionStrategy[ChangeDetectionStrategy.OnPush] = "OnPush";
	ChangeDetectionStrategy[ChangeDetectionStrategy.Default] = "Default";
	var createComponent = makeMetadataFactory('Component', function (c) {
	    if (c === void 0) { c = {}; }
	    return (__assign({ changeDetection: ChangeDetectionStrategy.Default }, c));
	});
	/**
	 * @record
	 */
	function Pipe() { }
	var createPipe = makeMetadataFactory('Pipe', function (p) { return (__assign({ pure: true }, p)); });
	/**
	 * @record
	 */
	function Input() { }
	var createInput = makeMetadataFactory('Input', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
	/**
	 * @record
	 */
	function Output() { }
	var createOutput = makeMetadataFactory('Output', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
	/**
	 * @record
	 */
	function HostBinding() { }
	var createHostBinding = makeMetadataFactory('HostBinding', function (hostPropertyName) { return ({ hostPropertyName: hostPropertyName }); });
	/**
	 * @record
	 */
	function HostListener() { }
	var createHostListener = makeMetadataFactory('HostListener', function (eventName, args) { return ({ eventName: eventName, args: args }); });
	/**
	 * @record
	 */
	function NgModule() { }
	var createNgModule = makeMetadataFactory('NgModule', function (ngModule) { return ngModule; });
	/**
	 * @record
	 */
	function ModuleWithProviders() { }
	/**
	 * @record
	 */
	function SchemaMetadata() { }
	var CUSTOM_ELEMENTS_SCHEMA = {
	    name: 'custom-elements'
	};
	var NO_ERRORS_SCHEMA = {
	    name: 'no-errors-schema'
	};
	var createOptional = makeMetadataFactory('Optional');
	var createInjectable = makeMetadataFactory('Injectable');
	var createSelf = makeMetadataFactory('Self');
	var createSkipSelf = makeMetadataFactory('SkipSelf');
	var createHost = makeMetadataFactory('Host');
	var Type = Function;
	/** @enum {number} */
	var SecurityContext = {
	    NONE: 0,
	    HTML: 1,
	    STYLE: 2,
	    SCRIPT: 3,
	    URL: 4,
	    RESOURCE_URL: 5,
	};
	SecurityContext[SecurityContext.NONE] = "NONE";
	SecurityContext[SecurityContext.HTML] = "HTML";
	SecurityContext[SecurityContext.STYLE] = "STYLE";
	SecurityContext[SecurityContext.SCRIPT] = "SCRIPT";
	SecurityContext[SecurityContext.URL] = "URL";
	SecurityContext[SecurityContext.RESOURCE_URL] = "RESOURCE_URL";
	/** @enum {number} */
	var NodeFlags = {
	    None: 0,
	    TypeElement: 1,
	    TypeText: 2,
	    ProjectedTemplate: 4,
	    CatRenderNode: 3,
	    TypeNgContent: 8,
	    TypePipe: 16,
	    TypePureArray: 32,
	    TypePureObject: 64,
	    TypePurePipe: 128,
	    CatPureExpression: 224,
	    TypeValueProvider: 256,
	    TypeClassProvider: 512,
	    TypeFactoryProvider: 1024,
	    TypeUseExistingProvider: 2048,
	    LazyProvider: 4096,
	    PrivateProvider: 8192,
	    TypeDirective: 16384,
	    Component: 32768,
	    CatProviderNoDirective: 3840,
	    CatProvider: 20224,
	    OnInit: 65536,
	    OnDestroy: 131072,
	    DoCheck: 262144,
	    OnChanges: 524288,
	    AfterContentInit: 1048576,
	    AfterContentChecked: 2097152,
	    AfterViewInit: 4194304,
	    AfterViewChecked: 8388608,
	    EmbeddedViews: 16777216,
	    ComponentView: 33554432,
	    TypeContentQuery: 67108864,
	    TypeViewQuery: 134217728,
	    StaticQuery: 268435456,
	    DynamicQuery: 536870912,
	    CatQuery: 201326592,
	    // mutually exclusive values...
	    Types: 201347067,
	};
	/** @enum {number} */
	var DepFlags = {
	    None: 0,
	    SkipSelf: 1,
	    Optional: 2,
	    Value: 8,
	};
	/** @enum {number} */
	var ArgumentType = { Inline: 0, Dynamic: 1, };
	/** @enum {number} */
	var BindingFlags = {
	    TypeElementAttribute: 1,
	    TypeElementClass: 2,
	    TypeElementStyle: 4,
	    TypeProperty: 8,
	    SyntheticProperty: 16,
	    SyntheticHostProperty: 32,
	    CatSyntheticProperty: 48,
	    // mutually exclusive values...
	    Types: 15,
	};
	/** @enum {number} */
	var QueryBindingType = { First: 0, All: 1, };
	/** @enum {number} */
	var QueryValueType = {
	    ElementRef: 0,
	    RenderElement: 1,
	    TemplateRef: 2,
	    ViewContainerRef: 3,
	    Provider: 4,
	};
	/** @enum {number} */
	var ViewFlags = {
	    None: 0,
	    OnPush: 2,
	};
	/** @enum {number} */
	var MissingTranslationStrategy = {
	    Error: 0,
	    Warning: 1,
	    Ignore: 2,
	};
	MissingTranslationStrategy[MissingTranslationStrategy.Error] = "Error";
	MissingTranslationStrategy[MissingTranslationStrategy.Warning] = "Warning";
	MissingTranslationStrategy[MissingTranslationStrategy.Ignore] = "Ignore";
	/**
	 * @record
	 * @template T
	 */
	function MetadataFactory() { }
	/**
	 * @template T
	 * @param {?} name
	 * @param {?=} props
	 * @return {?}
	 */
	function makeMetadataFactory(name, props) {
	    var /** @type {?} */ factory = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var /** @type {?} */ values = props ? props.apply(void 0, args) : {};
	        return __assign({ ngMetadataName: name }, values);
	    };
	    factory.isTypeOf = function (obj) { return obj && obj.ngMetadataName === name; };
	    factory.ngMetadataName = name;
	    return factory;
	}
	/**
	 * @record
	 */
	function Route() { }
	
	
	
	var core = Object.freeze({
		Inject: Inject,
		createInject: createInject,
		createInjectionToken: createInjectionToken,
		Attribute: Attribute,
		createAttribute: createAttribute,
		Query: Query,
		createContentChildren: createContentChildren,
		createContentChild: createContentChild,
		createViewChildren: createViewChildren,
		createViewChild: createViewChild,
		Directive: Directive,
		createDirective: createDirective,
		Component: Component,
		ViewEncapsulation: ViewEncapsulation,
		ChangeDetectionStrategy: ChangeDetectionStrategy,
		createComponent: createComponent,
		Pipe: Pipe,
		createPipe: createPipe,
		Input: Input,
		createInput: createInput,
		Output: Output,
		createOutput: createOutput,
		HostBinding: HostBinding,
		createHostBinding: createHostBinding,
		HostListener: HostListener,
		createHostListener: createHostListener,
		NgModule: NgModule,
		createNgModule: createNgModule,
		ModuleWithProviders: ModuleWithProviders,
		SchemaMetadata: SchemaMetadata,
		CUSTOM_ELEMENTS_SCHEMA: CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA: NO_ERRORS_SCHEMA,
		createOptional: createOptional,
		createInjectable: createInjectable,
		createSelf: createSelf,
		createSkipSelf: createSkipSelf,
		createHost: createHost,
		Type: Type,
		SecurityContext: SecurityContext,
		NodeFlags: NodeFlags,
		DepFlags: DepFlags,
		ArgumentType: ArgumentType,
		BindingFlags: BindingFlags,
		QueryBindingType: QueryBindingType,
		QueryValueType: QueryValueType,
		ViewFlags: ViewFlags,
		MissingTranslationStrategy: MissingTranslationStrategy,
		MetadataFactory: MetadataFactory,
		Route: Route
	});
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function dashCaseToCamelCase(input) {
	    return input.replace(DASH_CASE_REGEXP, function () {
	        var m = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            m[_i] = arguments[_i];
	        }
	        return m[1].toUpperCase();
	    });
	}
	/**
	 * @param {?} input
	 * @param {?} defaultValues
	 * @return {?}
	 */
	function splitAtColon(input, defaultValues) {
	    return _splitAt(input, ':', defaultValues);
	}
	/**
	 * @param {?} input
	 * @param {?} defaultValues
	 * @return {?}
	 */
	function splitAtPeriod(input, defaultValues) {
	    return _splitAt(input, '.', defaultValues);
	}
	/**
	 * @param {?} input
	 * @param {?} character
	 * @param {?} defaultValues
	 * @return {?}
	 */
	function _splitAt(input, character, defaultValues) {
	    var /** @type {?} */ characterIndex = input.indexOf(character);
	    if (characterIndex == -1)
	        return defaultValues;
	    return [input.slice(0, characterIndex).trim(), input.slice(characterIndex + 1).trim()];
	}
	/**
	 * @param {?} value
	 * @param {?} visitor
	 * @param {?} context
	 * @return {?}
	 */
	function visitValue(value, visitor, context) {
	    if (Array.isArray(value)) {
	        return visitor.visitArray(/** @type {?} */ (value), context);
	    }
	    if (isStrictStringMap(value)) {
	        return visitor.visitStringMap(/** @type {?} */ (value), context);
	    }
	    if (value == null || typeof value == 'string' || typeof value == 'number' ||
	        typeof value == 'boolean') {
	        return visitor.visitPrimitive(value, context);
	    }
	    return visitor.visitOther(value, context);
	}
	/**
	 * @param {?} val
	 * @return {?}
	 */
	function isDefined(val) {
	    return val !== null && val !== undefined;
	}
	/**
	 * @template T
	 * @param {?} val
	 * @return {?}
	 */
	function noUndefined(val) {
	    return val === undefined ? /** @type {?} */ ((null)) : val;
	}
	/**
	 * @record
	 */
	
	var ValueTransformer = /** @class */ (function () {
	    function ValueTransformer() {
	    }
	    /**
	     * @param {?} arr
	     * @param {?} context
	     * @return {?}
	     */
	    ValueTransformer.prototype.visitArray = /**
	     * @param {?} arr
	     * @param {?} context
	     * @return {?}
	     */
	    function (arr, context) {
	        var _this = this;
	        return arr.map(function (value) { return visitValue(value, _this, context); });
	    };
	    /**
	     * @param {?} map
	     * @param {?} context
	     * @return {?}
	     */
	    ValueTransformer.prototype.visitStringMap = /**
	     * @param {?} map
	     * @param {?} context
	     * @return {?}
	     */
	    function (map, context) {
	        var _this = this;
	        var /** @type {?} */ result = {};
	        Object.keys(map).forEach(function (key) { result[key] = visitValue(map[key], _this, context); });
	        return result;
	    };
	    /**
	     * @param {?} value
	     * @param {?} context
	     * @return {?}
	     */
	    ValueTransformer.prototype.visitPrimitive = /**
	     * @param {?} value
	     * @param {?} context
	     * @return {?}
	     */
	    function (value, context) { return value; };
	    /**
	     * @param {?} value
	     * @param {?} context
	     * @return {?}
	     */
	    ValueTransformer.prototype.visitOther = /**
	     * @param {?} value
	     * @param {?} context
	     * @return {?}
	     */
	    function (value, context) { return value; };
	    return ValueTransformer;
	}());
	var SyncAsync = {
	    assertSync: function (value) {
	        if (isPromise(value)) {
	            throw new Error("Illegal state: value cannot be a promise");
	        }
	        return value;
	    },
	    then: function (value, cb) { return isPromise(value) ? value.then(cb) : cb(value); },
	    all: function (syncAsyncValues) {
	        return syncAsyncValues.some(isPromise) ? Promise.all(syncAsyncValues) : /** @type {?} */ (syncAsyncValues);
	    }
	};
	/**
	 * @param {?} msg
	 * @param {?=} parseErrors
	 * @return {?}
	 */
	function syntaxError(msg, parseErrors) {
	    var /** @type {?} */ error = Error(msg);
	    (/** @type {?} */ (error))[ERROR_SYNTAX_ERROR] = true;
	    if (parseErrors)
	        (/** @type {?} */ (error))[ERROR_PARSE_ERRORS] = parseErrors;
	    return error;
	}
	var ERROR_SYNTAX_ERROR = 'ngSyntaxError';
	var ERROR_PARSE_ERRORS = 'ngParseErrors';
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function isSyntaxError(error) {
	    return (/** @type {?} */ (error))[ERROR_SYNTAX_ERROR];
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function getParseErrors(error) {
	    return (/** @type {?} */ (error))[ERROR_PARSE_ERRORS] || [];
	}
	/**
	 * @param {?} s
	 * @return {?}
	 */
	function escapeRegExp(s) {
	    return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	}
	var STRING_MAP_PROTO = Object.getPrototypeOf({});
	/**
	 * @param {?} obj
	 * @return {?}
	 */
	function isStrictStringMap(obj) {
	    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
	}
	/**
	 * @param {?} str
	 * @return {?}
	 */
	function utf8Encode(str) {
	    var /** @type {?} */ encoded = '';
	    for (var /** @type {?} */ index = 0; index < str.length; index++) {
	        var /** @type {?} */ codePoint = str.charCodeAt(index);
	        // decode surrogate
	        // see https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        if (codePoint >= 0xd800 && codePoint <= 0xdbff && str.length > (index + 1)) {
	            var /** @type {?} */ low = str.charCodeAt(index + 1);
	            if (low >= 0xdc00 && low <= 0xdfff) {
	                index++;
	                codePoint = ((codePoint - 0xd800) << 10) + low - 0xdc00 + 0x10000;
	            }
	        }
	        if (codePoint <= 0x7f) {
	            encoded += String.fromCharCode(codePoint);
	        }
	        else if (codePoint <= 0x7ff) {
	            encoded += String.fromCharCode(((codePoint >> 6) & 0x1F) | 0xc0, (codePoint & 0x3f) | 0x80);
	        }
	        else if (codePoint <= 0xffff) {
	            encoded += String.fromCharCode((codePoint >> 12) | 0xe0, ((codePoint >> 6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
	        }
	        else if (codePoint <= 0x1fffff) {
	            encoded += String.fromCharCode(((codePoint >> 18) & 0x07) | 0xf0, ((codePoint >> 12) & 0x3f) | 0x80, ((codePoint >> 6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
	        }
	    }
	    return encoded;
	}
	/**
	 * @record
	 */
	
	/**
	 * @param {?} token
	 * @return {?}
	 */
	function stringify(token) {
	    if (typeof token === 'string') {
	        return token;
	    }
	    if (token instanceof Array) {
	        return '[' + token.map(stringify).join(', ') + ']';
	    }
	    if (token == null) {
	        return '' + token;
	    }
	    if (token.overriddenName) {
	        return "" + token.overriddenName;
	    }
	    if (token.name) {
	        return "" + token.name;
	    }
	    var /** @type {?} */ res = token.toString();
	    if (res == null) {
	        return '' + res;
	    }
	    var /** @type {?} */ newLineIndex = res.indexOf('\n');
	    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
	}
	/**
	 * Lazily retrieves the reference value from a forwardRef.
	 * @param {?} type
	 * @return {?}
	 */
	function resolveForwardRef(type) {
	    if (typeof type === 'function' && type.hasOwnProperty('__forward_ref__')) {
	        return type();
	    }
	    else {
	        return type;
	    }
	}
	/**
	 * Determine if the argument is shaped like a Promise
	 * @param {?} obj
	 * @return {?}
	 */
	function isPromise(obj) {
	    // allow any Promise/A+ compliant thenable.
	    // It's up to the caller to ensure that obj.then conforms to the spec
	    return !!obj && typeof obj.then === 'function';
	}
	var Version = /** @class */ (function () {
	    function Version(full) {
	        this.full = full;
	        var /** @type {?} */ splits = full.split('.');
	        this.major = splits[0];
	        this.minor = splits[1];
	        this.patch = splits.slice(2).join('.');
	    }
	    return Version;
	}());
	/**
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var VERSION = new Version('5.2.11');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An Abstract Syntax Tree node representing part of a parsed Angular template.
	 * @record
	 */
	
	/**
	 * A segment of text within the template.
	 */
	var TextAst = /** @class */ (function () {
	    function TextAst(value, ngContentIndex, sourceSpan) {
	        this.value = value;
	        this.ngContentIndex = ngContentIndex;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    TextAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitText(this, context); };
	    return TextAst;
	}());
	/**
	 * A bound expression within the text of a template.
	 */
	var BoundTextAst = /** @class */ (function () {
	    function BoundTextAst(value, ngContentIndex, sourceSpan) {
	        this.value = value;
	        this.ngContentIndex = ngContentIndex;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    BoundTextAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitBoundText(this, context);
	    };
	    return BoundTextAst;
	}());
	/**
	 * A plain attribute on an element.
	 */
	var AttrAst = /** @class */ (function () {
	    function AttrAst(name, value, sourceSpan) {
	        this.name = name;
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    AttrAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitAttr(this, context); };
	    return AttrAst;
	}());
	/**
	 * A binding for an element property (e.g. `[property]="expression"`) or an animation trigger (e.g.
	 * `[\@trigger]="stateExp"`)
	 */
	var BoundElementPropertyAst = /** @class */ (function () {
	    function BoundElementPropertyAst(name, type, securityContext, value, unit, sourceSpan) {
	        this.name = name;
	        this.type = type;
	        this.securityContext = securityContext;
	        this.value = value;
	        this.unit = unit;
	        this.sourceSpan = sourceSpan;
	        this.isAnimation = this.type === PropertyBindingType.Animation;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    BoundElementPropertyAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitElementProperty(this, context);
	    };
	    return BoundElementPropertyAst;
	}());
	/**
	 * A binding for an element event (e.g. `(event)="handler()"`) or an animation trigger event (e.g.
	 * `(\@trigger.phase)="callback($event)"`).
	 */
	var BoundEventAst = /** @class */ (function () {
	    function BoundEventAst(name, target, phase, handler, sourceSpan) {
	        this.name = name;
	        this.target = target;
	        this.phase = phase;
	        this.handler = handler;
	        this.sourceSpan = sourceSpan;
	        this.fullName = BoundEventAst.calcFullName(this.name, this.target, this.phase);
	        this.isAnimation = !!this.phase;
	    }
	    /**
	     * @param {?} name
	     * @param {?} target
	     * @param {?} phase
	     * @return {?}
	     */
	    BoundEventAst.calcFullName = /**
	     * @param {?} name
	     * @param {?} target
	     * @param {?} phase
	     * @return {?}
	     */
	    function (name, target, phase) {
	        if (target) {
	            return target + ":" + name;
	        }
	        else if (phase) {
	            return "@" + name + "." + phase;
	        }
	        else {
	            return name;
	        }
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    BoundEventAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitEvent(this, context);
	    };
	    return BoundEventAst;
	}());
	/**
	 * A reference declaration on an element (e.g. `let someName="expression"`).
	 */
	var ReferenceAst = /** @class */ (function () {
	    function ReferenceAst(name, value, sourceSpan) {
	        this.name = name;
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ReferenceAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitReference(this, context);
	    };
	    return ReferenceAst;
	}());
	/**
	 * A variable declaration on a <ng-template> (e.g. `var-someName="someLocalName"`).
	 */
	var VariableAst = /** @class */ (function () {
	    function VariableAst(name, value, sourceSpan) {
	        this.name = name;
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    VariableAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitVariable(this, context);
	    };
	    return VariableAst;
	}());
	/**
	 * An element declaration in a template.
	 */
	var ElementAst = /** @class */ (function () {
	    function ElementAst(name, attrs, inputs, outputs, references, directives, providers, hasViewContainer, queryMatches, children, ngContentIndex, sourceSpan, endSourceSpan) {
	        this.name = name;
	        this.attrs = attrs;
	        this.inputs = inputs;
	        this.outputs = outputs;
	        this.references = references;
	        this.directives = directives;
	        this.providers = providers;
	        this.hasViewContainer = hasViewContainer;
	        this.queryMatches = queryMatches;
	        this.children = children;
	        this.ngContentIndex = ngContentIndex;
	        this.sourceSpan = sourceSpan;
	        this.endSourceSpan = endSourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ElementAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitElement(this, context);
	    };
	    return ElementAst;
	}());
	/**
	 * A `<ng-template>` element included in an Angular template.
	 */
	var EmbeddedTemplateAst = /** @class */ (function () {
	    function EmbeddedTemplateAst(attrs, outputs, references, variables, directives, providers, hasViewContainer, queryMatches, children, ngContentIndex, sourceSpan) {
	        this.attrs = attrs;
	        this.outputs = outputs;
	        this.references = references;
	        this.variables = variables;
	        this.directives = directives;
	        this.providers = providers;
	        this.hasViewContainer = hasViewContainer;
	        this.queryMatches = queryMatches;
	        this.children = children;
	        this.ngContentIndex = ngContentIndex;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    EmbeddedTemplateAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitEmbeddedTemplate(this, context);
	    };
	    return EmbeddedTemplateAst;
	}());
	/**
	 * A directive property with a bound value (e.g. `*ngIf="condition").
	 */
	var BoundDirectivePropertyAst = /** @class */ (function () {
	    function BoundDirectivePropertyAst(directiveName, templateName, value, sourceSpan) {
	        this.directiveName = directiveName;
	        this.templateName = templateName;
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    BoundDirectivePropertyAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitDirectiveProperty(this, context);
	    };
	    return BoundDirectivePropertyAst;
	}());
	/**
	 * A directive declared on an element.
	 */
	var DirectiveAst = /** @class */ (function () {
	    function DirectiveAst(directive, inputs, hostProperties, hostEvents, contentQueryStartId, sourceSpan) {
	        this.directive = directive;
	        this.inputs = inputs;
	        this.hostProperties = hostProperties;
	        this.hostEvents = hostEvents;
	        this.contentQueryStartId = contentQueryStartId;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    DirectiveAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitDirective(this, context);
	    };
	    return DirectiveAst;
	}());
	/**
	 * A provider declared on an element
	 */
	var ProviderAst = /** @class */ (function () {
	    function ProviderAst(token, multiProvider, eager, providers, providerType, lifecycleHooks, sourceSpan) {
	        this.token = token;
	        this.multiProvider = multiProvider;
	        this.eager = eager;
	        this.providers = providers;
	        this.providerType = providerType;
	        this.lifecycleHooks = lifecycleHooks;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ProviderAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        // No visit method in the visitor for now...
	        return null;
	    };
	    return ProviderAst;
	}());
	/** @enum {number} */
	var ProviderAstType = {
	    PublicService: 0,
	    PrivateService: 1,
	    Component: 2,
	    Directive: 3,
	    Builtin: 4,
	};
	ProviderAstType[ProviderAstType.PublicService] = "PublicService";
	ProviderAstType[ProviderAstType.PrivateService] = "PrivateService";
	ProviderAstType[ProviderAstType.Component] = "Component";
	ProviderAstType[ProviderAstType.Directive] = "Directive";
	ProviderAstType[ProviderAstType.Builtin] = "Builtin";
	/**
	 * Position where content is to be projected (instance of `<ng-content>` in a template).
	 */
	var NgContentAst = /** @class */ (function () {
	    function NgContentAst(index, ngContentIndex, sourceSpan) {
	        this.index = index;
	        this.ngContentIndex = ngContentIndex;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    NgContentAst.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitNgContent(this, context);
	    };
	    return NgContentAst;
	}());
	/** @enum {number} */
	var PropertyBindingType = {
	    /**
	       * A normal binding to a property (e.g. `[property]="expression"`).
	       */
	    Property: 0,
	    /**
	       * A binding to an element attribute (e.g. `[attr.name]="expression"`).
	       */
	    Attribute: 1,
	    /**
	       * A binding to a CSS class (e.g. `[class.name]="condition"`).
	       */
	    Class: 2,
	    /**
	       * A binding to a style rule (e.g. `[style.rule]="expression"`).
	       */
	    Style: 3,
	    /**
	       * A binding to an animation reference (e.g. `[animate.key]="expression"`).
	       */
	    Animation: 4,
	};
	PropertyBindingType[PropertyBindingType.Property] = "Property";
	PropertyBindingType[PropertyBindingType.Attribute] = "Attribute";
	PropertyBindingType[PropertyBindingType.Class] = "Class";
	PropertyBindingType[PropertyBindingType.Style] = "Style";
	PropertyBindingType[PropertyBindingType.Animation] = "Animation";
	/**
	 * @record
	 */
	
	/**
	 * A visitor for {\@link TemplateAst} trees that will process each node.
	 * @record
	 */
	
	/**
	 * A visitor that accepts each node but doesn't do anything. It is intended to be used
	 * as the base class for a visitor that is only interested in a subset of the node types.
	 */
	var NullTemplateVisitor = /** @class */ (function () {
	    function NullTemplateVisitor() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitNgContent = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitEmbeddedTemplate = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitReference = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitVariable = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitEvent = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitElementProperty = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitAttr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitBoundText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitDirective = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullTemplateVisitor.prototype.visitDirectiveProperty = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    return NullTemplateVisitor;
	}());
	/**
	 * Base class that can be used to build a visitor that visits each node
	 * in an template ast recursively.
	 */
	var RecursiveTemplateAstVisitor = /** @class */ (function (_super) {
	    __extends(RecursiveTemplateAstVisitor, _super);
	    function RecursiveTemplateAstVisitor() {
	        return _super.call(this) || this;
	    }
	    // Nodes with children
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveTemplateAstVisitor.prototype.visitEmbeddedTemplate = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitChildren(context, function (visit) {
	            visit(ast.attrs);
	            visit(ast.references);
	            visit(ast.variables);
	            visit(ast.directives);
	            visit(ast.providers);
	            visit(ast.children);
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveTemplateAstVisitor.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitChildren(context, function (visit) {
	            visit(ast.attrs);
	            visit(ast.inputs);
	            visit(ast.outputs);
	            visit(ast.references);
	            visit(ast.directives);
	            visit(ast.providers);
	            visit(ast.children);
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveTemplateAstVisitor.prototype.visitDirective = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitChildren(context, function (visit) {
	            visit(ast.inputs);
	            visit(ast.hostProperties);
	            visit(ast.hostEvents);
	        });
	    };
	    /**
	     * @template T
	     * @param {?} context
	     * @param {?} cb
	     * @return {?}
	     */
	    RecursiveTemplateAstVisitor.prototype.visitChildren = /**
	     * @template T
	     * @param {?} context
	     * @param {?} cb
	     * @return {?}
	     */
	    function (context, cb) {
	        var /** @type {?} */ results = [];
	        var /** @type {?} */ t = this;
	        /**
	         * @template T
	         * @param {?} children
	         * @return {?}
	         */
	        function visit(children) {
	            if (children && children.length)
	                results.push(templateVisitAll(t, children, context));
	        }
	        cb(visit);
	        return [].concat.apply([], results);
	    };
	    return RecursiveTemplateAstVisitor;
	}(NullTemplateVisitor));
	/**
	 * Visit every node in a list of {\@link TemplateAst}s with the given {\@link TemplateAstVisitor}.
	 * @param {?} visitor
	 * @param {?} asts
	 * @param {?=} context
	 * @return {?}
	 */
	function templateVisitAll(visitor, asts, context) {
	    if (context === void 0) { context = null; }
	    var /** @type {?} */ result = [];
	    var /** @type {?} */ visit = visitor.visit ?
	        function (ast) { return ((visitor.visit))(ast, context) || ast.visit(visitor, context); } :
	        function (ast) { return ast.visit(visitor, context); };
	    asts.forEach(function (ast) {
	        var /** @type {?} */ astResult = visit(ast);
	        if (astResult) {
	            result.push(astResult);
	        }
	    });
	    return result;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var CompilerConfig = /** @class */ (function () {
	    function CompilerConfig(_a) {
	        var _b = _a === void 0 ? {} : _a, _c = _b.defaultEncapsulation, defaultEncapsulation = _c === void 0 ? ViewEncapsulation.Emulated : _c, _d = _b.useJit, useJit = _d === void 0 ? true : _d, _e = _b.jitDevMode, jitDevMode = _e === void 0 ? false : _e, _f = _b.missingTranslation, missingTranslation = _f === void 0 ? null : _f, enableLegacyTemplate = _b.enableLegacyTemplate, preserveWhitespaces = _b.preserveWhitespaces, strictInjectionParameters = _b.strictInjectionParameters;
	        this.defaultEncapsulation = defaultEncapsulation;
	        this.useJit = !!useJit;
	        this.jitDevMode = !!jitDevMode;
	        this.missingTranslation = missingTranslation;
	        this.enableLegacyTemplate = enableLegacyTemplate === true;
	        this.preserveWhitespaces = preserveWhitespacesDefault(noUndefined(preserveWhitespaces));
	        this.strictInjectionParameters = strictInjectionParameters === true;
	    }
	    return CompilerConfig;
	}());
	/**
	 * @param {?} preserveWhitespacesOption
	 * @param {?=} defaultSetting
	 * @return {?}
	 */
	function preserveWhitespacesDefault(preserveWhitespacesOption, defaultSetting) {
	    if (defaultSetting === void 0) { defaultSetting = true; }
	    return preserveWhitespacesOption === null ? defaultSetting : preserveWhitespacesOption;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A token representing the a reference to a static type.
	 *
	 * This token is unique for a filePath and name and can be used as a hash table key.
	 */
	var StaticSymbol = /** @class */ (function () {
	    function StaticSymbol(filePath, name, members) {
	        this.filePath = filePath;
	        this.name = name;
	        this.members = members;
	    }
	    /**
	     * @return {?}
	     */
	    StaticSymbol.prototype.assertNoMembers = /**
	     * @return {?}
	     */
	    function () {
	        if (this.members.length) {
	            throw new Error("Illegal state: symbol without members expected, but got " + JSON.stringify(this) + ".");
	        }
	    };
	    return StaticSymbol;
	}());
	/**
	 * A cache of static symbol used by the StaticReflector to return the same symbol for the
	 * same symbol values.
	 */
	var StaticSymbolCache = /** @class */ (function () {
	    function StaticSymbolCache() {
	        this.cache = new Map();
	    }
	    /**
	     * @param {?} declarationFile
	     * @param {?} name
	     * @param {?=} members
	     * @return {?}
	     */
	    StaticSymbolCache.prototype.get = /**
	     * @param {?} declarationFile
	     * @param {?} name
	     * @param {?=} members
	     * @return {?}
	     */
	    function (declarationFile, name, members) {
	        members = members || [];
	        var /** @type {?} */ memberSuffix = members.length ? "." + members.join('.') : '';
	        var /** @type {?} */ key = "\"" + declarationFile + "\"." + name + memberSuffix;
	        var /** @type {?} */ result = this.cache.get(key);
	        if (!result) {
	            result = new StaticSymbol(declarationFile, name, members);
	            this.cache.set(key, result);
	        }
	        return result;
	    };
	    return StaticSymbolCache;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// group 0: "[prop] or (event) or @trigger"
	// group 1: "prop" from "[prop]"
	// group 2: "event" from "(event)"
	// group 3: "@trigger" from "@trigger"
	var HOST_REG_EXP = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
	/**
	 * @param {?} name
	 * @return {?}
	 */
	function _sanitizeIdentifier(name) {
	    return name.replace(/\W/g, '_');
	}
	var _anonymousTypeIndex = 0;
	/**
	 * @param {?} compileIdentifier
	 * @return {?}
	 */
	function identifierName(compileIdentifier) {
	    if (!compileIdentifier || !compileIdentifier.reference) {
	        return null;
	    }
	    var /** @type {?} */ ref = compileIdentifier.reference;
	    if (ref instanceof StaticSymbol) {
	        return ref.name;
	    }
	    if (ref['__anonymousType']) {
	        return ref['__anonymousType'];
	    }
	    var /** @type {?} */ identifier = stringify(ref);
	    if (identifier.indexOf('(') >= 0) {
	        // case: anonymous functions!
	        identifier = "anonymous_" + _anonymousTypeIndex++;
	        ref['__anonymousType'] = identifier;
	    }
	    else {
	        identifier = _sanitizeIdentifier(identifier);
	    }
	    return identifier;
	}
	/**
	 * @param {?} compileIdentifier
	 * @return {?}
	 */
	function identifierModuleUrl(compileIdentifier) {
	    var /** @type {?} */ ref = compileIdentifier.reference;
	    if (ref instanceof StaticSymbol) {
	        return ref.filePath;
	    }
	    // Runtime type
	    return "./" + stringify(ref);
	}
	/**
	 * @param {?} compType
	 * @param {?} embeddedTemplateIndex
	 * @return {?}
	 */
	function viewClassName(compType, embeddedTemplateIndex) {
	    return "View_" + identifierName({ reference: compType }) + "_" + embeddedTemplateIndex;
	}
	/**
	 * @param {?} compType
	 * @return {?}
	 */
	function rendererTypeName(compType) {
	    return "RenderType_" + identifierName({ reference: compType });
	}
	/**
	 * @param {?} compType
	 * @return {?}
	 */
	function hostViewClassName(compType) {
	    return "HostView_" + identifierName({ reference: compType });
	}
	/**
	 * @param {?} compType
	 * @return {?}
	 */
	function componentFactoryName(compType) {
	    return identifierName({ reference: compType }) + "NgFactory";
	}
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/** @enum {number} */
	var CompileSummaryKind = {
	    Pipe: 0,
	    Directive: 1,
	    NgModule: 2,
	    Injectable: 3,
	};
	CompileSummaryKind[CompileSummaryKind.Pipe] = "Pipe";
	CompileSummaryKind[CompileSummaryKind.Directive] = "Directive";
	CompileSummaryKind[CompileSummaryKind.NgModule] = "NgModule";
	CompileSummaryKind[CompileSummaryKind.Injectable] = "Injectable";
	/**
	 * A CompileSummary is the data needed to use a directive / pipe / module
	 * in other modules / components. However, this data is not enough to compile
	 * the directive / module itself.
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @param {?} token
	 * @return {?}
	 */
	function tokenName(token) {
	    return token.value != null ? _sanitizeIdentifier(token.value) : identifierName(token.identifier);
	}
	/**
	 * @param {?} token
	 * @return {?}
	 */
	function tokenReference(token) {
	    if (token.identifier != null) {
	        return token.identifier.reference;
	    }
	    else {
	        return token.value;
	    }
	}
	/**
	 * @record
	 */
	
	/**
	 * Metadata regarding compilation of a type.
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * Metadata about a stylesheet
	 */
	var CompileStylesheetMetadata = /** @class */ (function () {
	    function CompileStylesheetMetadata(_a) {
	        var _b = _a === void 0 ? {} : _a, moduleUrl = _b.moduleUrl, styles = _b.styles, styleUrls = _b.styleUrls;
	        this.moduleUrl = moduleUrl || null;
	        this.styles = _normalizeArray(styles);
	        this.styleUrls = _normalizeArray(styleUrls);
	    }
	    return CompileStylesheetMetadata;
	}());
	/**
	 * Summary Metadata regarding compilation of a template.
	 * @record
	 */
	
	/**
	 * Metadata regarding compilation of a template.
	 */
	var CompileTemplateMetadata = /** @class */ (function () {
	    function CompileTemplateMetadata(_a) {
	        var encapsulation = _a.encapsulation, template = _a.template, templateUrl = _a.templateUrl, htmlAst = _a.htmlAst, styles = _a.styles, styleUrls = _a.styleUrls, externalStylesheets = _a.externalStylesheets, animations = _a.animations, ngContentSelectors = _a.ngContentSelectors, interpolation = _a.interpolation, isInline = _a.isInline, preserveWhitespaces = _a.preserveWhitespaces;
	        this.encapsulation = encapsulation;
	        this.template = template;
	        this.templateUrl = templateUrl;
	        this.htmlAst = htmlAst;
	        this.styles = _normalizeArray(styles);
	        this.styleUrls = _normalizeArray(styleUrls);
	        this.externalStylesheets = _normalizeArray(externalStylesheets);
	        this.animations = animations ? flatten(animations) : [];
	        this.ngContentSelectors = ngContentSelectors || [];
	        if (interpolation && interpolation.length != 2) {
	            throw new Error("'interpolation' should have a start and an end symbol.");
	        }
	        this.interpolation = interpolation;
	        this.isInline = isInline;
	        this.preserveWhitespaces = preserveWhitespaces;
	    }
	    /**
	     * @return {?}
	     */
	    CompileTemplateMetadata.prototype.toSummary = /**
	     * @return {?}
	     */
	    function () {
	        return {
	            ngContentSelectors: this.ngContentSelectors,
	            encapsulation: this.encapsulation,
	        };
	    };
	    return CompileTemplateMetadata;
	}());
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * Metadata regarding compilation of a directive.
	 */
	var CompileDirectiveMetadata = /** @class */ (function () {
	    function CompileDirectiveMetadata(_a) {
	        var isHost = _a.isHost, type = _a.type, isComponent = _a.isComponent, selector = _a.selector, exportAs = _a.exportAs, changeDetection = _a.changeDetection, inputs = _a.inputs, outputs = _a.outputs, hostListeners = _a.hostListeners, hostProperties = _a.hostProperties, hostAttributes = _a.hostAttributes, providers = _a.providers, viewProviders = _a.viewProviders, queries = _a.queries, guards = _a.guards, viewQueries = _a.viewQueries, entryComponents = _a.entryComponents, template = _a.template, componentViewType = _a.componentViewType, rendererType = _a.rendererType, componentFactory = _a.componentFactory;
	        this.isHost = !!isHost;
	        this.type = type;
	        this.isComponent = isComponent;
	        this.selector = selector;
	        this.exportAs = exportAs;
	        this.changeDetection = changeDetection;
	        this.inputs = inputs;
	        this.outputs = outputs;
	        this.hostListeners = hostListeners;
	        this.hostProperties = hostProperties;
	        this.hostAttributes = hostAttributes;
	        this.providers = _normalizeArray(providers);
	        this.viewProviders = _normalizeArray(viewProviders);
	        this.queries = _normalizeArray(queries);
	        this.guards = guards;
	        this.viewQueries = _normalizeArray(viewQueries);
	        this.entryComponents = _normalizeArray(entryComponents);
	        this.template = template;
	        this.componentViewType = componentViewType;
	        this.rendererType = rendererType;
	        this.componentFactory = componentFactory;
	    }
	    /**
	     * @param {?} __0
	     * @return {?}
	     */
	    CompileDirectiveMetadata.create = /**
	     * @param {?} __0
	     * @return {?}
	     */
	    function (_a) {
	        var isHost = _a.isHost, type = _a.type, isComponent = _a.isComponent, selector = _a.selector, exportAs = _a.exportAs, changeDetection = _a.changeDetection, inputs = _a.inputs, outputs = _a.outputs, host = _a.host, providers = _a.providers, viewProviders = _a.viewProviders, queries = _a.queries, guards = _a.guards, viewQueries = _a.viewQueries, entryComponents = _a.entryComponents, template = _a.template, componentViewType = _a.componentViewType, rendererType = _a.rendererType, componentFactory = _a.componentFactory;
	        var /** @type {?} */ hostListeners = {};
	        var /** @type {?} */ hostProperties = {};
	        var /** @type {?} */ hostAttributes = {};
	        if (host != null) {
	            Object.keys(host).forEach(function (key) {
	                var /** @type {?} */ value = host[key];
	                var /** @type {?} */ matches = key.match(HOST_REG_EXP);
	                if (matches === null) {
	                    hostAttributes[key] = value;
	                }
	                else if (matches[1] != null) {
	                    hostProperties[matches[1]] = value;
	                }
	                else if (matches[2] != null) {
	                    hostListeners[matches[2]] = value;
	                }
	            });
	        }
	        var /** @type {?} */ inputsMap = {};
	        if (inputs != null) {
	            inputs.forEach(function (bindConfig) {
	                // canonical syntax: `dirProp: elProp`
	                // if there is no `:`, use dirProp = elProp
	                var /** @type {?} */ parts = splitAtColon(bindConfig, [bindConfig, bindConfig]);
	                inputsMap[parts[0]] = parts[1];
	            });
	        }
	        var /** @type {?} */ outputsMap = {};
	        if (outputs != null) {
	            outputs.forEach(function (bindConfig) {
	                // canonical syntax: `dirProp: elProp`
	                // if there is no `:`, use dirProp = elProp
	                var /** @type {?} */ parts = splitAtColon(bindConfig, [bindConfig, bindConfig]);
	                outputsMap[parts[0]] = parts[1];
	            });
	        }
	        return new CompileDirectiveMetadata({
	            isHost: isHost,
	            type: type,
	            isComponent: !!isComponent, selector: selector, exportAs: exportAs, changeDetection: changeDetection,
	            inputs: inputsMap,
	            outputs: outputsMap,
	            hostListeners: hostListeners,
	            hostProperties: hostProperties,
	            hostAttributes: hostAttributes,
	            providers: providers,
	            viewProviders: viewProviders,
	            queries: queries,
	            guards: guards,
	            viewQueries: viewQueries,
	            entryComponents: entryComponents,
	            template: template,
	            componentViewType: componentViewType,
	            rendererType: rendererType,
	            componentFactory: componentFactory,
	        });
	    };
	    /**
	     * @return {?}
	     */
	    CompileDirectiveMetadata.prototype.toSummary = /**
	     * @return {?}
	     */
	    function () {
	        return {
	            summaryKind: CompileSummaryKind.Directive,
	            type: this.type,
	            isComponent: this.isComponent,
	            selector: this.selector,
	            exportAs: this.exportAs,
	            inputs: this.inputs,
	            outputs: this.outputs,
	            hostListeners: this.hostListeners,
	            hostProperties: this.hostProperties,
	            hostAttributes: this.hostAttributes,
	            providers: this.providers,
	            viewProviders: this.viewProviders,
	            queries: this.queries,
	            guards: this.guards,
	            viewQueries: this.viewQueries,
	            entryComponents: this.entryComponents,
	            changeDetection: this.changeDetection,
	            template: this.template && this.template.toSummary(),
	            componentViewType: this.componentViewType,
	            rendererType: this.rendererType,
	            componentFactory: this.componentFactory
	        };
	    };
	    return CompileDirectiveMetadata;
	}());
	/**
	 * @record
	 */
	
	var CompilePipeMetadata = /** @class */ (function () {
	    function CompilePipeMetadata(_a) {
	        var type = _a.type, name = _a.name, pure = _a.pure;
	        this.type = type;
	        this.name = name;
	        this.pure = !!pure;
	    }
	    /**
	     * @return {?}
	     */
	    CompilePipeMetadata.prototype.toSummary = /**
	     * @return {?}
	     */
	    function () {
	        return {
	            summaryKind: CompileSummaryKind.Pipe,
	            type: this.type,
	            name: this.name,
	            pure: this.pure
	        };
	    };
	    return CompilePipeMetadata;
	}());
	/**
	 * @record
	 */
	
	/**
	 * Metadata regarding compilation of a module.
	 */
	var CompileNgModuleMetadata = /** @class */ (function () {
	    function CompileNgModuleMetadata(_a) {
	        var type = _a.type, providers = _a.providers, declaredDirectives = _a.declaredDirectives, exportedDirectives = _a.exportedDirectives, declaredPipes = _a.declaredPipes, exportedPipes = _a.exportedPipes, entryComponents = _a.entryComponents, bootstrapComponents = _a.bootstrapComponents, importedModules = _a.importedModules, exportedModules = _a.exportedModules, schemas = _a.schemas, transitiveModule = _a.transitiveModule, id = _a.id;
	        this.type = type || null;
	        this.declaredDirectives = _normalizeArray(declaredDirectives);
	        this.exportedDirectives = _normalizeArray(exportedDirectives);
	        this.declaredPipes = _normalizeArray(declaredPipes);
	        this.exportedPipes = _normalizeArray(exportedPipes);
	        this.providers = _normalizeArray(providers);
	        this.entryComponents = _normalizeArray(entryComponents);
	        this.bootstrapComponents = _normalizeArray(bootstrapComponents);
	        this.importedModules = _normalizeArray(importedModules);
	        this.exportedModules = _normalizeArray(exportedModules);
	        this.schemas = _normalizeArray(schemas);
	        this.id = id || null;
	        this.transitiveModule = transitiveModule || null;
	    }
	    /**
	     * @return {?}
	     */
	    CompileNgModuleMetadata.prototype.toSummary = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ module = /** @type {?} */ ((this.transitiveModule));
	        return {
	            summaryKind: CompileSummaryKind.NgModule,
	            type: this.type,
	            entryComponents: module.entryComponents,
	            providers: module.providers,
	            modules: module.modules,
	            exportedDirectives: module.exportedDirectives,
	            exportedPipes: module.exportedPipes
	        };
	    };
	    return CompileNgModuleMetadata;
	}());
	var TransitiveCompileNgModuleMetadata = /** @class */ (function () {
	    function TransitiveCompileNgModuleMetadata() {
	        this.directivesSet = new Set();
	        this.directives = [];
	        this.exportedDirectivesSet = new Set();
	        this.exportedDirectives = [];
	        this.pipesSet = new Set();
	        this.pipes = [];
	        this.exportedPipesSet = new Set();
	        this.exportedPipes = [];
	        this.modulesSet = new Set();
	        this.modules = [];
	        this.entryComponentsSet = new Set();
	        this.entryComponents = [];
	        this.providers = [];
	    }
	    /**
	     * @param {?} provider
	     * @param {?} module
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addProvider = /**
	     * @param {?} provider
	     * @param {?} module
	     * @return {?}
	     */
	    function (provider, module) {
	        this.providers.push({ provider: provider, module: module });
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addDirective = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        if (!this.directivesSet.has(id.reference)) {
	            this.directivesSet.add(id.reference);
	            this.directives.push(id);
	        }
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addExportedDirective = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        if (!this.exportedDirectivesSet.has(id.reference)) {
	            this.exportedDirectivesSet.add(id.reference);
	            this.exportedDirectives.push(id);
	        }
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addPipe = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        if (!this.pipesSet.has(id.reference)) {
	            this.pipesSet.add(id.reference);
	            this.pipes.push(id);
	        }
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addExportedPipe = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        if (!this.exportedPipesSet.has(id.reference)) {
	            this.exportedPipesSet.add(id.reference);
	            this.exportedPipes.push(id);
	        }
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addModule = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        if (!this.modulesSet.has(id.reference)) {
	            this.modulesSet.add(id.reference);
	            this.modules.push(id);
	        }
	    };
	    /**
	     * @param {?} ec
	     * @return {?}
	     */
	    TransitiveCompileNgModuleMetadata.prototype.addEntryComponent = /**
	     * @param {?} ec
	     * @return {?}
	     */
	    function (ec) {
	        if (!this.entryComponentsSet.has(ec.componentType)) {
	            this.entryComponentsSet.add(ec.componentType);
	            this.entryComponents.push(ec);
	        }
	    };
	    return TransitiveCompileNgModuleMetadata;
	}());
	/**
	 * @param {?} obj
	 * @return {?}
	 */
	function _normalizeArray(obj) {
	    return obj || [];
	}
	var ProviderMeta = /** @class */ (function () {
	    function ProviderMeta(token, _a) {
	        var useClass = _a.useClass, useValue = _a.useValue, useExisting = _a.useExisting, useFactory = _a.useFactory, deps = _a.deps, multi = _a.multi;
	        this.token = token;
	        this.useClass = useClass || null;
	        this.useValue = useValue;
	        this.useExisting = useExisting;
	        this.useFactory = useFactory || null;
	        this.dependencies = deps || null;
	        this.multi = !!multi;
	    }
	    return ProviderMeta;
	}());
	/**
	 * @template T
	 * @param {?} list
	 * @return {?}
	 */
	function flatten(list) {
	    return list.reduce(function (flat, item) {
	        var /** @type {?} */ flatItem = Array.isArray(item) ? flatten(item) : item;
	        return (/** @type {?} */ (flat)).concat(flatItem);
	    }, []);
	}
	/**
	 * @param {?} url
	 * @return {?}
	 */
	function jitSourceUrl(url) {
	    // Note: We need 3 "/" so that ng shows up as a separate domain
	    // in the chrome dev tools.
	    return url.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, 'ng:///');
	}
	/**
	 * @param {?} ngModuleType
	 * @param {?} compMeta
	 * @param {?} templateMeta
	 * @return {?}
	 */
	function templateSourceUrl(ngModuleType, compMeta, templateMeta) {
	    var /** @type {?} */ url;
	    if (templateMeta.isInline) {
	        if (compMeta.type.reference instanceof StaticSymbol) {
	            // Note: a .ts file might contain multiple components with inline templates,
	            // so we need to give them unique urls, as these will be used for sourcemaps.
	            url = compMeta.type.reference.filePath + "." + compMeta.type.reference.name + ".html";
	        }
	        else {
	            url = identifierName(ngModuleType) + "/" + identifierName(compMeta.type) + ".html";
	        }
	    }
	    else {
	        url = /** @type {?} */ ((templateMeta.templateUrl));
	    }
	    return compMeta.type.reference instanceof StaticSymbol ? url : jitSourceUrl(url);
	}
	/**
	 * @param {?} meta
	 * @param {?} id
	 * @return {?}
	 */
	function sharedStylesheetJitUrl(meta, id) {
	    var /** @type {?} */ pathParts = /** @type {?} */ ((meta.moduleUrl)).split(/\/\\/g);
	    var /** @type {?} */ baseName = pathParts[pathParts.length - 1];
	    return jitSourceUrl("css/" + id + baseName + ".ngstyle.js");
	}
	/**
	 * @param {?} moduleMeta
	 * @return {?}
	 */
	function ngModuleJitUrl(moduleMeta) {
	    return jitSourceUrl(identifierName(moduleMeta.type) + "/module.ngfactory.js");
	}
	/**
	 * @param {?} ngModuleType
	 * @param {?} compMeta
	 * @return {?}
	 */
	function templateJitUrl(ngModuleType, compMeta) {
	    return jitSourceUrl(identifierName(ngModuleType) + "/" + identifierName(compMeta.type) + ".ngfactory.js");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A path is an ordered set of elements. Typically a path is to  a
	 * particular offset in a source file. The head of the list is the top
	 * most node. The tail is the node that contains the offset directly.
	 *
	 * For example, the expresion `a + b + c` might have an ast that looks
	 * like:
	 *     +
	 *    / \
	 *   a   +
	 *      / \
	 *     b   c
	 *
	 * The path to the node at offset 9 would be `['+' at 1-10, '+' at 7-10,
	 * 'c' at 9-10]` and the path the node at offset 1 would be
	 * `['+' at 1-10, 'a' at 1-2]`.
	 * @template T
	 */
	var AstPath = /** @class */ (function () {
	    function AstPath(path, position) {
	        if (position === void 0) { position = -1; }
	        this.path = path;
	        this.position = position;
	    }
	    Object.defineProperty(AstPath.prototype, "empty", {
	        get: /**
	         * @return {?}
	         */
	        function () { return !this.path || !this.path.length; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AstPath.prototype, "head", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.path[0]; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AstPath.prototype, "tail", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.path[this.path.length - 1]; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    AstPath.prototype.parentOf = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        return node && this.path[this.path.indexOf(node) - 1];
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    AstPath.prototype.childOf = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return this.path[this.path.indexOf(node) + 1]; };
	    /**
	     * @template N
	     * @param {?} ctor
	     * @return {?}
	     */
	    AstPath.prototype.first = /**
	     * @template N
	     * @param {?} ctor
	     * @return {?}
	     */
	    function (ctor) {
	        for (var /** @type {?} */ i = this.path.length - 1; i >= 0; i--) {
	            var /** @type {?} */ item = this.path[i];
	            if (item instanceof ctor)
	                return /** @type {?} */ (item);
	        }
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    AstPath.prototype.push = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { this.path.push(node); };
	    /**
	     * @return {?}
	     */
	    AstPath.prototype.pop = /**
	     * @return {?}
	     */
	    function () { return /** @type {?} */ ((this.path.pop())); };
	    return AstPath;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	var Text = /** @class */ (function () {
	    function Text(value, sourceSpan) {
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    Text.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitText(this, context); };
	    return Text;
	}());
	var Expansion = /** @class */ (function () {
	    function Expansion(switchValue, type, cases, sourceSpan, switchValueSourceSpan) {
	        this.switchValue = switchValue;
	        this.type = type;
	        this.cases = cases;
	        this.sourceSpan = sourceSpan;
	        this.switchValueSourceSpan = switchValueSourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    Expansion.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitExpansion(this, context); };
	    return Expansion;
	}());
	var ExpansionCase = /** @class */ (function () {
	    function ExpansionCase(value, expression, sourceSpan, valueSourceSpan, expSourceSpan) {
	        this.value = value;
	        this.expression = expression;
	        this.sourceSpan = sourceSpan;
	        this.valueSourceSpan = valueSourceSpan;
	        this.expSourceSpan = expSourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ExpansionCase.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitExpansionCase(this, context); };
	    return ExpansionCase;
	}());
	var Attribute$1 = /** @class */ (function () {
	    function Attribute(name, value, sourceSpan, valueSpan) {
	        this.name = name;
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	        this.valueSpan = valueSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    Attribute.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitAttribute(this, context); };
	    return Attribute;
	}());
	var Element = /** @class */ (function () {
	    function Element(name, attrs, children, sourceSpan, startSourceSpan, endSourceSpan) {
	        if (startSourceSpan === void 0) { startSourceSpan = null; }
	        if (endSourceSpan === void 0) { endSourceSpan = null; }
	        this.name = name;
	        this.attrs = attrs;
	        this.children = children;
	        this.sourceSpan = sourceSpan;
	        this.startSourceSpan = startSourceSpan;
	        this.endSourceSpan = endSourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    Element.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitElement(this, context); };
	    return Element;
	}());
	var Comment = /** @class */ (function () {
	    function Comment(value, sourceSpan) {
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    Comment.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitComment(this, context); };
	    return Comment;
	}());
	/**
	 * @record
	 */
	
	/**
	 * @param {?} visitor
	 * @param {?} nodes
	 * @param {?=} context
	 * @return {?}
	 */
	function visitAll(visitor, nodes, context) {
	    if (context === void 0) { context = null; }
	    var /** @type {?} */ result = [];
	    var /** @type {?} */ visit = visitor.visit ?
	        function (ast) { return ((visitor.visit))(ast, context) || ast.visit(visitor, context); } :
	        function (ast) { return ast.visit(visitor, context); };
	    nodes.forEach(function (ast) {
	        var /** @type {?} */ astResult = visit(ast);
	        if (astResult) {
	            result.push(astResult);
	        }
	    });
	    return result;
	}
	var RecursiveVisitor = /** @class */ (function () {
	    function RecursiveVisitor() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        this.visitChildren(context, function (visit) {
	            visit(ast.attrs);
	            visit(ast.children);
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitAttribute = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitComment = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitExpansion = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitChildren(context, function (visit) { visit(ast.cases); });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitExpansionCase = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @template T
	     * @param {?} context
	     * @param {?} cb
	     * @return {?}
	     */
	    RecursiveVisitor.prototype.visitChildren = /**
	     * @template T
	     * @param {?} context
	     * @param {?} cb
	     * @return {?}
	     */
	    function (context, cb) {
	        var /** @type {?} */ results = [];
	        var /** @type {?} */ t = this;
	        /**
	         * @template T
	         * @param {?} children
	         * @return {?}
	         */
	        function visit(children) {
	            if (children)
	                results.push(visitAll(t, children, context));
	        }
	        cb(visit);
	        return [].concat.apply([], results);
	    };
	    return RecursiveVisitor;
	}());
	/**
	 * @param {?} ast
	 * @return {?}
	 */
	function spanOf(ast) {
	    var /** @type {?} */ start = ast.sourceSpan.start.offset;
	    var /** @type {?} */ end = ast.sourceSpan.end.offset;
	    if (ast instanceof Element) {
	        if (ast.endSourceSpan) {
	            end = ast.endSourceSpan.end.offset;
	        }
	        else if (ast.children && ast.children.length) {
	            end = spanOf(ast.children[ast.children.length - 1]).end;
	        }
	    }
	    return { start: start, end: end };
	}
	/**
	 * @param {?} nodes
	 * @param {?} position
	 * @return {?}
	 */
	function findNode(nodes, position) {
	    var /** @type {?} */ path = [];
	    var /** @type {?} */ visitor = new /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        /**
	         * @param {?} ast
	         * @param {?} context
	         * @return {?}
	         */
	        class_1.prototype.visit = /**
	         * @param {?} ast
	         * @param {?} context
	         * @return {?}
	         */
	        function (ast, context) {
	            var /** @type {?} */ span = spanOf(ast);
	            if (span.start <= position && position < span.end) {
	                path.push(ast);
	            }
	            else {
	                // Returning a value here will result in the children being skipped.
	                return true;
	            }
	        };
	        return class_1;
	    }(RecursiveVisitor));
	    visitAll(visitor, nodes);
	    return new AstPath(path, position);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} identifier
	 * @param {?} value
	 * @return {?}
	 */
	function assertArrayOfStrings(identifier, value) {
	    if (value == null) {
	        return;
	    }
	    if (!Array.isArray(value)) {
	        throw new Error("Expected '" + identifier + "' to be an array of strings.");
	    }
	    for (var /** @type {?} */ i = 0; i < value.length; i += 1) {
	        if (typeof value[i] !== 'string') {
	            throw new Error("Expected '" + identifier + "' to be an array of strings.");
	        }
	    }
	}
	var INTERPOLATION_BLACKLIST_REGEXPS = [
	    /^\s*$/,
	    /[<>]/,
	    /^[{}]$/,
	    /&(#|[a-z])/i,
	    /^\/\//,
	];
	/**
	 * @param {?} identifier
	 * @param {?} value
	 * @return {?}
	 */
	function assertInterpolationSymbols(identifier, value) {
	    if (value != null && !(Array.isArray(value) && value.length == 2)) {
	        throw new Error("Expected '" + identifier + "' to be an array, [start, end].");
	    }
	    else if (value != null) {
	        var /** @type {?} */ start_1 = /** @type {?} */ (value[0]);
	        var /** @type {?} */ end_1 = /** @type {?} */ (value[1]);
	        // black list checking
	        INTERPOLATION_BLACKLIST_REGEXPS.forEach(function (regexp) {
	            if (regexp.test(start_1) || regexp.test(end_1)) {
	                throw new Error("['" + start_1 + "', '" + end_1 + "'] contains unusable interpolation symbol.");
	            }
	        });
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var InterpolationConfig = /** @class */ (function () {
	    function InterpolationConfig(start, end) {
	        this.start = start;
	        this.end = end;
	    }
	    /**
	     * @param {?} markers
	     * @return {?}
	     */
	    InterpolationConfig.fromArray = /**
	     * @param {?} markers
	     * @return {?}
	     */
	    function (markers) {
	        if (!markers) {
	            return DEFAULT_INTERPOLATION_CONFIG;
	        }
	        assertInterpolationSymbols('interpolation', markers);
	        return new InterpolationConfig(markers[0], markers[1]);
	    };
	    return InterpolationConfig;
	}());
	var DEFAULT_INTERPOLATION_CONFIG = new InterpolationConfig('{{', '}}');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var StyleWithImports = /** @class */ (function () {
	    function StyleWithImports(style, styleUrls) {
	        this.style = style;
	        this.styleUrls = styleUrls;
	    }
	    return StyleWithImports;
	}());
	/**
	 * @param {?} url
	 * @return {?}
	 */
	function isStyleUrlResolvable(url) {
	    if (url == null || url.length === 0 || url[0] == '/')
	        return false;
	    var /** @type {?} */ schemeMatch = url.match(URL_WITH_SCHEMA_REGEXP);
	    return schemeMatch === null || schemeMatch[1] == 'package' || schemeMatch[1] == 'asset';
	}
	/**
	 * Rewrites stylesheets by resolving and removing the \@import urls that
	 * are either relative or don't have a `package:` scheme
	 * @param {?} resolver
	 * @param {?} baseUrl
	 * @param {?} cssText
	 * @return {?}
	 */
	function extractStyleUrls(resolver, baseUrl, cssText) {
	    var /** @type {?} */ foundUrls = [];
	    var /** @type {?} */ modifiedCssText = cssText.replace(CSS_STRIPPABLE_COMMENT_REGEXP, '')
	        .replace(CSS_IMPORT_REGEXP, function () {
	        var m = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            m[_i] = arguments[_i];
	        }
	        var /** @type {?} */ url = m[1] || m[2];
	        if (!isStyleUrlResolvable(url)) {
	            // Do not attempt to resolve non-package absolute URLs with URI
	            // scheme
	            return m[0];
	        }
	        foundUrls.push(resolver.resolve(baseUrl, url));
	        return '';
	    });
	    return new StyleWithImports(modifiedCssText, foundUrls);
	}
	var CSS_IMPORT_REGEXP = /@import\s+(?:url\()?\s*(?:(?:['"]([^'"]*))|([^;\)\s]*))[^;]*;?/g;
	var CSS_STRIPPABLE_COMMENT_REGEXP = /\/\*(?!#\s*(?:sourceURL|sourceMappingURL)=)[\s\S]+?\*\//g;
	var URL_WITH_SCHEMA_REGEXP = /^([^:/?#]+):/;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var TagContentType = {
	    RAW_TEXT: 0,
	    ESCAPABLE_RAW_TEXT: 1,
	    PARSABLE_DATA: 2,
	};
	TagContentType[TagContentType.RAW_TEXT] = "RAW_TEXT";
	TagContentType[TagContentType.ESCAPABLE_RAW_TEXT] = "ESCAPABLE_RAW_TEXT";
	TagContentType[TagContentType.PARSABLE_DATA] = "PARSABLE_DATA";
	/**
	 * @record
	 */
	
	/**
	 * @param {?} elementName
	 * @return {?}
	 */
	function splitNsName(elementName) {
	    if (elementName[0] != ':') {
	        return [null, elementName];
	    }
	    var /** @type {?} */ colonIndex = elementName.indexOf(':', 1);
	    if (colonIndex == -1) {
	        throw new Error("Unsupported format \"" + elementName + "\" expecting \":namespace:name\"");
	    }
	    return [elementName.slice(1, colonIndex), elementName.slice(colonIndex + 1)];
	}
	/**
	 * @param {?} tagName
	 * @return {?}
	 */
	function isNgContainer(tagName) {
	    return splitNsName(tagName)[1] === 'ng-container';
	}
	/**
	 * @param {?} tagName
	 * @return {?}
	 */
	function isNgContent(tagName) {
	    return splitNsName(tagName)[1] === 'ng-content';
	}
	/**
	 * @param {?} tagName
	 * @return {?}
	 */
	function isNgTemplate(tagName) {
	    return splitNsName(tagName)[1] === 'ng-template';
	}
	/**
	 * @param {?} fullName
	 * @return {?}
	 */
	function getNsPrefix(fullName) {
	    return fullName === null ? null : splitNsName(fullName)[0];
	}
	/**
	 * @param {?} prefix
	 * @param {?} localName
	 * @return {?}
	 */
	function mergeNsAndName(prefix, localName) {
	    return prefix ? ":" + prefix + ":" + localName : localName;
	}
	// see http://www.w3.org/TR/html51/syntax.html#named-character-references
	// see https://html.spec.whatwg.org/multipage/entities.json
	// This list is not exhaustive to keep the compiler footprint low.
	// The `&#123;` / `&#x1ab;` syntax should be used when the named character reference does not
	// exist.
	var NAMED_ENTITIES = {
	    'Aacute': '\u00C1',
	    'aacute': '\u00E1',
	    'Acirc': '\u00C2',
	    'acirc': '\u00E2',
	    'acute': '\u00B4',
	    'AElig': '\u00C6',
	    'aelig': '\u00E6',
	    'Agrave': '\u00C0',
	    'agrave': '\u00E0',
	    'alefsym': '\u2135',
	    'Alpha': '\u0391',
	    'alpha': '\u03B1',
	    'amp': '&',
	    'and': '\u2227',
	    'ang': '\u2220',
	    'apos': '\u0027',
	    'Aring': '\u00C5',
	    'aring': '\u00E5',
	    'asymp': '\u2248',
	    'Atilde': '\u00C3',
	    'atilde': '\u00E3',
	    'Auml': '\u00C4',
	    'auml': '\u00E4',
	    'bdquo': '\u201E',
	    'Beta': '\u0392',
	    'beta': '\u03B2',
	    'brvbar': '\u00A6',
	    'bull': '\u2022',
	    'cap': '\u2229',
	    'Ccedil': '\u00C7',
	    'ccedil': '\u00E7',
	    'cedil': '\u00B8',
	    'cent': '\u00A2',
	    'Chi': '\u03A7',
	    'chi': '\u03C7',
	    'circ': '\u02C6',
	    'clubs': '\u2663',
	    'cong': '\u2245',
	    'copy': '\u00A9',
	    'crarr': '\u21B5',
	    'cup': '\u222A',
	    'curren': '\u00A4',
	    'dagger': '\u2020',
	    'Dagger': '\u2021',
	    'darr': '\u2193',
	    'dArr': '\u21D3',
	    'deg': '\u00B0',
	    'Delta': '\u0394',
	    'delta': '\u03B4',
	    'diams': '\u2666',
	    'divide': '\u00F7',
	    'Eacute': '\u00C9',
	    'eacute': '\u00E9',
	    'Ecirc': '\u00CA',
	    'ecirc': '\u00EA',
	    'Egrave': '\u00C8',
	    'egrave': '\u00E8',
	    'empty': '\u2205',
	    'emsp': '\u2003',
	    'ensp': '\u2002',
	    'Epsilon': '\u0395',
	    'epsilon': '\u03B5',
	    'equiv': '\u2261',
	    'Eta': '\u0397',
	    'eta': '\u03B7',
	    'ETH': '\u00D0',
	    'eth': '\u00F0',
	    'Euml': '\u00CB',
	    'euml': '\u00EB',
	    'euro': '\u20AC',
	    'exist': '\u2203',
	    'fnof': '\u0192',
	    'forall': '\u2200',
	    'frac12': '\u00BD',
	    'frac14': '\u00BC',
	    'frac34': '\u00BE',
	    'frasl': '\u2044',
	    'Gamma': '\u0393',
	    'gamma': '\u03B3',
	    'ge': '\u2265',
	    'gt': '>',
	    'harr': '\u2194',
	    'hArr': '\u21D4',
	    'hearts': '\u2665',
	    'hellip': '\u2026',
	    'Iacute': '\u00CD',
	    'iacute': '\u00ED',
	    'Icirc': '\u00CE',
	    'icirc': '\u00EE',
	    'iexcl': '\u00A1',
	    'Igrave': '\u00CC',
	    'igrave': '\u00EC',
	    'image': '\u2111',
	    'infin': '\u221E',
	    'int': '\u222B',
	    'Iota': '\u0399',
	    'iota': '\u03B9',
	    'iquest': '\u00BF',
	    'isin': '\u2208',
	    'Iuml': '\u00CF',
	    'iuml': '\u00EF',
	    'Kappa': '\u039A',
	    'kappa': '\u03BA',
	    'Lambda': '\u039B',
	    'lambda': '\u03BB',
	    'lang': '\u27E8',
	    'laquo': '\u00AB',
	    'larr': '\u2190',
	    'lArr': '\u21D0',
	    'lceil': '\u2308',
	    'ldquo': '\u201C',
	    'le': '\u2264',
	    'lfloor': '\u230A',
	    'lowast': '\u2217',
	    'loz': '\u25CA',
	    'lrm': '\u200E',
	    'lsaquo': '\u2039',
	    'lsquo': '\u2018',
	    'lt': '<',
	    'macr': '\u00AF',
	    'mdash': '\u2014',
	    'micro': '\u00B5',
	    'middot': '\u00B7',
	    'minus': '\u2212',
	    'Mu': '\u039C',
	    'mu': '\u03BC',
	    'nabla': '\u2207',
	    'nbsp': '\u00A0',
	    'ndash': '\u2013',
	    'ne': '\u2260',
	    'ni': '\u220B',
	    'not': '\u00AC',
	    'notin': '\u2209',
	    'nsub': '\u2284',
	    'Ntilde': '\u00D1',
	    'ntilde': '\u00F1',
	    'Nu': '\u039D',
	    'nu': '\u03BD',
	    'Oacute': '\u00D3',
	    'oacute': '\u00F3',
	    'Ocirc': '\u00D4',
	    'ocirc': '\u00F4',
	    'OElig': '\u0152',
	    'oelig': '\u0153',
	    'Ograve': '\u00D2',
	    'ograve': '\u00F2',
	    'oline': '\u203E',
	    'Omega': '\u03A9',
	    'omega': '\u03C9',
	    'Omicron': '\u039F',
	    'omicron': '\u03BF',
	    'oplus': '\u2295',
	    'or': '\u2228',
	    'ordf': '\u00AA',
	    'ordm': '\u00BA',
	    'Oslash': '\u00D8',
	    'oslash': '\u00F8',
	    'Otilde': '\u00D5',
	    'otilde': '\u00F5',
	    'otimes': '\u2297',
	    'Ouml': '\u00D6',
	    'ouml': '\u00F6',
	    'para': '\u00B6',
	    'permil': '\u2030',
	    'perp': '\u22A5',
	    'Phi': '\u03A6',
	    'phi': '\u03C6',
	    'Pi': '\u03A0',
	    'pi': '\u03C0',
	    'piv': '\u03D6',
	    'plusmn': '\u00B1',
	    'pound': '\u00A3',
	    'prime': '\u2032',
	    'Prime': '\u2033',
	    'prod': '\u220F',
	    'prop': '\u221D',
	    'Psi': '\u03A8',
	    'psi': '\u03C8',
	    'quot': '\u0022',
	    'radic': '\u221A',
	    'rang': '\u27E9',
	    'raquo': '\u00BB',
	    'rarr': '\u2192',
	    'rArr': '\u21D2',
	    'rceil': '\u2309',
	    'rdquo': '\u201D',
	    'real': '\u211C',
	    'reg': '\u00AE',
	    'rfloor': '\u230B',
	    'Rho': '\u03A1',
	    'rho': '\u03C1',
	    'rlm': '\u200F',
	    'rsaquo': '\u203A',
	    'rsquo': '\u2019',
	    'sbquo': '\u201A',
	    'Scaron': '\u0160',
	    'scaron': '\u0161',
	    'sdot': '\u22C5',
	    'sect': '\u00A7',
	    'shy': '\u00AD',
	    'Sigma': '\u03A3',
	    'sigma': '\u03C3',
	    'sigmaf': '\u03C2',
	    'sim': '\u223C',
	    'spades': '\u2660',
	    'sub': '\u2282',
	    'sube': '\u2286',
	    'sum': '\u2211',
	    'sup': '\u2283',
	    'sup1': '\u00B9',
	    'sup2': '\u00B2',
	    'sup3': '\u00B3',
	    'supe': '\u2287',
	    'szlig': '\u00DF',
	    'Tau': '\u03A4',
	    'tau': '\u03C4',
	    'there4': '\u2234',
	    'Theta': '\u0398',
	    'theta': '\u03B8',
	    'thetasym': '\u03D1',
	    'thinsp': '\u2009',
	    'THORN': '\u00DE',
	    'thorn': '\u00FE',
	    'tilde': '\u02DC',
	    'times': '\u00D7',
	    'trade': '\u2122',
	    'Uacute': '\u00DA',
	    'uacute': '\u00FA',
	    'uarr': '\u2191',
	    'uArr': '\u21D1',
	    'Ucirc': '\u00DB',
	    'ucirc': '\u00FB',
	    'Ugrave': '\u00D9',
	    'ugrave': '\u00F9',
	    'uml': '\u00A8',
	    'upsih': '\u03D2',
	    'Upsilon': '\u03A5',
	    'upsilon': '\u03C5',
	    'Uuml': '\u00DC',
	    'uuml': '\u00FC',
	    'weierp': '\u2118',
	    'Xi': '\u039E',
	    'xi': '\u03BE',
	    'Yacute': '\u00DD',
	    'yacute': '\u00FD',
	    'yen': '\u00A5',
	    'yuml': '\u00FF',
	    'Yuml': '\u0178',
	    'Zeta': '\u0396',
	    'zeta': '\u03B6',
	    'zwj': '\u200D',
	    'zwnj': '\u200C',
	};
	// The &ngsp; pseudo-entity is denoting a space. see:
	// https://github.com/dart-lang/angular/blob/0bb611387d29d65b5af7f9d2515ab571fd3fbee4/_tests/test/compiler/preserve_whitespace_test.dart
	var NGSP_UNICODE = '\uE500';
	NAMED_ENTITIES['ngsp'] = NGSP_UNICODE;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NG_CONTENT_SELECT_ATTR = 'select';
	var LINK_ELEMENT = 'link';
	var LINK_STYLE_REL_ATTR = 'rel';
	var LINK_STYLE_HREF_ATTR = 'href';
	var LINK_STYLE_REL_VALUE = 'stylesheet';
	var STYLE_ELEMENT = 'style';
	var SCRIPT_ELEMENT = 'script';
	var NG_NON_BINDABLE_ATTR = 'ngNonBindable';
	var NG_PROJECT_AS = 'ngProjectAs';
	/**
	 * @param {?} ast
	 * @return {?}
	 */
	function preparseElement(ast) {
	    var /** @type {?} */ selectAttr = /** @type {?} */ ((null));
	    var /** @type {?} */ hrefAttr = /** @type {?} */ ((null));
	    var /** @type {?} */ relAttr = /** @type {?} */ ((null));
	    var /** @type {?} */ nonBindable = false;
	    var /** @type {?} */ projectAs = /** @type {?} */ ((null));
	    ast.attrs.forEach(function (attr) {
	        var /** @type {?} */ lcAttrName = attr.name.toLowerCase();
	        if (lcAttrName == NG_CONTENT_SELECT_ATTR) {
	            selectAttr = attr.value;
	        }
	        else if (lcAttrName == LINK_STYLE_HREF_ATTR) {
	            hrefAttr = attr.value;
	        }
	        else if (lcAttrName == LINK_STYLE_REL_ATTR) {
	            relAttr = attr.value;
	        }
	        else if (attr.name == NG_NON_BINDABLE_ATTR) {
	            nonBindable = true;
	        }
	        else if (attr.name == NG_PROJECT_AS) {
	            if (attr.value.length > 0) {
	                projectAs = attr.value;
	            }
	        }
	    });
	    selectAttr = normalizeNgContentSelect(selectAttr);
	    var /** @type {?} */ nodeName = ast.name.toLowerCase();
	    var /** @type {?} */ type = PreparsedElementType.OTHER;
	    if (isNgContent(nodeName)) {
	        type = PreparsedElementType.NG_CONTENT;
	    }
	    else if (nodeName == STYLE_ELEMENT) {
	        type = PreparsedElementType.STYLE;
	    }
	    else if (nodeName == SCRIPT_ELEMENT) {
	        type = PreparsedElementType.SCRIPT;
	    }
	    else if (nodeName == LINK_ELEMENT && relAttr == LINK_STYLE_REL_VALUE) {
	        type = PreparsedElementType.STYLESHEET;
	    }
	    return new PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs);
	}
	/** @enum {number} */
	var PreparsedElementType = {
	    NG_CONTENT: 0,
	    STYLE: 1,
	    STYLESHEET: 2,
	    SCRIPT: 3,
	    OTHER: 4,
	};
	PreparsedElementType[PreparsedElementType.NG_CONTENT] = "NG_CONTENT";
	PreparsedElementType[PreparsedElementType.STYLE] = "STYLE";
	PreparsedElementType[PreparsedElementType.STYLESHEET] = "STYLESHEET";
	PreparsedElementType[PreparsedElementType.SCRIPT] = "SCRIPT";
	PreparsedElementType[PreparsedElementType.OTHER] = "OTHER";
	var PreparsedElement = /** @class */ (function () {
	    function PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs) {
	        this.type = type;
	        this.selectAttr = selectAttr;
	        this.hrefAttr = hrefAttr;
	        this.nonBindable = nonBindable;
	        this.projectAs = projectAs;
	    }
	    return PreparsedElement;
	}());
	/**
	 * @param {?} selectAttr
	 * @return {?}
	 */
	function normalizeNgContentSelect(selectAttr) {
	    if (selectAttr === null || selectAttr.length === 0) {
	        return '*';
	    }
	    return selectAttr;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	var DirectiveNormalizer = /** @class */ (function () {
	    function DirectiveNormalizer(_resourceLoader, _urlResolver, _htmlParser, _config) {
	        this._resourceLoader = _resourceLoader;
	        this._urlResolver = _urlResolver;
	        this._htmlParser = _htmlParser;
	        this._config = _config;
	        this._resourceLoaderCache = new Map();
	    }
	    /**
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype.clearCache = /**
	     * @return {?}
	     */
	    function () { this._resourceLoaderCache.clear(); };
	    /**
	     * @param {?} normalizedDirective
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype.clearCacheFor = /**
	     * @param {?} normalizedDirective
	     * @return {?}
	     */
	    function (normalizedDirective) {
	        var _this = this;
	        if (!normalizedDirective.isComponent) {
	            return;
	        }
	        var /** @type {?} */ template = /** @type {?} */ ((normalizedDirective.template));
	        this._resourceLoaderCache.delete(/** @type {?} */ ((template.templateUrl)));
	        template.externalStylesheets.forEach(function (stylesheet) { _this._resourceLoaderCache.delete(/** @type {?} */ ((stylesheet.moduleUrl))); });
	    };
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._fetch = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        var /** @type {?} */ result = this._resourceLoaderCache.get(url);
	        if (!result) {
	            result = this._resourceLoader.get(url);
	            this._resourceLoaderCache.set(url, result);
	        }
	        return result;
	    };
	    /**
	     * @param {?} prenormData
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype.normalizeTemplate = /**
	     * @param {?} prenormData
	     * @return {?}
	     */
	    function (prenormData) {
	        var _this = this;
	        if (isDefined(prenormData.template)) {
	            if (isDefined(prenormData.templateUrl)) {
	                throw syntaxError("'" + stringify(prenormData.componentType) + "' component cannot define both template and templateUrl");
	            }
	            if (typeof prenormData.template !== 'string') {
	                throw syntaxError("The template specified for component " + stringify(prenormData.componentType) + " is not a string");
	            }
	        }
	        else if (isDefined(prenormData.templateUrl)) {
	            if (typeof prenormData.templateUrl !== 'string') {
	                throw syntaxError("The templateUrl specified for component " + stringify(prenormData.componentType) + " is not a string");
	            }
	        }
	        else {
	            throw syntaxError("No template specified for component " + stringify(prenormData.componentType));
	        }
	        if (isDefined(prenormData.preserveWhitespaces) &&
	            typeof prenormData.preserveWhitespaces !== 'boolean') {
	            throw syntaxError("The preserveWhitespaces option for component " + stringify(prenormData.componentType) + " must be a boolean");
	        }
	        return SyncAsync.then(this._preParseTemplate(prenormData), function (preparsedTemplate) { return _this._normalizeTemplateMetadata(prenormData, preparsedTemplate); });
	    };
	    /**
	     * @param {?} prenomData
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._preParseTemplate = /**
	     * @param {?} prenomData
	     * @return {?}
	     */
	    function (prenomData) {
	        var _this = this;
	        var /** @type {?} */ template;
	        var /** @type {?} */ templateUrl;
	        if (prenomData.template != null) {
	            template = prenomData.template;
	            templateUrl = prenomData.moduleUrl;
	        }
	        else {
	            templateUrl = this._urlResolver.resolve(prenomData.moduleUrl, /** @type {?} */ ((prenomData.templateUrl)));
	            template = this._fetch(templateUrl);
	        }
	        return SyncAsync.then(template, function (template) { return _this._preparseLoadedTemplate(prenomData, template, templateUrl); });
	    };
	    /**
	     * @param {?} prenormData
	     * @param {?} template
	     * @param {?} templateAbsUrl
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._preparseLoadedTemplate = /**
	     * @param {?} prenormData
	     * @param {?} template
	     * @param {?} templateAbsUrl
	     * @return {?}
	     */
	    function (prenormData, template, templateAbsUrl) {
	        var /** @type {?} */ isInline = !!prenormData.template;
	        var /** @type {?} */ interpolationConfig = InterpolationConfig.fromArray(/** @type {?} */ ((prenormData.interpolation)));
	        var /** @type {?} */ rootNodesAndErrors = this._htmlParser.parse(template, templateSourceUrl({ reference: prenormData.ngModuleType }, { type: { reference: prenormData.componentType } }, { isInline: isInline, templateUrl: templateAbsUrl }), true, interpolationConfig);
	        if (rootNodesAndErrors.errors.length > 0) {
	            var /** @type {?} */ errorString = rootNodesAndErrors.errors.join('\n');
	            throw syntaxError("Template parse errors:\n" + errorString);
	        }
	        var /** @type {?} */ templateMetadataStyles = this._normalizeStylesheet(new CompileStylesheetMetadata({ styles: prenormData.styles, moduleUrl: prenormData.moduleUrl }));
	        var /** @type {?} */ visitor = new TemplatePreparseVisitor();
	        visitAll(visitor, rootNodesAndErrors.rootNodes);
	        var /** @type {?} */ templateStyles = this._normalizeStylesheet(new CompileStylesheetMetadata({ styles: visitor.styles, styleUrls: visitor.styleUrls, moduleUrl: templateAbsUrl }));
	        var /** @type {?} */ styles = templateMetadataStyles.styles.concat(templateStyles.styles);
	        var /** @type {?} */ inlineStyleUrls = templateMetadataStyles.styleUrls.concat(templateStyles.styleUrls);
	        var /** @type {?} */ styleUrls = this
	            ._normalizeStylesheet(new CompileStylesheetMetadata({ styleUrls: prenormData.styleUrls, moduleUrl: prenormData.moduleUrl }))
	            .styleUrls;
	        return {
	            template: template,
	            templateUrl: templateAbsUrl, isInline: isInline,
	            htmlAst: rootNodesAndErrors, styles: styles, inlineStyleUrls: inlineStyleUrls, styleUrls: styleUrls,
	            ngContentSelectors: visitor.ngContentSelectors,
	        };
	    };
	    /**
	     * @param {?} prenormData
	     * @param {?} preparsedTemplate
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._normalizeTemplateMetadata = /**
	     * @param {?} prenormData
	     * @param {?} preparsedTemplate
	     * @return {?}
	     */
	    function (prenormData, preparsedTemplate) {
	        var _this = this;
	        return SyncAsync.then(this._loadMissingExternalStylesheets(preparsedTemplate.styleUrls.concat(preparsedTemplate.inlineStyleUrls)), function (externalStylesheets) {
	            return _this._normalizeLoadedTemplateMetadata(prenormData, preparsedTemplate, externalStylesheets);
	        });
	    };
	    /**
	     * @param {?} prenormData
	     * @param {?} preparsedTemplate
	     * @param {?} stylesheets
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._normalizeLoadedTemplateMetadata = /**
	     * @param {?} prenormData
	     * @param {?} preparsedTemplate
	     * @param {?} stylesheets
	     * @return {?}
	     */
	    function (prenormData, preparsedTemplate, stylesheets) {
	        var _this = this;
	        // Algorithm:
	        // - produce exactly 1 entry per original styleUrl in
	        // CompileTemplateMetadata.externalStylesheets whith all styles inlined
	        // - inline all styles that are referenced by the template into CompileTemplateMetadata.styles.
	        // Reason: be able to determine how many stylesheets there are even without loading
	        // the template nor the stylesheets, so we can create a stub for TypeScript always synchronously
	        // (as resouce loading may be async)
	        var /** @type {?} */ styles = preparsedTemplate.styles.slice();
	        this._inlineStyles(preparsedTemplate.inlineStyleUrls, stylesheets, styles);
	        var /** @type {?} */ styleUrls = preparsedTemplate.styleUrls;
	        var /** @type {?} */ externalStylesheets = styleUrls.map(function (styleUrl) {
	            var /** @type {?} */ stylesheet = /** @type {?} */ ((stylesheets.get(styleUrl)));
	            var /** @type {?} */ styles = stylesheet.styles.slice();
	            _this._inlineStyles(stylesheet.styleUrls, stylesheets, styles);
	            return new CompileStylesheetMetadata({ moduleUrl: styleUrl, styles: styles });
	        });
	        var /** @type {?} */ encapsulation = prenormData.encapsulation;
	        if (encapsulation == null) {
	            encapsulation = this._config.defaultEncapsulation;
	        }
	        if (encapsulation === ViewEncapsulation.Emulated && styles.length === 0 &&
	            styleUrls.length === 0) {
	            encapsulation = ViewEncapsulation.None;
	        }
	        return new CompileTemplateMetadata({
	            encapsulation: encapsulation,
	            template: preparsedTemplate.template,
	            templateUrl: preparsedTemplate.templateUrl,
	            htmlAst: preparsedTemplate.htmlAst, styles: styles, styleUrls: styleUrls,
	            ngContentSelectors: preparsedTemplate.ngContentSelectors,
	            animations: prenormData.animations,
	            interpolation: prenormData.interpolation,
	            isInline: preparsedTemplate.isInline, externalStylesheets: externalStylesheets,
	            preserveWhitespaces: preserveWhitespacesDefault(prenormData.preserveWhitespaces, this._config.preserveWhitespaces),
	        });
	    };
	    /**
	     * @param {?} styleUrls
	     * @param {?} stylesheets
	     * @param {?} targetStyles
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._inlineStyles = /**
	     * @param {?} styleUrls
	     * @param {?} stylesheets
	     * @param {?} targetStyles
	     * @return {?}
	     */
	    function (styleUrls, stylesheets, targetStyles) {
	        var _this = this;
	        styleUrls.forEach(function (styleUrl) {
	            var /** @type {?} */ stylesheet = /** @type {?} */ ((stylesheets.get(styleUrl)));
	            stylesheet.styles.forEach(function (style) { return targetStyles.push(style); });
	            _this._inlineStyles(stylesheet.styleUrls, stylesheets, targetStyles);
	        });
	    };
	    /**
	     * @param {?} styleUrls
	     * @param {?=} loadedStylesheets
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._loadMissingExternalStylesheets = /**
	     * @param {?} styleUrls
	     * @param {?=} loadedStylesheets
	     * @return {?}
	     */
	    function (styleUrls, loadedStylesheets) {
	        var _this = this;
	        if (loadedStylesheets === void 0) { loadedStylesheets = new Map(); }
	        return SyncAsync.then(SyncAsync.all(styleUrls.filter(function (styleUrl) { return !loadedStylesheets.has(styleUrl); })
	            .map(function (styleUrl) {
	            return SyncAsync.then(_this._fetch(styleUrl), function (loadedStyle) {
	                var /** @type {?} */ stylesheet = _this._normalizeStylesheet(new CompileStylesheetMetadata({ styles: [loadedStyle], moduleUrl: styleUrl }));
	                loadedStylesheets.set(styleUrl, stylesheet);
	                return _this._loadMissingExternalStylesheets(stylesheet.styleUrls, loadedStylesheets);
	            });
	        })), function (_) { return loadedStylesheets; });
	    };
	    /**
	     * @param {?} stylesheet
	     * @return {?}
	     */
	    DirectiveNormalizer.prototype._normalizeStylesheet = /**
	     * @param {?} stylesheet
	     * @return {?}
	     */
	    function (stylesheet) {
	        var _this = this;
	        var /** @type {?} */ moduleUrl = /** @type {?} */ ((stylesheet.moduleUrl));
	        var /** @type {?} */ allStyleUrls = stylesheet.styleUrls.filter(isStyleUrlResolvable)
	            .map(function (url) { return _this._urlResolver.resolve(moduleUrl, url); });
	        var /** @type {?} */ allStyles = stylesheet.styles.map(function (style) {
	            var /** @type {?} */ styleWithImports = extractStyleUrls(_this._urlResolver, moduleUrl, style);
	            allStyleUrls.push.apply(allStyleUrls, styleWithImports.styleUrls);
	            return styleWithImports.style;
	        });
	        return new CompileStylesheetMetadata({ styles: allStyles, styleUrls: allStyleUrls, moduleUrl: moduleUrl });
	    };
	    return DirectiveNormalizer;
	}());
	var TemplatePreparseVisitor = /** @class */ (function () {
	    function TemplatePreparseVisitor() {
	        this.ngContentSelectors = [];
	        this.styles = [];
	        this.styleUrls = [];
	        this.ngNonBindableStackCount = 0;
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    TemplatePreparseVisitor.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ preparsedElement = preparseElement(ast);
	        switch (preparsedElement.type) {
	            case PreparsedElementType.NG_CONTENT:
	                if (this.ngNonBindableStackCount === 0) {
	                    this.ngContentSelectors.push(preparsedElement.selectAttr);
	                }
	                break;
	            case PreparsedElementType.STYLE:
	                var /** @type {?} */ textContent_1 = '';
	                ast.children.forEach(function (child) {
	                    if (child instanceof Text) {
	                        textContent_1 += child.value;
	                    }
	                });
	                this.styles.push(textContent_1);
	                break;
	            case PreparsedElementType.STYLESHEET:
	                this.styleUrls.push(preparsedElement.hrefAttr);
	                break;
	            default:
	                break;
	        }
	        if (preparsedElement.nonBindable) {
	            this.ngNonBindableStackCount++;
	        }
	        visitAll(this, ast.children);
	        if (preparsedElement.nonBindable) {
	            this.ngNonBindableStackCount--;
	        }
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    TemplatePreparseVisitor.prototype.visitExpansion = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { visitAll(this, ast.cases); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    TemplatePreparseVisitor.prototype.visitExpansionCase = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        visitAll(this, ast.expression);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    TemplatePreparseVisitor.prototype.visitComment = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return null; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    TemplatePreparseVisitor.prototype.visitAttribute = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return null; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    TemplatePreparseVisitor.prototype.visitText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return null; };
	    return TemplatePreparseVisitor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var QUERY_METADATA_IDENTIFIERS = [
	    createViewChild,
	    createViewChildren,
	    createContentChild,
	    createContentChildren,
	];
	var DirectiveResolver = /** @class */ (function () {
	    function DirectiveResolver(_reflector) {
	        this._reflector = _reflector;
	    }
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    DirectiveResolver.prototype.isDirective = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ typeMetadata = this._reflector.annotations(resolveForwardRef(type));
	        return typeMetadata && typeMetadata.some(isDirectiveMetadata);
	    };
	    /**
	     * @param {?} type
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    DirectiveResolver.prototype.resolve = /**
	     * @param {?} type
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    function (type, throwIfNotFound) {
	        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
	        var /** @type {?} */ typeMetadata = this._reflector.annotations(resolveForwardRef(type));
	        if (typeMetadata) {
	            var /** @type {?} */ metadata = findLast(typeMetadata, isDirectiveMetadata);
	            if (metadata) {
	                var /** @type {?} */ propertyMetadata = this._reflector.propMetadata(type);
	                var /** @type {?} */ guards = this._reflector.guards(type);
	                return this._mergeWithPropertyMetadata(metadata, propertyMetadata, guards, type);
	            }
	        }
	        if (throwIfNotFound) {
	            throw new Error("No Directive annotation found on " + stringify(type));
	        }
	        return null;
	    };
	    /**
	     * @param {?} dm
	     * @param {?} propertyMetadata
	     * @param {?} guards
	     * @param {?} directiveType
	     * @return {?}
	     */
	    DirectiveResolver.prototype._mergeWithPropertyMetadata = /**
	     * @param {?} dm
	     * @param {?} propertyMetadata
	     * @param {?} guards
	     * @param {?} directiveType
	     * @return {?}
	     */
	    function (dm, propertyMetadata, guards, directiveType) {
	        var /** @type {?} */ inputs = [];
	        var /** @type {?} */ outputs = [];
	        var /** @type {?} */ host = {};
	        var /** @type {?} */ queries = {};
	        Object.keys(propertyMetadata).forEach(function (propName) {
	            var /** @type {?} */ input = findLast(propertyMetadata[propName], function (a) { return createInput.isTypeOf(a); });
	            if (input) {
	                if (input.bindingPropertyName) {
	                    inputs.push(propName + ": " + input.bindingPropertyName);
	                }
	                else {
	                    inputs.push(propName);
	                }
	            }
	            var /** @type {?} */ output = findLast(propertyMetadata[propName], function (a) { return createOutput.isTypeOf(a); });
	            if (output) {
	                if (output.bindingPropertyName) {
	                    outputs.push(propName + ": " + output.bindingPropertyName);
	                }
	                else {
	                    outputs.push(propName);
	                }
	            }
	            var /** @type {?} */ hostBindings = propertyMetadata[propName].filter(function (a) { return createHostBinding.isTypeOf(a); });
	            hostBindings.forEach(function (hostBinding) {
	                if (hostBinding.hostPropertyName) {
	                    var /** @type {?} */ startWith = hostBinding.hostPropertyName[0];
	                    if (startWith === '(') {
	                        throw new Error("@HostBinding can not bind to events. Use @HostListener instead.");
	                    }
	                    else if (startWith === '[') {
	                        throw new Error("@HostBinding parameter should be a property name, 'class.<name>', or 'attr.<name>'.");
	                    }
	                    host["[" + hostBinding.hostPropertyName + "]"] = propName;
	                }
	                else {
	                    host["[" + propName + "]"] = propName;
	                }
	            });
	            var /** @type {?} */ hostListeners = propertyMetadata[propName].filter(function (a) { return createHostListener.isTypeOf(a); });
	            hostListeners.forEach(function (hostListener) {
	                var /** @type {?} */ args = hostListener.args || [];
	                host["(" + hostListener.eventName + ")"] = propName + "(" + args.join(',') + ")";
	            });
	            var /** @type {?} */ query = findLast(propertyMetadata[propName], function (a) { return QUERY_METADATA_IDENTIFIERS.some(function (i) { return i.isTypeOf(a); }); });
	            if (query) {
	                queries[propName] = query;
	            }
	        });
	        return this._merge(dm, inputs, outputs, host, queries, guards, directiveType);
	    };
	    /**
	     * @param {?} def
	     * @return {?}
	     */
	    DirectiveResolver.prototype._extractPublicName = /**
	     * @param {?} def
	     * @return {?}
	     */
	    function (def) { return splitAtColon(def, [/** @type {?} */ ((null)), def])[1].trim(); };
	    /**
	     * @param {?} bindings
	     * @return {?}
	     */
	    DirectiveResolver.prototype._dedupeBindings = /**
	     * @param {?} bindings
	     * @return {?}
	     */
	    function (bindings) {
	        var /** @type {?} */ names = new Set();
	        var /** @type {?} */ publicNames = new Set();
	        var /** @type {?} */ reversedResult = [];
	        // go last to first to allow later entries to overwrite previous entries
	        for (var /** @type {?} */ i = bindings.length - 1; i >= 0; i--) {
	            var /** @type {?} */ binding = bindings[i];
	            var /** @type {?} */ name_1 = this._extractPublicName(binding);
	            publicNames.add(name_1);
	            if (!names.has(name_1)) {
	                names.add(name_1);
	                reversedResult.push(binding);
	            }
	        }
	        return reversedResult.reverse();
	    };
	    /**
	     * @param {?} directive
	     * @param {?} inputs
	     * @param {?} outputs
	     * @param {?} host
	     * @param {?} queries
	     * @param {?} guards
	     * @param {?} directiveType
	     * @return {?}
	     */
	    DirectiveResolver.prototype._merge = /**
	     * @param {?} directive
	     * @param {?} inputs
	     * @param {?} outputs
	     * @param {?} host
	     * @param {?} queries
	     * @param {?} guards
	     * @param {?} directiveType
	     * @return {?}
	     */
	    function (directive, inputs, outputs, host, queries, guards, directiveType) {
	        var /** @type {?} */ mergedInputs = this._dedupeBindings(directive.inputs ? directive.inputs.concat(inputs) : inputs);
	        var /** @type {?} */ mergedOutputs = this._dedupeBindings(directive.outputs ? directive.outputs.concat(outputs) : outputs);
	        var /** @type {?} */ mergedHost = directive.host ? __assign({}, directive.host, host) : host;
	        var /** @type {?} */ mergedQueries = directive.queries ? __assign({}, directive.queries, queries) : queries;
	        if (createComponent.isTypeOf(directive)) {
	            var /** @type {?} */ comp = /** @type {?} */ (directive);
	            return createComponent({
	                selector: comp.selector,
	                inputs: mergedInputs,
	                outputs: mergedOutputs,
	                host: mergedHost,
	                exportAs: comp.exportAs,
	                moduleId: comp.moduleId,
	                queries: mergedQueries,
	                changeDetection: comp.changeDetection,
	                providers: comp.providers,
	                viewProviders: comp.viewProviders,
	                entryComponents: comp.entryComponents,
	                template: comp.template,
	                templateUrl: comp.templateUrl,
	                styles: comp.styles,
	                styleUrls: comp.styleUrls,
	                encapsulation: comp.encapsulation,
	                animations: comp.animations,
	                interpolation: comp.interpolation,
	                preserveWhitespaces: directive.preserveWhitespaces,
	            });
	        }
	        else {
	            return createDirective({
	                selector: directive.selector,
	                inputs: mergedInputs,
	                outputs: mergedOutputs,
	                host: mergedHost,
	                exportAs: directive.exportAs,
	                queries: mergedQueries,
	                providers: directive.providers, guards: guards
	            });
	        }
	    };
	    return DirectiveResolver;
	}());
	/**
	 * @param {?} type
	 * @return {?}
	 */
	function isDirectiveMetadata(type) {
	    return createDirective.isTypeOf(type) || createComponent.isTypeOf(type);
	}
	/**
	 * @template T
	 * @param {?} arr
	 * @param {?} condition
	 * @return {?}
	 */
	function findLast(arr, condition) {
	    for (var /** @type {?} */ i = arr.length - 1; i >= 0; i--) {
	        if (condition(arr[i])) {
	            return arr[i];
	        }
	    }
	    return null;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var $EOF = 0;
	var $TAB = 9;
	var $LF = 10;
	var $VTAB = 11;
	var $FF = 12;
	var $CR = 13;
	var $SPACE = 32;
	var $BANG = 33;
	var $DQ = 34;
	var $HASH = 35;
	var $$ = 36;
	var $PERCENT = 37;
	var $AMPERSAND = 38;
	var $SQ = 39;
	var $LPAREN = 40;
	var $RPAREN = 41;
	var $STAR = 42;
	var $PLUS = 43;
	var $COMMA = 44;
	var $MINUS = 45;
	var $PERIOD = 46;
	var $SLASH = 47;
	var $COLON = 58;
	var $SEMICOLON = 59;
	var $LT = 60;
	var $EQ = 61;
	var $GT = 62;
	var $QUESTION = 63;
	var $0 = 48;
	var $9 = 57;
	var $A = 65;
	var $E = 69;
	var $F = 70;
	var $X = 88;
	var $Z = 90;
	var $LBRACKET = 91;
	var $BACKSLASH = 92;
	var $RBRACKET = 93;
	var $CARET = 94;
	var $_ = 95;
	var $a = 97;
	var $e = 101;
	var $f = 102;
	var $n = 110;
	var $r = 114;
	var $t = 116;
	var $u = 117;
	var $v = 118;
	var $x = 120;
	var $z = 122;
	var $LBRACE = 123;
	var $BAR = 124;
	var $RBRACE = 125;
	var $NBSP = 160;
	
	
	
	var $BT = 96;
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isWhitespace(code) {
	    return (code >= $TAB && code <= $SPACE) || (code == $NBSP);
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isDigit(code) {
	    return $0 <= code && code <= $9;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isAsciiLetter(code) {
	    return code >= $a && code <= $z || code >= $A && code <= $Z;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isAsciiHexDigit(code) {
	    return code >= $a && code <= $f || code >= $A && code <= $F || isDigit(code);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var TokenType = {
	    Character: 0,
	    Identifier: 1,
	    Keyword: 2,
	    String: 3,
	    Operator: 4,
	    Number: 5,
	    Error: 6,
	};
	TokenType[TokenType.Character] = "Character";
	TokenType[TokenType.Identifier] = "Identifier";
	TokenType[TokenType.Keyword] = "Keyword";
	TokenType[TokenType.String] = "String";
	TokenType[TokenType.Operator] = "Operator";
	TokenType[TokenType.Number] = "Number";
	TokenType[TokenType.Error] = "Error";
	var KEYWORDS = ['var', 'let', 'as', 'null', 'undefined', 'true', 'false', 'if', 'else', 'this'];
	var Lexer = /** @class */ (function () {
	    function Lexer() {
	    }
	    /**
	     * @param {?} text
	     * @return {?}
	     */
	    Lexer.prototype.tokenize = /**
	     * @param {?} text
	     * @return {?}
	     */
	    function (text) {
	        var /** @type {?} */ scanner = new _Scanner(text);
	        var /** @type {?} */ tokens = [];
	        var /** @type {?} */ token = scanner.scanToken();
	        while (token != null) {
	            tokens.push(token);
	            token = scanner.scanToken();
	        }
	        return tokens;
	    };
	    return Lexer;
	}());
	var Token = /** @class */ (function () {
	    function Token(index, type, numValue, strValue) {
	        this.index = index;
	        this.type = type;
	        this.numValue = numValue;
	        this.strValue = strValue;
	    }
	    /**
	     * @param {?} code
	     * @return {?}
	     */
	    Token.prototype.isCharacter = /**
	     * @param {?} code
	     * @return {?}
	     */
	    function (code) {
	        return this.type == TokenType.Character && this.numValue == code;
	    };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isNumber = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Number; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isString = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.String; };
	    /**
	     * @param {?} operater
	     * @return {?}
	     */
	    Token.prototype.isOperator = /**
	     * @param {?} operater
	     * @return {?}
	     */
	    function (operater) {
	        return this.type == TokenType.Operator && this.strValue == operater;
	    };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isIdentifier = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Identifier; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeyword = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordLet = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword && this.strValue == 'let'; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordAs = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword && this.strValue == 'as'; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordNull = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword && this.strValue == 'null'; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordUndefined = /**
	     * @return {?}
	     */
	    function () {
	        return this.type == TokenType.Keyword && this.strValue == 'undefined';
	    };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordTrue = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword && this.strValue == 'true'; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordFalse = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword && this.strValue == 'false'; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isKeywordThis = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Keyword && this.strValue == 'this'; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.isError = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Error; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.toNumber = /**
	     * @return {?}
	     */
	    function () { return this.type == TokenType.Number ? this.numValue : -1; };
	    /**
	     * @return {?}
	     */
	    Token.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        switch (this.type) {
	            case TokenType.Character:
	            case TokenType.Identifier:
	            case TokenType.Keyword:
	            case TokenType.Operator:
	            case TokenType.String:
	            case TokenType.Error:
	                return this.strValue;
	            case TokenType.Number:
	                return this.numValue.toString();
	            default:
	                return null;
	        }
	    };
	    return Token;
	}());
	/**
	 * @param {?} index
	 * @param {?} code
	 * @return {?}
	 */
	function newCharacterToken(index, code) {
	    return new Token(index, TokenType.Character, code, String.fromCharCode(code));
	}
	/**
	 * @param {?} index
	 * @param {?} text
	 * @return {?}
	 */
	function newIdentifierToken(index, text) {
	    return new Token(index, TokenType.Identifier, 0, text);
	}
	/**
	 * @param {?} index
	 * @param {?} text
	 * @return {?}
	 */
	function newKeywordToken(index, text) {
	    return new Token(index, TokenType.Keyword, 0, text);
	}
	/**
	 * @param {?} index
	 * @param {?} text
	 * @return {?}
	 */
	function newOperatorToken(index, text) {
	    return new Token(index, TokenType.Operator, 0, text);
	}
	/**
	 * @param {?} index
	 * @param {?} text
	 * @return {?}
	 */
	function newStringToken(index, text) {
	    return new Token(index, TokenType.String, 0, text);
	}
	/**
	 * @param {?} index
	 * @param {?} n
	 * @return {?}
	 */
	function newNumberToken(index, n) {
	    return new Token(index, TokenType.Number, n, '');
	}
	/**
	 * @param {?} index
	 * @param {?} message
	 * @return {?}
	 */
	function newErrorToken(index, message) {
	    return new Token(index, TokenType.Error, 0, message);
	}
	var EOF = new Token(-1, TokenType.Character, 0, '');
	var _Scanner = /** @class */ (function () {
	    function _Scanner(input) {
	        this.input = input;
	        this.peek = 0;
	        this.index = -1;
	        this.length = input.length;
	        this.advance();
	    }
	    /**
	     * @return {?}
	     */
	    _Scanner.prototype.advance = /**
	     * @return {?}
	     */
	    function () {
	        this.peek = ++this.index >= this.length ? $EOF : this.input.charCodeAt(this.index);
	    };
	    /**
	     * @return {?}
	     */
	    _Scanner.prototype.scanToken = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ input = this.input, /** @type {?} */ length = this.length;
	        var /** @type {?} */ peek = this.peek, /** @type {?} */ index = this.index;
	        // Skip whitespace.
	        while (peek <= $SPACE) {
	            if (++index >= length) {
	                peek = $EOF;
	                break;
	            }
	            else {
	                peek = input.charCodeAt(index);
	            }
	        }
	        this.peek = peek;
	        this.index = index;
	        if (index >= length) {
	            return null;
	        }
	        // Handle identifiers and numbers.
	        if (isIdentifierStart(peek))
	            return this.scanIdentifier();
	        if (isDigit(peek))
	            return this.scanNumber(index);
	        var /** @type {?} */ start = index;
	        switch (peek) {
	            case $PERIOD:
	                this.advance();
	                return isDigit(this.peek) ? this.scanNumber(start) :
	                    newCharacterToken(start, $PERIOD);
	            case $LPAREN:
	            case $RPAREN:
	            case $LBRACE:
	            case $RBRACE:
	            case $LBRACKET:
	            case $RBRACKET:
	            case $COMMA:
	            case $COLON:
	            case $SEMICOLON:
	                return this.scanCharacter(start, peek);
	            case $SQ:
	            case $DQ:
	                return this.scanString();
	            case $HASH:
	            case $PLUS:
	            case $MINUS:
	            case $STAR:
	            case $SLASH:
	            case $PERCENT:
	            case $CARET:
	                return this.scanOperator(start, String.fromCharCode(peek));
	            case $QUESTION:
	                return this.scanComplexOperator(start, '?', $PERIOD, '.');
	            case $LT:
	            case $GT:
	                return this.scanComplexOperator(start, String.fromCharCode(peek), $EQ, '=');
	            case $BANG:
	            case $EQ:
	                return this.scanComplexOperator(start, String.fromCharCode(peek), $EQ, '=', $EQ, '=');
	            case $AMPERSAND:
	                return this.scanComplexOperator(start, '&', $AMPERSAND, '&');
	            case $BAR:
	                return this.scanComplexOperator(start, '|', $BAR, '|');
	            case $NBSP:
	                while (isWhitespace(this.peek))
	                    this.advance();
	                return this.scanToken();
	        }
	        this.advance();
	        return this.error("Unexpected character [" + String.fromCharCode(peek) + "]", 0);
	    };
	    /**
	     * @param {?} start
	     * @param {?} code
	     * @return {?}
	     */
	    _Scanner.prototype.scanCharacter = /**
	     * @param {?} start
	     * @param {?} code
	     * @return {?}
	     */
	    function (start, code) {
	        this.advance();
	        return newCharacterToken(start, code);
	    };
	    /**
	     * @param {?} start
	     * @param {?} str
	     * @return {?}
	     */
	    _Scanner.prototype.scanOperator = /**
	     * @param {?} start
	     * @param {?} str
	     * @return {?}
	     */
	    function (start, str) {
	        this.advance();
	        return newOperatorToken(start, str);
	    };
	    /**
	     * Tokenize a 2/3 char long operator
	     *
	     * @param start start index in the expression
	     * @param one first symbol (always part of the operator)
	     * @param twoCode code point for the second symbol
	     * @param two second symbol (part of the operator when the second code point matches)
	     * @param threeCode code point for the third symbol
	     * @param three third symbol (part of the operator when provided and matches source expression)
	     */
	    /**
	     * Tokenize a 2/3 char long operator
	     *
	     * @param {?} start start index in the expression
	     * @param {?} one first symbol (always part of the operator)
	     * @param {?} twoCode code point for the second symbol
	     * @param {?} two second symbol (part of the operator when the second code point matches)
	     * @param {?=} threeCode code point for the third symbol
	     * @param {?=} three third symbol (part of the operator when provided and matches source expression)
	     * @return {?}
	     */
	    _Scanner.prototype.scanComplexOperator = /**
	     * Tokenize a 2/3 char long operator
	     *
	     * @param {?} start start index in the expression
	     * @param {?} one first symbol (always part of the operator)
	     * @param {?} twoCode code point for the second symbol
	     * @param {?} two second symbol (part of the operator when the second code point matches)
	     * @param {?=} threeCode code point for the third symbol
	     * @param {?=} three third symbol (part of the operator when provided and matches source expression)
	     * @return {?}
	     */
	    function (start, one, twoCode, two, threeCode, three) {
	        this.advance();
	        var /** @type {?} */ str = one;
	        if (this.peek == twoCode) {
	            this.advance();
	            str += two;
	        }
	        if (threeCode != null && this.peek == threeCode) {
	            this.advance();
	            str += three;
	        }
	        return newOperatorToken(start, str);
	    };
	    /**
	     * @return {?}
	     */
	    _Scanner.prototype.scanIdentifier = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ start = this.index;
	        this.advance();
	        while (isIdentifierPart(this.peek))
	            this.advance();
	        var /** @type {?} */ str = this.input.substring(start, this.index);
	        return KEYWORDS.indexOf(str) > -1 ? newKeywordToken(start, str) :
	            newIdentifierToken(start, str);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Scanner.prototype.scanNumber = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        var /** @type {?} */ simple = (this.index === start);
	        this.advance(); // Skip initial digit.
	        while (true) {
	            if (isDigit(this.peek)) {
	                // Do nothing.
	            }
	            else if (this.peek == $PERIOD) {
	                simple = false;
	            }
	            else if (isExponentStart(this.peek)) {
	                this.advance();
	                if (isExponentSign(this.peek))
	                    this.advance();
	                if (!isDigit(this.peek))
	                    return this.error('Invalid exponent', -1);
	                simple = false;
	            }
	            else {
	                break;
	            }
	            this.advance();
	        }
	        var /** @type {?} */ str = this.input.substring(start, this.index);
	        var /** @type {?} */ value = simple ? parseIntAutoRadix(str) : parseFloat(str);
	        return newNumberToken(start, value);
	    };
	    /**
	     * @return {?}
	     */
	    _Scanner.prototype.scanString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ start = this.index;
	        var /** @type {?} */ quote = this.peek;
	        this.advance(); // Skip initial quote.
	        var /** @type {?} */ buffer = '';
	        var /** @type {?} */ marker = this.index;
	        var /** @type {?} */ input = this.input;
	        while (this.peek != quote) {
	            if (this.peek == $BACKSLASH) {
	                buffer += input.substring(marker, this.index);
	                this.advance();
	                var /** @type {?} */ unescapedCode = void 0;
	                // Workaround for TS2.1-introduced type strictness
	                this.peek = this.peek;
	                if (this.peek == $u) {
	                    // 4 character hex code for unicode character.
	                    var /** @type {?} */ hex = input.substring(this.index + 1, this.index + 5);
	                    if (/^[0-9a-f]+$/i.test(hex)) {
	                        unescapedCode = parseInt(hex, 16);
	                    }
	                    else {
	                        return this.error("Invalid unicode escape [\\u" + hex + "]", 0);
	                    }
	                    for (var /** @type {?} */ i = 0; i < 5; i++) {
	                        this.advance();
	                    }
	                }
	                else {
	                    unescapedCode = unescape(this.peek);
	                    this.advance();
	                }
	                buffer += String.fromCharCode(unescapedCode);
	                marker = this.index;
	            }
	            else if (this.peek == $EOF) {
	                return this.error('Unterminated quote', 0);
	            }
	            else {
	                this.advance();
	            }
	        }
	        var /** @type {?} */ last = input.substring(marker, this.index);
	        this.advance(); // Skip terminating quote.
	        return newStringToken(start, buffer + last);
	    };
	    /**
	     * @param {?} message
	     * @param {?} offset
	     * @return {?}
	     */
	    _Scanner.prototype.error = /**
	     * @param {?} message
	     * @param {?} offset
	     * @return {?}
	     */
	    function (message, offset) {
	        var /** @type {?} */ position = this.index + offset;
	        return newErrorToken(position, "Lexer Error: " + message + " at column " + position + " in expression [" + this.input + "]");
	    };
	    return _Scanner;
	}());
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isIdentifierStart(code) {
	    return ($a <= code && code <= $z) || ($A <= code && code <= $Z) ||
	        (code == $_) || (code == $$);
	}
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function isIdentifier(input) {
	    if (input.length == 0)
	        return false;
	    var /** @type {?} */ scanner = new _Scanner(input);
	    if (!isIdentifierStart(scanner.peek))
	        return false;
	    scanner.advance();
	    while (scanner.peek !== $EOF) {
	        if (!isIdentifierPart(scanner.peek))
	            return false;
	        scanner.advance();
	    }
	    return true;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isIdentifierPart(code) {
	    return isAsciiLetter(code) || isDigit(code) || (code == $_) ||
	        (code == $$);
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isExponentStart(code) {
	    return code == $e || code == $E;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isExponentSign(code) {
	    return code == $MINUS || code == $PLUS;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isQuote(code) {
	    return code === $SQ || code === $DQ || code === $BT;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function unescape(code) {
	    switch (code) {
	        case $n:
	            return $LF;
	        case $f:
	            return $FF;
	        case $r:
	            return $CR;
	        case $t:
	            return $TAB;
	        case $v:
	            return $VTAB;
	        default:
	            return code;
	    }
	}
	/**
	 * @param {?} text
	 * @return {?}
	 */
	function parseIntAutoRadix(text) {
	    var /** @type {?} */ result = parseInt(text);
	    if (isNaN(result)) {
	        throw new Error('Invalid integer literal when parsing ' + text);
	    }
	    return result;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ParserError = /** @class */ (function () {
	    function ParserError(message, input, errLocation, ctxLocation) {
	        this.input = input;
	        this.errLocation = errLocation;
	        this.ctxLocation = ctxLocation;
	        this.message = "Parser Error: " + message + " " + errLocation + " [" + input + "] in " + ctxLocation;
	    }
	    return ParserError;
	}());
	var ParseSpan = /** @class */ (function () {
	    function ParseSpan(start, end) {
	        this.start = start;
	        this.end = end;
	    }
	    return ParseSpan;
	}());
	var AST = /** @class */ (function () {
	    function AST(span) {
	        this.span = span;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    AST.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return null;
	    };
	    /**
	     * @return {?}
	     */
	    AST.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return 'AST'; };
	    return AST;
	}());
	/**
	 * Represents a quoted expression of the form:
	 *
	 * quote = prefix `:` uninterpretedExpression
	 * prefix = identifier
	 * uninterpretedExpression = arbitrary string
	 *
	 * A quoted expression is meant to be pre-processed by an AST transformer that
	 * converts it into another AST that no longer contains quoted expressions.
	 * It is meant to allow third-party developers to extend Angular template
	 * expression language. The `uninterpretedExpression` part of the quote is
	 * therefore not interpreted by the Angular's own expression parser.
	 */
	var Quote = /** @class */ (function (_super) {
	    __extends(Quote, _super);
	    function Quote(span, prefix, uninterpretedExpression, location) {
	        var _this = _super.call(this, span) || this;
	        _this.prefix = prefix;
	        _this.uninterpretedExpression = uninterpretedExpression;
	        _this.location = location;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Quote.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitQuote(this, context);
	    };
	    /**
	     * @return {?}
	     */
	    Quote.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return 'Quote'; };
	    return Quote;
	}(AST));
	var EmptyExpr = /** @class */ (function (_super) {
	    __extends(EmptyExpr, _super);
	    function EmptyExpr() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    EmptyExpr.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        // do nothing
	    };
	    return EmptyExpr;
	}(AST));
	var ImplicitReceiver = /** @class */ (function (_super) {
	    __extends(ImplicitReceiver, _super);
	    function ImplicitReceiver() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    ImplicitReceiver.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitImplicitReceiver(this, context);
	    };
	    return ImplicitReceiver;
	}(AST));
	/**
	 * Multiple expressions separated by a semicolon.
	 */
	var Chain = /** @class */ (function (_super) {
	    __extends(Chain, _super);
	    function Chain(span, expressions) {
	        var _this = _super.call(this, span) || this;
	        _this.expressions = expressions;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Chain.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitChain(this, context);
	    };
	    return Chain;
	}(AST));
	var Conditional = /** @class */ (function (_super) {
	    __extends(Conditional, _super);
	    function Conditional(span, condition, trueExp, falseExp) {
	        var _this = _super.call(this, span) || this;
	        _this.condition = condition;
	        _this.trueExp = trueExp;
	        _this.falseExp = falseExp;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Conditional.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitConditional(this, context);
	    };
	    return Conditional;
	}(AST));
	var PropertyRead = /** @class */ (function (_super) {
	    __extends(PropertyRead, _super);
	    function PropertyRead(span, receiver, name) {
	        var _this = _super.call(this, span) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    PropertyRead.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitPropertyRead(this, context);
	    };
	    return PropertyRead;
	}(AST));
	var PropertyWrite = /** @class */ (function (_super) {
	    __extends(PropertyWrite, _super);
	    function PropertyWrite(span, receiver, name, value) {
	        var _this = _super.call(this, span) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    PropertyWrite.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitPropertyWrite(this, context);
	    };
	    return PropertyWrite;
	}(AST));
	var SafePropertyRead = /** @class */ (function (_super) {
	    __extends(SafePropertyRead, _super);
	    function SafePropertyRead(span, receiver, name) {
	        var _this = _super.call(this, span) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    SafePropertyRead.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitSafePropertyRead(this, context);
	    };
	    return SafePropertyRead;
	}(AST));
	var KeyedRead = /** @class */ (function (_super) {
	    __extends(KeyedRead, _super);
	    function KeyedRead(span, obj, key) {
	        var _this = _super.call(this, span) || this;
	        _this.obj = obj;
	        _this.key = key;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    KeyedRead.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitKeyedRead(this, context);
	    };
	    return KeyedRead;
	}(AST));
	var KeyedWrite = /** @class */ (function (_super) {
	    __extends(KeyedWrite, _super);
	    function KeyedWrite(span, obj, key, value) {
	        var _this = _super.call(this, span) || this;
	        _this.obj = obj;
	        _this.key = key;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    KeyedWrite.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitKeyedWrite(this, context);
	    };
	    return KeyedWrite;
	}(AST));
	var BindingPipe = /** @class */ (function (_super) {
	    __extends(BindingPipe, _super);
	    function BindingPipe(span, exp, name, args) {
	        var _this = _super.call(this, span) || this;
	        _this.exp = exp;
	        _this.name = name;
	        _this.args = args;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    BindingPipe.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitPipe(this, context);
	    };
	    return BindingPipe;
	}(AST));
	var LiteralPrimitive = /** @class */ (function (_super) {
	    __extends(LiteralPrimitive, _super);
	    function LiteralPrimitive(span, value) {
	        var _this = _super.call(this, span) || this;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    LiteralPrimitive.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitLiteralPrimitive(this, context);
	    };
	    return LiteralPrimitive;
	}(AST));
	var LiteralArray = /** @class */ (function (_super) {
	    __extends(LiteralArray, _super);
	    function LiteralArray(span, expressions) {
	        var _this = _super.call(this, span) || this;
	        _this.expressions = expressions;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    LiteralArray.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitLiteralArray(this, context);
	    };
	    return LiteralArray;
	}(AST));
	var LiteralMap = /** @class */ (function (_super) {
	    __extends(LiteralMap, _super);
	    function LiteralMap(span, keys, values) {
	        var _this = _super.call(this, span) || this;
	        _this.keys = keys;
	        _this.values = values;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    LiteralMap.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitLiteralMap(this, context);
	    };
	    return LiteralMap;
	}(AST));
	var Interpolation = /** @class */ (function (_super) {
	    __extends(Interpolation, _super);
	    function Interpolation(span, strings, expressions) {
	        var _this = _super.call(this, span) || this;
	        _this.strings = strings;
	        _this.expressions = expressions;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Interpolation.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitInterpolation(this, context);
	    };
	    return Interpolation;
	}(AST));
	var Binary = /** @class */ (function (_super) {
	    __extends(Binary, _super);
	    function Binary(span, operation, left, right) {
	        var _this = _super.call(this, span) || this;
	        _this.operation = operation;
	        _this.left = left;
	        _this.right = right;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Binary.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitBinary(this, context);
	    };
	    return Binary;
	}(AST));
	var PrefixNot = /** @class */ (function (_super) {
	    __extends(PrefixNot, _super);
	    function PrefixNot(span, expression) {
	        var _this = _super.call(this, span) || this;
	        _this.expression = expression;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    PrefixNot.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitPrefixNot(this, context);
	    };
	    return PrefixNot;
	}(AST));
	var NonNullAssert = /** @class */ (function (_super) {
	    __extends(NonNullAssert, _super);
	    function NonNullAssert(span, expression) {
	        var _this = _super.call(this, span) || this;
	        _this.expression = expression;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    NonNullAssert.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitNonNullAssert(this, context);
	    };
	    return NonNullAssert;
	}(AST));
	var MethodCall = /** @class */ (function (_super) {
	    __extends(MethodCall, _super);
	    function MethodCall(span, receiver, name, args) {
	        var _this = _super.call(this, span) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        _this.args = args;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    MethodCall.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitMethodCall(this, context);
	    };
	    return MethodCall;
	}(AST));
	var SafeMethodCall = /** @class */ (function (_super) {
	    __extends(SafeMethodCall, _super);
	    function SafeMethodCall(span, receiver, name, args) {
	        var _this = _super.call(this, span) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        _this.args = args;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    SafeMethodCall.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitSafeMethodCall(this, context);
	    };
	    return SafeMethodCall;
	}(AST));
	var FunctionCall = /** @class */ (function (_super) {
	    __extends(FunctionCall, _super);
	    function FunctionCall(span, target, args) {
	        var _this = _super.call(this, span) || this;
	        _this.target = target;
	        _this.args = args;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    FunctionCall.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return visitor.visitFunctionCall(this, context);
	    };
	    return FunctionCall;
	}(AST));
	var ASTWithSource = /** @class */ (function (_super) {
	    __extends(ASTWithSource, _super);
	    function ASTWithSource(ast, source, location, errors) {
	        var _this = _super.call(this, new ParseSpan(0, source == null ? 0 : source.length)) || this;
	        _this.ast = ast;
	        _this.source = source;
	        _this.location = location;
	        _this.errors = errors;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    ASTWithSource.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        if (context === void 0) { context = null; }
	        return this.ast.visit(visitor, context);
	    };
	    /**
	     * @return {?}
	     */
	    ASTWithSource.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return this.source + " in " + this.location; };
	    return ASTWithSource;
	}(AST));
	var TemplateBinding = /** @class */ (function () {
	    function TemplateBinding(span, key, keyIsVar, name, expression) {
	        this.span = span;
	        this.key = key;
	        this.keyIsVar = keyIsVar;
	        this.name = name;
	        this.expression = expression;
	    }
	    return TemplateBinding;
	}());
	/**
	 * @record
	 */
	
	var NullAstVisitor = /** @class */ (function () {
	    function NullAstVisitor() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitBinary = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitChain = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitConditional = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitFunctionCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitImplicitReceiver = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitInterpolation = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitKeyedRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitKeyedWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitLiteralArray = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitLiteralMap = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitLiteralPrimitive = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitPrefixNot = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitNonNullAssert = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitPropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitPropertyWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitQuote = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitSafeMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    NullAstVisitor.prototype.visitSafePropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    return NullAstVisitor;
	}());
	var RecursiveAstVisitor = /** @class */ (function () {
	    function RecursiveAstVisitor() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitBinary = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.left.visit(this);
	        ast.right.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitChain = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return this.visitAll(ast.expressions, context); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitConditional = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.condition.visit(this);
	        ast.trueExp.visit(this);
	        ast.falseExp.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.exp.visit(this);
	        this.visitAll(ast.args, context);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitFunctionCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        /** @type {?} */ ((ast.target)).visit(this);
	        this.visitAll(ast.args, context);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitImplicitReceiver = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return null; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitInterpolation = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitAll(ast.expressions, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitKeyedRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.obj.visit(this);
	        ast.key.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitKeyedWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.obj.visit(this);
	        ast.key.visit(this);
	        ast.value.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitLiteralArray = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitAll(ast.expressions, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitLiteralMap = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return this.visitAll(ast.values, context); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitLiteralPrimitive = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return null; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visit(this);
	        return this.visitAll(ast.args, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitPrefixNot = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.expression.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitNonNullAssert = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.expression.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitPropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitPropertyWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visit(this);
	        ast.value.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitSafePropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visit(this);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitSafeMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visit(this);
	        return this.visitAll(ast.args, context);
	    };
	    /**
	     * @param {?} asts
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitAll = /**
	     * @param {?} asts
	     * @param {?} context
	     * @return {?}
	     */
	    function (asts, context) {
	        var _this = this;
	        asts.forEach(function (ast) { return ast.visit(_this, context); });
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitQuote = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return null; };
	    return RecursiveAstVisitor;
	}());
	var AstTransformer = /** @class */ (function () {
	    function AstTransformer() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitImplicitReceiver = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return ast; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitInterpolation = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new Interpolation(ast.span, ast.strings, this.visitAll(ast.expressions));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitLiteralPrimitive = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new LiteralPrimitive(ast.span, ast.value);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitPropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new PropertyRead(ast.span, ast.receiver.visit(this), ast.name);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitPropertyWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new PropertyWrite(ast.span, ast.receiver.visit(this), ast.name, ast.value.visit(this));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitSafePropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new SafePropertyRead(ast.span, ast.receiver.visit(this), ast.name);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new MethodCall(ast.span, ast.receiver.visit(this), ast.name, this.visitAll(ast.args));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitSafeMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new SafeMethodCall(ast.span, ast.receiver.visit(this), ast.name, this.visitAll(ast.args));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitFunctionCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new FunctionCall(ast.span, /** @type {?} */ ((ast.target)).visit(this), this.visitAll(ast.args));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitLiteralArray = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new LiteralArray(ast.span, this.visitAll(ast.expressions));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitLiteralMap = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new LiteralMap(ast.span, ast.keys, this.visitAll(ast.values));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitBinary = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new Binary(ast.span, ast.operation, ast.left.visit(this), ast.right.visit(this));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitPrefixNot = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new PrefixNot(ast.span, ast.expression.visit(this));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitNonNullAssert = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new NonNullAssert(ast.span, ast.expression.visit(this));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitConditional = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new Conditional(ast.span, ast.condition.visit(this), ast.trueExp.visit(this), ast.falseExp.visit(this));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new BindingPipe(ast.span, ast.exp.visit(this), ast.name, this.visitAll(ast.args));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitKeyedRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new KeyedRead(ast.span, ast.obj.visit(this), ast.key.visit(this));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitKeyedWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new KeyedWrite(ast.span, ast.obj.visit(this), ast.key.visit(this), ast.value.visit(this));
	    };
	    /**
	     * @param {?} asts
	     * @return {?}
	     */
	    AstTransformer.prototype.visitAll = /**
	     * @param {?} asts
	     * @return {?}
	     */
	    function (asts) {
	        var /** @type {?} */ res = new Array(asts.length);
	        for (var /** @type {?} */ i = 0; i < asts.length; ++i) {
	            res[i] = asts[i].visit(this);
	        }
	        return res;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitChain = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new Chain(ast.span, this.visitAll(ast.expressions));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitQuote = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return new Quote(ast.span, ast.prefix, ast.uninterpretedExpression, ast.location);
	    };
	    return AstTransformer;
	}());
	/**
	 * @param {?} ast
	 * @param {?} visitor
	 * @param {?=} context
	 * @return {?}
	 */
	function visitAstChildren(ast, visitor, context) {
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function visit(ast) {
	        visitor.visit && visitor.visit(ast, context) || ast.visit(visitor, context);
	    }
	    /**
	     * @template T
	     * @param {?} asts
	     * @return {?}
	     */
	    function visitAll(asts) { asts.forEach(visit); }
	    ast.visit({
	        visitBinary: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.left);
	            visit(ast.right);
	        },
	        visitChain: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visitAll(ast.expressions); },
	        visitConditional: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.condition);
	            visit(ast.trueExp);
	            visit(ast.falseExp);
	        },
	        visitFunctionCall: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            if (ast.target) {
	                visit(ast.target);
	            }
	            visitAll(ast.args);
	        },
	        visitImplicitReceiver: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { },
	        visitInterpolation: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visitAll(ast.expressions); },
	        visitKeyedRead: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.obj);
	            visit(ast.key);
	        },
	        visitKeyedWrite: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.obj);
	            visit(ast.key);
	            visit(ast.obj);
	        },
	        visitLiteralArray: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visitAll(ast.expressions); },
	        visitLiteralMap: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { },
	        visitLiteralPrimitive: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { },
	        visitMethodCall: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.receiver);
	            visitAll(ast.args);
	        },
	        visitPipe: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.exp);
	            visitAll(ast.args);
	        },
	        visitPrefixNot: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visit(ast.expression); },
	        visitNonNullAssert: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visit(ast.expression); },
	        visitPropertyRead: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visit(ast.receiver); },
	        visitPropertyWrite: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.receiver);
	            visit(ast.value);
	        },
	        visitQuote: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { },
	        visitSafeMethodCall: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) {
	            visit(ast.receiver);
	            visitAll(ast.args);
	        },
	        visitSafePropertyRead: /**
	         * @param {?} ast
	         * @return {?}
	         */
	        function (ast) { visit(ast.receiver); },
	    });
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SplitInterpolation = /** @class */ (function () {
	    function SplitInterpolation(strings, expressions, offsets) {
	        this.strings = strings;
	        this.expressions = expressions;
	        this.offsets = offsets;
	    }
	    return SplitInterpolation;
	}());
	var TemplateBindingParseResult = /** @class */ (function () {
	    function TemplateBindingParseResult(templateBindings, warnings, errors) {
	        this.templateBindings = templateBindings;
	        this.warnings = warnings;
	        this.errors = errors;
	    }
	    return TemplateBindingParseResult;
	}());
	/**
	 * @param {?} config
	 * @return {?}
	 */
	function _createInterpolateRegExp(config) {
	    var /** @type {?} */ pattern = escapeRegExp(config.start) + '([\\s\\S]*?)' + escapeRegExp(config.end);
	    return new RegExp(pattern, 'g');
	}
	var Parser = /** @class */ (function () {
	    function Parser(_lexer) {
	        this._lexer = _lexer;
	        this.errors = [];
	    }
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype.parseAction = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        this._checkNoInterpolation(input, location, interpolationConfig);
	        var /** @type {?} */ sourceToLex = this._stripComments(input);
	        var /** @type {?} */ tokens = this._lexer.tokenize(this._stripComments(input));
	        var /** @type {?} */ ast = new _ParseAST(input, location, tokens, sourceToLex.length, true, this.errors, input.length - sourceToLex.length)
	            .parseChain();
	        return new ASTWithSource(ast, input, location, this.errors);
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype.parseBinding = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        var /** @type {?} */ ast = this._parseBindingAst(input, location, interpolationConfig);
	        return new ASTWithSource(ast, input, location, this.errors);
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype.parseSimpleBinding = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        var /** @type {?} */ ast = this._parseBindingAst(input, location, interpolationConfig);
	        var /** @type {?} */ errors = SimpleExpressionChecker.check(ast);
	        if (errors.length > 0) {
	            this._reportError("Host binding expression cannot contain " + errors.join(' '), input, location);
	        }
	        return new ASTWithSource(ast, input, location, this.errors);
	    };
	    /**
	     * @param {?} message
	     * @param {?} input
	     * @param {?} errLocation
	     * @param {?=} ctxLocation
	     * @return {?}
	     */
	    Parser.prototype._reportError = /**
	     * @param {?} message
	     * @param {?} input
	     * @param {?} errLocation
	     * @param {?=} ctxLocation
	     * @return {?}
	     */
	    function (message, input, errLocation, ctxLocation) {
	        this.errors.push(new ParserError(message, input, errLocation, ctxLocation));
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype._parseBindingAst = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        // Quotes expressions use 3rd-party expression language. We don't want to use
	        // our lexer or parser for that, so we check for that ahead of time.
	        var /** @type {?} */ quote = this._parseQuote(input, location);
	        if (quote != null) {
	            return quote;
	        }
	        this._checkNoInterpolation(input, location, interpolationConfig);
	        var /** @type {?} */ sourceToLex = this._stripComments(input);
	        var /** @type {?} */ tokens = this._lexer.tokenize(sourceToLex);
	        return new _ParseAST(input, location, tokens, sourceToLex.length, false, this.errors, input.length - sourceToLex.length)
	            .parseChain();
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @return {?}
	     */
	    Parser.prototype._parseQuote = /**
	     * @param {?} input
	     * @param {?} location
	     * @return {?}
	     */
	    function (input, location) {
	        if (input == null)
	            return null;
	        var /** @type {?} */ prefixSeparatorIndex = input.indexOf(':');
	        if (prefixSeparatorIndex == -1)
	            return null;
	        var /** @type {?} */ prefix = input.substring(0, prefixSeparatorIndex).trim();
	        if (!isIdentifier(prefix))
	            return null;
	        var /** @type {?} */ uninterpretedExpression = input.substring(prefixSeparatorIndex + 1);
	        return new Quote(new ParseSpan(0, input.length), prefix, uninterpretedExpression, location);
	    };
	    /**
	     * @param {?} prefixToken
	     * @param {?} input
	     * @param {?} location
	     * @return {?}
	     */
	    Parser.prototype.parseTemplateBindings = /**
	     * @param {?} prefixToken
	     * @param {?} input
	     * @param {?} location
	     * @return {?}
	     */
	    function (prefixToken, input, location) {
	        var /** @type {?} */ tokens = this._lexer.tokenize(input);
	        if (prefixToken) {
	            // Prefix the tokens with the tokens from prefixToken but have them take no space (0 index).
	            var /** @type {?} */ prefixTokens = this._lexer.tokenize(prefixToken).map(function (t) {
	                t.index = 0;
	                return t;
	            });
	            tokens.unshift.apply(tokens, prefixTokens);
	        }
	        return new _ParseAST(input, location, tokens, input.length, false, this.errors, 0)
	            .parseTemplateBindings();
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype.parseInterpolation = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        var /** @type {?} */ split = this.splitInterpolation(input, location, interpolationConfig);
	        if (split == null)
	            return null;
	        var /** @type {?} */ expressions = [];
	        for (var /** @type {?} */ i = 0; i < split.expressions.length; ++i) {
	            var /** @type {?} */ expressionText = split.expressions[i];
	            var /** @type {?} */ sourceToLex = this._stripComments(expressionText);
	            var /** @type {?} */ tokens = this._lexer.tokenize(sourceToLex);
	            var /** @type {?} */ ast = new _ParseAST(input, location, tokens, sourceToLex.length, false, this.errors, split.offsets[i] + (expressionText.length - sourceToLex.length))
	                .parseChain();
	            expressions.push(ast);
	        }
	        return new ASTWithSource(new Interpolation(new ParseSpan(0, input == null ? 0 : input.length), split.strings, expressions), input, location, this.errors);
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype.splitInterpolation = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        var /** @type {?} */ regexp = _createInterpolateRegExp(interpolationConfig);
	        var /** @type {?} */ parts = input.split(regexp);
	        if (parts.length <= 1) {
	            return null;
	        }
	        var /** @type {?} */ strings = [];
	        var /** @type {?} */ expressions = [];
	        var /** @type {?} */ offsets = [];
	        var /** @type {?} */ offset = 0;
	        for (var /** @type {?} */ i = 0; i < parts.length; i++) {
	            var /** @type {?} */ part = parts[i];
	            if (i % 2 === 0) {
	                // fixed string
	                strings.push(part);
	                offset += part.length;
	            }
	            else if (part.trim().length > 0) {
	                offset += interpolationConfig.start.length;
	                expressions.push(part);
	                offsets.push(offset);
	                offset += part.length + interpolationConfig.end.length;
	            }
	            else {
	                this._reportError('Blank expressions are not allowed in interpolated strings', input, "at column " + this._findInterpolationErrorColumn(parts, i, interpolationConfig) + " in", location);
	                expressions.push('$implict');
	                offsets.push(offset);
	            }
	        }
	        return new SplitInterpolation(strings, expressions, offsets);
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @return {?}
	     */
	    Parser.prototype.wrapLiteralPrimitive = /**
	     * @param {?} input
	     * @param {?} location
	     * @return {?}
	     */
	    function (input, location) {
	        return new ASTWithSource(new LiteralPrimitive(new ParseSpan(0, input == null ? 0 : input.length), input), input, location, this.errors);
	    };
	    /**
	     * @param {?} input
	     * @return {?}
	     */
	    Parser.prototype._stripComments = /**
	     * @param {?} input
	     * @return {?}
	     */
	    function (input) {
	        var /** @type {?} */ i = this._commentStart(input);
	        return i != null ? input.substring(0, i).trim() : input;
	    };
	    /**
	     * @param {?} input
	     * @return {?}
	     */
	    Parser.prototype._commentStart = /**
	     * @param {?} input
	     * @return {?}
	     */
	    function (input) {
	        var /** @type {?} */ outerQuote = null;
	        for (var /** @type {?} */ i = 0; i < input.length - 1; i++) {
	            var /** @type {?} */ char = input.charCodeAt(i);
	            var /** @type {?} */ nextChar = input.charCodeAt(i + 1);
	            if (char === $SLASH && nextChar == $SLASH && outerQuote == null)
	                return i;
	            if (outerQuote === char) {
	                outerQuote = null;
	            }
	            else if (outerQuote == null && isQuote(char)) {
	                outerQuote = char;
	            }
	        }
	        return null;
	    };
	    /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype._checkNoInterpolation = /**
	     * @param {?} input
	     * @param {?} location
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (input, location, interpolationConfig) {
	        var /** @type {?} */ regexp = _createInterpolateRegExp(interpolationConfig);
	        var /** @type {?} */ parts = input.split(regexp);
	        if (parts.length > 1) {
	            this._reportError("Got interpolation (" + interpolationConfig.start + interpolationConfig.end + ") where expression was expected", input, "at column " + this._findInterpolationErrorColumn(parts, 1, interpolationConfig) + " in", location);
	        }
	    };
	    /**
	     * @param {?} parts
	     * @param {?} partInErrIdx
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype._findInterpolationErrorColumn = /**
	     * @param {?} parts
	     * @param {?} partInErrIdx
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (parts, partInErrIdx, interpolationConfig) {
	        var /** @type {?} */ errLocation = '';
	        for (var /** @type {?} */ j = 0; j < partInErrIdx; j++) {
	            errLocation += j % 2 === 0 ?
	                parts[j] :
	                "" + interpolationConfig.start + parts[j] + interpolationConfig.end;
	        }
	        return errLocation.length;
	    };
	    return Parser;
	}());
	var _ParseAST = /** @class */ (function () {
	    function _ParseAST(input, location, tokens, inputLength, parseAction, errors, offset) {
	        this.input = input;
	        this.location = location;
	        this.tokens = tokens;
	        this.inputLength = inputLength;
	        this.parseAction = parseAction;
	        this.errors = errors;
	        this.offset = offset;
	        this.rparensExpected = 0;
	        this.rbracketsExpected = 0;
	        this.rbracesExpected = 0;
	        this.index = 0;
	    }
	    /**
	     * @param {?} offset
	     * @return {?}
	     */
	    _ParseAST.prototype.peek = /**
	     * @param {?} offset
	     * @return {?}
	     */
	    function (offset) {
	        var /** @type {?} */ i = this.index + offset;
	        return i < this.tokens.length ? this.tokens[i] : EOF;
	    };
	    Object.defineProperty(_ParseAST.prototype, "next", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.peek(0); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(_ParseAST.prototype, "inputIndex", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return (this.index < this.tokens.length) ? this.next.index + this.offset :
	                this.inputLength + this.offset;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _ParseAST.prototype.span = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) { return new ParseSpan(start, this.inputIndex); };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.advance = /**
	     * @return {?}
	     */
	    function () { this.index++; };
	    /**
	     * @param {?} code
	     * @return {?}
	     */
	    _ParseAST.prototype.optionalCharacter = /**
	     * @param {?} code
	     * @return {?}
	     */
	    function (code) {
	        if (this.next.isCharacter(code)) {
	            this.advance();
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.peekKeywordLet = /**
	     * @return {?}
	     */
	    function () { return this.next.isKeywordLet(); };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.peekKeywordAs = /**
	     * @return {?}
	     */
	    function () { return this.next.isKeywordAs(); };
	    /**
	     * @param {?} code
	     * @return {?}
	     */
	    _ParseAST.prototype.expectCharacter = /**
	     * @param {?} code
	     * @return {?}
	     */
	    function (code) {
	        if (this.optionalCharacter(code))
	            return;
	        this.error("Missing expected " + String.fromCharCode(code));
	    };
	    /**
	     * @param {?} op
	     * @return {?}
	     */
	    _ParseAST.prototype.optionalOperator = /**
	     * @param {?} op
	     * @return {?}
	     */
	    function (op) {
	        if (this.next.isOperator(op)) {
	            this.advance();
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * @param {?} operator
	     * @return {?}
	     */
	    _ParseAST.prototype.expectOperator = /**
	     * @param {?} operator
	     * @return {?}
	     */
	    function (operator) {
	        if (this.optionalOperator(operator))
	            return;
	        this.error("Missing expected operator " + operator);
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.expectIdentifierOrKeyword = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ n = this.next;
	        if (!n.isIdentifier() && !n.isKeyword()) {
	            this.error("Unexpected token " + n + ", expected identifier or keyword");
	            return '';
	        }
	        this.advance();
	        return /** @type {?} */ (n.toString());
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.expectIdentifierOrKeywordOrString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ n = this.next;
	        if (!n.isIdentifier() && !n.isKeyword() && !n.isString()) {
	            this.error("Unexpected token " + n + ", expected identifier, keyword, or string");
	            return '';
	        }
	        this.advance();
	        return /** @type {?} */ (n.toString());
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseChain = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ exprs = [];
	        var /** @type {?} */ start = this.inputIndex;
	        while (this.index < this.tokens.length) {
	            var /** @type {?} */ expr = this.parsePipe();
	            exprs.push(expr);
	            if (this.optionalCharacter($SEMICOLON)) {
	                if (!this.parseAction) {
	                    this.error('Binding expression cannot contain chained expression');
	                }
	                while (this.optionalCharacter($SEMICOLON)) {
	                } // read all semicolons
	            }
	            else if (this.index < this.tokens.length) {
	                this.error("Unexpected token '" + this.next + "'");
	            }
	        }
	        if (exprs.length == 0)
	            return new EmptyExpr(this.span(start));
	        if (exprs.length == 1)
	            return exprs[0];
	        return new Chain(this.span(start), exprs);
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parsePipe = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ result = this.parseExpression();
	        if (this.optionalOperator('|')) {
	            if (this.parseAction) {
	                this.error('Cannot have a pipe in an action expression');
	            }
	            do {
	                var /** @type {?} */ name_1 = this.expectIdentifierOrKeyword();
	                var /** @type {?} */ args = [];
	                while (this.optionalCharacter($COLON)) {
	                    args.push(this.parseExpression());
	                }
	                result = new BindingPipe(this.span(result.span.start), result, name_1, args);
	            } while (this.optionalOperator('|'));
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseExpression = /**
	     * @return {?}
	     */
	    function () { return this.parseConditional(); };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseConditional = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ start = this.inputIndex;
	        var /** @type {?} */ result = this.parseLogicalOr();
	        if (this.optionalOperator('?')) {
	            var /** @type {?} */ yes = this.parsePipe();
	            var /** @type {?} */ no = void 0;
	            if (!this.optionalCharacter($COLON)) {
	                var /** @type {?} */ end = this.inputIndex;
	                var /** @type {?} */ expression = this.input.substring(start, end);
	                this.error("Conditional expression " + expression + " requires all 3 expressions");
	                no = new EmptyExpr(this.span(start));
	            }
	            else {
	                no = this.parsePipe();
	            }
	            return new Conditional(this.span(start), result, yes, no);
	        }
	        else {
	            return result;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseLogicalOr = /**
	     * @return {?}
	     */
	    function () {
	        // '||'
	        var /** @type {?} */ result = this.parseLogicalAnd();
	        while (this.optionalOperator('||')) {
	            var /** @type {?} */ right = this.parseLogicalAnd();
	            result = new Binary(this.span(result.span.start), '||', result, right);
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseLogicalAnd = /**
	     * @return {?}
	     */
	    function () {
	        // '&&'
	        var /** @type {?} */ result = this.parseEquality();
	        while (this.optionalOperator('&&')) {
	            var /** @type {?} */ right = this.parseEquality();
	            result = new Binary(this.span(result.span.start), '&&', result, right);
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseEquality = /**
	     * @return {?}
	     */
	    function () {
	        // '==','!=','===','!=='
	        var /** @type {?} */ result = this.parseRelational();
	        while (this.next.type == TokenType.Operator) {
	            var /** @type {?} */ operator = this.next.strValue;
	            switch (operator) {
	                case '==':
	                case '===':
	                case '!=':
	                case '!==':
	                    this.advance();
	                    var /** @type {?} */ right = this.parseRelational();
	                    result = new Binary(this.span(result.span.start), operator, result, right);
	                    continue;
	            }
	            break;
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseRelational = /**
	     * @return {?}
	     */
	    function () {
	        // '<', '>', '<=', '>='
	        var /** @type {?} */ result = this.parseAdditive();
	        while (this.next.type == TokenType.Operator) {
	            var /** @type {?} */ operator = this.next.strValue;
	            switch (operator) {
	                case '<':
	                case '>':
	                case '<=':
	                case '>=':
	                    this.advance();
	                    var /** @type {?} */ right = this.parseAdditive();
	                    result = new Binary(this.span(result.span.start), operator, result, right);
	                    continue;
	            }
	            break;
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseAdditive = /**
	     * @return {?}
	     */
	    function () {
	        // '+', '-'
	        var /** @type {?} */ result = this.parseMultiplicative();
	        while (this.next.type == TokenType.Operator) {
	            var /** @type {?} */ operator = this.next.strValue;
	            switch (operator) {
	                case '+':
	                case '-':
	                    this.advance();
	                    var /** @type {?} */ right = this.parseMultiplicative();
	                    result = new Binary(this.span(result.span.start), operator, result, right);
	                    continue;
	            }
	            break;
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseMultiplicative = /**
	     * @return {?}
	     */
	    function () {
	        // '*', '%', '/'
	        var /** @type {?} */ result = this.parsePrefix();
	        while (this.next.type == TokenType.Operator) {
	            var /** @type {?} */ operator = this.next.strValue;
	            switch (operator) {
	                case '*':
	                case '%':
	                case '/':
	                    this.advance();
	                    var /** @type {?} */ right = this.parsePrefix();
	                    result = new Binary(this.span(result.span.start), operator, result, right);
	                    continue;
	            }
	            break;
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parsePrefix = /**
	     * @return {?}
	     */
	    function () {
	        if (this.next.type == TokenType.Operator) {
	            var /** @type {?} */ start = this.inputIndex;
	            var /** @type {?} */ operator = this.next.strValue;
	            var /** @type {?} */ result = void 0;
	            switch (operator) {
	                case '+':
	                    this.advance();
	                    result = this.parsePrefix();
	                    return new Binary(this.span(start), '-', result, new LiteralPrimitive(new ParseSpan(start, start), 0));
	                case '-':
	                    this.advance();
	                    result = this.parsePrefix();
	                    return new Binary(this.span(start), operator, new LiteralPrimitive(new ParseSpan(start, start), 0), result);
	                case '!':
	                    this.advance();
	                    result = this.parsePrefix();
	                    return new PrefixNot(this.span(start), result);
	            }
	        }
	        return this.parseCallChain();
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseCallChain = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ result = this.parsePrimary();
	        while (true) {
	            if (this.optionalCharacter($PERIOD)) {
	                result = this.parseAccessMemberOrMethodCall(result, false);
	            }
	            else if (this.optionalOperator('?.')) {
	                result = this.parseAccessMemberOrMethodCall(result, true);
	            }
	            else if (this.optionalCharacter($LBRACKET)) {
	                this.rbracketsExpected++;
	                var /** @type {?} */ key = this.parsePipe();
	                this.rbracketsExpected--;
	                this.expectCharacter($RBRACKET);
	                if (this.optionalOperator('=')) {
	                    var /** @type {?} */ value = this.parseConditional();
	                    result = new KeyedWrite(this.span(result.span.start), result, key, value);
	                }
	                else {
	                    result = new KeyedRead(this.span(result.span.start), result, key);
	                }
	            }
	            else if (this.optionalCharacter($LPAREN)) {
	                this.rparensExpected++;
	                var /** @type {?} */ args = this.parseCallArguments();
	                this.rparensExpected--;
	                this.expectCharacter($RPAREN);
	                result = new FunctionCall(this.span(result.span.start), result, args);
	            }
	            else if (this.optionalOperator('!')) {
	                result = new NonNullAssert(this.span(result.span.start), result);
	            }
	            else {
	                return result;
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parsePrimary = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ start = this.inputIndex;
	        if (this.optionalCharacter($LPAREN)) {
	            this.rparensExpected++;
	            var /** @type {?} */ result = this.parsePipe();
	            this.rparensExpected--;
	            this.expectCharacter($RPAREN);
	            return result;
	        }
	        else if (this.next.isKeywordNull()) {
	            this.advance();
	            return new LiteralPrimitive(this.span(start), null);
	        }
	        else if (this.next.isKeywordUndefined()) {
	            this.advance();
	            return new LiteralPrimitive(this.span(start), void 0);
	        }
	        else if (this.next.isKeywordTrue()) {
	            this.advance();
	            return new LiteralPrimitive(this.span(start), true);
	        }
	        else if (this.next.isKeywordFalse()) {
	            this.advance();
	            return new LiteralPrimitive(this.span(start), false);
	        }
	        else if (this.next.isKeywordThis()) {
	            this.advance();
	            return new ImplicitReceiver(this.span(start));
	        }
	        else if (this.optionalCharacter($LBRACKET)) {
	            this.rbracketsExpected++;
	            var /** @type {?} */ elements = this.parseExpressionList($RBRACKET);
	            this.rbracketsExpected--;
	            this.expectCharacter($RBRACKET);
	            return new LiteralArray(this.span(start), elements);
	        }
	        else if (this.next.isCharacter($LBRACE)) {
	            return this.parseLiteralMap();
	        }
	        else if (this.next.isIdentifier()) {
	            return this.parseAccessMemberOrMethodCall(new ImplicitReceiver(this.span(start)), false);
	        }
	        else if (this.next.isNumber()) {
	            var /** @type {?} */ value = this.next.toNumber();
	            this.advance();
	            return new LiteralPrimitive(this.span(start), value);
	        }
	        else if (this.next.isString()) {
	            var /** @type {?} */ literalValue = this.next.toString();
	            this.advance();
	            return new LiteralPrimitive(this.span(start), literalValue);
	        }
	        else if (this.index >= this.tokens.length) {
	            this.error("Unexpected end of expression: " + this.input);
	            return new EmptyExpr(this.span(start));
	        }
	        else {
	            this.error("Unexpected token " + this.next);
	            return new EmptyExpr(this.span(start));
	        }
	    };
	    /**
	     * @param {?} terminator
	     * @return {?}
	     */
	    _ParseAST.prototype.parseExpressionList = /**
	     * @param {?} terminator
	     * @return {?}
	     */
	    function (terminator) {
	        var /** @type {?} */ result = [];
	        if (!this.next.isCharacter(terminator)) {
	            do {
	                result.push(this.parsePipe());
	            } while (this.optionalCharacter($COMMA));
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseLiteralMap = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ keys = [];
	        var /** @type {?} */ values = [];
	        var /** @type {?} */ start = this.inputIndex;
	        this.expectCharacter($LBRACE);
	        if (!this.optionalCharacter($RBRACE)) {
	            this.rbracesExpected++;
	            do {
	                var /** @type {?} */ quoted = this.next.isString();
	                var /** @type {?} */ key = this.expectIdentifierOrKeywordOrString();
	                keys.push({ key: key, quoted: quoted });
	                this.expectCharacter($COLON);
	                values.push(this.parsePipe());
	            } while (this.optionalCharacter($COMMA));
	            this.rbracesExpected--;
	            this.expectCharacter($RBRACE);
	        }
	        return new LiteralMap(this.span(start), keys, values);
	    };
	    /**
	     * @param {?} receiver
	     * @param {?=} isSafe
	     * @return {?}
	     */
	    _ParseAST.prototype.parseAccessMemberOrMethodCall = /**
	     * @param {?} receiver
	     * @param {?=} isSafe
	     * @return {?}
	     */
	    function (receiver, isSafe) {
	        if (isSafe === void 0) { isSafe = false; }
	        var /** @type {?} */ start = receiver.span.start;
	        var /** @type {?} */ id = this.expectIdentifierOrKeyword();
	        if (this.optionalCharacter($LPAREN)) {
	            this.rparensExpected++;
	            var /** @type {?} */ args = this.parseCallArguments();
	            this.expectCharacter($RPAREN);
	            this.rparensExpected--;
	            var /** @type {?} */ span = this.span(start);
	            return isSafe ? new SafeMethodCall(span, receiver, id, args) :
	                new MethodCall(span, receiver, id, args);
	        }
	        else {
	            if (isSafe) {
	                if (this.optionalOperator('=')) {
	                    this.error('The \'?.\' operator cannot be used in the assignment');
	                    return new EmptyExpr(this.span(start));
	                }
	                else {
	                    return new SafePropertyRead(this.span(start), receiver, id);
	                }
	            }
	            else {
	                if (this.optionalOperator('=')) {
	                    if (!this.parseAction) {
	                        this.error('Bindings cannot contain assignments');
	                        return new EmptyExpr(this.span(start));
	                    }
	                    var /** @type {?} */ value = this.parseConditional();
	                    return new PropertyWrite(this.span(start), receiver, id, value);
	                }
	                else {
	                    return new PropertyRead(this.span(start), receiver, id);
	                }
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseCallArguments = /**
	     * @return {?}
	     */
	    function () {
	        if (this.next.isCharacter($RPAREN))
	            return [];
	        var /** @type {?} */ positionals = [];
	        do {
	            positionals.push(this.parsePipe());
	        } while (this.optionalCharacter($COMMA));
	        return /** @type {?} */ (positionals);
	    };
	    /**
	     * An identifier, a keyword, a string with an optional `-` inbetween.
	     */
	    /**
	     * An identifier, a keyword, a string with an optional `-` inbetween.
	     * @return {?}
	     */
	    _ParseAST.prototype.expectTemplateBindingKey = /**
	     * An identifier, a keyword, a string with an optional `-` inbetween.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ result = '';
	        var /** @type {?} */ operatorFound = false;
	        do {
	            result += this.expectIdentifierOrKeywordOrString();
	            operatorFound = this.optionalOperator('-');
	            if (operatorFound) {
	                result += '-';
	            }
	        } while (operatorFound);
	        return result.toString();
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.parseTemplateBindings = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ bindings = [];
	        var /** @type {?} */ prefix = /** @type {?} */ ((null));
	        var /** @type {?} */ warnings = [];
	        while (this.index < this.tokens.length) {
	            var /** @type {?} */ start = this.inputIndex;
	            var /** @type {?} */ keyIsVar = this.peekKeywordLet();
	            if (keyIsVar) {
	                this.advance();
	            }
	            var /** @type {?} */ rawKey = this.expectTemplateBindingKey();
	            var /** @type {?} */ key = rawKey;
	            if (!keyIsVar) {
	                if (prefix == null) {
	                    prefix = key;
	                }
	                else {
	                    key = prefix + key[0].toUpperCase() + key.substring(1);
	                }
	            }
	            this.optionalCharacter($COLON);
	            var /** @type {?} */ name_2 = /** @type {?} */ ((null));
	            var /** @type {?} */ expression = /** @type {?} */ ((null));
	            if (keyIsVar) {
	                if (this.optionalOperator('=')) {
	                    name_2 = this.expectTemplateBindingKey();
	                }
	                else {
	                    name_2 = '\$implicit';
	                }
	            }
	            else if (this.peekKeywordAs()) {
	                var /** @type {?} */ letStart = this.inputIndex;
	                this.advance(); // consume `as`
	                name_2 = rawKey;
	                key = this.expectTemplateBindingKey(); // read local var name
	                keyIsVar = true;
	            }
	            else if (this.next !== EOF && !this.peekKeywordLet()) {
	                var /** @type {?} */ start_1 = this.inputIndex;
	                var /** @type {?} */ ast = this.parsePipe();
	                var /** @type {?} */ source = this.input.substring(start_1 - this.offset, this.inputIndex - this.offset);
	                expression = new ASTWithSource(ast, source, this.location, this.errors);
	            }
	            bindings.push(new TemplateBinding(this.span(start), key, keyIsVar, name_2, expression));
	            if (this.peekKeywordAs() && !keyIsVar) {
	                var /** @type {?} */ letStart = this.inputIndex;
	                this.advance(); // consume `as`
	                var /** @type {?} */ letName = this.expectTemplateBindingKey(); // read local var name
	                bindings.push(new TemplateBinding(this.span(letStart), letName, true, key, /** @type {?} */ ((null))));
	            }
	            if (!this.optionalCharacter($SEMICOLON)) {
	                this.optionalCharacter($COMMA);
	            }
	        }
	        return new TemplateBindingParseResult(bindings, warnings, this.errors);
	    };
	    /**
	     * @param {?} message
	     * @param {?=} index
	     * @return {?}
	     */
	    _ParseAST.prototype.error = /**
	     * @param {?} message
	     * @param {?=} index
	     * @return {?}
	     */
	    function (message, index) {
	        if (index === void 0) { index = null; }
	        this.errors.push(new ParserError(message, this.input, this.locationText(index), this.location));
	        this.skip();
	    };
	    /**
	     * @param {?=} index
	     * @return {?}
	     */
	    _ParseAST.prototype.locationText = /**
	     * @param {?=} index
	     * @return {?}
	     */
	    function (index) {
	        if (index === void 0) { index = null; }
	        if (index == null)
	            index = this.index;
	        return (index < this.tokens.length) ? "at column " + (this.tokens[index].index + 1) + " in" :
	            "at the end of the expression";
	    };
	    /**
	     * @return {?}
	     */
	    _ParseAST.prototype.skip = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ n = this.next;
	        while (this.index < this.tokens.length && !n.isCharacter($SEMICOLON) &&
	            (this.rparensExpected <= 0 || !n.isCharacter($RPAREN)) &&
	            (this.rbracesExpected <= 0 || !n.isCharacter($RBRACE)) &&
	            (this.rbracketsExpected <= 0 || !n.isCharacter($RBRACKET))) {
	            if (this.next.isError()) {
	                this.errors.push(new ParserError(/** @type {?} */ ((this.next.toString())), this.input, this.locationText(), this.location));
	            }
	            this.advance();
	            n = this.next;
	        }
	    };
	    return _ParseAST;
	}());
	var SimpleExpressionChecker = /** @class */ (function () {
	    function SimpleExpressionChecker() {
	        this.errors = [];
	    }
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    SimpleExpressionChecker.check = /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function (ast) {
	        var /** @type {?} */ s = new SimpleExpressionChecker();
	        ast.visit(s);
	        return s.errors;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitImplicitReceiver = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitInterpolation = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitLiteralPrimitive = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitPropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitPropertyWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitSafePropertyRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitSafeMethodCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitFunctionCall = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitLiteralArray = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { this.visitAll(ast.expressions); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitLiteralMap = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { this.visitAll(ast.values); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitBinary = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitPrefixNot = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitNonNullAssert = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitConditional = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { this.errors.push('pipes'); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitKeyedRead = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitKeyedWrite = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} asts
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitAll = /**
	     * @param {?} asts
	     * @return {?}
	     */
	    function (asts) {
	        var _this = this;
	        return asts.map(function (node) { return node.visit(_this); });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitChain = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    SimpleExpressionChecker.prototype.visitQuote = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    return SimpleExpressionChecker;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ParseLocation = /** @class */ (function () {
	    function ParseLocation(file, offset, line, col) {
	        this.file = file;
	        this.offset = offset;
	        this.line = line;
	        this.col = col;
	    }
	    /**
	     * @return {?}
	     */
	    ParseLocation.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return this.offset != null ? this.file.url + "@" + this.line + ":" + this.col : this.file.url;
	    };
	    /**
	     * @param {?} delta
	     * @return {?}
	     */
	    ParseLocation.prototype.moveBy = /**
	     * @param {?} delta
	     * @return {?}
	     */
	    function (delta) {
	        var /** @type {?} */ source = this.file.content;
	        var /** @type {?} */ len = source.length;
	        var /** @type {?} */ offset = this.offset;
	        var /** @type {?} */ line = this.line;
	        var /** @type {?} */ col = this.col;
	        while (offset > 0 && delta < 0) {
	            offset--;
	            delta++;
	            var /** @type {?} */ ch = source.charCodeAt(offset);
	            if (ch == $LF) {
	                line--;
	                var /** @type {?} */ priorLine = source.substr(0, offset - 1).lastIndexOf(String.fromCharCode($LF));
	                col = priorLine > 0 ? offset - priorLine : offset;
	            }
	            else {
	                col--;
	            }
	        }
	        while (offset < len && delta > 0) {
	            var /** @type {?} */ ch = source.charCodeAt(offset);
	            offset++;
	            delta--;
	            if (ch == $LF) {
	                line++;
	                col = 0;
	            }
	            else {
	                col++;
	            }
	        }
	        return new ParseLocation(this.file, offset, line, col);
	    };
	    // Return the source around the location
	    // Up to `maxChars` or `maxLines` on each side of the location
	    /**
	     * @param {?} maxChars
	     * @param {?} maxLines
	     * @return {?}
	     */
	    ParseLocation.prototype.getContext = /**
	     * @param {?} maxChars
	     * @param {?} maxLines
	     * @return {?}
	     */
	    function (maxChars, maxLines) {
	        var /** @type {?} */ content = this.file.content;
	        var /** @type {?} */ startOffset = this.offset;
	        if (startOffset != null) {
	            if (startOffset > content.length - 1) {
	                startOffset = content.length - 1;
	            }
	            var /** @type {?} */ endOffset = startOffset;
	            var /** @type {?} */ ctxChars = 0;
	            var /** @type {?} */ ctxLines = 0;
	            while (ctxChars < maxChars && startOffset > 0) {
	                startOffset--;
	                ctxChars++;
	                if (content[startOffset] == '\n') {
	                    if (++ctxLines == maxLines) {
	                        break;
	                    }
	                }
	            }
	            ctxChars = 0;
	            ctxLines = 0;
	            while (ctxChars < maxChars && endOffset < content.length - 1) {
	                endOffset++;
	                ctxChars++;
	                if (content[endOffset] == '\n') {
	                    if (++ctxLines == maxLines) {
	                        break;
	                    }
	                }
	            }
	            return {
	                before: content.substring(startOffset, this.offset),
	                after: content.substring(this.offset, endOffset + 1),
	            };
	        }
	        return null;
	    };
	    return ParseLocation;
	}());
	var ParseSourceFile = /** @class */ (function () {
	    function ParseSourceFile(content, url) {
	        this.content = content;
	        this.url = url;
	    }
	    return ParseSourceFile;
	}());
	var ParseSourceSpan = /** @class */ (function () {
	    function ParseSourceSpan(start, end, details) {
	        if (details === void 0) { details = null; }
	        this.start = start;
	        this.end = end;
	        this.details = details;
	    }
	    /**
	     * @return {?}
	     */
	    ParseSourceSpan.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return this.start.file.content.substring(this.start.offset, this.end.offset);
	    };
	    return ParseSourceSpan;
	}());
	/** @enum {number} */
	var ParseErrorLevel = {
	    WARNING: 0,
	    ERROR: 1,
	};
	ParseErrorLevel[ParseErrorLevel.WARNING] = "WARNING";
	ParseErrorLevel[ParseErrorLevel.ERROR] = "ERROR";
	var ParseError = /** @class */ (function () {
	    function ParseError(span, msg, level) {
	        if (level === void 0) { level = ParseErrorLevel.ERROR; }
	        this.span = span;
	        this.msg = msg;
	        this.level = level;
	    }
	    /**
	     * @return {?}
	     */
	    ParseError.prototype.contextualMessage = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ ctx = this.span.start.getContext(100, 3);
	        return ctx ? this.msg + " (\"" + ctx.before + "[" + ParseErrorLevel[this.level] + " ->]" + ctx.after + "\")" :
	            this.msg;
	    };
	    /**
	     * @return {?}
	     */
	    ParseError.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ details = this.span.details ? ", " + this.span.details : '';
	        return this.contextualMessage() + ": " + this.span.start + details;
	    };
	    return ParseError;
	}());
	/**
	 * @param {?} kind
	 * @param {?} type
	 * @return {?}
	 */
	function typeSourceSpan(kind, type) {
	    var /** @type {?} */ moduleUrl = identifierModuleUrl(type);
	    var /** @type {?} */ sourceFileName = moduleUrl != null ? "in " + kind + " " + identifierName(type) + " in " + moduleUrl :
	        "in " + kind + " " + identifierName(type);
	    var /** @type {?} */ sourceFile = new ParseSourceFile('', sourceFileName);
	    return new ParseSourceSpan(new ParseLocation(sourceFile, -1, -1, -1), new ParseLocation(sourceFile, -1, -1, -1));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var TokenType$1 = {
	    TAG_OPEN_START: 0,
	    TAG_OPEN_END: 1,
	    TAG_OPEN_END_VOID: 2,
	    TAG_CLOSE: 3,
	    TEXT: 4,
	    ESCAPABLE_RAW_TEXT: 5,
	    RAW_TEXT: 6,
	    COMMENT_START: 7,
	    COMMENT_END: 8,
	    CDATA_START: 9,
	    CDATA_END: 10,
	    ATTR_NAME: 11,
	    ATTR_VALUE: 12,
	    DOC_TYPE: 13,
	    EXPANSION_FORM_START: 14,
	    EXPANSION_CASE_VALUE: 15,
	    EXPANSION_CASE_EXP_START: 16,
	    EXPANSION_CASE_EXP_END: 17,
	    EXPANSION_FORM_END: 18,
	    EOF: 19,
	};
	TokenType$1[TokenType$1.TAG_OPEN_START] = "TAG_OPEN_START";
	TokenType$1[TokenType$1.TAG_OPEN_END] = "TAG_OPEN_END";
	TokenType$1[TokenType$1.TAG_OPEN_END_VOID] = "TAG_OPEN_END_VOID";
	TokenType$1[TokenType$1.TAG_CLOSE] = "TAG_CLOSE";
	TokenType$1[TokenType$1.TEXT] = "TEXT";
	TokenType$1[TokenType$1.ESCAPABLE_RAW_TEXT] = "ESCAPABLE_RAW_TEXT";
	TokenType$1[TokenType$1.RAW_TEXT] = "RAW_TEXT";
	TokenType$1[TokenType$1.COMMENT_START] = "COMMENT_START";
	TokenType$1[TokenType$1.COMMENT_END] = "COMMENT_END";
	TokenType$1[TokenType$1.CDATA_START] = "CDATA_START";
	TokenType$1[TokenType$1.CDATA_END] = "CDATA_END";
	TokenType$1[TokenType$1.ATTR_NAME] = "ATTR_NAME";
	TokenType$1[TokenType$1.ATTR_VALUE] = "ATTR_VALUE";
	TokenType$1[TokenType$1.DOC_TYPE] = "DOC_TYPE";
	TokenType$1[TokenType$1.EXPANSION_FORM_START] = "EXPANSION_FORM_START";
	TokenType$1[TokenType$1.EXPANSION_CASE_VALUE] = "EXPANSION_CASE_VALUE";
	TokenType$1[TokenType$1.EXPANSION_CASE_EXP_START] = "EXPANSION_CASE_EXP_START";
	TokenType$1[TokenType$1.EXPANSION_CASE_EXP_END] = "EXPANSION_CASE_EXP_END";
	TokenType$1[TokenType$1.EXPANSION_FORM_END] = "EXPANSION_FORM_END";
	TokenType$1[TokenType$1.EOF] = "EOF";
	var Token$1 = /** @class */ (function () {
	    function Token(type, parts, sourceSpan) {
	        this.type = type;
	        this.parts = parts;
	        this.sourceSpan = sourceSpan;
	    }
	    return Token;
	}());
	var TokenError = /** @class */ (function (_super) {
	    __extends(TokenError, _super);
	    function TokenError(errorMsg, tokenType, span) {
	        var _this = _super.call(this, span, errorMsg) || this;
	        _this.tokenType = tokenType;
	        return _this;
	    }
	    return TokenError;
	}(ParseError));
	var TokenizeResult = /** @class */ (function () {
	    function TokenizeResult(tokens, errors) {
	        this.tokens = tokens;
	        this.errors = errors;
	    }
	    return TokenizeResult;
	}());
	/**
	 * @param {?} source
	 * @param {?} url
	 * @param {?} getTagDefinition
	 * @param {?=} tokenizeExpansionForms
	 * @param {?=} interpolationConfig
	 * @return {?}
	 */
	function tokenize(source, url, getTagDefinition, tokenizeExpansionForms, interpolationConfig) {
	    if (tokenizeExpansionForms === void 0) { tokenizeExpansionForms = false; }
	    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	    return new _Tokenizer(new ParseSourceFile(source, url), getTagDefinition, tokenizeExpansionForms, interpolationConfig)
	        .tokenize();
	}
	var _CR_OR_CRLF_REGEXP = /\r\n?/g;
	/**
	 * @param {?} charCode
	 * @return {?}
	 */
	function _unexpectedCharacterErrorMsg(charCode) {
	    var /** @type {?} */ char = charCode === $EOF ? 'EOF' : String.fromCharCode(charCode);
	    return "Unexpected character \"" + char + "\"";
	}
	/**
	 * @param {?} entitySrc
	 * @return {?}
	 */
	function _unknownEntityErrorMsg(entitySrc) {
	    return "Unknown entity \"" + entitySrc + "\" - use the \"&#<decimal>;\" or  \"&#x<hex>;\" syntax";
	}
	var _ControlFlowError = /** @class */ (function () {
	    function _ControlFlowError(error) {
	        this.error = error;
	    }
	    return _ControlFlowError;
	}());
	var _Tokenizer = /** @class */ (function () {
	    /**
	     * @param _file The html source
	     * @param _getTagDefinition
	     * @param _tokenizeIcu Whether to tokenize ICU messages (considered as text nodes when false)
	     * @param _interpolationConfig
	     */
	    function _Tokenizer(_file, _getTagDefinition, _tokenizeIcu, _interpolationConfig) {
	        if (_interpolationConfig === void 0) { _interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        this._file = _file;
	        this._getTagDefinition = _getTagDefinition;
	        this._tokenizeIcu = _tokenizeIcu;
	        this._interpolationConfig = _interpolationConfig;
	        this._peek = -1;
	        this._nextPeek = -1;
	        this._index = -1;
	        this._line = 0;
	        this._column = -1;
	        this._expansionCaseStack = [];
	        this._inInterpolation = false;
	        this.tokens = [];
	        this.errors = [];
	        this._input = _file.content;
	        this._length = _file.content.length;
	        this._advance();
	    }
	    /**
	     * @param {?} content
	     * @return {?}
	     */
	    _Tokenizer.prototype._processCarriageReturns = /**
	     * @param {?} content
	     * @return {?}
	     */
	    function (content) {
	        // http://www.w3.org/TR/html5/syntax.html#preprocessing-the-input-stream
	        // In order to keep the original position in the source, we can not
	        // pre-process it.
	        // Instead CRs are processed right before instantiating the tokens.
	        return content.replace(_CR_OR_CRLF_REGEXP, '\n');
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype.tokenize = /**
	     * @return {?}
	     */
	    function () {
	        while (this._peek !== $EOF) {
	            var /** @type {?} */ start = this._getLocation();
	            try {
	                if (this._attemptCharCode($LT)) {
	                    if (this._attemptCharCode($BANG)) {
	                        if (this._attemptCharCode($LBRACKET)) {
	                            this._consumeCdata(start);
	                        }
	                        else if (this._attemptCharCode($MINUS)) {
	                            this._consumeComment(start);
	                        }
	                        else {
	                            this._consumeDocType(start);
	                        }
	                    }
	                    else if (this._attemptCharCode($SLASH)) {
	                        this._consumeTagClose(start);
	                    }
	                    else {
	                        this._consumeTagOpen(start);
	                    }
	                }
	                else if (!(this._tokenizeIcu && this._tokenizeExpansionForm())) {
	                    this._consumeText();
	                }
	            }
	            catch (/** @type {?} */ e) {
	                if (e instanceof _ControlFlowError) {
	                    this.errors.push(e.error);
	                }
	                else {
	                    throw e;
	                }
	            }
	        }
	        this._beginToken(TokenType$1.EOF);
	        this._endToken([]);
	        return new TokenizeResult(mergeTextTokens(this.tokens), this.errors);
	    };
	    /**
	     * \@internal
	     * @return {?} whether an ICU token has been created
	     */
	    _Tokenizer.prototype._tokenizeExpansionForm = /**
	     * \@internal
	     * @return {?} whether an ICU token has been created
	     */
	    function () {
	        if (isExpansionFormStart(this._input, this._index, this._interpolationConfig)) {
	            this._consumeExpansionFormStart();
	            return true;
	        }
	        if (isExpansionCaseStart(this._peek) && this._isInExpansionForm()) {
	            this._consumeExpansionCaseStart();
	            return true;
	        }
	        if (this._peek === $RBRACE) {
	            if (this._isInExpansionCase()) {
	                this._consumeExpansionCaseEnd();
	                return true;
	            }
	            if (this._isInExpansionForm()) {
	                this._consumeExpansionFormEnd();
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._getLocation = /**
	     * @return {?}
	     */
	    function () {
	        return new ParseLocation(this._file, this._index, this._line, this._column);
	    };
	    /**
	     * @param {?=} start
	     * @param {?=} end
	     * @return {?}
	     */
	    _Tokenizer.prototype._getSpan = /**
	     * @param {?=} start
	     * @param {?=} end
	     * @return {?}
	     */
	    function (start, end) {
	        if (start === void 0) { start = this._getLocation(); }
	        if (end === void 0) { end = this._getLocation(); }
	        return new ParseSourceSpan(start, end);
	    };
	    /**
	     * @param {?} type
	     * @param {?=} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._beginToken = /**
	     * @param {?} type
	     * @param {?=} start
	     * @return {?}
	     */
	    function (type, start) {
	        if (start === void 0) { start = this._getLocation(); }
	        this._currentTokenStart = start;
	        this._currentTokenType = type;
	    };
	    /**
	     * @param {?} parts
	     * @param {?=} end
	     * @return {?}
	     */
	    _Tokenizer.prototype._endToken = /**
	     * @param {?} parts
	     * @param {?=} end
	     * @return {?}
	     */
	    function (parts, end) {
	        if (end === void 0) { end = this._getLocation(); }
	        var /** @type {?} */ token = new Token$1(this._currentTokenType, parts, new ParseSourceSpan(this._currentTokenStart, end));
	        this.tokens.push(token);
	        this._currentTokenStart = /** @type {?} */ ((null));
	        this._currentTokenType = /** @type {?} */ ((null));
	        return token;
	    };
	    /**
	     * @param {?} msg
	     * @param {?} span
	     * @return {?}
	     */
	    _Tokenizer.prototype._createError = /**
	     * @param {?} msg
	     * @param {?} span
	     * @return {?}
	     */
	    function (msg, span) {
	        if (this._isInExpansionForm()) {
	            msg += " (Do you have an unescaped \"{\" in your template? Use \"{{ '{' }}\") to escape it.)";
	        }
	        var /** @type {?} */ error = new TokenError(msg, this._currentTokenType, span);
	        this._currentTokenStart = /** @type {?} */ ((null));
	        this._currentTokenType = /** @type {?} */ ((null));
	        return new _ControlFlowError(error);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._advance = /**
	     * @return {?}
	     */
	    function () {
	        if (this._index >= this._length) {
	            throw this._createError(_unexpectedCharacterErrorMsg($EOF), this._getSpan());
	        }
	        if (this._peek === $LF) {
	            this._line++;
	            this._column = 0;
	        }
	        else if (this._peek !== $LF && this._peek !== $CR) {
	            this._column++;
	        }
	        this._index++;
	        this._peek = this._index >= this._length ? $EOF : this._input.charCodeAt(this._index);
	        this._nextPeek =
	            this._index + 1 >= this._length ? $EOF : this._input.charCodeAt(this._index + 1);
	    };
	    /**
	     * @param {?} charCode
	     * @return {?}
	     */
	    _Tokenizer.prototype._attemptCharCode = /**
	     * @param {?} charCode
	     * @return {?}
	     */
	    function (charCode) {
	        if (this._peek === charCode) {
	            this._advance();
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @param {?} charCode
	     * @return {?}
	     */
	    _Tokenizer.prototype._attemptCharCodeCaseInsensitive = /**
	     * @param {?} charCode
	     * @return {?}
	     */
	    function (charCode) {
	        if (compareCharCodeCaseInsensitive(this._peek, charCode)) {
	            this._advance();
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @param {?} charCode
	     * @return {?}
	     */
	    _Tokenizer.prototype._requireCharCode = /**
	     * @param {?} charCode
	     * @return {?}
	     */
	    function (charCode) {
	        var /** @type {?} */ location = this._getLocation();
	        if (!this._attemptCharCode(charCode)) {
	            throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan(location, location));
	        }
	    };
	    /**
	     * @param {?} chars
	     * @return {?}
	     */
	    _Tokenizer.prototype._attemptStr = /**
	     * @param {?} chars
	     * @return {?}
	     */
	    function (chars) {
	        var /** @type {?} */ len = chars.length;
	        if (this._index + len > this._length) {
	            return false;
	        }
	        var /** @type {?} */ initialPosition = this._savePosition();
	        for (var /** @type {?} */ i = 0; i < len; i++) {
	            if (!this._attemptCharCode(chars.charCodeAt(i))) {
	                // If attempting to parse the string fails, we want to reset the parser
	                // to where it was before the attempt
	                this._restorePosition(initialPosition);
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * @param {?} chars
	     * @return {?}
	     */
	    _Tokenizer.prototype._attemptStrCaseInsensitive = /**
	     * @param {?} chars
	     * @return {?}
	     */
	    function (chars) {
	        for (var /** @type {?} */ i = 0; i < chars.length; i++) {
	            if (!this._attemptCharCodeCaseInsensitive(chars.charCodeAt(i))) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * @param {?} chars
	     * @return {?}
	     */
	    _Tokenizer.prototype._requireStr = /**
	     * @param {?} chars
	     * @return {?}
	     */
	    function (chars) {
	        var /** @type {?} */ location = this._getLocation();
	        if (!this._attemptStr(chars)) {
	            throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan(location));
	        }
	    };
	    /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    _Tokenizer.prototype._attemptCharCodeUntilFn = /**
	     * @param {?} predicate
	     * @return {?}
	     */
	    function (predicate) {
	        while (!predicate(this._peek)) {
	            this._advance();
	        }
	    };
	    /**
	     * @param {?} predicate
	     * @param {?} len
	     * @return {?}
	     */
	    _Tokenizer.prototype._requireCharCodeUntilFn = /**
	     * @param {?} predicate
	     * @param {?} len
	     * @return {?}
	     */
	    function (predicate, len) {
	        var /** @type {?} */ start = this._getLocation();
	        this._attemptCharCodeUntilFn(predicate);
	        if (this._index - start.offset < len) {
	            throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan(start, start));
	        }
	    };
	    /**
	     * @param {?} char
	     * @return {?}
	     */
	    _Tokenizer.prototype._attemptUntilChar = /**
	     * @param {?} char
	     * @return {?}
	     */
	    function (char) {
	        while (this._peek !== char) {
	            this._advance();
	        }
	    };
	    /**
	     * @param {?} decodeEntities
	     * @return {?}
	     */
	    _Tokenizer.prototype._readChar = /**
	     * @param {?} decodeEntities
	     * @return {?}
	     */
	    function (decodeEntities) {
	        if (decodeEntities && this._peek === $AMPERSAND) {
	            return this._decodeEntity();
	        }
	        else {
	            var /** @type {?} */ index = this._index;
	            this._advance();
	            return this._input[index];
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._decodeEntity = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ start = this._getLocation();
	        this._advance();
	        if (this._attemptCharCode($HASH)) {
	            var /** @type {?} */ isHex = this._attemptCharCode($x) || this._attemptCharCode($X);
	            var /** @type {?} */ numberStart = this._getLocation().offset;
	            this._attemptCharCodeUntilFn(isDigitEntityEnd);
	            if (this._peek != $SEMICOLON) {
	                throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan());
	            }
	            this._advance();
	            var /** @type {?} */ strNum = this._input.substring(numberStart, this._index - 1);
	            try {
	                var /** @type {?} */ charCode = parseInt(strNum, isHex ? 16 : 10);
	                return String.fromCharCode(charCode);
	            }
	            catch (/** @type {?} */ e) {
	                var /** @type {?} */ entity = this._input.substring(start.offset + 1, this._index - 1);
	                throw this._createError(_unknownEntityErrorMsg(entity), this._getSpan(start));
	            }
	        }
	        else {
	            var /** @type {?} */ startPosition = this._savePosition();
	            this._attemptCharCodeUntilFn(isNamedEntityEnd);
	            if (this._peek != $SEMICOLON) {
	                this._restorePosition(startPosition);
	                return '&';
	            }
	            this._advance();
	            var /** @type {?} */ name_1 = this._input.substring(start.offset + 1, this._index - 1);
	            var /** @type {?} */ char = NAMED_ENTITIES[name_1];
	            if (!char) {
	                throw this._createError(_unknownEntityErrorMsg(name_1), this._getSpan(start));
	            }
	            return char;
	        }
	    };
	    /**
	     * @param {?} decodeEntities
	     * @param {?} firstCharOfEnd
	     * @param {?} attemptEndRest
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeRawText = /**
	     * @param {?} decodeEntities
	     * @param {?} firstCharOfEnd
	     * @param {?} attemptEndRest
	     * @return {?}
	     */
	    function (decodeEntities, firstCharOfEnd, attemptEndRest) {
	        var /** @type {?} */ tagCloseStart;
	        var /** @type {?} */ textStart = this._getLocation();
	        this._beginToken(decodeEntities ? TokenType$1.ESCAPABLE_RAW_TEXT : TokenType$1.RAW_TEXT, textStart);
	        var /** @type {?} */ parts = [];
	        while (true) {
	            tagCloseStart = this._getLocation();
	            if (this._attemptCharCode(firstCharOfEnd) && attemptEndRest()) {
	                break;
	            }
	            if (this._index > tagCloseStart.offset) {
	                // add the characters consumed by the previous if statement to the output
	                parts.push(this._input.substring(tagCloseStart.offset, this._index));
	            }
	            while (this._peek !== firstCharOfEnd) {
	                parts.push(this._readChar(decodeEntities));
	            }
	        }
	        return this._endToken([this._processCarriageReturns(parts.join(''))], tagCloseStart);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeComment = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        var _this = this;
	        this._beginToken(TokenType$1.COMMENT_START, start);
	        this._requireCharCode($MINUS);
	        this._endToken([]);
	        var /** @type {?} */ textToken = this._consumeRawText(false, $MINUS, function () { return _this._attemptStr('->'); });
	        this._beginToken(TokenType$1.COMMENT_END, textToken.sourceSpan.end);
	        this._endToken([]);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeCdata = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        var _this = this;
	        this._beginToken(TokenType$1.CDATA_START, start);
	        this._requireStr('CDATA[');
	        this._endToken([]);
	        var /** @type {?} */ textToken = this._consumeRawText(false, $RBRACKET, function () { return _this._attemptStr(']>'); });
	        this._beginToken(TokenType$1.CDATA_END, textToken.sourceSpan.end);
	        this._endToken([]);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeDocType = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        this._beginToken(TokenType$1.DOC_TYPE, start);
	        this._attemptUntilChar($GT);
	        this._advance();
	        this._endToken([this._input.substring(start.offset + 2, this._index - 1)]);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumePrefixAndName = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ nameOrPrefixStart = this._index;
	        var /** @type {?} */ prefix = /** @type {?} */ ((null));
	        while (this._peek !== $COLON && !isPrefixEnd(this._peek)) {
	            this._advance();
	        }
	        var /** @type {?} */ nameStart;
	        if (this._peek === $COLON) {
	            this._advance();
	            prefix = this._input.substring(nameOrPrefixStart, this._index - 1);
	            nameStart = this._index;
	        }
	        else {
	            nameStart = nameOrPrefixStart;
	        }
	        this._requireCharCodeUntilFn(isNameEnd, this._index === nameStart ? 1 : 0);
	        var /** @type {?} */ name = this._input.substring(nameStart, this._index);
	        return [prefix, name];
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeTagOpen = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        var /** @type {?} */ savedPos = this._savePosition();
	        var /** @type {?} */ tagName;
	        var /** @type {?} */ lowercaseTagName;
	        try {
	            if (!isAsciiLetter(this._peek)) {
	                throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan());
	            }
	            var /** @type {?} */ nameStart = this._index;
	            this._consumeTagOpenStart(start);
	            tagName = this._input.substring(nameStart, this._index);
	            lowercaseTagName = tagName.toLowerCase();
	            this._attemptCharCodeUntilFn(isNotWhitespace);
	            while (this._peek !== $SLASH && this._peek !== $GT) {
	                this._consumeAttributeName();
	                this._attemptCharCodeUntilFn(isNotWhitespace);
	                if (this._attemptCharCode($EQ)) {
	                    this._attemptCharCodeUntilFn(isNotWhitespace);
	                    this._consumeAttributeValue();
	                }
	                this._attemptCharCodeUntilFn(isNotWhitespace);
	            }
	            this._consumeTagOpenEnd();
	        }
	        catch (/** @type {?} */ e) {
	            if (e instanceof _ControlFlowError) {
	                // When the start tag is invalid, assume we want a "<"
	                this._restorePosition(savedPos);
	                // Back to back text tokens are merged at the end
	                this._beginToken(TokenType$1.TEXT, start);
	                this._endToken(['<']);
	                return;
	            }
	            throw e;
	        }
	        var /** @type {?} */ contentTokenType = this._getTagDefinition(tagName).contentType;
	        if (contentTokenType === TagContentType.RAW_TEXT) {
	            this._consumeRawTextWithTagClose(lowercaseTagName, false);
	        }
	        else if (contentTokenType === TagContentType.ESCAPABLE_RAW_TEXT) {
	            this._consumeRawTextWithTagClose(lowercaseTagName, true);
	        }
	    };
	    /**
	     * @param {?} lowercaseTagName
	     * @param {?} decodeEntities
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeRawTextWithTagClose = /**
	     * @param {?} lowercaseTagName
	     * @param {?} decodeEntities
	     * @return {?}
	     */
	    function (lowercaseTagName, decodeEntities) {
	        var _this = this;
	        var /** @type {?} */ textToken = this._consumeRawText(decodeEntities, $LT, function () {
	            if (!_this._attemptCharCode($SLASH))
	                return false;
	            _this._attemptCharCodeUntilFn(isNotWhitespace);
	            if (!_this._attemptStrCaseInsensitive(lowercaseTagName))
	                return false;
	            _this._attemptCharCodeUntilFn(isNotWhitespace);
	            return _this._attemptCharCode($GT);
	        });
	        this._beginToken(TokenType$1.TAG_CLOSE, textToken.sourceSpan.end);
	        this._endToken([/** @type {?} */ ((null)), lowercaseTagName]);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeTagOpenStart = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        this._beginToken(TokenType$1.TAG_OPEN_START, start);
	        var /** @type {?} */ parts = this._consumePrefixAndName();
	        this._endToken(parts);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeAttributeName = /**
	     * @return {?}
	     */
	    function () {
	        this._beginToken(TokenType$1.ATTR_NAME);
	        var /** @type {?} */ prefixAndName = this._consumePrefixAndName();
	        this._endToken(prefixAndName);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeAttributeValue = /**
	     * @return {?}
	     */
	    function () {
	        this._beginToken(TokenType$1.ATTR_VALUE);
	        var /** @type {?} */ value;
	        if (this._peek === $SQ || this._peek === $DQ) {
	            var /** @type {?} */ quoteChar = this._peek;
	            this._advance();
	            var /** @type {?} */ parts = [];
	            while (this._peek !== quoteChar) {
	                parts.push(this._readChar(true));
	            }
	            value = parts.join('');
	            this._advance();
	        }
	        else {
	            var /** @type {?} */ valueStart = this._index;
	            this._requireCharCodeUntilFn(isNameEnd, 1);
	            value = this._input.substring(valueStart, this._index);
	        }
	        this._endToken([this._processCarriageReturns(value)]);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeTagOpenEnd = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ tokenType = this._attemptCharCode($SLASH) ? TokenType$1.TAG_OPEN_END_VOID : TokenType$1.TAG_OPEN_END;
	        this._beginToken(tokenType);
	        this._requireCharCode($GT);
	        this._endToken([]);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeTagClose = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        this._beginToken(TokenType$1.TAG_CLOSE, start);
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	        var /** @type {?} */ prefixAndName = this._consumePrefixAndName();
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	        this._requireCharCode($GT);
	        this._endToken(prefixAndName);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeExpansionFormStart = /**
	     * @return {?}
	     */
	    function () {
	        this._beginToken(TokenType$1.EXPANSION_FORM_START, this._getLocation());
	        this._requireCharCode($LBRACE);
	        this._endToken([]);
	        this._expansionCaseStack.push(TokenType$1.EXPANSION_FORM_START);
	        this._beginToken(TokenType$1.RAW_TEXT, this._getLocation());
	        var /** @type {?} */ condition = this._readUntil($COMMA);
	        this._endToken([condition], this._getLocation());
	        this._requireCharCode($COMMA);
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	        this._beginToken(TokenType$1.RAW_TEXT, this._getLocation());
	        var /** @type {?} */ type = this._readUntil($COMMA);
	        this._endToken([type], this._getLocation());
	        this._requireCharCode($COMMA);
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeExpansionCaseStart = /**
	     * @return {?}
	     */
	    function () {
	        this._beginToken(TokenType$1.EXPANSION_CASE_VALUE, this._getLocation());
	        var /** @type {?} */ value = this._readUntil($LBRACE).trim();
	        this._endToken([value], this._getLocation());
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	        this._beginToken(TokenType$1.EXPANSION_CASE_EXP_START, this._getLocation());
	        this._requireCharCode($LBRACE);
	        this._endToken([], this._getLocation());
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	        this._expansionCaseStack.push(TokenType$1.EXPANSION_CASE_EXP_START);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeExpansionCaseEnd = /**
	     * @return {?}
	     */
	    function () {
	        this._beginToken(TokenType$1.EXPANSION_CASE_EXP_END, this._getLocation());
	        this._requireCharCode($RBRACE);
	        this._endToken([], this._getLocation());
	        this._attemptCharCodeUntilFn(isNotWhitespace);
	        this._expansionCaseStack.pop();
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeExpansionFormEnd = /**
	     * @return {?}
	     */
	    function () {
	        this._beginToken(TokenType$1.EXPANSION_FORM_END, this._getLocation());
	        this._requireCharCode($RBRACE);
	        this._endToken([]);
	        this._expansionCaseStack.pop();
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._consumeText = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ start = this._getLocation();
	        this._beginToken(TokenType$1.TEXT, start);
	        var /** @type {?} */ parts = [];
	        do {
	            if (this._interpolationConfig && this._attemptStr(this._interpolationConfig.start)) {
	                parts.push(this._interpolationConfig.start);
	                this._inInterpolation = true;
	            }
	            else if (this._interpolationConfig && this._inInterpolation &&
	                this._attemptStr(this._interpolationConfig.end)) {
	                parts.push(this._interpolationConfig.end);
	                this._inInterpolation = false;
	            }
	            else {
	                parts.push(this._readChar(true));
	            }
	        } while (!this._isTextEnd());
	        this._endToken([this._processCarriageReturns(parts.join(''))]);
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._isTextEnd = /**
	     * @return {?}
	     */
	    function () {
	        if (this._peek === $LT || this._peek === $EOF) {
	            return true;
	        }
	        if (this._tokenizeIcu && !this._inInterpolation) {
	            if (isExpansionFormStart(this._input, this._index, this._interpolationConfig)) {
	                // start of an expansion form
	                return true;
	            }
	            if (this._peek === $RBRACE && this._isInExpansionCase()) {
	                // end of and expansion case
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._savePosition = /**
	     * @return {?}
	     */
	    function () {
	        return [this._peek, this._index, this._column, this._line, this.tokens.length];
	    };
	    /**
	     * @param {?} char
	     * @return {?}
	     */
	    _Tokenizer.prototype._readUntil = /**
	     * @param {?} char
	     * @return {?}
	     */
	    function (char) {
	        var /** @type {?} */ start = this._index;
	        this._attemptUntilChar(char);
	        return this._input.substring(start, this._index);
	    };
	    /**
	     * @param {?} position
	     * @return {?}
	     */
	    _Tokenizer.prototype._restorePosition = /**
	     * @param {?} position
	     * @return {?}
	     */
	    function (position) {
	        this._peek = position[0];
	        this._index = position[1];
	        this._column = position[2];
	        this._line = position[3];
	        var /** @type {?} */ nbTokens = position[4];
	        if (nbTokens < this.tokens.length) {
	            // remove any extra tokens
	            this.tokens = this.tokens.slice(0, nbTokens);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._isInExpansionCase = /**
	     * @return {?}
	     */
	    function () {
	        return this._expansionCaseStack.length > 0 &&
	            this._expansionCaseStack[this._expansionCaseStack.length - 1] ===
	                TokenType$1.EXPANSION_CASE_EXP_START;
	    };
	    /**
	     * @return {?}
	     */
	    _Tokenizer.prototype._isInExpansionForm = /**
	     * @return {?}
	     */
	    function () {
	        return this._expansionCaseStack.length > 0 &&
	            this._expansionCaseStack[this._expansionCaseStack.length - 1] ===
	                TokenType$1.EXPANSION_FORM_START;
	    };
	    return _Tokenizer;
	}());
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isNotWhitespace(code) {
	    return !isWhitespace(code) || code === $EOF;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isNameEnd(code) {
	    return isWhitespace(code) || code === $GT || code === $SLASH ||
	        code === $SQ || code === $DQ || code === $EQ;
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isPrefixEnd(code) {
	    return (code < $a || $z < code) && (code < $A || $Z < code) &&
	        (code < $0 || code > $9);
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isDigitEntityEnd(code) {
	    return code == $SEMICOLON || code == $EOF || !isAsciiHexDigit(code);
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function isNamedEntityEnd(code) {
	    return code == $SEMICOLON || code == $EOF || !isAsciiLetter(code);
	}
	/**
	 * @param {?} input
	 * @param {?} offset
	 * @param {?} interpolationConfig
	 * @return {?}
	 */
	function isExpansionFormStart(input, offset, interpolationConfig) {
	    var /** @type {?} */ isInterpolationStart = interpolationConfig ? input.indexOf(interpolationConfig.start, offset) == offset : false;
	    return input.charCodeAt(offset) == $LBRACE && !isInterpolationStart;
	}
	/**
	 * @param {?} peek
	 * @return {?}
	 */
	function isExpansionCaseStart(peek) {
	    return peek === $EQ || isAsciiLetter(peek) || isDigit(peek);
	}
	/**
	 * @param {?} code1
	 * @param {?} code2
	 * @return {?}
	 */
	function compareCharCodeCaseInsensitive(code1, code2) {
	    return toUpperCaseCharCode(code1) == toUpperCaseCharCode(code2);
	}
	/**
	 * @param {?} code
	 * @return {?}
	 */
	function toUpperCaseCharCode(code) {
	    return code >= $a && code <= $z ? code - $a + $A : code;
	}
	/**
	 * @param {?} srcTokens
	 * @return {?}
	 */
	function mergeTextTokens(srcTokens) {
	    var /** @type {?} */ dstTokens = [];
	    var /** @type {?} */ lastDstToken = undefined;
	    for (var /** @type {?} */ i = 0; i < srcTokens.length; i++) {
	        var /** @type {?} */ token = srcTokens[i];
	        if (lastDstToken && lastDstToken.type == TokenType$1.TEXT && token.type == TokenType$1.TEXT) {
	            lastDstToken.parts[0] += token.parts[0];
	            lastDstToken.sourceSpan.end = token.sourceSpan.end;
	        }
	        else {
	            lastDstToken = token;
	            dstTokens.push(lastDstToken);
	        }
	    }
	    return dstTokens;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var TreeError = /** @class */ (function (_super) {
	    __extends(TreeError, _super);
	    function TreeError(elementName, span, msg) {
	        var _this = _super.call(this, span, msg) || this;
	        _this.elementName = elementName;
	        return _this;
	    }
	    /**
	     * @param {?} elementName
	     * @param {?} span
	     * @param {?} msg
	     * @return {?}
	     */
	    TreeError.create = /**
	     * @param {?} elementName
	     * @param {?} span
	     * @param {?} msg
	     * @return {?}
	     */
	    function (elementName, span, msg) {
	        return new TreeError(elementName, span, msg);
	    };
	    return TreeError;
	}(ParseError));
	var ParseTreeResult = /** @class */ (function () {
	    function ParseTreeResult(rootNodes, errors) {
	        this.rootNodes = rootNodes;
	        this.errors = errors;
	    }
	    return ParseTreeResult;
	}());
	var Parser$1 = /** @class */ (function () {
	    function Parser(getTagDefinition) {
	        this.getTagDefinition = getTagDefinition;
	    }
	    /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    Parser.prototype.parse = /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (source, url, parseExpansionForms, interpolationConfig) {
	        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        var /** @type {?} */ tokensAndErrors = tokenize(source, url, this.getTagDefinition, parseExpansionForms, interpolationConfig);
	        var /** @type {?} */ treeAndErrors = new _TreeBuilder(tokensAndErrors.tokens, this.getTagDefinition).build();
	        return new ParseTreeResult(treeAndErrors.rootNodes, (/** @type {?} */ (tokensAndErrors.errors)).concat(treeAndErrors.errors));
	    };
	    return Parser;
	}());
	var _TreeBuilder = /** @class */ (function () {
	    function _TreeBuilder(tokens, getTagDefinition) {
	        this.tokens = tokens;
	        this.getTagDefinition = getTagDefinition;
	        this._index = -1;
	        this._rootNodes = [];
	        this._errors = [];
	        this._elementStack = [];
	        this._advance();
	    }
	    /**
	     * @return {?}
	     */
	    _TreeBuilder.prototype.build = /**
	     * @return {?}
	     */
	    function () {
	        while (this._peek.type !== TokenType$1.EOF) {
	            if (this._peek.type === TokenType$1.TAG_OPEN_START) {
	                this._consumeStartTag(this._advance());
	            }
	            else if (this._peek.type === TokenType$1.TAG_CLOSE) {
	                this._consumeEndTag(this._advance());
	            }
	            else if (this._peek.type === TokenType$1.CDATA_START) {
	                this._closeVoidElement();
	                this._consumeCdata(this._advance());
	            }
	            else if (this._peek.type === TokenType$1.COMMENT_START) {
	                this._closeVoidElement();
	                this._consumeComment(this._advance());
	            }
	            else if (this._peek.type === TokenType$1.TEXT || this._peek.type === TokenType$1.RAW_TEXT ||
	                this._peek.type === TokenType$1.ESCAPABLE_RAW_TEXT) {
	                this._closeVoidElement();
	                this._consumeText(this._advance());
	            }
	            else if (this._peek.type === TokenType$1.EXPANSION_FORM_START) {
	                this._consumeExpansion(this._advance());
	            }
	            else {
	                // Skip all other tokens...
	                this._advance();
	            }
	        }
	        return new ParseTreeResult(this._rootNodes, this._errors);
	    };
	    /**
	     * @return {?}
	     */
	    _TreeBuilder.prototype._advance = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ prev = this._peek;
	        if (this._index < this.tokens.length - 1) {
	            // Note: there is always an EOF token at the end
	            this._index++;
	        }
	        this._peek = this.tokens[this._index];
	        return prev;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    _TreeBuilder.prototype._advanceIf = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        if (this._peek.type === type) {
	            return this._advance();
	        }
	        return null;
	    };
	    /**
	     * @param {?} startToken
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeCdata = /**
	     * @param {?} startToken
	     * @return {?}
	     */
	    function (startToken) {
	        this._consumeText(this._advance());
	        this._advanceIf(TokenType$1.CDATA_END);
	    };
	    /**
	     * @param {?} token
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeComment = /**
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        var /** @type {?} */ text = this._advanceIf(TokenType$1.RAW_TEXT);
	        this._advanceIf(TokenType$1.COMMENT_END);
	        var /** @type {?} */ value = text != null ? text.parts[0].trim() : null;
	        this._addToParent(new Comment(value, token.sourceSpan));
	    };
	    /**
	     * @param {?} token
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeExpansion = /**
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        var /** @type {?} */ switchValue = this._advance();
	        var /** @type {?} */ type = this._advance();
	        var /** @type {?} */ cases = [];
	        // read =
	        while (this._peek.type === TokenType$1.EXPANSION_CASE_VALUE) {
	            var /** @type {?} */ expCase = this._parseExpansionCase();
	            if (!expCase)
	                return; // error
	            cases.push(expCase);
	        }
	        // read the final }
	        if (this._peek.type !== TokenType$1.EXPANSION_FORM_END) {
	            this._errors.push(TreeError.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
	            return;
	        }
	        var /** @type {?} */ sourceSpan = new ParseSourceSpan(token.sourceSpan.start, this._peek.sourceSpan.end);
	        this._addToParent(new Expansion(switchValue.parts[0], type.parts[0], cases, sourceSpan, switchValue.sourceSpan));
	        this._advance();
	    };
	    /**
	     * @return {?}
	     */
	    _TreeBuilder.prototype._parseExpansionCase = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ value = this._advance();
	        // read {
	        if (this._peek.type !== TokenType$1.EXPANSION_CASE_EXP_START) {
	            this._errors.push(TreeError.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'."));
	            return null;
	        }
	        // read until }
	        var /** @type {?} */ start = this._advance();
	        var /** @type {?} */ exp = this._collectExpansionExpTokens(start);
	        if (!exp)
	            return null;
	        var /** @type {?} */ end = this._advance();
	        exp.push(new Token$1(TokenType$1.EOF, [], end.sourceSpan));
	        // parse everything in between { and }
	        var /** @type {?} */ parsedExp = new _TreeBuilder(exp, this.getTagDefinition).build();
	        if (parsedExp.errors.length > 0) {
	            this._errors = this._errors.concat(/** @type {?} */ (parsedExp.errors));
	            return null;
	        }
	        var /** @type {?} */ sourceSpan = new ParseSourceSpan(value.sourceSpan.start, end.sourceSpan.end);
	        var /** @type {?} */ expSourceSpan = new ParseSourceSpan(start.sourceSpan.start, end.sourceSpan.end);
	        return new ExpansionCase(value.parts[0], parsedExp.rootNodes, sourceSpan, value.sourceSpan, expSourceSpan);
	    };
	    /**
	     * @param {?} start
	     * @return {?}
	     */
	    _TreeBuilder.prototype._collectExpansionExpTokens = /**
	     * @param {?} start
	     * @return {?}
	     */
	    function (start) {
	        var /** @type {?} */ exp = [];
	        var /** @type {?} */ expansionFormStack = [TokenType$1.EXPANSION_CASE_EXP_START];
	        while (true) {
	            if (this._peek.type === TokenType$1.EXPANSION_FORM_START ||
	                this._peek.type === TokenType$1.EXPANSION_CASE_EXP_START) {
	                expansionFormStack.push(this._peek.type);
	            }
	            if (this._peek.type === TokenType$1.EXPANSION_CASE_EXP_END) {
	                if (lastOnStack(expansionFormStack, TokenType$1.EXPANSION_CASE_EXP_START)) {
	                    expansionFormStack.pop();
	                    if (expansionFormStack.length == 0)
	                        return exp;
	                }
	                else {
	                    this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
	                    return null;
	                }
	            }
	            if (this._peek.type === TokenType$1.EXPANSION_FORM_END) {
	                if (lastOnStack(expansionFormStack, TokenType$1.EXPANSION_FORM_START)) {
	                    expansionFormStack.pop();
	                }
	                else {
	                    this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
	                    return null;
	                }
	            }
	            if (this._peek.type === TokenType$1.EOF) {
	                this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
	                return null;
	            }
	            exp.push(this._advance());
	        }
	    };
	    /**
	     * @param {?} token
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeText = /**
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        var /** @type {?} */ text = token.parts[0];
	        if (text.length > 0 && text[0] == '\n') {
	            var /** @type {?} */ parent_1 = this._getParentElement();
	            if (parent_1 != null && parent_1.children.length == 0 &&
	                this.getTagDefinition(parent_1.name).ignoreFirstLf) {
	                text = text.substring(1);
	            }
	        }
	        if (text.length > 0) {
	            this._addToParent(new Text(text, token.sourceSpan));
	        }
	    };
	    /**
	     * @return {?}
	     */
	    _TreeBuilder.prototype._closeVoidElement = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ el = this._getParentElement();
	        if (el && this.getTagDefinition(el.name).isVoid) {
	            this._elementStack.pop();
	        }
	    };
	    /**
	     * @param {?} startTagToken
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeStartTag = /**
	     * @param {?} startTagToken
	     * @return {?}
	     */
	    function (startTagToken) {
	        var /** @type {?} */ prefix = startTagToken.parts[0];
	        var /** @type {?} */ name = startTagToken.parts[1];
	        var /** @type {?} */ attrs = [];
	        while (this._peek.type === TokenType$1.ATTR_NAME) {
	            attrs.push(this._consumeAttr(this._advance()));
	        }
	        var /** @type {?} */ fullName = this._getElementFullName(prefix, name, this._getParentElement());
	        var /** @type {?} */ selfClosing = false;
	        // Note: There could have been a tokenizer error
	        // so that we don't get a token for the end tag...
	        if (this._peek.type === TokenType$1.TAG_OPEN_END_VOID) {
	            this._advance();
	            selfClosing = true;
	            var /** @type {?} */ tagDef = this.getTagDefinition(fullName);
	            if (!(tagDef.canSelfClose || getNsPrefix(fullName) !== null || tagDef.isVoid)) {
	                this._errors.push(TreeError.create(fullName, startTagToken.sourceSpan, "Only void and foreign elements can be self closed \"" + startTagToken.parts[1] + "\""));
	            }
	        }
	        else if (this._peek.type === TokenType$1.TAG_OPEN_END) {
	            this._advance();
	            selfClosing = false;
	        }
	        var /** @type {?} */ end = this._peek.sourceSpan.start;
	        var /** @type {?} */ span = new ParseSourceSpan(startTagToken.sourceSpan.start, end);
	        var /** @type {?} */ el = new Element(fullName, attrs, [], span, span, undefined);
	        this._pushElement(el);
	        if (selfClosing) {
	            this._popElement(fullName);
	            el.endSourceSpan = span;
	        }
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    _TreeBuilder.prototype._pushElement = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        var /** @type {?} */ parentEl = this._getParentElement();
	        if (parentEl && this.getTagDefinition(parentEl.name).isClosedByChild(el.name)) {
	            this._elementStack.pop();
	        }
	        var /** @type {?} */ tagDef = this.getTagDefinition(el.name);
	        var _a = this._getParentElementSkippingContainers(), parent = _a.parent, container = _a.container;
	        if (parent && tagDef.requireExtraParent(parent.name)) {
	            var /** @type {?} */ newParent = new Element(tagDef.parentToAdd, [], [], el.sourceSpan, el.startSourceSpan, el.endSourceSpan);
	            this._insertBeforeContainer(parent, container, newParent);
	        }
	        this._addToParent(el);
	        this._elementStack.push(el);
	    };
	    /**
	     * @param {?} endTagToken
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeEndTag = /**
	     * @param {?} endTagToken
	     * @return {?}
	     */
	    function (endTagToken) {
	        var /** @type {?} */ fullName = this._getElementFullName(endTagToken.parts[0], endTagToken.parts[1], this._getParentElement());
	        if (this._getParentElement()) {
	            /** @type {?} */ ((this._getParentElement())).endSourceSpan = endTagToken.sourceSpan;
	        }
	        if (this.getTagDefinition(fullName).isVoid) {
	            this._errors.push(TreeError.create(fullName, endTagToken.sourceSpan, "Void elements do not have end tags \"" + endTagToken.parts[1] + "\""));
	        }
	        else if (!this._popElement(fullName)) {
	            var /** @type {?} */ errMsg = "Unexpected closing tag \"" + fullName + "\". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags";
	            this._errors.push(TreeError.create(fullName, endTagToken.sourceSpan, errMsg));
	        }
	    };
	    /**
	     * @param {?} fullName
	     * @return {?}
	     */
	    _TreeBuilder.prototype._popElement = /**
	     * @param {?} fullName
	     * @return {?}
	     */
	    function (fullName) {
	        for (var /** @type {?} */ stackIndex = this._elementStack.length - 1; stackIndex >= 0; stackIndex--) {
	            var /** @type {?} */ el = this._elementStack[stackIndex];
	            if (el.name == fullName) {
	                this._elementStack.splice(stackIndex, this._elementStack.length - stackIndex);
	                return true;
	            }
	            if (!this.getTagDefinition(el.name).closedByParent) {
	                return false;
	            }
	        }
	        return false;
	    };
	    /**
	     * @param {?} attrName
	     * @return {?}
	     */
	    _TreeBuilder.prototype._consumeAttr = /**
	     * @param {?} attrName
	     * @return {?}
	     */
	    function (attrName) {
	        var /** @type {?} */ fullName = mergeNsAndName(attrName.parts[0], attrName.parts[1]);
	        var /** @type {?} */ end = attrName.sourceSpan.end;
	        var /** @type {?} */ value = '';
	        var /** @type {?} */ valueSpan = /** @type {?} */ ((undefined));
	        if (this._peek.type === TokenType$1.ATTR_VALUE) {
	            var /** @type {?} */ valueToken = this._advance();
	            value = valueToken.parts[0];
	            end = valueToken.sourceSpan.end;
	            valueSpan = valueToken.sourceSpan;
	        }
	        return new Attribute$1(fullName, value, new ParseSourceSpan(attrName.sourceSpan.start, end), valueSpan);
	    };
	    /**
	     * @return {?}
	     */
	    _TreeBuilder.prototype._getParentElement = /**
	     * @return {?}
	     */
	    function () {
	        return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
	    };
	    /**
	     * Returns the parent in the DOM and the container.
	     *
	     * `<ng-container>` elements are skipped as they are not rendered as DOM element.
	     * @return {?}
	     */
	    _TreeBuilder.prototype._getParentElementSkippingContainers = /**
	     * Returns the parent in the DOM and the container.
	     *
	     * `<ng-container>` elements are skipped as they are not rendered as DOM element.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ container = null;
	        for (var /** @type {?} */ i = this._elementStack.length - 1; i >= 0; i--) {
	            if (!isNgContainer(this._elementStack[i].name)) {
	                return { parent: this._elementStack[i], container: container };
	            }
	            container = this._elementStack[i];
	        }
	        return { parent: null, container: container };
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    _TreeBuilder.prototype._addToParent = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        var /** @type {?} */ parent = this._getParentElement();
	        if (parent != null) {
	            parent.children.push(node);
	        }
	        else {
	            this._rootNodes.push(node);
	        }
	    };
	    /**
	     * Insert a node between the parent and the container.
	     * When no container is given, the node is appended as a child of the parent.
	     * Also updates the element stack accordingly.
	     *
	     * \@internal
	     * @param {?} parent
	     * @param {?} container
	     * @param {?} node
	     * @return {?}
	     */
	    _TreeBuilder.prototype._insertBeforeContainer = /**
	     * Insert a node between the parent and the container.
	     * When no container is given, the node is appended as a child of the parent.
	     * Also updates the element stack accordingly.
	     *
	     * \@internal
	     * @param {?} parent
	     * @param {?} container
	     * @param {?} node
	     * @return {?}
	     */
	    function (parent, container, node) {
	        if (!container) {
	            this._addToParent(node);
	            this._elementStack.push(node);
	        }
	        else {
	            if (parent) {
	                // replace the container with the new node in the children
	                var /** @type {?} */ index = parent.children.indexOf(container);
	                parent.children[index] = node;
	            }
	            else {
	                this._rootNodes.push(node);
	            }
	            node.children.push(container);
	            this._elementStack.splice(this._elementStack.indexOf(container), 0, node);
	        }
	    };
	    /**
	     * @param {?} prefix
	     * @param {?} localName
	     * @param {?} parentElement
	     * @return {?}
	     */
	    _TreeBuilder.prototype._getElementFullName = /**
	     * @param {?} prefix
	     * @param {?} localName
	     * @param {?} parentElement
	     * @return {?}
	     */
	    function (prefix, localName, parentElement) {
	        if (prefix == null) {
	            prefix = /** @type {?} */ ((this.getTagDefinition(localName).implicitNamespacePrefix));
	            if (prefix == null && parentElement != null) {
	                prefix = getNsPrefix(parentElement.name);
	            }
	        }
	        return mergeNsAndName(prefix, localName);
	    };
	    return _TreeBuilder;
	}());
	/**
	 * @param {?} stack
	 * @param {?} element
	 * @return {?}
	 */
	function lastOnStack(stack, element) {
	    return stack.length > 0 && stack[stack.length - 1] === element;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} message
	 * @return {?}
	 */
	function digest(message) {
	    return message.id || sha1(serializeNodes(message.nodes).join('') + ("[" + message.meaning + "]"));
	}
	/**
	 * @param {?} message
	 * @return {?}
	 */
	function decimalDigest(message) {
	    if (message.id) {
	        return message.id;
	    }
	    var /** @type {?} */ visitor = new _SerializerIgnoreIcuExpVisitor();
	    var /** @type {?} */ parts = message.nodes.map(function (a) { return a.visit(visitor, null); });
	    return computeMsgId(parts.join(''), message.meaning);
	}
	/**
	 * Serialize the i18n ast to something xml-like in order to generate an UID.
	 *
	 * The visitor is also used in the i18n parser tests
	 *
	 * \@internal
	 */
	var _SerializerVisitor = /** @class */ (function () {
	    function _SerializerVisitor() {
	    }
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    _SerializerVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { return text.value; };
	    /**
	     * @param {?} container
	     * @param {?} context
	     * @return {?}
	     */
	    _SerializerVisitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        return "[" + container.children.map(function (child) { return child.visit(_this); }).join(', ') + "]";
	    };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    _SerializerVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
	        return "{" + icu.expression + ", " + icu.type + ", " + strCases.join(', ') + "}";
	    };
	    /**
	     * @param {?} ph
	     * @param {?} context
	     * @return {?}
	     */
	    _SerializerVisitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var _this = this;
	        return ph.isVoid ?
	            "<ph tag name=\"" + ph.startName + "\"/>" :
	            "<ph tag name=\"" + ph.startName + "\">" + ph.children.map(function (child) { return child.visit(_this); }).join(', ') + "</ph name=\"" + ph.closeName + "\">";
	    };
	    /**
	     * @param {?} ph
	     * @param {?} context
	     * @return {?}
	     */
	    _SerializerVisitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?} context
	     * @return {?}
	     */
	    function (ph, context) {
	        return ph.value ? "<ph name=\"" + ph.name + "\">" + ph.value + "</ph>" : "<ph name=\"" + ph.name + "\"/>";
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _SerializerVisitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        return "<ph icu name=\"" + ph.name + "\">" + ph.value.visit(this) + "</ph>";
	    };
	    return _SerializerVisitor;
	}());
	var serializerVisitor = new _SerializerVisitor();
	/**
	 * @param {?} nodes
	 * @return {?}
	 */
	function serializeNodes(nodes) {
	    return nodes.map(function (a) { return a.visit(serializerVisitor, null); });
	}
	/**
	 * Serialize the i18n ast to something xml-like in order to generate an UID.
	 *
	 * Ignore the ICU expressions so that message IDs stays identical if only the expression changes.
	 *
	 * \@internal
	 */
	var _SerializerIgnoreIcuExpVisitor = /** @class */ (function (_super) {
	    __extends(_SerializerIgnoreIcuExpVisitor, _super);
	    function _SerializerIgnoreIcuExpVisitor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    _SerializerIgnoreIcuExpVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
	        // Do not take the expression into account
	        return "{" + icu.type + ", " + strCases.join(', ') + "}";
	    };
	    return _SerializerIgnoreIcuExpVisitor;
	}(_SerializerVisitor));
	/**
	 * Compute the SHA1 of the given string
	 *
	 * see http://csrc.nist.gov/publications/fips/fips180-4/fips-180-4.pdf
	 *
	 * WARNING: this function has not been designed not tested with security in mind.
	 *          DO NOT USE IT IN A SECURITY SENSITIVE CONTEXT.
	 * @param {?} str
	 * @return {?}
	 */
	function sha1(str) {
	    var /** @type {?} */ utf8 = utf8Encode(str);
	    var /** @type {?} */ words32 = stringToWords32(utf8, Endian.Big);
	    var /** @type {?} */ len = utf8.length * 8;
	    var /** @type {?} */ w = new Array(80);
	    var _a = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0], a = _a[0], b = _a[1], c = _a[2], d = _a[3], e = _a[4];
	    words32[len >> 5] |= 0x80 << (24 - len % 32);
	    words32[((len + 64 >> 9) << 4) + 15] = len;
	    for (var /** @type {?} */ i = 0; i < words32.length; i += 16) {
	        var _b = [a, b, c, d, e], h0 = _b[0], h1 = _b[1], h2 = _b[2], h3 = _b[3], h4 = _b[4];
	        for (var /** @type {?} */ j = 0; j < 80; j++) {
	            if (j < 16) {
	                w[j] = words32[i + j];
	            }
	            else {
	                w[j] = rol32(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
	            }
	            var _c = fk(j, b, c, d), f = _c[0], k = _c[1];
	            var /** @type {?} */ temp = [rol32(a, 5), f, e, k, w[j]].reduce(add32);
	            _d = [d, c, rol32(b, 30), a, temp], e = _d[0], d = _d[1], c = _d[2], b = _d[3], a = _d[4];
	        }
	        _e = [add32(a, h0), add32(b, h1), add32(c, h2), add32(d, h3), add32(e, h4)], a = _e[0], b = _e[1], c = _e[2], d = _e[3], e = _e[4];
	    }
	    return byteStringToHexString(words32ToByteString([a, b, c, d, e]));
	    var _d, _e;
	}
	/**
	 * @param {?} index
	 * @param {?} b
	 * @param {?} c
	 * @param {?} d
	 * @return {?}
	 */
	function fk(index, b, c, d) {
	    if (index < 20) {
	        return [(b & c) | (~b & d), 0x5a827999];
	    }
	    if (index < 40) {
	        return [b ^ c ^ d, 0x6ed9eba1];
	    }
	    if (index < 60) {
	        return [(b & c) | (b & d) | (c & d), 0x8f1bbcdc];
	    }
	    return [b ^ c ^ d, 0xca62c1d6];
	}
	/**
	 * Compute the fingerprint of the given string
	 *
	 * The output is 64 bit number encoded as a decimal string
	 *
	 * based on:
	 * https://github.com/google/closure-compiler/blob/master/src/com/google/javascript/jscomp/GoogleJsMessageIdGenerator.java
	 * @param {?} str
	 * @return {?}
	 */
	function fingerprint(str) {
	    var /** @type {?} */ utf8 = utf8Encode(str);
	    var _a = [hash32(utf8, 0), hash32(utf8, 102072)], hi = _a[0], lo = _a[1];
	    if (hi == 0 && (lo == 0 || lo == 1)) {
	        hi = hi ^ 0x130f9bef;
	        lo = lo ^ -0x6b5f56d8;
	    }
	    return [hi, lo];
	}
	/**
	 * @param {?} msg
	 * @param {?} meaning
	 * @return {?}
	 */
	function computeMsgId(msg, meaning) {
	    var _a = fingerprint(msg), hi = _a[0], lo = _a[1];
	    if (meaning) {
	        var _b = fingerprint(meaning), him = _b[0], lom = _b[1];
	        _c = add64(rol64([hi, lo], 1), [him, lom]), hi = _c[0], lo = _c[1];
	    }
	    return byteStringToDecString(words32ToByteString([hi & 0x7fffffff, lo]));
	    var _c;
	}
	/**
	 * @param {?} str
	 * @param {?} c
	 * @return {?}
	 */
	function hash32(str, c) {
	    var _a = [0x9e3779b9, 0x9e3779b9], a = _a[0], b = _a[1];
	    var /** @type {?} */ i;
	    var /** @type {?} */ len = str.length;
	    for (i = 0; i + 12 <= len; i += 12) {
	        a = add32(a, wordAt(str, i, Endian.Little));
	        b = add32(b, wordAt(str, i + 4, Endian.Little));
	        c = add32(c, wordAt(str, i + 8, Endian.Little));
	        _b = mix([a, b, c]), a = _b[0], b = _b[1], c = _b[2];
	    }
	    a = add32(a, wordAt(str, i, Endian.Little));
	    b = add32(b, wordAt(str, i + 4, Endian.Little));
	    // the first byte of c is reserved for the length
	    c = add32(c, len);
	    c = add32(c, wordAt(str, i + 8, Endian.Little) << 8);
	    return mix([a, b, c])[2];
	    var _b;
	}
	/**
	 * @param {?} __0
	 * @return {?}
	 */
	function mix(_a) {
	    var a = _a[0], b = _a[1], c = _a[2];
	    a = sub32(a, b);
	    a = sub32(a, c);
	    a ^= c >>> 13;
	    b = sub32(b, c);
	    b = sub32(b, a);
	    b ^= a << 8;
	    c = sub32(c, a);
	    c = sub32(c, b);
	    c ^= b >>> 13;
	    a = sub32(a, b);
	    a = sub32(a, c);
	    a ^= c >>> 12;
	    b = sub32(b, c);
	    b = sub32(b, a);
	    b ^= a << 16;
	    c = sub32(c, a);
	    c = sub32(c, b);
	    c ^= b >>> 5;
	    a = sub32(a, b);
	    a = sub32(a, c);
	    a ^= c >>> 3;
	    b = sub32(b, c);
	    b = sub32(b, a);
	    b ^= a << 10;
	    c = sub32(c, a);
	    c = sub32(c, b);
	    c ^= b >>> 15;
	    return [a, b, c];
	}
	/** @enum {number} */
	var Endian = {
	    Little: 0,
	    Big: 1,
	};
	Endian[Endian.Little] = "Little";
	Endian[Endian.Big] = "Big";
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function add32(a, b) {
	    return add32to64(a, b)[1];
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function add32to64(a, b) {
	    var /** @type {?} */ low = (a & 0xffff) + (b & 0xffff);
	    var /** @type {?} */ high = (a >>> 16) + (b >>> 16) + (low >>> 16);
	    return [high >>> 16, (high << 16) | (low & 0xffff)];
	}
	/**
	 * @param {?} __0
	 * @param {?} __1
	 * @return {?}
	 */
	function add64(_a, _b) {
	    var ah = _a[0], al = _a[1];
	    var bh = _b[0], bl = _b[1];
	    var _c = add32to64(al, bl), carry = _c[0], l = _c[1];
	    var /** @type {?} */ h = add32(add32(ah, bh), carry);
	    return [h, l];
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function sub32(a, b) {
	    var /** @type {?} */ low = (a & 0xffff) - (b & 0xffff);
	    var /** @type {?} */ high = (a >> 16) - (b >> 16) + (low >> 16);
	    return (high << 16) | (low & 0xffff);
	}
	/**
	 * @param {?} a
	 * @param {?} count
	 * @return {?}
	 */
	function rol32(a, count) {
	    return (a << count) | (a >>> (32 - count));
	}
	/**
	 * @param {?} __0
	 * @param {?} count
	 * @return {?}
	 */
	function rol64(_a, count) {
	    var hi = _a[0], lo = _a[1];
	    var /** @type {?} */ h = (hi << count) | (lo >>> (32 - count));
	    var /** @type {?} */ l = (lo << count) | (hi >>> (32 - count));
	    return [h, l];
	}
	/**
	 * @param {?} str
	 * @param {?} endian
	 * @return {?}
	 */
	function stringToWords32(str, endian) {
	    var /** @type {?} */ words32 = Array((str.length + 3) >>> 2);
	    for (var /** @type {?} */ i = 0; i < words32.length; i++) {
	        words32[i] = wordAt(str, i * 4, endian);
	    }
	    return words32;
	}
	/**
	 * @param {?} str
	 * @param {?} index
	 * @return {?}
	 */
	function byteAt(str, index) {
	    return index >= str.length ? 0 : str.charCodeAt(index) & 0xff;
	}
	/**
	 * @param {?} str
	 * @param {?} index
	 * @param {?} endian
	 * @return {?}
	 */
	function wordAt(str, index, endian) {
	    var /** @type {?} */ word = 0;
	    if (endian === Endian.Big) {
	        for (var /** @type {?} */ i = 0; i < 4; i++) {
	            word += byteAt(str, index + i) << (24 - 8 * i);
	        }
	    }
	    else {
	        for (var /** @type {?} */ i = 0; i < 4; i++) {
	            word += byteAt(str, index + i) << 8 * i;
	        }
	    }
	    return word;
	}
	/**
	 * @param {?} words32
	 * @return {?}
	 */
	function words32ToByteString(words32) {
	    return words32.reduce(function (str, word) { return str + word32ToByteString(word); }, '');
	}
	/**
	 * @param {?} word
	 * @return {?}
	 */
	function word32ToByteString(word) {
	    var /** @type {?} */ str = '';
	    for (var /** @type {?} */ i = 0; i < 4; i++) {
	        str += String.fromCharCode((word >>> 8 * (3 - i)) & 0xff);
	    }
	    return str;
	}
	/**
	 * @param {?} str
	 * @return {?}
	 */
	function byteStringToHexString(str) {
	    var /** @type {?} */ hex = '';
	    for (var /** @type {?} */ i = 0; i < str.length; i++) {
	        var /** @type {?} */ b = byteAt(str, i);
	        hex += (b >>> 4).toString(16) + (b & 0x0f).toString(16);
	    }
	    return hex.toLowerCase();
	}
	/**
	 * @param {?} str
	 * @return {?}
	 */
	function byteStringToDecString(str) {
	    var /** @type {?} */ decimal = '';
	    var /** @type {?} */ toThePower = '1';
	    for (var /** @type {?} */ i = str.length - 1; i >= 0; i--) {
	        decimal = addBigInt(decimal, numberTimesBigInt(byteAt(str, i), toThePower));
	        toThePower = numberTimesBigInt(256, toThePower);
	    }
	    return decimal.split('').reverse().join('');
	}
	/**
	 * @param {?} x
	 * @param {?} y
	 * @return {?}
	 */
	function addBigInt(x, y) {
	    var /** @type {?} */ sum = '';
	    var /** @type {?} */ len = Math.max(x.length, y.length);
	    for (var /** @type {?} */ i = 0, /** @type {?} */ carry = 0; i < len || carry; i++) {
	        var /** @type {?} */ tmpSum = carry + +(x[i] || 0) + +(y[i] || 0);
	        if (tmpSum >= 10) {
	            carry = 1;
	            sum += tmpSum - 10;
	        }
	        else {
	            carry = 0;
	            sum += tmpSum;
	        }
	    }
	    return sum;
	}
	/**
	 * @param {?} num
	 * @param {?} b
	 * @return {?}
	 */
	function numberTimesBigInt(num, b) {
	    var /** @type {?} */ product = '';
	    var /** @type {?} */ bToThePower = b;
	    for (; num !== 0; num = num >>> 1) {
	        if (num & 1)
	            product = addBigInt(product, bToThePower);
	        bToThePower = addBigInt(bToThePower, bToThePower);
	    }
	    return product;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var Message = /** @class */ (function () {
	    /**
	     * @param nodes message AST
	     * @param placeholders maps placeholder names to static content
	     * @param placeholderToMessage maps placeholder names to messages (used for nested ICU messages)
	     * @param meaning
	     * @param description
	     * @param id
	     */
	    function Message(nodes, placeholders, placeholderToMessage, meaning, description, id) {
	        this.nodes = nodes;
	        this.placeholders = placeholders;
	        this.placeholderToMessage = placeholderToMessage;
	        this.meaning = meaning;
	        this.description = description;
	        this.id = id;
	        if (nodes.length) {
	            this.sources = [{
	                    filePath: nodes[0].sourceSpan.start.file.url,
	                    startLine: nodes[0].sourceSpan.start.line + 1,
	                    startCol: nodes[0].sourceSpan.start.col + 1,
	                    endLine: nodes[nodes.length - 1].sourceSpan.end.line + 1,
	                    endCol: nodes[0].sourceSpan.start.col + 1
	                }];
	        }
	        else {
	            this.sources = [];
	        }
	    }
	    return Message;
	}());
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	var Text$1 = /** @class */ (function () {
	    function Text(value, sourceSpan) {
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Text.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitText(this, context); };
	    return Text;
	}());
	var Container = /** @class */ (function () {
	    function Container(children, sourceSpan) {
	        this.children = children;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Container.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitContainer(this, context); };
	    return Container;
	}());
	var Icu = /** @class */ (function () {
	    function Icu(expression, type, cases, sourceSpan) {
	        this.expression = expression;
	        this.type = type;
	        this.cases = cases;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Icu.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitIcu(this, context); };
	    return Icu;
	}());
	var TagPlaceholder = /** @class */ (function () {
	    function TagPlaceholder(tag, attrs, startName, closeName, children, isVoid, sourceSpan) {
	        this.tag = tag;
	        this.attrs = attrs;
	        this.startName = startName;
	        this.closeName = closeName;
	        this.children = children;
	        this.isVoid = isVoid;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    TagPlaceholder.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitTagPlaceholder(this, context); };
	    return TagPlaceholder;
	}());
	var Placeholder = /** @class */ (function () {
	    function Placeholder(value, name, sourceSpan) {
	        this.value = value;
	        this.name = name;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    Placeholder.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitPlaceholder(this, context); };
	    return Placeholder;
	}());
	var IcuPlaceholder = /** @class */ (function () {
	    function IcuPlaceholder(value, name, sourceSpan) {
	        this.value = value;
	        this.name = name;
	        this.sourceSpan = sourceSpan;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    IcuPlaceholder.prototype.visit = /**
	     * @param {?} visitor
	     * @param {?=} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitIcuPlaceholder(this, context); };
	    return IcuPlaceholder;
	}());
	/**
	 * @record
	 */
	
	var CloneVisitor = /** @class */ (function () {
	    function CloneVisitor() {
	    }
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    CloneVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) { return new Text$1(text.value, text.sourceSpan); };
	    /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    CloneVisitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        var /** @type {?} */ children = container.children.map(function (n) { return n.visit(_this, context); });
	        return new Container(children, container.sourceSpan);
	    };
	    /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    CloneVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ cases = {};
	        Object.keys(icu.cases).forEach(function (key) { return cases[key] = icu.cases[key].visit(_this, context); });
	        var /** @type {?} */ msg = new Icu(icu.expression, icu.type, cases, icu.sourceSpan);
	        msg.expressionPlaceholder = icu.expressionPlaceholder;
	        return msg;
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    CloneVisitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var _this = this;
	        var /** @type {?} */ children = ph.children.map(function (n) { return n.visit(_this, context); });
	        return new TagPlaceholder(ph.tag, ph.attrs, ph.startName, ph.closeName, children, ph.isVoid, ph.sourceSpan);
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    CloneVisitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        return new Placeholder(ph.value, ph.name, ph.sourceSpan);
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    CloneVisitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        return new IcuPlaceholder(ph.value, ph.name, ph.sourceSpan);
	    };
	    return CloneVisitor;
	}());
	var RecurseVisitor = /** @class */ (function () {
	    function RecurseVisitor() {
	    }
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    RecurseVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) { };
	    /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    RecurseVisitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        container.children.forEach(function (child) { return child.visit(_this); });
	    };
	    /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    RecurseVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        Object.keys(icu.cases).forEach(function (k) { icu.cases[k].visit(_this); });
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    RecurseVisitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var _this = this;
	        ph.children.forEach(function (child) { return child.visit(_this); });
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    RecurseVisitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) { };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    RecurseVisitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) { };
	    return RecurseVisitor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var HtmlTagDefinition = /** @class */ (function () {
	    function HtmlTagDefinition(_a) {
	        var _b = _a === void 0 ? {} : _a, closedByChildren = _b.closedByChildren, requiredParents = _b.requiredParents, implicitNamespacePrefix = _b.implicitNamespacePrefix, _c = _b.contentType, contentType = _c === void 0 ? TagContentType.PARSABLE_DATA : _c, _d = _b.closedByParent, closedByParent = _d === void 0 ? false : _d, _e = _b.isVoid, isVoid = _e === void 0 ? false : _e, _f = _b.ignoreFirstLf, ignoreFirstLf = _f === void 0 ? false : _f;
	        var _this = this;
	        this.closedByChildren = {};
	        this.closedByParent = false;
	        this.canSelfClose = false;
	        if (closedByChildren && closedByChildren.length > 0) {
	            closedByChildren.forEach(function (tagName) { return _this.closedByChildren[tagName] = true; });
	        }
	        this.isVoid = isVoid;
	        this.closedByParent = closedByParent || isVoid;
	        if (requiredParents && requiredParents.length > 0) {
	            this.requiredParents = {};
	            // The first parent is the list is automatically when none of the listed parents are present
	            this.parentToAdd = requiredParents[0];
	            requiredParents.forEach(function (tagName) { return _this.requiredParents[tagName] = true; });
	        }
	        this.implicitNamespacePrefix = implicitNamespacePrefix || null;
	        this.contentType = contentType;
	        this.ignoreFirstLf = ignoreFirstLf;
	    }
	    /**
	     * @param {?} currentParent
	     * @return {?}
	     */
	    HtmlTagDefinition.prototype.requireExtraParent = /**
	     * @param {?} currentParent
	     * @return {?}
	     */
	    function (currentParent) {
	        if (!this.requiredParents) {
	            return false;
	        }
	        if (!currentParent) {
	            return true;
	        }
	        var /** @type {?} */ lcParent = currentParent.toLowerCase();
	        var /** @type {?} */ isParentTemplate = lcParent === 'template' || currentParent === 'ng-template';
	        return !isParentTemplate && this.requiredParents[lcParent] != true;
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    HtmlTagDefinition.prototype.isClosedByChild = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        return this.isVoid || name.toLowerCase() in this.closedByChildren;
	    };
	    return HtmlTagDefinition;
	}());
	// see http://www.w3.org/TR/html51/syntax.html#optional-tags
	// This implementation does not fully conform to the HTML5 spec.
	var TAG_DEFINITIONS = {
	    'base': new HtmlTagDefinition({ isVoid: true }),
	    'meta': new HtmlTagDefinition({ isVoid: true }),
	    'area': new HtmlTagDefinition({ isVoid: true }),
	    'embed': new HtmlTagDefinition({ isVoid: true }),
	    'link': new HtmlTagDefinition({ isVoid: true }),
	    'img': new HtmlTagDefinition({ isVoid: true }),
	    'input': new HtmlTagDefinition({ isVoid: true }),
	    'param': new HtmlTagDefinition({ isVoid: true }),
	    'hr': new HtmlTagDefinition({ isVoid: true }),
	    'br': new HtmlTagDefinition({ isVoid: true }),
	    'source': new HtmlTagDefinition({ isVoid: true }),
	    'track': new HtmlTagDefinition({ isVoid: true }),
	    'wbr': new HtmlTagDefinition({ isVoid: true }),
	    'p': new HtmlTagDefinition({
	        closedByChildren: [
	            'address', 'article', 'aside', 'blockquote', 'div', 'dl', 'fieldset', 'footer', 'form',
	            'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr',
	            'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'ul'
	        ],
	        closedByParent: true
	    }),
	    'thead': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'] }),
	    'tbody': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'], closedByParent: true }),
	    'tfoot': new HtmlTagDefinition({ closedByChildren: ['tbody'], closedByParent: true }),
	    'tr': new HtmlTagDefinition({
	        closedByChildren: ['tr'],
	        requiredParents: ['tbody', 'tfoot', 'thead'],
	        closedByParent: true
	    }),
	    'td': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
	    'th': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
	    'col': new HtmlTagDefinition({ requiredParents: ['colgroup'], isVoid: true }),
	    'svg': new HtmlTagDefinition({ implicitNamespacePrefix: 'svg' }),
	    'math': new HtmlTagDefinition({ implicitNamespacePrefix: 'math' }),
	    'li': new HtmlTagDefinition({ closedByChildren: ['li'], closedByParent: true }),
	    'dt': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'] }),
	    'dd': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'], closedByParent: true }),
	    'rb': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
	    'rt': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
	    'rtc': new HtmlTagDefinition({ closedByChildren: ['rb', 'rtc', 'rp'], closedByParent: true }),
	    'rp': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
	    'optgroup': new HtmlTagDefinition({ closedByChildren: ['optgroup'], closedByParent: true }),
	    'option': new HtmlTagDefinition({ closedByChildren: ['option', 'optgroup'], closedByParent: true }),
	    'pre': new HtmlTagDefinition({ ignoreFirstLf: true }),
	    'listing': new HtmlTagDefinition({ ignoreFirstLf: true }),
	    'style': new HtmlTagDefinition({ contentType: TagContentType.RAW_TEXT }),
	    'script': new HtmlTagDefinition({ contentType: TagContentType.RAW_TEXT }),
	    'title': new HtmlTagDefinition({ contentType: TagContentType.ESCAPABLE_RAW_TEXT }),
	    'textarea': new HtmlTagDefinition({ contentType: TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }),
	};
	var _DEFAULT_TAG_DEFINITION = new HtmlTagDefinition();
	/**
	 * @param {?} tagName
	 * @return {?}
	 */
	function getHtmlTagDefinition(tagName) {
	    return TAG_DEFINITIONS[tagName.toLowerCase()] || _DEFAULT_TAG_DEFINITION;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var TAG_TO_PLACEHOLDER_NAMES = {
	    'A': 'LINK',
	    'B': 'BOLD_TEXT',
	    'BR': 'LINE_BREAK',
	    'EM': 'EMPHASISED_TEXT',
	    'H1': 'HEADING_LEVEL1',
	    'H2': 'HEADING_LEVEL2',
	    'H3': 'HEADING_LEVEL3',
	    'H4': 'HEADING_LEVEL4',
	    'H5': 'HEADING_LEVEL5',
	    'H6': 'HEADING_LEVEL6',
	    'HR': 'HORIZONTAL_RULE',
	    'I': 'ITALIC_TEXT',
	    'LI': 'LIST_ITEM',
	    'LINK': 'MEDIA_LINK',
	    'OL': 'ORDERED_LIST',
	    'P': 'PARAGRAPH',
	    'Q': 'QUOTATION',
	    'S': 'STRIKETHROUGH_TEXT',
	    'SMALL': 'SMALL_TEXT',
	    'SUB': 'SUBSTRIPT',
	    'SUP': 'SUPERSCRIPT',
	    'TBODY': 'TABLE_BODY',
	    'TD': 'TABLE_CELL',
	    'TFOOT': 'TABLE_FOOTER',
	    'TH': 'TABLE_HEADER_CELL',
	    'THEAD': 'TABLE_HEADER',
	    'TR': 'TABLE_ROW',
	    'TT': 'MONOSPACED_TEXT',
	    'U': 'UNDERLINED_TEXT',
	    'UL': 'UNORDERED_LIST',
	};
	/**
	 * Creates unique names for placeholder with different content.
	 *
	 * Returns the same placeholder name when the content is identical.
	 */
	var PlaceholderRegistry = /** @class */ (function () {
	    function PlaceholderRegistry() {
	        this._placeHolderNameCounts = {};
	        this._signatureToName = {};
	    }
	    /**
	     * @param {?} tag
	     * @param {?} attrs
	     * @param {?} isVoid
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype.getStartTagPlaceholderName = /**
	     * @param {?} tag
	     * @param {?} attrs
	     * @param {?} isVoid
	     * @return {?}
	     */
	    function (tag, attrs, isVoid) {
	        var /** @type {?} */ signature = this._hashTag(tag, attrs, isVoid);
	        if (this._signatureToName[signature]) {
	            return this._signatureToName[signature];
	        }
	        var /** @type {?} */ upperTag = tag.toUpperCase();
	        var /** @type {?} */ baseName = TAG_TO_PLACEHOLDER_NAMES[upperTag] || "TAG_" + upperTag;
	        var /** @type {?} */ name = this._generateUniqueName(isVoid ? baseName : "START_" + baseName);
	        this._signatureToName[signature] = name;
	        return name;
	    };
	    /**
	     * @param {?} tag
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype.getCloseTagPlaceholderName = /**
	     * @param {?} tag
	     * @return {?}
	     */
	    function (tag) {
	        var /** @type {?} */ signature = this._hashClosingTag(tag);
	        if (this._signatureToName[signature]) {
	            return this._signatureToName[signature];
	        }
	        var /** @type {?} */ upperTag = tag.toUpperCase();
	        var /** @type {?} */ baseName = TAG_TO_PLACEHOLDER_NAMES[upperTag] || "TAG_" + upperTag;
	        var /** @type {?} */ name = this._generateUniqueName("CLOSE_" + baseName);
	        this._signatureToName[signature] = name;
	        return name;
	    };
	    /**
	     * @param {?} name
	     * @param {?} content
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype.getPlaceholderName = /**
	     * @param {?} name
	     * @param {?} content
	     * @return {?}
	     */
	    function (name, content) {
	        var /** @type {?} */ upperName = name.toUpperCase();
	        var /** @type {?} */ signature = "PH: " + upperName + "=" + content;
	        if (this._signatureToName[signature]) {
	            return this._signatureToName[signature];
	        }
	        var /** @type {?} */ uniqueName = this._generateUniqueName(upperName);
	        this._signatureToName[signature] = uniqueName;
	        return uniqueName;
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype.getUniquePlaceholder = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        return this._generateUniqueName(name.toUpperCase());
	    };
	    /**
	     * @param {?} tag
	     * @param {?} attrs
	     * @param {?} isVoid
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype._hashTag = /**
	     * @param {?} tag
	     * @param {?} attrs
	     * @param {?} isVoid
	     * @return {?}
	     */
	    function (tag, attrs, isVoid) {
	        var /** @type {?} */ start = "<" + tag;
	        var /** @type {?} */ strAttrs = Object.keys(attrs).sort().map(function (name) { return " " + name + "=" + attrs[name]; }).join('');
	        var /** @type {?} */ end = isVoid ? '/>' : "></" + tag + ">";
	        return start + strAttrs + end;
	    };
	    /**
	     * @param {?} tag
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype._hashClosingTag = /**
	     * @param {?} tag
	     * @return {?}
	     */
	    function (tag) { return this._hashTag("/" + tag, {}, false); };
	    /**
	     * @param {?} base
	     * @return {?}
	     */
	    PlaceholderRegistry.prototype._generateUniqueName = /**
	     * @param {?} base
	     * @return {?}
	     */
	    function (base) {
	        var /** @type {?} */ seen = this._placeHolderNameCounts.hasOwnProperty(base);
	        if (!seen) {
	            this._placeHolderNameCounts[base] = 1;
	            return base;
	        }
	        var /** @type {?} */ id = this._placeHolderNameCounts[base];
	        this._placeHolderNameCounts[base] = id + 1;
	        return base + "_" + id;
	    };
	    return PlaceholderRegistry;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _expParser = new Parser(new Lexer());
	/**
	 * Returns a function converting html nodes to an i18n Message given an interpolationConfig
	 * @param {?} interpolationConfig
	 * @return {?}
	 */
	function createI18nMessageFactory(interpolationConfig) {
	    var /** @type {?} */ visitor = new _I18nVisitor(_expParser, interpolationConfig);
	    return function (nodes, meaning, description, id) {
	        return visitor.toI18nMessage(nodes, meaning, description, id);
	    };
	}
	var _I18nVisitor = /** @class */ (function () {
	    function _I18nVisitor(_expressionParser, _interpolationConfig) {
	        this._expressionParser = _expressionParser;
	        this._interpolationConfig = _interpolationConfig;
	    }
	    /**
	     * @param {?} nodes
	     * @param {?} meaning
	     * @param {?} description
	     * @param {?} id
	     * @return {?}
	     */
	    _I18nVisitor.prototype.toI18nMessage = /**
	     * @param {?} nodes
	     * @param {?} meaning
	     * @param {?} description
	     * @param {?} id
	     * @return {?}
	     */
	    function (nodes, meaning, description, id) {
	        this._isIcu = nodes.length == 1 && nodes[0] instanceof Expansion;
	        this._icuDepth = 0;
	        this._placeholderRegistry = new PlaceholderRegistry();
	        this._placeholderToContent = {};
	        this._placeholderToMessage = {};
	        var /** @type {?} */ i18nodes = visitAll(this, nodes, {});
	        return new Message(i18nodes, this._placeholderToContent, this._placeholderToMessage, meaning, description, id);
	    };
	    /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    _I18nVisitor.prototype.visitElement = /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    function (el, context) {
	        var /** @type {?} */ children = visitAll(this, el.children);
	        var /** @type {?} */ attrs = {};
	        el.attrs.forEach(function (attr) {
	            // Do not visit the attributes, translatable ones are top-level ASTs
	            attrs[attr.name] = attr.value;
	        });
	        var /** @type {?} */ isVoid = getHtmlTagDefinition(el.name).isVoid;
	        var /** @type {?} */ startPhName = this._placeholderRegistry.getStartTagPlaceholderName(el.name, attrs, isVoid);
	        this._placeholderToContent[startPhName] = /** @type {?} */ ((el.sourceSpan)).toString();
	        var /** @type {?} */ closePhName = '';
	        if (!isVoid) {
	            closePhName = this._placeholderRegistry.getCloseTagPlaceholderName(el.name);
	            this._placeholderToContent[closePhName] = "</" + el.name + ">";
	        }
	        return new TagPlaceholder(el.name, attrs, startPhName, closePhName, children, isVoid, /** @type {?} */ ((el.sourceSpan)));
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    _I18nVisitor.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) {
	        return this._visitTextWithInterpolation(attribute.value, attribute.sourceSpan);
	    };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    _I18nVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) {
	        return this._visitTextWithInterpolation(text.value, /** @type {?} */ ((text.sourceSpan)));
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    _I18nVisitor.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { return null; };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    _I18nVisitor.prototype.visitExpansion = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        this._icuDepth++;
	        var /** @type {?} */ i18nIcuCases = {};
	        var /** @type {?} */ i18nIcu = new Icu(icu.switchValue, icu.type, i18nIcuCases, icu.sourceSpan);
	        icu.cases.forEach(function (caze) {
	            i18nIcuCases[caze.value] = new Container(caze.expression.map(function (node) { return node.visit(_this, {}); }), caze.expSourceSpan);
	        });
	        this._icuDepth--;
	        if (this._isIcu || this._icuDepth > 0) {
	            // Returns an ICU node when:
	            // - the message (vs a part of the message) is an ICU message, or
	            // - the ICU message is nested.
	            var /** @type {?} */ expPh = this._placeholderRegistry.getUniquePlaceholder("VAR_" + icu.type);
	            i18nIcu.expressionPlaceholder = expPh;
	            this._placeholderToContent[expPh] = icu.switchValue;
	            return i18nIcu;
	        }
	        // Else returns a placeholder
	        // ICU placeholders should not be replaced with their original content but with the their
	        // translations. We need to create a new visitor (they are not re-entrant) to compute the
	        // message id.
	        // TODO(vicb): add a html.Node -> i18n.Message cache to avoid having to re-create the msg
	        var /** @type {?} */ phName = this._placeholderRegistry.getPlaceholderName('ICU', icu.sourceSpan.toString());
	        var /** @type {?} */ visitor = new _I18nVisitor(this._expressionParser, this._interpolationConfig);
	        this._placeholderToMessage[phName] = visitor.toI18nMessage([icu], '', '', '');
	        return new IcuPlaceholder(i18nIcu, phName, icu.sourceSpan);
	    };
	    /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    _I18nVisitor.prototype.visitExpansionCase = /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (icuCase, context) {
	        throw new Error('Unreachable code');
	    };
	    /**
	     * @param {?} text
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    _I18nVisitor.prototype._visitTextWithInterpolation = /**
	     * @param {?} text
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (text, sourceSpan) {
	        var /** @type {?} */ splitInterpolation = this._expressionParser.splitInterpolation(text, sourceSpan.start.toString(), this._interpolationConfig);
	        if (!splitInterpolation) {
	            // No expression, return a single text
	            return new Text$1(text, sourceSpan);
	        }
	        // Return a group of text + expressions
	        var /** @type {?} */ nodes = [];
	        var /** @type {?} */ container = new Container(nodes, sourceSpan);
	        var _a = this._interpolationConfig, sDelimiter = _a.start, eDelimiter = _a.end;
	        for (var /** @type {?} */ i = 0; i < splitInterpolation.strings.length - 1; i++) {
	            var /** @type {?} */ expression = splitInterpolation.expressions[i];
	            var /** @type {?} */ baseName = _extractPlaceholderName(expression) || 'INTERPOLATION';
	            var /** @type {?} */ phName = this._placeholderRegistry.getPlaceholderName(baseName, expression);
	            if (splitInterpolation.strings[i].length) {
	                // No need to add empty strings
	                nodes.push(new Text$1(splitInterpolation.strings[i], sourceSpan));
	            }
	            nodes.push(new Placeholder(expression, phName, sourceSpan));
	            this._placeholderToContent[phName] = sDelimiter + expression + eDelimiter;
	        }
	        // The last index contains no expression
	        var /** @type {?} */ lastStringIdx = splitInterpolation.strings.length - 1;
	        if (splitInterpolation.strings[lastStringIdx].length) {
	            nodes.push(new Text$1(splitInterpolation.strings[lastStringIdx], sourceSpan));
	        }
	        return container;
	    };
	    return _I18nVisitor;
	}());
	var _CUSTOM_PH_EXP = /\/\/[\s\S]*i18n[\s\S]*\([\s\S]*ph[\s\S]*=[\s\S]*("|')([\s\S]*?)\1[\s\S]*\)/g;
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function _extractPlaceholderName(input) {
	    return input.split(_CUSTOM_PH_EXP)[2];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An i18n error.
	 */
	var I18nError = /** @class */ (function (_super) {
	    __extends(I18nError, _super);
	    function I18nError(span, msg) {
	        return _super.call(this, span, msg) || this;
	    }
	    return I18nError;
	}(ParseError));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _I18N_ATTR = 'i18n';
	var _I18N_ATTR_PREFIX = 'i18n-';
	var _I18N_COMMENT_PREFIX_REGEXP = /^i18n:?/;
	var MEANING_SEPARATOR = '|';
	var ID_SEPARATOR = '@@';
	var i18nCommentsWarned = false;
	/**
	 * Extract translatable messages from an html AST
	 * @param {?} nodes
	 * @param {?} interpolationConfig
	 * @param {?} implicitTags
	 * @param {?} implicitAttrs
	 * @return {?}
	 */
	function extractMessages(nodes, interpolationConfig, implicitTags, implicitAttrs) {
	    var /** @type {?} */ visitor = new _Visitor(implicitTags, implicitAttrs);
	    return visitor.extract(nodes, interpolationConfig);
	}
	/**
	 * @param {?} nodes
	 * @param {?} translations
	 * @param {?} interpolationConfig
	 * @param {?} implicitTags
	 * @param {?} implicitAttrs
	 * @return {?}
	 */
	function mergeTranslations(nodes, translations, interpolationConfig, implicitTags, implicitAttrs) {
	    var /** @type {?} */ visitor = new _Visitor(implicitTags, implicitAttrs);
	    return visitor.merge(nodes, translations, interpolationConfig);
	}
	var ExtractionResult = /** @class */ (function () {
	    function ExtractionResult(messages, errors) {
	        this.messages = messages;
	        this.errors = errors;
	    }
	    return ExtractionResult;
	}());
	/** @enum {number} */
	var _VisitorMode = {
	    Extract: 0,
	    Merge: 1,
	};
	_VisitorMode[_VisitorMode.Extract] = "Extract";
	_VisitorMode[_VisitorMode.Merge] = "Merge";
	/**
	 * This Visitor is used:
	 * 1. to extract all the translatable strings from an html AST (see `extract()`),
	 * 2. to replace the translatable strings with the actual translations (see `merge()`)
	 *
	 * \@internal
	 */
	var _Visitor = /** @class */ (function () {
	    function _Visitor(_implicitTags, _implicitAttrs) {
	        this._implicitTags = _implicitTags;
	        this._implicitAttrs = _implicitAttrs;
	    }
	    /**
	     * Extracts the messages from the tree
	     */
	    /**
	     * Extracts the messages from the tree
	     * @param {?} nodes
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    _Visitor.prototype.extract = /**
	     * Extracts the messages from the tree
	     * @param {?} nodes
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (nodes, interpolationConfig) {
	        var _this = this;
	        this._init(_VisitorMode.Extract, interpolationConfig);
	        nodes.forEach(function (node) { return node.visit(_this, null); });
	        if (this._inI18nBlock) {
	            this._reportError(nodes[nodes.length - 1], 'Unclosed block');
	        }
	        return new ExtractionResult(this._messages, this._errors);
	    };
	    /**
	     * Returns a tree where all translatable nodes are translated
	     */
	    /**
	     * Returns a tree where all translatable nodes are translated
	     * @param {?} nodes
	     * @param {?} translations
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    _Visitor.prototype.merge = /**
	     * Returns a tree where all translatable nodes are translated
	     * @param {?} nodes
	     * @param {?} translations
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (nodes, translations, interpolationConfig) {
	        this._init(_VisitorMode.Merge, interpolationConfig);
	        this._translations = translations;
	        // Construct a single fake root element
	        var /** @type {?} */ wrapper = new Element('wrapper', [], nodes, /** @type {?} */ ((undefined)), undefined, undefined);
	        var /** @type {?} */ translatedNode = wrapper.visit(this, null);
	        if (this._inI18nBlock) {
	            this._reportError(nodes[nodes.length - 1], 'Unclosed block');
	        }
	        return new ParseTreeResult(translatedNode.children, this._errors);
	    };
	    /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitExpansionCase = /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (icuCase, context) {
	        // Parse cases for translatable html attributes
	        var /** @type {?} */ expression = visitAll(this, icuCase.expression, context);
	        if (this._mode === _VisitorMode.Merge) {
	            return new ExpansionCase(icuCase.value, expression, icuCase.sourceSpan, icuCase.valueSourceSpan, icuCase.expSourceSpan);
	        }
	    };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitExpansion = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        this._mayBeAddBlockChildren(icu);
	        var /** @type {?} */ wasInIcu = this._inIcu;
	        if (!this._inIcu) {
	            // nested ICU messages should not be extracted but top-level translated as a whole
	            if (this._isInTranslatableSection) {
	                this._addMessage([icu]);
	            }
	            this._inIcu = true;
	        }
	        var /** @type {?} */ cases = visitAll(this, icu.cases, context);
	        if (this._mode === _VisitorMode.Merge) {
	            icu = new Expansion(icu.switchValue, icu.type, cases, icu.sourceSpan, icu.switchValueSourceSpan);
	        }
	        this._inIcu = wasInIcu;
	        return icu;
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) {
	        var /** @type {?} */ isOpening = _isOpeningComment(comment);
	        if (isOpening && this._isInTranslatableSection) {
	            this._reportError(comment, 'Could not start a block inside a translatable section');
	            return;
	        }
	        var /** @type {?} */ isClosing = _isClosingComment(comment);
	        if (isClosing && !this._inI18nBlock) {
	            this._reportError(comment, 'Trying to close an unopened block');
	            return;
	        }
	        if (!this._inI18nNode && !this._inIcu) {
	            if (!this._inI18nBlock) {
	                if (isOpening) {
	                    // deprecated from v5 you should use <ng-container i18n> instead of i18n comments
	                    if (!i18nCommentsWarned && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	                        i18nCommentsWarned = true;
	                        var /** @type {?} */ details = comment.sourceSpan.details ? ", " + comment.sourceSpan.details : '';
	                        // TODO(ocombe): use a log service once there is a public one available
	                        console.warn("I18n comments are deprecated, use an <ng-container> element instead (" + comment.sourceSpan.start + details + ")");
	                    }
	                    this._inI18nBlock = true;
	                    this._blockStartDepth = this._depth;
	                    this._blockChildren = [];
	                    this._blockMeaningAndDesc = /** @type {?} */ ((comment.value)).replace(_I18N_COMMENT_PREFIX_REGEXP, '').trim();
	                    this._openTranslatableSection(comment);
	                }
	            }
	            else {
	                if (isClosing) {
	                    if (this._depth == this._blockStartDepth) {
	                        this._closeTranslatableSection(comment, this._blockChildren);
	                        this._inI18nBlock = false;
	                        var /** @type {?} */ message = /** @type {?} */ ((this._addMessage(this._blockChildren, this._blockMeaningAndDesc)));
	                        // merge attributes in sections
	                        var /** @type {?} */ nodes = this._translateMessage(comment, message);
	                        return visitAll(this, nodes);
	                    }
	                    else {
	                        this._reportError(comment, 'I18N blocks should not cross element boundaries');
	                        return;
	                    }
	                }
	            }
	        }
	    };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) {
	        if (this._isInTranslatableSection) {
	            this._mayBeAddBlockChildren(text);
	        }
	        return text;
	    };
	    /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitElement = /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    function (el, context) {
	        var _this = this;
	        this._mayBeAddBlockChildren(el);
	        this._depth++;
	        var /** @type {?} */ wasInI18nNode = this._inI18nNode;
	        var /** @type {?} */ wasInImplicitNode = this._inImplicitNode;
	        var /** @type {?} */ childNodes = [];
	        var /** @type {?} */ translatedChildNodes = /** @type {?} */ ((undefined));
	        // Extract:
	        // - top level nodes with the (implicit) "i18n" attribute if not already in a section
	        // - ICU messages
	        var /** @type {?} */ i18nAttr = _getI18nAttr(el);
	        var /** @type {?} */ i18nMeta = i18nAttr ? i18nAttr.value : '';
	        var /** @type {?} */ isImplicit = this._implicitTags.some(function (tag) { return el.name === tag; }) && !this._inIcu &&
	            !this._isInTranslatableSection;
	        var /** @type {?} */ isTopLevelImplicit = !wasInImplicitNode && isImplicit;
	        this._inImplicitNode = wasInImplicitNode || isImplicit;
	        if (!this._isInTranslatableSection && !this._inIcu) {
	            if (i18nAttr || isTopLevelImplicit) {
	                this._inI18nNode = true;
	                var /** @type {?} */ message = /** @type {?} */ ((this._addMessage(el.children, i18nMeta)));
	                translatedChildNodes = this._translateMessage(el, message);
	            }
	            if (this._mode == _VisitorMode.Extract) {
	                var /** @type {?} */ isTranslatable = i18nAttr || isTopLevelImplicit;
	                if (isTranslatable)
	                    this._openTranslatableSection(el);
	                visitAll(this, el.children);
	                if (isTranslatable)
	                    this._closeTranslatableSection(el, el.children);
	            }
	        }
	        else {
	            if (i18nAttr || isTopLevelImplicit) {
	                this._reportError(el, 'Could not mark an element as translatable inside a translatable section');
	            }
	            if (this._mode == _VisitorMode.Extract) {
	                // Descend into child nodes for extraction
	                visitAll(this, el.children);
	            }
	        }
	        if (this._mode === _VisitorMode.Merge) {
	            var /** @type {?} */ visitNodes = translatedChildNodes || el.children;
	            visitNodes.forEach(function (child) {
	                var /** @type {?} */ visited = child.visit(_this, context);
	                if (visited && !_this._isInTranslatableSection) {
	                    // Do not add the children from translatable sections (= i18n blocks here)
	                    // They will be added later in this loop when the block closes (i.e. on `<!-- /i18n -->`)
	                    childNodes = childNodes.concat(visited);
	                }
	            });
	        }
	        this._visitAttributesOf(el);
	        this._depth--;
	        this._inI18nNode = wasInI18nNode;
	        this._inImplicitNode = wasInImplicitNode;
	        if (this._mode === _VisitorMode.Merge) {
	            var /** @type {?} */ translatedAttrs = this._translateAttributes(el);
	            return new Element(el.name, translatedAttrs, childNodes, el.sourceSpan, el.startSourceSpan, el.endSourceSpan);
	        }
	        return null;
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) {
	        throw new Error('unreachable code');
	    };
	    /**
	     * @param {?} mode
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    _Visitor.prototype._init = /**
	     * @param {?} mode
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (mode, interpolationConfig) {
	        this._mode = mode;
	        this._inI18nBlock = false;
	        this._inI18nNode = false;
	        this._depth = 0;
	        this._inIcu = false;
	        this._msgCountAtSectionStart = undefined;
	        this._errors = [];
	        this._messages = [];
	        this._inImplicitNode = false;
	        this._createI18nMessage = createI18nMessageFactory(interpolationConfig);
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    _Visitor.prototype._visitAttributesOf = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        var _this = this;
	        var /** @type {?} */ explicitAttrNameToValue = {};
	        var /** @type {?} */ implicitAttrNames = this._implicitAttrs[el.name] || [];
	        el.attrs.filter(function (attr) { return attr.name.startsWith(_I18N_ATTR_PREFIX); })
	            .forEach(function (attr) {
	            return explicitAttrNameToValue[attr.name.slice(_I18N_ATTR_PREFIX.length)] =
	                attr.value;
	        });
	        el.attrs.forEach(function (attr) {
	            if (attr.name in explicitAttrNameToValue) {
	                _this._addMessage([attr], explicitAttrNameToValue[attr.name]);
	            }
	            else if (implicitAttrNames.some(function (name) { return attr.name === name; })) {
	                _this._addMessage([attr]);
	            }
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?=} msgMeta
	     * @return {?}
	     */
	    _Visitor.prototype._addMessage = /**
	     * @param {?} ast
	     * @param {?=} msgMeta
	     * @return {?}
	     */
	    function (ast, msgMeta) {
	        if (ast.length == 0 ||
	            ast.length == 1 && ast[0] instanceof Attribute$1 && !(/** @type {?} */ (ast[0])).value) {
	            // Do not create empty messages
	            return null;
	        }
	        var _a = _parseMessageMeta(msgMeta), meaning = _a.meaning, description = _a.description, id = _a.id;
	        var /** @type {?} */ message = this._createI18nMessage(ast, meaning, description, id);
	        this._messages.push(message);
	        return message;
	    };
	    /**
	     * @param {?} el
	     * @param {?} message
	     * @return {?}
	     */
	    _Visitor.prototype._translateMessage = /**
	     * @param {?} el
	     * @param {?} message
	     * @return {?}
	     */
	    function (el, message) {
	        if (message && this._mode === _VisitorMode.Merge) {
	            var /** @type {?} */ nodes = this._translations.get(message);
	            if (nodes) {
	                return nodes;
	            }
	            this._reportError(el, "Translation unavailable for message id=\"" + this._translations.digest(message) + "\"");
	        }
	        return [];
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    _Visitor.prototype._translateAttributes = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        var _this = this;
	        var /** @type {?} */ attributes = el.attrs;
	        var /** @type {?} */ i18nParsedMessageMeta = {};
	        attributes.forEach(function (attr) {
	            if (attr.name.startsWith(_I18N_ATTR_PREFIX)) {
	                i18nParsedMessageMeta[attr.name.slice(_I18N_ATTR_PREFIX.length)] =
	                    _parseMessageMeta(attr.value);
	            }
	        });
	        var /** @type {?} */ translatedAttributes = [];
	        attributes.forEach(function (attr) {
	            if (attr.name === _I18N_ATTR || attr.name.startsWith(_I18N_ATTR_PREFIX)) {
	                // strip i18n specific attributes
	                return;
	            }
	            if (attr.value && attr.value != '' && i18nParsedMessageMeta.hasOwnProperty(attr.name)) {
	                var _a = i18nParsedMessageMeta[attr.name], meaning = _a.meaning, description = _a.description, id = _a.id;
	                var /** @type {?} */ message = _this._createI18nMessage([attr], meaning, description, id);
	                var /** @type {?} */ nodes = _this._translations.get(message);
	                if (nodes) {
	                    if (nodes.length == 0) {
	                        translatedAttributes.push(new Attribute$1(attr.name, '', attr.sourceSpan));
	                    }
	                    else if (nodes[0] instanceof Text) {
	                        var /** @type {?} */ value = (/** @type {?} */ (nodes[0])).value;
	                        translatedAttributes.push(new Attribute$1(attr.name, value, attr.sourceSpan));
	                    }
	                    else {
	                        _this._reportError(el, "Unexpected translation for attribute \"" + attr.name + "\" (id=\"" + (id || _this._translations.digest(message)) + "\")");
	                    }
	                }
	                else {
	                    _this._reportError(el, "Translation unavailable for attribute \"" + attr.name + "\" (id=\"" + (id || _this._translations.digest(message)) + "\")");
	                }
	            }
	            else {
	                translatedAttributes.push(attr);
	            }
	        });
	        return translatedAttributes;
	    };
	    /**
	     * Add the node as a child of the block when:
	     * - we are in a block,
	     * - we are not inside a ICU message (those are handled separately),
	     * - the node is a "direct child" of the block
	     * @param {?} node
	     * @return {?}
	     */
	    _Visitor.prototype._mayBeAddBlockChildren = /**
	     * Add the node as a child of the block when:
	     * - we are in a block,
	     * - we are not inside a ICU message (those are handled separately),
	     * - the node is a "direct child" of the block
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        if (this._inI18nBlock && !this._inIcu && this._depth == this._blockStartDepth) {
	            this._blockChildren.push(node);
	        }
	    };
	    /**
	     * Marks the start of a section, see `_closeTranslatableSection`
	     * @param {?} node
	     * @return {?}
	     */
	    _Visitor.prototype._openTranslatableSection = /**
	     * Marks the start of a section, see `_closeTranslatableSection`
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        if (this._isInTranslatableSection) {
	            this._reportError(node, 'Unexpected section start');
	        }
	        else {
	            this._msgCountAtSectionStart = this._messages.length;
	        }
	    };
	    Object.defineProperty(_Visitor.prototype, "_isInTranslatableSection", {
	        get: /**
	         * A translatable section could be:
	         * - the content of translatable element,
	         * - nodes between `<!-- i18n -->` and `<!-- /i18n -->` comments
	         * @return {?}
	         */
	        function () {
	            return this._msgCountAtSectionStart !== void 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Terminates a section.
	     *
	     * If a section has only one significant children (comments not significant) then we should not
	     * keep the message from this children:
	     *
	     * `<p i18n="meaning|description">{ICU message}</p>` would produce two messages:
	     * - one for the <p> content with meaning and description,
	     * - another one for the ICU message.
	     *
	     * In this case the last message is discarded as it contains less information (the AST is
	     * otherwise identical).
	     *
	     * Note that we should still keep messages extracted from attributes inside the section (ie in the
	     * ICU message here)
	     * @param {?} node
	     * @param {?} directChildren
	     * @return {?}
	     */
	    _Visitor.prototype._closeTranslatableSection = /**
	     * Terminates a section.
	     *
	     * If a section has only one significant children (comments not significant) then we should not
	     * keep the message from this children:
	     *
	     * `<p i18n="meaning|description">{ICU message}</p>` would produce two messages:
	     * - one for the <p> content with meaning and description,
	     * - another one for the ICU message.
	     *
	     * In this case the last message is discarded as it contains less information (the AST is
	     * otherwise identical).
	     *
	     * Note that we should still keep messages extracted from attributes inside the section (ie in the
	     * ICU message here)
	     * @param {?} node
	     * @param {?} directChildren
	     * @return {?}
	     */
	    function (node, directChildren) {
	        if (!this._isInTranslatableSection) {
	            this._reportError(node, 'Unexpected section end');
	            return;
	        }
	        var /** @type {?} */ startIndex = this._msgCountAtSectionStart;
	        var /** @type {?} */ significantChildren = directChildren.reduce(function (count, node) { return count + (node instanceof Comment ? 0 : 1); }, 0);
	        if (significantChildren == 1) {
	            for (var /** @type {?} */ i = this._messages.length - 1; i >= /** @type {?} */ ((startIndex)); i--) {
	                var /** @type {?} */ ast = this._messages[i].nodes;
	                if (!(ast.length == 1 && ast[0] instanceof Text$1)) {
	                    this._messages.splice(i, 1);
	                    break;
	                }
	            }
	        }
	        this._msgCountAtSectionStart = undefined;
	    };
	    /**
	     * @param {?} node
	     * @param {?} msg
	     * @return {?}
	     */
	    _Visitor.prototype._reportError = /**
	     * @param {?} node
	     * @param {?} msg
	     * @return {?}
	     */
	    function (node, msg) {
	        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), msg));
	    };
	    return _Visitor;
	}());
	/**
	 * @param {?} n
	 * @return {?}
	 */
	function _isOpeningComment(n) {
	    return !!(n instanceof Comment && n.value && n.value.startsWith('i18n'));
	}
	/**
	 * @param {?} n
	 * @return {?}
	 */
	function _isClosingComment(n) {
	    return !!(n instanceof Comment && n.value && n.value === '/i18n');
	}
	/**
	 * @param {?} p
	 * @return {?}
	 */
	function _getI18nAttr(p) {
	    return p.attrs.find(function (attr) { return attr.name === _I18N_ATTR; }) || null;
	}
	/**
	 * @param {?=} i18n
	 * @return {?}
	 */
	function _parseMessageMeta(i18n) {
	    if (!i18n)
	        return { meaning: '', description: '', id: '' };
	    var /** @type {?} */ idIndex = i18n.indexOf(ID_SEPARATOR);
	    var /** @type {?} */ descIndex = i18n.indexOf(MEANING_SEPARATOR);
	    var _a = (idIndex > -1) ? [i18n.slice(0, idIndex), i18n.slice(idIndex + 2)] : [i18n, ''], meaningAndDesc = _a[0], id = _a[1];
	    var _b = (descIndex > -1) ?
	        [meaningAndDesc.slice(0, descIndex), meaningAndDesc.slice(descIndex + 1)] :
	        ['', meaningAndDesc], meaning = _b[0], description = _b[1];
	    return { meaning: meaning, description: description, id: id };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var XmlTagDefinition = /** @class */ (function () {
	    function XmlTagDefinition() {
	        this.closedByParent = false;
	        this.contentType = TagContentType.PARSABLE_DATA;
	        this.isVoid = false;
	        this.ignoreFirstLf = false;
	        this.canSelfClose = true;
	    }
	    /**
	     * @param {?} currentParent
	     * @return {?}
	     */
	    XmlTagDefinition.prototype.requireExtraParent = /**
	     * @param {?} currentParent
	     * @return {?}
	     */
	    function (currentParent) { return false; };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    XmlTagDefinition.prototype.isClosedByChild = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return false; };
	    return XmlTagDefinition;
	}());
	var _TAG_DEFINITION = new XmlTagDefinition();
	/**
	 * @param {?} tagName
	 * @return {?}
	 */
	function getXmlTagDefinition(tagName) {
	    return _TAG_DEFINITION;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var XmlParser = /** @class */ (function (_super) {
	    __extends(XmlParser, _super);
	    function XmlParser() {
	        return _super.call(this, getXmlTagDefinition) || this;
	    }
	    /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @return {?}
	     */
	    XmlParser.prototype.parse = /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @return {?}
	     */
	    function (source, url, parseExpansionForms) {
	        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
	        return _super.prototype.parse.call(this, source, url, parseExpansionForms);
	    };
	    return XmlParser;
	}(Parser$1));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @abstract
	 */
	var Serializer = /** @class */ (function () {
	    function Serializer() {
	    }
	    // Creates a name mapper, see `PlaceholderMapper`
	    // Returning `null` means that no name mapping is used.
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Serializer.prototype.createNameMapper = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) { return null; };
	    return Serializer;
	}());
	/**
	 * A `PlaceholderMapper` converts placeholder names from internal to serialized representation and
	 * back.
	 *
	 * It should be used for serialization format that put constraints on the placeholder names.
	 * @record
	 */
	
	/**
	 * A simple mapper that take a function to transform an internal name to a public name
	 */
	var SimplePlaceholderMapper = /** @class */ (function (_super) {
	    __extends(SimplePlaceholderMapper, _super);
	    // create a mapping from the message
	    function SimplePlaceholderMapper(message, mapName) {
	        var _this = _super.call(this) || this;
	        _this.mapName = mapName;
	        _this.internalToPublic = {};
	        _this.publicToNextId = {};
	        _this.publicToInternal = {};
	        message.nodes.forEach(function (node) { return node.visit(_this); });
	        return _this;
	    }
	    /**
	     * @param {?} internalName
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.toPublicName = /**
	     * @param {?} internalName
	     * @return {?}
	     */
	    function (internalName) {
	        return this.internalToPublic.hasOwnProperty(internalName) ?
	            this.internalToPublic[internalName] :
	            null;
	    };
	    /**
	     * @param {?} publicName
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.toInternalName = /**
	     * @param {?} publicName
	     * @return {?}
	     */
	    function (publicName) {
	        return this.publicToInternal.hasOwnProperty(publicName) ? this.publicToInternal[publicName] :
	            null;
	    };
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) { return null; };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        this.visitPlaceholderName(ph.startName);
	        _super.prototype.visitTagPlaceholder.call(this, ph, context);
	        this.visitPlaceholderName(ph.closeName);
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) { this.visitPlaceholderName(ph.name); };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        this.visitPlaceholderName(ph.name);
	    };
	    /**
	     * @param {?} internalName
	     * @return {?}
	     */
	    SimplePlaceholderMapper.prototype.visitPlaceholderName = /**
	     * @param {?} internalName
	     * @return {?}
	     */
	    function (internalName) {
	        if (!internalName || this.internalToPublic.hasOwnProperty(internalName)) {
	            return;
	        }
	        var /** @type {?} */ publicName = this.mapName(internalName);
	        if (this.publicToInternal.hasOwnProperty(publicName)) {
	            // Create a new XMB when it has already been used
	            var /** @type {?} */ nextId = this.publicToNextId[publicName];
	            this.publicToNextId[publicName] = nextId + 1;
	            publicName = publicName + "_" + nextId;
	        }
	        else {
	            this.publicToNextId[publicName] = 1;
	        }
	        this.internalToPublic[internalName] = publicName;
	        this.publicToInternal[publicName] = internalName;
	    };
	    return SimplePlaceholderMapper;
	}(RecurseVisitor));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	var _Visitor$1 = /** @class */ (function () {
	    function _Visitor() {
	    }
	    /**
	     * @param {?} tag
	     * @return {?}
	     */
	    _Visitor.prototype.visitTag = /**
	     * @param {?} tag
	     * @return {?}
	     */
	    function (tag) {
	        var _this = this;
	        var /** @type {?} */ strAttrs = this._serializeAttributes(tag.attrs);
	        if (tag.children.length == 0) {
	            return "<" + tag.name + strAttrs + "/>";
	        }
	        var /** @type {?} */ strChildren = tag.children.map(function (node) { return node.visit(_this); });
	        return "<" + tag.name + strAttrs + ">" + strChildren.join('') + "</" + tag.name + ">";
	    };
	    /**
	     * @param {?} text
	     * @return {?}
	     */
	    _Visitor.prototype.visitText = /**
	     * @param {?} text
	     * @return {?}
	     */
	    function (text) { return text.value; };
	    /**
	     * @param {?} decl
	     * @return {?}
	     */
	    _Visitor.prototype.visitDeclaration = /**
	     * @param {?} decl
	     * @return {?}
	     */
	    function (decl) {
	        return "<?xml" + this._serializeAttributes(decl.attrs) + " ?>";
	    };
	    /**
	     * @param {?} attrs
	     * @return {?}
	     */
	    _Visitor.prototype._serializeAttributes = /**
	     * @param {?} attrs
	     * @return {?}
	     */
	    function (attrs) {
	        var /** @type {?} */ strAttrs = Object.keys(attrs).map(function (name) { return name + "=\"" + attrs[name] + "\""; }).join(' ');
	        return strAttrs.length > 0 ? ' ' + strAttrs : '';
	    };
	    /**
	     * @param {?} doctype
	     * @return {?}
	     */
	    _Visitor.prototype.visitDoctype = /**
	     * @param {?} doctype
	     * @return {?}
	     */
	    function (doctype) {
	        return "<!DOCTYPE " + doctype.rootTag + " [\n" + doctype.dtd + "\n]>";
	    };
	    return _Visitor;
	}());
	var _visitor = new _Visitor$1();
	/**
	 * @param {?} nodes
	 * @return {?}
	 */
	function serialize(nodes) {
	    return nodes.map(function (node) { return node.visit(_visitor); }).join('');
	}
	/**
	 * @record
	 */
	
	var Declaration = /** @class */ (function () {
	    function Declaration(unescapedAttrs) {
	        var _this = this;
	        this.attrs = {};
	        Object.keys(unescapedAttrs).forEach(function (k) {
	            _this.attrs[k] = escapeXml(unescapedAttrs[k]);
	        });
	    }
	    /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    Declaration.prototype.visit = /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    function (visitor) { return visitor.visitDeclaration(this); };
	    return Declaration;
	}());
	var Doctype = /** @class */ (function () {
	    function Doctype(rootTag, dtd) {
	        this.rootTag = rootTag;
	        this.dtd = dtd;
	    }
	    /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    Doctype.prototype.visit = /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    function (visitor) { return visitor.visitDoctype(this); };
	    return Doctype;
	}());
	var Tag = /** @class */ (function () {
	    function Tag(name, unescapedAttrs, children) {
	        if (unescapedAttrs === void 0) { unescapedAttrs = {}; }
	        if (children === void 0) { children = []; }
	        var _this = this;
	        this.name = name;
	        this.children = children;
	        this.attrs = {};
	        Object.keys(unescapedAttrs).forEach(function (k) {
	            _this.attrs[k] = escapeXml(unescapedAttrs[k]);
	        });
	    }
	    /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    Tag.prototype.visit = /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    function (visitor) { return visitor.visitTag(this); };
	    return Tag;
	}());
	var Text$2 = /** @class */ (function () {
	    function Text(unescapedValue) {
	        this.value = escapeXml(unescapedValue);
	    }
	    /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    Text.prototype.visit = /**
	     * @param {?} visitor
	     * @return {?}
	     */
	    function (visitor) { return visitor.visitText(this); };
	    return Text;
	}());
	var CR = /** @class */ (function (_super) {
	    __extends(CR, _super);
	    function CR(ws) {
	        if (ws === void 0) { ws = 0; }
	        return _super.call(this, "\n" + new Array(ws + 1).join(' ')) || this;
	    }
	    return CR;
	}(Text$2));
	var _ESCAPED_CHARS = [
	    [/&/g, '&amp;'],
	    [/"/g, '&quot;'],
	    [/'/g, '&apos;'],
	    [/</g, '&lt;'],
	    [/>/g, '&gt;'],
	];
	/**
	 * @param {?} text
	 * @return {?}
	 */
	function escapeXml(text) {
	    return _ESCAPED_CHARS.reduce(function (text, entry) { return text.replace(entry[0], entry[1]); }, text);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _VERSION = '1.2';
	var _XMLNS = 'urn:oasis:names:tc:xliff:document:1.2';
	// TODO(vicb): make this a param (s/_/-/)
	var _DEFAULT_SOURCE_LANG = 'en';
	var _PLACEHOLDER_TAG = 'x';
	var _MARKER_TAG = 'mrk';
	var _FILE_TAG = 'file';
	var _SOURCE_TAG = 'source';
	var _SEGMENT_SOURCE_TAG = 'seg-source';
	var _TARGET_TAG = 'target';
	var _UNIT_TAG = 'trans-unit';
	var _CONTEXT_GROUP_TAG = 'context-group';
	var _CONTEXT_TAG = 'context';
	var Xliff = /** @class */ (function (_super) {
	    __extends(Xliff, _super);
	    function Xliff() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    Xliff.prototype.write = /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    function (messages, locale) {
	        var /** @type {?} */ visitor = new _WriteVisitor();
	        var /** @type {?} */ transUnits = [];
	        messages.forEach(function (message) {
	            var /** @type {?} */ contextTags = [];
	            message.sources.forEach(function (source) {
	                var /** @type {?} */ contextGroupTag = new Tag(_CONTEXT_GROUP_TAG, { purpose: 'location' });
	                contextGroupTag.children.push(new CR(10), new Tag(_CONTEXT_TAG, { 'context-type': 'sourcefile' }, [new Text$2(source.filePath)]), new CR(10), new Tag(_CONTEXT_TAG, { 'context-type': 'linenumber' }, [new Text$2("" + source.startLine)]), new CR(8));
	                contextTags.push(new CR(8), contextGroupTag);
	            });
	            var /** @type {?} */ transUnit = new Tag(_UNIT_TAG, { id: message.id, datatype: 'html' });
	            (_a = transUnit.children).push.apply(_a, [new CR(8), new Tag(_SOURCE_TAG, {}, visitor.serialize(message.nodes))].concat(contextTags));
	            if (message.description) {
	                transUnit.children.push(new CR(8), new Tag('note', { priority: '1', from: 'description' }, [new Text$2(message.description)]));
	            }
	            if (message.meaning) {
	                transUnit.children.push(new CR(8), new Tag('note', { priority: '1', from: 'meaning' }, [new Text$2(message.meaning)]));
	            }
	            transUnit.children.push(new CR(6));
	            transUnits.push(new CR(6), transUnit);
	            var _a;
	        });
	        var /** @type {?} */ body = new Tag('body', {}, transUnits.concat([new CR(4)]));
	        var /** @type {?} */ file = new Tag('file', {
	            'source-language': locale || _DEFAULT_SOURCE_LANG,
	            datatype: 'plaintext',
	            original: 'ng2.template',
	        }, [new CR(4), body, new CR(2)]);
	        var /** @type {?} */ xliff = new Tag('xliff', { version: _VERSION, xmlns: _XMLNS }, [new CR(2), file, new CR()]);
	        return serialize([
	            new Declaration({ version: '1.0', encoding: 'UTF-8' }), new CR(), xliff, new CR()
	        ]);
	    };
	    /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    Xliff.prototype.load = /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    function (content, url) {
	        // xliff to xml nodes
	        var /** @type {?} */ xliffParser = new XliffParser();
	        var _a = xliffParser.parse(content, url), locale = _a.locale, msgIdToHtml = _a.msgIdToHtml, errors = _a.errors;
	        // xml nodes to i18n nodes
	        var /** @type {?} */ i18nNodesByMsgId = {};
	        var /** @type {?} */ converter = new XmlToI18n();
	        Object.keys(msgIdToHtml).forEach(function (msgId) {
	            var _a = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _a.i18nNodes, e = _a.errors;
	            errors.push.apply(errors, e);
	            i18nNodesByMsgId[msgId] = i18nNodes;
	        });
	        if (errors.length) {
	            throw new Error("xliff parse errors:\n" + errors.join('\n'));
	        }
	        return { locale: /** @type {?} */ ((locale)), i18nNodesByMsgId: i18nNodesByMsgId };
	    };
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Xliff.prototype.digest = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) { return digest(message); };
	    return Xliff;
	}(Serializer));
	var _WriteVisitor = /** @class */ (function () {
	    function _WriteVisitor() {
	    }
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) { return [new Text$2(text.value)]; };
	    /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        var /** @type {?} */ nodes = [];
	        container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
	        return nodes;
	    };
	    /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
	        Object.keys(icu.cases).forEach(function (c) {
	            nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
	        });
	        nodes.push(new Text$2("}"));
	        return nodes;
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ ctype = getCtypeForTag(ph.tag);
	        if (ph.isVoid) {
	            // void tags have no children nor closing tags
	            return [new Tag(_PLACEHOLDER_TAG, { id: ph.startName, ctype: ctype, 'equiv-text': "<" + ph.tag + "/>" })];
	        }
	        var /** @type {?} */ startTagPh = new Tag(_PLACEHOLDER_TAG, { id: ph.startName, ctype: ctype, 'equiv-text': "<" + ph.tag + ">" });
	        var /** @type {?} */ closeTagPh = new Tag(_PLACEHOLDER_TAG, { id: ph.closeName, ctype: ctype, 'equiv-text': "</" + ph.tag + ">" });
	        return [startTagPh].concat(this.serialize(ph.children), [closeTagPh]);
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        return [new Tag(_PLACEHOLDER_TAG, { id: ph.name, 'equiv-text': "{{" + ph.value + "}}" })];
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ equivText = "{" + ph.value.expression + ", " + ph.value.type + ", " + Object.keys(ph.value.cases).map(function (value) { return value + ' {...}'; }).join(' ') + "}";
	        return [new Tag(_PLACEHOLDER_TAG, { id: ph.name, 'equiv-text': equivText })];
	    };
	    /**
	     * @param {?} nodes
	     * @return {?}
	     */
	    _WriteVisitor.prototype.serialize = /**
	     * @param {?} nodes
	     * @return {?}
	     */
	    function (nodes) {
	        var _this = this;
	        return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
	    };
	    return _WriteVisitor;
	}());
	var XliffParser = /** @class */ (function () {
	    function XliffParser() {
	        this._locale = null;
	    }
	    /**
	     * @param {?} xliff
	     * @param {?} url
	     * @return {?}
	     */
	    XliffParser.prototype.parse = /**
	     * @param {?} xliff
	     * @param {?} url
	     * @return {?}
	     */
	    function (xliff, url) {
	        this._unitMlString = null;
	        this._msgIdToHtml = {};
	        var /** @type {?} */ xml = new XmlParser().parse(xliff, url, false);
	        this._errors = xml.errors;
	        visitAll(this, xml.rootNodes, null);
	        return {
	            msgIdToHtml: this._msgIdToHtml,
	            errors: this._errors,
	            locale: this._locale,
	        };
	    };
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    XliffParser.prototype.visitElement = /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) {
	        switch (element.name) {
	            case _UNIT_TAG:
	                this._unitMlString = /** @type {?} */ ((null));
	                var /** @type {?} */ idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
	                if (!idAttr) {
	                    this._addError(element, "<" + _UNIT_TAG + "> misses the \"id\" attribute");
	                }
	                else {
	                    var /** @type {?} */ id = idAttr.value;
	                    if (this._msgIdToHtml.hasOwnProperty(id)) {
	                        this._addError(element, "Duplicated translations for msg " + id);
	                    }
	                    else {
	                        visitAll(this, element.children, null);
	                        if (typeof this._unitMlString === 'string') {
	                            this._msgIdToHtml[id] = this._unitMlString;
	                        }
	                        else {
	                            this._addError(element, "Message " + id + " misses a translation");
	                        }
	                    }
	                }
	                break;
	            // ignore those tags
	            case _SOURCE_TAG:
	            case _SEGMENT_SOURCE_TAG:
	                break;
	            case _TARGET_TAG:
	                var /** @type {?} */ innerTextStart = /** @type {?} */ ((element.startSourceSpan)).end.offset;
	                var /** @type {?} */ innerTextEnd = /** @type {?} */ ((element.endSourceSpan)).start.offset;
	                var /** @type {?} */ content = /** @type {?} */ ((element.startSourceSpan)).start.file.content;
	                var /** @type {?} */ innerText = content.slice(innerTextStart, innerTextEnd);
	                this._unitMlString = innerText;
	                break;
	            case _FILE_TAG:
	                var /** @type {?} */ localeAttr = element.attrs.find(function (attr) { return attr.name === 'target-language'; });
	                if (localeAttr) {
	                    this._locale = localeAttr.value;
	                }
	                visitAll(this, element.children, null);
	                break;
	            default:
	                // TODO(vicb): assert file structure, xliff version
	                // For now only recurse on unhandled nodes
	                visitAll(this, element.children, null);
	        }
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    XliffParser.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    XliffParser.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    XliffParser.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { };
	    /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    XliffParser.prototype.visitExpansion = /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansion, context) { };
	    /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    XliffParser.prototype.visitExpansionCase = /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansionCase, context) { };
	    /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    XliffParser.prototype._addError = /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    function (node, message) {
	        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
	    };
	    return XliffParser;
	}());
	var XmlToI18n = /** @class */ (function () {
	    function XmlToI18n() {
	    }
	    /**
	     * @param {?} message
	     * @param {?} url
	     * @return {?}
	     */
	    XmlToI18n.prototype.convert = /**
	     * @param {?} message
	     * @param {?} url
	     * @return {?}
	     */
	    function (message, url) {
	        var /** @type {?} */ xmlIcu = new XmlParser().parse(message, url, true);
	        this._errors = xmlIcu.errors;
	        var /** @type {?} */ i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
	            [] : [].concat.apply([], visitAll(this, xmlIcu.rootNodes));
	        return {
	            i18nNodes: i18nNodes,
	            errors: this._errors,
	        };
	    };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { return new Text$1(text.value, /** @type {?} */ ((text.sourceSpan))); };
	    /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitElement = /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    function (el, context) {
	        if (el.name === _PLACEHOLDER_TAG) {
	            var /** @type {?} */ nameAttr = el.attrs.find(function (attr) { return attr.name === 'id'; });
	            if (nameAttr) {
	                return new Placeholder('', nameAttr.value, /** @type {?} */ ((el.sourceSpan)));
	            }
	            this._addError(el, "<" + _PLACEHOLDER_TAG + "> misses the \"id\" attribute");
	            return null;
	        }
	        if (el.name === _MARKER_TAG) {
	            return [].concat.apply([], visitAll(this, el.children));
	        }
	        this._addError(el, "Unexpected tag");
	        return null;
	    };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitExpansion = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var /** @type {?} */ caseMap = {};
	        visitAll(this, icu.cases).forEach(function (c) {
	            caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
	        });
	        return new Icu(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
	    };
	    /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitExpansionCase = /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (icuCase, context) {
	        return {
	            value: icuCase.value,
	            nodes: visitAll(this, icuCase.expression),
	        };
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { };
	    /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    XmlToI18n.prototype._addError = /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    function (node, message) {
	        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
	    };
	    return XmlToI18n;
	}());
	/**
	 * @param {?} tag
	 * @return {?}
	 */
	function getCtypeForTag(tag) {
	    switch (tag.toLowerCase()) {
	        case 'br':
	            return 'lb';
	        case 'img':
	            return 'image';
	        default:
	            return "x-" + tag;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _VERSION$1 = '2.0';
	var _XMLNS$1 = 'urn:oasis:names:tc:xliff:document:2.0';
	// TODO(vicb): make this a param (s/_/-/)
	var _DEFAULT_SOURCE_LANG$1 = 'en';
	var _PLACEHOLDER_TAG$1 = 'ph';
	var _PLACEHOLDER_SPANNING_TAG = 'pc';
	var _MARKER_TAG$1 = 'mrk';
	var _XLIFF_TAG = 'xliff';
	var _SOURCE_TAG$1 = 'source';
	var _TARGET_TAG$1 = 'target';
	var _UNIT_TAG$1 = 'unit';
	var Xliff2 = /** @class */ (function (_super) {
	    __extends(Xliff2, _super);
	    function Xliff2() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    Xliff2.prototype.write = /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    function (messages, locale) {
	        var /** @type {?} */ visitor = new _WriteVisitor$1();
	        var /** @type {?} */ units = [];
	        messages.forEach(function (message) {
	            var /** @type {?} */ unit = new Tag(_UNIT_TAG$1, { id: message.id });
	            var /** @type {?} */ notes = new Tag('notes');
	            if (message.description || message.meaning) {
	                if (message.description) {
	                    notes.children.push(new CR(8), new Tag('note', { category: 'description' }, [new Text$2(message.description)]));
	                }
	                if (message.meaning) {
	                    notes.children.push(new CR(8), new Tag('note', { category: 'meaning' }, [new Text$2(message.meaning)]));
	                }
	            }
	            message.sources.forEach(function (source) {
	                notes.children.push(new CR(8), new Tag('note', { category: 'location' }, [
	                    new Text$2(source.filePath + ":" + source.startLine + (source.endLine !== source.startLine ? ',' + source.endLine : ''))
	                ]));
	            });
	            notes.children.push(new CR(6));
	            unit.children.push(new CR(6), notes);
	            var /** @type {?} */ segment = new Tag('segment');
	            segment.children.push(new CR(8), new Tag(_SOURCE_TAG$1, {}, visitor.serialize(message.nodes)), new CR(6));
	            unit.children.push(new CR(6), segment, new CR(4));
	            units.push(new CR(4), unit);
	        });
	        var /** @type {?} */ file = new Tag('file', { 'original': 'ng.template', id: 'ngi18n' }, units.concat([new CR(2)]));
	        var /** @type {?} */ xliff = new Tag(_XLIFF_TAG, { version: _VERSION$1, xmlns: _XMLNS$1, srcLang: locale || _DEFAULT_SOURCE_LANG$1 }, [new CR(2), file, new CR()]);
	        return serialize([
	            new Declaration({ version: '1.0', encoding: 'UTF-8' }), new CR(), xliff, new CR()
	        ]);
	    };
	    /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    Xliff2.prototype.load = /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    function (content, url) {
	        // xliff to xml nodes
	        var /** @type {?} */ xliff2Parser = new Xliff2Parser();
	        var _a = xliff2Parser.parse(content, url), locale = _a.locale, msgIdToHtml = _a.msgIdToHtml, errors = _a.errors;
	        // xml nodes to i18n nodes
	        var /** @type {?} */ i18nNodesByMsgId = {};
	        var /** @type {?} */ converter = new XmlToI18n$1();
	        Object.keys(msgIdToHtml).forEach(function (msgId) {
	            var _a = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _a.i18nNodes, e = _a.errors;
	            errors.push.apply(errors, e);
	            i18nNodesByMsgId[msgId] = i18nNodes;
	        });
	        if (errors.length) {
	            throw new Error("xliff2 parse errors:\n" + errors.join('\n'));
	        }
	        return { locale: /** @type {?} */ ((locale)), i18nNodesByMsgId: i18nNodesByMsgId };
	    };
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Xliff2.prototype.digest = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) { return decimalDigest(message); };
	    return Xliff2;
	}(Serializer));
	var _WriteVisitor$1 = /** @class */ (function () {
	    function _WriteVisitor() {
	    }
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) { return [new Text$2(text.value)]; };
	    /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        var /** @type {?} */ nodes = [];
	        container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
	        return nodes;
	    };
	    /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
	        Object.keys(icu.cases).forEach(function (c) {
	            nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
	        });
	        nodes.push(new Text$2("}"));
	        return nodes;
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var _this = this;
	        var /** @type {?} */ type = getTypeForTag(ph.tag);
	        if (ph.isVoid) {
	            var /** @type {?} */ tagPh = new Tag(_PLACEHOLDER_TAG$1, {
	                id: (this._nextPlaceholderId++).toString(),
	                equiv: ph.startName,
	                type: type,
	                disp: "<" + ph.tag + "/>",
	            });
	            return [tagPh];
	        }
	        var /** @type {?} */ tagPc = new Tag(_PLACEHOLDER_SPANNING_TAG, {
	            id: (this._nextPlaceholderId++).toString(),
	            equivStart: ph.startName,
	            equivEnd: ph.closeName,
	            type: type,
	            dispStart: "<" + ph.tag + ">",
	            dispEnd: "</" + ph.tag + ">",
	        });
	        var /** @type {?} */ nodes = [].concat.apply([], ph.children.map(function (node) { return node.visit(_this); }));
	        if (nodes.length) {
	            nodes.forEach(function (node) { return tagPc.children.push(node); });
	        }
	        else {
	            tagPc.children.push(new Text$2(''));
	        }
	        return [tagPc];
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ idStr = (this._nextPlaceholderId++).toString();
	        return [new Tag(_PLACEHOLDER_TAG$1, {
	                id: idStr,
	                equiv: ph.name,
	                disp: "{{" + ph.value + "}}",
	            })];
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _WriteVisitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ cases = Object.keys(ph.value.cases).map(function (value) { return value + ' {...}'; }).join(' ');
	        var /** @type {?} */ idStr = (this._nextPlaceholderId++).toString();
	        return [new Tag(_PLACEHOLDER_TAG$1, { id: idStr, equiv: ph.name, disp: "{" + ph.value.expression + ", " + ph.value.type + ", " + cases + "}" })];
	    };
	    /**
	     * @param {?} nodes
	     * @return {?}
	     */
	    _WriteVisitor.prototype.serialize = /**
	     * @param {?} nodes
	     * @return {?}
	     */
	    function (nodes) {
	        var _this = this;
	        this._nextPlaceholderId = 0;
	        return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
	    };
	    return _WriteVisitor;
	}());
	var Xliff2Parser = /** @class */ (function () {
	    function Xliff2Parser() {
	        this._locale = null;
	    }
	    /**
	     * @param {?} xliff
	     * @param {?} url
	     * @return {?}
	     */
	    Xliff2Parser.prototype.parse = /**
	     * @param {?} xliff
	     * @param {?} url
	     * @return {?}
	     */
	    function (xliff, url) {
	        this._unitMlString = null;
	        this._msgIdToHtml = {};
	        var /** @type {?} */ xml = new XmlParser().parse(xliff, url, false);
	        this._errors = xml.errors;
	        visitAll(this, xml.rootNodes, null);
	        return {
	            msgIdToHtml: this._msgIdToHtml,
	            errors: this._errors,
	            locale: this._locale,
	        };
	    };
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    Xliff2Parser.prototype.visitElement = /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) {
	        switch (element.name) {
	            case _UNIT_TAG$1:
	                this._unitMlString = null;
	                var /** @type {?} */ idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
	                if (!idAttr) {
	                    this._addError(element, "<" + _UNIT_TAG$1 + "> misses the \"id\" attribute");
	                }
	                else {
	                    var /** @type {?} */ id = idAttr.value;
	                    if (this._msgIdToHtml.hasOwnProperty(id)) {
	                        this._addError(element, "Duplicated translations for msg " + id);
	                    }
	                    else {
	                        visitAll(this, element.children, null);
	                        if (typeof this._unitMlString === 'string') {
	                            this._msgIdToHtml[id] = this._unitMlString;
	                        }
	                        else {
	                            this._addError(element, "Message " + id + " misses a translation");
	                        }
	                    }
	                }
	                break;
	            case _SOURCE_TAG$1:
	                // ignore source message
	                break;
	            case _TARGET_TAG$1:
	                var /** @type {?} */ innerTextStart = /** @type {?} */ ((element.startSourceSpan)).end.offset;
	                var /** @type {?} */ innerTextEnd = /** @type {?} */ ((element.endSourceSpan)).start.offset;
	                var /** @type {?} */ content = /** @type {?} */ ((element.startSourceSpan)).start.file.content;
	                var /** @type {?} */ innerText = content.slice(innerTextStart, innerTextEnd);
	                this._unitMlString = innerText;
	                break;
	            case _XLIFF_TAG:
	                var /** @type {?} */ localeAttr = element.attrs.find(function (attr) { return attr.name === 'trgLang'; });
	                if (localeAttr) {
	                    this._locale = localeAttr.value;
	                }
	                var /** @type {?} */ versionAttr = element.attrs.find(function (attr) { return attr.name === 'version'; });
	                if (versionAttr) {
	                    var /** @type {?} */ version = versionAttr.value;
	                    if (version !== '2.0') {
	                        this._addError(element, "The XLIFF file version " + version + " is not compatible with XLIFF 2.0 serializer");
	                    }
	                    else {
	                        visitAll(this, element.children, null);
	                    }
	                }
	                break;
	            default:
	                visitAll(this, element.children, null);
	        }
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    Xliff2Parser.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    Xliff2Parser.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    Xliff2Parser.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { };
	    /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    Xliff2Parser.prototype.visitExpansion = /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansion, context) { };
	    /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    Xliff2Parser.prototype.visitExpansionCase = /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansionCase, context) { };
	    /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    Xliff2Parser.prototype._addError = /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    function (node, message) {
	        this._errors.push(new I18nError(node.sourceSpan, message));
	    };
	    return Xliff2Parser;
	}());
	var XmlToI18n$1 = /** @class */ (function () {
	    function XmlToI18n() {
	    }
	    /**
	     * @param {?} message
	     * @param {?} url
	     * @return {?}
	     */
	    XmlToI18n.prototype.convert = /**
	     * @param {?} message
	     * @param {?} url
	     * @return {?}
	     */
	    function (message, url) {
	        var /** @type {?} */ xmlIcu = new XmlParser().parse(message, url, true);
	        this._errors = xmlIcu.errors;
	        var /** @type {?} */ i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
	            [] : [].concat.apply([], visitAll(this, xmlIcu.rootNodes));
	        return {
	            i18nNodes: i18nNodes,
	            errors: this._errors,
	        };
	    };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { return new Text$1(text.value, text.sourceSpan); };
	    /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitElement = /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    function (el, context) {
	        var _this = this;
	        switch (el.name) {
	            case _PLACEHOLDER_TAG$1:
	                var /** @type {?} */ nameAttr = el.attrs.find(function (attr) { return attr.name === 'equiv'; });
	                if (nameAttr) {
	                    return [new Placeholder('', nameAttr.value, el.sourceSpan)];
	                }
	                this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"equiv\" attribute");
	                break;
	            case _PLACEHOLDER_SPANNING_TAG:
	                var /** @type {?} */ startAttr = el.attrs.find(function (attr) { return attr.name === 'equivStart'; });
	                var /** @type {?} */ endAttr = el.attrs.find(function (attr) { return attr.name === 'equivEnd'; });
	                if (!startAttr) {
	                    this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"equivStart\" attribute");
	                }
	                else if (!endAttr) {
	                    this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"equivEnd\" attribute");
	                }
	                else {
	                    var /** @type {?} */ startId = startAttr.value;
	                    var /** @type {?} */ endId = endAttr.value;
	                    var /** @type {?} */ nodes = [];
	                    return nodes.concat.apply(nodes, [new Placeholder('', startId, el.sourceSpan)].concat(el.children.map(function (node) { return node.visit(_this, null); }), [new Placeholder('', endId, el.sourceSpan)]));
	                }
	                break;
	            case _MARKER_TAG$1:
	                return [].concat.apply([], visitAll(this, el.children));
	            default:
	                this._addError(el, "Unexpected tag");
	        }
	        return null;
	    };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitExpansion = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var /** @type {?} */ caseMap = {};
	        visitAll(this, icu.cases).forEach(function (c) {
	            caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
	        });
	        return new Icu(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
	    };
	    /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitExpansionCase = /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (icuCase, context) {
	        return {
	            value: icuCase.value,
	            nodes: [].concat.apply([], visitAll(this, icuCase.expression)),
	        };
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { };
	    /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    XmlToI18n.prototype._addError = /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    function (node, message) {
	        this._errors.push(new I18nError(node.sourceSpan, message));
	    };
	    return XmlToI18n;
	}());
	/**
	 * @param {?} tag
	 * @return {?}
	 */
	function getTypeForTag(tag) {
	    switch (tag.toLowerCase()) {
	        case 'br':
	        case 'b':
	        case 'i':
	        case 'u':
	            return 'fmt';
	        case 'img':
	            return 'image';
	        case 'a':
	            return 'link';
	        default:
	            return 'other';
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _MESSAGES_TAG = 'messagebundle';
	var _MESSAGE_TAG = 'msg';
	var _PLACEHOLDER_TAG$2 = 'ph';
	var _EXEMPLE_TAG = 'ex';
	var _SOURCE_TAG$2 = 'source';
	var _DOCTYPE = "<!ELEMENT messagebundle (msg)*>\n<!ATTLIST messagebundle class CDATA #IMPLIED>\n\n<!ELEMENT msg (#PCDATA|ph|source)*>\n<!ATTLIST msg id CDATA #IMPLIED>\n<!ATTLIST msg seq CDATA #IMPLIED>\n<!ATTLIST msg name CDATA #IMPLIED>\n<!ATTLIST msg desc CDATA #IMPLIED>\n<!ATTLIST msg meaning CDATA #IMPLIED>\n<!ATTLIST msg obsolete (obsolete) #IMPLIED>\n<!ATTLIST msg xml:space (default|preserve) \"default\">\n<!ATTLIST msg is_hidden CDATA #IMPLIED>\n\n<!ELEMENT source (#PCDATA)>\n\n<!ELEMENT ph (#PCDATA|ex)*>\n<!ATTLIST ph name CDATA #REQUIRED>\n\n<!ELEMENT ex (#PCDATA)>";
	var Xmb = /** @class */ (function (_super) {
	    __extends(Xmb, _super);
	    function Xmb() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    Xmb.prototype.write = /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    function (messages, locale) {
	        var /** @type {?} */ exampleVisitor = new ExampleVisitor();
	        var /** @type {?} */ visitor = new _Visitor$2();
	        var /** @type {?} */ rootNode = new Tag(_MESSAGES_TAG);
	        messages.forEach(function (message) {
	            var /** @type {?} */ attrs = { id: message.id };
	            if (message.description) {
	                attrs['desc'] = message.description;
	            }
	            if (message.meaning) {
	                attrs['meaning'] = message.meaning;
	            }
	            var /** @type {?} */ sourceTags = [];
	            message.sources.forEach(function (source) {
	                sourceTags.push(new Tag(_SOURCE_TAG$2, {}, [
	                    new Text$2(source.filePath + ":" + source.startLine + (source.endLine !== source.startLine ? ',' + source.endLine : ''))
	                ]));
	            });
	            rootNode.children.push(new CR(2), new Tag(_MESSAGE_TAG, attrs, sourceTags.concat(visitor.serialize(message.nodes))));
	        });
	        rootNode.children.push(new CR());
	        return serialize([
	            new Declaration({ version: '1.0', encoding: 'UTF-8' }),
	            new CR(),
	            new Doctype(_MESSAGES_TAG, _DOCTYPE),
	            new CR(),
	            exampleVisitor.addDefaultExamples(rootNode),
	            new CR(),
	        ]);
	    };
	    /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    Xmb.prototype.load = /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    function (content, url) {
	        throw new Error('Unsupported');
	    };
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Xmb.prototype.digest = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) { return digest$1(message); };
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Xmb.prototype.createNameMapper = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) {
	        return new SimplePlaceholderMapper(message, toPublicName);
	    };
	    return Xmb;
	}(Serializer));
	var _Visitor$2 = /** @class */ (function () {
	    function _Visitor() {
	    }
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) { return [new Text$2(text.value)]; };
	    /**
	     * @param {?} container
	     * @param {?} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        var /** @type {?} */ nodes = [];
	        container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
	        return nodes;
	    };
	    /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
	        Object.keys(icu.cases).forEach(function (c) {
	            nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
	        });
	        nodes.push(new Text$2("}"));
	        return nodes;
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ startEx = new Tag(_EXEMPLE_TAG, {}, [new Text$2("<" + ph.tag + ">")]);
	        var /** @type {?} */ startTagPh = new Tag(_PLACEHOLDER_TAG$2, { name: ph.startName }, [startEx]);
	        if (ph.isVoid) {
	            // void tags have no children nor closing tags
	            return [startTagPh];
	        }
	        var /** @type {?} */ closeEx = new Tag(_EXEMPLE_TAG, {}, [new Text$2("</" + ph.tag + ">")]);
	        var /** @type {?} */ closeTagPh = new Tag(_PLACEHOLDER_TAG$2, { name: ph.closeName }, [closeEx]);
	        return [startTagPh].concat(this.serialize(ph.children), [closeTagPh]);
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ exTag = new Tag(_EXEMPLE_TAG, {}, [new Text$2("{{" + ph.value + "}}")]);
	        return [new Tag(_PLACEHOLDER_TAG$2, { name: ph.name }, [exTag])];
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    _Visitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ exTag = new Tag(_EXEMPLE_TAG, {}, [
	            new Text$2("{" + ph.value.expression + ", " + ph.value.type + ", " + Object.keys(ph.value.cases).map(function (value) { return value + ' {...}'; }).join(' ') + "}")
	        ]);
	        return [new Tag(_PLACEHOLDER_TAG$2, { name: ph.name }, [exTag])];
	    };
	    /**
	     * @param {?} nodes
	     * @return {?}
	     */
	    _Visitor.prototype.serialize = /**
	     * @param {?} nodes
	     * @return {?}
	     */
	    function (nodes) {
	        var _this = this;
	        return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
	    };
	    return _Visitor;
	}());
	/**
	 * @param {?} message
	 * @return {?}
	 */
	function digest$1(message) {
	    return decimalDigest(message);
	}
	var ExampleVisitor = /** @class */ (function () {
	    function ExampleVisitor() {
	    }
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    ExampleVisitor.prototype.addDefaultExamples = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        node.visit(this);
	        return node;
	    };
	    /**
	     * @param {?} tag
	     * @return {?}
	     */
	    ExampleVisitor.prototype.visitTag = /**
	     * @param {?} tag
	     * @return {?}
	     */
	    function (tag) {
	        var _this = this;
	        if (tag.name === _PLACEHOLDER_TAG$2) {
	            if (!tag.children || tag.children.length == 0) {
	                var /** @type {?} */ exText = new Text$2(tag.attrs['name'] || '...');
	                tag.children = [new Tag(_EXEMPLE_TAG, {}, [exText])];
	            }
	        }
	        else if (tag.children) {
	            tag.children.forEach(function (node) { return node.visit(_this); });
	        }
	    };
	    /**
	     * @param {?} text
	     * @return {?}
	     */
	    ExampleVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @return {?}
	     */
	    function (text) { };
	    /**
	     * @param {?} decl
	     * @return {?}
	     */
	    ExampleVisitor.prototype.visitDeclaration = /**
	     * @param {?} decl
	     * @return {?}
	     */
	    function (decl) { };
	    /**
	     * @param {?} doctype
	     * @return {?}
	     */
	    ExampleVisitor.prototype.visitDoctype = /**
	     * @param {?} doctype
	     * @return {?}
	     */
	    function (doctype) { };
	    return ExampleVisitor;
	}());
	/**
	 * @param {?} internalName
	 * @return {?}
	 */
	function toPublicName(internalName) {
	    return internalName.toUpperCase().replace(/[^A-Z0-9_]/g, '_');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _TRANSLATIONS_TAG = 'translationbundle';
	var _TRANSLATION_TAG = 'translation';
	var _PLACEHOLDER_TAG$3 = 'ph';
	var Xtb = /** @class */ (function (_super) {
	    __extends(Xtb, _super);
	    function Xtb() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    Xtb.prototype.write = /**
	     * @param {?} messages
	     * @param {?} locale
	     * @return {?}
	     */
	    function (messages, locale) { throw new Error('Unsupported'); };
	    /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    Xtb.prototype.load = /**
	     * @param {?} content
	     * @param {?} url
	     * @return {?}
	     */
	    function (content, url) {
	        // xtb to xml nodes
	        var /** @type {?} */ xtbParser = new XtbParser();
	        var _a = xtbParser.parse(content, url), locale = _a.locale, msgIdToHtml = _a.msgIdToHtml, errors = _a.errors;
	        // xml nodes to i18n nodes
	        var /** @type {?} */ i18nNodesByMsgId = {};
	        var /** @type {?} */ converter = new XmlToI18n$2();
	        // Because we should be able to load xtb files that rely on features not supported by angular,
	        // we need to delay the conversion of html to i18n nodes so that non angular messages are not
	        // converted
	        Object.keys(msgIdToHtml).forEach(function (msgId) {
	            var /** @type {?} */ valueFn = function () {
	                var _a = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _a.i18nNodes, errors = _a.errors;
	                if (errors.length) {
	                    throw new Error("xtb parse errors:\n" + errors.join('\n'));
	                }
	                return i18nNodes;
	            };
	            createLazyProperty(i18nNodesByMsgId, msgId, valueFn);
	        });
	        if (errors.length) {
	            throw new Error("xtb parse errors:\n" + errors.join('\n'));
	        }
	        return { locale: /** @type {?} */ ((locale)), i18nNodesByMsgId: i18nNodesByMsgId };
	    };
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Xtb.prototype.digest = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) { return digest$1(message); };
	    /**
	     * @param {?} message
	     * @return {?}
	     */
	    Xtb.prototype.createNameMapper = /**
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) {
	        return new SimplePlaceholderMapper(message, toPublicName);
	    };
	    return Xtb;
	}(Serializer));
	/**
	 * @param {?} messages
	 * @param {?} id
	 * @param {?} valueFn
	 * @return {?}
	 */
	function createLazyProperty(messages, id, valueFn) {
	    Object.defineProperty(messages, id, {
	        configurable: true,
	        enumerable: true,
	        get: function () {
	            var /** @type {?} */ value = valueFn();
	            Object.defineProperty(messages, id, { enumerable: true, value: value });
	            return value;
	        },
	        set: function (_) { throw new Error('Could not overwrite an XTB translation'); },
	    });
	}
	var XtbParser = /** @class */ (function () {
	    function XtbParser() {
	        this._locale = null;
	    }
	    /**
	     * @param {?} xtb
	     * @param {?} url
	     * @return {?}
	     */
	    XtbParser.prototype.parse = /**
	     * @param {?} xtb
	     * @param {?} url
	     * @return {?}
	     */
	    function (xtb, url) {
	        this._bundleDepth = 0;
	        this._msgIdToHtml = {};
	        // We can not parse the ICU messages at this point as some messages might not originate
	        // from Angular that could not be lex'd.
	        var /** @type {?} */ xml = new XmlParser().parse(xtb, url, false);
	        this._errors = xml.errors;
	        visitAll(this, xml.rootNodes);
	        return {
	            msgIdToHtml: this._msgIdToHtml,
	            errors: this._errors,
	            locale: this._locale,
	        };
	    };
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    XtbParser.prototype.visitElement = /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) {
	        switch (element.name) {
	            case _TRANSLATIONS_TAG:
	                this._bundleDepth++;
	                if (this._bundleDepth > 1) {
	                    this._addError(element, "<" + _TRANSLATIONS_TAG + "> elements can not be nested");
	                }
	                var /** @type {?} */ langAttr = element.attrs.find(function (attr) { return attr.name === 'lang'; });
	                if (langAttr) {
	                    this._locale = langAttr.value;
	                }
	                visitAll(this, element.children, null);
	                this._bundleDepth--;
	                break;
	            case _TRANSLATION_TAG:
	                var /** @type {?} */ idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
	                if (!idAttr) {
	                    this._addError(element, "<" + _TRANSLATION_TAG + "> misses the \"id\" attribute");
	                }
	                else {
	                    var /** @type {?} */ id = idAttr.value;
	                    if (this._msgIdToHtml.hasOwnProperty(id)) {
	                        this._addError(element, "Duplicated translations for msg " + id);
	                    }
	                    else {
	                        var /** @type {?} */ innerTextStart = /** @type {?} */ ((element.startSourceSpan)).end.offset;
	                        var /** @type {?} */ innerTextEnd = /** @type {?} */ ((element.endSourceSpan)).start.offset;
	                        var /** @type {?} */ content = /** @type {?} */ ((element.startSourceSpan)).start.file.content;
	                        var /** @type {?} */ innerText = content.slice(/** @type {?} */ ((innerTextStart)), /** @type {?} */ ((innerTextEnd)));
	                        this._msgIdToHtml[id] = innerText;
	                    }
	                }
	                break;
	            default:
	                this._addError(element, 'Unexpected tag');
	        }
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    XtbParser.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    XtbParser.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    XtbParser.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { };
	    /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    XtbParser.prototype.visitExpansion = /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansion, context) { };
	    /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    XtbParser.prototype.visitExpansionCase = /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansionCase, context) { };
	    /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    XtbParser.prototype._addError = /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    function (node, message) {
	        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
	    };
	    return XtbParser;
	}());
	var XmlToI18n$2 = /** @class */ (function () {
	    function XmlToI18n() {
	    }
	    /**
	     * @param {?} message
	     * @param {?} url
	     * @return {?}
	     */
	    XmlToI18n.prototype.convert = /**
	     * @param {?} message
	     * @param {?} url
	     * @return {?}
	     */
	    function (message, url) {
	        var /** @type {?} */ xmlIcu = new XmlParser().parse(message, url, true);
	        this._errors = xmlIcu.errors;
	        var /** @type {?} */ i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
	            [] :
	            visitAll(this, xmlIcu.rootNodes);
	        return {
	            i18nNodes: i18nNodes,
	            errors: this._errors,
	        };
	    };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { return new Text$1(text.value, /** @type {?} */ ((text.sourceSpan))); };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitExpansion = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var /** @type {?} */ caseMap = {};
	        visitAll(this, icu.cases).forEach(function (c) {
	            caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
	        });
	        return new Icu(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
	    };
	    /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitExpansionCase = /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (icuCase, context) {
	        return {
	            value: icuCase.value,
	            nodes: visitAll(this, icuCase.expression),
	        };
	    };
	    /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitElement = /**
	     * @param {?} el
	     * @param {?} context
	     * @return {?}
	     */
	    function (el, context) {
	        if (el.name === _PLACEHOLDER_TAG$3) {
	            var /** @type {?} */ nameAttr = el.attrs.find(function (attr) { return attr.name === 'name'; });
	            if (nameAttr) {
	                return new Placeholder('', nameAttr.value, /** @type {?} */ ((el.sourceSpan)));
	            }
	            this._addError(el, "<" + _PLACEHOLDER_TAG$3 + "> misses the \"name\" attribute");
	        }
	        else {
	            this._addError(el, "Unexpected tag");
	        }
	        return null;
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    XmlToI18n.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { };
	    /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    XmlToI18n.prototype._addError = /**
	     * @param {?} node
	     * @param {?} message
	     * @return {?}
	     */
	    function (node, message) {
	        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
	    };
	    return XmlToI18n;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var HtmlParser = /** @class */ (function (_super) {
	    __extends(HtmlParser, _super);
	    function HtmlParser() {
	        return _super.call(this, getHtmlTagDefinition) || this;
	    }
	    /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    HtmlParser.prototype.parse = /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (source, url, parseExpansionForms, interpolationConfig) {
	        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        return _super.prototype.parse.call(this, source, url, parseExpansionForms, interpolationConfig);
	    };
	    return HtmlParser;
	}(Parser$1));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A container for translated messages
	 */
	var TranslationBundle = /** @class */ (function () {
	    function TranslationBundle(_i18nNodesByMsgId, locale, digest, mapperFactory, missingTranslationStrategy, console) {
	        if (_i18nNodesByMsgId === void 0) { _i18nNodesByMsgId = {}; }
	        if (missingTranslationStrategy === void 0) { missingTranslationStrategy = MissingTranslationStrategy.Warning; }
	        this._i18nNodesByMsgId = _i18nNodesByMsgId;
	        this.digest = digest;
	        this.mapperFactory = mapperFactory;
	        this._i18nToHtml = new I18nToHtmlVisitor(_i18nNodesByMsgId, locale, digest, /** @type {?} */ ((mapperFactory)), missingTranslationStrategy, console);
	    }
	    // Creates a `TranslationBundle` by parsing the given `content` with the `serializer`.
	    /**
	     * @param {?} content
	     * @param {?} url
	     * @param {?} serializer
	     * @param {?} missingTranslationStrategy
	     * @param {?=} console
	     * @return {?}
	     */
	    TranslationBundle.load = /**
	     * @param {?} content
	     * @param {?} url
	     * @param {?} serializer
	     * @param {?} missingTranslationStrategy
	     * @param {?=} console
	     * @return {?}
	     */
	    function (content, url, serializer, missingTranslationStrategy, console) {
	        var _a = serializer.load(content, url), locale = _a.locale, i18nNodesByMsgId = _a.i18nNodesByMsgId;
	        var /** @type {?} */ digestFn = function (m) { return serializer.digest(m); };
	        var /** @type {?} */ mapperFactory = function (m) { return ((serializer.createNameMapper(m))); };
	        return new TranslationBundle(i18nNodesByMsgId, locale, digestFn, mapperFactory, missingTranslationStrategy, console);
	    };
	    // Returns the translation as HTML nodes from the given source message.
	    /**
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    TranslationBundle.prototype.get = /**
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    function (srcMsg) {
	        var /** @type {?} */ html = this._i18nToHtml.convert(srcMsg);
	        if (html.errors.length) {
	            throw new Error(html.errors.join('\n'));
	        }
	        return html.nodes;
	    };
	    /**
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    TranslationBundle.prototype.has = /**
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    function (srcMsg) { return this.digest(srcMsg) in this._i18nNodesByMsgId; };
	    return TranslationBundle;
	}());
	var I18nToHtmlVisitor = /** @class */ (function () {
	    function I18nToHtmlVisitor(_i18nNodesByMsgId, _locale, _digest, _mapperFactory, _missingTranslationStrategy, _console) {
	        if (_i18nNodesByMsgId === void 0) { _i18nNodesByMsgId = {}; }
	        this._i18nNodesByMsgId = _i18nNodesByMsgId;
	        this._locale = _locale;
	        this._digest = _digest;
	        this._mapperFactory = _mapperFactory;
	        this._missingTranslationStrategy = _missingTranslationStrategy;
	        this._console = _console;
	        this._contextStack = [];
	        this._errors = [];
	    }
	    /**
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.convert = /**
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    function (srcMsg) {
	        this._contextStack.length = 0;
	        this._errors.length = 0;
	        // i18n to text
	        var /** @type {?} */ text = this._convertToText(srcMsg);
	        // text to html
	        var /** @type {?} */ url = srcMsg.nodes[0].sourceSpan.start.file.url;
	        var /** @type {?} */ html = new HtmlParser().parse(text, url, true);
	        return {
	            nodes: html.rootNodes,
	            errors: this._errors.concat(html.errors),
	        };
	    };
	    /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?=} context
	     * @return {?}
	     */
	    function (text, context) {
	        // `convert()` uses an `HtmlParser` to return `html.Node`s
	        // we should then make sure that any special characters are escaped
	        return escapeXml(text.value);
	    };
	    /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.visitContainer = /**
	     * @param {?} container
	     * @param {?=} context
	     * @return {?}
	     */
	    function (container, context) {
	        var _this = this;
	        return container.children.map(function (n) { return n.visit(_this); }).join('');
	    };
	    /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.visitIcu = /**
	     * @param {?} icu
	     * @param {?=} context
	     * @return {?}
	     */
	    function (icu, context) {
	        var _this = this;
	        var /** @type {?} */ cases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
	        // TODO(vicb): Once all format switch to using expression placeholders
	        // we should throw when the placeholder is not in the source message
	        var /** @type {?} */ exp = this._srcMsg.placeholders.hasOwnProperty(icu.expression) ?
	            this._srcMsg.placeholders[icu.expression] :
	            icu.expression;
	        return "{" + exp + ", " + icu.type + ", " + cases.join(' ') + "}";
	    };
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var /** @type {?} */ phName = this._mapper(ph.name);
	        if (this._srcMsg.placeholders.hasOwnProperty(phName)) {
	            return this._srcMsg.placeholders[phName];
	        }
	        if (this._srcMsg.placeholderToMessage.hasOwnProperty(phName)) {
	            return this._convertToText(this._srcMsg.placeholderToMessage[phName]);
	        }
	        this._addError(ph, "Unknown placeholder \"" + ph.name + "\"");
	        return '';
	    };
	    // Loaded message contains only placeholders (vs tag and icu placeholders).
	    // However when a translation can not be found, we need to serialize the source message
	    // which can contain tag placeholders
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        var _this = this;
	        var /** @type {?} */ tag = "" + ph.tag;
	        var /** @type {?} */ attrs = Object.keys(ph.attrs).map(function (name) { return name + "=\"" + ph.attrs[name] + "\""; }).join(' ');
	        if (ph.isVoid) {
	            return "<" + tag + " " + attrs + "/>";
	        }
	        var /** @type {?} */ children = ph.children.map(function (c) { return c.visit(_this); }).join('');
	        return "<" + tag + " " + attrs + ">" + children + "</" + tag + ">";
	    };
	    // Loaded message contains only placeholders (vs tag and icu placeholders).
	    // However when a translation can not be found, we need to serialize the source message
	    // which can contain tag placeholders
	    /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?=} context
	     * @return {?}
	     */
	    function (ph, context) {
	        // An ICU placeholder references the source message to be serialized
	        return this._convertToText(this._srcMsg.placeholderToMessage[ph.name]);
	    };
	    /**
	     * Convert a source message to a translated text string:
	     * - text nodes are replaced with their translation,
	     * - placeholders are replaced with their content,
	     * - ICU nodes are converted to ICU expressions.
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype._convertToText = /**
	     * Convert a source message to a translated text string:
	     * - text nodes are replaced with their translation,
	     * - placeholders are replaced with their content,
	     * - ICU nodes are converted to ICU expressions.
	     * @param {?} srcMsg
	     * @return {?}
	     */
	    function (srcMsg) {
	        var _this = this;
	        var /** @type {?} */ id = this._digest(srcMsg);
	        var /** @type {?} */ mapper = this._mapperFactory ? this._mapperFactory(srcMsg) : null;
	        var /** @type {?} */ nodes;
	        this._contextStack.push({ msg: this._srcMsg, mapper: this._mapper });
	        this._srcMsg = srcMsg;
	        if (this._i18nNodesByMsgId.hasOwnProperty(id)) {
	            // When there is a translation use its nodes as the source
	            // And create a mapper to convert serialized placeholder names to internal names
	            nodes = this._i18nNodesByMsgId[id];
	            this._mapper = function (name) { return mapper ? /** @type {?} */ ((mapper.toInternalName(name))) : name; };
	        }
	        else {
	            // When no translation has been found
	            // - report an error / a warning / nothing,
	            // - use the nodes from the original message
	            // - placeholders are already internal and need no mapper
	            if (this._missingTranslationStrategy === MissingTranslationStrategy.Error) {
	                var /** @type {?} */ ctx = this._locale ? " for locale \"" + this._locale + "\"" : '';
	                this._addError(srcMsg.nodes[0], "Missing translation for message \"" + id + "\"" + ctx);
	            }
	            else if (this._console &&
	                this._missingTranslationStrategy === MissingTranslationStrategy.Warning) {
	                var /** @type {?} */ ctx = this._locale ? " for locale \"" + this._locale + "\"" : '';
	                this._console.warn("Missing translation for message \"" + id + "\"" + ctx);
	            }
	            nodes = srcMsg.nodes;
	            this._mapper = function (name) { return name; };
	        }
	        var /** @type {?} */ text = nodes.map(function (node) { return node.visit(_this); }).join('');
	        var /** @type {?} */ context = /** @type {?} */ ((this._contextStack.pop()));
	        this._srcMsg = context.msg;
	        this._mapper = context.mapper;
	        return text;
	    };
	    /**
	     * @param {?} el
	     * @param {?} msg
	     * @return {?}
	     */
	    I18nToHtmlVisitor.prototype._addError = /**
	     * @param {?} el
	     * @param {?} msg
	     * @return {?}
	     */
	    function (el, msg) {
	        this._errors.push(new I18nError(el.sourceSpan, msg));
	    };
	    return I18nToHtmlVisitor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var I18NHtmlParser = /** @class */ (function () {
	    function I18NHtmlParser(_htmlParser, translations, translationsFormat, missingTranslation, console) {
	        if (missingTranslation === void 0) { missingTranslation = MissingTranslationStrategy.Warning; }
	        this._htmlParser = _htmlParser;
	        if (translations) {
	            var /** @type {?} */ serializer = createSerializer(translationsFormat);
	            this._translationBundle =
	                TranslationBundle.load(translations, 'i18n', serializer, missingTranslation, console);
	        }
	        else {
	            this._translationBundle =
	                new TranslationBundle({}, null, digest, undefined, missingTranslation, console);
	        }
	    }
	    /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    I18NHtmlParser.prototype.parse = /**
	     * @param {?} source
	     * @param {?} url
	     * @param {?=} parseExpansionForms
	     * @param {?=} interpolationConfig
	     * @return {?}
	     */
	    function (source, url, parseExpansionForms, interpolationConfig) {
	        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
	        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
	        var /** @type {?} */ parseResult = this._htmlParser.parse(source, url, parseExpansionForms, interpolationConfig);
	        if (parseResult.errors.length) {
	            return new ParseTreeResult(parseResult.rootNodes, parseResult.errors);
	        }
	        return mergeTranslations(parseResult.rootNodes, this._translationBundle, interpolationConfig, [], {});
	    };
	    return I18NHtmlParser;
	}());
	/**
	 * @param {?=} format
	 * @return {?}
	 */
	function createSerializer(format) {
	    format = (format || 'xlf').toLowerCase();
	    switch (format) {
	        case 'xmb':
	            return new Xmb();
	        case 'xtb':
	            return new Xtb();
	        case 'xliff2':
	        case 'xlf2':
	            return new Xliff2();
	        case 'xliff':
	        case 'xlf':
	        default:
	            return new Xliff();
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var STRIP_SRC_FILE_SUFFIXES = /(\.ts|\.d\.ts|\.js|\.jsx|\.tsx)$/;
	var GENERATED_FILE = /\.ngfactory\.|\.ngsummary\./;
	var JIT_SUMMARY_FILE = /\.ngsummary\./;
	var JIT_SUMMARY_NAME = /NgSummary$/;
	/**
	 * @param {?} filePath
	 * @param {?=} forceSourceFile
	 * @return {?}
	 */
	function ngfactoryFilePath(filePath, forceSourceFile) {
	    if (forceSourceFile === void 0) { forceSourceFile = false; }
	    var /** @type {?} */ urlWithSuffix = splitTypescriptSuffix(filePath, forceSourceFile);
	    return urlWithSuffix[0] + ".ngfactory" + normalizeGenFileSuffix(urlWithSuffix[1]);
	}
	/**
	 * @param {?} filePath
	 * @return {?}
	 */
	function stripGeneratedFileSuffix(filePath) {
	    return filePath.replace(GENERATED_FILE, '.');
	}
	/**
	 * @param {?} filePath
	 * @return {?}
	 */
	function isGeneratedFile(filePath) {
	    return GENERATED_FILE.test(filePath);
	}
	/**
	 * @param {?} path
	 * @param {?=} forceSourceFile
	 * @return {?}
	 */
	function splitTypescriptSuffix(path, forceSourceFile) {
	    if (forceSourceFile === void 0) { forceSourceFile = false; }
	    if (path.endsWith('.d.ts')) {
	        return [path.slice(0, -5), forceSourceFile ? '.ts' : '.d.ts'];
	    }
	    var /** @type {?} */ lastDot = path.lastIndexOf('.');
	    if (lastDot !== -1) {
	        return [path.substring(0, lastDot), path.substring(lastDot)];
	    }
	    return [path, ''];
	}
	/**
	 * @param {?} srcFileSuffix
	 * @return {?}
	 */
	function normalizeGenFileSuffix(srcFileSuffix) {
	    return srcFileSuffix === '.tsx' ? '.ts' : srcFileSuffix;
	}
	/**
	 * @param {?} fileName
	 * @return {?}
	 */
	function summaryFileName(fileName) {
	    var /** @type {?} */ fileNameWithoutSuffix = fileName.replace(STRIP_SRC_FILE_SUFFIXES, '');
	    return fileNameWithoutSuffix + ".ngsummary.json";
	}
	/**
	 * @param {?} fileName
	 * @param {?=} forceSourceFile
	 * @return {?}
	 */
	function summaryForJitFileName(fileName, forceSourceFile) {
	    if (forceSourceFile === void 0) { forceSourceFile = false; }
	    var /** @type {?} */ urlWithSuffix = splitTypescriptSuffix(stripGeneratedFileSuffix(fileName), forceSourceFile);
	    return urlWithSuffix[0] + ".ngsummary" + urlWithSuffix[1];
	}
	/**
	 * @param {?} filePath
	 * @return {?}
	 */
	function stripSummaryForJitFileSuffix(filePath) {
	    return filePath.replace(JIT_SUMMARY_FILE, '.');
	}
	/**
	 * @param {?} symbolName
	 * @return {?}
	 */
	function summaryForJitName(symbolName) {
	    return symbolName + "NgSummary";
	}
	/**
	 * @param {?} symbolName
	 * @return {?}
	 */
	function stripSummaryForJitNameSuffix(symbolName) {
	    return symbolName.replace(JIT_SUMMARY_NAME, '');
	}
	var LOWERED_SYMBOL = /\u0275\d+/;
	/**
	 * @param {?} name
	 * @return {?}
	 */
	function isLoweredSymbol(name) {
	    return LOWERED_SYMBOL.test(name);
	}
	/**
	 * @param {?} id
	 * @return {?}
	 */
	function createLoweredSymbol(id) {
	    return "\u0275" + id;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var CORE = '@angular/core';
	var Identifiers = /** @class */ (function () {
	    function Identifiers() {
	    }
	    Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS = {
	        name: 'ANALYZE_FOR_ENTRY_COMPONENTS',
	        moduleName: CORE,
	    };
	    Identifiers.ElementRef = { name: 'ElementRef', moduleName: CORE };
	    Identifiers.NgModuleRef = { name: 'NgModuleRef', moduleName: CORE };
	    Identifiers.ViewContainerRef = { name: 'ViewContainerRef', moduleName: CORE };
	    Identifiers.ChangeDetectorRef = {
	        name: 'ChangeDetectorRef',
	        moduleName: CORE,
	    };
	    Identifiers.QueryList = { name: 'QueryList', moduleName: CORE };
	    Identifiers.TemplateRef = { name: 'TemplateRef', moduleName: CORE };
	    Identifiers.CodegenComponentFactoryResolver = {
	        name: 'ɵCodegenComponentFactoryResolver',
	        moduleName: CORE,
	    };
	    Identifiers.ComponentFactoryResolver = {
	        name: 'ComponentFactoryResolver',
	        moduleName: CORE,
	    };
	    Identifiers.ComponentFactory = { name: 'ComponentFactory', moduleName: CORE };
	    Identifiers.ComponentRef = { name: 'ComponentRef', moduleName: CORE };
	    Identifiers.NgModuleFactory = { name: 'NgModuleFactory', moduleName: CORE };
	    Identifiers.createModuleFactory = {
	        name: 'ɵcmf',
	        moduleName: CORE,
	    };
	    Identifiers.moduleDef = {
	        name: 'ɵmod',
	        moduleName: CORE,
	    };
	    Identifiers.moduleProviderDef = {
	        name: 'ɵmpd',
	        moduleName: CORE,
	    };
	    Identifiers.RegisterModuleFactoryFn = {
	        name: 'ɵregisterModuleFactory',
	        moduleName: CORE,
	    };
	    Identifiers.Injector = { name: 'Injector', moduleName: CORE };
	    Identifiers.ViewEncapsulation = {
	        name: 'ViewEncapsulation',
	        moduleName: CORE,
	    };
	    Identifiers.ChangeDetectionStrategy = {
	        name: 'ChangeDetectionStrategy',
	        moduleName: CORE,
	    };
	    Identifiers.SecurityContext = {
	        name: 'SecurityContext',
	        moduleName: CORE,
	    };
	    Identifiers.LOCALE_ID = { name: 'LOCALE_ID', moduleName: CORE };
	    Identifiers.TRANSLATIONS_FORMAT = {
	        name: 'TRANSLATIONS_FORMAT',
	        moduleName: CORE,
	    };
	    Identifiers.inlineInterpolate = {
	        name: 'ɵinlineInterpolate',
	        moduleName: CORE,
	    };
	    Identifiers.interpolate = { name: 'ɵinterpolate', moduleName: CORE };
	    Identifiers.EMPTY_ARRAY = { name: 'ɵEMPTY_ARRAY', moduleName: CORE };
	    Identifiers.EMPTY_MAP = { name: 'ɵEMPTY_MAP', moduleName: CORE };
	    Identifiers.Renderer = { name: 'Renderer', moduleName: CORE };
	    Identifiers.viewDef = { name: 'ɵvid', moduleName: CORE };
	    Identifiers.elementDef = { name: 'ɵeld', moduleName: CORE };
	    Identifiers.anchorDef = { name: 'ɵand', moduleName: CORE };
	    Identifiers.textDef = { name: 'ɵted', moduleName: CORE };
	    Identifiers.directiveDef = { name: 'ɵdid', moduleName: CORE };
	    Identifiers.providerDef = { name: 'ɵprd', moduleName: CORE };
	    Identifiers.queryDef = { name: 'ɵqud', moduleName: CORE };
	    Identifiers.pureArrayDef = { name: 'ɵpad', moduleName: CORE };
	    Identifiers.pureObjectDef = { name: 'ɵpod', moduleName: CORE };
	    Identifiers.purePipeDef = { name: 'ɵppd', moduleName: CORE };
	    Identifiers.pipeDef = { name: 'ɵpid', moduleName: CORE };
	    Identifiers.nodeValue = { name: 'ɵnov', moduleName: CORE };
	    Identifiers.ngContentDef = { name: 'ɵncd', moduleName: CORE };
	    Identifiers.unwrapValue = { name: 'ɵunv', moduleName: CORE };
	    Identifiers.createRendererType2 = { name: 'ɵcrt', moduleName: CORE };
	    // type only
	    Identifiers.RendererType2 = {
	        name: 'RendererType2',
	        moduleName: CORE,
	    };
	    // type only
	    Identifiers.ViewDefinition = {
	        name: 'ɵViewDefinition',
	        moduleName: CORE,
	    };
	    Identifiers.createComponentFactory = { name: 'ɵccf', moduleName: CORE };
	    return Identifiers;
	}());
	/**
	 * @param {?} reference
	 * @return {?}
	 */
	function createTokenForReference(reference) {
	    return { identifier: { reference: reference } };
	}
	/**
	 * @param {?} reflector
	 * @param {?} reference
	 * @return {?}
	 */
	function createTokenForExternalReference(reflector, reference) {
	    return createTokenForReference(reflector.resolveExternalReference(reference));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var LifecycleHooks = {
	    OnInit: 0,
	    OnDestroy: 1,
	    DoCheck: 2,
	    OnChanges: 3,
	    AfterContentInit: 4,
	    AfterContentChecked: 5,
	    AfterViewInit: 6,
	    AfterViewChecked: 7,
	};
	LifecycleHooks[LifecycleHooks.OnInit] = "OnInit";
	LifecycleHooks[LifecycleHooks.OnDestroy] = "OnDestroy";
	LifecycleHooks[LifecycleHooks.DoCheck] = "DoCheck";
	LifecycleHooks[LifecycleHooks.OnChanges] = "OnChanges";
	LifecycleHooks[LifecycleHooks.AfterContentInit] = "AfterContentInit";
	LifecycleHooks[LifecycleHooks.AfterContentChecked] = "AfterContentChecked";
	LifecycleHooks[LifecycleHooks.AfterViewInit] = "AfterViewInit";
	LifecycleHooks[LifecycleHooks.AfterViewChecked] = "AfterViewChecked";
	var LIFECYCLE_HOOKS_VALUES = [
	    LifecycleHooks.OnInit, LifecycleHooks.OnDestroy, LifecycleHooks.DoCheck, LifecycleHooks.OnChanges,
	    LifecycleHooks.AfterContentInit, LifecycleHooks.AfterContentChecked, LifecycleHooks.AfterViewInit,
	    LifecycleHooks.AfterViewChecked
	];
	/**
	 * @param {?} reflector
	 * @param {?} hook
	 * @param {?} token
	 * @return {?}
	 */
	function hasLifecycleHook(reflector, hook, token) {
	    return reflector.hasLifecycleHook(token, getHookName(hook));
	}
	/**
	 * @param {?} reflector
	 * @param {?} token
	 * @return {?}
	 */
	function getAllLifecycleHooks(reflector, token) {
	    return LIFECYCLE_HOOKS_VALUES.filter(function (hook) { return hasLifecycleHook(reflector, hook, token); });
	}
	/**
	 * @param {?} hook
	 * @return {?}
	 */
	function getHookName(hook) {
	    switch (hook) {
	        case LifecycleHooks.OnInit:
	            return 'ngOnInit';
	        case LifecycleHooks.OnDestroy:
	            return 'ngOnDestroy';
	        case LifecycleHooks.DoCheck:
	            return 'ngDoCheck';
	        case LifecycleHooks.OnChanges:
	            return 'ngOnChanges';
	        case LifecycleHooks.AfterContentInit:
	            return 'ngAfterContentInit';
	        case LifecycleHooks.AfterContentChecked:
	            return 'ngAfterContentChecked';
	        case LifecycleHooks.AfterViewInit:
	            return 'ngAfterViewInit';
	        case LifecycleHooks.AfterViewChecked:
	            return 'ngAfterViewChecked';
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _SELECTOR_REGEXP = new RegExp('(\\:not\\()|' + //":not("
	    '([-\\w]+)|' + // "tag"
	    '(?:\\.([-\\w]+))|' + // ".class"
	    '(?:\\[([-.\\w*]+)(?:=([\"\']?)([^\\]\"\']*)\\5)?\\])|' + // "[name]", "[name=value]",
	    '(\\))|' + // ")"
	    '(\\s*,\\s*)', // ","
	'g');
	/**
	 * A css selector contains an element name,
	 * css classes and attribute/value pairs with the purpose
	 * of selecting subsets out of them.
	 */
	var CssSelector = /** @class */ (function () {
	    function CssSelector() {
	        this.element = null;
	        this.classNames = [];
	        this.attrs = [];
	        this.notSelectors = [];
	    }
	    /**
	     * @param {?} selector
	     * @return {?}
	     */
	    CssSelector.parse = /**
	     * @param {?} selector
	     * @return {?}
	     */
	    function (selector) {
	        var /** @type {?} */ results = [];
	        var /** @type {?} */ _addResult = function (res, cssSel) {
	            if (cssSel.notSelectors.length > 0 && !cssSel.element && cssSel.classNames.length == 0 &&
	                cssSel.attrs.length == 0) {
	                cssSel.element = '*';
	            }
	            res.push(cssSel);
	        };
	        var /** @type {?} */ cssSelector = new CssSelector();
	        var /** @type {?} */ match;
	        var /** @type {?} */ current = cssSelector;
	        var /** @type {?} */ inNot = false;
	        _SELECTOR_REGEXP.lastIndex = 0;
	        while (match = _SELECTOR_REGEXP.exec(selector)) {
	            if (match[1]) {
	                if (inNot) {
	                    throw new Error('Nesting :not is not allowed in a selector');
	                }
	                inNot = true;
	                current = new CssSelector();
	                cssSelector.notSelectors.push(current);
	            }
	            if (match[2]) {
	                current.setElement(match[2]);
	            }
	            if (match[3]) {
	                current.addClassName(match[3]);
	            }
	            if (match[4]) {
	                current.addAttribute(match[4], match[6]);
	            }
	            if (match[7]) {
	                inNot = false;
	                current = cssSelector;
	            }
	            if (match[8]) {
	                if (inNot) {
	                    throw new Error('Multiple selectors in :not are not supported');
	                }
	                _addResult(results, cssSelector);
	                cssSelector = current = new CssSelector();
	            }
	        }
	        _addResult(results, cssSelector);
	        return results;
	    };
	    /**
	     * @return {?}
	     */
	    CssSelector.prototype.isElementSelector = /**
	     * @return {?}
	     */
	    function () {
	        return this.hasElementSelector() && this.classNames.length == 0 && this.attrs.length == 0 &&
	            this.notSelectors.length === 0;
	    };
	    /**
	     * @return {?}
	     */
	    CssSelector.prototype.hasElementSelector = /**
	     * @return {?}
	     */
	    function () { return !!this.element; };
	    /**
	     * @param {?=} element
	     * @return {?}
	     */
	    CssSelector.prototype.setElement = /**
	     * @param {?=} element
	     * @return {?}
	     */
	    function (element) {
	        if (element === void 0) { element = null; }
	        this.element = element;
	    };
	    /** Gets a template string for an element that matches the selector. */
	    /**
	     * Gets a template string for an element that matches the selector.
	     * @return {?}
	     */
	    CssSelector.prototype.getMatchingElementTemplate = /**
	     * Gets a template string for an element that matches the selector.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ tagName = this.element || 'div';
	        var /** @type {?} */ classAttr = this.classNames.length > 0 ? " class=\"" + this.classNames.join(' ') + "\"" : '';
	        var /** @type {?} */ attrs = '';
	        for (var /** @type {?} */ i = 0; i < this.attrs.length; i += 2) {
	            var /** @type {?} */ attrName = this.attrs[i];
	            var /** @type {?} */ attrValue = this.attrs[i + 1] !== '' ? "=\"" + this.attrs[i + 1] + "\"" : '';
	            attrs += " " + attrName + attrValue;
	        }
	        return getHtmlTagDefinition(tagName).isVoid ? "<" + tagName + classAttr + attrs + "/>" :
	            "<" + tagName + classAttr + attrs + "></" + tagName + ">";
	    };
	    /**
	     * @param {?} name
	     * @param {?=} value
	     * @return {?}
	     */
	    CssSelector.prototype.addAttribute = /**
	     * @param {?} name
	     * @param {?=} value
	     * @return {?}
	     */
	    function (name, value) {
	        if (value === void 0) { value = ''; }
	        this.attrs.push(name, value && value.toLowerCase() || '');
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    CssSelector.prototype.addClassName = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { this.classNames.push(name.toLowerCase()); };
	    /**
	     * @return {?}
	     */
	    CssSelector.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ res = this.element || '';
	        if (this.classNames) {
	            this.classNames.forEach(function (klass) { return res += "." + klass; });
	        }
	        if (this.attrs) {
	            for (var /** @type {?} */ i = 0; i < this.attrs.length; i += 2) {
	                var /** @type {?} */ name_1 = this.attrs[i];
	                var /** @type {?} */ value = this.attrs[i + 1];
	                res += "[" + name_1 + (value ? '=' + value : '') + "]";
	            }
	        }
	        this.notSelectors.forEach(function (notSelector) { return res += ":not(" + notSelector + ")"; });
	        return res;
	    };
	    return CssSelector;
	}());
	/**
	 * Reads a list of CssSelectors and allows to calculate which ones
	 * are contained in a given CssSelector.
	 */
	var SelectorMatcher = /** @class */ (function () {
	    function SelectorMatcher() {
	        this._elementMap = new Map();
	        this._elementPartialMap = new Map();
	        this._classMap = new Map();
	        this._classPartialMap = new Map();
	        this._attrValueMap = new Map();
	        this._attrValuePartialMap = new Map();
	        this._listContexts = [];
	    }
	    /**
	     * @param {?} notSelectors
	     * @return {?}
	     */
	    SelectorMatcher.createNotMatcher = /**
	     * @param {?} notSelectors
	     * @return {?}
	     */
	    function (notSelectors) {
	        var /** @type {?} */ notMatcher = new SelectorMatcher();
	        notMatcher.addSelectables(notSelectors, null);
	        return notMatcher;
	    };
	    /**
	     * @param {?} cssSelectors
	     * @param {?=} callbackCtxt
	     * @return {?}
	     */
	    SelectorMatcher.prototype.addSelectables = /**
	     * @param {?} cssSelectors
	     * @param {?=} callbackCtxt
	     * @return {?}
	     */
	    function (cssSelectors, callbackCtxt) {
	        var /** @type {?} */ listContext = /** @type {?} */ ((null));
	        if (cssSelectors.length > 1) {
	            listContext = new SelectorListContext(cssSelectors);
	            this._listContexts.push(listContext);
	        }
	        for (var /** @type {?} */ i = 0; i < cssSelectors.length; i++) {
	            this._addSelectable(cssSelectors[i], callbackCtxt, listContext);
	        }
	    };
	    /**
	     * Add an object that can be found later on by calling `match`.
	     * @param {?} cssSelector A css selector
	     * @param {?} callbackCtxt An opaque object that will be given to the callback of the `match` function
	     * @param {?} listContext
	     * @return {?}
	     */
	    SelectorMatcher.prototype._addSelectable = /**
	     * Add an object that can be found later on by calling `match`.
	     * @param {?} cssSelector A css selector
	     * @param {?} callbackCtxt An opaque object that will be given to the callback of the `match` function
	     * @param {?} listContext
	     * @return {?}
	     */
	    function (cssSelector, callbackCtxt, listContext) {
	        var /** @type {?} */ matcher = this;
	        var /** @type {?} */ element = cssSelector.element;
	        var /** @type {?} */ classNames = cssSelector.classNames;
	        var /** @type {?} */ attrs = cssSelector.attrs;
	        var /** @type {?} */ selectable = new SelectorContext(cssSelector, callbackCtxt, listContext);
	        if (element) {
	            var /** @type {?} */ isTerminal = attrs.length === 0 && classNames.length === 0;
	            if (isTerminal) {
	                this._addTerminal(matcher._elementMap, element, selectable);
	            }
	            else {
	                matcher = this._addPartial(matcher._elementPartialMap, element);
	            }
	        }
	        if (classNames) {
	            for (var /** @type {?} */ i = 0; i < classNames.length; i++) {
	                var /** @type {?} */ isTerminal = attrs.length === 0 && i === classNames.length - 1;
	                var /** @type {?} */ className = classNames[i];
	                if (isTerminal) {
	                    this._addTerminal(matcher._classMap, className, selectable);
	                }
	                else {
	                    matcher = this._addPartial(matcher._classPartialMap, className);
	                }
	            }
	        }
	        if (attrs) {
	            for (var /** @type {?} */ i = 0; i < attrs.length; i += 2) {
	                var /** @type {?} */ isTerminal = i === attrs.length - 2;
	                var /** @type {?} */ name_2 = attrs[i];
	                var /** @type {?} */ value = attrs[i + 1];
	                if (isTerminal) {
	                    var /** @type {?} */ terminalMap = matcher._attrValueMap;
	                    var /** @type {?} */ terminalValuesMap = terminalMap.get(name_2);
	                    if (!terminalValuesMap) {
	                        terminalValuesMap = new Map();
	                        terminalMap.set(name_2, terminalValuesMap);
	                    }
	                    this._addTerminal(terminalValuesMap, value, selectable);
	                }
	                else {
	                    var /** @type {?} */ partialMap = matcher._attrValuePartialMap;
	                    var /** @type {?} */ partialValuesMap = partialMap.get(name_2);
	                    if (!partialValuesMap) {
	                        partialValuesMap = new Map();
	                        partialMap.set(name_2, partialValuesMap);
	                    }
	                    matcher = this._addPartial(partialValuesMap, value);
	                }
	            }
	        }
	    };
	    /**
	     * @param {?} map
	     * @param {?} name
	     * @param {?} selectable
	     * @return {?}
	     */
	    SelectorMatcher.prototype._addTerminal = /**
	     * @param {?} map
	     * @param {?} name
	     * @param {?} selectable
	     * @return {?}
	     */
	    function (map, name, selectable) {
	        var /** @type {?} */ terminalList = map.get(name);
	        if (!terminalList) {
	            terminalList = [];
	            map.set(name, terminalList);
	        }
	        terminalList.push(selectable);
	    };
	    /**
	     * @param {?} map
	     * @param {?} name
	     * @return {?}
	     */
	    SelectorMatcher.prototype._addPartial = /**
	     * @param {?} map
	     * @param {?} name
	     * @return {?}
	     */
	    function (map, name) {
	        var /** @type {?} */ matcher = map.get(name);
	        if (!matcher) {
	            matcher = new SelectorMatcher();
	            map.set(name, matcher);
	        }
	        return matcher;
	    };
	    /**
	     * Find the objects that have been added via `addSelectable`
	     * whose css selector is contained in the given css selector.
	     * @param cssSelector A css selector
	     * @param matchedCallback This callback will be called with the object handed into `addSelectable`
	     * @return boolean true if a match was found
	    */
	    /**
	     * Find the objects that have been added via `addSelectable`
	     * whose css selector is contained in the given css selector.
	     * @param {?} cssSelector A css selector
	     * @param {?} matchedCallback This callback will be called with the object handed into `addSelectable`
	     * @return {?} boolean true if a match was found
	     */
	    SelectorMatcher.prototype.match = /**
	     * Find the objects that have been added via `addSelectable`
	     * whose css selector is contained in the given css selector.
	     * @param {?} cssSelector A css selector
	     * @param {?} matchedCallback This callback will be called with the object handed into `addSelectable`
	     * @return {?} boolean true if a match was found
	     */
	    function (cssSelector, matchedCallback) {
	        var /** @type {?} */ result = false;
	        var /** @type {?} */ element = /** @type {?} */ ((cssSelector.element));
	        var /** @type {?} */ classNames = cssSelector.classNames;
	        var /** @type {?} */ attrs = cssSelector.attrs;
	        for (var /** @type {?} */ i = 0; i < this._listContexts.length; i++) {
	            this._listContexts[i].alreadyMatched = false;
	        }
	        result = this._matchTerminal(this._elementMap, element, cssSelector, matchedCallback) || result;
	        result = this._matchPartial(this._elementPartialMap, element, cssSelector, matchedCallback) ||
	            result;
	        if (classNames) {
	            for (var /** @type {?} */ i = 0; i < classNames.length; i++) {
	                var /** @type {?} */ className = classNames[i];
	                result =
	                    this._matchTerminal(this._classMap, className, cssSelector, matchedCallback) || result;
	                result =
	                    this._matchPartial(this._classPartialMap, className, cssSelector, matchedCallback) ||
	                        result;
	            }
	        }
	        if (attrs) {
	            for (var /** @type {?} */ i = 0; i < attrs.length; i += 2) {
	                var /** @type {?} */ name_3 = attrs[i];
	                var /** @type {?} */ value = attrs[i + 1];
	                var /** @type {?} */ terminalValuesMap = /** @type {?} */ ((this._attrValueMap.get(name_3)));
	                if (value) {
	                    result =
	                        this._matchTerminal(terminalValuesMap, '', cssSelector, matchedCallback) || result;
	                }
	                result =
	                    this._matchTerminal(terminalValuesMap, value, cssSelector, matchedCallback) || result;
	                var /** @type {?} */ partialValuesMap = /** @type {?} */ ((this._attrValuePartialMap.get(name_3)));
	                if (value) {
	                    result = this._matchPartial(partialValuesMap, '', cssSelector, matchedCallback) || result;
	                }
	                result =
	                    this._matchPartial(partialValuesMap, value, cssSelector, matchedCallback) || result;
	            }
	        }
	        return result;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} map
	     * @param {?} name
	     * @param {?} cssSelector
	     * @param {?} matchedCallback
	     * @return {?}
	     */
	    SelectorMatcher.prototype._matchTerminal = /**
	     * \@internal
	     * @param {?} map
	     * @param {?} name
	     * @param {?} cssSelector
	     * @param {?} matchedCallback
	     * @return {?}
	     */
	    function (map, name, cssSelector, matchedCallback) {
	        if (!map || typeof name !== 'string') {
	            return false;
	        }
	        var /** @type {?} */ selectables = map.get(name) || [];
	        var /** @type {?} */ starSelectables = /** @type {?} */ ((map.get('*')));
	        if (starSelectables) {
	            selectables = selectables.concat(starSelectables);
	        }
	        if (selectables.length === 0) {
	            return false;
	        }
	        var /** @type {?} */ selectable;
	        var /** @type {?} */ result = false;
	        for (var /** @type {?} */ i = 0; i < selectables.length; i++) {
	            selectable = selectables[i];
	            result = selectable.finalize(cssSelector, matchedCallback) || result;
	        }
	        return result;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} map
	     * @param {?} name
	     * @param {?} cssSelector
	     * @param {?} matchedCallback
	     * @return {?}
	     */
	    SelectorMatcher.prototype._matchPartial = /**
	     * \@internal
	     * @param {?} map
	     * @param {?} name
	     * @param {?} cssSelector
	     * @param {?} matchedCallback
	     * @return {?}
	     */
	    function (map, name, cssSelector, matchedCallback) {
	        if (!map || typeof name !== 'string') {
	            return false;
	        }
	        var /** @type {?} */ nestedSelector = map.get(name);
	        if (!nestedSelector) {
	            return false;
	        }
	        // TODO(perf): get rid of recursion and measure again
	        // TODO(perf): don't pass the whole selector into the recursion,
	        // but only the not processed parts
	        return nestedSelector.match(cssSelector, matchedCallback);
	    };
	    return SelectorMatcher;
	}());
	var SelectorListContext = /** @class */ (function () {
	    function SelectorListContext(selectors) {
	        this.selectors = selectors;
	        this.alreadyMatched = false;
	    }
	    return SelectorListContext;
	}());
	var SelectorContext = /** @class */ (function () {
	    function SelectorContext(selector, cbContext, listContext) {
	        this.selector = selector;
	        this.cbContext = cbContext;
	        this.listContext = listContext;
	        this.notSelectors = selector.notSelectors;
	    }
	    /**
	     * @param {?} cssSelector
	     * @param {?} callback
	     * @return {?}
	     */
	    SelectorContext.prototype.finalize = /**
	     * @param {?} cssSelector
	     * @param {?} callback
	     * @return {?}
	     */
	    function (cssSelector, callback) {
	        var /** @type {?} */ result = true;
	        if (this.notSelectors.length > 0 && (!this.listContext || !this.listContext.alreadyMatched)) {
	            var /** @type {?} */ notMatcher = SelectorMatcher.createNotMatcher(this.notSelectors);
	            result = !notMatcher.match(cssSelector, null);
	        }
	        if (result && callback && (!this.listContext || !this.listContext.alreadyMatched)) {
	            if (this.listContext) {
	                this.listContext.alreadyMatched = true;
	            }
	            callback(this.selector, this.cbContext);
	        }
	        return result;
	    };
	    return SelectorContext;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ERROR_COMPONENT_TYPE = 'ngComponentType';
	var CompileMetadataResolver = /** @class */ (function () {
	    function CompileMetadataResolver(_config, _htmlParser, _ngModuleResolver, _directiveResolver, _pipeResolver, _summaryResolver, _schemaRegistry, _directiveNormalizer, _console, _staticSymbolCache, _reflector, _errorCollector) {
	        this._config = _config;
	        this._htmlParser = _htmlParser;
	        this._ngModuleResolver = _ngModuleResolver;
	        this._directiveResolver = _directiveResolver;
	        this._pipeResolver = _pipeResolver;
	        this._summaryResolver = _summaryResolver;
	        this._schemaRegistry = _schemaRegistry;
	        this._directiveNormalizer = _directiveNormalizer;
	        this._console = _console;
	        this._staticSymbolCache = _staticSymbolCache;
	        this._reflector = _reflector;
	        this._errorCollector = _errorCollector;
	        this._nonNormalizedDirectiveCache = new Map();
	        this._directiveCache = new Map();
	        this._summaryCache = new Map();
	        this._pipeCache = new Map();
	        this._ngModuleCache = new Map();
	        this._ngModuleOfTypes = new Map();
	    }
	    /**
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getReflector = /**
	     * @return {?}
	     */
	    function () { return this._reflector; };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.clearCacheFor = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ dirMeta = this._directiveCache.get(type);
	        this._directiveCache.delete(type);
	        this._nonNormalizedDirectiveCache.delete(type);
	        this._summaryCache.delete(type);
	        this._pipeCache.delete(type);
	        this._ngModuleOfTypes.delete(type);
	        // Clear all of the NgModule as they contain transitive information!
	        this._ngModuleCache.clear();
	        if (dirMeta) {
	            this._directiveNormalizer.clearCacheFor(dirMeta);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.clearCache = /**
	     * @return {?}
	     */
	    function () {
	        this._directiveCache.clear();
	        this._nonNormalizedDirectiveCache.clear();
	        this._summaryCache.clear();
	        this._pipeCache.clear();
	        this._ngModuleCache.clear();
	        this._ngModuleOfTypes.clear();
	        this._directiveNormalizer.clearCache();
	    };
	    /**
	     * @param {?} baseType
	     * @param {?} name
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._createProxyClass = /**
	     * @param {?} baseType
	     * @param {?} name
	     * @return {?}
	     */
	    function (baseType, name) {
	        var /** @type {?} */ delegate = null;
	        var /** @type {?} */ proxyClass = /** @type {?} */ (function () {
	            if (!delegate) {
	                throw new Error("Illegal state: Class " + name + " for type " + stringify(baseType) + " is not compiled yet!");
	            }
	            return delegate.apply(this, arguments);
	        });
	        proxyClass.setDelegate = function (d) {
	            delegate = d;
	            (/** @type {?} */ (proxyClass)).prototype = d.prototype;
	        };
	        // Make stringify work correctly
	        (/** @type {?} */ (proxyClass)).overriddenName = name;
	        return proxyClass;
	    };
	    /**
	     * @param {?} dirType
	     * @param {?} name
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getGeneratedClass = /**
	     * @param {?} dirType
	     * @param {?} name
	     * @return {?}
	     */
	    function (dirType, name) {
	        if (dirType instanceof StaticSymbol) {
	            return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), name);
	        }
	        else {
	            return this._createProxyClass(dirType, name);
	        }
	    };
	    /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getComponentViewClass = /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    function (dirType) {
	        return this.getGeneratedClass(dirType, viewClassName(dirType, 0));
	    };
	    /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getHostComponentViewClass = /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    function (dirType) {
	        return this.getGeneratedClass(dirType, hostViewClassName(dirType));
	    };
	    /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getHostComponentType = /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    function (dirType) {
	        var /** @type {?} */ name = identifierName({ reference: dirType }) + "_Host";
	        if (dirType instanceof StaticSymbol) {
	            return this._staticSymbolCache.get(dirType.filePath, name);
	        }
	        else {
	            var /** @type {?} */ HostClass = /** @type {?} */ (function HostClass() { });
	            HostClass.overriddenName = name;
	            return HostClass;
	        }
	    };
	    /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getRendererType = /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    function (dirType) {
	        if (dirType instanceof StaticSymbol) {
	            return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), rendererTypeName(dirType));
	        }
	        else {
	            // returning an object as proxy,
	            // that we fill later during runtime compilation.
	            return /** @type {?} */ ({});
	        }
	    };
	    /**
	     * @param {?} selector
	     * @param {?} dirType
	     * @param {?} inputs
	     * @param {?} outputs
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getComponentFactory = /**
	     * @param {?} selector
	     * @param {?} dirType
	     * @param {?} inputs
	     * @param {?} outputs
	     * @return {?}
	     */
	    function (selector, dirType, inputs, outputs) {
	        if (dirType instanceof StaticSymbol) {
	            return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), componentFactoryName(dirType));
	        }
	        else {
	            var /** @type {?} */ hostView = this.getHostComponentViewClass(dirType);
	            // Note: ngContentSelectors will be filled later once the template is
	            // loaded.
	            var /** @type {?} */ createComponentFactory = this._reflector.resolveExternalReference(Identifiers.createComponentFactory);
	            return createComponentFactory(selector, dirType, /** @type {?} */ (hostView), inputs, outputs, []);
	        }
	    };
	    /**
	     * @param {?} factory
	     * @param {?} ngContentSelectors
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.initComponentFactory = /**
	     * @param {?} factory
	     * @param {?} ngContentSelectors
	     * @return {?}
	     */
	    function (factory, ngContentSelectors) {
	        if (!(factory instanceof StaticSymbol)) {
	            (_a = (/** @type {?} */ (factory)).ngContentSelectors).push.apply(_a, ngContentSelectors);
	        }
	        var _a;
	    };
	    /**
	     * @param {?} type
	     * @param {?} kind
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._loadSummary = /**
	     * @param {?} type
	     * @param {?} kind
	     * @return {?}
	     */
	    function (type, kind) {
	        var /** @type {?} */ typeSummary = this._summaryCache.get(type);
	        if (!typeSummary) {
	            var /** @type {?} */ summary = this._summaryResolver.resolveSummary(type);
	            typeSummary = summary ? summary.type : null;
	            this._summaryCache.set(type, typeSummary || null);
	        }
	        return typeSummary && typeSummary.summaryKind === kind ? typeSummary : null;
	    };
	    /**
	     * @param {?} compMeta
	     * @param {?=} hostViewType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getHostComponentMetadata = /**
	     * @param {?} compMeta
	     * @param {?=} hostViewType
	     * @return {?}
	     */
	    function (compMeta, hostViewType) {
	        var /** @type {?} */ hostType = this.getHostComponentType(compMeta.type.reference);
	        if (!hostViewType) {
	            hostViewType = this.getHostComponentViewClass(hostType);
	        }
	        // Note: ! is ok here as this method should only be called with normalized directive
	        // metadata, which always fills in the selector.
	        var /** @type {?} */ template = CssSelector.parse(/** @type {?} */ ((compMeta.selector)))[0].getMatchingElementTemplate();
	        var /** @type {?} */ templateUrl = '';
	        var /** @type {?} */ htmlAst = this._htmlParser.parse(template, templateUrl);
	        return CompileDirectiveMetadata.create({
	            isHost: true,
	            type: { reference: hostType, diDeps: [], lifecycleHooks: [] },
	            template: new CompileTemplateMetadata({
	                encapsulation: ViewEncapsulation.None,
	                template: template,
	                templateUrl: templateUrl,
	                htmlAst: htmlAst,
	                styles: [],
	                styleUrls: [],
	                ngContentSelectors: [],
	                animations: [],
	                isInline: true,
	                externalStylesheets: [],
	                interpolation: null,
	                preserveWhitespaces: false,
	            }),
	            exportAs: null,
	            changeDetection: ChangeDetectionStrategy.Default,
	            inputs: [],
	            outputs: [],
	            host: {},
	            isComponent: true,
	            selector: '*',
	            providers: [],
	            viewProviders: [],
	            queries: [],
	            guards: {},
	            viewQueries: [],
	            componentViewType: hostViewType,
	            rendererType: /** @type {?} */ ({ id: '__Host__', encapsulation: ViewEncapsulation.None, styles: [], data: {} }),
	            entryComponents: [],
	            componentFactory: null
	        });
	    };
	    /**
	     * @param {?} ngModuleType
	     * @param {?} directiveType
	     * @param {?} isSync
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.loadDirectiveMetadata = /**
	     * @param {?} ngModuleType
	     * @param {?} directiveType
	     * @param {?} isSync
	     * @return {?}
	     */
	    function (ngModuleType, directiveType, isSync) {
	        var _this = this;
	        if (this._directiveCache.has(directiveType)) {
	            return null;
	        }
	        directiveType = resolveForwardRef(directiveType);
	        var _a = /** @type {?} */ ((this.getNonNormalizedDirectiveMetadata(directiveType))), annotation = _a.annotation, metadata = _a.metadata;
	        var /** @type {?} */ createDirectiveMetadata = function (templateMetadata) {
	            var /** @type {?} */ normalizedDirMeta = new CompileDirectiveMetadata({
	                isHost: false,
	                type: metadata.type,
	                isComponent: metadata.isComponent,
	                selector: metadata.selector,
	                exportAs: metadata.exportAs,
	                changeDetection: metadata.changeDetection,
	                inputs: metadata.inputs,
	                outputs: metadata.outputs,
	                hostListeners: metadata.hostListeners,
	                hostProperties: metadata.hostProperties,
	                hostAttributes: metadata.hostAttributes,
	                providers: metadata.providers,
	                viewProviders: metadata.viewProviders,
	                queries: metadata.queries,
	                guards: metadata.guards,
	                viewQueries: metadata.viewQueries,
	                entryComponents: metadata.entryComponents,
	                componentViewType: metadata.componentViewType,
	                rendererType: metadata.rendererType,
	                componentFactory: metadata.componentFactory,
	                template: templateMetadata
	            });
	            if (templateMetadata) {
	                _this.initComponentFactory(/** @type {?} */ ((metadata.componentFactory)), templateMetadata.ngContentSelectors);
	            }
	            _this._directiveCache.set(directiveType, normalizedDirMeta);
	            _this._summaryCache.set(directiveType, normalizedDirMeta.toSummary());
	            return null;
	        };
	        if (metadata.isComponent) {
	            var /** @type {?} */ template = /** @type {?} */ ((metadata.template));
	            var /** @type {?} */ templateMeta = this._directiveNormalizer.normalizeTemplate({
	                ngModuleType: ngModuleType,
	                componentType: directiveType,
	                moduleUrl: this._reflector.componentModuleUrl(directiveType, annotation),
	                encapsulation: template.encapsulation,
	                template: template.template,
	                templateUrl: template.templateUrl,
	                styles: template.styles,
	                styleUrls: template.styleUrls,
	                animations: template.animations,
	                interpolation: template.interpolation,
	                preserveWhitespaces: template.preserveWhitespaces
	            });
	            if (isPromise(templateMeta) && isSync) {
	                this._reportError(componentStillLoadingError(directiveType), directiveType);
	                return null;
	            }
	            return SyncAsync.then(templateMeta, createDirectiveMetadata);
	        }
	        else {
	            // directive
	            createDirectiveMetadata(null);
	            return null;
	        }
	    };
	    /**
	     * @param {?} directiveType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getNonNormalizedDirectiveMetadata = /**
	     * @param {?} directiveType
	     * @return {?}
	     */
	    function (directiveType) {
	        var _this = this;
	        directiveType = resolveForwardRef(directiveType);
	        if (!directiveType) {
	            return null;
	        }
	        var /** @type {?} */ cacheEntry = this._nonNormalizedDirectiveCache.get(directiveType);
	        if (cacheEntry) {
	            return cacheEntry;
	        }
	        var /** @type {?} */ dirMeta = this._directiveResolver.resolve(directiveType, false);
	        if (!dirMeta) {
	            return null;
	        }
	        var /** @type {?} */ nonNormalizedTemplateMetadata = /** @type {?} */ ((undefined));
	        if (createComponent.isTypeOf(dirMeta)) {
	            // component
	            var /** @type {?} */ compMeta = /** @type {?} */ (dirMeta);
	            assertArrayOfStrings('styles', compMeta.styles);
	            assertArrayOfStrings('styleUrls', compMeta.styleUrls);
	            assertInterpolationSymbols('interpolation', compMeta.interpolation);
	            var /** @type {?} */ animations = compMeta.animations;
	            nonNormalizedTemplateMetadata = new CompileTemplateMetadata({
	                encapsulation: noUndefined(compMeta.encapsulation),
	                template: noUndefined(compMeta.template),
	                templateUrl: noUndefined(compMeta.templateUrl),
	                htmlAst: null,
	                styles: compMeta.styles || [],
	                styleUrls: compMeta.styleUrls || [],
	                animations: animations || [],
	                interpolation: noUndefined(compMeta.interpolation),
	                isInline: !!compMeta.template,
	                externalStylesheets: [],
	                ngContentSelectors: [],
	                preserveWhitespaces: noUndefined(dirMeta.preserveWhitespaces),
	            });
	        }
	        var /** @type {?} */ changeDetectionStrategy = /** @type {?} */ ((null));
	        var /** @type {?} */ viewProviders = [];
	        var /** @type {?} */ entryComponentMetadata = [];
	        var /** @type {?} */ selector = dirMeta.selector;
	        if (createComponent.isTypeOf(dirMeta)) {
	            // Component
	            var /** @type {?} */ compMeta = /** @type {?} */ (dirMeta);
	            changeDetectionStrategy = /** @type {?} */ ((compMeta.changeDetection));
	            if (compMeta.viewProviders) {
	                viewProviders = this._getProvidersMetadata(compMeta.viewProviders, entryComponentMetadata, "viewProviders for \"" + stringifyType(directiveType) + "\"", [], directiveType);
	            }
	            if (compMeta.entryComponents) {
	                entryComponentMetadata = flattenAndDedupeArray(compMeta.entryComponents)
	                    .map(function (type) { return ((_this._getEntryComponentMetadata(type))); })
	                    .concat(entryComponentMetadata);
	            }
	            if (!selector) {
	                selector = this._schemaRegistry.getDefaultComponentElementName();
	            }
	        }
	        else {
	            // Directive
	            if (!selector) {
	                this._reportError(syntaxError("Directive " + stringifyType(directiveType) + " has no selector, please add it!"), directiveType);
	                selector = 'error';
	            }
	        }
	        var /** @type {?} */ providers = [];
	        if (dirMeta.providers != null) {
	            providers = this._getProvidersMetadata(dirMeta.providers, entryComponentMetadata, "providers for \"" + stringifyType(directiveType) + "\"", [], directiveType);
	        }
	        var /** @type {?} */ queries = [];
	        var /** @type {?} */ viewQueries = [];
	        if (dirMeta.queries != null) {
	            queries = this._getQueriesMetadata(dirMeta.queries, false, directiveType);
	            viewQueries = this._getQueriesMetadata(dirMeta.queries, true, directiveType);
	        }
	        var /** @type {?} */ metadata = CompileDirectiveMetadata.create({
	            isHost: false,
	            selector: selector,
	            exportAs: noUndefined(dirMeta.exportAs),
	            isComponent: !!nonNormalizedTemplateMetadata,
	            type: this._getTypeMetadata(directiveType),
	            template: nonNormalizedTemplateMetadata,
	            changeDetection: changeDetectionStrategy,
	            inputs: dirMeta.inputs || [],
	            outputs: dirMeta.outputs || [],
	            host: dirMeta.host || {},
	            providers: providers || [],
	            viewProviders: viewProviders || [],
	            queries: queries || [],
	            guards: dirMeta.guards || {},
	            viewQueries: viewQueries || [],
	            entryComponents: entryComponentMetadata,
	            componentViewType: nonNormalizedTemplateMetadata ? this.getComponentViewClass(directiveType) :
	                null,
	            rendererType: nonNormalizedTemplateMetadata ? this.getRendererType(directiveType) : null,
	            componentFactory: null
	        });
	        if (nonNormalizedTemplateMetadata) {
	            metadata.componentFactory =
	                this.getComponentFactory(selector, directiveType, metadata.inputs, metadata.outputs);
	        }
	        cacheEntry = { metadata: metadata, annotation: dirMeta };
	        this._nonNormalizedDirectiveCache.set(directiveType, cacheEntry);
	        return cacheEntry;
	    };
	    /**
	     * Gets the metadata for the given directive.
	     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
	     */
	    /**
	     * Gets the metadata for the given directive.
	     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
	     * @param {?} directiveType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getDirectiveMetadata = /**
	     * Gets the metadata for the given directive.
	     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
	     * @param {?} directiveType
	     * @return {?}
	     */
	    function (directiveType) {
	        var /** @type {?} */ dirMeta = /** @type {?} */ ((this._directiveCache.get(directiveType)));
	        if (!dirMeta) {
	            this._reportError(syntaxError("Illegal state: getDirectiveMetadata can only be called after loadNgModuleDirectiveAndPipeMetadata for a module that declares it. Directive " + stringifyType(directiveType) + "."), directiveType);
	        }
	        return dirMeta;
	    };
	    /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getDirectiveSummary = /**
	     * @param {?} dirType
	     * @return {?}
	     */
	    function (dirType) {
	        var /** @type {?} */ dirSummary = /** @type {?} */ (this._loadSummary(dirType, CompileSummaryKind.Directive));
	        if (!dirSummary) {
	            this._reportError(syntaxError("Illegal state: Could not load the summary for directive " + stringifyType(dirType) + "."), dirType);
	        }
	        return dirSummary;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.isDirective = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        return !!this._loadSummary(type, CompileSummaryKind.Directive) ||
	            this._directiveResolver.isDirective(type);
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.isPipe = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        return !!this._loadSummary(type, CompileSummaryKind.Pipe) ||
	            this._pipeResolver.isPipe(type);
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.isNgModule = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        return !!this._loadSummary(type, CompileSummaryKind.NgModule) ||
	            this._ngModuleResolver.isNgModule(type);
	    };
	    /**
	     * @param {?} moduleType
	     * @param {?=} alreadyCollecting
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getNgModuleSummary = /**
	     * @param {?} moduleType
	     * @param {?=} alreadyCollecting
	     * @return {?}
	     */
	    function (moduleType, alreadyCollecting) {
	        if (alreadyCollecting === void 0) { alreadyCollecting = null; }
	        var /** @type {?} */ moduleSummary = /** @type {?} */ (this._loadSummary(moduleType, CompileSummaryKind.NgModule));
	        if (!moduleSummary) {
	            var /** @type {?} */ moduleMeta = this.getNgModuleMetadata(moduleType, false, alreadyCollecting);
	            moduleSummary = moduleMeta ? moduleMeta.toSummary() : null;
	            if (moduleSummary) {
	                this._summaryCache.set(moduleType, moduleSummary);
	            }
	        }
	        return moduleSummary;
	    };
	    /**
	     * Loads the declared directives and pipes of an NgModule.
	     */
	    /**
	     * Loads the declared directives and pipes of an NgModule.
	     * @param {?} moduleType
	     * @param {?} isSync
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.loadNgModuleDirectiveAndPipeMetadata = /**
	     * Loads the declared directives and pipes of an NgModule.
	     * @param {?} moduleType
	     * @param {?} isSync
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    function (moduleType, isSync, throwIfNotFound) {
	        var _this = this;
	        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
	        var /** @type {?} */ ngModule = this.getNgModuleMetadata(moduleType, throwIfNotFound);
	        var /** @type {?} */ loading = [];
	        if (ngModule) {
	            ngModule.declaredDirectives.forEach(function (id) {
	                var /** @type {?} */ promise = _this.loadDirectiveMetadata(moduleType, id.reference, isSync);
	                if (promise) {
	                    loading.push(promise);
	                }
	            });
	            ngModule.declaredPipes.forEach(function (id) { return _this._loadPipeMetadata(id.reference); });
	        }
	        return Promise.all(loading);
	    };
	    /**
	     * @param {?} moduleType
	     * @param {?=} throwIfNotFound
	     * @param {?=} alreadyCollecting
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getNgModuleMetadata = /**
	     * @param {?} moduleType
	     * @param {?=} throwIfNotFound
	     * @param {?=} alreadyCollecting
	     * @return {?}
	     */
	    function (moduleType, throwIfNotFound, alreadyCollecting) {
	        var _this = this;
	        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
	        if (alreadyCollecting === void 0) { alreadyCollecting = null; }
	        moduleType = resolveForwardRef(moduleType);
	        var /** @type {?} */ compileMeta = this._ngModuleCache.get(moduleType);
	        if (compileMeta) {
	            return compileMeta;
	        }
	        var /** @type {?} */ meta = this._ngModuleResolver.resolve(moduleType, throwIfNotFound);
	        if (!meta) {
	            return null;
	        }
	        var /** @type {?} */ declaredDirectives = [];
	        var /** @type {?} */ exportedNonModuleIdentifiers = [];
	        var /** @type {?} */ declaredPipes = [];
	        var /** @type {?} */ importedModules = [];
	        var /** @type {?} */ exportedModules = [];
	        var /** @type {?} */ providers = [];
	        var /** @type {?} */ entryComponents = [];
	        var /** @type {?} */ bootstrapComponents = [];
	        var /** @type {?} */ schemas = [];
	        if (meta.imports) {
	            flattenAndDedupeArray(meta.imports).forEach(function (importedType) {
	                var /** @type {?} */ importedModuleType = /** @type {?} */ ((undefined));
	                if (isValidType(importedType)) {
	                    importedModuleType = importedType;
	                }
	                else if (importedType && importedType.ngModule) {
	                    var /** @type {?} */ moduleWithProviders = importedType;
	                    importedModuleType = moduleWithProviders.ngModule;
	                    if (moduleWithProviders.providers) {
	                        providers.push.apply(providers, _this._getProvidersMetadata(moduleWithProviders.providers, entryComponents, "provider for the NgModule '" + stringifyType(importedModuleType) + "'", [], importedType));
	                    }
	                }
	                if (importedModuleType) {
	                    if (_this._checkSelfImport(moduleType, importedModuleType))
	                        return;
	                    if (!alreadyCollecting)
	                        alreadyCollecting = new Set();
	                    if (alreadyCollecting.has(importedModuleType)) {
	                        _this._reportError(syntaxError(_this._getTypeDescriptor(importedModuleType) + " '" + stringifyType(importedType) + "' is imported recursively by the module '" + stringifyType(moduleType) + "'."), moduleType);
	                        return;
	                    }
	                    alreadyCollecting.add(importedModuleType);
	                    var /** @type {?} */ importedModuleSummary = _this.getNgModuleSummary(importedModuleType, alreadyCollecting);
	                    alreadyCollecting.delete(importedModuleType);
	                    if (!importedModuleSummary) {
	                        _this._reportError(syntaxError("Unexpected " + _this._getTypeDescriptor(importedType) + " '" + stringifyType(importedType) + "' imported by the module '" + stringifyType(moduleType) + "'. Please add a @NgModule annotation."), moduleType);
	                        return;
	                    }
	                    importedModules.push(importedModuleSummary);
	                }
	                else {
	                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(importedType) + "' imported by the module '" + stringifyType(moduleType) + "'"), moduleType);
	                    return;
	                }
	            });
	        }
	        if (meta.exports) {
	            flattenAndDedupeArray(meta.exports).forEach(function (exportedType) {
	                if (!isValidType(exportedType)) {
	                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(exportedType) + "' exported by the module '" + stringifyType(moduleType) + "'"), moduleType);
	                    return;
	                }
	                if (!alreadyCollecting)
	                    alreadyCollecting = new Set();
	                if (alreadyCollecting.has(exportedType)) {
	                    _this._reportError(syntaxError(_this._getTypeDescriptor(exportedType) + " '" + stringify(exportedType) + "' is exported recursively by the module '" + stringifyType(moduleType) + "'"), moduleType);
	                    return;
	                }
	                alreadyCollecting.add(exportedType);
	                var /** @type {?} */ exportedModuleSummary = _this.getNgModuleSummary(exportedType, alreadyCollecting);
	                alreadyCollecting.delete(exportedType);
	                if (exportedModuleSummary) {
	                    exportedModules.push(exportedModuleSummary);
	                }
	                else {
	                    exportedNonModuleIdentifiers.push(_this._getIdentifierMetadata(exportedType));
	                }
	            });
	        }
	        // Note: This will be modified later, so we rely on
	        // getting a new instance every time!
	        var /** @type {?} */ transitiveModule = this._getTransitiveNgModuleMetadata(importedModules, exportedModules);
	        if (meta.declarations) {
	            flattenAndDedupeArray(meta.declarations).forEach(function (declaredType) {
	                if (!isValidType(declaredType)) {
	                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(declaredType) + "' declared by the module '" + stringifyType(moduleType) + "'"), moduleType);
	                    return;
	                }
	                var /** @type {?} */ declaredIdentifier = _this._getIdentifierMetadata(declaredType);
	                if (_this.isDirective(declaredType)) {
	                    transitiveModule.addDirective(declaredIdentifier);
	                    declaredDirectives.push(declaredIdentifier);
	                    _this._addTypeToModule(declaredType, moduleType);
	                }
	                else if (_this.isPipe(declaredType)) {
	                    transitiveModule.addPipe(declaredIdentifier);
	                    transitiveModule.pipes.push(declaredIdentifier);
	                    declaredPipes.push(declaredIdentifier);
	                    _this._addTypeToModule(declaredType, moduleType);
	                }
	                else {
	                    _this._reportError(syntaxError("Unexpected " + _this._getTypeDescriptor(declaredType) + " '" + stringifyType(declaredType) + "' declared by the module '" + stringifyType(moduleType) + "'. Please add a @Pipe/@Directive/@Component annotation."), moduleType);
	                    return;
	                }
	            });
	        }
	        var /** @type {?} */ exportedDirectives = [];
	        var /** @type {?} */ exportedPipes = [];
	        exportedNonModuleIdentifiers.forEach(function (exportedId) {
	            if (transitiveModule.directivesSet.has(exportedId.reference)) {
	                exportedDirectives.push(exportedId);
	                transitiveModule.addExportedDirective(exportedId);
	            }
	            else if (transitiveModule.pipesSet.has(exportedId.reference)) {
	                exportedPipes.push(exportedId);
	                transitiveModule.addExportedPipe(exportedId);
	            }
	            else {
	                _this._reportError(syntaxError("Can't export " + _this._getTypeDescriptor(exportedId.reference) + " " + stringifyType(exportedId.reference) + " from " + stringifyType(moduleType) + " as it was neither declared nor imported!"), moduleType);
	                return;
	            }
	        });
	        // The providers of the module have to go last
	        // so that they overwrite any other provider we already added.
	        if (meta.providers) {
	            providers.push.apply(providers, this._getProvidersMetadata(meta.providers, entryComponents, "provider for the NgModule '" + stringifyType(moduleType) + "'", [], moduleType));
	        }
	        if (meta.entryComponents) {
	            entryComponents.push.apply(entryComponents, flattenAndDedupeArray(meta.entryComponents)
	                .map(function (type) { return ((_this._getEntryComponentMetadata(type))); }));
	        }
	        if (meta.bootstrap) {
	            flattenAndDedupeArray(meta.bootstrap).forEach(function (type) {
	                if (!isValidType(type)) {
	                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(type) + "' used in the bootstrap property of module '" + stringifyType(moduleType) + "'"), moduleType);
	                    return;
	                }
	                bootstrapComponents.push(_this._getIdentifierMetadata(type));
	            });
	        }
	        entryComponents.push.apply(entryComponents, bootstrapComponents.map(function (type) { return ((_this._getEntryComponentMetadata(type.reference))); }));
	        if (meta.schemas) {
	            schemas.push.apply(schemas, flattenAndDedupeArray(meta.schemas));
	        }
	        compileMeta = new CompileNgModuleMetadata({
	            type: this._getTypeMetadata(moduleType),
	            providers: providers,
	            entryComponents: entryComponents,
	            bootstrapComponents: bootstrapComponents,
	            schemas: schemas,
	            declaredDirectives: declaredDirectives,
	            exportedDirectives: exportedDirectives,
	            declaredPipes: declaredPipes,
	            exportedPipes: exportedPipes,
	            importedModules: importedModules,
	            exportedModules: exportedModules,
	            transitiveModule: transitiveModule,
	            id: meta.id || null,
	        });
	        entryComponents.forEach(function (id) { return transitiveModule.addEntryComponent(id); });
	        providers.forEach(function (provider) { return transitiveModule.addProvider(provider, /** @type {?} */ ((compileMeta)).type); });
	        transitiveModule.addModule(compileMeta.type);
	        this._ngModuleCache.set(moduleType, compileMeta);
	        return compileMeta;
	    };
	    /**
	     * @param {?} moduleType
	     * @param {?} importedModuleType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._checkSelfImport = /**
	     * @param {?} moduleType
	     * @param {?} importedModuleType
	     * @return {?}
	     */
	    function (moduleType, importedModuleType) {
	        if (moduleType === importedModuleType) {
	            this._reportError(syntaxError("'" + stringifyType(moduleType) + "' module can't import itself"), moduleType);
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getTypeDescriptor = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        if (isValidType(type)) {
	            if (this.isDirective(type)) {
	                return 'directive';
	            }
	            if (this.isPipe(type)) {
	                return 'pipe';
	            }
	            if (this.isNgModule(type)) {
	                return 'module';
	            }
	        }
	        if ((/** @type {?} */ (type)).provide) {
	            return 'provider';
	        }
	        return 'value';
	    };
	    /**
	     * @param {?} type
	     * @param {?} moduleType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._addTypeToModule = /**
	     * @param {?} type
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (type, moduleType) {
	        var /** @type {?} */ oldModule = this._ngModuleOfTypes.get(type);
	        if (oldModule && oldModule !== moduleType) {
	            this._reportError(syntaxError("Type " + stringifyType(type) + " is part of the declarations of 2 modules: " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + "! " +
	                ("Please consider moving " + stringifyType(type) + " to a higher module that imports " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + ". ") +
	                ("You can also create a new NgModule that exports and includes " + stringifyType(type) + " then import that NgModule in " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + ".")), moduleType);
	            return;
	        }
	        this._ngModuleOfTypes.set(type, moduleType);
	    };
	    /**
	     * @param {?} importedModules
	     * @param {?} exportedModules
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getTransitiveNgModuleMetadata = /**
	     * @param {?} importedModules
	     * @param {?} exportedModules
	     * @return {?}
	     */
	    function (importedModules, exportedModules) {
	        // collect `providers` / `entryComponents` from all imported and all exported modules
	        var /** @type {?} */ result = new TransitiveCompileNgModuleMetadata();
	        var /** @type {?} */ modulesByToken = new Map();
	        importedModules.concat(exportedModules).forEach(function (modSummary) {
	            modSummary.modules.forEach(function (mod) { return result.addModule(mod); });
	            modSummary.entryComponents.forEach(function (comp) { return result.addEntryComponent(comp); });
	            var /** @type {?} */ addedTokens = new Set();
	            modSummary.providers.forEach(function (entry) {
	                var /** @type {?} */ tokenRef = tokenReference(entry.provider.token);
	                var /** @type {?} */ prevModules = modulesByToken.get(tokenRef);
	                if (!prevModules) {
	                    prevModules = new Set();
	                    modulesByToken.set(tokenRef, prevModules);
	                }
	                var /** @type {?} */ moduleRef = entry.module.reference;
	                // Note: the providers of one module may still contain multiple providers
	                // per token (e.g. for multi providers), and we need to preserve these.
	                if (addedTokens.has(tokenRef) || !prevModules.has(moduleRef)) {
	                    prevModules.add(moduleRef);
	                    addedTokens.add(tokenRef);
	                    result.addProvider(entry.provider, entry.module);
	                }
	            });
	        });
	        exportedModules.forEach(function (modSummary) {
	            modSummary.exportedDirectives.forEach(function (id) { return result.addExportedDirective(id); });
	            modSummary.exportedPipes.forEach(function (id) { return result.addExportedPipe(id); });
	        });
	        importedModules.forEach(function (modSummary) {
	            modSummary.exportedDirectives.forEach(function (id) { return result.addDirective(id); });
	            modSummary.exportedPipes.forEach(function (id) { return result.addPipe(id); });
	        });
	        return result;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getIdentifierMetadata = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        type = resolveForwardRef(type);
	        return { reference: type };
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.isInjectable = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ annotations = this._reflector.annotations(type);
	        return annotations.some(function (ann) { return createInjectable.isTypeOf(ann); });
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getInjectableSummary = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        return {
	            summaryKind: CompileSummaryKind.Injectable,
	            type: this._getTypeMetadata(type, null, false)
	        };
	    };
	    /**
	     * @param {?} type
	     * @param {?=} dependencies
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getInjectableMetadata = /**
	     * @param {?} type
	     * @param {?=} dependencies
	     * @return {?}
	     */
	    function (type, dependencies) {
	        if (dependencies === void 0) { dependencies = null; }
	        var /** @type {?} */ typeSummary = this._loadSummary(type, CompileSummaryKind.Injectable);
	        if (typeSummary) {
	            return typeSummary.type;
	        }
	        return this._getTypeMetadata(type, dependencies);
	    };
	    /**
	     * @param {?} type
	     * @param {?=} dependencies
	     * @param {?=} throwOnUnknownDeps
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getTypeMetadata = /**
	     * @param {?} type
	     * @param {?=} dependencies
	     * @param {?=} throwOnUnknownDeps
	     * @return {?}
	     */
	    function (type, dependencies, throwOnUnknownDeps) {
	        if (dependencies === void 0) { dependencies = null; }
	        if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
	        var /** @type {?} */ identifier = this._getIdentifierMetadata(type);
	        return {
	            reference: identifier.reference,
	            diDeps: this._getDependenciesMetadata(identifier.reference, dependencies, throwOnUnknownDeps),
	            lifecycleHooks: getAllLifecycleHooks(this._reflector, identifier.reference),
	        };
	    };
	    /**
	     * @param {?} factory
	     * @param {?=} dependencies
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getFactoryMetadata = /**
	     * @param {?} factory
	     * @param {?=} dependencies
	     * @return {?}
	     */
	    function (factory, dependencies) {
	        if (dependencies === void 0) { dependencies = null; }
	        factory = resolveForwardRef(factory);
	        return { reference: factory, diDeps: this._getDependenciesMetadata(factory, dependencies) };
	    };
	    /**
	     * Gets the metadata for the given pipe.
	     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
	     */
	    /**
	     * Gets the metadata for the given pipe.
	     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
	     * @param {?} pipeType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getPipeMetadata = /**
	     * Gets the metadata for the given pipe.
	     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
	     * @param {?} pipeType
	     * @return {?}
	     */
	    function (pipeType) {
	        var /** @type {?} */ pipeMeta = this._pipeCache.get(pipeType);
	        if (!pipeMeta) {
	            this._reportError(syntaxError("Illegal state: getPipeMetadata can only be called after loadNgModuleDirectiveAndPipeMetadata for a module that declares it. Pipe " + stringifyType(pipeType) + "."), pipeType);
	        }
	        return pipeMeta || null;
	    };
	    /**
	     * @param {?} pipeType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getPipeSummary = /**
	     * @param {?} pipeType
	     * @return {?}
	     */
	    function (pipeType) {
	        var /** @type {?} */ pipeSummary = /** @type {?} */ (this._loadSummary(pipeType, CompileSummaryKind.Pipe));
	        if (!pipeSummary) {
	            this._reportError(syntaxError("Illegal state: Could not load the summary for pipe " + stringifyType(pipeType) + "."), pipeType);
	        }
	        return pipeSummary;
	    };
	    /**
	     * @param {?} pipeType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getOrLoadPipeMetadata = /**
	     * @param {?} pipeType
	     * @return {?}
	     */
	    function (pipeType) {
	        var /** @type {?} */ pipeMeta = this._pipeCache.get(pipeType);
	        if (!pipeMeta) {
	            pipeMeta = this._loadPipeMetadata(pipeType);
	        }
	        return pipeMeta;
	    };
	    /**
	     * @param {?} pipeType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._loadPipeMetadata = /**
	     * @param {?} pipeType
	     * @return {?}
	     */
	    function (pipeType) {
	        pipeType = resolveForwardRef(pipeType);
	        var /** @type {?} */ pipeAnnotation = /** @type {?} */ ((this._pipeResolver.resolve(pipeType)));
	        var /** @type {?} */ pipeMeta = new CompilePipeMetadata({
	            type: this._getTypeMetadata(pipeType),
	            name: pipeAnnotation.name,
	            pure: !!pipeAnnotation.pure
	        });
	        this._pipeCache.set(pipeType, pipeMeta);
	        this._summaryCache.set(pipeType, pipeMeta.toSummary());
	        return pipeMeta;
	    };
	    /**
	     * @param {?} typeOrFunc
	     * @param {?} dependencies
	     * @param {?=} throwOnUnknownDeps
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getDependenciesMetadata = /**
	     * @param {?} typeOrFunc
	     * @param {?} dependencies
	     * @param {?=} throwOnUnknownDeps
	     * @return {?}
	     */
	    function (typeOrFunc, dependencies, throwOnUnknownDeps) {
	        var _this = this;
	        if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
	        var /** @type {?} */ hasUnknownDeps = false;
	        var /** @type {?} */ params = dependencies || this._reflector.parameters(typeOrFunc) || [];
	        var /** @type {?} */ dependenciesMetadata = params.map(function (param) {
	            var /** @type {?} */ isAttribute = false;
	            var /** @type {?} */ isHost = false;
	            var /** @type {?} */ isSelf = false;
	            var /** @type {?} */ isSkipSelf = false;
	            var /** @type {?} */ isOptional = false;
	            var /** @type {?} */ token = null;
	            if (Array.isArray(param)) {
	                param.forEach(function (paramEntry) {
	                    if (createHost.isTypeOf(paramEntry)) {
	                        isHost = true;
	                    }
	                    else if (createSelf.isTypeOf(paramEntry)) {
	                        isSelf = true;
	                    }
	                    else if (createSkipSelf.isTypeOf(paramEntry)) {
	                        isSkipSelf = true;
	                    }
	                    else if (createOptional.isTypeOf(paramEntry)) {
	                        isOptional = true;
	                    }
	                    else if (createAttribute.isTypeOf(paramEntry)) {
	                        isAttribute = true;
	                        token = paramEntry.attributeName;
	                    }
	                    else if (createInject.isTypeOf(paramEntry)) {
	                        token = paramEntry.token;
	                    }
	                    else if (createInjectionToken.isTypeOf(paramEntry) || paramEntry instanceof StaticSymbol) {
	                        token = paramEntry;
	                    }
	                    else if (isValidType(paramEntry) && token == null) {
	                        token = paramEntry;
	                    }
	                });
	            }
	            else {
	                token = param;
	            }
	            if (token == null) {
	                hasUnknownDeps = true;
	                return /** @type {?} */ ((null));
	            }
	            return {
	                isAttribute: isAttribute,
	                isHost: isHost,
	                isSelf: isSelf,
	                isSkipSelf: isSkipSelf,
	                isOptional: isOptional,
	                token: _this._getTokenMetadata(token)
	            };
	        });
	        if (hasUnknownDeps) {
	            var /** @type {?} */ depsTokens = dependenciesMetadata.map(function (dep) { return dep ? stringifyType(dep.token) : '?'; }).join(', ');
	            var /** @type {?} */ message = "Can't resolve all parameters for " + stringifyType(typeOrFunc) + ": (" + depsTokens + ").";
	            if (throwOnUnknownDeps || this._config.strictInjectionParameters) {
	                this._reportError(syntaxError(message), typeOrFunc);
	            }
	            else {
	                this._console.warn("Warning: " + message + " This will become an error in Angular v6.x");
	            }
	        }
	        return dependenciesMetadata;
	    };
	    /**
	     * @param {?} token
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getTokenMetadata = /**
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        token = resolveForwardRef(token);
	        var /** @type {?} */ compileToken;
	        if (typeof token === 'string') {
	            compileToken = { value: token };
	        }
	        else {
	            compileToken = { identifier: { reference: token } };
	        }
	        return compileToken;
	    };
	    /**
	     * @param {?} providers
	     * @param {?} targetEntryComponents
	     * @param {?=} debugInfo
	     * @param {?=} compileProviders
	     * @param {?=} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getProvidersMetadata = /**
	     * @param {?} providers
	     * @param {?} targetEntryComponents
	     * @param {?=} debugInfo
	     * @param {?=} compileProviders
	     * @param {?=} type
	     * @return {?}
	     */
	    function (providers, targetEntryComponents, debugInfo, compileProviders, type) {
	        var _this = this;
	        if (compileProviders === void 0) { compileProviders = []; }
	        providers.forEach(function (provider, providerIdx) {
	            if (Array.isArray(provider)) {
	                _this._getProvidersMetadata(provider, targetEntryComponents, debugInfo, compileProviders);
	            }
	            else {
	                provider = resolveForwardRef(provider);
	                var /** @type {?} */ providerMeta = /** @type {?} */ ((undefined));
	                if (provider && typeof provider === 'object' && provider.hasOwnProperty('provide')) {
	                    _this._validateProvider(provider);
	                    providerMeta = new ProviderMeta(provider.provide, provider);
	                }
	                else if (isValidType(provider)) {
	                    providerMeta = new ProviderMeta(provider, { useClass: provider });
	                }
	                else if (provider === void 0) {
	                    _this._reportError(syntaxError("Encountered undefined provider! Usually this means you have a circular dependencies (might be caused by using 'barrel' index.ts files."));
	                    return;
	                }
	                else {
	                    var /** @type {?} */ providersInfo = (/** @type {?} */ (providers.reduce(function (soFar, seenProvider, seenProviderIdx) {
	                        if (seenProviderIdx < providerIdx) {
	                            soFar.push("" + stringifyType(seenProvider));
	                        }
	                        else if (seenProviderIdx == providerIdx) {
	                            soFar.push("?" + stringifyType(seenProvider) + "?");
	                        }
	                        else if (seenProviderIdx == providerIdx + 1) {
	                            soFar.push('...');
	                        }
	                        return soFar;
	                    }, [])))
	                        .join(', ');
	                    _this._reportError(syntaxError("Invalid " + (debugInfo ? debugInfo : 'provider') + " - only instances of Provider and Type are allowed, got: [" + providersInfo + "]"), type);
	                    return;
	                }
	                if (providerMeta.token ===
	                    _this._reflector.resolveExternalReference(Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS)) {
	                    targetEntryComponents.push.apply(targetEntryComponents, _this._getEntryComponentsFromProvider(providerMeta, type));
	                }
	                else {
	                    compileProviders.push(_this.getProviderMetadata(providerMeta));
	                }
	            }
	        });
	        return compileProviders;
	    };
	    /**
	     * @param {?} provider
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._validateProvider = /**
	     * @param {?} provider
	     * @return {?}
	     */
	    function (provider) {
	        if (provider.hasOwnProperty('useClass') && provider.useClass == null) {
	            this._reportError(syntaxError("Invalid provider for " + stringifyType(provider.provide) + ". useClass cannot be " + provider.useClass + ".\n           Usually it happens when:\n           1. There's a circular dependency (might be caused by using index.ts (barrel) files).\n           2. Class was used before it was declared. Use forwardRef in this case."));
	        }
	    };
	    /**
	     * @param {?} provider
	     * @param {?=} type
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getEntryComponentsFromProvider = /**
	     * @param {?} provider
	     * @param {?=} type
	     * @return {?}
	     */
	    function (provider, type) {
	        var _this = this;
	        var /** @type {?} */ components = [];
	        var /** @type {?} */ collectedIdentifiers = [];
	        if (provider.useFactory || provider.useExisting || provider.useClass) {
	            this._reportError(syntaxError("The ANALYZE_FOR_ENTRY_COMPONENTS token only supports useValue!"), type);
	            return [];
	        }
	        if (!provider.multi) {
	            this._reportError(syntaxError("The ANALYZE_FOR_ENTRY_COMPONENTS token only supports 'multi = true'!"), type);
	            return [];
	        }
	        extractIdentifiers(provider.useValue, collectedIdentifiers);
	        collectedIdentifiers.forEach(function (identifier) {
	            var /** @type {?} */ entry = _this._getEntryComponentMetadata(identifier.reference, false);
	            if (entry) {
	                components.push(entry);
	            }
	        });
	        return components;
	    };
	    /**
	     * @param {?} dirType
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getEntryComponentMetadata = /**
	     * @param {?} dirType
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    function (dirType, throwIfNotFound) {
	        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
	        var /** @type {?} */ dirMeta = this.getNonNormalizedDirectiveMetadata(dirType);
	        if (dirMeta && dirMeta.metadata.isComponent) {
	            return { componentType: dirType, componentFactory: /** @type {?} */ ((dirMeta.metadata.componentFactory)) };
	        }
	        var /** @type {?} */ dirSummary = /** @type {?} */ (this._loadSummary(dirType, CompileSummaryKind.Directive));
	        if (dirSummary && dirSummary.isComponent) {
	            return { componentType: dirType, componentFactory: /** @type {?} */ ((dirSummary.componentFactory)) };
	        }
	        if (throwIfNotFound) {
	            throw syntaxError(dirType.name + " cannot be used as an entry component.");
	        }
	        return null;
	    };
	    /**
	     * @param {?} provider
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype.getProviderMetadata = /**
	     * @param {?} provider
	     * @return {?}
	     */
	    function (provider) {
	        var /** @type {?} */ compileDeps = /** @type {?} */ ((undefined));
	        var /** @type {?} */ compileTypeMetadata = /** @type {?} */ ((null));
	        var /** @type {?} */ compileFactoryMetadata = /** @type {?} */ ((null));
	        var /** @type {?} */ token = this._getTokenMetadata(provider.token);
	        if (provider.useClass) {
	            compileTypeMetadata = this._getInjectableMetadata(provider.useClass, provider.dependencies);
	            compileDeps = compileTypeMetadata.diDeps;
	            if (provider.token === provider.useClass) {
	                // use the compileTypeMetadata as it contains information about lifecycleHooks...
	                token = { identifier: compileTypeMetadata };
	            }
	        }
	        else if (provider.useFactory) {
	            compileFactoryMetadata = this._getFactoryMetadata(provider.useFactory, provider.dependencies);
	            compileDeps = compileFactoryMetadata.diDeps;
	        }
	        return {
	            token: token,
	            useClass: compileTypeMetadata,
	            useValue: provider.useValue,
	            useFactory: compileFactoryMetadata,
	            useExisting: provider.useExisting ? this._getTokenMetadata(provider.useExisting) : undefined,
	            deps: compileDeps,
	            multi: provider.multi
	        };
	    };
	    /**
	     * @param {?} queries
	     * @param {?} isViewQuery
	     * @param {?} directiveType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getQueriesMetadata = /**
	     * @param {?} queries
	     * @param {?} isViewQuery
	     * @param {?} directiveType
	     * @return {?}
	     */
	    function (queries, isViewQuery, directiveType) {
	        var _this = this;
	        var /** @type {?} */ res = [];
	        Object.keys(queries).forEach(function (propertyName) {
	            var /** @type {?} */ query = queries[propertyName];
	            if (query.isViewQuery === isViewQuery) {
	                res.push(_this._getQueryMetadata(query, propertyName, directiveType));
	            }
	        });
	        return res;
	    };
	    /**
	     * @param {?} selector
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._queryVarBindings = /**
	     * @param {?} selector
	     * @return {?}
	     */
	    function (selector) { return selector.split(/\s*,\s*/); };
	    /**
	     * @param {?} q
	     * @param {?} propertyName
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._getQueryMetadata = /**
	     * @param {?} q
	     * @param {?} propertyName
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (q, propertyName, typeOrFunc) {
	        var _this = this;
	        var /** @type {?} */ selectors;
	        if (typeof q.selector === 'string') {
	            selectors =
	                this._queryVarBindings(q.selector).map(function (varName) { return _this._getTokenMetadata(varName); });
	        }
	        else {
	            if (!q.selector) {
	                this._reportError(syntaxError("Can't construct a query for the property \"" + propertyName + "\" of \"" + stringifyType(typeOrFunc) + "\" since the query selector wasn't defined."), typeOrFunc);
	                selectors = [];
	            }
	            else {
	                selectors = [this._getTokenMetadata(q.selector)];
	            }
	        }
	        return {
	            selectors: selectors,
	            first: q.first,
	            descendants: q.descendants, propertyName: propertyName,
	            read: q.read ? this._getTokenMetadata(q.read) : /** @type {?} */ ((null))
	        };
	    };
	    /**
	     * @param {?} error
	     * @param {?=} type
	     * @param {?=} otherType
	     * @return {?}
	     */
	    CompileMetadataResolver.prototype._reportError = /**
	     * @param {?} error
	     * @param {?=} type
	     * @param {?=} otherType
	     * @return {?}
	     */
	    function (error, type, otherType) {
	        if (this._errorCollector) {
	            this._errorCollector(error, type);
	            if (otherType) {
	                this._errorCollector(error, otherType);
	            }
	        }
	        else {
	            throw error;
	        }
	    };
	    return CompileMetadataResolver;
	}());
	/**
	 * @param {?} tree
	 * @param {?=} out
	 * @return {?}
	 */
	function flattenArray(tree, out) {
	    if (out === void 0) { out = []; }
	    if (tree) {
	        for (var /** @type {?} */ i = 0; i < tree.length; i++) {
	            var /** @type {?} */ item = resolveForwardRef(tree[i]);
	            if (Array.isArray(item)) {
	                flattenArray(item, out);
	            }
	            else {
	                out.push(item);
	            }
	        }
	    }
	    return out;
	}
	/**
	 * @param {?} array
	 * @return {?}
	 */
	function dedupeArray(array) {
	    if (array) {
	        return Array.from(new Set(array));
	    }
	    return [];
	}
	/**
	 * @param {?} tree
	 * @return {?}
	 */
	function flattenAndDedupeArray(tree) {
	    return dedupeArray(flattenArray(tree));
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function isValidType(value) {
	    return (value instanceof StaticSymbol) || (value instanceof Type);
	}
	/**
	 * @param {?} value
	 * @param {?} targetIdentifiers
	 * @return {?}
	 */
	function extractIdentifiers(value, targetIdentifiers) {
	    visitValue(value, new _CompileValueConverter(), targetIdentifiers);
	}
	var _CompileValueConverter = /** @class */ (function (_super) {
	    __extends(_CompileValueConverter, _super);
	    function _CompileValueConverter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} value
	     * @param {?} targetIdentifiers
	     * @return {?}
	     */
	    _CompileValueConverter.prototype.visitOther = /**
	     * @param {?} value
	     * @param {?} targetIdentifiers
	     * @return {?}
	     */
	    function (value, targetIdentifiers) {
	        targetIdentifiers.push({ reference: value });
	    };
	    return _CompileValueConverter;
	}(ValueTransformer));
	/**
	 * @param {?} type
	 * @return {?}
	 */
	function stringifyType(type) {
	    if (type instanceof StaticSymbol) {
	        return type.name + " in " + type.filePath;
	    }
	    else {
	        return stringify(type);
	    }
	}
	/**
	 * Indicates that a component is still being loaded in a synchronous compile.
	 * @param {?} compType
	 * @return {?}
	 */
	function componentStillLoadingError(compType) {
	    var /** @type {?} */ error = Error("Can't compile synchronously as " + stringify(compType) + " is still being loaded!");
	    (/** @type {?} */ (error))[ERROR_COMPONENT_TYPE] = compType;
	    return error;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var TypeModifier = {
	    Const: 0,
	};
	TypeModifier[TypeModifier.Const] = "Const";
	/**
	 * @abstract
	 */
	var Type$1 = /** @class */ (function () {
	    function Type(modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        this.modifiers = modifiers;
	        if (!modifiers) {
	            this.modifiers = [];
	        }
	    }
	    /**
	     * @param {?} modifier
	     * @return {?}
	     */
	    Type.prototype.hasModifier = /**
	     * @param {?} modifier
	     * @return {?}
	     */
	    function (modifier) { return /** @type {?} */ ((this.modifiers)).indexOf(modifier) !== -1; };
	    return Type;
	}());
	/** @enum {number} */
	var BuiltinTypeName = {
	    Dynamic: 0,
	    Bool: 1,
	    String: 2,
	    Int: 3,
	    Number: 4,
	    Function: 5,
	    Inferred: 6,
	};
	BuiltinTypeName[BuiltinTypeName.Dynamic] = "Dynamic";
	BuiltinTypeName[BuiltinTypeName.Bool] = "Bool";
	BuiltinTypeName[BuiltinTypeName.String] = "String";
	BuiltinTypeName[BuiltinTypeName.Int] = "Int";
	BuiltinTypeName[BuiltinTypeName.Number] = "Number";
	BuiltinTypeName[BuiltinTypeName.Function] = "Function";
	BuiltinTypeName[BuiltinTypeName.Inferred] = "Inferred";
	var BuiltinType = /** @class */ (function (_super) {
	    __extends(BuiltinType, _super);
	    function BuiltinType(name, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers) || this;
	        _this.name = name;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    BuiltinType.prototype.visitType = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitBuiltintType(this, context);
	    };
	    return BuiltinType;
	}(Type$1));
	var ExpressionType = /** @class */ (function (_super) {
	    __extends(ExpressionType, _super);
	    function ExpressionType(value, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers) || this;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ExpressionType.prototype.visitType = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitExpressionType(this, context);
	    };
	    return ExpressionType;
	}(Type$1));
	var ArrayType = /** @class */ (function (_super) {
	    __extends(ArrayType, _super);
	    function ArrayType(of, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers) || this;
	        _this.of = of;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ArrayType.prototype.visitType = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitArrayType(this, context);
	    };
	    return ArrayType;
	}(Type$1));
	var MapType = /** @class */ (function (_super) {
	    __extends(MapType, _super);
	    function MapType(valueType, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers) || this;
	        _this.valueType = valueType || null;
	        return _this;
	    }
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    MapType.prototype.visitType = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) { return visitor.visitMapType(this, context); };
	    return MapType;
	}(Type$1));
	var DYNAMIC_TYPE = new BuiltinType(BuiltinTypeName.Dynamic);
	var INFERRED_TYPE = new BuiltinType(BuiltinTypeName.Inferred);
	var BOOL_TYPE = new BuiltinType(BuiltinTypeName.Bool);
	var INT_TYPE = new BuiltinType(BuiltinTypeName.Int);
	var NUMBER_TYPE = new BuiltinType(BuiltinTypeName.Number);
	var STRING_TYPE = new BuiltinType(BuiltinTypeName.String);
	var FUNCTION_TYPE = new BuiltinType(BuiltinTypeName.Function);
	/**
	 * @record
	 */
	
	/** @enum {number} */
	var BinaryOperator = {
	    Equals: 0,
	    NotEquals: 1,
	    Identical: 2,
	    NotIdentical: 3,
	    Minus: 4,
	    Plus: 5,
	    Divide: 6,
	    Multiply: 7,
	    Modulo: 8,
	    And: 9,
	    Or: 10,
	    Lower: 11,
	    LowerEquals: 12,
	    Bigger: 13,
	    BiggerEquals: 14,
	};
	BinaryOperator[BinaryOperator.Equals] = "Equals";
	BinaryOperator[BinaryOperator.NotEquals] = "NotEquals";
	BinaryOperator[BinaryOperator.Identical] = "Identical";
	BinaryOperator[BinaryOperator.NotIdentical] = "NotIdentical";
	BinaryOperator[BinaryOperator.Minus] = "Minus";
	BinaryOperator[BinaryOperator.Plus] = "Plus";
	BinaryOperator[BinaryOperator.Divide] = "Divide";
	BinaryOperator[BinaryOperator.Multiply] = "Multiply";
	BinaryOperator[BinaryOperator.Modulo] = "Modulo";
	BinaryOperator[BinaryOperator.And] = "And";
	BinaryOperator[BinaryOperator.Or] = "Or";
	BinaryOperator[BinaryOperator.Lower] = "Lower";
	BinaryOperator[BinaryOperator.LowerEquals] = "LowerEquals";
	BinaryOperator[BinaryOperator.Bigger] = "Bigger";
	BinaryOperator[BinaryOperator.BiggerEquals] = "BiggerEquals";
	/**
	 * @template T
	 * @param {?} base
	 * @param {?} other
	 * @return {?}
	 */
	function nullSafeIsEquivalent(base, other) {
	    if (base == null || other == null) {
	        return base == other;
	    }
	    return base.isEquivalent(other);
	}
	/**
	 * @template T
	 * @param {?} base
	 * @param {?} other
	 * @return {?}
	 */
	function areAllEquivalent(base, other) {
	    var /** @type {?} */ len = base.length;
	    if (len !== other.length) {
	        return false;
	    }
	    for (var /** @type {?} */ i = 0; i < len; i++) {
	        if (!base[i].isEquivalent(other[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * @abstract
	 */
	var Expression = /** @class */ (function () {
	    function Expression(type, sourceSpan) {
	        this.type = type || null;
	        this.sourceSpan = sourceSpan || null;
	    }
	    /**
	     * @param {?} name
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.prop = /**
	     * @param {?} name
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (name, sourceSpan) {
	        return new ReadPropExpr(this, name, null, sourceSpan);
	    };
	    /**
	     * @param {?} index
	     * @param {?=} type
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.key = /**
	     * @param {?} index
	     * @param {?=} type
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (index, type, sourceSpan) {
	        return new ReadKeyExpr(this, index, type, sourceSpan);
	    };
	    /**
	     * @param {?} name
	     * @param {?} params
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.callMethod = /**
	     * @param {?} name
	     * @param {?} params
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (name, params, sourceSpan) {
	        return new InvokeMethodExpr(this, name, params, null, sourceSpan);
	    };
	    /**
	     * @param {?} params
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.callFn = /**
	     * @param {?} params
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (params, sourceSpan) {
	        return new InvokeFunctionExpr(this, params, null, sourceSpan);
	    };
	    /**
	     * @param {?} params
	     * @param {?=} type
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.instantiate = /**
	     * @param {?} params
	     * @param {?=} type
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (params, type, sourceSpan) {
	        return new InstantiateExpr(this, params, type, sourceSpan);
	    };
	    /**
	     * @param {?} trueCase
	     * @param {?=} falseCase
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.conditional = /**
	     * @param {?} trueCase
	     * @param {?=} falseCase
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (trueCase, falseCase, sourceSpan) {
	        if (falseCase === void 0) { falseCase = null; }
	        return new ConditionalExpr(this, trueCase, falseCase, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.equals = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Equals, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.notEquals = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.NotEquals, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.identical = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Identical, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.notIdentical = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.NotIdentical, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.minus = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Minus, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.plus = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Plus, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.divide = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Divide, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.multiply = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Multiply, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.modulo = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Modulo, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.and = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.And, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.or = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Or, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.lower = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Lower, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.lowerEquals = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.LowerEquals, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.bigger = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.Bigger, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.biggerEquals = /**
	     * @param {?} rhs
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (rhs, sourceSpan) {
	        return new BinaryOperatorExpr(BinaryOperator.BiggerEquals, this, rhs, null, sourceSpan);
	    };
	    /**
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.isBlank = /**
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (sourceSpan) {
	        // Note: We use equals by purpose here to compare to null and undefined in JS.
	        // We use the typed null to allow strictNullChecks to narrow types.
	        return this.equals(TYPED_NULL_EXPR, sourceSpan);
	    };
	    /**
	     * @param {?} type
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    Expression.prototype.cast = /**
	     * @param {?} type
	     * @param {?=} sourceSpan
	     * @return {?}
	     */
	    function (type, sourceSpan) {
	        return new CastExpr(this, type, sourceSpan);
	    };
	    /**
	     * @return {?}
	     */
	    Expression.prototype.toStmt = /**
	     * @return {?}
	     */
	    function () { return new ExpressionStatement(this, null); };
	    return Expression;
	}());
	/** @enum {number} */
	var BuiltinVar = {
	    This: 0,
	    Super: 1,
	    CatchError: 2,
	    CatchStack: 3,
	};
	BuiltinVar[BuiltinVar.This] = "This";
	BuiltinVar[BuiltinVar.Super] = "Super";
	BuiltinVar[BuiltinVar.CatchError] = "CatchError";
	BuiltinVar[BuiltinVar.CatchStack] = "CatchStack";
	var ReadVarExpr = /** @class */ (function (_super) {
	    __extends(ReadVarExpr, _super);
	    function ReadVarExpr(name, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        if (typeof name === 'string') {
	            _this.name = name;
	            _this.builtin = null;
	        }
	        else {
	            _this.name = null;
	            _this.builtin = /** @type {?} */ (name);
	        }
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    ReadVarExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof ReadVarExpr && this.name === e.name && this.builtin === e.builtin;
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ReadVarExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitReadVarExpr(this, context);
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    ReadVarExpr.prototype.set = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (!this.name) {
	            throw new Error("Built in variable " + this.builtin + " can not be assigned to.");
	        }
	        return new WriteVarExpr(this.name, value, null, this.sourceSpan);
	    };
	    return ReadVarExpr;
	}(Expression));
	var WriteVarExpr = /** @class */ (function (_super) {
	    __extends(WriteVarExpr, _super);
	    function WriteVarExpr(name, value, type, sourceSpan) {
	        var _this = _super.call(this, type || value.type, sourceSpan) || this;
	        _this.name = name;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    WriteVarExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof WriteVarExpr && this.name === e.name && this.value.isEquivalent(e.value);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    WriteVarExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitWriteVarExpr(this, context);
	    };
	    /**
	     * @param {?=} type
	     * @param {?=} modifiers
	     * @return {?}
	     */
	    WriteVarExpr.prototype.toDeclStmt = /**
	     * @param {?=} type
	     * @param {?=} modifiers
	     * @return {?}
	     */
	    function (type, modifiers) {
	        return new DeclareVarStmt(this.name, this.value, type, modifiers, this.sourceSpan);
	    };
	    return WriteVarExpr;
	}(Expression));
	var WriteKeyExpr = /** @class */ (function (_super) {
	    __extends(WriteKeyExpr, _super);
	    function WriteKeyExpr(receiver, index, value, type, sourceSpan) {
	        var _this = _super.call(this, type || value.type, sourceSpan) || this;
	        _this.receiver = receiver;
	        _this.index = index;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    WriteKeyExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof WriteKeyExpr && this.receiver.isEquivalent(e.receiver) &&
	            this.index.isEquivalent(e.index) && this.value.isEquivalent(e.value);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    WriteKeyExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitWriteKeyExpr(this, context);
	    };
	    return WriteKeyExpr;
	}(Expression));
	var WritePropExpr = /** @class */ (function (_super) {
	    __extends(WritePropExpr, _super);
	    function WritePropExpr(receiver, name, value, type, sourceSpan) {
	        var _this = _super.call(this, type || value.type, sourceSpan) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    WritePropExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof WritePropExpr && this.receiver.isEquivalent(e.receiver) &&
	            this.name === e.name && this.value.isEquivalent(e.value);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    WritePropExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitWritePropExpr(this, context);
	    };
	    return WritePropExpr;
	}(Expression));
	/** @enum {number} */
	var BuiltinMethod = {
	    ConcatArray: 0,
	    SubscribeObservable: 1,
	    Bind: 2,
	};
	BuiltinMethod[BuiltinMethod.ConcatArray] = "ConcatArray";
	BuiltinMethod[BuiltinMethod.SubscribeObservable] = "SubscribeObservable";
	BuiltinMethod[BuiltinMethod.Bind] = "Bind";
	var InvokeMethodExpr = /** @class */ (function (_super) {
	    __extends(InvokeMethodExpr, _super);
	    function InvokeMethodExpr(receiver, method, args, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.receiver = receiver;
	        _this.args = args;
	        if (typeof method === 'string') {
	            _this.name = method;
	            _this.builtin = null;
	        }
	        else {
	            _this.name = null;
	            _this.builtin = /** @type {?} */ (method);
	        }
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    InvokeMethodExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof InvokeMethodExpr && this.receiver.isEquivalent(e.receiver) &&
	            this.name === e.name && this.builtin === e.builtin && areAllEquivalent(this.args, e.args);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    InvokeMethodExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitInvokeMethodExpr(this, context);
	    };
	    return InvokeMethodExpr;
	}(Expression));
	var InvokeFunctionExpr = /** @class */ (function (_super) {
	    __extends(InvokeFunctionExpr, _super);
	    function InvokeFunctionExpr(fn, args, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.fn = fn;
	        _this.args = args;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    InvokeFunctionExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof InvokeFunctionExpr && this.fn.isEquivalent(e.fn) &&
	            areAllEquivalent(this.args, e.args);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    InvokeFunctionExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitInvokeFunctionExpr(this, context);
	    };
	    return InvokeFunctionExpr;
	}(Expression));
	var InstantiateExpr = /** @class */ (function (_super) {
	    __extends(InstantiateExpr, _super);
	    function InstantiateExpr(classExpr, args, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.classExpr = classExpr;
	        _this.args = args;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    InstantiateExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof InstantiateExpr && this.classExpr.isEquivalent(e.classExpr) &&
	            areAllEquivalent(this.args, e.args);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    InstantiateExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitInstantiateExpr(this, context);
	    };
	    return InstantiateExpr;
	}(Expression));
	var LiteralExpr = /** @class */ (function (_super) {
	    __extends(LiteralExpr, _super);
	    function LiteralExpr(value, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    LiteralExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof LiteralExpr && this.value === e.value;
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    LiteralExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitLiteralExpr(this, context);
	    };
	    return LiteralExpr;
	}(Expression));
	var ExternalExpr = /** @class */ (function (_super) {
	    __extends(ExternalExpr, _super);
	    function ExternalExpr(value, type, typeParams, sourceSpan) {
	        if (typeParams === void 0) { typeParams = null; }
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.value = value;
	        _this.typeParams = typeParams;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    ExternalExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof ExternalExpr && this.value.name === e.value.name &&
	            this.value.moduleName === e.value.moduleName && this.value.runtime === e.value.runtime;
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ExternalExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitExternalExpr(this, context);
	    };
	    return ExternalExpr;
	}(Expression));
	var ExternalReference = /** @class */ (function () {
	    function ExternalReference(moduleName, name, runtime) {
	        this.moduleName = moduleName;
	        this.name = name;
	        this.runtime = runtime;
	    }
	    return ExternalReference;
	}());
	var ConditionalExpr = /** @class */ (function (_super) {
	    __extends(ConditionalExpr, _super);
	    function ConditionalExpr(condition, trueCase, falseCase, type, sourceSpan) {
	        if (falseCase === void 0) { falseCase = null; }
	        var _this = _super.call(this, type || trueCase.type, sourceSpan) || this;
	        _this.condition = condition;
	        _this.falseCase = falseCase;
	        _this.trueCase = trueCase;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    ConditionalExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof ConditionalExpr && this.condition.isEquivalent(e.condition) &&
	            this.trueCase.isEquivalent(e.trueCase) && nullSafeIsEquivalent(this.falseCase, e.falseCase);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ConditionalExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitConditionalExpr(this, context);
	    };
	    return ConditionalExpr;
	}(Expression));
	var NotExpr = /** @class */ (function (_super) {
	    __extends(NotExpr, _super);
	    function NotExpr(condition, sourceSpan) {
	        var _this = _super.call(this, BOOL_TYPE, sourceSpan) || this;
	        _this.condition = condition;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    NotExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof NotExpr && this.condition.isEquivalent(e.condition);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    NotExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitNotExpr(this, context);
	    };
	    return NotExpr;
	}(Expression));
	var AssertNotNull = /** @class */ (function (_super) {
	    __extends(AssertNotNull, _super);
	    function AssertNotNull(condition, sourceSpan) {
	        var _this = _super.call(this, condition.type, sourceSpan) || this;
	        _this.condition = condition;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    AssertNotNull.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof AssertNotNull && this.condition.isEquivalent(e.condition);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    AssertNotNull.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitAssertNotNullExpr(this, context);
	    };
	    return AssertNotNull;
	}(Expression));
	var CastExpr = /** @class */ (function (_super) {
	    __extends(CastExpr, _super);
	    function CastExpr(value, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    CastExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof CastExpr && this.value.isEquivalent(e.value);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    CastExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitCastExpr(this, context);
	    };
	    return CastExpr;
	}(Expression));
	var FnParam = /** @class */ (function () {
	    function FnParam(name, type) {
	        if (type === void 0) { type = null; }
	        this.name = name;
	        this.type = type;
	    }
	    /**
	     * @param {?} param
	     * @return {?}
	     */
	    FnParam.prototype.isEquivalent = /**
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) { return this.name === param.name; };
	    return FnParam;
	}());
	var FunctionExpr = /** @class */ (function (_super) {
	    __extends(FunctionExpr, _super);
	    function FunctionExpr(params, statements, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.params = params;
	        _this.statements = statements;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    FunctionExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof FunctionExpr && areAllEquivalent(this.params, e.params) &&
	            areAllEquivalent(this.statements, e.statements);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    FunctionExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitFunctionExpr(this, context);
	    };
	    /**
	     * @param {?} name
	     * @param {?=} modifiers
	     * @return {?}
	     */
	    FunctionExpr.prototype.toDeclStmt = /**
	     * @param {?} name
	     * @param {?=} modifiers
	     * @return {?}
	     */
	    function (name, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        return new DeclareFunctionStmt(name, this.params, this.statements, this.type, modifiers, this.sourceSpan);
	    };
	    return FunctionExpr;
	}(Expression));
	var BinaryOperatorExpr = /** @class */ (function (_super) {
	    __extends(BinaryOperatorExpr, _super);
	    function BinaryOperatorExpr(operator, lhs, rhs, type, sourceSpan) {
	        var _this = _super.call(this, type || lhs.type, sourceSpan) || this;
	        _this.operator = operator;
	        _this.rhs = rhs;
	        _this.lhs = lhs;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    BinaryOperatorExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof BinaryOperatorExpr && this.operator === e.operator &&
	            this.lhs.isEquivalent(e.lhs) && this.rhs.isEquivalent(e.rhs);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    BinaryOperatorExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitBinaryOperatorExpr(this, context);
	    };
	    return BinaryOperatorExpr;
	}(Expression));
	var ReadPropExpr = /** @class */ (function (_super) {
	    __extends(ReadPropExpr, _super);
	    function ReadPropExpr(receiver, name, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.receiver = receiver;
	        _this.name = name;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    ReadPropExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof ReadPropExpr && this.receiver.isEquivalent(e.receiver) &&
	            this.name === e.name;
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ReadPropExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitReadPropExpr(this, context);
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    ReadPropExpr.prototype.set = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return new WritePropExpr(this.receiver, this.name, value, null, this.sourceSpan);
	    };
	    return ReadPropExpr;
	}(Expression));
	var ReadKeyExpr = /** @class */ (function (_super) {
	    __extends(ReadKeyExpr, _super);
	    function ReadKeyExpr(receiver, index, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.receiver = receiver;
	        _this.index = index;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    ReadKeyExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof ReadKeyExpr && this.receiver.isEquivalent(e.receiver) &&
	            this.index.isEquivalent(e.index);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ReadKeyExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitReadKeyExpr(this, context);
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    ReadKeyExpr.prototype.set = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return new WriteKeyExpr(this.receiver, this.index, value, null, this.sourceSpan);
	    };
	    return ReadKeyExpr;
	}(Expression));
	var LiteralArrayExpr = /** @class */ (function (_super) {
	    __extends(LiteralArrayExpr, _super);
	    function LiteralArrayExpr(entries, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.entries = entries;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    LiteralArrayExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof LiteralArrayExpr && areAllEquivalent(this.entries, e.entries);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    LiteralArrayExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitLiteralArrayExpr(this, context);
	    };
	    return LiteralArrayExpr;
	}(Expression));
	var LiteralMapEntry = /** @class */ (function () {
	    function LiteralMapEntry(key, value, quoted) {
	        this.key = key;
	        this.value = value;
	        this.quoted = quoted;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    LiteralMapEntry.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return this.key === e.key && this.value.isEquivalent(e.value);
	    };
	    return LiteralMapEntry;
	}());
	var LiteralMapExpr = /** @class */ (function (_super) {
	    __extends(LiteralMapExpr, _super);
	    function LiteralMapExpr(entries, type, sourceSpan) {
	        var _this = _super.call(this, type, sourceSpan) || this;
	        _this.entries = entries;
	        _this.valueType = null;
	        if (type) {
	            _this.valueType = type.valueType;
	        }
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    LiteralMapExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof LiteralMapExpr && areAllEquivalent(this.entries, e.entries);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    LiteralMapExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitLiteralMapExpr(this, context);
	    };
	    return LiteralMapExpr;
	}(Expression));
	var CommaExpr = /** @class */ (function (_super) {
	    __extends(CommaExpr, _super);
	    function CommaExpr(parts, sourceSpan) {
	        var _this = _super.call(this, parts[parts.length - 1].type, sourceSpan) || this;
	        _this.parts = parts;
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    CommaExpr.prototype.isEquivalent = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return e instanceof CommaExpr && areAllEquivalent(this.parts, e.parts);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    CommaExpr.prototype.visitExpression = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitCommaExpr(this, context);
	    };
	    return CommaExpr;
	}(Expression));
	/**
	 * @record
	 */
	
	var THIS_EXPR = new ReadVarExpr(BuiltinVar.This, null, null);
	var SUPER_EXPR = new ReadVarExpr(BuiltinVar.Super, null, null);
	var CATCH_ERROR_VAR = new ReadVarExpr(BuiltinVar.CatchError, null, null);
	var CATCH_STACK_VAR = new ReadVarExpr(BuiltinVar.CatchStack, null, null);
	var NULL_EXPR = new LiteralExpr(null, null, null);
	var TYPED_NULL_EXPR = new LiteralExpr(null, INFERRED_TYPE, null);
	/** @enum {number} */
	var StmtModifier = {
	    Final: 0,
	    Private: 1,
	    Exported: 2,
	};
	StmtModifier[StmtModifier.Final] = "Final";
	StmtModifier[StmtModifier.Private] = "Private";
	StmtModifier[StmtModifier.Exported] = "Exported";
	/**
	 * @abstract
	 */
	var Statement = /** @class */ (function () {
	    function Statement(modifiers, sourceSpan) {
	        this.modifiers = modifiers || [];
	        this.sourceSpan = sourceSpan || null;
	    }
	    /**
	     * @param {?} modifier
	     * @return {?}
	     */
	    Statement.prototype.hasModifier = /**
	     * @param {?} modifier
	     * @return {?}
	     */
	    function (modifier) { return /** @type {?} */ ((this.modifiers)).indexOf(modifier) !== -1; };
	    return Statement;
	}());
	var DeclareVarStmt = /** @class */ (function (_super) {
	    __extends(DeclareVarStmt, _super);
	    function DeclareVarStmt(name, value, type, modifiers, sourceSpan) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers, sourceSpan) || this;
	        _this.name = name;
	        _this.value = value;
	        _this.type = type || value.type;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    DeclareVarStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof DeclareVarStmt && this.name === stmt.name &&
	            this.value.isEquivalent(stmt.value);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    DeclareVarStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitDeclareVarStmt(this, context);
	    };
	    return DeclareVarStmt;
	}(Statement));
	var DeclareFunctionStmt = /** @class */ (function (_super) {
	    __extends(DeclareFunctionStmt, _super);
	    function DeclareFunctionStmt(name, params, statements, type, modifiers, sourceSpan) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers, sourceSpan) || this;
	        _this.name = name;
	        _this.params = params;
	        _this.statements = statements;
	        _this.type = type || null;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    DeclareFunctionStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof DeclareFunctionStmt && areAllEquivalent(this.params, stmt.params) &&
	            areAllEquivalent(this.statements, stmt.statements);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    DeclareFunctionStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitDeclareFunctionStmt(this, context);
	    };
	    return DeclareFunctionStmt;
	}(Statement));
	var ExpressionStatement = /** @class */ (function (_super) {
	    __extends(ExpressionStatement, _super);
	    function ExpressionStatement(expr, sourceSpan) {
	        var _this = _super.call(this, null, sourceSpan) || this;
	        _this.expr = expr;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    ExpressionStatement.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof ExpressionStatement && this.expr.isEquivalent(stmt.expr);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ExpressionStatement.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitExpressionStmt(this, context);
	    };
	    return ExpressionStatement;
	}(Statement));
	var ReturnStatement = /** @class */ (function (_super) {
	    __extends(ReturnStatement, _super);
	    function ReturnStatement(value, sourceSpan) {
	        var _this = _super.call(this, null, sourceSpan) || this;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    ReturnStatement.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof ReturnStatement && this.value.isEquivalent(stmt.value);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ReturnStatement.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitReturnStmt(this, context);
	    };
	    return ReturnStatement;
	}(Statement));
	var AbstractClassPart = /** @class */ (function () {
	    function AbstractClassPart(type, modifiers) {
	        this.modifiers = modifiers;
	        if (!modifiers) {
	            this.modifiers = [];
	        }
	        this.type = type || null;
	    }
	    /**
	     * @param {?} modifier
	     * @return {?}
	     */
	    AbstractClassPart.prototype.hasModifier = /**
	     * @param {?} modifier
	     * @return {?}
	     */
	    function (modifier) { return /** @type {?} */ ((this.modifiers)).indexOf(modifier) !== -1; };
	    return AbstractClassPart;
	}());
	var ClassField = /** @class */ (function (_super) {
	    __extends(ClassField, _super);
	    function ClassField(name, type, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, type, modifiers) || this;
	        _this.name = name;
	        return _this;
	    }
	    /**
	     * @param {?} f
	     * @return {?}
	     */
	    ClassField.prototype.isEquivalent = /**
	     * @param {?} f
	     * @return {?}
	     */
	    function (f) { return this.name === f.name; };
	    return ClassField;
	}(AbstractClassPart));
	var ClassMethod = /** @class */ (function (_super) {
	    __extends(ClassMethod, _super);
	    function ClassMethod(name, params, body, type, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, type, modifiers) || this;
	        _this.name = name;
	        _this.params = params;
	        _this.body = body;
	        return _this;
	    }
	    /**
	     * @param {?} m
	     * @return {?}
	     */
	    ClassMethod.prototype.isEquivalent = /**
	     * @param {?} m
	     * @return {?}
	     */
	    function (m) {
	        return this.name === m.name && areAllEquivalent(this.body, m.body);
	    };
	    return ClassMethod;
	}(AbstractClassPart));
	var ClassGetter = /** @class */ (function (_super) {
	    __extends(ClassGetter, _super);
	    function ClassGetter(name, body, type, modifiers) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, type, modifiers) || this;
	        _this.name = name;
	        _this.body = body;
	        return _this;
	    }
	    /**
	     * @param {?} m
	     * @return {?}
	     */
	    ClassGetter.prototype.isEquivalent = /**
	     * @param {?} m
	     * @return {?}
	     */
	    function (m) {
	        return this.name === m.name && areAllEquivalent(this.body, m.body);
	    };
	    return ClassGetter;
	}(AbstractClassPart));
	var ClassStmt = /** @class */ (function (_super) {
	    __extends(ClassStmt, _super);
	    function ClassStmt(name, parent, fields, getters, constructorMethod, methods, modifiers, sourceSpan) {
	        if (modifiers === void 0) { modifiers = null; }
	        var _this = _super.call(this, modifiers, sourceSpan) || this;
	        _this.name = name;
	        _this.parent = parent;
	        _this.fields = fields;
	        _this.getters = getters;
	        _this.constructorMethod = constructorMethod;
	        _this.methods = methods;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    ClassStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof ClassStmt && this.name === stmt.name &&
	            nullSafeIsEquivalent(this.parent, stmt.parent) &&
	            areAllEquivalent(this.fields, stmt.fields) &&
	            areAllEquivalent(this.getters, stmt.getters) &&
	            this.constructorMethod.isEquivalent(stmt.constructorMethod) &&
	            areAllEquivalent(this.methods, stmt.methods);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ClassStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitDeclareClassStmt(this, context);
	    };
	    return ClassStmt;
	}(Statement));
	var IfStmt = /** @class */ (function (_super) {
	    __extends(IfStmt, _super);
	    function IfStmt(condition, trueCase, falseCase, sourceSpan) {
	        if (falseCase === void 0) { falseCase = []; }
	        var _this = _super.call(this, null, sourceSpan) || this;
	        _this.condition = condition;
	        _this.trueCase = trueCase;
	        _this.falseCase = falseCase;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    IfStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof IfStmt && this.condition.isEquivalent(stmt.condition) &&
	            areAllEquivalent(this.trueCase, stmt.trueCase) &&
	            areAllEquivalent(this.falseCase, stmt.falseCase);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    IfStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitIfStmt(this, context);
	    };
	    return IfStmt;
	}(Statement));
	var CommentStmt = /** @class */ (function (_super) {
	    __extends(CommentStmt, _super);
	    function CommentStmt(comment, sourceSpan) {
	        var _this = _super.call(this, null, sourceSpan) || this;
	        _this.comment = comment;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    CommentStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) { return stmt instanceof CommentStmt; };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    CommentStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitCommentStmt(this, context);
	    };
	    return CommentStmt;
	}(Statement));
	var TryCatchStmt = /** @class */ (function (_super) {
	    __extends(TryCatchStmt, _super);
	    function TryCatchStmt(bodyStmts, catchStmts, sourceSpan) {
	        var _this = _super.call(this, null, sourceSpan) || this;
	        _this.bodyStmts = bodyStmts;
	        _this.catchStmts = catchStmts;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    TryCatchStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof TryCatchStmt && areAllEquivalent(this.bodyStmts, stmt.bodyStmts) &&
	            areAllEquivalent(this.catchStmts, stmt.catchStmts);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    TryCatchStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitTryCatchStmt(this, context);
	    };
	    return TryCatchStmt;
	}(Statement));
	var ThrowStmt = /** @class */ (function (_super) {
	    __extends(ThrowStmt, _super);
	    function ThrowStmt(error, sourceSpan) {
	        var _this = _super.call(this, null, sourceSpan) || this;
	        _this.error = error;
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    ThrowStmt.prototype.isEquivalent = /**
	     * @param {?} stmt
	     * @return {?}
	     */
	    function (stmt) {
	        return stmt instanceof TryCatchStmt && this.error.isEquivalent(stmt.error);
	    };
	    /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    ThrowStmt.prototype.visitStatement = /**
	     * @param {?} visitor
	     * @param {?} context
	     * @return {?}
	     */
	    function (visitor, context) {
	        return visitor.visitThrowStmt(this, context);
	    };
	    return ThrowStmt;
	}(Statement));
	/**
	 * @record
	 */
	
	var AstTransformer$1 = /** @class */ (function () {
	    function AstTransformer() {
	    }
	    /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.transformExpr = /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    function (expr, context) { return expr; };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.transformStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) { return stmt; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitReadVarExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return this.transformExpr(ast, context); };
	    /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitWriteVarExpr = /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    function (expr, context) {
	        return this.transformExpr(new WriteVarExpr(expr.name, expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
	    };
	    /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitWriteKeyExpr = /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    function (expr, context) {
	        return this.transformExpr(new WriteKeyExpr(expr.receiver.visitExpression(this, context), expr.index.visitExpression(this, context), expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
	    };
	    /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitWritePropExpr = /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    function (expr, context) {
	        return this.transformExpr(new WritePropExpr(expr.receiver.visitExpression(this, context), expr.name, expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitInvokeMethodExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ method = ast.builtin || ast.name;
	        return this.transformExpr(new InvokeMethodExpr(ast.receiver.visitExpression(this, context), /** @type {?} */ ((method)), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitInvokeFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new InvokeFunctionExpr(ast.fn.visitExpression(this, context), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitInstantiateExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new InstantiateExpr(ast.classExpr.visitExpression(this, context), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitLiteralExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return this.transformExpr(ast, context); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitExternalExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitConditionalExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new ConditionalExpr(ast.condition.visitExpression(this, context), ast.trueCase.visitExpression(this, context), /** @type {?} */ ((ast.falseCase)).visitExpression(this, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitNotExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new NotExpr(ast.condition.visitExpression(this, context), ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitAssertNotNullExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new AssertNotNull(ast.condition.visitExpression(this, context), ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitCastExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new CastExpr(ast.value.visitExpression(this, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new FunctionExpr(ast.params, this.visitAllStatements(ast.statements, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitBinaryOperatorExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new BinaryOperatorExpr(ast.operator, ast.lhs.visitExpression(this, context), ast.rhs.visitExpression(this, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitReadPropExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new ReadPropExpr(ast.receiver.visitExpression(this, context), ast.name, ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitReadKeyExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new ReadKeyExpr(ast.receiver.visitExpression(this, context), ast.index.visitExpression(this, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitLiteralArrayExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new LiteralArrayExpr(this.visitAllExpressions(ast.entries, context), ast.type, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitLiteralMapExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ entries = ast.entries.map(function (entry) {
	            return new LiteralMapEntry(entry.key, entry.value.visitExpression(_this, context), entry.quoted);
	        });
	        var /** @type {?} */ mapType = new MapType(ast.valueType, null);
	        return this.transformExpr(new LiteralMapExpr(entries, mapType, ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitCommaExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.transformExpr(new CommaExpr(this.visitAllExpressions(ast.parts, context), ast.sourceSpan), context);
	    };
	    /**
	     * @param {?} exprs
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitAllExpressions = /**
	     * @param {?} exprs
	     * @param {?} context
	     * @return {?}
	     */
	    function (exprs, context) {
	        var _this = this;
	        return exprs.map(function (expr) { return expr.visitExpression(_this, context); });
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitDeclareVarStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new DeclareVarStmt(stmt.name, stmt.value.visitExpression(this, context), stmt.type, stmt.modifiers, stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new DeclareFunctionStmt(stmt.name, stmt.params, this.visitAllStatements(stmt.statements, context), stmt.type, stmt.modifiers, stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitExpressionStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new ExpressionStatement(stmt.expr.visitExpression(this, context), stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitReturnStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new ReturnStatement(stmt.value.visitExpression(this, context), stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        var _this = this;
	        var /** @type {?} */ parent = /** @type {?} */ ((stmt.parent)).visitExpression(this, context);
	        var /** @type {?} */ getters = stmt.getters.map(function (getter) {
	            return new ClassGetter(getter.name, _this.visitAllStatements(getter.body, context), getter.type, getter.modifiers);
	        });
	        var /** @type {?} */ ctorMethod = stmt.constructorMethod &&
	            new ClassMethod(stmt.constructorMethod.name, stmt.constructorMethod.params, this.visitAllStatements(stmt.constructorMethod.body, context), stmt.constructorMethod.type, stmt.constructorMethod.modifiers);
	        var /** @type {?} */ methods = stmt.methods.map(function (method) {
	            return new ClassMethod(method.name, method.params, _this.visitAllStatements(method.body, context), method.type, method.modifiers);
	        });
	        return this.transformStmt(new ClassStmt(stmt.name, parent, stmt.fields, getters, ctorMethod, methods, stmt.modifiers, stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitIfStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new IfStmt(stmt.condition.visitExpression(this, context), this.visitAllStatements(stmt.trueCase, context), this.visitAllStatements(stmt.falseCase, context), stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitTryCatchStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new TryCatchStmt(this.visitAllStatements(stmt.bodyStmts, context), this.visitAllStatements(stmt.catchStmts, context), stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitThrowStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(new ThrowStmt(stmt.error.visitExpression(this, context), stmt.sourceSpan), context);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitCommentStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        return this.transformStmt(stmt, context);
	    };
	    /**
	     * @param {?} stmts
	     * @param {?} context
	     * @return {?}
	     */
	    AstTransformer.prototype.visitAllStatements = /**
	     * @param {?} stmts
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmts, context) {
	        var _this = this;
	        return stmts.map(function (stmt) { return stmt.visitStatement(_this, context); });
	    };
	    return AstTransformer;
	}());
	var RecursiveAstVisitor$1 = /** @class */ (function () {
	    function RecursiveAstVisitor() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitType = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { return ast; };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitExpression = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        if (ast.type) {
	            ast.type.visitType(this, context);
	        }
	        return ast;
	    };
	    /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitBuiltintType = /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    function (type, context) { return this.visitType(type, context); };
	    /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitExpressionType = /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    function (type, context) {
	        type.value.visitExpression(this, context);
	        return this.visitType(type, context);
	    };
	    /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitArrayType = /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    function (type, context) { return this.visitType(type, context); };
	    /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitMapType = /**
	     * @param {?} type
	     * @param {?} context
	     * @return {?}
	     */
	    function (type, context) { return this.visitType(type, context); };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitReadVarExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitWriteVarExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.value.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitWriteKeyExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visitExpression(this, context);
	        ast.index.visitExpression(this, context);
	        ast.value.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitWritePropExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visitExpression(this, context);
	        ast.value.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitInvokeMethodExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visitExpression(this, context);
	        this.visitAllExpressions(ast.args, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitInvokeFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.fn.visitExpression(this, context);
	        this.visitAllExpressions(ast.args, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitInstantiateExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.classExpr.visitExpression(this, context);
	        this.visitAllExpressions(ast.args, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitLiteralExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitExternalExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        if (ast.typeParams) {
	            ast.typeParams.forEach(function (type) { return type.visitType(_this, context); });
	        }
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitConditionalExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.condition.visitExpression(this, context);
	        ast.trueCase.visitExpression(this, context); /** @type {?} */
	        ((ast.falseCase)).visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitNotExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.condition.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitAssertNotNullExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.condition.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitCastExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.value.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        this.visitAllStatements(ast.statements, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitBinaryOperatorExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.lhs.visitExpression(this, context);
	        ast.rhs.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitReadPropExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitReadKeyExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        ast.receiver.visitExpression(this, context);
	        ast.index.visitExpression(this, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitLiteralArrayExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        this.visitAllExpressions(ast.entries, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitLiteralMapExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        ast.entries.forEach(function (entry) { return entry.value.visitExpression(_this, context); });
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitCommaExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        this.visitAllExpressions(ast.parts, context);
	        return this.visitExpression(ast, context);
	    };
	    /**
	     * @param {?} exprs
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitAllExpressions = /**
	     * @param {?} exprs
	     * @param {?} context
	     * @return {?}
	     */
	    function (exprs, context) {
	        var _this = this;
	        exprs.forEach(function (expr) { return expr.visitExpression(_this, context); });
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitDeclareVarStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        stmt.value.visitExpression(this, context);
	        if (stmt.type) {
	            stmt.type.visitType(this, context);
	        }
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        this.visitAllStatements(stmt.statements, context);
	        if (stmt.type) {
	            stmt.type.visitType(this, context);
	        }
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitExpressionStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        stmt.expr.visitExpression(this, context);
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitReturnStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        stmt.value.visitExpression(this, context);
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        var _this = this;
	        /** @type {?} */ ((stmt.parent)).visitExpression(this, context);
	        stmt.getters.forEach(function (getter) { return _this.visitAllStatements(getter.body, context); });
	        if (stmt.constructorMethod) {
	            this.visitAllStatements(stmt.constructorMethod.body, context);
	        }
	        stmt.methods.forEach(function (method) { return _this.visitAllStatements(method.body, context); });
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitIfStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        stmt.condition.visitExpression(this, context);
	        this.visitAllStatements(stmt.trueCase, context);
	        this.visitAllStatements(stmt.falseCase, context);
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitTryCatchStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        this.visitAllStatements(stmt.bodyStmts, context);
	        this.visitAllStatements(stmt.catchStmts, context);
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitThrowStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        stmt.error.visitExpression(this, context);
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitCommentStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) { return stmt; };
	    /**
	     * @param {?} stmts
	     * @param {?} context
	     * @return {?}
	     */
	    RecursiveAstVisitor.prototype.visitAllStatements = /**
	     * @param {?} stmts
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmts, context) {
	        var _this = this;
	        stmts.forEach(function (stmt) { return stmt.visitStatement(_this, context); });
	    };
	    return RecursiveAstVisitor;
	}());
	/**
	 * @param {?} stmts
	 * @return {?}
	 */
	function findReadVarNames(stmts) {
	    var /** @type {?} */ visitor = new _ReadVarVisitor();
	    visitor.visitAllStatements(stmts, null);
	    return visitor.varNames;
	}
	var _ReadVarVisitor = /** @class */ (function (_super) {
	    __extends(_ReadVarVisitor, _super);
	    function _ReadVarVisitor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.varNames = new Set();
	        return _this;
	    }
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    _ReadVarVisitor.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        // Don't descend into nested functions
	        return stmt;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    _ReadVarVisitor.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        // Don't descend into nested classes
	        return stmt;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    _ReadVarVisitor.prototype.visitReadVarExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        if (ast.name) {
	            this.varNames.add(ast.name);
	        }
	        return null;
	    };
	    return _ReadVarVisitor;
	}(RecursiveAstVisitor$1));
	/**
	 * @param {?} stmts
	 * @return {?}
	 */
	function collectExternalReferences(stmts) {
	    var /** @type {?} */ visitor = new _FindExternalReferencesVisitor();
	    visitor.visitAllStatements(stmts, null);
	    return visitor.externalReferences;
	}
	var _FindExternalReferencesVisitor = /** @class */ (function (_super) {
	    __extends(_FindExternalReferencesVisitor, _super);
	    function _FindExternalReferencesVisitor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.externalReferences = [];
	        return _this;
	    }
	    /**
	     * @param {?} e
	     * @param {?} context
	     * @return {?}
	     */
	    _FindExternalReferencesVisitor.prototype.visitExternalExpr = /**
	     * @param {?} e
	     * @param {?} context
	     * @return {?}
	     */
	    function (e, context) {
	        this.externalReferences.push(e.value);
	        return _super.prototype.visitExternalExpr.call(this, e, context);
	    };
	    return _FindExternalReferencesVisitor;
	}(RecursiveAstVisitor$1));
	/**
	 * @param {?} stmt
	 * @param {?} sourceSpan
	 * @return {?}
	 */
	function applySourceSpanToStatementIfNeeded(stmt, sourceSpan) {
	    if (!sourceSpan) {
	        return stmt;
	    }
	    var /** @type {?} */ transformer = new _ApplySourceSpanTransformer(sourceSpan);
	    return stmt.visitStatement(transformer, null);
	}
	/**
	 * @param {?} expr
	 * @param {?} sourceSpan
	 * @return {?}
	 */
	function applySourceSpanToExpressionIfNeeded(expr, sourceSpan) {
	    if (!sourceSpan) {
	        return expr;
	    }
	    var /** @type {?} */ transformer = new _ApplySourceSpanTransformer(sourceSpan);
	    return expr.visitExpression(transformer, null);
	}
	var _ApplySourceSpanTransformer = /** @class */ (function (_super) {
	    __extends(_ApplySourceSpanTransformer, _super);
	    function _ApplySourceSpanTransformer(sourceSpan) {
	        var _this = _super.call(this) || this;
	        _this.sourceSpan = sourceSpan;
	        return _this;
	    }
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    _ApplySourceSpanTransformer.prototype._clone = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) {
	        var /** @type {?} */ clone = Object.create(obj.constructor.prototype);
	        for (var /** @type {?} */ prop in obj) {
	            clone[prop] = obj[prop];
	        }
	        return clone;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    _ApplySourceSpanTransformer.prototype.transformExpr = /**
	     * @param {?} expr
	     * @param {?} context
	     * @return {?}
	     */
	    function (expr, context) {
	        if (!expr.sourceSpan) {
	            expr = this._clone(expr);
	            expr.sourceSpan = this.sourceSpan;
	        }
	        return expr;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    _ApplySourceSpanTransformer.prototype.transformStmt = /**
	     * @param {?} stmt
	     * @param {?} context
	     * @return {?}
	     */
	    function (stmt, context) {
	        if (!stmt.sourceSpan) {
	            stmt = this._clone(stmt);
	            stmt.sourceSpan = this.sourceSpan;
	        }
	        return stmt;
	    };
	    return _ApplySourceSpanTransformer;
	}(AstTransformer$1));
	/**
	 * @param {?} name
	 * @param {?=} type
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function variable(name, type, sourceSpan) {
	    return new ReadVarExpr(name, type, sourceSpan);
	}
	/**
	 * @param {?} id
	 * @param {?=} typeParams
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function importExpr(id, typeParams, sourceSpan) {
	    if (typeParams === void 0) { typeParams = null; }
	    return new ExternalExpr(id, null, typeParams, sourceSpan);
	}
	/**
	 * @param {?} id
	 * @param {?=} typeParams
	 * @param {?=} typeModifiers
	 * @return {?}
	 */
	function importType(id, typeParams, typeModifiers) {
	    if (typeParams === void 0) { typeParams = null; }
	    if (typeModifiers === void 0) { typeModifiers = null; }
	    return id != null ? expressionType(importExpr(id, typeParams, null), typeModifiers) : null;
	}
	/**
	 * @param {?} expr
	 * @param {?=} typeModifiers
	 * @return {?}
	 */
	function expressionType(expr, typeModifiers) {
	    if (typeModifiers === void 0) { typeModifiers = null; }
	    return new ExpressionType(expr, typeModifiers);
	}
	/**
	 * @param {?} values
	 * @param {?=} type
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function literalArr(values, type, sourceSpan) {
	    return new LiteralArrayExpr(values, type, sourceSpan);
	}
	/**
	 * @param {?} values
	 * @param {?=} type
	 * @return {?}
	 */
	function literalMap(values, type) {
	    if (type === void 0) { type = null; }
	    return new LiteralMapExpr(values.map(function (e) { return new LiteralMapEntry(e.key, e.value, e.quoted); }), type, null);
	}
	/**
	 * @param {?} expr
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function not(expr, sourceSpan) {
	    return new NotExpr(expr, sourceSpan);
	}
	/**
	 * @param {?} expr
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function assertNotNull(expr, sourceSpan) {
	    return new AssertNotNull(expr, sourceSpan);
	}
	/**
	 * @param {?} params
	 * @param {?} body
	 * @param {?=} type
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function fn(params, body, type, sourceSpan) {
	    return new FunctionExpr(params, body, type, sourceSpan);
	}
	/**
	 * @param {?} value
	 * @param {?=} type
	 * @param {?=} sourceSpan
	 * @return {?}
	 */
	function literal(value, type, sourceSpan) {
	    return new LiteralExpr(value, type, sourceSpan);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ProviderError = /** @class */ (function (_super) {
	    __extends(ProviderError, _super);
	    function ProviderError(message, span) {
	        return _super.call(this, span, message) || this;
	    }
	    return ProviderError;
	}(ParseError));
	/**
	 * @record
	 */
	
	var ProviderViewContext = /** @class */ (function () {
	    function ProviderViewContext(reflector, component) {
	        var _this = this;
	        this.reflector = reflector;
	        this.component = component;
	        this.errors = [];
	        this.viewQueries = _getViewQueries(component);
	        this.viewProviders = new Map();
	        component.viewProviders.forEach(function (provider) {
	            if (_this.viewProviders.get(tokenReference(provider.token)) == null) {
	                _this.viewProviders.set(tokenReference(provider.token), true);
	            }
	        });
	    }
	    return ProviderViewContext;
	}());
	var ProviderElementContext = /** @class */ (function () {
	    function ProviderElementContext(viewContext, _parent, _isViewRoot, _directiveAsts, attrs, refs, isTemplate, contentQueryStartId, _sourceSpan) {
	        var _this = this;
	        this.viewContext = viewContext;
	        this._parent = _parent;
	        this._isViewRoot = _isViewRoot;
	        this._directiveAsts = _directiveAsts;
	        this._sourceSpan = _sourceSpan;
	        this._transformedProviders = new Map();
	        this._seenProviders = new Map();
	        this._queriedTokens = new Map();
	        this.transformedHasViewContainer = false;
	        this._attrs = {};
	        attrs.forEach(function (attrAst) { return _this._attrs[attrAst.name] = attrAst.value; });
	        var /** @type {?} */ directivesMeta = _directiveAsts.map(function (directiveAst) { return directiveAst.directive; });
	        this._allProviders =
	            _resolveProvidersFromDirectives(directivesMeta, _sourceSpan, viewContext.errors);
	        this._contentQueries = _getContentQueries(contentQueryStartId, directivesMeta);
	        Array.from(this._allProviders.values()).forEach(function (provider) {
	            _this._addQueryReadsTo(provider.token, provider.token, _this._queriedTokens);
	        });
	        if (isTemplate) {
	            var /** @type {?} */ templateRefId = createTokenForExternalReference(this.viewContext.reflector, Identifiers.TemplateRef);
	            this._addQueryReadsTo(templateRefId, templateRefId, this._queriedTokens);
	        }
	        refs.forEach(function (refAst) {
	            var /** @type {?} */ defaultQueryValue = refAst.value ||
	                createTokenForExternalReference(_this.viewContext.reflector, Identifiers.ElementRef);
	            _this._addQueryReadsTo({ value: refAst.name }, defaultQueryValue, _this._queriedTokens);
	        });
	        if (this._queriedTokens.get(this.viewContext.reflector.resolveExternalReference(Identifiers.ViewContainerRef))) {
	            this.transformedHasViewContainer = true;
	        }
	        // create the providers that we know are eager first
	        Array.from(this._allProviders.values()).forEach(function (provider) {
	            var /** @type {?} */ eager = provider.eager || _this._queriedTokens.get(tokenReference(provider.token));
	            if (eager) {
	                _this._getOrCreateLocalProvider(provider.providerType, provider.token, true);
	            }
	        });
	    }
	    /**
	     * @return {?}
	     */
	    ProviderElementContext.prototype.afterElement = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // collect lazy providers
	        Array.from(this._allProviders.values()).forEach(function (provider) {
	            _this._getOrCreateLocalProvider(provider.providerType, provider.token, false);
	        });
	    };
	    Object.defineProperty(ProviderElementContext.prototype, "transformProviders", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            // Note: Maps keep their insertion order.
	            var /** @type {?} */ lazyProviders = [];
	            var /** @type {?} */ eagerProviders = [];
	            this._transformedProviders.forEach(function (provider) {
	                if (provider.eager) {
	                    eagerProviders.push(provider);
	                }
	                else {
	                    lazyProviders.push(provider);
	                }
	            });
	            return lazyProviders.concat(eagerProviders);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProviderElementContext.prototype, "transformedDirectiveAsts", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ sortedProviderTypes = this.transformProviders.map(function (provider) { return provider.token.identifier; });
	            var /** @type {?} */ sortedDirectives = this._directiveAsts.slice();
	            sortedDirectives.sort(function (dir1, dir2) {
	                return sortedProviderTypes.indexOf(dir1.directive.type) -
	                    sortedProviderTypes.indexOf(dir2.directive.type);
	            });
	            return sortedDirectives;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProviderElementContext.prototype, "queryMatches", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ allMatches = [];
	            this._queriedTokens.forEach(function (matches) { allMatches.push.apply(allMatches, matches); });
	            return allMatches;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} token
	     * @param {?} defaultValue
	     * @param {?} queryReadTokens
	     * @return {?}
	     */
	    ProviderElementContext.prototype._addQueryReadsTo = /**
	     * @param {?} token
	     * @param {?} defaultValue
	     * @param {?} queryReadTokens
	     * @return {?}
	     */
	    function (token, defaultValue, queryReadTokens) {
	        this._getQueriesFor(token).forEach(function (query) {
	            var /** @type {?} */ queryValue = query.meta.read || defaultValue;
	            var /** @type {?} */ tokenRef = tokenReference(queryValue);
	            var /** @type {?} */ queryMatches = queryReadTokens.get(tokenRef);
	            if (!queryMatches) {
	                queryMatches = [];
	                queryReadTokens.set(tokenRef, queryMatches);
	            }
	            queryMatches.push({ queryId: query.queryId, value: queryValue });
	        });
	    };
	    /**
	     * @param {?} token
	     * @return {?}
	     */
	    ProviderElementContext.prototype._getQueriesFor = /**
	     * @param {?} token
	     * @return {?}
	     */
	    function (token) {
	        var /** @type {?} */ result = [];
	        var /** @type {?} */ currentEl = this;
	        var /** @type {?} */ distance = 0;
	        var /** @type {?} */ queries;
	        while (currentEl !== null) {
	            queries = currentEl._contentQueries.get(tokenReference(token));
	            if (queries) {
	                result.push.apply(result, queries.filter(function (query) { return query.meta.descendants || distance <= 1; }));
	            }
	            if (currentEl._directiveAsts.length > 0) {
	                distance++;
	            }
	            currentEl = currentEl._parent;
	        }
	        queries = this.viewContext.viewQueries.get(tokenReference(token));
	        if (queries) {
	            result.push.apply(result, queries);
	        }
	        return result;
	    };
	    /**
	     * @param {?} requestingProviderType
	     * @param {?} token
	     * @param {?} eager
	     * @return {?}
	     */
	    ProviderElementContext.prototype._getOrCreateLocalProvider = /**
	     * @param {?} requestingProviderType
	     * @param {?} token
	     * @param {?} eager
	     * @return {?}
	     */
	    function (requestingProviderType, token, eager) {
	        var _this = this;
	        var /** @type {?} */ resolvedProvider = this._allProviders.get(tokenReference(token));
	        if (!resolvedProvider || ((requestingProviderType === ProviderAstType.Directive ||
	            requestingProviderType === ProviderAstType.PublicService) &&
	            resolvedProvider.providerType === ProviderAstType.PrivateService) ||
	            ((requestingProviderType === ProviderAstType.PrivateService ||
	                requestingProviderType === ProviderAstType.PublicService) &&
	                resolvedProvider.providerType === ProviderAstType.Builtin)) {
	            return null;
	        }
	        var /** @type {?} */ transformedProviderAst = this._transformedProviders.get(tokenReference(token));
	        if (transformedProviderAst) {
	            return transformedProviderAst;
	        }
	        if (this._seenProviders.get(tokenReference(token)) != null) {
	            this.viewContext.errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + tokenName(token), this._sourceSpan));
	            return null;
	        }
	        this._seenProviders.set(tokenReference(token), true);
	        var /** @type {?} */ transformedProviders = resolvedProvider.providers.map(function (provider) {
	            var /** @type {?} */ transformedUseValue = provider.useValue;
	            var /** @type {?} */ transformedUseExisting = /** @type {?} */ ((provider.useExisting));
	            var /** @type {?} */ transformedDeps = /** @type {?} */ ((undefined));
	            if (provider.useExisting != null) {
	                var /** @type {?} */ existingDiDep = /** @type {?} */ ((_this._getDependency(resolvedProvider.providerType, { token: provider.useExisting }, eager)));
	                if (existingDiDep.token != null) {
	                    transformedUseExisting = existingDiDep.token;
	                }
	                else {
	                    transformedUseExisting = /** @type {?} */ ((null));
	                    transformedUseValue = existingDiDep.value;
	                }
	            }
	            else if (provider.useFactory) {
	                var /** @type {?} */ deps = provider.deps || provider.useFactory.diDeps;
	                transformedDeps =
	                    deps.map(function (dep) { return ((_this._getDependency(resolvedProvider.providerType, dep, eager))); });
	            }
	            else if (provider.useClass) {
	                var /** @type {?} */ deps = provider.deps || provider.useClass.diDeps;
	                transformedDeps =
	                    deps.map(function (dep) { return ((_this._getDependency(resolvedProvider.providerType, dep, eager))); });
	            }
	            return _transformProvider(provider, {
	                useExisting: transformedUseExisting,
	                useValue: transformedUseValue,
	                deps: transformedDeps
	            });
	        });
	        transformedProviderAst =
	            _transformProviderAst(resolvedProvider, { eager: eager, providers: transformedProviders });
	        this._transformedProviders.set(tokenReference(token), transformedProviderAst);
	        return transformedProviderAst;
	    };
	    /**
	     * @param {?} requestingProviderType
	     * @param {?} dep
	     * @param {?=} eager
	     * @return {?}
	     */
	    ProviderElementContext.prototype._getLocalDependency = /**
	     * @param {?} requestingProviderType
	     * @param {?} dep
	     * @param {?=} eager
	     * @return {?}
	     */
	    function (requestingProviderType, dep, eager) {
	        if (eager === void 0) { eager = false; }
	        if (dep.isAttribute) {
	            var /** @type {?} */ attrValue = this._attrs[/** @type {?} */ ((dep.token)).value];
	            return { isValue: true, value: attrValue == null ? null : attrValue };
	        }
	        if (dep.token != null) {
	            // access builtints
	            if ((requestingProviderType === ProviderAstType.Directive ||
	                requestingProviderType === ProviderAstType.Component)) {
	                if (tokenReference(dep.token) ===
	                    this.viewContext.reflector.resolveExternalReference(Identifiers.Renderer) ||
	                    tokenReference(dep.token) ===
	                        this.viewContext.reflector.resolveExternalReference(Identifiers.ElementRef) ||
	                    tokenReference(dep.token) ===
	                        this.viewContext.reflector.resolveExternalReference(Identifiers.ChangeDetectorRef) ||
	                    tokenReference(dep.token) ===
	                        this.viewContext.reflector.resolveExternalReference(Identifiers.TemplateRef)) {
	                    return dep;
	                }
	                if (tokenReference(dep.token) ===
	                    this.viewContext.reflector.resolveExternalReference(Identifiers.ViewContainerRef)) {
	                    (/** @type {?} */ (this)).transformedHasViewContainer = true;
	                }
	            }
	            // access the injector
	            if (tokenReference(dep.token) ===
	                this.viewContext.reflector.resolveExternalReference(Identifiers.Injector)) {
	                return dep;
	            }
	            // access providers
	            if (this._getOrCreateLocalProvider(requestingProviderType, dep.token, eager) != null) {
	                return dep;
	            }
	        }
	        return null;
	    };
	    /**
	     * @param {?} requestingProviderType
	     * @param {?} dep
	     * @param {?=} eager
	     * @return {?}
	     */
	    ProviderElementContext.prototype._getDependency = /**
	     * @param {?} requestingProviderType
	     * @param {?} dep
	     * @param {?=} eager
	     * @return {?}
	     */
	    function (requestingProviderType, dep, eager) {
	        if (eager === void 0) { eager = false; }
	        var /** @type {?} */ currElement = this;
	        var /** @type {?} */ currEager = eager;
	        var /** @type {?} */ result = null;
	        if (!dep.isSkipSelf) {
	            result = this._getLocalDependency(requestingProviderType, dep, eager);
	        }
	        if (dep.isSelf) {
	            if (!result && dep.isOptional) {
	                result = { isValue: true, value: null };
	            }
	        }
	        else {
	            // check parent elements
	            while (!result && currElement._parent) {
	                var /** @type {?} */ prevElement = currElement;
	                currElement = currElement._parent;
	                if (prevElement._isViewRoot) {
	                    currEager = false;
	                }
	                result = currElement._getLocalDependency(ProviderAstType.PublicService, dep, currEager);
	            }
	            // check @Host restriction
	            if (!result) {
	                if (!dep.isHost || this.viewContext.component.isHost ||
	                    this.viewContext.component.type.reference === tokenReference(/** @type {?} */ ((dep.token))) ||
	                    this.viewContext.viewProviders.get(tokenReference(/** @type {?} */ ((dep.token)))) != null) {
	                    result = dep;
	                }
	                else {
	                    result = dep.isOptional ? result = { isValue: true, value: null } : null;
	                }
	            }
	        }
	        if (!result) {
	            this.viewContext.errors.push(new ProviderError("No provider for " + tokenName((/** @type {?} */ ((dep.token)))), this._sourceSpan));
	        }
	        return result;
	    };
	    return ProviderElementContext;
	}());
	var NgModuleProviderAnalyzer = /** @class */ (function () {
	    function NgModuleProviderAnalyzer(reflector, ngModule, extraProviders, sourceSpan) {
	        var _this = this;
	        this.reflector = reflector;
	        this._transformedProviders = new Map();
	        this._seenProviders = new Map();
	        this._errors = [];
	        this._allProviders = new Map();
	        ngModule.transitiveModule.modules.forEach(function (ngModuleType) {
	            var /** @type {?} */ ngModuleProvider = { token: { identifier: ngModuleType }, useClass: ngModuleType };
	            _resolveProviders([ngModuleProvider], ProviderAstType.PublicService, true, sourceSpan, _this._errors, _this._allProviders);
	        });
	        _resolveProviders(ngModule.transitiveModule.providers.map(function (entry) { return entry.provider; }).concat(extraProviders), ProviderAstType.PublicService, false, sourceSpan, this._errors, this._allProviders);
	    }
	    /**
	     * @return {?}
	     */
	    NgModuleProviderAnalyzer.prototype.parse = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        Array.from(this._allProviders.values()).forEach(function (provider) {
	            _this._getOrCreateLocalProvider(provider.token, provider.eager);
	        });
	        if (this._errors.length > 0) {
	            var /** @type {?} */ errorString = this._errors.join('\n');
	            throw new Error("Provider parse errors:\n" + errorString);
	        }
	        // Note: Maps keep their insertion order.
	        var /** @type {?} */ lazyProviders = [];
	        var /** @type {?} */ eagerProviders = [];
	        this._transformedProviders.forEach(function (provider) {
	            if (provider.eager) {
	                eagerProviders.push(provider);
	            }
	            else {
	                lazyProviders.push(provider);
	            }
	        });
	        return lazyProviders.concat(eagerProviders);
	    };
	    /**
	     * @param {?} token
	     * @param {?} eager
	     * @return {?}
	     */
	    NgModuleProviderAnalyzer.prototype._getOrCreateLocalProvider = /**
	     * @param {?} token
	     * @param {?} eager
	     * @return {?}
	     */
	    function (token, eager) {
	        var _this = this;
	        var /** @type {?} */ resolvedProvider = this._allProviders.get(tokenReference(token));
	        if (!resolvedProvider) {
	            return null;
	        }
	        var /** @type {?} */ transformedProviderAst = this._transformedProviders.get(tokenReference(token));
	        if (transformedProviderAst) {
	            return transformedProviderAst;
	        }
	        if (this._seenProviders.get(tokenReference(token)) != null) {
	            this._errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + tokenName(token), resolvedProvider.sourceSpan));
	            return null;
	        }
	        this._seenProviders.set(tokenReference(token), true);
	        var /** @type {?} */ transformedProviders = resolvedProvider.providers.map(function (provider) {
	            var /** @type {?} */ transformedUseValue = provider.useValue;
	            var /** @type {?} */ transformedUseExisting = /** @type {?} */ ((provider.useExisting));
	            var /** @type {?} */ transformedDeps = /** @type {?} */ ((undefined));
	            if (provider.useExisting != null) {
	                var /** @type {?} */ existingDiDep = _this._getDependency({ token: provider.useExisting }, eager, resolvedProvider.sourceSpan);
	                if (existingDiDep.token != null) {
	                    transformedUseExisting = existingDiDep.token;
	                }
	                else {
	                    transformedUseExisting = /** @type {?} */ ((null));
	                    transformedUseValue = existingDiDep.value;
	                }
	            }
	            else if (provider.useFactory) {
	                var /** @type {?} */ deps = provider.deps || provider.useFactory.diDeps;
	                transformedDeps =
	                    deps.map(function (dep) { return _this._getDependency(dep, eager, resolvedProvider.sourceSpan); });
	            }
	            else if (provider.useClass) {
	                var /** @type {?} */ deps = provider.deps || provider.useClass.diDeps;
	                transformedDeps =
	                    deps.map(function (dep) { return _this._getDependency(dep, eager, resolvedProvider.sourceSpan); });
	            }
	            return _transformProvider(provider, {
	                useExisting: transformedUseExisting,
	                useValue: transformedUseValue,
	                deps: transformedDeps
	            });
	        });
	        transformedProviderAst =
	            _transformProviderAst(resolvedProvider, { eager: eager, providers: transformedProviders });
	        this._transformedProviders.set(tokenReference(token), transformedProviderAst);
	        return transformedProviderAst;
	    };
	    /**
	     * @param {?} dep
	     * @param {?=} eager
	     * @param {?=} requestorSourceSpan
	     * @return {?}
	     */
	    NgModuleProviderAnalyzer.prototype._getDependency = /**
	     * @param {?} dep
	     * @param {?=} eager
	     * @param {?=} requestorSourceSpan
	     * @return {?}
	     */
	    function (dep, eager, requestorSourceSpan) {
	        if (eager === void 0) { eager = false; }
	        var /** @type {?} */ foundLocal = false;
	        if (!dep.isSkipSelf && dep.token != null) {
	            // access the injector
	            if (tokenReference(dep.token) ===
	                this.reflector.resolveExternalReference(Identifiers.Injector) ||
	                tokenReference(dep.token) ===
	                    this.reflector.resolveExternalReference(Identifiers.ComponentFactoryResolver)) {
	                foundLocal = true;
	                // access providers
	            }
	            else if (this._getOrCreateLocalProvider(dep.token, eager) != null) {
	                foundLocal = true;
	            }
	        }
	        var /** @type {?} */ result = dep;
	        if (dep.isSelf && !foundLocal) {
	            if (dep.isOptional) {
	                result = { isValue: true, value: null };
	            }
	            else {
	                this._errors.push(new ProviderError("No provider for " + tokenName((/** @type {?} */ ((dep.token)))), requestorSourceSpan));
	            }
	        }
	        return result;
	    };
	    return NgModuleProviderAnalyzer;
	}());
	/**
	 * @param {?} provider
	 * @param {?} __1
	 * @return {?}
	 */
	function _transformProvider(provider, _a) {
	    var useExisting = _a.useExisting, useValue = _a.useValue, deps = _a.deps;
	    return {
	        token: provider.token,
	        useClass: provider.useClass,
	        useExisting: useExisting,
	        useFactory: provider.useFactory,
	        useValue: useValue,
	        deps: deps,
	        multi: provider.multi
	    };
	}
	/**
	 * @param {?} provider
	 * @param {?} __1
	 * @return {?}
	 */
	function _transformProviderAst(provider, _a) {
	    var eager = _a.eager, providers = _a.providers;
	    return new ProviderAst(provider.token, provider.multiProvider, provider.eager || eager, providers, provider.providerType, provider.lifecycleHooks, provider.sourceSpan);
	}
	/**
	 * @param {?} directives
	 * @param {?} sourceSpan
	 * @param {?} targetErrors
	 * @return {?}
	 */
	function _resolveProvidersFromDirectives(directives, sourceSpan, targetErrors) {
	    var /** @type {?} */ providersByToken = new Map();
	    directives.forEach(function (directive) {
	        var /** @type {?} */ dirProvider = { token: { identifier: directive.type }, useClass: directive.type };
	        _resolveProviders([dirProvider], directive.isComponent ? ProviderAstType.Component : ProviderAstType.Directive, true, sourceSpan, targetErrors, providersByToken);
	    });
	    // Note: directives need to be able to overwrite providers of a component!
	    var /** @type {?} */ directivesWithComponentFirst = directives.filter(function (dir) { return dir.isComponent; }).concat(directives.filter(function (dir) { return !dir.isComponent; }));
	    directivesWithComponentFirst.forEach(function (directive) {
	        _resolveProviders(directive.providers, ProviderAstType.PublicService, false, sourceSpan, targetErrors, providersByToken);
	        _resolveProviders(directive.viewProviders, ProviderAstType.PrivateService, false, sourceSpan, targetErrors, providersByToken);
	    });
	    return providersByToken;
	}
	/**
	 * @param {?} providers
	 * @param {?} providerType
	 * @param {?} eager
	 * @param {?} sourceSpan
	 * @param {?} targetErrors
	 * @param {?} targetProvidersByToken
	 * @return {?}
	 */
	function _resolveProviders(providers, providerType, eager, sourceSpan, targetErrors, targetProvidersByToken) {
	    providers.forEach(function (provider) {
	        var /** @type {?} */ resolvedProvider = targetProvidersByToken.get(tokenReference(provider.token));
	        if (resolvedProvider != null && !!resolvedProvider.multiProvider !== !!provider.multi) {
	            targetErrors.push(new ProviderError("Mixing multi and non multi provider is not possible for token " + tokenName(resolvedProvider.token), sourceSpan));
	        }
	        if (!resolvedProvider) {
	            var /** @type {?} */ lifecycleHooks = provider.token.identifier &&
	                (/** @type {?} */ (provider.token.identifier)).lifecycleHooks ?
	                (/** @type {?} */ (provider.token.identifier)).lifecycleHooks :
	                [];
	            var /** @type {?} */ isUseValue = !(provider.useClass || provider.useExisting || provider.useFactory);
	            resolvedProvider = new ProviderAst(provider.token, !!provider.multi, eager || isUseValue, [provider], providerType, lifecycleHooks, sourceSpan);
	            targetProvidersByToken.set(tokenReference(provider.token), resolvedProvider);
	        }
	        else {
	            if (!provider.multi) {
	                resolvedProvider.providers.length = 0;
	            }
	            resolvedProvider.providers.push(provider);
	        }
	    });
	}
	/**
	 * @param {?} component
	 * @return {?}
	 */
	function _getViewQueries(component) {
	    // Note: queries start with id 1 so we can use the number in a Bloom filter!
	    var /** @type {?} */ viewQueryId = 1;
	    var /** @type {?} */ viewQueries = new Map();
	    if (component.viewQueries) {
	        component.viewQueries.forEach(function (query) { return _addQueryToTokenMap(viewQueries, { meta: query, queryId: viewQueryId++ }); });
	    }
	    return viewQueries;
	}
	/**
	 * @param {?} contentQueryStartId
	 * @param {?} directives
	 * @return {?}
	 */
	function _getContentQueries(contentQueryStartId, directives) {
	    var /** @type {?} */ contentQueryId = contentQueryStartId;
	    var /** @type {?} */ contentQueries = new Map();
	    directives.forEach(function (directive, directiveIndex) {
	        if (directive.queries) {
	            directive.queries.forEach(function (query) { return _addQueryToTokenMap(contentQueries, { meta: query, queryId: contentQueryId++ }); });
	        }
	    });
	    return contentQueries;
	}
	/**
	 * @param {?} map
	 * @param {?} query
	 * @return {?}
	 */
	function _addQueryToTokenMap(map, query) {
	    query.meta.selectors.forEach(function (token) {
	        var /** @type {?} */ entry = map.get(tokenReference(token));
	        if (!entry) {
	            entry = [];
	            map.set(tokenReference(token), entry);
	        }
	        entry.push(query);
	    });
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var QUOTED_KEYS = '$quoted$';
	/**
	 * @param {?} ctx
	 * @param {?} value
	 * @param {?=} type
	 * @return {?}
	 */
	function convertValueToOutputAst(ctx, value, type) {
	    if (type === void 0) { type = null; }
	    return visitValue(value, new _ValueOutputAstTransformer(ctx), type);
	}
	var _ValueOutputAstTransformer = /** @class */ (function () {
	    function _ValueOutputAstTransformer(ctx) {
	        this.ctx = ctx;
	    }
	    /**
	     * @param {?} arr
	     * @param {?} type
	     * @return {?}
	     */
	    _ValueOutputAstTransformer.prototype.visitArray = /**
	     * @param {?} arr
	     * @param {?} type
	     * @return {?}
	     */
	    function (arr, type) {
	        var _this = this;
	        return literalArr(arr.map(function (value) { return visitValue(value, _this, null); }), type);
	    };
	    /**
	     * @param {?} map
	     * @param {?} type
	     * @return {?}
	     */
	    _ValueOutputAstTransformer.prototype.visitStringMap = /**
	     * @param {?} map
	     * @param {?} type
	     * @return {?}
	     */
	    function (map, type) {
	        var _this = this;
	        var /** @type {?} */ entries = [];
	        var /** @type {?} */ quotedSet = new Set(map && map[QUOTED_KEYS]);
	        Object.keys(map).forEach(function (key) {
	            entries.push(new LiteralMapEntry(key, visitValue(map[key], _this, null), quotedSet.has(key)));
	        });
	        return new LiteralMapExpr(entries, type);
	    };
	    /**
	     * @param {?} value
	     * @param {?} type
	     * @return {?}
	     */
	    _ValueOutputAstTransformer.prototype.visitPrimitive = /**
	     * @param {?} value
	     * @param {?} type
	     * @return {?}
	     */
	    function (value, type) { return literal(value, type); };
	    /**
	     * @param {?} value
	     * @param {?} type
	     * @return {?}
	     */
	    _ValueOutputAstTransformer.prototype.visitOther = /**
	     * @param {?} value
	     * @param {?} type
	     * @return {?}
	     */
	    function (value, type) {
	        if (value instanceof Expression) {
	            return value;
	        }
	        else {
	            return this.ctx.importExpr(value);
	        }
	    };
	    return _ValueOutputAstTransformer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} ctx
	 * @param {?} providerAst
	 * @return {?}
	 */
	function providerDef(ctx, providerAst) {
	    var /** @type {?} */ flags = 0;
	    if (!providerAst.eager) {
	        flags |= 4096 /* LazyProvider */;
	    }
	    if (providerAst.providerType === ProviderAstType.PrivateService) {
	        flags |= 8192 /* PrivateProvider */;
	    }
	    providerAst.lifecycleHooks.forEach(function (lifecycleHook) {
	        // for regular providers, we only support ngOnDestroy
	        if (lifecycleHook === LifecycleHooks.OnDestroy ||
	            providerAst.providerType === ProviderAstType.Directive ||
	            providerAst.providerType === ProviderAstType.Component) {
	            flags |= lifecycleHookToNodeFlag(lifecycleHook);
	        }
	    });
	    var _a = providerAst.multiProvider ?
	        multiProviderDef(ctx, flags, providerAst.providers) :
	        singleProviderDef(ctx, flags, providerAst.providerType, providerAst.providers[0]), providerExpr = _a.providerExpr, providerFlags = _a.flags, depsExpr = _a.depsExpr;
	    return {
	        providerExpr: providerExpr,
	        flags: providerFlags, depsExpr: depsExpr,
	        tokenExpr: tokenExpr(ctx, providerAst.token),
	    };
	}
	/**
	 * @param {?} ctx
	 * @param {?} flags
	 * @param {?} providers
	 * @return {?}
	 */
	function multiProviderDef(ctx, flags, providers) {
	    var /** @type {?} */ allDepDefs = [];
	    var /** @type {?} */ allParams = [];
	    var /** @type {?} */ exprs = providers.map(function (provider, providerIndex) {
	        var /** @type {?} */ expr;
	        if (provider.useClass) {
	            var /** @type {?} */ depExprs = convertDeps(providerIndex, provider.deps || provider.useClass.diDeps);
	            expr = ctx.importExpr(provider.useClass.reference).instantiate(depExprs);
	        }
	        else if (provider.useFactory) {
	            var /** @type {?} */ depExprs = convertDeps(providerIndex, provider.deps || provider.useFactory.diDeps);
	            expr = ctx.importExpr(provider.useFactory.reference).callFn(depExprs);
	        }
	        else if (provider.useExisting) {
	            var /** @type {?} */ depExprs = convertDeps(providerIndex, [{ token: provider.useExisting }]);
	            expr = depExprs[0];
	        }
	        else {
	            expr = convertValueToOutputAst(ctx, provider.useValue);
	        }
	        return expr;
	    });
	    var /** @type {?} */ providerExpr = fn(allParams, [new ReturnStatement(literalArr(exprs))], INFERRED_TYPE);
	    return {
	        providerExpr: providerExpr,
	        flags: flags | 1024 /* TypeFactoryProvider */,
	        depsExpr: literalArr(allDepDefs)
	    };
	    /**
	     * @param {?} providerIndex
	     * @param {?} deps
	     * @return {?}
	     */
	    function convertDeps(providerIndex, deps) {
	        return deps.map(function (dep, depIndex) {
	            var /** @type {?} */ paramName = "p" + providerIndex + "_" + depIndex;
	            allParams.push(new FnParam(paramName, DYNAMIC_TYPE));
	            allDepDefs.push(depDef(ctx, dep));
	            return variable(paramName);
	        });
	    }
	}
	/**
	 * @param {?} ctx
	 * @param {?} flags
	 * @param {?} providerType
	 * @param {?} providerMeta
	 * @return {?}
	 */
	function singleProviderDef(ctx, flags, providerType, providerMeta) {
	    var /** @type {?} */ providerExpr;
	    var /** @type {?} */ deps;
	    if (providerType === ProviderAstType.Directive || providerType === ProviderAstType.Component) {
	        providerExpr = ctx.importExpr(/** @type {?} */ ((providerMeta.useClass)).reference);
	        flags |= 16384 /* TypeDirective */;
	        deps = providerMeta.deps || /** @type {?} */ ((providerMeta.useClass)).diDeps;
	    }
	    else {
	        if (providerMeta.useClass) {
	            providerExpr = ctx.importExpr(providerMeta.useClass.reference);
	            flags |= 512 /* TypeClassProvider */;
	            deps = providerMeta.deps || providerMeta.useClass.diDeps;
	        }
	        else if (providerMeta.useFactory) {
	            providerExpr = ctx.importExpr(providerMeta.useFactory.reference);
	            flags |= 1024 /* TypeFactoryProvider */;
	            deps = providerMeta.deps || providerMeta.useFactory.diDeps;
	        }
	        else if (providerMeta.useExisting) {
	            providerExpr = NULL_EXPR;
	            flags |= 2048 /* TypeUseExistingProvider */;
	            deps = [{ token: providerMeta.useExisting }];
	        }
	        else {
	            providerExpr = convertValueToOutputAst(ctx, providerMeta.useValue);
	            flags |= 256 /* TypeValueProvider */;
	            deps = [];
	        }
	    }
	    var /** @type {?} */ depsExpr = literalArr(deps.map(function (dep) { return depDef(ctx, dep); }));
	    return { providerExpr: providerExpr, flags: flags, depsExpr: depsExpr };
	}
	/**
	 * @param {?} ctx
	 * @param {?} tokenMeta
	 * @return {?}
	 */
	function tokenExpr(ctx, tokenMeta) {
	    return tokenMeta.identifier ? ctx.importExpr(tokenMeta.identifier.reference) :
	        literal(tokenMeta.value);
	}
	/**
	 * @param {?} ctx
	 * @param {?} dep
	 * @return {?}
	 */
	function depDef(ctx, dep) {
	    // Note: the following fields have already been normalized out by provider_analyzer:
	    // - isAttribute, isSelf, isHost
	    var /** @type {?} */ expr = dep.isValue ? convertValueToOutputAst(ctx, dep.value) : tokenExpr(ctx, /** @type {?} */ ((dep.token)));
	    var /** @type {?} */ flags = 0;
	    if (dep.isSkipSelf) {
	        flags |= 1 /* SkipSelf */;
	    }
	    if (dep.isOptional) {
	        flags |= 2 /* Optional */;
	    }
	    if (dep.isValue) {
	        flags |= 8 /* Value */;
	    }
	    return flags === 0 /* None */ ? expr : literalArr([literal(flags), expr]);
	}
	/**
	 * @param {?} lifecycleHook
	 * @return {?}
	 */
	function lifecycleHookToNodeFlag(lifecycleHook) {
	    var /** @type {?} */ nodeFlag = 0;
	    switch (lifecycleHook) {
	        case LifecycleHooks.AfterContentChecked:
	            nodeFlag = 2097152 /* AfterContentChecked */;
	            break;
	        case LifecycleHooks.AfterContentInit:
	            nodeFlag = 1048576 /* AfterContentInit */;
	            break;
	        case LifecycleHooks.AfterViewChecked:
	            nodeFlag = 8388608 /* AfterViewChecked */;
	            break;
	        case LifecycleHooks.AfterViewInit:
	            nodeFlag = 4194304 /* AfterViewInit */;
	            break;
	        case LifecycleHooks.DoCheck:
	            nodeFlag = 262144 /* DoCheck */;
	            break;
	        case LifecycleHooks.OnChanges:
	            nodeFlag = 524288 /* OnChanges */;
	            break;
	        case LifecycleHooks.OnDestroy:
	            nodeFlag = 131072 /* OnDestroy */;
	            break;
	        case LifecycleHooks.OnInit:
	            nodeFlag = 65536 /* OnInit */;
	            break;
	    }
	    return nodeFlag;
	}
	/**
	 * @param {?} reflector
	 * @param {?} ctx
	 * @param {?} flags
	 * @param {?} entryComponents
	 * @return {?}
	 */
	function componentFactoryResolverProviderDef(reflector, ctx, flags, entryComponents) {
	    var /** @type {?} */ entryComponentFactories = entryComponents.map(function (entryComponent) { return ctx.importExpr(entryComponent.componentFactory); });
	    var /** @type {?} */ token = createTokenForExternalReference(reflector, Identifiers.ComponentFactoryResolver);
	    var /** @type {?} */ classMeta = {
	        diDeps: [
	            { isValue: true, value: literalArr(entryComponentFactories) },
	            { token: token, isSkipSelf: true, isOptional: true },
	            { token: createTokenForExternalReference(reflector, Identifiers.NgModuleRef) },
	        ],
	        lifecycleHooks: [],
	        reference: reflector.resolveExternalReference(Identifiers.CodegenComponentFactoryResolver)
	    };
	    var _a = singleProviderDef(ctx, flags, ProviderAstType.PrivateService, {
	        token: token,
	        multi: false,
	        useClass: classMeta,
	    }), providerExpr = _a.providerExpr, providerFlags = _a.flags, depsExpr = _a.depsExpr;
	    return { providerExpr: providerExpr, flags: providerFlags, depsExpr: depsExpr, tokenExpr: tokenExpr(ctx, token) };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NgModuleCompileResult = /** @class */ (function () {
	    function NgModuleCompileResult(ngModuleFactoryVar) {
	        this.ngModuleFactoryVar = ngModuleFactoryVar;
	    }
	    return NgModuleCompileResult;
	}());
	var LOG_VAR = variable('_l');
	var NgModuleCompiler = /** @class */ (function () {
	    function NgModuleCompiler(reflector) {
	        this.reflector = reflector;
	    }
	    /**
	     * @param {?} ctx
	     * @param {?} ngModuleMeta
	     * @param {?} extraProviders
	     * @return {?}
	     */
	    NgModuleCompiler.prototype.compile = /**
	     * @param {?} ctx
	     * @param {?} ngModuleMeta
	     * @param {?} extraProviders
	     * @return {?}
	     */
	    function (ctx, ngModuleMeta, extraProviders) {
	        var /** @type {?} */ sourceSpan = typeSourceSpan('NgModule', ngModuleMeta.type);
	        var /** @type {?} */ entryComponentFactories = ngModuleMeta.transitiveModule.entryComponents;
	        var /** @type {?} */ bootstrapComponents = ngModuleMeta.bootstrapComponents;
	        var /** @type {?} */ providerParser = new NgModuleProviderAnalyzer(this.reflector, ngModuleMeta, extraProviders, sourceSpan);
	        var /** @type {?} */ providerDefs = [componentFactoryResolverProviderDef(this.reflector, ctx, 0 /* None */, entryComponentFactories)]
	            .concat(providerParser.parse().map(function (provider) { return providerDef(ctx, provider); }))
	            .map(function (_a) {
	            var providerExpr = _a.providerExpr, depsExpr = _a.depsExpr, flags = _a.flags, tokenExpr = _a.tokenExpr;
	            return importExpr(Identifiers.moduleProviderDef).callFn([
	                literal(flags), tokenExpr, providerExpr, depsExpr
	            ]);
	        });
	        var /** @type {?} */ ngModuleDef = importExpr(Identifiers.moduleDef).callFn([literalArr(providerDefs)]);
	        var /** @type {?} */ ngModuleDefFactory = fn([new FnParam(/** @type {?} */ ((LOG_VAR.name)))], [new ReturnStatement(ngModuleDef)], INFERRED_TYPE);
	        var /** @type {?} */ ngModuleFactoryVar = identifierName(ngModuleMeta.type) + "NgFactory";
	        this._createNgModuleFactory(ctx, ngModuleMeta.type.reference, importExpr(Identifiers.createModuleFactory).callFn([
	            ctx.importExpr(ngModuleMeta.type.reference),
	            literalArr(bootstrapComponents.map(function (id) { return ctx.importExpr(id.reference); })),
	            ngModuleDefFactory
	        ]));
	        if (ngModuleMeta.id) {
	            var /** @type {?} */ registerFactoryStmt = importExpr(Identifiers.RegisterModuleFactoryFn)
	                .callFn([literal(ngModuleMeta.id), variable(ngModuleFactoryVar)])
	                .toStmt();
	            ctx.statements.push(registerFactoryStmt);
	        }
	        return new NgModuleCompileResult(ngModuleFactoryVar);
	    };
	    /**
	     * @param {?} ctx
	     * @param {?} ngModuleReference
	     * @return {?}
	     */
	    NgModuleCompiler.prototype.createStub = /**
	     * @param {?} ctx
	     * @param {?} ngModuleReference
	     * @return {?}
	     */
	    function (ctx, ngModuleReference) {
	        this._createNgModuleFactory(ctx, ngModuleReference, NULL_EXPR);
	    };
	    /**
	     * @param {?} ctx
	     * @param {?} reference
	     * @param {?} value
	     * @return {?}
	     */
	    NgModuleCompiler.prototype._createNgModuleFactory = /**
	     * @param {?} ctx
	     * @param {?} reference
	     * @param {?} value
	     * @return {?}
	     */
	    function (ctx, reference, value) {
	        var /** @type {?} */ ngModuleFactoryVar = identifierName({ reference: reference }) + "NgFactory";
	        var /** @type {?} */ ngModuleFactoryStmt = variable(ngModuleFactoryVar)
	            .set(value)
	            .toDeclStmt(importType(Identifiers.NgModuleFactory, [/** @type {?} */ ((expressionType(ctx.importExpr(reference))))], [TypeModifier.Const]), [StmtModifier.Final, StmtModifier.Exported]);
	        ctx.statements.push(ngModuleFactoryStmt);
	    };
	    return NgModuleCompiler;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Resolves types to {\@link NgModule}.
	 */
	var NgModuleResolver = /** @class */ (function () {
	    function NgModuleResolver(_reflector) {
	        this._reflector = _reflector;
	    }
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    NgModuleResolver.prototype.isNgModule = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) { return this._reflector.annotations(type).some(createNgModule.isTypeOf); };
	    /**
	     * @param {?} type
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    NgModuleResolver.prototype.resolve = /**
	     * @param {?} type
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    function (type, throwIfNotFound) {
	        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
	        var /** @type {?} */ ngModuleMeta = findLast(this._reflector.annotations(type), createNgModule.isTypeOf);
	        if (ngModuleMeta) {
	            return ngModuleMeta;
	        }
	        else {
	            if (throwIfNotFound) {
	                throw new Error("No NgModule metadata found for '" + stringify(type) + "'.");
	            }
	            return null;
	        }
	    };
	    return NgModuleResolver;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit
	var VERSION$1 = 3;
	var JS_B64_PREFIX = '# sourceMappingURL=data:application/json;base64,';
	var SourceMapGenerator = /** @class */ (function () {
	    function SourceMapGenerator(file) {
	        if (file === void 0) { file = null; }
	        this.file = file;
	        this.sourcesContent = new Map();
	        this.lines = [];
	        this.lastCol0 = 0;
	        this.hasMappings = false;
	    }
	    // The content is `null` when the content is expected to be loaded using the URL
	    /**
	     * @param {?} url
	     * @param {?=} content
	     * @return {?}
	     */
	    SourceMapGenerator.prototype.addSource = /**
	     * @param {?} url
	     * @param {?=} content
	     * @return {?}
	     */
	    function (url, content) {
	        if (content === void 0) { content = null; }
	        if (!this.sourcesContent.has(url)) {
	            this.sourcesContent.set(url, content);
	        }
	        return this;
	    };
	    /**
	     * @return {?}
	     */
	    SourceMapGenerator.prototype.addLine = /**
	     * @return {?}
	     */
	    function () {
	        this.lines.push([]);
	        this.lastCol0 = 0;
	        return this;
	    };
	    /**
	     * @param {?} col0
	     * @param {?=} sourceUrl
	     * @param {?=} sourceLine0
	     * @param {?=} sourceCol0
	     * @return {?}
	     */
	    SourceMapGenerator.prototype.addMapping = /**
	     * @param {?} col0
	     * @param {?=} sourceUrl
	     * @param {?=} sourceLine0
	     * @param {?=} sourceCol0
	     * @return {?}
	     */
	    function (col0, sourceUrl, sourceLine0, sourceCol0) {
	        if (!this.currentLine) {
	            throw new Error("A line must be added before mappings can be added");
	        }
	        if (sourceUrl != null && !this.sourcesContent.has(sourceUrl)) {
	            throw new Error("Unknown source file \"" + sourceUrl + "\"");
	        }
	        if (col0 == null) {
	            throw new Error("The column in the generated code must be provided");
	        }
	        if (col0 < this.lastCol0) {
	            throw new Error("Mapping should be added in output order");
	        }
	        if (sourceUrl && (sourceLine0 == null || sourceCol0 == null)) {
	            throw new Error("The source location must be provided when a source url is provided");
	        }
	        this.hasMappings = true;
	        this.lastCol0 = col0;
	        this.currentLine.push({ col0: col0, sourceUrl: sourceUrl, sourceLine0: sourceLine0, sourceCol0: sourceCol0 });
	        return this;
	    };
	    Object.defineProperty(SourceMapGenerator.prototype, "currentLine", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.lines.slice(-1)[0]; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    SourceMapGenerator.prototype.toJSON = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this.hasMappings) {
	            return null;
	        }
	        var /** @type {?} */ sourcesIndex = new Map();
	        var /** @type {?} */ sources = [];
	        var /** @type {?} */ sourcesContent = [];
	        Array.from(this.sourcesContent.keys()).forEach(function (url, i) {
	            sourcesIndex.set(url, i);
	            sources.push(url);
	            sourcesContent.push(_this.sourcesContent.get(url) || null);
	        });
	        var /** @type {?} */ mappings = '';
	        var /** @type {?} */ lastCol0 = 0;
	        var /** @type {?} */ lastSourceIndex = 0;
	        var /** @type {?} */ lastSourceLine0 = 0;
	        var /** @type {?} */ lastSourceCol0 = 0;
	        this.lines.forEach(function (segments) {
	            lastCol0 = 0;
	            mappings += segments
	                .map(function (segment) {
	                // zero-based starting column of the line in the generated code
	                var /** @type {?} */ segAsStr = toBase64VLQ(segment.col0 - lastCol0);
	                lastCol0 = segment.col0;
	                if (segment.sourceUrl != null) {
	                    // zero-based index into the “sources” list
	                    segAsStr +=
	                        toBase64VLQ(/** @type {?} */ ((sourcesIndex.get(segment.sourceUrl))) - lastSourceIndex);
	                    lastSourceIndex = /** @type {?} */ ((sourcesIndex.get(segment.sourceUrl)));
	                    // the zero-based starting line in the original source
	                    segAsStr += toBase64VLQ(/** @type {?} */ ((segment.sourceLine0)) - lastSourceLine0);
	                    lastSourceLine0 = /** @type {?} */ ((segment.sourceLine0));
	                    // the zero-based starting column in the original source
	                    segAsStr += toBase64VLQ(/** @type {?} */ ((segment.sourceCol0)) - lastSourceCol0);
	                    lastSourceCol0 = /** @type {?} */ ((segment.sourceCol0));
	                }
	                return segAsStr;
	            })
	                .join(',');
	            mappings += ';';
	        });
	        mappings = mappings.slice(0, -1);
	        return {
	            'file': this.file || '',
	            'version': VERSION$1,
	            'sourceRoot': '',
	            'sources': sources,
	            'sourcesContent': sourcesContent,
	            'mappings': mappings,
	        };
	    };
	    /**
	     * @return {?}
	     */
	    SourceMapGenerator.prototype.toJsComment = /**
	     * @return {?}
	     */
	    function () {
	        return this.hasMappings ? '//' + JS_B64_PREFIX + toBase64String(JSON.stringify(this, null, 0)) :
	            '';
	    };
	    return SourceMapGenerator;
	}());
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function toBase64String(value) {
	    var /** @type {?} */ b64 = '';
	    value = utf8Encode(value);
	    for (var /** @type {?} */ i = 0; i < value.length;) {
	        var /** @type {?} */ i1 = value.charCodeAt(i++);
	        var /** @type {?} */ i2 = value.charCodeAt(i++);
	        var /** @type {?} */ i3 = value.charCodeAt(i++);
	        b64 += toBase64Digit(i1 >> 2);
	        b64 += toBase64Digit(((i1 & 3) << 4) | (isNaN(i2) ? 0 : i2 >> 4));
	        b64 += isNaN(i2) ? '=' : toBase64Digit(((i2 & 15) << 2) | (i3 >> 6));
	        b64 += isNaN(i2) || isNaN(i3) ? '=' : toBase64Digit(i3 & 63);
	    }
	    return b64;
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function toBase64VLQ(value) {
	    value = value < 0 ? ((-value) << 1) + 1 : value << 1;
	    var /** @type {?} */ out = '';
	    do {
	        var /** @type {?} */ digit = value & 31;
	        value = value >> 5;
	        if (value > 0) {
	            digit = digit | 32;
	        }
	        out += toBase64Digit(digit);
	    } while (value > 0);
	    return out;
	}
	var B64_DIGITS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function toBase64Digit(value) {
	    if (value < 0 || value >= 64) {
	        throw new Error("Can only encode value in the range [0, 63]");
	    }
	    return B64_DIGITS[value];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _SINGLE_QUOTE_ESCAPE_STRING_RE = /'|\\|\n|\r|\$/g;
	var _LEGAL_IDENTIFIER_RE = /^[$A-Z_][0-9A-Z_$]*$/i;
	var _INDENT_WITH = '  ';
	var CATCH_ERROR_VAR$1 = variable('error', null, null);
	var CATCH_STACK_VAR$1 = variable('stack', null, null);
	/**
	 * @record
	 */
	
	var _EmittedLine = /** @class */ (function () {
	    function _EmittedLine(indent) {
	        this.indent = indent;
	        this.partsLength = 0;
	        this.parts = [];
	        this.srcSpans = [];
	    }
	    return _EmittedLine;
	}());
	var EmitterVisitorContext = /** @class */ (function () {
	    function EmitterVisitorContext(_indent) {
	        this._indent = _indent;
	        this._classes = [];
	        this._preambleLineCount = 0;
	        this._lines = [new _EmittedLine(_indent)];
	    }
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.createRoot = /**
	     * @return {?}
	     */
	    function () { return new EmitterVisitorContext(0); };
	    Object.defineProperty(EmitterVisitorContext.prototype, "_currentLine", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._lines[this._lines.length - 1]; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?=} from
	     * @param {?=} lastPart
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.println = /**
	     * @param {?=} from
	     * @param {?=} lastPart
	     * @return {?}
	     */
	    function (from, lastPart) {
	        if (lastPart === void 0) { lastPart = ''; }
	        this.print(from || null, lastPart, true);
	    };
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.lineIsEmpty = /**
	     * @return {?}
	     */
	    function () { return this._currentLine.parts.length === 0; };
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.lineLength = /**
	     * @return {?}
	     */
	    function () {
	        return this._currentLine.indent * _INDENT_WITH.length + this._currentLine.partsLength;
	    };
	    /**
	     * @param {?} from
	     * @param {?} part
	     * @param {?=} newLine
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.print = /**
	     * @param {?} from
	     * @param {?} part
	     * @param {?=} newLine
	     * @return {?}
	     */
	    function (from, part, newLine) {
	        if (newLine === void 0) { newLine = false; }
	        if (part.length > 0) {
	            this._currentLine.parts.push(part);
	            this._currentLine.partsLength += part.length;
	            this._currentLine.srcSpans.push(from && from.sourceSpan || null);
	        }
	        if (newLine) {
	            this._lines.push(new _EmittedLine(this._indent));
	        }
	    };
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.removeEmptyLastLine = /**
	     * @return {?}
	     */
	    function () {
	        if (this.lineIsEmpty()) {
	            this._lines.pop();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.incIndent = /**
	     * @return {?}
	     */
	    function () {
	        this._indent++;
	        if (this.lineIsEmpty()) {
	            this._currentLine.indent = this._indent;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.decIndent = /**
	     * @return {?}
	     */
	    function () {
	        this._indent--;
	        if (this.lineIsEmpty()) {
	            this._currentLine.indent = this._indent;
	        }
	    };
	    /**
	     * @param {?} clazz
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.pushClass = /**
	     * @param {?} clazz
	     * @return {?}
	     */
	    function (clazz) { this._classes.push(clazz); };
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.popClass = /**
	     * @return {?}
	     */
	    function () { return /** @type {?} */ ((this._classes.pop())); };
	    Object.defineProperty(EmitterVisitorContext.prototype, "currentClass", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._classes.length > 0 ? this._classes[this._classes.length - 1] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.toSource = /**
	     * @return {?}
	     */
	    function () {
	        return this.sourceLines
	            .map(function (l) { return l.parts.length > 0 ? _createIndent(l.indent) + l.parts.join('') : ''; })
	            .join('\n');
	    };
	    /**
	     * @param {?} genFilePath
	     * @param {?=} startsAtLine
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.toSourceMapGenerator = /**
	     * @param {?} genFilePath
	     * @param {?=} startsAtLine
	     * @return {?}
	     */
	    function (genFilePath, startsAtLine) {
	        if (startsAtLine === void 0) { startsAtLine = 0; }
	        var /** @type {?} */ map = new SourceMapGenerator(genFilePath);
	        var /** @type {?} */ firstOffsetMapped = false;
	        var /** @type {?} */ mapFirstOffsetIfNeeded = function () {
	            if (!firstOffsetMapped) {
	                // Add a single space so that tools won't try to load the file from disk.
	                // Note: We are using virtual urls like `ng:///`, so we have to
	                // provide a content here.
	                map.addSource(genFilePath, ' ').addMapping(0, genFilePath, 0, 0);
	                firstOffsetMapped = true;
	            }
	        };
	        for (var /** @type {?} */ i = 0; i < startsAtLine; i++) {
	            map.addLine();
	            mapFirstOffsetIfNeeded();
	        }
	        this.sourceLines.forEach(function (line, lineIdx) {
	            map.addLine();
	            var /** @type {?} */ spans = line.srcSpans;
	            var /** @type {?} */ parts = line.parts;
	            var /** @type {?} */ col0 = line.indent * _INDENT_WITH.length;
	            var /** @type {?} */ spanIdx = 0;
	            // skip leading parts without source spans
	            while (spanIdx < spans.length && !spans[spanIdx]) {
	                col0 += parts[spanIdx].length;
	                spanIdx++;
	            }
	            if (spanIdx < spans.length && lineIdx === 0 && col0 === 0) {
	                firstOffsetMapped = true;
	            }
	            else {
	                mapFirstOffsetIfNeeded();
	            }
	            while (spanIdx < spans.length) {
	                var /** @type {?} */ span = /** @type {?} */ ((spans[spanIdx]));
	                var /** @type {?} */ source = span.start.file;
	                var /** @type {?} */ sourceLine = span.start.line;
	                var /** @type {?} */ sourceCol = span.start.col;
	                map.addSource(source.url, source.content)
	                    .addMapping(col0, source.url, sourceLine, sourceCol);
	                col0 += parts[spanIdx].length;
	                spanIdx++;
	                // assign parts without span or the same span to the previous segment
	                while (spanIdx < spans.length && (span === spans[spanIdx] || !spans[spanIdx])) {
	                    col0 += parts[spanIdx].length;
	                    spanIdx++;
	                }
	            }
	        });
	        return map;
	    };
	    /**
	     * @param {?} count
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.setPreambleLineCount = /**
	     * @param {?} count
	     * @return {?}
	     */
	    function (count) { return this._preambleLineCount = count; };
	    /**
	     * @param {?} line
	     * @param {?} column
	     * @return {?}
	     */
	    EmitterVisitorContext.prototype.spanOf = /**
	     * @param {?} line
	     * @param {?} column
	     * @return {?}
	     */
	    function (line, column) {
	        var /** @type {?} */ emittedLine = this._lines[line - this._preambleLineCount];
	        if (emittedLine) {
	            var /** @type {?} */ columnsLeft = column - _createIndent(emittedLine.indent).length;
	            for (var /** @type {?} */ partIndex = 0; partIndex < emittedLine.parts.length; partIndex++) {
	                var /** @type {?} */ part = emittedLine.parts[partIndex];
	                if (part.length > columnsLeft) {
	                    return emittedLine.srcSpans[partIndex];
	                }
	                columnsLeft -= part.length;
	            }
	        }
	        return null;
	    };
	    Object.defineProperty(EmitterVisitorContext.prototype, "sourceLines", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (this._lines.length && this._lines[this._lines.length - 1].parts.length === 0) {
	                return this._lines.slice(0, -1);
	            }
	            return this._lines;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return EmitterVisitorContext;
	}());
	/**
	 * @abstract
	 */
	var AbstractEmitterVisitor = /** @class */ (function () {
	    function AbstractEmitterVisitor(_escapeDollarInStrings) {
	        this._escapeDollarInStrings = _escapeDollarInStrings;
	    }
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitExpressionStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        stmt.expr.visitExpression(this, ctx);
	        ctx.println(stmt, ';');
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitReturnStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "return ");
	        stmt.value.visitExpression(this, ctx);
	        ctx.println(stmt, ';');
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitIfStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "if (");
	        stmt.condition.visitExpression(this, ctx);
	        ctx.print(stmt, ") {");
	        var /** @type {?} */ hasElseCase = stmt.falseCase != null && stmt.falseCase.length > 0;
	        if (stmt.trueCase.length <= 1 && !hasElseCase) {
	            ctx.print(stmt, " ");
	            this.visitAllStatements(stmt.trueCase, ctx);
	            ctx.removeEmptyLastLine();
	            ctx.print(stmt, " ");
	        }
	        else {
	            ctx.println();
	            ctx.incIndent();
	            this.visitAllStatements(stmt.trueCase, ctx);
	            ctx.decIndent();
	            if (hasElseCase) {
	                ctx.println(stmt, "} else {");
	                ctx.incIndent();
	                this.visitAllStatements(stmt.falseCase, ctx);
	                ctx.decIndent();
	            }
	        }
	        ctx.println(stmt, "}");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitThrowStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "throw ");
	        stmt.error.visitExpression(this, ctx);
	        ctx.println(stmt, ";");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitCommentStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var /** @type {?} */ lines = stmt.comment.split('\n');
	        lines.forEach(function (line) { ctx.println(stmt, "// " + line); });
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitWriteVarExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ lineWasEmpty = ctx.lineIsEmpty();
	        if (!lineWasEmpty) {
	            ctx.print(expr, '(');
	        }
	        ctx.print(expr, expr.name + " = ");
	        expr.value.visitExpression(this, ctx);
	        if (!lineWasEmpty) {
	            ctx.print(expr, ')');
	        }
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitWriteKeyExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ lineWasEmpty = ctx.lineIsEmpty();
	        if (!lineWasEmpty) {
	            ctx.print(expr, '(');
	        }
	        expr.receiver.visitExpression(this, ctx);
	        ctx.print(expr, "[");
	        expr.index.visitExpression(this, ctx);
	        ctx.print(expr, "] = ");
	        expr.value.visitExpression(this, ctx);
	        if (!lineWasEmpty) {
	            ctx.print(expr, ')');
	        }
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitWritePropExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ lineWasEmpty = ctx.lineIsEmpty();
	        if (!lineWasEmpty) {
	            ctx.print(expr, '(');
	        }
	        expr.receiver.visitExpression(this, ctx);
	        ctx.print(expr, "." + expr.name + " = ");
	        expr.value.visitExpression(this, ctx);
	        if (!lineWasEmpty) {
	            ctx.print(expr, ')');
	        }
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitInvokeMethodExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        expr.receiver.visitExpression(this, ctx);
	        var /** @type {?} */ name = expr.name;
	        if (expr.builtin != null) {
	            name = this.getBuiltinMethodName(expr.builtin);
	            if (name == null) {
	                // some builtins just mean to skip the call.
	                return null;
	            }
	        }
	        ctx.print(expr, "." + name + "(");
	        this.visitAllExpressions(expr.args, ctx, ",");
	        ctx.print(expr, ")");
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitInvokeFunctionExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        expr.fn.visitExpression(this, ctx);
	        ctx.print(expr, "(");
	        this.visitAllExpressions(expr.args, ctx, ',');
	        ctx.print(expr, ")");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitReadVarExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ varName = /** @type {?} */ ((ast.name));
	        if (ast.builtin != null) {
	            switch (ast.builtin) {
	                case BuiltinVar.Super:
	                    varName = 'super';
	                    break;
	                case BuiltinVar.This:
	                    varName = 'this';
	                    break;
	                case BuiltinVar.CatchError:
	                    varName = /** @type {?} */ ((CATCH_ERROR_VAR$1.name));
	                    break;
	                case BuiltinVar.CatchStack:
	                    varName = /** @type {?} */ ((CATCH_STACK_VAR$1.name));
	                    break;
	                default:
	                    throw new Error("Unknown builtin variable " + ast.builtin);
	            }
	        }
	        ctx.print(ast, varName);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitInstantiateExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "new ");
	        ast.classExpr.visitExpression(this, ctx);
	        ctx.print(ast, "(");
	        this.visitAllExpressions(ast.args, ctx, ',');
	        ctx.print(ast, ")");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitLiteralExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ value = ast.value;
	        if (typeof value === 'string') {
	            ctx.print(ast, escapeIdentifier(value, this._escapeDollarInStrings));
	        }
	        else {
	            ctx.print(ast, "" + value);
	        }
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitConditionalExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "(");
	        ast.condition.visitExpression(this, ctx);
	        ctx.print(ast, '? ');
	        ast.trueCase.visitExpression(this, ctx);
	        ctx.print(ast, ': '); /** @type {?} */
	        ((ast.falseCase)).visitExpression(this, ctx);
	        ctx.print(ast, ")");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitNotExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, '!');
	        ast.condition.visitExpression(this, ctx);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitAssertNotNullExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ast.condition.visitExpression(this, ctx);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitBinaryOperatorExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ opStr;
	        switch (ast.operator) {
	            case BinaryOperator.Equals:
	                opStr = '==';
	                break;
	            case BinaryOperator.Identical:
	                opStr = '===';
	                break;
	            case BinaryOperator.NotEquals:
	                opStr = '!=';
	                break;
	            case BinaryOperator.NotIdentical:
	                opStr = '!==';
	                break;
	            case BinaryOperator.And:
	                opStr = '&&';
	                break;
	            case BinaryOperator.Or:
	                opStr = '||';
	                break;
	            case BinaryOperator.Plus:
	                opStr = '+';
	                break;
	            case BinaryOperator.Minus:
	                opStr = '-';
	                break;
	            case BinaryOperator.Divide:
	                opStr = '/';
	                break;
	            case BinaryOperator.Multiply:
	                opStr = '*';
	                break;
	            case BinaryOperator.Modulo:
	                opStr = '%';
	                break;
	            case BinaryOperator.Lower:
	                opStr = '<';
	                break;
	            case BinaryOperator.LowerEquals:
	                opStr = '<=';
	                break;
	            case BinaryOperator.Bigger:
	                opStr = '>';
	                break;
	            case BinaryOperator.BiggerEquals:
	                opStr = '>=';
	                break;
	            default:
	                throw new Error("Unknown operator " + ast.operator);
	        }
	        ctx.print(ast, "(");
	        ast.lhs.visitExpression(this, ctx);
	        ctx.print(ast, " " + opStr + " ");
	        ast.rhs.visitExpression(this, ctx);
	        ctx.print(ast, ")");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitReadPropExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ast.receiver.visitExpression(this, ctx);
	        ctx.print(ast, ".");
	        ctx.print(ast, ast.name);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitReadKeyExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ast.receiver.visitExpression(this, ctx);
	        ctx.print(ast, "[");
	        ast.index.visitExpression(this, ctx);
	        ctx.print(ast, "]");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitLiteralArrayExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "[");
	        this.visitAllExpressions(ast.entries, ctx, ',');
	        ctx.print(ast, "]");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitLiteralMapExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var _this = this;
	        ctx.print(ast, "{");
	        this.visitAllObjects(function (entry) {
	            ctx.print(ast, escapeIdentifier(entry.key, _this._escapeDollarInStrings, entry.quoted) + ":");
	            entry.value.visitExpression(_this, ctx);
	        }, ast.entries, ctx, ',');
	        ctx.print(ast, "}");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitCommaExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, '(');
	        this.visitAllExpressions(ast.parts, ctx, ',');
	        ctx.print(ast, ')');
	        return null;
	    };
	    /**
	     * @param {?} expressions
	     * @param {?} ctx
	     * @param {?} separator
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitAllExpressions = /**
	     * @param {?} expressions
	     * @param {?} ctx
	     * @param {?} separator
	     * @return {?}
	     */
	    function (expressions, ctx, separator) {
	        var _this = this;
	        this.visitAllObjects(function (expr) { return expr.visitExpression(_this, ctx); }, expressions, ctx, separator);
	    };
	    /**
	     * @template T
	     * @param {?} handler
	     * @param {?} expressions
	     * @param {?} ctx
	     * @param {?} separator
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitAllObjects = /**
	     * @template T
	     * @param {?} handler
	     * @param {?} expressions
	     * @param {?} ctx
	     * @param {?} separator
	     * @return {?}
	     */
	    function (handler, expressions, ctx, separator) {
	        var /** @type {?} */ incrementedIndent = false;
	        for (var /** @type {?} */ i = 0; i < expressions.length; i++) {
	            if (i > 0) {
	                if (ctx.lineLength() > 80) {
	                    ctx.print(null, separator, true);
	                    if (!incrementedIndent) {
	                        // continuation are marked with double indent.
	                        ctx.incIndent();
	                        ctx.incIndent();
	                        incrementedIndent = true;
	                    }
	                }
	                else {
	                    ctx.print(null, separator, false);
	                }
	            }
	            handler(expressions[i]);
	        }
	        if (incrementedIndent) {
	            // continuation are marked with double indent.
	            ctx.decIndent();
	            ctx.decIndent();
	        }
	    };
	    /**
	     * @param {?} statements
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractEmitterVisitor.prototype.visitAllStatements = /**
	     * @param {?} statements
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (statements, ctx) {
	        var _this = this;
	        statements.forEach(function (stmt) { return stmt.visitStatement(_this, ctx); });
	    };
	    return AbstractEmitterVisitor;
	}());
	/**
	 * @param {?} input
	 * @param {?} escapeDollar
	 * @param {?=} alwaysQuote
	 * @return {?}
	 */
	function escapeIdentifier(input, escapeDollar, alwaysQuote) {
	    if (alwaysQuote === void 0) { alwaysQuote = true; }
	    if (input == null) {
	        return null;
	    }
	    var /** @type {?} */ body = input.replace(_SINGLE_QUOTE_ESCAPE_STRING_RE, function () {
	        var match = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            match[_i] = arguments[_i];
	        }
	        if (match[0] == '$') {
	            return escapeDollar ? '\\$' : '$';
	        }
	        else if (match[0] == '\n') {
	            return '\\n';
	        }
	        else if (match[0] == '\r') {
	            return '\\r';
	        }
	        else {
	            return "\\" + match[0];
	        }
	    });
	    var /** @type {?} */ requiresQuotes = alwaysQuote || !_LEGAL_IDENTIFIER_RE.test(body);
	    return requiresQuotes ? "'" + body + "'" : body;
	}
	/**
	 * @param {?} count
	 * @return {?}
	 */
	function _createIndent(count) {
	    var /** @type {?} */ res = '';
	    for (var /** @type {?} */ i = 0; i < count; i++) {
	        res += _INDENT_WITH;
	    }
	    return res;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} ast
	 * @return {?}
	 */
	function debugOutputAstAsTypeScript(ast) {
	    var /** @type {?} */ converter = new _TsEmitterVisitor();
	    var /** @type {?} */ ctx = EmitterVisitorContext.createRoot();
	    var /** @type {?} */ asts = Array.isArray(ast) ? ast : [ast];
	    asts.forEach(function (ast) {
	        if (ast instanceof Statement) {
	            ast.visitStatement(converter, ctx);
	        }
	        else if (ast instanceof Expression) {
	            ast.visitExpression(converter, ctx);
	        }
	        else if (ast instanceof Type$1) {
	            ast.visitType(converter, ctx);
	        }
	        else {
	            throw new Error("Don't know how to print debug info for " + ast);
	        }
	    });
	    return ctx.toSource();
	}
	var TypeScriptEmitter = /** @class */ (function () {
	    function TypeScriptEmitter() {
	    }
	    /**
	     * @param {?} genFilePath
	     * @param {?} stmts
	     * @param {?=} preamble
	     * @param {?=} emitSourceMaps
	     * @param {?=} referenceFilter
	     * @return {?}
	     */
	    TypeScriptEmitter.prototype.emitStatementsAndContext = /**
	     * @param {?} genFilePath
	     * @param {?} stmts
	     * @param {?=} preamble
	     * @param {?=} emitSourceMaps
	     * @param {?=} referenceFilter
	     * @return {?}
	     */
	    function (genFilePath, stmts, preamble, emitSourceMaps, referenceFilter) {
	        if (preamble === void 0) { preamble = ''; }
	        if (emitSourceMaps === void 0) { emitSourceMaps = true; }
	        var /** @type {?} */ converter = new _TsEmitterVisitor(referenceFilter);
	        var /** @type {?} */ ctx = EmitterVisitorContext.createRoot();
	        converter.visitAllStatements(stmts, ctx);
	        var /** @type {?} */ preambleLines = preamble ? preamble.split('\n') : [];
	        converter.reexports.forEach(function (reexports, exportedModuleName) {
	            var /** @type {?} */ reexportsCode = reexports.map(function (reexport) { return reexport.name + " as " + reexport.as; }).join(',');
	            preambleLines.push("export {" + reexportsCode + "} from '" + exportedModuleName + "';");
	        });
	        converter.importsWithPrefixes.forEach(function (prefix, importedModuleName) {
	            // Note: can't write the real word for import as it screws up system.js auto detection...
	            preambleLines.push("imp" +
	                ("ort * as " + prefix + " from '" + importedModuleName + "';"));
	        });
	        var /** @type {?} */ sm = emitSourceMaps ?
	            ctx.toSourceMapGenerator(genFilePath, preambleLines.length).toJsComment() :
	            '';
	        var /** @type {?} */ lines = preambleLines.concat([ctx.toSource(), sm]);
	        if (sm) {
	            // always add a newline at the end, as some tools have bugs without it.
	            lines.push('');
	        }
	        ctx.setPreambleLineCount(preambleLines.length);
	        return { sourceText: lines.join('\n'), context: ctx };
	    };
	    /**
	     * @param {?} genFilePath
	     * @param {?} stmts
	     * @param {?=} preamble
	     * @return {?}
	     */
	    TypeScriptEmitter.prototype.emitStatements = /**
	     * @param {?} genFilePath
	     * @param {?} stmts
	     * @param {?=} preamble
	     * @return {?}
	     */
	    function (genFilePath, stmts, preamble) {
	        if (preamble === void 0) { preamble = ''; }
	        return this.emitStatementsAndContext(genFilePath, stmts, preamble).sourceText;
	    };
	    return TypeScriptEmitter;
	}());
	var _TsEmitterVisitor = /** @class */ (function (_super) {
	    __extends(_TsEmitterVisitor, _super);
	    function _TsEmitterVisitor(referenceFilter) {
	        var _this = _super.call(this, false) || this;
	        _this.referenceFilter = referenceFilter;
	        _this.typeExpression = 0;
	        _this.importsWithPrefixes = new Map();
	        _this.reexports = new Map();
	        return _this;
	    }
	    /**
	     * @param {?} t
	     * @param {?} ctx
	     * @param {?=} defaultType
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitType = /**
	     * @param {?} t
	     * @param {?} ctx
	     * @param {?=} defaultType
	     * @return {?}
	     */
	    function (t, ctx, defaultType) {
	        if (defaultType === void 0) { defaultType = 'any'; }
	        if (t) {
	            this.typeExpression++;
	            t.visitType(this, ctx);
	            this.typeExpression--;
	        }
	        else {
	            ctx.print(null, defaultType);
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitLiteralExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ value = ast.value;
	        if (value == null && ast.type != INFERRED_TYPE) {
	            ctx.print(ast, "(" + value + " as any)");
	            return null;
	        }
	        return _super.prototype.visitLiteralExpr.call(this, ast, ctx);
	    };
	    // Temporary workaround to support strictNullCheck enabled consumers of ngc emit.
	    // In SNC mode, [] have the type never[], so we cast here to any[].
	    // TODO: narrow the cast to a more explicit type, or use a pattern that does not
	    // start with [].concat. see https://github.com/angular/angular/pull/11846
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitLiteralArrayExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        if (ast.entries.length === 0) {
	            ctx.print(ast, '(');
	        }
	        var /** @type {?} */ result = _super.prototype.visitLiteralArrayExpr.call(this, ast, ctx);
	        if (ast.entries.length === 0) {
	            ctx.print(ast, ' as any[])');
	        }
	        return result;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitExternalExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        this._visitIdentifier(ast.value, ast.typeParams, ctx);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitAssertNotNullExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ result = _super.prototype.visitAssertNotNullExpr.call(this, ast, ctx);
	        ctx.print(ast, '!');
	        return result;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitDeclareVarStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        if (stmt.hasModifier(StmtModifier.Exported) && stmt.value instanceof ExternalExpr &&
	            !stmt.type) {
	            // check for a reexport
	            var _a = stmt.value.value, name_1 = _a.name, moduleName = _a.moduleName;
	            if (moduleName) {
	                var /** @type {?} */ reexports = this.reexports.get(moduleName);
	                if (!reexports) {
	                    reexports = [];
	                    this.reexports.set(moduleName, reexports);
	                }
	                reexports.push({ name: /** @type {?} */ ((name_1)), as: stmt.name });
	                return null;
	            }
	        }
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            ctx.print(stmt, "export ");
	        }
	        if (stmt.hasModifier(StmtModifier.Final)) {
	            ctx.print(stmt, "const");
	        }
	        else {
	            ctx.print(stmt, "var");
	        }
	        ctx.print(stmt, " " + stmt.name);
	        this._printColonType(stmt.type, ctx);
	        ctx.print(stmt, " = ");
	        stmt.value.visitExpression(this, ctx);
	        ctx.println(stmt, ";");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitCastExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "(<"); /** @type {?} */
	        ((ast.type)).visitType(this, ctx);
	        ctx.print(ast, ">");
	        ast.value.visitExpression(this, ctx);
	        ctx.print(ast, ")");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitInstantiateExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "new ");
	        this.typeExpression++;
	        ast.classExpr.visitExpression(this, ctx);
	        this.typeExpression--;
	        ctx.print(ast, "(");
	        this.visitAllExpressions(ast.args, ctx, ',');
	        ctx.print(ast, ")");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var _this = this;
	        ctx.pushClass(stmt);
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            ctx.print(stmt, "export ");
	        }
	        ctx.print(stmt, "class " + stmt.name);
	        if (stmt.parent != null) {
	            ctx.print(stmt, " extends ");
	            this.typeExpression++;
	            stmt.parent.visitExpression(this, ctx);
	            this.typeExpression--;
	        }
	        ctx.println(stmt, " {");
	        ctx.incIndent();
	        stmt.fields.forEach(function (field) { return _this._visitClassField(field, ctx); });
	        if (stmt.constructorMethod != null) {
	            this._visitClassConstructor(stmt, ctx);
	        }
	        stmt.getters.forEach(function (getter) { return _this._visitClassGetter(getter, ctx); });
	        stmt.methods.forEach(function (method) { return _this._visitClassMethod(method, ctx); });
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	        ctx.popClass();
	        return null;
	    };
	    /**
	     * @param {?} field
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._visitClassField = /**
	     * @param {?} field
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (field, ctx) {
	        if (field.hasModifier(StmtModifier.Private)) {
	            // comment out as a workaround for #10967
	            ctx.print(null, "/*private*/ ");
	        }
	        ctx.print(null, field.name);
	        this._printColonType(field.type, ctx);
	        ctx.println(null, ";");
	    };
	    /**
	     * @param {?} getter
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._visitClassGetter = /**
	     * @param {?} getter
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (getter, ctx) {
	        if (getter.hasModifier(StmtModifier.Private)) {
	            ctx.print(null, "private ");
	        }
	        ctx.print(null, "get " + getter.name + "()");
	        this._printColonType(getter.type, ctx);
	        ctx.println(null, " {");
	        ctx.incIndent();
	        this.visitAllStatements(getter.body, ctx);
	        ctx.decIndent();
	        ctx.println(null, "}");
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._visitClassConstructor = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "constructor(");
	        this._visitParams(stmt.constructorMethod.params, ctx);
	        ctx.println(stmt, ") {");
	        ctx.incIndent();
	        this.visitAllStatements(stmt.constructorMethod.body, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	    };
	    /**
	     * @param {?} method
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._visitClassMethod = /**
	     * @param {?} method
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (method, ctx) {
	        if (method.hasModifier(StmtModifier.Private)) {
	            ctx.print(null, "private ");
	        }
	        ctx.print(null, method.name + "(");
	        this._visitParams(method.params, ctx);
	        ctx.print(null, ")");
	        this._printColonType(method.type, ctx, 'void');
	        ctx.println(null, " {");
	        ctx.incIndent();
	        this.visitAllStatements(method.body, ctx);
	        ctx.decIndent();
	        ctx.println(null, "}");
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "(");
	        this._visitParams(ast.params, ctx);
	        ctx.print(ast, ")");
	        this._printColonType(ast.type, ctx, 'void');
	        ctx.println(ast, " => {");
	        ctx.incIndent();
	        this.visitAllStatements(ast.statements, ctx);
	        ctx.decIndent();
	        ctx.print(ast, "}");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            ctx.print(stmt, "export ");
	        }
	        ctx.print(stmt, "function " + stmt.name + "(");
	        this._visitParams(stmt.params, ctx);
	        ctx.print(stmt, ")");
	        this._printColonType(stmt.type, ctx, 'void');
	        ctx.println(stmt, " {");
	        ctx.incIndent();
	        this.visitAllStatements(stmt.statements, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitTryCatchStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.println(stmt, "try {");
	        ctx.incIndent();
	        this.visitAllStatements(stmt.bodyStmts, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "} catch (" + CATCH_ERROR_VAR$1.name + ") {");
	        ctx.incIndent();
	        var /** @type {?} */ catchStmts = [/** @type {?} */ (CATCH_STACK_VAR$1.set(CATCH_ERROR_VAR$1.prop('stack', null)).toDeclStmt(null, [
	                StmtModifier.Final
	            ]))].concat(stmt.catchStmts);
	        this.visitAllStatements(catchStmts, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	        return null;
	    };
	    /**
	     * @param {?} type
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitBuiltintType = /**
	     * @param {?} type
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (type, ctx) {
	        var /** @type {?} */ typeStr;
	        switch (type.name) {
	            case BuiltinTypeName.Bool:
	                typeStr = 'boolean';
	                break;
	            case BuiltinTypeName.Dynamic:
	                typeStr = 'any';
	                break;
	            case BuiltinTypeName.Function:
	                typeStr = 'Function';
	                break;
	            case BuiltinTypeName.Number:
	                typeStr = 'number';
	                break;
	            case BuiltinTypeName.Int:
	                typeStr = 'number';
	                break;
	            case BuiltinTypeName.String:
	                typeStr = 'string';
	                break;
	            default:
	                throw new Error("Unsupported builtin type " + type.name);
	        }
	        ctx.print(null, typeStr);
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitExpressionType = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ast.value.visitExpression(this, ctx);
	        return null;
	    };
	    /**
	     * @param {?} type
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitArrayType = /**
	     * @param {?} type
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (type, ctx) {
	        this.visitType(type.of, ctx);
	        ctx.print(null, "[]");
	        return null;
	    };
	    /**
	     * @param {?} type
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.visitMapType = /**
	     * @param {?} type
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (type, ctx) {
	        ctx.print(null, "{[key: string]:");
	        this.visitType(type.valueType, ctx);
	        ctx.print(null, "}");
	        return null;
	    };
	    /**
	     * @param {?} method
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype.getBuiltinMethodName = /**
	     * @param {?} method
	     * @return {?}
	     */
	    function (method) {
	        var /** @type {?} */ name;
	        switch (method) {
	            case BuiltinMethod.ConcatArray:
	                name = 'concat';
	                break;
	            case BuiltinMethod.SubscribeObservable:
	                name = 'subscribe';
	                break;
	            case BuiltinMethod.Bind:
	                name = 'bind';
	                break;
	            default:
	                throw new Error("Unknown builtin method: " + method);
	        }
	        return name;
	    };
	    /**
	     * @param {?} params
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._visitParams = /**
	     * @param {?} params
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (params, ctx) {
	        var _this = this;
	        this.visitAllObjects(function (param) {
	            ctx.print(null, param.name);
	            _this._printColonType(param.type, ctx);
	        }, params, ctx, ',');
	    };
	    /**
	     * @param {?} value
	     * @param {?} typeParams
	     * @param {?} ctx
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._visitIdentifier = /**
	     * @param {?} value
	     * @param {?} typeParams
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (value, typeParams, ctx) {
	        var _this = this;
	        var name = value.name, moduleName = value.moduleName;
	        if (this.referenceFilter && this.referenceFilter(value)) {
	            ctx.print(null, '(null as any)');
	            return;
	        }
	        if (moduleName) {
	            var /** @type {?} */ prefix = this.importsWithPrefixes.get(moduleName);
	            if (prefix == null) {
	                prefix = "i" + this.importsWithPrefixes.size;
	                this.importsWithPrefixes.set(moduleName, prefix);
	            }
	            ctx.print(null, prefix + ".");
	        }
	        ctx.print(null, /** @type {?} */ ((name)));
	        if (this.typeExpression > 0) {
	            // If we are in a type expression that refers to a generic type then supply
	            // the required type parameters. If there were not enough type parameters
	            // supplied, supply any as the type. Outside a type expression the reference
	            // should not supply type parameters and be treated as a simple value reference
	            // to the constructor function itself.
	            var /** @type {?} */ suppliedParameters = typeParams || [];
	            if (suppliedParameters.length > 0) {
	                ctx.print(null, "<");
	                this.visitAllObjects(function (type) { return type.visitType(_this, ctx); }, /** @type {?} */ ((typeParams)), ctx, ',');
	                ctx.print(null, ">");
	            }
	        }
	    };
	    /**
	     * @param {?} type
	     * @param {?} ctx
	     * @param {?=} defaultType
	     * @return {?}
	     */
	    _TsEmitterVisitor.prototype._printColonType = /**
	     * @param {?} type
	     * @param {?} ctx
	     * @param {?=} defaultType
	     * @return {?}
	     */
	    function (type, ctx, defaultType) {
	        if (type !== INFERRED_TYPE) {
	            ctx.print(null, ':');
	            this.visitType(type, ctx, defaultType);
	        }
	    };
	    return _TsEmitterVisitor;
	}(AbstractEmitterVisitor));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Resolve a `Type` for {\@link Pipe}.
	 *
	 * This interface can be overridden by the application developer to create custom behavior.
	 *
	 * See {\@link Compiler}
	 */
	var PipeResolver = /** @class */ (function () {
	    function PipeResolver(_reflector) {
	        this._reflector = _reflector;
	    }
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    PipeResolver.prototype.isPipe = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ typeMetadata = this._reflector.annotations(resolveForwardRef(type));
	        return typeMetadata && typeMetadata.some(createPipe.isTypeOf);
	    };
	    /**
	     * Return {@link Pipe} for a given `Type`.
	     */
	    /**
	     * Return {\@link Pipe} for a given `Type`.
	     * @param {?} type
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    PipeResolver.prototype.resolve = /**
	     * Return {\@link Pipe} for a given `Type`.
	     * @param {?} type
	     * @param {?=} throwIfNotFound
	     * @return {?}
	     */
	    function (type, throwIfNotFound) {
	        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
	        var /** @type {?} */ metas = this._reflector.annotations(resolveForwardRef(type));
	        if (metas) {
	            var /** @type {?} */ annotation = findLast(metas, createPipe.isTypeOf);
	            if (annotation) {
	                return annotation;
	            }
	        }
	        if (throwIfNotFound) {
	            throw new Error("No Pipe decorator found on " + stringify(type));
	        }
	        return null;
	    };
	    return PipeResolver;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Map from tagName|propertyName SecurityContext. Properties applying to all tags use '*'.
	 */
	var SECURITY_SCHEMA = {};
	/**
	 * @param {?} ctx
	 * @param {?} specs
	 * @return {?}
	 */
	function registerContext(ctx, specs) {
	    for (var _i = 0, specs_1 = specs; _i < specs_1.length; _i++) {
	        var spec = specs_1[_i];
	        SECURITY_SCHEMA[spec.toLowerCase()] = ctx;
	    }
	}
	// Case is insignificant below, all element and attribute names are lower-cased for lookup.
	registerContext(SecurityContext.HTML, [
	    'iframe|srcdoc',
	    '*|innerHTML',
	    '*|outerHTML',
	]);
	registerContext(SecurityContext.STYLE, ['*|style']);
	// NB: no SCRIPT contexts here, they are never allowed due to the parser stripping them.
	registerContext(SecurityContext.URL, [
	    '*|formAction', 'area|href', 'area|ping', 'audio|src', 'a|href',
	    'a|ping', 'blockquote|cite', 'body|background', 'del|cite', 'form|action',
	    'img|src', 'img|srcset', 'input|src', 'ins|cite', 'q|cite',
	    'source|src', 'source|srcset', 'track|src', 'video|poster', 'video|src',
	]);
	registerContext(SecurityContext.RESOURCE_URL, [
	    'applet|code',
	    'applet|codebase',
	    'base|href',
	    'embed|src',
	    'frame|src',
	    'head|profile',
	    'html|manifest',
	    'iframe|src',
	    'link|href',
	    'media|src',
	    'object|codebase',
	    'object|data',
	    'script|src',
	]);
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @abstract
	 */
	var ElementSchemaRegistry = /** @class */ (function () {
	    function ElementSchemaRegistry() {
	    }
	    return ElementSchemaRegistry;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var BOOLEAN = 'boolean';
	var NUMBER = 'number';
	var STRING = 'string';
	var OBJECT = 'object';
	/**
	 * This array represents the DOM schema. It encodes inheritance, properties, and events.
	 *
	 * ## Overview
	 *
	 * Each line represents one kind of element. The `element_inheritance` and properties are joined
	 * using `element_inheritance|properties` syntax.
	 *
	 * ## Element Inheritance
	 *
	 * The `element_inheritance` can be further subdivided as `element1,element2,...^parentElement`.
	 * Here the individual elements are separated by `,` (commas). Every element in the list
	 * has identical properties.
	 *
	 * An `element` may inherit additional properties from `parentElement` If no `^parentElement` is
	 * specified then `""` (blank) element is assumed.
	 *
	 * NOTE: The blank element inherits from root `[Element]` element, the super element of all
	 * elements.
	 *
	 * NOTE an element prefix such as `:svg:` has no special meaning to the schema.
	 *
	 * ## Properties
	 *
	 * Each element has a set of properties separated by `,` (commas). Each property can be prefixed
	 * by a special character designating its type:
	 *
	 * - (no prefix): property is a string.
	 * - `*`: property represents an event.
	 * - `!`: property is a boolean.
	 * - `#`: property is a number.
	 * - `%`: property is an object.
	 *
	 * ## Query
	 *
	 * The class creates an internal squas representation which allows to easily answer the query of
	 * if a given property exist on a given element.
	 *
	 * NOTE: We don't yet support querying for types or events.
	 * NOTE: This schema is auto extracted from `schema_extractor.ts` located in the test folder,
	 *       see dom_element_schema_registry_spec.ts
	 */
	var SCHEMA = [
	    '[Element]|textContent,%classList,className,id,innerHTML,*beforecopy,*beforecut,*beforepaste,*copy,*cut,*paste,*search,*selectstart,*webkitfullscreenchange,*webkitfullscreenerror,*wheel,outerHTML,#scrollLeft,#scrollTop,slot' +
	        ',*message,*mozfullscreenchange,*mozfullscreenerror,*mozpointerlockchange,*mozpointerlockerror,*webglcontextcreationerror,*webglcontextlost,*webglcontextrestored',
	    '[HTMLElement]^[Element]|accessKey,contentEditable,dir,!draggable,!hidden,innerText,lang,*abort,*auxclick,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*gotpointercapture,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*lostpointercapture,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*pointercancel,*pointerdown,*pointerenter,*pointerleave,*pointermove,*pointerout,*pointerover,*pointerup,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,outerText,!spellcheck,%style,#tabIndex,title,!translate',
	    'abbr,address,article,aside,b,bdi,bdo,cite,code,dd,dfn,dt,em,figcaption,figure,footer,header,i,kbd,main,mark,nav,noscript,rb,rp,rt,rtc,ruby,s,samp,section,small,strong,sub,sup,u,var,wbr^[HTMLElement]|accessKey,contentEditable,dir,!draggable,!hidden,innerText,lang,*abort,*auxclick,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*gotpointercapture,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*lostpointercapture,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*pointercancel,*pointerdown,*pointerenter,*pointerleave,*pointermove,*pointerout,*pointerover,*pointerup,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,outerText,!spellcheck,%style,#tabIndex,title,!translate',
	    'media^[HTMLElement]|!autoplay,!controls,%controlsList,%crossOrigin,#currentTime,!defaultMuted,#defaultPlaybackRate,!disableRemotePlayback,!loop,!muted,*encrypted,*waitingforkey,#playbackRate,preload,src,%srcObject,#volume',
	    ':svg:^[HTMLElement]|*abort,*auxclick,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*gotpointercapture,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*lostpointercapture,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*pointercancel,*pointerdown,*pointerenter,*pointerleave,*pointermove,*pointerout,*pointerover,*pointerup,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,%style,#tabIndex',
	    ':svg:graphics^:svg:|',
	    ':svg:animation^:svg:|*begin,*end,*repeat',
	    ':svg:geometry^:svg:|',
	    ':svg:componentTransferFunction^:svg:|',
	    ':svg:gradient^:svg:|',
	    ':svg:textContent^:svg:graphics|',
	    ':svg:textPositioning^:svg:textContent|',
	    'a^[HTMLElement]|charset,coords,download,hash,host,hostname,href,hreflang,name,password,pathname,ping,port,protocol,referrerPolicy,rel,rev,search,shape,target,text,type,username',
	    'area^[HTMLElement]|alt,coords,download,hash,host,hostname,href,!noHref,password,pathname,ping,port,protocol,referrerPolicy,rel,search,shape,target,username',
	    'audio^media|',
	    'br^[HTMLElement]|clear',
	    'base^[HTMLElement]|href,target',
	    'body^[HTMLElement]|aLink,background,bgColor,link,*beforeunload,*blur,*error,*focus,*hashchange,*languagechange,*load,*message,*offline,*online,*pagehide,*pageshow,*popstate,*rejectionhandled,*resize,*scroll,*storage,*unhandledrejection,*unload,text,vLink',
	    'button^[HTMLElement]|!autofocus,!disabled,formAction,formEnctype,formMethod,!formNoValidate,formTarget,name,type,value',
	    'canvas^[HTMLElement]|#height,#width',
	    'content^[HTMLElement]|select',
	    'dl^[HTMLElement]|!compact',
	    'datalist^[HTMLElement]|',
	    'details^[HTMLElement]|!open',
	    'dialog^[HTMLElement]|!open,returnValue',
	    'dir^[HTMLElement]|!compact',
	    'div^[HTMLElement]|align',
	    'embed^[HTMLElement]|align,height,name,src,type,width',
	    'fieldset^[HTMLElement]|!disabled,name',
	    'font^[HTMLElement]|color,face,size',
	    'form^[HTMLElement]|acceptCharset,action,autocomplete,encoding,enctype,method,name,!noValidate,target',
	    'frame^[HTMLElement]|frameBorder,longDesc,marginHeight,marginWidth,name,!noResize,scrolling,src',
	    'frameset^[HTMLElement]|cols,*beforeunload,*blur,*error,*focus,*hashchange,*languagechange,*load,*message,*offline,*online,*pagehide,*pageshow,*popstate,*rejectionhandled,*resize,*scroll,*storage,*unhandledrejection,*unload,rows',
	    'hr^[HTMLElement]|align,color,!noShade,size,width',
	    'head^[HTMLElement]|',
	    'h1,h2,h3,h4,h5,h6^[HTMLElement]|align',
	    'html^[HTMLElement]|version',
	    'iframe^[HTMLElement]|align,!allowFullscreen,frameBorder,height,longDesc,marginHeight,marginWidth,name,referrerPolicy,%sandbox,scrolling,src,srcdoc,width',
	    'img^[HTMLElement]|align,alt,border,%crossOrigin,#height,#hspace,!isMap,longDesc,lowsrc,name,referrerPolicy,sizes,src,srcset,useMap,#vspace,#width',
	    'input^[HTMLElement]|accept,align,alt,autocapitalize,autocomplete,!autofocus,!checked,!defaultChecked,defaultValue,dirName,!disabled,%files,formAction,formEnctype,formMethod,!formNoValidate,formTarget,#height,!incremental,!indeterminate,max,#maxLength,min,#minLength,!multiple,name,pattern,placeholder,!readOnly,!required,selectionDirection,#selectionEnd,#selectionStart,#size,src,step,type,useMap,value,%valueAsDate,#valueAsNumber,#width',
	    'li^[HTMLElement]|type,#value',
	    'label^[HTMLElement]|htmlFor',
	    'legend^[HTMLElement]|align',
	    'link^[HTMLElement]|as,charset,%crossOrigin,!disabled,href,hreflang,integrity,media,referrerPolicy,rel,%relList,rev,%sizes,target,type',
	    'map^[HTMLElement]|name',
	    'marquee^[HTMLElement]|behavior,bgColor,direction,height,#hspace,#loop,#scrollAmount,#scrollDelay,!trueSpeed,#vspace,width',
	    'menu^[HTMLElement]|!compact',
	    'meta^[HTMLElement]|content,httpEquiv,name,scheme',
	    'meter^[HTMLElement]|#high,#low,#max,#min,#optimum,#value',
	    'ins,del^[HTMLElement]|cite,dateTime',
	    'ol^[HTMLElement]|!compact,!reversed,#start,type',
	    'object^[HTMLElement]|align,archive,border,code,codeBase,codeType,data,!declare,height,#hspace,name,standby,type,useMap,#vspace,width',
	    'optgroup^[HTMLElement]|!disabled,label',
	    'option^[HTMLElement]|!defaultSelected,!disabled,label,!selected,text,value',
	    'output^[HTMLElement]|defaultValue,%htmlFor,name,value',
	    'p^[HTMLElement]|align',
	    'param^[HTMLElement]|name,type,value,valueType',
	    'picture^[HTMLElement]|',
	    'pre^[HTMLElement]|#width',
	    'progress^[HTMLElement]|#max,#value',
	    'q,blockquote,cite^[HTMLElement]|',
	    'script^[HTMLElement]|!async,charset,%crossOrigin,!defer,event,htmlFor,integrity,src,text,type',
	    'select^[HTMLElement]|!autofocus,!disabled,#length,!multiple,name,!required,#selectedIndex,#size,value',
	    'shadow^[HTMLElement]|',
	    'slot^[HTMLElement]|name',
	    'source^[HTMLElement]|media,sizes,src,srcset,type',
	    'span^[HTMLElement]|',
	    'style^[HTMLElement]|!disabled,media,type',
	    'caption^[HTMLElement]|align',
	    'th,td^[HTMLElement]|abbr,align,axis,bgColor,ch,chOff,#colSpan,headers,height,!noWrap,#rowSpan,scope,vAlign,width',
	    'col,colgroup^[HTMLElement]|align,ch,chOff,#span,vAlign,width',
	    'table^[HTMLElement]|align,bgColor,border,%caption,cellPadding,cellSpacing,frame,rules,summary,%tFoot,%tHead,width',
	    'tr^[HTMLElement]|align,bgColor,ch,chOff,vAlign',
	    'tfoot,thead,tbody^[HTMLElement]|align,ch,chOff,vAlign',
	    'template^[HTMLElement]|',
	    'textarea^[HTMLElement]|autocapitalize,!autofocus,#cols,defaultValue,dirName,!disabled,#maxLength,#minLength,name,placeholder,!readOnly,!required,#rows,selectionDirection,#selectionEnd,#selectionStart,value,wrap',
	    'title^[HTMLElement]|text',
	    'track^[HTMLElement]|!default,kind,label,src,srclang',
	    'ul^[HTMLElement]|!compact,type',
	    'unknown^[HTMLElement]|',
	    'video^media|#height,poster,#width',
	    ':svg:a^:svg:graphics|',
	    ':svg:animate^:svg:animation|',
	    ':svg:animateMotion^:svg:animation|',
	    ':svg:animateTransform^:svg:animation|',
	    ':svg:circle^:svg:geometry|',
	    ':svg:clipPath^:svg:graphics|',
	    ':svg:defs^:svg:graphics|',
	    ':svg:desc^:svg:|',
	    ':svg:discard^:svg:|',
	    ':svg:ellipse^:svg:geometry|',
	    ':svg:feBlend^:svg:|',
	    ':svg:feColorMatrix^:svg:|',
	    ':svg:feComponentTransfer^:svg:|',
	    ':svg:feComposite^:svg:|',
	    ':svg:feConvolveMatrix^:svg:|',
	    ':svg:feDiffuseLighting^:svg:|',
	    ':svg:feDisplacementMap^:svg:|',
	    ':svg:feDistantLight^:svg:|',
	    ':svg:feDropShadow^:svg:|',
	    ':svg:feFlood^:svg:|',
	    ':svg:feFuncA^:svg:componentTransferFunction|',
	    ':svg:feFuncB^:svg:componentTransferFunction|',
	    ':svg:feFuncG^:svg:componentTransferFunction|',
	    ':svg:feFuncR^:svg:componentTransferFunction|',
	    ':svg:feGaussianBlur^:svg:|',
	    ':svg:feImage^:svg:|',
	    ':svg:feMerge^:svg:|',
	    ':svg:feMergeNode^:svg:|',
	    ':svg:feMorphology^:svg:|',
	    ':svg:feOffset^:svg:|',
	    ':svg:fePointLight^:svg:|',
	    ':svg:feSpecularLighting^:svg:|',
	    ':svg:feSpotLight^:svg:|',
	    ':svg:feTile^:svg:|',
	    ':svg:feTurbulence^:svg:|',
	    ':svg:filter^:svg:|',
	    ':svg:foreignObject^:svg:graphics|',
	    ':svg:g^:svg:graphics|',
	    ':svg:image^:svg:graphics|',
	    ':svg:line^:svg:geometry|',
	    ':svg:linearGradient^:svg:gradient|',
	    ':svg:mpath^:svg:|',
	    ':svg:marker^:svg:|',
	    ':svg:mask^:svg:|',
	    ':svg:metadata^:svg:|',
	    ':svg:path^:svg:geometry|',
	    ':svg:pattern^:svg:|',
	    ':svg:polygon^:svg:geometry|',
	    ':svg:polyline^:svg:geometry|',
	    ':svg:radialGradient^:svg:gradient|',
	    ':svg:rect^:svg:geometry|',
	    ':svg:svg^:svg:graphics|#currentScale,#zoomAndPan',
	    ':svg:script^:svg:|type',
	    ':svg:set^:svg:animation|',
	    ':svg:stop^:svg:|',
	    ':svg:style^:svg:|!disabled,media,title,type',
	    ':svg:switch^:svg:graphics|',
	    ':svg:symbol^:svg:|',
	    ':svg:tspan^:svg:textPositioning|',
	    ':svg:text^:svg:textPositioning|',
	    ':svg:textPath^:svg:textContent|',
	    ':svg:title^:svg:|',
	    ':svg:use^:svg:graphics|',
	    ':svg:view^:svg:|#zoomAndPan',
	    'data^[HTMLElement]|value',
	    'keygen^[HTMLElement]|!autofocus,challenge,!disabled,form,keytype,name',
	    'menuitem^[HTMLElement]|type,label,icon,!disabled,!checked,radiogroup,!default',
	    'summary^[HTMLElement]|',
	    'time^[HTMLElement]|dateTime',
	    ':svg:cursor^:svg:|',
	];
	var _ATTR_TO_PROP = {
	    'class': 'className',
	    'for': 'htmlFor',
	    'formaction': 'formAction',
	    'innerHtml': 'innerHTML',
	    'readonly': 'readOnly',
	    'tabindex': 'tabIndex',
	};
	var DomElementSchemaRegistry = /** @class */ (function (_super) {
	    __extends(DomElementSchemaRegistry, _super);
	    function DomElementSchemaRegistry() {
	        var _this = _super.call(this) || this;
	        _this._schema = {};
	        SCHEMA.forEach(function (encodedType) {
	            var /** @type {?} */ type = {};
	            var _a = encodedType.split('|'), strType = _a[0], strProperties = _a[1];
	            var /** @type {?} */ properties = strProperties.split(',');
	            var _b = strType.split('^'), typeNames = _b[0], superName = _b[1];
	            typeNames.split(',').forEach(function (tag) { return _this._schema[tag.toLowerCase()] = type; });
	            var /** @type {?} */ superType = superName && _this._schema[superName.toLowerCase()];
	            if (superType) {
	                Object.keys(superType).forEach(function (prop) { type[prop] = superType[prop]; });
	            }
	            properties.forEach(function (property) {
	                if (property.length > 0) {
	                    switch (property[0]) {
	                        case '*':
	                            // We don't yet support events.
	                            // If ever allowing to bind to events, GO THROUGH A SECURITY REVIEW, allowing events
	                            // will
	                            // almost certainly introduce bad XSS vulnerabilities.
	                            // type[property.substring(1)] = EVENT;
	                            break;
	                        case '!':
	                            type[property.substring(1)] = BOOLEAN;
	                            break;
	                        case '#':
	                            type[property.substring(1)] = NUMBER;
	                            break;
	                        case '%':
	                            type[property.substring(1)] = OBJECT;
	                            break;
	                        default:
	                            type[property] = STRING;
	                    }
	                }
	            });
	        });
	        return _this;
	    }
	    /**
	     * @param {?} tagName
	     * @param {?} propName
	     * @param {?} schemaMetas
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.hasProperty = /**
	     * @param {?} tagName
	     * @param {?} propName
	     * @param {?} schemaMetas
	     * @return {?}
	     */
	    function (tagName, propName, schemaMetas) {
	        if (schemaMetas.some(function (schema) { return schema.name === NO_ERRORS_SCHEMA.name; })) {
	            return true;
	        }
	        if (tagName.indexOf('-') > -1) {
	            if (isNgContainer(tagName) || isNgContent(tagName)) {
	                return false;
	            }
	            if (schemaMetas.some(function (schema) { return schema.name === CUSTOM_ELEMENTS_SCHEMA.name; })) {
	                // Can't tell now as we don't know which properties a custom element will get
	                // once it is instantiated
	                return true;
	            }
	        }
	        var /** @type {?} */ elementProperties = this._schema[tagName.toLowerCase()] || this._schema['unknown'];
	        return !!elementProperties[propName];
	    };
	    /**
	     * @param {?} tagName
	     * @param {?} schemaMetas
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.hasElement = /**
	     * @param {?} tagName
	     * @param {?} schemaMetas
	     * @return {?}
	     */
	    function (tagName, schemaMetas) {
	        if (schemaMetas.some(function (schema) { return schema.name === NO_ERRORS_SCHEMA.name; })) {
	            return true;
	        }
	        if (tagName.indexOf('-') > -1) {
	            if (isNgContainer(tagName) || isNgContent(tagName)) {
	                return true;
	            }
	            if (schemaMetas.some(function (schema) { return schema.name === CUSTOM_ELEMENTS_SCHEMA.name; })) {
	                // Allow any custom elements
	                return true;
	            }
	        }
	        return !!this._schema[tagName.toLowerCase()];
	    };
	    /**
	     * securityContext returns the security context for the given property on the given DOM tag.
	     *
	     * Tag and property name are statically known and cannot change at runtime, i.e. it is not
	     * possible to bind a value into a changing attribute or tag name.
	     *
	     * The filtering is white list based. All attributes in the schema above are assumed to have the
	     * 'NONE' security context, i.e. that they are safe inert string values. Only specific well known
	     * attack vectors are assigned their appropriate context.
	     */
	    /**
	     * securityContext returns the security context for the given property on the given DOM tag.
	     *
	     * Tag and property name are statically known and cannot change at runtime, i.e. it is not
	     * possible to bind a value into a changing attribute or tag name.
	     *
	     * The filtering is white list based. All attributes in the schema above are assumed to have the
	     * 'NONE' security context, i.e. that they are safe inert string values. Only specific well known
	     * attack vectors are assigned their appropriate context.
	     * @param {?} tagName
	     * @param {?} propName
	     * @param {?} isAttribute
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.securityContext = /**
	     * securityContext returns the security context for the given property on the given DOM tag.
	     *
	     * Tag and property name are statically known and cannot change at runtime, i.e. it is not
	     * possible to bind a value into a changing attribute or tag name.
	     *
	     * The filtering is white list based. All attributes in the schema above are assumed to have the
	     * 'NONE' security context, i.e. that they are safe inert string values. Only specific well known
	     * attack vectors are assigned their appropriate context.
	     * @param {?} tagName
	     * @param {?} propName
	     * @param {?} isAttribute
	     * @return {?}
	     */
	    function (tagName, propName, isAttribute) {
	        if (isAttribute) {
	            // NB: For security purposes, use the mapped property name, not the attribute name.
	            propName = this.getMappedPropName(propName);
	        }
	        // Make sure comparisons are case insensitive, so that case differences between attribute and
	        // property names do not have a security impact.
	        tagName = tagName.toLowerCase();
	        propName = propName.toLowerCase();
	        var /** @type {?} */ ctx = SECURITY_SCHEMA[tagName + '|' + propName];
	        if (ctx) {
	            return ctx;
	        }
	        ctx = SECURITY_SCHEMA['*|' + propName];
	        return ctx ? ctx : SecurityContext.NONE;
	    };
	    /**
	     * @param {?} propName
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.getMappedPropName = /**
	     * @param {?} propName
	     * @return {?}
	     */
	    function (propName) { return _ATTR_TO_PROP[propName] || propName; };
	    /**
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.getDefaultComponentElementName = /**
	     * @return {?}
	     */
	    function () { return 'ng-component'; };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.validateProperty = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (name.toLowerCase().startsWith('on')) {
	            var /** @type {?} */ msg = "Binding to event property '" + name + "' is disallowed for security reasons, " +
	                ("please use (" + name.slice(2) + ")=...") +
	                ("\nIf '" + name + "' is a directive input, make sure the directive is imported by the") +
	                " current module.";
	            return { error: true, msg: msg };
	        }
	        else {
	            return { error: false };
	        }
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.validateAttribute = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (name.toLowerCase().startsWith('on')) {
	            var /** @type {?} */ msg = "Binding to event attribute '" + name + "' is disallowed for security reasons, " +
	                ("please use (" + name.slice(2) + ")=...");
	            return { error: true, msg: msg };
	        }
	        else {
	            return { error: false };
	        }
	    };
	    /**
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.allKnownElementNames = /**
	     * @return {?}
	     */
	    function () { return Object.keys(this._schema); };
	    /**
	     * @param {?} propName
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.normalizeAnimationStyleProperty = /**
	     * @param {?} propName
	     * @return {?}
	     */
	    function (propName) {
	        return dashCaseToCamelCase(propName);
	    };
	    /**
	     * @param {?} camelCaseProp
	     * @param {?} userProvidedProp
	     * @param {?} val
	     * @return {?}
	     */
	    DomElementSchemaRegistry.prototype.normalizeAnimationStyleValue = /**
	     * @param {?} camelCaseProp
	     * @param {?} userProvidedProp
	     * @param {?} val
	     * @return {?}
	     */
	    function (camelCaseProp, userProvidedProp, val) {
	        var /** @type {?} */ unit = '';
	        var /** @type {?} */ strVal = val.toString().trim();
	        var /** @type {?} */ errorMsg = /** @type {?} */ ((null));
	        if (_isPixelDimensionStyle(camelCaseProp) && val !== 0 && val !== '0') {
	            if (typeof val === 'number') {
	                unit = 'px';
	            }
	            else {
	                var /** @type {?} */ valAndSuffixMatch = val.match(/^[+-]?[\d\.]+([a-z]*)$/);
	                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
	                    errorMsg = "Please provide a CSS unit value for " + userProvidedProp + ":" + val;
	                }
	            }
	        }
	        return { error: errorMsg, value: strVal + unit };
	    };
	    return DomElementSchemaRegistry;
	}(ElementSchemaRegistry));
	/**
	 * @param {?} prop
	 * @return {?}
	 */
	function _isPixelDimensionStyle(prop) {
	    switch (prop) {
	        case 'width':
	        case 'height':
	        case 'minWidth':
	        case 'minHeight':
	        case 'maxWidth':
	        case 'maxHeight':
	        case 'left':
	        case 'top':
	        case 'bottom':
	        case 'right':
	        case 'fontSize':
	        case 'outlineWidth':
	        case 'outlineOffset':
	        case 'paddingTop':
	        case 'paddingLeft':
	        case 'paddingBottom':
	        case 'paddingRight':
	        case 'marginTop':
	        case 'marginLeft':
	        case 'marginBottom':
	        case 'marginRight':
	        case 'borderRadius':
	        case 'borderWidth':
	        case 'borderTopWidth':
	        case 'borderLeftWidth':
	        case 'borderRightWidth':
	        case 'borderBottomWidth':
	        case 'textIndent':
	            return true;
	        default:
	            return false;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * This file is a port of shadowCSS from webcomponents.js to TypeScript.
	 *
	 * Please make sure to keep to edits in sync with the source file.
	 *
	 * Source:
	 * https://github.com/webcomponents/webcomponentsjs/blob/4efecd7e0e/src/ShadowCSS/ShadowCSS.js
	 *
	 * The original file level comment is reproduced below
	 */
	/*
	  This is a limited shim for ShadowDOM css styling.
	  https://dvcs.w3.org/hg/webcomponents/raw-file/tip/spec/shadow/index.html#styles
	
	  The intention here is to support only the styling features which can be
	  relatively simply implemented. The goal is to allow users to avoid the
	  most obvious pitfalls and do so without compromising performance significantly.
	  For ShadowDOM styling that's not covered here, a set of best practices
	  can be provided that should allow users to accomplish more complex styling.
	
	  The following is a list of specific ShadowDOM styling features and a brief
	  discussion of the approach used to shim.
	
	  Shimmed features:
	
	  * :host, :host-context: ShadowDOM allows styling of the shadowRoot's host
	  element using the :host rule. To shim this feature, the :host styles are
	  reformatted and prefixed with a given scope name and promoted to a
	  document level stylesheet.
	  For example, given a scope name of .foo, a rule like this:
	
	    :host {
	        background: red;
	      }
	    }
	
	  becomes:
	
	    .foo {
	      background: red;
	    }
	
	  * encapsulation: Styles defined within ShadowDOM, apply only to
	  dom inside the ShadowDOM. Polymer uses one of two techniques to implement
	  this feature.
	
	  By default, rules are prefixed with the host element tag name
	  as a descendant selector. This ensures styling does not leak out of the 'top'
	  of the element's ShadowDOM. For example,
	
	  div {
	      font-weight: bold;
	    }
	
	  becomes:
	
	  x-foo div {
	      font-weight: bold;
	    }
	
	  becomes:
	
	
	  Alternatively, if WebComponents.ShadowCSS.strictStyling is set to true then
	  selectors are scoped by adding an attribute selector suffix to each
	  simple selector that contains the host element tag name. Each element
	  in the element's ShadowDOM template is also given the scope attribute.
	  Thus, these rules match only elements that have the scope attribute.
	  For example, given a scope name of x-foo, a rule like this:
	
	    div {
	      font-weight: bold;
	    }
	
	  becomes:
	
	    div[x-foo] {
	      font-weight: bold;
	    }
	
	  Note that elements that are dynamically added to a scope must have the scope
	  selector added to them manually.
	
	  * upper/lower bound encapsulation: Styles which are defined outside a
	  shadowRoot should not cross the ShadowDOM boundary and should not apply
	  inside a shadowRoot.
	
	  This styling behavior is not emulated. Some possible ways to do this that
	  were rejected due to complexity and/or performance concerns include: (1) reset
	  every possible property for every possible selector for a given scope name;
	  (2) re-implement css in javascript.
	
	  As an alternative, users should make sure to use selectors
	  specific to the scope in which they are working.
	
	  * ::distributed: This behavior is not emulated. It's often not necessary
	  to style the contents of a specific insertion point and instead, descendants
	  of the host element can be styled selectively. Users can also create an
	  extra node around an insertion point and style that node's contents
	  via descendent selectors. For example, with a shadowRoot like this:
	
	    <style>
	      ::content(div) {
	        background: red;
	      }
	    </style>
	    <content></content>
	
	  could become:
	
	    <style>
	      / *@polyfill .content-container div * /
	      ::content(div) {
	        background: red;
	      }
	    </style>
	    <div class="content-container">
	      <content></content>
	    </div>
	
	  Note the use of @polyfill in the comment above a ShadowDOM specific style
	  declaration. This is a directive to the styling shim to use the selector
	  in comments in lieu of the next selector when running under polyfill.
	*/
	var ShadowCss = /** @class */ (function () {
	    function ShadowCss() {
	        this.strictStyling = true;
	    }
	    /*
	    * Shim some cssText with the given selector. Returns cssText that can
	    * be included in the document via WebComponents.ShadowCSS.addCssToDocument(css).
	    *
	    * When strictStyling is true:
	    * - selector is the attribute added to all elements inside the host,
	    * - hostSelector is the attribute added to the host itself.
	    */
	    /**
	     * @param {?} cssText
	     * @param {?} selector
	     * @param {?=} hostSelector
	     * @return {?}
	     */
	    ShadowCss.prototype.shimCssText = /**
	     * @param {?} cssText
	     * @param {?} selector
	     * @param {?=} hostSelector
	     * @return {?}
	     */
	    function (cssText, selector, hostSelector) {
	        if (hostSelector === void 0) { hostSelector = ''; }
	        var /** @type {?} */ commentsWithHash = extractCommentsWithHash(cssText);
	        cssText = stripComments(cssText);
	        cssText = this._insertDirectives(cssText);
	        var /** @type {?} */ scopedCssText = this._scopeCssText(cssText, selector, hostSelector);
	        return [scopedCssText].concat(commentsWithHash).join('\n');
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._insertDirectives = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        cssText = this._insertPolyfillDirectivesInCssText(cssText);
	        return this._insertPolyfillRulesInCssText(cssText);
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._insertPolyfillDirectivesInCssText = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        // Difference with webcomponents.js: does not handle comments
	        return cssText.replace(_cssContentNextSelectorRe, function () {
	            var m = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                m[_i] = arguments[_i];
	            }
	            return m[2] + '{';
	        });
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._insertPolyfillRulesInCssText = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        // Difference with webcomponents.js: does not handle comments
	        return cssText.replace(_cssContentRuleRe, function () {
	            var m = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                m[_i] = arguments[_i];
	            }
	            var /** @type {?} */ rule = m[0].replace(m[1], '').replace(m[2], '');
	            return m[4] + rule;
	        });
	    };
	    /**
	     * @param {?} cssText
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._scopeCssText = /**
	     * @param {?} cssText
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    function (cssText, scopeSelector, hostSelector) {
	        var /** @type {?} */ unscopedRules = this._extractUnscopedRulesFromCssText(cssText);
	        // replace :host and :host-context -shadowcsshost and -shadowcsshost respectively
	        cssText = this._insertPolyfillHostInCssText(cssText);
	        cssText = this._convertColonHost(cssText);
	        cssText = this._convertColonHostContext(cssText);
	        cssText = this._convertShadowDOMSelectors(cssText);
	        if (scopeSelector) {
	            cssText = this._scopeSelectors(cssText, scopeSelector, hostSelector);
	        }
	        cssText = cssText + '\n' + unscopedRules;
	        return cssText.trim();
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._extractUnscopedRulesFromCssText = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        // Difference with webcomponents.js: does not handle comments
	        var /** @type {?} */ r = '';
	        var /** @type {?} */ m;
	        _cssContentUnscopedRuleRe.lastIndex = 0;
	        while ((m = _cssContentUnscopedRuleRe.exec(cssText)) !== null) {
	            var /** @type {?} */ rule = m[0].replace(m[2], '').replace(m[1], m[4]);
	            r += rule + '\n\n';
	        }
	        return r;
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._convertColonHost = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        return this._convertColonRule(cssText, _cssColonHostRe, this._colonHostPartReplacer);
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._convertColonHostContext = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        return this._convertColonRule(cssText, _cssColonHostContextRe, this._colonHostContextPartReplacer);
	    };
	    /**
	     * @param {?} cssText
	     * @param {?} regExp
	     * @param {?} partReplacer
	     * @return {?}
	     */
	    ShadowCss.prototype._convertColonRule = /**
	     * @param {?} cssText
	     * @param {?} regExp
	     * @param {?} partReplacer
	     * @return {?}
	     */
	    function (cssText, regExp, partReplacer) {
	        // m[1] = :host(-context), m[2] = contents of (), m[3] rest of rule
	        return cssText.replace(regExp, function () {
	            var m = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                m[_i] = arguments[_i];
	            }
	            if (m[2]) {
	                var /** @type {?} */ parts = m[2].split(',');
	                var /** @type {?} */ r = [];
	                for (var /** @type {?} */ i = 0; i < parts.length; i++) {
	                    var /** @type {?} */ p = parts[i].trim();
	                    if (!p)
	                        break;
	                    r.push(partReplacer(_polyfillHostNoCombinator, p, m[3]));
	                }
	                return r.join(',');
	            }
	            else {
	                return _polyfillHostNoCombinator + m[3];
	            }
	        });
	    };
	    /**
	     * @param {?} host
	     * @param {?} part
	     * @param {?} suffix
	     * @return {?}
	     */
	    ShadowCss.prototype._colonHostContextPartReplacer = /**
	     * @param {?} host
	     * @param {?} part
	     * @param {?} suffix
	     * @return {?}
	     */
	    function (host, part, suffix) {
	        if (part.indexOf(_polyfillHost) > -1) {
	            return this._colonHostPartReplacer(host, part, suffix);
	        }
	        else {
	            return host + part + suffix + ', ' + part + ' ' + host + suffix;
	        }
	    };
	    /**
	     * @param {?} host
	     * @param {?} part
	     * @param {?} suffix
	     * @return {?}
	     */
	    ShadowCss.prototype._colonHostPartReplacer = /**
	     * @param {?} host
	     * @param {?} part
	     * @param {?} suffix
	     * @return {?}
	     */
	    function (host, part, suffix) {
	        return host + part.replace(_polyfillHost, '') + suffix;
	    };
	    /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    ShadowCss.prototype._convertShadowDOMSelectors = /**
	     * @param {?} cssText
	     * @return {?}
	     */
	    function (cssText) {
	        return _shadowDOMSelectorsRe.reduce(function (result, pattern) { return result.replace(pattern, ' '); }, cssText);
	    };
	    /**
	     * @param {?} cssText
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._scopeSelectors = /**
	     * @param {?} cssText
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    function (cssText, scopeSelector, hostSelector) {
	        var _this = this;
	        return processRules(cssText, function (rule) {
	            var /** @type {?} */ selector = rule.selector;
	            var /** @type {?} */ content = rule.content;
	            if (rule.selector[0] != '@') {
	                selector =
	                    _this._scopeSelector(rule.selector, scopeSelector, hostSelector, _this.strictStyling);
	            }
	            else if (rule.selector.startsWith('@media') || rule.selector.startsWith('@supports') ||
	                rule.selector.startsWith('@page') || rule.selector.startsWith('@document')) {
	                content = _this._scopeSelectors(rule.content, scopeSelector, hostSelector);
	            }
	            return new CssRule(selector, content);
	        });
	    };
	    /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @param {?} strict
	     * @return {?}
	     */
	    ShadowCss.prototype._scopeSelector = /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @param {?} strict
	     * @return {?}
	     */
	    function (selector, scopeSelector, hostSelector, strict) {
	        var _this = this;
	        return selector.split(',')
	            .map(function (part) { return part.trim().split(_shadowDeepSelectors); })
	            .map(function (deepParts) {
	            var shallowPart = deepParts[0], otherParts = deepParts.slice(1);
	            var /** @type {?} */ applyScope = function (shallowPart) {
	                if (_this._selectorNeedsScoping(shallowPart, scopeSelector)) {
	                    return strict ?
	                        _this._applyStrictSelectorScope(shallowPart, scopeSelector, hostSelector) :
	                        _this._applySelectorScope(shallowPart, scopeSelector, hostSelector);
	                }
	                else {
	                    return shallowPart;
	                }
	            };
	            return [applyScope(shallowPart)].concat(otherParts).join(' ');
	        })
	            .join(', ');
	    };
	    /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._selectorNeedsScoping = /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @return {?}
	     */
	    function (selector, scopeSelector) {
	        var /** @type {?} */ re = this._makeScopeMatcher(scopeSelector);
	        return !re.test(selector);
	    };
	    /**
	     * @param {?} scopeSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._makeScopeMatcher = /**
	     * @param {?} scopeSelector
	     * @return {?}
	     */
	    function (scopeSelector) {
	        var /** @type {?} */ lre = /\[/g;
	        var /** @type {?} */ rre = /\]/g;
	        scopeSelector = scopeSelector.replace(lre, '\\[').replace(rre, '\\]');
	        return new RegExp('^(' + scopeSelector + ')' + _selectorReSuffix, 'm');
	    };
	    /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._applySelectorScope = /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    function (selector, scopeSelector, hostSelector) {
	        // Difference from webcomponents.js: scopeSelector could not be an array
	        return this._applySimpleSelectorScope(selector, scopeSelector, hostSelector);
	    };
	    /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._applySimpleSelectorScope = /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    function (selector, scopeSelector, hostSelector) {
	        // In Android browser, the lastIndex is not reset when the regex is used in String.replace()
	        _polyfillHostRe.lastIndex = 0;
	        if (_polyfillHostRe.test(selector)) {
	            var /** @type {?} */ replaceBy_1 = this.strictStyling ? "[" + hostSelector + "]" : scopeSelector;
	            return selector
	                .replace(_polyfillHostNoCombinatorRe, function (hnc, selector) {
	                return selector.replace(/([^:]*)(:*)(.*)/, function (_, before, colon, after) {
	                    return before + replaceBy_1 + colon + after;
	                });
	            })
	                .replace(_polyfillHostRe, replaceBy_1 + ' ');
	        }
	        return scopeSelector + ' ' + selector;
	    };
	    /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    ShadowCss.prototype._applyStrictSelectorScope = /**
	     * @param {?} selector
	     * @param {?} scopeSelector
	     * @param {?} hostSelector
	     * @return {?}
	     */
	    function (selector, scopeSelector, hostSelector) {
	        var _this = this;
	        var /** @type {?} */ isRe = /\[is=([^\]]*)\]/g;
	        scopeSelector = scopeSelector.replace(isRe, function (_) {
	            var parts = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                parts[_i - 1] = arguments[_i];
	            }
	            return parts[0];
	        });
	        var /** @type {?} */ attrName = '[' + scopeSelector + ']';
	        var /** @type {?} */ _scopeSelectorPart = function (p) {
	            var /** @type {?} */ scopedP = p.trim();
	            if (!scopedP) {
	                return '';
	            }
	            if (p.indexOf(_polyfillHostNoCombinator) > -1) {
	                scopedP = _this._applySimpleSelectorScope(p, scopeSelector, hostSelector);
	            }
	            else {
	                // remove :host since it should be unnecessary
	                var /** @type {?} */ t = p.replace(_polyfillHostRe, '');
	                if (t.length > 0) {
	                    var /** @type {?} */ matches = t.match(/([^:]*)(:*)(.*)/);
	                    if (matches) {
	                        scopedP = matches[1] + attrName + matches[2] + matches[3];
	                    }
	                }
	            }
	            return scopedP;
	        };
	        var /** @type {?} */ safeContent = new SafeSelector(selector);
	        selector = safeContent.content();
	        var /** @type {?} */ scopedSelector = '';
	        var /** @type {?} */ startIndex = 0;
	        var /** @type {?} */ res;
	        var /** @type {?} */ sep = /( |>|\+|~(?!=))\s*/g;
	        // If a selector appears before :host it should not be shimmed as it
	        // matches on ancestor elements and not on elements in the host's shadow
	        // `:host-context(div)` is transformed to
	        // `-shadowcsshost-no-combinatordiv, div -shadowcsshost-no-combinator`
	        // the `div` is not part of the component in the 2nd selectors and should not be scoped.
	        // Historically `component-tag:host` was matching the component so we also want to preserve
	        // this behavior to avoid breaking legacy apps (it should not match).
	        // The behavior should be:
	        // - `tag:host` -> `tag[h]` (this is to avoid breaking legacy apps, should not match anything)
	        // - `tag :host` -> `tag [h]` (`tag` is not scoped because it's considered part of a
	        //   `:host-context(tag)`)
	        var /** @type {?} */ hasHost = selector.indexOf(_polyfillHostNoCombinator) > -1;
	        // Only scope parts after the first `-shadowcsshost-no-combinator` when it is present
	        var /** @type {?} */ shouldScope = !hasHost;
	        while ((res = sep.exec(selector)) !== null) {
	            var /** @type {?} */ separator = res[1];
	            var /** @type {?} */ part_1 = selector.slice(startIndex, res.index).trim();
	            shouldScope = shouldScope || part_1.indexOf(_polyfillHostNoCombinator) > -1;
	            var /** @type {?} */ scopedPart = shouldScope ? _scopeSelectorPart(part_1) : part_1;
	            scopedSelector += scopedPart + " " + separator + " ";
	            startIndex = sep.lastIndex;
	        }
	        var /** @type {?} */ part = selector.substring(startIndex);
	        shouldScope = shouldScope || part.indexOf(_polyfillHostNoCombinator) > -1;
	        scopedSelector += shouldScope ? _scopeSelectorPart(part) : part;
	        // replace the placeholders with their original values
	        return safeContent.restore(scopedSelector);
	    };
	    /**
	     * @param {?} selector
	     * @return {?}
	     */
	    ShadowCss.prototype._insertPolyfillHostInCssText = /**
	     * @param {?} selector
	     * @return {?}
	     */
	    function (selector) {
	        return selector.replace(_colonHostContextRe, _polyfillHostContext)
	            .replace(_colonHostRe, _polyfillHost);
	    };
	    return ShadowCss;
	}());
	var SafeSelector = /** @class */ (function () {
	    function SafeSelector(selector) {
	        var _this = this;
	        this.placeholders = [];
	        this.index = 0;
	        // Replaces attribute selectors with placeholders.
	        // The WS in [attr="va lue"] would otherwise be interpreted as a selector separator.
	        selector = selector.replace(/(\[[^\]]*\])/g, function (_, keep) {
	            var /** @type {?} */ replaceBy = "__ph-" + _this.index + "__";
	            _this.placeholders.push(keep);
	            _this.index++;
	            return replaceBy;
	        });
	        // Replaces the expression in `:nth-child(2n + 1)` with a placeholder.
	        // WS and "+" would otherwise be interpreted as selector separators.
	        this._content = selector.replace(/(:nth-[-\w]+)(\([^)]+\))/g, function (_, pseudo, exp) {
	            var /** @type {?} */ replaceBy = "__ph-" + _this.index + "__";
	            _this.placeholders.push(exp);
	            _this.index++;
	            return pseudo + replaceBy;
	        });
	    }
	    /**
	     * @param {?} content
	     * @return {?}
	     */
	    SafeSelector.prototype.restore = /**
	     * @param {?} content
	     * @return {?}
	     */
	    function (content) {
	        var _this = this;
	        return content.replace(/__ph-(\d+)__/g, function (ph, index) { return _this.placeholders[+index]; });
	    };
	    /**
	     * @return {?}
	     */
	    SafeSelector.prototype.content = /**
	     * @return {?}
	     */
	    function () { return this._content; };
	    return SafeSelector;
	}());
	var _cssContentNextSelectorRe = /polyfill-next-selector[^}]*content:[\s]*?(['"])(.*?)\1[;\s]*}([^{]*?){/gim;
	var _cssContentRuleRe = /(polyfill-rule)[^}]*(content:[\s]*(['"])(.*?)\3)[;\s]*[^}]*}/gim;
	var _cssContentUnscopedRuleRe = /(polyfill-unscoped-rule)[^}]*(content:[\s]*(['"])(.*?)\3)[;\s]*[^}]*}/gim;
	var _polyfillHost = '-shadowcsshost';
	// note: :host-context pre-processed to -shadowcsshostcontext.
	var _polyfillHostContext = '-shadowcsscontext';
	var _parenSuffix = ')(?:\\((' +
	    '(?:\\([^)(]*\\)|[^)(]*)+?' +
	    ')\\))?([^,{]*)';
	var _cssColonHostRe = new RegExp('(' + _polyfillHost + _parenSuffix, 'gim');
	var _cssColonHostContextRe = new RegExp('(' + _polyfillHostContext + _parenSuffix, 'gim');
	var _polyfillHostNoCombinator = _polyfillHost + '-no-combinator';
	var _polyfillHostNoCombinatorRe = /-shadowcsshost-no-combinator([^\s]*)/;
	var _shadowDOMSelectorsRe = [
	    /::shadow/g,
	    /::content/g,
	    /\/shadow-deep\//g,
	    /\/shadow\//g,
	];
	// The deep combinator is deprecated in the CSS spec
	// Support for `>>>`, `deep`, `::ng-deep` is then also deprecated and will be removed in the future.
	// see https://github.com/angular/angular/pull/17677
	var _shadowDeepSelectors = /(?:>>>)|(?:\/deep\/)|(?:::ng-deep)/g;
	var _selectorReSuffix = '([>\\s~+\[.,{:][\\s\\S]*)?$';
	var _polyfillHostRe = /-shadowcsshost/gim;
	var _colonHostRe = /:host/gim;
	var _colonHostContextRe = /:host-context/gim;
	var _commentRe = /\/\*\s*[\s\S]*?\*\//g;
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function stripComments(input) {
	    return input.replace(_commentRe, '');
	}
	var _commentWithHashRe = /\/\*\s*#\s*source(Mapping)?URL=[\s\S]+?\*\//g;
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function extractCommentsWithHash(input) {
	    return input.match(_commentWithHashRe) || [];
	}
	var _ruleRe = /(\s*)([^;\{\}]+?)(\s*)((?:{%BLOCK%}?\s*;?)|(?:\s*;))/g;
	var _curlyRe = /([{}])/g;
	var OPEN_CURLY = '{';
	var CLOSE_CURLY = '}';
	var BLOCK_PLACEHOLDER = '%BLOCK%';
	var CssRule = /** @class */ (function () {
	    function CssRule(selector, content) {
	        this.selector = selector;
	        this.content = content;
	    }
	    return CssRule;
	}());
	/**
	 * @param {?} input
	 * @param {?} ruleCallback
	 * @return {?}
	 */
	function processRules(input, ruleCallback) {
	    var /** @type {?} */ inputWithEscapedBlocks = escapeBlocks(input);
	    var /** @type {?} */ nextBlockIndex = 0;
	    return inputWithEscapedBlocks.escapedString.replace(_ruleRe, function () {
	        var m = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            m[_i] = arguments[_i];
	        }
	        var /** @type {?} */ selector = m[2];
	        var /** @type {?} */ content = '';
	        var /** @type {?} */ suffix = m[4];
	        var /** @type {?} */ contentPrefix = '';
	        if (suffix && suffix.startsWith('{' + BLOCK_PLACEHOLDER)) {
	            content = inputWithEscapedBlocks.blocks[nextBlockIndex++];
	            suffix = suffix.substring(BLOCK_PLACEHOLDER.length + 1);
	            contentPrefix = '{';
	        }
	        var /** @type {?} */ rule = ruleCallback(new CssRule(selector, content));
	        return "" + m[1] + rule.selector + m[3] + contentPrefix + rule.content + suffix;
	    });
	}
	var StringWithEscapedBlocks = /** @class */ (function () {
	    function StringWithEscapedBlocks(escapedString, blocks) {
	        this.escapedString = escapedString;
	        this.blocks = blocks;
	    }
	    return StringWithEscapedBlocks;
	}());
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function escapeBlocks(input) {
	    var /** @type {?} */ inputParts = input.split(_curlyRe);
	    var /** @type {?} */ resultParts = [];
	    var /** @type {?} */ escapedBlocks = [];
	    var /** @type {?} */ bracketCount = 0;
	    var /** @type {?} */ currentBlockParts = [];
	    for (var /** @type {?} */ partIndex = 0; partIndex < inputParts.length; partIndex++) {
	        var /** @type {?} */ part = inputParts[partIndex];
	        if (part == CLOSE_CURLY) {
	            bracketCount--;
	        }
	        if (bracketCount > 0) {
	            currentBlockParts.push(part);
	        }
	        else {
	            if (currentBlockParts.length > 0) {
	                escapedBlocks.push(currentBlockParts.join(''));
	                resultParts.push(BLOCK_PLACEHOLDER);
	                currentBlockParts = [];
	            }
	            resultParts.push(part);
	        }
	        if (part == OPEN_CURLY) {
	            bracketCount++;
	        }
	    }
	    if (currentBlockParts.length > 0) {
	        escapedBlocks.push(currentBlockParts.join(''));
	        resultParts.push(BLOCK_PLACEHOLDER);
	    }
	    return new StringWithEscapedBlocks(resultParts.join(''), escapedBlocks);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var COMPONENT_VARIABLE = '%COMP%';
	var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
	var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
	var StylesCompileDependency = /** @class */ (function () {
	    function StylesCompileDependency(name, moduleUrl, setValue) {
	        this.name = name;
	        this.moduleUrl = moduleUrl;
	        this.setValue = setValue;
	    }
	    return StylesCompileDependency;
	}());
	var CompiledStylesheet = /** @class */ (function () {
	    function CompiledStylesheet(outputCtx, stylesVar, dependencies, isShimmed, meta) {
	        this.outputCtx = outputCtx;
	        this.stylesVar = stylesVar;
	        this.dependencies = dependencies;
	        this.isShimmed = isShimmed;
	        this.meta = meta;
	    }
	    return CompiledStylesheet;
	}());
	var StyleCompiler = /** @class */ (function () {
	    function StyleCompiler(_urlResolver) {
	        this._urlResolver = _urlResolver;
	        this._shadowCss = new ShadowCss();
	    }
	    /**
	     * @param {?} outputCtx
	     * @param {?} comp
	     * @return {?}
	     */
	    StyleCompiler.prototype.compileComponent = /**
	     * @param {?} outputCtx
	     * @param {?} comp
	     * @return {?}
	     */
	    function (outputCtx, comp) {
	        var /** @type {?} */ template = /** @type {?} */ ((comp.template));
	        return this._compileStyles(outputCtx, comp, new CompileStylesheetMetadata({
	            styles: template.styles,
	            styleUrls: template.styleUrls,
	            moduleUrl: identifierModuleUrl(comp.type)
	        }), this.needsStyleShim(comp), true);
	    };
	    /**
	     * @param {?} outputCtx
	     * @param {?} comp
	     * @param {?} stylesheet
	     * @param {?=} shim
	     * @return {?}
	     */
	    StyleCompiler.prototype.compileStyles = /**
	     * @param {?} outputCtx
	     * @param {?} comp
	     * @param {?} stylesheet
	     * @param {?=} shim
	     * @return {?}
	     */
	    function (outputCtx, comp, stylesheet, shim) {
	        if (shim === void 0) { shim = this.needsStyleShim(comp); }
	        return this._compileStyles(outputCtx, comp, stylesheet, shim, false);
	    };
	    /**
	     * @param {?} comp
	     * @return {?}
	     */
	    StyleCompiler.prototype.needsStyleShim = /**
	     * @param {?} comp
	     * @return {?}
	     */
	    function (comp) {
	        return /** @type {?} */ ((comp.template)).encapsulation === ViewEncapsulation.Emulated;
	    };
	    /**
	     * @param {?} outputCtx
	     * @param {?} comp
	     * @param {?} stylesheet
	     * @param {?} shim
	     * @param {?} isComponentStylesheet
	     * @return {?}
	     */
	    StyleCompiler.prototype._compileStyles = /**
	     * @param {?} outputCtx
	     * @param {?} comp
	     * @param {?} stylesheet
	     * @param {?} shim
	     * @param {?} isComponentStylesheet
	     * @return {?}
	     */
	    function (outputCtx, comp, stylesheet, shim, isComponentStylesheet) {
	        var _this = this;
	        var /** @type {?} */ styleExpressions = stylesheet.styles.map(function (plainStyle) { return literal(_this._shimIfNeeded(plainStyle, shim)); });
	        var /** @type {?} */ dependencies = [];
	        stylesheet.styleUrls.forEach(function (styleUrl) {
	            var /** @type {?} */ exprIndex = styleExpressions.length;
	            // Note: This placeholder will be filled later.
	            styleExpressions.push(/** @type {?} */ ((null)));
	            dependencies.push(new StylesCompileDependency(getStylesVarName(null), styleUrl, function (value) { return styleExpressions[exprIndex] = outputCtx.importExpr(value); }));
	        });
	        // styles variable contains plain strings and arrays of other styles arrays (recursive),
	        // so we set its type to dynamic.
	        var /** @type {?} */ stylesVar = getStylesVarName(isComponentStylesheet ? comp : null);
	        var /** @type {?} */ stmt = variable(stylesVar)
	            .set(literalArr(styleExpressions, new ArrayType(DYNAMIC_TYPE, [TypeModifier.Const])))
	            .toDeclStmt(null, isComponentStylesheet ? [StmtModifier.Final] : [
	            StmtModifier.Final, StmtModifier.Exported
	        ]);
	        outputCtx.statements.push(stmt);
	        return new CompiledStylesheet(outputCtx, stylesVar, dependencies, shim, stylesheet);
	    };
	    /**
	     * @param {?} style
	     * @param {?} shim
	     * @return {?}
	     */
	    StyleCompiler.prototype._shimIfNeeded = /**
	     * @param {?} style
	     * @param {?} shim
	     * @return {?}
	     */
	    function (style, shim) {
	        return shim ? this._shadowCss.shimCssText(style, CONTENT_ATTR, HOST_ATTR) : style;
	    };
	    return StyleCompiler;
	}());
	/**
	 * @param {?} component
	 * @return {?}
	 */
	function getStylesVarName(component) {
	    var /** @type {?} */ result = "styles";
	    if (component) {
	        result += "_" + identifierName(component.type);
	    }
	    return result;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var PRESERVE_WS_ATTR_NAME = 'ngPreserveWhitespaces';
	var SKIP_WS_TRIM_TAGS = new Set(['pre', 'template', 'textarea', 'script', 'style']);
	// Equivalent to \s with \u00a0 (non-breaking space) excluded.
	// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp
	var WS_CHARS = ' \f\n\r\t\v\u1680\u180e\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff';
	var NO_WS_REGEXP = new RegExp("[^" + WS_CHARS + "]");
	var WS_REPLACE_REGEXP = new RegExp("[" + WS_CHARS + "]{2,}", 'g');
	/**
	 * @param {?} attrs
	 * @return {?}
	 */
	function hasPreserveWhitespacesAttr(attrs) {
	    return attrs.some(function (attr) { return attr.name === PRESERVE_WS_ATTR_NAME; });
	}
	/**
	 * Angular Dart introduced &ngsp; as a placeholder for non-removable space, see:
	 * https://github.com/dart-lang/angular/blob/0bb611387d29d65b5af7f9d2515ab571fd3fbee4/_tests/test/compiler/preserve_whitespace_test.dart#L25-L32
	 * In Angular Dart &ngsp; is converted to the 0xE500 PUA (Private Use Areas) unicode character
	 * and later on replaced by a space. We are re-implementing the same idea here.
	 * @param {?} value
	 * @return {?}
	 */
	function replaceNgsp(value) {
	    // lexer is replacing the &ngsp; pseudo-entity with NGSP_UNICODE
	    return value.replace(new RegExp(NGSP_UNICODE, 'g'), ' ');
	}
	/**
	 * This visitor can walk HTML parse tree and remove / trim text nodes using the following rules:
	 * - consider spaces, tabs and new lines as whitespace characters;
	 * - drop text nodes consisting of whitespace characters only;
	 * - for all other text nodes replace consecutive whitespace characters with one space;
	 * - convert &ngsp; pseudo-entity to a single space;
	 *
	 * Removal and trimming of whitespaces have positive performance impact (less code to generate
	 * while compiling templates, faster view creation). At the same time it can be "destructive"
	 * in some cases (whitespaces can influence layout). Because of the potential of breaking layout
	 * this visitor is not activated by default in Angular 5 and people need to explicitly opt-in for
	 * whitespace removal. The default option for whitespace removal will be revisited in Angular 6
	 * and might be changed to "on" by default.
	 */
	var WhitespaceVisitor = /** @class */ (function () {
	    function WhitespaceVisitor() {
	    }
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    WhitespaceVisitor.prototype.visitElement = /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) {
	        if (SKIP_WS_TRIM_TAGS.has(element.name) || hasPreserveWhitespacesAttr(element.attrs)) {
	            // don't descent into elements where we need to preserve whitespaces
	            // but still visit all attributes to eliminate one used as a market to preserve WS
	            return new Element(element.name, visitAll(this, element.attrs), element.children, element.sourceSpan, element.startSourceSpan, element.endSourceSpan);
	        }
	        return new Element(element.name, element.attrs, visitAll(this, element.children), element.sourceSpan, element.startSourceSpan, element.endSourceSpan);
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    WhitespaceVisitor.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) {
	        return attribute.name !== PRESERVE_WS_ATTR_NAME ? attribute : null;
	    };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    WhitespaceVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) {
	        var /** @type {?} */ isNotBlank = text.value.match(NO_WS_REGEXP);
	        if (isNotBlank) {
	            return new Text(replaceNgsp(text.value).replace(WS_REPLACE_REGEXP, ' '), text.sourceSpan);
	        }
	        return null;
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    WhitespaceVisitor.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { return comment; };
	    /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    WhitespaceVisitor.prototype.visitExpansion = /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansion, context) { return expansion; };
	    /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    WhitespaceVisitor.prototype.visitExpansionCase = /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansionCase, context) { return expansionCase; };
	    return WhitespaceVisitor;
	}());
	/**
	 * @param {?} htmlAstWithErrors
	 * @return {?}
	 */
	function removeWhitespaces(htmlAstWithErrors) {
	    return new ParseTreeResult(visitAll(new WhitespaceVisitor(), htmlAstWithErrors.rootNodes), htmlAstWithErrors.errors);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// http://cldr.unicode.org/index/cldr-spec/plural-rules
	var PLURAL_CASES = ['zero', 'one', 'two', 'few', 'many', 'other'];
	/**
	 * Expands special forms into elements.
	 *
	 * For example,
	 *
	 * ```
	 * { messages.length, plural,
	 *   =0 {zero}
	 *   =1 {one}
	 *   other {more than one}
	 * }
	 * ```
	 *
	 * will be expanded into
	 *
	 * ```
	 * <ng-container [ngPlural]="messages.length">
	 *   <ng-template ngPluralCase="=0">zero</ng-template>
	 *   <ng-template ngPluralCase="=1">one</ng-template>
	 *   <ng-template ngPluralCase="other">more than one</ng-template>
	 * </ng-container>
	 * ```
	 * @param {?} nodes
	 * @return {?}
	 */
	function expandNodes(nodes) {
	    var /** @type {?} */ expander = new _Expander();
	    return new ExpansionResult(visitAll(expander, nodes), expander.isExpanded, expander.errors);
	}
	var ExpansionResult = /** @class */ (function () {
	    function ExpansionResult(nodes, expanded, errors) {
	        this.nodes = nodes;
	        this.expanded = expanded;
	        this.errors = errors;
	    }
	    return ExpansionResult;
	}());
	var ExpansionError = /** @class */ (function (_super) {
	    __extends(ExpansionError, _super);
	    function ExpansionError(span, errorMsg) {
	        return _super.call(this, span, errorMsg) || this;
	    }
	    return ExpansionError;
	}(ParseError));
	/**
	 * Expand expansion forms (plural, select) to directives
	 *
	 * \@internal
	 */
	var _Expander = /** @class */ (function () {
	    function _Expander() {
	        this.isExpanded = false;
	        this.errors = [];
	    }
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    _Expander.prototype.visitElement = /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) {
	        return new Element(element.name, element.attrs, visitAll(this, element.children), element.sourceSpan, element.startSourceSpan, element.endSourceSpan);
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    _Expander.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) { return attribute; };
	    /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    _Expander.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} context
	     * @return {?}
	     */
	    function (text, context) { return text; };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    _Expander.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { return comment; };
	    /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    _Expander.prototype.visitExpansion = /**
	     * @param {?} icu
	     * @param {?} context
	     * @return {?}
	     */
	    function (icu, context) {
	        this.isExpanded = true;
	        return icu.type == 'plural' ? _expandPluralForm(icu, this.errors) :
	            _expandDefaultForm(icu, this.errors);
	    };
	    /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    _Expander.prototype.visitExpansionCase = /**
	     * @param {?} icuCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (icuCase, context) {
	        throw new Error('Should not be reached');
	    };
	    return _Expander;
	}());
	/**
	 * @param {?} ast
	 * @param {?} errors
	 * @return {?}
	 */
	function _expandPluralForm(ast, errors) {
	    var /** @type {?} */ children = ast.cases.map(function (c) {
	        if (PLURAL_CASES.indexOf(c.value) == -1 && !c.value.match(/^=\d+$/)) {
	            errors.push(new ExpansionError(c.valueSourceSpan, "Plural cases should be \"=<number>\" or one of " + PLURAL_CASES.join(", ")));
	        }
	        var /** @type {?} */ expansionResult = expandNodes(c.expression);
	        errors.push.apply(errors, expansionResult.errors);
	        return new Element("ng-template", [new Attribute$1('ngPluralCase', "" + c.value, c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
	    });
	    var /** @type {?} */ switchAttr = new Attribute$1('[ngPlural]', ast.switchValue, ast.switchValueSourceSpan);
	    return new Element('ng-container', [switchAttr], children, ast.sourceSpan, ast.sourceSpan, ast.sourceSpan);
	}
	/**
	 * @param {?} ast
	 * @param {?} errors
	 * @return {?}
	 */
	function _expandDefaultForm(ast, errors) {
	    var /** @type {?} */ children = ast.cases.map(function (c) {
	        var /** @type {?} */ expansionResult = expandNodes(c.expression);
	        errors.push.apply(errors, expansionResult.errors);
	        if (c.value === 'other') {
	            // other is the default case when no values match
	            return new Element("ng-template", [new Attribute$1('ngSwitchDefault', '', c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
	        }
	        return new Element("ng-template", [new Attribute$1('ngSwitchCase', "" + c.value, c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
	    });
	    var /** @type {?} */ switchAttr = new Attribute$1('[ngSwitch]', ast.switchValue, ast.switchValueSourceSpan);
	    return new Element('ng-container', [switchAttr], children, ast.sourceSpan, ast.sourceSpan, ast.sourceSpan);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var PROPERTY_PARTS_SEPARATOR = '.';
	var ATTRIBUTE_PREFIX = 'attr';
	var CLASS_PREFIX = 'class';
	var STYLE_PREFIX = 'style';
	var ANIMATE_PROP_PREFIX = 'animate-';
	/** @enum {number} */
	var BoundPropertyType = {
	    DEFAULT: 0,
	    LITERAL_ATTR: 1,
	    ANIMATION: 2,
	};
	BoundPropertyType[BoundPropertyType.DEFAULT] = "DEFAULT";
	BoundPropertyType[BoundPropertyType.LITERAL_ATTR] = "LITERAL_ATTR";
	BoundPropertyType[BoundPropertyType.ANIMATION] = "ANIMATION";
	/**
	 * Represents a parsed property.
	 */
	var BoundProperty = /** @class */ (function () {
	    function BoundProperty(name, expression, type, sourceSpan) {
	        this.name = name;
	        this.expression = expression;
	        this.type = type;
	        this.sourceSpan = sourceSpan;
	        this.isLiteral = this.type === BoundPropertyType.LITERAL_ATTR;
	        this.isAnimation = this.type === BoundPropertyType.ANIMATION;
	    }
	    return BoundProperty;
	}());
	/**
	 * Parses bindings in templates and in the directive host area.
	 */
	var BindingParser = /** @class */ (function () {
	    function BindingParser(_exprParser, _interpolationConfig, _schemaRegistry, pipes, _targetErrors) {
	        var _this = this;
	        this._exprParser = _exprParser;
	        this._interpolationConfig = _interpolationConfig;
	        this._schemaRegistry = _schemaRegistry;
	        this._targetErrors = _targetErrors;
	        this.pipesByName = new Map();
	        this._usedPipes = new Map();
	        pipes.forEach(function (pipe) { return _this.pipesByName.set(pipe.name, pipe); });
	    }
	    /**
	     * @return {?}
	     */
	    BindingParser.prototype.getUsedPipes = /**
	     * @return {?}
	     */
	    function () { return Array.from(this._usedPipes.values()); };
	    /**
	     * @param {?} dirMeta
	     * @param {?} elementSelector
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype.createDirectiveHostPropertyAsts = /**
	     * @param {?} dirMeta
	     * @param {?} elementSelector
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (dirMeta, elementSelector, sourceSpan) {
	        var _this = this;
	        if (dirMeta.hostProperties) {
	            var /** @type {?} */ boundProps_1 = [];
	            Object.keys(dirMeta.hostProperties).forEach(function (propName) {
	                var /** @type {?} */ expression = dirMeta.hostProperties[propName];
	                if (typeof expression === 'string') {
	                    _this.parsePropertyBinding(propName, expression, true, sourceSpan, [], boundProps_1);
	                }
	                else {
	                    _this._reportError("Value of the host property binding \"" + propName + "\" needs to be a string representing an expression but got \"" + expression + "\" (" + typeof expression + ")", sourceSpan);
	                }
	            });
	            return boundProps_1.map(function (prop) { return _this.createElementPropertyAst(elementSelector, prop); });
	        }
	        return null;
	    };
	    /**
	     * @param {?} dirMeta
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype.createDirectiveHostEventAsts = /**
	     * @param {?} dirMeta
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (dirMeta, sourceSpan) {
	        var _this = this;
	        if (dirMeta.hostListeners) {
	            var /** @type {?} */ targetEventAsts_1 = [];
	            Object.keys(dirMeta.hostListeners).forEach(function (propName) {
	                var /** @type {?} */ expression = dirMeta.hostListeners[propName];
	                if (typeof expression === 'string') {
	                    _this.parseEvent(propName, expression, sourceSpan, [], targetEventAsts_1);
	                }
	                else {
	                    _this._reportError("Value of the host listener \"" + propName + "\" needs to be a string representing an expression but got \"" + expression + "\" (" + typeof expression + ")", sourceSpan);
	                }
	            });
	            return targetEventAsts_1;
	        }
	        return null;
	    };
	    /**
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype.parseInterpolation = /**
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (value, sourceSpan) {
	        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
	        try {
	            var /** @type {?} */ ast = /** @type {?} */ ((this._exprParser.parseInterpolation(value, sourceInfo, this._interpolationConfig)));
	            if (ast)
	                this._reportExpressionParserErrors(ast.errors, sourceSpan);
	            this._checkPipes(ast, sourceSpan);
	            return ast;
	        }
	        catch (/** @type {?} */ e) {
	            this._reportError("" + e, sourceSpan);
	            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
	        }
	    };
	    /**
	     * @param {?} prefixToken
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @param {?} targetVars
	     * @return {?}
	     */
	    BindingParser.prototype.parseInlineTemplateBinding = /**
	     * @param {?} prefixToken
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @param {?} targetVars
	     * @return {?}
	     */
	    function (prefixToken, value, sourceSpan, targetMatchableAttrs, targetProps, targetVars) {
	        var /** @type {?} */ bindings = this._parseTemplateBindings(prefixToken, value, sourceSpan);
	        for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
	            var /** @type {?} */ binding = bindings[i];
	            if (binding.keyIsVar) {
	                targetVars.push(new VariableAst(binding.key, binding.name, sourceSpan));
	            }
	            else if (binding.expression) {
	                this._parsePropertyAst(binding.key, binding.expression, sourceSpan, targetMatchableAttrs, targetProps);
	            }
	            else {
	                targetMatchableAttrs.push([binding.key, '']);
	                this.parseLiteralAttr(binding.key, null, sourceSpan, targetMatchableAttrs, targetProps);
	            }
	        }
	    };
	    /**
	     * @param {?} prefixToken
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype._parseTemplateBindings = /**
	     * @param {?} prefixToken
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (prefixToken, value, sourceSpan) {
	        var _this = this;
	        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
	        try {
	            var /** @type {?} */ bindingsResult = this._exprParser.parseTemplateBindings(prefixToken, value, sourceInfo);
	            this._reportExpressionParserErrors(bindingsResult.errors, sourceSpan);
	            bindingsResult.templateBindings.forEach(function (binding) {
	                if (binding.expression) {
	                    _this._checkPipes(binding.expression, sourceSpan);
	                }
	            });
	            bindingsResult.warnings.forEach(function (warning) { _this._reportError(warning, sourceSpan, ParseErrorLevel.WARNING); });
	            return bindingsResult.templateBindings;
	        }
	        catch (/** @type {?} */ e) {
	            this._reportError("" + e, sourceSpan);
	            return [];
	        }
	    };
	    /**
	     * @param {?} name
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    BindingParser.prototype.parseLiteralAttr = /**
	     * @param {?} name
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    function (name, value, sourceSpan, targetMatchableAttrs, targetProps) {
	        if (_isAnimationLabel(name)) {
	            name = name.substring(1);
	            if (value) {
	                this._reportError("Assigning animation triggers via @prop=\"exp\" attributes with an expression is invalid." +
	                    " Use property bindings (e.g. [@prop]=\"exp\") or use an attribute without a value (e.g. @prop) instead.", sourceSpan, ParseErrorLevel.ERROR);
	            }
	            this._parseAnimation(name, value, sourceSpan, targetMatchableAttrs, targetProps);
	        }
	        else {
	            targetProps.push(new BoundProperty(name, this._exprParser.wrapLiteralPrimitive(value, ''), BoundPropertyType.LITERAL_ATTR, sourceSpan));
	        }
	    };
	    /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} isHost
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    BindingParser.prototype.parsePropertyBinding = /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} isHost
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    function (name, expression, isHost, sourceSpan, targetMatchableAttrs, targetProps) {
	        var /** @type {?} */ isAnimationProp = false;
	        if (name.startsWith(ANIMATE_PROP_PREFIX)) {
	            isAnimationProp = true;
	            name = name.substring(ANIMATE_PROP_PREFIX.length);
	        }
	        else if (_isAnimationLabel(name)) {
	            isAnimationProp = true;
	            name = name.substring(1);
	        }
	        if (isAnimationProp) {
	            this._parseAnimation(name, expression, sourceSpan, targetMatchableAttrs, targetProps);
	        }
	        else {
	            this._parsePropertyAst(name, this._parseBinding(expression, isHost, sourceSpan), sourceSpan, targetMatchableAttrs, targetProps);
	        }
	    };
	    /**
	     * @param {?} name
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    BindingParser.prototype.parsePropertyInterpolation = /**
	     * @param {?} name
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    function (name, value, sourceSpan, targetMatchableAttrs, targetProps) {
	        var /** @type {?} */ expr = this.parseInterpolation(value, sourceSpan);
	        if (expr) {
	            this._parsePropertyAst(name, expr, sourceSpan, targetMatchableAttrs, targetProps);
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @param {?} name
	     * @param {?} ast
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    BindingParser.prototype._parsePropertyAst = /**
	     * @param {?} name
	     * @param {?} ast
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    function (name, ast, sourceSpan, targetMatchableAttrs, targetProps) {
	        targetMatchableAttrs.push([name, /** @type {?} */ ((ast.source))]);
	        targetProps.push(new BoundProperty(name, ast, BoundPropertyType.DEFAULT, sourceSpan));
	    };
	    /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    BindingParser.prototype._parseAnimation = /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @return {?}
	     */
	    function (name, expression, sourceSpan, targetMatchableAttrs, targetProps) {
	        // This will occur when a @trigger is not paired with an expression.
	        // For animations it is valid to not have an expression since */void
	        // states will be applied by angular when the element is attached/detached
	        var /** @type {?} */ ast = this._parseBinding(expression || 'undefined', false, sourceSpan);
	        targetMatchableAttrs.push([name, /** @type {?} */ ((ast.source))]);
	        targetProps.push(new BoundProperty(name, ast, BoundPropertyType.ANIMATION, sourceSpan));
	    };
	    /**
	     * @param {?} value
	     * @param {?} isHostBinding
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype._parseBinding = /**
	     * @param {?} value
	     * @param {?} isHostBinding
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (value, isHostBinding, sourceSpan) {
	        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
	        try {
	            var /** @type {?} */ ast = isHostBinding ?
	                this._exprParser.parseSimpleBinding(value, sourceInfo, this._interpolationConfig) :
	                this._exprParser.parseBinding(value, sourceInfo, this._interpolationConfig);
	            if (ast)
	                this._reportExpressionParserErrors(ast.errors, sourceSpan);
	            this._checkPipes(ast, sourceSpan);
	            return ast;
	        }
	        catch (/** @type {?} */ e) {
	            this._reportError("" + e, sourceSpan);
	            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
	        }
	    };
	    /**
	     * @param {?} elementSelector
	     * @param {?} boundProp
	     * @return {?}
	     */
	    BindingParser.prototype.createElementPropertyAst = /**
	     * @param {?} elementSelector
	     * @param {?} boundProp
	     * @return {?}
	     */
	    function (elementSelector, boundProp) {
	        if (boundProp.isAnimation) {
	            return new BoundElementPropertyAst(boundProp.name, PropertyBindingType.Animation, SecurityContext.NONE, boundProp.expression, null, boundProp.sourceSpan);
	        }
	        var /** @type {?} */ unit = null;
	        var /** @type {?} */ bindingType = /** @type {?} */ ((undefined));
	        var /** @type {?} */ boundPropertyName = null;
	        var /** @type {?} */ parts = boundProp.name.split(PROPERTY_PARTS_SEPARATOR);
	        var /** @type {?} */ securityContexts = /** @type {?} */ ((undefined));
	        // Check check for special cases (prefix style, attr, class)
	        if (parts.length > 1) {
	            if (parts[0] == ATTRIBUTE_PREFIX) {
	                boundPropertyName = parts[1];
	                this._validatePropertyOrAttributeName(boundPropertyName, boundProp.sourceSpan, true);
	                securityContexts = calcPossibleSecurityContexts(this._schemaRegistry, elementSelector, boundPropertyName, true);
	                var /** @type {?} */ nsSeparatorIdx = boundPropertyName.indexOf(':');
	                if (nsSeparatorIdx > -1) {
	                    var /** @type {?} */ ns = boundPropertyName.substring(0, nsSeparatorIdx);
	                    var /** @type {?} */ name_1 = boundPropertyName.substring(nsSeparatorIdx + 1);
	                    boundPropertyName = mergeNsAndName(ns, name_1);
	                }
	                bindingType = PropertyBindingType.Attribute;
	            }
	            else if (parts[0] == CLASS_PREFIX) {
	                boundPropertyName = parts[1];
	                bindingType = PropertyBindingType.Class;
	                securityContexts = [SecurityContext.NONE];
	            }
	            else if (parts[0] == STYLE_PREFIX) {
	                unit = parts.length > 2 ? parts[2] : null;
	                boundPropertyName = parts[1];
	                bindingType = PropertyBindingType.Style;
	                securityContexts = [SecurityContext.STYLE];
	            }
	        }
	        // If not a special case, use the full property name
	        if (boundPropertyName === null) {
	            boundPropertyName = this._schemaRegistry.getMappedPropName(boundProp.name);
	            securityContexts = calcPossibleSecurityContexts(this._schemaRegistry, elementSelector, boundPropertyName, false);
	            bindingType = PropertyBindingType.Property;
	            this._validatePropertyOrAttributeName(boundPropertyName, boundProp.sourceSpan, false);
	        }
	        return new BoundElementPropertyAst(boundPropertyName, bindingType, securityContexts[0], boundProp.expression, unit, boundProp.sourceSpan);
	    };
	    /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    BindingParser.prototype.parseEvent = /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
	        if (_isAnimationLabel(name)) {
	            name = name.substr(1);
	            this._parseAnimationEvent(name, expression, sourceSpan, targetEvents);
	        }
	        else {
	            this._parseEvent(name, expression, sourceSpan, targetMatchableAttrs, targetEvents);
	        }
	    };
	    /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    BindingParser.prototype._parseAnimationEvent = /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    function (name, expression, sourceSpan, targetEvents) {
	        var /** @type {?} */ matches = splitAtPeriod(name, [name, '']);
	        var /** @type {?} */ eventName = matches[0];
	        var /** @type {?} */ phase = matches[1].toLowerCase();
	        if (phase) {
	            switch (phase) {
	                case 'start':
	                case 'done':
	                    var /** @type {?} */ ast = this._parseAction(expression, sourceSpan);
	                    targetEvents.push(new BoundEventAst(eventName, null, phase, ast, sourceSpan));
	                    break;
	                default:
	                    this._reportError("The provided animation output phase value \"" + phase + "\" for \"@" + eventName + "\" is not supported (use start or done)", sourceSpan);
	                    break;
	            }
	        }
	        else {
	            this._reportError("The animation trigger output event (@" + eventName + ") is missing its phase value name (start or done are currently supported)", sourceSpan);
	        }
	    };
	    /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    BindingParser.prototype._parseEvent = /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
	        // long format: 'target: eventName'
	        var _a = splitAtColon(name, [/** @type {?} */ ((null)), name]), target = _a[0], eventName = _a[1];
	        var /** @type {?} */ ast = this._parseAction(expression, sourceSpan);
	        targetMatchableAttrs.push([/** @type {?} */ ((name)), /** @type {?} */ ((ast.source))]);
	        targetEvents.push(new BoundEventAst(eventName, target, null, ast, sourceSpan));
	        // Don't detect directives for event names for now,
	        // so don't add the event name to the matchableAttrs
	    };
	    /**
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype._parseAction = /**
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (value, sourceSpan) {
	        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
	        try {
	            var /** @type {?} */ ast = this._exprParser.parseAction(value, sourceInfo, this._interpolationConfig);
	            if (ast) {
	                this._reportExpressionParserErrors(ast.errors, sourceSpan);
	            }
	            if (!ast || ast.ast instanceof EmptyExpr) {
	                this._reportError("Empty expressions are not allowed", sourceSpan);
	                return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
	            }
	            this._checkPipes(ast, sourceSpan);
	            return ast;
	        }
	        catch (/** @type {?} */ e) {
	            this._reportError("" + e, sourceSpan);
	            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
	        }
	    };
	    /**
	     * @param {?} message
	     * @param {?} sourceSpan
	     * @param {?=} level
	     * @return {?}
	     */
	    BindingParser.prototype._reportError = /**
	     * @param {?} message
	     * @param {?} sourceSpan
	     * @param {?=} level
	     * @return {?}
	     */
	    function (message, sourceSpan, level) {
	        if (level === void 0) { level = ParseErrorLevel.ERROR; }
	        this._targetErrors.push(new ParseError(sourceSpan, message, level));
	    };
	    /**
	     * @param {?} errors
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype._reportExpressionParserErrors = /**
	     * @param {?} errors
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (errors, sourceSpan) {
	        for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
	            var error = errors_1[_i];
	            this._reportError(error.message, sourceSpan);
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    BindingParser.prototype._checkPipes = /**
	     * @param {?} ast
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (ast, sourceSpan) {
	        var _this = this;
	        if (ast) {
	            var /** @type {?} */ collector = new PipeCollector();
	            ast.visit(collector);
	            collector.pipes.forEach(function (ast, pipeName) {
	                var /** @type {?} */ pipeMeta = _this.pipesByName.get(pipeName);
	                if (!pipeMeta) {
	                    _this._reportError("The pipe '" + pipeName + "' could not be found", new ParseSourceSpan(sourceSpan.start.moveBy(ast.span.start), sourceSpan.start.moveBy(ast.span.end)));
	                }
	                else {
	                    _this._usedPipes.set(pipeName, pipeMeta);
	                }
	            });
	        }
	    };
	    /**
	     * @param {?} propName the name of the property / attribute
	     * @param {?} sourceSpan
	     * @param {?} isAttr true when binding to an attribute
	     * @return {?}
	     */
	    BindingParser.prototype._validatePropertyOrAttributeName = /**
	     * @param {?} propName the name of the property / attribute
	     * @param {?} sourceSpan
	     * @param {?} isAttr true when binding to an attribute
	     * @return {?}
	     */
	    function (propName, sourceSpan, isAttr) {
	        var /** @type {?} */ report = isAttr ? this._schemaRegistry.validateAttribute(propName) :
	            this._schemaRegistry.validateProperty(propName);
	        if (report.error) {
	            this._reportError(/** @type {?} */ ((report.msg)), sourceSpan, ParseErrorLevel.ERROR);
	        }
	    };
	    return BindingParser;
	}());
	var PipeCollector = /** @class */ (function (_super) {
	    __extends(PipeCollector, _super);
	    function PipeCollector() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.pipes = new Map();
	        return _this;
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    PipeCollector.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        this.pipes.set(ast.name, ast);
	        ast.exp.visit(this);
	        this.visitAll(ast.args, context);
	        return null;
	    };
	    return PipeCollector;
	}(RecursiveAstVisitor));
	/**
	 * @param {?} name
	 * @return {?}
	 */
	function _isAnimationLabel(name) {
	    return name[0] == '@';
	}
	/**
	 * @param {?} registry
	 * @param {?} selector
	 * @param {?} propName
	 * @param {?} isAttribute
	 * @return {?}
	 */
	function calcPossibleSecurityContexts(registry, selector, propName, isAttribute) {
	    var /** @type {?} */ ctxs = [];
	    CssSelector.parse(selector).forEach(function (selector) {
	        var /** @type {?} */ elementNames = selector.element ? [selector.element] : registry.allKnownElementNames();
	        var /** @type {?} */ notElementNames = new Set(selector.notSelectors.filter(function (selector) { return selector.isElementSelector(); })
	            .map(function (selector) { return selector.element; }));
	        var /** @type {?} */ possibleElementNames = elementNames.filter(function (elementName) { return !notElementNames.has(elementName); });
	        ctxs.push.apply(ctxs, possibleElementNames.map(function (elementName) { return registry.securityContext(elementName, propName, isAttribute); }));
	    });
	    return ctxs.length === 0 ? [SecurityContext.NONE] : Array.from(new Set(ctxs)).sort();
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var BIND_NAME_REGEXP = /^(?:(?:(?:(bind-)|(let-)|(ref-|#)|(on-)|(bindon-)|(@))(.+))|\[\(([^\)]+)\)\]|\[([^\]]+)\]|\(([^\)]+)\))$/;
	// Group 1 = "bind-"
	var KW_BIND_IDX = 1;
	// Group 2 = "let-"
	var KW_LET_IDX = 2;
	// Group 3 = "ref-/#"
	var KW_REF_IDX = 3;
	// Group 4 = "on-"
	var KW_ON_IDX = 4;
	// Group 5 = "bindon-"
	var KW_BINDON_IDX = 5;
	// Group 6 = "@"
	var KW_AT_IDX = 6;
	// Group 7 = the identifier after "bind-", "let-", "ref-/#", "on-", "bindon-" or "@"
	var IDENT_KW_IDX = 7;
	// Group 8 = identifier inside [()]
	var IDENT_BANANA_BOX_IDX = 8;
	// Group 9 = identifier inside []
	var IDENT_PROPERTY_IDX = 9;
	// Group 10 = identifier inside ()
	var IDENT_EVENT_IDX = 10;
	// deprecated in 4.x
	var TEMPLATE_ELEMENT = 'template';
	// deprecated in 4.x
	var TEMPLATE_ATTR = 'template';
	var TEMPLATE_ATTR_PREFIX = '*';
	var CLASS_ATTR = 'class';
	var TEXT_CSS_SELECTOR = CssSelector.parse('*')[0];
	var TEMPLATE_ELEMENT_DEPRECATION_WARNING = 'The <template> element is deprecated. Use <ng-template> instead';
	var TEMPLATE_ATTR_DEPRECATION_WARNING = 'The template attribute is deprecated. Use an ng-template element instead.';
	var warningCounts = {};
	/**
	 * @param {?} warnings
	 * @return {?}
	 */
	function warnOnlyOnce(warnings) {
	    return function (error) {
	        if (warnings.indexOf(error.msg) !== -1) {
	            warningCounts[error.msg] = (warningCounts[error.msg] || 0) + 1;
	            return warningCounts[error.msg] <= 1;
	        }
	        return true;
	    };
	}
	var TemplateParseError = /** @class */ (function (_super) {
	    __extends(TemplateParseError, _super);
	    function TemplateParseError(message, span, level) {
	        return _super.call(this, span, message, level) || this;
	    }
	    return TemplateParseError;
	}(ParseError));
	var TemplateParseResult = /** @class */ (function () {
	    function TemplateParseResult(templateAst, usedPipes, errors) {
	        this.templateAst = templateAst;
	        this.usedPipes = usedPipes;
	        this.errors = errors;
	    }
	    return TemplateParseResult;
	}());
	var TemplateParser = /** @class */ (function () {
	    function TemplateParser(_config, _reflector, _exprParser, _schemaRegistry, _htmlParser, _console, transforms) {
	        this._config = _config;
	        this._reflector = _reflector;
	        this._exprParser = _exprParser;
	        this._schemaRegistry = _schemaRegistry;
	        this._htmlParser = _htmlParser;
	        this._console = _console;
	        this.transforms = transforms;
	    }
	    /**
	     * @param {?} component
	     * @param {?} template
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} schemas
	     * @param {?} templateUrl
	     * @param {?} preserveWhitespaces
	     * @return {?}
	     */
	    TemplateParser.prototype.parse = /**
	     * @param {?} component
	     * @param {?} template
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} schemas
	     * @param {?} templateUrl
	     * @param {?} preserveWhitespaces
	     * @return {?}
	     */
	    function (component, template, directives, pipes, schemas, templateUrl, preserveWhitespaces) {
	        var /** @type {?} */ result = this.tryParse(component, template, directives, pipes, schemas, templateUrl, preserveWhitespaces);
	        var /** @type {?} */ warnings = /** @type {?} */ ((result.errors)).filter(function (error) { return error.level === ParseErrorLevel.WARNING; }).filter(warnOnlyOnce([TEMPLATE_ATTR_DEPRECATION_WARNING, TEMPLATE_ELEMENT_DEPRECATION_WARNING]));
	        var /** @type {?} */ errors = /** @type {?} */ ((result.errors)).filter(function (error) { return error.level === ParseErrorLevel.ERROR; });
	        if (warnings.length > 0) {
	            this._console.warn("Template parse warnings:\n" + warnings.join('\n'));
	        }
	        if (errors.length > 0) {
	            var /** @type {?} */ errorString = errors.join('\n');
	            throw syntaxError("Template parse errors:\n" + errorString, errors);
	        }
	        return { template: /** @type {?} */ ((result.templateAst)), pipes: /** @type {?} */ ((result.usedPipes)) };
	    };
	    /**
	     * @param {?} component
	     * @param {?} template
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} schemas
	     * @param {?} templateUrl
	     * @param {?} preserveWhitespaces
	     * @return {?}
	     */
	    TemplateParser.prototype.tryParse = /**
	     * @param {?} component
	     * @param {?} template
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} schemas
	     * @param {?} templateUrl
	     * @param {?} preserveWhitespaces
	     * @return {?}
	     */
	    function (component, template, directives, pipes, schemas, templateUrl, preserveWhitespaces) {
	        var /** @type {?} */ htmlParseResult = typeof template === 'string' ? /** @type {?} */ ((this._htmlParser)).parse(template, templateUrl, true, this.getInterpolationConfig(component)) :
	            template;
	        if (!preserveWhitespaces) {
	            htmlParseResult = removeWhitespaces(htmlParseResult);
	        }
	        return this.tryParseHtml(this.expandHtml(htmlParseResult), component, directives, pipes, schemas);
	    };
	    /**
	     * @param {?} htmlAstWithErrors
	     * @param {?} component
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} schemas
	     * @return {?}
	     */
	    TemplateParser.prototype.tryParseHtml = /**
	     * @param {?} htmlAstWithErrors
	     * @param {?} component
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} schemas
	     * @return {?}
	     */
	    function (htmlAstWithErrors, component, directives, pipes, schemas) {
	        var /** @type {?} */ result;
	        var /** @type {?} */ errors = htmlAstWithErrors.errors;
	        var /** @type {?} */ usedPipes = [];
	        if (htmlAstWithErrors.rootNodes.length > 0) {
	            var /** @type {?} */ uniqDirectives = removeSummaryDuplicates(directives);
	            var /** @type {?} */ uniqPipes = removeSummaryDuplicates(pipes);
	            var /** @type {?} */ providerViewContext = new ProviderViewContext(this._reflector, component);
	            var /** @type {?} */ interpolationConfig = /** @type {?} */ ((undefined));
	            if (component.template && component.template.interpolation) {
	                interpolationConfig = {
	                    start: component.template.interpolation[0],
	                    end: component.template.interpolation[1]
	                };
	            }
	            var /** @type {?} */ bindingParser = new BindingParser(this._exprParser, /** @type {?} */ ((interpolationConfig)), this._schemaRegistry, uniqPipes, errors);
	            var /** @type {?} */ parseVisitor = new TemplateParseVisitor(this._reflector, this._config, providerViewContext, uniqDirectives, bindingParser, this._schemaRegistry, schemas, errors);
	            result = visitAll(parseVisitor, htmlAstWithErrors.rootNodes, EMPTY_ELEMENT_CONTEXT);
	            errors.push.apply(errors, providerViewContext.errors);
	            usedPipes.push.apply(usedPipes, bindingParser.getUsedPipes());
	        }
	        else {
	            result = [];
	        }
	        this._assertNoReferenceDuplicationOnTemplate(result, errors);
	        if (errors.length > 0) {
	            return new TemplateParseResult(result, usedPipes, errors);
	        }
	        if (this.transforms) {
	            this.transforms.forEach(function (transform) { result = templateVisitAll(transform, result); });
	        }
	        return new TemplateParseResult(result, usedPipes, errors);
	    };
	    /**
	     * @param {?} htmlAstWithErrors
	     * @param {?=} forced
	     * @return {?}
	     */
	    TemplateParser.prototype.expandHtml = /**
	     * @param {?} htmlAstWithErrors
	     * @param {?=} forced
	     * @return {?}
	     */
	    function (htmlAstWithErrors, forced) {
	        if (forced === void 0) { forced = false; }
	        var /** @type {?} */ errors = htmlAstWithErrors.errors;
	        if (errors.length == 0 || forced) {
	            // Transform ICU messages to angular directives
	            var /** @type {?} */ expandedHtmlAst = expandNodes(htmlAstWithErrors.rootNodes);
	            errors.push.apply(errors, expandedHtmlAst.errors);
	            htmlAstWithErrors = new ParseTreeResult(expandedHtmlAst.nodes, errors);
	        }
	        return htmlAstWithErrors;
	    };
	    /**
	     * @param {?} component
	     * @return {?}
	     */
	    TemplateParser.prototype.getInterpolationConfig = /**
	     * @param {?} component
	     * @return {?}
	     */
	    function (component) {
	        if (component.template) {
	            return InterpolationConfig.fromArray(component.template.interpolation);
	        }
	        return undefined;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} result
	     * @param {?} errors
	     * @return {?}
	     */
	    TemplateParser.prototype._assertNoReferenceDuplicationOnTemplate = /**
	     * \@internal
	     * @param {?} result
	     * @param {?} errors
	     * @return {?}
	     */
	    function (result, errors) {
	        var /** @type {?} */ existingReferences = [];
	        result.filter(function (element) { return !!(/** @type {?} */ (element)).references; })
	            .forEach(function (element) {
	            return (/** @type {?} */ (element)).references.forEach(function (reference) {
	                var /** @type {?} */ name = reference.name;
	                if (existingReferences.indexOf(name) < 0) {
	                    existingReferences.push(name);
	                }
	                else {
	                    var /** @type {?} */ error = new TemplateParseError("Reference \"#" + name + "\" is defined several times", reference.sourceSpan, ParseErrorLevel.ERROR);
	                    errors.push(error);
	                }
	            });
	        });
	    };
	    return TemplateParser;
	}());
	var TemplateParseVisitor = /** @class */ (function () {
	    function TemplateParseVisitor(reflector, config, providerViewContext, directives, _bindingParser, _schemaRegistry, _schemas, _targetErrors) {
	        var _this = this;
	        this.reflector = reflector;
	        this.config = config;
	        this.providerViewContext = providerViewContext;
	        this._bindingParser = _bindingParser;
	        this._schemaRegistry = _schemaRegistry;
	        this._schemas = _schemas;
	        this._targetErrors = _targetErrors;
	        this.selectorMatcher = new SelectorMatcher();
	        this.directivesIndex = new Map();
	        this.ngContentCount = 0;
	        // Note: queries start with id 1 so we can use the number in a Bloom filter!
	        this.contentQueryStartId = providerViewContext.component.viewQueries.length + 1;
	        directives.forEach(function (directive, index) {
	            var /** @type {?} */ selector = CssSelector.parse(/** @type {?} */ ((directive.selector)));
	            _this.selectorMatcher.addSelectables(selector, directive);
	            _this.directivesIndex.set(directive, index);
	        });
	    }
	    /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype.visitExpansion = /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansion, context) { return null; };
	    /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype.visitExpansionCase = /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansionCase, context) { return null; };
	    /**
	     * @param {?} text
	     * @param {?} parent
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} parent
	     * @return {?}
	     */
	    function (text, parent) {
	        var /** @type {?} */ ngContentIndex = /** @type {?} */ ((parent.findNgContentIndex(TEXT_CSS_SELECTOR)));
	        var /** @type {?} */ valueNoNgsp = replaceNgsp(text.value);
	        var /** @type {?} */ expr = this._bindingParser.parseInterpolation(valueNoNgsp, /** @type {?} */ ((text.sourceSpan)));
	        return expr ? new BoundTextAst(expr, ngContentIndex, /** @type {?} */ ((text.sourceSpan))) :
	            new TextAst(valueNoNgsp, ngContentIndex, /** @type {?} */ ((text.sourceSpan)));
	    };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) {
	        return new AttrAst(attribute.name, attribute.value, attribute.sourceSpan);
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { return null; };
	    /**
	     * @param {?} element
	     * @param {?} parent
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype.visitElement = /**
	     * @param {?} element
	     * @param {?} parent
	     * @return {?}
	     */
	    function (element, parent) {
	        var _this = this;
	        var /** @type {?} */ queryStartIndex = this.contentQueryStartId;
	        var /** @type {?} */ nodeName = element.name;
	        var /** @type {?} */ preparsedElement = preparseElement(element);
	        if (preparsedElement.type === PreparsedElementType.SCRIPT ||
	            preparsedElement.type === PreparsedElementType.STYLE) {
	            // Skipping <script> for security reasons
	            // Skipping <style> as we already processed them
	            // in the StyleCompiler
	            return null;
	        }
	        if (preparsedElement.type === PreparsedElementType.STYLESHEET &&
	            isStyleUrlResolvable(preparsedElement.hrefAttr)) {
	            // Skipping stylesheets with either relative urls or package scheme as we already processed
	            // them in the StyleCompiler
	            return null;
	        }
	        var /** @type {?} */ matchableAttrs = [];
	        var /** @type {?} */ elementOrDirectiveProps = [];
	        var /** @type {?} */ elementOrDirectiveRefs = [];
	        var /** @type {?} */ elementVars = [];
	        var /** @type {?} */ events = [];
	        var /** @type {?} */ templateElementOrDirectiveProps = [];
	        var /** @type {?} */ templateMatchableAttrs = [];
	        var /** @type {?} */ templateElementVars = [];
	        var /** @type {?} */ hasInlineTemplates = false;
	        var /** @type {?} */ attrs = [];
	        var /** @type {?} */ isTemplateElement = isTemplate(element, this.config.enableLegacyTemplate, function (m, span) { return _this._reportError(m, span, ParseErrorLevel.WARNING); });
	        element.attrs.forEach(function (attr) {
	            var /** @type {?} */ hasBinding = _this._parseAttr(isTemplateElement, attr, matchableAttrs, elementOrDirectiveProps, events, elementOrDirectiveRefs, elementVars);
	            var /** @type {?} */ templateBindingsSource;
	            var /** @type {?} */ prefixToken;
	            var /** @type {?} */ normalizedName = _this._normalizeAttributeName(attr.name);
	            if (_this.config.enableLegacyTemplate && normalizedName == TEMPLATE_ATTR) {
	                _this._reportError(TEMPLATE_ATTR_DEPRECATION_WARNING, attr.sourceSpan, ParseErrorLevel.WARNING);
	                templateBindingsSource = attr.value;
	            }
	            else if (normalizedName.startsWith(TEMPLATE_ATTR_PREFIX)) {
	                templateBindingsSource = attr.value;
	                prefixToken = normalizedName.substring(TEMPLATE_ATTR_PREFIX.length) + ':';
	            }
	            var /** @type {?} */ hasTemplateBinding = templateBindingsSource != null;
	            if (hasTemplateBinding) {
	                if (hasInlineTemplates) {
	                    _this._reportError("Can't have multiple template bindings on one element. Use only one attribute named 'template' or prefixed with *", attr.sourceSpan);
	                }
	                hasInlineTemplates = true;
	                _this._bindingParser.parseInlineTemplateBinding(/** @type {?} */ ((prefixToken)), /** @type {?} */ ((templateBindingsSource)), attr.sourceSpan, templateMatchableAttrs, templateElementOrDirectiveProps, templateElementVars);
	            }
	            if (!hasBinding && !hasTemplateBinding) {
	                // don't include the bindings as attributes as well in the AST
	                attrs.push(_this.visitAttribute(attr, null));
	                matchableAttrs.push([attr.name, attr.value]);
	            }
	        });
	        var /** @type {?} */ elementCssSelector = createElementCssSelector(nodeName, matchableAttrs);
	        var _a = this._parseDirectives(this.selectorMatcher, elementCssSelector), directiveMetas = _a.directives, matchElement = _a.matchElement;
	        var /** @type {?} */ references = [];
	        var /** @type {?} */ boundDirectivePropNames = new Set();
	        var /** @type {?} */ directiveAsts = this._createDirectiveAsts(isTemplateElement, element.name, directiveMetas, elementOrDirectiveProps, elementOrDirectiveRefs, /** @type {?} */ ((element.sourceSpan)), references, boundDirectivePropNames);
	        var /** @type {?} */ elementProps = this._createElementPropertyAsts(element.name, elementOrDirectiveProps, boundDirectivePropNames);
	        var /** @type {?} */ isViewRoot = parent.isTemplateElement || hasInlineTemplates;
	        var /** @type {?} */ providerContext = new ProviderElementContext(this.providerViewContext, /** @type {?} */ ((parent.providerContext)), isViewRoot, directiveAsts, attrs, references, isTemplateElement, queryStartIndex, /** @type {?} */ ((element.sourceSpan)));
	        var /** @type {?} */ children = visitAll(preparsedElement.nonBindable ? NON_BINDABLE_VISITOR : this, element.children, ElementContext.create(isTemplateElement, directiveAsts, isTemplateElement ? /** @type {?} */ ((parent.providerContext)) : providerContext));
	        providerContext.afterElement();
	        // Override the actual selector when the `ngProjectAs` attribute is provided
	        var /** @type {?} */ projectionSelector = preparsedElement.projectAs != null ?
	            CssSelector.parse(preparsedElement.projectAs)[0] :
	            elementCssSelector;
	        var /** @type {?} */ ngContentIndex = /** @type {?} */ ((parent.findNgContentIndex(projectionSelector)));
	        var /** @type {?} */ parsedElement;
	        if (preparsedElement.type === PreparsedElementType.NG_CONTENT) {
	            if (element.children && !element.children.every(_isEmptyTextNode)) {
	                this._reportError("<ng-content> element cannot have content.", /** @type {?} */ ((element.sourceSpan)));
	            }
	            parsedElement = new NgContentAst(this.ngContentCount++, hasInlineTemplates ? /** @type {?} */ ((null)) : ngContentIndex, /** @type {?} */ ((element.sourceSpan)));
	        }
	        else if (isTemplateElement) {
	            this._assertAllEventsPublishedByDirectives(directiveAsts, events);
	            this._assertNoComponentsNorElementBindingsOnTemplate(directiveAsts, elementProps, /** @type {?} */ ((element.sourceSpan)));
	            parsedElement = new EmbeddedTemplateAst(attrs, events, references, elementVars, providerContext.transformedDirectiveAsts, providerContext.transformProviders, providerContext.transformedHasViewContainer, providerContext.queryMatches, children, hasInlineTemplates ? /** @type {?} */ ((null)) : ngContentIndex, /** @type {?} */ ((element.sourceSpan)));
	        }
	        else {
	            this._assertElementExists(matchElement, element);
	            this._assertOnlyOneComponent(directiveAsts, /** @type {?} */ ((element.sourceSpan)));
	            var /** @type {?} */ ngContentIndex_1 = hasInlineTemplates ? null : parent.findNgContentIndex(projectionSelector);
	            parsedElement = new ElementAst(nodeName, attrs, elementProps, events, references, providerContext.transformedDirectiveAsts, providerContext.transformProviders, providerContext.transformedHasViewContainer, providerContext.queryMatches, children, hasInlineTemplates ? null : ngContentIndex_1, element.sourceSpan, element.endSourceSpan || null);
	        }
	        if (hasInlineTemplates) {
	            var /** @type {?} */ templateQueryStartIndex = this.contentQueryStartId;
	            var /** @type {?} */ templateSelector = createElementCssSelector(TEMPLATE_ELEMENT, templateMatchableAttrs);
	            var templateDirectiveMetas = this._parseDirectives(this.selectorMatcher, templateSelector).directives;
	            var /** @type {?} */ templateBoundDirectivePropNames = new Set();
	            var /** @type {?} */ templateDirectiveAsts = this._createDirectiveAsts(true, element.name, templateDirectiveMetas, templateElementOrDirectiveProps, [], /** @type {?} */ ((element.sourceSpan)), [], templateBoundDirectivePropNames);
	            var /** @type {?} */ templateElementProps = this._createElementPropertyAsts(element.name, templateElementOrDirectiveProps, templateBoundDirectivePropNames);
	            this._assertNoComponentsNorElementBindingsOnTemplate(templateDirectiveAsts, templateElementProps, /** @type {?} */ ((element.sourceSpan)));
	            var /** @type {?} */ templateProviderContext = new ProviderElementContext(this.providerViewContext, /** @type {?} */ ((parent.providerContext)), parent.isTemplateElement, templateDirectiveAsts, [], [], true, templateQueryStartIndex, /** @type {?} */ ((element.sourceSpan)));
	            templateProviderContext.afterElement();
	            parsedElement = new EmbeddedTemplateAst([], [], [], templateElementVars, templateProviderContext.transformedDirectiveAsts, templateProviderContext.transformProviders, templateProviderContext.transformedHasViewContainer, templateProviderContext.queryMatches, [parsedElement], ngContentIndex, /** @type {?} */ ((element.sourceSpan)));
	        }
	        return parsedElement;
	    };
	    /**
	     * @param {?} isTemplateElement
	     * @param {?} attr
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @param {?} targetEvents
	     * @param {?} targetRefs
	     * @param {?} targetVars
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._parseAttr = /**
	     * @param {?} isTemplateElement
	     * @param {?} attr
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetProps
	     * @param {?} targetEvents
	     * @param {?} targetRefs
	     * @param {?} targetVars
	     * @return {?}
	     */
	    function (isTemplateElement, attr, targetMatchableAttrs, targetProps, targetEvents, targetRefs, targetVars) {
	        var /** @type {?} */ name = this._normalizeAttributeName(attr.name);
	        var /** @type {?} */ value = attr.value;
	        var /** @type {?} */ srcSpan = attr.sourceSpan;
	        var /** @type {?} */ bindParts = name.match(BIND_NAME_REGEXP);
	        var /** @type {?} */ hasBinding = false;
	        if (bindParts !== null) {
	            hasBinding = true;
	            if (bindParts[KW_BIND_IDX] != null) {
	                this._bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
	            }
	            else if (bindParts[KW_LET_IDX]) {
	                if (isTemplateElement) {
	                    var /** @type {?} */ identifier = bindParts[IDENT_KW_IDX];
	                    this._parseVariable(identifier, value, srcSpan, targetVars);
	                }
	                else {
	                    this._reportError("\"let-\" is only supported on ng-template elements.", srcSpan);
	                }
	            }
	            else if (bindParts[KW_REF_IDX]) {
	                var /** @type {?} */ identifier = bindParts[IDENT_KW_IDX];
	                this._parseReference(identifier, value, srcSpan, targetRefs);
	            }
	            else if (bindParts[KW_ON_IDX]) {
	                this._bindingParser.parseEvent(bindParts[IDENT_KW_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
	            }
	            else if (bindParts[KW_BINDON_IDX]) {
	                this._bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
	                this._parseAssignmentEvent(bindParts[IDENT_KW_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
	            }
	            else if (bindParts[KW_AT_IDX]) {
	                this._bindingParser.parseLiteralAttr(name, value, srcSpan, targetMatchableAttrs, targetProps);
	            }
	            else if (bindParts[IDENT_BANANA_BOX_IDX]) {
	                this._bindingParser.parsePropertyBinding(bindParts[IDENT_BANANA_BOX_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
	                this._parseAssignmentEvent(bindParts[IDENT_BANANA_BOX_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
	            }
	            else if (bindParts[IDENT_PROPERTY_IDX]) {
	                this._bindingParser.parsePropertyBinding(bindParts[IDENT_PROPERTY_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
	            }
	            else if (bindParts[IDENT_EVENT_IDX]) {
	                this._bindingParser.parseEvent(bindParts[IDENT_EVENT_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
	            }
	        }
	        else {
	            hasBinding = this._bindingParser.parsePropertyInterpolation(name, value, srcSpan, targetMatchableAttrs, targetProps);
	        }
	        if (!hasBinding) {
	            this._bindingParser.parseLiteralAttr(name, value, srcSpan, targetMatchableAttrs, targetProps);
	        }
	        return hasBinding;
	    };
	    /**
	     * @param {?} attrName
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._normalizeAttributeName = /**
	     * @param {?} attrName
	     * @return {?}
	     */
	    function (attrName) {
	        return /^data-/i.test(attrName) ? attrName.substring(5) : attrName;
	    };
	    /**
	     * @param {?} identifier
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetVars
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._parseVariable = /**
	     * @param {?} identifier
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetVars
	     * @return {?}
	     */
	    function (identifier, value, sourceSpan, targetVars) {
	        if (identifier.indexOf('-') > -1) {
	            this._reportError("\"-\" is not allowed in variable names", sourceSpan);
	        }
	        targetVars.push(new VariableAst(identifier, value, sourceSpan));
	    };
	    /**
	     * @param {?} identifier
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetRefs
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._parseReference = /**
	     * @param {?} identifier
	     * @param {?} value
	     * @param {?} sourceSpan
	     * @param {?} targetRefs
	     * @return {?}
	     */
	    function (identifier, value, sourceSpan, targetRefs) {
	        if (identifier.indexOf('-') > -1) {
	            this._reportError("\"-\" is not allowed in reference names", sourceSpan);
	        }
	        targetRefs.push(new ElementOrDirectiveRef(identifier, value, sourceSpan));
	    };
	    /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._parseAssignmentEvent = /**
	     * @param {?} name
	     * @param {?} expression
	     * @param {?} sourceSpan
	     * @param {?} targetMatchableAttrs
	     * @param {?} targetEvents
	     * @return {?}
	     */
	    function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
	        this._bindingParser.parseEvent(name + "Change", expression + "=$event", sourceSpan, targetMatchableAttrs, targetEvents);
	    };
	    /**
	     * @param {?} selectorMatcher
	     * @param {?} elementCssSelector
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._parseDirectives = /**
	     * @param {?} selectorMatcher
	     * @param {?} elementCssSelector
	     * @return {?}
	     */
	    function (selectorMatcher, elementCssSelector) {
	        var _this = this;
	        // Need to sort the directives so that we get consistent results throughout,
	        // as selectorMatcher uses Maps inside.
	        // Also deduplicate directives as they might match more than one time!
	        var /** @type {?} */ directives = new Array(this.directivesIndex.size);
	        // Whether any directive selector matches on the element name
	        var /** @type {?} */ matchElement = false;
	        selectorMatcher.match(elementCssSelector, function (selector, directive) {
	            directives[/** @type {?} */ ((_this.directivesIndex.get(directive)))] = directive;
	            matchElement = matchElement || selector.hasElementSelector();
	        });
	        return {
	            directives: directives.filter(function (dir) { return !!dir; }),
	            matchElement: matchElement,
	        };
	    };
	    /**
	     * @param {?} isTemplateElement
	     * @param {?} elementName
	     * @param {?} directives
	     * @param {?} props
	     * @param {?} elementOrDirectiveRefs
	     * @param {?} elementSourceSpan
	     * @param {?} targetReferences
	     * @param {?} targetBoundDirectivePropNames
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._createDirectiveAsts = /**
	     * @param {?} isTemplateElement
	     * @param {?} elementName
	     * @param {?} directives
	     * @param {?} props
	     * @param {?} elementOrDirectiveRefs
	     * @param {?} elementSourceSpan
	     * @param {?} targetReferences
	     * @param {?} targetBoundDirectivePropNames
	     * @return {?}
	     */
	    function (isTemplateElement, elementName, directives, props, elementOrDirectiveRefs, elementSourceSpan, targetReferences, targetBoundDirectivePropNames) {
	        var _this = this;
	        var /** @type {?} */ matchedReferences = new Set();
	        var /** @type {?} */ component = /** @type {?} */ ((null));
	        var /** @type {?} */ directiveAsts = directives.map(function (directive) {
	            var /** @type {?} */ sourceSpan = new ParseSourceSpan(elementSourceSpan.start, elementSourceSpan.end, "Directive " + identifierName(directive.type));
	            if (directive.isComponent) {
	                component = directive;
	            }
	            var /** @type {?} */ directiveProperties = [];
	            var /** @type {?} */ hostProperties = /** @type {?} */ ((_this._bindingParser.createDirectiveHostPropertyAsts(directive, elementName, sourceSpan)));
	            // Note: We need to check the host properties here as well,
	            // as we don't know the element name in the DirectiveWrapperCompiler yet.
	            hostProperties = _this._checkPropertiesInSchema(elementName, hostProperties);
	            var /** @type {?} */ hostEvents = /** @type {?} */ ((_this._bindingParser.createDirectiveHostEventAsts(directive, sourceSpan)));
	            _this._createDirectivePropertyAsts(directive.inputs, props, directiveProperties, targetBoundDirectivePropNames);
	            elementOrDirectiveRefs.forEach(function (elOrDirRef) {
	                if ((elOrDirRef.value.length === 0 && directive.isComponent) ||
	                    (elOrDirRef.isReferenceToDirective(directive))) {
	                    targetReferences.push(new ReferenceAst(elOrDirRef.name, createTokenForReference(directive.type.reference), elOrDirRef.sourceSpan));
	                    matchedReferences.add(elOrDirRef.name);
	                }
	            });
	            var /** @type {?} */ contentQueryStartId = _this.contentQueryStartId;
	            _this.contentQueryStartId += directive.queries.length;
	            return new DirectiveAst(directive, directiveProperties, hostProperties, hostEvents, contentQueryStartId, sourceSpan);
	        });
	        elementOrDirectiveRefs.forEach(function (elOrDirRef) {
	            if (elOrDirRef.value.length > 0) {
	                if (!matchedReferences.has(elOrDirRef.name)) {
	                    _this._reportError("There is no directive with \"exportAs\" set to \"" + elOrDirRef.value + "\"", elOrDirRef.sourceSpan);
	                }
	            }
	            else if (!component) {
	                var /** @type {?} */ refToken = /** @type {?} */ ((null));
	                if (isTemplateElement) {
	                    refToken = createTokenForExternalReference(_this.reflector, Identifiers.TemplateRef);
	                }
	                targetReferences.push(new ReferenceAst(elOrDirRef.name, refToken, elOrDirRef.sourceSpan));
	            }
	        });
	        return directiveAsts;
	    };
	    /**
	     * @param {?} directiveProperties
	     * @param {?} boundProps
	     * @param {?} targetBoundDirectiveProps
	     * @param {?} targetBoundDirectivePropNames
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._createDirectivePropertyAsts = /**
	     * @param {?} directiveProperties
	     * @param {?} boundProps
	     * @param {?} targetBoundDirectiveProps
	     * @param {?} targetBoundDirectivePropNames
	     * @return {?}
	     */
	    function (directiveProperties, boundProps, targetBoundDirectiveProps, targetBoundDirectivePropNames) {
	        if (directiveProperties) {
	            var /** @type {?} */ boundPropsByName_1 = new Map();
	            boundProps.forEach(function (boundProp) {
	                var /** @type {?} */ prevValue = boundPropsByName_1.get(boundProp.name);
	                if (!prevValue || prevValue.isLiteral) {
	                    // give [a]="b" a higher precedence than a="b" on the same element
	                    // give [a]="b" a higher precedence than a="b" on the same element
	                    boundPropsByName_1.set(boundProp.name, boundProp);
	                }
	            });
	            Object.keys(directiveProperties).forEach(function (dirProp) {
	                var /** @type {?} */ elProp = directiveProperties[dirProp];
	                var /** @type {?} */ boundProp = boundPropsByName_1.get(elProp);
	                // Bindings are optional, so this binding only needs to be set up if an expression is given.
	                if (boundProp) {
	                    targetBoundDirectivePropNames.add(boundProp.name);
	                    if (!isEmptyExpression(boundProp.expression)) {
	                        targetBoundDirectiveProps.push(new BoundDirectivePropertyAst(dirProp, boundProp.name, boundProp.expression, boundProp.sourceSpan));
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @param {?} elementName
	     * @param {?} props
	     * @param {?} boundDirectivePropNames
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._createElementPropertyAsts = /**
	     * @param {?} elementName
	     * @param {?} props
	     * @param {?} boundDirectivePropNames
	     * @return {?}
	     */
	    function (elementName, props, boundDirectivePropNames) {
	        var _this = this;
	        var /** @type {?} */ boundElementProps = [];
	        props.forEach(function (prop) {
	            if (!prop.isLiteral && !boundDirectivePropNames.has(prop.name)) {
	                boundElementProps.push(_this._bindingParser.createElementPropertyAst(elementName, prop));
	            }
	        });
	        return this._checkPropertiesInSchema(elementName, boundElementProps);
	    };
	    /**
	     * @param {?} directives
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._findComponentDirectives = /**
	     * @param {?} directives
	     * @return {?}
	     */
	    function (directives) {
	        return directives.filter(function (directive) { return directive.directive.isComponent; });
	    };
	    /**
	     * @param {?} directives
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._findComponentDirectiveNames = /**
	     * @param {?} directives
	     * @return {?}
	     */
	    function (directives) {
	        return this._findComponentDirectives(directives)
	            .map(function (directive) { return ((identifierName(directive.directive.type))); });
	    };
	    /**
	     * @param {?} directives
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._assertOnlyOneComponent = /**
	     * @param {?} directives
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (directives, sourceSpan) {
	        var /** @type {?} */ componentTypeNames = this._findComponentDirectiveNames(directives);
	        if (componentTypeNames.length > 1) {
	            this._reportError("More than one component matched on this element.\n" +
	                "Make sure that only one component's selector can match a given element.\n" +
	                ("Conflicting components: " + componentTypeNames.join(',')), sourceSpan);
	        }
	    };
	    /**
	     * Make sure that non-angular tags conform to the schemas.
	     *
	     * Note: An element is considered an angular tag when at least one directive selector matches the
	     * tag name.
	     *
	     * @param {?} matchElement Whether any directive has matched on the tag name
	     * @param {?} element the html element
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._assertElementExists = /**
	     * Make sure that non-angular tags conform to the schemas.
	     *
	     * Note: An element is considered an angular tag when at least one directive selector matches the
	     * tag name.
	     *
	     * @param {?} matchElement Whether any directive has matched on the tag name
	     * @param {?} element the html element
	     * @return {?}
	     */
	    function (matchElement, element) {
	        var /** @type {?} */ elName = element.name.replace(/^:xhtml:/, '');
	        if (!matchElement && !this._schemaRegistry.hasElement(elName, this._schemas)) {
	            var /** @type {?} */ errorMsg = "'" + elName + "' is not a known element:\n";
	            errorMsg +=
	                "1. If '" + elName + "' is an Angular component, then verify that it is part of this module.\n";
	            if (elName.indexOf('-') > -1) {
	                errorMsg +=
	                    "2. If '" + elName + "' is a Web Component then add 'CUSTOM_ELEMENTS_SCHEMA' to the '@NgModule.schemas' of this component to suppress this message.";
	            }
	            else {
	                errorMsg +=
	                    "2. To allow any element add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
	            }
	            this._reportError(errorMsg, /** @type {?} */ ((element.sourceSpan)));
	        }
	    };
	    /**
	     * @param {?} directives
	     * @param {?} elementProps
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._assertNoComponentsNorElementBindingsOnTemplate = /**
	     * @param {?} directives
	     * @param {?} elementProps
	     * @param {?} sourceSpan
	     * @return {?}
	     */
	    function (directives, elementProps, sourceSpan) {
	        var _this = this;
	        var /** @type {?} */ componentTypeNames = this._findComponentDirectiveNames(directives);
	        if (componentTypeNames.length > 0) {
	            this._reportError("Components on an embedded template: " + componentTypeNames.join(','), sourceSpan);
	        }
	        elementProps.forEach(function (prop) {
	            _this._reportError("Property binding " + prop.name + " not used by any directive on an embedded template. Make sure that the property name is spelled correctly and all directives are listed in the \"@NgModule.declarations\".", sourceSpan);
	        });
	    };
	    /**
	     * @param {?} directives
	     * @param {?} events
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._assertAllEventsPublishedByDirectives = /**
	     * @param {?} directives
	     * @param {?} events
	     * @return {?}
	     */
	    function (directives, events) {
	        var _this = this;
	        var /** @type {?} */ allDirectiveEvents = new Set();
	        directives.forEach(function (directive) {
	            Object.keys(directive.directive.outputs).forEach(function (k) {
	                var /** @type {?} */ eventName = directive.directive.outputs[k];
	                allDirectiveEvents.add(eventName);
	            });
	        });
	        events.forEach(function (event) {
	            if (event.target != null || !allDirectiveEvents.has(event.name)) {
	                _this._reportError("Event binding " + event.fullName + " not emitted by any directive on an embedded template. Make sure that the event name is spelled correctly and all directives are listed in the \"@NgModule.declarations\".", event.sourceSpan);
	            }
	        });
	    };
	    /**
	     * @param {?} elementName
	     * @param {?} boundProps
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._checkPropertiesInSchema = /**
	     * @param {?} elementName
	     * @param {?} boundProps
	     * @return {?}
	     */
	    function (elementName, boundProps) {
	        var _this = this;
	        // Note: We can't filter out empty expressions before this method,
	        // as we still want to validate them!
	        return boundProps.filter(function (boundProp) {
	            if (boundProp.type === PropertyBindingType.Property &&
	                !_this._schemaRegistry.hasProperty(elementName, boundProp.name, _this._schemas)) {
	                var /** @type {?} */ errorMsg = "Can't bind to '" + boundProp.name + "' since it isn't a known property of '" + elementName + "'.";
	                if (elementName.startsWith('ng-')) {
	                    errorMsg +=
	                        "\n1. If '" + boundProp.name + "' is an Angular directive, then add 'CommonModule' to the '@NgModule.imports' of this component." +
	                            "\n2. To allow any property add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
	                }
	                else if (elementName.indexOf('-') > -1) {
	                    errorMsg +=
	                        "\n1. If '" + elementName + "' is an Angular component and it has '" + boundProp.name + "' input, then verify that it is part of this module." +
	                            ("\n2. If '" + elementName + "' is a Web Component then add 'CUSTOM_ELEMENTS_SCHEMA' to the '@NgModule.schemas' of this component to suppress this message.") +
	                            "\n3. To allow any property add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
	                }
	                _this._reportError(errorMsg, boundProp.sourceSpan);
	            }
	            return !isEmptyExpression(boundProp.value);
	        });
	    };
	    /**
	     * @param {?} message
	     * @param {?} sourceSpan
	     * @param {?=} level
	     * @return {?}
	     */
	    TemplateParseVisitor.prototype._reportError = /**
	     * @param {?} message
	     * @param {?} sourceSpan
	     * @param {?=} level
	     * @return {?}
	     */
	    function (message, sourceSpan, level) {
	        if (level === void 0) { level = ParseErrorLevel.ERROR; }
	        this._targetErrors.push(new ParseError(sourceSpan, message, level));
	    };
	    return TemplateParseVisitor;
	}());
	var NonBindableVisitor = /** @class */ (function () {
	    function NonBindableVisitor() {
	    }
	    /**
	     * @param {?} ast
	     * @param {?} parent
	     * @return {?}
	     */
	    NonBindableVisitor.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} parent
	     * @return {?}
	     */
	    function (ast, parent) {
	        var /** @type {?} */ preparsedElement = preparseElement(ast);
	        if (preparsedElement.type === PreparsedElementType.SCRIPT ||
	            preparsedElement.type === PreparsedElementType.STYLE ||
	            preparsedElement.type === PreparsedElementType.STYLESHEET) {
	            // Skipping <script> for security reasons
	            // Skipping <style> and stylesheets as we already processed them
	            // in the StyleCompiler
	            return null;
	        }
	        var /** @type {?} */ attrNameAndValues = ast.attrs.map(function (attr) { return [attr.name, attr.value]; });
	        var /** @type {?} */ selector = createElementCssSelector(ast.name, attrNameAndValues);
	        var /** @type {?} */ ngContentIndex = parent.findNgContentIndex(selector);
	        var /** @type {?} */ children = visitAll(this, ast.children, EMPTY_ELEMENT_CONTEXT);
	        return new ElementAst(ast.name, visitAll(this, ast.attrs), [], [], [], [], [], false, [], children, ngContentIndex, ast.sourceSpan, ast.endSourceSpan);
	    };
	    /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    NonBindableVisitor.prototype.visitComment = /**
	     * @param {?} comment
	     * @param {?} context
	     * @return {?}
	     */
	    function (comment, context) { return null; };
	    /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    NonBindableVisitor.prototype.visitAttribute = /**
	     * @param {?} attribute
	     * @param {?} context
	     * @return {?}
	     */
	    function (attribute, context) {
	        return new AttrAst(attribute.name, attribute.value, attribute.sourceSpan);
	    };
	    /**
	     * @param {?} text
	     * @param {?} parent
	     * @return {?}
	     */
	    NonBindableVisitor.prototype.visitText = /**
	     * @param {?} text
	     * @param {?} parent
	     * @return {?}
	     */
	    function (text, parent) {
	        var /** @type {?} */ ngContentIndex = /** @type {?} */ ((parent.findNgContentIndex(TEXT_CSS_SELECTOR)));
	        return new TextAst(text.value, ngContentIndex, /** @type {?} */ ((text.sourceSpan)));
	    };
	    /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    NonBindableVisitor.prototype.visitExpansion = /**
	     * @param {?} expansion
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansion, context) { return expansion; };
	    /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    NonBindableVisitor.prototype.visitExpansionCase = /**
	     * @param {?} expansionCase
	     * @param {?} context
	     * @return {?}
	     */
	    function (expansionCase, context) { return expansionCase; };
	    return NonBindableVisitor;
	}());
	/**
	 * A reference to an element or directive in a template. E.g., the reference in this template:
	 *
	 * <div #myMenu="coolMenu">
	 *
	 * would be {name: 'myMenu', value: 'coolMenu', sourceSpan: ...}
	 */
	var ElementOrDirectiveRef = /** @class */ (function () {
	    function ElementOrDirectiveRef(name, value, sourceSpan) {
	        this.name = name;
	        this.value = value;
	        this.sourceSpan = sourceSpan;
	    }
	    /** Gets whether this is a reference to the given directive. */
	    /**
	     * Gets whether this is a reference to the given directive.
	     * @param {?} directive
	     * @return {?}
	     */
	    ElementOrDirectiveRef.prototype.isReferenceToDirective = /**
	     * Gets whether this is a reference to the given directive.
	     * @param {?} directive
	     * @return {?}
	     */
	    function (directive) {
	        return splitExportAs(directive.exportAs).indexOf(this.value) !== -1;
	    };
	    return ElementOrDirectiveRef;
	}());
	/**
	 * Splits a raw, potentially comma-delimted `exportAs` value into an array of names.
	 * @param {?} exportAs
	 * @return {?}
	 */
	function splitExportAs(exportAs) {
	    return exportAs ? exportAs.split(',').map(function (e) { return e.trim(); }) : [];
	}
	/**
	 * @param {?} classAttrValue
	 * @return {?}
	 */
	function splitClasses(classAttrValue) {
	    return classAttrValue.trim().split(/\s+/g);
	}
	var ElementContext = /** @class */ (function () {
	    function ElementContext(isTemplateElement, _ngContentIndexMatcher, _wildcardNgContentIndex, providerContext) {
	        this.isTemplateElement = isTemplateElement;
	        this._ngContentIndexMatcher = _ngContentIndexMatcher;
	        this._wildcardNgContentIndex = _wildcardNgContentIndex;
	        this.providerContext = providerContext;
	    }
	    /**
	     * @param {?} isTemplateElement
	     * @param {?} directives
	     * @param {?} providerContext
	     * @return {?}
	     */
	    ElementContext.create = /**
	     * @param {?} isTemplateElement
	     * @param {?} directives
	     * @param {?} providerContext
	     * @return {?}
	     */
	    function (isTemplateElement, directives, providerContext) {
	        var /** @type {?} */ matcher = new SelectorMatcher();
	        var /** @type {?} */ wildcardNgContentIndex = /** @type {?} */ ((null));
	        var /** @type {?} */ component = directives.find(function (directive) { return directive.directive.isComponent; });
	        if (component) {
	            var /** @type {?} */ ngContentSelectors = /** @type {?} */ ((component.directive.template)).ngContentSelectors;
	            for (var /** @type {?} */ i = 0; i < ngContentSelectors.length; i++) {
	                var /** @type {?} */ selector = ngContentSelectors[i];
	                if (selector === '*') {
	                    wildcardNgContentIndex = i;
	                }
	                else {
	                    matcher.addSelectables(CssSelector.parse(ngContentSelectors[i]), i);
	                }
	            }
	        }
	        return new ElementContext(isTemplateElement, matcher, wildcardNgContentIndex, providerContext);
	    };
	    /**
	     * @param {?} selector
	     * @return {?}
	     */
	    ElementContext.prototype.findNgContentIndex = /**
	     * @param {?} selector
	     * @return {?}
	     */
	    function (selector) {
	        var /** @type {?} */ ngContentIndices = [];
	        this._ngContentIndexMatcher.match(selector, function (selector, ngContentIndex) { ngContentIndices.push(ngContentIndex); });
	        ngContentIndices.sort();
	        if (this._wildcardNgContentIndex != null) {
	            ngContentIndices.push(this._wildcardNgContentIndex);
	        }
	        return ngContentIndices.length > 0 ? ngContentIndices[0] : null;
	    };
	    return ElementContext;
	}());
	/**
	 * @param {?} elementName
	 * @param {?} attributes
	 * @return {?}
	 */
	function createElementCssSelector(elementName, attributes) {
	    var /** @type {?} */ cssSelector = new CssSelector();
	    var /** @type {?} */ elNameNoNs = splitNsName(elementName)[1];
	    cssSelector.setElement(elNameNoNs);
	    for (var /** @type {?} */ i = 0; i < attributes.length; i++) {
	        var /** @type {?} */ attrName = attributes[i][0];
	        var /** @type {?} */ attrNameNoNs = splitNsName(attrName)[1];
	        var /** @type {?} */ attrValue = attributes[i][1];
	        cssSelector.addAttribute(attrNameNoNs, attrValue);
	        if (attrName.toLowerCase() == CLASS_ATTR) {
	            var /** @type {?} */ classes = splitClasses(attrValue);
	            classes.forEach(function (className) { return cssSelector.addClassName(className); });
	        }
	    }
	    return cssSelector;
	}
	var EMPTY_ELEMENT_CONTEXT = new ElementContext(true, new SelectorMatcher(), null, null);
	var NON_BINDABLE_VISITOR = new NonBindableVisitor();
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function _isEmptyTextNode(node) {
	    return node instanceof Text && node.value.trim().length == 0;
	}
	/**
	 * @template T
	 * @param {?} items
	 * @return {?}
	 */
	function removeSummaryDuplicates(items) {
	    var /** @type {?} */ map = new Map();
	    items.forEach(function (item) {
	        if (!map.get(item.type.reference)) {
	            map.set(item.type.reference, item);
	        }
	    });
	    return Array.from(map.values());
	}
	/**
	 * @param {?} ast
	 * @return {?}
	 */
	function isEmptyExpression(ast) {
	    if (ast instanceof ASTWithSource) {
	        ast = ast.ast;
	    }
	    return ast instanceof EmptyExpr;
	}
	/**
	 * @param {?} el
	 * @param {?} enableLegacyTemplate
	 * @param {?} reportDeprecation
	 * @return {?}
	 */
	function isTemplate(el, enableLegacyTemplate, reportDeprecation) {
	    if (isNgTemplate(el.name))
	        return true;
	    var /** @type {?} */ tagNoNs = splitNsName(el.name)[1];
	    // `<template>` is HTML and case insensitive
	    if (tagNoNs.toLowerCase() === TEMPLATE_ELEMENT) {
	        if (enableLegacyTemplate && tagNoNs.toLowerCase() === TEMPLATE_ELEMENT) {
	            reportDeprecation(TEMPLATE_ELEMENT_DEPRECATION_WARNING, /** @type {?} */ ((el.sourceSpan)));
	            return true;
	        }
	    }
	    return false;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var EventHandlerVars = /** @class */ (function () {
	    function EventHandlerVars() {
	    }
	    EventHandlerVars.event = variable('$event');
	    return EventHandlerVars;
	}());
	/**
	 * @record
	 */
	
	var ConvertActionBindingResult = /** @class */ (function () {
	    function ConvertActionBindingResult(stmts, allowDefault) {
	        this.stmts = stmts;
	        this.allowDefault = allowDefault;
	    }
	    return ConvertActionBindingResult;
	}());
	/**
	 * Converts the given expression AST into an executable output AST, assuming the expression is
	 * used in an action binding (e.g. an event handler).
	 * @param {?} localResolver
	 * @param {?} implicitReceiver
	 * @param {?} action
	 * @param {?} bindingId
	 * @return {?}
	 */
	function convertActionBinding(localResolver, implicitReceiver, action, bindingId) {
	    if (!localResolver) {
	        localResolver = new DefaultLocalResolver();
	    }
	    var /** @type {?} */ actionWithoutBuiltins = convertPropertyBindingBuiltins({
	        createLiteralArrayConverter: function (argCount) {
	            // Note: no caching for literal arrays in actions.
	            return function (args) { return literalArr(args); };
	        },
	        createLiteralMapConverter: function (keys) {
	            // Note: no caching for literal maps in actions.
	            return function (values) {
	                var /** @type {?} */ entries = keys.map(function (k, i) {
	                    return ({
	                        key: k.key,
	                        value: values[i],
	                        quoted: k.quoted,
	                    });
	                });
	                return literalMap(entries);
	            };
	        },
	        createPipeConverter: function (name) {
	            throw new Error("Illegal State: Actions are not allowed to contain pipes. Pipe: " + name);
	        }
	    }, action);
	    var /** @type {?} */ visitor = new _AstToIrVisitor(localResolver, implicitReceiver, bindingId);
	    var /** @type {?} */ actionStmts = [];
	    flattenStatements(actionWithoutBuiltins.visit(visitor, _Mode.Statement), actionStmts);
	    prependTemporaryDecls(visitor.temporaryCount, bindingId, actionStmts);
	    var /** @type {?} */ lastIndex = actionStmts.length - 1;
	    var /** @type {?} */ preventDefaultVar = /** @type {?} */ ((null));
	    if (lastIndex >= 0) {
	        var /** @type {?} */ lastStatement = actionStmts[lastIndex];
	        var /** @type {?} */ returnExpr = convertStmtIntoExpression(lastStatement);
	        if (returnExpr) {
	            // Note: We need to cast the result of the method call to dynamic,
	            // as it might be a void method!
	            preventDefaultVar = createPreventDefaultVar(bindingId);
	            actionStmts[lastIndex] =
	                preventDefaultVar.set(returnExpr.cast(DYNAMIC_TYPE).notIdentical(literal(false)))
	                    .toDeclStmt(null, [StmtModifier.Final]);
	        }
	    }
	    return new ConvertActionBindingResult(actionStmts, preventDefaultVar);
	}
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @param {?} converterFactory
	 * @param {?} ast
	 * @return {?}
	 */
	function convertPropertyBindingBuiltins(converterFactory, ast) {
	    return convertBuiltins(converterFactory, ast);
	}
	var ConvertPropertyBindingResult = /** @class */ (function () {
	    function ConvertPropertyBindingResult(stmts, currValExpr) {
	        this.stmts = stmts;
	        this.currValExpr = currValExpr;
	    }
	    return ConvertPropertyBindingResult;
	}());
	/** @enum {number} */
	var BindingForm = {
	    // The general form of binding expression, supports all expressions.
	    General: 0,
	    // Try to generate a simple binding (no temporaries or statements)
	    // otherise generate a general binding
	    TrySimple: 1,
	};
	BindingForm[BindingForm.General] = "General";
	BindingForm[BindingForm.TrySimple] = "TrySimple";
	/**
	 * Converts the given expression AST into an executable output AST, assuming the expression
	 * is used in property binding. The expression has to be preprocessed via
	 * `convertPropertyBindingBuiltins`.
	 * @param {?} localResolver
	 * @param {?} implicitReceiver
	 * @param {?} expressionWithoutBuiltins
	 * @param {?} bindingId
	 * @param {?} form
	 * @return {?}
	 */
	function convertPropertyBinding(localResolver, implicitReceiver, expressionWithoutBuiltins, bindingId, form) {
	    if (!localResolver) {
	        localResolver = new DefaultLocalResolver();
	    }
	    var /** @type {?} */ currValExpr = createCurrValueExpr(bindingId);
	    var /** @type {?} */ stmts = [];
	    var /** @type {?} */ visitor = new _AstToIrVisitor(localResolver, implicitReceiver, bindingId);
	    var /** @type {?} */ outputExpr = expressionWithoutBuiltins.visit(visitor, _Mode.Expression);
	    if (visitor.temporaryCount) {
	        for (var /** @type {?} */ i = 0; i < visitor.temporaryCount; i++) {
	            stmts.push(temporaryDeclaration(bindingId, i));
	        }
	    }
	    else if (form == BindingForm.TrySimple) {
	        return new ConvertPropertyBindingResult([], outputExpr);
	    }
	    stmts.push(currValExpr.set(outputExpr).toDeclStmt(DYNAMIC_TYPE, [StmtModifier.Final]));
	    return new ConvertPropertyBindingResult(stmts, currValExpr);
	}
	/**
	 * @param {?} converterFactory
	 * @param {?} ast
	 * @return {?}
	 */
	function convertBuiltins(converterFactory, ast) {
	    var /** @type {?} */ visitor = new _BuiltinAstConverter(converterFactory);
	    return ast.visit(visitor);
	}
	/**
	 * @param {?} bindingId
	 * @param {?} temporaryNumber
	 * @return {?}
	 */
	function temporaryName(bindingId, temporaryNumber) {
	    return "tmp_" + bindingId + "_" + temporaryNumber;
	}
	/**
	 * @param {?} bindingId
	 * @param {?} temporaryNumber
	 * @return {?}
	 */
	function temporaryDeclaration(bindingId, temporaryNumber) {
	    return new DeclareVarStmt(temporaryName(bindingId, temporaryNumber), NULL_EXPR);
	}
	/**
	 * @param {?} temporaryCount
	 * @param {?} bindingId
	 * @param {?} statements
	 * @return {?}
	 */
	function prependTemporaryDecls(temporaryCount, bindingId, statements) {
	    for (var /** @type {?} */ i = temporaryCount - 1; i >= 0; i--) {
	        statements.unshift(temporaryDeclaration(bindingId, i));
	    }
	}
	/** @enum {number} */
	var _Mode = {
	    Statement: 0,
	    Expression: 1,
	};
	_Mode[_Mode.Statement] = "Statement";
	_Mode[_Mode.Expression] = "Expression";
	/**
	 * @param {?} mode
	 * @param {?} ast
	 * @return {?}
	 */
	function ensureStatementMode(mode, ast) {
	    if (mode !== _Mode.Statement) {
	        throw new Error("Expected a statement, but saw " + ast);
	    }
	}
	/**
	 * @param {?} mode
	 * @param {?} ast
	 * @return {?}
	 */
	function ensureExpressionMode(mode, ast) {
	    if (mode !== _Mode.Expression) {
	        throw new Error("Expected an expression, but saw " + ast);
	    }
	}
	/**
	 * @param {?} mode
	 * @param {?} expr
	 * @return {?}
	 */
	function convertToStatementIfNeeded(mode, expr) {
	    if (mode === _Mode.Statement) {
	        return expr.toStmt();
	    }
	    else {
	        return expr;
	    }
	}
	var _BuiltinAstConverter = /** @class */ (function (_super) {
	    __extends(_BuiltinAstConverter, _super);
	    function _BuiltinAstConverter(_converterFactory) {
	        var _this = _super.call(this) || this;
	        _this._converterFactory = _converterFactory;
	        return _this;
	    }
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    _BuiltinAstConverter.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ args = [ast.exp].concat(ast.args).map(function (ast) { return ast.visit(_this, context); });
	        return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createPipeConverter(ast.name, args.length));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    _BuiltinAstConverter.prototype.visitLiteralArray = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ args = ast.expressions.map(function (ast) { return ast.visit(_this, context); });
	        return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createLiteralArrayConverter(ast.expressions.length));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    _BuiltinAstConverter.prototype.visitLiteralMap = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ args = ast.values.map(function (ast) { return ast.visit(_this, context); });
	        return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createLiteralMapConverter(ast.keys));
	    };
	    return _BuiltinAstConverter;
	}(AstTransformer));
	var _AstToIrVisitor = /** @class */ (function () {
	    function _AstToIrVisitor(_localResolver, _implicitReceiver, bindingId) {
	        this._localResolver = _localResolver;
	        this._implicitReceiver = _implicitReceiver;
	        this.bindingId = bindingId;
	        this._nodeMap = new Map();
	        this._resultMap = new Map();
	        this._currentTemporary = 0;
	        this.temporaryCount = 0;
	    }
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitBinary = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ op;
	        switch (ast.operation) {
	            case '+':
	                op = BinaryOperator.Plus;
	                break;
	            case '-':
	                op = BinaryOperator.Minus;
	                break;
	            case '*':
	                op = BinaryOperator.Multiply;
	                break;
	            case '/':
	                op = BinaryOperator.Divide;
	                break;
	            case '%':
	                op = BinaryOperator.Modulo;
	                break;
	            case '&&':
	                op = BinaryOperator.And;
	                break;
	            case '||':
	                op = BinaryOperator.Or;
	                break;
	            case '==':
	                op = BinaryOperator.Equals;
	                break;
	            case '!=':
	                op = BinaryOperator.NotEquals;
	                break;
	            case '===':
	                op = BinaryOperator.Identical;
	                break;
	            case '!==':
	                op = BinaryOperator.NotIdentical;
	                break;
	            case '<':
	                op = BinaryOperator.Lower;
	                break;
	            case '>':
	                op = BinaryOperator.Bigger;
	                break;
	            case '<=':
	                op = BinaryOperator.LowerEquals;
	                break;
	            case '>=':
	                op = BinaryOperator.BiggerEquals;
	                break;
	            default:
	                throw new Error("Unsupported operation " + ast.operation);
	        }
	        return convertToStatementIfNeeded(mode, new BinaryOperatorExpr(op, this._visit(ast.left, _Mode.Expression), this._visit(ast.right, _Mode.Expression)));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitChain = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        ensureStatementMode(mode, ast);
	        return this.visitAll(ast.expressions, mode);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitConditional = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ value = this._visit(ast.condition, _Mode.Expression);
	        return convertToStatementIfNeeded(mode, value.conditional(this._visit(ast.trueExp, _Mode.Expression), this._visit(ast.falseExp, _Mode.Expression)));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitPipe = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        throw new Error("Illegal state: Pipes should have been converted into functions. Pipe: " + ast.name);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitFunctionCall = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ convertedArgs = this.visitAll(ast.args, _Mode.Expression);
	        var /** @type {?} */ fnResult;
	        if (ast instanceof BuiltinFunctionCall) {
	            fnResult = ast.converter(convertedArgs);
	        }
	        else {
	            fnResult = this._visit(/** @type {?} */ ((ast.target)), _Mode.Expression).callFn(convertedArgs);
	        }
	        return convertToStatementIfNeeded(mode, fnResult);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitImplicitReceiver = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        ensureExpressionMode(mode, ast);
	        return this._implicitReceiver;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitInterpolation = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        ensureExpressionMode(mode, ast);
	        var /** @type {?} */ args = [literal(ast.expressions.length)];
	        for (var /** @type {?} */ i = 0; i < ast.strings.length - 1; i++) {
	            args.push(literal(ast.strings[i]));
	            args.push(this._visit(ast.expressions[i], _Mode.Expression));
	        }
	        args.push(literal(ast.strings[ast.strings.length - 1]));
	        return ast.expressions.length <= 9 ?
	            importExpr(Identifiers.inlineInterpolate).callFn(args) :
	            importExpr(Identifiers.interpolate).callFn([args[0], literalArr(args.slice(1))]);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitKeyedRead = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ leftMostSafe = this.leftMostSafeNode(ast);
	        if (leftMostSafe) {
	            return this.convertSafeAccess(ast, leftMostSafe, mode);
	        }
	        else {
	            return convertToStatementIfNeeded(mode, this._visit(ast.obj, _Mode.Expression).key(this._visit(ast.key, _Mode.Expression)));
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitKeyedWrite = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ obj = this._visit(ast.obj, _Mode.Expression);
	        var /** @type {?} */ key = this._visit(ast.key, _Mode.Expression);
	        var /** @type {?} */ value = this._visit(ast.value, _Mode.Expression);
	        return convertToStatementIfNeeded(mode, obj.key(key).set(value));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitLiteralArray = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        throw new Error("Illegal State: literal arrays should have been converted into functions");
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitLiteralMap = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        throw new Error("Illegal State: literal maps should have been converted into functions");
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitLiteralPrimitive = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        // For literal values of null, undefined, true, or false allow type inteference
	        // to infer the type.
	        var /** @type {?} */ type = ast.value === null || ast.value === undefined || ast.value === true || ast.value === true ?
	            INFERRED_TYPE :
	            undefined;
	        return convertToStatementIfNeeded(mode, literal(ast.value, type));
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype._getLocal = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return this._localResolver.getLocal(name); };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitMethodCall = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        if (ast.receiver instanceof ImplicitReceiver && ast.name == '$any') {
	            var /** @type {?} */ args = /** @type {?} */ (this.visitAll(ast.args, _Mode.Expression));
	            if (args.length != 1) {
	                throw new Error("Invalid call to $any, expected 1 argument but received " + (args.length || 'none'));
	            }
	            return (/** @type {?} */ (args[0])).cast(DYNAMIC_TYPE);
	        }
	        var /** @type {?} */ leftMostSafe = this.leftMostSafeNode(ast);
	        if (leftMostSafe) {
	            return this.convertSafeAccess(ast, leftMostSafe, mode);
	        }
	        else {
	            var /** @type {?} */ args = this.visitAll(ast.args, _Mode.Expression);
	            var /** @type {?} */ result = null;
	            var /** @type {?} */ receiver = this._visit(ast.receiver, _Mode.Expression);
	            if (receiver === this._implicitReceiver) {
	                var /** @type {?} */ varExpr = this._getLocal(ast.name);
	                if (varExpr) {
	                    result = varExpr.callFn(args);
	                }
	            }
	            if (result == null) {
	                result = receiver.callMethod(ast.name, args);
	            }
	            return convertToStatementIfNeeded(mode, result);
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitPrefixNot = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        return convertToStatementIfNeeded(mode, not(this._visit(ast.expression, _Mode.Expression)));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitNonNullAssert = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        return convertToStatementIfNeeded(mode, assertNotNull(this._visit(ast.expression, _Mode.Expression)));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitPropertyRead = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ leftMostSafe = this.leftMostSafeNode(ast);
	        if (leftMostSafe) {
	            return this.convertSafeAccess(ast, leftMostSafe, mode);
	        }
	        else {
	            var /** @type {?} */ result = null;
	            var /** @type {?} */ receiver = this._visit(ast.receiver, _Mode.Expression);
	            if (receiver === this._implicitReceiver) {
	                result = this._getLocal(ast.name);
	            }
	            if (result == null) {
	                result = receiver.prop(ast.name);
	            }
	            return convertToStatementIfNeeded(mode, result);
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitPropertyWrite = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ receiver = this._visit(ast.receiver, _Mode.Expression);
	        if (receiver === this._implicitReceiver) {
	            var /** @type {?} */ varExpr = this._getLocal(ast.name);
	            if (varExpr) {
	                throw new Error('Cannot assign to a reference or variable!');
	            }
	        }
	        return convertToStatementIfNeeded(mode, receiver.prop(ast.name).set(this._visit(ast.value, _Mode.Expression)));
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitSafePropertyRead = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        return this.convertSafeAccess(ast, this.leftMostSafeNode(ast), mode);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitSafeMethodCall = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        return this.convertSafeAccess(ast, this.leftMostSafeNode(ast), mode);
	    };
	    /**
	     * @param {?} asts
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitAll = /**
	     * @param {?} asts
	     * @param {?} mode
	     * @return {?}
	     */
	    function (asts, mode) {
	        var _this = this;
	        return asts.map(function (ast) { return _this._visit(ast, mode); });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.visitQuote = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        throw new Error("Quotes are not supported for evaluation!\n        Statement: " + ast.uninterpretedExpression + " located at " + ast.location);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype._visit = /**
	     * @param {?} ast
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, mode) {
	        var /** @type {?} */ result = this._resultMap.get(ast);
	        if (result)
	            return result;
	        return (this._nodeMap.get(ast) || ast).visit(this, mode);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} leftMostSafe
	     * @param {?} mode
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.convertSafeAccess = /**
	     * @param {?} ast
	     * @param {?} leftMostSafe
	     * @param {?} mode
	     * @return {?}
	     */
	    function (ast, leftMostSafe, mode) {
	        // If the expression contains a safe access node on the left it needs to be converted to
	        // an expression that guards the access to the member by checking the receiver for blank. As
	        // execution proceeds from left to right, the left most part of the expression must be guarded
	        // first but, because member access is left associative, the right side of the expression is at
	        // the top of the AST. The desired result requires lifting a copy of the the left part of the
	        // expression up to test it for blank before generating the unguarded version.
	        // Consider, for example the following expression: a?.b.c?.d.e
	        // This results in the ast:
	        //         .
	        //        / \
	        //       ?.   e
	        //      /  \
	        //     .    d
	        //    / \
	        //   ?.  c
	        //  /  \
	        // a    b
	        // The following tree should be generated:
	        //
	        //        /---- ? ----\
	        //       /      |      \
	        //     a   /--- ? ---\  null
	        //        /     |     \
	        //       .      .     null
	        //      / \    / \
	        //     .  c   .   e
	        //    / \    / \
	        //   a   b  ,   d
	        //         / \
	        //        .   c
	        //       / \
	        //      a   b
	        //
	        // Notice that the first guard condition is the left hand of the left most safe access node
	        // which comes in as leftMostSafe to this routine.
	        var /** @type {?} */ guardedExpression = this._visit(leftMostSafe.receiver, _Mode.Expression);
	        var /** @type {?} */ temporary = /** @type {?} */ ((undefined));
	        if (this.needsTemporary(leftMostSafe.receiver)) {
	            // If the expression has method calls or pipes then we need to save the result into a
	            // temporary variable to avoid calling stateful or impure code more than once.
	            temporary = this.allocateTemporary();
	            // Preserve the result in the temporary variable
	            guardedExpression = temporary.set(guardedExpression);
	            // Ensure all further references to the guarded expression refer to the temporary instead.
	            this._resultMap.set(leftMostSafe.receiver, temporary);
	        }
	        var /** @type {?} */ condition = guardedExpression.isBlank();
	        // Convert the ast to an unguarded access to the receiver's member. The map will substitute
	        // leftMostNode with its unguarded version in the call to `this.visit()`.
	        if (leftMostSafe instanceof SafeMethodCall) {
	            this._nodeMap.set(leftMostSafe, new MethodCall(leftMostSafe.span, leftMostSafe.receiver, leftMostSafe.name, leftMostSafe.args));
	        }
	        else {
	            this._nodeMap.set(leftMostSafe, new PropertyRead(leftMostSafe.span, leftMostSafe.receiver, leftMostSafe.name));
	        }
	        // Recursively convert the node now without the guarded member access.
	        var /** @type {?} */ access = this._visit(ast, _Mode.Expression);
	        // Remove the mapping. This is not strictly required as the converter only traverses each node
	        // once but is safer if the conversion is changed to traverse the nodes more than once.
	        this._nodeMap.delete(leftMostSafe);
	        // If we allocated a temporary, release it.
	        if (temporary) {
	            this.releaseTemporary(temporary);
	        }
	        // Produce the conditional
	        return convertToStatementIfNeeded(mode, condition.conditional(literal(null), access));
	    };
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.leftMostSafeNode = /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function (ast) {
	        var _this = this;
	        var /** @type {?} */ visit = function (visitor, ast) {
	            return (_this._nodeMap.get(ast) || ast).visit(visitor);
	        };
	        return ast.visit({
	            visitBinary: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitChain: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitConditional: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitFunctionCall: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitImplicitReceiver: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitInterpolation: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitKeyedRead: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.obj); },
	            visitKeyedWrite: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitLiteralArray: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitLiteralMap: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitLiteralPrimitive: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitMethodCall: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.receiver); },
	            visitPipe: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitPrefixNot: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitNonNullAssert: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitPropertyRead: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.receiver); },
	            visitPropertyWrite: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitQuote: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return null; },
	            visitSafeMethodCall: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.receiver) || ast; },
	            visitSafePropertyRead: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) {
	                return visit(this, ast.receiver) || ast;
	            }
	        });
	    };
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.needsTemporary = /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function (ast) {
	        var _this = this;
	        var /** @type {?} */ visit = function (visitor, ast) {
	            return ast && (_this._nodeMap.get(ast) || ast).visit(visitor);
	        };
	        var /** @type {?} */ visitSome = function (visitor, ast) {
	            return ast.some(function (ast) { return visit(visitor, ast); });
	        };
	        return ast.visit({
	            visitBinary: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.left) || visit(this, ast.right); },
	            visitChain: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitConditional: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) {
	                return visit(this, ast.condition) || visit(this, ast.trueExp) ||
	                    visit(this, ast.falseExp);
	            },
	            visitFunctionCall: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return true; },
	            visitImplicitReceiver: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitInterpolation: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visitSome(this, ast.expressions); },
	            visitKeyedRead: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitKeyedWrite: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitLiteralArray: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return true; },
	            visitLiteralMap: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return true; },
	            visitLiteralPrimitive: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitMethodCall: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return true; },
	            visitPipe: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return true; },
	            visitPrefixNot: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.expression); },
	            visitNonNullAssert: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return visit(this, ast.expression); },
	            visitPropertyRead: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitPropertyWrite: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitQuote: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; },
	            visitSafeMethodCall: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return true; },
	            visitSafePropertyRead: /**
	             * @param {?} ast
	             * @return {?}
	             */
	            function (ast) { return false; }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.allocateTemporary = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ tempNumber = this._currentTemporary++;
	        this.temporaryCount = Math.max(this._currentTemporary, this.temporaryCount);
	        return new ReadVarExpr(temporaryName(this.bindingId, tempNumber));
	    };
	    /**
	     * @param {?} temporary
	     * @return {?}
	     */
	    _AstToIrVisitor.prototype.releaseTemporary = /**
	     * @param {?} temporary
	     * @return {?}
	     */
	    function (temporary) {
	        this._currentTemporary--;
	        if (temporary.name != temporaryName(this.bindingId, this._currentTemporary)) {
	            throw new Error("Temporary " + temporary.name + " released out of order");
	        }
	    };
	    return _AstToIrVisitor;
	}());
	/**
	 * @param {?} arg
	 * @param {?} output
	 * @return {?}
	 */
	function flattenStatements(arg, output) {
	    if (Array.isArray(arg)) {
	        (/** @type {?} */ (arg)).forEach(function (entry) { return flattenStatements(entry, output); });
	    }
	    else {
	        output.push(arg);
	    }
	}
	var DefaultLocalResolver = /** @class */ (function () {
	    function DefaultLocalResolver() {
	    }
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    DefaultLocalResolver.prototype.getLocal = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (name === EventHandlerVars.event.name) {
	            return EventHandlerVars.event;
	        }
	        return null;
	    };
	    return DefaultLocalResolver;
	}());
	/**
	 * @param {?} bindingId
	 * @return {?}
	 */
	function createCurrValueExpr(bindingId) {
	    return variable("currVal_" + bindingId); // fix syntax highlighting: `
	}
	/**
	 * @param {?} bindingId
	 * @return {?}
	 */
	function createPreventDefaultVar(bindingId) {
	    return variable("pd_" + bindingId);
	}
	/**
	 * @param {?} stmt
	 * @return {?}
	 */
	function convertStmtIntoExpression(stmt) {
	    if (stmt instanceof ExpressionStatement) {
	        return stmt.expr;
	    }
	    else if (stmt instanceof ReturnStatement) {
	        return stmt.value;
	    }
	    return null;
	}
	var BuiltinFunctionCall = /** @class */ (function (_super) {
	    __extends(BuiltinFunctionCall, _super);
	    function BuiltinFunctionCall(span, args, converter) {
	        var _this = _super.call(this, span, null, args) || this;
	        _this.args = args;
	        _this.converter = converter;
	        return _this;
	    }
	    return BuiltinFunctionCall;
	}(FunctionCall));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Generates code that is used to type check templates.
	 */
	var TypeCheckCompiler = /** @class */ (function () {
	    function TypeCheckCompiler(options, reflector) {
	        this.options = options;
	        this.reflector = reflector;
	    }
	    /**
	     * Important notes:
	     * - This must not produce new `import` statements, but only refer to types outside
	     *   of the file via the variables provided via externalReferenceVars.
	     *   This allows Typescript to reuse the old program's structure as no imports have changed.
	     * - This must not produce any exports, as this would pollute the .d.ts file
	     *   and also violate the point above.
	     */
	    /**
	     * Important notes:
	     * - This must not produce new `import` statements, but only refer to types outside
	     *   of the file via the variables provided via externalReferenceVars.
	     *   This allows Typescript to reuse the old program's structure as no imports have changed.
	     * - This must not produce any exports, as this would pollute the .d.ts file
	     *   and also violate the point above.
	     * @param {?} componentId
	     * @param {?} component
	     * @param {?} template
	     * @param {?} usedPipes
	     * @param {?} externalReferenceVars
	     * @param {?} ctx
	     * @return {?}
	     */
	    TypeCheckCompiler.prototype.compileComponent = /**
	     * Important notes:
	     * - This must not produce new `import` statements, but only refer to types outside
	     *   of the file via the variables provided via externalReferenceVars.
	     *   This allows Typescript to reuse the old program's structure as no imports have changed.
	     * - This must not produce any exports, as this would pollute the .d.ts file
	     *   and also violate the point above.
	     * @param {?} componentId
	     * @param {?} component
	     * @param {?} template
	     * @param {?} usedPipes
	     * @param {?} externalReferenceVars
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (componentId, component, template, usedPipes, externalReferenceVars, ctx) {
	        var _this = this;
	        var /** @type {?} */ pipes = new Map();
	        usedPipes.forEach(function (p) { return pipes.set(p.name, p.type.reference); });
	        var /** @type {?} */ embeddedViewCount = 0;
	        var /** @type {?} */ viewBuilderFactory = function (parent, guards) {
	            var /** @type {?} */ embeddedViewIndex = embeddedViewCount++;
	            return new ViewBuilder(_this.options, _this.reflector, externalReferenceVars, parent, component.type.reference, component.isHost, embeddedViewIndex, pipes, guards, ctx, viewBuilderFactory);
	        };
	        var /** @type {?} */ visitor = viewBuilderFactory(null, []);
	        visitor.visitAll([], template);
	        return visitor.build(componentId);
	    };
	    return TypeCheckCompiler;
	}());
	var DYNAMIC_VAR_NAME = '_any';
	var TypeCheckLocalResolver = /** @class */ (function () {
	    function TypeCheckLocalResolver() {
	    }
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    TypeCheckLocalResolver.prototype.getLocal = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (name === EventHandlerVars.event.name) {
	            // References to the event should not be type-checked.
	            // TODO(chuckj): determine a better type for the event.
	            return variable(DYNAMIC_VAR_NAME);
	        }
	        return null;
	    };
	    return TypeCheckLocalResolver;
	}());
	var defaultResolver = new TypeCheckLocalResolver();
	var ViewBuilder = /** @class */ (function () {
	    function ViewBuilder(options, reflector, externalReferenceVars, parent, component, isHostComponent, embeddedViewIndex, pipes, guards, ctx, viewBuilderFactory) {
	        this.options = options;
	        this.reflector = reflector;
	        this.externalReferenceVars = externalReferenceVars;
	        this.parent = parent;
	        this.component = component;
	        this.isHostComponent = isHostComponent;
	        this.embeddedViewIndex = embeddedViewIndex;
	        this.pipes = pipes;
	        this.guards = guards;
	        this.ctx = ctx;
	        this.viewBuilderFactory = viewBuilderFactory;
	        this.refOutputVars = new Map();
	        this.variables = [];
	        this.children = [];
	        this.updates = [];
	        this.actions = [];
	    }
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    ViewBuilder.prototype.getOutputVar = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ varName;
	        if (type === this.component && this.isHostComponent) {
	            varName = DYNAMIC_VAR_NAME;
	        }
	        else if (type instanceof StaticSymbol) {
	            varName = this.externalReferenceVars.get(type);
	        }
	        else {
	            varName = DYNAMIC_VAR_NAME;
	        }
	        if (!varName) {
	            throw new Error("Illegal State: referring to a type without a variable " + JSON.stringify(type));
	        }
	        return varName;
	    };
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    ViewBuilder.prototype.getTypeGuardExpressions = /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function (ast) {
	        var /** @type {?} */ result = this.guards.slice();
	        for (var _i = 0, _a = ast.directives; _i < _a.length; _i++) {
	            var directive = _a[_i];
	            for (var _b = 0, _c = directive.inputs; _b < _c.length; _b++) {
	                var input = _c[_b];
	                var /** @type {?} */ guard = directive.directive.guards[input.directiveName];
	                if (guard) {
	                    var /** @type {?} */ useIf = guard === 'UseIf';
	                    result.push({
	                        guard: guard,
	                        useIf: useIf,
	                        expression: /** @type {?} */ ({ context: this.component, value: input.value })
	                    });
	                }
	            }
	        }
	        return result;
	    };
	    /**
	     * @param {?} variables
	     * @param {?} astNodes
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitAll = /**
	     * @param {?} variables
	     * @param {?} astNodes
	     * @return {?}
	     */
	    function (variables, astNodes) {
	        this.variables = variables;
	        templateVisitAll(this, astNodes);
	    };
	    /**
	     * @param {?} componentId
	     * @param {?=} targetStatements
	     * @return {?}
	     */
	    ViewBuilder.prototype.build = /**
	     * @param {?} componentId
	     * @param {?=} targetStatements
	     * @return {?}
	     */
	    function (componentId, targetStatements) {
	        var _this = this;
	        if (targetStatements === void 0) { targetStatements = []; }
	        this.children.forEach(function (child) { return child.build(componentId, targetStatements); });
	        var /** @type {?} */ viewStmts = [variable(DYNAMIC_VAR_NAME).set(NULL_EXPR).toDeclStmt(DYNAMIC_TYPE)];
	        var /** @type {?} */ bindingCount = 0;
	        this.updates.forEach(function (expression) {
	            var _a = _this.preprocessUpdateExpression(expression), sourceSpan = _a.sourceSpan, context = _a.context, value = _a.value;
	            var /** @type {?} */ bindingId = "" + bindingCount++;
	            var /** @type {?} */ nameResolver = context === _this.component ? _this : defaultResolver;
	            var _b = convertPropertyBinding(nameResolver, variable(_this.getOutputVar(context)), value, bindingId, BindingForm.General), stmts = _b.stmts, currValExpr = _b.currValExpr;
	            stmts.push(new ExpressionStatement(currValExpr));
	            viewStmts.push.apply(viewStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
	        });
	        this.actions.forEach(function (_a) {
	            var sourceSpan = _a.sourceSpan, context = _a.context, value = _a.value;
	            var /** @type {?} */ bindingId = "" + bindingCount++;
	            var /** @type {?} */ nameResolver = context === _this.component ? _this : defaultResolver;
	            var stmts = convertActionBinding(nameResolver, variable(_this.getOutputVar(context)), value, bindingId).stmts;
	            viewStmts.push.apply(viewStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
	        });
	        if (this.guards.length) {
	            var /** @type {?} */ guardExpression = undefined;
	            for (var _i = 0, _a = this.guards; _i < _a.length; _i++) {
	                var guard = _a[_i];
	                var _b = this.preprocessUpdateExpression(guard.expression), context = _b.context, value = _b.value;
	                var /** @type {?} */ bindingId = "" + bindingCount++;
	                var /** @type {?} */ nameResolver = context === this.component ? this : defaultResolver;
	                // We only support support simple expressions and ignore others as they
	                // are unlikely to affect type narrowing.
	                var _c = convertPropertyBinding(nameResolver, variable(this.getOutputVar(context)), value, bindingId, BindingForm.TrySimple), stmts = _c.stmts, currValExpr = _c.currValExpr;
	                if (stmts.length == 0) {
	                    var /** @type {?} */ guardClause = guard.useIf ? currValExpr : this.ctx.importExpr(guard.guard).callFn([currValExpr]);
	                    guardExpression = guardExpression ? guardExpression.and(guardClause) : guardClause;
	                }
	            }
	            if (guardExpression) {
	                viewStmts = [new IfStmt(guardExpression, viewStmts)];
	            }
	        }
	        var /** @type {?} */ viewName = "_View_" + componentId + "_" + this.embeddedViewIndex;
	        var /** @type {?} */ viewFactory = new DeclareFunctionStmt(viewName, [], viewStmts);
	        targetStatements.push(viewFactory);
	        return targetStatements;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitBoundText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ astWithSource = /** @type {?} */ (ast.value);
	        var /** @type {?} */ inter = /** @type {?} */ (astWithSource.ast);
	        inter.expressions.forEach(function (expr) {
	            return _this.updates.push({ context: _this.component, value: expr, sourceSpan: ast.sourceSpan });
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitEmbeddedTemplate = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        this.visitElementOrTemplate(ast);
	        // Note: The old view compiler used to use an `any` type
	        // for the context in any embedded view.
	        // We keep this behaivor behind a flag for now.
	        if (this.options.fullTemplateTypeCheck) {
	            // Find any applicable type guards. For example, NgIf has a type guard on ngIf
	            // (see NgIf.ngIfTypeGuard) that can be used to indicate that a template is only
	            // stamped out if ngIf is truthy so any bindings in the template can assume that,
	            // if a nullable type is used for ngIf, that expression is not null or undefined.
	            var /** @type {?} */ guards = this.getTypeGuardExpressions(ast);
	            var /** @type {?} */ childVisitor = this.viewBuilderFactory(this, guards);
	            this.children.push(childVisitor);
	            childVisitor.visitAll(ast.variables, ast.children);
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        this.visitElementOrTemplate(ast);
	        var /** @type {?} */ inputDefs = [];
	        var /** @type {?} */ updateRendererExpressions = [];
	        var /** @type {?} */ outputDefs = [];
	        ast.inputs.forEach(function (inputAst) {
	            _this.updates.push({ context: _this.component, value: inputAst.value, sourceSpan: inputAst.sourceSpan });
	        });
	        templateVisitAll(this, ast.children);
	    };
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitElementOrTemplate = /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function (ast) {
	        var _this = this;
	        ast.directives.forEach(function (dirAst) { _this.visitDirective(dirAst); });
	        ast.references.forEach(function (ref) {
	            var /** @type {?} */ outputVarType = /** @type {?} */ ((null));
	            // Note: The old view compiler used to use an `any` type
	            // for directives exposed via `exportAs`.
	            // We keep this behaivor behind a flag for now.
	            if (ref.value && ref.value.identifier && _this.options.fullTemplateTypeCheck) {
	                outputVarType = ref.value.identifier.reference;
	            }
	            else {
	                outputVarType = BuiltinTypeName.Dynamic;
	            }
	            _this.refOutputVars.set(ref.name, outputVarType);
	        });
	        ast.outputs.forEach(function (outputAst) {
	            _this.actions.push({ context: _this.component, value: outputAst.handler, sourceSpan: outputAst.sourceSpan });
	        });
	    };
	    /**
	     * @param {?} dirAst
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitDirective = /**
	     * @param {?} dirAst
	     * @return {?}
	     */
	    function (dirAst) {
	        var _this = this;
	        var /** @type {?} */ dirType = dirAst.directive.type.reference;
	        dirAst.inputs.forEach(function (input) {
	            return _this.updates.push({ context: _this.component, value: input.value, sourceSpan: input.sourceSpan });
	        });
	        // Note: The old view compiler used to use an `any` type
	        // for expressions in host properties / events.
	        // We keep this behaivor behind a flag for now.
	        if (this.options.fullTemplateTypeCheck) {
	            dirAst.hostProperties.forEach(function (inputAst) {
	                return _this.updates.push({ context: dirType, value: inputAst.value, sourceSpan: inputAst.sourceSpan });
	            });
	            dirAst.hostEvents.forEach(function (hostEventAst) {
	                return _this.actions.push({
	                    context: dirType,
	                    value: hostEventAst.handler,
	                    sourceSpan: hostEventAst.sourceSpan
	                });
	            });
	        }
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ViewBuilder.prototype.getLocal = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (name == EventHandlerVars.event.name) {
	            return variable(this.getOutputVar(BuiltinTypeName.Dynamic));
	        }
	        for (var /** @type {?} */ currBuilder = this; currBuilder; currBuilder = currBuilder.parent) {
	            var /** @type {?} */ outputVarType = void 0;
	            // check references
	            outputVarType = currBuilder.refOutputVars.get(name);
	            if (outputVarType == null) {
	                // check variables
	                var /** @type {?} */ varAst = currBuilder.variables.find(function (varAst) { return varAst.name === name; });
	                if (varAst) {
	                    outputVarType = BuiltinTypeName.Dynamic;
	                }
	            }
	            if (outputVarType != null) {
	                return variable(this.getOutputVar(outputVarType));
	            }
	        }
	        return null;
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ViewBuilder.prototype.pipeOutputVar = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var /** @type {?} */ pipe = this.pipes.get(name);
	        if (!pipe) {
	            throw new Error("Illegal State: Could not find pipe " + name + " in template of " + this.component);
	        }
	        return this.getOutputVar(pipe);
	    };
	    /**
	     * @param {?} expression
	     * @return {?}
	     */
	    ViewBuilder.prototype.preprocessUpdateExpression = /**
	     * @param {?} expression
	     * @return {?}
	     */
	    function (expression) {
	        var _this = this;
	        return {
	            sourceSpan: expression.sourceSpan,
	            context: expression.context,
	            value: convertPropertyBindingBuiltins({
	                createLiteralArrayConverter: function (argCount) {
	                    return function (args) {
	                        var /** @type {?} */ arr = literalArr(args);
	                        // Note: The old view compiler used to use an `any` type
	                        // for arrays.
	                        return _this.options.fullTemplateTypeCheck ? arr : arr.cast(DYNAMIC_TYPE);
	                    };
	                },
	                createLiteralMapConverter: function (keys) {
	                    return function (values) {
	                        var /** @type {?} */ entries = keys.map(function (k, i) {
	                            return ({
	                                key: k.key,
	                                value: values[i],
	                                quoted: k.quoted,
	                            });
	                        });
	                        var /** @type {?} */ map = literalMap(entries);
	                        // Note: The old view compiler used to use an `any` type
	                        // for maps.
	                        return _this.options.fullTemplateTypeCheck ? map : map.cast(DYNAMIC_TYPE);
	                    };
	                },
	                createPipeConverter: function (name, argCount) {
	                    return function (args) {
	                        // Note: The old view compiler used to use an `any` type
	                        // for pipes.
	                        var /** @type {?} */ pipeExpr = _this.options.fullTemplateTypeCheck ?
	                            variable(_this.pipeOutputVar(name)) :
	                            variable(_this.getOutputVar(BuiltinTypeName.Dynamic));
	                        return pipeExpr.callMethod('transform', args);
	                    };
	                },
	            }, expression.value)
	        };
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitNgContent = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitDirectiveProperty = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitReference = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitVariable = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitEvent = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitElementProperty = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitAttr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    return ViewBuilder;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var CLASS_ATTR$1 = 'class';
	var STYLE_ATTR = 'style';
	var IMPLICIT_TEMPLATE_VAR = '\$implicit';
	var ViewCompileResult = /** @class */ (function () {
	    function ViewCompileResult(viewClassVar, rendererTypeVar) {
	        this.viewClassVar = viewClassVar;
	        this.rendererTypeVar = rendererTypeVar;
	    }
	    return ViewCompileResult;
	}());
	var ViewCompiler = /** @class */ (function () {
	    function ViewCompiler(_reflector) {
	        this._reflector = _reflector;
	    }
	    /**
	     * @param {?} outputCtx
	     * @param {?} component
	     * @param {?} template
	     * @param {?} styles
	     * @param {?} usedPipes
	     * @return {?}
	     */
	    ViewCompiler.prototype.compileComponent = /**
	     * @param {?} outputCtx
	     * @param {?} component
	     * @param {?} template
	     * @param {?} styles
	     * @param {?} usedPipes
	     * @return {?}
	     */
	    function (outputCtx, component, template, styles, usedPipes) {
	        var _this = this;
	        var /** @type {?} */ embeddedViewCount = 0;
	        var /** @type {?} */ staticQueryIds = findStaticQueryIds(template);
	        var /** @type {?} */ renderComponentVarName = /** @type {?} */ ((undefined));
	        if (!component.isHost) {
	            var /** @type {?} */ template_1 = /** @type {?} */ ((component.template));
	            var /** @type {?} */ customRenderData = [];
	            if (template_1.animations && template_1.animations.length) {
	                customRenderData.push(new LiteralMapEntry('animation', convertValueToOutputAst(outputCtx, template_1.animations), true));
	            }
	            var /** @type {?} */ renderComponentVar = variable(rendererTypeName(component.type.reference));
	            renderComponentVarName = /** @type {?} */ ((renderComponentVar.name));
	            outputCtx.statements.push(renderComponentVar
	                .set(importExpr(Identifiers.createRendererType2).callFn([new LiteralMapExpr([
	                    new LiteralMapEntry('encapsulation', literal(template_1.encapsulation), false),
	                    new LiteralMapEntry('styles', styles, false),
	                    new LiteralMapEntry('data', new LiteralMapExpr(customRenderData), false)
	                ])]))
	                .toDeclStmt(importType(Identifiers.RendererType2), [StmtModifier.Final, StmtModifier.Exported]));
	        }
	        var /** @type {?} */ viewBuilderFactory = function (parent) {
	            var /** @type {?} */ embeddedViewIndex = embeddedViewCount++;
	            return new ViewBuilder$1(_this._reflector, outputCtx, parent, component, embeddedViewIndex, usedPipes, staticQueryIds, viewBuilderFactory);
	        };
	        var /** @type {?} */ visitor = viewBuilderFactory(null);
	        visitor.visitAll([], template);
	        (_a = outputCtx.statements).push.apply(_a, visitor.build());
	        return new ViewCompileResult(visitor.viewName, renderComponentVarName);
	        var _a;
	    };
	    return ViewCompiler;
	}());
	var LOG_VAR$1 = variable('_l');
	var VIEW_VAR = variable('_v');
	var CHECK_VAR = variable('_ck');
	var COMP_VAR = variable('_co');
	var EVENT_NAME_VAR = variable('en');
	var ALLOW_DEFAULT_VAR = variable("ad");
	var ViewBuilder$1 = /** @class */ (function () {
	    function ViewBuilder(reflector, outputCtx, parent, component, embeddedViewIndex, usedPipes, staticQueryIds, viewBuilderFactory) {
	        this.reflector = reflector;
	        this.outputCtx = outputCtx;
	        this.parent = parent;
	        this.component = component;
	        this.embeddedViewIndex = embeddedViewIndex;
	        this.usedPipes = usedPipes;
	        this.staticQueryIds = staticQueryIds;
	        this.viewBuilderFactory = viewBuilderFactory;
	        this.nodes = [];
	        this.purePipeNodeIndices = Object.create(null);
	        this.refNodeIndices = Object.create(null);
	        this.variables = [];
	        this.children = [];
	        // TODO(tbosch): The old view compiler used to use an `any` type
	        // for the context in any embedded view. We keep this behaivor for now
	        // to be able to introduce the new view compiler without too many errors.
	        this.compType = this.embeddedViewIndex > 0 ?
	            DYNAMIC_TYPE : /** @type {?} */
	            ((expressionType(outputCtx.importExpr(this.component.type.reference))));
	        this.viewName = viewClassName(this.component.type.reference, this.embeddedViewIndex);
	    }
	    /**
	     * @param {?} variables
	     * @param {?} astNodes
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitAll = /**
	     * @param {?} variables
	     * @param {?} astNodes
	     * @return {?}
	     */
	    function (variables, astNodes) {
	        var _this = this;
	        this.variables = variables;
	        // create the pipes for the pure pipes immediately, so that we know their indices.
	        if (!this.parent) {
	            this.usedPipes.forEach(function (pipe) {
	                if (pipe.pure) {
	                    _this.purePipeNodeIndices[pipe.name] = _this._createPipe(null, pipe);
	                }
	            });
	        }
	        if (!this.parent) {
	            var /** @type {?} */ queryIds_1 = staticViewQueryIds(this.staticQueryIds);
	            this.component.viewQueries.forEach(function (query, queryIndex) {
	                // Note: queries start with id 1 so we can use the number in a Bloom filter!
	                var /** @type {?} */ queryId = queryIndex + 1;
	                var /** @type {?} */ bindingType = query.first ? 0 /* First */ : 1;
	                var /** @type {?} */ flags = 134217728 /* TypeViewQuery */ | calcStaticDynamicQueryFlags(queryIds_1, queryId, query.first);
	                _this.nodes.push(function () {
	                    return ({
	                        sourceSpan: null,
	                        nodeFlags: flags,
	                        nodeDef: importExpr(Identifiers.queryDef).callFn([
	                            literal(flags), literal(queryId),
	                            new LiteralMapExpr([new LiteralMapEntry(query.propertyName, literal(bindingType), false)])
	                        ])
	                    });
	                });
	            });
	        }
	        templateVisitAll(this, astNodes);
	        if (this.parent && (astNodes.length === 0 || needsAdditionalRootNode(astNodes))) {
	            // if the view is an embedded view, then we need to add an additional root node in some cases
	            this.nodes.push(function () {
	                return ({
	                    sourceSpan: null,
	                    nodeFlags: 1 /* TypeElement */,
	                    nodeDef: importExpr(Identifiers.anchorDef).callFn([
	                        literal(0 /* None */), NULL_EXPR, NULL_EXPR, literal(0)
	                    ])
	                });
	            });
	        }
	    };
	    /**
	     * @param {?=} targetStatements
	     * @return {?}
	     */
	    ViewBuilder.prototype.build = /**
	     * @param {?=} targetStatements
	     * @return {?}
	     */
	    function (targetStatements) {
	        if (targetStatements === void 0) { targetStatements = []; }
	        this.children.forEach(function (child) { return child.build(targetStatements); });
	        var _a = this._createNodeExpressions(), updateRendererStmts = _a.updateRendererStmts, updateDirectivesStmts = _a.updateDirectivesStmts, nodeDefExprs = _a.nodeDefExprs;
	        var /** @type {?} */ updateRendererFn = this._createUpdateFn(updateRendererStmts);
	        var /** @type {?} */ updateDirectivesFn = this._createUpdateFn(updateDirectivesStmts);
	        var /** @type {?} */ viewFlags = 0;
	        if (!this.parent && this.component.changeDetection === ChangeDetectionStrategy.OnPush) {
	            viewFlags |= 2 /* OnPush */;
	        }
	        var /** @type {?} */ viewFactory = new DeclareFunctionStmt(this.viewName, [new FnParam(/** @type {?} */ ((LOG_VAR$1.name)))], [new ReturnStatement(importExpr(Identifiers.viewDef).callFn([
	                literal(viewFlags),
	                literalArr(nodeDefExprs),
	                updateDirectivesFn,
	                updateRendererFn,
	            ]))], importType(Identifiers.ViewDefinition), this.embeddedViewIndex === 0 ? [StmtModifier.Exported] : []);
	        targetStatements.push(viewFactory);
	        return targetStatements;
	    };
	    /**
	     * @param {?} updateStmts
	     * @return {?}
	     */
	    ViewBuilder.prototype._createUpdateFn = /**
	     * @param {?} updateStmts
	     * @return {?}
	     */
	    function (updateStmts) {
	        var /** @type {?} */ updateFn;
	        if (updateStmts.length > 0) {
	            var /** @type {?} */ preStmts = [];
	            if (!this.component.isHost && findReadVarNames(updateStmts).has(/** @type {?} */ ((COMP_VAR.name)))) {
	                preStmts.push(COMP_VAR.set(VIEW_VAR.prop('component')).toDeclStmt(this.compType));
	            }
	            updateFn = fn([
	                new FnParam(/** @type {?} */ ((CHECK_VAR.name)), INFERRED_TYPE),
	                new FnParam(/** @type {?} */ ((VIEW_VAR.name)), INFERRED_TYPE)
	            ], preStmts.concat(updateStmts), INFERRED_TYPE);
	        }
	        else {
	            updateFn = NULL_EXPR;
	        }
	        return updateFn;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitNgContent = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        // ngContentDef(ngContentIndex: number, index: number): NodeDef;
	        this.nodes.push(function () {
	            return ({
	                sourceSpan: ast.sourceSpan,
	                nodeFlags: 8 /* TypeNgContent */,
	                nodeDef: importExpr(Identifiers.ngContentDef).callFn([
	                    literal(ast.ngContentIndex), literal(ast.index)
	                ])
	            });
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        // Static text nodes have no check function
	        var /** @type {?} */ checkIndex = -1;
	        this.nodes.push(function () {
	            return ({
	                sourceSpan: ast.sourceSpan,
	                nodeFlags: 2 /* TypeText */,
	                nodeDef: importExpr(Identifiers.textDef).callFn([
	                    literal(checkIndex),
	                    literal(ast.ngContentIndex),
	                    literalArr([literal(ast.value)]),
	                ])
	            });
	        });
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitBoundText = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ nodeIndex = this.nodes.length;
	        // reserve the space in the nodeDefs array
	        this.nodes.push(/** @type {?} */ ((null)));
	        var /** @type {?} */ astWithSource = /** @type {?} */ (ast.value);
	        var /** @type {?} */ inter = /** @type {?} */ (astWithSource.ast);
	        var /** @type {?} */ updateRendererExpressions = inter.expressions.map(function (expr, bindingIndex) {
	            return _this._preprocessUpdateExpression({ nodeIndex: nodeIndex, bindingIndex: bindingIndex, sourceSpan: ast.sourceSpan, context: COMP_VAR, value: expr });
	        });
	        // Check index is the same as the node index during compilation
	        // They might only differ at runtime
	        var /** @type {?} */ checkIndex = nodeIndex;
	        this.nodes[nodeIndex] = function () {
	            return ({
	                sourceSpan: ast.sourceSpan,
	                nodeFlags: 2 /* TypeText */,
	                nodeDef: importExpr(Identifiers.textDef).callFn([
	                    literal(checkIndex),
	                    literal(ast.ngContentIndex),
	                    literalArr(inter.strings.map(function (s) { return literal(s); })),
	                ]),
	                updateRenderer: updateRendererExpressions
	            });
	        };
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitEmbeddedTemplate = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ nodeIndex = this.nodes.length;
	        // reserve the space in the nodeDefs array
	        this.nodes.push(/** @type {?} */ ((null)));
	        var _a = this._visitElementOrTemplate(nodeIndex, ast), flags = _a.flags, queryMatchesExpr = _a.queryMatchesExpr, hostEvents = _a.hostEvents;
	        var /** @type {?} */ childVisitor = this.viewBuilderFactory(this);
	        this.children.push(childVisitor);
	        childVisitor.visitAll(ast.variables, ast.children);
	        var /** @type {?} */ childCount = this.nodes.length - nodeIndex - 1;
	        // anchorDef(
	        //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], ngContentIndex: number,
	        //   childCount: number, handleEventFn?: ElementHandleEventFn, templateFactory?:
	        //   ViewDefinitionFactory): NodeDef;
	        this.nodes[nodeIndex] = function () {
	            return ({
	                sourceSpan: ast.sourceSpan,
	                nodeFlags: 1 /* TypeElement */ | flags,
	                nodeDef: importExpr(Identifiers.anchorDef).callFn([
	                    literal(flags),
	                    queryMatchesExpr,
	                    literal(ast.ngContentIndex),
	                    literal(childCount),
	                    _this._createElementHandleEventFn(nodeIndex, hostEvents),
	                    variable(childVisitor.viewName),
	                ])
	            });
	        };
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitElement = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ nodeIndex = this.nodes.length;
	        // reserve the space in the nodeDefs array so we can add children
	        this.nodes.push(/** @type {?} */ ((null)));
	        // Using a null element name creates an anchor.
	        var /** @type {?} */ elName = isNgContainer(ast.name) ? null : ast.name;
	        var _a = this._visitElementOrTemplate(nodeIndex, ast), flags = _a.flags, usedEvents = _a.usedEvents, queryMatchesExpr = _a.queryMatchesExpr, dirHostBindings = _a.hostBindings, hostEvents = _a.hostEvents;
	        var /** @type {?} */ inputDefs = [];
	        var /** @type {?} */ updateRendererExpressions = [];
	        var /** @type {?} */ outputDefs = [];
	        if (elName) {
	            var /** @type {?} */ hostBindings = ast.inputs
	                .map(function (inputAst) {
	                return ({
	                    context: /** @type {?} */ (COMP_VAR),
	                    inputAst: inputAst,
	                    dirAst: /** @type {?} */ (null),
	                });
	            })
	                .concat(dirHostBindings);
	            if (hostBindings.length) {
	                updateRendererExpressions =
	                    hostBindings.map(function (hostBinding, bindingIndex) {
	                        return _this._preprocessUpdateExpression({
	                            context: hostBinding.context,
	                            nodeIndex: nodeIndex,
	                            bindingIndex: bindingIndex,
	                            sourceSpan: hostBinding.inputAst.sourceSpan,
	                            value: hostBinding.inputAst.value
	                        });
	                    });
	                inputDefs = hostBindings.map(function (hostBinding) { return elementBindingDef(hostBinding.inputAst, hostBinding.dirAst); });
	            }
	            outputDefs = usedEvents.map(function (_a) {
	                var target = _a[0], eventName = _a[1];
	                return literalArr([literal(target), literal(eventName)]);
	            });
	        }
	        templateVisitAll(this, ast.children);
	        var /** @type {?} */ childCount = this.nodes.length - nodeIndex - 1;
	        var /** @type {?} */ compAst = ast.directives.find(function (dirAst) { return dirAst.directive.isComponent; });
	        var /** @type {?} */ compRendererType = /** @type {?} */ (NULL_EXPR);
	        var /** @type {?} */ compView = /** @type {?} */ (NULL_EXPR);
	        if (compAst) {
	            compView = this.outputCtx.importExpr(compAst.directive.componentViewType);
	            compRendererType = this.outputCtx.importExpr(compAst.directive.rendererType);
	        }
	        // Check index is the same as the node index during compilation
	        // They might only differ at runtime
	        var /** @type {?} */ checkIndex = nodeIndex;
	        this.nodes[nodeIndex] = function () {
	            return ({
	                sourceSpan: ast.sourceSpan,
	                nodeFlags: 1 /* TypeElement */ | flags,
	                nodeDef: importExpr(Identifiers.elementDef).callFn([
	                    literal(checkIndex),
	                    literal(flags),
	                    queryMatchesExpr,
	                    literal(ast.ngContentIndex),
	                    literal(childCount),
	                    literal(elName),
	                    elName ? fixedAttrsDef(ast) : NULL_EXPR,
	                    inputDefs.length ? literalArr(inputDefs) : NULL_EXPR,
	                    outputDefs.length ? literalArr(outputDefs) : NULL_EXPR,
	                    _this._createElementHandleEventFn(nodeIndex, hostEvents),
	                    compView,
	                    compRendererType,
	                ]),
	                updateRenderer: updateRendererExpressions
	            });
	        };
	    };
	    /**
	     * @param {?} nodeIndex
	     * @param {?} ast
	     * @return {?}
	     */
	    ViewBuilder.prototype._visitElementOrTemplate = /**
	     * @param {?} nodeIndex
	     * @param {?} ast
	     * @return {?}
	     */
	    function (nodeIndex, ast) {
	        var _this = this;
	        var /** @type {?} */ flags = 0;
	        if (ast.hasViewContainer) {
	            flags |= 16777216 /* EmbeddedViews */;
	        }
	        var /** @type {?} */ usedEvents = new Map();
	        ast.outputs.forEach(function (event) {
	            var _a = elementEventNameAndTarget(event, null), name = _a.name, target = _a.target;
	            usedEvents.set(elementEventFullName(target, name), [target, name]);
	        });
	        ast.directives.forEach(function (dirAst) {
	            dirAst.hostEvents.forEach(function (event) {
	                var _a = elementEventNameAndTarget(event, dirAst), name = _a.name, target = _a.target;
	                usedEvents.set(elementEventFullName(target, name), [target, name]);
	            });
	        });
	        var /** @type {?} */ hostBindings = [];
	        var /** @type {?} */ hostEvents = [];
	        this._visitComponentFactoryResolverProvider(ast.directives);
	        ast.providers.forEach(function (providerAst, providerIndex) {
	            var /** @type {?} */ dirAst = /** @type {?} */ ((undefined));
	            var /** @type {?} */ dirIndex = /** @type {?} */ ((undefined));
	            ast.directives.forEach(function (localDirAst, i) {
	                if (localDirAst.directive.type.reference === tokenReference(providerAst.token)) {
	                    dirAst = localDirAst;
	                    dirIndex = i;
	                }
	            });
	            if (dirAst) {
	                var _a = _this._visitDirective(providerAst, dirAst, dirIndex, nodeIndex, ast.references, ast.queryMatches, usedEvents, /** @type {?} */ ((_this.staticQueryIds.get(/** @type {?} */ (ast))))), dirHostBindings = _a.hostBindings, dirHostEvents = _a.hostEvents;
	                hostBindings.push.apply(hostBindings, dirHostBindings);
	                hostEvents.push.apply(hostEvents, dirHostEvents);
	            }
	            else {
	                _this._visitProvider(providerAst, ast.queryMatches);
	            }
	        });
	        var /** @type {?} */ queryMatchExprs = [];
	        ast.queryMatches.forEach(function (match) {
	            var /** @type {?} */ valueType = /** @type {?} */ ((undefined));
	            if (tokenReference(match.value) ===
	                _this.reflector.resolveExternalReference(Identifiers.ElementRef)) {
	                valueType = 0 /* ElementRef */;
	            }
	            else if (tokenReference(match.value) ===
	                _this.reflector.resolveExternalReference(Identifiers.ViewContainerRef)) {
	                valueType = 3 /* ViewContainerRef */;
	            }
	            else if (tokenReference(match.value) ===
	                _this.reflector.resolveExternalReference(Identifiers.TemplateRef)) {
	                valueType = 2 /* TemplateRef */;
	            }
	            if (valueType != null) {
	                queryMatchExprs.push(literalArr([literal(match.queryId), literal(valueType)]));
	            }
	        });
	        ast.references.forEach(function (ref) {
	            var /** @type {?} */ valueType = /** @type {?} */ ((undefined));
	            if (!ref.value) {
	                valueType = 1 /* RenderElement */;
	            }
	            else if (tokenReference(ref.value) ===
	                _this.reflector.resolveExternalReference(Identifiers.TemplateRef)) {
	                valueType = 2 /* TemplateRef */;
	            }
	            if (valueType != null) {
	                _this.refNodeIndices[ref.name] = nodeIndex;
	                queryMatchExprs.push(literalArr([literal(ref.name), literal(valueType)]));
	            }
	        });
	        ast.outputs.forEach(function (outputAst) {
	            hostEvents.push({ context: COMP_VAR, eventAst: outputAst, dirAst: /** @type {?} */ ((null)) });
	        });
	        return {
	            flags: flags,
	            usedEvents: Array.from(usedEvents.values()),
	            queryMatchesExpr: queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
	            hostBindings: hostBindings,
	            hostEvents: hostEvents
	        };
	    };
	    /**
	     * @param {?} providerAst
	     * @param {?} dirAst
	     * @param {?} directiveIndex
	     * @param {?} elementNodeIndex
	     * @param {?} refs
	     * @param {?} queryMatches
	     * @param {?} usedEvents
	     * @param {?} queryIds
	     * @return {?}
	     */
	    ViewBuilder.prototype._visitDirective = /**
	     * @param {?} providerAst
	     * @param {?} dirAst
	     * @param {?} directiveIndex
	     * @param {?} elementNodeIndex
	     * @param {?} refs
	     * @param {?} queryMatches
	     * @param {?} usedEvents
	     * @param {?} queryIds
	     * @return {?}
	     */
	    function (providerAst, dirAst, directiveIndex, elementNodeIndex, refs, queryMatches, usedEvents, queryIds) {
	        var _this = this;
	        var /** @type {?} */ nodeIndex = this.nodes.length;
	        // reserve the space in the nodeDefs array so we can add children
	        this.nodes.push(/** @type {?} */ ((null)));
	        dirAst.directive.queries.forEach(function (query, queryIndex) {
	            var /** @type {?} */ queryId = dirAst.contentQueryStartId + queryIndex;
	            var /** @type {?} */ flags = 67108864 /* TypeContentQuery */ | calcStaticDynamicQueryFlags(queryIds, queryId, query.first);
	            var /** @type {?} */ bindingType = query.first ? 0 /* First */ : 1;
	            _this.nodes.push(function () {
	                return ({
	                    sourceSpan: dirAst.sourceSpan,
	                    nodeFlags: flags,
	                    nodeDef: importExpr(Identifiers.queryDef).callFn([
	                        literal(flags), literal(queryId),
	                        new LiteralMapExpr([new LiteralMapEntry(query.propertyName, literal(bindingType), false)])
	                    ]),
	                });
	            });
	        });
	        // Note: the operation below might also create new nodeDefs,
	        // but we don't want them to be a child of a directive,
	        // as they might be a provider/pipe on their own.
	        // I.e. we only allow queries as children of directives nodes.
	        var /** @type {?} */ childCount = this.nodes.length - nodeIndex - 1;
	        var _a = this._visitProviderOrDirective(providerAst, queryMatches), flags = _a.flags, queryMatchExprs = _a.queryMatchExprs, providerExpr = _a.providerExpr, depsExpr = _a.depsExpr;
	        refs.forEach(function (ref) {
	            if (ref.value && tokenReference(ref.value) === tokenReference(providerAst.token)) {
	                _this.refNodeIndices[ref.name] = nodeIndex;
	                queryMatchExprs.push(literalArr([literal(ref.name), literal(4 /* Provider */)]));
	            }
	        });
	        if (dirAst.directive.isComponent) {
	            flags |= 32768 /* Component */;
	        }
	        var /** @type {?} */ inputDefs = dirAst.inputs.map(function (inputAst, inputIndex) {
	            var /** @type {?} */ mapValue = literalArr([literal(inputIndex), literal(inputAst.directiveName)]);
	            // Note: it's important to not quote the key so that we can capture renames by minifiers!
	            return new LiteralMapEntry(inputAst.directiveName, mapValue, false);
	        });
	        var /** @type {?} */ outputDefs = [];
	        var /** @type {?} */ dirMeta = dirAst.directive;
	        Object.keys(dirMeta.outputs).forEach(function (propName) {
	            var /** @type {?} */ eventName = dirMeta.outputs[propName];
	            if (usedEvents.has(eventName)) {
	                // Note: it's important to not quote the key so that we can capture renames by minifiers!
	                outputDefs.push(new LiteralMapEntry(propName, literal(eventName), false));
	            }
	        });
	        var /** @type {?} */ updateDirectiveExpressions = [];
	        if (dirAst.inputs.length || (flags & (262144 /* DoCheck */ | 65536 /* OnInit */)) > 0) {
	            updateDirectiveExpressions =
	                dirAst.inputs.map(function (input, bindingIndex) {
	                    return _this._preprocessUpdateExpression({
	                        nodeIndex: nodeIndex,
	                        bindingIndex: bindingIndex,
	                        sourceSpan: input.sourceSpan,
	                        context: COMP_VAR,
	                        value: input.value
	                    });
	                });
	        }
	        var /** @type {?} */ dirContextExpr = importExpr(Identifiers.nodeValue).callFn([VIEW_VAR, literal(nodeIndex)]);
	        var /** @type {?} */ hostBindings = dirAst.hostProperties.map(function (inputAst) {
	            return ({
	                context: dirContextExpr,
	                dirAst: dirAst,
	                inputAst: inputAst,
	            });
	        });
	        var /** @type {?} */ hostEvents = dirAst.hostEvents.map(function (hostEventAst) {
	            return ({
	                context: dirContextExpr,
	                eventAst: hostEventAst, dirAst: dirAst,
	            });
	        });
	        // Check index is the same as the node index during compilation
	        // They might only differ at runtime
	        var /** @type {?} */ checkIndex = nodeIndex;
	        this.nodes[nodeIndex] = function () {
	            return ({
	                sourceSpan: dirAst.sourceSpan,
	                nodeFlags: 16384 /* TypeDirective */ | flags,
	                nodeDef: importExpr(Identifiers.directiveDef).callFn([
	                    literal(checkIndex),
	                    literal(flags),
	                    queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
	                    literal(childCount),
	                    providerExpr,
	                    depsExpr,
	                    inputDefs.length ? new LiteralMapExpr(inputDefs) : NULL_EXPR,
	                    outputDefs.length ? new LiteralMapExpr(outputDefs) : NULL_EXPR,
	                ]),
	                updateDirectives: updateDirectiveExpressions,
	                directive: dirAst.directive.type,
	            });
	        };
	        return { hostBindings: hostBindings, hostEvents: hostEvents };
	    };
	    /**
	     * @param {?} providerAst
	     * @param {?} queryMatches
	     * @return {?}
	     */
	    ViewBuilder.prototype._visitProvider = /**
	     * @param {?} providerAst
	     * @param {?} queryMatches
	     * @return {?}
	     */
	    function (providerAst, queryMatches) {
	        this._addProviderNode(this._visitProviderOrDirective(providerAst, queryMatches));
	    };
	    /**
	     * @param {?} directives
	     * @return {?}
	     */
	    ViewBuilder.prototype._visitComponentFactoryResolverProvider = /**
	     * @param {?} directives
	     * @return {?}
	     */
	    function (directives) {
	        var /** @type {?} */ componentDirMeta = directives.find(function (dirAst) { return dirAst.directive.isComponent; });
	        if (componentDirMeta && componentDirMeta.directive.entryComponents.length) {
	            var _a = componentFactoryResolverProviderDef(this.reflector, this.outputCtx, 8192 /* PrivateProvider */, componentDirMeta.directive.entryComponents), providerExpr = _a.providerExpr, depsExpr = _a.depsExpr, flags = _a.flags, tokenExpr = _a.tokenExpr;
	            this._addProviderNode({
	                providerExpr: providerExpr,
	                depsExpr: depsExpr,
	                flags: flags,
	                tokenExpr: tokenExpr,
	                queryMatchExprs: [],
	                sourceSpan: componentDirMeta.sourceSpan
	            });
	        }
	    };
	    /**
	     * @param {?} data
	     * @return {?}
	     */
	    ViewBuilder.prototype._addProviderNode = /**
	     * @param {?} data
	     * @return {?}
	     */
	    function (data) {
	        var /** @type {?} */ nodeIndex = this.nodes.length;
	        // providerDef(
	        //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], token:any,
	        //   value: any, deps: ([DepFlags, any] | any)[]): NodeDef;
	        this.nodes.push(function () {
	            return ({
	                sourceSpan: data.sourceSpan,
	                nodeFlags: data.flags,
	                nodeDef: importExpr(Identifiers.providerDef).callFn([
	                    literal(data.flags),
	                    data.queryMatchExprs.length ? literalArr(data.queryMatchExprs) : NULL_EXPR,
	                    data.tokenExpr, data.providerExpr, data.depsExpr
	                ])
	            });
	        });
	    };
	    /**
	     * @param {?} providerAst
	     * @param {?} queryMatches
	     * @return {?}
	     */
	    ViewBuilder.prototype._visitProviderOrDirective = /**
	     * @param {?} providerAst
	     * @param {?} queryMatches
	     * @return {?}
	     */
	    function (providerAst, queryMatches) {
	        var /** @type {?} */ flags = 0;
	        var /** @type {?} */ queryMatchExprs = [];
	        queryMatches.forEach(function (match) {
	            if (tokenReference(match.value) === tokenReference(providerAst.token)) {
	                queryMatchExprs.push(literalArr([literal(match.queryId), literal(4 /* Provider */)]));
	            }
	        });
	        var _a = providerDef(this.outputCtx, providerAst), providerExpr = _a.providerExpr, depsExpr = _a.depsExpr, providerFlags = _a.flags, tokenExpr = _a.tokenExpr;
	        return {
	            flags: flags | providerFlags,
	            queryMatchExprs: queryMatchExprs,
	            providerExpr: providerExpr,
	            depsExpr: depsExpr,
	            tokenExpr: tokenExpr,
	            sourceSpan: providerAst.sourceSpan
	        };
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ViewBuilder.prototype.getLocal = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (name == EventHandlerVars.event.name) {
	            return EventHandlerVars.event;
	        }
	        var /** @type {?} */ currViewExpr = VIEW_VAR;
	        for (var /** @type {?} */ currBuilder = this; currBuilder; currBuilder = currBuilder.parent,
	            currViewExpr = currViewExpr.prop('parent').cast(DYNAMIC_TYPE)) {
	            // check references
	            var /** @type {?} */ refNodeIndex = currBuilder.refNodeIndices[name];
	            if (refNodeIndex != null) {
	                return importExpr(Identifiers.nodeValue).callFn([currViewExpr, literal(refNodeIndex)]);
	            }
	            // check variables
	            var /** @type {?} */ varAst = currBuilder.variables.find(function (varAst) { return varAst.name === name; });
	            if (varAst) {
	                var /** @type {?} */ varValue = varAst.value || IMPLICIT_TEMPLATE_VAR;
	                return currViewExpr.prop('context').prop(varValue);
	            }
	        }
	        return null;
	    };
	    /**
	     * @param {?} sourceSpan
	     * @param {?} argCount
	     * @return {?}
	     */
	    ViewBuilder.prototype._createLiteralArrayConverter = /**
	     * @param {?} sourceSpan
	     * @param {?} argCount
	     * @return {?}
	     */
	    function (sourceSpan, argCount) {
	        if (argCount === 0) {
	            var /** @type {?} */ valueExpr_1 = importExpr(Identifiers.EMPTY_ARRAY);
	            return function () { return valueExpr_1; };
	        }
	        var /** @type {?} */ checkIndex = this.nodes.length;
	        this.nodes.push(function () {
	            return ({
	                sourceSpan: sourceSpan,
	                nodeFlags: 32 /* TypePureArray */,
	                nodeDef: importExpr(Identifiers.pureArrayDef).callFn([
	                    literal(checkIndex),
	                    literal(argCount),
	                ])
	            });
	        });
	        return function (args) { return callCheckStmt(checkIndex, args); };
	    };
	    /**
	     * @param {?} sourceSpan
	     * @param {?} keys
	     * @return {?}
	     */
	    ViewBuilder.prototype._createLiteralMapConverter = /**
	     * @param {?} sourceSpan
	     * @param {?} keys
	     * @return {?}
	     */
	    function (sourceSpan, keys) {
	        if (keys.length === 0) {
	            var /** @type {?} */ valueExpr_2 = importExpr(Identifiers.EMPTY_MAP);
	            return function () { return valueExpr_2; };
	        }
	        var /** @type {?} */ map = literalMap(keys.map(function (e, i) { return (__assign({}, e, { value: literal(i) })); }));
	        var /** @type {?} */ checkIndex = this.nodes.length;
	        this.nodes.push(function () {
	            return ({
	                sourceSpan: sourceSpan,
	                nodeFlags: 64 /* TypePureObject */,
	                nodeDef: importExpr(Identifiers.pureObjectDef).callFn([
	                    literal(checkIndex),
	                    map,
	                ])
	            });
	        });
	        return function (args) { return callCheckStmt(checkIndex, args); };
	    };
	    /**
	     * @param {?} expression
	     * @param {?} name
	     * @param {?} argCount
	     * @return {?}
	     */
	    ViewBuilder.prototype._createPipeConverter = /**
	     * @param {?} expression
	     * @param {?} name
	     * @param {?} argCount
	     * @return {?}
	     */
	    function (expression, name, argCount) {
	        var /** @type {?} */ pipe = /** @type {?} */ ((this.usedPipes.find(function (pipeSummary) { return pipeSummary.name === name; })));
	        if (pipe.pure) {
	            var /** @type {?} */ checkIndex_1 = this.nodes.length;
	            this.nodes.push(function () {
	                return ({
	                    sourceSpan: expression.sourceSpan,
	                    nodeFlags: 128 /* TypePurePipe */,
	                    nodeDef: importExpr(Identifiers.purePipeDef).callFn([
	                        literal(checkIndex_1),
	                        literal(argCount),
	                    ])
	                });
	            });
	            // find underlying pipe in the component view
	            var /** @type {?} */ compViewExpr = VIEW_VAR;
	            var /** @type {?} */ compBuilder = this;
	            while (compBuilder.parent) {
	                compBuilder = compBuilder.parent;
	                compViewExpr = compViewExpr.prop('parent').cast(DYNAMIC_TYPE);
	            }
	            var /** @type {?} */ pipeNodeIndex = compBuilder.purePipeNodeIndices[name];
	            var /** @type {?} */ pipeValueExpr_1 = importExpr(Identifiers.nodeValue).callFn([compViewExpr, literal(pipeNodeIndex)]);
	            return function (args) {
	                return callUnwrapValue(expression.nodeIndex, expression.bindingIndex, callCheckStmt(checkIndex_1, [pipeValueExpr_1].concat(args)));
	            };
	        }
	        else {
	            var /** @type {?} */ nodeIndex = this._createPipe(expression.sourceSpan, pipe);
	            var /** @type {?} */ nodeValueExpr_1 = importExpr(Identifiers.nodeValue).callFn([VIEW_VAR, literal(nodeIndex)]);
	            return function (args) {
	                return callUnwrapValue(expression.nodeIndex, expression.bindingIndex, nodeValueExpr_1.callMethod('transform', args));
	            };
	        }
	    };
	    /**
	     * @param {?} sourceSpan
	     * @param {?} pipe
	     * @return {?}
	     */
	    ViewBuilder.prototype._createPipe = /**
	     * @param {?} sourceSpan
	     * @param {?} pipe
	     * @return {?}
	     */
	    function (sourceSpan, pipe) {
	        var _this = this;
	        var /** @type {?} */ nodeIndex = this.nodes.length;
	        var /** @type {?} */ flags = 0;
	        pipe.type.lifecycleHooks.forEach(function (lifecycleHook) {
	            // for pipes, we only support ngOnDestroy
	            if (lifecycleHook === LifecycleHooks.OnDestroy) {
	                flags |= lifecycleHookToNodeFlag(lifecycleHook);
	            }
	        });
	        var /** @type {?} */ depExprs = pipe.type.diDeps.map(function (diDep) { return depDef(_this.outputCtx, diDep); });
	        // function pipeDef(
	        //   flags: NodeFlags, ctor: any, deps: ([DepFlags, any] | any)[]): NodeDef
	        this.nodes.push(function () {
	            return ({
	                sourceSpan: sourceSpan,
	                nodeFlags: 16 /* TypePipe */,
	                nodeDef: importExpr(Identifiers.pipeDef).callFn([
	                    literal(flags), _this.outputCtx.importExpr(pipe.type.reference), literalArr(depExprs)
	                ])
	            });
	        });
	        return nodeIndex;
	    };
	    /**
	     * For the AST in `UpdateExpression.value`:
	     * - create nodes for pipes, literal arrays and, literal maps,
	     * - update the AST to replace pipes, literal arrays and, literal maps with calls to check fn.
	     *
	     * WARNING: This might create new nodeDefs (for pipes and literal arrays and literal maps)!
	     * @param {?} expression
	     * @return {?}
	     */
	    ViewBuilder.prototype._preprocessUpdateExpression = /**
	     * For the AST in `UpdateExpression.value`:
	     * - create nodes for pipes, literal arrays and, literal maps,
	     * - update the AST to replace pipes, literal arrays and, literal maps with calls to check fn.
	     *
	     * WARNING: This might create new nodeDefs (for pipes and literal arrays and literal maps)!
	     * @param {?} expression
	     * @return {?}
	     */
	    function (expression) {
	        var _this = this;
	        return {
	            nodeIndex: expression.nodeIndex,
	            bindingIndex: expression.bindingIndex,
	            sourceSpan: expression.sourceSpan,
	            context: expression.context,
	            value: convertPropertyBindingBuiltins({
	                createLiteralArrayConverter: function (argCount) {
	                    return _this._createLiteralArrayConverter(expression.sourceSpan, argCount);
	                },
	                createLiteralMapConverter: function (keys) {
	                    return _this._createLiteralMapConverter(expression.sourceSpan, keys);
	                },
	                createPipeConverter: function (name, argCount) {
	                    return _this._createPipeConverter(expression, name, argCount);
	                }
	            }, expression.value)
	        };
	    };
	    /**
	     * @return {?}
	     */
	    ViewBuilder.prototype._createNodeExpressions = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ self = this;
	        var /** @type {?} */ updateBindingCount = 0;
	        var /** @type {?} */ updateRendererStmts = [];
	        var /** @type {?} */ updateDirectivesStmts = [];
	        var /** @type {?} */ nodeDefExprs = this.nodes.map(function (factory, nodeIndex) {
	            var _a = factory(), nodeDef = _a.nodeDef, nodeFlags = _a.nodeFlags, updateDirectives = _a.updateDirectives, updateRenderer = _a.updateRenderer, sourceSpan = _a.sourceSpan;
	            if (updateRenderer) {
	                updateRendererStmts.push.apply(updateRendererStmts, createUpdateStatements(nodeIndex, sourceSpan, updateRenderer, false));
	            }
	            if (updateDirectives) {
	                updateDirectivesStmts.push.apply(updateDirectivesStmts, createUpdateStatements(nodeIndex, sourceSpan, updateDirectives, (nodeFlags & (262144 /* DoCheck */ | 65536 /* OnInit */)) > 0));
	            }
	            // We use a comma expression to call the log function before
	            // the nodeDef function, but still use the result of the nodeDef function
	            // as the value.
	            // Note: We only add the logger to elements / text nodes,
	            // so we don't generate too much code.
	            var /** @type {?} */ logWithNodeDef = nodeFlags & 3 /* CatRenderNode */ ?
	                new CommaExpr([LOG_VAR$1.callFn([]).callFn([]), nodeDef]) :
	                nodeDef;
	            return applySourceSpanToExpressionIfNeeded(logWithNodeDef, sourceSpan);
	        });
	        return { updateRendererStmts: updateRendererStmts, updateDirectivesStmts: updateDirectivesStmts, nodeDefExprs: nodeDefExprs };
	        /**
	         * @param {?} nodeIndex
	         * @param {?} sourceSpan
	         * @param {?} expressions
	         * @param {?} allowEmptyExprs
	         * @return {?}
	         */
	        function createUpdateStatements(nodeIndex, sourceSpan, expressions, allowEmptyExprs) {
	            var /** @type {?} */ updateStmts = [];
	            var /** @type {?} */ exprs = expressions.map(function (_a) {
	                var sourceSpan = _a.sourceSpan, context = _a.context, value = _a.value;
	                var /** @type {?} */ bindingId = "" + updateBindingCount++;
	                var /** @type {?} */ nameResolver = context === COMP_VAR ? self : null;
	                var _b = convertPropertyBinding(nameResolver, context, value, bindingId, BindingForm.General), stmts = _b.stmts, currValExpr = _b.currValExpr;
	                updateStmts.push.apply(updateStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
	                return applySourceSpanToExpressionIfNeeded(currValExpr, sourceSpan);
	            });
	            if (expressions.length || allowEmptyExprs) {
	                updateStmts.push(applySourceSpanToStatementIfNeeded(callCheckStmt(nodeIndex, exprs).toStmt(), sourceSpan));
	            }
	            return updateStmts;
	        }
	    };
	    /**
	     * @param {?} nodeIndex
	     * @param {?} handlers
	     * @return {?}
	     */
	    ViewBuilder.prototype._createElementHandleEventFn = /**
	     * @param {?} nodeIndex
	     * @param {?} handlers
	     * @return {?}
	     */
	    function (nodeIndex, handlers) {
	        var _this = this;
	        var /** @type {?} */ handleEventStmts = [];
	        var /** @type {?} */ handleEventBindingCount = 0;
	        handlers.forEach(function (_a) {
	            var context = _a.context, eventAst = _a.eventAst, dirAst = _a.dirAst;
	            var /** @type {?} */ bindingId = "" + handleEventBindingCount++;
	            var /** @type {?} */ nameResolver = context === COMP_VAR ? _this : null;
	            var _b = convertActionBinding(nameResolver, context, eventAst.handler, bindingId), stmts = _b.stmts, allowDefault = _b.allowDefault;
	            var /** @type {?} */ trueStmts = stmts;
	            if (allowDefault) {
	                trueStmts.push(ALLOW_DEFAULT_VAR.set(allowDefault.and(ALLOW_DEFAULT_VAR)).toStmt());
	            }
	            var _c = elementEventNameAndTarget(eventAst, dirAst), eventTarget = _c.target, eventName = _c.name;
	            var /** @type {?} */ fullEventName = elementEventFullName(eventTarget, eventName);
	            handleEventStmts.push(applySourceSpanToStatementIfNeeded(new IfStmt(literal(fullEventName).identical(EVENT_NAME_VAR), trueStmts), eventAst.sourceSpan));
	        });
	        var /** @type {?} */ handleEventFn;
	        if (handleEventStmts.length > 0) {
	            var /** @type {?} */ preStmts = [ALLOW_DEFAULT_VAR.set(literal(true)).toDeclStmt(BOOL_TYPE)];
	            if (!this.component.isHost && findReadVarNames(handleEventStmts).has(/** @type {?} */ ((COMP_VAR.name)))) {
	                preStmts.push(COMP_VAR.set(VIEW_VAR.prop('component')).toDeclStmt(this.compType));
	            }
	            handleEventFn = fn([
	                new FnParam(/** @type {?} */ ((VIEW_VAR.name)), INFERRED_TYPE),
	                new FnParam(/** @type {?} */ ((EVENT_NAME_VAR.name)), INFERRED_TYPE),
	                new FnParam(/** @type {?} */ ((EventHandlerVars.event.name)), INFERRED_TYPE)
	            ], preStmts.concat(handleEventStmts, [new ReturnStatement(ALLOW_DEFAULT_VAR)]), INFERRED_TYPE);
	        }
	        else {
	            handleEventFn = NULL_EXPR;
	        }
	        return handleEventFn;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitDirective = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitDirectiveProperty = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitReference = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitVariable = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitEvent = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitElementProperty = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    ViewBuilder.prototype.visitAttr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) { };
	    return ViewBuilder;
	}());
	/**
	 * @param {?} astNodes
	 * @return {?}
	 */
	function needsAdditionalRootNode(astNodes) {
	    var /** @type {?} */ lastAstNode = astNodes[astNodes.length - 1];
	    if (lastAstNode instanceof EmbeddedTemplateAst) {
	        return lastAstNode.hasViewContainer;
	    }
	    if (lastAstNode instanceof ElementAst) {
	        if (isNgContainer(lastAstNode.name) && lastAstNode.children.length) {
	            return needsAdditionalRootNode(lastAstNode.children);
	        }
	        return lastAstNode.hasViewContainer;
	    }
	    return lastAstNode instanceof NgContentAst;
	}
	/**
	 * @param {?} inputAst
	 * @param {?} dirAst
	 * @return {?}
	 */
	function elementBindingDef(inputAst, dirAst) {
	    switch (inputAst.type) {
	        case PropertyBindingType.Attribute:
	            return literalArr([
	                literal(1 /* TypeElementAttribute */), literal(inputAst.name),
	                literal(inputAst.securityContext)
	            ]);
	        case PropertyBindingType.Property:
	            return literalArr([
	                literal(8 /* TypeProperty */), literal(inputAst.name),
	                literal(inputAst.securityContext)
	            ]);
	        case PropertyBindingType.Animation:
	            var /** @type {?} */ bindingType = 8 /* TypeProperty */ |
	                (dirAst && dirAst.directive.isComponent ? 32 /* SyntheticHostProperty */ :
	                    16 /* SyntheticProperty */);
	            return literalArr([
	                literal(bindingType), literal('@' + inputAst.name), literal(inputAst.securityContext)
	            ]);
	        case PropertyBindingType.Class:
	            return literalArr([literal(2 /* TypeElementClass */), literal(inputAst.name), NULL_EXPR]);
	        case PropertyBindingType.Style:
	            return literalArr([
	                literal(4 /* TypeElementStyle */), literal(inputAst.name), literal(inputAst.unit)
	            ]);
	    }
	}
	/**
	 * @param {?} elementAst
	 * @return {?}
	 */
	function fixedAttrsDef(elementAst) {
	    var /** @type {?} */ mapResult = Object.create(null);
	    elementAst.attrs.forEach(function (attrAst) { mapResult[attrAst.name] = attrAst.value; });
	    elementAst.directives.forEach(function (dirAst) {
	        Object.keys(dirAst.directive.hostAttributes).forEach(function (name) {
	            var /** @type {?} */ value = dirAst.directive.hostAttributes[name];
	            var /** @type {?} */ prevValue = mapResult[name];
	            mapResult[name] = prevValue != null ? mergeAttributeValue(name, prevValue, value) : value;
	        });
	    });
	    // Note: We need to sort to get a defined output order
	    // for tests and for caching generated artifacts...
	    return literalArr(Object.keys(mapResult).sort().map(function (attrName) { return literalArr([literal(attrName), literal(mapResult[attrName])]); }));
	}
	/**
	 * @param {?} attrName
	 * @param {?} attrValue1
	 * @param {?} attrValue2
	 * @return {?}
	 */
	function mergeAttributeValue(attrName, attrValue1, attrValue2) {
	    if (attrName == CLASS_ATTR$1 || attrName == STYLE_ATTR) {
	        return attrValue1 + " " + attrValue2;
	    }
	    else {
	        return attrValue2;
	    }
	}
	/**
	 * @param {?} nodeIndex
	 * @param {?} exprs
	 * @return {?}
	 */
	function callCheckStmt(nodeIndex, exprs) {
	    if (exprs.length > 10) {
	        return CHECK_VAR.callFn([VIEW_VAR, literal(nodeIndex), literal(1 /* Dynamic */), literalArr(exprs)]);
	    }
	    else {
	        return CHECK_VAR.callFn([VIEW_VAR, literal(nodeIndex), literal(0 /* Inline */)].concat(exprs));
	    }
	}
	/**
	 * @param {?} nodeIndex
	 * @param {?} bindingIdx
	 * @param {?} expr
	 * @return {?}
	 */
	function callUnwrapValue(nodeIndex, bindingIdx, expr) {
	    return importExpr(Identifiers.unwrapValue).callFn([
	        VIEW_VAR, literal(nodeIndex), literal(bindingIdx), expr
	    ]);
	}
	/**
	 * @param {?} nodes
	 * @param {?=} result
	 * @return {?}
	 */
	function findStaticQueryIds(nodes, result) {
	    if (result === void 0) { result = new Map(); }
	    nodes.forEach(function (node) {
	        var /** @type {?} */ staticQueryIds = new Set();
	        var /** @type {?} */ dynamicQueryIds = new Set();
	        var /** @type {?} */ queryMatches = /** @type {?} */ ((undefined));
	        if (node instanceof ElementAst) {
	            findStaticQueryIds(node.children, result);
	            node.children.forEach(function (child) {
	                var /** @type {?} */ childData = /** @type {?} */ ((result.get(child)));
	                childData.staticQueryIds.forEach(function (queryId) { return staticQueryIds.add(queryId); });
	                childData.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
	            });
	            queryMatches = node.queryMatches;
	        }
	        else if (node instanceof EmbeddedTemplateAst) {
	            findStaticQueryIds(node.children, result);
	            node.children.forEach(function (child) {
	                var /** @type {?} */ childData = /** @type {?} */ ((result.get(child)));
	                childData.staticQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
	                childData.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
	            });
	            queryMatches = node.queryMatches;
	        }
	        if (queryMatches) {
	            queryMatches.forEach(function (match) { return staticQueryIds.add(match.queryId); });
	        }
	        dynamicQueryIds.forEach(function (queryId) { return staticQueryIds.delete(queryId); });
	        result.set(node, { staticQueryIds: staticQueryIds, dynamicQueryIds: dynamicQueryIds });
	    });
	    return result;
	}
	/**
	 * @param {?} nodeStaticQueryIds
	 * @return {?}
	 */
	function staticViewQueryIds(nodeStaticQueryIds) {
	    var /** @type {?} */ staticQueryIds = new Set();
	    var /** @type {?} */ dynamicQueryIds = new Set();
	    Array.from(nodeStaticQueryIds.values()).forEach(function (entry) {
	        entry.staticQueryIds.forEach(function (queryId) { return staticQueryIds.add(queryId); });
	        entry.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
	    });
	    dynamicQueryIds.forEach(function (queryId) { return staticQueryIds.delete(queryId); });
	    return { staticQueryIds: staticQueryIds, dynamicQueryIds: dynamicQueryIds };
	}
	/**
	 * @param {?} eventAst
	 * @param {?} dirAst
	 * @return {?}
	 */
	function elementEventNameAndTarget(eventAst, dirAst) {
	    if (eventAst.isAnimation) {
	        return {
	            name: "@" + eventAst.name + "." + eventAst.phase,
	            target: dirAst && dirAst.directive.isComponent ? 'component' : null
	        };
	    }
	    else {
	        return eventAst;
	    }
	}
	/**
	 * @param {?} queryIds
	 * @param {?} queryId
	 * @param {?} isFirst
	 * @return {?}
	 */
	function calcStaticDynamicQueryFlags(queryIds, queryId, isFirst) {
	    var /** @type {?} */ flags = 0;
	    // Note: We only make queries static that query for a single item.
	    // This is because of backwards compatibility with the old view compiler...
	    if (isFirst && (queryIds.staticQueryIds.has(queryId) || !queryIds.dynamicQueryIds.has(queryId))) {
	        flags |= 268435456 /* StaticQuery */;
	    }
	    else {
	        flags |= 536870912 /* DynamicQuery */;
	    }
	    return flags;
	}
	/**
	 * @param {?} target
	 * @param {?} name
	 * @return {?}
	 */
	function elementEventFullName(target, name) {
	    return target ? target + ":" + name : name;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A container for message extracted from the templates.
	 */
	var MessageBundle = /** @class */ (function () {
	    function MessageBundle(_htmlParser, _implicitTags, _implicitAttrs, _locale) {
	        if (_locale === void 0) { _locale = null; }
	        this._htmlParser = _htmlParser;
	        this._implicitTags = _implicitTags;
	        this._implicitAttrs = _implicitAttrs;
	        this._locale = _locale;
	        this._messages = [];
	    }
	    /**
	     * @param {?} html
	     * @param {?} url
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    MessageBundle.prototype.updateFromTemplate = /**
	     * @param {?} html
	     * @param {?} url
	     * @param {?} interpolationConfig
	     * @return {?}
	     */
	    function (html, url, interpolationConfig) {
	        var /** @type {?} */ htmlParserResult = this._htmlParser.parse(html, url, true, interpolationConfig);
	        if (htmlParserResult.errors.length) {
	            return htmlParserResult.errors;
	        }
	        var /** @type {?} */ i18nParserResult = extractMessages(htmlParserResult.rootNodes, interpolationConfig, this._implicitTags, this._implicitAttrs);
	        if (i18nParserResult.errors.length) {
	            return i18nParserResult.errors;
	        }
	        (_a = this._messages).push.apply(_a, i18nParserResult.messages);
	        return [];
	        var _a;
	    };
	    // Return the message in the internal format
	    // The public (serialized) format might be different, see the `write` method.
	    /**
	     * @return {?}
	     */
	    MessageBundle.prototype.getMessages = /**
	     * @return {?}
	     */
	    function () { return this._messages; };
	    /**
	     * @param {?} serializer
	     * @param {?=} filterSources
	     * @return {?}
	     */
	    MessageBundle.prototype.write = /**
	     * @param {?} serializer
	     * @param {?=} filterSources
	     * @return {?}
	     */
	    function (serializer, filterSources) {
	        var /** @type {?} */ messages = {};
	        var /** @type {?} */ mapperVisitor = new MapPlaceholderNames();
	        // Deduplicate messages based on their ID
	        this._messages.forEach(function (message) {
	            var /** @type {?} */ id = serializer.digest(message);
	            if (!messages.hasOwnProperty(id)) {
	                messages[id] = message;
	            }
	            else {
	                (_a = messages[id].sources).push.apply(_a, message.sources);
	            }
	            var _a;
	        });
	        // Transform placeholder names using the serializer mapping
	        var /** @type {?} */ msgList = Object.keys(messages).map(function (id) {
	            var /** @type {?} */ mapper = serializer.createNameMapper(messages[id]);
	            var /** @type {?} */ src = messages[id];
	            var /** @type {?} */ nodes = mapper ? mapperVisitor.convert(src.nodes, mapper) : src.nodes;
	            var /** @type {?} */ transformedMessage = new Message(nodes, {}, {}, src.meaning, src.description, id);
	            transformedMessage.sources = src.sources;
	            if (filterSources) {
	                transformedMessage.sources.forEach(function (source) { return source.filePath = filterSources(source.filePath); });
	            }
	            return transformedMessage;
	        });
	        return serializer.write(msgList, this._locale);
	    };
	    return MessageBundle;
	}());
	var MapPlaceholderNames = /** @class */ (function (_super) {
	    __extends(MapPlaceholderNames, _super);
	    function MapPlaceholderNames() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} nodes
	     * @param {?} mapper
	     * @return {?}
	     */
	    MapPlaceholderNames.prototype.convert = /**
	     * @param {?} nodes
	     * @param {?} mapper
	     * @return {?}
	     */
	    function (nodes, mapper) {
	        var _this = this;
	        return mapper ? nodes.map(function (n) { return n.visit(_this, mapper); }) : nodes;
	    };
	    /**
	     * @param {?} ph
	     * @param {?} mapper
	     * @return {?}
	     */
	    MapPlaceholderNames.prototype.visitTagPlaceholder = /**
	     * @param {?} ph
	     * @param {?} mapper
	     * @return {?}
	     */
	    function (ph, mapper) {
	        var _this = this;
	        var /** @type {?} */ startName = /** @type {?} */ ((mapper.toPublicName(ph.startName)));
	        var /** @type {?} */ closeName = ph.closeName ? /** @type {?} */ ((mapper.toPublicName(ph.closeName))) : ph.closeName;
	        var /** @type {?} */ children = ph.children.map(function (n) { return n.visit(_this, mapper); });
	        return new TagPlaceholder(ph.tag, ph.attrs, startName, closeName, children, ph.isVoid, ph.sourceSpan);
	    };
	    /**
	     * @param {?} ph
	     * @param {?} mapper
	     * @return {?}
	     */
	    MapPlaceholderNames.prototype.visitPlaceholder = /**
	     * @param {?} ph
	     * @param {?} mapper
	     * @return {?}
	     */
	    function (ph, mapper) {
	        return new Placeholder(ph.value, /** @type {?} */ ((mapper.toPublicName(ph.name))), ph.sourceSpan);
	    };
	    /**
	     * @param {?} ph
	     * @param {?} mapper
	     * @return {?}
	     */
	    MapPlaceholderNames.prototype.visitIcuPlaceholder = /**
	     * @param {?} ph
	     * @param {?} mapper
	     * @return {?}
	     */
	    function (ph, mapper) {
	        return new IcuPlaceholder(ph.value, /** @type {?} */ ((mapper.toPublicName(ph.name))), ph.sourceSpan);
	    };
	    return MapPlaceholderNames;
	}(CloneVisitor));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var GeneratedFile = /** @class */ (function () {
	    function GeneratedFile(srcFileUrl, genFileUrl, sourceOrStmts) {
	        this.srcFileUrl = srcFileUrl;
	        this.genFileUrl = genFileUrl;
	        if (typeof sourceOrStmts === 'string') {
	            this.source = sourceOrStmts;
	            this.stmts = null;
	        }
	        else {
	            this.source = null;
	            this.stmts = sourceOrStmts;
	        }
	    }
	    /**
	     * @param {?} other
	     * @return {?}
	     */
	    GeneratedFile.prototype.isEquivalent = /**
	     * @param {?} other
	     * @return {?}
	     */
	    function (other) {
	        if (this.genFileUrl !== other.genFileUrl) {
	            return false;
	        }
	        if (this.source) {
	            return this.source === other.source;
	        }
	        if (other.stmts == null) {
	            return false;
	        }
	        // Note: the constructor guarantees that if this.source is not filled,
	        // then this.stmts is.
	        return areAllEquivalent(/** @type {?} */ ((this.stmts)), /** @type {?} */ ((other.stmts)));
	    };
	    return GeneratedFile;
	}());
	/**
	 * @param {?} file
	 * @param {?=} preamble
	 * @return {?}
	 */
	function toTypeScript(file, preamble) {
	    if (preamble === void 0) { preamble = ''; }
	    if (!file.stmts) {
	        throw new Error("Illegal state: No stmts present on GeneratedFile " + file.genFileUrl);
	    }
	    return new TypeScriptEmitter().emitStatements(file.genFileUrl, file.stmts, preamble);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	/**
	 * @param {?} moduleMeta
	 * @param {?} reflector
	 * @return {?}
	 */
	function listLazyRoutes(moduleMeta, reflector) {
	    var /** @type {?} */ allLazyRoutes = [];
	    for (var _i = 0, _a = moduleMeta.transitiveModule.providers; _i < _a.length; _i++) {
	        var _b = _a[_i], provider = _b.provider, module = _b.module;
	        if (tokenReference(provider.token) === reflector.ROUTES) {
	            var /** @type {?} */ loadChildren = _collectLoadChildren(provider.useValue);
	            for (var _c = 0, loadChildren_1 = loadChildren; _c < loadChildren_1.length; _c++) {
	                var route = loadChildren_1[_c];
	                allLazyRoutes.push(parseLazyRoute(route, reflector, module.reference));
	            }
	        }
	    }
	    return allLazyRoutes;
	}
	/**
	 * @param {?} routes
	 * @param {?=} target
	 * @return {?}
	 */
	function _collectLoadChildren(routes, target) {
	    if (target === void 0) { target = []; }
	    if (typeof routes === 'string') {
	        target.push(routes);
	    }
	    else if (Array.isArray(routes)) {
	        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
	            var route = routes_1[_i];
	            _collectLoadChildren(route, target);
	        }
	    }
	    else if (routes.loadChildren) {
	        _collectLoadChildren(routes.loadChildren, target);
	    }
	    else if (routes.children) {
	        _collectLoadChildren(routes.children, target);
	    }
	    return target;
	}
	/**
	 * @param {?} route
	 * @param {?} reflector
	 * @param {?=} module
	 * @return {?}
	 */
	function parseLazyRoute(route, reflector, module) {
	    var _a = route.split('#'), routePath = _a[0], routeName = _a[1];
	    var /** @type {?} */ referencedModule = reflector.resolveExternalReference({
	        moduleName: routePath,
	        name: routeName,
	    }, module ? module.filePath : undefined);
	    return { route: route, module: module || referencedModule, referencedModule: referencedModule };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ResolvedStaticSymbol = /** @class */ (function () {
	    function ResolvedStaticSymbol(symbol, metadata) {
	        this.symbol = symbol;
	        this.metadata = metadata;
	    }
	    return ResolvedStaticSymbol;
	}());
	/**
	 * The host of the SymbolResolverHost disconnects the implementation from TypeScript / other
	 * language
	 * services and from underlying file systems.
	 * @record
	 */
	
	var SUPPORTED_SCHEMA_VERSION = 4;
	/**
	 * This class is responsible for loading metadata per symbol,
	 * and normalizing references between symbols.
	 *
	 * Internally, it only uses symbols without members,
	 * and deduces the values for symbols with members based
	 * on these symbols.
	 */
	var StaticSymbolResolver = /** @class */ (function () {
	    function StaticSymbolResolver(host, staticSymbolCache, summaryResolver, errorRecorder) {
	        this.host = host;
	        this.staticSymbolCache = staticSymbolCache;
	        this.summaryResolver = summaryResolver;
	        this.errorRecorder = errorRecorder;
	        this.metadataCache = new Map();
	        this.resolvedSymbols = new Map();
	        this.resolvedFilePaths = new Set();
	        this.importAs = new Map();
	        this.symbolResourcePaths = new Map();
	        this.symbolFromFile = new Map();
	        this.knownFileNameToModuleNames = new Map();
	    }
	    /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.resolveSymbol = /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        if (staticSymbol.members.length > 0) {
	            return /** @type {?} */ ((this._resolveSymbolMembers(staticSymbol)));
	        }
	        // Note: always ask for a summary first,
	        // as we might have read shallow metadata via a .d.ts file
	        // for the symbol.
	        var /** @type {?} */ resultFromSummary = /** @type {?} */ ((this._resolveSymbolFromSummary(staticSymbol)));
	        if (resultFromSummary) {
	            return resultFromSummary;
	        }
	        var /** @type {?} */ resultFromCache = this.resolvedSymbols.get(staticSymbol);
	        if (resultFromCache) {
	            return resultFromCache;
	        }
	        // Note: Some users use libraries that were not compiled with ngc, i.e. they don't
	        // have summaries, only .d.ts files. So we always need to check both, the summary
	        // and metadata.
	        this._createSymbolsOf(staticSymbol.filePath);
	        return /** @type {?} */ ((this.resolvedSymbols.get(staticSymbol)));
	    };
	    /**
	     * getImportAs produces a symbol that can be used to import the given symbol.
	     * The import might be different than the symbol if the symbol is exported from
	     * a library with a summary; in which case we want to import the symbol from the
	     * ngfactory re-export instead of directly to avoid introducing a direct dependency
	     * on an otherwise indirect dependency.
	     *
	     * @param staticSymbol the symbol for which to generate a import symbol
	     */
	    /**
	     * getImportAs produces a symbol that can be used to import the given symbol.
	     * The import might be different than the symbol if the symbol is exported from
	     * a library with a summary; in which case we want to import the symbol from the
	     * ngfactory re-export instead of directly to avoid introducing a direct dependency
	     * on an otherwise indirect dependency.
	     *
	     * @param {?} staticSymbol the symbol for which to generate a import symbol
	     * @param {?=} useSummaries
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getImportAs = /**
	     * getImportAs produces a symbol that can be used to import the given symbol.
	     * The import might be different than the symbol if the symbol is exported from
	     * a library with a summary; in which case we want to import the symbol from the
	     * ngfactory re-export instead of directly to avoid introducing a direct dependency
	     * on an otherwise indirect dependency.
	     *
	     * @param {?} staticSymbol the symbol for which to generate a import symbol
	     * @param {?=} useSummaries
	     * @return {?}
	     */
	    function (staticSymbol, useSummaries) {
	        if (useSummaries === void 0) { useSummaries = true; }
	        if (staticSymbol.members.length) {
	            var /** @type {?} */ baseSymbol = this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name);
	            var /** @type {?} */ baseImportAs = this.getImportAs(baseSymbol, useSummaries);
	            return baseImportAs ?
	                this.getStaticSymbol(baseImportAs.filePath, baseImportAs.name, staticSymbol.members) :
	                null;
	        }
	        var /** @type {?} */ summarizedFileName = stripSummaryForJitFileSuffix(staticSymbol.filePath);
	        if (summarizedFileName !== staticSymbol.filePath) {
	            var /** @type {?} */ summarizedName = stripSummaryForJitNameSuffix(staticSymbol.name);
	            var /** @type {?} */ baseSymbol = this.getStaticSymbol(summarizedFileName, summarizedName, staticSymbol.members);
	            var /** @type {?} */ baseImportAs = this.getImportAs(baseSymbol, useSummaries);
	            return baseImportAs ?
	                this.getStaticSymbol(summaryForJitFileName(baseImportAs.filePath), summaryForJitName(baseImportAs.name), baseSymbol.members) :
	                null;
	        }
	        var /** @type {?} */ result = (useSummaries && this.summaryResolver.getImportAs(staticSymbol)) || null;
	        if (!result) {
	            result = /** @type {?} */ ((this.importAs.get(staticSymbol)));
	        }
	        return result;
	    };
	    /**
	     * getResourcePath produces the path to the original location of the symbol and should
	     * be used to determine the relative location of resource references recorded in
	     * symbol metadata.
	     */
	    /**
	     * getResourcePath produces the path to the original location of the symbol and should
	     * be used to determine the relative location of resource references recorded in
	     * symbol metadata.
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getResourcePath = /**
	     * getResourcePath produces the path to the original location of the symbol and should
	     * be used to determine the relative location of resource references recorded in
	     * symbol metadata.
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        return this.symbolResourcePaths.get(staticSymbol) || staticSymbol.filePath;
	    };
	    /**
	     * getTypeArity returns the number of generic type parameters the given symbol
	     * has. If the symbol is not a type the result is null.
	     */
	    /**
	     * getTypeArity returns the number of generic type parameters the given symbol
	     * has. If the symbol is not a type the result is null.
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getTypeArity = /**
	     * getTypeArity returns the number of generic type parameters the given symbol
	     * has. If the symbol is not a type the result is null.
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        // If the file is a factory/ngsummary file, don't resolve the symbol as doing so would
	        // cause the metadata for an factory/ngsummary file to be loaded which doesn't exist.
	        // All references to generated classes must include the correct arity whenever
	        // generating code.
	        if (isGeneratedFile(staticSymbol.filePath)) {
	            return null;
	        }
	        var /** @type {?} */ resolvedSymbol = unwrapResolvedMetadata(this.resolveSymbol(staticSymbol));
	        while (resolvedSymbol && resolvedSymbol.metadata instanceof StaticSymbol) {
	            resolvedSymbol = unwrapResolvedMetadata(this.resolveSymbol(resolvedSymbol.metadata));
	        }
	        return (resolvedSymbol && resolvedSymbol.metadata && resolvedSymbol.metadata.arity) || null;
	    };
	    /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getKnownModuleName = /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    function (filePath) {
	        return this.knownFileNameToModuleNames.get(filePath) || null;
	    };
	    /**
	     * @param {?} sourceSymbol
	     * @param {?} targetSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.recordImportAs = /**
	     * @param {?} sourceSymbol
	     * @param {?} targetSymbol
	     * @return {?}
	     */
	    function (sourceSymbol, targetSymbol) {
	        sourceSymbol.assertNoMembers();
	        targetSymbol.assertNoMembers();
	        this.importAs.set(sourceSymbol, targetSymbol);
	    };
	    /**
	     * @param {?} fileName
	     * @param {?} moduleName
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.recordModuleNameForFileName = /**
	     * @param {?} fileName
	     * @param {?} moduleName
	     * @return {?}
	     */
	    function (fileName, moduleName) {
	        this.knownFileNameToModuleNames.set(fileName, moduleName);
	    };
	    /**
	     * Invalidate all information derived from the given file.
	     *
	     * @param fileName the file to invalidate
	     */
	    /**
	     * Invalidate all information derived from the given file.
	     *
	     * @param {?} fileName the file to invalidate
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.invalidateFile = /**
	     * Invalidate all information derived from the given file.
	     *
	     * @param {?} fileName the file to invalidate
	     * @return {?}
	     */
	    function (fileName) {
	        this.metadataCache.delete(fileName);
	        this.resolvedFilePaths.delete(fileName);
	        var /** @type {?} */ symbols = this.symbolFromFile.get(fileName);
	        if (symbols) {
	            this.symbolFromFile.delete(fileName);
	            for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
	                var symbol = symbols_1[_i];
	                this.resolvedSymbols.delete(symbol);
	                this.importAs.delete(symbol);
	                this.symbolResourcePaths.delete(symbol);
	            }
	        }
	    };
	    /* @internal */
	    /**
	     * @template T
	     * @param {?} cb
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.ignoreErrorsFor = /**
	     * @template T
	     * @param {?} cb
	     * @return {?}
	     */
	    function (cb) {
	        var /** @type {?} */ recorder = this.errorRecorder;
	        this.errorRecorder = function () { };
	        try {
	            return cb();
	        }
	        finally {
	            this.errorRecorder = recorder;
	        }
	    };
	    /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype._resolveSymbolMembers = /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        var /** @type {?} */ members = staticSymbol.members;
	        var /** @type {?} */ baseResolvedSymbol = this.resolveSymbol(this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name));
	        if (!baseResolvedSymbol) {
	            return null;
	        }
	        var /** @type {?} */ baseMetadata = unwrapResolvedMetadata(baseResolvedSymbol.metadata);
	        if (baseMetadata instanceof StaticSymbol) {
	            return new ResolvedStaticSymbol(staticSymbol, this.getStaticSymbol(baseMetadata.filePath, baseMetadata.name, members));
	        }
	        else if (baseMetadata && baseMetadata.__symbolic === 'class') {
	            if (baseMetadata.statics && members.length === 1) {
	                return new ResolvedStaticSymbol(staticSymbol, baseMetadata.statics[members[0]]);
	            }
	        }
	        else {
	            var /** @type {?} */ value = baseMetadata;
	            for (var /** @type {?} */ i = 0; i < members.length && value; i++) {
	                value = value[members[i]];
	            }
	            return new ResolvedStaticSymbol(staticSymbol, value);
	        }
	        return null;
	    };
	    /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype._resolveSymbolFromSummary = /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        var /** @type {?} */ summary = this.summaryResolver.resolveSummary(staticSymbol);
	        return summary ? new ResolvedStaticSymbol(staticSymbol, summary.metadata) : null;
	    };
	    /**
	     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
	     * All types passed to the StaticResolver should be pseudo-types returned by this method.
	     *
	     * @param declarationFile the absolute path of the file where the symbol is declared
	     * @param name the name of the type.
	     * @param members a symbol for a static member of the named type
	     */
	    /**
	     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
	     * All types passed to the StaticResolver should be pseudo-types returned by this method.
	     *
	     * @param {?} declarationFile the absolute path of the file where the symbol is declared
	     * @param {?} name the name of the type.
	     * @param {?=} members a symbol for a static member of the named type
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getStaticSymbol = /**
	     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
	     * All types passed to the StaticResolver should be pseudo-types returned by this method.
	     *
	     * @param {?} declarationFile the absolute path of the file where the symbol is declared
	     * @param {?} name the name of the type.
	     * @param {?=} members a symbol for a static member of the named type
	     * @return {?}
	     */
	    function (declarationFile, name, members) {
	        return this.staticSymbolCache.get(declarationFile, name, members);
	    };
	    /**
	     * hasDecorators checks a file's metadata for the presense of decorators without evalutating the
	     * metadata.
	     *
	     * @param filePath the absolute path to examine for decorators.
	     * @returns true if any class in the file has a decorator.
	     */
	    /**
	     * hasDecorators checks a file's metadata for the presense of decorators without evalutating the
	     * metadata.
	     *
	     * @param {?} filePath the absolute path to examine for decorators.
	     * @return {?} true if any class in the file has a decorator.
	     */
	    StaticSymbolResolver.prototype.hasDecorators = /**
	     * hasDecorators checks a file's metadata for the presense of decorators without evalutating the
	     * metadata.
	     *
	     * @param {?} filePath the absolute path to examine for decorators.
	     * @return {?} true if any class in the file has a decorator.
	     */
	    function (filePath) {
	        var /** @type {?} */ metadata = this.getModuleMetadata(filePath);
	        if (metadata['metadata']) {
	            return Object.keys(metadata['metadata']).some(function (metadataKey) {
	                var /** @type {?} */ entry = metadata['metadata'][metadataKey];
	                return entry && entry.__symbolic === 'class' && entry.decorators;
	            });
	        }
	        return false;
	    };
	    /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getSymbolsOf = /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    function (filePath) {
	        var /** @type {?} */ summarySymbols = this.summaryResolver.getSymbolsOf(filePath);
	        if (summarySymbols) {
	            return summarySymbols;
	        }
	        // Note: Some users use libraries that were not compiled with ngc, i.e. they don't
	        // have summaries, only .d.ts files, but `summaryResolver.isLibraryFile` returns true.
	        this._createSymbolsOf(filePath);
	        var /** @type {?} */ metadataSymbols = [];
	        this.resolvedSymbols.forEach(function (resolvedSymbol) {
	            if (resolvedSymbol.symbol.filePath === filePath) {
	                metadataSymbols.push(resolvedSymbol.symbol);
	            }
	        });
	        return metadataSymbols;
	    };
	    /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype._createSymbolsOf = /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    function (filePath) {
	        var _this = this;
	        if (this.resolvedFilePaths.has(filePath)) {
	            return;
	        }
	        this.resolvedFilePaths.add(filePath);
	        var /** @type {?} */ resolvedSymbols = [];
	        var /** @type {?} */ metadata = this.getModuleMetadata(filePath);
	        if (metadata['importAs']) {
	            // Index bundle indices should use the importAs module name defined
	            // in the bundle.
	            this.knownFileNameToModuleNames.set(filePath, metadata['importAs']);
	        }
	        // handle the symbols in one of the re-export location
	        if (metadata['exports']) {
	            var _loop_1 = function (moduleExport) {
	                // handle the symbols in the list of explicitly re-exported symbols.
	                if (moduleExport.export) {
	                    moduleExport.export.forEach(function (exportSymbol) {
	                        var /** @type {?} */ symbolName;
	                        if (typeof exportSymbol === 'string') {
	                            symbolName = exportSymbol;
	                        }
	                        else {
	                            symbolName = exportSymbol.as;
	                        }
	                        symbolName = unescapeIdentifier(symbolName);
	                        var /** @type {?} */ symName = symbolName;
	                        if (typeof exportSymbol !== 'string') {
	                            symName = unescapeIdentifier(exportSymbol.name);
	                        }
	                        var /** @type {?} */ resolvedModule = _this.resolveModule(moduleExport.from, filePath);
	                        if (resolvedModule) {
	                            var /** @type {?} */ targetSymbol = _this.getStaticSymbol(resolvedModule, symName);
	                            var /** @type {?} */ sourceSymbol = _this.getStaticSymbol(filePath, symbolName);
	                            resolvedSymbols.push(_this.createExport(sourceSymbol, targetSymbol));
	                        }
	                    });
	                }
	                else {
	                    // handle the symbols via export * directives.
	                    var /** @type {?} */ resolvedModule = this_1.resolveModule(moduleExport.from, filePath);
	                    if (resolvedModule) {
	                        var /** @type {?} */ nestedExports = this_1.getSymbolsOf(resolvedModule);
	                        nestedExports.forEach(function (targetSymbol) {
	                            var /** @type {?} */ sourceSymbol = _this.getStaticSymbol(filePath, targetSymbol.name);
	                            resolvedSymbols.push(_this.createExport(sourceSymbol, targetSymbol));
	                        });
	                    }
	                }
	            };
	            var this_1 = this;
	            for (var _i = 0, _a = metadata['exports']; _i < _a.length; _i++) {
	                var moduleExport = _a[_i];
	                _loop_1(moduleExport);
	            }
	        }
	        // handle the actual metadata. Has to be after the exports
	        // as there migth be collisions in the names, and we want the symbols
	        // of the current module to win ofter reexports.
	        if (metadata['metadata']) {
	            // handle direct declarations of the symbol
	            var /** @type {?} */ topLevelSymbolNames_1 = new Set(Object.keys(metadata['metadata']).map(unescapeIdentifier));
	            var /** @type {?} */ origins_1 = metadata['origins'] || {};
	            Object.keys(metadata['metadata']).forEach(function (metadataKey) {
	                var /** @type {?} */ symbolMeta = metadata['metadata'][metadataKey];
	                var /** @type {?} */ name = unescapeIdentifier(metadataKey);
	                var /** @type {?} */ symbol = _this.getStaticSymbol(filePath, name);
	                var /** @type {?} */ origin = origins_1.hasOwnProperty(metadataKey) && origins_1[metadataKey];
	                if (origin) {
	                    // If the symbol is from a bundled index, use the declaration location of the
	                    // symbol so relative references (such as './my.html') will be calculated
	                    // correctly.
	                    var /** @type {?} */ originFilePath = _this.resolveModule(origin, filePath);
	                    if (!originFilePath) {
	                        _this.reportError(new Error("Couldn't resolve original symbol for " + origin + " from " + filePath));
	                    }
	                    else {
	                        _this.symbolResourcePaths.set(symbol, originFilePath);
	                    }
	                }
	                resolvedSymbols.push(_this.createResolvedSymbol(symbol, filePath, topLevelSymbolNames_1, symbolMeta));
	            });
	        }
	        resolvedSymbols.forEach(function (resolvedSymbol) { return _this.resolvedSymbols.set(resolvedSymbol.symbol, resolvedSymbol); });
	        this.symbolFromFile.set(filePath, resolvedSymbols.map(function (resolvedSymbol) { return resolvedSymbol.symbol; }));
	    };
	    /**
	     * @param {?} sourceSymbol
	     * @param {?} topLevelPath
	     * @param {?} topLevelSymbolNames
	     * @param {?} metadata
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.createResolvedSymbol = /**
	     * @param {?} sourceSymbol
	     * @param {?} topLevelPath
	     * @param {?} topLevelSymbolNames
	     * @param {?} metadata
	     * @return {?}
	     */
	    function (sourceSymbol, topLevelPath, topLevelSymbolNames, metadata) {
	        var _this = this;
	        // For classes that don't have Angular summaries / metadata,
	        // we only keep their arity, but nothing else
	        // (e.g. their constructor parameters).
	        // We do this to prevent introducing deep imports
	        // as we didn't generate .ngfactory.ts files with proper reexports.
	        if (this.summaryResolver.isLibraryFile(sourceSymbol.filePath) && metadata &&
	            metadata['__symbolic'] === 'class') {
	            var /** @type {?} */ transformedMeta_1 = { __symbolic: 'class', arity: metadata.arity };
	            return new ResolvedStaticSymbol(sourceSymbol, transformedMeta_1);
	        }
	        var /** @type {?} */ _originalFileMemo;
	        var /** @type {?} */ getOriginalName = function () {
	            if (!_originalFileMemo) {
	                // Guess what hte original file name is from the reference. If it has a `.d.ts` extension
	                // replace it with `.ts`. If it already has `.ts` just leave it in place. If it doesn't have
	                // .ts or .d.ts, append `.ts'. Also, if it is in `node_modules`, trim the `node_module`
	                // location as it is not important to finding the file.
	                _originalFileMemo =
	                    _this.host.getOutputName(topLevelPath.replace(/((\.ts)|(\.d\.ts)|)$/, '.ts')
	                        .replace(/^.*node_modules[/\\]/, ''));
	            }
	            return _originalFileMemo;
	        };
	        var /** @type {?} */ self = this;
	        var ReferenceTransformer = /** @class */ (function (_super) {
	            __extends(ReferenceTransformer, _super);
	            function ReferenceTransformer() {
	                return _super !== null && _super.apply(this, arguments) || this;
	            }
	            /**
	             * @param {?} map
	             * @param {?} functionParams
	             * @return {?}
	             */
	            ReferenceTransformer.prototype.visitStringMap = /**
	             * @param {?} map
	             * @param {?} functionParams
	             * @return {?}
	             */
	            function (map, functionParams) {
	                var /** @type {?} */ symbolic = map['__symbolic'];
	                if (symbolic === 'function') {
	                    var /** @type {?} */ oldLen = functionParams.length;
	                    functionParams.push.apply(functionParams, (map['parameters'] || []));
	                    var /** @type {?} */ result = _super.prototype.visitStringMap.call(this, map, functionParams);
	                    functionParams.length = oldLen;
	                    return result;
	                }
	                else if (symbolic === 'reference') {
	                    var /** @type {?} */ module = map['module'];
	                    var /** @type {?} */ name_1 = map['name'] ? unescapeIdentifier(map['name']) : map['name'];
	                    if (!name_1) {
	                        return null;
	                    }
	                    var /** @type {?} */ filePath = void 0;
	                    if (module) {
	                        filePath = /** @type {?} */ ((self.resolveModule(module, sourceSymbol.filePath)));
	                        if (!filePath) {
	                            return {
	                                __symbolic: 'error',
	                                message: "Could not resolve " + module + " relative to " + sourceSymbol.filePath + ".",
	                                line: map["line"],
	                                character: map["character"],
	                                fileName: getOriginalName()
	                            };
	                        }
	                        return {
	                            __symbolic: 'resolved',
	                            symbol: self.getStaticSymbol(filePath, name_1),
	                            line: map["line"],
	                            character: map["character"],
	                            fileName: getOriginalName()
	                        };
	                    }
	                    else if (functionParams.indexOf(name_1) >= 0) {
	                        // reference to a function parameter
	                        return { __symbolic: 'reference', name: name_1 };
	                    }
	                    else {
	                        if (topLevelSymbolNames.has(name_1)) {
	                            return self.getStaticSymbol(topLevelPath, name_1);
	                        }
	                        // ambient value
	                        null;
	                    }
	                }
	                else if (symbolic === 'error') {
	                    return __assign({}, map, { fileName: getOriginalName() });
	                }
	                else {
	                    return _super.prototype.visitStringMap.call(this, map, functionParams);
	                }
	            };
	            return ReferenceTransformer;
	        }(ValueTransformer));
	        var /** @type {?} */ transformedMeta = visitValue(metadata, new ReferenceTransformer(), []);
	        var /** @type {?} */ unwrappedTransformedMeta = unwrapResolvedMetadata(transformedMeta);
	        if (unwrappedTransformedMeta instanceof StaticSymbol) {
	            return this.createExport(sourceSymbol, unwrappedTransformedMeta);
	        }
	        return new ResolvedStaticSymbol(sourceSymbol, transformedMeta);
	    };
	    /**
	     * @param {?} sourceSymbol
	     * @param {?} targetSymbol
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.createExport = /**
	     * @param {?} sourceSymbol
	     * @param {?} targetSymbol
	     * @return {?}
	     */
	    function (sourceSymbol, targetSymbol) {
	        sourceSymbol.assertNoMembers();
	        targetSymbol.assertNoMembers();
	        if (this.summaryResolver.isLibraryFile(sourceSymbol.filePath) &&
	            this.summaryResolver.isLibraryFile(targetSymbol.filePath)) {
	            // This case is for an ng library importing symbols from a plain ts library
	            // transitively.
	            // Note: We rely on the fact that we discover symbols in the direction
	            // from source files to library files
	            this.importAs.set(targetSymbol, this.getImportAs(sourceSymbol) || sourceSymbol);
	        }
	        return new ResolvedStaticSymbol(sourceSymbol, targetSymbol);
	    };
	    /**
	     * @param {?} error
	     * @param {?=} context
	     * @param {?=} path
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.reportError = /**
	     * @param {?} error
	     * @param {?=} context
	     * @param {?=} path
	     * @return {?}
	     */
	    function (error, context, path) {
	        if (this.errorRecorder) {
	            this.errorRecorder(error, (context && context.filePath) || path);
	        }
	        else {
	            throw error;
	        }
	    };
	    /**
	     * @param {?} module an absolute path to a module file.
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getModuleMetadata = /**
	     * @param {?} module an absolute path to a module file.
	     * @return {?}
	     */
	    function (module) {
	        var /** @type {?} */ moduleMetadata = this.metadataCache.get(module);
	        if (!moduleMetadata) {
	            var /** @type {?} */ moduleMetadatas = this.host.getMetadataFor(module);
	            if (moduleMetadatas) {
	                var /** @type {?} */ maxVersion_1 = -1;
	                moduleMetadatas.forEach(function (md) {
	                    if (md && md['version'] > maxVersion_1) {
	                        maxVersion_1 = md['version'];
	                        moduleMetadata = md;
	                    }
	                });
	            }
	            if (!moduleMetadata) {
	                moduleMetadata =
	                    { __symbolic: 'module', version: SUPPORTED_SCHEMA_VERSION, module: module, metadata: {} };
	            }
	            if (moduleMetadata['version'] != SUPPORTED_SCHEMA_VERSION) {
	                var /** @type {?} */ errorMessage = moduleMetadata['version'] == 2 ?
	                    "Unsupported metadata version " + moduleMetadata['version'] + " for module " + module + ". This module should be compiled with a newer version of ngc" :
	                    "Metadata version mismatch for module " + module + ", found version " + moduleMetadata['version'] + ", expected " + SUPPORTED_SCHEMA_VERSION;
	                this.reportError(new Error(errorMessage));
	            }
	            this.metadataCache.set(module, moduleMetadata);
	        }
	        return moduleMetadata;
	    };
	    /**
	     * @param {?} module
	     * @param {?} symbolName
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.getSymbolByModule = /**
	     * @param {?} module
	     * @param {?} symbolName
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    function (module, symbolName, containingFile) {
	        var /** @type {?} */ filePath = this.resolveModule(module, containingFile);
	        if (!filePath) {
	            this.reportError(new Error("Could not resolve module " + module + (containingFile ? ' relative to ' +
	                containingFile : '')));
	            return this.getStaticSymbol("ERROR:" + module, symbolName);
	        }
	        return this.getStaticSymbol(filePath, symbolName);
	    };
	    /**
	     * @param {?} module
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    StaticSymbolResolver.prototype.resolveModule = /**
	     * @param {?} module
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    function (module, containingFile) {
	        try {
	            return this.host.moduleNameToFileName(module, containingFile);
	        }
	        catch (/** @type {?} */ e) {
	            console.error("Could not resolve module '" + module + "' relative to file " + containingFile);
	            this.reportError(e, undefined, containingFile);
	        }
	        return null;
	    };
	    return StaticSymbolResolver;
	}());
	/**
	 * @param {?} identifier
	 * @return {?}
	 */
	function unescapeIdentifier(identifier) {
	    return identifier.startsWith('___') ? identifier.substr(1) : identifier;
	}
	/**
	 * @param {?} metadata
	 * @return {?}
	 */
	function unwrapResolvedMetadata(metadata) {
	    if (metadata && metadata.__symbolic === 'resolved') {
	        return metadata.symbol;
	    }
	    return metadata;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @param {?} srcFileName
	 * @param {?} forJitCtx
	 * @param {?} summaryResolver
	 * @param {?} symbolResolver
	 * @param {?} symbols
	 * @param {?} types
	 * @return {?}
	 */
	function serializeSummaries(srcFileName, forJitCtx, summaryResolver, symbolResolver, symbols, types) {
	    var /** @type {?} */ toJsonSerializer = new ToJsonSerializer(symbolResolver, summaryResolver, srcFileName);
	    // for symbols, we use everything except for the class metadata itself
	    // (we keep the statics though), as the class metadata is contained in the
	    // CompileTypeSummary.
	    symbols.forEach(function (resolvedSymbol) {
	        return toJsonSerializer.addSummary({ symbol: resolvedSymbol.symbol, metadata: resolvedSymbol.metadata });
	    });
	    // Add type summaries.
	    types.forEach(function (_a) {
	        var summary = _a.summary, metadata = _a.metadata;
	        toJsonSerializer.addSummary({ symbol: summary.type.reference, metadata: undefined, type: summary });
	    });
	    var _a = toJsonSerializer.serialize(), json = _a.json, exportAs = _a.exportAs;
	    if (forJitCtx) {
	        var /** @type {?} */ forJitSerializer_1 = new ForJitSerializer(forJitCtx, symbolResolver, summaryResolver);
	        types.forEach(function (_a) {
	            var summary = _a.summary, metadata = _a.metadata;
	            forJitSerializer_1.addSourceType(summary, metadata);
	        });
	        toJsonSerializer.unprocessedSymbolSummariesBySymbol.forEach(function (summary) {
	            if (summaryResolver.isLibraryFile(summary.symbol.filePath) && summary.type) {
	                forJitSerializer_1.addLibType(summary.type);
	            }
	        });
	        forJitSerializer_1.serialize(exportAs);
	    }
	    return { json: json, exportAs: exportAs };
	}
	/**
	 * @param {?} symbolCache
	 * @param {?} summaryResolver
	 * @param {?} libraryFileName
	 * @param {?} json
	 * @return {?}
	 */
	function deserializeSummaries(symbolCache, summaryResolver, libraryFileName, json) {
	    var /** @type {?} */ deserializer = new FromJsonDeserializer(symbolCache, summaryResolver);
	    return deserializer.deserialize(libraryFileName, json);
	}
	/**
	 * @param {?} outputCtx
	 * @param {?} reference
	 * @return {?}
	 */
	function createForJitStub(outputCtx, reference) {
	    return createSummaryForJitFunction(outputCtx, reference, NULL_EXPR);
	}
	/**
	 * @param {?} outputCtx
	 * @param {?} reference
	 * @param {?} value
	 * @return {?}
	 */
	function createSummaryForJitFunction(outputCtx, reference, value) {
	    var /** @type {?} */ fnName = summaryForJitName(reference.name);
	    outputCtx.statements.push(fn([], [new ReturnStatement(value)], new ArrayType(DYNAMIC_TYPE)).toDeclStmt(fnName, [
	        StmtModifier.Final, StmtModifier.Exported
	    ]));
	}
	var ToJsonSerializer = /** @class */ (function (_super) {
	    __extends(ToJsonSerializer, _super);
	    function ToJsonSerializer(symbolResolver, summaryResolver, srcFileName) {
	        var _this = _super.call(this) || this;
	        _this.symbolResolver = symbolResolver;
	        _this.summaryResolver = summaryResolver;
	        _this.srcFileName = srcFileName;
	        _this.symbols = [];
	        _this.indexBySymbol = new Map();
	        _this.reexportedBy = new Map();
	        _this.processedSummaryBySymbol = new Map();
	        _this.processedSummaries = [];
	        _this.unprocessedSymbolSummariesBySymbol = new Map();
	        _this.moduleName = symbolResolver.getKnownModuleName(srcFileName);
	        return _this;
	    }
	    /**
	     * @param {?} summary
	     * @return {?}
	     */
	    ToJsonSerializer.prototype.addSummary = /**
	     * @param {?} summary
	     * @return {?}
	     */
	    function (summary) {
	        var _this = this;
	        var /** @type {?} */ unprocessedSummary = this.unprocessedSymbolSummariesBySymbol.get(summary.symbol);
	        var /** @type {?} */ processedSummary = this.processedSummaryBySymbol.get(summary.symbol);
	        if (!unprocessedSummary) {
	            unprocessedSummary = { symbol: summary.symbol, metadata: undefined };
	            this.unprocessedSymbolSummariesBySymbol.set(summary.symbol, unprocessedSummary);
	            processedSummary = { symbol: this.processValue(summary.symbol, 0 /* None */) };
	            this.processedSummaries.push(processedSummary);
	            this.processedSummaryBySymbol.set(summary.symbol, processedSummary);
	        }
	        if (!unprocessedSummary.metadata && summary.metadata) {
	            var /** @type {?} */ metadata_1 = summary.metadata || {};
	            if (metadata_1.__symbolic === 'class') {
	                // For classes, we keep everything except their class decorators.
	                // We need to keep e.g. the ctor args, method names, method decorators
	                // so that the class can be extended in another compilation unit.
	                // We don't keep the class decorators as
	                // 1) they refer to data
	                //   that should not cause a rebuild of downstream compilation units
	                //   (e.g. inline templates of @Component, or @NgModule.declarations)
	                // 2) their data is already captured in TypeSummaries, e.g. DirectiveSummary.
	                var /** @type {?} */ clone_1 = {};
	                Object.keys(metadata_1).forEach(function (propName) {
	                    if (propName !== 'decorators') {
	                        clone_1[propName] = metadata_1[propName];
	                    }
	                });
	                metadata_1 = clone_1;
	            }
	            else if (isCall(metadata_1)) {
	                if (!isFunctionCall(metadata_1) && !isMethodCallOnVariable(metadata_1)) {
	                    // Don't store complex calls as we won't be able to simplify them anyways later on.
	                    // Don't store complex calls as we won't be able to simplify them anyways later on.
	                    metadata_1 = {
	                        __symbolic: 'error',
	                        message: 'Complex function calls are not supported.',
	                    };
	                }
	            }
	            // Note: We need to keep storing ctor calls for e.g.
	            // `export const x = new InjectionToken(...)`
	            unprocessedSummary.metadata = metadata_1;
	            processedSummary.metadata = this.processValue(metadata_1, 1 /* ResolveValue */);
	            if (metadata_1 instanceof StaticSymbol &&
	                this.summaryResolver.isLibraryFile(metadata_1.filePath)) {
	                var /** @type {?} */ declarationSymbol = this.symbols[/** @type {?} */ ((this.indexBySymbol.get(metadata_1)))];
	                if (!isLoweredSymbol(declarationSymbol.name)) {
	                    // Note: symbols that were introduced during codegen in the user file can have a reexport
	                    // if a user used `export *`. However, we can't rely on this as tsickle will change
	                    // `export *` into named exports, using only the information from the typechecker.
	                    // As we introduce the new symbols after typecheck, Tsickle does not know about them,
	                    // and omits them when expanding `export *`.
	                    // So we have to keep reexporting these symbols manually via .ngfactory files.
	                    this.reexportedBy.set(declarationSymbol, summary.symbol);
	                }
	            }
	        }
	        if (!unprocessedSummary.type && summary.type) {
	            unprocessedSummary.type = summary.type;
	            // Note: We don't add the summaries of all referenced symbols as for the ResolvedSymbols,
	            // as the type summaries already contain the transitive data that they require
	            // (in a minimal way).
	            processedSummary.type = this.processValue(summary.type, 0 /* None */);
	            // except for reexported directives / pipes, so we need to store
	            // their summaries explicitly.
	            if (summary.type.summaryKind === CompileSummaryKind.NgModule) {
	                var /** @type {?} */ ngModuleSummary = /** @type {?} */ (summary.type);
	                ngModuleSummary.exportedDirectives.concat(ngModuleSummary.exportedPipes).forEach(function (id) {
	                    var /** @type {?} */ symbol = id.reference;
	                    if (_this.summaryResolver.isLibraryFile(symbol.filePath) &&
	                        !_this.unprocessedSymbolSummariesBySymbol.has(symbol)) {
	                        var /** @type {?} */ summary_1 = _this.summaryResolver.resolveSummary(symbol);
	                        if (summary_1) {
	                            _this.addSummary(summary_1);
	                        }
	                    }
	                });
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    ToJsonSerializer.prototype.serialize = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ exportAs = [];
	        var /** @type {?} */ json = JSON.stringify({
	            moduleName: this.moduleName,
	            summaries: this.processedSummaries,
	            symbols: this.symbols.map(function (symbol, index) {
	                symbol.assertNoMembers();
	                var /** @type {?} */ importAs = /** @type {?} */ ((undefined));
	                if (_this.summaryResolver.isLibraryFile(symbol.filePath)) {
	                    var /** @type {?} */ reexportSymbol = _this.reexportedBy.get(symbol);
	                    if (reexportSymbol) {
	                        importAs = /** @type {?} */ ((_this.indexBySymbol.get(reexportSymbol)));
	                    }
	                    else {
	                        var /** @type {?} */ summary = _this.unprocessedSymbolSummariesBySymbol.get(symbol);
	                        if (!summary || !summary.metadata || summary.metadata.__symbolic !== 'interface') {
	                            importAs = symbol.name + "_" + index;
	                            exportAs.push({ symbol: symbol, exportAs: importAs });
	                        }
	                    }
	                }
	                return {
	                    __symbol: index,
	                    name: symbol.name,
	                    filePath: _this.summaryResolver.toSummaryFileName(symbol.filePath, _this.srcFileName),
	                    importAs: importAs
	                };
	            })
	        });
	        return { json: json, exportAs: exportAs };
	    };
	    /**
	     * @param {?} value
	     * @param {?} flags
	     * @return {?}
	     */
	    ToJsonSerializer.prototype.processValue = /**
	     * @param {?} value
	     * @param {?} flags
	     * @return {?}
	     */
	    function (value, flags) {
	        return visitValue(value, this, flags);
	    };
	    /**
	     * @param {?} value
	     * @param {?} context
	     * @return {?}
	     */
	    ToJsonSerializer.prototype.visitOther = /**
	     * @param {?} value
	     * @param {?} context
	     * @return {?}
	     */
	    function (value, context) {
	        if (value instanceof StaticSymbol) {
	            var /** @type {?} */ baseSymbol = this.symbolResolver.getStaticSymbol(value.filePath, value.name);
	            var /** @type {?} */ index = this.visitStaticSymbol(baseSymbol, context);
	            return { __symbol: index, members: value.members };
	        }
	    };
	    /**
	     * Returns null if the options.resolveValue is true, and the summary for the symbol
	     * resolved to a type or could not be resolved.
	     * @param {?} baseSymbol
	     * @param {?} flags
	     * @return {?}
	     */
	    ToJsonSerializer.prototype.visitStaticSymbol = /**
	     * Returns null if the options.resolveValue is true, and the summary for the symbol
	     * resolved to a type or could not be resolved.
	     * @param {?} baseSymbol
	     * @param {?} flags
	     * @return {?}
	     */
	    function (baseSymbol, flags) {
	        var /** @type {?} */ index = this.indexBySymbol.get(baseSymbol);
	        var /** @type {?} */ summary = null;
	        if (flags & 1 /* ResolveValue */ &&
	            this.summaryResolver.isLibraryFile(baseSymbol.filePath)) {
	            if (this.unprocessedSymbolSummariesBySymbol.has(baseSymbol)) {
	                // the summary for this symbol was already added
	                // -> nothing to do.
	                return /** @type {?} */ ((index));
	            }
	            summary = this.loadSummary(baseSymbol);
	            if (summary && summary.metadata instanceof StaticSymbol) {
	                // The summary is a reexport
	                index = this.visitStaticSymbol(summary.metadata, flags);
	                // reset the summary as it is just a reexport, so we don't want to store it.
	                summary = null;
	            }
	        }
	        else if (index != null) {
	            // Note: == on purpose to compare with undefined!
	            // No summary and the symbol is already added -> nothing to do.
	            return index;
	        }
	        // Note: == on purpose to compare with undefined!
	        if (index == null) {
	            index = this.symbols.length;
	            this.symbols.push(baseSymbol);
	        }
	        this.indexBySymbol.set(baseSymbol, index);
	        if (summary) {
	            this.addSummary(summary);
	        }
	        return index;
	    };
	    /**
	     * @param {?} symbol
	     * @return {?}
	     */
	    ToJsonSerializer.prototype.loadSummary = /**
	     * @param {?} symbol
	     * @return {?}
	     */
	    function (symbol) {
	        var /** @type {?} */ summary = this.summaryResolver.resolveSummary(symbol);
	        if (!summary) {
	            // some symbols might originate from a plain typescript library
	            // that just exported .d.ts and .metadata.json files, i.e. where no summary
	            // files were created.
	            var /** @type {?} */ resolvedSymbol = this.symbolResolver.resolveSymbol(symbol);
	            if (resolvedSymbol) {
	                summary = { symbol: resolvedSymbol.symbol, metadata: resolvedSymbol.metadata };
	            }
	        }
	        return summary;
	    };
	    return ToJsonSerializer;
	}(ValueTransformer));
	var ForJitSerializer = /** @class */ (function () {
	    function ForJitSerializer(outputCtx, symbolResolver, summaryResolver) {
	        this.outputCtx = outputCtx;
	        this.symbolResolver = symbolResolver;
	        this.summaryResolver = summaryResolver;
	        this.data = [];
	    }
	    /**
	     * @param {?} summary
	     * @param {?} metadata
	     * @return {?}
	     */
	    ForJitSerializer.prototype.addSourceType = /**
	     * @param {?} summary
	     * @param {?} metadata
	     * @return {?}
	     */
	    function (summary, metadata) {
	        this.data.push({ summary: summary, metadata: metadata, isLibrary: false });
	    };
	    /**
	     * @param {?} summary
	     * @return {?}
	     */
	    ForJitSerializer.prototype.addLibType = /**
	     * @param {?} summary
	     * @return {?}
	     */
	    function (summary) {
	        this.data.push({ summary: summary, metadata: null, isLibrary: true });
	    };
	    /**
	     * @param {?} exportAsArr
	     * @return {?}
	     */
	    ForJitSerializer.prototype.serialize = /**
	     * @param {?} exportAsArr
	     * @return {?}
	     */
	    function (exportAsArr) {
	        var _this = this;
	        var /** @type {?} */ exportAsBySymbol = new Map();
	        for (var _i = 0, exportAsArr_1 = exportAsArr; _i < exportAsArr_1.length; _i++) {
	            var _a = exportAsArr_1[_i], symbol = _a.symbol, exportAs = _a.exportAs;
	            exportAsBySymbol.set(symbol, exportAs);
	        }
	        var /** @type {?} */ ngModuleSymbols = new Set();
	        for (var _b = 0, _c = this.data; _b < _c.length; _b++) {
	            var _d = _c[_b], summary = _d.summary, metadata = _d.metadata, isLibrary = _d.isLibrary;
	            if (summary.summaryKind === CompileSummaryKind.NgModule) {
	                // collect the symbols that refer to NgModule classes.
	                // Note: we can't just rely on `summary.type.summaryKind` to determine this as
	                // we don't add the summaries of all referenced symbols when we serialize type summaries.
	                // See serializeSummaries for details.
	                ngModuleSymbols.add(summary.type.reference);
	                var /** @type {?} */ modSummary = /** @type {?} */ (summary);
	                for (var _e = 0, _f = modSummary.modules; _e < _f.length; _e++) {
	                    var mod = _f[_e];
	                    ngModuleSymbols.add(mod.reference);
	                }
	            }
	            if (!isLibrary) {
	                var /** @type {?} */ fnName = summaryForJitName(summary.type.reference.name);
	                createSummaryForJitFunction(this.outputCtx, summary.type.reference, this.serializeSummaryWithDeps(summary, /** @type {?} */ ((metadata))));
	            }
	        }
	        ngModuleSymbols.forEach(function (ngModuleSymbol) {
	            if (_this.summaryResolver.isLibraryFile(ngModuleSymbol.filePath)) {
	                var /** @type {?} */ exportAs = exportAsBySymbol.get(ngModuleSymbol) || ngModuleSymbol.name;
	                var /** @type {?} */ jitExportAsName = summaryForJitName(exportAs);
	                _this.outputCtx.statements.push(variable(jitExportAsName)
	                    .set(_this.serializeSummaryRef(ngModuleSymbol))
	                    .toDeclStmt(null, [StmtModifier.Exported]));
	            }
	        });
	    };
	    /**
	     * @param {?} summary
	     * @param {?} metadata
	     * @return {?}
	     */
	    ForJitSerializer.prototype.serializeSummaryWithDeps = /**
	     * @param {?} summary
	     * @param {?} metadata
	     * @return {?}
	     */
	    function (summary, metadata) {
	        var _this = this;
	        var /** @type {?} */ expressions = [this.serializeSummary(summary)];
	        var /** @type {?} */ providers = [];
	        if (metadata instanceof CompileNgModuleMetadata) {
	            expressions.push.apply(expressions, 
	            // For directives / pipes, we only add the declared ones,
	            // and rely on transitively importing NgModules to get the transitive
	            // summaries.
	            metadata.declaredDirectives.concat(metadata.declaredPipes)
	                .map(function (type) { return type.reference; })
	                .concat(metadata.transitiveModule.modules.map(function (type) { return type.reference; })
	                .filter(function (ref) { return ref !== metadata.type.reference; }))
	                .map(function (ref) { return _this.serializeSummaryRef(ref); }));
	            // Note: We don't use `NgModuleSummary.providers`, as that one is transitive,
	            // and we already have transitive modules.
	            providers = metadata.providers;
	        }
	        else if (summary.summaryKind === CompileSummaryKind.Directive) {
	            var /** @type {?} */ dirSummary = /** @type {?} */ (summary);
	            providers = dirSummary.providers.concat(dirSummary.viewProviders);
	        }
	        // Note: We can't just refer to the `ngsummary.ts` files for `useClass` providers (as we do for
	        // declaredDirectives / declaredPipes), as we allow
	        // providers without ctor arguments to skip the `@Injectable` decorator,
	        // i.e. we didn't generate .ngsummary.ts files for these.
	        expressions.push.apply(expressions, providers.filter(function (provider) { return !!provider.useClass; }).map(function (provider) {
	            return _this.serializeSummary(/** @type {?} */ ({
	                summaryKind: CompileSummaryKind.Injectable, type: provider.useClass
	            }));
	        }));
	        return literalArr(expressions);
	    };
	    /**
	     * @param {?} typeSymbol
	     * @return {?}
	     */
	    ForJitSerializer.prototype.serializeSummaryRef = /**
	     * @param {?} typeSymbol
	     * @return {?}
	     */
	    function (typeSymbol) {
	        var /** @type {?} */ jitImportedSymbol = this.symbolResolver.getStaticSymbol(summaryForJitFileName(typeSymbol.filePath), summaryForJitName(typeSymbol.name));
	        return this.outputCtx.importExpr(jitImportedSymbol);
	    };
	    /**
	     * @param {?} data
	     * @return {?}
	     */
	    ForJitSerializer.prototype.serializeSummary = /**
	     * @param {?} data
	     * @return {?}
	     */
	    function (data) {
	        var /** @type {?} */ outputCtx = this.outputCtx;
	        var Transformer = /** @class */ (function () {
	            function Transformer() {
	            }
	            /**
	             * @param {?} arr
	             * @param {?} context
	             * @return {?}
	             */
	            Transformer.prototype.visitArray = /**
	             * @param {?} arr
	             * @param {?} context
	             * @return {?}
	             */
	            function (arr, context) {
	                var _this = this;
	                return literalArr(arr.map(function (entry) { return visitValue(entry, _this, context); }));
	            };
	            /**
	             * @param {?} map
	             * @param {?} context
	             * @return {?}
	             */
	            Transformer.prototype.visitStringMap = /**
	             * @param {?} map
	             * @param {?} context
	             * @return {?}
	             */
	            function (map, context) {
	                var _this = this;
	                return new LiteralMapExpr(Object.keys(map).map(function (key) { return new LiteralMapEntry(key, visitValue(map[key], _this, context), false); }));
	            };
	            /**
	             * @param {?} value
	             * @param {?} context
	             * @return {?}
	             */
	            Transformer.prototype.visitPrimitive = /**
	             * @param {?} value
	             * @param {?} context
	             * @return {?}
	             */
	            function (value, context) { return literal(value); };
	            /**
	             * @param {?} value
	             * @param {?} context
	             * @return {?}
	             */
	            Transformer.prototype.visitOther = /**
	             * @param {?} value
	             * @param {?} context
	             * @return {?}
	             */
	            function (value, context) {
	                if (value instanceof StaticSymbol) {
	                    return outputCtx.importExpr(value);
	                }
	                else {
	                    throw new Error("Illegal State: Encountered value " + value);
	                }
	            };
	            return Transformer;
	        }());
	        return visitValue(data, new Transformer(), null);
	    };
	    return ForJitSerializer;
	}());
	var FromJsonDeserializer = /** @class */ (function (_super) {
	    __extends(FromJsonDeserializer, _super);
	    function FromJsonDeserializer(symbolCache, summaryResolver) {
	        var _this = _super.call(this) || this;
	        _this.symbolCache = symbolCache;
	        _this.summaryResolver = summaryResolver;
	        return _this;
	    }
	    /**
	     * @param {?} libraryFileName
	     * @param {?} json
	     * @return {?}
	     */
	    FromJsonDeserializer.prototype.deserialize = /**
	     * @param {?} libraryFileName
	     * @param {?} json
	     * @return {?}
	     */
	    function (libraryFileName, json) {
	        var _this = this;
	        var /** @type {?} */ data = JSON.parse(json);
	        var /** @type {?} */ allImportAs = [];
	        this.symbols = data.symbols.map(function (serializedSymbol) {
	            return _this.symbolCache.get(_this.summaryResolver.fromSummaryFileName(serializedSymbol.filePath, libraryFileName), serializedSymbol.name);
	        });
	        data.symbols.forEach(function (serializedSymbol, index) {
	            var /** @type {?} */ symbol = _this.symbols[index];
	            var /** @type {?} */ importAs = serializedSymbol.importAs;
	            if (typeof importAs === 'number') {
	                allImportAs.push({ symbol: symbol, importAs: _this.symbols[importAs] });
	            }
	            else if (typeof importAs === 'string') {
	                allImportAs.push({ symbol: symbol, importAs: _this.symbolCache.get(ngfactoryFilePath(libraryFileName), importAs) });
	            }
	        });
	        var /** @type {?} */ summaries = /** @type {?} */ (visitValue(data.summaries, this, null));
	        return { moduleName: data.moduleName, summaries: summaries, importAs: allImportAs };
	    };
	    /**
	     * @param {?} map
	     * @param {?} context
	     * @return {?}
	     */
	    FromJsonDeserializer.prototype.visitStringMap = /**
	     * @param {?} map
	     * @param {?} context
	     * @return {?}
	     */
	    function (map, context) {
	        if ('__symbol' in map) {
	            var /** @type {?} */ baseSymbol = this.symbols[map['__symbol']];
	            var /** @type {?} */ members = map['members'];
	            return members.length ? this.symbolCache.get(baseSymbol.filePath, baseSymbol.name, members) :
	                baseSymbol;
	        }
	        else {
	            return _super.prototype.visitStringMap.call(this, map, context);
	        }
	    };
	    return FromJsonDeserializer;
	}(ValueTransformer));
	/**
	 * @param {?} metadata
	 * @return {?}
	 */
	function isCall(metadata) {
	    return metadata && metadata.__symbolic === 'call';
	}
	/**
	 * @param {?} metadata
	 * @return {?}
	 */
	function isFunctionCall(metadata) {
	    return isCall(metadata) && unwrapResolvedMetadata(metadata.expression) instanceof StaticSymbol;
	}
	/**
	 * @param {?} metadata
	 * @return {?}
	 */
	function isMethodCallOnVariable(metadata) {
	    return isCall(metadata) && metadata.expression && metadata.expression.__symbolic === 'select' &&
	        unwrapResolvedMetadata(metadata.expression.expression) instanceof StaticSymbol;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var StubEmitFlags = {
	    Basic: 1,
	    TypeCheck: 2,
	    All: 3,
	};
	StubEmitFlags[StubEmitFlags.Basic] = "Basic";
	StubEmitFlags[StubEmitFlags.TypeCheck] = "TypeCheck";
	StubEmitFlags[StubEmitFlags.All] = "All";
	var AotCompiler = /** @class */ (function () {
	    function AotCompiler(_config, _options, _host, _reflector, _metadataResolver, _templateParser, _styleCompiler, _viewCompiler, _typeCheckCompiler, _ngModuleCompiler, _outputEmitter, _summaryResolver, _symbolResolver) {
	        this._config = _config;
	        this._options = _options;
	        this._host = _host;
	        this._reflector = _reflector;
	        this._metadataResolver = _metadataResolver;
	        this._templateParser = _templateParser;
	        this._styleCompiler = _styleCompiler;
	        this._viewCompiler = _viewCompiler;
	        this._typeCheckCompiler = _typeCheckCompiler;
	        this._ngModuleCompiler = _ngModuleCompiler;
	        this._outputEmitter = _outputEmitter;
	        this._summaryResolver = _summaryResolver;
	        this._symbolResolver = _symbolResolver;
	        this._templateAstCache = new Map();
	        this._analyzedFiles = new Map();
	    }
	    /**
	     * @return {?}
	     */
	    AotCompiler.prototype.clearCache = /**
	     * @return {?}
	     */
	    function () { this._metadataResolver.clearCache(); };
	    /**
	     * @param {?} rootFiles
	     * @return {?}
	     */
	    AotCompiler.prototype.analyzeModulesSync = /**
	     * @param {?} rootFiles
	     * @return {?}
	     */
	    function (rootFiles) {
	        var _this = this;
	        var /** @type {?} */ analyzeResult = analyzeAndValidateNgModules(rootFiles, this._host, this._symbolResolver, this._metadataResolver);
	        analyzeResult.ngModules.forEach(function (ngModule) {
	            return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, true);
	        });
	        return analyzeResult;
	    };
	    /**
	     * @param {?} rootFiles
	     * @return {?}
	     */
	    AotCompiler.prototype.analyzeModulesAsync = /**
	     * @param {?} rootFiles
	     * @return {?}
	     */
	    function (rootFiles) {
	        var _this = this;
	        var /** @type {?} */ analyzeResult = analyzeAndValidateNgModules(rootFiles, this._host, this._symbolResolver, this._metadataResolver);
	        return Promise
	            .all(analyzeResult.ngModules.map(function (ngModule) {
	            return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false);
	        }))
	            .then(function () { return analyzeResult; });
	    };
	    /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    AotCompiler.prototype._analyzeFile = /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    function (fileName) {
	        var /** @type {?} */ analyzedFile = this._analyzedFiles.get(fileName);
	        if (!analyzedFile) {
	            analyzedFile =
	                analyzeFile(this._host, this._symbolResolver, this._metadataResolver, fileName);
	            this._analyzedFiles.set(fileName, analyzedFile);
	        }
	        return analyzedFile;
	    };
	    /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    AotCompiler.prototype.findGeneratedFileNames = /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    function (fileName) {
	        var _this = this;
	        var /** @type {?} */ genFileNames = [];
	        var /** @type {?} */ file = this._analyzeFile(fileName);
	        // Make sure we create a .ngfactory if we have a injectable/directive/pipe/NgModule
	        // or a reference to a non source file.
	        // Note: This is overestimating the required .ngfactory files as the real calculation is harder.
	        // Only do this for StubEmitFlags.Basic, as adding a type check block
	        // does not change this file (as we generate type check blocks based on NgModules).
	        if (this._options.allowEmptyCodegenFiles || file.directives.length || file.pipes.length ||
	            file.injectables.length || file.ngModules.length || file.exportsNonSourceFiles) {
	            genFileNames.push(ngfactoryFilePath(file.fileName, true));
	            if (this._options.enableSummariesForJit) {
	                genFileNames.push(summaryForJitFileName(file.fileName, true));
	            }
	        }
	        var /** @type {?} */ fileSuffix = normalizeGenFileSuffix(splitTypescriptSuffix(file.fileName, true)[1]);
	        file.directives.forEach(function (dirSymbol) {
	            var /** @type {?} */ compMeta = /** @type {?} */ ((_this._metadataResolver.getNonNormalizedDirectiveMetadata(dirSymbol))).metadata;
	            if (!compMeta.isComponent) {
	                return;
	            } /** @type {?} */
	            ((
	            // Note: compMeta is a component and therefore template is non null.
	            compMeta.template)).styleUrls.forEach(function (styleUrl) {
	                var /** @type {?} */ normalizedUrl = _this._host.resourceNameToFileName(styleUrl, file.fileName);
	                if (!normalizedUrl) {
	                    throw syntaxError("Couldn't resolve resource " + styleUrl + " relative to " + file.fileName);
	                }
	                var /** @type {?} */ needsShim = (/** @type {?} */ ((compMeta.template)).encapsulation || _this._config.defaultEncapsulation) === ViewEncapsulation.Emulated;
	                genFileNames.push(_stylesModuleUrl(normalizedUrl, needsShim, fileSuffix));
	                if (_this._options.allowEmptyCodegenFiles) {
	                    genFileNames.push(_stylesModuleUrl(normalizedUrl, !needsShim, fileSuffix));
	                }
	            });
	        });
	        return genFileNames;
	    };
	    /**
	     * @param {?} genFileName
	     * @param {?=} originalFileName
	     * @return {?}
	     */
	    AotCompiler.prototype.emitBasicStub = /**
	     * @param {?} genFileName
	     * @param {?=} originalFileName
	     * @return {?}
	     */
	    function (genFileName, originalFileName) {
	        var /** @type {?} */ outputCtx = this._createOutputContext(genFileName);
	        if (genFileName.endsWith('.ngfactory.ts')) {
	            if (!originalFileName) {
	                throw new Error("Assertion error: require the original file for .ngfactory.ts stubs. File: " + genFileName);
	            }
	            var /** @type {?} */ originalFile = this._analyzeFile(originalFileName);
	            this._createNgFactoryStub(outputCtx, originalFile, StubEmitFlags.Basic);
	        }
	        else if (genFileName.endsWith('.ngsummary.ts')) {
	            if (this._options.enableSummariesForJit) {
	                if (!originalFileName) {
	                    throw new Error("Assertion error: require the original file for .ngsummary.ts stubs. File: " + genFileName);
	                }
	                var /** @type {?} */ originalFile = this._analyzeFile(originalFileName);
	                _createEmptyStub(outputCtx);
	                originalFile.ngModules.forEach(function (ngModule) {
	                    // create exports that user code can reference
	                    createForJitStub(outputCtx, ngModule.type.reference);
	                });
	            }
	        }
	        else if (genFileName.endsWith('.ngstyle.ts')) {
	            _createEmptyStub(outputCtx);
	        }
	        // Note: for the stubs, we don't need a property srcFileUrl,
	        // as lateron in emitAllImpls we will create the proper GeneratedFiles with the
	        // correct srcFileUrl.
	        // This is good as e.g. for .ngstyle.ts files we can't derive
	        // the url of components based on the genFileUrl.
	        return this._codegenSourceModule('unknown', outputCtx);
	    };
	    /**
	     * @param {?} genFileName
	     * @param {?} originalFileName
	     * @return {?}
	     */
	    AotCompiler.prototype.emitTypeCheckStub = /**
	     * @param {?} genFileName
	     * @param {?} originalFileName
	     * @return {?}
	     */
	    function (genFileName, originalFileName) {
	        var /** @type {?} */ originalFile = this._analyzeFile(originalFileName);
	        var /** @type {?} */ outputCtx = this._createOutputContext(genFileName);
	        if (genFileName.endsWith('.ngfactory.ts')) {
	            this._createNgFactoryStub(outputCtx, originalFile, StubEmitFlags.TypeCheck);
	        }
	        return outputCtx.statements.length > 0 ?
	            this._codegenSourceModule(originalFile.fileName, outputCtx) :
	            null;
	    };
	    /**
	     * @param {?} fileNames
	     * @return {?}
	     */
	    AotCompiler.prototype.loadFilesAsync = /**
	     * @param {?} fileNames
	     * @return {?}
	     */
	    function (fileNames) {
	        var _this = this;
	        var /** @type {?} */ files = fileNames.map(function (fileName) { return _this._analyzeFile(fileName); });
	        var /** @type {?} */ loadingPromises = [];
	        files.forEach(function (file) {
	            return file.ngModules.forEach(function (ngModule) {
	                return loadingPromises.push(_this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false));
	            });
	        });
	        return Promise.all(loadingPromises).then(function (_) { return mergeAndValidateNgFiles(files); });
	    };
	    /**
	     * @param {?} fileNames
	     * @return {?}
	     */
	    AotCompiler.prototype.loadFilesSync = /**
	     * @param {?} fileNames
	     * @return {?}
	     */
	    function (fileNames) {
	        var _this = this;
	        var /** @type {?} */ files = fileNames.map(function (fileName) { return _this._analyzeFile(fileName); });
	        files.forEach(function (file) {
	            return file.ngModules.forEach(function (ngModule) {
	                return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, true);
	            });
	        });
	        return mergeAndValidateNgFiles(files);
	    };
	    /**
	     * @param {?} outputCtx
	     * @param {?} file
	     * @param {?} emitFlags
	     * @return {?}
	     */
	    AotCompiler.prototype._createNgFactoryStub = /**
	     * @param {?} outputCtx
	     * @param {?} file
	     * @param {?} emitFlags
	     * @return {?}
	     */
	    function (outputCtx, file, emitFlags) {
	        var _this = this;
	        var /** @type {?} */ componentId = 0;
	        file.ngModules.forEach(function (ngModuleMeta, ngModuleIndex) {
	            // Note: the code below needs to executed for StubEmitFlags.Basic and StubEmitFlags.TypeCheck,
	            // so we don't change the .ngfactory file too much when adding the typecheck block.
	            // create exports that user code can reference
	            // Note: the code below needs to executed for StubEmitFlags.Basic and StubEmitFlags.TypeCheck,
	            // so we don't change the .ngfactory file too much when adding the typecheck block.
	            // create exports that user code can reference
	            _this._ngModuleCompiler.createStub(outputCtx, ngModuleMeta.type.reference);
	            // add references to the symbols from the metadata.
	            // These can be used by the type check block for components,
	            // and they also cause TypeScript to include these files into the program too,
	            // which will make them part of the analyzedFiles.
	            var /** @type {?} */ externalReferences = ngModuleMeta.transitiveModule.directives.map(function (d) { return d.reference; }).concat(ngModuleMeta.transitiveModule.pipes.map(function (d) { return d.reference; }), ngModuleMeta.importedModules.map(function (m) { return m.type.reference; }), ngModuleMeta.exportedModules.map(function (m) { return m.type.reference; }), _this._externalIdentifierReferences([Identifiers.TemplateRef, Identifiers.ElementRef]));
	            var /** @type {?} */ externalReferenceVars = new Map();
	            externalReferences.forEach(function (ref, typeIndex) {
	                externalReferenceVars.set(ref, "_decl" + ngModuleIndex + "_" + typeIndex);
	            });
	            externalReferenceVars.forEach(function (varName, reference) {
	                outputCtx.statements.push(variable(varName)
	                    .set(NULL_EXPR.cast(DYNAMIC_TYPE))
	                    .toDeclStmt(expressionType(outputCtx.importExpr(reference, /* typeParams */ null, /* useSummaries */ /* useSummaries */ false))));
	            });
	            if (emitFlags & StubEmitFlags.TypeCheck) {
	                // add the typecheck block for all components of the NgModule
	                ngModuleMeta.declaredDirectives.forEach(function (dirId) {
	                    var /** @type {?} */ compMeta = _this._metadataResolver.getDirectiveMetadata(dirId.reference);
	                    if (!compMeta.isComponent) {
	                        return;
	                    }
	                    componentId++;
	                    _this._createTypeCheckBlock(outputCtx, compMeta.type.reference.name + "_Host_" + componentId, ngModuleMeta, _this._metadataResolver.getHostComponentMetadata(compMeta), [compMeta.type], externalReferenceVars);
	                    _this._createTypeCheckBlock(outputCtx, compMeta.type.reference.name + "_" + componentId, ngModuleMeta, compMeta, ngModuleMeta.transitiveModule.directives, externalReferenceVars);
	                });
	            }
	        });
	        if (outputCtx.statements.length === 0) {
	            _createEmptyStub(outputCtx);
	        }
	    };
	    /**
	     * @param {?} references
	     * @return {?}
	     */
	    AotCompiler.prototype._externalIdentifierReferences = /**
	     * @param {?} references
	     * @return {?}
	     */
	    function (references) {
	        var /** @type {?} */ result = [];
	        for (var _i = 0, references_1 = references; _i < references_1.length; _i++) {
	            var reference = references_1[_i];
	            var /** @type {?} */ token = createTokenForExternalReference(this._reflector, reference);
	            if (token.identifier) {
	                result.push(token.identifier.reference);
	            }
	        }
	        return result;
	    };
	    /**
	     * @param {?} ctx
	     * @param {?} componentId
	     * @param {?} moduleMeta
	     * @param {?} compMeta
	     * @param {?} directives
	     * @param {?} externalReferenceVars
	     * @return {?}
	     */
	    AotCompiler.prototype._createTypeCheckBlock = /**
	     * @param {?} ctx
	     * @param {?} componentId
	     * @param {?} moduleMeta
	     * @param {?} compMeta
	     * @param {?} directives
	     * @param {?} externalReferenceVars
	     * @return {?}
	     */
	    function (ctx, componentId, moduleMeta, compMeta, directives, externalReferenceVars) {
	        var _a = this._parseTemplate(compMeta, moduleMeta, directives), parsedTemplate = _a.template, usedPipes = _a.pipes;
	        (_b = ctx.statements).push.apply(_b, this._typeCheckCompiler.compileComponent(componentId, compMeta, parsedTemplate, usedPipes, externalReferenceVars, ctx));
	        var _b;
	    };
	    /**
	     * @param {?} analyzeResult
	     * @param {?} locale
	     * @return {?}
	     */
	    AotCompiler.prototype.emitMessageBundle = /**
	     * @param {?} analyzeResult
	     * @param {?} locale
	     * @return {?}
	     */
	    function (analyzeResult, locale) {
	        var _this = this;
	        var /** @type {?} */ errors = [];
	        var /** @type {?} */ htmlParser = new HtmlParser();
	        // TODO(vicb): implicit tags & attributes
	        var /** @type {?} */ messageBundle = new MessageBundle(htmlParser, [], {}, locale);
	        analyzeResult.files.forEach(function (file) {
	            var /** @type {?} */ compMetas = [];
	            file.directives.forEach(function (directiveType) {
	                var /** @type {?} */ dirMeta = _this._metadataResolver.getDirectiveMetadata(directiveType);
	                if (dirMeta && dirMeta.isComponent) {
	                    compMetas.push(dirMeta);
	                }
	            });
	            compMetas.forEach(function (compMeta) {
	                var /** @type {?} */ html = /** @type {?} */ ((/** @type {?} */ ((compMeta.template)).template));
	                var /** @type {?} */ interpolationConfig = InterpolationConfig.fromArray(/** @type {?} */ ((compMeta.template)).interpolation);
	                errors.push.apply(errors, /** @type {?} */ ((messageBundle.updateFromTemplate(html, file.fileName, interpolationConfig))));
	            });
	        });
	        if (errors.length) {
	            throw new Error(errors.map(function (e) { return e.toString(); }).join('\n'));
	        }
	        return messageBundle;
	    };
	    /**
	     * @param {?} analyzeResult
	     * @return {?}
	     */
	    AotCompiler.prototype.emitAllImpls = /**
	     * @param {?} analyzeResult
	     * @return {?}
	     */
	    function (analyzeResult) {
	        var _this = this;
	        var ngModuleByPipeOrDirective = analyzeResult.ngModuleByPipeOrDirective, files = analyzeResult.files;
	        var /** @type {?} */ sourceModules = files.map(function (file) {
	            return _this._compileImplFile(file.fileName, ngModuleByPipeOrDirective, file.directives, file.pipes, file.ngModules, file.injectables);
	        });
	        return flatten(sourceModules);
	    };
	    /**
	     * @param {?} srcFileUrl
	     * @param {?} ngModuleByPipeOrDirective
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} ngModules
	     * @param {?} injectables
	     * @return {?}
	     */
	    AotCompiler.prototype._compileImplFile = /**
	     * @param {?} srcFileUrl
	     * @param {?} ngModuleByPipeOrDirective
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} ngModules
	     * @param {?} injectables
	     * @return {?}
	     */
	    function (srcFileUrl, ngModuleByPipeOrDirective, directives, pipes, ngModules, injectables) {
	        var _this = this;
	        var /** @type {?} */ fileSuffix = normalizeGenFileSuffix(splitTypescriptSuffix(srcFileUrl, true)[1]);
	        var /** @type {?} */ generatedFiles = [];
	        var /** @type {?} */ outputCtx = this._createOutputContext(ngfactoryFilePath(srcFileUrl, true));
	        generatedFiles.push.apply(generatedFiles, this._createSummary(srcFileUrl, directives, pipes, ngModules, injectables, outputCtx));
	        // compile all ng modules
	        ngModules.forEach(function (ngModuleMeta) { return _this._compileModule(outputCtx, ngModuleMeta); });
	        // compile components
	        directives.forEach(function (dirType) {
	            var /** @type {?} */ compMeta = _this._metadataResolver.getDirectiveMetadata(/** @type {?} */ (dirType));
	            if (!compMeta.isComponent) {
	                return;
	            }
	            var /** @type {?} */ ngModule = ngModuleByPipeOrDirective.get(dirType);
	            if (!ngModule) {
	                throw new Error("Internal Error: cannot determine the module for component " + identifierName(compMeta.type) + "!");
	            }
	            // compile styles
	            var /** @type {?} */ componentStylesheet = _this._styleCompiler.compileComponent(outputCtx, compMeta); /** @type {?} */
	            ((
	            // Note: compMeta is a component and therefore template is non null.
	            compMeta.template)).externalStylesheets.forEach(function (stylesheetMeta) {
	                // Note: fill non shim and shim style files as they might
	                // be shared by component with and without ViewEncapsulation.
	                var /** @type {?} */ shim = _this._styleCompiler.needsStyleShim(compMeta);
	                generatedFiles.push(_this._codegenStyles(srcFileUrl, compMeta, stylesheetMeta, shim, fileSuffix));
	                if (_this._options.allowEmptyCodegenFiles) {
	                    generatedFiles.push(_this._codegenStyles(srcFileUrl, compMeta, stylesheetMeta, !shim, fileSuffix));
	                }
	            });
	            // compile components
	            var /** @type {?} */ compViewVars = _this._compileComponent(outputCtx, compMeta, ngModule, ngModule.transitiveModule.directives, componentStylesheet, fileSuffix);
	            _this._compileComponentFactory(outputCtx, compMeta, ngModule, fileSuffix);
	        });
	        if (outputCtx.statements.length > 0 || this._options.allowEmptyCodegenFiles) {
	            var /** @type {?} */ srcModule = this._codegenSourceModule(srcFileUrl, outputCtx);
	            generatedFiles.unshift(srcModule);
	        }
	        return generatedFiles;
	    };
	    /**
	     * @param {?} srcFileName
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} ngModules
	     * @param {?} injectables
	     * @param {?} ngFactoryCtx
	     * @return {?}
	     */
	    AotCompiler.prototype._createSummary = /**
	     * @param {?} srcFileName
	     * @param {?} directives
	     * @param {?} pipes
	     * @param {?} ngModules
	     * @param {?} injectables
	     * @param {?} ngFactoryCtx
	     * @return {?}
	     */
	    function (srcFileName, directives, pipes, ngModules, injectables, ngFactoryCtx) {
	        var _this = this;
	        var /** @type {?} */ symbolSummaries = this._symbolResolver.getSymbolsOf(srcFileName)
	            .map(function (symbol) { return _this._symbolResolver.resolveSymbol(symbol); });
	        var /** @type {?} */ typeData = ngModules.map(function (meta) {
	            return ({
	                summary: /** @type {?} */ ((_this._metadataResolver.getNgModuleSummary(meta.type.reference))),
	                metadata: /** @type {?} */ ((_this._metadataResolver.getNgModuleMetadata(meta.type.reference)))
	            });
	        }).concat(directives.map(function (ref) {
	            return ({
	                summary: /** @type {?} */ ((_this._metadataResolver.getDirectiveSummary(ref))),
	                metadata: /** @type {?} */ ((_this._metadataResolver.getDirectiveMetadata(ref)))
	            });
	        }), pipes.map(function (ref) {
	            return ({
	                summary: /** @type {?} */ ((_this._metadataResolver.getPipeSummary(ref))),
	                metadata: /** @type {?} */ ((_this._metadataResolver.getPipeMetadata(ref)))
	            });
	        }), injectables.map(function (ref) {
	            return ({
	                summary: /** @type {?} */ ((_this._metadataResolver.getInjectableSummary(ref))),
	                metadata: /** @type {?} */ ((_this._metadataResolver.getInjectableSummary(ref))).type
	            });
	        }));
	        var /** @type {?} */ forJitOutputCtx = this._options.enableSummariesForJit ?
	            this._createOutputContext(summaryForJitFileName(srcFileName, true)) :
	            null;
	        var _a = serializeSummaries(srcFileName, forJitOutputCtx, this._summaryResolver, this._symbolResolver, symbolSummaries, typeData), json = _a.json, exportAs = _a.exportAs;
	        exportAs.forEach(function (entry) {
	            ngFactoryCtx.statements.push(variable(entry.exportAs).set(ngFactoryCtx.importExpr(entry.symbol)).toDeclStmt(null, [
	                StmtModifier.Exported
	            ]));
	        });
	        var /** @type {?} */ summaryJson = new GeneratedFile(srcFileName, summaryFileName(srcFileName), json);
	        var /** @type {?} */ result = [summaryJson];
	        if (forJitOutputCtx) {
	            result.push(this._codegenSourceModule(srcFileName, forJitOutputCtx));
	        }
	        return result;
	    };
	    /**
	     * @param {?} outputCtx
	     * @param {?} ngModule
	     * @return {?}
	     */
	    AotCompiler.prototype._compileModule = /**
	     * @param {?} outputCtx
	     * @param {?} ngModule
	     * @return {?}
	     */
	    function (outputCtx, ngModule) {
	        var /** @type {?} */ providers = [];
	        if (this._options.locale) {
	            var /** @type {?} */ normalizedLocale = this._options.locale.replace(/_/g, '-');
	            providers.push({
	                token: createTokenForExternalReference(this._reflector, Identifiers.LOCALE_ID),
	                useValue: normalizedLocale,
	            });
	        }
	        if (this._options.i18nFormat) {
	            providers.push({
	                token: createTokenForExternalReference(this._reflector, Identifiers.TRANSLATIONS_FORMAT),
	                useValue: this._options.i18nFormat
	            });
	        }
	        this._ngModuleCompiler.compile(outputCtx, ngModule, providers);
	    };
	    /**
	     * @param {?} outputCtx
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} fileSuffix
	     * @return {?}
	     */
	    AotCompiler.prototype._compileComponentFactory = /**
	     * @param {?} outputCtx
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} fileSuffix
	     * @return {?}
	     */
	    function (outputCtx, compMeta, ngModule, fileSuffix) {
	        var /** @type {?} */ hostMeta = this._metadataResolver.getHostComponentMetadata(compMeta);
	        var /** @type {?} */ hostViewFactoryVar = this._compileComponent(outputCtx, hostMeta, ngModule, [compMeta.type], null, fileSuffix)
	            .viewClassVar;
	        var /** @type {?} */ compFactoryVar = componentFactoryName(compMeta.type.reference);
	        var /** @type {?} */ inputsExprs = [];
	        for (var /** @type {?} */ propName in compMeta.inputs) {
	            var /** @type {?} */ templateName = compMeta.inputs[propName];
	            // Don't quote so that the key gets minified...
	            inputsExprs.push(new LiteralMapEntry(propName, literal(templateName), false));
	        }
	        var /** @type {?} */ outputsExprs = [];
	        for (var /** @type {?} */ propName in compMeta.outputs) {
	            var /** @type {?} */ templateName = compMeta.outputs[propName];
	            // Don't quote so that the key gets minified...
	            outputsExprs.push(new LiteralMapEntry(propName, literal(templateName), false));
	        }
	        outputCtx.statements.push(variable(compFactoryVar)
	            .set(importExpr(Identifiers.createComponentFactory).callFn([
	            literal(compMeta.selector), outputCtx.importExpr(compMeta.type.reference),
	            variable(hostViewFactoryVar), new LiteralMapExpr(inputsExprs),
	            new LiteralMapExpr(outputsExprs),
	            literalArr(/** @type {?} */ ((compMeta.template)).ngContentSelectors.map(function (selector) { return literal(selector); }))
	        ]))
	            .toDeclStmt(importType(Identifiers.ComponentFactory, [/** @type {?} */ ((expressionType(outputCtx.importExpr(compMeta.type.reference))))], [TypeModifier.Const]), [StmtModifier.Final, StmtModifier.Exported]));
	    };
	    /**
	     * @param {?} outputCtx
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} directiveIdentifiers
	     * @param {?} componentStyles
	     * @param {?} fileSuffix
	     * @return {?}
	     */
	    AotCompiler.prototype._compileComponent = /**
	     * @param {?} outputCtx
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} directiveIdentifiers
	     * @param {?} componentStyles
	     * @param {?} fileSuffix
	     * @return {?}
	     */
	    function (outputCtx, compMeta, ngModule, directiveIdentifiers, componentStyles, fileSuffix) {
	        var _a = this._parseTemplate(compMeta, ngModule, directiveIdentifiers), parsedTemplate = _a.template, usedPipes = _a.pipes;
	        var /** @type {?} */ stylesExpr = componentStyles ? variable(componentStyles.stylesVar) : literalArr([]);
	        var /** @type {?} */ viewResult = this._viewCompiler.compileComponent(outputCtx, compMeta, parsedTemplate, stylesExpr, usedPipes);
	        if (componentStyles) {
	            _resolveStyleStatements(this._symbolResolver, componentStyles, this._styleCompiler.needsStyleShim(compMeta), fileSuffix);
	        }
	        return viewResult;
	    };
	    /**
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} directiveIdentifiers
	     * @return {?}
	     */
	    AotCompiler.prototype._parseTemplate = /**
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} directiveIdentifiers
	     * @return {?}
	     */
	    function (compMeta, ngModule, directiveIdentifiers) {
	        var _this = this;
	        if (this._templateAstCache.has(compMeta.type.reference)) {
	            return /** @type {?} */ ((this._templateAstCache.get(compMeta.type.reference)));
	        }
	        var /** @type {?} */ preserveWhitespaces = /** @type {?} */ ((/** @type {?} */ ((compMeta)).template)).preserveWhitespaces;
	        var /** @type {?} */ directives = directiveIdentifiers.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
	        var /** @type {?} */ pipes = ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
	        var /** @type {?} */ result = this._templateParser.parse(compMeta, /** @type {?} */ ((/** @type {?} */ ((compMeta.template)).htmlAst)), directives, pipes, ngModule.schemas, templateSourceUrl(ngModule.type, compMeta, /** @type {?} */ ((compMeta.template))), preserveWhitespaces);
	        this._templateAstCache.set(compMeta.type.reference, result);
	        return result;
	    };
	    /**
	     * @param {?} genFilePath
	     * @return {?}
	     */
	    AotCompiler.prototype._createOutputContext = /**
	     * @param {?} genFilePath
	     * @return {?}
	     */
	    function (genFilePath) {
	        var _this = this;
	        var /** @type {?} */ importExpr$$1 = function (symbol, typeParams, useSummaries) {
	            if (typeParams === void 0) { typeParams = null; }
	            if (useSummaries === void 0) { useSummaries = true; }
	            if (!(symbol instanceof StaticSymbol)) {
	                throw new Error("Internal error: unknown identifier " + JSON.stringify(symbol));
	            }
	            var /** @type {?} */ arity = _this._symbolResolver.getTypeArity(symbol) || 0;
	            var _a = _this._symbolResolver.getImportAs(symbol, useSummaries) || symbol, filePath = _a.filePath, name = _a.name, members = _a.members;
	            var /** @type {?} */ importModule = _this._fileNameToModuleName(filePath, genFilePath);
	            // It should be good enough to compare filePath to genFilePath and if they are equal
	            // there is a self reference. However, ngfactory files generate to .ts but their
	            // symbols have .d.ts so a simple compare is insufficient. They should be canonical
	            // and is tracked by #17705.
	            var /** @type {?} */ selfReference = _this._fileNameToModuleName(genFilePath, genFilePath);
	            var /** @type {?} */ moduleName = importModule === selfReference ? null : importModule;
	            // If we are in a type expression that refers to a generic type then supply
	            // the required type parameters. If there were not enough type parameters
	            // supplied, supply any as the type. Outside a type expression the reference
	            // should not supply type parameters and be treated as a simple value reference
	            // to the constructor function itself.
	            var /** @type {?} */ suppliedTypeParams = typeParams || [];
	            var /** @type {?} */ missingTypeParamsCount = arity - suppliedTypeParams.length;
	            var /** @type {?} */ allTypeParams = suppliedTypeParams.concat(new Array(missingTypeParamsCount).fill(DYNAMIC_TYPE));
	            return members.reduce(function (expr, memberName) { return expr.prop(memberName); }, /** @type {?} */ (importExpr(new ExternalReference(moduleName, name, null), allTypeParams)));
	        };
	        return { statements: [], genFilePath: genFilePath, importExpr: importExpr$$1 };
	    };
	    /**
	     * @param {?} importedFilePath
	     * @param {?} containingFilePath
	     * @return {?}
	     */
	    AotCompiler.prototype._fileNameToModuleName = /**
	     * @param {?} importedFilePath
	     * @param {?} containingFilePath
	     * @return {?}
	     */
	    function (importedFilePath, containingFilePath) {
	        return this._summaryResolver.getKnownModuleName(importedFilePath) ||
	            this._symbolResolver.getKnownModuleName(importedFilePath) ||
	            this._host.fileNameToModuleName(importedFilePath, containingFilePath);
	    };
	    /**
	     * @param {?} srcFileUrl
	     * @param {?} compMeta
	     * @param {?} stylesheetMetadata
	     * @param {?} isShimmed
	     * @param {?} fileSuffix
	     * @return {?}
	     */
	    AotCompiler.prototype._codegenStyles = /**
	     * @param {?} srcFileUrl
	     * @param {?} compMeta
	     * @param {?} stylesheetMetadata
	     * @param {?} isShimmed
	     * @param {?} fileSuffix
	     * @return {?}
	     */
	    function (srcFileUrl, compMeta, stylesheetMetadata, isShimmed, fileSuffix) {
	        var /** @type {?} */ outputCtx = this._createOutputContext(_stylesModuleUrl(/** @type {?} */ ((stylesheetMetadata.moduleUrl)), isShimmed, fileSuffix));
	        var /** @type {?} */ compiledStylesheet = this._styleCompiler.compileStyles(outputCtx, compMeta, stylesheetMetadata, isShimmed);
	        _resolveStyleStatements(this._symbolResolver, compiledStylesheet, isShimmed, fileSuffix);
	        return this._codegenSourceModule(srcFileUrl, outputCtx);
	    };
	    /**
	     * @param {?} srcFileUrl
	     * @param {?} ctx
	     * @return {?}
	     */
	    AotCompiler.prototype._codegenSourceModule = /**
	     * @param {?} srcFileUrl
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (srcFileUrl, ctx) {
	        return new GeneratedFile(srcFileUrl, ctx.genFilePath, ctx.statements);
	    };
	    /**
	     * @param {?=} entryRoute
	     * @param {?=} analyzedModules
	     * @return {?}
	     */
	    AotCompiler.prototype.listLazyRoutes = /**
	     * @param {?=} entryRoute
	     * @param {?=} analyzedModules
	     * @return {?}
	     */
	    function (entryRoute, analyzedModules) {
	        var /** @type {?} */ self = this;
	        if (entryRoute) {
	            var /** @type {?} */ symbol = parseLazyRoute(entryRoute, this._reflector).referencedModule;
	            return visitLazyRoute(symbol);
	        }
	        else if (analyzedModules) {
	            var /** @type {?} */ allLazyRoutes = [];
	            for (var _i = 0, _a = analyzedModules.ngModules; _i < _a.length; _i++) {
	                var ngModule = _a[_i];
	                var /** @type {?} */ lazyRoutes = listLazyRoutes(ngModule, this._reflector);
	                for (var _b = 0, lazyRoutes_1 = lazyRoutes; _b < lazyRoutes_1.length; _b++) {
	                    var lazyRoute = lazyRoutes_1[_b];
	                    allLazyRoutes.push(lazyRoute);
	                }
	            }
	            return allLazyRoutes;
	        }
	        else {
	            throw new Error("Either route or analyzedModules has to be specified!");
	        }
	        /**
	         * @param {?} symbol
	         * @param {?=} seenRoutes
	         * @param {?=} allLazyRoutes
	         * @return {?}
	         */
	        function visitLazyRoute(symbol, seenRoutes, allLazyRoutes) {
	            if (seenRoutes === void 0) { seenRoutes = new Set(); }
	            if (allLazyRoutes === void 0) { allLazyRoutes = []; }
	            // Support pointing to default exports, but stop recursing there,
	            // as the StaticReflector does not yet support default exports.
	            if (seenRoutes.has(symbol) || !symbol.name) {
	                return allLazyRoutes;
	            }
	            seenRoutes.add(symbol);
	            var /** @type {?} */ lazyRoutes = listLazyRoutes(/** @type {?} */ ((self._metadataResolver.getNgModuleMetadata(symbol, true))), self._reflector);
	            for (var _i = 0, lazyRoutes_2 = lazyRoutes; _i < lazyRoutes_2.length; _i++) {
	                var lazyRoute = lazyRoutes_2[_i];
	                allLazyRoutes.push(lazyRoute);
	                visitLazyRoute(lazyRoute.referencedModule, seenRoutes, allLazyRoutes);
	            }
	            return allLazyRoutes;
	        }
	    };
	    return AotCompiler;
	}());
	/**
	 * @param {?} outputCtx
	 * @return {?}
	 */
	function _createEmptyStub(outputCtx) {
	    // Note: We need to produce at least one import statement so that
	    // TypeScript knows that the file is an es6 module. Otherwise our generated
	    // exports / imports won't be emitted properly by TypeScript.
	    outputCtx.statements.push(importExpr(Identifiers.ComponentFactory).toStmt());
	}
	/**
	 * @param {?} symbolResolver
	 * @param {?} compileResult
	 * @param {?} needsShim
	 * @param {?} fileSuffix
	 * @return {?}
	 */
	function _resolveStyleStatements(symbolResolver, compileResult, needsShim, fileSuffix) {
	    compileResult.dependencies.forEach(function (dep) {
	        dep.setValue(symbolResolver.getStaticSymbol(_stylesModuleUrl(dep.moduleUrl, needsShim, fileSuffix), dep.name));
	    });
	}
	/**
	 * @param {?} stylesheetUrl
	 * @param {?} shim
	 * @param {?} suffix
	 * @return {?}
	 */
	function _stylesModuleUrl(stylesheetUrl, shim, suffix) {
	    return "" + stylesheetUrl + (shim ? '.shim' : '') + ".ngstyle" + suffix;
	}
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	/**
	 * @param {?} fileNames
	 * @param {?} host
	 * @param {?} staticSymbolResolver
	 * @param {?} metadataResolver
	 * @return {?}
	 */
	function analyzeNgModules(fileNames, host, staticSymbolResolver, metadataResolver) {
	    var /** @type {?} */ files = _analyzeFilesIncludingNonProgramFiles(fileNames, host, staticSymbolResolver, metadataResolver);
	    return mergeAnalyzedFiles(files);
	}
	/**
	 * @param {?} fileNames
	 * @param {?} host
	 * @param {?} staticSymbolResolver
	 * @param {?} metadataResolver
	 * @return {?}
	 */
	function analyzeAndValidateNgModules(fileNames, host, staticSymbolResolver, metadataResolver) {
	    return validateAnalyzedModules(analyzeNgModules(fileNames, host, staticSymbolResolver, metadataResolver));
	}
	/**
	 * @param {?} analyzedModules
	 * @return {?}
	 */
	function validateAnalyzedModules(analyzedModules) {
	    if (analyzedModules.symbolsMissingModule && analyzedModules.symbolsMissingModule.length) {
	        var /** @type {?} */ messages = analyzedModules.symbolsMissingModule.map(function (s) {
	            return "Cannot determine the module for class " + s.name + " in " + s.filePath + "! Add " + s.name + " to the NgModule to fix it.";
	        });
	        throw syntaxError(messages.join('\n'));
	    }
	    return analyzedModules;
	}
	/**
	 * @param {?} fileNames
	 * @param {?} host
	 * @param {?} staticSymbolResolver
	 * @param {?} metadataResolver
	 * @return {?}
	 */
	function _analyzeFilesIncludingNonProgramFiles(fileNames, host, staticSymbolResolver, metadataResolver) {
	    var /** @type {?} */ seenFiles = new Set();
	    var /** @type {?} */ files = [];
	    var /** @type {?} */ visitFile = function (fileName) {
	        if (seenFiles.has(fileName) || !host.isSourceFile(fileName)) {
	            return false;
	        }
	        seenFiles.add(fileName);
	        var /** @type {?} */ analyzedFile = analyzeFile(host, staticSymbolResolver, metadataResolver, fileName);
	        files.push(analyzedFile);
	        analyzedFile.ngModules.forEach(function (ngModule) {
	            ngModule.transitiveModule.modules.forEach(function (modMeta) { return visitFile(modMeta.reference.filePath); });
	        });
	    };
	    fileNames.forEach(function (fileName) { return visitFile(fileName); });
	    return files;
	}
	/**
	 * @param {?} host
	 * @param {?} staticSymbolResolver
	 * @param {?} metadataResolver
	 * @param {?} fileName
	 * @return {?}
	 */
	function analyzeFile(host, staticSymbolResolver, metadataResolver, fileName) {
	    var /** @type {?} */ directives = [];
	    var /** @type {?} */ pipes = [];
	    var /** @type {?} */ injectables = [];
	    var /** @type {?} */ ngModules = [];
	    var /** @type {?} */ hasDecorators = staticSymbolResolver.hasDecorators(fileName);
	    var /** @type {?} */ exportsNonSourceFiles = false;
	    // Don't analyze .d.ts files that have no decorators as a shortcut
	    // to speed up the analysis. This prevents us from
	    // resolving the references in these files.
	    // Note: exportsNonSourceFiles is only needed when compiling with summaries,
	    // which is not the case when .d.ts files are treated as input files.
	    if (!fileName.endsWith('.d.ts') || hasDecorators) {
	        staticSymbolResolver.getSymbolsOf(fileName).forEach(function (symbol) {
	            var /** @type {?} */ resolvedSymbol = staticSymbolResolver.resolveSymbol(symbol);
	            var /** @type {?} */ symbolMeta = resolvedSymbol.metadata;
	            if (!symbolMeta || symbolMeta.__symbolic === 'error') {
	                return;
	            }
	            var /** @type {?} */ isNgSymbol = false;
	            if (symbolMeta.__symbolic === 'class') {
	                if (metadataResolver.isDirective(symbol)) {
	                    isNgSymbol = true;
	                    directives.push(symbol);
	                }
	                else if (metadataResolver.isPipe(symbol)) {
	                    isNgSymbol = true;
	                    pipes.push(symbol);
	                }
	                else if (metadataResolver.isNgModule(symbol)) {
	                    var /** @type {?} */ ngModule = metadataResolver.getNgModuleMetadata(symbol, false);
	                    if (ngModule) {
	                        isNgSymbol = true;
	                        ngModules.push(ngModule);
	                    }
	                }
	                else if (metadataResolver.isInjectable(symbol)) {
	                    isNgSymbol = true;
	                    injectables.push(symbol);
	                }
	            }
	            if (!isNgSymbol) {
	                exportsNonSourceFiles =
	                    exportsNonSourceFiles || isValueExportingNonSourceFile(host, symbolMeta);
	            }
	        });
	    }
	    return {
	        fileName: fileName, directives: directives, pipes: pipes, ngModules: ngModules, injectables: injectables, exportsNonSourceFiles: exportsNonSourceFiles,
	    };
	}
	/**
	 * @param {?} host
	 * @param {?} metadata
	 * @return {?}
	 */
	function isValueExportingNonSourceFile(host, metadata) {
	    var /** @type {?} */ exportsNonSourceFiles = false;
	    var Visitor = /** @class */ (function () {
	        function Visitor() {
	        }
	        /**
	         * @param {?} arr
	         * @param {?} context
	         * @return {?}
	         */
	        Visitor.prototype.visitArray = /**
	         * @param {?} arr
	         * @param {?} context
	         * @return {?}
	         */
	        function (arr, context) {
	            var _this = this;
	            arr.forEach(function (v) { return visitValue(v, _this, context); });
	        };
	        /**
	         * @param {?} map
	         * @param {?} context
	         * @return {?}
	         */
	        Visitor.prototype.visitStringMap = /**
	         * @param {?} map
	         * @param {?} context
	         * @return {?}
	         */
	        function (map, context) {
	            var _this = this;
	            Object.keys(map).forEach(function (key) { return visitValue(map[key], _this, context); });
	        };
	        /**
	         * @param {?} value
	         * @param {?} context
	         * @return {?}
	         */
	        Visitor.prototype.visitPrimitive = /**
	         * @param {?} value
	         * @param {?} context
	         * @return {?}
	         */
	        function (value, context) { };
	        /**
	         * @param {?} value
	         * @param {?} context
	         * @return {?}
	         */
	        Visitor.prototype.visitOther = /**
	         * @param {?} value
	         * @param {?} context
	         * @return {?}
	         */
	        function (value, context) {
	            if (value instanceof StaticSymbol && !host.isSourceFile(value.filePath)) {
	                exportsNonSourceFiles = true;
	            }
	        };
	        return Visitor;
	    }());
	    visitValue(metadata, new Visitor(), null);
	    return exportsNonSourceFiles;
	}
	/**
	 * @param {?} analyzedFiles
	 * @return {?}
	 */
	function mergeAnalyzedFiles(analyzedFiles) {
	    var /** @type {?} */ allNgModules = [];
	    var /** @type {?} */ ngModuleByPipeOrDirective = new Map();
	    var /** @type {?} */ allPipesAndDirectives = new Set();
	    analyzedFiles.forEach(function (af) {
	        af.ngModules.forEach(function (ngModule) {
	            allNgModules.push(ngModule);
	            ngModule.declaredDirectives.forEach(function (d) { return ngModuleByPipeOrDirective.set(d.reference, ngModule); });
	            ngModule.declaredPipes.forEach(function (p) { return ngModuleByPipeOrDirective.set(p.reference, ngModule); });
	        });
	        af.directives.forEach(function (d) { return allPipesAndDirectives.add(d); });
	        af.pipes.forEach(function (p) { return allPipesAndDirectives.add(p); });
	    });
	    var /** @type {?} */ symbolsMissingModule = [];
	    allPipesAndDirectives.forEach(function (ref) {
	        if (!ngModuleByPipeOrDirective.has(ref)) {
	            symbolsMissingModule.push(ref);
	        }
	    });
	    return {
	        ngModules: allNgModules,
	        ngModuleByPipeOrDirective: ngModuleByPipeOrDirective,
	        symbolsMissingModule: symbolsMissingModule,
	        files: analyzedFiles
	    };
	}
	/**
	 * @param {?} files
	 * @return {?}
	 */
	function mergeAndValidateNgFiles(files) {
	    return validateAnalyzedModules(mergeAnalyzedFiles(files));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	/**
	 * @record
	 */
	
	var FORMATTED_MESSAGE = 'ngFormattedMessage';
	/**
	 * @param {?} level
	 * @return {?}
	 */
	function indentStr(level) {
	    if (level <= 0)
	        return '';
	    if (level < 6)
	        return ['', ' ', '  ', '   ', '    ', '     '][level];
	    var /** @type {?} */ half = indentStr(Math.floor(level / 2));
	    return half + half + (level % 2 === 1 ? ' ' : '');
	}
	/**
	 * @param {?} chain
	 * @param {?=} indent
	 * @return {?}
	 */
	function formatChain(chain, indent) {
	    if (indent === void 0) { indent = 0; }
	    if (!chain)
	        return '';
	    var /** @type {?} */ position = chain.position ?
	        chain.position.fileName + "(" + (chain.position.line + 1) + "," + (chain.position.column + 1) + ")" :
	        '';
	    var /** @type {?} */ prefix = position && indent === 0 ? position + ": " : '';
	    var /** @type {?} */ postfix = position && indent !== 0 ? " at " + position : '';
	    var /** @type {?} */ message = "" + prefix + chain.message + postfix;
	    return "" + indentStr(indent) + message + ((chain.next && ('\n' + formatChain(chain.next, indent + 2))) || '');
	}
	/**
	 * @param {?} chain
	 * @return {?}
	 */
	function formattedError(chain) {
	    var /** @type {?} */ message = formatChain(chain) + '.';
	    var /** @type {?} */ error = /** @type {?} */ (syntaxError(message));
	    (/** @type {?} */ (error))[FORMATTED_MESSAGE] = true;
	    error.chain = chain;
	    error.position = chain.position;
	    return error;
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function isFormattedError(error) {
	    return !!(/** @type {?} */ (error))[FORMATTED_MESSAGE];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ANGULAR_CORE = '@angular/core';
	var ANGULAR_ROUTER = '@angular/router';
	var HIDDEN_KEY = /^\$.*\$$/;
	var IGNORE = {
	    __symbolic: 'ignore'
	};
	var USE_VALUE = 'useValue';
	var PROVIDE = 'provide';
	var REFERENCE_SET = new Set([USE_VALUE, 'useFactory', 'data']);
	var TYPEGUARD_POSTFIX = 'TypeGuard';
	var USE_IF = 'UseIf';
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function shouldIgnore(value) {
	    return value && value.__symbolic == 'ignore';
	}
	/**
	 * A static reflector implements enough of the Reflector API that is necessary to compile
	 * templates statically.
	 */
	var StaticReflector = /** @class */ (function () {
	    function StaticReflector(summaryResolver, symbolResolver, knownMetadataClasses, knownMetadataFunctions, errorRecorder) {
	        if (knownMetadataClasses === void 0) { knownMetadataClasses = []; }
	        if (knownMetadataFunctions === void 0) { knownMetadataFunctions = []; }
	        var _this = this;
	        this.summaryResolver = summaryResolver;
	        this.symbolResolver = symbolResolver;
	        this.errorRecorder = errorRecorder;
	        this.annotationCache = new Map();
	        this.propertyCache = new Map();
	        this.parameterCache = new Map();
	        this.methodCache = new Map();
	        this.staticCache = new Map();
	        this.conversionMap = new Map();
	        this.resolvedExternalReferences = new Map();
	        this.annotationForParentClassWithSummaryKind = new Map();
	        this.initializeConversionMap();
	        knownMetadataClasses.forEach(function (kc) {
	            return _this._registerDecoratorOrConstructor(_this.getStaticSymbol(kc.filePath, kc.name), kc.ctor);
	        });
	        knownMetadataFunctions.forEach(function (kf) { return _this._registerFunction(_this.getStaticSymbol(kf.filePath, kf.name), kf.fn); });
	        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Directive, [createDirective, createComponent]);
	        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Pipe, [createPipe]);
	        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.NgModule, [createNgModule]);
	        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Injectable, [createInjectable, createPipe, createDirective, createComponent, createNgModule]);
	    }
	    /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    StaticReflector.prototype.componentModuleUrl = /**
	     * @param {?} typeOrFunc
	     * @return {?}
	     */
	    function (typeOrFunc) {
	        var /** @type {?} */ staticSymbol = this.findSymbolDeclaration(typeOrFunc);
	        return this.symbolResolver.getResourcePath(staticSymbol);
	    };
	    /**
	     * @param {?} ref
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    StaticReflector.prototype.resolveExternalReference = /**
	     * @param {?} ref
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    function (ref, containingFile) {
	        var /** @type {?} */ key = undefined;
	        if (!containingFile) {
	            key = ref.moduleName + ":" + ref.name;
	            var /** @type {?} */ declarationSymbol_1 = this.resolvedExternalReferences.get(key);
	            if (declarationSymbol_1)
	                return declarationSymbol_1;
	        }
	        var /** @type {?} */ refSymbol = this.symbolResolver.getSymbolByModule(/** @type {?} */ ((ref.moduleName)), /** @type {?} */ ((ref.name)), containingFile);
	        var /** @type {?} */ declarationSymbol = this.findSymbolDeclaration(refSymbol);
	        if (!containingFile) {
	            this.symbolResolver.recordModuleNameForFileName(refSymbol.filePath, /** @type {?} */ ((ref.moduleName)));
	            this.symbolResolver.recordImportAs(declarationSymbol, refSymbol);
	        }
	        if (key) {
	            this.resolvedExternalReferences.set(key, declarationSymbol);
	        }
	        return declarationSymbol;
	    };
	    /**
	     * @param {?} moduleUrl
	     * @param {?} name
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    StaticReflector.prototype.findDeclaration = /**
	     * @param {?} moduleUrl
	     * @param {?} name
	     * @param {?=} containingFile
	     * @return {?}
	     */
	    function (moduleUrl, name, containingFile) {
	        return this.findSymbolDeclaration(this.symbolResolver.getSymbolByModule(moduleUrl, name, containingFile));
	    };
	    /**
	     * @param {?} moduleUrl
	     * @param {?} name
	     * @return {?}
	     */
	    StaticReflector.prototype.tryFindDeclaration = /**
	     * @param {?} moduleUrl
	     * @param {?} name
	     * @return {?}
	     */
	    function (moduleUrl, name) {
	        var _this = this;
	        return this.symbolResolver.ignoreErrorsFor(function () { return _this.findDeclaration(moduleUrl, name); });
	    };
	    /**
	     * @param {?} symbol
	     * @return {?}
	     */
	    StaticReflector.prototype.findSymbolDeclaration = /**
	     * @param {?} symbol
	     * @return {?}
	     */
	    function (symbol) {
	        var /** @type {?} */ resolvedSymbol = this.symbolResolver.resolveSymbol(symbol);
	        if (resolvedSymbol) {
	            var /** @type {?} */ resolvedMetadata = resolvedSymbol.metadata;
	            if (resolvedMetadata && resolvedMetadata.__symbolic === 'resolved') {
	                resolvedMetadata = resolvedMetadata.symbol;
	            }
	            if (resolvedMetadata instanceof StaticSymbol) {
	                return this.findSymbolDeclaration(resolvedSymbol.metadata);
	            }
	        }
	        return symbol;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype.annotations = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ annotations = this.annotationCache.get(type);
	        if (!annotations) {
	            annotations = [];
	            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
	            var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
	            if (parentType) {
	                var /** @type {?} */ parentAnnotations = this.annotations(parentType);
	                annotations.push.apply(annotations, parentAnnotations);
	            }
	            var /** @type {?} */ ownAnnotations_1 = [];
	            if (classMetadata['decorators']) {
	                ownAnnotations_1 = this.simplify(type, classMetadata['decorators']);
	                annotations.push.apply(annotations, ownAnnotations_1);
	            }
	            if (parentType && !this.summaryResolver.isLibraryFile(type.filePath) &&
	                this.summaryResolver.isLibraryFile(parentType.filePath)) {
	                var /** @type {?} */ summary = this.summaryResolver.resolveSummary(parentType);
	                if (summary && summary.type) {
	                    var /** @type {?} */ requiredAnnotationTypes = /** @type {?} */ ((this.annotationForParentClassWithSummaryKind.get(/** @type {?} */ ((summary.type.summaryKind)))));
	                    var /** @type {?} */ typeHasRequiredAnnotation = requiredAnnotationTypes.some(function (requiredType) { return ownAnnotations_1.some(function (ann) { return requiredType.isTypeOf(ann); }); });
	                    if (!typeHasRequiredAnnotation) {
	                        this.reportError(formatMetadataError(metadataError("Class " + type.name + " in " + type.filePath + " extends from a " + CompileSummaryKind[(/** @type {?} */ ((summary.type.summaryKind)))] + " in another compilation unit without duplicating the decorator", undefined, "Please add a " + requiredAnnotationTypes.map(function (type) { return type.ngMetadataName; }).join(' or ') + " decorator to the class"), type), type);
	                    }
	                }
	            }
	            this.annotationCache.set(type, annotations.filter(function (ann) { return !!ann; }));
	        }
	        return annotations;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype.propMetadata = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var _this = this;
	        var /** @type {?} */ propMetadata = this.propertyCache.get(type);
	        if (!propMetadata) {
	            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
	            propMetadata = {};
	            var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
	            if (parentType) {
	                var /** @type {?} */ parentPropMetadata_1 = this.propMetadata(parentType);
	                Object.keys(parentPropMetadata_1).forEach(function (parentProp) {
	                    /** @type {?} */ ((propMetadata))[parentProp] = parentPropMetadata_1[parentProp];
	                });
	            }
	            var /** @type {?} */ members_1 = classMetadata['members'] || {};
	            Object.keys(members_1).forEach(function (propName) {
	                var /** @type {?} */ propData = members_1[propName];
	                var /** @type {?} */ prop = (/** @type {?} */ (propData))
	                    .find(function (a) { return a['__symbolic'] == 'property' || a['__symbolic'] == 'method'; });
	                var /** @type {?} */ decorators = [];
	                if (/** @type {?} */ ((propMetadata))[propName]) {
	                    decorators.push.apply(decorators, /** @type {?} */ ((propMetadata))[propName]);
	                } /** @type {?} */
	                ((propMetadata))[propName] = decorators;
	                if (prop && prop['decorators']) {
	                    decorators.push.apply(decorators, _this.simplify(type, prop['decorators']));
	                }
	            });
	            this.propertyCache.set(type, propMetadata);
	        }
	        return propMetadata;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype.parameters = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var _this = this;
	        if (!(type instanceof StaticSymbol)) {
	            this.reportError(new Error("parameters received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
	            return [];
	        }
	        try {
	            var /** @type {?} */ parameters_1 = this.parameterCache.get(type);
	            if (!parameters_1) {
	                var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
	                var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
	                var /** @type {?} */ members = classMetadata ? classMetadata['members'] : null;
	                var /** @type {?} */ ctorData = members ? members['__ctor__'] : null;
	                if (ctorData) {
	                    var /** @type {?} */ ctor = (/** @type {?} */ (ctorData)).find(function (a) { return a['__symbolic'] == 'constructor'; });
	                    var /** @type {?} */ rawParameterTypes = /** @type {?} */ (ctor['parameters']) || [];
	                    var /** @type {?} */ parameterDecorators_1 = /** @type {?} */ (this.simplify(type, ctor['parameterDecorators'] || []));
	                    parameters_1 = [];
	                    rawParameterTypes.forEach(function (rawParamType, index) {
	                        var /** @type {?} */ nestedResult = [];
	                        var /** @type {?} */ paramType = _this.trySimplify(type, rawParamType);
	                        if (paramType)
	                            nestedResult.push(paramType);
	                        var /** @type {?} */ decorators = parameterDecorators_1 ? parameterDecorators_1[index] : null;
	                        if (decorators) {
	                            nestedResult.push.apply(nestedResult, decorators);
	                        } /** @type {?} */
	                        ((parameters_1)).push(nestedResult);
	                    });
	                }
	                else if (parentType) {
	                    parameters_1 = this.parameters(parentType);
	                }
	                if (!parameters_1) {
	                    parameters_1 = [];
	                }
	                this.parameterCache.set(type, parameters_1);
	            }
	            return parameters_1;
	        }
	        catch (/** @type {?} */ e) {
	            console.error("Failed on type " + JSON.stringify(type) + " with error " + e);
	            throw e;
	        }
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype._methodNames = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ methodNames = this.methodCache.get(type);
	        if (!methodNames) {
	            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
	            methodNames = {};
	            var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
	            if (parentType) {
	                var /** @type {?} */ parentMethodNames_1 = this._methodNames(parentType);
	                Object.keys(parentMethodNames_1).forEach(function (parentProp) {
	                    /** @type {?} */ ((methodNames))[parentProp] = parentMethodNames_1[parentProp];
	                });
	            }
	            var /** @type {?} */ members_2 = classMetadata['members'] || {};
	            Object.keys(members_2).forEach(function (propName) {
	                var /** @type {?} */ propData = members_2[propName];
	                var /** @type {?} */ isMethod = (/** @type {?} */ (propData)).some(function (a) { return a['__symbolic'] == 'method'; }); /** @type {?} */
	                ((methodNames))[propName] = /** @type {?} */ ((methodNames))[propName] || isMethod;
	            });
	            this.methodCache.set(type, methodNames);
	        }
	        return methodNames;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype._staticMembers = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ staticMembers = this.staticCache.get(type);
	        if (!staticMembers) {
	            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
	            var /** @type {?} */ staticMemberData = classMetadata['statics'] || {};
	            staticMembers = Object.keys(staticMemberData);
	            this.staticCache.set(type, staticMembers);
	        }
	        return staticMembers;
	    };
	    /**
	     * @param {?} type
	     * @param {?} classMetadata
	     * @return {?}
	     */
	    StaticReflector.prototype.findParentType = /**
	     * @param {?} type
	     * @param {?} classMetadata
	     * @return {?}
	     */
	    function (type, classMetadata) {
	        var /** @type {?} */ parentType = this.trySimplify(type, classMetadata['extends']);
	        if (parentType instanceof StaticSymbol) {
	            return parentType;
	        }
	    };
	    /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    StaticReflector.prototype.hasLifecycleHook = /**
	     * @param {?} type
	     * @param {?} lcProperty
	     * @return {?}
	     */
	    function (type, lcProperty) {
	        if (!(type instanceof StaticSymbol)) {
	            this.reportError(new Error("hasLifecycleHook received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
	        }
	        try {
	            return !!this._methodNames(type)[lcProperty];
	        }
	        catch (/** @type {?} */ e) {
	            console.error("Failed on type " + JSON.stringify(type) + " with error " + e);
	            throw e;
	        }
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype.guards = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        if (!(type instanceof StaticSymbol)) {
	            this.reportError(new Error("guards received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
	            return {};
	        }
	        var /** @type {?} */ staticMembers = this._staticMembers(type);
	        var /** @type {?} */ result = {};
	        for (var _i = 0, staticMembers_1 = staticMembers; _i < staticMembers_1.length; _i++) {
	            var name_1 = staticMembers_1[_i];
	            if (name_1.endsWith(TYPEGUARD_POSTFIX)) {
	                var /** @type {?} */ property = name_1.substr(0, name_1.length - TYPEGUARD_POSTFIX.length);
	                var /** @type {?} */ value = void 0;
	                if (property.endsWith(USE_IF)) {
	                    property = name_1.substr(0, property.length - USE_IF.length);
	                    value = USE_IF;
	                }
	                else {
	                    value = this.getStaticSymbol(type.filePath, type.name, [name_1]);
	                }
	                result[property] = value;
	            }
	        }
	        return result;
	    };
	    /**
	     * @param {?} type
	     * @param {?} ctor
	     * @return {?}
	     */
	    StaticReflector.prototype._registerDecoratorOrConstructor = /**
	     * @param {?} type
	     * @param {?} ctor
	     * @return {?}
	     */
	    function (type, ctor) {
	        this.conversionMap.set(type, function (context, args) { return new (ctor.bind.apply(ctor, [void 0].concat(args)))(); });
	    };
	    /**
	     * @param {?} type
	     * @param {?} fn
	     * @return {?}
	     */
	    StaticReflector.prototype._registerFunction = /**
	     * @param {?} type
	     * @param {?} fn
	     * @return {?}
	     */
	    function (type, fn) {
	        this.conversionMap.set(type, function (context, args) { return fn.apply(undefined, args); });
	    };
	    /**
	     * @return {?}
	     */
	    StaticReflector.prototype.initializeConversionMap = /**
	     * @return {?}
	     */
	    function () {
	        this.injectionToken = this.findDeclaration(ANGULAR_CORE, 'InjectionToken');
	        this.opaqueToken = this.findDeclaration(ANGULAR_CORE, 'OpaqueToken');
	        this.ROUTES = this.tryFindDeclaration(ANGULAR_ROUTER, 'ROUTES');
	        this.ANALYZE_FOR_ENTRY_COMPONENTS =
	            this.findDeclaration(ANGULAR_CORE, 'ANALYZE_FOR_ENTRY_COMPONENTS');
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Host'), createHost);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Injectable'), createInjectable);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Self'), createSelf);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'SkipSelf'), createSkipSelf);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Inject'), createInject);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Optional'), createOptional);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Attribute'), createAttribute);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ContentChild'), createContentChild);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ContentChildren'), createContentChildren);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ViewChild'), createViewChild);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ViewChildren'), createViewChildren);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Input'), createInput);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Output'), createOutput);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Pipe'), createPipe);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'HostBinding'), createHostBinding);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'HostListener'), createHostListener);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Directive'), createDirective);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Component'), createComponent);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'NgModule'), createNgModule);
	        // Note: Some metadata classes can be used directly with Provider.deps.
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Host'), createHost);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Self'), createSelf);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'SkipSelf'), createSkipSelf);
	        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Optional'), createOptional);
	    };
	    /**
	     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
	     * All types passed to the StaticResolver should be pseudo-types returned by this method.
	     *
	     * @param declarationFile the absolute path of the file where the symbol is declared
	     * @param name the name of the type.
	     */
	    /**
	     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
	     * All types passed to the StaticResolver should be pseudo-types returned by this method.
	     *
	     * @param {?} declarationFile the absolute path of the file where the symbol is declared
	     * @param {?} name the name of the type.
	     * @param {?=} members
	     * @return {?}
	     */
	    StaticReflector.prototype.getStaticSymbol = /**
	     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
	     * All types passed to the StaticResolver should be pseudo-types returned by this method.
	     *
	     * @param {?} declarationFile the absolute path of the file where the symbol is declared
	     * @param {?} name the name of the type.
	     * @param {?=} members
	     * @return {?}
	     */
	    function (declarationFile, name, members) {
	        return this.symbolResolver.getStaticSymbol(declarationFile, name, members);
	    };
	    /**
	     * Simplify but discard any errors
	     * @param {?} context
	     * @param {?} value
	     * @return {?}
	     */
	    StaticReflector.prototype.trySimplify = /**
	     * Simplify but discard any errors
	     * @param {?} context
	     * @param {?} value
	     * @return {?}
	     */
	    function (context, value) {
	        var /** @type {?} */ originalRecorder = this.errorRecorder;
	        this.errorRecorder = function (error, fileName) { };
	        var /** @type {?} */ result = this.simplify(context, value);
	        this.errorRecorder = originalRecorder;
	        return result;
	    };
	    /**
	     * \@internal
	     * @param {?} context
	     * @param {?} value
	     * @return {?}
	     */
	    StaticReflector.prototype.simplify = /**
	     * \@internal
	     * @param {?} context
	     * @param {?} value
	     * @return {?}
	     */
	    function (context, value) {
	        var /** @type {?} */ self = this;
	        var /** @type {?} */ scope = BindingScope.empty;
	        var /** @type {?} */ calling = new Map();
	        var /** @type {?} */ rootContext = context;
	        /**
	         * @param {?} context
	         * @param {?} value
	         * @param {?} depth
	         * @param {?} references
	         * @return {?}
	         */
	        function simplifyInContext(context, value, depth, references) {
	            /**
	             * @param {?} staticSymbol
	             * @return {?}
	             */
	            function resolveReferenceValue(staticSymbol) {
	                var /** @type {?} */ resolvedSymbol = self.symbolResolver.resolveSymbol(staticSymbol);
	                return resolvedSymbol ? resolvedSymbol.metadata : null;
	            }
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            function simplifyEagerly(value) {
	                return simplifyInContext(context, value, depth, 0);
	            }
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            function simplifyLazily(value) {
	                return simplifyInContext(context, value, depth, references + 1);
	            }
	            /**
	             * @param {?} nestedContext
	             * @param {?} value
	             * @return {?}
	             */
	            function simplifyNested(nestedContext, value) {
	                if (nestedContext === context) {
	                    // If the context hasn't changed let the exception propagate unmodified.
	                    return simplifyInContext(nestedContext, value, depth + 1, references);
	                }
	                try {
	                    return simplifyInContext(nestedContext, value, depth + 1, references);
	                }
	                catch (/** @type {?} */ e) {
	                    if (isMetadataError(e)) {
	                        // Propagate the message text up but add a message to the chain that explains how we got
	                        // here.
	                        // e.chain implies e.symbol
	                        var /** @type {?} */ summaryMsg = e.chain ? 'references \'' + /** @type {?} */ ((e.symbol)).name + '\'' : errorSummary(e);
	                        var /** @type {?} */ summary = "'" + nestedContext.name + "' " + summaryMsg;
	                        var /** @type {?} */ chain = { message: summary, position: e.position, next: e.chain };
	                        // TODO(chuckj): retrieve the position information indirectly from the collectors node
	                        // map if the metadata is from a .ts file.
	                        self.error({
	                            message: e.message,
	                            advise: e.advise,
	                            context: e.context, chain: chain,
	                            symbol: nestedContext
	                        }, context);
	                    }
	                    else {
	                        // It is probably an internal error.
	                        throw e;
	                    }
	                }
	            }
	            /**
	             * @param {?} functionSymbol
	             * @param {?} targetFunction
	             * @param {?} args
	             * @param {?} targetExpression
	             * @return {?}
	             */
	            function simplifyCall(functionSymbol, targetFunction, args, targetExpression) {
	                if (targetFunction && targetFunction['__symbolic'] == 'function') {
	                    if (calling.get(functionSymbol)) {
	                        self.error({
	                            message: 'Recursion is not supported',
	                            summary: "called '" + functionSymbol.name + "' recursively",
	                            value: targetFunction
	                        }, functionSymbol);
	                    }
	                    try {
	                        var /** @type {?} */ value_1 = targetFunction['value'];
	                        if (value_1 && (depth != 0 || value_1.__symbolic != 'error')) {
	                            var /** @type {?} */ parameters = targetFunction['parameters'];
	                            var /** @type {?} */ defaults = targetFunction.defaults;
	                            args = args.map(function (arg) { return simplifyNested(context, arg); })
	                                .map(function (arg) { return shouldIgnore(arg) ? undefined : arg; });
	                            if (defaults && defaults.length > args.length) {
	                                args.push.apply(args, defaults.slice(args.length).map(function (value) { return simplify(value); }));
	                            }
	                            calling.set(functionSymbol, true);
	                            var /** @type {?} */ functionScope = BindingScope.build();
	                            for (var /** @type {?} */ i = 0; i < parameters.length; i++) {
	                                functionScope.define(parameters[i], args[i]);
	                            }
	                            var /** @type {?} */ oldScope = scope;
	                            var /** @type {?} */ result_1;
	                            try {
	                                scope = functionScope.done();
	                                result_1 = simplifyNested(functionSymbol, value_1);
	                            }
	                            finally {
	                                scope = oldScope;
	                            }
	                            return result_1;
	                        }
	                    }
	                    finally {
	                        calling.delete(functionSymbol);
	                    }
	                }
	                if (depth === 0) {
	                    // If depth is 0 we are evaluating the top level expression that is describing element
	                    // decorator. In this case, it is a decorator we don't understand, such as a custom
	                    // non-angular decorator, and we should just ignore it.
	                    return IGNORE;
	                }
	                var /** @type {?} */ position = undefined;
	                if (targetExpression && targetExpression.__symbolic == 'resolved') {
	                    var /** @type {?} */ line = targetExpression.line;
	                    var /** @type {?} */ character = targetExpression.character;
	                    var /** @type {?} */ fileName = targetExpression.fileName;
	                    if (fileName != null && line != null && character != null) {
	                        position = { fileName: fileName, line: line, column: character };
	                    }
	                }
	                self.error({
	                    message: FUNCTION_CALL_NOT_SUPPORTED,
	                    context: functionSymbol,
	                    value: targetFunction, position: position
	                }, context);
	            }
	            /**
	             * @param {?} expression
	             * @return {?}
	             */
	            function simplify(expression) {
	                if (isPrimitive(expression)) {
	                    return expression;
	                }
	                if (expression instanceof Array) {
	                    var /** @type {?} */ result_2 = [];
	                    for (var _i = 0, _a = (/** @type {?} */ (expression)); _i < _a.length; _i++) {
	                        var item = _a[_i];
	                        // Check for a spread expression
	                        if (item && item.__symbolic === 'spread') {
	                            // We call with references as 0 because we require the actual value and cannot
	                            // tolerate a reference here.
	                            var /** @type {?} */ spreadArray = simplifyEagerly(item.expression);
	                            if (Array.isArray(spreadArray)) {
	                                for (var _b = 0, spreadArray_1 = spreadArray; _b < spreadArray_1.length; _b++) {
	                                    var spreadItem = spreadArray_1[_b];
	                                    result_2.push(spreadItem);
	                                }
	                                continue;
	                            }
	                        }
	                        var /** @type {?} */ value_2 = simplify(item);
	                        if (shouldIgnore(value_2)) {
	                            continue;
	                        }
	                        result_2.push(value_2);
	                    }
	                    return result_2;
	                }
	                if (expression instanceof StaticSymbol) {
	                    // Stop simplification at builtin symbols or if we are in a reference context and
	                    // the symbol doesn't have members.
	                    if (expression === self.injectionToken || self.conversionMap.has(expression) ||
	                        (references > 0 && !expression.members.length)) {
	                        return expression;
	                    }
	                    else {
	                        var /** @type {?} */ staticSymbol = expression;
	                        var /** @type {?} */ declarationValue = resolveReferenceValue(staticSymbol);
	                        if (declarationValue != null) {
	                            return simplifyNested(staticSymbol, declarationValue);
	                        }
	                        else {
	                            return staticSymbol;
	                        }
	                    }
	                }
	                if (expression) {
	                    if (expression['__symbolic']) {
	                        var /** @type {?} */ staticSymbol = void 0;
	                        switch (expression['__symbolic']) {
	                            case 'binop':
	                                var /** @type {?} */ left = simplify(expression['left']);
	                                if (shouldIgnore(left))
	                                    return left;
	                                var /** @type {?} */ right = simplify(expression['right']);
	                                if (shouldIgnore(right))
	                                    return right;
	                                switch (expression['operator']) {
	                                    case '&&':
	                                        return left && right;
	                                    case '||':
	                                        return left || right;
	                                    case '|':
	                                        return left | right;
	                                    case '^':
	                                        return left ^ right;
	                                    case '&':
	                                        return left & right;
	                                    case '==':
	                                        return left == right;
	                                    case '!=':
	                                        return left != right;
	                                    case '===':
	                                        return left === right;
	                                    case '!==':
	                                        return left !== right;
	                                    case '<':
	                                        return left < right;
	                                    case '>':
	                                        return left > right;
	                                    case '<=':
	                                        return left <= right;
	                                    case '>=':
	                                        return left >= right;
	                                    case '<<':
	                                        return left << right;
	                                    case '>>':
	                                        return left >> right;
	                                    case '+':
	                                        return left + right;
	                                    case '-':
	                                        return left - right;
	                                    case '*':
	                                        return left * right;
	                                    case '/':
	                                        return left / right;
	                                    case '%':
	                                        return left % right;
	                                }
	                                return null;
	                            case 'if':
	                                var /** @type {?} */ condition = simplify(expression['condition']);
	                                return condition ? simplify(expression['thenExpression']) :
	                                    simplify(expression['elseExpression']);
	                            case 'pre':
	                                var /** @type {?} */ operand = simplify(expression['operand']);
	                                if (shouldIgnore(operand))
	                                    return operand;
	                                switch (expression['operator']) {
	                                    case '+':
	                                        return operand;
	                                    case '-':
	                                        return -operand;
	                                    case '!':
	                                        return !operand;
	                                    case '~':
	                                        return ~operand;
	                                }
	                                return null;
	                            case 'index':
	                                var /** @type {?} */ indexTarget = simplifyEagerly(expression['expression']);
	                                var /** @type {?} */ index = simplifyEagerly(expression['index']);
	                                if (indexTarget && isPrimitive(index))
	                                    return indexTarget[index];
	                                return null;
	                            case 'select':
	                                var /** @type {?} */ member = expression['member'];
	                                var /** @type {?} */ selectContext = context;
	                                var /** @type {?} */ selectTarget = simplify(expression['expression']);
	                                if (selectTarget instanceof StaticSymbol) {
	                                    var /** @type {?} */ members = selectTarget.members.concat(member);
	                                    selectContext =
	                                        self.getStaticSymbol(selectTarget.filePath, selectTarget.name, members);
	                                    var /** @type {?} */ declarationValue = resolveReferenceValue(selectContext);
	                                    if (declarationValue != null) {
	                                        return simplifyNested(selectContext, declarationValue);
	                                    }
	                                    else {
	                                        return selectContext;
	                                    }
	                                }
	                                if (selectTarget && isPrimitive(member))
	                                    return simplifyNested(selectContext, selectTarget[member]);
	                                return null;
	                            case 'reference':
	                                // Note: This only has to deal with variable references, as symbol references have
	                                // been converted into 'resolved'
	                                // in the StaticSymbolResolver.
	                                var /** @type {?} */ name_2 = expression['name'];
	                                var /** @type {?} */ localValue = scope.resolve(name_2);
	                                if (localValue != BindingScope.missing) {
	                                    return localValue;
	                                }
	                                break;
	                            case 'resolved':
	                                try {
	                                    return simplify(expression.symbol);
	                                }
	                                catch (/** @type {?} */ e) {
	                                    // If an error is reported evaluating the symbol record the position of the
	                                    // reference in the error so it can
	                                    // be reported in the error message generated from the exception.
	                                    if (isMetadataError(e) && expression.fileName != null &&
	                                        expression.line != null && expression.character != null) {
	                                        e.position = {
	                                            fileName: expression.fileName,
	                                            line: expression.line,
	                                            column: expression.character
	                                        };
	                                    }
	                                    throw e;
	                                }
	                            case 'class':
	                                return context;
	                            case 'function':
	                                return context;
	                            case 'new':
	                            case 'call':
	                                // Determine if the function is a built-in conversion
	                                staticSymbol = simplifyInContext(context, expression['expression'], depth + 1, /* references */ 0);
	                                if (staticSymbol instanceof StaticSymbol) {
	                                    if (staticSymbol === self.injectionToken || staticSymbol === self.opaqueToken) {
	                                        // if somebody calls new InjectionToken, don't create an InjectionToken,
	                                        // but rather return the symbol to which the InjectionToken is assigned to.
	                                        // OpaqueToken is supported too as it is required by the language service to
	                                        // support v4 and prior versions of Angular.
	                                        return context;
	                                    }
	                                    var /** @type {?} */ argExpressions = expression['arguments'] || [];
	                                    var /** @type {?} */ converter = self.conversionMap.get(staticSymbol);
	                                    if (converter) {
	                                        var /** @type {?} */ args = argExpressions.map(function (arg) { return simplifyNested(context, arg); })
	                                            .map(function (arg) { return shouldIgnore(arg) ? undefined : arg; });
	                                        return converter(context, args);
	                                    }
	                                    else {
	                                        // Determine if the function is one we can simplify.
	                                        var /** @type {?} */ targetFunction = resolveReferenceValue(staticSymbol);
	                                        return simplifyCall(staticSymbol, targetFunction, argExpressions, expression['expression']);
	                                    }
	                                }
	                                return IGNORE;
	                            case 'error':
	                                var /** @type {?} */ message = expression.message;
	                                if (expression['line'] != null) {
	                                    self.error({
	                                        message: message,
	                                        context: expression.context,
	                                        value: expression,
	                                        position: {
	                                            fileName: expression['fileName'],
	                                            line: expression['line'],
	                                            column: expression['character']
	                                        }
	                                    }, context);
	                                }
	                                else {
	                                    self.error({ message: message, context: expression.context }, context);
	                                }
	                                return IGNORE;
	                            case 'ignore':
	                                return expression;
	                        }
	                        return null;
	                    }
	                    return mapStringMap(expression, function (value, name) {
	                        if (REFERENCE_SET.has(name)) {
	                            if (name === USE_VALUE && PROVIDE in expression) {
	                                // If this is a provider expression, check for special tokens that need the value
	                                // during analysis.
	                                var /** @type {?} */ provide = simplify(expression.provide);
	                                if (provide === self.ROUTES || provide == self.ANALYZE_FOR_ENTRY_COMPONENTS) {
	                                    return simplify(value);
	                                }
	                            }
	                            return simplifyLazily(value);
	                        }
	                        return simplify(value);
	                    });
	                }
	                return IGNORE;
	            }
	            return simplify(value);
	        }
	        var /** @type {?} */ result;
	        try {
	            result = simplifyInContext(context, value, 0, 0);
	        }
	        catch (/** @type {?} */ e) {
	            if (this.errorRecorder) {
	                this.reportError(e, context);
	            }
	            else {
	                throw formatMetadataError(e, context);
	            }
	        }
	        if (shouldIgnore(result)) {
	            return undefined;
	        }
	        return result;
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    StaticReflector.prototype.getTypeMetadata = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        var /** @type {?} */ resolvedSymbol = this.symbolResolver.resolveSymbol(type);
	        return resolvedSymbol && resolvedSymbol.metadata ? resolvedSymbol.metadata :
	            { __symbolic: 'class' };
	    };
	    /**
	     * @param {?} error
	     * @param {?} context
	     * @param {?=} path
	     * @return {?}
	     */
	    StaticReflector.prototype.reportError = /**
	     * @param {?} error
	     * @param {?} context
	     * @param {?=} path
	     * @return {?}
	     */
	    function (error, context, path) {
	        if (this.errorRecorder) {
	            this.errorRecorder(formatMetadataError(error, context), (context && context.filePath) || path);
	        }
	        else {
	            throw error;
	        }
	    };
	    /**
	     * @param {?} __0
	     * @param {?} reportingContext
	     * @return {?}
	     */
	    StaticReflector.prototype.error = /**
	     * @param {?} __0
	     * @param {?} reportingContext
	     * @return {?}
	     */
	    function (_a, reportingContext) {
	        var message = _a.message, summary = _a.summary, advise = _a.advise, position = _a.position, context = _a.context, value = _a.value, symbol = _a.symbol, chain = _a.chain;
	        this.reportError(metadataError(message, summary, advise, position, symbol, context, chain), reportingContext);
	    };
	    return StaticReflector;
	}());
	var METADATA_ERROR = 'ngMetadataError';
	/**
	 * @param {?} message
	 * @param {?=} summary
	 * @param {?=} advise
	 * @param {?=} position
	 * @param {?=} symbol
	 * @param {?=} context
	 * @param {?=} chain
	 * @return {?}
	 */
	function metadataError(message, summary, advise, position, symbol, context, chain) {
	    var /** @type {?} */ error = /** @type {?} */ (syntaxError(message));
	    (/** @type {?} */ (error))[METADATA_ERROR] = true;
	    if (advise)
	        error.advise = advise;
	    if (position)
	        error.position = position;
	    if (summary)
	        error.summary = summary;
	    if (context)
	        error.context = context;
	    if (chain)
	        error.chain = chain;
	    if (symbol)
	        error.symbol = symbol;
	    return error;
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function isMetadataError(error) {
	    return !!(/** @type {?} */ (error))[METADATA_ERROR];
	}
	var REFERENCE_TO_NONEXPORTED_CLASS = 'Reference to non-exported class';
	var VARIABLE_NOT_INITIALIZED = 'Variable not initialized';
	var DESTRUCTURE_NOT_SUPPORTED = 'Destructuring not supported';
	var COULD_NOT_RESOLVE_TYPE = 'Could not resolve type';
	var FUNCTION_CALL_NOT_SUPPORTED = 'Function call not supported';
	var REFERENCE_TO_LOCAL_SYMBOL = 'Reference to a local symbol';
	var LAMBDA_NOT_SUPPORTED = 'Lambda not supported';
	/**
	 * @param {?} message
	 * @param {?} context
	 * @return {?}
	 */
	function expandedMessage(message, context) {
	    switch (message) {
	        case REFERENCE_TO_NONEXPORTED_CLASS:
	            if (context && context.className) {
	                return "References to a non-exported class are not supported in decorators but " + context.className + " was referenced.";
	            }
	            break;
	        case VARIABLE_NOT_INITIALIZED:
	            return 'Only initialized variables and constants can be referenced in decorators because the value of this variable is needed by the template compiler';
	        case DESTRUCTURE_NOT_SUPPORTED:
	            return 'Referencing an exported destructured variable or constant is not supported in decorators and this value is needed by the template compiler';
	        case COULD_NOT_RESOLVE_TYPE:
	            if (context && context.typeName) {
	                return "Could not resolve type " + context.typeName;
	            }
	            break;
	        case FUNCTION_CALL_NOT_SUPPORTED:
	            if (context && context.name) {
	                return "Function calls are not supported in decorators but '" + context.name + "' was called";
	            }
	            return 'Function calls are not supported in decorators';
	        case REFERENCE_TO_LOCAL_SYMBOL:
	            if (context && context.name) {
	                return "Reference to a local (non-exported) symbols are not supported in decorators but '" + context.name + "' was referenced";
	            }
	            break;
	        case LAMBDA_NOT_SUPPORTED:
	            return "Function expressions are not supported in decorators";
	    }
	    return message;
	}
	/**
	 * @param {?} message
	 * @param {?} context
	 * @return {?}
	 */
	function messageAdvise(message, context) {
	    switch (message) {
	        case REFERENCE_TO_NONEXPORTED_CLASS:
	            if (context && context.className) {
	                return "Consider exporting '" + context.className + "'";
	            }
	            break;
	        case DESTRUCTURE_NOT_SUPPORTED:
	            return 'Consider simplifying to avoid destructuring';
	        case REFERENCE_TO_LOCAL_SYMBOL:
	            if (context && context.name) {
	                return "Consider exporting '" + context.name + "'";
	            }
	            break;
	        case LAMBDA_NOT_SUPPORTED:
	            return "Consider changing the function expression into an exported function";
	    }
	    return undefined;
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function errorSummary(error) {
	    if (error.summary) {
	        return error.summary;
	    }
	    switch (error.message) {
	        case REFERENCE_TO_NONEXPORTED_CLASS:
	            if (error.context && error.context.className) {
	                return "references non-exported class " + error.context.className;
	            }
	            break;
	        case VARIABLE_NOT_INITIALIZED:
	            return 'is not initialized';
	        case DESTRUCTURE_NOT_SUPPORTED:
	            return 'is a destructured variable';
	        case COULD_NOT_RESOLVE_TYPE:
	            return 'could not be resolved';
	        case FUNCTION_CALL_NOT_SUPPORTED:
	            if (error.context && error.context.name) {
	                return "calls '" + error.context.name + "'";
	            }
	            return "calls a function";
	        case REFERENCE_TO_LOCAL_SYMBOL:
	            if (error.context && error.context.name) {
	                return "references local variable " + error.context.name;
	            }
	            return "references a local variable";
	    }
	    return 'contains the error';
	}
	/**
	 * @param {?} input
	 * @param {?} transform
	 * @return {?}
	 */
	function mapStringMap(input, transform) {
	    if (!input)
	        return {};
	    var /** @type {?} */ result = {};
	    Object.keys(input).forEach(function (key) {
	        var /** @type {?} */ value = transform(input[key], key);
	        if (!shouldIgnore(value)) {
	            if (HIDDEN_KEY.test(key)) {
	                Object.defineProperty(result, key, { enumerable: false, configurable: true, value: value });
	            }
	            else {
	                result[key] = value;
	            }
	        }
	    });
	    return result;
	}
	/**
	 * @param {?} o
	 * @return {?}
	 */
	function isPrimitive(o) {
	    return o === null || (typeof o !== 'function' && typeof o !== 'object');
	}
	/**
	 * @abstract
	 */
	var BindingScope = /** @class */ (function () {
	    function BindingScope() {
	    }
	    /**
	     * @return {?}
	     */
	    BindingScope.build = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ current = new Map();
	        return {
	            define: function (name, value) {
	                current.set(name, value);
	                return this;
	            },
	            done: function () {
	                return current.size > 0 ? new PopulatedScope(current) : BindingScope.empty;
	            }
	        };
	    };
	    BindingScope.missing = {};
	    BindingScope.empty = { resolve: function (name) { return BindingScope.missing; } };
	    return BindingScope;
	}());
	var PopulatedScope = /** @class */ (function (_super) {
	    __extends(PopulatedScope, _super);
	    function PopulatedScope(bindings) {
	        var _this = _super.call(this) || this;
	        _this.bindings = bindings;
	        return _this;
	    }
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    PopulatedScope.prototype.resolve = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        return this.bindings.has(name) ? this.bindings.get(name) : BindingScope.missing;
	    };
	    return PopulatedScope;
	}(BindingScope));
	/**
	 * @param {?} chain
	 * @param {?} advise
	 * @return {?}
	 */
	function formatMetadataMessageChain(chain, advise) {
	    var /** @type {?} */ expanded = expandedMessage(chain.message, chain.context);
	    var /** @type {?} */ nesting = chain.symbol ? " in '" + chain.symbol.name + "'" : '';
	    var /** @type {?} */ message = "" + expanded + nesting;
	    var /** @type {?} */ position = chain.position;
	    var /** @type {?} */ next = chain.next ?
	        formatMetadataMessageChain(chain.next, advise) :
	        advise ? { message: advise } : undefined;
	    return { message: message, position: position, next: next };
	}
	/**
	 * @param {?} e
	 * @param {?} context
	 * @return {?}
	 */
	function formatMetadataError(e, context) {
	    if (isMetadataError(e)) {
	        // Produce a formatted version of the and leaving enough information in the original error
	        // to recover the formatting information to eventually produce a diagnostic error message.
	        var /** @type {?} */ position = e.position;
	        var /** @type {?} */ chain = {
	            message: "Error during template compile of '" + context.name + "'",
	            position: position,
	            next: { message: e.message, next: e.chain, context: e.context, symbol: e.symbol }
	        };
	        var /** @type {?} */ advise = e.advise || messageAdvise(e.message, e.context);
	        return formattedError(formatMetadataMessageChain(chain, advise));
	    }
	    return e;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	var AotSummaryResolver = /** @class */ (function () {
	    function AotSummaryResolver(host, staticSymbolCache) {
	        this.host = host;
	        this.staticSymbolCache = staticSymbolCache;
	        this.summaryCache = new Map();
	        this.loadedFilePaths = new Map();
	        this.importAs = new Map();
	        this.knownFileNameToModuleNames = new Map();
	    }
	    /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.isLibraryFile = /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    function (filePath) {
	        // Note: We need to strip the .ngfactory. file path,
	        // so this method also works for generated files
	        // (for which host.isSourceFile will always return false).
	        return !this.host.isSourceFile(stripGeneratedFileSuffix(filePath));
	    };
	    /**
	     * @param {?} filePath
	     * @param {?} referringSrcFileName
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.toSummaryFileName = /**
	     * @param {?} filePath
	     * @param {?} referringSrcFileName
	     * @return {?}
	     */
	    function (filePath, referringSrcFileName) {
	        return this.host.toSummaryFileName(filePath, referringSrcFileName);
	    };
	    /**
	     * @param {?} fileName
	     * @param {?} referringLibFileName
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.fromSummaryFileName = /**
	     * @param {?} fileName
	     * @param {?} referringLibFileName
	     * @return {?}
	     */
	    function (fileName, referringLibFileName) {
	        return this.host.fromSummaryFileName(fileName, referringLibFileName);
	    };
	    /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.resolveSummary = /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        var /** @type {?} */ rootSymbol = staticSymbol.members.length ?
	            this.staticSymbolCache.get(staticSymbol.filePath, staticSymbol.name) :
	            staticSymbol;
	        var /** @type {?} */ summary = this.summaryCache.get(rootSymbol);
	        if (!summary) {
	            this._loadSummaryFile(staticSymbol.filePath);
	            summary = /** @type {?} */ ((this.summaryCache.get(staticSymbol)));
	        }
	        return (rootSymbol === staticSymbol && summary) || null;
	    };
	    /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.getSymbolsOf = /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    function (filePath) {
	        if (this._loadSummaryFile(filePath)) {
	            return Array.from(this.summaryCache.keys()).filter(function (symbol) { return symbol.filePath === filePath; });
	        }
	        return null;
	    };
	    /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.getImportAs = /**
	     * @param {?} staticSymbol
	     * @return {?}
	     */
	    function (staticSymbol) {
	        staticSymbol.assertNoMembers();
	        return /** @type {?} */ ((this.importAs.get(staticSymbol)));
	    };
	    /**
	     * Converts a file path to a module name that can be used as an `import`.
	     */
	    /**
	     * Converts a file path to a module name that can be used as an `import`.
	     * @param {?} importedFilePath
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.getKnownModuleName = /**
	     * Converts a file path to a module name that can be used as an `import`.
	     * @param {?} importedFilePath
	     * @return {?}
	     */
	    function (importedFilePath) {
	        return this.knownFileNameToModuleNames.get(importedFilePath) || null;
	    };
	    /**
	     * @param {?} summary
	     * @return {?}
	     */
	    AotSummaryResolver.prototype.addSummary = /**
	     * @param {?} summary
	     * @return {?}
	     */
	    function (summary) { this.summaryCache.set(summary.symbol, summary); };
	    /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    AotSummaryResolver.prototype._loadSummaryFile = /**
	     * @param {?} filePath
	     * @return {?}
	     */
	    function (filePath) {
	        var _this = this;
	        var /** @type {?} */ hasSummary = this.loadedFilePaths.get(filePath);
	        if (hasSummary != null) {
	            return hasSummary;
	        }
	        var /** @type {?} */ json = null;
	        if (this.isLibraryFile(filePath)) {
	            var /** @type {?} */ summaryFilePath = summaryFileName(filePath);
	            try {
	                json = this.host.loadSummary(summaryFilePath);
	            }
	            catch (/** @type {?} */ e) {
	                console.error("Error loading summary file " + summaryFilePath);
	                throw e;
	            }
	        }
	        hasSummary = json != null;
	        this.loadedFilePaths.set(filePath, hasSummary);
	        if (json) {
	            var _a = deserializeSummaries(this.staticSymbolCache, this, filePath, json), moduleName = _a.moduleName, summaries = _a.summaries, importAs = _a.importAs;
	            summaries.forEach(function (summary) { return _this.summaryCache.set(summary.symbol, summary); });
	            if (moduleName) {
	                this.knownFileNameToModuleNames.set(filePath, moduleName);
	            }
	            importAs.forEach(function (importAs) { _this.importAs.set(importAs.symbol, importAs.importAs); });
	        }
	        return hasSummary;
	    };
	    return AotSummaryResolver;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} host
	 * @return {?}
	 */
	function createAotUrlResolver(host) {
	    return {
	        resolve: function (basePath, url) {
	            var /** @type {?} */ filePath = host.resourceNameToFileName(url, basePath);
	            if (!filePath) {
	                throw syntaxError("Couldn't resolve resource " + url + " from " + basePath);
	            }
	            return filePath;
	        }
	    };
	}
	/**
	 * Creates a new AotCompiler based on options and a host.
	 * @param {?} compilerHost
	 * @param {?} options
	 * @param {?=} errorCollector
	 * @return {?}
	 */
	function createAotCompiler(compilerHost, options, errorCollector) {
	    var /** @type {?} */ translations = options.translations || '';
	    var /** @type {?} */ urlResolver = createAotUrlResolver(compilerHost);
	    var /** @type {?} */ symbolCache = new StaticSymbolCache();
	    var /** @type {?} */ summaryResolver = new AotSummaryResolver(compilerHost, symbolCache);
	    var /** @type {?} */ symbolResolver = new StaticSymbolResolver(compilerHost, symbolCache, summaryResolver);
	    var /** @type {?} */ staticReflector = new StaticReflector(summaryResolver, symbolResolver, [], [], errorCollector);
	    var /** @type {?} */ htmlParser = new I18NHtmlParser(new HtmlParser(), translations, options.i18nFormat, options.missingTranslation, console);
	    var /** @type {?} */ config = new CompilerConfig({
	        defaultEncapsulation: ViewEncapsulation.Emulated,
	        useJit: false,
	        enableLegacyTemplate: options.enableLegacyTemplate === true,
	        missingTranslation: options.missingTranslation,
	        preserveWhitespaces: options.preserveWhitespaces,
	        strictInjectionParameters: options.strictInjectionParameters,
	    });
	    var /** @type {?} */ normalizer = new DirectiveNormalizer({ get: function (url) { return compilerHost.loadResource(url); } }, urlResolver, htmlParser, config);
	    var /** @type {?} */ expressionParser = new Parser(new Lexer());
	    var /** @type {?} */ elementSchemaRegistry = new DomElementSchemaRegistry();
	    var /** @type {?} */ tmplParser = new TemplateParser(config, staticReflector, expressionParser, elementSchemaRegistry, htmlParser, console, []);
	    var /** @type {?} */ resolver = new CompileMetadataResolver(config, htmlParser, new NgModuleResolver(staticReflector), new DirectiveResolver(staticReflector), new PipeResolver(staticReflector), summaryResolver, elementSchemaRegistry, normalizer, console, symbolCache, staticReflector, errorCollector);
	    // TODO(vicb): do not pass options.i18nFormat here
	    var /** @type {?} */ viewCompiler = new ViewCompiler(staticReflector);
	    var /** @type {?} */ typeCheckCompiler = new TypeCheckCompiler(options, staticReflector);
	    var /** @type {?} */ compiler = new AotCompiler(config, options, compilerHost, staticReflector, resolver, tmplParser, new StyleCompiler(urlResolver), viewCompiler, typeCheckCompiler, new NgModuleCompiler(staticReflector), new TypeScriptEmitter(), summaryResolver, symbolResolver);
	    return { compiler: compiler, reflector: staticReflector };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @record
	 * @template T
	 */
	
	/**
	 * @abstract
	 * @template T
	 */
	var SummaryResolver = /** @class */ (function () {
	    function SummaryResolver() {
	    }
	    return SummaryResolver;
	}());
	var JitSummaryResolver = /** @class */ (function () {
	    function JitSummaryResolver() {
	        this._summaries = new Map();
	    }
	    /**
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.isLibraryFile = /**
	     * @return {?}
	     */
	    function () { return false; };
	    /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.toSummaryFileName = /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    function (fileName) { return fileName; };
	    /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.fromSummaryFileName = /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    function (fileName) { return fileName; };
	    /**
	     * @param {?} reference
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.resolveSummary = /**
	     * @param {?} reference
	     * @return {?}
	     */
	    function (reference) {
	        return this._summaries.get(reference) || null;
	    };
	    /**
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.getSymbolsOf = /**
	     * @return {?}
	     */
	    function () { return []; };
	    /**
	     * @param {?} reference
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.getImportAs = /**
	     * @param {?} reference
	     * @return {?}
	     */
	    function (reference) { return reference; };
	    /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.getKnownModuleName = /**
	     * @param {?} fileName
	     * @return {?}
	     */
	    function (fileName) { return null; };
	    /**
	     * @param {?} summary
	     * @return {?}
	     */
	    JitSummaryResolver.prototype.addSummary = /**
	     * @param {?} summary
	     * @return {?}
	     */
	    function (summary) { this._summaries.set(summary.symbol, summary); };
	    return JitSummaryResolver;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} statements
	 * @param {?} reflector
	 * @return {?}
	 */
	function interpretStatements(statements, reflector) {
	    var /** @type {?} */ ctx = new _ExecutionContext(null, null, null, new Map());
	    var /** @type {?} */ visitor = new StatementInterpreter(reflector);
	    visitor.visitAllStatements(statements, ctx);
	    var /** @type {?} */ result = {};
	    ctx.exports.forEach(function (exportName) { result[exportName] = ctx.vars.get(exportName); });
	    return result;
	}
	/**
	 * @param {?} varNames
	 * @param {?} varValues
	 * @param {?} statements
	 * @param {?} ctx
	 * @param {?} visitor
	 * @return {?}
	 */
	function _executeFunctionStatements(varNames, varValues, statements, ctx, visitor) {
	    var /** @type {?} */ childCtx = ctx.createChildWihtLocalVars();
	    for (var /** @type {?} */ i = 0; i < varNames.length; i++) {
	        childCtx.vars.set(varNames[i], varValues[i]);
	    }
	    var /** @type {?} */ result = visitor.visitAllStatements(statements, childCtx);
	    return result ? result.value : null;
	}
	var _ExecutionContext = /** @class */ (function () {
	    function _ExecutionContext(parent, instance, className, vars) {
	        this.parent = parent;
	        this.instance = instance;
	        this.className = className;
	        this.vars = vars;
	        this.exports = [];
	    }
	    /**
	     * @return {?}
	     */
	    _ExecutionContext.prototype.createChildWihtLocalVars = /**
	     * @return {?}
	     */
	    function () {
	        return new _ExecutionContext(this, this.instance, this.className, new Map());
	    };
	    return _ExecutionContext;
	}());
	var ReturnValue = /** @class */ (function () {
	    function ReturnValue(value) {
	        this.value = value;
	    }
	    return ReturnValue;
	}());
	/**
	 * @param {?} _classStmt
	 * @param {?} _ctx
	 * @param {?} _visitor
	 * @return {?}
	 */
	function createDynamicClass(_classStmt, _ctx, _visitor) {
	    var /** @type {?} */ propertyDescriptors = {};
	    _classStmt.getters.forEach(function (getter) {
	        // Note: use `function` instead of arrow function to capture `this`
	        propertyDescriptors[getter.name] = {
	            configurable: false,
	            get: function () {
	                var /** @type {?} */ instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
	                return _executeFunctionStatements([], [], getter.body, instanceCtx, _visitor);
	            }
	        };
	    });
	    _classStmt.methods.forEach(function (method) {
	        var /** @type {?} */ paramNames = method.params.map(function (param) { return param.name; });
	        // Note: use `function` instead of arrow function to capture `this`
	        propertyDescriptors[/** @type {?} */ ((method.name))] = {
	            writable: false,
	            configurable: false,
	            value: function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var /** @type {?} */ instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
	                return _executeFunctionStatements(paramNames, args, method.body, instanceCtx, _visitor);
	            }
	        };
	    });
	    var /** @type {?} */ ctorParamNames = _classStmt.constructorMethod.params.map(function (param) { return param.name; });
	    // Note: use `function` instead of arrow function to capture `this`
	    var /** @type {?} */ ctor = function () {
	        var _this = this;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var /** @type {?} */ instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
	        _classStmt.fields.forEach(function (field) { _this[field.name] = undefined; });
	        _executeFunctionStatements(ctorParamNames, args, _classStmt.constructorMethod.body, instanceCtx, _visitor);
	    };
	    var /** @type {?} */ superClass = _classStmt.parent ? _classStmt.parent.visitExpression(_visitor, _ctx) : Object;
	    ctor.prototype = Object.create(superClass.prototype, propertyDescriptors);
	    return ctor;
	}
	var StatementInterpreter = /** @class */ (function () {
	    function StatementInterpreter(reflector) {
	        this.reflector = reflector;
	    }
	    /**
	     * @param {?} ast
	     * @return {?}
	     */
	    StatementInterpreter.prototype.debugAst = /**
	     * @param {?} ast
	     * @return {?}
	     */
	    function (ast) { return debugOutputAstAsTypeScript(ast); };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitDeclareVarStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.vars.set(stmt.name, stmt.value.visitExpression(this, ctx));
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            ctx.exports.push(stmt.name);
	        }
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitWriteVarExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ value = expr.value.visitExpression(this, ctx);
	        var /** @type {?} */ currCtx = ctx;
	        while (currCtx != null) {
	            if (currCtx.vars.has(expr.name)) {
	                currCtx.vars.set(expr.name, value);
	                return value;
	            }
	            currCtx = /** @type {?} */ ((currCtx.parent));
	        }
	        throw new Error("Not declared variable " + expr.name);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitReadVarExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ varName = /** @type {?} */ ((ast.name));
	        if (ast.builtin != null) {
	            switch (ast.builtin) {
	                case BuiltinVar.Super:
	                    return ctx.instance.__proto__;
	                case BuiltinVar.This:
	                    return ctx.instance;
	                case BuiltinVar.CatchError:
	                    varName = CATCH_ERROR_VAR$2;
	                    break;
	                case BuiltinVar.CatchStack:
	                    varName = CATCH_STACK_VAR$2;
	                    break;
	                default:
	                    throw new Error("Unknown builtin variable " + ast.builtin);
	            }
	        }
	        var /** @type {?} */ currCtx = ctx;
	        while (currCtx != null) {
	            if (currCtx.vars.has(varName)) {
	                return currCtx.vars.get(varName);
	            }
	            currCtx = /** @type {?} */ ((currCtx.parent));
	        }
	        throw new Error("Not declared variable " + varName);
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitWriteKeyExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ receiver = expr.receiver.visitExpression(this, ctx);
	        var /** @type {?} */ index = expr.index.visitExpression(this, ctx);
	        var /** @type {?} */ value = expr.value.visitExpression(this, ctx);
	        receiver[index] = value;
	        return value;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitWritePropExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ receiver = expr.receiver.visitExpression(this, ctx);
	        var /** @type {?} */ value = expr.value.visitExpression(this, ctx);
	        receiver[expr.name] = value;
	        return value;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitInvokeMethodExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ receiver = expr.receiver.visitExpression(this, ctx);
	        var /** @type {?} */ args = this.visitAllExpressions(expr.args, ctx);
	        var /** @type {?} */ result;
	        if (expr.builtin != null) {
	            switch (expr.builtin) {
	                case BuiltinMethod.ConcatArray:
	                    result = receiver.concat.apply(receiver, args);
	                    break;
	                case BuiltinMethod.SubscribeObservable:
	                    result = receiver.subscribe({ next: args[0] });
	                    break;
	                case BuiltinMethod.Bind:
	                    result = receiver.bind.apply(receiver, args);
	                    break;
	                default:
	                    throw new Error("Unknown builtin method " + expr.builtin);
	            }
	        }
	        else {
	            result = receiver[/** @type {?} */ ((expr.name))].apply(receiver, args);
	        }
	        return result;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitInvokeFunctionExpr = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var /** @type {?} */ args = this.visitAllExpressions(stmt.args, ctx);
	        var /** @type {?} */ fnExpr = stmt.fn;
	        if (fnExpr instanceof ReadVarExpr && fnExpr.builtin === BuiltinVar.Super) {
	            ctx.instance.constructor.prototype.constructor.apply(ctx.instance, args);
	            return null;
	        }
	        else {
	            var /** @type {?} */ fn$$1 = stmt.fn.visitExpression(this, ctx);
	            return fn$$1.apply(null, args);
	        }
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitReturnStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        return new ReturnValue(stmt.value.visitExpression(this, ctx));
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var /** @type {?} */ clazz = createDynamicClass(stmt, ctx, this);
	        ctx.vars.set(stmt.name, clazz);
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            ctx.exports.push(stmt.name);
	        }
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitExpressionStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        return stmt.expr.visitExpression(this, ctx);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitIfStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var /** @type {?} */ condition = stmt.condition.visitExpression(this, ctx);
	        if (condition) {
	            return this.visitAllStatements(stmt.trueCase, ctx);
	        }
	        else if (stmt.falseCase != null) {
	            return this.visitAllStatements(stmt.falseCase, ctx);
	        }
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitTryCatchStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        try {
	            return this.visitAllStatements(stmt.bodyStmts, ctx);
	        }
	        catch (/** @type {?} */ e) {
	            var /** @type {?} */ childCtx = ctx.createChildWihtLocalVars();
	            childCtx.vars.set(CATCH_ERROR_VAR$2, e);
	            childCtx.vars.set(CATCH_STACK_VAR$2, e.stack);
	            return this.visitAllStatements(stmt.catchStmts, childCtx);
	        }
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitThrowStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        throw stmt.error.visitExpression(this, ctx);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?=} context
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitCommentStmt = /**
	     * @param {?} stmt
	     * @param {?=} context
	     * @return {?}
	     */
	    function (stmt, context) { return null; };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitInstantiateExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ args = this.visitAllExpressions(ast.args, ctx);
	        var /** @type {?} */ clazz = ast.classExpr.visitExpression(this, ctx);
	        return new (clazz.bind.apply(clazz, [void 0].concat(args)))();
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitLiteralExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) { return ast.value; };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitExternalExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        return this.reflector.resolveExternalReference(ast.value);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitConditionalExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        if (ast.condition.visitExpression(this, ctx)) {
	            return ast.trueCase.visitExpression(this, ctx);
	        }
	        else if (ast.falseCase != null) {
	            return ast.falseCase.visitExpression(this, ctx);
	        }
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitNotExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        return !ast.condition.visitExpression(this, ctx);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitAssertNotNullExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        return ast.condition.visitExpression(this, ctx);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitCastExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        return ast.value.visitExpression(this, ctx);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ paramNames = ast.params.map(function (param) { return param.name; });
	        return _declareFn(paramNames, ast.statements, ctx, this);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var /** @type {?} */ paramNames = stmt.params.map(function (param) { return param.name; });
	        ctx.vars.set(stmt.name, _declareFn(paramNames, stmt.statements, ctx, this));
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            ctx.exports.push(stmt.name);
	        }
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitBinaryOperatorExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var _this = this;
	        var /** @type {?} */ lhs = function () { return ast.lhs.visitExpression(_this, ctx); };
	        var /** @type {?} */ rhs = function () { return ast.rhs.visitExpression(_this, ctx); };
	        switch (ast.operator) {
	            case BinaryOperator.Equals:
	                return lhs() == rhs();
	            case BinaryOperator.Identical:
	                return lhs() === rhs();
	            case BinaryOperator.NotEquals:
	                return lhs() != rhs();
	            case BinaryOperator.NotIdentical:
	                return lhs() !== rhs();
	            case BinaryOperator.And:
	                return lhs() && rhs();
	            case BinaryOperator.Or:
	                return lhs() || rhs();
	            case BinaryOperator.Plus:
	                return lhs() + rhs();
	            case BinaryOperator.Minus:
	                return lhs() - rhs();
	            case BinaryOperator.Divide:
	                return lhs() / rhs();
	            case BinaryOperator.Multiply:
	                return lhs() * rhs();
	            case BinaryOperator.Modulo:
	                return lhs() % rhs();
	            case BinaryOperator.Lower:
	                return lhs() < rhs();
	            case BinaryOperator.LowerEquals:
	                return lhs() <= rhs();
	            case BinaryOperator.Bigger:
	                return lhs() > rhs();
	            case BinaryOperator.BiggerEquals:
	                return lhs() >= rhs();
	            default:
	                throw new Error("Unknown operator " + ast.operator);
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitReadPropExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ result;
	        var /** @type {?} */ receiver = ast.receiver.visitExpression(this, ctx);
	        result = receiver[ast.name];
	        return result;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitReadKeyExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ receiver = ast.receiver.visitExpression(this, ctx);
	        var /** @type {?} */ prop = ast.index.visitExpression(this, ctx);
	        return receiver[prop];
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitLiteralArrayExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        return this.visitAllExpressions(ast.entries, ctx);
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitLiteralMapExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var _this = this;
	        var /** @type {?} */ result = {};
	        ast.entries.forEach(function (entry) { return result[entry.key] = entry.value.visitExpression(_this, ctx); });
	        return result;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitCommaExpr = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ values = this.visitAllExpressions(ast.parts, context);
	        return values[values.length - 1];
	    };
	    /**
	     * @param {?} expressions
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitAllExpressions = /**
	     * @param {?} expressions
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expressions, ctx) {
	        var _this = this;
	        return expressions.map(function (expr) { return expr.visitExpression(_this, ctx); });
	    };
	    /**
	     * @param {?} statements
	     * @param {?} ctx
	     * @return {?}
	     */
	    StatementInterpreter.prototype.visitAllStatements = /**
	     * @param {?} statements
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (statements, ctx) {
	        for (var /** @type {?} */ i = 0; i < statements.length; i++) {
	            var /** @type {?} */ stmt = statements[i];
	            var /** @type {?} */ val = stmt.visitStatement(this, ctx);
	            if (val instanceof ReturnValue) {
	                return val;
	            }
	        }
	        return null;
	    };
	    return StatementInterpreter;
	}());
	/**
	 * @param {?} varNames
	 * @param {?} statements
	 * @param {?} ctx
	 * @param {?} visitor
	 * @return {?}
	 */
	function _declareFn(varNames, statements, ctx, visitor) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return _executeFunctionStatements(varNames, args, statements, ctx, visitor);
	    };
	}
	var CATCH_ERROR_VAR$2 = 'error';
	var CATCH_STACK_VAR$2 = 'stack';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @abstract
	 */
	var AbstractJsEmitterVisitor = /** @class */ (function (_super) {
	    __extends(AbstractJsEmitterVisitor, _super);
	    function AbstractJsEmitterVisitor() {
	        return _super.call(this, false) || this;
	    }
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        var _this = this;
	        ctx.pushClass(stmt);
	        this._visitClassConstructor(stmt, ctx);
	        if (stmt.parent != null) {
	            ctx.print(stmt, stmt.name + ".prototype = Object.create(");
	            stmt.parent.visitExpression(this, ctx);
	            ctx.println(stmt, ".prototype);");
	        }
	        stmt.getters.forEach(function (getter) { return _this._visitClassGetter(stmt, getter, ctx); });
	        stmt.methods.forEach(function (method) { return _this._visitClassMethod(stmt, method, ctx); });
	        ctx.popClass();
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype._visitClassConstructor = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "function " + stmt.name + "(");
	        if (stmt.constructorMethod != null) {
	            this._visitParams(stmt.constructorMethod.params, ctx);
	        }
	        ctx.println(stmt, ") {");
	        ctx.incIndent();
	        if (stmt.constructorMethod != null) {
	            if (stmt.constructorMethod.body.length > 0) {
	                ctx.println(stmt, "var self = this;");
	                this.visitAllStatements(stmt.constructorMethod.body, ctx);
	            }
	        }
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} getter
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype._visitClassGetter = /**
	     * @param {?} stmt
	     * @param {?} getter
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, getter, ctx) {
	        ctx.println(stmt, "Object.defineProperty(" + stmt.name + ".prototype, '" + getter.name + "', { get: function() {");
	        ctx.incIndent();
	        if (getter.body.length > 0) {
	            ctx.println(stmt, "var self = this;");
	            this.visitAllStatements(getter.body, ctx);
	        }
	        ctx.decIndent();
	        ctx.println(stmt, "}});");
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} method
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype._visitClassMethod = /**
	     * @param {?} stmt
	     * @param {?} method
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, method, ctx) {
	        ctx.print(stmt, stmt.name + ".prototype." + method.name + " = function(");
	        this._visitParams(method.params, ctx);
	        ctx.println(stmt, ") {");
	        ctx.incIndent();
	        if (method.body.length > 0) {
	            ctx.println(stmt, "var self = this;");
	            this.visitAllStatements(method.body, ctx);
	        }
	        ctx.decIndent();
	        ctx.println(stmt, "};");
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitReadVarExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        if (ast.builtin === BuiltinVar.This) {
	            ctx.print(ast, 'self');
	        }
	        else if (ast.builtin === BuiltinVar.Super) {
	            throw new Error("'super' needs to be handled at a parent ast node, not at the variable level!");
	        }
	        else {
	            _super.prototype.visitReadVarExpr.call(this, ast, ctx);
	        }
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitDeclareVarStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "var " + stmt.name + " = ");
	        stmt.value.visitExpression(this, ctx);
	        ctx.println(stmt, ";");
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitCastExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ast.value.visitExpression(this, ctx);
	        return null;
	    };
	    /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitInvokeFunctionExpr = /**
	     * @param {?} expr
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (expr, ctx) {
	        var /** @type {?} */ fnExpr = expr.fn;
	        if (fnExpr instanceof ReadVarExpr && fnExpr.builtin === BuiltinVar.Super) {
	            /** @type {?} */ ((/** @type {?} */ ((ctx.currentClass)).parent)).visitExpression(this, ctx);
	            ctx.print(expr, ".call(this");
	            if (expr.args.length > 0) {
	                ctx.print(expr, ", ");
	                this.visitAllExpressions(expr.args, ctx, ',');
	            }
	            ctx.print(expr, ")");
	        }
	        else {
	            _super.prototype.visitInvokeFunctionExpr.call(this, expr, ctx);
	        }
	        return null;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitFunctionExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        ctx.print(ast, "function(");
	        this._visitParams(ast.params, ctx);
	        ctx.println(ast, ") {");
	        ctx.incIndent();
	        this.visitAllStatements(ast.statements, ctx);
	        ctx.decIndent();
	        ctx.print(ast, "}");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.print(stmt, "function " + stmt.name + "(");
	        this._visitParams(stmt.params, ctx);
	        ctx.println(stmt, ") {");
	        ctx.incIndent();
	        this.visitAllStatements(stmt.statements, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.visitTryCatchStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        ctx.println(stmt, "try {");
	        ctx.incIndent();
	        this.visitAllStatements(stmt.bodyStmts, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "} catch (" + CATCH_ERROR_VAR$1.name + ") {");
	        ctx.incIndent();
	        var /** @type {?} */ catchStmts = [/** @type {?} */ (CATCH_STACK_VAR$1.set(CATCH_ERROR_VAR$1.prop('stack')).toDeclStmt(null, [
	                StmtModifier.Final
	            ]))].concat(stmt.catchStmts);
	        this.visitAllStatements(catchStmts, ctx);
	        ctx.decIndent();
	        ctx.println(stmt, "}");
	        return null;
	    };
	    /**
	     * @param {?} params
	     * @param {?} ctx
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype._visitParams = /**
	     * @param {?} params
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (params, ctx) {
	        this.visitAllObjects(function (param) { return ctx.print(null, param.name); }, params, ctx, ',');
	    };
	    /**
	     * @param {?} method
	     * @return {?}
	     */
	    AbstractJsEmitterVisitor.prototype.getBuiltinMethodName = /**
	     * @param {?} method
	     * @return {?}
	     */
	    function (method) {
	        var /** @type {?} */ name;
	        switch (method) {
	            case BuiltinMethod.ConcatArray:
	                name = 'concat';
	                break;
	            case BuiltinMethod.SubscribeObservable:
	                name = 'subscribe';
	                break;
	            case BuiltinMethod.Bind:
	                name = 'bind';
	                break;
	            default:
	                throw new Error("Unknown builtin method: " + method);
	        }
	        return name;
	    };
	    return AbstractJsEmitterVisitor;
	}(AbstractEmitterVisitor));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} sourceUrl
	 * @param {?} ctx
	 * @param {?} vars
	 * @param {?} createSourceMap
	 * @return {?}
	 */
	function evalExpression(sourceUrl, ctx, vars, createSourceMap) {
	    var /** @type {?} */ fnBody = ctx.toSource() + "\n//# sourceURL=" + sourceUrl;
	    var /** @type {?} */ fnArgNames = [];
	    var /** @type {?} */ fnArgValues = [];
	    for (var /** @type {?} */ argName in vars) {
	        fnArgNames.push(argName);
	        fnArgValues.push(vars[argName]);
	    }
	    if (createSourceMap) {
	        // using `new Function(...)` generates a header, 1 line of no arguments, 2 lines otherwise
	        // E.g. ```
	        // function anonymous(a,b,c
	        // /**/) { ... }```
	        // We don't want to hard code this fact, so we auto detect it via an empty function first.
	        var /** @type {?} */ emptyFn = new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat('return null;'))))().toString();
	        var /** @type {?} */ headerLines = emptyFn.slice(0, emptyFn.indexOf('return null;')).split('\n').length - 1;
	        fnBody += "\n" + ctx.toSourceMapGenerator(sourceUrl, headerLines).toJsComment();
	    }
	    return new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat(fnBody))))().apply(void 0, fnArgValues);
	}
	/**
	 * @param {?} sourceUrl
	 * @param {?} statements
	 * @param {?} reflector
	 * @param {?} createSourceMaps
	 * @return {?}
	 */
	function jitStatements(sourceUrl, statements, reflector, createSourceMaps) {
	    var /** @type {?} */ converter = new JitEmitterVisitor(reflector);
	    var /** @type {?} */ ctx = EmitterVisitorContext.createRoot();
	    converter.visitAllStatements(statements, ctx);
	    converter.createReturnStmt(ctx);
	    return evalExpression(sourceUrl, ctx, converter.getArgs(), createSourceMaps);
	}
	var JitEmitterVisitor = /** @class */ (function (_super) {
	    __extends(JitEmitterVisitor, _super);
	    function JitEmitterVisitor(reflector) {
	        var _this = _super.call(this) || this;
	        _this.reflector = reflector;
	        _this._evalArgNames = [];
	        _this._evalArgValues = [];
	        _this._evalExportedVars = [];
	        return _this;
	    }
	    /**
	     * @param {?} ctx
	     * @return {?}
	     */
	    JitEmitterVisitor.prototype.createReturnStmt = /**
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ctx) {
	        var /** @type {?} */ stmt = new ReturnStatement(new LiteralMapExpr(this._evalExportedVars.map(function (resultVar) { return new LiteralMapEntry(resultVar, variable(resultVar), false); })));
	        stmt.visitStatement(this, ctx);
	    };
	    /**
	     * @return {?}
	     */
	    JitEmitterVisitor.prototype.getArgs = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ result = {};
	        for (var /** @type {?} */ i = 0; i < this._evalArgNames.length; i++) {
	            result[this._evalArgNames[i]] = this._evalArgValues[i];
	        }
	        return result;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    JitEmitterVisitor.prototype.visitExternalExpr = /**
	     * @param {?} ast
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ast, ctx) {
	        var /** @type {?} */ value = this.reflector.resolveExternalReference(ast.value);
	        var /** @type {?} */ id = this._evalArgValues.indexOf(value);
	        if (id === -1) {
	            id = this._evalArgValues.length;
	            this._evalArgValues.push(value);
	            var /** @type {?} */ name_1 = identifierName({ reference: value }) || 'val';
	            this._evalArgNames.push("jit_" + name_1 + "_" + id);
	        }
	        ctx.print(ast, this._evalArgNames[id]);
	        return null;
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    JitEmitterVisitor.prototype.visitDeclareVarStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            this._evalExportedVars.push(stmt.name);
	        }
	        return _super.prototype.visitDeclareVarStmt.call(this, stmt, ctx);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    JitEmitterVisitor.prototype.visitDeclareFunctionStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            this._evalExportedVars.push(stmt.name);
	        }
	        return _super.prototype.visitDeclareFunctionStmt.call(this, stmt, ctx);
	    };
	    /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    JitEmitterVisitor.prototype.visitDeclareClassStmt = /**
	     * @param {?} stmt
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (stmt, ctx) {
	        if (stmt.hasModifier(StmtModifier.Exported)) {
	            this._evalExportedVars.push(stmt.name);
	        }
	        return _super.prototype.visitDeclareClassStmt.call(this, stmt, ctx);
	    };
	    return JitEmitterVisitor;
	}(AbstractJsEmitterVisitor));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	
	/**
	 * An internal module of the Angular compiler that begins with component types,
	 * extracts templates, and eventually produces a compiled version of the component
	 * ready for linking into an application.
	 *
	 * \@security When compiling templates at runtime, you must ensure that the entire template comes
	 * from a trusted source. Attacker-controlled data introduced by a template could expose your
	 * application to XSS risks.  For more detail, see the [Security Guide](http://g.co/ng/security).
	 */
	var JitCompiler = /** @class */ (function () {
	    function JitCompiler(_metadataResolver, _templateParser, _styleCompiler, _viewCompiler, _ngModuleCompiler, _summaryResolver, _reflector, _compilerConfig, _console, getExtraNgModuleProviders) {
	        this._metadataResolver = _metadataResolver;
	        this._templateParser = _templateParser;
	        this._styleCompiler = _styleCompiler;
	        this._viewCompiler = _viewCompiler;
	        this._ngModuleCompiler = _ngModuleCompiler;
	        this._summaryResolver = _summaryResolver;
	        this._reflector = _reflector;
	        this._compilerConfig = _compilerConfig;
	        this._console = _console;
	        this.getExtraNgModuleProviders = getExtraNgModuleProviders;
	        this._compiledTemplateCache = new Map();
	        this._compiledHostTemplateCache = new Map();
	        this._compiledDirectiveWrapperCache = new Map();
	        this._compiledNgModuleCache = new Map();
	        this._sharedStylesheetCount = 0;
	        this._addedAotSummaries = new Set();
	    }
	    /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    JitCompiler.prototype.compileModuleSync = /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return SyncAsync.assertSync(this._compileModuleAndComponents(moduleType, true));
	    };
	    /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    JitCompiler.prototype.compileModuleAsync = /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return Promise.resolve(this._compileModuleAndComponents(moduleType, false));
	    };
	    /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    JitCompiler.prototype.compileModuleAndAllComponentsSync = /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return SyncAsync.assertSync(this._compileModuleAndAllComponents(moduleType, true));
	    };
	    /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    JitCompiler.prototype.compileModuleAndAllComponentsAsync = /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        return Promise.resolve(this._compileModuleAndAllComponents(moduleType, false));
	    };
	    /**
	     * @param {?} component
	     * @return {?}
	     */
	    JitCompiler.prototype.getComponentFactory = /**
	     * @param {?} component
	     * @return {?}
	     */
	    function (component) {
	        var /** @type {?} */ summary = this._metadataResolver.getDirectiveSummary(component);
	        return /** @type {?} */ (summary.componentFactory);
	    };
	    /**
	     * @param {?} summaries
	     * @return {?}
	     */
	    JitCompiler.prototype.loadAotSummaries = /**
	     * @param {?} summaries
	     * @return {?}
	     */
	    function (summaries) {
	        this.clearCache();
	        this._addAotSummaries(summaries);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    JitCompiler.prototype._addAotSummaries = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn$$1) {
	        if (this._addedAotSummaries.has(fn$$1)) {
	            return;
	        }
	        this._addedAotSummaries.add(fn$$1);
	        var /** @type {?} */ summaries = fn$$1();
	        for (var /** @type {?} */ i = 0; i < summaries.length; i++) {
	            var /** @type {?} */ entry = summaries[i];
	            if (typeof entry === 'function') {
	                this._addAotSummaries(entry);
	            }
	            else {
	                var /** @type {?} */ summary = /** @type {?} */ (entry);
	                this._summaryResolver.addSummary({ symbol: summary.type.reference, metadata: null, type: summary });
	            }
	        }
	    };
	    /**
	     * @param {?} ref
	     * @return {?}
	     */
	    JitCompiler.prototype.hasAotSummary = /**
	     * @param {?} ref
	     * @return {?}
	     */
	    function (ref) { return !!this._summaryResolver.resolveSummary(ref); };
	    /**
	     * @param {?} ids
	     * @return {?}
	     */
	    JitCompiler.prototype._filterJitIdentifiers = /**
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) {
	        var _this = this;
	        return ids.map(function (mod) { return mod.reference; }).filter(function (ref) { return !_this.hasAotSummary(ref); });
	    };
	    /**
	     * @param {?} moduleType
	     * @param {?} isSync
	     * @return {?}
	     */
	    JitCompiler.prototype._compileModuleAndComponents = /**
	     * @param {?} moduleType
	     * @param {?} isSync
	     * @return {?}
	     */
	    function (moduleType, isSync) {
	        var _this = this;
	        return SyncAsync.then(this._loadModules(moduleType, isSync), function () {
	            _this._compileComponents(moduleType, null);
	            return _this._compileModule(moduleType);
	        });
	    };
	    /**
	     * @param {?} moduleType
	     * @param {?} isSync
	     * @return {?}
	     */
	    JitCompiler.prototype._compileModuleAndAllComponents = /**
	     * @param {?} moduleType
	     * @param {?} isSync
	     * @return {?}
	     */
	    function (moduleType, isSync) {
	        var _this = this;
	        return SyncAsync.then(this._loadModules(moduleType, isSync), function () {
	            var /** @type {?} */ componentFactories = [];
	            _this._compileComponents(moduleType, componentFactories);
	            return {
	                ngModuleFactory: _this._compileModule(moduleType),
	                componentFactories: componentFactories
	            };
	        });
	    };
	    /**
	     * @param {?} mainModule
	     * @param {?} isSync
	     * @return {?}
	     */
	    JitCompiler.prototype._loadModules = /**
	     * @param {?} mainModule
	     * @param {?} isSync
	     * @return {?}
	     */
	    function (mainModule, isSync) {
	        var _this = this;
	        var /** @type {?} */ loading = [];
	        var /** @type {?} */ mainNgModule = /** @type {?} */ ((this._metadataResolver.getNgModuleMetadata(mainModule)));
	        // Note: for runtime compilation, we want to transitively compile all modules,
	        // so we also need to load the declared directives / pipes for all nested modules.
	        this._filterJitIdentifiers(mainNgModule.transitiveModule.modules).forEach(function (nestedNgModule) {
	            // getNgModuleMetadata only returns null if the value passed in is not an NgModule
	            var /** @type {?} */ moduleMeta = /** @type {?} */ ((_this._metadataResolver.getNgModuleMetadata(nestedNgModule)));
	            _this._filterJitIdentifiers(moduleMeta.declaredDirectives).forEach(function (ref) {
	                var /** @type {?} */ promise = _this._metadataResolver.loadDirectiveMetadata(moduleMeta.type.reference, ref, isSync);
	                if (promise) {
	                    loading.push(promise);
	                }
	            });
	            _this._filterJitIdentifiers(moduleMeta.declaredPipes)
	                .forEach(function (ref) { return _this._metadataResolver.getOrLoadPipeMetadata(ref); });
	        });
	        return SyncAsync.all(loading);
	    };
	    /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    JitCompiler.prototype._compileModule = /**
	     * @param {?} moduleType
	     * @return {?}
	     */
	    function (moduleType) {
	        var /** @type {?} */ ngModuleFactory = /** @type {?} */ ((this._compiledNgModuleCache.get(moduleType)));
	        if (!ngModuleFactory) {
	            var /** @type {?} */ moduleMeta = /** @type {?} */ ((this._metadataResolver.getNgModuleMetadata(moduleType)));
	            // Always provide a bound Compiler
	            var /** @type {?} */ extraProviders = this.getExtraNgModuleProviders(moduleMeta.type.reference);
	            var /** @type {?} */ outputCtx = createOutputContext();
	            var /** @type {?} */ compileResult = this._ngModuleCompiler.compile(outputCtx, moduleMeta, extraProviders);
	            ngModuleFactory = this._interpretOrJit(ngModuleJitUrl(moduleMeta), outputCtx.statements)[compileResult.ngModuleFactoryVar];
	            this._compiledNgModuleCache.set(moduleMeta.type.reference, ngModuleFactory);
	        }
	        return ngModuleFactory;
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} mainModule
	     * @param {?} allComponentFactories
	     * @return {?}
	     */
	    JitCompiler.prototype._compileComponents = /**
	     * \@internal
	     * @param {?} mainModule
	     * @param {?} allComponentFactories
	     * @return {?}
	     */
	    function (mainModule, allComponentFactories) {
	        var _this = this;
	        var /** @type {?} */ ngModule = /** @type {?} */ ((this._metadataResolver.getNgModuleMetadata(mainModule)));
	        var /** @type {?} */ moduleByJitDirective = new Map();
	        var /** @type {?} */ templates = new Set();
	        var /** @type {?} */ transJitModules = this._filterJitIdentifiers(ngModule.transitiveModule.modules);
	        transJitModules.forEach(function (localMod) {
	            var /** @type {?} */ localModuleMeta = /** @type {?} */ ((_this._metadataResolver.getNgModuleMetadata(localMod)));
	            _this._filterJitIdentifiers(localModuleMeta.declaredDirectives).forEach(function (dirRef) {
	                moduleByJitDirective.set(dirRef, localModuleMeta);
	                var /** @type {?} */ dirMeta = _this._metadataResolver.getDirectiveMetadata(dirRef);
	                if (dirMeta.isComponent) {
	                    templates.add(_this._createCompiledTemplate(dirMeta, localModuleMeta));
	                    if (allComponentFactories) {
	                        var /** @type {?} */ template = _this._createCompiledHostTemplate(dirMeta.type.reference, localModuleMeta);
	                        templates.add(template);
	                        allComponentFactories.push(/** @type {?} */ (dirMeta.componentFactory));
	                    }
	                }
	            });
	        });
	        transJitModules.forEach(function (localMod) {
	            var /** @type {?} */ localModuleMeta = /** @type {?} */ ((_this._metadataResolver.getNgModuleMetadata(localMod)));
	            _this._filterJitIdentifiers(localModuleMeta.declaredDirectives).forEach(function (dirRef) {
	                var /** @type {?} */ dirMeta = _this._metadataResolver.getDirectiveMetadata(dirRef);
	                if (dirMeta.isComponent) {
	                    dirMeta.entryComponents.forEach(function (entryComponentType) {
	                        var /** @type {?} */ moduleMeta = /** @type {?} */ ((moduleByJitDirective.get(entryComponentType.componentType)));
	                        templates.add(_this._createCompiledHostTemplate(entryComponentType.componentType, moduleMeta));
	                    });
	                }
	            });
	            localModuleMeta.entryComponents.forEach(function (entryComponentType) {
	                if (!_this.hasAotSummary(entryComponentType.componentType.reference)) {
	                    var /** @type {?} */ moduleMeta = /** @type {?} */ ((moduleByJitDirective.get(entryComponentType.componentType)));
	                    templates.add(_this._createCompiledHostTemplate(entryComponentType.componentType, moduleMeta));
	                }
	            });
	        });
	        templates.forEach(function (template) { return _this._compileTemplate(template); });
	    };
	    /**
	     * @param {?} type
	     * @return {?}
	     */
	    JitCompiler.prototype.clearCacheFor = /**
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        this._compiledNgModuleCache.delete(type);
	        this._metadataResolver.clearCacheFor(type);
	        this._compiledHostTemplateCache.delete(type);
	        var /** @type {?} */ compiledTemplate = this._compiledTemplateCache.get(type);
	        if (compiledTemplate) {
	            this._compiledTemplateCache.delete(type);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    JitCompiler.prototype.clearCache = /**
	     * @return {?}
	     */
	    function () {
	        // Note: don't clear the _addedAotSummaries, as they don't change!
	        this._metadataResolver.clearCache();
	        this._compiledTemplateCache.clear();
	        this._compiledHostTemplateCache.clear();
	        this._compiledNgModuleCache.clear();
	    };
	    /**
	     * @param {?} compType
	     * @param {?} ngModule
	     * @return {?}
	     */
	    JitCompiler.prototype._createCompiledHostTemplate = /**
	     * @param {?} compType
	     * @param {?} ngModule
	     * @return {?}
	     */
	    function (compType, ngModule) {
	        if (!ngModule) {
	            throw new Error("Component " + stringify(compType) + " is not part of any NgModule or the module has not been imported into your module.");
	        }
	        var /** @type {?} */ compiledTemplate = this._compiledHostTemplateCache.get(compType);
	        if (!compiledTemplate) {
	            var /** @type {?} */ compMeta = this._metadataResolver.getDirectiveMetadata(compType);
	            assertComponent(compMeta);
	            var /** @type {?} */ hostMeta = this._metadataResolver.getHostComponentMetadata(compMeta, (/** @type {?} */ (compMeta.componentFactory)).viewDefFactory);
	            compiledTemplate =
	                new CompiledTemplate(true, compMeta.type, hostMeta, ngModule, [compMeta.type]);
	            this._compiledHostTemplateCache.set(compType, compiledTemplate);
	        }
	        return compiledTemplate;
	    };
	    /**
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @return {?}
	     */
	    JitCompiler.prototype._createCompiledTemplate = /**
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @return {?}
	     */
	    function (compMeta, ngModule) {
	        var /** @type {?} */ compiledTemplate = this._compiledTemplateCache.get(compMeta.type.reference);
	        if (!compiledTemplate) {
	            assertComponent(compMeta);
	            compiledTemplate = new CompiledTemplate(false, compMeta.type, compMeta, ngModule, ngModule.transitiveModule.directives);
	            this._compiledTemplateCache.set(compMeta.type.reference, compiledTemplate);
	        }
	        return compiledTemplate;
	    };
	    /**
	     * @param {?} template
	     * @return {?}
	     */
	    JitCompiler.prototype._compileTemplate = /**
	     * @param {?} template
	     * @return {?}
	     */
	    function (template) {
	        var _this = this;
	        if (template.isCompiled) {
	            return;
	        }
	        var /** @type {?} */ compMeta = template.compMeta;
	        var /** @type {?} */ externalStylesheetsByModuleUrl = new Map();
	        var /** @type {?} */ outputContext = createOutputContext();
	        var /** @type {?} */ componentStylesheet = this._styleCompiler.compileComponent(outputContext, compMeta); /** @type {?} */
	        ((compMeta.template)).externalStylesheets.forEach(function (stylesheetMeta) {
	            var /** @type {?} */ compiledStylesheet = _this._styleCompiler.compileStyles(createOutputContext(), compMeta, stylesheetMeta);
	            externalStylesheetsByModuleUrl.set(/** @type {?} */ ((stylesheetMeta.moduleUrl)), compiledStylesheet);
	        });
	        this._resolveStylesCompileResult(componentStylesheet, externalStylesheetsByModuleUrl);
	        var /** @type {?} */ pipes = template.ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
	        var _a = this._parseTemplate(compMeta, template.ngModule, template.directives), parsedTemplate = _a.template, usedPipes = _a.pipes;
	        var /** @type {?} */ compileResult = this._viewCompiler.compileComponent(outputContext, compMeta, parsedTemplate, variable(componentStylesheet.stylesVar), usedPipes);
	        var /** @type {?} */ evalResult = this._interpretOrJit(templateJitUrl(template.ngModule.type, template.compMeta), outputContext.statements);
	        var /** @type {?} */ viewClass = evalResult[compileResult.viewClassVar];
	        var /** @type {?} */ rendererType = evalResult[compileResult.rendererTypeVar];
	        template.compiled(viewClass, rendererType);
	    };
	    /**
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} directiveIdentifiers
	     * @return {?}
	     */
	    JitCompiler.prototype._parseTemplate = /**
	     * @param {?} compMeta
	     * @param {?} ngModule
	     * @param {?} directiveIdentifiers
	     * @return {?}
	     */
	    function (compMeta, ngModule, directiveIdentifiers) {
	        var _this = this;
	        // Note: ! is ok here as components always have a template.
	        var /** @type {?} */ preserveWhitespaces = /** @type {?} */ ((compMeta.template)).preserveWhitespaces;
	        var /** @type {?} */ directives = directiveIdentifiers.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
	        var /** @type {?} */ pipes = ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
	        return this._templateParser.parse(compMeta, /** @type {?} */ ((/** @type {?} */ ((compMeta.template)).htmlAst)), directives, pipes, ngModule.schemas, templateSourceUrl(ngModule.type, compMeta, /** @type {?} */ ((compMeta.template))), preserveWhitespaces);
	    };
	    /**
	     * @param {?} result
	     * @param {?} externalStylesheetsByModuleUrl
	     * @return {?}
	     */
	    JitCompiler.prototype._resolveStylesCompileResult = /**
	     * @param {?} result
	     * @param {?} externalStylesheetsByModuleUrl
	     * @return {?}
	     */
	    function (result, externalStylesheetsByModuleUrl) {
	        var _this = this;
	        result.dependencies.forEach(function (dep, i) {
	            var /** @type {?} */ nestedCompileResult = /** @type {?} */ ((externalStylesheetsByModuleUrl.get(dep.moduleUrl)));
	            var /** @type {?} */ nestedStylesArr = _this._resolveAndEvalStylesCompileResult(nestedCompileResult, externalStylesheetsByModuleUrl);
	            dep.setValue(nestedStylesArr);
	        });
	    };
	    /**
	     * @param {?} result
	     * @param {?} externalStylesheetsByModuleUrl
	     * @return {?}
	     */
	    JitCompiler.prototype._resolveAndEvalStylesCompileResult = /**
	     * @param {?} result
	     * @param {?} externalStylesheetsByModuleUrl
	     * @return {?}
	     */
	    function (result, externalStylesheetsByModuleUrl) {
	        this._resolveStylesCompileResult(result, externalStylesheetsByModuleUrl);
	        return this._interpretOrJit(sharedStylesheetJitUrl(result.meta, this._sharedStylesheetCount++), result.outputCtx.statements)[result.stylesVar];
	    };
	    /**
	     * @param {?} sourceUrl
	     * @param {?} statements
	     * @return {?}
	     */
	    JitCompiler.prototype._interpretOrJit = /**
	     * @param {?} sourceUrl
	     * @param {?} statements
	     * @return {?}
	     */
	    function (sourceUrl, statements) {
	        if (!this._compilerConfig.useJit) {
	            return interpretStatements(statements, this._reflector);
	        }
	        else {
	            return jitStatements(sourceUrl, statements, this._reflector, this._compilerConfig.jitDevMode);
	        }
	    };
	    return JitCompiler;
	}());
	var CompiledTemplate = /** @class */ (function () {
	    function CompiledTemplate(isHost, compType, compMeta, ngModule, directives) {
	        this.isHost = isHost;
	        this.compType = compType;
	        this.compMeta = compMeta;
	        this.ngModule = ngModule;
	        this.directives = directives;
	        this._viewClass = /** @type {?} */ ((null));
	        this.isCompiled = false;
	    }
	    /**
	     * @param {?} viewClass
	     * @param {?} rendererType
	     * @return {?}
	     */
	    CompiledTemplate.prototype.compiled = /**
	     * @param {?} viewClass
	     * @param {?} rendererType
	     * @return {?}
	     */
	    function (viewClass, rendererType) {
	        this._viewClass = viewClass;
	        (/** @type {?} */ (this.compMeta.componentViewType)).setDelegate(viewClass);
	        for (var /** @type {?} */ prop in rendererType) {
	            (/** @type {?} */ (this.compMeta.rendererType))[prop] = rendererType[prop];
	        }
	        this.isCompiled = true;
	    };
	    return CompiledTemplate;
	}());
	/**
	 * @param {?} meta
	 * @return {?}
	 */
	function assertComponent(meta) {
	    if (!meta.isComponent) {
	        throw new Error("Could not compile '" + identifierName(meta.type) + "' because it is not a component.");
	    }
	}
	/**
	 * @return {?}
	 */
	function createOutputContext() {
	    var /** @type {?} */ importExpr$$1 = function (symbol) {
	        return importExpr({ name: identifierName(symbol), moduleName: null, runtime: symbol });
	    };
	    return { statements: [], genFilePath: '', importExpr: importExpr$$1 };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Provides access to reflection data about symbols that the compiler needs.
	 * @abstract
	 */
	var CompileReflector = /** @class */ (function () {
	    function CompileReflector() {
	    }
	    return CompileReflector;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Create a {\@link UrlResolver} with no package prefix.
	 * @return {?}
	 */
	function createUrlResolverWithoutPackagePrefix() {
	    return new UrlResolver();
	}
	/**
	 * @return {?}
	 */
	function createOfflineCompileUrlResolver() {
	    return new UrlResolver('.');
	}
	/**
	 * @record
	 */
	
	var UrlResolver = /** @class */ (function () {
	    function UrlResolverImpl(_packagePrefix) {
	        if (_packagePrefix === void 0) { _packagePrefix = null; }
	        this._packagePrefix = _packagePrefix;
	    }
	    /**
	     * Resolves the `url` given the `baseUrl`:
	     * - when the `url` is null, the `baseUrl` is returned,
	     * - if `url` is relative ('path/to/here', './path/to/here'), the resolved url is a combination of
	     * `baseUrl` and `url`,
	     * - if `url` is absolute (it has a scheme: 'http://', 'https://' or start with '/'), the `url` is
	     * returned as is (ignoring the `baseUrl`)
	     */
	    /**
	     * Resolves the `url` given the `baseUrl`:
	     * - when the `url` is null, the `baseUrl` is returned,
	     * - if `url` is relative ('path/to/here', './path/to/here'), the resolved url is a combination of
	     * `baseUrl` and `url`,
	     * - if `url` is absolute (it has a scheme: 'http://', 'https://' or start with '/'), the `url` is
	     * returned as is (ignoring the `baseUrl`)
	     * @param {?} baseUrl
	     * @param {?} url
	     * @return {?}
	     */
	    UrlResolverImpl.prototype.resolve = /**
	     * Resolves the `url` given the `baseUrl`:
	     * - when the `url` is null, the `baseUrl` is returned,
	     * - if `url` is relative ('path/to/here', './path/to/here'), the resolved url is a combination of
	     * `baseUrl` and `url`,
	     * - if `url` is absolute (it has a scheme: 'http://', 'https://' or start with '/'), the `url` is
	     * returned as is (ignoring the `baseUrl`)
	     * @param {?} baseUrl
	     * @param {?} url
	     * @return {?}
	     */
	    function (baseUrl, url) {
	        var /** @type {?} */ resolvedUrl = url;
	        if (baseUrl != null && baseUrl.length > 0) {
	            resolvedUrl = _resolveUrl(baseUrl, resolvedUrl);
	        }
	        var /** @type {?} */ resolvedParts = _split(resolvedUrl);
	        var /** @type {?} */ prefix = this._packagePrefix;
	        if (prefix != null && resolvedParts != null &&
	            resolvedParts[_ComponentIndex.Scheme] == 'package') {
	            var /** @type {?} */ path = resolvedParts[_ComponentIndex.Path];
	            prefix = prefix.replace(/\/+$/, '');
	            path = path.replace(/^\/+/, '');
	            return prefix + "/" + path;
	        }
	        return resolvedUrl;
	    };
	    return UrlResolverImpl;
	}());
	/**
	 * Extract the scheme of a URL.
	 * @param {?} url
	 * @return {?}
	 */
	function getUrlScheme(url) {
	    var /** @type {?} */ match = _split(url);
	    return (match && match[_ComponentIndex.Scheme]) || '';
	}
	/**
	 * Builds a URI string from already-encoded parts.
	 *
	 * No encoding is performed.  Any component may be omitted as either null or
	 * undefined.
	 *
	 * @param {?=} opt_scheme The scheme such as 'http'.
	 * @param {?=} opt_userInfo The user name before the '\@'.
	 * @param {?=} opt_domain The domain such as 'www.google.com', already
	 *     URI-encoded.
	 * @param {?=} opt_port The port number.
	 * @param {?=} opt_path The path, already URI-encoded.  If it is not
	 *     empty, it must begin with a slash.
	 * @param {?=} opt_queryData The URI-encoded query data.
	 * @param {?=} opt_fragment The URI-encoded fragment identifier.
	 * @return {?} The fully combined URI.
	 */
	function _buildFromEncodedParts(opt_scheme, opt_userInfo, opt_domain, opt_port, opt_path, opt_queryData, opt_fragment) {
	    var /** @type {?} */ out = [];
	    if (opt_scheme != null) {
	        out.push(opt_scheme + ':');
	    }
	    if (opt_domain != null) {
	        out.push('//');
	        if (opt_userInfo != null) {
	            out.push(opt_userInfo + '@');
	        }
	        out.push(opt_domain);
	        if (opt_port != null) {
	            out.push(':' + opt_port);
	        }
	    }
	    if (opt_path != null) {
	        out.push(opt_path);
	    }
	    if (opt_queryData != null) {
	        out.push('?' + opt_queryData);
	    }
	    if (opt_fragment != null) {
	        out.push('#' + opt_fragment);
	    }
	    return out.join('');
	}
	/**
	 * A regular expression for breaking a URI into its component parts.
	 *
	 * {\@link http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234} says
	 * As the "first-match-wins" algorithm is identical to the "greedy"
	 * disambiguation method used by POSIX regular expressions, it is natural and
	 * commonplace to use a regular expression for parsing the potential five
	 * components of a URI reference.
	 *
	 * The following line is the regular expression for breaking-down a
	 * well-formed URI reference into its components.
	 *
	 * <pre>
	 * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
	 *  12            3  4          5       6  7        8 9
	 * </pre>
	 *
	 * The numbers in the second line above are only to assist readability; they
	 * indicate the reference points for each subexpression (i.e., each paired
	 * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
	 * For example, matching the above expression to
	 * <pre>
	 *     http://www.ics.uci.edu/pub/ietf/uri/#Related
	 * </pre>
	 * results in the following subexpression matches:
	 * <pre>
	 *    $1 = http:
	 *    $2 = http
	 *    $3 = //www.ics.uci.edu
	 *    $4 = www.ics.uci.edu
	 *    $5 = /pub/ietf/uri/
	 *    $6 = <undefined>
	 *    $7 = <undefined>
	 *    $8 = #Related
	 *    $9 = Related
	 * </pre>
	 * where <undefined> indicates that the component is not present, as is the
	 * case for the query component in the above example. Therefore, we can
	 * determine the value of the five components as
	 * <pre>
	 *    scheme    = $2
	 *    authority = $4
	 *    path      = $5
	 *    query     = $7
	 *    fragment  = $9
	 * </pre>
	 *
	 * The regular expression has been modified slightly to expose the
	 * userInfo, domain, and port separately from the authority.
	 * The modified version yields
	 * <pre>
	 *    $1 = http              scheme
	 *    $2 = <undefined>       userInfo -\
	 *    $3 = www.ics.uci.edu   domain     | authority
	 *    $4 = <undefined>       port     -/
	 *    $5 = /pub/ietf/uri/    path
	 *    $6 = <undefined>       query without ?
	 *    $7 = Related           fragment without #
	 * </pre>
	 * \@internal
	 */
	var _splitRe = new RegExp('^' +
	    '(?:' +
	    '([^:/?#.]+)' + // scheme - ignore special characters
	    ':)?' +
	    '(?://' +
	    '(?:([^/?#]*)@)?' + // userInfo
	    '([\\w\\d\\-\\u0100-\\uffff.%]*)' + // domain - restrict to letters,
	    '(?::([0-9]+))?' + // port
	    ')?' +
	    '([^?#]+)?' + // path
	    '(?:\\?([^#]*))?' + // query
	    '(?:#(.*))?' + // fragment
	    '$');
	/** @enum {number} */
	var _ComponentIndex = {
	    Scheme: 1,
	    UserInfo: 2,
	    Domain: 3,
	    Port: 4,
	    Path: 5,
	    QueryData: 6,
	    Fragment: 7,
	};
	_ComponentIndex[_ComponentIndex.Scheme] = "Scheme";
	_ComponentIndex[_ComponentIndex.UserInfo] = "UserInfo";
	_ComponentIndex[_ComponentIndex.Domain] = "Domain";
	_ComponentIndex[_ComponentIndex.Port] = "Port";
	_ComponentIndex[_ComponentIndex.Path] = "Path";
	_ComponentIndex[_ComponentIndex.QueryData] = "QueryData";
	_ComponentIndex[_ComponentIndex.Fragment] = "Fragment";
	/**
	 * Splits a URI into its component parts.
	 *
	 * Each component can be accessed via the component indices; for example:
	 * <pre>
	 * goog.uri.utils.split(someStr)[goog.uri.utils.CompontentIndex.QUERY_DATA];
	 * </pre>
	 *
	 * @param {?} uri The URI string to examine.
	 * @return {?} Each component still URI-encoded.
	 *     Each component that is present will contain the encoded value, whereas
	 *     components that are not present will be undefined or empty, depending
	 *     on the browser's regular expression implementation.  Never null, since
	 *     arbitrary strings may still look like path names.
	 */
	function _split(uri) {
	    return /** @type {?} */ ((uri.match(_splitRe)));
	}
	/**
	 * Removes dot segments in given path component, as described in
	 * RFC 3986, section 5.2.4.
	 *
	 * @param {?} path A non-empty path component.
	 * @return {?} Path component with removed dot segments.
	 */
	function _removeDotSegments(path) {
	    if (path == '/')
	        return '/';
	    var /** @type {?} */ leadingSlash = path[0] == '/' ? '/' : '';
	    var /** @type {?} */ trailingSlash = path[path.length - 1] === '/' ? '/' : '';
	    var /** @type {?} */ segments = path.split('/');
	    var /** @type {?} */ out = [];
	    var /** @type {?} */ up = 0;
	    for (var /** @type {?} */ pos = 0; pos < segments.length; pos++) {
	        var /** @type {?} */ segment = segments[pos];
	        switch (segment) {
	            case '':
	            case '.':
	                break;
	            case '..':
	                if (out.length > 0) {
	                    out.pop();
	                }
	                else {
	                    up++;
	                }
	                break;
	            default:
	                out.push(segment);
	        }
	    }
	    if (leadingSlash == '') {
	        while (up-- > 0) {
	            out.unshift('..');
	        }
	        if (out.length === 0)
	            out.push('.');
	    }
	    return leadingSlash + out.join('/') + trailingSlash;
	}
	/**
	 * Takes an array of the parts from split and canonicalizes the path part
	 * and then joins all the parts.
	 * @param {?} parts
	 * @return {?}
	 */
	function _joinAndCanonicalizePath(parts) {
	    var /** @type {?} */ path = parts[_ComponentIndex.Path];
	    path = path == null ? '' : _removeDotSegments(path);
	    parts[_ComponentIndex.Path] = path;
	    return _buildFromEncodedParts(parts[_ComponentIndex.Scheme], parts[_ComponentIndex.UserInfo], parts[_ComponentIndex.Domain], parts[_ComponentIndex.Port], path, parts[_ComponentIndex.QueryData], parts[_ComponentIndex.Fragment]);
	}
	/**
	 * Resolves a URL.
	 * @param {?} base The URL acting as the base URL.
	 * @param {?} url
	 * @return {?}
	 */
	function _resolveUrl(base, url) {
	    var /** @type {?} */ parts = _split(encodeURI(url));
	    var /** @type {?} */ baseParts = _split(base);
	    if (parts[_ComponentIndex.Scheme] != null) {
	        return _joinAndCanonicalizePath(parts);
	    }
	    else {
	        parts[_ComponentIndex.Scheme] = baseParts[_ComponentIndex.Scheme];
	    }
	    for (var /** @type {?} */ i = _ComponentIndex.Scheme; i <= _ComponentIndex.Port; i++) {
	        if (parts[i] == null) {
	            parts[i] = baseParts[i];
	        }
	    }
	    if (parts[_ComponentIndex.Path][0] == '/') {
	        return _joinAndCanonicalizePath(parts);
	    }
	    var /** @type {?} */ path = baseParts[_ComponentIndex.Path];
	    if (path == null)
	        path = '/';
	    var /** @type {?} */ index = path.lastIndexOf('/');
	    path = path.substring(0, index + 1) + parts[_ComponentIndex.Path];
	    parts[_ComponentIndex.Path] = path;
	    return _joinAndCanonicalizePath(parts);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An interface for retrieving documents by URL that the compiler uses
	 * to load templates.
	 */
	var ResourceLoader = /** @class */ (function () {
	    function ResourceLoader() {
	    }
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    ResourceLoader.prototype.get = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) { return ''; };
	    return ResourceLoader;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * The host of the Extractor disconnects the implementation from TypeScript / other language
	 * services and from underlying file systems.
	 * @record
	 */
	
	var Extractor = /** @class */ (function () {
	    function Extractor(host, staticSymbolResolver, messageBundle, metadataResolver) {
	        this.host = host;
	        this.staticSymbolResolver = staticSymbolResolver;
	        this.messageBundle = messageBundle;
	        this.metadataResolver = metadataResolver;
	    }
	    /**
	     * @param {?} rootFiles
	     * @return {?}
	     */
	    Extractor.prototype.extract = /**
	     * @param {?} rootFiles
	     * @return {?}
	     */
	    function (rootFiles) {
	        var _this = this;
	        var _a = analyzeAndValidateNgModules(rootFiles, this.host, this.staticSymbolResolver, this.metadataResolver), files = _a.files, ngModules = _a.ngModules;
	        return Promise
	            .all(ngModules.map(function (ngModule) {
	            return _this.metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false);
	        }))
	            .then(function () {
	            var /** @type {?} */ errors = [];
	            files.forEach(function (file) {
	                var /** @type {?} */ compMetas = [];
	                file.directives.forEach(function (directiveType) {
	                    var /** @type {?} */ dirMeta = _this.metadataResolver.getDirectiveMetadata(directiveType);
	                    if (dirMeta && dirMeta.isComponent) {
	                        compMetas.push(dirMeta);
	                    }
	                });
	                compMetas.forEach(function (compMeta) {
	                    var /** @type {?} */ html = /** @type {?} */ ((/** @type {?} */ ((compMeta.template)).template));
	                    var /** @type {?} */ interpolationConfig = InterpolationConfig.fromArray(/** @type {?} */ ((compMeta.template)).interpolation);
	                    errors.push.apply(errors, /** @type {?} */ ((_this.messageBundle.updateFromTemplate(html, file.fileName, interpolationConfig))));
	                });
	            });
	            if (errors.length) {
	                throw new Error(errors.map(function (e) { return e.toString(); }).join('\n'));
	            }
	            return _this.messageBundle;
	        });
	    };
	    /**
	     * @param {?} host
	     * @param {?} locale
	     * @return {?}
	     */
	    Extractor.create = /**
	     * @param {?} host
	     * @param {?} locale
	     * @return {?}
	     */
	    function (host, locale) {
	        var /** @type {?} */ htmlParser = new HtmlParser();
	        var /** @type {?} */ urlResolver = createAotUrlResolver(host);
	        var /** @type {?} */ symbolCache = new StaticSymbolCache();
	        var /** @type {?} */ summaryResolver = new AotSummaryResolver(host, symbolCache);
	        var /** @type {?} */ staticSymbolResolver = new StaticSymbolResolver(host, symbolCache, summaryResolver);
	        var /** @type {?} */ staticReflector = new StaticReflector(summaryResolver, staticSymbolResolver);
	        var /** @type {?} */ config = new CompilerConfig({ defaultEncapsulation: ViewEncapsulation.Emulated, useJit: false });
	        var /** @type {?} */ normalizer = new DirectiveNormalizer({ get: function (url) { return host.loadResource(url); } }, urlResolver, htmlParser, config);
	        var /** @type {?} */ elementSchemaRegistry = new DomElementSchemaRegistry();
	        var /** @type {?} */ resolver = new CompileMetadataResolver(config, htmlParser, new NgModuleResolver(staticReflector), new DirectiveResolver(staticReflector), new PipeResolver(staticReflector), summaryResolver, elementSchemaRegistry, normalizer, console, symbolCache, staticReflector);
	        // TODO(vicb): implicit tags & attributes
	        var /** @type {?} */ messageBundle = new MessageBundle(htmlParser, [], {}, locale);
	        var /** @type {?} */ extractor = new Extractor(host, staticSymbolResolver, messageBundle, resolver);
	        return { extractor: extractor, staticReflector: staticReflector };
	    };
	    return Extractor;
	}());
	
	exports.core = core;
	exports.CompilerConfig = CompilerConfig;
	exports.preserveWhitespacesDefault = preserveWhitespacesDefault;
	exports.isLoweredSymbol = isLoweredSymbol;
	exports.createLoweredSymbol = createLoweredSymbol;
	exports.Identifiers = Identifiers;
	exports.JitCompiler = JitCompiler;
	exports.DirectiveResolver = DirectiveResolver;
	exports.PipeResolver = PipeResolver;
	exports.NgModuleResolver = NgModuleResolver;
	exports.DEFAULT_INTERPOLATION_CONFIG = DEFAULT_INTERPOLATION_CONFIG;
	exports.InterpolationConfig = InterpolationConfig;
	exports.NgModuleCompiler = NgModuleCompiler;
	exports.AssertNotNull = AssertNotNull;
	exports.BinaryOperator = BinaryOperator;
	exports.BinaryOperatorExpr = BinaryOperatorExpr;
	exports.BuiltinMethod = BuiltinMethod;
	exports.BuiltinVar = BuiltinVar;
	exports.CastExpr = CastExpr;
	exports.ClassStmt = ClassStmt;
	exports.CommaExpr = CommaExpr;
	exports.CommentStmt = CommentStmt;
	exports.ConditionalExpr = ConditionalExpr;
	exports.DeclareFunctionStmt = DeclareFunctionStmt;
	exports.DeclareVarStmt = DeclareVarStmt;
	exports.ExpressionStatement = ExpressionStatement;
	exports.ExternalExpr = ExternalExpr;
	exports.ExternalReference = ExternalReference;
	exports.FunctionExpr = FunctionExpr;
	exports.IfStmt = IfStmt;
	exports.InstantiateExpr = InstantiateExpr;
	exports.InvokeFunctionExpr = InvokeFunctionExpr;
	exports.InvokeMethodExpr = InvokeMethodExpr;
	exports.LiteralArrayExpr = LiteralArrayExpr;
	exports.LiteralExpr = LiteralExpr;
	exports.LiteralMapExpr = LiteralMapExpr;
	exports.NotExpr = NotExpr;
	exports.ReadKeyExpr = ReadKeyExpr;
	exports.ReadPropExpr = ReadPropExpr;
	exports.ReadVarExpr = ReadVarExpr;
	exports.ReturnStatement = ReturnStatement;
	exports.ThrowStmt = ThrowStmt;
	exports.TryCatchStmt = TryCatchStmt;
	exports.WriteKeyExpr = WriteKeyExpr;
	exports.WritePropExpr = WritePropExpr;
	exports.WriteVarExpr = WriteVarExpr;
	exports.StmtModifier = StmtModifier;
	exports.Statement = Statement;
	exports.collectExternalReferences = collectExternalReferences;
	exports.EmitterVisitorContext = EmitterVisitorContext;
	exports.ViewCompiler = ViewCompiler;
	exports.getParseErrors = getParseErrors;
	exports.isSyntaxError = isSyntaxError;
	exports.syntaxError = syntaxError;
	exports.Version = Version;
	exports.VERSION = VERSION;
	exports.TextAst = TextAst;
	exports.BoundTextAst = BoundTextAst;
	exports.AttrAst = AttrAst;
	exports.BoundElementPropertyAst = BoundElementPropertyAst;
	exports.BoundEventAst = BoundEventAst;
	exports.ReferenceAst = ReferenceAst;
	exports.VariableAst = VariableAst;
	exports.ElementAst = ElementAst;
	exports.EmbeddedTemplateAst = EmbeddedTemplateAst;
	exports.BoundDirectivePropertyAst = BoundDirectivePropertyAst;
	exports.DirectiveAst = DirectiveAst;
	exports.ProviderAst = ProviderAst;
	exports.ProviderAstType = ProviderAstType;
	exports.NgContentAst = NgContentAst;
	exports.PropertyBindingType = PropertyBindingType;
	exports.NullTemplateVisitor = NullTemplateVisitor;
	exports.RecursiveTemplateAstVisitor = RecursiveTemplateAstVisitor;
	exports.templateVisitAll = templateVisitAll;
	exports.identifierName = identifierName;
	exports.identifierModuleUrl = identifierModuleUrl;
	exports.viewClassName = viewClassName;
	exports.rendererTypeName = rendererTypeName;
	exports.hostViewClassName = hostViewClassName;
	exports.componentFactoryName = componentFactoryName;
	exports.CompileSummaryKind = CompileSummaryKind;
	exports.tokenName = tokenName;
	exports.tokenReference = tokenReference;
	exports.CompileStylesheetMetadata = CompileStylesheetMetadata;
	exports.CompileTemplateMetadata = CompileTemplateMetadata;
	exports.CompileDirectiveMetadata = CompileDirectiveMetadata;
	exports.CompilePipeMetadata = CompilePipeMetadata;
	exports.CompileNgModuleMetadata = CompileNgModuleMetadata;
	exports.TransitiveCompileNgModuleMetadata = TransitiveCompileNgModuleMetadata;
	exports.ProviderMeta = ProviderMeta;
	exports.flatten = flatten;
	exports.templateSourceUrl = templateSourceUrl;
	exports.sharedStylesheetJitUrl = sharedStylesheetJitUrl;
	exports.ngModuleJitUrl = ngModuleJitUrl;
	exports.templateJitUrl = templateJitUrl;
	exports.createAotUrlResolver = createAotUrlResolver;
	exports.createAotCompiler = createAotCompiler;
	exports.AotCompiler = AotCompiler;
	exports.analyzeNgModules = analyzeNgModules;
	exports.analyzeAndValidateNgModules = analyzeAndValidateNgModules;
	exports.analyzeFile = analyzeFile;
	exports.mergeAnalyzedFiles = mergeAnalyzedFiles;
	exports.GeneratedFile = GeneratedFile;
	exports.toTypeScript = toTypeScript;
	exports.formattedError = formattedError;
	exports.isFormattedError = isFormattedError;
	exports.StaticReflector = StaticReflector;
	exports.StaticSymbol = StaticSymbol;
	exports.StaticSymbolCache = StaticSymbolCache;
	exports.ResolvedStaticSymbol = ResolvedStaticSymbol;
	exports.StaticSymbolResolver = StaticSymbolResolver;
	exports.unescapeIdentifier = unescapeIdentifier;
	exports.unwrapResolvedMetadata = unwrapResolvedMetadata;
	exports.AotSummaryResolver = AotSummaryResolver;
	exports.AstPath = AstPath;
	exports.SummaryResolver = SummaryResolver;
	exports.JitSummaryResolver = JitSummaryResolver;
	exports.CompileReflector = CompileReflector;
	exports.createUrlResolverWithoutPackagePrefix = createUrlResolverWithoutPackagePrefix;
	exports.createOfflineCompileUrlResolver = createOfflineCompileUrlResolver;
	exports.UrlResolver = UrlResolver;
	exports.getUrlScheme = getUrlScheme;
	exports.ResourceLoader = ResourceLoader;
	exports.ElementSchemaRegistry = ElementSchemaRegistry;
	exports.Extractor = Extractor;
	exports.I18NHtmlParser = I18NHtmlParser;
	exports.MessageBundle = MessageBundle;
	exports.Serializer = Serializer;
	exports.Xliff = Xliff;
	exports.Xliff2 = Xliff2;
	exports.Xmb = Xmb;
	exports.Xtb = Xtb;
	exports.DirectiveNormalizer = DirectiveNormalizer;
	exports.ParserError = ParserError;
	exports.ParseSpan = ParseSpan;
	exports.AST = AST;
	exports.Quote = Quote;
	exports.EmptyExpr = EmptyExpr;
	exports.ImplicitReceiver = ImplicitReceiver;
	exports.Chain = Chain;
	exports.Conditional = Conditional;
	exports.PropertyRead = PropertyRead;
	exports.PropertyWrite = PropertyWrite;
	exports.SafePropertyRead = SafePropertyRead;
	exports.KeyedRead = KeyedRead;
	exports.KeyedWrite = KeyedWrite;
	exports.BindingPipe = BindingPipe;
	exports.LiteralPrimitive = LiteralPrimitive;
	exports.LiteralArray = LiteralArray;
	exports.LiteralMap = LiteralMap;
	exports.Interpolation = Interpolation;
	exports.Binary = Binary;
	exports.PrefixNot = PrefixNot;
	exports.NonNullAssert = NonNullAssert;
	exports.MethodCall = MethodCall;
	exports.SafeMethodCall = SafeMethodCall;
	exports.FunctionCall = FunctionCall;
	exports.ASTWithSource = ASTWithSource;
	exports.TemplateBinding = TemplateBinding;
	exports.NullAstVisitor = NullAstVisitor;
	exports.RecursiveAstVisitor = RecursiveAstVisitor;
	exports.AstTransformer = AstTransformer;
	exports.visitAstChildren = visitAstChildren;
	exports.TokenType = TokenType;
	exports.Lexer = Lexer;
	exports.Token = Token;
	exports.EOF = EOF;
	exports.isIdentifier = isIdentifier;
	exports.isQuote = isQuote;
	exports.SplitInterpolation = SplitInterpolation;
	exports.TemplateBindingParseResult = TemplateBindingParseResult;
	exports.Parser = Parser;
	exports._ParseAST = _ParseAST;
	exports.ERROR_COMPONENT_TYPE = ERROR_COMPONENT_TYPE;
	exports.CompileMetadataResolver = CompileMetadataResolver;
	exports.Text = Text;
	exports.Expansion = Expansion;
	exports.ExpansionCase = ExpansionCase;
	exports.Attribute = Attribute$1;
	exports.Element = Element;
	exports.Comment = Comment;
	exports.visitAll = visitAll;
	exports.RecursiveVisitor = RecursiveVisitor;
	exports.findNode = findNode;
	exports.ParseTreeResult = ParseTreeResult;
	exports.TreeError = TreeError;
	exports.HtmlParser = HtmlParser;
	exports.HtmlTagDefinition = HtmlTagDefinition;
	exports.getHtmlTagDefinition = getHtmlTagDefinition;
	exports.TagContentType = TagContentType;
	exports.splitNsName = splitNsName;
	exports.isNgContainer = isNgContainer;
	exports.isNgContent = isNgContent;
	exports.isNgTemplate = isNgTemplate;
	exports.getNsPrefix = getNsPrefix;
	exports.mergeNsAndName = mergeNsAndName;
	exports.NAMED_ENTITIES = NAMED_ENTITIES;
	exports.NGSP_UNICODE = NGSP_UNICODE;
	exports.debugOutputAstAsTypeScript = debugOutputAstAsTypeScript;
	exports.TypeScriptEmitter = TypeScriptEmitter;
	exports.ParseLocation = ParseLocation;
	exports.ParseSourceFile = ParseSourceFile;
	exports.ParseSourceSpan = ParseSourceSpan;
	exports.ParseErrorLevel = ParseErrorLevel;
	exports.ParseError = ParseError;
	exports.typeSourceSpan = typeSourceSpan;
	exports.DomElementSchemaRegistry = DomElementSchemaRegistry;
	exports.CssSelector = CssSelector;
	exports.SelectorMatcher = SelectorMatcher;
	exports.SelectorListContext = SelectorListContext;
	exports.SelectorContext = SelectorContext;
	exports.StylesCompileDependency = StylesCompileDependency;
	exports.CompiledStylesheet = CompiledStylesheet;
	exports.StyleCompiler = StyleCompiler;
	exports.TemplateParseError = TemplateParseError;
	exports.TemplateParseResult = TemplateParseResult;
	exports.TemplateParser = TemplateParser;
	exports.splitClasses = splitClasses;
	exports.createElementCssSelector = createElementCssSelector;
	exports.removeSummaryDuplicates = removeSummaryDuplicates;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=compiler.umd.js.map


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205)) :
		typeof define === 'function' && define.amd ? define('@angular/common', ['exports', '@angular/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.common = {}),global.ng.core));
	}(this, (function (exports,_angular_core) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * This class should not be used directly by an application developer. Instead, use
	 * {\@link Location}.
	 *
	 * `PlatformLocation` encapsulates all calls to DOM apis, which allows the Router to be platform
	 * agnostic.
	 * This means that we can have different implementation of `PlatformLocation` for the different
	 * platforms that angular supports. For example, `\@angular/platform-browser` provides an
	 * implementation specific to the browser environment, while `\@angular/platform-webworker` provides
	 * one suitable for use with web workers.
	 *
	 * The `PlatformLocation` class is used directly by all implementations of {\@link LocationStrategy}
	 * when they need to interact with the DOM apis like pushState, popState, etc...
	 *
	 * {\@link LocationStrategy} in turn is used by the {\@link Location} service which is used directly
	 * by the {\@link Router} in order to navigate between routes. Since all interactions between {\@link
	 * Router} /
	 * {\@link Location} / {\@link LocationStrategy} and DOM apis flow through the `PlatformLocation`
	 * class they are all platform independent.
	 *
	 * \@stable
	 * @abstract
	 */
	var PlatformLocation = /** @class */ (function () {
	    function PlatformLocation() {
	    }
	    return PlatformLocation;
	}());
	/**
	 * \@whatItDoes indicates when a location is initialized
	 * \@experimental
	 */
	var LOCATION_INITIALIZED = new _angular_core.InjectionToken('Location Initialized');
	/**
	 * A serializable version of the event from onPopState or onHashChange
	 *
	 * \@experimental
	 * @record
	 */
	
	/**
	 * \@experimental
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * `LocationStrategy` is responsible for representing and reading route state
	 * from the browser's URL. Angular provides two strategies:
	 * {\@link HashLocationStrategy} and {\@link PathLocationStrategy}.
	 *
	 * This is used under the hood of the {\@link Location} service.
	 *
	 * Applications should use the {\@link Router} or {\@link Location} services to
	 * interact with application route state.
	 *
	 * For instance, {\@link HashLocationStrategy} produces URLs like
	 * `http://example.com#/foo`, and {\@link PathLocationStrategy} produces
	 * `http://example.com/foo` as an equivalent URL.
	 *
	 * See these two classes for more.
	 *
	 * \@stable
	 * @abstract
	 */
	var LocationStrategy = /** @class */ (function () {
	    function LocationStrategy() {
	    }
	    return LocationStrategy;
	}());
	/**
	 * The `APP_BASE_HREF` token represents the base href to be used with the
	 * {\@link PathLocationStrategy}.
	 *
	 * If you're using {\@link PathLocationStrategy}, you must provide a provider to a string
	 * representing the URL prefix that should be preserved when generating and recognizing
	 * URLs.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * import {Component, NgModule} from '\@angular/core';
	 * import {APP_BASE_HREF} from '\@angular/common';
	 *
	 * \@NgModule({
	 *   providers: [{provide: APP_BASE_HREF, useValue: '/my/app'}]
	 * })
	 * class AppModule {}
	 * ```
	 *
	 * \@stable
	 */
	var APP_BASE_HREF = new _angular_core.InjectionToken('appBaseHref');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@experimental
	 * @record
	 */
	
	/**
	 * \@whatItDoes `Location` is a service that applications can use to interact with a browser's URL.
	 * \@description
	 * Depending on which {\@link LocationStrategy} is used, `Location` will either persist
	 * to the URL's path or the URL's hash segment.
	 *
	 * Note: it's better to use {\@link Router#navigate} service to trigger route changes. Use
	 * `Location` only if you need to interact with or create normalized URLs outside of
	 * routing.
	 *
	 * `Location` is responsible for normalizing the URL against the application's base href.
	 * A normalized URL is absolute from the URL host, includes the application's base href, and has no
	 * trailing slash:
	 * - `/my/app/user/123` is normalized
	 * - `my/app/user/123` **is not** normalized
	 * - `/my/app/user/123/` **is not** normalized
	 *
	 * ### Example
	 * {\@example common/location/ts/path_location_component.ts region='LocationComponent'}
	 * \@stable
	 */
	var Location = /** @class */ (function () {
	    function Location(platformStrategy) {
	        var _this = this;
	        /**
	         * \@internal
	         */
	        this._subject = new _angular_core.EventEmitter();
	        this._platformStrategy = platformStrategy;
	        var /** @type {?} */ browserBaseHref = this._platformStrategy.getBaseHref();
	        this._baseHref = Location.stripTrailingSlash(_stripIndexHtml(browserBaseHref));
	        this._platformStrategy.onPopState(function (ev) {
	            _this._subject.emit({
	                'url': _this.path(true),
	                'pop': true,
	                'type': ev.type,
	            });
	        });
	    }
	    /**
	     * Returns the normalized URL path.
	     */
	    // TODO: vsavkin. Remove the boolean flag and always include hash once the deprecated router is
	    // removed.
	    /**
	     * Returns the normalized URL path.
	     * @param {?=} includeHash
	     * @return {?}
	     */
	    Location.prototype.path = /**
	     * Returns the normalized URL path.
	     * @param {?=} includeHash
	     * @return {?}
	     */
	    function (includeHash) {
	        if (includeHash === void 0) { includeHash = false; }
	        return this.normalize(this._platformStrategy.path(includeHash));
	    };
	    /**
	     * Normalizes the given path and compares to the current normalized path.
	     */
	    /**
	     * Normalizes the given path and compares to the current normalized path.
	     * @param {?} path
	     * @param {?=} query
	     * @return {?}
	     */
	    Location.prototype.isCurrentPathEqualTo = /**
	     * Normalizes the given path and compares to the current normalized path.
	     * @param {?} path
	     * @param {?=} query
	     * @return {?}
	     */
	    function (path, query) {
	        if (query === void 0) { query = ''; }
	        return this.path() == this.normalize(path + Location.normalizeQueryParams(query));
	    };
	    /**
	     * Given a string representing a URL, returns the normalized URL path without leading or
	     * trailing slashes.
	     */
	    /**
	     * Given a string representing a URL, returns the normalized URL path without leading or
	     * trailing slashes.
	     * @param {?} url
	     * @return {?}
	     */
	    Location.prototype.normalize = /**
	     * Given a string representing a URL, returns the normalized URL path without leading or
	     * trailing slashes.
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        return Location.stripTrailingSlash(_stripBaseHref(this._baseHref, _stripIndexHtml(url)));
	    };
	    /**
	     * Given a string representing a URL, returns the platform-specific external URL path.
	     * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
	     * before normalizing. This method will also add a hash if `HashLocationStrategy` is
	     * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
	     */
	    /**
	     * Given a string representing a URL, returns the platform-specific external URL path.
	     * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
	     * before normalizing. This method will also add a hash if `HashLocationStrategy` is
	     * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
	     * @param {?} url
	     * @return {?}
	     */
	    Location.prototype.prepareExternalUrl = /**
	     * Given a string representing a URL, returns the platform-specific external URL path.
	     * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
	     * before normalizing. This method will also add a hash if `HashLocationStrategy` is
	     * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        if (url && url[0] !== '/') {
	            url = '/' + url;
	        }
	        return this._platformStrategy.prepareExternalUrl(url);
	    };
	    // TODO: rename this method to pushState
	    /**
	     * Changes the browsers URL to the normalized version of the given URL, and pushes a
	     * new item onto the platform's history.
	     */
	    /**
	     * Changes the browsers URL to the normalized version of the given URL, and pushes a
	     * new item onto the platform's history.
	     * @param {?} path
	     * @param {?=} query
	     * @return {?}
	     */
	    Location.prototype.go = /**
	     * Changes the browsers URL to the normalized version of the given URL, and pushes a
	     * new item onto the platform's history.
	     * @param {?} path
	     * @param {?=} query
	     * @return {?}
	     */
	    function (path, query) {
	        if (query === void 0) { query = ''; }
	        this._platformStrategy.pushState(null, '', path, query);
	    };
	    /**
	     * Changes the browsers URL to the normalized version of the given URL, and replaces
	     * the top item on the platform's history stack.
	     */
	    /**
	     * Changes the browsers URL to the normalized version of the given URL, and replaces
	     * the top item on the platform's history stack.
	     * @param {?} path
	     * @param {?=} query
	     * @return {?}
	     */
	    Location.prototype.replaceState = /**
	     * Changes the browsers URL to the normalized version of the given URL, and replaces
	     * the top item on the platform's history stack.
	     * @param {?} path
	     * @param {?=} query
	     * @return {?}
	     */
	    function (path, query) {
	        if (query === void 0) { query = ''; }
	        this._platformStrategy.replaceState(null, '', path, query);
	    };
	    /**
	     * Navigates forward in the platform's history.
	     */
	    /**
	     * Navigates forward in the platform's history.
	     * @return {?}
	     */
	    Location.prototype.forward = /**
	     * Navigates forward in the platform's history.
	     * @return {?}
	     */
	    function () { this._platformStrategy.forward(); };
	    /**
	     * Navigates back in the platform's history.
	     */
	    /**
	     * Navigates back in the platform's history.
	     * @return {?}
	     */
	    Location.prototype.back = /**
	     * Navigates back in the platform's history.
	     * @return {?}
	     */
	    function () { this._platformStrategy.back(); };
	    /**
	     * Subscribe to the platform's `popState` events.
	     */
	    /**
	     * Subscribe to the platform's `popState` events.
	     * @param {?} onNext
	     * @param {?=} onThrow
	     * @param {?=} onReturn
	     * @return {?}
	     */
	    Location.prototype.subscribe = /**
	     * Subscribe to the platform's `popState` events.
	     * @param {?} onNext
	     * @param {?=} onThrow
	     * @param {?=} onReturn
	     * @return {?}
	     */
	    function (onNext, onThrow, onReturn) {
	        return this._subject.subscribe({ next: onNext, error: onThrow, complete: onReturn });
	    };
	    /**
	     * Given a string of url parameters, prepend with '?' if needed, otherwise return parameters as
	     * is.
	     * @param {?} params
	     * @return {?}
	     */
	    Location.normalizeQueryParams = /**
	     * Given a string of url parameters, prepend with '?' if needed, otherwise return parameters as
	     * is.
	     * @param {?} params
	     * @return {?}
	     */
	    function (params) {
	        return params && params[0] !== '?' ? '?' + params : params;
	    };
	    /**
	     * Given 2 parts of a url, join them with a slash if needed.
	     * @param {?} start
	     * @param {?} end
	     * @return {?}
	     */
	    Location.joinWithSlash = /**
	     * Given 2 parts of a url, join them with a slash if needed.
	     * @param {?} start
	     * @param {?} end
	     * @return {?}
	     */
	    function (start, end) {
	        if (start.length == 0) {
	            return end;
	        }
	        if (end.length == 0) {
	            return start;
	        }
	        var /** @type {?} */ slashes = 0;
	        if (start.endsWith('/')) {
	            slashes++;
	        }
	        if (end.startsWith('/')) {
	            slashes++;
	        }
	        if (slashes == 2) {
	            return start + end.substring(1);
	        }
	        if (slashes == 1) {
	            return start + end;
	        }
	        return start + '/' + end;
	    };
	    /**
	     * If url has a trailing slash, remove it, otherwise return url as is. This
	     * method looks for the first occurence of either #, ?, or the end of the
	     * line as `/` characters after any of these should not be replaced.
	     * @param {?} url
	     * @return {?}
	     */
	    Location.stripTrailingSlash = /**
	     * If url has a trailing slash, remove it, otherwise return url as is. This
	     * method looks for the first occurence of either #, ?, or the end of the
	     * line as `/` characters after any of these should not be replaced.
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        var /** @type {?} */ match = url.match(/#|\?|$/);
	        var /** @type {?} */ pathEndIdx = match && match.index || url.length;
	        var /** @type {?} */ droppedSlashIdx = pathEndIdx - (url[pathEndIdx - 1] === '/' ? 1 : 0);
	        return url.slice(0, droppedSlashIdx) + url.slice(pathEndIdx);
	    };
	    Location.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Location.ctorParameters = function () { return [
	        { type: LocationStrategy, },
	    ]; };
	    return Location;
	}());
	/**
	 * @param {?} baseHref
	 * @param {?} url
	 * @return {?}
	 */
	function _stripBaseHref(baseHref, url) {
	    return baseHref && url.startsWith(baseHref) ? url.substring(baseHref.length) : url;
	}
	/**
	 * @param {?} url
	 * @return {?}
	 */
	function _stripIndexHtml(url) {
	    return url.replace(/\/index.html$/, '');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Use URL hash for storing application location data.
	 * \@description
	 * `HashLocationStrategy` is a {\@link LocationStrategy} used to configure the
	 * {\@link Location} service to represent its state in the
	 * [hash fragment](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax)
	 * of the browser's URL.
	 *
	 * For instance, if you call `location.go('/foo')`, the browser's URL will become
	 * `example.com#/foo`.
	 *
	 * ### Example
	 *
	 * {\@example common/location/ts/hash_location_component.ts region='LocationComponent'}
	 *
	 * \@stable
	 */
	var HashLocationStrategy = /** @class */ (function (_super) {
	    __extends(HashLocationStrategy, _super);
	    function HashLocationStrategy(_platformLocation, _baseHref) {
	        var _this = _super.call(this) || this;
	        _this._platformLocation = _platformLocation;
	        _this._baseHref = '';
	        if (_baseHref != null) {
	            _this._baseHref = _baseHref;
	        }
	        return _this;
	    }
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.onPopState = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._platformLocation.onPopState(fn);
	        this._platformLocation.onHashChange(fn);
	    };
	    /**
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.getBaseHref = /**
	     * @return {?}
	     */
	    function () { return this._baseHref; };
	    /**
	     * @param {?=} includeHash
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.path = /**
	     * @param {?=} includeHash
	     * @return {?}
	     */
	    function (includeHash) {
	        if (includeHash === void 0) { includeHash = false; }
	        // the hash value is always prefixed with a `#`
	        // and if it is empty then it will stay empty
	        var /** @type {?} */ path = this._platformLocation.hash;
	        if (path == null)
	            path = '#';
	        return path.length > 0 ? path.substring(1) : path;
	    };
	    /**
	     * @param {?} internal
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.prepareExternalUrl = /**
	     * @param {?} internal
	     * @return {?}
	     */
	    function (internal) {
	        var /** @type {?} */ url = Location.joinWithSlash(this._baseHref, internal);
	        return url.length > 0 ? ('#' + url) : url;
	    };
	    /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} path
	     * @param {?} queryParams
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.pushState = /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} path
	     * @param {?} queryParams
	     * @return {?}
	     */
	    function (state, title, path, queryParams) {
	        var /** @type {?} */ url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
	        if (url.length == 0) {
	            url = this._platformLocation.pathname;
	        }
	        this._platformLocation.pushState(state, title, url);
	    };
	    /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} path
	     * @param {?} queryParams
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.replaceState = /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} path
	     * @param {?} queryParams
	     * @return {?}
	     */
	    function (state, title, path, queryParams) {
	        var /** @type {?} */ url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
	        if (url.length == 0) {
	            url = this._platformLocation.pathname;
	        }
	        this._platformLocation.replaceState(state, title, url);
	    };
	    /**
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.forward = /**
	     * @return {?}
	     */
	    function () { this._platformLocation.forward(); };
	    /**
	     * @return {?}
	     */
	    HashLocationStrategy.prototype.back = /**
	     * @return {?}
	     */
	    function () { this._platformLocation.back(); };
	    HashLocationStrategy.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HashLocationStrategy.ctorParameters = function () { return [
	        { type: PlatformLocation, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [APP_BASE_HREF,] },] },
	    ]; };
	    return HashLocationStrategy;
	}(LocationStrategy));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Use URL for storing application location data.
	 * \@description
	 * `PathLocationStrategy` is a {\@link LocationStrategy} used to configure the
	 * {\@link Location} service to represent its state in the
	 * [path](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax) of the
	 * browser's URL.
	 *
	 * If you're using `PathLocationStrategy`, you must provide a {\@link APP_BASE_HREF}
	 * or add a base element to the document. This URL prefix that will be preserved
	 * when generating and recognizing URLs.
	 *
	 * For instance, if you provide an `APP_BASE_HREF` of `'/my/app'` and call
	 * `location.go('/foo')`, the browser's URL will become
	 * `example.com/my/app/foo`.
	 *
	 * Similarly, if you add `<base href='/my/app'/>` to the document and call
	 * `location.go('/foo')`, the browser's URL will become
	 * `example.com/my/app/foo`.
	 *
	 * ### Example
	 *
	 * {\@example common/location/ts/path_location_component.ts region='LocationComponent'}
	 *
	 * \@stable
	 */
	var PathLocationStrategy = /** @class */ (function (_super) {
	    __extends(PathLocationStrategy, _super);
	    function PathLocationStrategy(_platformLocation, href) {
	        var _this = _super.call(this) || this;
	        _this._platformLocation = _platformLocation;
	        if (href == null) {
	            href = _this._platformLocation.getBaseHrefFromDOM();
	        }
	        if (href == null) {
	            throw new Error("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
	        }
	        _this._baseHref = href;
	        return _this;
	    }
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.onPopState = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._platformLocation.onPopState(fn);
	        this._platformLocation.onHashChange(fn);
	    };
	    /**
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.getBaseHref = /**
	     * @return {?}
	     */
	    function () { return this._baseHref; };
	    /**
	     * @param {?} internal
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.prepareExternalUrl = /**
	     * @param {?} internal
	     * @return {?}
	     */
	    function (internal) {
	        return Location.joinWithSlash(this._baseHref, internal);
	    };
	    /**
	     * @param {?=} includeHash
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.path = /**
	     * @param {?=} includeHash
	     * @return {?}
	     */
	    function (includeHash) {
	        if (includeHash === void 0) { includeHash = false; }
	        var /** @type {?} */ pathname = this._platformLocation.pathname +
	            Location.normalizeQueryParams(this._platformLocation.search);
	        var /** @type {?} */ hash = this._platformLocation.hash;
	        return hash && includeHash ? "" + pathname + hash : pathname;
	    };
	    /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @param {?} queryParams
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.pushState = /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @param {?} queryParams
	     * @return {?}
	     */
	    function (state, title, url, queryParams) {
	        var /** @type {?} */ externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
	        this._platformLocation.pushState(state, title, externalUrl);
	    };
	    /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @param {?} queryParams
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.replaceState = /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @param {?} queryParams
	     * @return {?}
	     */
	    function (state, title, url, queryParams) {
	        var /** @type {?} */ externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
	        this._platformLocation.replaceState(state, title, externalUrl);
	    };
	    /**
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.forward = /**
	     * @return {?}
	     */
	    function () { this._platformLocation.forward(); };
	    /**
	     * @return {?}
	     */
	    PathLocationStrategy.prototype.back = /**
	     * @return {?}
	     */
	    function () { this._platformLocation.back(); };
	    PathLocationStrategy.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    PathLocationStrategy.ctorParameters = function () { return [
	        { type: PlatformLocation, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [APP_BASE_HREF,] },] },
	    ]; };
	    return PathLocationStrategy;
	}(LocationStrategy));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// THIS CODE IS GENERATED - DO NOT MODIFY
	// See angular/tools/gulp-tasks/cldr/extract.js
	/**
	 * \@internal
	 */
	var CURRENCIES = {
	    'AOA': [, 'Kz'],
	    'ARS': [, '$'],
	    'AUD': ['A$', '$'],
	    'BAM': [, 'KM'],
	    'BBD': [, '$'],
	    'BDT': [, '৳'],
	    'BMD': [, '$'],
	    'BND': [, '$'],
	    'BOB': [, 'Bs'],
	    'BRL': ['R$'],
	    'BSD': [, '$'],
	    'BWP': [, 'P'],
	    'BYN': [, 'р.'],
	    'BZD': [, '$'],
	    'CAD': ['CA$', '$'],
	    'CLP': [, '$'],
	    'CNY': ['CN¥', '¥'],
	    'COP': [, '$'],
	    'CRC': [, '₡'],
	    'CUC': [, '$'],
	    'CUP': [, '$'],
	    'CZK': [, 'Kč'],
	    'DKK': [, 'kr'],
	    'DOP': [, '$'],
	    'EGP': [, 'E£'],
	    'ESP': [, '₧'],
	    'EUR': ['€'],
	    'FJD': [, '$'],
	    'FKP': [, '£'],
	    'GBP': ['£'],
	    'GEL': [, '₾'],
	    'GIP': [, '£'],
	    'GNF': [, 'FG'],
	    'GTQ': [, 'Q'],
	    'GYD': [, '$'],
	    'HKD': ['HK$', '$'],
	    'HNL': [, 'L'],
	    'HRK': [, 'kn'],
	    'HUF': [, 'Ft'],
	    'IDR': [, 'Rp'],
	    'ILS': ['₪'],
	    'INR': ['₹'],
	    'ISK': [, 'kr'],
	    'JMD': [, '$'],
	    'JPY': ['¥'],
	    'KHR': [, '៛'],
	    'KMF': [, 'CF'],
	    'KPW': [, '₩'],
	    'KRW': ['₩'],
	    'KYD': [, '$'],
	    'KZT': [, '₸'],
	    'LAK': [, '₭'],
	    'LBP': [, 'L£'],
	    'LKR': [, 'Rs'],
	    'LRD': [, '$'],
	    'LTL': [, 'Lt'],
	    'LVL': [, 'Ls'],
	    'MGA': [, 'Ar'],
	    'MMK': [, 'K'],
	    'MNT': [, '₮'],
	    'MUR': [, 'Rs'],
	    'MXN': ['MX$', '$'],
	    'MYR': [, 'RM'],
	    'NAD': [, '$'],
	    'NGN': [, '₦'],
	    'NIO': [, 'C$'],
	    'NOK': [, 'kr'],
	    'NPR': [, 'Rs'],
	    'NZD': ['NZ$', '$'],
	    'PHP': [, '₱'],
	    'PKR': [, 'Rs'],
	    'PLN': [, 'zł'],
	    'PYG': [, '₲'],
	    'RON': [, 'lei'],
	    'RUB': [, '₽'],
	    'RUR': [, 'р.'],
	    'RWF': [, 'RF'],
	    'SBD': [, '$'],
	    'SEK': [, 'kr'],
	    'SGD': [, '$'],
	    'SHP': [, '£'],
	    'SRD': [, '$'],
	    'SSP': [, '£'],
	    'STD': [, 'Db'],
	    'SYP': [, '£'],
	    'THB': [, '฿'],
	    'TOP': [, 'T$'],
	    'TRY': [, '₺'],
	    'TTD': [, '$'],
	    'TWD': ['NT$', '$'],
	    'UAH': [, '₴'],
	    'USD': ['$'],
	    'UYU': [, '$'],
	    'VEF': [, 'Bs'],
	    'VND': ['₫'],
	    'XAF': ['FCFA'],
	    'XCD': ['EC$', '$'],
	    'XOF': ['CFA'],
	    'XPF': ['CFPF'],
	    'ZAR': [, 'R'],
	    'ZMW': [, 'ZK'],
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// THIS CODE IS GENERATED - DO NOT MODIFY
	// See angular/tools/gulp-tasks/cldr/extract.js
	/**
	 * @param {?} n
	 * @return {?}
	 */
	function plural(n) {
	    var /** @type {?} */ i = Math.floor(Math.abs(n)), /** @type {?} */ v = n.toString().replace(/^[^.]*\.?/, '').length;
	    if (i === 1 && v === 0)
	        return 1;
	    return 5;
	}
	var localeEn = [
	    'en',
	    [
	        ['a', 'p'],
	        ['AM', 'PM'],
	    ],
	    [
	        ['AM', 'PM'],
	        ,
	    ],
	    [
	        ['S', 'M', 'T', 'W', 'T', 'F', 'S'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	        ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	        ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
	    ],
	    ,
	    [
	        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	        ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	        [
	            'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
	            'October', 'November', 'December'
	        ]
	    ],
	    ,
	    [['B', 'A'], ['BC', 'AD'], ['Before Christ', 'Anno Domini']], 0, [6, 0],
	    ['M/d/yy', 'MMM d, y', 'MMMM d, y', 'EEEE, MMMM d, y'],
	    ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'],
	    [
	        '{1}, {0}',
	        ,
	        '{1} \'at\' {0}',
	    ],
	    ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
	    ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], '$', 'US Dollar', plural
	];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@experimental i18n support is experimental.
	 */
	var LOCALE_DATA = {};
	/**
	 * Register global data to be used internally by Angular. See the
	 * {\@linkDocs guide/i18n#i18n-pipes "I18n guide"} to know how to import additional locale data.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} data
	 * @param {?=} localeId
	 * @param {?=} extraData
	 * @return {?}
	 */
	function registerLocaleData(data, localeId, extraData) {
	    if (typeof localeId !== 'string') {
	        extraData = localeId;
	        localeId = data[0 /* LocaleId */];
	    }
	    localeId = localeId.toLowerCase().replace(/_/g, '-');
	    LOCALE_DATA[localeId] = data;
	    if (extraData) {
	        LOCALE_DATA[localeId][18 /* ExtraData */] = extraData;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var NumberFormatStyle = {
	    Decimal: 0,
	    Percent: 1,
	    Currency: 2,
	    Scientific: 3,
	};
	NumberFormatStyle[NumberFormatStyle.Decimal] = "Decimal";
	NumberFormatStyle[NumberFormatStyle.Percent] = "Percent";
	NumberFormatStyle[NumberFormatStyle.Currency] = "Currency";
	NumberFormatStyle[NumberFormatStyle.Scientific] = "Scientific";
	/** @enum {number} */
	var Plural = {
	    Zero: 0,
	    One: 1,
	    Two: 2,
	    Few: 3,
	    Many: 4,
	    Other: 5,
	};
	Plural[Plural.Zero] = "Zero";
	Plural[Plural.One] = "One";
	Plural[Plural.Two] = "Two";
	Plural[Plural.Few] = "Few";
	Plural[Plural.Many] = "Many";
	Plural[Plural.Other] = "Other";
	/** @enum {number} */
	var FormStyle = {
	    Format: 0,
	    Standalone: 1,
	};
	FormStyle[FormStyle.Format] = "Format";
	FormStyle[FormStyle.Standalone] = "Standalone";
	/** @enum {number} */
	var TranslationWidth = {
	    Narrow: 0,
	    Abbreviated: 1,
	    Wide: 2,
	    Short: 3,
	};
	TranslationWidth[TranslationWidth.Narrow] = "Narrow";
	TranslationWidth[TranslationWidth.Abbreviated] = "Abbreviated";
	TranslationWidth[TranslationWidth.Wide] = "Wide";
	TranslationWidth[TranslationWidth.Short] = "Short";
	/** @enum {number} */
	var FormatWidth = {
	    Short: 0,
	    Medium: 1,
	    Long: 2,
	    Full: 3,
	};
	FormatWidth[FormatWidth.Short] = "Short";
	FormatWidth[FormatWidth.Medium] = "Medium";
	FormatWidth[FormatWidth.Long] = "Long";
	FormatWidth[FormatWidth.Full] = "Full";
	/** @enum {number} */
	var NumberSymbol = {
	    Decimal: 0,
	    Group: 1,
	    List: 2,
	    PercentSign: 3,
	    PlusSign: 4,
	    MinusSign: 5,
	    Exponential: 6,
	    SuperscriptingExponent: 7,
	    PerMille: 8,
	    Infinity: 9,
	    NaN: 10,
	    TimeSeparator: 11,
	    CurrencyDecimal: 12,
	    CurrencyGroup: 13,
	};
	NumberSymbol[NumberSymbol.Decimal] = "Decimal";
	NumberSymbol[NumberSymbol.Group] = "Group";
	NumberSymbol[NumberSymbol.List] = "List";
	NumberSymbol[NumberSymbol.PercentSign] = "PercentSign";
	NumberSymbol[NumberSymbol.PlusSign] = "PlusSign";
	NumberSymbol[NumberSymbol.MinusSign] = "MinusSign";
	NumberSymbol[NumberSymbol.Exponential] = "Exponential";
	NumberSymbol[NumberSymbol.SuperscriptingExponent] = "SuperscriptingExponent";
	NumberSymbol[NumberSymbol.PerMille] = "PerMille";
	NumberSymbol[NumberSymbol.Infinity] = "Infinity";
	NumberSymbol[NumberSymbol.NaN] = "NaN";
	NumberSymbol[NumberSymbol.TimeSeparator] = "TimeSeparator";
	NumberSymbol[NumberSymbol.CurrencyDecimal] = "CurrencyDecimal";
	NumberSymbol[NumberSymbol.CurrencyGroup] = "CurrencyGroup";
	/** @enum {number} */
	var WeekDay = {
	    Sunday: 0,
	    Monday: 1,
	    Tuesday: 2,
	    Wednesday: 3,
	    Thursday: 4,
	    Friday: 5,
	    Saturday: 6,
	};
	WeekDay[WeekDay.Sunday] = "Sunday";
	WeekDay[WeekDay.Monday] = "Monday";
	WeekDay[WeekDay.Tuesday] = "Tuesday";
	WeekDay[WeekDay.Wednesday] = "Wednesday";
	WeekDay[WeekDay.Thursday] = "Thursday";
	WeekDay[WeekDay.Friday] = "Friday";
	WeekDay[WeekDay.Saturday] = "Saturday";
	/**
	 * The locale id for the chosen locale (e.g `en-GB`).
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocaleId(locale) {
	    return findLocaleData(locale)[0 /* LocaleId */];
	}
	/**
	 * Periods of the day (e.g. `[AM, PM]` for en-US).
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} formStyle
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleDayPeriods(locale, formStyle, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    var /** @type {?} */ amPmData = /** @type {?} */ ([data[1 /* DayPeriodsFormat */], data[2 /* DayPeriodsStandalone */]]);
	    var /** @type {?} */ amPm = getLastDefinedValue(amPmData, formStyle);
	    return getLastDefinedValue(amPm, width);
	}
	/**
	 * Days of the week for the Gregorian calendar (e.g. `[Sunday, Monday, ... Saturday]` for en-US).
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} formStyle
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleDayNames(locale, formStyle, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    var /** @type {?} */ daysData = /** @type {?} */ ([data[3 /* DaysFormat */], data[4 /* DaysStandalone */]]);
	    var /** @type {?} */ days = getLastDefinedValue(daysData, formStyle);
	    return getLastDefinedValue(days, width);
	}
	/**
	 * Months of the year for the Gregorian calendar (e.g. `[January, February, ...]` for en-US).
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} formStyle
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleMonthNames(locale, formStyle, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    var /** @type {?} */ monthsData = /** @type {?} */ ([data[5 /* MonthsFormat */], data[6 /* MonthsStandalone */]]);
	    var /** @type {?} */ months = getLastDefinedValue(monthsData, formStyle);
	    return getLastDefinedValue(months, width);
	}
	/**
	 * Eras for the Gregorian calendar (e.g. AD/BC).
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleEraNames(locale, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    var /** @type {?} */ erasData = /** @type {?} */ (data[7 /* Eras */]);
	    return getLastDefinedValue(erasData, width);
	}
	/**
	 * First day of the week for this locale, based on english days (Sunday = 0, Monday = 1, ...).
	 * For example in french the value would be 1 because the first day of the week is Monday.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocaleFirstDayOfWeek(locale) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return data[8 /* FirstDayOfWeek */];
	}
	/**
	 * Range of days in the week that represent the week-end for this locale, based on english days
	 * (Sunday = 0, Monday = 1, ...).
	 * For example in english the value would be [6,0] for Saturday to Sunday.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocaleWeekEndRange(locale) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return data[9 /* WeekendRange */];
	}
	/**
	 * Date format that depends on the locale.
	 *
	 * There are four basic date formats:
	 * - `full` should contain long-weekday (EEEE), year (y), long-month (MMMM), day (d).
	 *
	 *  For example, English uses `EEEE, MMMM d, y`, corresponding to a date like
	 *  "Tuesday, September 14, 1999".
	 *
	 * - `long` should contain year, long-month, day.
	 *
	 *  For example, `MMMM d, y`, corresponding to a date like "September 14, 1999".
	 *
	 * - `medium` should contain year, abbreviated-month (MMM), day.
	 *
	 *  For example, `MMM d, y`, corresponding to a date like "Sep 14, 1999".
	 *  For languages that do not use abbreviated months, use the numeric month (MM/M). For example,
	 *  `y/MM/dd`, corresponding to a date like "1999/09/14".
	 *
	 * - `short` should contain year, numeric-month (MM/M), and day.
	 *
	 *  For example, `M/d/yy`, corresponding to a date like "9/14/99".
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleDateFormat(locale, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return getLastDefinedValue(data[10 /* DateFormat */], width);
	}
	/**
	 * Time format that depends on the locale.
	 *
	 * The standard formats include four basic time formats:
	 * - `full` should contain hour (h/H), minute (mm), second (ss), and zone (zzzz).
	 * - `long` should contain hour, minute, second, and zone (z)
	 * - `medium` should contain hour, minute, second.
	 * - `short` should contain hour, minute.
	 *
	 * Note: The patterns depend on whether the main country using your language uses 12-hour time or
	 * not:
	 * - For 12-hour time, use a pattern like `hh:mm a` using h to mean a 12-hour clock cycle running
	 * 1 through 12 (midnight plus 1 minute is 12:01), or using K to mean a 12-hour clock cycle
	 * running 0 through 11 (midnight plus 1 minute is 0:01).
	 * - For 24-hour time, use a pattern like `HH:mm` using H to mean a 24-hour clock cycle running 0
	 * through 23 (midnight plus 1 minute is 0:01), or using k to mean a 24-hour clock cycle running
	 * 1 through 24 (midnight plus 1 minute is 24:01).
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleTimeFormat(locale, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return getLastDefinedValue(data[11 /* TimeFormat */], width);
	}
	/**
	 * Date-time format that depends on the locale.
	 *
	 * The date-time pattern shows how to combine separate patterns for date (represented by {1})
	 * and time (represented by {0}) into a single pattern. It usually doesn't need to be changed.
	 * What you want to pay attention to are:
	 * - possibly removing a space for languages that don't use it, such as many East Asian languages
	 * - possibly adding a comma, other punctuation, or a combining word
	 *
	 * For example:
	 * - English uses `{1} 'at' {0}` or `{1}, {0}` (depending on date style), while Japanese uses
	 *  `{1}{0}`.
	 * - An English formatted date-time using the combining pattern `{1}, {0}` could be
	 *  `Dec 10, 2010, 3:59:49 PM`. Notice the comma and space between the date portion and the time
	 *  portion.
	 *
	 * There are four formats (`full`, `long`, `medium`, `short`); the determination of which to use
	 * is normally based on the date style. For example, if the date has a full month and weekday
	 * name, the full combining pattern will be used to combine that with a time. If the date has
	 * numeric month, the short version of the combining pattern will be used to combine that with a
	 * time. English uses `{1} 'at' {0}` for full and long styles, and `{1}, {0}` for medium and short
	 * styles.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleDateTimeFormat(locale, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    var /** @type {?} */ dateTimeFormatData = /** @type {?} */ (data[12 /* DateTimeFormat */]);
	    return getLastDefinedValue(dateTimeFormatData, width);
	}
	/**
	 * Number symbol that can be used to replace placeholders in number formats.
	 * See {\@link NumberSymbol} for more information.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} symbol
	 * @return {?}
	 */
	function getLocaleNumberSymbol(locale, symbol) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    var /** @type {?} */ res = data[13 /* NumberSymbols */][symbol];
	    if (typeof res === 'undefined') {
	        if (symbol === NumberSymbol.CurrencyDecimal) {
	            return data[13 /* NumberSymbols */][NumberSymbol.Decimal];
	        }
	        else if (symbol === NumberSymbol.CurrencyGroup) {
	            return data[13 /* NumberSymbols */][NumberSymbol.Group];
	        }
	    }
	    return res;
	}
	/**
	 * Number format that depends on the locale.
	 *
	 * Numbers are formatted using patterns, like `#,###.00`. For example, the pattern `#,###.00`
	 * when used to format the number 12345.678 could result in "12'345,67". That would happen if the
	 * grouping separator for your language is an apostrophe, and the decimal separator is a comma.
	 *
	 * <b>Important:</b> The characters `.` `,` `0` `#` (and others below) are special placeholders;
	 * they stand for the decimal separator, and so on, and are NOT real characters.
	 * You must NOT "translate" the placeholders; for example, don't change `.` to `,` even though in
	 * your language the decimal point is written with a comma. The symbols should be replaced by the
	 * local equivalents, using the Number Symbols for your language.
	 *
	 * Here are the special characters used in number patterns:
	 *
	 * | Symbol | Meaning |
	 * |--------|---------|
	 * | . | Replaced automatically by the character used for the decimal point. |
	 * | , | Replaced by the "grouping" (thousands) separator. |
	 * | 0 | Replaced by a digit (or zero if there aren't enough digits). |
	 * | # | Replaced by a digit (or nothing if there aren't enough). |
	 * | ¤ | This will be replaced by a currency symbol, such as $ or USD. |
	 * | % | This marks a percent format. The % symbol may change position, but must be retained. |
	 * | E | This marks a scientific format. The E symbol may change position, but must be retained. |
	 * | ' | Special characters used as literal characters are quoted with ASCII single quotes. |
	 *
	 * You can find more information
	 * [on the CLDR website](http://cldr.unicode.org/translation/number-patterns)
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} type
	 * @return {?}
	 */
	function getLocaleNumberFormat(locale, type) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return data[14 /* NumberFormats */][type];
	}
	/**
	 * The symbol used to represent the currency for the main country using this locale (e.g. $ for
	 * the locale en-US).
	 * The symbol will be `null` if the main country cannot be determined.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocaleCurrencySymbol(locale) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return data[15 /* CurrencySymbol */] || null;
	}
	/**
	 * The name of the currency for the main country using this locale (e.g. USD for the locale
	 * en-US).
	 * The name will be `null` if the main country cannot be determined.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocaleCurrencyName(locale) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return data[16 /* CurrencyName */] || null;
	}
	/**
	 * The locale plural function used by ICU expressions to determine the plural case to use.
	 * See {\@link NgPlural} for more information.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocalePluralCase(locale) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    return data[17 /* PluralCase */];
	}
	/**
	 * @param {?} data
	 * @return {?}
	 */
	function checkFullData(data) {
	    if (!data[18 /* ExtraData */]) {
	        throw new Error("Missing extra locale data for the locale \"" + data[0 /* LocaleId */] + "\". Use \"registerLocaleData\" to load new data. See the \"I18n guide\" on angular.io to know more.");
	    }
	}
	/**
	 * Rules used to determine which day period to use (See `dayPeriods` below).
	 * The rules can either be an array or a single value. If it's an array, consider it as "from"
	 * and "to". If it's a single value then it means that the period is only valid at this exact
	 * value.
	 * There is always the same number of rules as the number of day periods, which means that the
	 * first rule is applied to the first day period and so on.
	 * You should fallback to AM/PM when there are no rules available.
	 *
	 * Note: this is only available if you load the full locale data.
	 * See the {\@linkDocs guide/i18n#i18n-pipes "I18n guide"} to know how to import additional locale
	 * data.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function getLocaleExtraDayPeriodRules(locale) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    checkFullData(data);
	    var /** @type {?} */ rules = data[18 /* ExtraData */][2 /* ExtraDayPeriodsRules */] || [];
	    return rules.map(function (rule) {
	        if (typeof rule === 'string') {
	            return extractTime(rule);
	        }
	        return [extractTime(rule[0]), extractTime(rule[1])];
	    });
	}
	/**
	 * Day Periods indicate roughly how the day is broken up in different languages (e.g. morning,
	 * noon, afternoon, midnight, ...).
	 * You should use the function {\@link getLocaleExtraDayPeriodRules} to determine which period to
	 * use.
	 * You should fallback to AM/PM when there are no day periods available.
	 *
	 * Note: this is only available if you load the full locale data.
	 * See the {\@linkDocs guide/i18n#i18n-pipes "I18n guide"} to know how to import additional locale
	 * data.
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @param {?} formStyle
	 * @param {?} width
	 * @return {?}
	 */
	function getLocaleExtraDayPeriods(locale, formStyle, width) {
	    var /** @type {?} */ data = findLocaleData(locale);
	    checkFullData(data);
	    var /** @type {?} */ dayPeriodsData = /** @type {?} */ ([
	        data[18 /* ExtraData */][0 /* ExtraDayPeriodFormats */],
	        data[18 /* ExtraData */][1 /* ExtraDayPeriodStandalone */]
	    ]);
	    var /** @type {?} */ dayPeriods = getLastDefinedValue(dayPeriodsData, formStyle) || [];
	    return getLastDefinedValue(dayPeriods, width) || [];
	}
	/**
	 * Returns the first value that is defined in an array, going backwards.
	 *
	 * To avoid repeating the same data (e.g. when "format" and "standalone" are the same) we only
	 * add the first one to the locale data arrays, the other ones are only defined when different.
	 * We use this function to retrieve the first defined value.
	 *
	 * \@experimental i18n support is experimental.
	 * @template T
	 * @param {?} data
	 * @param {?} index
	 * @return {?}
	 */
	function getLastDefinedValue(data, index) {
	    for (var /** @type {?} */ i = index; i > -1; i--) {
	        if (typeof data[i] !== 'undefined') {
	            return data[i];
	        }
	    }
	    throw new Error('Locale data API: locale data undefined');
	}
	/**
	 * Extract the hours and minutes from a string like "15:45"
	 * @param {?} time
	 * @return {?}
	 */
	function extractTime(time) {
	    var _a = time.split(':'), h = _a[0], m = _a[1];
	    return { hours: +h, minutes: +m };
	}
	/**
	 * Finds the locale data for a locale id
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} locale
	 * @return {?}
	 */
	function findLocaleData(locale) {
	    var /** @type {?} */ normalizedLocale = locale.toLowerCase().replace(/_/g, '-');
	    var /** @type {?} */ match = LOCALE_DATA[normalizedLocale];
	    if (match) {
	        return match;
	    }
	    // let's try to find a parent locale
	    var /** @type {?} */ parentLocale = normalizedLocale.split('-')[0];
	    match = LOCALE_DATA[parentLocale];
	    if (match) {
	        return match;
	    }
	    if (parentLocale === 'en') {
	        return localeEn;
	    }
	    throw new Error("Missing locale data for the locale \"" + locale + "\".");
	}
	/**
	 * Return the currency symbol for a given currency code, or the code if no symbol available
	 * (e.g.: format narrow = $, format wide = US$, code = USD)
	 *
	 * \@experimental i18n support is experimental.
	 * @param {?} code
	 * @param {?} format
	 * @return {?}
	 */
	function getCurrencySymbol(code, format) {
	    var /** @type {?} */ currency = CURRENCIES[code] || [];
	    var /** @type {?} */ symbolNarrow = currency[1];
	    if (format === 'narrow' && typeof symbolNarrow === 'string') {
	        return symbolNarrow;
	    }
	    return currency[0] || code;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @deprecated from v5
	 */
	var DEPRECATED_PLURAL_FN = new _angular_core.InjectionToken('UseV4Plurals');
	/**
	 * \@experimental
	 * @abstract
	 */
	var NgLocalization = /** @class */ (function () {
	    function NgLocalization() {
	    }
	    return NgLocalization;
	}());
	/**
	 * Returns the plural category for a given value.
	 * - "=value" when the case exists,
	 * - the plural category otherwise
	 * @param {?} value
	 * @param {?} cases
	 * @param {?} ngLocalization
	 * @param {?=} locale
	 * @return {?}
	 */
	function getPluralCategory(value, cases, ngLocalization, locale) {
	    var /** @type {?} */ key = "=" + value;
	    if (cases.indexOf(key) > -1) {
	        return key;
	    }
	    key = ngLocalization.getPluralCategory(value, locale);
	    if (cases.indexOf(key) > -1) {
	        return key;
	    }
	    if (cases.indexOf('other') > -1) {
	        return 'other';
	    }
	    throw new Error("No plural message found for value \"" + value + "\"");
	}
	/**
	 * Returns the plural case based on the locale
	 *
	 * \@experimental
	 */
	var NgLocaleLocalization = /** @class */ (function (_super) {
	    __extends(NgLocaleLocalization, _super);
	    function NgLocaleLocalization(locale, /** @deprecated from v5 */
	        deprecatedPluralFn) {
	        var _this = _super.call(this) || this;
	        _this.locale = locale;
	        _this.deprecatedPluralFn = deprecatedPluralFn;
	        return _this;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} locale
	     * @return {?}
	     */
	    NgLocaleLocalization.prototype.getPluralCategory = /**
	     * @param {?} value
	     * @param {?=} locale
	     * @return {?}
	     */
	    function (value, locale) {
	        var /** @type {?} */ plural = this.deprecatedPluralFn ? this.deprecatedPluralFn(locale || this.locale, value) :
	            getLocalePluralCase(locale || this.locale)(value);
	        switch (plural) {
	            case Plural.Zero:
	                return 'zero';
	            case Plural.One:
	                return 'one';
	            case Plural.Two:
	                return 'two';
	            case Plural.Few:
	                return 'few';
	            case Plural.Many:
	                return 'many';
	            default:
	                return 'other';
	        }
	    };
	    NgLocaleLocalization.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    NgLocaleLocalization.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [DEPRECATED_PLURAL_FN,] },] },
	    ]; };
	    return NgLocaleLocalization;
	}(NgLocalization));
	/**
	 * Returns the plural case based on the locale
	 *
	 * @deprecated from v5 the plural case function is in locale data files common/locales/*.ts
	 * \@experimental
	 * @param {?} locale
	 * @param {?} nLike
	 * @return {?}
	 */
	function getPluralCase(locale, nLike) {
	    // TODO(vicb): lazy compute
	    if (typeof nLike === 'string') {
	        nLike = parseInt(/** @type {?} */ (nLike), 10);
	    }
	    var /** @type {?} */ n = /** @type {?} */ (nLike);
	    var /** @type {?} */ nDecimal = n.toString().replace(/^[^.]*\.?/, '');
	    var /** @type {?} */ i = Math.floor(Math.abs(n));
	    var /** @type {?} */ v = nDecimal.length;
	    var /** @type {?} */ f = parseInt(nDecimal, 10);
	    var /** @type {?} */ t = parseInt(n.toString().replace(/^[^.]*\.?|0+$/g, ''), 10) || 0;
	    var /** @type {?} */ lang = locale.split('-')[0].toLowerCase();
	    switch (lang) {
	        case 'af':
	        case 'asa':
	        case 'az':
	        case 'bem':
	        case 'bez':
	        case 'bg':
	        case 'brx':
	        case 'ce':
	        case 'cgg':
	        case 'chr':
	        case 'ckb':
	        case 'ee':
	        case 'el':
	        case 'eo':
	        case 'es':
	        case 'eu':
	        case 'fo':
	        case 'fur':
	        case 'gsw':
	        case 'ha':
	        case 'haw':
	        case 'hu':
	        case 'jgo':
	        case 'jmc':
	        case 'ka':
	        case 'kk':
	        case 'kkj':
	        case 'kl':
	        case 'ks':
	        case 'ksb':
	        case 'ky':
	        case 'lb':
	        case 'lg':
	        case 'mas':
	        case 'mgo':
	        case 'ml':
	        case 'mn':
	        case 'nb':
	        case 'nd':
	        case 'ne':
	        case 'nn':
	        case 'nnh':
	        case 'nyn':
	        case 'om':
	        case 'or':
	        case 'os':
	        case 'ps':
	        case 'rm':
	        case 'rof':
	        case 'rwk':
	        case 'saq':
	        case 'seh':
	        case 'sn':
	        case 'so':
	        case 'sq':
	        case 'ta':
	        case 'te':
	        case 'teo':
	        case 'tk':
	        case 'tr':
	        case 'ug':
	        case 'uz':
	        case 'vo':
	        case 'vun':
	        case 'wae':
	        case 'xog':
	            if (n === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'ak':
	        case 'ln':
	        case 'mg':
	        case 'pa':
	        case 'ti':
	            if (n === Math.floor(n) && n >= 0 && n <= 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'am':
	        case 'as':
	        case 'bn':
	        case 'fa':
	        case 'gu':
	        case 'hi':
	        case 'kn':
	        case 'mr':
	        case 'zu':
	            if (i === 0 || n === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'ar':
	            if (n === 0)
	                return Plural.Zero;
	            if (n === 1)
	                return Plural.One;
	            if (n === 2)
	                return Plural.Two;
	            if (n % 100 === Math.floor(n % 100) && n % 100 >= 3 && n % 100 <= 10)
	                return Plural.Few;
	            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 99)
	                return Plural.Many;
	            return Plural.Other;
	        case 'ast':
	        case 'ca':
	        case 'de':
	        case 'en':
	        case 'et':
	        case 'fi':
	        case 'fy':
	        case 'gl':
	        case 'it':
	        case 'nl':
	        case 'sv':
	        case 'sw':
	        case 'ur':
	        case 'yi':
	            if (i === 1 && v === 0)
	                return Plural.One;
	            return Plural.Other;
	        case 'be':
	            if (n % 10 === 1 && !(n % 100 === 11))
	                return Plural.One;
	            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 4 &&
	                !(n % 100 >= 12 && n % 100 <= 14))
	                return Plural.Few;
	            if (n % 10 === 0 || n % 10 === Math.floor(n % 10) && n % 10 >= 5 && n % 10 <= 9 ||
	                n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 14)
	                return Plural.Many;
	            return Plural.Other;
	        case 'br':
	            if (n % 10 === 1 && !(n % 100 === 11 || n % 100 === 71 || n % 100 === 91))
	                return Plural.One;
	            if (n % 10 === 2 && !(n % 100 === 12 || n % 100 === 72 || n % 100 === 92))
	                return Plural.Two;
	            if (n % 10 === Math.floor(n % 10) && (n % 10 >= 3 && n % 10 <= 4 || n % 10 === 9) &&
	                !(n % 100 >= 10 && n % 100 <= 19 || n % 100 >= 70 && n % 100 <= 79 ||
	                    n % 100 >= 90 && n % 100 <= 99))
	                return Plural.Few;
	            if (!(n === 0) && n % 1e6 === 0)
	                return Plural.Many;
	            return Plural.Other;
	        case 'bs':
	        case 'hr':
	        case 'sr':
	            if (v === 0 && i % 10 === 1 && !(i % 100 === 11) || f % 10 === 1 && !(f % 100 === 11))
	                return Plural.One;
	            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
	                !(i % 100 >= 12 && i % 100 <= 14) ||
	                f % 10 === Math.floor(f % 10) && f % 10 >= 2 && f % 10 <= 4 &&
	                    !(f % 100 >= 12 && f % 100 <= 14))
	                return Plural.Few;
	            return Plural.Other;
	        case 'cs':
	        case 'sk':
	            if (i === 1 && v === 0)
	                return Plural.One;
	            if (i === Math.floor(i) && i >= 2 && i <= 4 && v === 0)
	                return Plural.Few;
	            if (!(v === 0))
	                return Plural.Many;
	            return Plural.Other;
	        case 'cy':
	            if (n === 0)
	                return Plural.Zero;
	            if (n === 1)
	                return Plural.One;
	            if (n === 2)
	                return Plural.Two;
	            if (n === 3)
	                return Plural.Few;
	            if (n === 6)
	                return Plural.Many;
	            return Plural.Other;
	        case 'da':
	            if (n === 1 || !(t === 0) && (i === 0 || i === 1))
	                return Plural.One;
	            return Plural.Other;
	        case 'dsb':
	        case 'hsb':
	            if (v === 0 && i % 100 === 1 || f % 100 === 1)
	                return Plural.One;
	            if (v === 0 && i % 100 === 2 || f % 100 === 2)
	                return Plural.Two;
	            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 ||
	                f % 100 === Math.floor(f % 100) && f % 100 >= 3 && f % 100 <= 4)
	                return Plural.Few;
	            return Plural.Other;
	        case 'ff':
	        case 'fr':
	        case 'hy':
	        case 'kab':
	            if (i === 0 || i === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'fil':
	            if (v === 0 && (i === 1 || i === 2 || i === 3) ||
	                v === 0 && !(i % 10 === 4 || i % 10 === 6 || i % 10 === 9) ||
	                !(v === 0) && !(f % 10 === 4 || f % 10 === 6 || f % 10 === 9))
	                return Plural.One;
	            return Plural.Other;
	        case 'ga':
	            if (n === 1)
	                return Plural.One;
	            if (n === 2)
	                return Plural.Two;
	            if (n === Math.floor(n) && n >= 3 && n <= 6)
	                return Plural.Few;
	            if (n === Math.floor(n) && n >= 7 && n <= 10)
	                return Plural.Many;
	            return Plural.Other;
	        case 'gd':
	            if (n === 1 || n === 11)
	                return Plural.One;
	            if (n === 2 || n === 12)
	                return Plural.Two;
	            if (n === Math.floor(n) && (n >= 3 && n <= 10 || n >= 13 && n <= 19))
	                return Plural.Few;
	            return Plural.Other;
	        case 'gv':
	            if (v === 0 && i % 10 === 1)
	                return Plural.One;
	            if (v === 0 && i % 10 === 2)
	                return Plural.Two;
	            if (v === 0 &&
	                (i % 100 === 0 || i % 100 === 20 || i % 100 === 40 || i % 100 === 60 || i % 100 === 80))
	                return Plural.Few;
	            if (!(v === 0))
	                return Plural.Many;
	            return Plural.Other;
	        case 'he':
	            if (i === 1 && v === 0)
	                return Plural.One;
	            if (i === 2 && v === 0)
	                return Plural.Two;
	            if (v === 0 && !(n >= 0 && n <= 10) && n % 10 === 0)
	                return Plural.Many;
	            return Plural.Other;
	        case 'is':
	            if (t === 0 && i % 10 === 1 && !(i % 100 === 11) || !(t === 0))
	                return Plural.One;
	            return Plural.Other;
	        case 'ksh':
	            if (n === 0)
	                return Plural.Zero;
	            if (n === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'kw':
	        case 'naq':
	        case 'se':
	        case 'smn':
	            if (n === 1)
	                return Plural.One;
	            if (n === 2)
	                return Plural.Two;
	            return Plural.Other;
	        case 'lag':
	            if (n === 0)
	                return Plural.Zero;
	            if ((i === 0 || i === 1) && !(n === 0))
	                return Plural.One;
	            return Plural.Other;
	        case 'lt':
	            if (n % 10 === 1 && !(n % 100 >= 11 && n % 100 <= 19))
	                return Plural.One;
	            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 9 &&
	                !(n % 100 >= 11 && n % 100 <= 19))
	                return Plural.Few;
	            if (!(f === 0))
	                return Plural.Many;
	            return Plural.Other;
	        case 'lv':
	        case 'prg':
	            if (n % 10 === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19 ||
	                v === 2 && f % 100 === Math.floor(f % 100) && f % 100 >= 11 && f % 100 <= 19)
	                return Plural.Zero;
	            if (n % 10 === 1 && !(n % 100 === 11) || v === 2 && f % 10 === 1 && !(f % 100 === 11) ||
	                !(v === 2) && f % 10 === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'mk':
	            if (v === 0 && i % 10 === 1 || f % 10 === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'mt':
	            if (n === 1)
	                return Plural.One;
	            if (n === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 2 && n % 100 <= 10)
	                return Plural.Few;
	            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19)
	                return Plural.Many;
	            return Plural.Other;
	        case 'pl':
	            if (i === 1 && v === 0)
	                return Plural.One;
	            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
	                !(i % 100 >= 12 && i % 100 <= 14))
	                return Plural.Few;
	            if (v === 0 && !(i === 1) && i % 10 === Math.floor(i % 10) && i % 10 >= 0 && i % 10 <= 1 ||
	                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
	                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 12 && i % 100 <= 14)
	                return Plural.Many;
	            return Plural.Other;
	        case 'pt':
	            if (n === Math.floor(n) && n >= 0 && n <= 2 && !(n === 2))
	                return Plural.One;
	            return Plural.Other;
	        case 'ro':
	            if (i === 1 && v === 0)
	                return Plural.One;
	            if (!(v === 0) || n === 0 ||
	                !(n === 1) && n % 100 === Math.floor(n % 100) && n % 100 >= 1 && n % 100 <= 19)
	                return Plural.Few;
	            return Plural.Other;
	        case 'ru':
	        case 'uk':
	            if (v === 0 && i % 10 === 1 && !(i % 100 === 11))
	                return Plural.One;
	            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
	                !(i % 100 >= 12 && i % 100 <= 14))
	                return Plural.Few;
	            if (v === 0 && i % 10 === 0 ||
	                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
	                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 11 && i % 100 <= 14)
	                return Plural.Many;
	            return Plural.Other;
	        case 'shi':
	            if (i === 0 || n === 1)
	                return Plural.One;
	            if (n === Math.floor(n) && n >= 2 && n <= 10)
	                return Plural.Few;
	            return Plural.Other;
	        case 'si':
	            if (n === 0 || n === 1 || i === 0 && f === 1)
	                return Plural.One;
	            return Plural.Other;
	        case 'sl':
	            if (v === 0 && i % 100 === 1)
	                return Plural.One;
	            if (v === 0 && i % 100 === 2)
	                return Plural.Two;
	            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 || !(v === 0))
	                return Plural.Few;
	            return Plural.Other;
	        case 'tzm':
	            if (n === Math.floor(n) && n >= 0 && n <= 1 || n === Math.floor(n) && n >= 11 && n <= 99)
	                return Plural.One;
	            return Plural.Other;
	        // When there is no specification, the default is always "other"
	        // Spec: http://cldr.unicode.org/index/cldr-spec/plural-rules
	        // > other (required—general plural form — also used if the language only has a single form)
	        default:
	            return Plural.Other;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} cookieStr
	 * @param {?} name
	 * @return {?}
	 */
	function parseCookieValue(cookieStr, name) {
	    name = encodeURIComponent(name);
	    for (var _i = 0, _a = cookieStr.split(';'); _i < _a.length; _i++) {
	        var cookie = _a[_i];
	        var /** @type {?} */ eqIndex = cookie.indexOf('=');
	        var _b = eqIndex == -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)], cookieName = _b[0], cookieValue = _b[1];
	        if (cookieName.trim() === name) {
	            return decodeURIComponent(cookieValue);
	        }
	    }
	    return null;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Adds and removes CSS classes on an HTML element.
	 *
	 * \@howToUse
	 * ```
	 *     <some-element [ngClass]="'first second'">...</some-element>
	 *
	 *     <some-element [ngClass]="['first', 'second']">...</some-element>
	 *
	 *     <some-element [ngClass]="{'first': true, 'second': true, 'third': false}">...</some-element>
	 *
	 *     <some-element [ngClass]="stringExp|arrayExp|objExp">...</some-element>
	 *
	 *     <some-element [ngClass]="{'class1 class2 class3' : true}">...</some-element>
	 * ```
	 *
	 * \@description
	 *
	 * The CSS classes are updated as follows, depending on the type of the expression evaluation:
	 * - `string` - the CSS classes listed in the string (space delimited) are added,
	 * - `Array` - the CSS classes declared as Array elements are added,
	 * - `Object` - keys are CSS classes that get added when the expression given in the value
	 *              evaluates to a truthy value, otherwise they are removed.
	 *
	 * \@stable
	 */
	var NgClass = /** @class */ (function () {
	    function NgClass(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
	        this._iterableDiffers = _iterableDiffers;
	        this._keyValueDiffers = _keyValueDiffers;
	        this._ngEl = _ngEl;
	        this._renderer = _renderer;
	        this._initialClasses = [];
	    }
	    Object.defineProperty(NgClass.prototype, "klass", {
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._removeClasses(this._initialClasses);
	            this._initialClasses = typeof v === 'string' ? v.split(/\s+/) : [];
	            this._applyClasses(this._initialClasses);
	            this._applyClasses(this._rawClass);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgClass.prototype, "ngClass", {
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._removeClasses(this._rawClass);
	            this._applyClasses(this._initialClasses);
	            this._iterableDiffer = null;
	            this._keyValueDiffer = null;
	            this._rawClass = typeof v === 'string' ? v.split(/\s+/) : v;
	            if (this._rawClass) {
	                if (_angular_core.ɵisListLikeIterable(this._rawClass)) {
	                    this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create();
	                }
	                else {
	                    this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create();
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    NgClass.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._iterableDiffer) {
	            var /** @type {?} */ iterableChanges = this._iterableDiffer.diff(/** @type {?} */ (this._rawClass));
	            if (iterableChanges) {
	                this._applyIterableChanges(iterableChanges);
	            }
	        }
	        else if (this._keyValueDiffer) {
	            var /** @type {?} */ keyValueChanges = this._keyValueDiffer.diff(/** @type {?} */ (this._rawClass));
	            if (keyValueChanges) {
	                this._applyKeyValueChanges(keyValueChanges);
	            }
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgClass.prototype._applyKeyValueChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        changes.forEachAddedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
	        changes.forEachChangedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
	        changes.forEachRemovedItem(function (record) {
	            if (record.previousValue) {
	                _this._toggleClass(record.key, false);
	            }
	        });
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgClass.prototype._applyIterableChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        changes.forEachAddedItem(function (record) {
	            if (typeof record.item === 'string') {
	                _this._toggleClass(record.item, true);
	            }
	            else {
	                throw new Error("NgClass can only toggle CSS classes expressed as strings, got " + _angular_core.ɵstringify(record.item));
	            }
	        });
	        changes.forEachRemovedItem(function (record) { return _this._toggleClass(record.item, false); });
	    };
	    /**
	     * Applies a collection of CSS classes to the DOM element.
	     *
	     * For argument of type Set and Array CSS class names contained in those collections are always
	     * added.
	     * For argument of type Map CSS class name in the map's key is toggled based on the value (added
	     * for truthy and removed for falsy).
	     * @param {?} rawClassVal
	     * @return {?}
	     */
	    NgClass.prototype._applyClasses = /**
	     * Applies a collection of CSS classes to the DOM element.
	     *
	     * For argument of type Set and Array CSS class names contained in those collections are always
	     * added.
	     * For argument of type Map CSS class name in the map's key is toggled based on the value (added
	     * for truthy and removed for falsy).
	     * @param {?} rawClassVal
	     * @return {?}
	     */
	    function (rawClassVal) {
	        var _this = this;
	        if (rawClassVal) {
	            if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
	                (/** @type {?} */ (rawClassVal)).forEach(function (klass) { return _this._toggleClass(klass, true); });
	            }
	            else {
	                Object.keys(rawClassVal).forEach(function (klass) { return _this._toggleClass(klass, !!rawClassVal[klass]); });
	            }
	        }
	    };
	    /**
	     * Removes a collection of CSS classes from the DOM element. This is mostly useful for cleanup
	     * purposes.
	     * @param {?} rawClassVal
	     * @return {?}
	     */
	    NgClass.prototype._removeClasses = /**
	     * Removes a collection of CSS classes from the DOM element. This is mostly useful for cleanup
	     * purposes.
	     * @param {?} rawClassVal
	     * @return {?}
	     */
	    function (rawClassVal) {
	        var _this = this;
	        if (rawClassVal) {
	            if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
	                (/** @type {?} */ (rawClassVal)).forEach(function (klass) { return _this._toggleClass(klass, false); });
	            }
	            else {
	                Object.keys(rawClassVal).forEach(function (klass) { return _this._toggleClass(klass, false); });
	            }
	        }
	    };
	    /**
	     * @param {?} klass
	     * @param {?} enabled
	     * @return {?}
	     */
	    NgClass.prototype._toggleClass = /**
	     * @param {?} klass
	     * @param {?} enabled
	     * @return {?}
	     */
	    function (klass, enabled) {
	        var _this = this;
	        klass = klass.trim();
	        if (klass) {
	            klass.split(/\s+/g).forEach(function (klass) {
	                if (enabled) {
	                    _this._renderer.addClass(_this._ngEl.nativeElement, klass);
	                }
	                else {
	                    _this._renderer.removeClass(_this._ngEl.nativeElement, klass);
	                }
	            });
	        }
	    };
	    NgClass.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngClass]' },] },
	    ];
	    /** @nocollapse */
	    NgClass.ctorParameters = function () { return [
	        { type: _angular_core.IterableDiffers, },
	        { type: _angular_core.KeyValueDiffers, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.Renderer2, },
	    ]; };
	    NgClass.propDecorators = {
	        "klass": [{ type: _angular_core.Input, args: ['class',] },],
	        "ngClass": [{ type: _angular_core.Input },],
	    };
	    return NgClass;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Instantiates a single {\@link Component} type and inserts its Host View into current View.
	 * `NgComponentOutlet` provides a declarative approach for dynamic component creation.
	 *
	 * `NgComponentOutlet` requires a component type, if a falsy value is set the view will clear and
	 * any existing component will get destroyed.
	 *
	 * ### Fine tune control
	 *
	 * You can control the component creation process by using the following optional attributes:
	 *
	 * * `ngComponentOutletInjector`: Optional custom {\@link Injector} that will be used as parent for
	 * the Component. Defaults to the injector of the current view container.
	 *
	 * * `ngComponentOutletContent`: Optional list of projectable nodes to insert into the content
	 * section of the component, if exists.
	 *
	 * * `ngComponentOutletNgModuleFactory`: Optional module factory to allow dynamically loading other
	 * module, then load a component from that module.
	 *
	 * ### Syntax
	 *
	 * Simple
	 * ```
	 * <ng-container *ngComponentOutlet="componentTypeExpression"></ng-container>
	 * ```
	 *
	 * Customized injector/content
	 * ```
	 * <ng-container *ngComponentOutlet="componentTypeExpression;
	 *                                   injector: injectorExpression;
	 *                                   content: contentNodesExpression;">
	 * </ng-container>
	 * ```
	 *
	 * Customized ngModuleFactory
	 * ```
	 * <ng-container *ngComponentOutlet="componentTypeExpression;
	 *                                   ngModuleFactory: moduleFactory;">
	 * </ng-container>
	 * ```
	 * ## Example
	 *
	 * {\@example common/ngComponentOutlet/ts/module.ts region='SimpleExample'}
	 *
	 * A more complete example with additional options:
	 *
	 * {\@example common/ngComponentOutlet/ts/module.ts region='CompleteExample'}
	 * A more complete example with ngModuleFactory:
	 *
	 * {\@example common/ngComponentOutlet/ts/module.ts region='NgModuleFactoryExample'}
	 *
	 * \@experimental
	 */
	var NgComponentOutlet = /** @class */ (function () {
	    function NgComponentOutlet(_viewContainerRef) {
	        this._viewContainerRef = _viewContainerRef;
	        this._componentRef = null;
	        this._moduleRef = null;
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgComponentOutlet.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        this._viewContainerRef.clear();
	        this._componentRef = null;
	        if (this.ngComponentOutlet) {
	            var /** @type {?} */ elInjector = this.ngComponentOutletInjector || this._viewContainerRef.parentInjector;
	            if (changes['ngComponentOutletNgModuleFactory']) {
	                if (this._moduleRef)
	                    this._moduleRef.destroy();
	                if (this.ngComponentOutletNgModuleFactory) {
	                    var /** @type {?} */ parentModule = elInjector.get(_angular_core.NgModuleRef);
	                    this._moduleRef = this.ngComponentOutletNgModuleFactory.create(parentModule.injector);
	                }
	                else {
	                    this._moduleRef = null;
	                }
	            }
	            var /** @type {?} */ componentFactoryResolver = this._moduleRef ? this._moduleRef.componentFactoryResolver :
	                elInjector.get(_angular_core.ComponentFactoryResolver);
	            var /** @type {?} */ componentFactory = componentFactoryResolver.resolveComponentFactory(this.ngComponentOutlet);
	            this._componentRef = this._viewContainerRef.createComponent(componentFactory, this._viewContainerRef.length, elInjector, this.ngComponentOutletContent);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NgComponentOutlet.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._moduleRef)
	            this._moduleRef.destroy();
	    };
	    NgComponentOutlet.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngComponentOutlet]' },] },
	    ];
	    /** @nocollapse */
	    NgComponentOutlet.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    NgComponentOutlet.propDecorators = {
	        "ngComponentOutlet": [{ type: _angular_core.Input },],
	        "ngComponentOutletInjector": [{ type: _angular_core.Input },],
	        "ngComponentOutletContent": [{ type: _angular_core.Input },],
	        "ngComponentOutletNgModuleFactory": [{ type: _angular_core.Input },],
	    };
	    return NgComponentOutlet;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 * @template T
	 */
	var NgForOfContext = /** @class */ (function () {
	    function NgForOfContext($implicit, ngForOf, index, count) {
	        this.$implicit = $implicit;
	        this.ngForOf = ngForOf;
	        this.index = index;
	        this.count = count;
	    }
	    Object.defineProperty(NgForOfContext.prototype, "first", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.index === 0; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForOfContext.prototype, "last", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.index === this.count - 1; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForOfContext.prototype, "even", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.index % 2 === 0; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForOfContext.prototype, "odd", {
	        get: /**
	         * @return {?}
	         */
	        function () { return !this.even; },
	        enumerable: true,
	        configurable: true
	    });
	    return NgForOfContext;
	}());
	/**
	 * The `NgForOf` directive instantiates a template once per item from an iterable. The context
	 * for each instantiated template inherits from the outer context with the given loop variable
	 * set to the current item from the iterable.
	 *
	 * ### Local Variables
	 *
	 * `NgForOf` provides several exported values that can be aliased to local variables:
	 *
	 * - `$implicit: T`: The value of the individual items in the iterable (`ngForOf`).
	 * - `ngForOf: NgIterable<T>`: The value of the iterable expression. Useful when the expression is
	 * more complex then a property access, for example when using the async pipe (`userStreams |
	 * async`).
	 * - `index: number`: The index of the current item in the iterable.
	 * - `first: boolean`: True when the item is the first item in the iterable.
	 * - `last: boolean`: True when the item is the last item in the iterable.
	 * - `even: boolean`: True when the item has an even index in the iterable.
	 * - `odd: boolean`: True when the item has an odd index in the iterable.
	 *
	 * ```
	 * <li *ngFor="let user of userObservable | async as users; index as i; first as isFirst">
	 *    {{i}}/{{users.length}}. {{user}} <span *ngIf="isFirst">default</span>
	 * </li>
	 * ```
	 *
	 * ### Change Propagation
	 *
	 * When the contents of the iterator changes, `NgForOf` makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 * * Otherwise, the DOM element for that item will remain the same.
	 *
	 * Angular uses object identity to track insertions and deletions within the iterator and reproduce
	 * those changes in the DOM. This has important implications for animations and any stateful
	 * controls (such as `<input>` elements which accept user input) that are present. Inserted rows can
	 * be animated in, deleted rows can be animated out, and unchanged rows retain any unsaved state
	 * such as user input.
	 *
	 * It is possible for the identities of elements in the iterator to change while the data does not.
	 * This can happen, for example, if the iterator produced from an RPC to the server, and that
	 * RPC is re-run. Even if the data hasn't changed, the second response will produce objects with
	 * different identities, and Angular will tear down the entire DOM and rebuild it (as if all old
	 * elements were deleted and all new elements inserted). This is an expensive operation and should
	 * be avoided if possible.
	 *
	 * To customize the default tracking algorithm, `NgForOf` supports `trackBy` option.
	 * `trackBy` takes a function which has two arguments: `index` and `item`.
	 * If `trackBy` is given, Angular tracks changes by the return value of the function.
	 *
	 * ### Syntax
	 *
	 * - `<li *ngFor="let item of items; index as i; trackBy: trackByFn">...</li>`
	 *
	 * With `<ng-template>` element:
	 *
	 * ```
	 * <ng-template ngFor let-item [ngForOf]="items" let-i="index" [ngForTrackBy]="trackByFn">
	 *   <li>...</li>
	 * </ng-template>
	 * ```
	 *
	 * ### Example
	 *
	 * See a [live demo](http://plnkr.co/edit/KVuXxDp0qinGDyo307QW?p=preview) for a more detailed
	 * example.
	 *
	 * \@stable
	 * @template T
	 */
	var NgForOf = /** @class */ (function () {
	    function NgForOf(_viewContainer, _template, _differs) {
	        this._viewContainer = _viewContainer;
	        this._template = _template;
	        this._differs = _differs;
	        this._differ = null;
	    }
	    Object.defineProperty(NgForOf.prototype, "ngForTrackBy", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._trackByFn; },
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            if (_angular_core.isDevMode() && fn != null && typeof fn !== 'function') {
	                // TODO(vicb): use a log service once there is a public one available
	                if (/** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	                    console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ". " +
	                        "See https://angular.io/docs/ts/latest/api/common/index/NgFor-directive.html#!#change-propagation for more information.");
	                }
	            }
	            this._trackByFn = fn;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForOf.prototype, "ngForTemplate", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            // TODO(TS2.1): make TemplateRef<Partial<NgForRowOf<T>>> once we move to TS v2.1
	            // The current type is too restrictive; a template that just uses index, for example,
	            // should be acceptable.
	            if (value) {
	                this._template = value;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgForOf.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if ('ngForOf' in changes) {
	            // React on ngForOf changes only once all inputs have been initialized
	            var /** @type {?} */ value = changes['ngForOf'].currentValue;
	            if (!this._differ && value) {
	                try {
	                    this._differ = this._differs.find(value).create(this.ngForTrackBy);
	                }
	                catch (/** @type {?} */ e) {
	                    throw new Error("Cannot find a differ supporting object '" + value + "' of type '" + getTypeNameForDebugging(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
	                }
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NgForOf.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._differ) {
	            var /** @type {?} */ changes = this._differ.diff(this.ngForOf);
	            if (changes)
	                this._applyChanges(changes);
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgForOf.prototype._applyChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        var /** @type {?} */ insertTuples = [];
	        changes.forEachOperation(function (item, adjustedPreviousIndex, currentIndex) {
	            if (item.previousIndex == null) {
	                var /** @type {?} */ view = _this._viewContainer.createEmbeddedView(_this._template, new NgForOfContext(/** @type {?} */ ((null)), _this.ngForOf, -1, -1), currentIndex);
	                var /** @type {?} */ tuple = new RecordViewTuple(item, view);
	                insertTuples.push(tuple);
	            }
	            else if (currentIndex == null) {
	                _this._viewContainer.remove(adjustedPreviousIndex);
	            }
	            else {
	                var /** @type {?} */ view = /** @type {?} */ ((_this._viewContainer.get(adjustedPreviousIndex)));
	                _this._viewContainer.move(view, currentIndex);
	                var /** @type {?} */ tuple = new RecordViewTuple(item, /** @type {?} */ (view));
	                insertTuples.push(tuple);
	            }
	        });
	        for (var /** @type {?} */ i = 0; i < insertTuples.length; i++) {
	            this._perViewChange(insertTuples[i].view, insertTuples[i].record);
	        }
	        for (var /** @type {?} */ i = 0, /** @type {?} */ ilen = this._viewContainer.length; i < ilen; i++) {
	            var /** @type {?} */ viewRef = /** @type {?} */ (this._viewContainer.get(i));
	            viewRef.context.index = i;
	            viewRef.context.count = ilen;
	        }
	        changes.forEachIdentityChange(function (record) {
	            var /** @type {?} */ viewRef = /** @type {?} */ (_this._viewContainer.get(record.currentIndex));
	            viewRef.context.$implicit = record.item;
	        });
	    };
	    /**
	     * @param {?} view
	     * @param {?} record
	     * @return {?}
	     */
	    NgForOf.prototype._perViewChange = /**
	     * @param {?} view
	     * @param {?} record
	     * @return {?}
	     */
	    function (view, record) {
	        view.context.$implicit = record.item;
	    };
	    NgForOf.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngFor][ngForOf]' },] },
	    ];
	    /** @nocollapse */
	    NgForOf.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.IterableDiffers, },
	    ]; };
	    NgForOf.propDecorators = {
	        "ngForOf": [{ type: _angular_core.Input },],
	        "ngForTrackBy": [{ type: _angular_core.Input },],
	        "ngForTemplate": [{ type: _angular_core.Input },],
	    };
	    return NgForOf;
	}());
	/**
	 * @template T
	 */
	var RecordViewTuple = /** @class */ (function () {
	    function RecordViewTuple(record, view) {
	        this.record = record;
	        this.view = view;
	    }
	    return RecordViewTuple;
	}());
	/**
	 * @param {?} type
	 * @return {?}
	 */
	function getTypeNameForDebugging(type) {
	    return type['name'] || typeof type;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Conditionally includes a template based on the value of an `expression`.
	 *
	 * `ngIf` evaluates the `expression` and then renders the `then` or `else` template in its place
	 * when expression is truthy or falsy respectively. Typically the:
	 *  - `then` template is the inline template of `ngIf` unless bound to a different value.
	 *  - `else` template is blank unless it is bound.
	 *
	 * ## Most common usage
	 *
	 * The most common usage of the `ngIf` directive is to conditionally show the inline template as
	 * seen in this example:
	 * {\@example common/ngIf/ts/module.ts region='NgIfSimple'}
	 *
	 * ## Showing an alternative template using `else`
	 *
	 * If it is necessary to display a template when the `expression` is falsy use the `else` template
	 * binding as shown. Note that the `else` binding points to a `<ng-template>` labeled `#elseBlock`.
	 * The template can be defined anywhere in the component view but is typically placed right after
	 * `ngIf` for readability.
	 *
	 * {\@example common/ngIf/ts/module.ts region='NgIfElse'}
	 *
	 * ## Using non-inlined `then` template
	 *
	 * Usually the `then` template is the inlined template of the `ngIf`, but it can be changed using
	 * a binding (just like `else`). Because `then` and `else` are bindings, the template references can
	 * change at runtime as shown in this example.
	 *
	 * {\@example common/ngIf/ts/module.ts region='NgIfThenElse'}
	 *
	 * ## Storing conditional result in a variable
	 *
	 * A common pattern is that we need to show a set of properties from the same object. If the
	 * object is undefined, then we have to use the safe-traversal-operator `?.` to guard against
	 * dereferencing a `null` value. This is especially the case when waiting on async data such as
	 * when using the `async` pipe as shown in following example:
	 *
	 * ```
	 * Hello {{ (userStream|async)?.last }}, {{ (userStream|async)?.first }}!
	 * ```
	 *
	 * There are several inefficiencies in the above example:
	 *  - We create multiple subscriptions on `userStream`. One for each `async` pipe, or two in the
	 *    example above.
	 *  - We cannot display an alternative screen while waiting for the data to arrive asynchronously.
	 *  - We have to use the safe-traversal-operator `?.` to access properties, which is cumbersome.
	 *  - We have to place the `async` pipe in parenthesis.
	 *
	 * A better way to do this is to use `ngIf` and store the result of the condition in a local
	 * variable as shown in the the example below:
	 *
	 * {\@example common/ngIf/ts/module.ts region='NgIfAs'}
	 *
	 * Notice that:
	 *  - We use only one `async` pipe and hence only one subscription gets created.
	 *  - `ngIf` stores the result of the `userStream|async` in the local variable `user`.
	 *  - The local `user` can then be bound repeatedly in a more efficient way.
	 *  - No need to use the safe-traversal-operator `?.` to access properties as `ngIf` will only
	 *    display the data if `userStream` returns a value.
	 *  - We can display an alternative template while waiting for the data.
	 *
	 * ### Syntax
	 *
	 * Simple form:
	 * - `<div *ngIf="condition">...</div>`
	 * - `<ng-template [ngIf]="condition"><div>...</div></ng-template>`
	 *
	 * Form with an else block:
	 * ```
	 * <div *ngIf="condition; else elseBlock">...</div>
	 * <ng-template #elseBlock>...</ng-template>
	 * ```
	 *
	 * Form with a `then` and `else` block:
	 * ```
	 * <div *ngIf="condition; then thenBlock else elseBlock"></div>
	 * <ng-template #thenBlock>...</ng-template>
	 * <ng-template #elseBlock>...</ng-template>
	 * ```
	 *
	 * Form with storing the value locally:
	 * ```
	 * <div *ngIf="condition as value; else elseBlock">{{value}}</div>
	 * <ng-template #elseBlock>...</ng-template>
	 * ```
	 *
	 * \@stable
	 */
	var NgIf = /** @class */ (function () {
	    function NgIf(_viewContainer, templateRef) {
	        this._viewContainer = _viewContainer;
	        this._context = new NgIfContext();
	        this._thenTemplateRef = null;
	        this._elseTemplateRef = null;
	        this._thenViewRef = null;
	        this._elseViewRef = null;
	        this._thenTemplateRef = templateRef;
	    }
	    Object.defineProperty(NgIf.prototype, "ngIf", {
	        set: /**
	         * @param {?} condition
	         * @return {?}
	         */
	        function (condition) {
	            this._context.$implicit = this._context.ngIf = condition;
	            this._updateView();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgIf.prototype, "ngIfThen", {
	        set: /**
	         * @param {?} templateRef
	         * @return {?}
	         */
	        function (templateRef) {
	            this._thenTemplateRef = templateRef;
	            this._thenViewRef = null; // clear previous view if any.
	            this._updateView();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgIf.prototype, "ngIfElse", {
	        set: /**
	         * @param {?} templateRef
	         * @return {?}
	         */
	        function (templateRef) {
	            this._elseTemplateRef = templateRef;
	            this._elseViewRef = null; // clear previous view if any.
	            this._updateView();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    NgIf.prototype._updateView = /**
	     * @return {?}
	     */
	    function () {
	        if (this._context.$implicit) {
	            if (!this._thenViewRef) {
	                this._viewContainer.clear();
	                this._elseViewRef = null;
	                if (this._thenTemplateRef) {
	                    this._thenViewRef =
	                        this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context);
	                }
	            }
	        }
	        else {
	            if (!this._elseViewRef) {
	                this._viewContainer.clear();
	                this._thenViewRef = null;
	                if (this._elseTemplateRef) {
	                    this._elseViewRef =
	                        this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context);
	                }
	            }
	        }
	    };
	    NgIf.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngIf]' },] },
	    ];
	    /** @nocollapse */
	    NgIf.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    NgIf.propDecorators = {
	        "ngIf": [{ type: _angular_core.Input },],
	        "ngIfThen": [{ type: _angular_core.Input },],
	        "ngIfElse": [{ type: _angular_core.Input },],
	    };
	    return NgIf;
	}());
	/**
	 * \@stable
	 */
	var NgIfContext = /** @class */ (function () {
	    function NgIfContext() {
	        this.$implicit = null;
	        this.ngIf = null;
	    }
	    return NgIfContext;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SwitchView = /** @class */ (function () {
	    function SwitchView(_viewContainerRef, _templateRef) {
	        this._viewContainerRef = _viewContainerRef;
	        this._templateRef = _templateRef;
	        this._created = false;
	    }
	    /**
	     * @return {?}
	     */
	    SwitchView.prototype.create = /**
	     * @return {?}
	     */
	    function () {
	        this._created = true;
	        this._viewContainerRef.createEmbeddedView(this._templateRef);
	    };
	    /**
	     * @return {?}
	     */
	    SwitchView.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        this._created = false;
	        this._viewContainerRef.clear();
	    };
	    /**
	     * @param {?} created
	     * @return {?}
	     */
	    SwitchView.prototype.enforceState = /**
	     * @param {?} created
	     * @return {?}
	     */
	    function (created) {
	        if (created && !this._created) {
	            this.create();
	        }
	        else if (!created && this._created) {
	            this.destroy();
	        }
	    };
	    return SwitchView;
	}());
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Adds / removes DOM sub-trees when the nest match expressions matches the switch
	 *             expression.
	 *
	 * \@howToUse
	 * ```
	 *     <container-element [ngSwitch]="switch_expression">
	 *       <some-element *ngSwitchCase="match_expression_1">...</some-element>
	 *       <some-element *ngSwitchCase="match_expression_2">...</some-element>
	 *       <some-other-element *ngSwitchCase="match_expression_3">...</some-other-element>
	 *       <ng-container *ngSwitchCase="match_expression_3">
	 *         <!-- use a ng-container to group multiple root nodes -->
	 *         <inner-element></inner-element>
	 *         <inner-other-element></inner-other-element>
	 *       </ng-container>
	 *       <some-element *ngSwitchDefault>...</some-element>
	 *     </container-element>
	 * ```
	 * \@description
	 *
	 * `NgSwitch` stamps out nested views when their match expression value matches the value of the
	 * switch expression.
	 *
	 * In other words:
	 * - you define a container element (where you place the directive with a switch expression on the
	 * `[ngSwitch]="..."` attribute)
	 * - you define inner views inside the `NgSwitch` and place a `*ngSwitchCase` attribute on the view
	 * root elements.
	 *
	 * Elements within `NgSwitch` but outside of a `NgSwitchCase` or `NgSwitchDefault` directives will
	 * be preserved at the location.
	 *
	 * The `ngSwitchCase` directive informs the parent `NgSwitch` of which view to display when the
	 * expression is evaluated.
	 * When no matching expression is found on a `ngSwitchCase` view, the `ngSwitchDefault` view is
	 * stamped out.
	 *
	 * \@stable
	 */
	var NgSwitch = /** @class */ (function () {
	    function NgSwitch() {
	        this._defaultUsed = false;
	        this._caseCount = 0;
	        this._lastCaseCheckIndex = 0;
	        this._lastCasesMatched = false;
	    }
	    Object.defineProperty(NgSwitch.prototype, "ngSwitch", {
	        set: /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        function (newValue) {
	            this._ngSwitch = newValue;
	            if (this._caseCount === 0) {
	                this._updateDefaultCases(true);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    NgSwitch.prototype._addCase = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { return this._caseCount++; };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} view
	     * @return {?}
	     */
	    NgSwitch.prototype._addDefault = /**
	     * \@internal
	     * @param {?} view
	     * @return {?}
	     */
	    function (view) {
	        if (!this._defaultViews) {
	            this._defaultViews = [];
	        }
	        this._defaultViews.push(view);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    NgSwitch.prototype._matchCase = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ matched = value == this._ngSwitch;
	        this._lastCasesMatched = this._lastCasesMatched || matched;
	        this._lastCaseCheckIndex++;
	        if (this._lastCaseCheckIndex === this._caseCount) {
	            this._updateDefaultCases(!this._lastCasesMatched);
	            this._lastCaseCheckIndex = 0;
	            this._lastCasesMatched = false;
	        }
	        return matched;
	    };
	    /**
	     * @param {?} useDefault
	     * @return {?}
	     */
	    NgSwitch.prototype._updateDefaultCases = /**
	     * @param {?} useDefault
	     * @return {?}
	     */
	    function (useDefault) {
	        if (this._defaultViews && useDefault !== this._defaultUsed) {
	            this._defaultUsed = useDefault;
	            for (var /** @type {?} */ i = 0; i < this._defaultViews.length; i++) {
	                var /** @type {?} */ defaultView = this._defaultViews[i];
	                defaultView.enforceState(useDefault);
	            }
	        }
	    };
	    NgSwitch.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngSwitch]' },] },
	    ];
	    /** @nocollapse */
	    NgSwitch.ctorParameters = function () { return []; };
	    NgSwitch.propDecorators = {
	        "ngSwitch": [{ type: _angular_core.Input },],
	    };
	    return NgSwitch;
	}());
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Creates a view that will be added/removed from the parent {\@link NgSwitch} when the
	 *             given expression evaluate to respectively the same/different value as the switch
	 *             expression.
	 *
	 * \@howToUse
	 * ```
	 * <container-element [ngSwitch]="switch_expression">
	 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
	 * </container-element>
	 * ```
	 * \@description
	 *
	 * Insert the sub-tree when the expression evaluates to the same value as the enclosing switch
	 * expression.
	 *
	 * If multiple match expressions match the switch expression value, all of them are displayed.
	 *
	 * See {\@link NgSwitch} for more details and example.
	 *
	 * \@stable
	 */
	var NgSwitchCase = /** @class */ (function () {
	    function NgSwitchCase(viewContainer, templateRef, ngSwitch) {
	        this.ngSwitch = ngSwitch;
	        ngSwitch._addCase();
	        this._view = new SwitchView(viewContainer, templateRef);
	    }
	    /**
	     * @return {?}
	     */
	    NgSwitchCase.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () { this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase)); };
	    NgSwitchCase.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngSwitchCase]' },] },
	    ];
	    /** @nocollapse */
	    NgSwitchCase.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.TemplateRef, },
	        { type: NgSwitch, decorators: [{ type: _angular_core.Host },] },
	    ]; };
	    NgSwitchCase.propDecorators = {
	        "ngSwitchCase": [{ type: _angular_core.Input },],
	    };
	    return NgSwitchCase;
	}());
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Creates a view that is added to the parent {\@link NgSwitch} when no case expressions
	 * match the
	 *             switch expression.
	 *
	 * \@howToUse
	 * ```
	 * <container-element [ngSwitch]="switch_expression">
	 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
	 *   <some-other-element *ngSwitchDefault>...</some-other-element>
	 * </container-element>
	 * ```
	 *
	 * \@description
	 *
	 * Insert the sub-tree when no case expressions evaluate to the same value as the enclosing switch
	 * expression.
	 *
	 * See {\@link NgSwitch} for more details and example.
	 *
	 * \@stable
	 */
	var NgSwitchDefault = /** @class */ (function () {
	    function NgSwitchDefault(viewContainer, templateRef, ngSwitch) {
	        ngSwitch._addDefault(new SwitchView(viewContainer, templateRef));
	    }
	    NgSwitchDefault.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngSwitchDefault]' },] },
	    ];
	    /** @nocollapse */
	    NgSwitchDefault.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.TemplateRef, },
	        { type: NgSwitch, decorators: [{ type: _angular_core.Host },] },
	    ]; };
	    return NgSwitchDefault;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Adds / removes DOM sub-trees based on a numeric value. Tailored for pluralization.
	 *
	 * \@howToUse
	 * ```
	 * <some-element [ngPlural]="value">
	 *   <ng-template ngPluralCase="=0">there is nothing</ng-template>
	 *   <ng-template ngPluralCase="=1">there is one</ng-template>
	 *   <ng-template ngPluralCase="few">there are a few</ng-template>
	 * </some-element>
	 * ```
	 *
	 * \@description
	 *
	 * Displays DOM sub-trees that match the switch expression value, or failing that, DOM sub-trees
	 * that match the switch expression's pluralization category.
	 *
	 * To use this directive you must provide a container element that sets the `[ngPlural]` attribute
	 * to a switch expression. Inner elements with a `[ngPluralCase]` will display based on their
	 * expression:
	 * - if `[ngPluralCase]` is set to a value starting with `=`, it will only display if the value
	 *   matches the switch expression exactly,
	 * - otherwise, the view will be treated as a "category match", and will only display if exact
	 *   value matches aren't found and the value maps to its category for the defined locale.
	 *
	 * See http://cldr.unicode.org/index/cldr-spec/plural-rules
	 *
	 * \@experimental
	 */
	var NgPlural = /** @class */ (function () {
	    function NgPlural(_localization) {
	        this._localization = _localization;
	        this._caseViews = {};
	    }
	    Object.defineProperty(NgPlural.prototype, "ngPlural", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._switchValue = value;
	            this._updateView();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} value
	     * @param {?} switchView
	     * @return {?}
	     */
	    NgPlural.prototype.addCase = /**
	     * @param {?} value
	     * @param {?} switchView
	     * @return {?}
	     */
	    function (value, switchView) { this._caseViews[value] = switchView; };
	    /**
	     * @return {?}
	     */
	    NgPlural.prototype._updateView = /**
	     * @return {?}
	     */
	    function () {
	        this._clearViews();
	        var /** @type {?} */ cases = Object.keys(this._caseViews);
	        var /** @type {?} */ key = getPluralCategory(this._switchValue, cases, this._localization);
	        this._activateView(this._caseViews[key]);
	    };
	    /**
	     * @return {?}
	     */
	    NgPlural.prototype._clearViews = /**
	     * @return {?}
	     */
	    function () {
	        if (this._activeView)
	            this._activeView.destroy();
	    };
	    /**
	     * @param {?} view
	     * @return {?}
	     */
	    NgPlural.prototype._activateView = /**
	     * @param {?} view
	     * @return {?}
	     */
	    function (view) {
	        if (view) {
	            this._activeView = view;
	            this._activeView.create();
	        }
	    };
	    NgPlural.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngPlural]' },] },
	    ];
	    /** @nocollapse */
	    NgPlural.ctorParameters = function () { return [
	        { type: NgLocalization, },
	    ]; };
	    NgPlural.propDecorators = {
	        "ngPlural": [{ type: _angular_core.Input },],
	    };
	    return NgPlural;
	}());
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Creates a view that will be added/removed from the parent {\@link NgPlural} when the
	 *             given expression matches the plural expression according to CLDR rules.
	 *
	 * \@howToUse
	 * ```
	 * <some-element [ngPlural]="value">
	 *   <ng-template ngPluralCase="=0">...</ng-template>
	 *   <ng-template ngPluralCase="other">...</ng-template>
	 * </some-element>
	 * ```
	 *
	 * See {\@link NgPlural} for more details and example.
	 *
	 * \@experimental
	 */
	var NgPluralCase = /** @class */ (function () {
	    function NgPluralCase(value, template, viewContainer, ngPlural) {
	        this.value = value;
	        var /** @type {?} */ isANumber = !isNaN(Number(value));
	        ngPlural.addCase(isANumber ? "=" + value : value, new SwitchView(viewContainer, template));
	    }
	    NgPluralCase.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngPluralCase]' },] },
	    ];
	    /** @nocollapse */
	    NgPluralCase.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['ngPluralCase',] },] },
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: NgPlural, decorators: [{ type: _angular_core.Host },] },
	    ]; };
	    return NgPluralCase;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Update an HTML element styles.
	 *
	 * \@howToUse
	 * ```
	 * <some-element [ngStyle]="{'font-style': styleExp}">...</some-element>
	 *
	 * <some-element [ngStyle]="{'max-width.px': widthExp}">...</some-element>
	 *
	 * <some-element [ngStyle]="objExp">...</some-element>
	 * ```
	 *
	 * \@description
	 *
	 * The styles are updated according to the value of the expression evaluation:
	 * - keys are style names with an optional `.<unit>` suffix (ie 'top.px', 'font-style.em'),
	 * - values are the values assigned to those properties (expressed in the given unit).
	 *
	 * \@stable
	 */
	var NgStyle = /** @class */ (function () {
	    function NgStyle(_differs, _ngEl, _renderer) {
	        this._differs = _differs;
	        this._ngEl = _ngEl;
	        this._renderer = _renderer;
	    }
	    Object.defineProperty(NgStyle.prototype, "ngStyle", {
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._ngStyle = v;
	            if (!this._differ && v) {
	                this._differ = this._differs.find(v).create();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    NgStyle.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._differ) {
	            var /** @type {?} */ changes = this._differ.diff(this._ngStyle);
	            if (changes) {
	                this._applyChanges(changes);
	            }
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgStyle.prototype._applyChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        changes.forEachRemovedItem(function (record) { return _this._setStyle(record.key, null); });
	        changes.forEachAddedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
	        changes.forEachChangedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
	    };
	    /**
	     * @param {?} nameAndUnit
	     * @param {?} value
	     * @return {?}
	     */
	    NgStyle.prototype._setStyle = /**
	     * @param {?} nameAndUnit
	     * @param {?} value
	     * @return {?}
	     */
	    function (nameAndUnit, value) {
	        var _a = nameAndUnit.split('.'), name = _a[0], unit = _a[1];
	        value = value != null && unit ? "" + value + unit : value;
	        if (value != null) {
	            this._renderer.setStyle(this._ngEl.nativeElement, name, /** @type {?} */ (value));
	        }
	        else {
	            this._renderer.removeStyle(this._ngEl.nativeElement, name);
	        }
	    };
	    NgStyle.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngStyle]' },] },
	    ];
	    /** @nocollapse */
	    NgStyle.ctorParameters = function () { return [
	        { type: _angular_core.KeyValueDiffers, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.Renderer2, },
	    ]; };
	    NgStyle.propDecorators = {
	        "ngStyle": [{ type: _angular_core.Input },],
	    };
	    return NgStyle;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 *
	 * \@whatItDoes Inserts an embedded view from a prepared `TemplateRef`
	 *
	 * \@howToUse
	 * ```
	 * <ng-container *ngTemplateOutlet="templateRefExp; context: contextExp"></ng-container>
	 * ```
	 *
	 * \@description
	 *
	 * You can attach a context object to the `EmbeddedViewRef` by setting `[ngTemplateOutletContext]`.
	 * `[ngTemplateOutletContext]` should be an object, the object's keys will be available for binding
	 * by the local template `let` declarations.
	 *
	 * Note: using the key `$implicit` in the context object will set its value as default.
	 *
	 * ## Example
	 *
	 * {\@example common/ngTemplateOutlet/ts/module.ts region='NgTemplateOutlet'}
	 *
	 * \@stable
	 */
	var NgTemplateOutlet = /** @class */ (function () {
	    function NgTemplateOutlet(_viewContainerRef) {
	        this._viewContainerRef = _viewContainerRef;
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgTemplateOutlet.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var /** @type {?} */ recreateView = this._shouldRecreateView(changes);
	        if (recreateView) {
	            if (this._viewRef) {
	                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
	            }
	            if (this.ngTemplateOutlet) {
	                this._viewRef = this._viewContainerRef.createEmbeddedView(this.ngTemplateOutlet, this.ngTemplateOutletContext);
	            }
	        }
	        else {
	            if (this._viewRef && this.ngTemplateOutletContext) {
	                this._updateExistingContext(this.ngTemplateOutletContext);
	            }
	        }
	    };
	    /**
	     * We need to re-create existing embedded view if:
	     * - templateRef has changed
	     * - context has changes
	     *
	     * We mark context object as changed when the corresponding object
	     * shape changes (new properties are added or existing properties are removed).
	     * In other words we consider context with the same properties as "the same" even
	     * if object reference changes (see https://github.com/angular/angular/issues/13407).
	     * @param {?} changes
	     * @return {?}
	     */
	    NgTemplateOutlet.prototype._shouldRecreateView = /**
	     * We need to re-create existing embedded view if:
	     * - templateRef has changed
	     * - context has changes
	     *
	     * We mark context object as changed when the corresponding object
	     * shape changes (new properties are added or existing properties are removed).
	     * In other words we consider context with the same properties as "the same" even
	     * if object reference changes (see https://github.com/angular/angular/issues/13407).
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var /** @type {?} */ ctxChange = changes['ngTemplateOutletContext'];
	        return !!changes['ngTemplateOutlet'] || (ctxChange && this._hasContextShapeChanged(ctxChange));
	    };
	    /**
	     * @param {?} ctxChange
	     * @return {?}
	     */
	    NgTemplateOutlet.prototype._hasContextShapeChanged = /**
	     * @param {?} ctxChange
	     * @return {?}
	     */
	    function (ctxChange) {
	        var /** @type {?} */ prevCtxKeys = Object.keys(ctxChange.previousValue || {});
	        var /** @type {?} */ currCtxKeys = Object.keys(ctxChange.currentValue || {});
	        if (prevCtxKeys.length === currCtxKeys.length) {
	            for (var _i = 0, currCtxKeys_1 = currCtxKeys; _i < currCtxKeys_1.length; _i++) {
	                var propName = currCtxKeys_1[_i];
	                if (prevCtxKeys.indexOf(propName) === -1) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * @param {?} ctx
	     * @return {?}
	     */
	    NgTemplateOutlet.prototype._updateExistingContext = /**
	     * @param {?} ctx
	     * @return {?}
	     */
	    function (ctx) {
	        for (var _i = 0, _a = Object.keys(ctx); _i < _a.length; _i++) {
	            var propName = _a[_i];
	            (/** @type {?} */ (this._viewRef.context))[propName] = (/** @type {?} */ (this.ngTemplateOutletContext))[propName];
	        }
	    };
	    NgTemplateOutlet.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngTemplateOutlet]' },] },
	    ];
	    /** @nocollapse */
	    NgTemplateOutlet.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    NgTemplateOutlet.propDecorators = {
	        "ngTemplateOutletContext": [{ type: _angular_core.Input },],
	        "ngTemplateOutlet": [{ type: _angular_core.Input },],
	    };
	    return NgTemplateOutlet;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A collection of Angular directives that are likely to be used in each and every Angular
	 * application.
	 */
	var COMMON_DIRECTIVES = [
	    NgClass,
	    NgComponentOutlet,
	    NgForOf,
	    NgIf,
	    NgTemplateOutlet,
	    NgStyle,
	    NgSwitch,
	    NgSwitchCase,
	    NgSwitchDefault,
	    NgPlural,
	    NgPluralCase,
	];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NAMED_FORMATS = {};
	var DATE_FORMATS_SPLIT = /((?:[^GyMLwWdEabBhHmsSzZO']+)|(?:'(?:[^']|'')*')|(?:G{1,5}|y{1,4}|M{1,5}|L{1,5}|w{1,2}|W{1}|d{1,2}|E{1,6}|a{1,5}|b{1,5}|B{1,5}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|O{1,4}))([\s\S]*)/;
	/** @enum {number} */
	var ZoneWidth = {
	    Short: 0,
	    ShortGMT: 1,
	    Long: 2,
	    Extended: 3,
	};
	ZoneWidth[ZoneWidth.Short] = "Short";
	ZoneWidth[ZoneWidth.ShortGMT] = "ShortGMT";
	ZoneWidth[ZoneWidth.Long] = "Long";
	ZoneWidth[ZoneWidth.Extended] = "Extended";
	/** @enum {number} */
	var DateType = {
	    FullYear: 0,
	    Month: 1,
	    Date: 2,
	    Hours: 3,
	    Minutes: 4,
	    Seconds: 5,
	    Milliseconds: 6,
	    Day: 7,
	};
	DateType[DateType.FullYear] = "FullYear";
	DateType[DateType.Month] = "Month";
	DateType[DateType.Date] = "Date";
	DateType[DateType.Hours] = "Hours";
	DateType[DateType.Minutes] = "Minutes";
	DateType[DateType.Seconds] = "Seconds";
	DateType[DateType.Milliseconds] = "Milliseconds";
	DateType[DateType.Day] = "Day";
	/** @enum {number} */
	var TranslationType = {
	    DayPeriods: 0,
	    Days: 1,
	    Months: 2,
	    Eras: 3,
	};
	TranslationType[TranslationType.DayPeriods] = "DayPeriods";
	TranslationType[TranslationType.Days] = "Days";
	TranslationType[TranslationType.Months] = "Months";
	TranslationType[TranslationType.Eras] = "Eras";
	/**
	 * Transforms a date to a locale string based on a pattern and a timezone
	 *
	 * \@internal
	 * @param {?} date
	 * @param {?} format
	 * @param {?} locale
	 * @param {?=} timezone
	 * @return {?}
	 */
	function formatDate(date, format, locale, timezone) {
	    var /** @type {?} */ namedFormat = getNamedFormat(locale, format);
	    format = namedFormat || format;
	    var /** @type {?} */ parts = [];
	    var /** @type {?} */ match;
	    while (format) {
	        match = DATE_FORMATS_SPLIT.exec(format);
	        if (match) {
	            parts = parts.concat(match.slice(1));
	            var /** @type {?} */ part = parts.pop();
	            if (!part) {
	                break;
	            }
	            format = part;
	        }
	        else {
	            parts.push(format);
	            break;
	        }
	    }
	    var /** @type {?} */ dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	        date = convertTimezoneToLocal(date, timezone, true);
	    }
	    var /** @type {?} */ text = '';
	    parts.forEach(function (value) {
	        var /** @type {?} */ dateFormatter = getDateFormatter(value);
	        text += dateFormatter ?
	            dateFormatter(date, locale, dateTimezoneOffset) :
	            value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	    return text;
	}
	/**
	 * @param {?} locale
	 * @param {?} format
	 * @return {?}
	 */
	function getNamedFormat(locale, format) {
	    var /** @type {?} */ localeId = getLocaleId(locale);
	    NAMED_FORMATS[localeId] = NAMED_FORMATS[localeId] || {};
	    if (NAMED_FORMATS[localeId][format]) {
	        return NAMED_FORMATS[localeId][format];
	    }
	    var /** @type {?} */ formatValue = '';
	    switch (format) {
	        case 'shortDate':
	            formatValue = getLocaleDateFormat(locale, FormatWidth.Short);
	            break;
	        case 'mediumDate':
	            formatValue = getLocaleDateFormat(locale, FormatWidth.Medium);
	            break;
	        case 'longDate':
	            formatValue = getLocaleDateFormat(locale, FormatWidth.Long);
	            break;
	        case 'fullDate':
	            formatValue = getLocaleDateFormat(locale, FormatWidth.Full);
	            break;
	        case 'shortTime':
	            formatValue = getLocaleTimeFormat(locale, FormatWidth.Short);
	            break;
	        case 'mediumTime':
	            formatValue = getLocaleTimeFormat(locale, FormatWidth.Medium);
	            break;
	        case 'longTime':
	            formatValue = getLocaleTimeFormat(locale, FormatWidth.Long);
	            break;
	        case 'fullTime':
	            formatValue = getLocaleTimeFormat(locale, FormatWidth.Full);
	            break;
	        case 'short':
	            var /** @type {?} */ shortTime = getNamedFormat(locale, 'shortTime');
	            var /** @type {?} */ shortDate = getNamedFormat(locale, 'shortDate');
	            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Short), [shortTime, shortDate]);
	            break;
	        case 'medium':
	            var /** @type {?} */ mediumTime = getNamedFormat(locale, 'mediumTime');
	            var /** @type {?} */ mediumDate = getNamedFormat(locale, 'mediumDate');
	            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Medium), [mediumTime, mediumDate]);
	            break;
	        case 'long':
	            var /** @type {?} */ longTime = getNamedFormat(locale, 'longTime');
	            var /** @type {?} */ longDate = getNamedFormat(locale, 'longDate');
	            formatValue =
	                formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Long), [longTime, longDate]);
	            break;
	        case 'full':
	            var /** @type {?} */ fullTime = getNamedFormat(locale, 'fullTime');
	            var /** @type {?} */ fullDate = getNamedFormat(locale, 'fullDate');
	            formatValue =
	                formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Full), [fullTime, fullDate]);
	            break;
	    }
	    if (formatValue) {
	        NAMED_FORMATS[localeId][format] = formatValue;
	    }
	    return formatValue;
	}
	/**
	 * @param {?} str
	 * @param {?} opt_values
	 * @return {?}
	 */
	function formatDateTime(str, opt_values) {
	    if (opt_values) {
	        str = str.replace(/\{([^}]+)}/g, function (match, key) {
	            return (opt_values != null && key in opt_values) ? opt_values[key] : match;
	        });
	    }
	    return str;
	}
	/**
	 * @param {?} num
	 * @param {?} digits
	 * @param {?=} minusSign
	 * @param {?=} trim
	 * @param {?=} negWrap
	 * @return {?}
	 */
	function padNumber(num, digits, minusSign, trim, negWrap) {
	    if (minusSign === void 0) { minusSign = '-'; }
	    var /** @type {?} */ neg = '';
	    if (num < 0 || (negWrap && num <= 0)) {
	        if (negWrap) {
	            num = -num + 1;
	        }
	        else {
	            num = -num;
	            neg = minusSign;
	        }
	    }
	    var /** @type {?} */ strNum = '' + num;
	    while (strNum.length < digits)
	        strNum = '0' + strNum;
	    if (trim) {
	        strNum = strNum.substr(strNum.length - digits);
	    }
	    return neg + strNum;
	}
	/**
	 * Returns a date formatter that transforms a date into its locale digit representation
	 * @param {?} name
	 * @param {?} size
	 * @param {?=} offset
	 * @param {?=} trim
	 * @param {?=} negWrap
	 * @return {?}
	 */
	function dateGetter(name, size, offset, trim, negWrap) {
	    if (offset === void 0) { offset = 0; }
	    if (trim === void 0) { trim = false; }
	    if (negWrap === void 0) { negWrap = false; }
	    return function (date, locale) {
	        var /** @type {?} */ part = getDatePart(name, date, size);
	        if (offset > 0 || part > -offset) {
	            part += offset;
	        }
	        if (name === DateType.Hours && part === 0 && offset === -12) {
	            part = 12;
	        }
	        return padNumber(part, size, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign), trim, negWrap);
	    };
	}
	/**
	 * @param {?} name
	 * @param {?} date
	 * @param {?} size
	 * @return {?}
	 */
	function getDatePart(name, date, size) {
	    switch (name) {
	        case DateType.FullYear:
	            return date.getFullYear();
	        case DateType.Month:
	            return date.getMonth();
	        case DateType.Date:
	            return date.getDate();
	        case DateType.Hours:
	            return date.getHours();
	        case DateType.Minutes:
	            return date.getMinutes();
	        case DateType.Seconds:
	            return date.getSeconds();
	        case DateType.Milliseconds:
	            var /** @type {?} */ div = size === 1 ? 100 : (size === 2 ? 10 : 1);
	            return Math.round(date.getMilliseconds() / div);
	        case DateType.Day:
	            return date.getDay();
	        default:
	            throw new Error("Unknown DateType value \"" + name + "\".");
	    }
	}
	/**
	 * Returns a date formatter that transforms a date into its locale string representation
	 * @param {?} name
	 * @param {?} width
	 * @param {?=} form
	 * @param {?=} extended
	 * @return {?}
	 */
	function dateStrGetter(name, width, form, extended) {
	    if (form === void 0) { form = FormStyle.Format; }
	    if (extended === void 0) { extended = false; }
	    return function (date, locale) {
	        return getDateTranslation(date, locale, name, width, form, extended);
	    };
	}
	/**
	 * Returns the locale translation of a date for a given form, type and width
	 * @param {?} date
	 * @param {?} locale
	 * @param {?} name
	 * @param {?} width
	 * @param {?} form
	 * @param {?} extended
	 * @return {?}
	 */
	function getDateTranslation(date, locale, name, width, form, extended) {
	    switch (name) {
	        case TranslationType.Months:
	            return getLocaleMonthNames(locale, form, width)[date.getMonth()];
	        case TranslationType.Days:
	            return getLocaleDayNames(locale, form, width)[date.getDay()];
	        case TranslationType.DayPeriods:
	            var /** @type {?} */ currentHours_1 = date.getHours();
	            var /** @type {?} */ currentMinutes_1 = date.getMinutes();
	            if (extended) {
	                var /** @type {?} */ rules = getLocaleExtraDayPeriodRules(locale);
	                var /** @type {?} */ dayPeriods_1 = getLocaleExtraDayPeriods(locale, form, width);
	                var /** @type {?} */ result_1;
	                rules.forEach(function (rule, index) {
	                    if (Array.isArray(rule)) {
	                        // morning, afternoon, evening, night
	                        var _a = rule[0], hoursFrom = _a.hours, minutesFrom = _a.minutes;
	                        var _b = rule[1], hoursTo = _b.hours, minutesTo = _b.minutes;
	                        if (currentHours_1 >= hoursFrom && currentMinutes_1 >= minutesFrom &&
	                            (currentHours_1 < hoursTo ||
	                                (currentHours_1 === hoursTo && currentMinutes_1 < minutesTo))) {
	                            result_1 = dayPeriods_1[index];
	                        }
	                    }
	                    else {
	                        // noon or midnight
	                        var hours = rule.hours, minutes = rule.minutes;
	                        if (hours === currentHours_1 && minutes === currentMinutes_1) {
	                            result_1 = dayPeriods_1[index];
	                        }
	                    }
	                });
	                if (result_1) {
	                    return result_1;
	                }
	            }
	            // if no rules for the day periods, we use am/pm by default
	            return getLocaleDayPeriods(locale, form, /** @type {?} */ (width))[currentHours_1 < 12 ? 0 : 1];
	        case TranslationType.Eras:
	            return getLocaleEraNames(locale, /** @type {?} */ (width))[date.getFullYear() <= 0 ? 0 : 1];
	        default:
	            // This default case is not needed by TypeScript compiler, as the switch is exhaustive.
	            // However Closure Compiler does not understand that and reports an error in typed mode.
	            // The `throw new Error` below works around the problem, and the unexpected: never variable
	            // makes sure tsc still checks this code is unreachable.
	            var /** @type {?} */ unexpected = name;
	            throw new Error("unexpected translation type " + unexpected);
	    }
	}
	/**
	 * Returns a date formatter that transforms a date and an offset into a timezone with ISO8601 or
	 * GMT format depending on the width (eg: short = +0430, short:GMT = GMT+4, long = GMT+04:30,
	 * extended = +04:30)
	 * @param {?} width
	 * @return {?}
	 */
	function timeZoneGetter(width) {
	    return function (date, locale, offset) {
	        var /** @type {?} */ zone = -1 * offset;
	        var /** @type {?} */ minusSign = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
	        var /** @type {?} */ hours = zone > 0 ? Math.floor(zone / 60) : Math.ceil(zone / 60);
	        switch (width) {
	            case ZoneWidth.Short:
	                return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) +
	                    padNumber(Math.abs(zone % 60), 2, minusSign);
	            case ZoneWidth.ShortGMT:
	                return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 1, minusSign);
	            case ZoneWidth.Long:
	                return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
	                    padNumber(Math.abs(zone % 60), 2, minusSign);
	            case ZoneWidth.Extended:
	                if (offset === 0) {
	                    return 'Z';
	                }
	                else {
	                    return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
	                        padNumber(Math.abs(zone % 60), 2, minusSign);
	                }
	            default:
	                throw new Error("Unknown zone width \"" + width + "\"");
	        }
	    };
	}
	var JANUARY = 0;
	var THURSDAY = 4;
	/**
	 * @param {?} year
	 * @return {?}
	 */
	function getFirstThursdayOfYear(year) {
	    var /** @type {?} */ firstDayOfYear = (new Date(year, JANUARY, 1)).getDay();
	    return new Date(year, 0, 1 + ((firstDayOfYear <= THURSDAY) ? THURSDAY : THURSDAY + 7) - firstDayOfYear);
	}
	/**
	 * @param {?} datetime
	 * @return {?}
	 */
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate() + (THURSDAY - datetime.getDay()));
	}
	/**
	 * @param {?} size
	 * @param {?=} monthBased
	 * @return {?}
	 */
	function weekGetter(size, monthBased) {
	    if (monthBased === void 0) { monthBased = false; }
	    return function (date, locale) {
	        var /** @type {?} */ result;
	        if (monthBased) {
	            var /** @type {?} */ nbDaysBefore1stDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay() - 1;
	            var /** @type {?} */ today = date.getDate();
	            result = 1 + Math.floor((today + nbDaysBefore1stDayOfMonth) / 7);
	        }
	        else {
	            var /** @type {?} */ firstThurs = getFirstThursdayOfYear(date.getFullYear());
	            var /** @type {?} */ thisThurs = getThursdayThisWeek(date);
	            var /** @type {?} */ diff = thisThurs.getTime() - firstThurs.getTime();
	            result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	        }
	        return padNumber(result, size, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
	    };
	}
	var DATE_FORMATS = {};
	/**
	 * @param {?} format
	 * @return {?}
	 */
	function getDateFormatter(format) {
	    if (DATE_FORMATS[format]) {
	        return DATE_FORMATS[format];
	    }
	    var /** @type {?} */ formatter;
	    switch (format) {
	        // Era name (AD/BC)
	        case 'G':
	        case 'GG':
	        case 'GGG':
	            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Abbreviated);
	            break;
	        case 'GGGG':
	            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Wide);
	            break;
	        case 'GGGGG':
	            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Narrow);
	            break;
	        // 1 digit representation of the year, e.g. (AD 1 => 1, AD 199 => 199)
	        case 'y':
	            formatter = dateGetter(DateType.FullYear, 1, 0, false, true);
	            break;
	        // 2 digit representation of the year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	        case 'yy':
	            formatter = dateGetter(DateType.FullYear, 2, 0, true, true);
	            break;
	        // 3 digit representation of the year, padded (000-999). (e.g. AD 2001 => 01, AD 2010 => 10)
	        case 'yyy':
	            formatter = dateGetter(DateType.FullYear, 3, 0, false, true);
	            break;
	        // 4 digit representation of the year (e.g. AD 1 => 0001, AD 2010 => 2010)
	        case 'yyyy':
	            formatter = dateGetter(DateType.FullYear, 4, 0, false, true);
	            break;
	        // Month of the year (1-12), numeric
	        case 'M':
	        case 'L':
	            formatter = dateGetter(DateType.Month, 1, 1);
	            break;
	        case 'MM':
	        case 'LL':
	            formatter = dateGetter(DateType.Month, 2, 1);
	            break;
	        // Month of the year (January, ...), string, format
	        case 'MMM':
	            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated);
	            break;
	        case 'MMMM':
	            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Wide);
	            break;
	        case 'MMMMM':
	            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Narrow);
	            break;
	        // Month of the year (January, ...), string, standalone
	        case 'LLL':
	            formatter =
	                dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated, FormStyle.Standalone);
	            break;
	        case 'LLLL':
	            formatter =
	                dateStrGetter(TranslationType.Months, TranslationWidth.Wide, FormStyle.Standalone);
	            break;
	        case 'LLLLL':
	            formatter =
	                dateStrGetter(TranslationType.Months, TranslationWidth.Narrow, FormStyle.Standalone);
	            break;
	        // Week of the year (1, ... 52)
	        case 'w':
	            formatter = weekGetter(1);
	            break;
	        case 'ww':
	            formatter = weekGetter(2);
	            break;
	        // Week of the month (1, ...)
	        case 'W':
	            formatter = weekGetter(1, true);
	            break;
	        // Day of the month (1-31)
	        case 'd':
	            formatter = dateGetter(DateType.Date, 1);
	            break;
	        case 'dd':
	            formatter = dateGetter(DateType.Date, 2);
	            break;
	        // Day of the Week
	        case 'E':
	        case 'EE':
	        case 'EEE':
	            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Abbreviated);
	            break;
	        case 'EEEE':
	            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Wide);
	            break;
	        case 'EEEEE':
	            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Narrow);
	            break;
	        case 'EEEEEE':
	            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Short);
	            break;
	        // Generic period of the day (am-pm)
	        case 'a':
	        case 'aa':
	        case 'aaa':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated);
	            break;
	        case 'aaaa':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide);
	            break;
	        case 'aaaaa':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow);
	            break;
	        // Extended period of the day (midnight, at night, ...), standalone
	        case 'b':
	        case 'bb':
	        case 'bbb':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Standalone, true);
	            break;
	        case 'bbbb':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Standalone, true);
	            break;
	        case 'bbbbb':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Standalone, true);
	            break;
	        // Extended period of the day (midnight, night, ...), standalone
	        case 'B':
	        case 'BB':
	        case 'BBB':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Format, true);
	            break;
	        case 'BBBB':
	            formatter =
	                dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Format, true);
	            break;
	        case 'BBBBB':
	            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Format, true);
	            break;
	        // Hour in AM/PM, (1-12)
	        case 'h':
	            formatter = dateGetter(DateType.Hours, 1, -12);
	            break;
	        case 'hh':
	            formatter = dateGetter(DateType.Hours, 2, -12);
	            break;
	        // Hour of the day (0-23)
	        case 'H':
	            formatter = dateGetter(DateType.Hours, 1);
	            break;
	        // Hour in day, padded (00-23)
	        case 'HH':
	            formatter = dateGetter(DateType.Hours, 2);
	            break;
	        // Minute of the hour (0-59)
	        case 'm':
	            formatter = dateGetter(DateType.Minutes, 1);
	            break;
	        case 'mm':
	            formatter = dateGetter(DateType.Minutes, 2);
	            break;
	        // Second of the minute (0-59)
	        case 's':
	            formatter = dateGetter(DateType.Seconds, 1);
	            break;
	        case 'ss':
	            formatter = dateGetter(DateType.Seconds, 2);
	            break;
	        // Fractional second padded (0-9)
	        case 'S':
	            formatter = dateGetter(DateType.Milliseconds, 1);
	            break;
	        case 'SS':
	            formatter = dateGetter(DateType.Milliseconds, 2);
	            break;
	        // = millisecond
	        case 'SSS':
	            formatter = dateGetter(DateType.Milliseconds, 3);
	            break;
	        // Timezone ISO8601 short format (-0430)
	        case 'Z':
	        case 'ZZ':
	        case 'ZZZ':
	            formatter = timeZoneGetter(ZoneWidth.Short);
	            break;
	        // Timezone ISO8601 extended format (-04:30)
	        case 'ZZZZZ':
	            formatter = timeZoneGetter(ZoneWidth.Extended);
	            break;
	        // Timezone GMT short format (GMT+4)
	        case 'O':
	        case 'OO':
	        case 'OOO':
	        // Should be location, but fallback to format O instead because we don't have the data yet
	        case 'z':
	        case 'zz':
	        case 'zzz':
	            formatter = timeZoneGetter(ZoneWidth.ShortGMT);
	            break;
	        // Timezone GMT long format (GMT+0430)
	        case 'OOOO':
	        case 'ZZZZ':
	        // Should be location, but fallback to format O instead because we don't have the data yet
	        case 'zzzz':
	            formatter = timeZoneGetter(ZoneWidth.Long);
	            break;
	        default:
	            return null;
	    }
	    DATE_FORMATS[format] = formatter;
	    return formatter;
	}
	/**
	 * @param {?} timezone
	 * @param {?} fallback
	 * @return {?}
	 */
	function timezoneToOffset(timezone, fallback) {
	    // Support: IE 9-11 only, Edge 13-15+
	    // IE/Edge do not "understand" colon (`:`) in timezone
	    timezone = timezone.replace(/:/g, '');
	    var /** @type {?} */ requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	/**
	 * @param {?} date
	 * @param {?} minutes
	 * @return {?}
	 */
	function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	}
	/**
	 * @param {?} date
	 * @param {?} timezone
	 * @param {?} reverse
	 * @return {?}
	 */
	function convertTimezoneToLocal(date, timezone, reverse) {
	    var /** @type {?} */ reverseValue = reverse ? -1 : 1;
	    var /** @type {?} */ dateTimezoneOffset = date.getTimezoneOffset();
	    var /** @type {?} */ timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverseValue * (timezoneOffset - dateTimezoneOffset));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} type
	 * @param {?} value
	 * @return {?}
	 */
	function invalidPipeArgumentError(type, value) {
	    return Error("InvalidPipeArgument: '" + value + "' for pipe '" + _angular_core.ɵstringify(type) + "'");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ISO8601_DATE_REGEX = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a date according to locale rules.
	 * \@howToUse `date_expression | date[:format[:timezone[:locale]]]`
	 * \@description
	 *
	 * Where:
	 * - `expression` is a date object or a number (milliseconds since UTC epoch) or an ISO string
	 * (https://www.w3.org/TR/NOTE-datetime).
	 * - `format` indicates which date/time components to include. The format can be predefined as
	 *   shown below (all examples are given for `en-US`) or custom as shown in the table.
	 *   - `'short'`: equivalent to `'M/d/yy, h:mm a'` (e.g. `6/15/15, 9:03 AM`)
	 *   - `'medium'`: equivalent to `'MMM d, y, h:mm:ss a'` (e.g. `Jun 15, 2015, 9:03:01 AM`)
	 *   - `'long'`: equivalent to `'MMMM d, y, h:mm:ss a z'` (e.g. `June 15, 2015 at 9:03:01 AM GMT+1`)
	 *   - `'full'`: equivalent to `'EEEE, MMMM d, y, h:mm:ss a zzzz'` (e.g. `Monday, June 15, 2015 at
	 * 9:03:01 AM GMT+01:00`)
	 *   - `'shortDate'`: equivalent to `'M/d/yy'` (e.g. `6/15/15`)
	 *   - `'mediumDate'`: equivalent to `'MMM d, y'` (e.g. `Jun 15, 2015`)
	 *   - `'longDate'`: equivalent to `'MMMM d, y'` (e.g. `June 15, 2015`)
	 *   - `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` (e.g. `Monday, June 15, 2015`)
	 *   - `'shortTime'`: equivalent to `'h:mm a'` (e.g. `9:03 AM`)
	 *   - `'mediumTime'`: equivalent to `'h:mm:ss a'` (e.g. `9:03:01 AM`)
	 *   - `'longTime'`: equivalent to `'h:mm:ss a z'` (e.g. `9:03:01 AM GMT+1`)
	 *   - `'fullTime'`: equivalent to `'h:mm:ss a zzzz'` (e.g. `9:03:01 AM GMT+01:00`)
	 *  - `timezone` to be used for formatting. It understands UTC/GMT and the continental US time zone
	 *  abbreviations, but for general use, use a time zone offset, for example,
	 *  `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *  If not specified, the local system timezone of the end-user's browser will be used.
	 *  - `locale` is a `string` defining the locale to use (uses the current {\@link LOCALE_ID} by
	 * default)
	 *
	 *
	 *  | Field Type         | Format      | Description                                                   | Example Value                                              |
	 *  |--------------------|-------------|---------------------------------------------------------------|------------------------------------------------------------|
	 *  | Era                | G, GG & GGG | Abbreviated                                                   | AD                                                         |
	 *  |                    | GGGG        | Wide                                                          | Anno Domini                                                |
	 *  |                    | GGGGG       | Narrow                                                        | A                                                          |
	 *  | Year               | y           | Numeric: minimum digits                                       | 2, 20, 201, 2017, 20173                                    |
	 *  |                    | yy          | Numeric: 2 digits + zero padded                               | 02, 20, 01, 17, 73                                         |
	 *  |                    | yyy         | Numeric: 3 digits + zero padded                               | 002, 020, 201, 2017, 20173                                 |
	 *  |                    | yyyy        | Numeric: 4 digits or more + zero padded                       | 0002, 0020, 0201, 2017, 20173                              |
	 *  | Month              | M           | Numeric: 1 digit                                              | 9, 12                                                      |
	 *  |                    | MM          | Numeric: 2 digits + zero padded                               | 09, 12                                                     |
	 *  |                    | MMM         | Abbreviated                                                   | Sep                                                        |
	 *  |                    | MMMM        | Wide                                                          | September                                                  |
	 *  |                    | MMMMM       | Narrow                                                        | S                                                          |
	 *  | Month standalone   | L           | Numeric: 1 digit                                              | 9, 12                                                      |
	 *  |                    | LL          | Numeric: 2 digits + zero padded                               | 09, 12                                                     |
	 *  |                    | LLL         | Abbreviated                                                   | Sep                                                        |
	 *  |                    | LLLL        | Wide                                                          | September                                                  |
	 *  |                    | LLLLL       | Narrow                                                        | S                                                          |
	 *  | Week of year       | w           | Numeric: minimum digits                                       | 1... 53                                                    |
	 *  |                    | ww          | Numeric: 2 digits + zero padded                               | 01... 53                                                   |
	 *  | Week of month      | W           | Numeric: 1 digit                                              | 1... 5                                                     |
	 *  | Day of month       | d           | Numeric: minimum digits                                       | 1                                                          |
	 *  |                    | dd          | Numeric: 2 digits + zero padded                               | 01                                                          |
	 *  | Week day           | E, EE & EEE | Abbreviated                                                   | Tue                                                        |
	 *  |                    | EEEE        | Wide                                                          | Tuesday                                                    |
	 *  |                    | EEEEE       | Narrow                                                        | T                                                          |
	 *  |                    | EEEEEE      | Short                                                         | Tu                                                         |
	 *  | Period             | a, aa & aaa | Abbreviated                                                   | am/pm or AM/PM                                             |
	 *  |                    | aaaa        | Wide (fallback to `a` when missing)                           | ante meridiem/post meridiem                                |
	 *  |                    | aaaaa       | Narrow                                                        | a/p                                                        |
	 *  | Period*            | B, BB & BBB | Abbreviated                                                   | mid.                                                       |
	 *  |                    | BBBB        | Wide                                                          | am, pm, midnight, noon, morning, afternoon, evening, night |
	 *  |                    | BBBBB       | Narrow                                                        | md                                                         |
	 *  | Period standalone* | b, bb & bbb | Abbreviated                                                   | mid.                                                       |
	 *  |                    | bbbb        | Wide                                                          | am, pm, midnight, noon, morning, afternoon, evening, night |
	 *  |                    | bbbbb       | Narrow                                                        | md                                                         |
	 *  | Hour 1-12          | h           | Numeric: minimum digits                                       | 1, 12                                                      |
	 *  |                    | hh          | Numeric: 2 digits + zero padded                               | 01, 12                                                     |
	 *  | Hour 0-23          | H           | Numeric: minimum digits                                       | 0, 23                                                      |
	 *  |                    | HH          | Numeric: 2 digits + zero padded                               | 00, 23                                                     |
	 *  | Minute             | m           | Numeric: minimum digits                                       | 8, 59                                                      |
	 *  |                    | mm          | Numeric: 2 digits + zero padded                               | 08, 59                                                     |
	 *  | Second             | s           | Numeric: minimum digits                                       | 0... 59                                                    |
	 *  |                    | ss          | Numeric: 2 digits + zero padded                               | 00... 59                                                   |
	 *  | Fractional seconds | S           | Numeric: 1 digit                                              | 0... 9                                                     |
	 *  |                    | SS          | Numeric: 2 digits + zero padded                               | 00... 99                                                   |
	 *  |                    | SSS         | Numeric: 3 digits + zero padded (= milliseconds)              | 000... 999                                                 |
	 *  | Zone               | z, zz & zzz | Short specific non location format (fallback to O)            | GMT-8                                                      |
	 *  |                    | zzzz        | Long specific non location format (fallback to OOOO)          | GMT-08:00                                                  |
	 *  |                    | Z, ZZ & ZZZ | ISO8601 basic format                                          | -0800                                                      |
	 *  |                    | ZZZZ        | Long localized GMT format                                     | GMT-8:00                                                   |
	 *  |                    | ZZZZZ       | ISO8601 extended format + Z indicator for offset 0 (= XXXXX)  | -08:00                                                     |
	 *  |                    | O, OO & OOO | Short localized GMT format                                    | GMT-8                                                      |
	 *  |                    | OOOO        | Long localized GMT format                                     | GMT-08:00                                                  |
	 *
	 *
	 * When the expression is a ISO string without time (e.g. 2016-09-19) the time zone offset is not
	 * applied and the formatted text will have the same day, month and year of the expression.
	 *
	 * WARNINGS:
	 * - this pipe has only access to en-US locale data by default. If you want to localize the dates
	 *   in another language, you will have to import data for other locales.
	 *   See the {\@linkDocs guide/i18n#i18n-pipes "I18n guide"} to know how to import additional locale
	 *   data.
	 * - Fields suffixed with * are only available in the extra dataset.
	 *   See the {\@linkDocs guide/i18n#i18n-pipes "I18n guide"} to know how to import extra locale
	 *   data.
	 * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
	 *   Instead users should treat the date as an immutable object and change the reference when the
	 *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
	 *   which would be an expensive operation).
	 *
	 * ### Examples
	 *
	 * Assuming `dateObj` is (year: 2015, month: 6, day: 15, hour: 21, minute: 43, second: 11)
	 * in the _local_ time and locale is 'en-US':
	 *
	 * {\@example common/pipes/ts/date_pipe.ts region='DatePipe'}
	 *
	 * \@stable
	 */
	var DatePipe = /** @class */ (function () {
	    function DatePipe(locale) {
	        this.locale = locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} format
	     * @param {?=} timezone
	     * @param {?=} locale
	     * @return {?}
	     */
	    DatePipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} format
	     * @param {?=} timezone
	     * @param {?=} locale
	     * @return {?}
	     */
	    function (value, format, timezone, locale) {
	        if (format === void 0) { format = 'mediumDate'; }
	        if (value == null || value === '' || value !== value)
	            return null;
	        if (typeof value === 'string') {
	            value = value.trim();
	        }
	        var /** @type {?} */ date;
	        var /** @type {?} */ match;
	        if (isDate$1(value)) {
	            date = value;
	        }
	        else if (!isNaN(value - parseFloat(value))) {
	            date = new Date(parseFloat(value));
	        }
	        else if (typeof value === 'string' && /^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
	            /**
	             * For ISO Strings without time the day, month and year must be extracted from the ISO String
	             * before Date creation to avoid time offset and errors in the new Date.
	             * If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
	             * date, some browsers (e.g. IE 9) will throw an invalid Date error
	             * If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
	             * is applied
	             * Note: ISO months are 0 for January, 1 for February, ...
	             */
	            var _a = value.split('-').map(function (val) { return +val; }), y = _a[0], m = _a[1], d = _a[2];
	            date = new Date(y, m - 1, d);
	        }
	        else if ((typeof value === 'string') && (match = value.match(ISO8601_DATE_REGEX))) {
	            date = isoStringToDate(match);
	        }
	        else {
	            date = new Date(value);
	        }
	        if (!isDate$1(date)) {
	            throw invalidPipeArgumentError(DatePipe, value);
	        }
	        return formatDate(date, format, locale || this.locale, timezone);
	    };
	    DatePipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'date', pure: true },] },
	    ];
	    /** @nocollapse */
	    DatePipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return DatePipe;
	}());
	/**
	 * \@internal
	 * @param {?} match
	 * @return {?}
	 */
	function isoStringToDate(match) {
	    var /** @type {?} */ date = new Date(0);
	    var /** @type {?} */ tzHour = 0;
	    var /** @type {?} */ tzMin = 0;
	    // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
	    var /** @type {?} */ dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
	    var /** @type {?} */ timeSetter = match[8] ? date.setUTCHours : date.setHours;
	    // if there is a timezone defined like "+01:00" or "+0100"
	    if (match[9]) {
	        tzHour = +(match[9] + match[10]);
	        tzMin = +(match[9] + match[11]);
	    }
	    dateSetter.call(date, +(match[1]), +(match[2]) - 1, +(match[3]));
	    var /** @type {?} */ h = +(match[4] || '0') - tzHour;
	    var /** @type {?} */ m = +(match[5] || '0') - tzMin;
	    var /** @type {?} */ s = +(match[6] || '0');
	    var /** @type {?} */ ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	    timeSetter.call(date, h, m, s, ms);
	    return date;
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function isDate$1(value) {
	    return value instanceof Date && !isNaN(value.valueOf());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var NumberFormatter = /** @class */ (function () {
	    function NumberFormatter() {
	    }
	    /**
	     * @param {?} num
	     * @param {?} locale
	     * @param {?} style
	     * @param {?=} opts
	     * @return {?}
	     */
	    NumberFormatter.format = /**
	     * @param {?} num
	     * @param {?} locale
	     * @param {?} style
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (num, locale, style, opts) {
	        if (opts === void 0) { opts = {}; }
	        var minimumIntegerDigits = opts.minimumIntegerDigits, minimumFractionDigits = opts.minimumFractionDigits, maximumFractionDigits = opts.maximumFractionDigits, currency = opts.currency, _a = opts.currencyAsSymbol, currencyAsSymbol = _a === void 0 ? false : _a;
	        var /** @type {?} */ options = {
	            minimumIntegerDigits: minimumIntegerDigits,
	            minimumFractionDigits: minimumFractionDigits,
	            maximumFractionDigits: maximumFractionDigits,
	            style: NumberFormatStyle[style].toLowerCase()
	        };
	        if (style == NumberFormatStyle.Currency) {
	            options.currency = typeof currency == 'string' ? currency : undefined;
	            options.currencyDisplay = currencyAsSymbol ? 'symbol' : 'code';
	        }
	        return new Intl.NumberFormat(locale, options).format(num);
	    };
	    return NumberFormatter;
	}());
	var DATE_FORMATS_SPLIT$1 = /((?:[^yMLdHhmsazZEwGjJ']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|J+|j+|m+|s+|a|z|Z|G+|w+))(.*)/;
	var PATTERN_ALIASES = {
	    // Keys are quoted so they do not get renamed during closure compilation.
	    'yMMMdjms': datePartGetterFactory(combine([
	        digitCondition('year', 1),
	        nameCondition('month', 3),
	        digitCondition('day', 1),
	        digitCondition('hour', 1),
	        digitCondition('minute', 1),
	        digitCondition('second', 1),
	    ])),
	    'yMdjm': datePartGetterFactory(combine([
	        digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1),
	        digitCondition('hour', 1), digitCondition('minute', 1)
	    ])),
	    'yMMMMEEEEd': datePartGetterFactory(combine([
	        digitCondition('year', 1), nameCondition('month', 4), nameCondition('weekday', 4),
	        digitCondition('day', 1)
	    ])),
	    'yMMMMd': datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 4), digitCondition('day', 1)])),
	    'yMMMd': datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 3), digitCondition('day', 1)])),
	    'yMd': datePartGetterFactory(combine([digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1)])),
	    'jms': datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('second', 1), digitCondition('minute', 1)])),
	    'jm': datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('minute', 1)]))
	};
	var DATE_FORMATS$1 = {
	    // Keys are quoted so they do not get renamed.
	    'yyyy': datePartGetterFactory(digitCondition('year', 4)),
	    'yy': datePartGetterFactory(digitCondition('year', 2)),
	    'y': datePartGetterFactory(digitCondition('year', 1)),
	    'MMMM': datePartGetterFactory(nameCondition('month', 4)),
	    'MMM': datePartGetterFactory(nameCondition('month', 3)),
	    'MM': datePartGetterFactory(digitCondition('month', 2)),
	    'M': datePartGetterFactory(digitCondition('month', 1)),
	    'LLLL': datePartGetterFactory(nameCondition('month', 4)),
	    'L': datePartGetterFactory(nameCondition('month', 1)),
	    'dd': datePartGetterFactory(digitCondition('day', 2)),
	    'd': datePartGetterFactory(digitCondition('day', 1)),
	    'HH': digitModifier(hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), false)))),
	    'H': hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), false))),
	    'hh': digitModifier(hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), true)))),
	    'h': hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
	    'jj': datePartGetterFactory(digitCondition('hour', 2)),
	    'j': datePartGetterFactory(digitCondition('hour', 1)),
	    'mm': digitModifier(datePartGetterFactory(digitCondition('minute', 2))),
	    'm': datePartGetterFactory(digitCondition('minute', 1)),
	    'ss': digitModifier(datePartGetterFactory(digitCondition('second', 2))),
	    's': datePartGetterFactory(digitCondition('second', 1)),
	    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	    // we can be just safely rely on using `sss` since we currently don't support single or two digit
	    // fractions
	    'sss': datePartGetterFactory(digitCondition('second', 3)),
	    'EEEE': datePartGetterFactory(nameCondition('weekday', 4)),
	    'EEE': datePartGetterFactory(nameCondition('weekday', 3)),
	    'EE': datePartGetterFactory(nameCondition('weekday', 2)),
	    'E': datePartGetterFactory(nameCondition('weekday', 1)),
	    'a': hourClockExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
	    'Z': timeZoneGetter$1('short'),
	    'z': timeZoneGetter$1('long'),
	    'ww': datePartGetterFactory({}),
	    // Week of year, padded (00-53). Week 01 is the week with the
	    // first Thursday of the year. not support ?
	    'w': datePartGetterFactory({}),
	    // Week of year (0-53). Week 1 is the week with the first Thursday
	    // of the year not support ?
	    'G': datePartGetterFactory(nameCondition('era', 1)),
	    'GG': datePartGetterFactory(nameCondition('era', 2)),
	    'GGG': datePartGetterFactory(nameCondition('era', 3)),
	    'GGGG': datePartGetterFactory(nameCondition('era', 4))
	};
	/**
	 * @param {?} inner
	 * @return {?}
	 */
	function digitModifier(inner) {
	    return function (date, locale) {
	        var /** @type {?} */ result = inner(date, locale);
	        return result.length == 1 ? '0' + result : result;
	    };
	}
	/**
	 * @param {?} inner
	 * @return {?}
	 */
	function hourClockExtractor(inner) {
	    return function (date, locale) { return inner(date, locale).split(' ')[1]; };
	}
	/**
	 * @param {?} inner
	 * @return {?}
	 */
	function hourExtractor(inner) {
	    return function (date, locale) { return inner(date, locale).split(' ')[0]; };
	}
	/**
	 * @param {?} date
	 * @param {?} locale
	 * @param {?} options
	 * @return {?}
	 */
	function intlDateFormat(date, locale, options) {
	    return new Intl.DateTimeFormat(locale, options).format(date).replace(/[\u200e\u200f]/g, '');
	}
	/**
	 * @param {?} timezone
	 * @return {?}
	 */
	function timeZoneGetter$1(timezone) {
	    // To workaround `Intl` API restriction for single timezone let format with 24 hours
	    var /** @type {?} */ options = { hour: '2-digit', hour12: false, timeZoneName: timezone };
	    return function (date, locale) {
	        var /** @type {?} */ result = intlDateFormat(date, locale, options);
	        // Then extract first 3 letters that related to hours
	        return result ? result.substring(3) : '';
	    };
	}
	/**
	 * @param {?} options
	 * @param {?} value
	 * @return {?}
	 */
	function hour12Modify(options, value) {
	    options.hour12 = value;
	    return options;
	}
	/**
	 * @param {?} prop
	 * @param {?} len
	 * @return {?}
	 */
	function digitCondition(prop, len) {
	    var /** @type {?} */ result = {};
	    result[prop] = len === 2 ? '2-digit' : 'numeric';
	    return result;
	}
	/**
	 * @param {?} prop
	 * @param {?} len
	 * @return {?}
	 */
	function nameCondition(prop, len) {
	    var /** @type {?} */ result = {};
	    if (len < 4) {
	        result[prop] = len > 1 ? 'short' : 'narrow';
	    }
	    else {
	        result[prop] = 'long';
	    }
	    return result;
	}
	/**
	 * @param {?} options
	 * @return {?}
	 */
	function combine(options) {
	    return options.reduce(function (merged, opt) { return (__assign({}, merged, opt)); }, {});
	}
	/**
	 * @param {?} ret
	 * @return {?}
	 */
	function datePartGetterFactory(ret) {
	    return function (date, locale) { return intlDateFormat(date, locale, ret); };
	}
	var DATE_FORMATTER_CACHE = new Map();
	/**
	 * @param {?} format
	 * @param {?} date
	 * @param {?} locale
	 * @return {?}
	 */
	function dateFormatter(format, date, locale) {
	    var /** @type {?} */ fn = PATTERN_ALIASES[format];
	    if (fn)
	        return fn(date, locale);
	    var /** @type {?} */ cacheKey = format;
	    var /** @type {?} */ parts = DATE_FORMATTER_CACHE.get(cacheKey);
	    if (!parts) {
	        parts = [];
	        var /** @type {?} */ match = void 0;
	        DATE_FORMATS_SPLIT$1.exec(format);
	        var /** @type {?} */ _format = format;
	        while (_format) {
	            match = DATE_FORMATS_SPLIT$1.exec(_format);
	            if (match) {
	                parts = parts.concat(match.slice(1));
	                _format = /** @type {?} */ ((parts.pop()));
	            }
	            else {
	                parts.push(_format);
	                _format = null;
	            }
	        }
	        DATE_FORMATTER_CACHE.set(cacheKey, parts);
	    }
	    return parts.reduce(function (text, part) {
	        var /** @type {?} */ fn = DATE_FORMATS$1[part];
	        return text + (fn ? fn(date, locale) : partToTime(part));
	    }, '');
	}
	/**
	 * @param {?} part
	 * @return {?}
	 */
	function partToTime(part) {
	    return part === '\'\'' ? '\'' : part.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	}
	var DateFormatter = /** @class */ (function () {
	    function DateFormatter() {
	    }
	    /**
	     * @param {?} date
	     * @param {?} locale
	     * @param {?} pattern
	     * @return {?}
	     */
	    DateFormatter.format = /**
	     * @param {?} date
	     * @param {?} locale
	     * @param {?} pattern
	     * @return {?}
	     */
	    function (date, locale, pattern) {
	        return dateFormatter(pattern, date, locale);
	    };
	    return DateFormatter;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	* @license
	* Copyright Google Inc. All Rights Reserved.
	*
	* Use of this source code is governed by an MIT-style license that can be
	* found in the LICENSE file at https://angular.io/license
	  */
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a date according to locale rules.
	 * \@howToUse `date_expression | date[:format]`
	 * \@description
	 *
	 * Where:
	 * - `expression` is a date object or a number (milliseconds since UTC epoch) or an ISO string
	 * (https://www.w3.org/TR/NOTE-datetime).
	 * - `format` indicates which date/time components to include. The format can be predefined as
	 *   shown below or custom as shown in the table.
	 *   - `'medium'`: equivalent to `'yMMMdjms'` (e.g. `Sep 3, 2010, 12:05:08 PM` for `en-US`)
	 *   - `'short'`: equivalent to `'yMdjm'` (e.g. `9/3/2010, 12:05 PM` for `en-US`)
	 *   - `'fullDate'`: equivalent to `'yMMMMEEEEd'` (e.g. `Friday, September 3, 2010` for `en-US`)
	 *   - `'longDate'`: equivalent to `'yMMMMd'` (e.g. `September 3, 2010` for `en-US`)
	 *   - `'mediumDate'`: equivalent to `'yMMMd'` (e.g. `Sep 3, 2010` for `en-US`)
	 *   - `'shortDate'`: equivalent to `'yMd'` (e.g. `9/3/2010` for `en-US`)
	 *   - `'mediumTime'`: equivalent to `'jms'` (e.g. `12:05:08 PM` for `en-US`)
	 *   - `'shortTime'`: equivalent to `'jm'` (e.g. `12:05 PM` for `en-US`)
	 *
	 *
	 *  | Component | Symbol | Narrow | Short Form   | Long Form         | Numeric   | 2-digit   |
	 *  |-----------|:------:|--------|--------------|-------------------|-----------|-----------|
	 *  | era       |   G    | G (A)  | GGG (AD)     | GGGG (Anno Domini)| -         | -         |
	 *  | year      |   y    | -      | -            | -                 | y (2015)  | yy (15)   |
	 *  | month     |   M    | L (S)  | MMM (Sep)    | MMMM (September)  | M (9)     | MM (09)   |
	 *  | day       |   d    | -      | -            | -                 | d (3)     | dd (03)   |
	 *  | weekday   |   E    | E (S)  | EEE (Sun)    | EEEE (Sunday)     | -         | -         |
	 *  | hour      |   j    | -      | -            | -                 | j (13)    | jj (13)   |
	 *  | hour12    |   h    | -      | -            | -                 | h (1 PM)  | hh (01 PM)|
	 *  | hour24    |   H    | -      | -            | -                 | H (13)    | HH (13)   |
	 *  | minute    |   m    | -      | -            | -                 | m (5)     | mm (05)   |
	 *  | second    |   s    | -      | -            | -                 | s (9)     | ss (09)   |
	 *  | timezone  |   z    | -      | -            | z (Pacific Standard Time)| -  | -         |
	 *  | timezone  |   Z    | -      | Z (GMT-8:00) | -                 | -         | -         |
	 *  | timezone  |   a    | -      | a (PM)       | -                 | -         | -         |
	 *
	 * In javascript, only the components specified will be respected (not the ordering,
	 * punctuations, ...) and details of the formatting will be dependent on the locale.
	 *
	 * Timezone of the formatted text will be the local system timezone of the end-user's machine.
	 *
	 * When the expression is a ISO string without time (e.g. 2016-09-19) the time zone offset is not
	 * applied and the formatted text will have the same day, month and year of the expression.
	 *
	 * WARNINGS:
	 * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
	 *   Instead users should treat the date as an immutable object and change the reference when the
	 *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
	 *   which would be an expensive operation).
	 * - this pipe uses the Internationalization API. Therefore it is only reliable in Chrome and Opera
	 *   browsers.
	 *
	 * ### Examples
	 *
	 * Assuming `dateObj` is (year: 2010, month: 9, day: 3, hour: 12 PM, minute: 05, second: 08)
	 * in the _local_ time and locale is 'en-US':
	 *
	 * {\@example common/pipes/ts/date_pipe.ts region='DeprecatedDatePipe'}
	 *
	 * \@stable
	 */
	var DeprecatedDatePipe = /** @class */ (function () {
	    function DeprecatedDatePipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} pattern
	     * @return {?}
	     */
	    DeprecatedDatePipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} pattern
	     * @return {?}
	     */
	    function (value, pattern) {
	        if (pattern === void 0) { pattern = 'mediumDate'; }
	        if (value == null || value === '' || value !== value)
	            return null;
	        var /** @type {?} */ date;
	        if (typeof value === 'string') {
	            value = value.trim();
	        }
	        if (isDate(value)) {
	            date = value;
	        }
	        else if (!isNaN(value - parseFloat(value))) {
	            date = new Date(parseFloat(value));
	        }
	        else if (typeof value === 'string' && /^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
	            /**
	             * For ISO Strings without time the day, month and year must be extracted from the ISO String
	             * before Date creation to avoid time offset and errors in the new Date.
	             * If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
	             * date, some browsers (e.g. IE 9) will throw an invalid Date error
	             * If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the
	             * timeoffset
	             * is applied
	             * Note: ISO months are 0 for January, 1 for February, ...
	             */
	            var _a = value.split('-').map(function (val) { return parseInt(val, 10); }), y = _a[0], m = _a[1], d = _a[2];
	            date = new Date(y, m - 1, d);
	        }
	        else {
	            date = new Date(value);
	        }
	        if (!isDate(date)) {
	            var /** @type {?} */ match = void 0;
	            if ((typeof value === 'string') && (match = value.match(ISO8601_DATE_REGEX))) {
	                date = isoStringToDate(match);
	            }
	            else {
	                throw invalidPipeArgumentError(DeprecatedDatePipe, value);
	            }
	        }
	        return DateFormatter.format(date, this._locale, DeprecatedDatePipe._ALIASES[pattern] || pattern);
	    };
	    /**
	     * \@internal
	     */
	    DeprecatedDatePipe._ALIASES = {
	        'medium': 'yMMMdjms',
	        'short': 'yMdjm',
	        'fullDate': 'yMMMMEEEEd',
	        'longDate': 'yMMMMd',
	        'mediumDate': 'yMMMd',
	        'shortDate': 'yMd',
	        'mediumTime': 'jms',
	        'shortTime': 'jm'
	    };
	    DeprecatedDatePipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'date', pure: true },] },
	    ];
	    /** @nocollapse */
	    DeprecatedDatePipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return DeprecatedDatePipe;
	}());
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function isDate(value) {
	    return value instanceof Date && !isNaN(value.valueOf());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	var PATTERN_SEP = ';';
	var GROUP_SEP = ',';
	var DIGIT_CHAR = '#';
	var CURRENCY_CHAR = '¤';
	var PERCENT_CHAR = '%';
	/**
	 * Transform a number to a locale string based on a style and a format
	 *
	 * \@internal
	 * @param {?} value
	 * @param {?} locale
	 * @param {?} style
	 * @param {?=} digitsInfo
	 * @param {?=} currency
	 * @return {?}
	 */
	function formatNumber$1(value, locale, style, digitsInfo, currency) {
	    if (currency === void 0) { currency = null; }
	    var /** @type {?} */ res = { str: null };
	    var /** @type {?} */ format = getLocaleNumberFormat(locale, style);
	    var /** @type {?} */ num;
	    // Convert strings to numbers
	    if (typeof value === 'string' && !isNaN(+value - parseFloat(value))) {
	        num = +value;
	    }
	    else if (typeof value !== 'number') {
	        res.error = value + " is not a number";
	        return res;
	    }
	    else {
	        num = value;
	    }
	    var /** @type {?} */ pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
	    var /** @type {?} */ formattedText = '';
	    var /** @type {?} */ isZero = false;
	    if (!isFinite(num)) {
	        formattedText = getLocaleNumberSymbol(locale, NumberSymbol.Infinity);
	    }
	    else {
	        var /** @type {?} */ parsedNumber = parseNumber(num);
	        if (style === NumberFormatStyle.Percent) {
	            parsedNumber = toPercent(parsedNumber);
	        }
	        var /** @type {?} */ minInt = pattern.minInt;
	        var /** @type {?} */ minFraction = pattern.minFrac;
	        var /** @type {?} */ maxFraction = pattern.maxFrac;
	        if (digitsInfo) {
	            var /** @type {?} */ parts = digitsInfo.match(NUMBER_FORMAT_REGEXP);
	            if (parts === null) {
	                res.error = digitsInfo + " is not a valid digit info";
	                return res;
	            }
	            var /** @type {?} */ minIntPart = parts[1];
	            var /** @type {?} */ minFractionPart = parts[3];
	            var /** @type {?} */ maxFractionPart = parts[5];
	            if (minIntPart != null) {
	                minInt = parseIntAutoRadix(minIntPart);
	            }
	            if (minFractionPart != null) {
	                minFraction = parseIntAutoRadix(minFractionPart);
	            }
	            if (maxFractionPart != null) {
	                maxFraction = parseIntAutoRadix(maxFractionPart);
	            }
	            else if (minFractionPart != null && minFraction > maxFraction) {
	                maxFraction = minFraction;
	            }
	        }
	        roundNumber(parsedNumber, minFraction, maxFraction);
	        var /** @type {?} */ digits = parsedNumber.digits;
	        var /** @type {?} */ integerLen = parsedNumber.integerLen;
	        var /** @type {?} */ exponent = parsedNumber.exponent;
	        var /** @type {?} */ decimals = [];
	        isZero = digits.every(function (d) { return !d; });
	        // pad zeros for small numbers
	        for (; integerLen < minInt; integerLen++) {
	            digits.unshift(0);
	        }
	        // pad zeros for small numbers
	        for (; integerLen < 0; integerLen++) {
	            digits.unshift(0);
	        }
	        // extract decimals digits
	        if (integerLen > 0) {
	            decimals = digits.splice(integerLen, digits.length);
	        }
	        else {
	            decimals = digits;
	            digits = [0];
	        }
	        // format the integer digits with grouping separators
	        var /** @type {?} */ groups = [];
	        if (digits.length >= pattern.lgSize) {
	            groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	        }
	        while (digits.length > pattern.gSize) {
	            groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	        }
	        if (digits.length) {
	            groups.unshift(digits.join(''));
	        }
	        var /** @type {?} */ groupSymbol = currency ? NumberSymbol.CurrencyGroup : NumberSymbol.Group;
	        formattedText = groups.join(getLocaleNumberSymbol(locale, groupSymbol));
	        // append the decimal digits
	        if (decimals.length) {
	            var /** @type {?} */ decimalSymbol = currency ? NumberSymbol.CurrencyDecimal : NumberSymbol.Decimal;
	            formattedText += getLocaleNumberSymbol(locale, decimalSymbol) + decimals.join('');
	        }
	        if (exponent) {
	            formattedText += getLocaleNumberSymbol(locale, NumberSymbol.Exponential) + '+' + exponent;
	        }
	    }
	    if (num < 0 && !isZero) {
	        formattedText = pattern.negPre + formattedText + pattern.negSuf;
	    }
	    else {
	        formattedText = pattern.posPre + formattedText + pattern.posSuf;
	    }
	    if (style === NumberFormatStyle.Currency && currency !== null) {
	        res.str = formattedText
	            .replace(CURRENCY_CHAR, currency)
	            .replace(CURRENCY_CHAR, '');
	        return res;
	    }
	    if (style === NumberFormatStyle.Percent) {
	        res.str = formattedText.replace(new RegExp(PERCENT_CHAR, 'g'), getLocaleNumberSymbol(locale, NumberSymbol.PercentSign));
	        return res;
	    }
	    res.str = formattedText;
	    return res;
	}
	/**
	 * @param {?} format
	 * @param {?=} minusSign
	 * @return {?}
	 */
	function parseNumberFormat(format, minusSign) {
	    if (minusSign === void 0) { minusSign = '-'; }
	    var /** @type {?} */ p = {
	        minInt: 1,
	        minFrac: 0,
	        maxFrac: 0,
	        posPre: '',
	        posSuf: '',
	        negPre: '',
	        negSuf: '',
	        gSize: 0,
	        lgSize: 0
	    };
	    var /** @type {?} */ patternParts = format.split(PATTERN_SEP);
	    var /** @type {?} */ positive = patternParts[0];
	    var /** @type {?} */ negative = patternParts[1];
	    var /** @type {?} */ positiveParts = positive.indexOf(DECIMAL_SEP) !== -1 ?
	        positive.split(DECIMAL_SEP) :
	        [
	            positive.substring(0, positive.lastIndexOf(ZERO_CHAR) + 1),
	            positive.substring(positive.lastIndexOf(ZERO_CHAR) + 1)
	        ], /** @type {?} */
	    integer = positiveParts[0], /** @type {?} */ fraction = positiveParts[1] || '';
	    p.posPre = integer.substr(0, integer.indexOf(DIGIT_CHAR));
	    for (var /** @type {?} */ i = 0; i < fraction.length; i++) {
	        var /** @type {?} */ ch = fraction.charAt(i);
	        if (ch === ZERO_CHAR) {
	            p.minFrac = p.maxFrac = i + 1;
	        }
	        else if (ch === DIGIT_CHAR) {
	            p.maxFrac = i + 1;
	        }
	        else {
	            p.posSuf += ch;
	        }
	    }
	    var /** @type {?} */ groups = integer.split(GROUP_SEP);
	    p.gSize = groups[1] ? groups[1].length : 0;
	    p.lgSize = (groups[2] || groups[1]) ? (groups[2] || groups[1]).length : 0;
	    if (negative) {
	        var /** @type {?} */ trunkLen = positive.length - p.posPre.length - p.posSuf.length, /** @type {?} */
	        pos = negative.indexOf(DIGIT_CHAR);
	        p.negPre = negative.substr(0, pos).replace(/'/g, '');
	        p.negSuf = negative.substr(pos + trunkLen).replace(/'/g, '');
	    }
	    else {
	        p.negPre = minusSign + p.posPre;
	        p.negSuf = p.posSuf;
	    }
	    return p;
	}
	/**
	 * @param {?} parsedNumber
	 * @return {?}
	 */
	function toPercent(parsedNumber) {
	    // if the number is 0, don't do anything
	    if (parsedNumber.digits[0] === 0) {
	        return parsedNumber;
	    }
	    // Getting the current number of decimals
	    var /** @type {?} */ fractionLen = parsedNumber.digits.length - parsedNumber.integerLen;
	    if (parsedNumber.exponent) {
	        parsedNumber.exponent += 2;
	    }
	    else {
	        if (fractionLen === 0) {
	            parsedNumber.digits.push(0, 0);
	        }
	        else if (fractionLen === 1) {
	            parsedNumber.digits.push(0);
	        }
	        parsedNumber.integerLen += 2;
	    }
	    return parsedNumber;
	}
	/**
	 * Parses a number.
	 * Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/
	 * @param {?} num
	 * @return {?}
	 */
	function parseNumber(num) {
	    var /** @type {?} */ numStr = Math.abs(num) + '';
	    var /** @type {?} */ exponent = 0, /** @type {?} */ digits, /** @type {?} */ integerLen;
	    var /** @type {?} */ i, /** @type {?} */ j, /** @type {?} */ zeros;
	    // Decimal point?
	    if ((integerLen = numStr.indexOf(DECIMAL_SEP)) > -1) {
	        numStr = numStr.replace(DECIMAL_SEP, '');
	    }
	    // Exponential form?
	    if ((i = numStr.search(/e/i)) > 0) {
	        // Work out the exponent.
	        if (integerLen < 0)
	            integerLen = i;
	        integerLen += +numStr.slice(i + 1);
	        numStr = numStr.substring(0, i);
	    }
	    else if (integerLen < 0) {
	        // There was no decimal point or exponent so it is an integer.
	        integerLen = numStr.length;
	    }
	    // Count the number of leading zeros.
	    for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) {
	        /* empty */
	    }
	    if (i === (zeros = numStr.length)) {
	        // The digits are all zero.
	        digits = [0];
	        integerLen = 1;
	    }
	    else {
	        // Count the number of trailing zeros
	        zeros--;
	        while (numStr.charAt(zeros) === ZERO_CHAR)
	            zeros--;
	        // Trailing zeros are insignificant so ignore them
	        integerLen -= i;
	        digits = [];
	        // Convert string to array of digits without leading/trailing zeros.
	        for (j = 0; i <= zeros; i++, j++) {
	            digits[j] = +numStr.charAt(i);
	        }
	    }
	    // If the number overflows the maximum allowed digits then use an exponent.
	    if (integerLen > MAX_DIGITS) {
	        digits = digits.splice(0, MAX_DIGITS - 1);
	        exponent = integerLen - 1;
	        integerLen = 1;
	    }
	    return { digits: digits, exponent: exponent, integerLen: integerLen };
	}
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changes the parsedNumber in-place
	 * @param {?} parsedNumber
	 * @param {?} minFrac
	 * @param {?} maxFrac
	 * @return {?}
	 */
	function roundNumber(parsedNumber, minFrac, maxFrac) {
	    if (minFrac > maxFrac) {
	        throw new Error("The minimum number of digits after fraction (" + minFrac + ") is higher than the maximum (" + maxFrac + ").");
	    }
	    var /** @type {?} */ digits = parsedNumber.digits;
	    var /** @type {?} */ fractionLen = digits.length - parsedNumber.integerLen;
	    var /** @type {?} */ fractionSize = Math.min(Math.max(minFrac, fractionLen), maxFrac);
	    // The index of the digit to where rounding is to occur
	    var /** @type {?} */ roundAt = fractionSize + parsedNumber.integerLen;
	    var /** @type {?} */ digit = digits[roundAt];
	    if (roundAt > 0) {
	        // Drop fractional digits beyond `roundAt`
	        digits.splice(Math.max(parsedNumber.integerLen, roundAt));
	        // Set non-fractional digits beyond `roundAt` to 0
	        for (var /** @type {?} */ j = roundAt; j < digits.length; j++) {
	            digits[j] = 0;
	        }
	    }
	    else {
	        // We rounded to zero so reset the parsedNumber
	        fractionLen = Math.max(0, fractionLen);
	        parsedNumber.integerLen = 1;
	        digits.length = Math.max(1, roundAt = fractionSize + 1);
	        digits[0] = 0;
	        for (var /** @type {?} */ i = 1; i < roundAt; i++)
	            digits[i] = 0;
	    }
	    if (digit >= 5) {
	        if (roundAt - 1 < 0) {
	            for (var /** @type {?} */ k = 0; k > roundAt; k--) {
	                digits.unshift(0);
	                parsedNumber.integerLen++;
	            }
	            digits.unshift(1);
	            parsedNumber.integerLen++;
	        }
	        else {
	            digits[roundAt - 1]++;
	        }
	    }
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++)
	        digits.push(0);
	    var /** @type {?} */ dropTrailingZeros = fractionSize !== 0;
	    // Minimal length = nb of decimals required + current nb of integers
	    // Any number besides that is optional and can be removed if it's a trailing 0
	    var /** @type {?} */ minLen = minFrac + parsedNumber.integerLen;
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var /** @type {?} */ carry = digits.reduceRight(function (carry, d, i, digits) {
	        d = d + carry;
	        digits[i] = d < 10 ? d : d - 10; // d % 10
	        if (dropTrailingZeros) {
	            // Do not keep meaningless fractional trailing zeros (e.g. 15.52000 --> 15.52)
	            if (digits[i] === 0 && i >= minLen) {
	                digits.pop();
	            }
	            else {
	                dropTrailingZeros = false;
	            }
	        }
	        return d >= 10 ? 1 : 0; // Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	        digits.unshift(carry);
	        parsedNumber.integerLen++;
	    }
	}
	/**
	 * \@internal
	 * @param {?} text
	 * @return {?}
	 */
	function parseIntAutoRadix(text) {
	    var /** @type {?} */ result = parseInt(text);
	    if (isNaN(result)) {
	        throw new Error('Invalid integer literal when parsing ' + text);
	    }
	    return result;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} pipe
	 * @param {?} locale
	 * @param {?} value
	 * @param {?} style
	 * @param {?=} digits
	 * @param {?=} currency
	 * @param {?=} currencyAsSymbol
	 * @return {?}
	 */
	function formatNumber(pipe, locale, value, style, digits, currency, currencyAsSymbol) {
	    if (currency === void 0) { currency = null; }
	    if (currencyAsSymbol === void 0) { currencyAsSymbol = false; }
	    if (value == null)
	        return null;
	    // Convert strings to numbers
	    value = typeof value === 'string' && !isNaN(+value - parseFloat(value)) ? +value : value;
	    if (typeof value !== 'number') {
	        throw invalidPipeArgumentError(pipe, value);
	    }
	    var /** @type {?} */ minInt;
	    var /** @type {?} */ minFraction;
	    var /** @type {?} */ maxFraction;
	    if (style !== NumberFormatStyle.Currency) {
	        // rely on Intl default for currency
	        minInt = 1;
	        minFraction = 0;
	        maxFraction = 3;
	    }
	    if (digits) {
	        var /** @type {?} */ parts = digits.match(NUMBER_FORMAT_REGEXP);
	        if (parts === null) {
	            throw new Error(digits + " is not a valid digit info for number pipes");
	        }
	        if (parts[1] != null) {
	            // min integer digits
	            minInt = parseIntAutoRadix(parts[1]);
	        }
	        if (parts[3] != null) {
	            // min fraction digits
	            minFraction = parseIntAutoRadix(parts[3]);
	        }
	        if (parts[5] != null) {
	            // max fraction digits
	            maxFraction = parseIntAutoRadix(parts[5]);
	        }
	    }
	    return NumberFormatter.format(/** @type {?} */ (value), locale, style, {
	        minimumIntegerDigits: minInt,
	        minimumFractionDigits: minFraction,
	        maximumFractionDigits: maxFraction,
	        currency: currency,
	        currencyAsSymbol: currencyAsSymbol,
	    });
	}
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a number according to locale rules.
	 * \@howToUse `number_expression | number[:digitInfo]`
	 *
	 * Formats a number as text. Group sizing and separator and other locale-specific
	 * configurations are based on the active locale.
	 *
	 * where `expression` is a number:
	 *  - `digitInfo` is a `string` which has a following format: <br>
	 *     <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
	 *   - `minIntegerDigits` is the minimum number of integer digits to use. Defaults to `1`.
	 *   - `minFractionDigits` is the minimum number of digits after fraction. Defaults to `0`.
	 *   - `maxFractionDigits` is the maximum number of digits after fraction. Defaults to `3`.
	 *
	 * For more information on the acceptable range for each of these numbers and other
	 * details see your native internationalization library.
	 *
	 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
	 * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
	 *
	 * ### Example
	 *
	 * {\@example common/pipes/ts/number_pipe.ts region='DeprecatedNumberPipe'}
	 *
	 * \@stable
	 */
	var DeprecatedDecimalPipe = /** @class */ (function () {
	    function DeprecatedDecimalPipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} digits
	     * @return {?}
	     */
	    DeprecatedDecimalPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} digits
	     * @return {?}
	     */
	    function (value, digits) {
	        return formatNumber(DeprecatedDecimalPipe, this._locale, value, NumberFormatStyle.Decimal, digits);
	    };
	    DeprecatedDecimalPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'number' },] },
	    ];
	    /** @nocollapse */
	    DeprecatedDecimalPipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return DeprecatedDecimalPipe;
	}());
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a number as a percentage according to locale rules.
	 * \@howToUse `number_expression | percent[:digitInfo]`
	 *
	 * \@description
	 *
	 * Formats a number as percentage.
	 *
	 * - `digitInfo` See {\@link DecimalPipe} for detailed description.
	 *
	 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
	 * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
	 *
	 * ### Example
	 *
	 * {\@example common/pipes/ts/percent_pipe.ts region='DeprecatedPercentPipe'}
	 *
	 * \@stable
	 */
	var DeprecatedPercentPipe = /** @class */ (function () {
	    function DeprecatedPercentPipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} digits
	     * @return {?}
	     */
	    DeprecatedPercentPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} digits
	     * @return {?}
	     */
	    function (value, digits) {
	        return formatNumber(DeprecatedPercentPipe, this._locale, value, NumberFormatStyle.Percent, digits);
	    };
	    DeprecatedPercentPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'percent' },] },
	    ];
	    /** @nocollapse */
	    DeprecatedPercentPipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return DeprecatedPercentPipe;
	}());
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a number as currency using locale rules.
	 * \@howToUse `number_expression | currency[:currencyCode[:symbolDisplay[:digitInfo]]]`
	 * \@description
	 *
	 * Use `currency` to format a number as currency.
	 *
	 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
	 *    as `USD` for the US dollar and `EUR` for the euro.
	 * - `symbolDisplay` is a boolean indicating whether to use the currency symbol or code.
	 *   - `true`: use symbol (e.g. `$`).
	 *   - `false`(default): use code (e.g. `USD`).
	 * - `digitInfo` See {\@link DecimalPipe} for detailed description.
	 *
	 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
	 * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
	 *
	 * ### Example
	 *
	 * {\@example common/pipes/ts/currency_pipe.ts region='DeprecatedCurrencyPipe'}
	 *
	 * \@stable
	 */
	var DeprecatedCurrencyPipe = /** @class */ (function () {
	    function DeprecatedCurrencyPipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} currencyCode
	     * @param {?=} symbolDisplay
	     * @param {?=} digits
	     * @return {?}
	     */
	    DeprecatedCurrencyPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} currencyCode
	     * @param {?=} symbolDisplay
	     * @param {?=} digits
	     * @return {?}
	     */
	    function (value, currencyCode, symbolDisplay, digits) {
	        if (currencyCode === void 0) { currencyCode = 'USD'; }
	        if (symbolDisplay === void 0) { symbolDisplay = false; }
	        return formatNumber(DeprecatedCurrencyPipe, this._locale, value, NumberFormatStyle.Currency, digits, currencyCode, symbolDisplay);
	    };
	    DeprecatedCurrencyPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'currency' },] },
	    ];
	    /** @nocollapse */
	    DeprecatedCurrencyPipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return DeprecatedCurrencyPipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A collection of deprecated i18n pipes that require intl api
	 *
	 * @deprecated from v5
	 */
	var COMMON_DEPRECATED_I18N_PIPES = [DeprecatedDecimalPipe, DeprecatedPercentPipe, DeprecatedCurrencyPipe, DeprecatedDatePipe];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ObservableStrategy = /** @class */ (function () {
	    function ObservableStrategy() {
	    }
	    /**
	     * @param {?} async
	     * @param {?} updateLatestValue
	     * @return {?}
	     */
	    ObservableStrategy.prototype.createSubscription = /**
	     * @param {?} async
	     * @param {?} updateLatestValue
	     * @return {?}
	     */
	    function (async, updateLatestValue) {
	        return async.subscribe({ next: updateLatestValue, error: function (e) { throw e; } });
	    };
	    /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    ObservableStrategy.prototype.dispose = /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    function (subscription) { subscription.unsubscribe(); };
	    /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    ObservableStrategy.prototype.onDestroy = /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    function (subscription) { subscription.unsubscribe(); };
	    return ObservableStrategy;
	}());
	var PromiseStrategy = /** @class */ (function () {
	    function PromiseStrategy() {
	    }
	    /**
	     * @param {?} async
	     * @param {?} updateLatestValue
	     * @return {?}
	     */
	    PromiseStrategy.prototype.createSubscription = /**
	     * @param {?} async
	     * @param {?} updateLatestValue
	     * @return {?}
	     */
	    function (async, updateLatestValue) {
	        return async.then(updateLatestValue, function (e) { throw e; });
	    };
	    /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    PromiseStrategy.prototype.dispose = /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    function (subscription) { };
	    /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    PromiseStrategy.prototype.onDestroy = /**
	     * @param {?} subscription
	     * @return {?}
	     */
	    function (subscription) { };
	    return PromiseStrategy;
	}());
	var _promiseStrategy = new PromiseStrategy();
	var _observableStrategy = new ObservableStrategy();
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Unwraps a value from an asynchronous primitive.
	 * \@howToUse `observable_or_promise_expression | async`
	 * \@description
	 * The `async` pipe subscribes to an `Observable` or `Promise` and returns the latest value it has
	 * emitted. When a new value is emitted, the `async` pipe marks the component to be checked for
	 * changes. When the component gets destroyed, the `async` pipe unsubscribes automatically to avoid
	 * potential memory leaks.
	 *
	 *
	 * ## Examples
	 *
	 * This example binds a `Promise` to the view. Clicking the `Resolve` button resolves the
	 * promise.
	 *
	 * {\@example common/pipes/ts/async_pipe.ts region='AsyncPipePromise'}
	 *
	 * It's also possible to use `async` with Observables. The example below binds the `time` Observable
	 * to the view. The Observable continuously updates the view with the current time.
	 *
	 * {\@example common/pipes/ts/async_pipe.ts region='AsyncPipeObservable'}
	 *
	 * \@stable
	 */
	var AsyncPipe = /** @class */ (function () {
	    function AsyncPipe(_ref) {
	        this._ref = _ref;
	        this._latestValue = null;
	        this._latestReturnedValue = null;
	        this._subscription = null;
	        this._obj = null;
	        this._strategy = /** @type {?} */ ((null));
	    }
	    /**
	     * @return {?}
	     */
	    AsyncPipe.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._subscription) {
	            this._dispose();
	        }
	    };
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    AsyncPipe.prototype.transform = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) {
	        if (!this._obj) {
	            if (obj) {
	                this._subscribe(obj);
	            }
	            this._latestReturnedValue = this._latestValue;
	            return this._latestValue;
	        }
	        if (obj !== this._obj) {
	            this._dispose();
	            return this.transform(/** @type {?} */ (obj));
	        }
	        if (this._latestValue === this._latestReturnedValue) {
	            return this._latestReturnedValue;
	        }
	        this._latestReturnedValue = this._latestValue;
	        return _angular_core.WrappedValue.wrap(this._latestValue);
	    };
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    AsyncPipe.prototype._subscribe = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) {
	        var _this = this;
	        this._obj = obj;
	        this._strategy = this._selectStrategy(obj);
	        this._subscription = this._strategy.createSubscription(obj, function (value) { return _this._updateLatestValue(obj, value); });
	    };
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    AsyncPipe.prototype._selectStrategy = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) {
	        if (_angular_core.ɵisPromise(obj)) {
	            return _promiseStrategy;
	        }
	        if (_angular_core.ɵisObservable(obj)) {
	            return _observableStrategy;
	        }
	        throw invalidPipeArgumentError(AsyncPipe, obj);
	    };
	    /**
	     * @return {?}
	     */
	    AsyncPipe.prototype._dispose = /**
	     * @return {?}
	     */
	    function () {
	        this._strategy.dispose(/** @type {?} */ ((this._subscription)));
	        this._latestValue = null;
	        this._latestReturnedValue = null;
	        this._subscription = null;
	        this._obj = null;
	    };
	    /**
	     * @param {?} async
	     * @param {?} value
	     * @return {?}
	     */
	    AsyncPipe.prototype._updateLatestValue = /**
	     * @param {?} async
	     * @param {?} value
	     * @return {?}
	     */
	    function (async, value) {
	        if (async === this._obj) {
	            this._latestValue = value;
	            this._ref.markForCheck();
	        }
	    };
	    AsyncPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'async', pure: false },] },
	    ];
	    /** @nocollapse */
	    AsyncPipe.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    return AsyncPipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Transforms text to lowercase.
	 *
	 * {\@example  common/pipes/ts/lowerupper_pipe.ts region='LowerUpperPipe' }
	 *
	 * \@stable
	 */
	var LowerCasePipe = /** @class */ (function () {
	    function LowerCasePipe() {
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    LowerCasePipe.prototype.transform = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (!value)
	            return value;
	        if (typeof value !== 'string') {
	            throw invalidPipeArgumentError(LowerCasePipe, value);
	        }
	        return value.toLowerCase();
	    };
	    LowerCasePipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'lowercase' },] },
	    ];
	    /** @nocollapse */
	    LowerCasePipe.ctorParameters = function () { return []; };
	    return LowerCasePipe;
	}());
	/**
	 * Helper method to transform a single word to titlecase.
	 *
	 * \@stable
	 * @param {?} word
	 * @return {?}
	 */
	function titleCaseWord(word) {
	    if (!word)
	        return word;
	    return word[0].toUpperCase() + word.substr(1).toLowerCase();
	}
	/**
	 * Transforms text to titlecase.
	 *
	 * \@stable
	 */
	var TitleCasePipe = /** @class */ (function () {
	    function TitleCasePipe() {
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    TitleCasePipe.prototype.transform = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (!value)
	            return value;
	        if (typeof value !== 'string') {
	            throw invalidPipeArgumentError(TitleCasePipe, value);
	        }
	        return value.split(/\b/g).map(function (word) { return titleCaseWord(word); }).join('');
	    };
	    TitleCasePipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'titlecase' },] },
	    ];
	    /** @nocollapse */
	    TitleCasePipe.ctorParameters = function () { return []; };
	    return TitleCasePipe;
	}());
	/**
	 * Transforms text to uppercase.
	 *
	 * \@stable
	 */
	var UpperCasePipe = /** @class */ (function () {
	    function UpperCasePipe() {
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    UpperCasePipe.prototype.transform = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (!value)
	            return value;
	        if (typeof value !== 'string') {
	            throw invalidPipeArgumentError(UpperCasePipe, value);
	        }
	        return value.toUpperCase();
	    };
	    UpperCasePipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'uppercase' },] },
	    ];
	    /** @nocollapse */
	    UpperCasePipe.ctorParameters = function () { return []; };
	    return UpperCasePipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _INTERPOLATION_REGEXP = /#/g;
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Maps a value to a string that pluralizes the value according to locale rules.
	 * \@howToUse `expression | i18nPlural:mapping[:locale]`
	 * \@description
	 *
	 *  Where:
	 *  - `expression` is a number.
	 *  - `mapping` is an object that mimics the ICU format, see
	 *    http://userguide.icu-project.org/formatparse/messages
	 *  - `locale` is a `string` defining the locale to use (uses the current {\@link LOCALE_ID} by
	 * default)
	 *
	 *  ## Example
	 *
	 * {\@example common/pipes/ts/i18n_pipe.ts region='I18nPluralPipeComponent'}
	 *
	 * \@experimental
	 */
	var I18nPluralPipe = /** @class */ (function () {
	    function I18nPluralPipe(_localization) {
	        this._localization = _localization;
	    }
	    /**
	     * @param {?} value
	     * @param {?} pluralMap
	     * @param {?=} locale
	     * @return {?}
	     */
	    I18nPluralPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?} pluralMap
	     * @param {?=} locale
	     * @return {?}
	     */
	    function (value, pluralMap, locale) {
	        if (value == null)
	            return '';
	        if (typeof pluralMap !== 'object' || pluralMap === null) {
	            throw invalidPipeArgumentError(I18nPluralPipe, pluralMap);
	        }
	        var /** @type {?} */ key = getPluralCategory(value, Object.keys(pluralMap), this._localization, locale);
	        return pluralMap[key].replace(_INTERPOLATION_REGEXP, value.toString());
	    };
	    I18nPluralPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'i18nPlural', pure: true },] },
	    ];
	    /** @nocollapse */
	    I18nPluralPipe.ctorParameters = function () { return [
	        { type: NgLocalization, },
	    ]; };
	    return I18nPluralPipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Generic selector that displays the string that matches the current value.
	 * \@howToUse `expression | i18nSelect:mapping`
	 * \@description
	 *
	 *  Where `mapping` is an object that indicates the text that should be displayed
	 *  for different values of the provided `expression`.
	 *  If none of the keys of the mapping match the value of the `expression`, then the content
	 *  of the `other` key is returned when present, otherwise an empty string is returned.
	 *
	 *  ## Example
	 *
	 * {\@example common/pipes/ts/i18n_pipe.ts region='I18nSelectPipeComponent'}
	 *
	 *  \@experimental
	 */
	var I18nSelectPipe = /** @class */ (function () {
	    function I18nSelectPipe() {
	    }
	    /**
	     * @param {?} value
	     * @param {?} mapping
	     * @return {?}
	     */
	    I18nSelectPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?} mapping
	     * @return {?}
	     */
	    function (value, mapping) {
	        if (value == null)
	            return '';
	        if (typeof mapping !== 'object' || typeof value !== 'string') {
	            throw invalidPipeArgumentError(I18nSelectPipe, mapping);
	        }
	        if (mapping.hasOwnProperty(value)) {
	            return mapping[value];
	        }
	        if (mapping.hasOwnProperty('other')) {
	            return mapping['other'];
	        }
	        return '';
	    };
	    I18nSelectPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'i18nSelect', pure: true },] },
	    ];
	    /** @nocollapse */
	    I18nSelectPipe.ctorParameters = function () { return []; };
	    return I18nSelectPipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Converts value into JSON string.
	 * \@howToUse `expression | json`
	 * \@description
	 *
	 * Converts value into string using `JSON.stringify`. Useful for debugging.
	 *
	 * ### Example
	 * {\@example common/pipes/ts/json_pipe.ts region='JsonPipe'}
	 *
	 * \@stable
	 */
	var JsonPipe = /** @class */ (function () {
	    function JsonPipe() {
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    JsonPipe.prototype.transform = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return JSON.stringify(value, null, 2); };
	    JsonPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'json', pure: false },] },
	    ];
	    /** @nocollapse */
	    JsonPipe.ctorParameters = function () { return []; };
	    return JsonPipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a number according to locale rules.
	 * \@howToUse `number_expression | number[:digitInfo[:locale]]`
	 *
	 * Formats a number as text. Group sizing and separator and other locale-specific
	 * configurations are based on the active locale.
	 *
	 * where `expression` is a number:
	 *  - `digitInfo` is a `string` which has a following format: <br>
	 *     <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
	 *   - `minIntegerDigits` is the minimum number of integer digits to use. Defaults to `1`.
	 *   - `minFractionDigits` is the minimum number of digits after fraction. Defaults to `0`.
	 *   - `maxFractionDigits` is the maximum number of digits after fraction. Defaults to `3`.
	 *  - `locale` is a `string` defining the locale to use (uses the current {\@link LOCALE_ID} by
	 * default)
	 *
	 * For more information on the acceptable range for each of these numbers and other
	 * details see your native internationalization library.
	 *
	 * ### Example
	 *
	 * {\@example common/pipes/ts/number_pipe.ts region='NumberPipe'}
	 *
	 * \@stable
	 */
	var DecimalPipe = /** @class */ (function () {
	    function DecimalPipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} digits
	     * @param {?=} locale
	     * @return {?}
	     */
	    DecimalPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} digits
	     * @param {?=} locale
	     * @return {?}
	     */
	    function (value, digits, locale) {
	        if (isEmpty(value))
	            return null;
	        locale = locale || this._locale;
	        var _a = formatNumber$1(value, locale, NumberFormatStyle.Decimal, digits), str = _a.str, error = _a.error;
	        if (error) {
	            throw invalidPipeArgumentError(DecimalPipe, error);
	        }
	        return str;
	    };
	    DecimalPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'number' },] },
	    ];
	    /** @nocollapse */
	    DecimalPipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return DecimalPipe;
	}());
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a number as a percentage according to locale rules.
	 * \@howToUse `number_expression | percent[:digitInfo[:locale]]`
	 *
	 * \@description
	 *
	 * Formats a number as percentage.
	 *
	 * - `digitInfo` See {\@link DecimalPipe} for detailed description.
	 *  - `locale` is a `string` defining the locale to use (uses the current {\@link LOCALE_ID} by
	 * default)
	 *
	 * ### Example
	 *
	 * {\@example common/pipes/ts/percent_pipe.ts region='PercentPipe'}
	 *
	 * \@stable
	 */
	var PercentPipe = /** @class */ (function () {
	    function PercentPipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} digits
	     * @param {?=} locale
	     * @return {?}
	     */
	    PercentPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} digits
	     * @param {?=} locale
	     * @return {?}
	     */
	    function (value, digits, locale) {
	        if (isEmpty(value))
	            return null;
	        locale = locale || this._locale;
	        var _a = formatNumber$1(value, locale, NumberFormatStyle.Percent, digits), str = _a.str, error = _a.error;
	        if (error) {
	            throw invalidPipeArgumentError(PercentPipe, error);
	        }
	        return str;
	    };
	    PercentPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'percent' },] },
	    ];
	    /** @nocollapse */
	    PercentPipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return PercentPipe;
	}());
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Formats a number as currency using locale rules.
	 * \@howToUse `number_expression | currency[:currencyCode[:display[:digitInfo[:locale]]]]`
	 * \@description
	 *
	 * Use `currency` to format a number as currency.
	 *
	 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
	 *    as `USD` for the US dollar and `EUR` for the euro.
	 * - `display` indicates whether to show the currency symbol or the code.
	 *   - `code`: use code (e.g. `USD`).
	 *   - `symbol`(default): use symbol (e.g. `$`).
	 *   - `symbol-narrow`: some countries have two symbols for their currency, one regular and one
	 *   narrow (e.g. the canadian dollar CAD has the symbol `CA$` and the symbol-narrow `$`).
	 *   - boolean (deprecated from v5): `true` for symbol and false for `code`
	 *   If there is no narrow symbol for the chosen currency, the regular symbol will be used.
	 * - `digitInfo` See {\@link DecimalPipe} for detailed description.
	 *  - `locale` is a `string` defining the locale to use (uses the current {\@link LOCALE_ID} by
	 * default)
	 *
	 * ### Example
	 *
	 * {\@example common/pipes/ts/currency_pipe.ts region='CurrencyPipe'}
	 *
	 * \@stable
	 */
	var CurrencyPipe = /** @class */ (function () {
	    function CurrencyPipe(_locale) {
	        this._locale = _locale;
	    }
	    /**
	     * @param {?} value
	     * @param {?=} currencyCode
	     * @param {?=} display
	     * @param {?=} digits
	     * @param {?=} locale
	     * @return {?}
	     */
	    CurrencyPipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?=} currencyCode
	     * @param {?=} display
	     * @param {?=} digits
	     * @param {?=} locale
	     * @return {?}
	     */
	    function (value, currencyCode, display, digits, locale) {
	        if (display === void 0) { display = 'symbol'; }
	        if (isEmpty(value))
	            return null;
	        locale = locale || this._locale;
	        if (typeof display === 'boolean') {
	            if (/** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	                console.warn("Warning: the currency pipe has been changed in Angular v5. The symbolDisplay option (third parameter) is now a string instead of a boolean. The accepted values are \"code\", \"symbol\" or \"symbol-narrow\".");
	            }
	            display = display ? 'symbol' : 'code';
	        }
	        var /** @type {?} */ currency = currencyCode || 'USD';
	        if (display !== 'code') {
	            currency = getCurrencySymbol(currency, display === 'symbol' ? 'wide' : 'narrow');
	        }
	        var _a = formatNumber$1(value, locale, NumberFormatStyle.Currency, digits, currency), str = _a.str, error = _a.error;
	        if (error) {
	            throw invalidPipeArgumentError(CurrencyPipe, error);
	        }
	        return str;
	    };
	    CurrencyPipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'currency' },] },
	    ];
	    /** @nocollapse */
	    CurrencyPipe.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.LOCALE_ID,] },] },
	    ]; };
	    return CurrencyPipe;
	}());
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function isEmpty(value) {
	    return value == null || value === '' || value !== value;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@ngModule CommonModule
	 * \@whatItDoes Creates a new List or String containing a subset (slice) of the elements.
	 * \@howToUse `array_or_string_expression | slice:start[:end]`
	 * \@description
	 *
	 * Where the input expression is a `List` or `String`, and:
	 * - `start`: The starting index of the subset to return.
	 *   - **a positive integer**: return the item at `start` index and all items after
	 *     in the list or string expression.
	 *   - **a negative integer**: return the item at `start` index from the end and all items after
	 *     in the list or string expression.
	 *   - **if positive and greater than the size of the expression**: return an empty list or string.
	 *   - **if negative and greater than the size of the expression**: return entire list or string.
	 * - `end`: The ending index of the subset to return.
	 *   - **omitted**: return all items until the end.
	 *   - **if positive**: return all items before `end` index of the list or string.
	 *   - **if negative**: return all items before `end` index from the end of the list or string.
	 *
	 * All behavior is based on the expected behavior of the JavaScript API `Array.prototype.slice()`
	 * and `String.prototype.slice()`.
	 *
	 * When operating on a [List], the returned list is always a copy even when all
	 * the elements are being returned.
	 *
	 * When operating on a blank value, the pipe returns the blank value.
	 *
	 * ## List Example
	 *
	 * This `ngFor` example:
	 *
	 * {\@example common/pipes/ts/slice_pipe.ts region='SlicePipe_list'}
	 *
	 * produces the following:
	 *
	 *     <li>b</li>
	 *     <li>c</li>
	 *
	 * ## String Examples
	 *
	 * {\@example common/pipes/ts/slice_pipe.ts region='SlicePipe_string'}
	 *
	 * \@stable
	 */
	var SlicePipe = /** @class */ (function () {
	    function SlicePipe() {
	    }
	    /**
	     * @param {?} value
	     * @param {?} start
	     * @param {?=} end
	     * @return {?}
	     */
	    SlicePipe.prototype.transform = /**
	     * @param {?} value
	     * @param {?} start
	     * @param {?=} end
	     * @return {?}
	     */
	    function (value, start, end) {
	        if (value == null)
	            return value;
	        if (!this.supports(value)) {
	            throw invalidPipeArgumentError(SlicePipe, value);
	        }
	        return value.slice(start, end);
	    };
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    SlicePipe.prototype.supports = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) { return typeof obj === 'string' || Array.isArray(obj); };
	    SlicePipe.decorators = [
	        { type: _angular_core.Pipe, args: [{ name: 'slice', pure: false },] },
	    ];
	    /** @nocollapse */
	    SlicePipe.ctorParameters = function () { return []; };
	    return SlicePipe;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A collection of Angular pipes that are likely to be used in each and every application.
	 */
	var COMMON_PIPES = [
	    AsyncPipe,
	    UpperCasePipe,
	    LowerCasePipe,
	    JsonPipe,
	    SlicePipe,
	    DecimalPipe,
	    PercentPipe,
	    TitleCasePipe,
	    CurrencyPipe,
	    DatePipe,
	    I18nPluralPipe,
	    I18nSelectPipe,
	];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * The module that includes all the basic Angular directives like {\@link NgIf}, {\@link NgForOf}, ...
	 *
	 * \@stable
	 */
	var CommonModule = /** @class */ (function () {
	    function CommonModule() {
	    }
	    CommonModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [COMMON_DIRECTIVES, COMMON_PIPES],
	                    exports: [COMMON_DIRECTIVES, COMMON_PIPES],
	                    providers: [
	                        { provide: NgLocalization, useClass: NgLocaleLocalization },
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    CommonModule.ctorParameters = function () { return []; };
	    return CommonModule;
	}());
	var ɵ0 = getPluralCase;
	/**
	 * A module that contains the deprecated i18n pipes.
	 *
	 * @deprecated from v5
	 */
	var DeprecatedI18NPipesModule = /** @class */ (function () {
	    function DeprecatedI18NPipesModule() {
	    }
	    DeprecatedI18NPipesModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [COMMON_DEPRECATED_I18N_PIPES],
	                    exports: [COMMON_DEPRECATED_I18N_PIPES],
	                    providers: [{ provide: DEPRECATED_PLURAL_FN, useValue: ɵ0 }],
	                },] },
	    ];
	    /** @nocollapse */
	    DeprecatedI18NPipesModule.ctorParameters = function () { return []; };
	    return DeprecatedI18NPipesModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
	 *
	 * Note: Document might not be available in the Application Context when Application and Rendering
	 * Contexts are not the same (e.g. when running the application into a Web Worker).
	 *
	 * \@stable
	 */
	var DOCUMENT = new _angular_core.InjectionToken('DocumentToken');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var PLATFORM_BROWSER_ID = 'browser';
	var PLATFORM_SERVER_ID = 'server';
	var PLATFORM_WORKER_APP_ID = 'browserWorkerApp';
	var PLATFORM_WORKER_UI_ID = 'browserWorkerUi';
	/**
	 * Returns whether a platform id represents a browser platform.
	 * \@experimental
	 * @param {?} platformId
	 * @return {?}
	 */
	function isPlatformBrowser(platformId) {
	    return platformId === PLATFORM_BROWSER_ID;
	}
	/**
	 * Returns whether a platform id represents a server platform.
	 * \@experimental
	 * @param {?} platformId
	 * @return {?}
	 */
	function isPlatformServer(platformId) {
	    return platformId === PLATFORM_SERVER_ID;
	}
	/**
	 * Returns whether a platform id represents a web worker app platform.
	 * \@experimental
	 * @param {?} platformId
	 * @return {?}
	 */
	function isPlatformWorkerApp(platformId) {
	    return platformId === PLATFORM_WORKER_APP_ID;
	}
	/**
	 * Returns whether a platform id represents a web worker UI platform.
	 * \@experimental
	 * @param {?} platformId
	 * @return {?}
	 */
	function isPlatformWorkerUi(platformId) {
	    return platformId === PLATFORM_WORKER_UI_ID;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var VERSION = new _angular_core.Version('5.2.11');
	
	exports.ɵregisterLocaleData = registerLocaleData;
	exports.NgLocaleLocalization = NgLocaleLocalization;
	exports.NgLocalization = NgLocalization;
	exports.registerLocaleData = registerLocaleData;
	exports.Plural = Plural;
	exports.NumberFormatStyle = NumberFormatStyle;
	exports.FormStyle = FormStyle;
	exports.TranslationWidth = TranslationWidth;
	exports.FormatWidth = FormatWidth;
	exports.NumberSymbol = NumberSymbol;
	exports.WeekDay = WeekDay;
	exports.getCurrencySymbol = getCurrencySymbol;
	exports.getLocaleDayPeriods = getLocaleDayPeriods;
	exports.getLocaleDayNames = getLocaleDayNames;
	exports.getLocaleMonthNames = getLocaleMonthNames;
	exports.getLocaleId = getLocaleId;
	exports.getLocaleEraNames = getLocaleEraNames;
	exports.getLocaleWeekEndRange = getLocaleWeekEndRange;
	exports.getLocaleFirstDayOfWeek = getLocaleFirstDayOfWeek;
	exports.getLocaleDateFormat = getLocaleDateFormat;
	exports.getLocaleDateTimeFormat = getLocaleDateTimeFormat;
	exports.getLocaleExtraDayPeriodRules = getLocaleExtraDayPeriodRules;
	exports.getLocaleExtraDayPeriods = getLocaleExtraDayPeriods;
	exports.getLocalePluralCase = getLocalePluralCase;
	exports.getLocaleTimeFormat = getLocaleTimeFormat;
	exports.getLocaleNumberSymbol = getLocaleNumberSymbol;
	exports.getLocaleNumberFormat = getLocaleNumberFormat;
	exports.getLocaleCurrencyName = getLocaleCurrencyName;
	exports.getLocaleCurrencySymbol = getLocaleCurrencySymbol;
	exports.ɵparseCookieValue = parseCookieValue;
	exports.CommonModule = CommonModule;
	exports.DeprecatedI18NPipesModule = DeprecatedI18NPipesModule;
	exports.NgClass = NgClass;
	exports.NgForOf = NgForOf;
	exports.NgForOfContext = NgForOfContext;
	exports.NgIf = NgIf;
	exports.NgIfContext = NgIfContext;
	exports.NgPlural = NgPlural;
	exports.NgPluralCase = NgPluralCase;
	exports.NgStyle = NgStyle;
	exports.NgSwitch = NgSwitch;
	exports.NgSwitchCase = NgSwitchCase;
	exports.NgSwitchDefault = NgSwitchDefault;
	exports.NgTemplateOutlet = NgTemplateOutlet;
	exports.NgComponentOutlet = NgComponentOutlet;
	exports.DOCUMENT = DOCUMENT;
	exports.AsyncPipe = AsyncPipe;
	exports.DatePipe = DatePipe;
	exports.I18nPluralPipe = I18nPluralPipe;
	exports.I18nSelectPipe = I18nSelectPipe;
	exports.JsonPipe = JsonPipe;
	exports.LowerCasePipe = LowerCasePipe;
	exports.CurrencyPipe = CurrencyPipe;
	exports.DecimalPipe = DecimalPipe;
	exports.PercentPipe = PercentPipe;
	exports.SlicePipe = SlicePipe;
	exports.UpperCasePipe = UpperCasePipe;
	exports.TitleCasePipe = TitleCasePipe;
	exports.DeprecatedDatePipe = DeprecatedDatePipe;
	exports.DeprecatedCurrencyPipe = DeprecatedCurrencyPipe;
	exports.DeprecatedDecimalPipe = DeprecatedDecimalPipe;
	exports.DeprecatedPercentPipe = DeprecatedPercentPipe;
	exports.ɵPLATFORM_BROWSER_ID = PLATFORM_BROWSER_ID;
	exports.ɵPLATFORM_SERVER_ID = PLATFORM_SERVER_ID;
	exports.ɵPLATFORM_WORKER_APP_ID = PLATFORM_WORKER_APP_ID;
	exports.ɵPLATFORM_WORKER_UI_ID = PLATFORM_WORKER_UI_ID;
	exports.isPlatformBrowser = isPlatformBrowser;
	exports.isPlatformServer = isPlatformServer;
	exports.isPlatformWorkerApp = isPlatformWorkerApp;
	exports.isPlatformWorkerUi = isPlatformWorkerUi;
	exports.VERSION = VERSION;
	exports.PlatformLocation = PlatformLocation;
	exports.LOCATION_INITIALIZED = LOCATION_INITIALIZED;
	exports.LocationStrategy = LocationStrategy;
	exports.APP_BASE_HREF = APP_BASE_HREF;
	exports.HashLocationStrategy = HashLocationStrategy;
	exports.PathLocationStrategy = PathLocationStrategy;
	exports.Location = Location;
	exports.ɵe = COMMON_DIRECTIVES;
	exports.ɵd = findLocaleData;
	exports.ɵa = DEPRECATED_PLURAL_FN;
	exports.ɵb = getPluralCase;
	exports.ɵg = COMMON_DEPRECATED_I18N_PIPES;
	exports.ɵf = COMMON_PIPES;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=common.umd.js.map


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(246), __webpack_require__(205)) :
		typeof define === 'function' && define.amd ? define('@angular/platform-browser', ['exports', '@angular/common', '@angular/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.platformBrowser = {}),global.ng.common,global.ng.core));
	}(this, (function (exports,_angular_common,_angular_core) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _DOM = /** @type {?} */ ((null));
	/**
	 * @return {?}
	 */
	function getDOM() {
	    return _DOM;
	}
	/**
	 * @param {?} adapter
	 * @return {?}
	 */
	
	/**
	 * @param {?} adapter
	 * @return {?}
	 */
	function setRootDomAdapter(adapter) {
	    if (!_DOM) {
	        _DOM = adapter;
	    }
	}
	/**
	 * Provides DOM operations in an environment-agnostic way.
	 *
	 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
	 * can introduce XSS risks.
	 * @abstract
	 */
	var DomAdapter = /** @class */ (function () {
	    function DomAdapter() {
	        this.resourceLoaderType = /** @type {?} */ ((null));
	    }
	    Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
	        /**
	         * Maps attribute names to their corresponding property names for cases
	         * where attribute name doesn't match property name.
	         */
	        get: /**
	         * Maps attribute names to their corresponding property names for cases
	         * where attribute name doesn't match property name.
	         * @return {?}
	         */
	        function () { return this._attrToPropMap; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._attrToPropMap = value; },
	        enumerable: true,
	        configurable: true
	    });
	    return DomAdapter;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Provides DOM operations in any browser environment.
	 *
	 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
	 * can introduce XSS risks.
	 * @abstract
	 */
	var GenericBrowserDomAdapter = /** @class */ (function (_super) {
	    __extends(GenericBrowserDomAdapter, _super);
	    function GenericBrowserDomAdapter() {
	        var _this = _super.call(this) || this;
	        _this._animationPrefix = null;
	        _this._transitionEnd = null;
	        try {
	            var /** @type {?} */ element_1 = _this.createElement('div', document);
	            if (_this.getStyle(element_1, 'animationName') != null) {
	                _this._animationPrefix = '';
	            }
	            else {
	                var /** @type {?} */ domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
	                for (var /** @type {?} */ i = 0; i < domPrefixes.length; i++) {
	                    if (_this.getStyle(element_1, domPrefixes[i] + 'AnimationName') != null) {
	                        _this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
	                        break;
	                    }
	                }
	            }
	            var /** @type {?} */ transEndEventNames_1 = {
	                WebkitTransition: 'webkitTransitionEnd',
	                MozTransition: 'transitionend',
	                OTransition: 'oTransitionEnd otransitionend',
	                transition: 'transitionend'
	            };
	            Object.keys(transEndEventNames_1).forEach(function (key) {
	                if (_this.getStyle(element_1, key) != null) {
	                    _this._transitionEnd = transEndEventNames_1[key];
	                }
	            });
	        }
	        catch (/** @type {?} */ e) {
	            _this._animationPrefix = null;
	            _this._transitionEnd = null;
	        }
	        return _this;
	    }
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.getDistributedNodes = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return (/** @type {?} */ (el)).getDistributedNodes(); };
	    /**
	     * @param {?} el
	     * @param {?} baseUrl
	     * @param {?} href
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.resolveAndSetHref = /**
	     * @param {?} el
	     * @param {?} baseUrl
	     * @param {?} href
	     * @return {?}
	     */
	    function (el, baseUrl, href) {
	        el.href = href == null ? baseUrl : baseUrl + '/../' + href;
	    };
	    /**
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.supportsDOMEvents = /**
	     * @return {?}
	     */
	    function () { return true; };
	    /**
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = /**
	     * @return {?}
	     */
	    function () {
	        return typeof (/** @type {?} */ (document.body)).createShadowRoot === 'function';
	    };
	    /**
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.getAnimationPrefix = /**
	     * @return {?}
	     */
	    function () { return this._animationPrefix ? this._animationPrefix : ''; };
	    /**
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.getTransitionEnd = /**
	     * @return {?}
	     */
	    function () { return this._transitionEnd ? this._transitionEnd : ''; };
	    /**
	     * @return {?}
	     */
	    GenericBrowserDomAdapter.prototype.supportsAnimation = /**
	     * @return {?}
	     */
	    function () {
	        return this._animationPrefix != null && this._transitionEnd != null;
	    };
	    return GenericBrowserDomAdapter;
	}(DomAdapter));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _attrToPropMap = {
	    'class': 'className',
	    'innerHtml': 'innerHTML',
	    'readonly': 'readOnly',
	    'tabindex': 'tabIndex',
	};
	var DOM_KEY_LOCATION_NUMPAD = 3;
	// Map to convert some key or keyIdentifier values to what will be returned by getEventKey
	var _keyMap = {
	    // The following values are here for cross-browser compatibility and to match the W3C standard
	    // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
	    '\b': 'Backspace',
	    '\t': 'Tab',
	    '\x7F': 'Delete',
	    '\x1B': 'Escape',
	    'Del': 'Delete',
	    'Esc': 'Escape',
	    'Left': 'ArrowLeft',
	    'Right': 'ArrowRight',
	    'Up': 'ArrowUp',
	    'Down': 'ArrowDown',
	    'Menu': 'ContextMenu',
	    'Scroll': 'ScrollLock',
	    'Win': 'OS'
	};
	// There is a bug in Chrome for numeric keypad keys:
	// https://code.google.com/p/chromium/issues/detail?id=155654
	// 1, 2, 3 ... are reported as A, B, C ...
	var _chromeNumKeyPadMap = {
	    'A': '1',
	    'B': '2',
	    'C': '3',
	    'D': '4',
	    'E': '5',
	    'F': '6',
	    'G': '7',
	    'H': '8',
	    'I': '9',
	    'J': '*',
	    'K': '+',
	    'M': '-',
	    'N': '.',
	    'O': '/',
	    '\x60': '0',
	    '\x90': 'NumLock'
	};
	var nodeContains;
	if (_angular_core.ɵglobal['Node']) {
	    nodeContains = _angular_core.ɵglobal['Node'].prototype.contains || function (node) {
	        return !!(this.compareDocumentPosition(node) & 16);
	    };
	}
	/**
	 * A `DomAdapter` powered by full browser DOM APIs.
	 *
	 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
	 * can introduce XSS risks.
	 */
	var BrowserDomAdapter = /** @class */ (function (_super) {
	    __extends(BrowserDomAdapter, _super);
	    function BrowserDomAdapter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} templateHtml
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.parse = /**
	     * @param {?} templateHtml
	     * @return {?}
	     */
	    function (templateHtml) { throw new Error('parse not implemented'); };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.makeCurrent = /**
	     * @return {?}
	     */
	    function () { setRootDomAdapter(new BrowserDomAdapter()); };
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.hasProperty = /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    function (element, name) { return name in element; };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setProperty = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, name, value) { (/** @type {?} */ (el))[name] = value; };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getProperty = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) { return (/** @type {?} */ (el))[name]; };
	    /**
	     * @param {?} el
	     * @param {?} methodName
	     * @param {?} args
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.invoke = /**
	     * @param {?} el
	     * @param {?} methodName
	     * @param {?} args
	     * @return {?}
	     */
	    function (el, methodName, args) {
	        (_a = (/** @type {?} */ (el)))[methodName].apply(_a, args);
	        var _a;
	    };
	    // TODO(tbosch): move this into a separate environment class once we have it
	    /**
	     * @param {?} error
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.logError = /**
	     * @param {?} error
	     * @return {?}
	     */
	    function (error) {
	        if (window.console) {
	            if (console.error) {
	                console.error(error);
	            }
	            else {
	                console.log(error);
	            }
	        }
	    };
	    /**
	     * @param {?} error
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.log = /**
	     * @param {?} error
	     * @return {?}
	     */
	    function (error) {
	        if (window.console) {
	            window.console.log && window.console.log(error);
	        }
	    };
	    /**
	     * @param {?} error
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.logGroup = /**
	     * @param {?} error
	     * @return {?}
	     */
	    function (error) {
	        if (window.console) {
	            window.console.group && window.console.group(error);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.logGroupEnd = /**
	     * @return {?}
	     */
	    function () {
	        if (window.console) {
	            window.console.groupEnd && window.console.groupEnd();
	        }
	    };
	    Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
	        get: /**
	         * @return {?}
	         */
	        function () { return _attrToPropMap; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} nodeA
	     * @param {?} nodeB
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.contains = /**
	     * @param {?} nodeA
	     * @param {?} nodeB
	     * @return {?}
	     */
	    function (nodeA, nodeB) { return nodeContains.call(nodeA, nodeB); };
	    /**
	     * @param {?} el
	     * @param {?} selector
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.querySelector = /**
	     * @param {?} el
	     * @param {?} selector
	     * @return {?}
	     */
	    function (el, selector) { return el.querySelector(selector); };
	    /**
	     * @param {?} el
	     * @param {?} selector
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.querySelectorAll = /**
	     * @param {?} el
	     * @param {?} selector
	     * @return {?}
	     */
	    function (el, selector) { return el.querySelectorAll(selector); };
	    /**
	     * @param {?} el
	     * @param {?} evt
	     * @param {?} listener
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.on = /**
	     * @param {?} el
	     * @param {?} evt
	     * @param {?} listener
	     * @return {?}
	     */
	    function (el, evt, listener) { el.addEventListener(evt, listener, false); };
	    /**
	     * @param {?} el
	     * @param {?} evt
	     * @param {?} listener
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.onAndCancel = /**
	     * @param {?} el
	     * @param {?} evt
	     * @param {?} listener
	     * @return {?}
	     */
	    function (el, evt, listener) {
	        el.addEventListener(evt, listener, false);
	        // Needed to follow Dart's subscription semantic, until fix of
	        // https://code.google.com/p/dart/issues/detail?id=17406
	        return function () { el.removeEventListener(evt, listener, false); };
	    };
	    /**
	     * @param {?} el
	     * @param {?} evt
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.dispatchEvent = /**
	     * @param {?} el
	     * @param {?} evt
	     * @return {?}
	     */
	    function (el, evt) { el.dispatchEvent(evt); };
	    /**
	     * @param {?} eventType
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createMouseEvent = /**
	     * @param {?} eventType
	     * @return {?}
	     */
	    function (eventType) {
	        var /** @type {?} */ evt = this.getDefaultDocument().createEvent('MouseEvent');
	        evt.initEvent(eventType, true, true);
	        return evt;
	    };
	    /**
	     * @param {?} eventType
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createEvent = /**
	     * @param {?} eventType
	     * @return {?}
	     */
	    function (eventType) {
	        var /** @type {?} */ evt = this.getDefaultDocument().createEvent('Event');
	        evt.initEvent(eventType, true, true);
	        return evt;
	    };
	    /**
	     * @param {?} evt
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.preventDefault = /**
	     * @param {?} evt
	     * @return {?}
	     */
	    function (evt) {
	        evt.preventDefault();
	        evt.returnValue = false;
	    };
	    /**
	     * @param {?} evt
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.isPrevented = /**
	     * @param {?} evt
	     * @return {?}
	     */
	    function (evt) {
	        return evt.defaultPrevented || evt.returnValue != null && !evt.returnValue;
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getInnerHTML = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.innerHTML; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getTemplateContent = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        return 'content' in el && this.isTemplateElement(el) ? (/** @type {?} */ (el)).content : null;
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getOuterHTML = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.outerHTML; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.nodeName = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.nodeName; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.nodeValue = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.nodeValue; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.type = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.type; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.content = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        if (this.hasProperty(node, 'content')) {
	            return (/** @type {?} */ (node)).content;
	        }
	        else {
	            return node;
	        }
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.firstChild = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.firstChild; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.nextSibling = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.nextSibling; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.parentElement = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.parentNode; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.childNodes = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.childNodes; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.childNodesAsList = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        var /** @type {?} */ childNodes = el.childNodes;
	        var /** @type {?} */ res = new Array(childNodes.length);
	        for (var /** @type {?} */ i = 0; i < childNodes.length; i++) {
	            res[i] = childNodes[i];
	        }
	        return res;
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.clearNodes = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        while (el.firstChild) {
	            el.removeChild(el.firstChild);
	        }
	    };
	    /**
	     * @param {?} el
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.appendChild = /**
	     * @param {?} el
	     * @param {?} node
	     * @return {?}
	     */
	    function (el, node) { el.appendChild(node); };
	    /**
	     * @param {?} el
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.removeChild = /**
	     * @param {?} el
	     * @param {?} node
	     * @return {?}
	     */
	    function (el, node) { el.removeChild(node); };
	    /**
	     * @param {?} el
	     * @param {?} newChild
	     * @param {?} oldChild
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.replaceChild = /**
	     * @param {?} el
	     * @param {?} newChild
	     * @param {?} oldChild
	     * @return {?}
	     */
	    function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.remove = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        if (node.parentNode) {
	            node.parentNode.removeChild(node);
	        }
	        return node;
	    };
	    /**
	     * @param {?} parent
	     * @param {?} ref
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.insertBefore = /**
	     * @param {?} parent
	     * @param {?} ref
	     * @param {?} node
	     * @return {?}
	     */
	    function (parent, ref, node) { parent.insertBefore(node, ref); };
	    /**
	     * @param {?} parent
	     * @param {?} ref
	     * @param {?} nodes
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.insertAllBefore = /**
	     * @param {?} parent
	     * @param {?} ref
	     * @param {?} nodes
	     * @return {?}
	     */
	    function (parent, ref, nodes) {
	        nodes.forEach(function (n) { return parent.insertBefore(n, ref); });
	    };
	    /**
	     * @param {?} parent
	     * @param {?} ref
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.insertAfter = /**
	     * @param {?} parent
	     * @param {?} ref
	     * @param {?} node
	     * @return {?}
	     */
	    function (parent, ref, node) { parent.insertBefore(node, ref.nextSibling); };
	    /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setInnerHTML = /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, value) { el.innerHTML = value; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getText = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.textContent; };
	    /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setText = /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, value) { el.textContent = value; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getValue = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.value; };
	    /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setValue = /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, value) { el.value = value; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getChecked = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return el.checked; };
	    /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setChecked = /**
	     * @param {?} el
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, value) { el.checked = value; };
	    /**
	     * @param {?} text
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createComment = /**
	     * @param {?} text
	     * @return {?}
	     */
	    function (text) { return this.getDefaultDocument().createComment(text); };
	    /**
	     * @param {?} html
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createTemplate = /**
	     * @param {?} html
	     * @return {?}
	     */
	    function (html) {
	        var /** @type {?} */ t = this.getDefaultDocument().createElement('template');
	        t.innerHTML = html;
	        return t;
	    };
	    /**
	     * @param {?} tagName
	     * @param {?=} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createElement = /**
	     * @param {?} tagName
	     * @param {?=} doc
	     * @return {?}
	     */
	    function (tagName, doc) {
	        doc = doc || this.getDefaultDocument();
	        return doc.createElement(tagName);
	    };
	    /**
	     * @param {?} ns
	     * @param {?} tagName
	     * @param {?=} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createElementNS = /**
	     * @param {?} ns
	     * @param {?} tagName
	     * @param {?=} doc
	     * @return {?}
	     */
	    function (ns, tagName, doc) {
	        doc = doc || this.getDefaultDocument();
	        return doc.createElementNS(ns, tagName);
	    };
	    /**
	     * @param {?} text
	     * @param {?=} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createTextNode = /**
	     * @param {?} text
	     * @param {?=} doc
	     * @return {?}
	     */
	    function (text, doc) {
	        doc = doc || this.getDefaultDocument();
	        return doc.createTextNode(text);
	    };
	    /**
	     * @param {?} attrName
	     * @param {?} attrValue
	     * @param {?=} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createScriptTag = /**
	     * @param {?} attrName
	     * @param {?} attrValue
	     * @param {?=} doc
	     * @return {?}
	     */
	    function (attrName, attrValue, doc) {
	        doc = doc || this.getDefaultDocument();
	        var /** @type {?} */ el = /** @type {?} */ (doc.createElement('SCRIPT'));
	        el.setAttribute(attrName, attrValue);
	        return el;
	    };
	    /**
	     * @param {?} css
	     * @param {?=} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createStyleElement = /**
	     * @param {?} css
	     * @param {?=} doc
	     * @return {?}
	     */
	    function (css, doc) {
	        doc = doc || this.getDefaultDocument();
	        var /** @type {?} */ style = /** @type {?} */ (doc.createElement('style'));
	        this.appendChild(style, this.createTextNode(css, doc));
	        return style;
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createShadowRoot = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return (/** @type {?} */ (el)).createShadowRoot(); };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getShadowRoot = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return (/** @type {?} */ (el)).shadowRoot; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getHost = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return (/** @type {?} */ (el)).host; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.clone = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.cloneNode(true); };
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getElementsByClassName = /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    function (element, name) {
	        return element.getElementsByClassName(name);
	    };
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getElementsByTagName = /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    function (element, name) {
	        return element.getElementsByTagName(name);
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.classList = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) { return Array.prototype.slice.call(element.classList, 0); };
	    /**
	     * @param {?} element
	     * @param {?} className
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.addClass = /**
	     * @param {?} element
	     * @param {?} className
	     * @return {?}
	     */
	    function (element, className) { element.classList.add(className); };
	    /**
	     * @param {?} element
	     * @param {?} className
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.removeClass = /**
	     * @param {?} element
	     * @param {?} className
	     * @return {?}
	     */
	    function (element, className) { element.classList.remove(className); };
	    /**
	     * @param {?} element
	     * @param {?} className
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.hasClass = /**
	     * @param {?} element
	     * @param {?} className
	     * @return {?}
	     */
	    function (element, className) {
	        return element.classList.contains(className);
	    };
	    /**
	     * @param {?} element
	     * @param {?} styleName
	     * @param {?} styleValue
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setStyle = /**
	     * @param {?} element
	     * @param {?} styleName
	     * @param {?} styleValue
	     * @return {?}
	     */
	    function (element, styleName, styleValue) {
	        element.style[styleName] = styleValue;
	    };
	    /**
	     * @param {?} element
	     * @param {?} stylename
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.removeStyle = /**
	     * @param {?} element
	     * @param {?} stylename
	     * @return {?}
	     */
	    function (element, stylename) {
	        // IE requires '' instead of null
	        // see https://github.com/angular/angular/issues/7916
	        element.style[stylename] = '';
	    };
	    /**
	     * @param {?} element
	     * @param {?} stylename
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getStyle = /**
	     * @param {?} element
	     * @param {?} stylename
	     * @return {?}
	     */
	    function (element, stylename) { return element.style[stylename]; };
	    /**
	     * @param {?} element
	     * @param {?} styleName
	     * @param {?=} styleValue
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.hasStyle = /**
	     * @param {?} element
	     * @param {?} styleName
	     * @param {?=} styleValue
	     * @return {?}
	     */
	    function (element, styleName, styleValue) {
	        var /** @type {?} */ value = this.getStyle(element, styleName) || '';
	        return styleValue ? value == styleValue : value.length > 0;
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.tagName = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) { return element.tagName; };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.attributeMap = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ res = new Map();
	        var /** @type {?} */ elAttrs = element.attributes;
	        for (var /** @type {?} */ i = 0; i < elAttrs.length; i++) {
	            var /** @type {?} */ attrib = elAttrs.item(i);
	            res.set(attrib.name, attrib.value);
	        }
	        return res;
	    };
	    /**
	     * @param {?} element
	     * @param {?} attribute
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.hasAttribute = /**
	     * @param {?} element
	     * @param {?} attribute
	     * @return {?}
	     */
	    function (element, attribute) {
	        return element.hasAttribute(attribute);
	    };
	    /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} attribute
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.hasAttributeNS = /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} attribute
	     * @return {?}
	     */
	    function (element, ns, attribute) {
	        return element.hasAttributeNS(ns, attribute);
	    };
	    /**
	     * @param {?} element
	     * @param {?} attribute
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getAttribute = /**
	     * @param {?} element
	     * @param {?} attribute
	     * @return {?}
	     */
	    function (element, attribute) {
	        return element.getAttribute(attribute);
	    };
	    /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getAttributeNS = /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} name
	     * @return {?}
	     */
	    function (element, ns, name) {
	        return element.getAttributeNS(ns, name);
	    };
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setAttribute = /**
	     * @param {?} element
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (element, name, value) { element.setAttribute(name, value); };
	    /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setAttributeNS = /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (element, ns, name, value) {
	        element.setAttributeNS(ns, name, value);
	    };
	    /**
	     * @param {?} element
	     * @param {?} attribute
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.removeAttribute = /**
	     * @param {?} element
	     * @param {?} attribute
	     * @return {?}
	     */
	    function (element, attribute) { element.removeAttribute(attribute); };
	    /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.removeAttributeNS = /**
	     * @param {?} element
	     * @param {?} ns
	     * @param {?} name
	     * @return {?}
	     */
	    function (element, ns, name) {
	        element.removeAttributeNS(ns, name);
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.templateAwareRoot = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.createHtmlDocument = /**
	     * @return {?}
	     */
	    function () {
	        return document.implementation.createHTMLDocument('fakeTitle');
	    };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getDefaultDocument = /**
	     * @return {?}
	     */
	    function () { return document; };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getBoundingClientRect = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        try {
	            return el.getBoundingClientRect();
	        }
	        catch (/** @type {?} */ e) {
	            return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
	        }
	    };
	    /**
	     * @param {?} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getTitle = /**
	     * @param {?} doc
	     * @return {?}
	     */
	    function (doc) { return doc.title; };
	    /**
	     * @param {?} doc
	     * @param {?} newTitle
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setTitle = /**
	     * @param {?} doc
	     * @param {?} newTitle
	     * @return {?}
	     */
	    function (doc, newTitle) { doc.title = newTitle || ''; };
	    /**
	     * @param {?} n
	     * @param {?} selector
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.elementMatches = /**
	     * @param {?} n
	     * @param {?} selector
	     * @return {?}
	     */
	    function (n, selector) {
	        if (this.isElementNode(n)) {
	            return n.matches && n.matches(selector) ||
	                n.msMatchesSelector && n.msMatchesSelector(selector) ||
	                n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
	        }
	        return false;
	    };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.isTemplateElement = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        return this.isElementNode(el) && el.nodeName === 'TEMPLATE';
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.isTextNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.nodeType === Node.TEXT_NODE; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.isCommentNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.nodeType === Node.COMMENT_NODE; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.isElementNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.nodeType === Node.ELEMENT_NODE; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.hasShadowRoot = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        return node.shadowRoot != null && node instanceof HTMLElement;
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.isShadowRoot = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node instanceof DocumentFragment; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.importIntoDoc = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return document.importNode(this.templateAwareRoot(node), true); };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.adoptNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return document.adoptNode(node); };
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getHref = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) { return /** @type {?} */ ((el.getAttribute('href'))); };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getEventKey = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ key = event.key;
	        if (key == null) {
	            key = event.keyIdentifier;
	            // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
	            // Safari cf
	            // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
	            if (key == null) {
	                return 'Unidentified';
	            }
	            if (key.startsWith('U+')) {
	                key = String.fromCharCode(parseInt(key.substring(2), 16));
	                if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
	                    // There is a bug in Chrome for numeric keypad keys:
	                    // https://code.google.com/p/chromium/issues/detail?id=155654
	                    // 1, 2, 3 ... are reported as A, B, C ...
	                    key = (/** @type {?} */ (_chromeNumKeyPadMap))[key];
	                }
	            }
	        }
	        return _keyMap[key] || key;
	    };
	    /**
	     * @param {?} doc
	     * @param {?} target
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getGlobalEventTarget = /**
	     * @param {?} doc
	     * @param {?} target
	     * @return {?}
	     */
	    function (doc, target) {
	        if (target === 'window') {
	            return window;
	        }
	        if (target === 'document') {
	            return doc;
	        }
	        if (target === 'body') {
	            return doc.body;
	        }
	        return null;
	    };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getHistory = /**
	     * @return {?}
	     */
	    function () { return window.history; };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getLocation = /**
	     * @return {?}
	     */
	    function () { return window.location; };
	    /**
	     * @param {?} doc
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getBaseHref = /**
	     * @param {?} doc
	     * @return {?}
	     */
	    function (doc) {
	        var /** @type {?} */ href = getBaseElementHref();
	        return href == null ? null : relativePath(href);
	    };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.resetBaseElement = /**
	     * @return {?}
	     */
	    function () { baseElement = null; };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getUserAgent = /**
	     * @return {?}
	     */
	    function () { return window.navigator.userAgent; };
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setData = /**
	     * @param {?} element
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (element, name, value) {
	        this.setAttribute(element, 'data-' + name, value);
	    };
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getData = /**
	     * @param {?} element
	     * @param {?} name
	     * @return {?}
	     */
	    function (element, name) {
	        return this.getAttribute(element, 'data-' + name);
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getComputedStyle = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) { return getComputedStyle(element); };
	    // TODO(tbosch): move this into a separate environment class once we have it
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.supportsWebAnimation = /**
	     * @return {?}
	     */
	    function () {
	        return typeof (/** @type {?} */ (Element)).prototype['animate'] === 'function';
	    };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.performanceNow = /**
	     * @return {?}
	     */
	    function () {
	        // performance.now() is not available in all browsers, see
	        // http://caniuse.com/#search=performance.now
	        return window.performance && window.performance.now ? window.performance.now() :
	            new Date().getTime();
	    };
	    /**
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.supportsCookies = /**
	     * @return {?}
	     */
	    function () { return true; };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.getCookie = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return _angular_common.ɵparseCookieValue(document.cookie, name); };
	    /**
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    BrowserDomAdapter.prototype.setCookie = /**
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (name, value) {
	        // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
	        // not clear other cookies.
	        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    };
	    return BrowserDomAdapter;
	}(GenericBrowserDomAdapter));
	var baseElement = null;
	/**
	 * @return {?}
	 */
	function getBaseElementHref() {
	    if (!baseElement) {
	        baseElement = /** @type {?} */ ((document.querySelector('base')));
	        if (!baseElement) {
	            return null;
	        }
	    }
	    return baseElement.getAttribute('href');
	}
	// based on urlUtils.js in AngularJS 1
	var urlParsingNode;
	/**
	 * @param {?} url
	 * @return {?}
	 */
	function relativePath(url) {
	    if (!urlParsingNode) {
	        urlParsingNode = document.createElement('a');
	    }
	    urlParsingNode.setAttribute('href', url);
	    return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
	        '/' + urlParsingNode.pathname;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
	 *
	 * Note: Document might not be available in the Application Context when Application and Rendering
	 * Contexts are not the same (e.g. when running the application into a Web Worker).
	 *
	 * @deprecated import from `\@angular/common` instead.
	 */
	var DOCUMENT$1 = _angular_common.DOCUMENT;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @return {?}
	 */
	function supportsState() {
	    return !!window.history.pushState;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
	 * This class should not be used directly by an application developer. Instead, use
	 * {\@link Location}.
	 */
	var BrowserPlatformLocation = /** @class */ (function (_super) {
	    __extends(BrowserPlatformLocation, _super);
	    function BrowserPlatformLocation(_doc) {
	        var _this = _super.call(this) || this;
	        _this._doc = _doc;
	        _this._init();
	        return _this;
	    }
	    // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype._init = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        (/** @type {?} */ (this)).location = getDOM().getLocation();
	        this._history = getDOM().getHistory();
	    };
	    /**
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.getBaseHrefFromDOM = /**
	     * @return {?}
	     */
	    function () { return /** @type {?} */ ((getDOM().getBaseHref(this._doc))); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.onPopState = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('popstate', fn, false);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.onHashChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('hashchange', fn, false);
	    };
	    Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.location.pathname; },
	        set: /**
	         * @param {?} newPath
	         * @return {?}
	         */
	        function (newPath) { this.location.pathname = newPath; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.location.search; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.location.hash; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.pushState = /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @return {?}
	     */
	    function (state, title, url) {
	        if (supportsState()) {
	            this._history.pushState(state, title, url);
	        }
	        else {
	            this.location.hash = url;
	        }
	    };
	    /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.replaceState = /**
	     * @param {?} state
	     * @param {?} title
	     * @param {?} url
	     * @return {?}
	     */
	    function (state, title, url) {
	        if (supportsState()) {
	            this._history.replaceState(state, title, url);
	        }
	        else {
	            this.location.hash = url;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.forward = /**
	     * @return {?}
	     */
	    function () { this._history.forward(); };
	    /**
	     * @return {?}
	     */
	    BrowserPlatformLocation.prototype.back = /**
	     * @return {?}
	     */
	    function () { this._history.back(); };
	    BrowserPlatformLocation.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BrowserPlatformLocation.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	    ]; };
	    return BrowserPlatformLocation;
	}(_angular_common.PlatformLocation));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A service that can be used to get and add meta tags.
	 *
	 * \@experimental
	 */
	var Meta = /** @class */ (function () {
	    function Meta(_doc) {
	        this._doc = _doc;
	        this._dom = getDOM();
	    }
	    /**
	     * @param {?} tag
	     * @param {?=} forceCreation
	     * @return {?}
	     */
	    Meta.prototype.addTag = /**
	     * @param {?} tag
	     * @param {?=} forceCreation
	     * @return {?}
	     */
	    function (tag, forceCreation) {
	        if (forceCreation === void 0) { forceCreation = false; }
	        if (!tag)
	            return null;
	        return this._getOrCreateElement(tag, forceCreation);
	    };
	    /**
	     * @param {?} tags
	     * @param {?=} forceCreation
	     * @return {?}
	     */
	    Meta.prototype.addTags = /**
	     * @param {?} tags
	     * @param {?=} forceCreation
	     * @return {?}
	     */
	    function (tags, forceCreation) {
	        var _this = this;
	        if (forceCreation === void 0) { forceCreation = false; }
	        if (!tags)
	            return [];
	        return tags.reduce(function (result, tag) {
	            if (tag) {
	                result.push(_this._getOrCreateElement(tag, forceCreation));
	            }
	            return result;
	        }, []);
	    };
	    /**
	     * @param {?} attrSelector
	     * @return {?}
	     */
	    Meta.prototype.getTag = /**
	     * @param {?} attrSelector
	     * @return {?}
	     */
	    function (attrSelector) {
	        if (!attrSelector)
	            return null;
	        return this._dom.querySelector(this._doc, "meta[" + attrSelector + "]") || null;
	    };
	    /**
	     * @param {?} attrSelector
	     * @return {?}
	     */
	    Meta.prototype.getTags = /**
	     * @param {?} attrSelector
	     * @return {?}
	     */
	    function (attrSelector) {
	        if (!attrSelector)
	            return [];
	        var /** @type {?} */ list = this._dom.querySelectorAll(this._doc, "meta[" + attrSelector + "]");
	        return list ? [].slice.call(list) : [];
	    };
	    /**
	     * @param {?} tag
	     * @param {?=} selector
	     * @return {?}
	     */
	    Meta.prototype.updateTag = /**
	     * @param {?} tag
	     * @param {?=} selector
	     * @return {?}
	     */
	    function (tag, selector) {
	        if (!tag)
	            return null;
	        selector = selector || this._parseSelector(tag);
	        var /** @type {?} */ meta = /** @type {?} */ ((this.getTag(selector)));
	        if (meta) {
	            return this._setMetaElementAttributes(tag, meta);
	        }
	        return this._getOrCreateElement(tag, true);
	    };
	    /**
	     * @param {?} attrSelector
	     * @return {?}
	     */
	    Meta.prototype.removeTag = /**
	     * @param {?} attrSelector
	     * @return {?}
	     */
	    function (attrSelector) { this.removeTagElement(/** @type {?} */ ((this.getTag(attrSelector)))); };
	    /**
	     * @param {?} meta
	     * @return {?}
	     */
	    Meta.prototype.removeTagElement = /**
	     * @param {?} meta
	     * @return {?}
	     */
	    function (meta) {
	        if (meta) {
	            this._dom.remove(meta);
	        }
	    };
	    /**
	     * @param {?} meta
	     * @param {?=} forceCreation
	     * @return {?}
	     */
	    Meta.prototype._getOrCreateElement = /**
	     * @param {?} meta
	     * @param {?=} forceCreation
	     * @return {?}
	     */
	    function (meta, forceCreation) {
	        if (forceCreation === void 0) { forceCreation = false; }
	        if (!forceCreation) {
	            var /** @type {?} */ selector = this._parseSelector(meta);
	            var /** @type {?} */ elem = /** @type {?} */ ((this.getTag(selector)));
	            // It's allowed to have multiple elements with the same name so it's not enough to
	            // just check that element with the same name already present on the page. We also need to
	            // check if element has tag attributes
	            if (elem && this._containsAttributes(meta, elem))
	                return elem;
	        }
	        var /** @type {?} */ element = /** @type {?} */ (this._dom.createElement('meta'));
	        this._setMetaElementAttributes(meta, element);
	        var /** @type {?} */ head = this._dom.getElementsByTagName(this._doc, 'head')[0];
	        this._dom.appendChild(head, element);
	        return element;
	    };
	    /**
	     * @param {?} tag
	     * @param {?} el
	     * @return {?}
	     */
	    Meta.prototype._setMetaElementAttributes = /**
	     * @param {?} tag
	     * @param {?} el
	     * @return {?}
	     */
	    function (tag, el) {
	        var _this = this;
	        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
	        return el;
	    };
	    /**
	     * @param {?} tag
	     * @return {?}
	     */
	    Meta.prototype._parseSelector = /**
	     * @param {?} tag
	     * @return {?}
	     */
	    function (tag) {
	        var /** @type {?} */ attr = tag.name ? 'name' : 'property';
	        return attr + "=\"" + tag[attr] + "\"";
	    };
	    /**
	     * @param {?} tag
	     * @param {?} elem
	     * @return {?}
	     */
	    Meta.prototype._containsAttributes = /**
	     * @param {?} tag
	     * @param {?} elem
	     * @return {?}
	     */
	    function (tag, elem) {
	        var _this = this;
	        return Object.keys(tag).every(function (key) { return _this._dom.getAttribute(elem, key) === tag[key]; });
	    };
	    Meta.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Meta.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	    ]; };
	    return Meta;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An id that identifies a particular application being bootstrapped, that should
	 * match across the client/server boundary.
	 */
	var TRANSITION_ID = new _angular_core.InjectionToken('TRANSITION_ID');
	/**
	 * @param {?} transitionId
	 * @param {?} document
	 * @param {?} injector
	 * @return {?}
	 */
	function appInitializerFactory(transitionId, document, injector) {
	    return function () {
	        // Wait for all application initializers to be completed before removing the styles set by
	        // the server.
	        injector.get(_angular_core.ApplicationInitStatus).donePromise.then(function () {
	            var /** @type {?} */ dom = getDOM();
	            var /** @type {?} */ styles = Array.prototype.slice.apply(dom.querySelectorAll(document, "style[ng-transition]"));
	            styles.filter(function (el) { return dom.getAttribute(el, 'ng-transition') === transitionId; })
	                .forEach(function (el) { return dom.remove(el); });
	        });
	    };
	}
	var SERVER_TRANSITION_PROVIDERS = [
	    {
	        provide: _angular_core.APP_INITIALIZER,
	        useFactory: appInitializerFactory,
	        deps: [TRANSITION_ID, DOCUMENT$1, _angular_core.Injector],
	        multi: true
	    },
	];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var BrowserGetTestability = /** @class */ (function () {
	    function BrowserGetTestability() {
	    }
	    /**
	     * @return {?}
	     */
	    BrowserGetTestability.init = /**
	     * @return {?}
	     */
	    function () { _angular_core.setTestabilityGetter(new BrowserGetTestability()); };
	    /**
	     * @param {?} registry
	     * @return {?}
	     */
	    BrowserGetTestability.prototype.addToWindow = /**
	     * @param {?} registry
	     * @return {?}
	     */
	    function (registry) {
	        _angular_core.ɵglobal['getAngularTestability'] = function (elem, findInAncestors) {
	            if (findInAncestors === void 0) { findInAncestors = true; }
	            var /** @type {?} */ testability = registry.findTestabilityInTree(elem, findInAncestors);
	            if (testability == null) {
	                throw new Error('Could not find testability for element.');
	            }
	            return testability;
	        };
	        _angular_core.ɵglobal['getAllAngularTestabilities'] = function () { return registry.getAllTestabilities(); };
	        _angular_core.ɵglobal['getAllAngularRootElements'] = function () { return registry.getAllRootElements(); };
	        var /** @type {?} */ whenAllStable = function (callback /** TODO #9100 */) {
	            var /** @type {?} */ testabilities = _angular_core.ɵglobal['getAllAngularTestabilities']();
	            var /** @type {?} */ count = testabilities.length;
	            var /** @type {?} */ didWork = false;
	            var /** @type {?} */ decrement = function (didWork_ /** TODO #9100 */) {
	                didWork = didWork || didWork_;
	                count--;
	                if (count == 0) {
	                    callback(didWork);
	                }
	            };
	            testabilities.forEach(function (testability /** TODO #9100 */) {
	                testability.whenStable(decrement);
	            });
	        };
	        if (!_angular_core.ɵglobal['frameworkStabilizers']) {
	            _angular_core.ɵglobal['frameworkStabilizers'] = [];
	        }
	        _angular_core.ɵglobal['frameworkStabilizers'].push(whenAllStable);
	    };
	    /**
	     * @param {?} registry
	     * @param {?} elem
	     * @param {?} findInAncestors
	     * @return {?}
	     */
	    BrowserGetTestability.prototype.findTestabilityInTree = /**
	     * @param {?} registry
	     * @param {?} elem
	     * @param {?} findInAncestors
	     * @return {?}
	     */
	    function (registry, elem, findInAncestors) {
	        if (elem == null) {
	            return null;
	        }
	        var /** @type {?} */ t = registry.getTestability(elem);
	        if (t != null) {
	            return t;
	        }
	        else if (!findInAncestors) {
	            return null;
	        }
	        if (getDOM().isShadowRoot(elem)) {
	            return this.findTestabilityInTree(registry, getDOM().getHost(elem), true);
	        }
	        return this.findTestabilityInTree(registry, getDOM().parentElement(elem), true);
	    };
	    return BrowserGetTestability;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A service that can be used to get and set the title of a current HTML document.
	 *
	 * Since an Angular application can't be bootstrapped on the entire HTML document (`<html>` tag)
	 * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
	 * (representing the `<title>` tag). Instead, this service can be used to set and get the current
	 * title value.
	 *
	 * \@experimental
	 */
	var Title = /** @class */ (function () {
	    function Title(_doc) {
	        this._doc = _doc;
	    }
	    /**
	     * Get the title of the current HTML document.
	     */
	    /**
	     * Get the title of the current HTML document.
	     * @return {?}
	     */
	    Title.prototype.getTitle = /**
	     * Get the title of the current HTML document.
	     * @return {?}
	     */
	    function () { return getDOM().getTitle(this._doc); };
	    /**
	     * Set the title of the current HTML document.
	     * @param newTitle
	     */
	    /**
	     * Set the title of the current HTML document.
	     * @param {?} newTitle
	     * @return {?}
	     */
	    Title.prototype.setTitle = /**
	     * Set the title of the current HTML document.
	     * @param {?} newTitle
	     * @return {?}
	     */
	    function (newTitle) { getDOM().setTitle(this._doc, newTitle); };
	    Title.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Title.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	    ]; };
	    return Title;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} input
	 * @return {?}
	 */
	
	/**
	 * @param {?} input
	 * @return {?}
	 */
	
	/**
	 * Exports the value under a given `name` in the global property `ng`. For example `ng.probe` if
	 * `name` is `'probe'`.
	 * @param {?} name Name under which it will be exported. Keep in mind this will be a property of the
	 * global `ng` object.
	 * @param {?} value The value to export.
	 * @return {?}
	 */
	function exportNgVar(name, value) {
	    if (typeof COMPILED === 'undefined' || !COMPILED) {
	        // Note: we can't export `ng` when using closure enhanced optimization as:
	        // - closure declares globals itself for minified names, which sometimes clobber our `ng` global
	        // - we can't declare a closure extern as the namespace `ng` is already used within Google
	        //   for typings for angularJS (via `goog.provide('ng....')`).
	        var /** @type {?} */ ng = _angular_core.ɵglobal['ng'] = (/** @type {?} */ (_angular_core.ɵglobal['ng'])) || {};
	        ng[name] = value;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var CORE_TOKENS = {
	    'ApplicationRef': _angular_core.ApplicationRef,
	    'NgZone': _angular_core.NgZone,
	};
	var INSPECT_GLOBAL_NAME = 'probe';
	var CORE_TOKENS_GLOBAL_NAME = 'coreTokens';
	/**
	 * Returns a {\@link DebugElement} for the given native DOM element, or
	 * null if the given native element does not have an Angular view associated
	 * with it.
	 * @param {?} element
	 * @return {?}
	 */
	function inspectNativeElement(element) {
	    return _angular_core.getDebugNode(element);
	}
	/**
	 * @param {?} coreTokens
	 * @return {?}
	 */
	function _createNgProbe(coreTokens) {
	    exportNgVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
	    exportNgVar(CORE_TOKENS_GLOBAL_NAME, __assign({}, CORE_TOKENS, _ngProbeTokensToMap(coreTokens || [])));
	    return function () { return inspectNativeElement; };
	}
	/**
	 * @param {?} tokens
	 * @return {?}
	 */
	function _ngProbeTokensToMap(tokens) {
	    return tokens.reduce(function (prev, t) { return (prev[t.name] = t.token, prev); }, {});
	}
	/**
	 * Providers which support debugging Angular applications (e.g. via `ng.probe`).
	 */
	var ELEMENT_PROBE_PROVIDERS = [
	    {
	        provide: _angular_core.APP_INITIALIZER,
	        useFactory: _createNgProbe,
	        deps: [
	            [_angular_core.NgProbeToken, new _angular_core.Optional()],
	        ],
	        multi: true,
	    },
	];
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var EVENT_MANAGER_PLUGINS = new _angular_core.InjectionToken('EventManagerPlugins');
	/**
	 * \@stable
	 */
	var EventManager = /** @class */ (function () {
	    function EventManager(plugins, _zone) {
	        var _this = this;
	        this._zone = _zone;
	        this._eventNameToPlugin = new Map();
	        plugins.forEach(function (p) { return p.manager = _this; });
	        this._plugins = plugins.slice().reverse();
	    }
	    /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    EventManager.prototype.addEventListener = /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    function (element, eventName, handler) {
	        var /** @type {?} */ plugin = this._findPluginFor(eventName);
	        return plugin.addEventListener(element, eventName, handler);
	    };
	    /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    EventManager.prototype.addGlobalEventListener = /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    function (target, eventName, handler) {
	        var /** @type {?} */ plugin = this._findPluginFor(eventName);
	        return plugin.addGlobalEventListener(target, eventName, handler);
	    };
	    /**
	     * @return {?}
	     */
	    EventManager.prototype.getZone = /**
	     * @return {?}
	     */
	    function () { return this._zone; };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} eventName
	     * @return {?}
	     */
	    EventManager.prototype._findPluginFor = /**
	     * \@internal
	     * @param {?} eventName
	     * @return {?}
	     */
	    function (eventName) {
	        var /** @type {?} */ plugin = this._eventNameToPlugin.get(eventName);
	        if (plugin) {
	            return plugin;
	        }
	        var /** @type {?} */ plugins = this._plugins;
	        for (var /** @type {?} */ i = 0; i < plugins.length; i++) {
	            var /** @type {?} */ plugin_1 = plugins[i];
	            if (plugin_1.supports(eventName)) {
	                this._eventNameToPlugin.set(eventName, plugin_1);
	                return plugin_1;
	            }
	        }
	        throw new Error("No event manager plugin found for event " + eventName);
	    };
	    EventManager.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    EventManager.ctorParameters = function () { return [
	        { type: Array, decorators: [{ type: _angular_core.Inject, args: [EVENT_MANAGER_PLUGINS,] },] },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return EventManager;
	}());
	/**
	 * @abstract
	 */
	var EventManagerPlugin = /** @class */ (function () {
	    function EventManagerPlugin(_doc) {
	        this._doc = _doc;
	    }
	    /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    EventManagerPlugin.prototype.addGlobalEventListener = /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    function (element, eventName, handler) {
	        var /** @type {?} */ target = getDOM().getGlobalEventTarget(this._doc, element);
	        if (!target) {
	            throw new Error("Unsupported event target " + target + " for event " + eventName);
	        }
	        return this.addEventListener(target, eventName, handler);
	    };
	    return EventManagerPlugin;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SharedStylesHost = /** @class */ (function () {
	    function SharedStylesHost() {
	        /**
	         * \@internal
	         */
	        this._stylesSet = new Set();
	    }
	    /**
	     * @param {?} styles
	     * @return {?}
	     */
	    SharedStylesHost.prototype.addStyles = /**
	     * @param {?} styles
	     * @return {?}
	     */
	    function (styles) {
	        var _this = this;
	        var /** @type {?} */ additions = new Set();
	        styles.forEach(function (style) {
	            if (!_this._stylesSet.has(style)) {
	                _this._stylesSet.add(style);
	                additions.add(style);
	            }
	        });
	        this.onStylesAdded(additions);
	    };
	    /**
	     * @param {?} additions
	     * @return {?}
	     */
	    SharedStylesHost.prototype.onStylesAdded = /**
	     * @param {?} additions
	     * @return {?}
	     */
	    function (additions) { };
	    /**
	     * @return {?}
	     */
	    SharedStylesHost.prototype.getAllStyles = /**
	     * @return {?}
	     */
	    function () { return Array.from(this._stylesSet); };
	    SharedStylesHost.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    SharedStylesHost.ctorParameters = function () { return []; };
	    return SharedStylesHost;
	}());
	var DomSharedStylesHost = /** @class */ (function (_super) {
	    __extends(DomSharedStylesHost, _super);
	    function DomSharedStylesHost(_doc) {
	        var _this = _super.call(this) || this;
	        _this._doc = _doc;
	        _this._hostNodes = new Set();
	        _this._styleNodes = new Set();
	        _this._hostNodes.add(_doc.head);
	        return _this;
	    }
	    /**
	     * @param {?} styles
	     * @param {?} host
	     * @return {?}
	     */
	    DomSharedStylesHost.prototype._addStylesToHost = /**
	     * @param {?} styles
	     * @param {?} host
	     * @return {?}
	     */
	    function (styles, host) {
	        var _this = this;
	        styles.forEach(function (style) {
	            var /** @type {?} */ styleEl = _this._doc.createElement('style');
	            styleEl.textContent = style;
	            _this._styleNodes.add(host.appendChild(styleEl));
	        });
	    };
	    /**
	     * @param {?} hostNode
	     * @return {?}
	     */
	    DomSharedStylesHost.prototype.addHost = /**
	     * @param {?} hostNode
	     * @return {?}
	     */
	    function (hostNode) {
	        this._addStylesToHost(this._stylesSet, hostNode);
	        this._hostNodes.add(hostNode);
	    };
	    /**
	     * @param {?} hostNode
	     * @return {?}
	     */
	    DomSharedStylesHost.prototype.removeHost = /**
	     * @param {?} hostNode
	     * @return {?}
	     */
	    function (hostNode) { this._hostNodes.delete(hostNode); };
	    /**
	     * @param {?} additions
	     * @return {?}
	     */
	    DomSharedStylesHost.prototype.onStylesAdded = /**
	     * @param {?} additions
	     * @return {?}
	     */
	    function (additions) {
	        var _this = this;
	        this._hostNodes.forEach(function (hostNode) { return _this._addStylesToHost(additions, hostNode); });
	    };
	    /**
	     * @return {?}
	     */
	    DomSharedStylesHost.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this._styleNodes.forEach(function (styleNode) { return getDOM().remove(styleNode); }); };
	    DomSharedStylesHost.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    DomSharedStylesHost.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	    ]; };
	    return DomSharedStylesHost;
	}(SharedStylesHost));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NAMESPACE_URIS = {
	    'svg': 'http://www.w3.org/2000/svg',
	    'xhtml': 'http://www.w3.org/1999/xhtml',
	    'xlink': 'http://www.w3.org/1999/xlink',
	    'xml': 'http://www.w3.org/XML/1998/namespace',
	    'xmlns': 'http://www.w3.org/2000/xmlns/',
	};
	var COMPONENT_REGEX = /%COMP%/g;
	var COMPONENT_VARIABLE = '%COMP%';
	var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
	var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
	/**
	 * @param {?} componentShortId
	 * @return {?}
	 */
	function shimContentAttribute(componentShortId) {
	    return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
	}
	/**
	 * @param {?} componentShortId
	 * @return {?}
	 */
	function shimHostAttribute(componentShortId) {
	    return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
	}
	/**
	 * @param {?} compId
	 * @param {?} styles
	 * @param {?} target
	 * @return {?}
	 */
	function flattenStyles(compId, styles, target) {
	    for (var /** @type {?} */ i = 0; i < styles.length; i++) {
	        var /** @type {?} */ style = styles[i];
	        if (Array.isArray(style)) {
	            flattenStyles(compId, style, target);
	        }
	        else {
	            style = style.replace(COMPONENT_REGEX, compId);
	            target.push(style);
	        }
	    }
	    return target;
	}
	/**
	 * @param {?} eventHandler
	 * @return {?}
	 */
	function decoratePreventDefault(eventHandler) {
	    return function (event) {
	        var /** @type {?} */ allowDefaultBehavior = eventHandler(event);
	        if (allowDefaultBehavior === false) {
	            // TODO(tbosch): move preventDefault into event plugins...
	            event.preventDefault();
	            event.returnValue = false;
	        }
	    };
	}
	var DomRendererFactory2 = /** @class */ (function () {
	    function DomRendererFactory2(eventManager, sharedStylesHost) {
	        this.eventManager = eventManager;
	        this.sharedStylesHost = sharedStylesHost;
	        this.rendererByCompId = new Map();
	        this.defaultRenderer = new DefaultDomRenderer2(eventManager);
	    }
	    /**
	     * @param {?} element
	     * @param {?} type
	     * @return {?}
	     */
	    DomRendererFactory2.prototype.createRenderer = /**
	     * @param {?} element
	     * @param {?} type
	     * @return {?}
	     */
	    function (element, type) {
	        if (!element || !type) {
	            return this.defaultRenderer;
	        }
	        switch (type.encapsulation) {
	            case _angular_core.ViewEncapsulation.Emulated: {
	                var /** @type {?} */ renderer = this.rendererByCompId.get(type.id);
	                if (!renderer) {
	                    renderer =
	                        new EmulatedEncapsulationDomRenderer2(this.eventManager, this.sharedStylesHost, type);
	                    this.rendererByCompId.set(type.id, renderer);
	                }
	                (/** @type {?} */ (renderer)).applyToHost(element);
	                return renderer;
	            }
	            case _angular_core.ViewEncapsulation.Native:
	                return new ShadowDomRenderer(this.eventManager, this.sharedStylesHost, element, type);
	            default: {
	                if (!this.rendererByCompId.has(type.id)) {
	                    var /** @type {?} */ styles = flattenStyles(type.id, type.styles, []);
	                    this.sharedStylesHost.addStyles(styles);
	                    this.rendererByCompId.set(type.id, this.defaultRenderer);
	                }
	                return this.defaultRenderer;
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    DomRendererFactory2.prototype.begin = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @return {?}
	     */
	    DomRendererFactory2.prototype.end = /**
	     * @return {?}
	     */
	    function () { };
	    DomRendererFactory2.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    DomRendererFactory2.ctorParameters = function () { return [
	        { type: EventManager, },
	        { type: DomSharedStylesHost, },
	    ]; };
	    return DomRendererFactory2;
	}());
	var DefaultDomRenderer2 = /** @class */ (function () {
	    function DefaultDomRenderer2(eventManager) {
	        this.eventManager = eventManager;
	        this.data = Object.create(null);
	    }
	    /**
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.createElement = /**
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (name, namespace) {
	        if (namespace) {
	            return document.createElementNS(NAMESPACE_URIS[namespace], name);
	        }
	        return document.createElement(name);
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.createComment = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return document.createComment(value); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.createText = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return document.createTextNode(value); };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.appendChild = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    function (parent, newChild) { parent.appendChild(newChild); };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.insertBefore = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    function (parent, newChild, refChild) {
	        if (parent) {
	            parent.insertBefore(newChild, refChild);
	        }
	    };
	    /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.removeChild = /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    function (parent, oldChild) {
	        if (parent) {
	            parent.removeChild(oldChild);
	        }
	    };
	    /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.selectRootElement = /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    function (selectorOrNode) {
	        var /** @type {?} */ el = typeof selectorOrNode === 'string' ? document.querySelector(selectorOrNode) :
	            selectorOrNode;
	        if (!el) {
	            throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
	        }
	        el.textContent = '';
	        return el;
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.parentNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.parentNode; };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.nextSibling = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node.nextSibling; };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @param {?=} namespace
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.setAttribute = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (el, name, value, namespace) {
	        if (namespace) {
	            name = namespace + ":" + name;
	            var /** @type {?} */ namespaceUri = NAMESPACE_URIS[namespace];
	            if (namespaceUri) {
	                el.setAttributeNS(namespaceUri, name, value);
	            }
	            else {
	                el.setAttribute(name, value);
	            }
	        }
	        else {
	            el.setAttribute(name, value);
	        }
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.removeAttribute = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (el, name, namespace) {
	        if (namespace) {
	            var /** @type {?} */ namespaceUri = NAMESPACE_URIS[namespace];
	            if (namespaceUri) {
	                el.removeAttributeNS(namespaceUri, name);
	            }
	            else {
	                el.removeAttribute(namespace + ":" + name);
	            }
	        }
	        else {
	            el.removeAttribute(name);
	        }
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.addClass = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) { el.classList.add(name); };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.removeClass = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) { el.classList.remove(name); };
	    /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} value
	     * @param {?} flags
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.setStyle = /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} value
	     * @param {?} flags
	     * @return {?}
	     */
	    function (el, style, value, flags) {
	        if (flags & _angular_core.RendererStyleFlags2.DashCase) {
	            el.style.setProperty(style, value, !!(flags & _angular_core.RendererStyleFlags2.Important) ? 'important' : '');
	        }
	        else {
	            el.style[style] = value;
	        }
	    };
	    /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} flags
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.removeStyle = /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} flags
	     * @return {?}
	     */
	    function (el, style, flags) {
	        if (flags & _angular_core.RendererStyleFlags2.DashCase) {
	            el.style.removeProperty(style);
	        }
	        else {
	            // IE requires '' instead of null
	            // see https://github.com/angular/angular/issues/7916
	            el.style[style] = '';
	        }
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.setProperty = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, name, value) {
	        checkNoSyntheticProp(name, 'property');
	        el[name] = value;
	    };
	    /**
	     * @param {?} node
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.setValue = /**
	     * @param {?} node
	     * @param {?} value
	     * @return {?}
	     */
	    function (node, value) { node.nodeValue = value; };
	    /**
	     * @param {?} target
	     * @param {?} event
	     * @param {?} callback
	     * @return {?}
	     */
	    DefaultDomRenderer2.prototype.listen = /**
	     * @param {?} target
	     * @param {?} event
	     * @param {?} callback
	     * @return {?}
	     */
	    function (target, event, callback) {
	        checkNoSyntheticProp(event, 'listener');
	        if (typeof target === 'string') {
	            return /** @type {?} */ (this.eventManager.addGlobalEventListener(target, event, decoratePreventDefault(callback)));
	        }
	        return /** @type {?} */ ((this.eventManager.addEventListener(target, event, decoratePreventDefault(callback))));
	    };
	    return DefaultDomRenderer2;
	}());
	var AT_CHARCODE = '@'.charCodeAt(0);
	/**
	 * @param {?} name
	 * @param {?} nameKind
	 * @return {?}
	 */
	function checkNoSyntheticProp(name, nameKind) {
	    if (name.charCodeAt(0) === AT_CHARCODE) {
	        throw new Error("Found the synthetic " + nameKind + " " + name + ". Please include either \"BrowserAnimationsModule\" or \"NoopAnimationsModule\" in your application.");
	    }
	}
	var EmulatedEncapsulationDomRenderer2 = /** @class */ (function (_super) {
	    __extends(EmulatedEncapsulationDomRenderer2, _super);
	    function EmulatedEncapsulationDomRenderer2(eventManager, sharedStylesHost, component) {
	        var _this = _super.call(this, eventManager) || this;
	        _this.component = component;
	        var /** @type {?} */ styles = flattenStyles(component.id, component.styles, []);
	        sharedStylesHost.addStyles(styles);
	        _this.contentAttr = shimContentAttribute(component.id);
	        _this.hostAttr = shimHostAttribute(component.id);
	        return _this;
	    }
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    EmulatedEncapsulationDomRenderer2.prototype.applyToHost = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) { _super.prototype.setAttribute.call(this, element, this.hostAttr, ''); };
	    /**
	     * @param {?} parent
	     * @param {?} name
	     * @return {?}
	     */
	    EmulatedEncapsulationDomRenderer2.prototype.createElement = /**
	     * @param {?} parent
	     * @param {?} name
	     * @return {?}
	     */
	    function (parent, name) {
	        var /** @type {?} */ el = _super.prototype.createElement.call(this, parent, name);
	        _super.prototype.setAttribute.call(this, el, this.contentAttr, '');
	        return el;
	    };
	    return EmulatedEncapsulationDomRenderer2;
	}(DefaultDomRenderer2));
	var ShadowDomRenderer = /** @class */ (function (_super) {
	    __extends(ShadowDomRenderer, _super);
	    function ShadowDomRenderer(eventManager, sharedStylesHost, hostEl, component) {
	        var _this = _super.call(this, eventManager) || this;
	        _this.sharedStylesHost = sharedStylesHost;
	        _this.hostEl = hostEl;
	        _this.component = component;
	        _this.shadowRoot = (/** @type {?} */ (hostEl)).createShadowRoot();
	        _this.sharedStylesHost.addHost(_this.shadowRoot);
	        var /** @type {?} */ styles = flattenStyles(component.id, component.styles, []);
	        for (var /** @type {?} */ i = 0; i < styles.length; i++) {
	            var /** @type {?} */ styleEl = document.createElement('style');
	            styleEl.textContent = styles[i];
	            _this.shadowRoot.appendChild(styleEl);
	        }
	        return _this;
	    }
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    ShadowDomRenderer.prototype.nodeOrShadowRoot = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return node === this.hostEl ? this.shadowRoot : node; };
	    /**
	     * @return {?}
	     */
	    ShadowDomRenderer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { this.sharedStylesHost.removeHost(this.shadowRoot); };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    ShadowDomRenderer.prototype.appendChild = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    function (parent, newChild) {
	        return _super.prototype.appendChild.call(this, this.nodeOrShadowRoot(parent), newChild);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    ShadowDomRenderer.prototype.insertBefore = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    function (parent, newChild, refChild) {
	        return _super.prototype.insertBefore.call(this, this.nodeOrShadowRoot(parent), newChild, refChild);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    ShadowDomRenderer.prototype.removeChild = /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    function (parent, oldChild) {
	        return _super.prototype.removeChild.call(this, this.nodeOrShadowRoot(parent), oldChild);
	    };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    ShadowDomRenderer.prototype.parentNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        return this.nodeOrShadowRoot(_super.prototype.parentNode.call(this, this.nodeOrShadowRoot(node)));
	    };
	    return ShadowDomRenderer;
	}(DefaultDomRenderer2));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ɵ0 = function (v) {
	    return '__zone_symbol__' + v;
	};
	/**
	 * Detect if Zone is present. If it is then use simple zone aware 'addEventListener'
	 * since Angular can do much more
	 * efficient bookkeeping than Zone can, because we have additional information. This speeds up
	 * addEventListener by 3x.
	 */
	var __symbol__ = (typeof Zone !== 'undefined') && (/** @type {?} */ (Zone))['__symbol__'] || ɵ0;
	var ADD_EVENT_LISTENER = __symbol__('addEventListener');
	var REMOVE_EVENT_LISTENER = __symbol__('removeEventListener');
	var symbolNames = {};
	var FALSE = 'FALSE';
	var ANGULAR = 'ANGULAR';
	var NATIVE_ADD_LISTENER = 'addEventListener';
	var NATIVE_REMOVE_LISTENER = 'removeEventListener';
	// use the same symbol string which is used in zone.js
	var stopSymbol = '__zone_symbol__propagationStopped';
	var stopMethodSymbol = '__zone_symbol__stopImmediatePropagation';
	var blackListedEvents = (typeof Zone !== 'undefined') && (/** @type {?} */ (Zone))[__symbol__('BLACK_LISTED_EVENTS')];
	var blackListedMap;
	if (blackListedEvents) {
	    blackListedMap = {};
	    blackListedEvents.forEach(function (eventName) { blackListedMap[eventName] = eventName; });
	}
	var isBlackListedEvent = function (eventName) {
	    if (!blackListedMap) {
	        return false;
	    }
	    return blackListedMap.hasOwnProperty(eventName);
	};
	// a global listener to handle all dom event,
	// so we do not need to create a closure everytime
	var globalListener = function (event) {
	    var /** @type {?} */ symbolName = symbolNames[event.type];
	    if (!symbolName) {
	        return;
	    }
	    var /** @type {?} */ taskDatas = this[symbolName];
	    if (!taskDatas) {
	        return;
	    }
	    var /** @type {?} */ args = [event];
	    if (taskDatas.length === 1) {
	        // if taskDatas only have one element, just invoke it
	        var /** @type {?} */ taskData = taskDatas[0];
	        if (taskData.zone !== Zone.current) {
	            // only use Zone.run when Zone.current not equals to stored zone
	            return taskData.zone.run(taskData.handler, this, args);
	        }
	        else {
	            return taskData.handler.apply(this, args);
	        }
	    }
	    else {
	        // copy tasks as a snapshot to avoid event handlers remove
	        // itself or others
	        var /** @type {?} */ copiedTasks = taskDatas.slice();
	        for (var /** @type {?} */ i = 0; i < copiedTasks.length; i++) {
	            // if other listener call event.stopImmediatePropagation
	            // just break
	            if ((/** @type {?} */ (event))[stopSymbol] === true) {
	                break;
	            }
	            var /** @type {?} */ taskData = copiedTasks[i];
	            if (taskData.zone !== Zone.current) {
	                // only use Zone.run when Zone.current not equals to stored zone
	                taskData.zone.run(taskData.handler, this, args);
	            }
	            else {
	                taskData.handler.apply(this, args);
	            }
	        }
	    }
	};
	var DomEventsPlugin = /** @class */ (function (_super) {
	    __extends(DomEventsPlugin, _super);
	    function DomEventsPlugin(doc, ngZone) {
	        var _this = _super.call(this, doc) || this;
	        _this.ngZone = ngZone;
	        _this.patchEvent();
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    DomEventsPlugin.prototype.patchEvent = /**
	     * @return {?}
	     */
	    function () {
	        if (!Event || !Event.prototype) {
	            return;
	        }
	        if ((/** @type {?} */ (Event.prototype))[stopMethodSymbol]) {
	            // already patched by zone.js
	            return;
	        }
	        var /** @type {?} */ delegate = (/** @type {?} */ (Event.prototype))[stopMethodSymbol] =
	            Event.prototype.stopImmediatePropagation;
	        Event.prototype.stopImmediatePropagation = function () {
	            if (this) {
	                this[stopSymbol] = true;
	            }
	            // should call native delegate in case
	            // in some enviroment part of the application
	            // will not use the patched Event
	            delegate && delegate.apply(this, arguments);
	        };
	    };
	    // This plugin should come last in the list of plugins, because it accepts all
	    // events.
	    /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    DomEventsPlugin.prototype.supports = /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    function (eventName) { return true; };
	    /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    DomEventsPlugin.prototype.addEventListener = /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    function (element, eventName, handler) {
	        var _this = this;
	        /**
	         * This code is about to add a listener to the DOM. If Zone.js is present, than
	         * `addEventListener` has been patched. The patched code adds overhead in both
	         * memory and speed (3x slower) than native. For this reason if we detect that
	         * Zone.js is present we use a simple version of zone aware addEventListener instead.
	         * The result is faster registration and the zone will be restored.
	         * But ZoneSpec.onScheduleTask, ZoneSpec.onInvokeTask, ZoneSpec.onCancelTask
	         * will not be invoked
	         * We also do manual zone restoration in element.ts renderEventHandlerClosure method.
	         *
	         * NOTE: it is possible that the element is from different iframe, and so we
	         * have to check before we execute the method.
	         */
	        var /** @type {?} */ self = this;
	        var /** @type {?} */ zoneJsLoaded = element[ADD_EVENT_LISTENER];
	        var /** @type {?} */ callback = /** @type {?} */ (handler);
	        // if zonejs is loaded and current zone is not ngZone
	        // we keep Zone.current on target for later restoration.
	        if (zoneJsLoaded && (!_angular_core.NgZone.isInAngularZone() || isBlackListedEvent(eventName))) {
	            var /** @type {?} */ symbolName = symbolNames[eventName];
	            if (!symbolName) {
	                symbolName = symbolNames[eventName] = __symbol__(ANGULAR + eventName + FALSE);
	            }
	            var /** @type {?} */ taskDatas = (/** @type {?} */ (element))[symbolName];
	            var /** @type {?} */ globalListenerRegistered = taskDatas && taskDatas.length > 0;
	            if (!taskDatas) {
	                taskDatas = (/** @type {?} */ (element))[symbolName] = [];
	            }
	            var /** @type {?} */ zone = isBlackListedEvent(eventName) ? Zone.root : Zone.current;
	            if (taskDatas.length === 0) {
	                taskDatas.push({ zone: zone, handler: callback });
	            }
	            else {
	                var /** @type {?} */ callbackRegistered = false;
	                for (var /** @type {?} */ i = 0; i < taskDatas.length; i++) {
	                    if (taskDatas[i].handler === callback) {
	                        callbackRegistered = true;
	                        break;
	                    }
	                }
	                if (!callbackRegistered) {
	                    taskDatas.push({ zone: zone, handler: callback });
	                }
	            }
	            if (!globalListenerRegistered) {
	                element[ADD_EVENT_LISTENER](eventName, globalListener, false);
	            }
	        }
	        else {
	            element[NATIVE_ADD_LISTENER](eventName, callback, false);
	        }
	        return function () { return _this.removeEventListener(element, eventName, callback); };
	    };
	    /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    DomEventsPlugin.prototype.removeEventListener = /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    function (target, eventName, callback) {
	        var /** @type {?} */ underlyingRemove = target[REMOVE_EVENT_LISTENER];
	        // zone.js not loaded, use native removeEventListener
	        if (!underlyingRemove) {
	            return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
	        }
	        var /** @type {?} */ symbolName = symbolNames[eventName];
	        var /** @type {?} */ taskDatas = symbolName && target[symbolName];
	        if (!taskDatas) {
	            // addEventListener not using patched version
	            // just call native removeEventListener
	            return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
	        }
	        // fix issue 20532, should be able to remove
	        // listener which was added inside of ngZone
	        var /** @type {?} */ found = false;
	        for (var /** @type {?} */ i = 0; i < taskDatas.length; i++) {
	            // remove listener from taskDatas if the callback equals
	            if (taskDatas[i].handler === callback) {
	                found = true;
	                taskDatas.splice(i, 1);
	                break;
	            }
	        }
	        if (found) {
	            if (taskDatas.length === 0) {
	                // all listeners are removed, we can remove the globalListener from target
	                underlyingRemove.apply(target, [eventName, globalListener, false]);
	            }
	        }
	        else {
	            // not found in taskDatas, the callback may be added inside of ngZone
	            // use native remove listener to remove the calback
	            target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
	        }
	    };
	    DomEventsPlugin.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    DomEventsPlugin.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return DomEventsPlugin;
	}(EventManagerPlugin));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var EVENT_NAMES = {
	    // pan
	    'pan': true,
	    'panstart': true,
	    'panmove': true,
	    'panend': true,
	    'pancancel': true,
	    'panleft': true,
	    'panright': true,
	    'panup': true,
	    'pandown': true,
	    // pinch
	    'pinch': true,
	    'pinchstart': true,
	    'pinchmove': true,
	    'pinchend': true,
	    'pinchcancel': true,
	    'pinchin': true,
	    'pinchout': true,
	    // press
	    'press': true,
	    'pressup': true,
	    // rotate
	    'rotate': true,
	    'rotatestart': true,
	    'rotatemove': true,
	    'rotateend': true,
	    'rotatecancel': true,
	    // swipe
	    'swipe': true,
	    'swipeleft': true,
	    'swiperight': true,
	    'swipeup': true,
	    'swipedown': true,
	    // tap
	    'tap': true,
	};
	/**
	 * A DI token that you can use to provide{\@link HammerGestureConfig} to Angular. Use it to configure
	 * Hammer gestures.
	 *
	 * \@experimental
	 */
	var HAMMER_GESTURE_CONFIG = new _angular_core.InjectionToken('HammerGestureConfig');
	/**
	 * @record
	 */
	
	/**
	 * \@experimental
	 */
	var HammerGestureConfig = /** @class */ (function () {
	    function HammerGestureConfig() {
	        this.events = [];
	        this.overrides = {};
	    }
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    HammerGestureConfig.prototype.buildHammer = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ mc = new Hammer(element);
	        mc.get('pinch').set({ enable: true });
	        mc.get('rotate').set({ enable: true });
	        for (var /** @type {?} */ eventName in this.overrides) {
	            mc.get(eventName).set(this.overrides[eventName]);
	        }
	        return mc;
	    };
	    HammerGestureConfig.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HammerGestureConfig.ctorParameters = function () { return []; };
	    return HammerGestureConfig;
	}());
	var HammerGesturesPlugin = /** @class */ (function (_super) {
	    __extends(HammerGesturesPlugin, _super);
	    function HammerGesturesPlugin(doc, _config) {
	        var _this = _super.call(this, doc) || this;
	        _this._config = _config;
	        return _this;
	    }
	    /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    HammerGesturesPlugin.prototype.supports = /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    function (eventName) {
	        if (!EVENT_NAMES.hasOwnProperty(eventName.toLowerCase()) && !this.isCustomEvent(eventName)) {
	            return false;
	        }
	        if (!(/** @type {?} */ (window)).Hammer) {
	            throw new Error("Hammer.js is not loaded, can not bind " + eventName + " event");
	        }
	        return true;
	    };
	    /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    HammerGesturesPlugin.prototype.addEventListener = /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    function (element, eventName, handler) {
	        var _this = this;
	        var /** @type {?} */ zone = this.manager.getZone();
	        eventName = eventName.toLowerCase();
	        return zone.runOutsideAngular(function () {
	            // Creating the manager bind events, must be done outside of angular
	            var /** @type {?} */ mc = _this._config.buildHammer(element);
	            var /** @type {?} */ callback = function (eventObj) {
	                zone.runGuarded(function () { handler(eventObj); });
	            };
	            mc.on(eventName, callback);
	            return function () { return mc.off(eventName, callback); };
	        });
	    };
	    /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    HammerGesturesPlugin.prototype.isCustomEvent = /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    function (eventName) { return this._config.events.indexOf(eventName) > -1; };
	    HammerGesturesPlugin.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HammerGesturesPlugin.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	        { type: HammerGestureConfig, decorators: [{ type: _angular_core.Inject, args: [HAMMER_GESTURE_CONFIG,] },] },
	    ]; };
	    return HammerGesturesPlugin;
	}(EventManagerPlugin));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var MODIFIER_KEYS = ['alt', 'control', 'meta', 'shift'];
	var ɵ0$1 = function (event) { return event.altKey; };
	var ɵ1$1 = function (event) { return event.ctrlKey; };
	var ɵ2$1 = function (event) { return event.metaKey; };
	var ɵ3 = function (event) { return event.shiftKey; };
	var MODIFIER_KEY_GETTERS = {
	    'alt': ɵ0$1,
	    'control': ɵ1$1,
	    'meta': ɵ2$1,
	    'shift': ɵ3
	};
	/**
	 * \@experimental
	 */
	var KeyEventsPlugin = /** @class */ (function (_super) {
	    __extends(KeyEventsPlugin, _super);
	    function KeyEventsPlugin(doc) {
	        return _super.call(this, doc) || this;
	    }
	    /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    KeyEventsPlugin.prototype.supports = /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    function (eventName) { return KeyEventsPlugin.parseEventName(eventName) != null; };
	    /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    KeyEventsPlugin.prototype.addEventListener = /**
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} handler
	     * @return {?}
	     */
	    function (element, eventName, handler) {
	        var /** @type {?} */ parsedEvent = /** @type {?} */ ((KeyEventsPlugin.parseEventName(eventName)));
	        var /** @type {?} */ outsideHandler = KeyEventsPlugin.eventCallback(parsedEvent['fullKey'], handler, this.manager.getZone());
	        return this.manager.getZone().runOutsideAngular(function () {
	            return getDOM().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
	        });
	    };
	    /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    KeyEventsPlugin.parseEventName = /**
	     * @param {?} eventName
	     * @return {?}
	     */
	    function (eventName) {
	        var /** @type {?} */ parts = eventName.toLowerCase().split('.');
	        var /** @type {?} */ domEventName = parts.shift();
	        if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
	            return null;
	        }
	        var /** @type {?} */ key = KeyEventsPlugin._normalizeKey(/** @type {?} */ ((parts.pop())));
	        var /** @type {?} */ fullKey = '';
	        MODIFIER_KEYS.forEach(function (modifierName) {
	            var /** @type {?} */ index = parts.indexOf(modifierName);
	            if (index > -1) {
	                parts.splice(index, 1);
	                fullKey += modifierName + '.';
	            }
	        });
	        fullKey += key;
	        if (parts.length != 0 || key.length === 0) {
	            // returning null instead of throwing to let another plugin process the event
	            return null;
	        }
	        var /** @type {?} */ result = {};
	        result['domEventName'] = domEventName;
	        result['fullKey'] = fullKey;
	        return result;
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    KeyEventsPlugin.getEventFullKey = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ fullKey = '';
	        var /** @type {?} */ key = getDOM().getEventKey(event);
	        key = key.toLowerCase();
	        if (key === ' ') {
	            key = 'space'; // for readability
	        }
	        else if (key === '.') {
	            key = 'dot'; // because '.' is used as a separator in event names
	        }
	        MODIFIER_KEYS.forEach(function (modifierName) {
	            if (modifierName != key) {
	                var /** @type {?} */ modifierGetter = MODIFIER_KEY_GETTERS[modifierName];
	                if (modifierGetter(event)) {
	                    fullKey += modifierName + '.';
	                }
	            }
	        });
	        fullKey += key;
	        return fullKey;
	    };
	    /**
	     * @param {?} fullKey
	     * @param {?} handler
	     * @param {?} zone
	     * @return {?}
	     */
	    KeyEventsPlugin.eventCallback = /**
	     * @param {?} fullKey
	     * @param {?} handler
	     * @param {?} zone
	     * @return {?}
	     */
	    function (fullKey, handler, zone) {
	        return function (event /** TODO #9100 */) {
	            if (KeyEventsPlugin.getEventFullKey(event) === fullKey) {
	                zone.runGuarded(function () { return handler(event); });
	            }
	        };
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} keyName
	     * @return {?}
	     */
	    KeyEventsPlugin._normalizeKey = /**
	     * \@internal
	     * @param {?} keyName
	     * @return {?}
	     */
	    function (keyName) {
	        // TODO: switch to a Map if the mapping grows too much
	        switch (keyName) {
	            case 'esc':
	                return 'escape';
	            default:
	                return keyName;
	        }
	    };
	    KeyEventsPlugin.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    KeyEventsPlugin.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	    ]; };
	    return KeyEventsPlugin;
	}(EventManagerPlugin));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * This helper class is used to get hold of an inert tree of DOM elements containing dirty HTML
	 * that needs sanitizing.
	 * Depending upon browser support we must use one of three strategies for doing this.
	 * Support: Safari 10.x -> XHR strategy
	 * Support: Firefox -> DomParser strategy
	 * Default: InertDocument strategy
	 */
	var InertBodyHelper = /** @class */ (function () {
	    function InertBodyHelper(defaultDoc, DOM) {
	        this.defaultDoc = defaultDoc;
	        this.DOM = DOM;
	        var /** @type {?} */ inertDocument = this.DOM.createHtmlDocument();
	        this.inertBodyElement = inertDocument.body;
	        if (this.inertBodyElement == null) {
	            // usually there should be only one body element in the document, but IE doesn't have any, so
	            // we need to create one.
	            var /** @type {?} */ inertHtml = this.DOM.createElement('html', inertDocument);
	            this.inertBodyElement = this.DOM.createElement('body', inertDocument);
	            this.DOM.appendChild(inertHtml, this.inertBodyElement);
	            this.DOM.appendChild(inertDocument, inertHtml);
	        }
	        this.DOM.setInnerHTML(this.inertBodyElement, '<svg><g onload="this.parentNode.remove()"></g></svg>');
	        if (this.inertBodyElement.querySelector && !this.inertBodyElement.querySelector('svg')) {
	            // We just hit the Safari 10.1 bug - which allows JS to run inside the SVG G element
	            // so use the XHR strategy.
	            this.getInertBodyElement = this.getInertBodyElement_XHR;
	            return;
	        }
	        this.DOM.setInnerHTML(this.inertBodyElement, '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
	        if (this.inertBodyElement.querySelector && this.inertBodyElement.querySelector('svg img')) {
	            // We just hit the Firefox bug - which prevents the inner img JS from being sanitized
	            // so use the DOMParser strategy, if it is available.
	            // If the DOMParser is not available then we are not in Firefox (Server/WebWorker?) so we
	            // fall through to the default strategy below.
	            if (isDOMParserAvailable()) {
	                this.getInertBodyElement = this.getInertBodyElement_DOMParser;
	                return;
	            }
	        }
	        // None of the bugs were hit so it is safe for us to use the default InertDocument strategy
	        this.getInertBodyElement = this.getInertBodyElement_InertDocument;
	    }
	    /**
	     * Use XHR to create and fill an inert body element (on Safari 10.1)
	     * See
	     * https://github.com/cure53/DOMPurify/blob/a992d3a75031cb8bb032e5ea8399ba972bdf9a65/src/purify.js#L439-L449
	     * @param {?} html
	     * @return {?}
	     */
	    InertBodyHelper.prototype.getInertBodyElement_XHR = /**
	     * Use XHR to create and fill an inert body element (on Safari 10.1)
	     * See
	     * https://github.com/cure53/DOMPurify/blob/a992d3a75031cb8bb032e5ea8399ba972bdf9a65/src/purify.js#L439-L449
	     * @param {?} html
	     * @return {?}
	     */
	    function (html) {
	        // We add these extra elements to ensure that the rest of the content is parsed as expected
	        // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
	        // `<head>` tag.
	        html = '<body><remove></remove>' + html + '</body>';
	        try {
	            html = encodeURI(html);
	        }
	        catch (/** @type {?} */ e) {
	            return null;
	        }
	        var /** @type {?} */ xhr = new XMLHttpRequest();
	        xhr.responseType = 'document';
	        xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
	        xhr.send(null);
	        var /** @type {?} */ body = xhr.response.body;
	        body.removeChild(/** @type {?} */ ((body.firstChild)));
	        return body;
	    };
	    /**
	     * Use DOMParser to create and fill an inert body element (on Firefox)
	     * See https://github.com/cure53/DOMPurify/releases/tag/0.6.7
	     *
	     * @param {?} html
	     * @return {?}
	     */
	    InertBodyHelper.prototype.getInertBodyElement_DOMParser = /**
	     * Use DOMParser to create and fill an inert body element (on Firefox)
	     * See https://github.com/cure53/DOMPurify/releases/tag/0.6.7
	     *
	     * @param {?} html
	     * @return {?}
	     */
	    function (html) {
	        // We add these extra elements to ensure that the rest of the content is parsed as expected
	        // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
	        // `<head>` tag.
	        html = '<body><remove></remove>' + html + '</body>';
	        try {
	            var /** @type {?} */ body = /** @type {?} */ (new (/** @type {?} */ (window))
	                .DOMParser()
	                .parseFromString(html, 'text/html')
	                .body);
	            body.removeChild(/** @type {?} */ ((body.firstChild)));
	            return body;
	        }
	        catch (/** @type {?} */ e) {
	            return null;
	        }
	    };
	    /**
	     * Use an HTML5 `template` element, if supported, or an inert body element created via
	     * `createHtmlDocument` to create and fill an inert DOM element.
	     * This is the default sane strategy to use if the browser does not require one of the specialised
	     * strategies above.
	     * @param {?} html
	     * @return {?}
	     */
	    InertBodyHelper.prototype.getInertBodyElement_InertDocument = /**
	     * Use an HTML5 `template` element, if supported, or an inert body element created via
	     * `createHtmlDocument` to create and fill an inert DOM element.
	     * This is the default sane strategy to use if the browser does not require one of the specialised
	     * strategies above.
	     * @param {?} html
	     * @return {?}
	     */
	    function (html) {
	        // Prefer using <template> element if supported.
	        var /** @type {?} */ templateEl = this.DOM.createElement('template');
	        if ('content' in templateEl) {
	            this.DOM.setInnerHTML(templateEl, html);
	            return templateEl;
	        }
	        this.DOM.setInnerHTML(this.inertBodyElement, html);
	        // Support: IE 9-11 only
	        // strip custom-namespaced attributes on IE<=11
	        if (this.defaultDoc.documentMode) {
	            this.stripCustomNsAttrs(this.inertBodyElement);
	        }
	        return this.inertBodyElement;
	    };
	    /**
	     * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
	     * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g.
	     * 'ns1:xlink:foo').
	     *
	     * This is undesirable since we don't want to allow any of these custom attributes. This method
	     * strips them all.
	     * @param {?} el
	     * @return {?}
	     */
	    InertBodyHelper.prototype.stripCustomNsAttrs = /**
	     * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
	     * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g.
	     * 'ns1:xlink:foo').
	     *
	     * This is undesirable since we don't want to allow any of these custom attributes. This method
	     * strips them all.
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        var _this = this;
	        this.DOM.attributeMap(el).forEach(function (_, attrName) {
	            if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
	                _this.DOM.removeAttribute(el, attrName);
	            }
	        });
	        for (var _i = 0, _a = this.DOM.childNodesAsList(el); _i < _a.length; _i++) {
	            var n = _a[_i];
	            if (this.DOM.isElementNode(n))
	                this.stripCustomNsAttrs(/** @type {?} */ (n));
	        }
	    };
	    return InertBodyHelper;
	}());
	/**
	 * We need to determine whether the DOMParser exists in the global context.
	 * The try-catch is because, on some browsers, trying to access this property
	 * on window can actually throw an error.
	 *
	 * @suppress {uselessCode}
	 * @return {?}
	 */
	function isDOMParserAvailable() {
	    try {
	        return !!(/** @type {?} */ (window)).DOMParser;
	    }
	    catch (/** @type {?} */ e) {
	        return false;
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A pattern that recognizes a commonly useful subset of URLs that are safe.
	 *
	 * This regular expression matches a subset of URLs that will not cause script
	 * execution if used in URL context within a HTML document. Specifically, this
	 * regular expression matches if (comment from here on and regex copied from
	 * Soy's EscapingConventions):
	 * (1) Either a protocol in a whitelist (http, https, mailto or ftp).
	 * (2) or no protocol.  A protocol must be followed by a colon. The below
	 *     allows that by allowing colons only after one of the characters [/?#].
	 *     A colon after a hash (#) must be in the fragment.
	 *     Otherwise, a colon after a (?) must be in a query.
	 *     Otherwise, a colon after a single solidus (/) must be in a path.
	 *     Otherwise, a colon after a double solidus (//) must be in the authority
	 *     (before port).
	 *
	 * The pattern disallows &, used in HTML entity declarations before
	 * one of the characters in [/?#]. This disallows HTML entities used in the
	 * protocol name, which should never happen, e.g. "h&#116;tp" for "http".
	 * It also disallows HTML entities in the first path part of a relative path,
	 * e.g. "foo&lt;bar/baz".  Our existing escaping functions should not produce
	 * that. More importantly, it disallows masking of a colon,
	 * e.g. "javascript&#58;...".
	 *
	 * This regular expression was taken from the Closure sanitization library.
	 */
	var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
	/**
	 * A pattern that matches safe data URLs. Only matches image, video and audio types.
	 */
	var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
	/**
	 * @param {?} url
	 * @return {?}
	 */
	function sanitizeUrl(url) {
	    url = String(url);
	    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN))
	        return url;
	    if (_angular_core.isDevMode()) {
	        getDOM().log("WARNING: sanitizing unsafe URL value " + url + " (see http://g.co/ng/security#xss)");
	    }
	    return 'unsafe:' + url;
	}
	/**
	 * @param {?} srcset
	 * @return {?}
	 */
	function sanitizeSrcset(srcset) {
	    srcset = String(srcset);
	    return srcset.split(',').map(function (srcset) { return sanitizeUrl(srcset.trim()); }).join(', ');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} tags
	 * @return {?}
	 */
	function tagSet(tags) {
	    var /** @type {?} */ res = {};
	    for (var _i = 0, _a = tags.split(','); _i < _a.length; _i++) {
	        var t = _a[_i];
	        res[t] = true;
	    }
	    return res;
	}
	/**
	 * @param {...?} sets
	 * @return {?}
	 */
	function merge() {
	    var sets = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sets[_i] = arguments[_i];
	    }
	    var /** @type {?} */ res = {};
	    for (var _a = 0, sets_1 = sets; _a < sets_1.length; _a++) {
	        var s = sets_1[_a];
	        for (var /** @type {?} */ v in s) {
	            if (s.hasOwnProperty(v))
	                res[v] = true;
	        }
	    }
	    return res;
	}
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var VOID_ELEMENTS = tagSet('area,br,col,hr,img,wbr');
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var OPTIONAL_END_TAG_BLOCK_ELEMENTS = tagSet('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr');
	var OPTIONAL_END_TAG_INLINE_ELEMENTS = tagSet('rp,rt');
	var OPTIONAL_END_TAG_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, OPTIONAL_END_TAG_BLOCK_ELEMENTS);
	// Safe Block Elements - HTML5
	var BLOCK_ELEMENTS = merge(OPTIONAL_END_TAG_BLOCK_ELEMENTS, tagSet('address,article,' +
	    'aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	    'h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul'));
	// Inline Elements - HTML5
	var INLINE_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, tagSet('a,abbr,acronym,audio,b,' +
	    'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,' +
	    'samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video'));
	var VALID_ELEMENTS = merge(VOID_ELEMENTS, BLOCK_ELEMENTS, INLINE_ELEMENTS, OPTIONAL_END_TAG_ELEMENTS);
	// Attributes that have href and hence need to be sanitized
	var URI_ATTRS = tagSet('background,cite,href,itemtype,longdesc,poster,src,xlink:href');
	// Attributes that have special href set hence need to be sanitized
	var SRCSET_ATTRS = tagSet('srcset');
	var HTML_ATTRS = tagSet('abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,' +
	    'compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,' +
	    'ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,' +
	    'valign,value,vspace,width');
	// NB: This currently consciously doesn't support SVG. SVG sanitization has had several security
	// issues in the past, so it seems safer to leave it out if possible. If support for binding SVG via
	// innerHTML is required, SVG attributes should be added here.
	// NB: Sanitization does not allow <form> elements or other active elements (<button> etc). Those
	// can be sanitized, but they increase security surface area without a legitimate use case, so they
	// are left out here.
	var VALID_ATTRS = merge(URI_ATTRS, SRCSET_ATTRS, HTML_ATTRS);
	/**
	 * SanitizingHtmlSerializer serializes a DOM fragment, stripping out any unsafe elements and unsafe
	 * attributes.
	 */
	var SanitizingHtmlSerializer = /** @class */ (function () {
	    function SanitizingHtmlSerializer() {
	        this.sanitizedSomething = false;
	        this.buf = [];
	        this.DOM = getDOM();
	    }
	    /**
	     * @param {?} el
	     * @return {?}
	     */
	    SanitizingHtmlSerializer.prototype.sanitizeChildren = /**
	     * @param {?} el
	     * @return {?}
	     */
	    function (el) {
	        // This cannot use a TreeWalker, as it has to run on Angular's various DOM adapters.
	        // However this code never accesses properties off of `document` before deleting its contents
	        // again, so it shouldn't be vulnerable to DOM clobbering.
	        var /** @type {?} */ current = /** @type {?} */ ((this.DOM.firstChild(el)));
	        while (current) {
	            if (this.DOM.isElementNode(current)) {
	                this.startElement(/** @type {?} */ (current));
	            }
	            else if (this.DOM.isTextNode(current)) {
	                this.chars(/** @type {?} */ ((this.DOM.nodeValue(current))));
	            }
	            else {
	                // Strip non-element, non-text nodes.
	                this.sanitizedSomething = true;
	            }
	            if (this.DOM.firstChild(current)) {
	                current = /** @type {?} */ ((this.DOM.firstChild(current)));
	                continue;
	            }
	            while (current) {
	                // Leaving the element. Walk up and to the right, closing tags as we go.
	                if (this.DOM.isElementNode(current)) {
	                    this.endElement(/** @type {?} */ (current));
	                }
	                var /** @type {?} */ next = this.checkClobberedElement(current, /** @type {?} */ ((this.DOM.nextSibling(current))));
	                if (next) {
	                    current = next;
	                    break;
	                }
	                current = this.checkClobberedElement(current, /** @type {?} */ ((this.DOM.parentElement(current))));
	            }
	        }
	        return this.buf.join('');
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    SanitizingHtmlSerializer.prototype.startElement = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var _this = this;
	        var /** @type {?} */ tagName = this.DOM.nodeName(element).toLowerCase();
	        if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
	            this.sanitizedSomething = true;
	            return;
	        }
	        this.buf.push('<');
	        this.buf.push(tagName);
	        this.DOM.attributeMap(element).forEach(function (value, attrName) {
	            var /** @type {?} */ lower = attrName.toLowerCase();
	            if (!VALID_ATTRS.hasOwnProperty(lower)) {
	                _this.sanitizedSomething = true;
	                return;
	            }
	            // TODO(martinprobst): Special case image URIs for data:image/...
	            if (URI_ATTRS[lower])
	                value = sanitizeUrl(value);
	            if (SRCSET_ATTRS[lower])
	                value = sanitizeSrcset(value);
	            _this.buf.push(' ');
	            _this.buf.push(attrName);
	            _this.buf.push('="');
	            _this.buf.push(encodeEntities(value));
	            _this.buf.push('"');
	        });
	        this.buf.push('>');
	    };
	    /**
	     * @param {?} current
	     * @return {?}
	     */
	    SanitizingHtmlSerializer.prototype.endElement = /**
	     * @param {?} current
	     * @return {?}
	     */
	    function (current) {
	        var /** @type {?} */ tagName = this.DOM.nodeName(current).toLowerCase();
	        if (VALID_ELEMENTS.hasOwnProperty(tagName) && !VOID_ELEMENTS.hasOwnProperty(tagName)) {
	            this.buf.push('</');
	            this.buf.push(tagName);
	            this.buf.push('>');
	        }
	    };
	    /**
	     * @param {?} chars
	     * @return {?}
	     */
	    SanitizingHtmlSerializer.prototype.chars = /**
	     * @param {?} chars
	     * @return {?}
	     */
	    function (chars) { this.buf.push(encodeEntities(chars)); };
	    /**
	     * @param {?} node
	     * @param {?} nextNode
	     * @return {?}
	     */
	    SanitizingHtmlSerializer.prototype.checkClobberedElement = /**
	     * @param {?} node
	     * @param {?} nextNode
	     * @return {?}
	     */
	    function (node, nextNode) {
	        if (nextNode && this.DOM.contains(node, nextNode)) {
	            throw new Error("Failed to sanitize html because the element is clobbered: " + this.DOM.getOuterHTML(node));
	        }
	        return nextNode;
	    };
	    return SanitizingHtmlSerializer;
	}());
	// Regular Expressions for parsing tags and attributes
	var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// ! to ~ is the ASCII range.
	var NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param {?} value
	 * @return {?}
	 */
	function encodeEntities(value) {
	    return value.replace(/&/g, '&amp;')
	        .replace(SURROGATE_PAIR_REGEXP, function (match) {
	        var /** @type {?} */ hi = match.charCodeAt(0);
	        var /** @type {?} */ low = match.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    })
	        .replace(NON_ALPHANUMERIC_REGEXP, function (match) { return '&#' + match.charCodeAt(0) + ';'; })
	        .replace(/</g, '&lt;')
	        .replace(/>/g, '&gt;');
	}
	var inertBodyHelper;
	/**
	 * Sanitizes the given unsafe, untrusted HTML fragment, and returns HTML text that is safe to add to
	 * the DOM in a browser environment.
	 * @param {?} defaultDoc
	 * @param {?} unsafeHtmlInput
	 * @return {?}
	 */
	function sanitizeHtml(defaultDoc, unsafeHtmlInput) {
	    var /** @type {?} */ DOM = getDOM();
	    var /** @type {?} */ inertBodyElement = null;
	    try {
	        inertBodyHelper = inertBodyHelper || new InertBodyHelper(defaultDoc, DOM);
	        // Make sure unsafeHtml is actually a string (TypeScript types are not enforced at runtime).
	        var /** @type {?} */ unsafeHtml = unsafeHtmlInput ? String(unsafeHtmlInput) : '';
	        inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
	        // mXSS protection. Repeatedly parse the document to make sure it stabilizes, so that a browser
	        // trying to auto-correct incorrect HTML cannot cause formerly inert HTML to become dangerous.
	        var /** @type {?} */ mXSSAttempts = 5;
	        var /** @type {?} */ parsedHtml = unsafeHtml;
	        do {
	            if (mXSSAttempts === 0) {
	                throw new Error('Failed to sanitize html because the input is unstable');
	            }
	            mXSSAttempts--;
	            unsafeHtml = parsedHtml;
	            parsedHtml = DOM.getInnerHTML(inertBodyElement);
	            inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
	        } while (unsafeHtml !== parsedHtml);
	        var /** @type {?} */ sanitizer = new SanitizingHtmlSerializer();
	        var /** @type {?} */ safeHtml = sanitizer.sanitizeChildren(DOM.getTemplateContent(inertBodyElement) || inertBodyElement);
	        if (_angular_core.isDevMode() && sanitizer.sanitizedSomething) {
	            DOM.log('WARNING: sanitizing HTML stripped some content (see http://g.co/ng/security#xss).');
	        }
	        return safeHtml;
	    }
	    finally {
	        // In case anything goes wrong, clear out inertElement to reset the entire DOM structure.
	        if (inertBodyElement) {
	            var /** @type {?} */ parent_1 = DOM.getTemplateContent(inertBodyElement) || inertBodyElement;
	            for (var _i = 0, _a = DOM.childNodesAsList(parent_1); _i < _a.length; _i++) {
	                var child = _a[_i];
	                DOM.removeChild(parent_1, child);
	            }
	        }
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Regular expression for safe style values.
	 *
	 * Quotes (" and ') are allowed, but a check must be done elsewhere to ensure they're balanced.
	 *
	 * ',' allows multiple values to be assigned to the same property (e.g. background-attachment or
	 * font-family) and hence could allow multiple values to get injected, but that should pose no risk
	 * of XSS.
	 *
	 * The function expression checks only for XSS safety, not for CSS validity.
	 *
	 * This regular expression was taken from the Closure sanitization library, and augmented for
	 * transformation values.
	 */
	var VALUES = '[-,."\'%_!# a-zA-Z0-9]+';
	var TRANSFORMATION_FNS = '(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|3d)?';
	var COLOR_FNS = '(?:rgb|hsl)a?';
	var GRADIENTS = '(?:repeating-)?(?:linear|radial)-gradient';
	var CSS3_FNS = '(?:calc|attr)';
	var FN_ARGS = '\\([-0-9.%, #a-zA-Z]+\\)';
	var SAFE_STYLE_VALUE = new RegExp("^(" + VALUES + "|" +
	    ("(?:" + TRANSFORMATION_FNS + "|" + COLOR_FNS + "|" + GRADIENTS + "|" + CSS3_FNS + ")") +
	    (FN_ARGS + ")$"), 'g');
	/**
	 * Matches a `url(...)` value with an arbitrary argument as long as it does
	 * not contain parentheses.
	 *
	 * The URL value still needs to be sanitized separately.
	 *
	 * `url(...)` values are a very common use case, e.g. for `background-image`. With carefully crafted
	 * CSS style rules, it is possible to construct an information leak with `url` values in CSS, e.g.
	 * by observing whether scroll bars are displayed, or character ranges used by a font face
	 * definition.
	 *
	 * Angular only allows binding CSS values (as opposed to entire CSS rules), so it is unlikely that
	 * binding a URL value without further cooperation from the page will cause an information leak, and
	 * if so, it is just a leak, not a full blown XSS vulnerability.
	 *
	 * Given the common use case, low likelihood of attack vector, and low impact of an attack, this
	 * code is permissive and allows URLs that sanitize otherwise.
	 */
	var URL_RE = /^url\(([^)]+)\)$/;
	/**
	 * Checks that quotes (" and ') are properly balanced inside a string. Assumes
	 * that neither escape (\) nor any other character that could result in
	 * breaking out of a string parsing context are allowed;
	 * see http://www.w3.org/TR/css3-syntax/#string-token-diagram.
	 *
	 * This code was taken from the Closure sanitization library.
	 * @param {?} value
	 * @return {?}
	 */
	function hasBalancedQuotes(value) {
	    var /** @type {?} */ outsideSingle = true;
	    var /** @type {?} */ outsideDouble = true;
	    for (var /** @type {?} */ i = 0; i < value.length; i++) {
	        var /** @type {?} */ c = value.charAt(i);
	        if (c === '\'' && outsideDouble) {
	            outsideSingle = !outsideSingle;
	        }
	        else if (c === '"' && outsideSingle) {
	            outsideDouble = !outsideDouble;
	        }
	    }
	    return outsideSingle && outsideDouble;
	}
	/**
	 * Sanitizes the given untrusted CSS style property value (i.e. not an entire object, just a single
	 * value) and returns a value that is safe to use in a browser environment.
	 * @param {?} value
	 * @return {?}
	 */
	function sanitizeStyle(value) {
	    value = String(value).trim(); // Make sure it's actually a string.
	    if (!value)
	        return '';
	    // Single url(...) values are supported, but only for URLs that sanitize cleanly. See above for
	    // reasoning behind this.
	    var /** @type {?} */ urlMatch = value.match(URL_RE);
	    if ((urlMatch && sanitizeUrl(urlMatch[1]) === urlMatch[1]) ||
	        value.match(SAFE_STYLE_VALUE) && hasBalancedQuotes(value)) {
	        return value; // Safe style values.
	    }
	    if (_angular_core.isDevMode()) {
	        getDOM().log("WARNING: sanitizing unsafe style value " + value + " (see http://g.co/ng/security#xss).");
	    }
	    return 'unsafe';
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Marker interface for a value that's safe to use in a particular context.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Marker interface for a value that's safe to use as HTML.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Marker interface for a value that's safe to use as style (CSS).
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Marker interface for a value that's safe to use as JavaScript.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Marker interface for a value that's safe to use as a URL linking to a document.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Marker interface for a value that's safe to use as a URL to load executable code from.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
	 * values to be safe to use in the different DOM contexts.
	 *
	 * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
	 * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
	 * the website.
	 *
	 * In specific situations, it might be necessary to disable sanitization, for example if the
	 * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
	 * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
	 * methods, and then binding to that value from the template.
	 *
	 * These situations should be very rare, and extraordinary care must be taken to avoid creating a
	 * Cross Site Scripting (XSS) security bug!
	 *
	 * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
	 * close as possible to the source of the value, to make it easy to verify no security bug is
	 * created by its use.
	 *
	 * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
	 * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
	 * code. The sanitizer leaves safe values intact.
	 *
	 * \@security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
	 * sanitization for the value passed in. Carefully check and audit all values and code paths going
	 * into this call. Make sure any user data is appropriately escaped for this security context.
	 * For more detail, see the [Security Guide](http://g.co/ng/security).
	 *
	 * \@stable
	 * @abstract
	 */
	var DomSanitizer = /** @class */ (function () {
	    function DomSanitizer() {
	    }
	    return DomSanitizer;
	}());
	var DomSanitizerImpl = /** @class */ (function (_super) {
	    __extends(DomSanitizerImpl, _super);
	    function DomSanitizerImpl(_doc) {
	        var _this = _super.call(this) || this;
	        _this._doc = _doc;
	        return _this;
	    }
	    /**
	     * @param {?} ctx
	     * @param {?} value
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.sanitize = /**
	     * @param {?} ctx
	     * @param {?} value
	     * @return {?}
	     */
	    function (ctx, value) {
	        if (value == null)
	            return null;
	        switch (ctx) {
	            case _angular_core.SecurityContext.NONE:
	                return /** @type {?} */ (value);
	            case _angular_core.SecurityContext.HTML:
	                if (value instanceof SafeHtmlImpl)
	                    return value.changingThisBreaksApplicationSecurity;
	                this.checkNotSafeValue(value, 'HTML');
	                return sanitizeHtml(this._doc, String(value));
	            case _angular_core.SecurityContext.STYLE:
	                if (value instanceof SafeStyleImpl)
	                    return value.changingThisBreaksApplicationSecurity;
	                this.checkNotSafeValue(value, 'Style');
	                return sanitizeStyle(/** @type {?} */ (value));
	            case _angular_core.SecurityContext.SCRIPT:
	                if (value instanceof SafeScriptImpl)
	                    return value.changingThisBreaksApplicationSecurity;
	                this.checkNotSafeValue(value, 'Script');
	                throw new Error('unsafe value used in a script context');
	            case _angular_core.SecurityContext.URL:
	                if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
	                    // Allow resource URLs in URL contexts, they are strictly more trusted.
	                    return value.changingThisBreaksApplicationSecurity;
	                }
	                this.checkNotSafeValue(value, 'URL');
	                return sanitizeUrl(String(value));
	            case _angular_core.SecurityContext.RESOURCE_URL:
	                if (value instanceof SafeResourceUrlImpl) {
	                    return value.changingThisBreaksApplicationSecurity;
	                }
	                this.checkNotSafeValue(value, 'ResourceURL');
	                throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
	            default:
	                throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
	        }
	    };
	    /**
	     * @param {?} value
	     * @param {?} expectedType
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.checkNotSafeValue = /**
	     * @param {?} value
	     * @param {?} expectedType
	     * @return {?}
	     */
	    function (value, expectedType) {
	        if (value instanceof SafeValueImpl) {
	            throw new Error("Required a safe " + expectedType + ", got a " + value.getTypeName() + " " +
	                "(see http://g.co/ng/security#xss)");
	        }
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.bypassSecurityTrustHtml = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return new SafeHtmlImpl(value); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.bypassSecurityTrustStyle = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return new SafeStyleImpl(value); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.bypassSecurityTrustScript = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return new SafeScriptImpl(value); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.bypassSecurityTrustUrl = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return new SafeUrlImpl(value); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return new SafeResourceUrlImpl(value);
	    };
	    DomSanitizerImpl.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    DomSanitizerImpl.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [DOCUMENT$1,] },] },
	    ]; };
	    return DomSanitizerImpl;
	}(DomSanitizer));
	/**
	 * @abstract
	 */
	var SafeValueImpl = /** @class */ (function () {
	    function SafeValueImpl(changingThisBreaksApplicationSecurity) {
	        // empty
	        this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
	    }
	    /**
	     * @return {?}
	     */
	    SafeValueImpl.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return "SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity +
	            " (see http://g.co/ng/security#xss)";
	    };
	    return SafeValueImpl;
	}());
	var SafeHtmlImpl = /** @class */ (function (_super) {
	    __extends(SafeHtmlImpl, _super);
	    function SafeHtmlImpl() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    SafeHtmlImpl.prototype.getTypeName = /**
	     * @return {?}
	     */
	    function () { return 'HTML'; };
	    return SafeHtmlImpl;
	}(SafeValueImpl));
	var SafeStyleImpl = /** @class */ (function (_super) {
	    __extends(SafeStyleImpl, _super);
	    function SafeStyleImpl() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    SafeStyleImpl.prototype.getTypeName = /**
	     * @return {?}
	     */
	    function () { return 'Style'; };
	    return SafeStyleImpl;
	}(SafeValueImpl));
	var SafeScriptImpl = /** @class */ (function (_super) {
	    __extends(SafeScriptImpl, _super);
	    function SafeScriptImpl() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    SafeScriptImpl.prototype.getTypeName = /**
	     * @return {?}
	     */
	    function () { return 'Script'; };
	    return SafeScriptImpl;
	}(SafeValueImpl));
	var SafeUrlImpl = /** @class */ (function (_super) {
	    __extends(SafeUrlImpl, _super);
	    function SafeUrlImpl() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    SafeUrlImpl.prototype.getTypeName = /**
	     * @return {?}
	     */
	    function () { return 'URL'; };
	    return SafeUrlImpl;
	}(SafeValueImpl));
	var SafeResourceUrlImpl = /** @class */ (function (_super) {
	    __extends(SafeResourceUrlImpl, _super);
	    function SafeResourceUrlImpl() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    SafeResourceUrlImpl.prototype.getTypeName = /**
	     * @return {?}
	     */
	    function () { return 'ResourceURL'; };
	    return SafeResourceUrlImpl;
	}(SafeValueImpl));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
	    { provide: _angular_core.PLATFORM_ID, useValue: _angular_common.ɵPLATFORM_BROWSER_ID },
	    { provide: _angular_core.PLATFORM_INITIALIZER, useValue: initDomAdapter, multi: true },
	    { provide: _angular_common.PlatformLocation, useClass: BrowserPlatformLocation, deps: [DOCUMENT$1] },
	    { provide: DOCUMENT$1, useFactory: _document, deps: [] },
	];
	/**
	 * \@security Replacing built-in sanitization providers exposes the application to XSS risks.
	 * Attacker-controlled data introduced by an unsanitized provider could expose your
	 * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
	 * \@experimental
	 */
	var BROWSER_SANITIZATION_PROVIDERS = [
	    { provide: _angular_core.Sanitizer, useExisting: DomSanitizer },
	    { provide: DomSanitizer, useClass: DomSanitizerImpl, deps: [DOCUMENT$1] },
	];
	/**
	 * \@stable
	 */
	var platformBrowser = _angular_core.createPlatformFactory(_angular_core.platformCore, 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
	/**
	 * @return {?}
	 */
	function initDomAdapter() {
	    BrowserDomAdapter.makeCurrent();
	    BrowserGetTestability.init();
	}
	/**
	 * @return {?}
	 */
	function errorHandler() {
	    return new _angular_core.ErrorHandler();
	}
	/**
	 * @return {?}
	 */
	function _document() {
	    return document;
	}
	/**
	 * The ng module for the browser.
	 *
	 * \@stable
	 */
	var BrowserModule = /** @class */ (function () {
	    function BrowserModule(parentModule) {
	        if (parentModule) {
	            throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.");
	        }
	    }
	    /**
	     * Configures a browser-based application to transition from a server-rendered app, if
	     * one is present on the page. The specified parameters must include an application id,
	     * which must match between the client and server applications.
	     *
	     * @experimental
	     */
	    /**
	     * Configures a browser-based application to transition from a server-rendered app, if
	     * one is present on the page. The specified parameters must include an application id,
	     * which must match between the client and server applications.
	     *
	     * \@experimental
	     * @param {?} params
	     * @return {?}
	     */
	    BrowserModule.withServerTransition = /**
	     * Configures a browser-based application to transition from a server-rendered app, if
	     * one is present on the page. The specified parameters must include an application id,
	     * which must match between the client and server applications.
	     *
	     * \@experimental
	     * @param {?} params
	     * @return {?}
	     */
	    function (params) {
	        return {
	            ngModule: BrowserModule,
	            providers: [
	                { provide: _angular_core.APP_ID, useValue: params.appId },
	                { provide: TRANSITION_ID, useExisting: _angular_core.APP_ID },
	                SERVER_TRANSITION_PROVIDERS,
	            ],
	        };
	    };
	    BrowserModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        BROWSER_SANITIZATION_PROVIDERS,
	                        { provide: _angular_core.ErrorHandler, useFactory: errorHandler, deps: [] },
	                        { provide: EVENT_MANAGER_PLUGINS, useClass: DomEventsPlugin, multi: true },
	                        { provide: EVENT_MANAGER_PLUGINS, useClass: KeyEventsPlugin, multi: true },
	                        { provide: EVENT_MANAGER_PLUGINS, useClass: HammerGesturesPlugin, multi: true },
	                        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
	                        DomRendererFactory2,
	                        { provide: _angular_core.RendererFactory2, useExisting: DomRendererFactory2 },
	                        { provide: SharedStylesHost, useExisting: DomSharedStylesHost },
	                        DomSharedStylesHost,
	                        _angular_core.Testability,
	                        EventManager,
	                        ELEMENT_PROBE_PROVIDERS,
	                        Meta,
	                        Title,
	                    ],
	                    exports: [_angular_common.CommonModule, _angular_core.ApplicationModule]
	                },] },
	    ];
	    /** @nocollapse */
	    BrowserModule.ctorParameters = function () { return [
	        { type: BrowserModule, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.SkipSelf },] },
	    ]; };
	    return BrowserModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var win = typeof window !== 'undefined' && window || /** @type {?} */ ({});
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ChangeDetectionPerfRecord = /** @class */ (function () {
	    function ChangeDetectionPerfRecord(msPerTick, numTicks) {
	        this.msPerTick = msPerTick;
	        this.numTicks = numTicks;
	    }
	    return ChangeDetectionPerfRecord;
	}());
	/**
	 * Entry point for all Angular profiling-related debug tools. This object
	 * corresponds to the `ng.profiler` in the dev console.
	 */
	var AngularProfiler = /** @class */ (function () {
	    function AngularProfiler(ref) {
	        this.appRef = ref.injector.get(_angular_core.ApplicationRef);
	    }
	    // tslint:disable:no-console
	    /**
	     * Exercises change detection in a loop and then prints the average amount of
	     * time in milliseconds how long a single round of change detection takes for
	     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
	     * of 500 milliseconds.
	     *
	     * Optionally, a user may pass a `config` parameter containing a map of
	     * options. Supported options are:
	     *
	     * `record` (boolean) - causes the profiler to record a CPU profile while
	     * it exercises the change detector. Example:
	     *
	     * ```
	     * ng.profiler.timeChangeDetection({record: true})
	     * ```
	     */
	    /**
	     * Exercises change detection in a loop and then prints the average amount of
	     * time in milliseconds how long a single round of change detection takes for
	     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
	     * of 500 milliseconds.
	     *
	     * Optionally, a user may pass a `config` parameter containing a map of
	     * options. Supported options are:
	     *
	     * `record` (boolean) - causes the profiler to record a CPU profile while
	     * it exercises the change detector. Example:
	     *
	     * ```
	     * ng.profiler.timeChangeDetection({record: true})
	     * ```
	     * @param {?} config
	     * @return {?}
	     */
	    AngularProfiler.prototype.timeChangeDetection = /**
	     * Exercises change detection in a loop and then prints the average amount of
	     * time in milliseconds how long a single round of change detection takes for
	     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
	     * of 500 milliseconds.
	     *
	     * Optionally, a user may pass a `config` parameter containing a map of
	     * options. Supported options are:
	     *
	     * `record` (boolean) - causes the profiler to record a CPU profile while
	     * it exercises the change detector. Example:
	     *
	     * ```
	     * ng.profiler.timeChangeDetection({record: true})
	     * ```
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        var /** @type {?} */ record = config && config['record'];
	        var /** @type {?} */ profileName = 'Change Detection';
	        // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
	        var /** @type {?} */ isProfilerAvailable = win.console.profile != null;
	        if (record && isProfilerAvailable) {
	            win.console.profile(profileName);
	        }
	        var /** @type {?} */ start = getDOM().performanceNow();
	        var /** @type {?} */ numTicks = 0;
	        while (numTicks < 5 || (getDOM().performanceNow() - start) < 500) {
	            this.appRef.tick();
	            numTicks++;
	        }
	        var /** @type {?} */ end = getDOM().performanceNow();
	        if (record && isProfilerAvailable) {
	            // need to cast to <any> because type checker thinks there's no argument
	            // while in fact there is:
	            //
	            // https://developer.mozilla.org/en-US/docs/Web/API/Console/profileEnd
	            (/** @type {?} */ (win.console.profileEnd))(profileName);
	        }
	        var /** @type {?} */ msPerTick = (end - start) / numTicks;
	        win.console.log("ran " + numTicks + " change detection cycles");
	        win.console.log(msPerTick.toFixed(2) + " ms per check");
	        return new ChangeDetectionPerfRecord(msPerTick, numTicks);
	    };
	    return AngularProfiler;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var PROFILER_GLOBAL_NAME = 'profiler';
	/**
	 * Enabled Angular debug tools that are accessible via your browser's
	 * developer console.
	 *
	 * Usage:
	 *
	 * 1. Open developer console (e.g. in Chrome Ctrl + Shift + j)
	 * 1. Type `ng.` (usually the console will show auto-complete suggestion)
	 * 1. Try the change detection profiler `ng.profiler.timeChangeDetection()`
	 *    then hit Enter.
	 *
	 * \@experimental All debugging apis are currently experimental.
	 * @template T
	 * @param {?} ref
	 * @return {?}
	 */
	function enableDebugTools(ref) {
	    exportNgVar(PROFILER_GLOBAL_NAME, new AngularProfiler(ref));
	    return ref;
	}
	/**
	 * Disables Angular tools.
	 *
	 * \@experimental All debugging apis are currently experimental.
	 * @return {?}
	 */
	function disableDebugTools() {
	    exportNgVar(PROFILER_GLOBAL_NAME, null);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} text
	 * @return {?}
	 */
	function escapeHtml(text) {
	    var /** @type {?} */ escapedText = {
	        '&': '&a;',
	        '"': '&q;',
	        '\'': '&s;',
	        '<': '&l;',
	        '>': '&g;',
	    };
	    return text.replace(/[&"'<>]/g, function (s) { return escapedText[s]; });
	}
	/**
	 * @param {?} text
	 * @return {?}
	 */
	function unescapeHtml(text) {
	    var /** @type {?} */ unescapedText = {
	        '&a;': '&',
	        '&q;': '"',
	        '&s;': '\'',
	        '&l;': '<',
	        '&g;': '>',
	    };
	    return text.replace(/&[^;]+;/g, function (s) { return unescapedText[s]; });
	}
	/**
	 * Create a `StateKey<T>` that can be used to store value of type T with `TransferState`.
	 *
	 * Example:
	 *
	 * ```
	 * const COUNTER_KEY = makeStateKey<number>('counter');
	 * let value = 10;
	 *
	 * transferState.set(COUNTER_KEY, value);
	 * ```
	 *
	 * \@experimental
	 * @template T
	 * @param {?} key
	 * @return {?}
	 */
	function makeStateKey(key) {
	    return /** @type {?} */ (key);
	}
	/**
	 * A key value store that is transferred from the application on the server side to the application
	 * on the client side.
	 *
	 * `TransferState` will be available as an injectable token. To use it import
	 * `ServerTransferStateModule` on the server and `BrowserTransferStateModule` on the client.
	 *
	 * The values in the store are serialized/deserialized using JSON.stringify/JSON.parse. So only
	 * boolean, number, string, null and non-class objects will be serialized and deserialzied in a
	 * non-lossy manner.
	 *
	 * \@experimental
	 */
	var TransferState = /** @class */ (function () {
	    function TransferState() {
	        this.store = {};
	        this.onSerializeCallbacks = {};
	    }
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} initState
	     * @return {?}
	     */
	    TransferState.init = /**
	     * \@internal
	     * @param {?} initState
	     * @return {?}
	     */
	    function (initState) {
	        var /** @type {?} */ transferState = new TransferState();
	        transferState.store = initState;
	        return transferState;
	    };
	    /**
	     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
	     */
	    /**
	     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
	     * @template T
	     * @param {?} key
	     * @param {?} defaultValue
	     * @return {?}
	     */
	    TransferState.prototype.get = /**
	     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
	     * @template T
	     * @param {?} key
	     * @param {?} defaultValue
	     * @return {?}
	     */
	    function (key, defaultValue) {
	        return this.store[key] !== undefined ? /** @type {?} */ (this.store[key]) : defaultValue;
	    };
	    /**
	     * Set the value corresponding to a key.
	     */
	    /**
	     * Set the value corresponding to a key.
	     * @template T
	     * @param {?} key
	     * @param {?} value
	     * @return {?}
	     */
	    TransferState.prototype.set = /**
	     * Set the value corresponding to a key.
	     * @template T
	     * @param {?} key
	     * @param {?} value
	     * @return {?}
	     */
	    function (key, value) { this.store[key] = value; };
	    /**
	     * Remove a key from the store.
	     */
	    /**
	     * Remove a key from the store.
	     * @template T
	     * @param {?} key
	     * @return {?}
	     */
	    TransferState.prototype.remove = /**
	     * Remove a key from the store.
	     * @template T
	     * @param {?} key
	     * @return {?}
	     */
	    function (key) { delete this.store[key]; };
	    /**
	     * Test whether a key exists in the store.
	     */
	    /**
	     * Test whether a key exists in the store.
	     * @template T
	     * @param {?} key
	     * @return {?}
	     */
	    TransferState.prototype.hasKey = /**
	     * Test whether a key exists in the store.
	     * @template T
	     * @param {?} key
	     * @return {?}
	     */
	    function (key) { return this.store.hasOwnProperty(key); };
	    /**
	     * Register a callback to provide the value for a key when `toJson` is called.
	     */
	    /**
	     * Register a callback to provide the value for a key when `toJson` is called.
	     * @template T
	     * @param {?} key
	     * @param {?} callback
	     * @return {?}
	     */
	    TransferState.prototype.onSerialize = /**
	     * Register a callback to provide the value for a key when `toJson` is called.
	     * @template T
	     * @param {?} key
	     * @param {?} callback
	     * @return {?}
	     */
	    function (key, callback) {
	        this.onSerializeCallbacks[key] = callback;
	    };
	    /**
	     * Serialize the current state of the store to JSON.
	     */
	    /**
	     * Serialize the current state of the store to JSON.
	     * @return {?}
	     */
	    TransferState.prototype.toJson = /**
	     * Serialize the current state of the store to JSON.
	     * @return {?}
	     */
	    function () {
	        // Call the onSerialize callbacks and put those values into the store.
	        for (var /** @type {?} */ key in this.onSerializeCallbacks) {
	            if (this.onSerializeCallbacks.hasOwnProperty(key)) {
	                try {
	                    this.store[key] = this.onSerializeCallbacks[key]();
	                }
	                catch (/** @type {?} */ e) {
	                    console.warn('Exception in onSerialize callback: ', e);
	                }
	            }
	        }
	        return JSON.stringify(this.store);
	    };
	    TransferState.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    TransferState.ctorParameters = function () { return []; };
	    return TransferState;
	}());
	/**
	 * @param {?} doc
	 * @param {?} appId
	 * @return {?}
	 */
	function initTransferState(doc, appId) {
	    // Locate the script tag with the JSON data transferred from the server.
	    // The id of the script tag is set to the Angular appId + 'state'.
	    var /** @type {?} */ script = doc.getElementById(appId + '-state');
	    var /** @type {?} */ initialState = {};
	    if (script && script.textContent) {
	        try {
	            initialState = JSON.parse(unescapeHtml(script.textContent));
	        }
	        catch (/** @type {?} */ e) {
	            console.warn('Exception while restoring TransferState for app ' + appId, e);
	        }
	    }
	    return TransferState.init(initialState);
	}
	/**
	 * NgModule to install on the client side while using the `TransferState` to transfer state from
	 * server to client.
	 *
	 * \@experimental
	 */
	var BrowserTransferStateModule = /** @class */ (function () {
	    function BrowserTransferStateModule() {
	    }
	    BrowserTransferStateModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [{ provide: TransferState, useFactory: initTransferState, deps: [DOCUMENT$1, _angular_core.APP_ID] }],
	                },] },
	    ];
	    /** @nocollapse */
	    BrowserTransferStateModule.ctorParameters = function () { return []; };
	    return BrowserTransferStateModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Predicates for use with {\@link DebugElement}'s query functions.
	 *
	 * \@experimental All debugging apis are currently experimental.
	 */
	var By = /** @class */ (function () {
	    function By() {
	    }
	    /**
	     * Match all elements.
	     *
	     * ## Example
	     *
	     * {@example platform-browser/dom/debug/ts/by/by.ts region='by_all'}
	     */
	    /**
	     * Match all elements.
	     *
	     * ## Example
	     *
	     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_all'}
	     * @return {?}
	     */
	    By.all = /**
	     * Match all elements.
	     *
	     * ## Example
	     *
	     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_all'}
	     * @return {?}
	     */
	    function () { return function (debugElement) { return true; }; };
	    /**
	     * Match elements by the given CSS selector.
	     *
	     * ## Example
	     *
	     * {@example platform-browser/dom/debug/ts/by/by.ts region='by_css'}
	     */
	    /**
	     * Match elements by the given CSS selector.
	     *
	     * ## Example
	     *
	     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_css'}
	     * @param {?} selector
	     * @return {?}
	     */
	    By.css = /**
	     * Match elements by the given CSS selector.
	     *
	     * ## Example
	     *
	     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_css'}
	     * @param {?} selector
	     * @return {?}
	     */
	    function (selector) {
	        return function (debugElement) {
	            return debugElement.nativeElement != null ?
	                getDOM().elementMatches(debugElement.nativeElement, selector) :
	                false;
	        };
	    };
	    /**
	     * Match elements that have the given directive present.
	     *
	     * ## Example
	     *
	     * {@example platform-browser/dom/debug/ts/by/by.ts region='by_directive'}
	     */
	    /**
	     * Match elements that have the given directive present.
	     *
	     * ## Example
	     *
	     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_directive'}
	     * @param {?} type
	     * @return {?}
	     */
	    By.directive = /**
	     * Match elements that have the given directive present.
	     *
	     * ## Example
	     *
	     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_directive'}
	     * @param {?} type
	     * @return {?}
	     */
	    function (type) {
	        return function (debugElement) { return ((debugElement.providerTokens)).indexOf(type) !== -1; };
	    };
	    return By;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var VERSION = new _angular_core.Version('5.2.11');
	
	exports.BrowserModule = BrowserModule;
	exports.platformBrowser = platformBrowser;
	exports.Meta = Meta;
	exports.Title = Title;
	exports.disableDebugTools = disableDebugTools;
	exports.enableDebugTools = enableDebugTools;
	exports.BrowserTransferStateModule = BrowserTransferStateModule;
	exports.TransferState = TransferState;
	exports.makeStateKey = makeStateKey;
	exports.By = By;
	exports.DOCUMENT = DOCUMENT$1;
	exports.EVENT_MANAGER_PLUGINS = EVENT_MANAGER_PLUGINS;
	exports.EventManager = EventManager;
	exports.HAMMER_GESTURE_CONFIG = HAMMER_GESTURE_CONFIG;
	exports.HammerGestureConfig = HammerGestureConfig;
	exports.DomSanitizer = DomSanitizer;
	exports.VERSION = VERSION;
	exports.ɵBROWSER_SANITIZATION_PROVIDERS = BROWSER_SANITIZATION_PROVIDERS;
	exports.ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS = INTERNAL_BROWSER_PLATFORM_PROVIDERS;
	exports.ɵinitDomAdapter = initDomAdapter;
	exports.ɵBrowserDomAdapter = BrowserDomAdapter;
	exports.ɵBrowserPlatformLocation = BrowserPlatformLocation;
	exports.ɵTRANSITION_ID = TRANSITION_ID;
	exports.ɵBrowserGetTestability = BrowserGetTestability;
	exports.ɵescapeHtml = escapeHtml;
	exports.ɵELEMENT_PROBE_PROVIDERS = ELEMENT_PROBE_PROVIDERS;
	exports.ɵDomAdapter = DomAdapter;
	exports.ɵgetDOM = getDOM;
	exports.ɵsetRootDomAdapter = setRootDomAdapter;
	exports.ɵDomRendererFactory2 = DomRendererFactory2;
	exports.ɵNAMESPACE_URIS = NAMESPACE_URIS;
	exports.ɵflattenStyles = flattenStyles;
	exports.ɵshimContentAttribute = shimContentAttribute;
	exports.ɵshimHostAttribute = shimHostAttribute;
	exports.ɵDomEventsPlugin = DomEventsPlugin;
	exports.ɵHammerGesturesPlugin = HammerGesturesPlugin;
	exports.ɵKeyEventsPlugin = KeyEventsPlugin;
	exports.ɵDomSharedStylesHost = DomSharedStylesHost;
	exports.ɵSharedStylesHost = SharedStylesHost;
	exports.ɵb = _document;
	exports.ɵa = errorHandler;
	exports.ɵi = GenericBrowserDomAdapter;
	exports.ɵg = SERVER_TRANSITION_PROVIDERS;
	exports.ɵf = appInitializerFactory;
	exports.ɵc = initTransferState;
	exports.ɵh = _createNgProbe;
	exports.ɵd = EventManagerPlugin;
	exports.ɵe = DomSanitizerImpl;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=platform-browser.umd.js.map


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(223);
	exports.of = ArrayObservable_1.ArrayObservable.of;
	//# sourceMappingURL=of.js.map

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return function mapOperation(source) {
	        if (typeof project !== 'function') {
	            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	        }
	        return source.lift(new MapOperator(project, thisArg));
	    };
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	exports.MapOperator = MapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        _super.call(this, destination);
	        this.project = project;
	        this.count = 0;
	        this.thisArg = thisArg || this;
	    }
	    // NOTE: This looks unoptimized, but it's actually purposefully NOT
	    // using try/catch optimizations.
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=map.js.map

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var scan_1 = __webpack_require__(259);
	var takeLast_1 = __webpack_require__(260);
	var defaultIfEmpty_1 = __webpack_require__(262);
	var pipe_1 = __webpack_require__(220);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        return function reduceOperatorFunctionWithSeed(source) {
	            return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
	        };
	    }
	    return function reduceOperatorFunction(source) {
	        return pipe_1.pipe(scan_1.scan(function (acc, value, index) {
	            return accumulator(acc, value, index + 1);
	        }), takeLast_1.takeLast(1))(source);
	    };
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    var hasSeed = false;
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        hasSeed = true;
	    }
	    return function scanOperatorFunction(source) {
	        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
	    };
	}
	exports.scan = scan;
	var ScanOperator = (function () {
	    function ScanOperator(accumulator, seed, hasSeed) {
	        if (hasSeed === void 0) { hasSeed = false; }
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.hasSeed = hasSeed;
	    }
	    ScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
	    };
	    return ScanOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ScanSubscriber = (function (_super) {
	    __extends(ScanSubscriber, _super);
	    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this._seed = _seed;
	        this.hasSeed = hasSeed;
	        this.index = 0;
	    }
	    Object.defineProperty(ScanSubscriber.prototype, "seed", {
	        get: function () {
	            return this._seed;
	        },
	        set: function (value) {
	            this.hasSeed = true;
	            this._seed = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScanSubscriber.prototype._next = function (value) {
	        if (!this.hasSeed) {
	            this.seed = value;
	            this.destination.next(value);
	        }
	        else {
	            return this._tryNext(value);
	        }
	    };
	    ScanSubscriber.prototype._tryNext = function (value) {
	        var index = this.index++;
	        var result;
	        try {
	            result = this.accumulator(this.seed, value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	        this.seed = result;
	        this.destination.next(result);
	    };
	    return ScanSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=scan.js.map

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var ArgumentOutOfRangeError_1 = __webpack_require__(261);
	var EmptyObservable_1 = __webpack_require__(225);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    return function takeLastOperatorFunction(source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else {
	            return source.lift(new TakeLastOperator(count));
	        }
	    };
	}
	exports.takeLast = takeLast;
	var TakeLastOperator = (function () {
	    function TakeLastOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeLastOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
	    };
	    return TakeLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeLastSubscriber = (function (_super) {
	    __extends(TakeLastSubscriber, _super);
	    function TakeLastSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.ring = new Array();
	        this.count = 0;
	    }
	    TakeLastSubscriber.prototype._next = function (value) {
	        var ring = this.ring;
	        var total = this.total;
	        var count = this.count++;
	        if (ring.length < total) {
	            ring.push(value);
	        }
	        else {
	            var index = count % total;
	            ring[index] = value;
	        }
	    };
	    TakeLastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var count = this.count;
	        if (count > 0) {
	            var total = this.count >= this.total ? this.total : this.count;
	            var ring = this.ring;
	            for (var i = 0; i < total; i++) {
	                var idx = (count++) % total;
	                destination.next(ring[idx]);
	            }
	        }
	        destination.complete();
	    };
	    return TakeLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeLast.js.map

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an element was queried at a certain index of an
	 * Observable, but no such index or position exists in that sequence.
	 *
	 * @see {@link elementAt}
	 * @see {@link take}
	 * @see {@link takeLast}
	 *
	 * @class ArgumentOutOfRangeError
	 */
	var ArgumentOutOfRangeError = (function (_super) {
	    __extends(ArgumentOutOfRangeError, _super);
	    function ArgumentOutOfRangeError() {
	        var err = _super.call(this, 'argument out of range');
	        this.name = err.name = 'ArgumentOutOfRangeError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ArgumentOutOfRangeError;
	}(Error));
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
	//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/* tslint:enable:max-line-length */
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	var DefaultIfEmptyOperator = (function () {
	    function DefaultIfEmptyOperator(defaultValue) {
	        this.defaultValue = defaultValue;
	    }
	    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
	    };
	    return DefaultIfEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DefaultIfEmptySubscriber = (function (_super) {
	    __extends(DefaultIfEmptySubscriber, _super);
	    function DefaultIfEmptySubscriber(destination, defaultValue) {
	        _super.call(this, destination);
	        this.defaultValue = defaultValue;
	        this.isEmpty = true;
	    }
	    DefaultIfEmptySubscriber.prototype._next = function (value) {
	        this.isEmpty = false;
	        this.destination.next(value);
	    };
	    DefaultIfEmptySubscriber.prototype._complete = function () {
	        if (this.isEmpty) {
	            this.destination.next(this.defaultValue);
	        }
	        this.destination.complete();
	    };
	    return DefaultIfEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(269)(module)))

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(246), __webpack_require__(205), __webpack_require__(271), __webpack_require__(240), __webpack_require__(253), __webpack_require__(272), __webpack_require__(274), __webpack_require__(275), __webpack_require__(206), __webpack_require__(276), __webpack_require__(283), __webpack_require__(285), __webpack_require__(287), __webpack_require__(289), __webpack_require__(290), __webpack_require__(291), __webpack_require__(293), __webpack_require__(295), __webpack_require__(296), __webpack_require__(247), __webpack_require__(297)) :
		typeof define === 'function' && define.amd ? define('@angular/router', ['exports', '@angular/common', '@angular/core', 'rxjs/BehaviorSubject', 'rxjs/Subject', 'rxjs/observable/of', 'rxjs/operator/concatMap', 'rxjs/operator/map', 'rxjs/operator/mergeMap', 'rxjs/Observable', 'rxjs/observable/from', 'rxjs/operator/catch', 'rxjs/operator/concatAll', 'rxjs/operator/first', 'rxjs/util/EmptyError', 'rxjs/observable/fromPromise', 'rxjs/operator/every', 'rxjs/operator/last', 'rxjs/operator/mergeAll', 'rxjs/operator/reduce', '@angular/platform-browser', 'rxjs/operator/filter'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.router = {}),global.ng.common,global.ng.core,global.Rx,global.Rx,global.Rx.Observable,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx,global.Rx.Observable,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx,global.Rx.Observable,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.ng.platformBrowser,global.Rx.Observable.prototype));
	}(this, (function (exports,_angular_common,_angular_core,rxjs_BehaviorSubject,rxjs_Subject,rxjs_observable_of,rxjs_operator_concatMap,rxjs_operator_map,rxjs_operator_mergeMap,rxjs_Observable,rxjs_observable_from,rxjs_operator_catch,rxjs_operator_concatAll,rxjs_operator_first,rxjs_util_EmptyError,rxjs_observable_fromPromise,rxjs_operator_every,rxjs_operator_last,rxjs_operator_mergeAll,rxjs_operator_reduce,_angular_platformBrowser,rxjs_operator_filter) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Base for events the Router goes through, as opposed to events tied to a specific
	 * Route. `RouterEvent`s will only be fired one time for any given navigation.
	 *
	 * Example:
	 *
	 * ```
	 * class MyService {
	 *   constructor(public router: Router, logger: Logger) {
	 *     router.events.filter(e => e instanceof RouterEvent).subscribe(e => {
	 *       logger.log(e.id, e.url);
	 *     });
	 *   }
	 * }
	 * ```
	 *
	 * \@experimental
	 */
	var RouterEvent = /** @class */ (function () {
	    function RouterEvent(id, url) {
	        this.id = id;
	        this.url = url;
	    }
	    return RouterEvent;
	}());
	/**
	 * \@whatItDoes Represents an event triggered when a navigation starts.
	 *
	 * \@stable
	 */
	var NavigationStart = /** @class */ (function (_super) {
	    __extends(NavigationStart, _super);
	    function NavigationStart() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    NavigationStart.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
	    return NavigationStart;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents an event triggered when a navigation ends successfully.
	 *
	 * \@stable
	 */
	var NavigationEnd = /** @class */ (function (_super) {
	    __extends(NavigationEnd, _super);
	    function NavigationEnd(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, urlAfterRedirects) {
	        var _this = _super.call(this, id, url) || this;
	        _this.urlAfterRedirects = urlAfterRedirects;
	        return _this;
	    }
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    NavigationEnd.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () {
	        return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
	    };
	    return NavigationEnd;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents an event triggered when a navigation is canceled.
	 *
	 * \@stable
	 */
	var NavigationCancel = /** @class */ (function (_super) {
	    __extends(NavigationCancel, _super);
	    function NavigationCancel(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, reason) {
	        var _this = _super.call(this, id, url) || this;
	        _this.reason = reason;
	        return _this;
	    }
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    NavigationCancel.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
	    return NavigationCancel;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents an event triggered when a navigation fails due to an unexpected error.
	 *
	 * \@stable
	 */
	var NavigationError = /** @class */ (function (_super) {
	    __extends(NavigationError, _super);
	    function NavigationError(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, error) {
	        var _this = _super.call(this, id, url) || this;
	        _this.error = error;
	        return _this;
	    }
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    NavigationError.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () {
	        return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
	    };
	    return NavigationError;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents an event triggered when routes are recognized.
	 *
	 * \@stable
	 */
	var RoutesRecognized = /** @class */ (function (_super) {
	    __extends(RoutesRecognized, _super);
	    function RoutesRecognized(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, urlAfterRedirects, state) {
	        var _this = _super.call(this, id, url) || this;
	        _this.urlAfterRedirects = urlAfterRedirects;
	        _this.state = state;
	        return _this;
	    }
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    RoutesRecognized.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () {
	        return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
	    };
	    return RoutesRecognized;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents the start of the Guard phase of routing.
	 *
	 * \@experimental
	 */
	var GuardsCheckStart = /** @class */ (function (_super) {
	    __extends(GuardsCheckStart, _super);
	    function GuardsCheckStart(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, urlAfterRedirects, state) {
	        var _this = _super.call(this, id, url) || this;
	        _this.urlAfterRedirects = urlAfterRedirects;
	        _this.state = state;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    GuardsCheckStart.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return "GuardsCheckStart(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
	    };
	    return GuardsCheckStart;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents the end of the Guard phase of routing.
	 *
	 * \@experimental
	 */
	var GuardsCheckEnd = /** @class */ (function (_super) {
	    __extends(GuardsCheckEnd, _super);
	    function GuardsCheckEnd(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, urlAfterRedirects, state, shouldActivate) {
	        var _this = _super.call(this, id, url) || this;
	        _this.urlAfterRedirects = urlAfterRedirects;
	        _this.state = state;
	        _this.shouldActivate = shouldActivate;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    GuardsCheckEnd.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return "GuardsCheckEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ", shouldActivate: " + this.shouldActivate + ")";
	    };
	    return GuardsCheckEnd;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents the start of the Resolve phase of routing. The timing of this
	 * event may change, thus it's experimental. In the current iteration it will run
	 * in the "resolve" phase whether there's things to resolve or not. In the future this
	 * behavior may change to only run when there are things to be resolved.
	 *
	 * \@experimental
	 */
	var ResolveStart = /** @class */ (function (_super) {
	    __extends(ResolveStart, _super);
	    function ResolveStart(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, urlAfterRedirects, state) {
	        var _this = _super.call(this, id, url) || this;
	        _this.urlAfterRedirects = urlAfterRedirects;
	        _this.state = state;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    ResolveStart.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return "ResolveStart(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
	    };
	    return ResolveStart;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents the end of the Resolve phase of routing. See note on
	 * {\@link ResolveStart} for use of this experimental API.
	 *
	 * \@experimental
	 */
	var ResolveEnd = /** @class */ (function (_super) {
	    __extends(ResolveEnd, _super);
	    function ResolveEnd(/** @docsNotRequired */
	        /** @docsNotRequired */
	        id, /** @docsNotRequired */
	        /** @docsNotRequired */
	        url, urlAfterRedirects, state) {
	        var _this = _super.call(this, id, url) || this;
	        _this.urlAfterRedirects = urlAfterRedirects;
	        _this.state = state;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    ResolveEnd.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return "ResolveEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
	    };
	    return ResolveEnd;
	}(RouterEvent));
	/**
	 * \@whatItDoes Represents an event triggered before lazy loading a route config.
	 *
	 * \@experimental
	 */
	var RouteConfigLoadStart = /** @class */ (function () {
	    function RouteConfigLoadStart(route) {
	        this.route = route;
	    }
	    /**
	     * @return {?}
	     */
	    RouteConfigLoadStart.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return "RouteConfigLoadStart(path: " + this.route.path + ")"; };
	    return RouteConfigLoadStart;
	}());
	/**
	 * \@whatItDoes Represents an event triggered when a route has been lazy loaded.
	 *
	 * \@experimental
	 */
	var RouteConfigLoadEnd = /** @class */ (function () {
	    function RouteConfigLoadEnd(route) {
	        this.route = route;
	    }
	    /**
	     * @return {?}
	     */
	    RouteConfigLoadEnd.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return "RouteConfigLoadEnd(path: " + this.route.path + ")"; };
	    return RouteConfigLoadEnd;
	}());
	/**
	 * \@whatItDoes Represents the start of end of the Resolve phase of routing. See note on
	 * {\@link ChildActivationEnd} for use of this experimental API.
	 *
	 * \@experimental
	 */
	var ChildActivationStart = /** @class */ (function () {
	    function ChildActivationStart(snapshot) {
	        this.snapshot = snapshot;
	    }
	    /**
	     * @return {?}
	     */
	    ChildActivationStart.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
	        return "ChildActivationStart(path: '" + path + "')";
	    };
	    return ChildActivationStart;
	}());
	/**
	 * \@whatItDoes Represents the start of end of the Resolve phase of routing. See note on
	 * {\@link ChildActivationStart} for use of this experimental API.
	 *
	 * \@experimental
	 */
	var ChildActivationEnd = /** @class */ (function () {
	    function ChildActivationEnd(snapshot) {
	        this.snapshot = snapshot;
	    }
	    /**
	     * @return {?}
	     */
	    ChildActivationEnd.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
	        return "ChildActivationEnd(path: '" + path + "')";
	    };
	    return ChildActivationEnd;
	}());
	/**
	 * \@whatItDoes Represents the start of end of the Resolve phase of routing. See note on
	 * {\@link ActivationEnd} for use of this experimental API.
	 *
	 * \@experimental
	 */
	var ActivationStart = /** @class */ (function () {
	    function ActivationStart(snapshot) {
	        this.snapshot = snapshot;
	    }
	    /**
	     * @return {?}
	     */
	    ActivationStart.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
	        return "ActivationStart(path: '" + path + "')";
	    };
	    return ActivationStart;
	}());
	/**
	 * \@whatItDoes Represents the start of end of the Resolve phase of routing. See note on
	 * {\@link ActivationStart} for use of this experimental API.
	 *
	 * \@experimental
	 */
	var ActivationEnd = /** @class */ (function () {
	    function ActivationEnd(snapshot) {
	        this.snapshot = snapshot;
	    }
	    /**
	     * @return {?}
	     */
	    ActivationEnd.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
	        return "ActivationEnd(path: '" + path + "')";
	    };
	    return ActivationEnd;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Name of the primary outlet.
	 *
	 * \@stable
	 */
	var PRIMARY_OUTLET = 'primary';
	/**
	 * Matrix and Query parameters.
	 *
	 * `ParamMap` makes it easier to work with parameters as they could have either a single value or
	 * multiple value. Because this should be known by the user, calling `get` or `getAll` returns the
	 * correct type (either `string` or `string[]`).
	 *
	 * The API is inspired by the URLSearchParams interface.
	 * see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
	 *
	 * \@stable
	 * @record
	 */
	
	var ParamsAsMap = /** @class */ (function () {
	    function ParamsAsMap(params) {
	        this.params = params || {};
	    }
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ParamsAsMap.prototype.has = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return this.params.hasOwnProperty(name); };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ParamsAsMap.prototype.get = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (this.has(name)) {
	            var /** @type {?} */ v = this.params[name];
	            return Array.isArray(v) ? v[0] : v;
	        }
	        return null;
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    ParamsAsMap.prototype.getAll = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (this.has(name)) {
	            var /** @type {?} */ v = this.params[name];
	            return Array.isArray(v) ? v : [v];
	        }
	        return [];
	    };
	    Object.defineProperty(ParamsAsMap.prototype, "keys", {
	        get: /**
	         * @return {?}
	         */
	        function () { return Object.keys(this.params); },
	        enumerable: true,
	        configurable: true
	    });
	    return ParamsAsMap;
	}());
	/**
	 * Convert a {\@link Params} instance to a {\@link ParamMap}.
	 *
	 * \@stable
	 * @param {?} params
	 * @return {?}
	 */
	function convertToParamMap(params) {
	    return new ParamsAsMap(params);
	}
	var NAVIGATION_CANCELING_ERROR = 'ngNavigationCancelingError';
	/**
	 * @param {?} message
	 * @return {?}
	 */
	function navigationCancelingError(message) {
	    var /** @type {?} */ error = Error('NavigationCancelingError: ' + message);
	    (/** @type {?} */ (error))[NAVIGATION_CANCELING_ERROR] = true;
	    return error;
	}
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function isNavigationCancelingError(error) {
	    return error && (/** @type {?} */ (error))[NAVIGATION_CANCELING_ERROR];
	}
	/**
	 * @param {?} segments
	 * @param {?} segmentGroup
	 * @param {?} route
	 * @return {?}
	 */
	function defaultUrlMatcher(segments, segmentGroup, route) {
	    var /** @type {?} */ parts = /** @type {?} */ ((route.path)).split('/');
	    if (parts.length > segments.length) {
	        // The actual URL is shorter than the config, no match
	        return null;
	    }
	    if (route.pathMatch === 'full' &&
	        (segmentGroup.hasChildren() || parts.length < segments.length)) {
	        // The config is longer than the actual URL but we are looking for a full match, return null
	        return null;
	    }
	    var /** @type {?} */ posParams = {};
	    // Check each config part against the actual URL
	    for (var /** @type {?} */ index = 0; index < parts.length; index++) {
	        var /** @type {?} */ part = parts[index];
	        var /** @type {?} */ segment = segments[index];
	        var /** @type {?} */ isParameter = part.startsWith(':');
	        if (isParameter) {
	            posParams[part.substring(1)] = segment;
	        }
	        else if (part !== segment.path) {
	            // The actual URL part does not match the config, no match
	            return null;
	        }
	    }
	    return { consumed: segments.slice(0, parts.length), posParams: posParams };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * See {\@link Routes} for more details.
	 * \@stable
	 * @record
	 */
	
	var LoadedRouterConfig = /** @class */ (function () {
	    function LoadedRouterConfig(routes, module) {
	        this.routes = routes;
	        this.module = module;
	    }
	    return LoadedRouterConfig;
	}());
	/**
	 * @param {?} config
	 * @param {?=} parentPath
	 * @return {?}
	 */
	function validateConfig(config, parentPath) {
	    if (parentPath === void 0) { parentPath = ''; }
	    // forEach doesn't iterate undefined values
	    for (var /** @type {?} */ i = 0; i < config.length; i++) {
	        var /** @type {?} */ route = config[i];
	        var /** @type {?} */ fullPath = getFullPath(parentPath, route);
	        validateNode(route, fullPath);
	    }
	}
	/**
	 * @param {?} route
	 * @param {?} fullPath
	 * @return {?}
	 */
	function validateNode(route, fullPath) {
	    if (!route) {
	        throw new Error("\n      Invalid configuration of route '" + fullPath + "': Encountered undefined route.\n      The reason might be an extra comma.\n\n      Example:\n      const routes: Routes = [\n        { path: '', redirectTo: '/dashboard', pathMatch: 'full' },\n        { path: 'dashboard',  component: DashboardComponent },, << two commas\n        { path: 'detail/:id', component: HeroDetailComponent }\n      ];\n    ");
	    }
	    if (Array.isArray(route)) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': Array cannot be specified");
	    }
	    if (!route.component && (route.outlet && route.outlet !== PRIMARY_OUTLET)) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': a componentless route cannot have a named outlet set");
	    }
	    if (route.redirectTo && route.children) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and children cannot be used together");
	    }
	    if (route.redirectTo && route.loadChildren) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and loadChildren cannot be used together");
	    }
	    if (route.children && route.loadChildren) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': children and loadChildren cannot be used together");
	    }
	    if (route.redirectTo && route.component) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and component cannot be used together");
	    }
	    if (route.path && route.matcher) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': path and matcher cannot be used together");
	    }
	    if (route.redirectTo === void 0 && !route.component && !route.children && !route.loadChildren) {
	        throw new Error("Invalid configuration of route '" + fullPath + "'. One of the following must be provided: component, redirectTo, children or loadChildren");
	    }
	    if (route.path === void 0 && route.matcher === void 0) {
	        throw new Error("Invalid configuration of route '" + fullPath + "': routes must have either a path or a matcher specified");
	    }
	    if (typeof route.path === 'string' && route.path.charAt(0) === '/') {
	        throw new Error("Invalid configuration of route '" + fullPath + "': path cannot start with a slash");
	    }
	    if (route.path === '' && route.redirectTo !== void 0 && route.pathMatch === void 0) {
	        var /** @type {?} */ exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
	        throw new Error("Invalid configuration of route '{path: \"" + fullPath + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
	    }
	    if (route.pathMatch !== void 0 && route.pathMatch !== 'full' && route.pathMatch !== 'prefix') {
	        throw new Error("Invalid configuration of route '" + fullPath + "': pathMatch can only be set to 'prefix' or 'full'");
	    }
	    if (route.children) {
	        validateConfig(route.children, fullPath);
	    }
	}
	/**
	 * @param {?} parentPath
	 * @param {?} currentRoute
	 * @return {?}
	 */
	function getFullPath(parentPath, currentRoute) {
	    if (!currentRoute) {
	        return parentPath;
	    }
	    if (!parentPath && !currentRoute.path) {
	        return '';
	    }
	    else if (parentPath && !currentRoute.path) {
	        return parentPath + "/";
	    }
	    else if (!parentPath && currentRoute.path) {
	        return currentRoute.path;
	    }
	    else {
	        return parentPath + "/" + currentRoute.path;
	    }
	}
	/**
	 * @param {?} r
	 * @return {?}
	 */
	function copyConfig(r) {
	    var /** @type {?} */ children = r.children && r.children.map(copyConfig);
	    return children ? __assign({}, r, { children: children }) : __assign({}, r);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function shallowEqualArrays(a, b) {
	    if (a.length !== b.length)
	        return false;
	    for (var /** @type {?} */ i = 0; i < a.length; ++i) {
	        if (!shallowEqual(a[i], b[i]))
	            return false;
	    }
	    return true;
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function shallowEqual(a, b) {
	    var /** @type {?} */ k1 = Object.keys(a);
	    var /** @type {?} */ k2 = Object.keys(b);
	    if (k1.length != k2.length) {
	        return false;
	    }
	    var /** @type {?} */ key;
	    for (var /** @type {?} */ i = 0; i < k1.length; i++) {
	        key = k1[i];
	        if (a[key] !== b[key]) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * Flattens single-level nested arrays.
	 * @template T
	 * @param {?} arr
	 * @return {?}
	 */
	function flatten(arr) {
	    return Array.prototype.concat.apply([], arr);
	}
	/**
	 * Return the last element of an array.
	 * @template T
	 * @param {?} a
	 * @return {?}
	 */
	function last$1(a) {
	    return a.length > 0 ? a[a.length - 1] : null;
	}
	/**
	 * Verifys all booleans in an array are `true`.
	 * @param {?} bools
	 * @return {?}
	 */
	
	/**
	 * @template K, V
	 * @param {?} map
	 * @param {?} callback
	 * @return {?}
	 */
	function forEach(map$$1, callback) {
	    for (var /** @type {?} */ prop in map$$1) {
	        if (map$$1.hasOwnProperty(prop)) {
	            callback(map$$1[prop], prop);
	        }
	    }
	}
	/**
	 * @template A, B
	 * @param {?} obj
	 * @param {?} fn
	 * @return {?}
	 */
	function waitForMap(obj, fn) {
	    if (Object.keys(obj).length === 0) {
	        return rxjs_observable_of.of({});
	    }
	    var /** @type {?} */ waitHead = [];
	    var /** @type {?} */ waitTail = [];
	    var /** @type {?} */ res = {};
	    forEach(obj, function (a, k) {
	        var /** @type {?} */ mapped = rxjs_operator_map.map.call(fn(k, a), function (r) { return res[k] = r; });
	        if (k === PRIMARY_OUTLET) {
	            waitHead.push(mapped);
	        }
	        else {
	            waitTail.push(mapped);
	        }
	    });
	    var /** @type {?} */ concat$ = rxjs_operator_concatAll.concatAll.call(rxjs_observable_of.of.apply(void 0, waitHead.concat(waitTail)));
	    var /** @type {?} */ last$ = rxjs_operator_last.last.call(concat$);
	    return rxjs_operator_map.map.call(last$, function () { return res; });
	}
	/**
	 * ANDs Observables by merging all input observables, reducing to an Observable verifying all
	 * input Observables return `true`.
	 * @param {?} observables
	 * @return {?}
	 */
	function andObservables(observables) {
	    var /** @type {?} */ merged$ = rxjs_operator_mergeAll.mergeAll.call(observables);
	    return rxjs_operator_every.every.call(merged$, function (result) { return result === true; });
	}
	/**
	 * @template T
	 * @param {?} value
	 * @return {?}
	 */
	function wrapIntoObservable(value) {
	    if (_angular_core.ɵisObservable(value)) {
	        return value;
	    }
	    if (_angular_core.ɵisPromise(value)) {
	        // Use `Promise.resolve()` to wrap promise-like instances.
	        // Required ie when a Resolver returns a AngularJS `$q` promise to correctly trigger the
	        // change detection.
	        return rxjs_observable_fromPromise.fromPromise(Promise.resolve(value));
	    }
	    return rxjs_observable_of.of(/** @type {?} */ (value));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @return {?}
	 */
	function createEmptyUrlTree() {
	    return new UrlTree(new UrlSegmentGroup([], {}), {}, null);
	}
	/**
	 * @param {?} container
	 * @param {?} containee
	 * @param {?} exact
	 * @return {?}
	 */
	function containsTree(container, containee, exact) {
	    if (exact) {
	        return equalQueryParams(container.queryParams, containee.queryParams) &&
	            equalSegmentGroups(container.root, containee.root);
	    }
	    return containsQueryParams(container.queryParams, containee.queryParams) &&
	        containsSegmentGroup(container.root, containee.root);
	}
	/**
	 * @param {?} container
	 * @param {?} containee
	 * @return {?}
	 */
	function equalQueryParams(container, containee) {
	    return shallowEqual(container, containee);
	}
	/**
	 * @param {?} container
	 * @param {?} containee
	 * @return {?}
	 */
	function equalSegmentGroups(container, containee) {
	    if (!equalPath(container.segments, containee.segments))
	        return false;
	    if (container.numberOfChildren !== containee.numberOfChildren)
	        return false;
	    for (var /** @type {?} */ c in containee.children) {
	        if (!container.children[c])
	            return false;
	        if (!equalSegmentGroups(container.children[c], containee.children[c]))
	            return false;
	    }
	    return true;
	}
	/**
	 * @param {?} container
	 * @param {?} containee
	 * @return {?}
	 */
	function containsQueryParams(container, containee) {
	    return Object.keys(containee).length <= Object.keys(container).length &&
	        Object.keys(containee).every(function (key) { return containee[key] === container[key]; });
	}
	/**
	 * @param {?} container
	 * @param {?} containee
	 * @return {?}
	 */
	function containsSegmentGroup(container, containee) {
	    return containsSegmentGroupHelper(container, containee, containee.segments);
	}
	/**
	 * @param {?} container
	 * @param {?} containee
	 * @param {?} containeePaths
	 * @return {?}
	 */
	function containsSegmentGroupHelper(container, containee, containeePaths) {
	    if (container.segments.length > containeePaths.length) {
	        var /** @type {?} */ current = container.segments.slice(0, containeePaths.length);
	        if (!equalPath(current, containeePaths))
	            return false;
	        if (containee.hasChildren())
	            return false;
	        return true;
	    }
	    else if (container.segments.length === containeePaths.length) {
	        if (!equalPath(container.segments, containeePaths))
	            return false;
	        for (var /** @type {?} */ c in containee.children) {
	            if (!container.children[c])
	                return false;
	            if (!containsSegmentGroup(container.children[c], containee.children[c]))
	                return false;
	        }
	        return true;
	    }
	    else {
	        var /** @type {?} */ current = containeePaths.slice(0, container.segments.length);
	        var /** @type {?} */ next = containeePaths.slice(container.segments.length);
	        if (!equalPath(container.segments, current))
	            return false;
	        if (!container.children[PRIMARY_OUTLET])
	            return false;
	        return containsSegmentGroupHelper(container.children[PRIMARY_OUTLET], containee, next);
	    }
	}
	/**
	 * \@whatItDoes Represents the parsed URL.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@Component({templateUrl:'template.html'})
	 * class MyComponent {
	 *   constructor(router: Router) {
	 *     const tree: UrlTree =
	 *       router.parseUrl('/team/33/(user/victor//support:help)?debug=true#fragment');
	 *     const f = tree.fragment; // return 'fragment'
	 *     const q = tree.queryParams; // returns {debug: 'true'}
	 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
	 *     const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'
	 *     g.children[PRIMARY_OUTLET].segments; // returns 2 segments 'user' and 'victor'
	 *     g.children['support'].segments; // return 1 segment 'help'
	 *   }
	 * }
	 * ```
	 *
	 * \@description
	 *
	 * Since a router state is a tree, and the URL is nothing but a serialized state, the URL is a
	 * serialized tree.
	 * UrlTree is a data structure that provides a lot of affordances in dealing with URLs
	 *
	 * \@stable
	 */
	var UrlTree = /** @class */ (function () {
	    /** @internal */
	    function UrlTree(root, queryParams, fragment) {
	        this.root = root;
	        this.queryParams = queryParams;
	        this.fragment = fragment;
	    }
	    Object.defineProperty(UrlTree.prototype, "queryParamMap", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this._queryParamMap) {
	                this._queryParamMap = convertToParamMap(this.queryParams);
	            }
	            return this._queryParamMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    UrlTree.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () { return DEFAULT_SERIALIZER.serialize(this); };
	    return UrlTree;
	}());
	/**
	 * \@whatItDoes Represents the parsed URL segment group.
	 *
	 * See {\@link UrlTree} for more information.
	 *
	 * \@stable
	 */
	var UrlSegmentGroup = /** @class */ (function () {
	    function UrlSegmentGroup(segments, children) {
	        var _this = this;
	        this.segments = segments;
	        this.children = children;
	        /**
	         * The parent node in the url tree
	         */
	        this.parent = null;
	        forEach(children, function (v, k) { return v.parent = _this; });
	    }
	    /** Whether the segment has child segments */
	    /**
	     * Whether the segment has child segments
	     * @return {?}
	     */
	    UrlSegmentGroup.prototype.hasChildren = /**
	     * Whether the segment has child segments
	     * @return {?}
	     */
	    function () { return this.numberOfChildren > 0; };
	    Object.defineProperty(UrlSegmentGroup.prototype, "numberOfChildren", {
	        /** Number of child segments */
	        get: /**
	         * Number of child segments
	         * @return {?}
	         */
	        function () { return Object.keys(this.children).length; },
	        enumerable: true,
	        configurable: true
	    });
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    UrlSegmentGroup.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () { return serializePaths(this); };
	    return UrlSegmentGroup;
	}());
	/**
	 * \@whatItDoes Represents a single URL segment.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@Component({templateUrl:'template.html'})
	 * class MyComponent {
	 *   constructor(router: Router) {
	 *     const tree: UrlTree = router.parseUrl('/team;id=33');
	 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
	 *     const s: UrlSegment[] = g.segments;
	 *     s[0].path; // returns 'team'
	 *     s[0].parameters; // returns {id: 33}
	 *   }
	 * }
	 * ```
	 *
	 * \@description
	 *
	 * A UrlSegment is a part of a URL between the two slashes. It contains a path and the matrix
	 * parameters associated with the segment.
	 *
	 * \@stable
	 */
	var UrlSegment = /** @class */ (function () {
	    function UrlSegment(path, parameters) {
	        this.path = path;
	        this.parameters = parameters;
	    }
	    Object.defineProperty(UrlSegment.prototype, "parameterMap", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this._parameterMap) {
	                this._parameterMap = convertToParamMap(this.parameters);
	            }
	            return this._parameterMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    UrlSegment.prototype.toString = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () { return serializePath(this); };
	    return UrlSegment;
	}());
	/**
	 * @param {?} as
	 * @param {?} bs
	 * @return {?}
	 */
	function equalSegments(as, bs) {
	    return equalPath(as, bs) && as.every(function (a, i) { return shallowEqual(a.parameters, bs[i].parameters); });
	}
	/**
	 * @param {?} as
	 * @param {?} bs
	 * @return {?}
	 */
	function equalPath(as, bs) {
	    if (as.length !== bs.length)
	        return false;
	    return as.every(function (a, i) { return a.path === bs[i].path; });
	}
	/**
	 * @template T
	 * @param {?} segment
	 * @param {?} fn
	 * @return {?}
	 */
	function mapChildrenIntoArray(segment, fn) {
	    var /** @type {?} */ res = [];
	    forEach(segment.children, function (child, childOutlet) {
	        if (childOutlet === PRIMARY_OUTLET) {
	            res = res.concat(fn(child, childOutlet));
	        }
	    });
	    forEach(segment.children, function (child, childOutlet) {
	        if (childOutlet !== PRIMARY_OUTLET) {
	            res = res.concat(fn(child, childOutlet));
	        }
	    });
	    return res;
	}
	/**
	 * \@whatItDoes Serializes and deserializes a URL string into a URL tree.
	 *
	 * \@description The url serialization strategy is customizable. You can
	 * make all URLs case insensitive by providing a custom UrlSerializer.
	 *
	 * See {\@link DefaultUrlSerializer} for an example of a URL serializer.
	 *
	 * \@stable
	 * @abstract
	 */
	var UrlSerializer = /** @class */ (function () {
	    function UrlSerializer() {
	    }
	    return UrlSerializer;
	}());
	/**
	 * \@whatItDoes A default implementation of the {\@link UrlSerializer}.
	 *
	 * \@description
	 *
	 * Example URLs:
	 *
	 * ```
	 * /inbox/33(popup:compose)
	 * /inbox/33;open=true/messages/44
	 * ```
	 *
	 * DefaultUrlSerializer uses parentheses to serialize secondary segments (e.g., popup:compose), the
	 * colon syntax to specify the outlet, and the ';parameter=value' syntax (e.g., open=true) to
	 * specify route specific parameters.
	 *
	 * \@stable
	 */
	var DefaultUrlSerializer = /** @class */ (function () {
	    function DefaultUrlSerializer() {
	    }
	    /** Parses a url into a {@link UrlTree} */
	    /**
	     * Parses a url into a {\@link UrlTree}
	     * @param {?} url
	     * @return {?}
	     */
	    DefaultUrlSerializer.prototype.parse = /**
	     * Parses a url into a {\@link UrlTree}
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        var /** @type {?} */ p = new UrlParser(url);
	        return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
	    };
	    /** Converts a {@link UrlTree} into a url */
	    /**
	     * Converts a {\@link UrlTree} into a url
	     * @param {?} tree
	     * @return {?}
	     */
	    DefaultUrlSerializer.prototype.serialize = /**
	     * Converts a {\@link UrlTree} into a url
	     * @param {?} tree
	     * @return {?}
	     */
	    function (tree) {
	        var /** @type {?} */ segment = "/" + serializeSegment(tree.root, true);
	        var /** @type {?} */ query = serializeQueryParams(tree.queryParams);
	        var /** @type {?} */ fragment = typeof tree.fragment === "string" ? "#" + encodeUriFragment((/** @type {?} */ ((tree.fragment)))) : '';
	        return "" + segment + query + fragment;
	    };
	    return DefaultUrlSerializer;
	}());
	var DEFAULT_SERIALIZER = new DefaultUrlSerializer();
	/**
	 * @param {?} segment
	 * @return {?}
	 */
	function serializePaths(segment) {
	    return segment.segments.map(function (p) { return serializePath(p); }).join('/');
	}
	/**
	 * @param {?} segment
	 * @param {?} root
	 * @return {?}
	 */
	function serializeSegment(segment, root) {
	    if (!segment.hasChildren()) {
	        return serializePaths(segment);
	    }
	    if (root) {
	        var /** @type {?} */ primary = segment.children[PRIMARY_OUTLET] ?
	            serializeSegment(segment.children[PRIMARY_OUTLET], false) :
	            '';
	        var /** @type {?} */ children_1 = [];
	        forEach(segment.children, function (v, k) {
	            if (k !== PRIMARY_OUTLET) {
	                children_1.push(k + ":" + serializeSegment(v, false));
	            }
	        });
	        return children_1.length > 0 ? primary + "(" + children_1.join('//') + ")" : primary;
	    }
	    else {
	        var /** @type {?} */ children = mapChildrenIntoArray(segment, function (v, k) {
	            if (k === PRIMARY_OUTLET) {
	                return [serializeSegment(segment.children[PRIMARY_OUTLET], false)];
	            }
	            return [k + ":" + serializeSegment(v, false)];
	        });
	        return serializePaths(segment) + "/(" + children.join('//') + ")";
	    }
	}
	/**
	 * Encodes a URI string with the default encoding. This function will only ever be called from
	 * `encodeUriQuery` or `encodeUriSegment` as it's the base set of encodings to be used. We need
	 * a custom encoding because encodeURIComponent is too aggressive and encodes stuff that doesn't
	 * have to be encoded per https://url.spec.whatwg.org.
	 * @param {?} s
	 * @return {?}
	 */
	function encodeUriString(s) {
	    return encodeURIComponent(s)
	        .replace(/%40/g, '@')
	        .replace(/%3A/gi, ':')
	        .replace(/%24/g, '$')
	        .replace(/%2C/gi, ',');
	}
	/**
	 * This function should be used to encode both keys and values in a query string key/value. In
	 * the following URL, you need to call encodeUriQuery on "k" and "v":
	 *
	 * http://www.site.org/html;mk=mv?k=v#f
	 * @param {?} s
	 * @return {?}
	 */
	function encodeUriQuery(s) {
	    return encodeUriString(s).replace(/%3B/gi, ';');
	}
	/**
	 * This function should be used to encode a URL fragment. In the following URL, you need to call
	 * encodeUriFragment on "f":
	 *
	 * http://www.site.org/html;mk=mv?k=v#f
	 * @param {?} s
	 * @return {?}
	 */
	function encodeUriFragment(s) {
	    return encodeURI(s);
	}
	/**
	 * This function should be run on any URI segment as well as the key and value in a key/value
	 * pair for matrix params. In the following URL, you need to call encodeUriSegment on "html",
	 * "mk", and "mv":
	 *
	 * http://www.site.org/html;mk=mv?k=v#f
	 * @param {?} s
	 * @return {?}
	 */
	function encodeUriSegment(s) {
	    return encodeUriString(s).replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/%26/gi, '&');
	}
	/**
	 * @param {?} s
	 * @return {?}
	 */
	function decode(s) {
	    return decodeURIComponent(s);
	}
	/**
	 * @param {?} s
	 * @return {?}
	 */
	function decodeQuery(s) {
	    return decode(s.replace(/\+/g, '%20'));
	}
	/**
	 * @param {?} path
	 * @return {?}
	 */
	function serializePath(path) {
	    return "" + encodeUriSegment(path.path) + serializeMatrixParams(path.parameters);
	}
	/**
	 * @param {?} params
	 * @return {?}
	 */
	function serializeMatrixParams(params) {
	    return Object.keys(params)
	        .map(function (key) { return ";" + encodeUriSegment(key) + "=" + encodeUriSegment(params[key]); })
	        .join('');
	}
	/**
	 * @param {?} params
	 * @return {?}
	 */
	function serializeQueryParams(params) {
	    var /** @type {?} */ strParams = Object.keys(params).map(function (name) {
	        var /** @type {?} */ value = params[name];
	        return Array.isArray(value) ?
	            value.map(function (v) { return encodeUriQuery(name) + "=" + encodeUriQuery(v); }).join('&') :
	            encodeUriQuery(name) + "=" + encodeUriQuery(value);
	    });
	    return strParams.length ? "?" + strParams.join("&") : '';
	}
	var SEGMENT_RE = /^[^\/()?;=&#]+/;
	/**
	 * @param {?} str
	 * @return {?}
	 */
	function matchSegments(str) {
	    var /** @type {?} */ match = str.match(SEGMENT_RE);
	    return match ? match[0] : '';
	}
	var QUERY_PARAM_RE = /^[^=?&#]+/;
	/**
	 * @param {?} str
	 * @return {?}
	 */
	function matchQueryParams(str) {
	    var /** @type {?} */ match = str.match(QUERY_PARAM_RE);
	    return match ? match[0] : '';
	}
	var QUERY_PARAM_VALUE_RE = /^[^?&#]+/;
	/**
	 * @param {?} str
	 * @return {?}
	 */
	function matchUrlQueryParamValue(str) {
	    var /** @type {?} */ match = str.match(QUERY_PARAM_VALUE_RE);
	    return match ? match[0] : '';
	}
	var UrlParser = /** @class */ (function () {
	    function UrlParser(url) {
	        this.url = url;
	        this.remaining = url;
	    }
	    /**
	     * @return {?}
	     */
	    UrlParser.prototype.parseRootSegment = /**
	     * @return {?}
	     */
	    function () {
	        this.consumeOptional('/');
	        if (this.remaining === '' || this.peekStartsWith('?') || this.peekStartsWith('#')) {
	            return new UrlSegmentGroup([], {});
	        }
	        // The root segment group never has segments
	        return new UrlSegmentGroup([], this.parseChildren());
	    };
	    /**
	     * @return {?}
	     */
	    UrlParser.prototype.parseQueryParams = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ params = {};
	        if (this.consumeOptional('?')) {
	            do {
	                this.parseQueryParam(params);
	            } while (this.consumeOptional('&'));
	        }
	        return params;
	    };
	    /**
	     * @return {?}
	     */
	    UrlParser.prototype.parseFragment = /**
	     * @return {?}
	     */
	    function () {
	        return this.consumeOptional('#') ? decodeURIComponent(this.remaining) : null;
	    };
	    /**
	     * @return {?}
	     */
	    UrlParser.prototype.parseChildren = /**
	     * @return {?}
	     */
	    function () {
	        if (this.remaining === '') {
	            return {};
	        }
	        this.consumeOptional('/');
	        var /** @type {?} */ segments = [];
	        if (!this.peekStartsWith('(')) {
	            segments.push(this.parseSegment());
	        }
	        while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
	            this.capture('/');
	            segments.push(this.parseSegment());
	        }
	        var /** @type {?} */ children = {};
	        if (this.peekStartsWith('/(')) {
	            this.capture('/');
	            children = this.parseParens(true);
	        }
	        var /** @type {?} */ res = {};
	        if (this.peekStartsWith('(')) {
	            res = this.parseParens(false);
	        }
	        if (segments.length > 0 || Object.keys(children).length > 0) {
	            res[PRIMARY_OUTLET] = new UrlSegmentGroup(segments, children);
	        }
	        return res;
	    };
	    /**
	     * @return {?}
	     */
	    UrlParser.prototype.parseSegment = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ path = matchSegments(this.remaining);
	        if (path === '' && this.peekStartsWith(';')) {
	            throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
	        }
	        this.capture(path);
	        return new UrlSegment(decode(path), this.parseMatrixParams());
	    };
	    /**
	     * @return {?}
	     */
	    UrlParser.prototype.parseMatrixParams = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ params = {};
	        while (this.consumeOptional(';')) {
	            this.parseParam(params);
	        }
	        return params;
	    };
	    /**
	     * @param {?} params
	     * @return {?}
	     */
	    UrlParser.prototype.parseParam = /**
	     * @param {?} params
	     * @return {?}
	     */
	    function (params) {
	        var /** @type {?} */ key = matchSegments(this.remaining);
	        if (!key) {
	            return;
	        }
	        this.capture(key);
	        var /** @type {?} */ value = '';
	        if (this.consumeOptional('=')) {
	            var /** @type {?} */ valueMatch = matchSegments(this.remaining);
	            if (valueMatch) {
	                value = valueMatch;
	                this.capture(value);
	            }
	        }
	        params[decode(key)] = decode(value);
	    };
	    /**
	     * @param {?} params
	     * @return {?}
	     */
	    UrlParser.prototype.parseQueryParam = /**
	     * @param {?} params
	     * @return {?}
	     */
	    function (params) {
	        var /** @type {?} */ key = matchQueryParams(this.remaining);
	        if (!key) {
	            return;
	        }
	        this.capture(key);
	        var /** @type {?} */ value = '';
	        if (this.consumeOptional('=')) {
	            var /** @type {?} */ valueMatch = matchUrlQueryParamValue(this.remaining);
	            if (valueMatch) {
	                value = valueMatch;
	                this.capture(value);
	            }
	        }
	        var /** @type {?} */ decodedKey = decodeQuery(key);
	        var /** @type {?} */ decodedVal = decodeQuery(value);
	        if (params.hasOwnProperty(decodedKey)) {
	            // Append to existing values
	            var /** @type {?} */ currentVal = params[decodedKey];
	            if (!Array.isArray(currentVal)) {
	                currentVal = [currentVal];
	                params[decodedKey] = currentVal;
	            }
	            currentVal.push(decodedVal);
	        }
	        else {
	            // Create a new value
	            params[decodedKey] = decodedVal;
	        }
	    };
	    /**
	     * @param {?} allowPrimary
	     * @return {?}
	     */
	    UrlParser.prototype.parseParens = /**
	     * @param {?} allowPrimary
	     * @return {?}
	     */
	    function (allowPrimary) {
	        var /** @type {?} */ segments = {};
	        this.capture('(');
	        while (!this.consumeOptional(')') && this.remaining.length > 0) {
	            var /** @type {?} */ path = matchSegments(this.remaining);
	            var /** @type {?} */ next = this.remaining[path.length];
	            // if is is not one of these characters, then the segment was unescaped
	            // or the group was not closed
	            if (next !== '/' && next !== ')' && next !== ';') {
	                throw new Error("Cannot parse url '" + this.url + "'");
	            }
	            var /** @type {?} */ outletName = /** @type {?} */ ((undefined));
	            if (path.indexOf(':') > -1) {
	                outletName = path.substr(0, path.indexOf(':'));
	                this.capture(outletName);
	                this.capture(':');
	            }
	            else if (allowPrimary) {
	                outletName = PRIMARY_OUTLET;
	            }
	            var /** @type {?} */ children = this.parseChildren();
	            segments[outletName] = Object.keys(children).length === 1 ? children[PRIMARY_OUTLET] :
	                new UrlSegmentGroup([], children);
	            this.consumeOptional('//');
	        }
	        return segments;
	    };
	    /**
	     * @param {?} str
	     * @return {?}
	     */
	    UrlParser.prototype.peekStartsWith = /**
	     * @param {?} str
	     * @return {?}
	     */
	    function (str) { return this.remaining.startsWith(str); };
	    /**
	     * @param {?} str
	     * @return {?}
	     */
	    UrlParser.prototype.consumeOptional = /**
	     * @param {?} str
	     * @return {?}
	     */
	    function (str) {
	        if (this.peekStartsWith(str)) {
	            this.remaining = this.remaining.substring(str.length);
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @param {?} str
	     * @return {?}
	     */
	    UrlParser.prototype.capture = /**
	     * @param {?} str
	     * @return {?}
	     */
	    function (str) {
	        if (!this.consumeOptional(str)) {
	            throw new Error("Expected \"" + str + "\".");
	        }
	    };
	    return UrlParser;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NoMatch = /** @class */ (function () {
	    function NoMatch(segmentGroup) {
	        this.segmentGroup = segmentGroup || null;
	    }
	    return NoMatch;
	}());
	var AbsoluteRedirect = /** @class */ (function () {
	    function AbsoluteRedirect(urlTree) {
	        this.urlTree = urlTree;
	    }
	    return AbsoluteRedirect;
	}());
	/**
	 * @param {?} segmentGroup
	 * @return {?}
	 */
	function noMatch(segmentGroup) {
	    return new rxjs_Observable.Observable(function (obs) { return obs.error(new NoMatch(segmentGroup)); });
	}
	/**
	 * @param {?} newTree
	 * @return {?}
	 */
	function absoluteRedirect(newTree) {
	    return new rxjs_Observable.Observable(function (obs) { return obs.error(new AbsoluteRedirect(newTree)); });
	}
	/**
	 * @param {?} redirectTo
	 * @return {?}
	 */
	function namedOutletsRedirect(redirectTo) {
	    return new rxjs_Observable.Observable(function (obs) {
	        return obs.error(new Error("Only absolute redirects can have named outlets. redirectTo: '" + redirectTo + "'"));
	    });
	}
	/**
	 * @param {?} route
	 * @return {?}
	 */
	function canLoadFails(route) {
	    return new rxjs_Observable.Observable(function (obs) {
	        return obs.error(navigationCancelingError("Cannot load children because the guard of the route \"path: '" + route.path + "'\" returned false"));
	    });
	}
	/**
	 * Returns the `UrlTree` with the redirection applied.
	 *
	 * Lazy modules are loaded along the way.
	 * @param {?} moduleInjector
	 * @param {?} configLoader
	 * @param {?} urlSerializer
	 * @param {?} urlTree
	 * @param {?} config
	 * @return {?}
	 */
	function applyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
	    return new ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config).apply();
	}
	var ApplyRedirects = /** @class */ (function () {
	    function ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
	        this.configLoader = configLoader;
	        this.urlSerializer = urlSerializer;
	        this.urlTree = urlTree;
	        this.config = config;
	        this.allowRedirects = true;
	        this.ngModule = moduleInjector.get(_angular_core.NgModuleRef);
	    }
	    /**
	     * @return {?}
	     */
	    ApplyRedirects.prototype.apply = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ expanded$ = this.expandSegmentGroup(this.ngModule, this.config, this.urlTree.root, PRIMARY_OUTLET);
	        var /** @type {?} */ urlTrees$ = rxjs_operator_map.map.call(expanded$, function (rootSegmentGroup) {
	            return _this.createUrlTree(rootSegmentGroup, _this.urlTree.queryParams, /** @type {?} */ ((_this.urlTree.fragment)));
	        });
	        return rxjs_operator_catch._catch.call(urlTrees$, function (e) {
	            if (e instanceof AbsoluteRedirect) {
	                // after an absolute redirect we do not apply any more redirects!
	                // after an absolute redirect we do not apply any more redirects!
	                _this.allowRedirects = false;
	                // we need to run matching, so we can fetch all lazy-loaded modules
	                return _this.match(e.urlTree);
	            }
	            if (e instanceof NoMatch) {
	                throw _this.noMatchError(e);
	            }
	            throw e;
	        });
	    };
	    /**
	     * @param {?} tree
	     * @return {?}
	     */
	    ApplyRedirects.prototype.match = /**
	     * @param {?} tree
	     * @return {?}
	     */
	    function (tree) {
	        var _this = this;
	        var /** @type {?} */ expanded$ = this.expandSegmentGroup(this.ngModule, this.config, tree.root, PRIMARY_OUTLET);
	        var /** @type {?} */ mapped$ = rxjs_operator_map.map.call(expanded$, function (rootSegmentGroup) {
	            return _this.createUrlTree(rootSegmentGroup, tree.queryParams, /** @type {?} */ ((tree.fragment)));
	        });
	        return rxjs_operator_catch._catch.call(mapped$, function (e) {
	            if (e instanceof NoMatch) {
	                throw _this.noMatchError(e);
	            }
	            throw e;
	        });
	    };
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    ApplyRedirects.prototype.noMatchError = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        return new Error("Cannot match any routes. URL Segment: '" + e.segmentGroup + "'");
	    };
	    /**
	     * @param {?} rootCandidate
	     * @param {?} queryParams
	     * @param {?} fragment
	     * @return {?}
	     */
	    ApplyRedirects.prototype.createUrlTree = /**
	     * @param {?} rootCandidate
	     * @param {?} queryParams
	     * @param {?} fragment
	     * @return {?}
	     */
	    function (rootCandidate, queryParams, fragment) {
	        var /** @type {?} */ root = rootCandidate.segments.length > 0 ?
	            new UrlSegmentGroup([], (_a = {}, _a[PRIMARY_OUTLET] = rootCandidate, _a)) :
	            rootCandidate;
	        return new UrlTree(root, queryParams, fragment);
	        var _a;
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @param {?} segmentGroup
	     * @param {?} outlet
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandSegmentGroup = /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @param {?} segmentGroup
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (ngModule, routes, segmentGroup, outlet) {
	        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
	            return rxjs_operator_map.map.call(this.expandChildren(ngModule, routes, segmentGroup), function (children) { return new UrlSegmentGroup([], children); });
	        }
	        return this.expandSegment(ngModule, segmentGroup, routes, segmentGroup.segments, outlet, true);
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @param {?} segmentGroup
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandChildren = /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @param {?} segmentGroup
	     * @return {?}
	     */
	    function (ngModule, routes, segmentGroup) {
	        var _this = this;
	        return waitForMap(segmentGroup.children, function (childOutlet, child) { return _this.expandSegmentGroup(ngModule, routes, child, childOutlet); });
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} segments
	     * @param {?} outlet
	     * @param {?} allowRedirects
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandSegment = /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} segments
	     * @param {?} outlet
	     * @param {?} allowRedirects
	     * @return {?}
	     */
	    function (ngModule, segmentGroup, routes, segments, outlet, allowRedirects) {
	        var _this = this;
	        var /** @type {?} */ routes$ = rxjs_observable_of.of.apply(void 0, routes);
	        var /** @type {?} */ processedRoutes$ = rxjs_operator_map.map.call(routes$, function (r) {
	            var /** @type {?} */ expanded$ = _this.expandSegmentAgainstRoute(ngModule, segmentGroup, routes, r, segments, outlet, allowRedirects);
	            return rxjs_operator_catch._catch.call(expanded$, function (e) {
	                if (e instanceof NoMatch) {
	                    return rxjs_observable_of.of(null);
	                }
	                throw e;
	            });
	        });
	        var /** @type {?} */ concattedProcessedRoutes$ = rxjs_operator_concatAll.concatAll.call(processedRoutes$);
	        var /** @type {?} */ first$ = rxjs_operator_first.first.call(concattedProcessedRoutes$, function (s) { return !!s; });
	        return rxjs_operator_catch._catch.call(first$, function (e, _) {
	            if (e instanceof rxjs_util_EmptyError.EmptyError || e.name === 'EmptyError') {
	                if (_this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
	                    return rxjs_observable_of.of(new UrlSegmentGroup([], {}));
	                }
	                throw new NoMatch(segmentGroup);
	            }
	            throw e;
	        });
	    };
	    /**
	     * @param {?} segmentGroup
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    ApplyRedirects.prototype.noLeftoversInUrl = /**
	     * @param {?} segmentGroup
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (segmentGroup, segments, outlet) {
	        return segments.length === 0 && !segmentGroup.children[outlet];
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} paths
	     * @param {?} outlet
	     * @param {?} allowRedirects
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandSegmentAgainstRoute = /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} paths
	     * @param {?} outlet
	     * @param {?} allowRedirects
	     * @return {?}
	     */
	    function (ngModule, segmentGroup, routes, route, paths, outlet, allowRedirects) {
	        if (getOutlet(route) !== outlet) {
	            return noMatch(segmentGroup);
	        }
	        if (route.redirectTo === undefined) {
	            return this.matchSegmentAgainstRoute(ngModule, segmentGroup, route, paths);
	        }
	        if (allowRedirects && this.allowRedirects) {
	            return this.expandSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, paths, outlet);
	        }
	        return noMatch(segmentGroup);
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandSegmentAgainstRouteUsingRedirect = /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (ngModule, segmentGroup, routes, route, segments, outlet) {
	        if (route.path === '**') {
	            return this.expandWildCardWithParamsAgainstRouteUsingRedirect(ngModule, routes, route, outlet);
	        }
	        return this.expandRegularSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, segments, outlet);
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} outlet
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandWildCardWithParamsAgainstRouteUsingRedirect = /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (ngModule, routes, route, outlet) {
	        var _this = this;
	        var /** @type {?} */ newTree = this.applyRedirectCommands([], /** @type {?} */ ((route.redirectTo)), {});
	        if (/** @type {?} */ ((route.redirectTo)).startsWith('/')) {
	            return absoluteRedirect(newTree);
	        }
	        return rxjs_operator_mergeMap.mergeMap.call(this.lineralizeSegments(route, newTree), function (newSegments) {
	            var /** @type {?} */ group = new UrlSegmentGroup(newSegments, {});
	            return _this.expandSegment(ngModule, group, routes, newSegments, outlet, false);
	        });
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    ApplyRedirects.prototype.expandRegularSegmentAgainstRouteUsingRedirect = /**
	     * @param {?} ngModule
	     * @param {?} segmentGroup
	     * @param {?} routes
	     * @param {?} route
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (ngModule, segmentGroup, routes, route, segments, outlet) {
	        var _this = this;
	        var _a = match(segmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild, positionalParamSegments = _a.positionalParamSegments;
	        if (!matched)
	            return noMatch(segmentGroup);
	        var /** @type {?} */ newTree = this.applyRedirectCommands(consumedSegments, /** @type {?} */ ((route.redirectTo)), /** @type {?} */ (positionalParamSegments));
	        if (/** @type {?} */ ((route.redirectTo)).startsWith('/')) {
	            return absoluteRedirect(newTree);
	        }
	        return rxjs_operator_mergeMap.mergeMap.call(this.lineralizeSegments(route, newTree), function (newSegments) {
	            return _this.expandSegment(ngModule, segmentGroup, routes, newSegments.concat(segments.slice(lastChild)), outlet, false);
	        });
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} rawSegmentGroup
	     * @param {?} route
	     * @param {?} segments
	     * @return {?}
	     */
	    ApplyRedirects.prototype.matchSegmentAgainstRoute = /**
	     * @param {?} ngModule
	     * @param {?} rawSegmentGroup
	     * @param {?} route
	     * @param {?} segments
	     * @return {?}
	     */
	    function (ngModule, rawSegmentGroup, route, segments) {
	        var _this = this;
	        if (route.path === '**') {
	            if (route.loadChildren) {
	                return rxjs_operator_map.map.call(this.configLoader.load(ngModule.injector, route), function (cfg) {
	                    route._loadedConfig = cfg;
	                    return new UrlSegmentGroup(segments, {});
	                });
	            }
	            return rxjs_observable_of.of(new UrlSegmentGroup(segments, {}));
	        }
	        var _a = match(rawSegmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild;
	        if (!matched)
	            return noMatch(rawSegmentGroup);
	        var /** @type {?} */ rawSlicedSegments = segments.slice(lastChild);
	        var /** @type {?} */ childConfig$ = this.getChildConfig(ngModule, route);
	        return rxjs_operator_mergeMap.mergeMap.call(childConfig$, function (routerConfig) {
	            var /** @type {?} */ childModule = routerConfig.module;
	            var /** @type {?} */ childConfig = routerConfig.routes;
	            var _a = split(rawSegmentGroup, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
	            if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
	                var /** @type {?} */ expanded$_1 = _this.expandChildren(childModule, childConfig, segmentGroup);
	                return rxjs_operator_map.map.call(expanded$_1, function (children) { return new UrlSegmentGroup(consumedSegments, children); });
	            }
	            if (childConfig.length === 0 && slicedSegments.length === 0) {
	                return rxjs_observable_of.of(new UrlSegmentGroup(consumedSegments, {}));
	            }
	            var /** @type {?} */ expanded$ = _this.expandSegment(childModule, segmentGroup, childConfig, slicedSegments, PRIMARY_OUTLET, true);
	            return rxjs_operator_map.map.call(expanded$, function (cs) {
	                return new UrlSegmentGroup(consumedSegments.concat(cs.segments), cs.children);
	            });
	        });
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} route
	     * @return {?}
	     */
	    ApplyRedirects.prototype.getChildConfig = /**
	     * @param {?} ngModule
	     * @param {?} route
	     * @return {?}
	     */
	    function (ngModule, route) {
	        var _this = this;
	        if (route.children) {
	            // The children belong to the same module
	            return rxjs_observable_of.of(new LoadedRouterConfig(route.children, ngModule));
	        }
	        if (route.loadChildren) {
	            // lazy children belong to the loaded module
	            if (route._loadedConfig !== undefined) {
	                return rxjs_observable_of.of(route._loadedConfig);
	            }
	            return rxjs_operator_mergeMap.mergeMap.call(runCanLoadGuard(ngModule.injector, route), function (shouldLoad) {
	                if (shouldLoad) {
	                    return rxjs_operator_map.map.call(_this.configLoader.load(ngModule.injector, route), function (cfg) {
	                        route._loadedConfig = cfg;
	                        return cfg;
	                    });
	                }
	                return canLoadFails(route);
	            });
	        }
	        return rxjs_observable_of.of(new LoadedRouterConfig([], ngModule));
	    };
	    /**
	     * @param {?} route
	     * @param {?} urlTree
	     * @return {?}
	     */
	    ApplyRedirects.prototype.lineralizeSegments = /**
	     * @param {?} route
	     * @param {?} urlTree
	     * @return {?}
	     */
	    function (route, urlTree) {
	        var /** @type {?} */ res = [];
	        var /** @type {?} */ c = urlTree.root;
	        while (true) {
	            res = res.concat(c.segments);
	            if (c.numberOfChildren === 0) {
	                return rxjs_observable_of.of(res);
	            }
	            if (c.numberOfChildren > 1 || !c.children[PRIMARY_OUTLET]) {
	                return namedOutletsRedirect(/** @type {?} */ ((route.redirectTo)));
	            }
	            c = c.children[PRIMARY_OUTLET];
	        }
	    };
	    /**
	     * @param {?} segments
	     * @param {?} redirectTo
	     * @param {?} posParams
	     * @return {?}
	     */
	    ApplyRedirects.prototype.applyRedirectCommands = /**
	     * @param {?} segments
	     * @param {?} redirectTo
	     * @param {?} posParams
	     * @return {?}
	     */
	    function (segments, redirectTo, posParams) {
	        return this.applyRedirectCreatreUrlTree(redirectTo, this.urlSerializer.parse(redirectTo), segments, posParams);
	    };
	    /**
	     * @param {?} redirectTo
	     * @param {?} urlTree
	     * @param {?} segments
	     * @param {?} posParams
	     * @return {?}
	     */
	    ApplyRedirects.prototype.applyRedirectCreatreUrlTree = /**
	     * @param {?} redirectTo
	     * @param {?} urlTree
	     * @param {?} segments
	     * @param {?} posParams
	     * @return {?}
	     */
	    function (redirectTo, urlTree, segments, posParams) {
	        var /** @type {?} */ newRoot = this.createSegmentGroup(redirectTo, urlTree.root, segments, posParams);
	        return new UrlTree(newRoot, this.createQueryParams(urlTree.queryParams, this.urlTree.queryParams), urlTree.fragment);
	    };
	    /**
	     * @param {?} redirectToParams
	     * @param {?} actualParams
	     * @return {?}
	     */
	    ApplyRedirects.prototype.createQueryParams = /**
	     * @param {?} redirectToParams
	     * @param {?} actualParams
	     * @return {?}
	     */
	    function (redirectToParams, actualParams) {
	        var /** @type {?} */ res = {};
	        forEach(redirectToParams, function (v, k) {
	            var /** @type {?} */ copySourceValue = typeof v === 'string' && v.startsWith(':');
	            if (copySourceValue) {
	                var /** @type {?} */ sourceName = v.substring(1);
	                res[k] = actualParams[sourceName];
	            }
	            else {
	                res[k] = v;
	            }
	        });
	        return res;
	    };
	    /**
	     * @param {?} redirectTo
	     * @param {?} group
	     * @param {?} segments
	     * @param {?} posParams
	     * @return {?}
	     */
	    ApplyRedirects.prototype.createSegmentGroup = /**
	     * @param {?} redirectTo
	     * @param {?} group
	     * @param {?} segments
	     * @param {?} posParams
	     * @return {?}
	     */
	    function (redirectTo, group, segments, posParams) {
	        var _this = this;
	        var /** @type {?} */ updatedSegments = this.createSegments(redirectTo, group.segments, segments, posParams);
	        var /** @type {?} */ children = {};
	        forEach(group.children, function (child, name) {
	            children[name] = _this.createSegmentGroup(redirectTo, child, segments, posParams);
	        });
	        return new UrlSegmentGroup(updatedSegments, children);
	    };
	    /**
	     * @param {?} redirectTo
	     * @param {?} redirectToSegments
	     * @param {?} actualSegments
	     * @param {?} posParams
	     * @return {?}
	     */
	    ApplyRedirects.prototype.createSegments = /**
	     * @param {?} redirectTo
	     * @param {?} redirectToSegments
	     * @param {?} actualSegments
	     * @param {?} posParams
	     * @return {?}
	     */
	    function (redirectTo, redirectToSegments, actualSegments, posParams) {
	        var _this = this;
	        return redirectToSegments.map(function (s) {
	            return s.path.startsWith(':') ? _this.findPosParam(redirectTo, s, posParams) :
	                _this.findOrReturn(s, actualSegments);
	        });
	    };
	    /**
	     * @param {?} redirectTo
	     * @param {?} redirectToUrlSegment
	     * @param {?} posParams
	     * @return {?}
	     */
	    ApplyRedirects.prototype.findPosParam = /**
	     * @param {?} redirectTo
	     * @param {?} redirectToUrlSegment
	     * @param {?} posParams
	     * @return {?}
	     */
	    function (redirectTo, redirectToUrlSegment, posParams) {
	        var /** @type {?} */ pos = posParams[redirectToUrlSegment.path.substring(1)];
	        if (!pos)
	            throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + redirectToUrlSegment.path + "'.");
	        return pos;
	    };
	    /**
	     * @param {?} redirectToUrlSegment
	     * @param {?} actualSegments
	     * @return {?}
	     */
	    ApplyRedirects.prototype.findOrReturn = /**
	     * @param {?} redirectToUrlSegment
	     * @param {?} actualSegments
	     * @return {?}
	     */
	    function (redirectToUrlSegment, actualSegments) {
	        var /** @type {?} */ idx = 0;
	        for (var _i = 0, actualSegments_1 = actualSegments; _i < actualSegments_1.length; _i++) {
	            var s = actualSegments_1[_i];
	            if (s.path === redirectToUrlSegment.path) {
	                actualSegments.splice(idx);
	                return s;
	            }
	            idx++;
	        }
	        return redirectToUrlSegment;
	    };
	    return ApplyRedirects;
	}());
	/**
	 * @param {?} moduleInjector
	 * @param {?} route
	 * @return {?}
	 */
	function runCanLoadGuard(moduleInjector, route) {
	    var /** @type {?} */ canLoad = route.canLoad;
	    if (!canLoad || canLoad.length === 0)
	        return rxjs_observable_of.of(true);
	    var /** @type {?} */ obs = rxjs_operator_map.map.call(rxjs_observable_from.from(canLoad), function (injectionToken) {
	        var /** @type {?} */ guard = moduleInjector.get(injectionToken);
	        return wrapIntoObservable(guard.canLoad ? guard.canLoad(route) : guard(route));
	    });
	    return andObservables(obs);
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} route
	 * @param {?} segments
	 * @return {?}
	 */
	function match(segmentGroup, route, segments) {
	    if (route.path === '') {
	        if ((route.pathMatch === 'full') && (segmentGroup.hasChildren() || segments.length > 0)) {
	            return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
	        }
	        return { matched: true, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
	    }
	    var /** @type {?} */ matcher = route.matcher || defaultUrlMatcher;
	    var /** @type {?} */ res = matcher(segments, segmentGroup, route);
	    if (!res) {
	        return {
	            matched: false,
	            consumedSegments: /** @type {?} */ ([]),
	            lastChild: 0,
	            positionalParamSegments: {},
	        };
	    }
	    return {
	        matched: true,
	        consumedSegments: /** @type {?} */ ((res.consumed)),
	        lastChild: /** @type {?} */ ((res.consumed.length)),
	        positionalParamSegments: /** @type {?} */ ((res.posParams)),
	    };
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} consumedSegments
	 * @param {?} slicedSegments
	 * @param {?} config
	 * @return {?}
	 */
	function split(segmentGroup, consumedSegments, slicedSegments, config) {
	    if (slicedSegments.length > 0 &&
	        containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, config)) {
	        var /** @type {?} */ s = new UrlSegmentGroup(consumedSegments, createChildrenForEmptySegments(config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
	        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: [] };
	    }
	    if (slicedSegments.length === 0 &&
	        containsEmptyPathRedirects(segmentGroup, slicedSegments, config)) {
	        var /** @type {?} */ s = new UrlSegmentGroup(segmentGroup.segments, addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
	        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: slicedSegments };
	    }
	    return { segmentGroup: segmentGroup, slicedSegments: slicedSegments };
	}
	/**
	 * @param {?} s
	 * @return {?}
	 */
	function mergeTrivialChildren(s) {
	    if (s.numberOfChildren === 1 && s.children[PRIMARY_OUTLET]) {
	        var /** @type {?} */ c = s.children[PRIMARY_OUTLET];
	        return new UrlSegmentGroup(s.segments.concat(c.segments), c.children);
	    }
	    return s;
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} slicedSegments
	 * @param {?} routes
	 * @param {?} children
	 * @return {?}
	 */
	function addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
	    var /** @type {?} */ res = {};
	    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
	        var r = routes_1[_i];
	        if (isEmptyPathRedirect(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
	            res[getOutlet(r)] = new UrlSegmentGroup([], {});
	        }
	    }
	    return __assign({}, children, res);
	}
	/**
	 * @param {?} routes
	 * @param {?} primarySegmentGroup
	 * @return {?}
	 */
	function createChildrenForEmptySegments(routes, primarySegmentGroup) {
	    var /** @type {?} */ res = {};
	    res[PRIMARY_OUTLET] = primarySegmentGroup;
	    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
	        var r = routes_2[_i];
	        if (r.path === '' && getOutlet(r) !== PRIMARY_OUTLET) {
	            res[getOutlet(r)] = new UrlSegmentGroup([], {});
	        }
	    }
	    return res;
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} segments
	 * @param {?} routes
	 * @return {?}
	 */
	function containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, segments, routes) {
	    return routes.some(function (r) { return isEmptyPathRedirect(segmentGroup, segments, r) && getOutlet(r) !== PRIMARY_OUTLET; });
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} segments
	 * @param {?} routes
	 * @return {?}
	 */
	function containsEmptyPathRedirects(segmentGroup, segments, routes) {
	    return routes.some(function (r) { return isEmptyPathRedirect(segmentGroup, segments, r); });
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} segments
	 * @param {?} r
	 * @return {?}
	 */
	function isEmptyPathRedirect(segmentGroup, segments, r) {
	    if ((segmentGroup.hasChildren() || segments.length > 0) && r.pathMatch === 'full') {
	        return false;
	    }
	    return r.path === '' && r.redirectTo !== undefined;
	}
	/**
	 * @param {?} route
	 * @return {?}
	 */
	function getOutlet(route) {
	    return route.outlet || PRIMARY_OUTLET;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @template T
	 */
	var Tree = /** @class */ (function () {
	    function Tree(root) {
	        this._root = root;
	    }
	    Object.defineProperty(Tree.prototype, "root", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._root.value; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    Tree.prototype.parent = /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    function (t) {
	        var /** @type {?} */ p = this.pathFromRoot(t);
	        return p.length > 1 ? p[p.length - 2] : null;
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    Tree.prototype.children = /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    function (t) {
	        var /** @type {?} */ n = findNode(t, this._root);
	        return n ? n.children.map(function (t) { return t.value; }) : [];
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    Tree.prototype.firstChild = /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    function (t) {
	        var /** @type {?} */ n = findNode(t, this._root);
	        return n && n.children.length > 0 ? n.children[0].value : null;
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    Tree.prototype.siblings = /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    function (t) {
	        var /** @type {?} */ p = findPath(t, this._root);
	        if (p.length < 2)
	            return [];
	        var /** @type {?} */ c = p[p.length - 2].children.map(function (c) { return c.value; });
	        return c.filter(function (cc) { return cc !== t; });
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    Tree.prototype.pathFromRoot = /**
	     * \@internal
	     * @param {?} t
	     * @return {?}
	     */
	    function (t) { return findPath(t, this._root).map(function (s) { return s.value; }); };
	    return Tree;
	}());
	/**
	 * @template T
	 * @param {?} value
	 * @param {?} node
	 * @return {?}
	 */
	function findNode(value, node) {
	    if (value === node.value)
	        return node;
	    for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
	        var child = _a[_i];
	        var /** @type {?} */ node_1 = findNode(value, child);
	        if (node_1)
	            return node_1;
	    }
	    return null;
	}
	/**
	 * @template T
	 * @param {?} value
	 * @param {?} node
	 * @return {?}
	 */
	function findPath(value, node) {
	    if (value === node.value)
	        return [node];
	    for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
	        var child = _a[_i];
	        var /** @type {?} */ path = findPath(value, child);
	        if (path.length) {
	            path.unshift(node);
	            return path;
	        }
	    }
	    return [];
	}
	/**
	 * @template T
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode(value, children) {
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @return {?}
	     */
	    TreeNode.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return "TreeNode(" + this.value + ")"; };
	    return TreeNode;
	}());
	/**
	 * @template T
	 * @param {?} node
	 * @return {?}
	 */
	function nodeChildrenAsMap(node) {
	    var /** @type {?} */ map$$1 = {};
	    if (node) {
	        node.children.forEach(function (child) { return map$$1[child.value.outlet] = child; });
	    }
	    return map$$1;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Represents the state of the router.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@Component({templateUrl:'template.html'})
	 * class MyComponent {
	 *   constructor(router: Router) {
	 *     const state: RouterState = router.routerState;
	 *     const root: ActivatedRoute = state.root;
	 *     const child = root.firstChild;
	 *     const id: Observable<string> = child.params.map(p => p.id);
	 *     //...
	 *   }
	 * }
	 * ```
	 *
	 * \@description
	 * RouterState is a tree of activated routes. Every node in this tree knows about the "consumed" URL
	 * segments, the extracted parameters, and the resolved data.
	 *
	 * See {\@link ActivatedRoute} for more information.
	 *
	 * \@stable
	 */
	var RouterState = /** @class */ (function (_super) {
	    __extends(RouterState, _super);
	    /** @internal */
	    function RouterState(root, snapshot) {
	        var _this = _super.call(this, root) || this;
	        _this.snapshot = snapshot;
	        setRouterState(/** @type {?} */ (_this), root);
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    RouterState.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return this.snapshot.toString(); };
	    return RouterState;
	}(Tree));
	/**
	 * @param {?} urlTree
	 * @param {?} rootComponent
	 * @return {?}
	 */
	function createEmptyState(urlTree, rootComponent) {
	    var /** @type {?} */ snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
	    var /** @type {?} */ emptyUrl = new rxjs_BehaviorSubject.BehaviorSubject([new UrlSegment('', {})]);
	    var /** @type {?} */ emptyParams = new rxjs_BehaviorSubject.BehaviorSubject({});
	    var /** @type {?} */ emptyData = new rxjs_BehaviorSubject.BehaviorSubject({});
	    var /** @type {?} */ emptyQueryParams = new rxjs_BehaviorSubject.BehaviorSubject({});
	    var /** @type {?} */ fragment = new rxjs_BehaviorSubject.BehaviorSubject('');
	    var /** @type {?} */ activated = new ActivatedRoute(emptyUrl, emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, snapshot.root);
	    activated.snapshot = snapshot.root;
	    return new RouterState(new TreeNode(activated, []), snapshot);
	}
	/**
	 * @param {?} urlTree
	 * @param {?} rootComponent
	 * @return {?}
	 */
	function createEmptyStateSnapshot(urlTree, rootComponent) {
	    var /** @type {?} */ emptyParams = {};
	    var /** @type {?} */ emptyData = {};
	    var /** @type {?} */ emptyQueryParams = {};
	    var /** @type {?} */ fragment = '';
	    var /** @type {?} */ activated = new ActivatedRouteSnapshot([], emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, null, urlTree.root, -1, {});
	    return new RouterStateSnapshot('', new TreeNode(activated, []));
	}
	/**
	 * \@whatItDoes Contains the information about a route associated with a component loaded in an
	 * outlet.
	 * An `ActivatedRoute` can also be used to traverse the router state tree.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@Component({...})
	 * class MyComponent {
	 *   constructor(route: ActivatedRoute) {
	 *     const id: Observable<string> = route.params.map(p => p.id);
	 *     const url: Observable<string> = route.url.map(segments => segments.join(''));
	 *     // route.data includes both `data` and `resolve`
	 *     const user = route.data.map(d => d.user);
	 *   }
	 * }
	 * ```
	 *
	 * \@stable
	 */
	var ActivatedRoute = /** @class */ (function () {
	    /** @internal */
	    function ActivatedRoute(url, params, queryParams, fragment, data, outlet, component, futureSnapshot) {
	        this.url = url;
	        this.params = params;
	        this.queryParams = queryParams;
	        this.fragment = fragment;
	        this.data = data;
	        this.outlet = outlet;
	        this.component = component;
	        this._futureSnapshot = futureSnapshot;
	    }
	    Object.defineProperty(ActivatedRoute.prototype, "routeConfig", {
	        /** The configuration used to match this route */
	        get: /**
	         * The configuration used to match this route
	         * @return {?}
	         */
	        function () { return this._futureSnapshot.routeConfig; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "root", {
	        /** The root of the router state */
	        get: /**
	         * The root of the router state
	         * @return {?}
	         */
	        function () { return this._routerState.root; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "parent", {
	        /** The parent of this route in the router state tree */
	        get: /**
	         * The parent of this route in the router state tree
	         * @return {?}
	         */
	        function () { return this._routerState.parent(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "firstChild", {
	        /** The first child of this route in the router state tree */
	        get: /**
	         * The first child of this route in the router state tree
	         * @return {?}
	         */
	        function () { return this._routerState.firstChild(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "children", {
	        /** The children of this route in the router state tree */
	        get: /**
	         * The children of this route in the router state tree
	         * @return {?}
	         */
	        function () { return this._routerState.children(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "pathFromRoot", {
	        /** The path from the root of the router state tree to this route */
	        get: /**
	         * The path from the root of the router state tree to this route
	         * @return {?}
	         */
	        function () { return this._routerState.pathFromRoot(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "paramMap", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this._paramMap) {
	                this._paramMap = rxjs_operator_map.map.call(this.params, function (p) { return convertToParamMap(p); });
	            }
	            return this._paramMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRoute.prototype, "queryParamMap", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this._queryParamMap) {
	                this._queryParamMap =
	                    rxjs_operator_map.map.call(this.queryParams, function (p) { return convertToParamMap(p); });
	            }
	            return this._queryParamMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    ActivatedRoute.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
	    };
	    return ActivatedRoute;
	}());
	/**
	 * Returns the inherited params, data, and resolve for a given route.
	 * By default, this only inherits values up to the nearest path-less or component-less route.
	 * \@internal
	 * @param {?} route
	 * @param {?=} paramsInheritanceStrategy
	 * @return {?}
	 */
	function inheritedParamsDataResolve(route, paramsInheritanceStrategy) {
	    if (paramsInheritanceStrategy === void 0) { paramsInheritanceStrategy = 'emptyOnly'; }
	    var /** @type {?} */ pathFromRoot = route.pathFromRoot;
	    var /** @type {?} */ inheritingStartingFrom = 0;
	    if (paramsInheritanceStrategy !== 'always') {
	        inheritingStartingFrom = pathFromRoot.length - 1;
	        while (inheritingStartingFrom >= 1) {
	            var /** @type {?} */ current = pathFromRoot[inheritingStartingFrom];
	            var /** @type {?} */ parent_1 = pathFromRoot[inheritingStartingFrom - 1];
	            // current route is an empty path => inherits its parent's params and data
	            if (current.routeConfig && current.routeConfig.path === '') {
	                inheritingStartingFrom--;
	                // parent is componentless => current route should inherit its params and data
	            }
	            else if (!parent_1.component) {
	                inheritingStartingFrom--;
	            }
	            else {
	                break;
	            }
	        }
	    }
	    return flattenInherited(pathFromRoot.slice(inheritingStartingFrom));
	}
	/**
	 * \@internal
	 * @param {?} pathFromRoot
	 * @return {?}
	 */
	function flattenInherited(pathFromRoot) {
	    return pathFromRoot.reduce(function (res, curr) {
	        var /** @type {?} */ params = __assign({}, res.params, curr.params);
	        var /** @type {?} */ data = __assign({}, res.data, curr.data);
	        var /** @type {?} */ resolve = __assign({}, res.resolve, curr._resolvedData);
	        return { params: params, data: data, resolve: resolve };
	    }, /** @type {?} */ ({ params: {}, data: {}, resolve: {} }));
	}
	/**
	 * \@whatItDoes Contains the information about a route associated with a component loaded in an
	 * outlet
	 * at a particular moment in time. ActivatedRouteSnapshot can also be used to traverse the router
	 * state tree.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@Component({templateUrl:'./my-component.html'})
	 * class MyComponent {
	 *   constructor(route: ActivatedRoute) {
	 *     const id: string = route.snapshot.params.id;
	 *     const url: string = route.snapshot.url.join('');
	 *     const user = route.snapshot.data.user;
	 *   }
	 * }
	 * ```
	 *
	 * \@stable
	 */
	var ActivatedRouteSnapshot = /** @class */ (function () {
	    /** @internal */
	    function ActivatedRouteSnapshot(url, params, queryParams, fragment, data, outlet, component, routeConfig, urlSegment, lastPathIndex, resolve) {
	        this.url = url;
	        this.params = params;
	        this.queryParams = queryParams;
	        this.fragment = fragment;
	        this.data = data;
	        this.outlet = outlet;
	        this.component = component;
	        this.routeConfig = routeConfig;
	        this._urlSegment = urlSegment;
	        this._lastPathIndex = lastPathIndex;
	        this._resolve = resolve;
	    }
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "root", {
	        /** The root of the router state */
	        get: /**
	         * The root of the router state
	         * @return {?}
	         */
	        function () { return this._routerState.root; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "parent", {
	        /** The parent of this route in the router state tree */
	        get: /**
	         * The parent of this route in the router state tree
	         * @return {?}
	         */
	        function () { return this._routerState.parent(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "firstChild", {
	        /** The first child of this route in the router state tree */
	        get: /**
	         * The first child of this route in the router state tree
	         * @return {?}
	         */
	        function () { return this._routerState.firstChild(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "children", {
	        /** The children of this route in the router state tree */
	        get: /**
	         * The children of this route in the router state tree
	         * @return {?}
	         */
	        function () { return this._routerState.children(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "pathFromRoot", {
	        /** The path from the root of the router state tree to this route */
	        get: /**
	         * The path from the root of the router state tree to this route
	         * @return {?}
	         */
	        function () { return this._routerState.pathFromRoot(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "paramMap", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this._paramMap) {
	                this._paramMap = convertToParamMap(this.params);
	            }
	            return this._paramMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ActivatedRouteSnapshot.prototype, "queryParamMap", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this._queryParamMap) {
	                this._queryParamMap = convertToParamMap(this.queryParams);
	            }
	            return this._queryParamMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    ActivatedRouteSnapshot.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ url = this.url.map(function (segment) { return segment.toString(); }).join('/');
	        var /** @type {?} */ matched = this.routeConfig ? this.routeConfig.path : '';
	        return "Route(url:'" + url + "', path:'" + matched + "')";
	    };
	    return ActivatedRouteSnapshot;
	}());
	/**
	 * \@whatItDoes Represents the state of the router at a moment in time.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@Component({templateUrl:'template.html'})
	 * class MyComponent {
	 *   constructor(router: Router) {
	 *     const state: RouterState = router.routerState;
	 *     const snapshot: RouterStateSnapshot = state.snapshot;
	 *     const root: ActivatedRouteSnapshot = snapshot.root;
	 *     const child = root.firstChild;
	 *     const id: Observable<string> = child.params.map(p => p.id);
	 *     //...
	 *   }
	 * }
	 * ```
	 *
	 * \@description
	 * RouterStateSnapshot is a tree of activated route snapshots. Every node in this tree knows about
	 * the "consumed" URL segments, the extracted parameters, and the resolved data.
	 *
	 * \@stable
	 */
	var RouterStateSnapshot = /** @class */ (function (_super) {
	    __extends(RouterStateSnapshot, _super);
	    /** @internal */
	    function RouterStateSnapshot(url, root) {
	        var _this = _super.call(this, root) || this;
	        _this.url = url;
	        setRouterState(/** @type {?} */ (_this), root);
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    RouterStateSnapshot.prototype.toString = /**
	     * @return {?}
	     */
	    function () { return serializeNode(this._root); };
	    return RouterStateSnapshot;
	}(Tree));
	/**
	 * @template U, T
	 * @param {?} state
	 * @param {?} node
	 * @return {?}
	 */
	function setRouterState(state, node) {
	    node.value._routerState = state;
	    node.children.forEach(function (c) { return setRouterState(state, c); });
	}
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function serializeNode(node) {
	    var /** @type {?} */ c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(', ') + " } " : '';
	    return "" + node.value + c;
	}
	/**
	 * The expectation is that the activate route is created with the right set of parameters.
	 * So we push new values into the observables only when they are not the initial values.
	 * And we detect that by checking if the snapshot field is set.
	 * @param {?} route
	 * @return {?}
	 */
	function advanceActivatedRoute(route) {
	    if (route.snapshot) {
	        var /** @type {?} */ currentSnapshot = route.snapshot;
	        var /** @type {?} */ nextSnapshot = route._futureSnapshot;
	        route.snapshot = nextSnapshot;
	        if (!shallowEqual(currentSnapshot.queryParams, nextSnapshot.queryParams)) {
	            (/** @type {?} */ (route.queryParams)).next(nextSnapshot.queryParams);
	        }
	        if (currentSnapshot.fragment !== nextSnapshot.fragment) {
	            (/** @type {?} */ (route.fragment)).next(nextSnapshot.fragment);
	        }
	        if (!shallowEqual(currentSnapshot.params, nextSnapshot.params)) {
	            (/** @type {?} */ (route.params)).next(nextSnapshot.params);
	        }
	        if (!shallowEqualArrays(currentSnapshot.url, nextSnapshot.url)) {
	            (/** @type {?} */ (route.url)).next(nextSnapshot.url);
	        }
	        if (!shallowEqual(currentSnapshot.data, nextSnapshot.data)) {
	            (/** @type {?} */ (route.data)).next(nextSnapshot.data);
	        }
	    }
	    else {
	        route.snapshot = route._futureSnapshot;
	        // this is for resolved data
	        (/** @type {?} */ (route.data)).next(route._futureSnapshot.data);
	    }
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function equalParamsAndUrlSegments(a, b) {
	    var /** @type {?} */ equalUrlParams = shallowEqual(a.params, b.params) && equalSegments(a.url, b.url);
	    var /** @type {?} */ parentsMismatch = !a.parent !== !b.parent;
	    return equalUrlParams && !parentsMismatch &&
	        (!a.parent || equalParamsAndUrlSegments(a.parent, /** @type {?} */ ((b.parent))));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} routeReuseStrategy
	 * @param {?} curr
	 * @param {?} prevState
	 * @return {?}
	 */
	function createRouterState(routeReuseStrategy, curr, prevState) {
	    var /** @type {?} */ root = createNode(routeReuseStrategy, curr._root, prevState ? prevState._root : undefined);
	    return new RouterState(root, curr);
	}
	/**
	 * @param {?} routeReuseStrategy
	 * @param {?} curr
	 * @param {?=} prevState
	 * @return {?}
	 */
	function createNode(routeReuseStrategy, curr, prevState) {
	    // reuse an activated route that is currently displayed on the screen
	    if (prevState && routeReuseStrategy.shouldReuseRoute(curr.value, prevState.value.snapshot)) {
	        var /** @type {?} */ value = prevState.value;
	        value._futureSnapshot = curr.value;
	        var /** @type {?} */ children = createOrReuseChildren(routeReuseStrategy, curr, prevState);
	        return new TreeNode(value, children);
	        // retrieve an activated route that is used to be displayed, but is not currently displayed
	    }
	    else if (routeReuseStrategy.retrieve(curr.value)) {
	        var /** @type {?} */ tree = (/** @type {?} */ (routeReuseStrategy.retrieve(curr.value))).route;
	        setFutureSnapshotsOfActivatedRoutes(curr, tree);
	        return tree;
	    }
	    else {
	        var /** @type {?} */ value = createActivatedRoute(curr.value);
	        var /** @type {?} */ children = curr.children.map(function (c) { return createNode(routeReuseStrategy, c); });
	        return new TreeNode(value, children);
	    }
	}
	/**
	 * @param {?} curr
	 * @param {?} result
	 * @return {?}
	 */
	function setFutureSnapshotsOfActivatedRoutes(curr, result) {
	    if (curr.value.routeConfig !== result.value.routeConfig) {
	        throw new Error('Cannot reattach ActivatedRouteSnapshot created from a different route');
	    }
	    if (curr.children.length !== result.children.length) {
	        throw new Error('Cannot reattach ActivatedRouteSnapshot with a different number of children');
	    }
	    result.value._futureSnapshot = curr.value;
	    for (var /** @type {?} */ i = 0; i < curr.children.length; ++i) {
	        setFutureSnapshotsOfActivatedRoutes(curr.children[i], result.children[i]);
	    }
	}
	/**
	 * @param {?} routeReuseStrategy
	 * @param {?} curr
	 * @param {?} prevState
	 * @return {?}
	 */
	function createOrReuseChildren(routeReuseStrategy, curr, prevState) {
	    return curr.children.map(function (child) {
	        for (var _i = 0, _a = prevState.children; _i < _a.length; _i++) {
	            var p = _a[_i];
	            if (routeReuseStrategy.shouldReuseRoute(p.value.snapshot, child.value)) {
	                return createNode(routeReuseStrategy, child, p);
	            }
	        }
	        return createNode(routeReuseStrategy, child);
	    });
	}
	/**
	 * @param {?} c
	 * @return {?}
	 */
	function createActivatedRoute(c) {
	    return new ActivatedRoute(new rxjs_BehaviorSubject.BehaviorSubject(c.url), new rxjs_BehaviorSubject.BehaviorSubject(c.params), new rxjs_BehaviorSubject.BehaviorSubject(c.queryParams), new rxjs_BehaviorSubject.BehaviorSubject(c.fragment), new rxjs_BehaviorSubject.BehaviorSubject(c.data), c.outlet, c.component, c);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} route
	 * @param {?} urlTree
	 * @param {?} commands
	 * @param {?} queryParams
	 * @param {?} fragment
	 * @return {?}
	 */
	function createUrlTree(route, urlTree, commands, queryParams, fragment) {
	    if (commands.length === 0) {
	        return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
	    }
	    var /** @type {?} */ nav = computeNavigation(commands);
	    if (nav.toRoot()) {
	        return tree(urlTree.root, new UrlSegmentGroup([], {}), urlTree, queryParams, fragment);
	    }
	    var /** @type {?} */ startingPosition = findStartingPosition(nav, urlTree, route);
	    var /** @type {?} */ segmentGroup = startingPosition.processChildren ?
	        updateSegmentGroupChildren(startingPosition.segmentGroup, startingPosition.index, nav.commands) :
	        updateSegmentGroup(startingPosition.segmentGroup, startingPosition.index, nav.commands);
	    return tree(startingPosition.segmentGroup, segmentGroup, urlTree, queryParams, fragment);
	}
	/**
	 * @param {?} command
	 * @return {?}
	 */
	function isMatrixParams(command) {
	    return typeof command === 'object' && command != null && !command.outlets && !command.segmentPath;
	}
	/**
	 * @param {?} oldSegmentGroup
	 * @param {?} newSegmentGroup
	 * @param {?} urlTree
	 * @param {?} queryParams
	 * @param {?} fragment
	 * @return {?}
	 */
	function tree(oldSegmentGroup, newSegmentGroup, urlTree, queryParams, fragment) {
	    var /** @type {?} */ qp = {};
	    if (queryParams) {
	        forEach(queryParams, function (value, name) {
	            qp[name] = Array.isArray(value) ? value.map(function (v) { return "" + v; }) : "" + value;
	        });
	    }
	    if (urlTree.root === oldSegmentGroup) {
	        return new UrlTree(newSegmentGroup, qp, fragment);
	    }
	    return new UrlTree(replaceSegment(urlTree.root, oldSegmentGroup, newSegmentGroup), qp, fragment);
	}
	/**
	 * @param {?} current
	 * @param {?} oldSegment
	 * @param {?} newSegment
	 * @return {?}
	 */
	function replaceSegment(current, oldSegment, newSegment) {
	    var /** @type {?} */ children = {};
	    forEach(current.children, function (c, outletName) {
	        if (c === oldSegment) {
	            children[outletName] = newSegment;
	        }
	        else {
	            children[outletName] = replaceSegment(c, oldSegment, newSegment);
	        }
	    });
	    return new UrlSegmentGroup(current.segments, children);
	}
	var Navigation = /** @class */ (function () {
	    function Navigation(isAbsolute, numberOfDoubleDots, commands) {
	        this.isAbsolute = isAbsolute;
	        this.numberOfDoubleDots = numberOfDoubleDots;
	        this.commands = commands;
	        if (isAbsolute && commands.length > 0 && isMatrixParams(commands[0])) {
	            throw new Error('Root segment cannot have matrix parameters');
	        }
	        var /** @type {?} */ cmdWithOutlet = commands.find(function (c) { return typeof c === 'object' && c != null && c.outlets; });
	        if (cmdWithOutlet && cmdWithOutlet !== last$1(commands)) {
	            throw new Error('{outlets:{}} has to be the last command');
	        }
	    }
	    /**
	     * @return {?}
	     */
	    Navigation.prototype.toRoot = /**
	     * @return {?}
	     */
	    function () {
	        return this.isAbsolute && this.commands.length === 1 && this.commands[0] == '/';
	    };
	    return Navigation;
	}());
	/**
	 * Transforms commands to a normalized `Navigation`
	 * @param {?} commands
	 * @return {?}
	 */
	function computeNavigation(commands) {
	    if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] === '/') {
	        return new Navigation(true, 0, commands);
	    }
	    var /** @type {?} */ numberOfDoubleDots = 0;
	    var /** @type {?} */ isAbsolute = false;
	    var /** @type {?} */ res = commands.reduce(function (res, cmd, cmdIdx) {
	        if (typeof cmd === 'object' && cmd != null) {
	            if (cmd.outlets) {
	                var /** @type {?} */ outlets_1 = {};
	                forEach(cmd.outlets, function (commands, name) {
	                    outlets_1[name] = typeof commands === 'string' ? commands.split('/') : commands;
	                });
	                return res.concat([{ outlets: outlets_1 }]);
	            }
	            if (cmd.segmentPath) {
	                return res.concat([cmd.segmentPath]);
	            }
	        }
	        if (!(typeof cmd === 'string')) {
	            return res.concat([cmd]);
	        }
	        if (cmdIdx === 0) {
	            cmd.split('/').forEach(function (urlPart, partIndex) {
	                if (partIndex == 0 && urlPart === '.') {
	                    // skip './a'
	                }
	                else if (partIndex == 0 && urlPart === '') {
	                    //  '/a'
	                    isAbsolute = true;
	                }
	                else if (urlPart === '..') {
	                    //  '../a'
	                    numberOfDoubleDots++;
	                }
	                else if (urlPart != '') {
	                    res.push(urlPart);
	                }
	            });
	            return res;
	        }
	        return res.concat([cmd]);
	    }, []);
	    return new Navigation(isAbsolute, numberOfDoubleDots, res);
	}
	var Position = /** @class */ (function () {
	    function Position(segmentGroup, processChildren, index) {
	        this.segmentGroup = segmentGroup;
	        this.processChildren = processChildren;
	        this.index = index;
	    }
	    return Position;
	}());
	/**
	 * @param {?} nav
	 * @param {?} tree
	 * @param {?} route
	 * @return {?}
	 */
	function findStartingPosition(nav, tree, route) {
	    if (nav.isAbsolute) {
	        return new Position(tree.root, true, 0);
	    }
	    if (route.snapshot._lastPathIndex === -1) {
	        return new Position(route.snapshot._urlSegment, true, 0);
	    }
	    var /** @type {?} */ modifier = isMatrixParams(nav.commands[0]) ? 0 : 1;
	    var /** @type {?} */ index = route.snapshot._lastPathIndex + modifier;
	    return createPositionApplyingDoubleDots(route.snapshot._urlSegment, index, nav.numberOfDoubleDots);
	}
	/**
	 * @param {?} group
	 * @param {?} index
	 * @param {?} numberOfDoubleDots
	 * @return {?}
	 */
	function createPositionApplyingDoubleDots(group, index, numberOfDoubleDots) {
	    var /** @type {?} */ g = group;
	    var /** @type {?} */ ci = index;
	    var /** @type {?} */ dd = numberOfDoubleDots;
	    while (dd > ci) {
	        dd -= ci;
	        g = /** @type {?} */ ((g.parent));
	        if (!g) {
	            throw new Error('Invalid number of \'../\'');
	        }
	        ci = g.segments.length;
	    }
	    return new Position(g, false, ci - dd);
	}
	/**
	 * @param {?} command
	 * @return {?}
	 */
	function getPath(command) {
	    if (typeof command === 'object' && command != null && command.outlets) {
	        return command.outlets[PRIMARY_OUTLET];
	    }
	    return "" + command;
	}
	/**
	 * @param {?} commands
	 * @return {?}
	 */
	function getOutlets(commands) {
	    if (!(typeof commands[0] === 'object'))
	        return _a = {}, _a[PRIMARY_OUTLET] = commands, _a;
	    if (commands[0].outlets === undefined)
	        return _b = {}, _b[PRIMARY_OUTLET] = commands, _b;
	    return commands[0].outlets;
	    var _a, _b;
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} startIndex
	 * @param {?} commands
	 * @return {?}
	 */
	function updateSegmentGroup(segmentGroup, startIndex, commands) {
	    if (!segmentGroup) {
	        segmentGroup = new UrlSegmentGroup([], {});
	    }
	    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
	        return updateSegmentGroupChildren(segmentGroup, startIndex, commands);
	    }
	    var /** @type {?} */ m = prefixedWith(segmentGroup, startIndex, commands);
	    var /** @type {?} */ slicedCommands = commands.slice(m.commandIndex);
	    if (m.match && m.pathIndex < segmentGroup.segments.length) {
	        var /** @type {?} */ g = new UrlSegmentGroup(segmentGroup.segments.slice(0, m.pathIndex), {});
	        g.children[PRIMARY_OUTLET] =
	            new UrlSegmentGroup(segmentGroup.segments.slice(m.pathIndex), segmentGroup.children);
	        return updateSegmentGroupChildren(g, 0, slicedCommands);
	    }
	    else if (m.match && slicedCommands.length === 0) {
	        return new UrlSegmentGroup(segmentGroup.segments, {});
	    }
	    else if (m.match && !segmentGroup.hasChildren()) {
	        return createNewSegmentGroup(segmentGroup, startIndex, commands);
	    }
	    else if (m.match) {
	        return updateSegmentGroupChildren(segmentGroup, 0, slicedCommands);
	    }
	    else {
	        return createNewSegmentGroup(segmentGroup, startIndex, commands);
	    }
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} startIndex
	 * @param {?} commands
	 * @return {?}
	 */
	function updateSegmentGroupChildren(segmentGroup, startIndex, commands) {
	    if (commands.length === 0) {
	        return new UrlSegmentGroup(segmentGroup.segments, {});
	    }
	    else {
	        var /** @type {?} */ outlets_2 = getOutlets(commands);
	        var /** @type {?} */ children_1 = {};
	        forEach(outlets_2, function (commands, outlet) {
	            if (commands !== null) {
	                children_1[outlet] = updateSegmentGroup(segmentGroup.children[outlet], startIndex, commands);
	            }
	        });
	        forEach(segmentGroup.children, function (child, childOutlet) {
	            if (outlets_2[childOutlet] === undefined) {
	                children_1[childOutlet] = child;
	            }
	        });
	        return new UrlSegmentGroup(segmentGroup.segments, children_1);
	    }
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} startIndex
	 * @param {?} commands
	 * @return {?}
	 */
	function prefixedWith(segmentGroup, startIndex, commands) {
	    var /** @type {?} */ currentCommandIndex = 0;
	    var /** @type {?} */ currentPathIndex = startIndex;
	    var /** @type {?} */ noMatch = { match: false, pathIndex: 0, commandIndex: 0 };
	    while (currentPathIndex < segmentGroup.segments.length) {
	        if (currentCommandIndex >= commands.length)
	            return noMatch;
	        var /** @type {?} */ path = segmentGroup.segments[currentPathIndex];
	        var /** @type {?} */ curr = getPath(commands[currentCommandIndex]);
	        var /** @type {?} */ next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
	        if (currentPathIndex > 0 && curr === undefined)
	            break;
	        if (curr && next && (typeof next === 'object') && next.outlets === undefined) {
	            if (!compare(curr, next, path))
	                return noMatch;
	            currentCommandIndex += 2;
	        }
	        else {
	            if (!compare(curr, {}, path))
	                return noMatch;
	            currentCommandIndex++;
	        }
	        currentPathIndex++;
	    }
	    return { match: true, pathIndex: currentPathIndex, commandIndex: currentCommandIndex };
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} startIndex
	 * @param {?} commands
	 * @return {?}
	 */
	function createNewSegmentGroup(segmentGroup, startIndex, commands) {
	    var /** @type {?} */ paths = segmentGroup.segments.slice(0, startIndex);
	    var /** @type {?} */ i = 0;
	    while (i < commands.length) {
	        if (typeof commands[i] === 'object' && commands[i].outlets !== undefined) {
	            var /** @type {?} */ children = createNewSegmentChildren(commands[i].outlets);
	            return new UrlSegmentGroup(paths, children);
	        }
	        // if we start with an object literal, we need to reuse the path part from the segment
	        if (i === 0 && isMatrixParams(commands[0])) {
	            var /** @type {?} */ p = segmentGroup.segments[startIndex];
	            paths.push(new UrlSegment(p.path, commands[0]));
	            i++;
	            continue;
	        }
	        var /** @type {?} */ curr = getPath(commands[i]);
	        var /** @type {?} */ next = (i < commands.length - 1) ? commands[i + 1] : null;
	        if (curr && next && isMatrixParams(next)) {
	            paths.push(new UrlSegment(curr, stringify(next)));
	            i += 2;
	        }
	        else {
	            paths.push(new UrlSegment(curr, {}));
	            i++;
	        }
	    }
	    return new UrlSegmentGroup(paths, {});
	}
	/**
	 * @param {?} outlets
	 * @return {?}
	 */
	function createNewSegmentChildren(outlets) {
	    var /** @type {?} */ children = {};
	    forEach(outlets, function (commands, outlet) {
	        if (commands !== null) {
	            children[outlet] = createNewSegmentGroup(new UrlSegmentGroup([], {}), 0, commands);
	        }
	    });
	    return children;
	}
	/**
	 * @param {?} params
	 * @return {?}
	 */
	function stringify(params) {
	    var /** @type {?} */ res = {};
	    forEach(params, function (v, k) { return res[k] = "" + v; });
	    return res;
	}
	/**
	 * @param {?} path
	 * @param {?} params
	 * @param {?} segment
	 * @return {?}
	 */
	function compare(path, params, segment) {
	    return path == segment.path && shallowEqual(params, segment.parameters);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var CanActivate = /** @class */ (function () {
	    function CanActivate(path) {
	        this.path = path;
	        this.route = this.path[this.path.length - 1];
	    }
	    return CanActivate;
	}());
	var CanDeactivate = /** @class */ (function () {
	    function CanDeactivate(component, route) {
	        this.component = component;
	        this.route = route;
	    }
	    return CanDeactivate;
	}());
	/**
	 * This class bundles the actions involved in preactivation of a route.
	 */
	var PreActivation = /** @class */ (function () {
	    function PreActivation(future, curr, moduleInjector, forwardEvent) {
	        this.future = future;
	        this.curr = curr;
	        this.moduleInjector = moduleInjector;
	        this.forwardEvent = forwardEvent;
	        this.canActivateChecks = [];
	        this.canDeactivateChecks = [];
	    }
	    /**
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    PreActivation.prototype.initialize = /**
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    function (parentContexts) {
	        var /** @type {?} */ futureRoot = this.future._root;
	        var /** @type {?} */ currRoot = this.curr ? this.curr._root : null;
	        this.setupChildRouteGuards(futureRoot, currRoot, parentContexts, [futureRoot.value]);
	    };
	    /**
	     * @return {?}
	     */
	    PreActivation.prototype.checkGuards = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this.isDeactivating() && !this.isActivating()) {
	            return rxjs_observable_of.of(true);
	        }
	        var /** @type {?} */ canDeactivate$ = this.runCanDeactivateChecks();
	        return rxjs_operator_mergeMap.mergeMap.call(canDeactivate$, function (canDeactivate) { return canDeactivate ? _this.runCanActivateChecks() : rxjs_observable_of.of(false); });
	    };
	    /**
	     * @param {?} paramsInheritanceStrategy
	     * @return {?}
	     */
	    PreActivation.prototype.resolveData = /**
	     * @param {?} paramsInheritanceStrategy
	     * @return {?}
	     */
	    function (paramsInheritanceStrategy) {
	        var _this = this;
	        if (!this.isActivating())
	            return rxjs_observable_of.of(null);
	        var /** @type {?} */ checks$ = rxjs_observable_from.from(this.canActivateChecks);
	        var /** @type {?} */ runningChecks$ = rxjs_operator_concatMap.concatMap.call(checks$, function (check) { return _this.runResolve(check.route, paramsInheritanceStrategy); });
	        return rxjs_operator_reduce.reduce.call(runningChecks$, function (_, __) { return _; });
	    };
	    /**
	     * @return {?}
	     */
	    PreActivation.prototype.isDeactivating = /**
	     * @return {?}
	     */
	    function () { return this.canDeactivateChecks.length !== 0; };
	    /**
	     * @return {?}
	     */
	    PreActivation.prototype.isActivating = /**
	     * @return {?}
	     */
	    function () { return this.canActivateChecks.length !== 0; };
	    /**
	     * Iterates over child routes and calls recursive `setupRouteGuards` to get `this` instance in
	     * proper state to run `checkGuards()` method.
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} contexts
	     * @param {?} futurePath
	     * @return {?}
	     */
	    PreActivation.prototype.setupChildRouteGuards = /**
	     * Iterates over child routes and calls recursive `setupRouteGuards` to get `this` instance in
	     * proper state to run `checkGuards()` method.
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} contexts
	     * @param {?} futurePath
	     * @return {?}
	     */
	    function (futureNode, currNode, contexts, futurePath) {
	        var _this = this;
	        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
	        // Process the children of the future route
	        futureNode.children.forEach(function (c) {
	            _this.setupRouteGuards(c, prevChildren[c.value.outlet], contexts, futurePath.concat([c.value]));
	            delete prevChildren[c.value.outlet];
	        });
	        // Process any children left from the current route (not active for the future route)
	        forEach(prevChildren, function (v, k) {
	            return _this.deactivateRouteAndItsChildren(v, /** @type {?} */ ((contexts)).getContext(k));
	        });
	    };
	    /**
	     * Iterates over child routes and calls recursive `setupRouteGuards` to get `this` instance in
	     * proper state to run `checkGuards()` method.
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} parentContexts
	     * @param {?} futurePath
	     * @return {?}
	     */
	    PreActivation.prototype.setupRouteGuards = /**
	     * Iterates over child routes and calls recursive `setupRouteGuards` to get `this` instance in
	     * proper state to run `checkGuards()` method.
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} parentContexts
	     * @param {?} futurePath
	     * @return {?}
	     */
	    function (futureNode, currNode, parentContexts, futurePath) {
	        var /** @type {?} */ future = futureNode.value;
	        var /** @type {?} */ curr = currNode ? currNode.value : null;
	        var /** @type {?} */ context = parentContexts ? parentContexts.getContext(futureNode.value.outlet) : null;
	        // reusing the node
	        if (curr && future.routeConfig === curr.routeConfig) {
	            var /** @type {?} */ shouldRunGuardsAndResolvers = this.shouldRunGuardsAndResolvers(curr, future, /** @type {?} */ ((future.routeConfig)).runGuardsAndResolvers);
	            if (shouldRunGuardsAndResolvers) {
	                this.canActivateChecks.push(new CanActivate(futurePath));
	            }
	            else {
	                // we need to set the data
	                future.data = curr.data;
	                future._resolvedData = curr._resolvedData;
	            }
	            // If we have a component, we need to go through an outlet.
	            if (future.component) {
	                this.setupChildRouteGuards(futureNode, currNode, context ? context.children : null, futurePath);
	                // if we have a componentless route, we recurse but keep the same outlet map.
	            }
	            else {
	                this.setupChildRouteGuards(futureNode, currNode, parentContexts, futurePath);
	            }
	            if (shouldRunGuardsAndResolvers) {
	                var /** @type {?} */ outlet = /** @type {?} */ ((/** @type {?} */ ((context)).outlet));
	                this.canDeactivateChecks.push(new CanDeactivate(outlet.component, curr));
	            }
	        }
	        else {
	            if (curr) {
	                this.deactivateRouteAndItsChildren(currNode, context);
	            }
	            this.canActivateChecks.push(new CanActivate(futurePath));
	            // If we have a component, we need to go through an outlet.
	            if (future.component) {
	                this.setupChildRouteGuards(futureNode, null, context ? context.children : null, futurePath);
	                // if we have a componentless route, we recurse but keep the same outlet map.
	            }
	            else {
	                this.setupChildRouteGuards(futureNode, null, parentContexts, futurePath);
	            }
	        }
	    };
	    /**
	     * @param {?} curr
	     * @param {?} future
	     * @param {?} mode
	     * @return {?}
	     */
	    PreActivation.prototype.shouldRunGuardsAndResolvers = /**
	     * @param {?} curr
	     * @param {?} future
	     * @param {?} mode
	     * @return {?}
	     */
	    function (curr, future, mode) {
	        switch (mode) {
	            case 'always':
	                return true;
	            case 'paramsOrQueryParamsChange':
	                return !equalParamsAndUrlSegments(curr, future) ||
	                    !shallowEqual(curr.queryParams, future.queryParams);
	            case 'paramsChange':
	            default:
	                return !equalParamsAndUrlSegments(curr, future);
	        }
	    };
	    /**
	     * @param {?} route
	     * @param {?} context
	     * @return {?}
	     */
	    PreActivation.prototype.deactivateRouteAndItsChildren = /**
	     * @param {?} route
	     * @param {?} context
	     * @return {?}
	     */
	    function (route, context) {
	        var _this = this;
	        var /** @type {?} */ children = nodeChildrenAsMap(route);
	        var /** @type {?} */ r = route.value;
	        forEach(children, function (node, childName) {
	            if (!r.component) {
	                _this.deactivateRouteAndItsChildren(node, context);
	            }
	            else if (context) {
	                _this.deactivateRouteAndItsChildren(node, context.children.getContext(childName));
	            }
	            else {
	                _this.deactivateRouteAndItsChildren(node, null);
	            }
	        });
	        if (!r.component) {
	            this.canDeactivateChecks.push(new CanDeactivate(null, r));
	        }
	        else if (context && context.outlet && context.outlet.isActivated) {
	            this.canDeactivateChecks.push(new CanDeactivate(context.outlet.component, r));
	        }
	        else {
	            this.canDeactivateChecks.push(new CanDeactivate(null, r));
	        }
	    };
	    /**
	     * @return {?}
	     */
	    PreActivation.prototype.runCanDeactivateChecks = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ checks$ = rxjs_observable_from.from(this.canDeactivateChecks);
	        var /** @type {?} */ runningChecks$ = rxjs_operator_mergeMap.mergeMap.call(checks$, function (check) { return _this.runCanDeactivate(check.component, check.route); });
	        return rxjs_operator_every.every.call(runningChecks$, function (result) { return result === true; });
	    };
	    /**
	     * @return {?}
	     */
	    PreActivation.prototype.runCanActivateChecks = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ checks$ = rxjs_observable_from.from(this.canActivateChecks);
	        var /** @type {?} */ runningChecks$ = rxjs_operator_concatMap.concatMap.call(checks$, function (check) {
	            return andObservables(rxjs_observable_from.from([
	                _this.fireChildActivationStart(check.route.parent), _this.fireActivationStart(check.route),
	                _this.runCanActivateChild(check.path), _this.runCanActivate(check.route)
	            ]));
	        });
	        return rxjs_operator_every.every.call(runningChecks$, function (result) { return result === true; });
	        // this.fireChildActivationStart(check.path),
	    };
	    /**
	     * This should fire off `ActivationStart` events for each route being activated at this
	     * level.
	     * In other words, if you're activating `a` and `b` below, `path` will contain the
	     * `ActivatedRouteSnapshot`s for both and we will fire `ActivationStart` for both. Always
	     * return
	     * `true` so checks continue to run.
	     * @param {?} snapshot
	     * @return {?}
	     */
	    PreActivation.prototype.fireActivationStart = /**
	     * This should fire off `ActivationStart` events for each route being activated at this
	     * level.
	     * In other words, if you're activating `a` and `b` below, `path` will contain the
	     * `ActivatedRouteSnapshot`s for both and we will fire `ActivationStart` for both. Always
	     * return
	     * `true` so checks continue to run.
	     * @param {?} snapshot
	     * @return {?}
	     */
	    function (snapshot) {
	        if (snapshot !== null && this.forwardEvent) {
	            this.forwardEvent(new ActivationStart(snapshot));
	        }
	        return rxjs_observable_of.of(true);
	    };
	    /**
	     * This should fire off `ChildActivationStart` events for each route being activated at this
	     * level.
	     * In other words, if you're activating `a` and `b` below, `path` will contain the
	     * `ActivatedRouteSnapshot`s for both and we will fire `ChildActivationStart` for both. Always
	     * return
	     * `true` so checks continue to run.
	     * @param {?} snapshot
	     * @return {?}
	     */
	    PreActivation.prototype.fireChildActivationStart = /**
	     * This should fire off `ChildActivationStart` events for each route being activated at this
	     * level.
	     * In other words, if you're activating `a` and `b` below, `path` will contain the
	     * `ActivatedRouteSnapshot`s for both and we will fire `ChildActivationStart` for both. Always
	     * return
	     * `true` so checks continue to run.
	     * @param {?} snapshot
	     * @return {?}
	     */
	    function (snapshot) {
	        if (snapshot !== null && this.forwardEvent) {
	            this.forwardEvent(new ChildActivationStart(snapshot));
	        }
	        return rxjs_observable_of.of(true);
	    };
	    /**
	     * @param {?} future
	     * @return {?}
	     */
	    PreActivation.prototype.runCanActivate = /**
	     * @param {?} future
	     * @return {?}
	     */
	    function (future) {
	        var _this = this;
	        var /** @type {?} */ canActivate = future.routeConfig ? future.routeConfig.canActivate : null;
	        if (!canActivate || canActivate.length === 0)
	            return rxjs_observable_of.of(true);
	        var /** @type {?} */ obs = rxjs_operator_map.map.call(rxjs_observable_from.from(canActivate), function (c) {
	            var /** @type {?} */ guard = _this.getToken(c, future);
	            var /** @type {?} */ observable;
	            if (guard.canActivate) {
	                observable = wrapIntoObservable(guard.canActivate(future, _this.future));
	            }
	            else {
	                observable = wrapIntoObservable(guard(future, _this.future));
	            }
	            return rxjs_operator_first.first.call(observable);
	        });
	        return andObservables(obs);
	    };
	    /**
	     * @param {?} path
	     * @return {?}
	     */
	    PreActivation.prototype.runCanActivateChild = /**
	     * @param {?} path
	     * @return {?}
	     */
	    function (path) {
	        var _this = this;
	        var /** @type {?} */ future = path[path.length - 1];
	        var /** @type {?} */ canActivateChildGuards = path.slice(0, path.length - 1)
	            .reverse()
	            .map(function (p) { return _this.extractCanActivateChild(p); })
	            .filter(function (_) { return _ !== null; });
	        return andObservables(rxjs_operator_map.map.call(rxjs_observable_from.from(canActivateChildGuards), function (d) {
	            var /** @type {?} */ obs = rxjs_operator_map.map.call(rxjs_observable_from.from(d.guards), function (c) {
	                var /** @type {?} */ guard = _this.getToken(c, d.node);
	                var /** @type {?} */ observable;
	                if (guard.canActivateChild) {
	                    observable = wrapIntoObservable(guard.canActivateChild(future, _this.future));
	                }
	                else {
	                    observable = wrapIntoObservable(guard(future, _this.future));
	                }
	                return rxjs_operator_first.first.call(observable);
	            });
	            return andObservables(obs);
	        }));
	    };
	    /**
	     * @param {?} p
	     * @return {?}
	     */
	    PreActivation.prototype.extractCanActivateChild = /**
	     * @param {?} p
	     * @return {?}
	     */
	    function (p) {
	        var /** @type {?} */ canActivateChild = p.routeConfig ? p.routeConfig.canActivateChild : null;
	        if (!canActivateChild || canActivateChild.length === 0)
	            return null;
	        return { node: p, guards: canActivateChild };
	    };
	    /**
	     * @param {?} component
	     * @param {?} curr
	     * @return {?}
	     */
	    PreActivation.prototype.runCanDeactivate = /**
	     * @param {?} component
	     * @param {?} curr
	     * @return {?}
	     */
	    function (component, curr) {
	        var _this = this;
	        var /** @type {?} */ canDeactivate = curr && curr.routeConfig ? curr.routeConfig.canDeactivate : null;
	        if (!canDeactivate || canDeactivate.length === 0)
	            return rxjs_observable_of.of(true);
	        var /** @type {?} */ canDeactivate$ = rxjs_operator_mergeMap.mergeMap.call(rxjs_observable_from.from(canDeactivate), function (c) {
	            var /** @type {?} */ guard = _this.getToken(c, curr);
	            var /** @type {?} */ observable;
	            if (guard.canDeactivate) {
	                observable =
	                    wrapIntoObservable(guard.canDeactivate(component, curr, _this.curr, _this.future));
	            }
	            else {
	                observable = wrapIntoObservable(guard(component, curr, _this.curr, _this.future));
	            }
	            return rxjs_operator_first.first.call(observable);
	        });
	        return rxjs_operator_every.every.call(canDeactivate$, function (result) { return result === true; });
	    };
	    /**
	     * @param {?} future
	     * @param {?} paramsInheritanceStrategy
	     * @return {?}
	     */
	    PreActivation.prototype.runResolve = /**
	     * @param {?} future
	     * @param {?} paramsInheritanceStrategy
	     * @return {?}
	     */
	    function (future, paramsInheritanceStrategy) {
	        var /** @type {?} */ resolve = future._resolve;
	        return rxjs_operator_map.map.call(this.resolveNode(resolve, future), function (resolvedData) {
	            future._resolvedData = resolvedData;
	            future.data = __assign({}, future.data, inheritedParamsDataResolve(future, paramsInheritanceStrategy).resolve);
	            return null;
	        });
	    };
	    /**
	     * @param {?} resolve
	     * @param {?} future
	     * @return {?}
	     */
	    PreActivation.prototype.resolveNode = /**
	     * @param {?} resolve
	     * @param {?} future
	     * @return {?}
	     */
	    function (resolve, future) {
	        var _this = this;
	        var /** @type {?} */ keys = Object.keys(resolve);
	        if (keys.length === 0) {
	            return rxjs_observable_of.of({});
	        }
	        if (keys.length === 1) {
	            var /** @type {?} */ key_1 = keys[0];
	            return rxjs_operator_map.map.call(this.getResolver(resolve[key_1], future), function (value) {
	                return _a = {}, _a[key_1] = value, _a;
	                var _a;
	            });
	        }
	        var /** @type {?} */ data = {};
	        var /** @type {?} */ runningResolvers$ = rxjs_operator_mergeMap.mergeMap.call(rxjs_observable_from.from(keys), function (key) {
	            return rxjs_operator_map.map.call(_this.getResolver(resolve[key], future), function (value) {
	                data[key] = value;
	                return value;
	            });
	        });
	        return rxjs_operator_map.map.call(rxjs_operator_last.last.call(runningResolvers$), function () { return data; });
	    };
	    /**
	     * @param {?} injectionToken
	     * @param {?} future
	     * @return {?}
	     */
	    PreActivation.prototype.getResolver = /**
	     * @param {?} injectionToken
	     * @param {?} future
	     * @return {?}
	     */
	    function (injectionToken, future) {
	        var /** @type {?} */ resolver = this.getToken(injectionToken, future);
	        return resolver.resolve ? wrapIntoObservable(resolver.resolve(future, this.future)) :
	            wrapIntoObservable(resolver(future, this.future));
	    };
	    /**
	     * @param {?} token
	     * @param {?} snapshot
	     * @return {?}
	     */
	    PreActivation.prototype.getToken = /**
	     * @param {?} token
	     * @param {?} snapshot
	     * @return {?}
	     */
	    function (token, snapshot) {
	        var /** @type {?} */ config = closestLoadedConfig(snapshot);
	        var /** @type {?} */ injector = config ? config.module.injector : this.moduleInjector;
	        return injector.get(token);
	    };
	    return PreActivation;
	}());
	/**
	 * @param {?} snapshot
	 * @return {?}
	 */
	function closestLoadedConfig(snapshot) {
	    if (!snapshot)
	        return null;
	    for (var /** @type {?} */ s = snapshot.parent; s; s = s.parent) {
	        var /** @type {?} */ route = s.routeConfig;
	        if (route && route._loadedConfig)
	            return route._loadedConfig;
	    }
	    return null;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NoMatch$1 = /** @class */ (function () {
	    function NoMatch() {
	    }
	    return NoMatch;
	}());
	/**
	 * @param {?} rootComponentType
	 * @param {?} config
	 * @param {?} urlTree
	 * @param {?} url
	 * @param {?=} paramsInheritanceStrategy
	 * @return {?}
	 */
	function recognize(rootComponentType, config, urlTree, url, paramsInheritanceStrategy) {
	    if (paramsInheritanceStrategy === void 0) { paramsInheritanceStrategy = 'emptyOnly'; }
	    return new Recognizer(rootComponentType, config, urlTree, url, paramsInheritanceStrategy)
	        .recognize();
	}
	var Recognizer = /** @class */ (function () {
	    function Recognizer(rootComponentType, config, urlTree, url, paramsInheritanceStrategy) {
	        this.rootComponentType = rootComponentType;
	        this.config = config;
	        this.urlTree = urlTree;
	        this.url = url;
	        this.paramsInheritanceStrategy = paramsInheritanceStrategy;
	    }
	    /**
	     * @return {?}
	     */
	    Recognizer.prototype.recognize = /**
	     * @return {?}
	     */
	    function () {
	        try {
	            var /** @type {?} */ rootSegmentGroup = split$1(this.urlTree.root, [], [], this.config).segmentGroup;
	            var /** @type {?} */ children = this.processSegmentGroup(this.config, rootSegmentGroup, PRIMARY_OUTLET);
	            var /** @type {?} */ root = new ActivatedRouteSnapshot([], Object.freeze({}), Object.freeze(this.urlTree.queryParams), /** @type {?} */ ((this.urlTree.fragment)), {}, PRIMARY_OUTLET, this.rootComponentType, null, this.urlTree.root, -1, {});
	            var /** @type {?} */ rootNode = new TreeNode(root, children);
	            var /** @type {?} */ routeState = new RouterStateSnapshot(this.url, rootNode);
	            this.inheritParamsAndData(routeState._root);
	            return rxjs_observable_of.of(routeState);
	        }
	        catch (/** @type {?} */ e) {
	            return new rxjs_Observable.Observable(function (obs) { return obs.error(e); });
	        }
	    };
	    /**
	     * @param {?} routeNode
	     * @return {?}
	     */
	    Recognizer.prototype.inheritParamsAndData = /**
	     * @param {?} routeNode
	     * @return {?}
	     */
	    function (routeNode) {
	        var _this = this;
	        var /** @type {?} */ route = routeNode.value;
	        var /** @type {?} */ i = inheritedParamsDataResolve(route, this.paramsInheritanceStrategy);
	        route.params = Object.freeze(i.params);
	        route.data = Object.freeze(i.data);
	        routeNode.children.forEach(function (n) { return _this.inheritParamsAndData(n); });
	    };
	    /**
	     * @param {?} config
	     * @param {?} segmentGroup
	     * @param {?} outlet
	     * @return {?}
	     */
	    Recognizer.prototype.processSegmentGroup = /**
	     * @param {?} config
	     * @param {?} segmentGroup
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (config, segmentGroup, outlet) {
	        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
	            return this.processChildren(config, segmentGroup);
	        }
	        return this.processSegment(config, segmentGroup, segmentGroup.segments, outlet);
	    };
	    /**
	     * @param {?} config
	     * @param {?} segmentGroup
	     * @return {?}
	     */
	    Recognizer.prototype.processChildren = /**
	     * @param {?} config
	     * @param {?} segmentGroup
	     * @return {?}
	     */
	    function (config, segmentGroup) {
	        var _this = this;
	        var /** @type {?} */ children = mapChildrenIntoArray(segmentGroup, function (child, childOutlet) { return _this.processSegmentGroup(config, child, childOutlet); });
	        checkOutletNameUniqueness(children);
	        sortActivatedRouteSnapshots(children);
	        return children;
	    };
	    /**
	     * @param {?} config
	     * @param {?} segmentGroup
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    Recognizer.prototype.processSegment = /**
	     * @param {?} config
	     * @param {?} segmentGroup
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (config, segmentGroup, segments, outlet) {
	        for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
	            var r = config_1[_i];
	            try {
	                return this.processSegmentAgainstRoute(r, segmentGroup, segments, outlet);
	            }
	            catch (/** @type {?} */ e) {
	                if (!(e instanceof NoMatch$1))
	                    throw e;
	            }
	        }
	        if (this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
	            return [];
	        }
	        throw new NoMatch$1();
	    };
	    /**
	     * @param {?} segmentGroup
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    Recognizer.prototype.noLeftoversInUrl = /**
	     * @param {?} segmentGroup
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (segmentGroup, segments, outlet) {
	        return segments.length === 0 && !segmentGroup.children[outlet];
	    };
	    /**
	     * @param {?} route
	     * @param {?} rawSegment
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    Recognizer.prototype.processSegmentAgainstRoute = /**
	     * @param {?} route
	     * @param {?} rawSegment
	     * @param {?} segments
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (route, rawSegment, segments, outlet) {
	        if (route.redirectTo)
	            throw new NoMatch$1();
	        if ((route.outlet || PRIMARY_OUTLET) !== outlet)
	            throw new NoMatch$1();
	        var /** @type {?} */ snapshot;
	        var /** @type {?} */ consumedSegments = [];
	        var /** @type {?} */ rawSlicedSegments = [];
	        if (route.path === '**') {
	            var /** @type {?} */ params = segments.length > 0 ? /** @type {?} */ ((last$1(segments))).parameters : {};
	            snapshot = new ActivatedRouteSnapshot(segments, params, Object.freeze(this.urlTree.queryParams), /** @type {?} */ ((this.urlTree.fragment)), getData(route), outlet, /** @type {?} */ ((route.component)), route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + segments.length, getResolve(route));
	        }
	        else {
	            var /** @type {?} */ result = match$1(rawSegment, route, segments);
	            consumedSegments = result.consumedSegments;
	            rawSlicedSegments = segments.slice(result.lastChild);
	            snapshot = new ActivatedRouteSnapshot(consumedSegments, result.parameters, Object.freeze(this.urlTree.queryParams), /** @type {?} */ ((this.urlTree.fragment)), getData(route), outlet, /** @type {?} */ ((route.component)), route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + consumedSegments.length, getResolve(route));
	        }
	        var /** @type {?} */ childConfig = getChildConfig(route);
	        var _a = split$1(rawSegment, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
	        if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
	            var /** @type {?} */ children_1 = this.processChildren(childConfig, segmentGroup);
	            return [new TreeNode(snapshot, children_1)];
	        }
	        if (childConfig.length === 0 && slicedSegments.length === 0) {
	            return [new TreeNode(snapshot, [])];
	        }
	        var /** @type {?} */ children = this.processSegment(childConfig, segmentGroup, slicedSegments, PRIMARY_OUTLET);
	        return [new TreeNode(snapshot, children)];
	    };
	    return Recognizer;
	}());
	/**
	 * @param {?} nodes
	 * @return {?}
	 */
	function sortActivatedRouteSnapshots(nodes) {
	    nodes.sort(function (a, b) {
	        if (a.value.outlet === PRIMARY_OUTLET)
	            return -1;
	        if (b.value.outlet === PRIMARY_OUTLET)
	            return 1;
	        return a.value.outlet.localeCompare(b.value.outlet);
	    });
	}
	/**
	 * @param {?} route
	 * @return {?}
	 */
	function getChildConfig(route) {
	    if (route.children) {
	        return route.children;
	    }
	    if (route.loadChildren) {
	        return /** @type {?} */ ((route._loadedConfig)).routes;
	    }
	    return [];
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} route
	 * @param {?} segments
	 * @return {?}
	 */
	function match$1(segmentGroup, route, segments) {
	    if (route.path === '') {
	        if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || segments.length > 0)) {
	            throw new NoMatch$1();
	        }
	        return { consumedSegments: [], lastChild: 0, parameters: {} };
	    }
	    var /** @type {?} */ matcher = route.matcher || defaultUrlMatcher;
	    var /** @type {?} */ res = matcher(segments, segmentGroup, route);
	    if (!res)
	        throw new NoMatch$1();
	    var /** @type {?} */ posParams = {};
	    forEach(/** @type {?} */ ((res.posParams)), function (v, k) { posParams[k] = v.path; });
	    var /** @type {?} */ parameters = res.consumed.length > 0 ? __assign({}, posParams, res.consumed[res.consumed.length - 1].parameters) :
	        posParams;
	    return { consumedSegments: res.consumed, lastChild: res.consumed.length, parameters: parameters };
	}
	/**
	 * @param {?} nodes
	 * @return {?}
	 */
	function checkOutletNameUniqueness(nodes) {
	    var /** @type {?} */ names = {};
	    nodes.forEach(function (n) {
	        var /** @type {?} */ routeWithSameOutletName = names[n.value.outlet];
	        if (routeWithSameOutletName) {
	            var /** @type {?} */ p = routeWithSameOutletName.url.map(function (s) { return s.toString(); }).join('/');
	            var /** @type {?} */ c = n.value.url.map(function (s) { return s.toString(); }).join('/');
	            throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
	        }
	        names[n.value.outlet] = n.value;
	    });
	}
	/**
	 * @param {?} segmentGroup
	 * @return {?}
	 */
	function getSourceSegmentGroup(segmentGroup) {
	    var /** @type {?} */ s = segmentGroup;
	    while (s._sourceSegment) {
	        s = s._sourceSegment;
	    }
	    return s;
	}
	/**
	 * @param {?} segmentGroup
	 * @return {?}
	 */
	function getPathIndexShift(segmentGroup) {
	    var /** @type {?} */ s = segmentGroup;
	    var /** @type {?} */ res = (s._segmentIndexShift ? s._segmentIndexShift : 0);
	    while (s._sourceSegment) {
	        s = s._sourceSegment;
	        res += (s._segmentIndexShift ? s._segmentIndexShift : 0);
	    }
	    return res - 1;
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} consumedSegments
	 * @param {?} slicedSegments
	 * @param {?} config
	 * @return {?}
	 */
	function split$1(segmentGroup, consumedSegments, slicedSegments, config) {
	    if (slicedSegments.length > 0 &&
	        containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, config)) {
	        var /** @type {?} */ s_1 = new UrlSegmentGroup(consumedSegments, createChildrenForEmptyPaths(segmentGroup, consumedSegments, config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
	        s_1._sourceSegment = segmentGroup;
	        s_1._segmentIndexShift = consumedSegments.length;
	        return { segmentGroup: s_1, slicedSegments: [] };
	    }
	    if (slicedSegments.length === 0 &&
	        containsEmptyPathMatches(segmentGroup, slicedSegments, config)) {
	        var /** @type {?} */ s_2 = new UrlSegmentGroup(segmentGroup.segments, addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
	        s_2._sourceSegment = segmentGroup;
	        s_2._segmentIndexShift = consumedSegments.length;
	        return { segmentGroup: s_2, slicedSegments: slicedSegments };
	    }
	    var /** @type {?} */ s = new UrlSegmentGroup(segmentGroup.segments, segmentGroup.children);
	    s._sourceSegment = segmentGroup;
	    s._segmentIndexShift = consumedSegments.length;
	    return { segmentGroup: s, slicedSegments: slicedSegments };
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} slicedSegments
	 * @param {?} routes
	 * @param {?} children
	 * @return {?}
	 */
	function addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
	    var /** @type {?} */ res = {};
	    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
	        var r = routes_1[_i];
	        if (emptyPathMatch(segmentGroup, slicedSegments, r) && !children[getOutlet$1(r)]) {
	            var /** @type {?} */ s = new UrlSegmentGroup([], {});
	            s._sourceSegment = segmentGroup;
	            s._segmentIndexShift = segmentGroup.segments.length;
	            res[getOutlet$1(r)] = s;
	        }
	    }
	    return __assign({}, children, res);
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} consumedSegments
	 * @param {?} routes
	 * @param {?} primarySegment
	 * @return {?}
	 */
	function createChildrenForEmptyPaths(segmentGroup, consumedSegments, routes, primarySegment) {
	    var /** @type {?} */ res = {};
	    res[PRIMARY_OUTLET] = primarySegment;
	    primarySegment._sourceSegment = segmentGroup;
	    primarySegment._segmentIndexShift = consumedSegments.length;
	    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
	        var r = routes_2[_i];
	        if (r.path === '' && getOutlet$1(r) !== PRIMARY_OUTLET) {
	            var /** @type {?} */ s = new UrlSegmentGroup([], {});
	            s._sourceSegment = segmentGroup;
	            s._segmentIndexShift = consumedSegments.length;
	            res[getOutlet$1(r)] = s;
	        }
	    }
	    return res;
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} slicedSegments
	 * @param {?} routes
	 * @return {?}
	 */
	function containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, routes) {
	    return routes.some(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r) && getOutlet$1(r) !== PRIMARY_OUTLET; });
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} slicedSegments
	 * @param {?} routes
	 * @return {?}
	 */
	function containsEmptyPathMatches(segmentGroup, slicedSegments, routes) {
	    return routes.some(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r); });
	}
	/**
	 * @param {?} segmentGroup
	 * @param {?} slicedSegments
	 * @param {?} r
	 * @return {?}
	 */
	function emptyPathMatch(segmentGroup, slicedSegments, r) {
	    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full') {
	        return false;
	    }
	    return r.path === '' && r.redirectTo === undefined;
	}
	/**
	 * @param {?} route
	 * @return {?}
	 */
	function getOutlet$1(route) {
	    return route.outlet || PRIMARY_OUTLET;
	}
	/**
	 * @param {?} route
	 * @return {?}
	 */
	function getData(route) {
	    return route.data || {};
	}
	/**
	 * @param {?} route
	 * @return {?}
	 */
	function getResolve(route) {
	    return route.resolve || {};
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Provides a way to customize when activated routes get reused.
	 *
	 * \@experimental
	 * @abstract
	 */
	var RouteReuseStrategy = /** @class */ (function () {
	    function RouteReuseStrategy() {
	    }
	    return RouteReuseStrategy;
	}());
	/**
	 * Does not detach any subtrees. Reuses routes as long as their route config is the same.
	 */
	var DefaultRouteReuseStrategy = /** @class */ (function () {
	    function DefaultRouteReuseStrategy() {
	    }
	    /**
	     * @param {?} route
	     * @return {?}
	     */
	    DefaultRouteReuseStrategy.prototype.shouldDetach = /**
	     * @param {?} route
	     * @return {?}
	     */
	    function (route) { return false; };
	    /**
	     * @param {?} route
	     * @param {?} detachedTree
	     * @return {?}
	     */
	    DefaultRouteReuseStrategy.prototype.store = /**
	     * @param {?} route
	     * @param {?} detachedTree
	     * @return {?}
	     */
	    function (route, detachedTree) { };
	    /**
	     * @param {?} route
	     * @return {?}
	     */
	    DefaultRouteReuseStrategy.prototype.shouldAttach = /**
	     * @param {?} route
	     * @return {?}
	     */
	    function (route) { return false; };
	    /**
	     * @param {?} route
	     * @return {?}
	     */
	    DefaultRouteReuseStrategy.prototype.retrieve = /**
	     * @param {?} route
	     * @return {?}
	     */
	    function (route) { return null; };
	    /**
	     * @param {?} future
	     * @param {?} curr
	     * @return {?}
	     */
	    DefaultRouteReuseStrategy.prototype.shouldReuseRoute = /**
	     * @param {?} future
	     * @param {?} curr
	     * @return {?}
	     */
	    function (future, curr) {
	        return future.routeConfig === curr.routeConfig;
	    };
	    return DefaultRouteReuseStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@docsNotRequired
	 * \@experimental
	 */
	var ROUTES = new _angular_core.InjectionToken('ROUTES');
	var RouterConfigLoader = /** @class */ (function () {
	    function RouterConfigLoader(loader, compiler, onLoadStartListener, onLoadEndListener) {
	        this.loader = loader;
	        this.compiler = compiler;
	        this.onLoadStartListener = onLoadStartListener;
	        this.onLoadEndListener = onLoadEndListener;
	    }
	    /**
	     * @param {?} parentInjector
	     * @param {?} route
	     * @return {?}
	     */
	    RouterConfigLoader.prototype.load = /**
	     * @param {?} parentInjector
	     * @param {?} route
	     * @return {?}
	     */
	    function (parentInjector, route) {
	        var _this = this;
	        if (this.onLoadStartListener) {
	            this.onLoadStartListener(route);
	        }
	        var /** @type {?} */ moduleFactory$ = this.loadModuleFactory(/** @type {?} */ ((route.loadChildren)));
	        return rxjs_operator_map.map.call(moduleFactory$, function (factory) {
	            if (_this.onLoadEndListener) {
	                _this.onLoadEndListener(route);
	            }
	            var /** @type {?} */ module = factory.create(parentInjector);
	            return new LoadedRouterConfig(flatten(module.injector.get(ROUTES)).map(copyConfig), module);
	        });
	    };
	    /**
	     * @param {?} loadChildren
	     * @return {?}
	     */
	    RouterConfigLoader.prototype.loadModuleFactory = /**
	     * @param {?} loadChildren
	     * @return {?}
	     */
	    function (loadChildren) {
	        var _this = this;
	        if (typeof loadChildren === 'string') {
	            return rxjs_observable_fromPromise.fromPromise(this.loader.load(loadChildren));
	        }
	        else {
	            return rxjs_operator_mergeMap.mergeMap.call(wrapIntoObservable(loadChildren()), function (t) {
	                if (t instanceof _angular_core.NgModuleFactory) {
	                    return rxjs_observable_of.of(t);
	                }
	                else {
	                    return rxjs_observable_fromPromise.fromPromise(_this.compiler.compileModuleAsync(t));
	                }
	            });
	        }
	    };
	    return RouterConfigLoader;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Provides a way to migrate AngularJS applications to Angular.
	 *
	 * \@experimental
	 * @abstract
	 */
	var UrlHandlingStrategy = /** @class */ (function () {
	    function UrlHandlingStrategy() {
	    }
	    return UrlHandlingStrategy;
	}());
	/**
	 * \@experimental
	 */
	var DefaultUrlHandlingStrategy = /** @class */ (function () {
	    function DefaultUrlHandlingStrategy() {
	    }
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    DefaultUrlHandlingStrategy.prototype.shouldProcessUrl = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) { return true; };
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    DefaultUrlHandlingStrategy.prototype.extract = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) { return url; };
	    /**
	     * @param {?} newUrlPart
	     * @param {?} wholeUrl
	     * @return {?}
	     */
	    DefaultUrlHandlingStrategy.prototype.merge = /**
	     * @param {?} newUrlPart
	     * @param {?} wholeUrl
	     * @return {?}
	     */
	    function (newUrlPart, wholeUrl) { return newUrlPart; };
	    return DefaultUrlHandlingStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Represents the extra options used during navigation.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * @param {?} error
	 * @return {?}
	 */
	function defaultErrorHandler(error) {
	    throw error;
	}
	/**
	 * \@internal
	 * @param {?} snapshot
	 * @return {?}
	 */
	function defaultRouterHook(snapshot) {
	    return /** @type {?} */ (rxjs_observable_of.of(null));
	}
	/**
	 * \@whatItDoes Provides the navigation and url manipulation capabilities.
	 *
	 * See {\@link Routes} for more details and examples.
	 *
	 * \@ngModule RouterModule
	 *
	 * \@stable
	 */
	var Router = /** @class */ (function () {
	    /**
	     * Creates the router service.
	     */
	    // TODO: vsavkin make internal after the final is out.
	    function Router(rootComponentType, urlSerializer, rootContexts, location, injector, loader, compiler, config) {
	        var _this = this;
	        this.rootComponentType = rootComponentType;
	        this.urlSerializer = urlSerializer;
	        this.rootContexts = rootContexts;
	        this.location = location;
	        this.config = config;
	        this.navigations = new rxjs_BehaviorSubject.BehaviorSubject(/** @type {?} */ ((null)));
	        this.navigationId = 0;
	        this.events = new rxjs_Subject.Subject();
	        /**
	         * Error handler that is invoked when a navigation errors.
	         *
	         * See {\@link ErrorHandler} for more information.
	         */
	        this.errorHandler = defaultErrorHandler;
	        /**
	         * Indicates if at least one navigation happened.
	         */
	        this.navigated = false;
	        /**
	         * Used by RouterModule. This allows us to
	         * pause the navigation either before preactivation or after it.
	         * \@internal
	         */
	        this.hooks = {
	            beforePreactivation: defaultRouterHook,
	            afterPreactivation: defaultRouterHook
	        };
	        /**
	         * Extracts and merges URLs. Used for AngularJS to Angular migrations.
	         */
	        this.urlHandlingStrategy = new DefaultUrlHandlingStrategy();
	        this.routeReuseStrategy = new DefaultRouteReuseStrategy();
	        /**
	         * Define what the router should do if it receives a navigation request to the current URL.
	         * By default, the router will ignore this navigation. However, this prevents features such
	         * as a "refresh" button. Use this option to configure the behavior when navigating to the
	         * current URL. Default is 'ignore'.
	         */
	        this.onSameUrlNavigation = 'ignore';
	        /**
	         * Defines how the router merges params, data and resolved data from parent to child
	         * routes. Available options are:
	         *
	         * - `'emptyOnly'`, the default, only inherits parent params for path-less or component-less
	         *   routes.
	         * - `'always'`, enables unconditional inheritance of parent params.
	         */
	        this.paramsInheritanceStrategy = 'emptyOnly';
	        var /** @type {?} */ onLoadStart = function (r) { return _this.triggerEvent(new RouteConfigLoadStart(r)); };
	        var /** @type {?} */ onLoadEnd = function (r) { return _this.triggerEvent(new RouteConfigLoadEnd(r)); };
	        this.ngModule = injector.get(_angular_core.NgModuleRef);
	        this.resetConfig(config);
	        this.currentUrlTree = createEmptyUrlTree();
	        this.rawUrlTree = this.currentUrlTree;
	        this.configLoader = new RouterConfigLoader(loader, compiler, onLoadStart, onLoadEnd);
	        this.routerState = createEmptyState(this.currentUrlTree, this.rootComponentType);
	        this.processNavigations();
	    }
	    /**
	     * @internal
	     * TODO: this should be removed once the constructor of the router made internal
	     */
	    /**
	     * \@internal
	     * TODO: this should be removed once the constructor of the router made internal
	     * @param {?} rootComponentType
	     * @return {?}
	     */
	    Router.prototype.resetRootComponentType = /**
	     * \@internal
	     * TODO: this should be removed once the constructor of the router made internal
	     * @param {?} rootComponentType
	     * @return {?}
	     */
	    function (rootComponentType) {
	        this.rootComponentType = rootComponentType;
	        // TODO: vsavkin router 4.0 should make the root component set to null
	        // this will simplify the lifecycle of the router.
	        this.routerState.root.component = this.rootComponentType;
	    };
	    /**
	     * Sets up the location change listener and performs the initial navigation.
	     */
	    /**
	     * Sets up the location change listener and performs the initial navigation.
	     * @return {?}
	     */
	    Router.prototype.initialNavigation = /**
	     * Sets up the location change listener and performs the initial navigation.
	     * @return {?}
	     */
	    function () {
	        this.setUpLocationChangeListener();
	        if (this.navigationId === 0) {
	            this.navigateByUrl(this.location.path(true), { replaceUrl: true });
	        }
	    };
	    /**
	     * Sets up the location change listener.
	     */
	    /**
	     * Sets up the location change listener.
	     * @return {?}
	     */
	    Router.prototype.setUpLocationChangeListener = /**
	     * Sets up the location change listener.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Don't need to use Zone.wrap any more, because zone.js
	        // already patch onPopState, so location change callback will
	        // run into ngZone
	        if (!this.locationSubscription) {
	            this.locationSubscription = /** @type {?} */ (this.location.subscribe(function (change) {
	                var /** @type {?} */ rawUrlTree = _this.urlSerializer.parse(change['url']);
	                var /** @type {?} */ source = change['type'] === 'popstate' ? 'popstate' : 'hashchange';
	                setTimeout(function () { _this.scheduleNavigation(rawUrlTree, source, { replaceUrl: true }); }, 0);
	            }));
	        }
	    };
	    Object.defineProperty(Router.prototype, "url", {
	        /** The current url */
	        get: /**
	         * The current url
	         * @return {?}
	         */
	        function () { return this.serializeUrl(this.currentUrlTree); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} e
	     * @return {?}
	     */
	    Router.prototype.triggerEvent = /**
	     * \@internal
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) { (/** @type {?} */ (this.events)).next(e); };
	    /**
	     * Resets the configuration used for navigation and generating links.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.resetConfig([
	     *  { path: 'team/:id', component: TeamCmp, children: [
	     *    { path: 'simple', component: SimpleCmp },
	     *    { path: 'user/:name', component: UserCmp }
	     *  ]}
	     * ]);
	     * ```
	     */
	    /**
	     * Resets the configuration used for navigation and generating links.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.resetConfig([
	     *  { path: 'team/:id', component: TeamCmp, children: [
	     *    { path: 'simple', component: SimpleCmp },
	     *    { path: 'user/:name', component: UserCmp }
	     *  ]}
	     * ]);
	     * ```
	     * @param {?} config
	     * @return {?}
	     */
	    Router.prototype.resetConfig = /**
	     * Resets the configuration used for navigation and generating links.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.resetConfig([
	     *  { path: 'team/:id', component: TeamCmp, children: [
	     *    { path: 'simple', component: SimpleCmp },
	     *    { path: 'user/:name', component: UserCmp }
	     *  ]}
	     * ]);
	     * ```
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        validateConfig(config);
	        this.config = config.map(copyConfig);
	        this.navigated = false;
	    };
	    /** @docsNotRequired */
	    /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    Router.prototype.ngOnDestroy = /**
	     * \@docsNotRequired
	     * @return {?}
	     */
	    function () { this.dispose(); };
	    /** Disposes of the router */
	    /**
	     * Disposes of the router
	     * @return {?}
	     */
	    Router.prototype.dispose = /**
	     * Disposes of the router
	     * @return {?}
	     */
	    function () {
	        if (this.locationSubscription) {
	            this.locationSubscription.unsubscribe();
	            this.locationSubscription = /** @type {?} */ ((null));
	        }
	    };
	    /**
	     * Applies an array of commands to the current url tree and creates a new url tree.
	     *
	     * When given an activate route, applies the given commands starting from the route.
	     * When not given a route, applies the given command starting from the root.
	     *
	     * ### Usage
	     *
	     * ```
	     * // create /team/33/user/11
	     * router.createUrlTree(['/team', 33, 'user', 11]);
	     *
	     * // create /team/33;expand=true/user/11
	     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
	     *
	     * // you can collapse static segments like this (this works only with the first passed-in value):
	     * router.createUrlTree(['/team/33/user', userId]);
	     *
	     * // If the first segment can contain slashes, and you do not want the router to split it, you
	     * // can do the following:
	     *
	     * router.createUrlTree([{segmentPath: '/one/two'}]);
	     *
	     * // create /team/33/(user/11//right:chat)
	     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
	     *
	     * // remove the right secondary node
	     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
	     *
	     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
	     *
	     * // navigate to /team/33/user/11/details
	     * router.createUrlTree(['details'], {relativeTo: route});
	     *
	     * // navigate to /team/33/user/22
	     * router.createUrlTree(['../22'], {relativeTo: route});
	     *
	     * // navigate to /team/44/user/22
	     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
	     * ```
	     */
	    /**
	     * Applies an array of commands to the current url tree and creates a new url tree.
	     *
	     * When given an activate route, applies the given commands starting from the route.
	     * When not given a route, applies the given command starting from the root.
	     *
	     * ### Usage
	     *
	     * ```
	     * // create /team/33/user/11
	     * router.createUrlTree(['/team', 33, 'user', 11]);
	     *
	     * // create /team/33;expand=true/user/11
	     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
	     *
	     * // you can collapse static segments like this (this works only with the first passed-in value):
	     * router.createUrlTree(['/team/33/user', userId]);
	     *
	     * // If the first segment can contain slashes, and you do not want the router to split it, you
	     * // can do the following:
	     *
	     * router.createUrlTree([{segmentPath: '/one/two'}]);
	     *
	     * // create /team/33/(user/11//right:chat)
	     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
	     *
	     * // remove the right secondary node
	     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
	     *
	     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
	     *
	     * // navigate to /team/33/user/11/details
	     * router.createUrlTree(['details'], {relativeTo: route});
	     *
	     * // navigate to /team/33/user/22
	     * router.createUrlTree(['../22'], {relativeTo: route});
	     *
	     * // navigate to /team/44/user/22
	     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
	     * ```
	     * @param {?} commands
	     * @param {?=} navigationExtras
	     * @return {?}
	     */
	    Router.prototype.createUrlTree = /**
	     * Applies an array of commands to the current url tree and creates a new url tree.
	     *
	     * When given an activate route, applies the given commands starting from the route.
	     * When not given a route, applies the given command starting from the root.
	     *
	     * ### Usage
	     *
	     * ```
	     * // create /team/33/user/11
	     * router.createUrlTree(['/team', 33, 'user', 11]);
	     *
	     * // create /team/33;expand=true/user/11
	     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
	     *
	     * // you can collapse static segments like this (this works only with the first passed-in value):
	     * router.createUrlTree(['/team/33/user', userId]);
	     *
	     * // If the first segment can contain slashes, and you do not want the router to split it, you
	     * // can do the following:
	     *
	     * router.createUrlTree([{segmentPath: '/one/two'}]);
	     *
	     * // create /team/33/(user/11//right:chat)
	     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
	     *
	     * // remove the right secondary node
	     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
	     *
	     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
	     *
	     * // navigate to /team/33/user/11/details
	     * router.createUrlTree(['details'], {relativeTo: route});
	     *
	     * // navigate to /team/33/user/22
	     * router.createUrlTree(['../22'], {relativeTo: route});
	     *
	     * // navigate to /team/44/user/22
	     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
	     * ```
	     * @param {?} commands
	     * @param {?=} navigationExtras
	     * @return {?}
	     */
	    function (commands, navigationExtras) {
	        if (navigationExtras === void 0) { navigationExtras = {}; }
	        var relativeTo = navigationExtras.relativeTo, queryParams = navigationExtras.queryParams, fragment = navigationExtras.fragment, preserveQueryParams = navigationExtras.preserveQueryParams, queryParamsHandling = navigationExtras.queryParamsHandling, preserveFragment = navigationExtras.preserveFragment;
	        if (_angular_core.isDevMode() && preserveQueryParams && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	            console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
	        }
	        var /** @type {?} */ a = relativeTo || this.routerState.root;
	        var /** @type {?} */ f = preserveFragment ? this.currentUrlTree.fragment : fragment;
	        var /** @type {?} */ q = null;
	        if (queryParamsHandling) {
	            switch (queryParamsHandling) {
	                case 'merge':
	                    q = __assign({}, this.currentUrlTree.queryParams, queryParams);
	                    break;
	                case 'preserve':
	                    q = this.currentUrlTree.queryParams;
	                    break;
	                default:
	                    q = queryParams || null;
	            }
	        }
	        else {
	            q = preserveQueryParams ? this.currentUrlTree.queryParams : queryParams || null;
	        }
	        if (q !== null) {
	            q = this.removeEmptyProps(q);
	        }
	        return createUrlTree(a, this.currentUrlTree, commands, /** @type {?} */ ((q)), /** @type {?} */ ((f)));
	    };
	    /**
	     * Navigate based on the provided url. This navigation is always absolute.
	     *
	     * Returns a promise that:
	     * - resolves to 'true' when navigation succeeds,
	     * - resolves to 'false' when navigation fails,
	     * - is rejected when an error happens.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigateByUrl("/team/33/user/11");
	     *
	     * // Navigate without updating the URL
	     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
	     * ```
	     *
	     * In opposite to `navigate`, `navigateByUrl` takes a whole URL
	     * and does not apply any delta to the current one.
	     */
	    /**
	     * Navigate based on the provided url. This navigation is always absolute.
	     *
	     * Returns a promise that:
	     * - resolves to 'true' when navigation succeeds,
	     * - resolves to 'false' when navigation fails,
	     * - is rejected when an error happens.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigateByUrl("/team/33/user/11");
	     *
	     * // Navigate without updating the URL
	     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
	     * ```
	     *
	     * In opposite to `navigate`, `navigateByUrl` takes a whole URL
	     * and does not apply any delta to the current one.
	     * @param {?} url
	     * @param {?=} extras
	     * @return {?}
	     */
	    Router.prototype.navigateByUrl = /**
	     * Navigate based on the provided url. This navigation is always absolute.
	     *
	     * Returns a promise that:
	     * - resolves to 'true' when navigation succeeds,
	     * - resolves to 'false' when navigation fails,
	     * - is rejected when an error happens.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigateByUrl("/team/33/user/11");
	     *
	     * // Navigate without updating the URL
	     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
	     * ```
	     *
	     * In opposite to `navigate`, `navigateByUrl` takes a whole URL
	     * and does not apply any delta to the current one.
	     * @param {?} url
	     * @param {?=} extras
	     * @return {?}
	     */
	    function (url, extras) {
	        if (extras === void 0) { extras = { skipLocationChange: false }; }
	        var /** @type {?} */ urlTree = url instanceof UrlTree ? url : this.parseUrl(url);
	        var /** @type {?} */ mergedTree = this.urlHandlingStrategy.merge(urlTree, this.rawUrlTree);
	        return this.scheduleNavigation(mergedTree, 'imperative', extras);
	    };
	    /**
	     * Navigate based on the provided array of commands and a starting point.
	     * If no starting route is provided, the navigation is absolute.
	     *
	     * Returns a promise that:
	     * - resolves to 'true' when navigation succeeds,
	     * - resolves to 'false' when navigation fails,
	     * - is rejected when an error happens.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
	     *
	     * // Navigate without updating the URL
	     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
	     * ```
	     *
	     * In opposite to `navigateByUrl`, `navigate` always takes a delta that is applied to the current
	     * URL.
	     */
	    /**
	     * Navigate based on the provided array of commands and a starting point.
	     * If no starting route is provided, the navigation is absolute.
	     *
	     * Returns a promise that:
	     * - resolves to 'true' when navigation succeeds,
	     * - resolves to 'false' when navigation fails,
	     * - is rejected when an error happens.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
	     *
	     * // Navigate without updating the URL
	     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
	     * ```
	     *
	     * In opposite to `navigateByUrl`, `navigate` always takes a delta that is applied to the current
	     * URL.
	     * @param {?} commands
	     * @param {?=} extras
	     * @return {?}
	     */
	    Router.prototype.navigate = /**
	     * Navigate based on the provided array of commands and a starting point.
	     * If no starting route is provided, the navigation is absolute.
	     *
	     * Returns a promise that:
	     * - resolves to 'true' when navigation succeeds,
	     * - resolves to 'false' when navigation fails,
	     * - is rejected when an error happens.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
	     *
	     * // Navigate without updating the URL
	     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
	     * ```
	     *
	     * In opposite to `navigateByUrl`, `navigate` always takes a delta that is applied to the current
	     * URL.
	     * @param {?} commands
	     * @param {?=} extras
	     * @return {?}
	     */
	    function (commands, extras) {
	        if (extras === void 0) { extras = { skipLocationChange: false }; }
	        validateCommands(commands);
	        return this.navigateByUrl(this.createUrlTree(commands, extras), extras);
	    };
	    /** Serializes a {@link UrlTree} into a string */
	    /**
	     * Serializes a {\@link UrlTree} into a string
	     * @param {?} url
	     * @return {?}
	     */
	    Router.prototype.serializeUrl = /**
	     * Serializes a {\@link UrlTree} into a string
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) { return this.urlSerializer.serialize(url); };
	    /** Parses a string into a {@link UrlTree} */
	    /**
	     * Parses a string into a {\@link UrlTree}
	     * @param {?} url
	     * @return {?}
	     */
	    Router.prototype.parseUrl = /**
	     * Parses a string into a {\@link UrlTree}
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) { return this.urlSerializer.parse(url); };
	    /** Returns whether the url is activated */
	    /**
	     * Returns whether the url is activated
	     * @param {?} url
	     * @param {?} exact
	     * @return {?}
	     */
	    Router.prototype.isActive = /**
	     * Returns whether the url is activated
	     * @param {?} url
	     * @param {?} exact
	     * @return {?}
	     */
	    function (url, exact) {
	        if (url instanceof UrlTree) {
	            return containsTree(this.currentUrlTree, url, exact);
	        }
	        var /** @type {?} */ urlTree = this.urlSerializer.parse(url);
	        return containsTree(this.currentUrlTree, urlTree, exact);
	    };
	    /**
	     * @param {?} params
	     * @return {?}
	     */
	    Router.prototype.removeEmptyProps = /**
	     * @param {?} params
	     * @return {?}
	     */
	    function (params) {
	        return Object.keys(params).reduce(function (result, key) {
	            var /** @type {?} */ value = params[key];
	            if (value !== null && value !== undefined) {
	                result[key] = value;
	            }
	            return result;
	        }, {});
	    };
	    /**
	     * @return {?}
	     */
	    Router.prototype.processNavigations = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        rxjs_operator_concatMap.concatMap
	            .call(this.navigations, function (nav) {
	            if (nav) {
	                _this.executeScheduledNavigation(nav);
	                // a failed navigation should not stop the router from processing
	                // further navigations => the catch
	                return nav.promise.catch(function () { });
	            }
	            else {
	                return /** @type {?} */ (rxjs_observable_of.of(null));
	            }
	        })
	            .subscribe(function () { });
	    };
	    /**
	     * @param {?} rawUrl
	     * @param {?} source
	     * @param {?} extras
	     * @return {?}
	     */
	    Router.prototype.scheduleNavigation = /**
	     * @param {?} rawUrl
	     * @param {?} source
	     * @param {?} extras
	     * @return {?}
	     */
	    function (rawUrl, source, extras) {
	        var /** @type {?} */ lastNavigation = this.navigations.value;
	        // If the user triggers a navigation imperatively (e.g., by using navigateByUrl),
	        // and that navigation results in 'replaceState' that leads to the same URL,
	        // we should skip those.
	        if (lastNavigation && source !== 'imperative' && lastNavigation.source === 'imperative' &&
	            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
	            return Promise.resolve(true); // return value is not used
	        }
	        // Because of a bug in IE and Edge, the location class fires two events (popstate and
	        // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
	        // flicker. Handles the case when a popstate was emitted first.
	        if (lastNavigation && source == 'hashchange' && lastNavigation.source === 'popstate' &&
	            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
	            return Promise.resolve(true); // return value is not used
	        }
	        // Because of a bug in IE and Edge, the location class fires two events (popstate and
	        // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
	        // flicker. Handles the case when a hashchange was emitted first.
	        if (lastNavigation && source == 'popstate' && lastNavigation.source === 'hashchange' &&
	            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
	            return Promise.resolve(true); // return value is not used
	        }
	        var /** @type {?} */ resolve = null;
	        var /** @type {?} */ reject = null;
	        var /** @type {?} */ promise = new Promise(function (res, rej) {
	            resolve = res;
	            reject = rej;
	        });
	        var /** @type {?} */ id = ++this.navigationId;
	        this.navigations.next({ id: id, source: source, rawUrl: rawUrl, extras: extras, resolve: resolve, reject: reject, promise: promise });
	        // Make sure that the error is propagated even though `processNavigations` catch
	        // handler does not rethrow
	        return promise.catch(function (e) { return Promise.reject(e); });
	    };
	    /**
	     * @param {?} __0
	     * @return {?}
	     */
	    Router.prototype.executeScheduledNavigation = /**
	     * @param {?} __0
	     * @return {?}
	     */
	    function (_a) {
	        var _this = this;
	        var id = _a.id, rawUrl = _a.rawUrl, extras = _a.extras, resolve = _a.resolve, reject = _a.reject;
	        var /** @type {?} */ url = this.urlHandlingStrategy.extract(rawUrl);
	        var /** @type {?} */ urlTransition = !this.navigated || url.toString() !== this.currentUrlTree.toString();
	        if ((this.onSameUrlNavigation === 'reload' ? true : urlTransition) &&
	            this.urlHandlingStrategy.shouldProcessUrl(rawUrl)) {
	            (/** @type {?} */ (this.events)).next(new NavigationStart(id, this.serializeUrl(url)));
	            Promise.resolve()
	                .then(function (_) {
	                return _this.runNavigate(url, rawUrl, !!extras.skipLocationChange, !!extras.replaceUrl, id, null);
	            })
	                .then(resolve, reject);
	            // we cannot process the current URL, but we could process the previous one =>
	            // we need to do some cleanup
	        }
	        else if (urlTransition && this.rawUrlTree &&
	            this.urlHandlingStrategy.shouldProcessUrl(this.rawUrlTree)) {
	            (/** @type {?} */ (this.events)).next(new NavigationStart(id, this.serializeUrl(url)));
	            Promise.resolve()
	                .then(function (_) {
	                return _this.runNavigate(url, rawUrl, false, false, id, createEmptyState(url, _this.rootComponentType).snapshot);
	            })
	                .then(resolve, reject);
	        }
	        else {
	            this.rawUrlTree = rawUrl;
	            resolve(null);
	        }
	    };
	    /**
	     * @param {?} url
	     * @param {?} rawUrl
	     * @param {?} skipLocationChange
	     * @param {?} replaceUrl
	     * @param {?} id
	     * @param {?} precreatedState
	     * @return {?}
	     */
	    Router.prototype.runNavigate = /**
	     * @param {?} url
	     * @param {?} rawUrl
	     * @param {?} skipLocationChange
	     * @param {?} replaceUrl
	     * @param {?} id
	     * @param {?} precreatedState
	     * @return {?}
	     */
	    function (url, rawUrl, skipLocationChange, replaceUrl, id, precreatedState) {
	        var _this = this;
	        if (id !== this.navigationId) {
	            (/** @type {?} */ (this.events))
	                .next(new NavigationCancel(id, this.serializeUrl(url), "Navigation ID " + id + " is not equal to the current navigation id " + this.navigationId));
	            return Promise.resolve(false);
	        }
	        return new Promise(function (resolvePromise, rejectPromise) {
	            // create an observable of the url and route state snapshot
	            // this operation do not result in any side effects
	            var /** @type {?} */ urlAndSnapshot$;
	            if (!precreatedState) {
	                var /** @type {?} */ moduleInjector = _this.ngModule.injector;
	                var /** @type {?} */ redirectsApplied$ = applyRedirects(moduleInjector, _this.configLoader, _this.urlSerializer, url, _this.config);
	                urlAndSnapshot$ = rxjs_operator_mergeMap.mergeMap.call(redirectsApplied$, function (appliedUrl) {
	                    return rxjs_operator_map.map.call(recognize(_this.rootComponentType, _this.config, appliedUrl, _this.serializeUrl(appliedUrl), _this.paramsInheritanceStrategy), function (snapshot) {
	                        (/** @type {?} */ (_this.events))
	                            .next(new RoutesRecognized(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), snapshot));
	                        return { appliedUrl: appliedUrl, snapshot: snapshot };
	                    });
	                });
	            }
	            else {
	                urlAndSnapshot$ = rxjs_observable_of.of({ appliedUrl: url, snapshot: precreatedState });
	            }
	            var /** @type {?} */ beforePreactivationDone$ = rxjs_operator_mergeMap.mergeMap.call(urlAndSnapshot$, function (p) {
	                return rxjs_operator_map.map.call(_this.hooks.beforePreactivation(p.snapshot), function () { return p; });
	            });
	            // run preactivation: guards and data resolvers
	            var /** @type {?} */ preActivation;
	            var /** @type {?} */ preactivationSetup$ = rxjs_operator_map.map.call(beforePreactivationDone$, function (_a) {
	                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot;
	                var /** @type {?} */ moduleInjector = _this.ngModule.injector;
	                preActivation = new PreActivation(snapshot, _this.routerState.snapshot, moduleInjector, function (evt) { return _this.triggerEvent(evt); });
	                preActivation.initialize(_this.rootContexts);
	                return { appliedUrl: appliedUrl, snapshot: snapshot };
	            });
	            var /** @type {?} */ preactivationCheckGuards$ = rxjs_operator_mergeMap.mergeMap.call(preactivationSetup$, function (_a) {
	                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot;
	                if (_this.navigationId !== id)
	                    return rxjs_observable_of.of(false);
	                _this.triggerEvent(new GuardsCheckStart(id, _this.serializeUrl(url), appliedUrl, snapshot));
	                return rxjs_operator_map.map.call(preActivation.checkGuards(), function (shouldActivate) {
	                    _this.triggerEvent(new GuardsCheckEnd(id, _this.serializeUrl(url), appliedUrl, snapshot, shouldActivate));
	                    return { appliedUrl: appliedUrl, snapshot: snapshot, shouldActivate: shouldActivate };
	                });
	            });
	            var /** @type {?} */ preactivationResolveData$ = rxjs_operator_mergeMap.mergeMap.call(preactivationCheckGuards$, function (p) {
	                if (_this.navigationId !== id)
	                    return rxjs_observable_of.of(false);
	                if (p.shouldActivate && preActivation.isActivating()) {
	                    _this.triggerEvent(new ResolveStart(id, _this.serializeUrl(url), p.appliedUrl, p.snapshot));
	                    return rxjs_operator_map.map.call(preActivation.resolveData(_this.paramsInheritanceStrategy), function () {
	                        _this.triggerEvent(new ResolveEnd(id, _this.serializeUrl(url), p.appliedUrl, p.snapshot));
	                        return p;
	                    });
	                }
	                else {
	                    return rxjs_observable_of.of(p);
	                }
	            });
	            var /** @type {?} */ preactivationDone$ = rxjs_operator_mergeMap.mergeMap.call(preactivationResolveData$, function (p) {
	                return rxjs_operator_map.map.call(_this.hooks.afterPreactivation(p.snapshot), function () { return p; });
	            });
	            // create router state
	            // this operation has side effects => route state is being affected
	            var /** @type {?} */ routerState$ = rxjs_operator_map.map.call(preactivationDone$, function (_a) {
	                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot, shouldActivate = _a.shouldActivate;
	                if (shouldActivate) {
	                    var /** @type {?} */ state = createRouterState(_this.routeReuseStrategy, snapshot, _this.routerState);
	                    return { appliedUrl: appliedUrl, state: state, shouldActivate: shouldActivate };
	                }
	                else {
	                    return { appliedUrl: appliedUrl, state: null, shouldActivate: shouldActivate };
	                }
	            });
	            _this.activateRoutes(routerState$, _this.routerState, _this.currentUrlTree, id, url, rawUrl, skipLocationChange, replaceUrl, resolvePromise, rejectPromise);
	        });
	    };
	    /**
	     * Performs the logic of activating routes. This is a synchronous process by default. While this
	     * is a private method, it could be overridden to make activation asynchronous.
	     * @param {?} state
	     * @param {?} storedState
	     * @param {?} storedUrl
	     * @param {?} id
	     * @param {?} url
	     * @param {?} rawUrl
	     * @param {?} skipLocationChange
	     * @param {?} replaceUrl
	     * @param {?} resolvePromise
	     * @param {?} rejectPromise
	     * @return {?}
	     */
	    Router.prototype.activateRoutes = /**
	     * Performs the logic of activating routes. This is a synchronous process by default. While this
	     * is a private method, it could be overridden to make activation asynchronous.
	     * @param {?} state
	     * @param {?} storedState
	     * @param {?} storedUrl
	     * @param {?} id
	     * @param {?} url
	     * @param {?} rawUrl
	     * @param {?} skipLocationChange
	     * @param {?} replaceUrl
	     * @param {?} resolvePromise
	     * @param {?} rejectPromise
	     * @return {?}
	     */
	    function (state, storedState, storedUrl, id, url, rawUrl, skipLocationChange, replaceUrl, resolvePromise, rejectPromise) {
	        var _this = this;
	        // applied the new router state
	        // this operation has side effects
	        var /** @type {?} */ navigationIsSuccessful;
	        state
	            .forEach(function (_a) {
	            var appliedUrl = _a.appliedUrl, state = _a.state, shouldActivate = _a.shouldActivate;
	            if (!shouldActivate || id !== _this.navigationId) {
	                navigationIsSuccessful = false;
	                return;
	            }
	            _this.currentUrlTree = appliedUrl;
	            _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, rawUrl);
	            (/** @type {?} */ (_this)).routerState = state;
	            if (!skipLocationChange) {
	                var /** @type {?} */ path = _this.urlSerializer.serialize(_this.rawUrlTree);
	                if (_this.location.isCurrentPathEqualTo(path) || replaceUrl) {
	                    _this.location.replaceState(path);
	                }
	                else {
	                    _this.location.go(path);
	                }
	            }
	            new ActivateRoutes(_this.routeReuseStrategy, state, storedState, function (evt) { return _this.triggerEvent(evt); })
	                .activate(_this.rootContexts);
	            navigationIsSuccessful = true;
	        })
	            .then(function () {
	            if (navigationIsSuccessful) {
	                _this.navigated = true;
	                (/** @type {?} */ (_this.events))
	                    .next(new NavigationEnd(id, _this.serializeUrl(url), _this.serializeUrl(_this.currentUrlTree)));
	                resolvePromise(true);
	            }
	            else {
	                _this.resetUrlToCurrentUrlTree();
	                (/** @type {?} */ (_this.events))
	                    .next(new NavigationCancel(id, _this.serializeUrl(url), ''));
	                resolvePromise(false);
	            }
	        }, function (e) {
	            if (isNavigationCancelingError(e)) {
	                _this.navigated = true;
	                _this.resetStateAndUrl(storedState, storedUrl, rawUrl);
	                (/** @type {?} */ (_this.events))
	                    .next(new NavigationCancel(id, _this.serializeUrl(url), e.message));
	                resolvePromise(false);
	            }
	            else {
	                _this.resetStateAndUrl(storedState, storedUrl, rawUrl);
	                (/** @type {?} */ (_this.events))
	                    .next(new NavigationError(id, _this.serializeUrl(url), e));
	                try {
	                    resolvePromise(_this.errorHandler(e));
	                }
	                catch (/** @type {?} */ ee) {
	                    rejectPromise(ee);
	                }
	            }
	        });
	    };
	    /**
	     * @param {?} storedState
	     * @param {?} storedUrl
	     * @param {?} rawUrl
	     * @return {?}
	     */
	    Router.prototype.resetStateAndUrl = /**
	     * @param {?} storedState
	     * @param {?} storedUrl
	     * @param {?} rawUrl
	     * @return {?}
	     */
	    function (storedState, storedUrl, rawUrl) {
	        (/** @type {?} */ (this)).routerState = storedState;
	        this.currentUrlTree = storedUrl;
	        this.rawUrlTree = this.urlHandlingStrategy.merge(this.currentUrlTree, rawUrl);
	        this.resetUrlToCurrentUrlTree();
	    };
	    /**
	     * @return {?}
	     */
	    Router.prototype.resetUrlToCurrentUrlTree = /**
	     * @return {?}
	     */
	    function () {
	        this.location.replaceState(this.urlSerializer.serialize(this.rawUrlTree));
	    };
	    return Router;
	}());
	var ActivateRoutes = /** @class */ (function () {
	    function ActivateRoutes(routeReuseStrategy, futureState, currState, forwardEvent) {
	        this.routeReuseStrategy = routeReuseStrategy;
	        this.futureState = futureState;
	        this.currState = currState;
	        this.forwardEvent = forwardEvent;
	    }
	    /**
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.activate = /**
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    function (parentContexts) {
	        var /** @type {?} */ futureRoot = this.futureState._root;
	        var /** @type {?} */ currRoot = this.currState ? this.currState._root : null;
	        this.deactivateChildRoutes(futureRoot, currRoot, parentContexts);
	        advanceActivatedRoute(this.futureState.root);
	        this.activateChildRoutes(futureRoot, currRoot, parentContexts);
	    };
	    /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} contexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.deactivateChildRoutes = /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} contexts
	     * @return {?}
	     */
	    function (futureNode, currNode, contexts) {
	        var _this = this;
	        var /** @type {?} */ children = nodeChildrenAsMap(currNode);
	        // Recurse on the routes active in the future state to de-activate deeper children
	        futureNode.children.forEach(function (futureChild) {
	            var /** @type {?} */ childOutletName = futureChild.value.outlet;
	            _this.deactivateRoutes(futureChild, children[childOutletName], contexts);
	            delete children[childOutletName];
	        });
	        // De-activate the routes that will not be re-used
	        forEach(children, function (v, childName) {
	            _this.deactivateRouteAndItsChildren(v, contexts);
	        });
	    };
	    /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} parentContext
	     * @return {?}
	     */
	    ActivateRoutes.prototype.deactivateRoutes = /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} parentContext
	     * @return {?}
	     */
	    function (futureNode, currNode, parentContext) {
	        var /** @type {?} */ future = futureNode.value;
	        var /** @type {?} */ curr = currNode ? currNode.value : null;
	        if (future === curr) {
	            // Reusing the node, check to see if the children need to be de-activated
	            if (future.component) {
	                // If we have a normal route, we need to go through an outlet.
	                var /** @type {?} */ context = parentContext.getContext(future.outlet);
	                if (context) {
	                    this.deactivateChildRoutes(futureNode, currNode, context.children);
	                }
	            }
	            else {
	                // if we have a componentless route, we recurse but keep the same outlet map.
	                this.deactivateChildRoutes(futureNode, currNode, parentContext);
	            }
	        }
	        else {
	            if (curr) {
	                // Deactivate the current route which will not be re-used
	                this.deactivateRouteAndItsChildren(currNode, parentContext);
	            }
	        }
	    };
	    /**
	     * @param {?} route
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.deactivateRouteAndItsChildren = /**
	     * @param {?} route
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    function (route, parentContexts) {
	        if (this.routeReuseStrategy.shouldDetach(route.value.snapshot)) {
	            this.detachAndStoreRouteSubtree(route, parentContexts);
	        }
	        else {
	            this.deactivateRouteAndOutlet(route, parentContexts);
	        }
	    };
	    /**
	     * @param {?} route
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.detachAndStoreRouteSubtree = /**
	     * @param {?} route
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    function (route, parentContexts) {
	        var /** @type {?} */ context = parentContexts.getContext(route.value.outlet);
	        if (context && context.outlet) {
	            var /** @type {?} */ componentRef = context.outlet.detach();
	            var /** @type {?} */ contexts = context.children.onOutletDeactivated();
	            this.routeReuseStrategy.store(route.value.snapshot, { componentRef: componentRef, route: route, contexts: contexts });
	        }
	    };
	    /**
	     * @param {?} route
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.deactivateRouteAndOutlet = /**
	     * @param {?} route
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    function (route, parentContexts) {
	        var _this = this;
	        var /** @type {?} */ context = parentContexts.getContext(route.value.outlet);
	        if (context) {
	            var /** @type {?} */ children = nodeChildrenAsMap(route);
	            var /** @type {?} */ contexts_1 = route.value.component ? context.children : parentContexts;
	            forEach(children, function (v, k) { return _this.deactivateRouteAndItsChildren(v, contexts_1); });
	            if (context.outlet) {
	                // Destroy the component
	                context.outlet.deactivate();
	                // Destroy the contexts for all the outlets that were in the component
	                context.children.onOutletDeactivated();
	            }
	        }
	    };
	    /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} contexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.activateChildRoutes = /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} contexts
	     * @return {?}
	     */
	    function (futureNode, currNode, contexts) {
	        var _this = this;
	        var /** @type {?} */ children = nodeChildrenAsMap(currNode);
	        futureNode.children.forEach(function (c) {
	            _this.activateRoutes(c, children[c.value.outlet], contexts);
	            _this.forwardEvent(new ActivationEnd(c.value.snapshot));
	        });
	        if (futureNode.children.length) {
	            this.forwardEvent(new ChildActivationEnd(futureNode.value.snapshot));
	        }
	    };
	    /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    ActivateRoutes.prototype.activateRoutes = /**
	     * @param {?} futureNode
	     * @param {?} currNode
	     * @param {?} parentContexts
	     * @return {?}
	     */
	    function (futureNode, currNode, parentContexts) {
	        var /** @type {?} */ future = futureNode.value;
	        var /** @type {?} */ curr = currNode ? currNode.value : null;
	        advanceActivatedRoute(future);
	        // reusing the node
	        if (future === curr) {
	            if (future.component) {
	                // If we have a normal route, we need to go through an outlet.
	                var /** @type {?} */ context = parentContexts.getOrCreateContext(future.outlet);
	                this.activateChildRoutes(futureNode, currNode, context.children);
	            }
	            else {
	                // if we have a componentless route, we recurse but keep the same outlet map.
	                this.activateChildRoutes(futureNode, currNode, parentContexts);
	            }
	        }
	        else {
	            if (future.component) {
	                // if we have a normal route, we need to place the component into the outlet and recurse.
	                var /** @type {?} */ context = parentContexts.getOrCreateContext(future.outlet);
	                if (this.routeReuseStrategy.shouldAttach(future.snapshot)) {
	                    var /** @type {?} */ stored = (/** @type {?} */ (this.routeReuseStrategy.retrieve(future.snapshot)));
	                    this.routeReuseStrategy.store(future.snapshot, null);
	                    context.children.onOutletReAttached(stored.contexts);
	                    context.attachRef = stored.componentRef;
	                    context.route = stored.route.value;
	                    if (context.outlet) {
	                        // Attach right away when the outlet has already been instantiated
	                        // Otherwise attach from `RouterOutlet.ngOnInit` when it is instantiated
	                        context.outlet.attach(stored.componentRef, stored.route.value);
	                    }
	                    advanceActivatedRouteNodeAndItsChildren(stored.route);
	                }
	                else {
	                    var /** @type {?} */ config = parentLoadedConfig(future.snapshot);
	                    var /** @type {?} */ cmpFactoryResolver = config ? config.module.componentFactoryResolver : null;
	                    context.route = future;
	                    context.resolver = cmpFactoryResolver;
	                    if (context.outlet) {
	                        // Activate the outlet when it has already been instantiated
	                        // Otherwise it will get activated from its `ngOnInit` when instantiated
	                        context.outlet.activateWith(future, cmpFactoryResolver);
	                    }
	                    this.activateChildRoutes(futureNode, null, context.children);
	                }
	            }
	            else {
	                // if we have a componentless route, we recurse but keep the same outlet map.
	                this.activateChildRoutes(futureNode, null, parentContexts);
	            }
	        }
	    };
	    return ActivateRoutes;
	}());
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function advanceActivatedRouteNodeAndItsChildren(node) {
	    advanceActivatedRoute(node.value);
	    node.children.forEach(advanceActivatedRouteNodeAndItsChildren);
	}
	/**
	 * @param {?} snapshot
	 * @return {?}
	 */
	function parentLoadedConfig(snapshot) {
	    for (var /** @type {?} */ s = snapshot.parent; s; s = s.parent) {
	        var /** @type {?} */ route = s.routeConfig;
	        if (route && route._loadedConfig)
	            return route._loadedConfig;
	        if (route && route.component)
	            return null;
	    }
	    return null;
	}
	/**
	 * @param {?} commands
	 * @return {?}
	 */
	function validateCommands(commands) {
	    for (var /** @type {?} */ i = 0; i < commands.length; i++) {
	        var /** @type {?} */ cmd = commands[i];
	        if (cmd == null) {
	            throw new Error("The requested path contains " + cmd + " segment at index " + i);
	        }
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Lets you link to specific parts of your app.
	 *
	 * \@howToUse
	 *
	 * Consider the following route configuration:
	 * `[{ path: 'user/:name', component: UserCmp }]`
	 *
	 * When linking to this `user/:name` route, you can write:
	 * `<a routerLink='/user/bob'>link to user component</a>`
	 *
	 * \@description
	 *
	 * The RouterLink directives let you link to specific parts of your app.
	 *
	 * When the link is static, you can use the directive as follows:
	 * `<a routerLink="/user/bob">link to user component</a>`
	 *
	 * If you use dynamic values to generate the link, you can pass an array of path
	 * segments, followed by the params for each segment.
	 *
	 * For instance `['/team', teamId, 'user', userName, {details: true}]`
	 * means that we want to generate a link to `/team/11/user/bob;details=true`.
	 *
	 * Multiple static segments can be merged into one
	 * (e.g., `['/team/11/user', userName, {details: true}]`).
	 *
	 * The first segment name can be prepended with `/`, `./`, or `../`:
	 * * If the first segment begins with `/`, the router will look up the route from the root of the
	 *   app.
	 * * If the first segment begins with `./`, or doesn't begin with a slash, the router will
	 *   instead look in the children of the current activated route.
	 * * And if the first segment begins with `../`, the router will go up one level.
	 *
	 * You can set query params and fragment as follows:
	 *
	 * ```
	 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" fragment="education">
	 *   link to user component
	 * </a>
	 * ```
	 * RouterLink will use these to generate this link: `/user/bob#education?debug=true`.
	 *
	 * (Deprecated in v4.0.0 use `queryParamsHandling` instead) You can also tell the
	 * directive to preserve the current query params and fragment:
	 *
	 * ```
	 * <a [routerLink]="['/user/bob']" preserveQueryParams preserveFragment>
	 *   link to user component
	 * </a>
	 * ```
	 *
	 * You can tell the directive to how to handle queryParams, available options are:
	 *  - `'merge'`: merge the queryParams into the current queryParams
	 *  - `'preserve'`: preserve the current queryParams
	 *  - default/`''`: use the queryParams only
	 *
	 * Same options for {\@link NavigationExtras#queryParamsHandling
	 * NavigationExtras#queryParamsHandling}.
	 *
	 * ```
	 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" queryParamsHandling="merge">
	 *   link to user component
	 * </a>
	 * ```
	 *
	 * The router link directive always treats the provided input as a delta to the current url.
	 *
	 * For instance, if the current url is `/user/(box//aux:team)`.
	 *
	 * Then the following link `<a [routerLink]="['/user/jim']">Jim</a>` will generate the link
	 * `/user/(jim//aux:team)`.
	 *
	 * See {\@link Router#createUrlTree createUrlTree} for more information.
	 *
	 * \@ngModule RouterModule
	 *
	 * \@stable
	 */
	var RouterLink = /** @class */ (function () {
	    function RouterLink(router, route, tabIndex, renderer, el) {
	        this.router = router;
	        this.route = route;
	        this.commands = [];
	        if (tabIndex == null) {
	            renderer.setAttribute(el.nativeElement, 'tabindex', '0');
	        }
	    }
	    Object.defineProperty(RouterLink.prototype, "routerLink", {
	        set: /**
	         * @param {?} commands
	         * @return {?}
	         */
	        function (commands) {
	            if (commands != null) {
	                this.commands = Array.isArray(commands) ? commands : [commands];
	            }
	            else {
	                this.commands = [];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterLink.prototype, "preserveQueryParams", {
	        set: /**
	         * @deprecated 4.0.0 use `queryParamsHandling` instead.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (_angular_core.isDevMode() && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	                console.warn('preserveQueryParams is deprecated!, use queryParamsHandling instead.');
	            }
	            this.preserve = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    RouterLink.prototype.onClick = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ extras = {
	            skipLocationChange: attrBoolValue(this.skipLocationChange),
	            replaceUrl: attrBoolValue(this.replaceUrl),
	        };
	        this.router.navigateByUrl(this.urlTree, extras);
	        return true;
	    };
	    Object.defineProperty(RouterLink.prototype, "urlTree", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this.router.createUrlTree(this.commands, {
	                relativeTo: this.route,
	                queryParams: this.queryParams,
	                fragment: this.fragment,
	                preserveQueryParams: attrBoolValue(this.preserve),
	                queryParamsHandling: this.queryParamsHandling,
	                preserveFragment: attrBoolValue(this.preserveFragment),
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouterLink.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: ':not(a)[routerLink]' },] },
	    ];
	    /** @nocollapse */
	    RouterLink.ctorParameters = function () { return [
	        { type: Router, },
	        { type: ActivatedRoute, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    RouterLink.propDecorators = {
	        "queryParams": [{ type: _angular_core.Input },],
	        "fragment": [{ type: _angular_core.Input },],
	        "queryParamsHandling": [{ type: _angular_core.Input },],
	        "preserveFragment": [{ type: _angular_core.Input },],
	        "skipLocationChange": [{ type: _angular_core.Input },],
	        "replaceUrl": [{ type: _angular_core.Input },],
	        "routerLink": [{ type: _angular_core.Input },],
	        "preserveQueryParams": [{ type: _angular_core.Input },],
	        "onClick": [{ type: _angular_core.HostListener, args: ['click',] },],
	    };
	    return RouterLink;
	}());
	/**
	 * \@whatItDoes Lets you link to specific parts of your app.
	 *
	 * See {\@link RouterLink} for more information.
	 *
	 * \@ngModule RouterModule
	 *
	 * \@stable
	 */
	var RouterLinkWithHref = /** @class */ (function () {
	    function RouterLinkWithHref(router, route, locationStrategy) {
	        var _this = this;
	        this.router = router;
	        this.route = route;
	        this.locationStrategy = locationStrategy;
	        this.commands = [];
	        this.subscription = router.events.subscribe(function (s) {
	            if (s instanceof NavigationEnd) {
	                _this.updateTargetUrlAndHref();
	            }
	        });
	    }
	    Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
	        set: /**
	         * @param {?} commands
	         * @return {?}
	         */
	        function (commands) {
	            if (commands != null) {
	                this.commands = Array.isArray(commands) ? commands : [commands];
	            }
	            else {
	                this.commands = [];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterLinkWithHref.prototype, "preserveQueryParams", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (_angular_core.isDevMode() && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	                console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
	            }
	            this.preserve = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    RouterLinkWithHref.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) { this.updateTargetUrlAndHref(); };
	    /**
	     * @return {?}
	     */
	    RouterLinkWithHref.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this.subscription.unsubscribe(); };
	    /**
	     * @param {?} button
	     * @param {?} ctrlKey
	     * @param {?} metaKey
	     * @param {?} shiftKey
	     * @return {?}
	     */
	    RouterLinkWithHref.prototype.onClick = /**
	     * @param {?} button
	     * @param {?} ctrlKey
	     * @param {?} metaKey
	     * @param {?} shiftKey
	     * @return {?}
	     */
	    function (button, ctrlKey, metaKey, shiftKey) {
	        if (button !== 0 || ctrlKey || metaKey || shiftKey) {
	            return true;
	        }
	        if (typeof this.target === 'string' && this.target != '_self') {
	            return true;
	        }
	        var /** @type {?} */ extras = {
	            skipLocationChange: attrBoolValue(this.skipLocationChange),
	            replaceUrl: attrBoolValue(this.replaceUrl),
	        };
	        this.router.navigateByUrl(this.urlTree, extras);
	        return false;
	    };
	    /**
	     * @return {?}
	     */
	    RouterLinkWithHref.prototype.updateTargetUrlAndHref = /**
	     * @return {?}
	     */
	    function () {
	        this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
	    };
	    Object.defineProperty(RouterLinkWithHref.prototype, "urlTree", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this.router.createUrlTree(this.commands, {
	                relativeTo: this.route,
	                queryParams: this.queryParams,
	                fragment: this.fragment,
	                preserveQueryParams: attrBoolValue(this.preserve),
	                queryParamsHandling: this.queryParamsHandling,
	                preserveFragment: attrBoolValue(this.preserveFragment),
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouterLinkWithHref.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: 'a[routerLink]' },] },
	    ];
	    /** @nocollapse */
	    RouterLinkWithHref.ctorParameters = function () { return [
	        { type: Router, },
	        { type: ActivatedRoute, },
	        { type: _angular_common.LocationStrategy, },
	    ]; };
	    RouterLinkWithHref.propDecorators = {
	        "target": [{ type: _angular_core.HostBinding, args: ['attr.target',] }, { type: _angular_core.Input },],
	        "queryParams": [{ type: _angular_core.Input },],
	        "fragment": [{ type: _angular_core.Input },],
	        "queryParamsHandling": [{ type: _angular_core.Input },],
	        "preserveFragment": [{ type: _angular_core.Input },],
	        "skipLocationChange": [{ type: _angular_core.Input },],
	        "replaceUrl": [{ type: _angular_core.Input },],
	        "href": [{ type: _angular_core.HostBinding },],
	        "routerLink": [{ type: _angular_core.Input },],
	        "preserveQueryParams": [{ type: _angular_core.Input },],
	        "onClick": [{ type: _angular_core.HostListener, args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey', '$event.shiftKey'],] },],
	    };
	    return RouterLinkWithHref;
	}());
	/**
	 * @param {?} s
	 * @return {?}
	 */
	function attrBoolValue(s) {
	    return s === '' || !!s;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Lets you add a CSS class to an element when the link's route becomes active.
	 *
	 * \@howToUse
	 *
	 * ```
	 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
	 * ```
	 *
	 * \@description
	 *
	 * The RouterLinkActive directive lets you add a CSS class to an element when the link's route
	 * becomes active.
	 *
	 * Consider the following example:
	 *
	 * ```
	 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
	 * ```
	 *
	 * When the url is either '/user' or '/user/bob', the active-link class will
	 * be added to the `a` tag. If the url changes, the class will be removed.
	 *
	 * You can set more than one class, as follows:
	 *
	 * ```
	 * <a routerLink="/user/bob" routerLinkActive="class1 class2">Bob</a>
	 * <a routerLink="/user/bob" [routerLinkActive]="['class1', 'class2']">Bob</a>
	 * ```
	 *
	 * You can configure RouterLinkActive by passing `exact: true`. This will add the classes
	 * only when the url matches the link exactly.
	 *
	 * ```
	 * <a routerLink="/user/bob" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:
	 * true}">Bob</a>
	 * ```
	 *
	 * You can assign the RouterLinkActive instance to a template variable and directly check
	 * the `isActive` status.
	 * ```
	 * <a routerLink="/user/bob" routerLinkActive #rla="routerLinkActive">
	 *   Bob {{ rla.isActive ? '(already open)' : ''}}
	 * </a>
	 * ```
	 *
	 * Finally, you can apply the RouterLinkActive directive to an ancestor of a RouterLink.
	 *
	 * ```
	 * <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
	 *   <a routerLink="/user/jim">Jim</a>
	 *   <a routerLink="/user/bob">Bob</a>
	 * </div>
	 * ```
	 *
	 * This will set the active-link class on the div tag if the url is either '/user/jim' or
	 * '/user/bob'.
	 *
	 * \@ngModule RouterModule
	 *
	 * \@stable
	 */
	var RouterLinkActive = /** @class */ (function () {
	    function RouterLinkActive(router, element, renderer, cdr) {
	        var _this = this;
	        this.router = router;
	        this.element = element;
	        this.renderer = renderer;
	        this.cdr = cdr;
	        this.classes = [];
	        this.isActive = false;
	        this.routerLinkActiveOptions = { exact: false };
	        this.subscription = router.events.subscribe(function (s) {
	            if (s instanceof NavigationEnd) {
	                _this.update();
	            }
	        });
	    }
	    /**
	     * @return {?}
	     */
	    RouterLinkActive.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.links.changes.subscribe(function (_) { return _this.update(); });
	        this.linksWithHrefs.changes.subscribe(function (_) { return _this.update(); });
	        this.update();
	    };
	    Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
	        set: /**
	         * @param {?} data
	         * @return {?}
	         */
	        function (data) {
	            var /** @type {?} */ classes = Array.isArray(data) ? data : data.split(' ');
	            this.classes = classes.filter(function (c) { return !!c; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    RouterLinkActive.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) { this.update(); };
	    /**
	     * @return {?}
	     */
	    RouterLinkActive.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this.subscription.unsubscribe(); };
	    /**
	     * @return {?}
	     */
	    RouterLinkActive.prototype.update = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this.links || !this.linksWithHrefs || !this.router.navigated)
	            return;
	        Promise.resolve().then(function () {
	            var /** @type {?} */ hasActiveLinks = _this.hasActiveLinks();
	            if (_this.isActive !== hasActiveLinks) {
	                (/** @type {?} */ (_this)).isActive = hasActiveLinks;
	                _this.classes.forEach(function (c) {
	                    if (hasActiveLinks) {
	                        _this.renderer.addClass(_this.element.nativeElement, c);
	                    }
	                    else {
	                        _this.renderer.removeClass(_this.element.nativeElement, c);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @param {?} router
	     * @return {?}
	     */
	    RouterLinkActive.prototype.isLinkActive = /**
	     * @param {?} router
	     * @return {?}
	     */
	    function (router) {
	        var _this = this;
	        return function (link) {
	            return router.isActive(link.urlTree, _this.routerLinkActiveOptions.exact);
	        };
	    };
	    /**
	     * @return {?}
	     */
	    RouterLinkActive.prototype.hasActiveLinks = /**
	     * @return {?}
	     */
	    function () {
	        return this.links.some(this.isLinkActive(this.router)) ||
	            this.linksWithHrefs.some(this.isLinkActive(this.router));
	    };
	    RouterLinkActive.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[routerLinkActive]',
	                    exportAs: 'routerLinkActive',
	                },] },
	    ];
	    /** @nocollapse */
	    RouterLinkActive.ctorParameters = function () { return [
	        { type: Router, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    RouterLinkActive.propDecorators = {
	        "links": [{ type: _angular_core.ContentChildren, args: [RouterLink, { descendants: true },] },],
	        "linksWithHrefs": [{ type: _angular_core.ContentChildren, args: [RouterLinkWithHref, { descendants: true },] },],
	        "routerLinkActiveOptions": [{ type: _angular_core.Input },],
	        "routerLinkActive": [{ type: _angular_core.Input },],
	    };
	    return RouterLinkActive;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Store contextual information about a {\@link RouterOutlet}
	 *
	 * \@stable
	 */
	var OutletContext = /** @class */ (function () {
	    function OutletContext() {
	        this.outlet = null;
	        this.route = null;
	        this.resolver = null;
	        this.children = new ChildrenOutletContexts();
	        this.attachRef = null;
	    }
	    return OutletContext;
	}());
	/**
	 * Store contextual information about the children (= nested) {\@link RouterOutlet}
	 *
	 * \@stable
	 */
	var ChildrenOutletContexts = /** @class */ (function () {
	    function ChildrenOutletContexts() {
	        this.contexts = new Map();
	    }
	    /** Called when a `RouterOutlet` directive is instantiated */
	    /**
	     * Called when a `RouterOutlet` directive is instantiated
	     * @param {?} childName
	     * @param {?} outlet
	     * @return {?}
	     */
	    ChildrenOutletContexts.prototype.onChildOutletCreated = /**
	     * Called when a `RouterOutlet` directive is instantiated
	     * @param {?} childName
	     * @param {?} outlet
	     * @return {?}
	     */
	    function (childName, outlet) {
	        var /** @type {?} */ context = this.getOrCreateContext(childName);
	        context.outlet = outlet;
	        this.contexts.set(childName, context);
	    };
	    /**
	     * Called when a `RouterOutlet` directive is destroyed.
	     * We need to keep the context as the outlet could be destroyed inside a NgIf and might be
	     * re-created later.
	     */
	    /**
	     * Called when a `RouterOutlet` directive is destroyed.
	     * We need to keep the context as the outlet could be destroyed inside a NgIf and might be
	     * re-created later.
	     * @param {?} childName
	     * @return {?}
	     */
	    ChildrenOutletContexts.prototype.onChildOutletDestroyed = /**
	     * Called when a `RouterOutlet` directive is destroyed.
	     * We need to keep the context as the outlet could be destroyed inside a NgIf and might be
	     * re-created later.
	     * @param {?} childName
	     * @return {?}
	     */
	    function (childName) {
	        var /** @type {?} */ context = this.getContext(childName);
	        if (context) {
	            context.outlet = null;
	        }
	    };
	    /**
	     * Called when the corresponding route is deactivated during navigation.
	     * Because the component get destroyed, all children outlet are destroyed.
	     */
	    /**
	     * Called when the corresponding route is deactivated during navigation.
	     * Because the component get destroyed, all children outlet are destroyed.
	     * @return {?}
	     */
	    ChildrenOutletContexts.prototype.onOutletDeactivated = /**
	     * Called when the corresponding route is deactivated during navigation.
	     * Because the component get destroyed, all children outlet are destroyed.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ contexts = this.contexts;
	        this.contexts = new Map();
	        return contexts;
	    };
	    /**
	     * @param {?} contexts
	     * @return {?}
	     */
	    ChildrenOutletContexts.prototype.onOutletReAttached = /**
	     * @param {?} contexts
	     * @return {?}
	     */
	    function (contexts) { this.contexts = contexts; };
	    /**
	     * @param {?} childName
	     * @return {?}
	     */
	    ChildrenOutletContexts.prototype.getOrCreateContext = /**
	     * @param {?} childName
	     * @return {?}
	     */
	    function (childName) {
	        var /** @type {?} */ context = this.getContext(childName);
	        if (!context) {
	            context = new OutletContext();
	            this.contexts.set(childName, context);
	        }
	        return context;
	    };
	    /**
	     * @param {?} childName
	     * @return {?}
	     */
	    ChildrenOutletContexts.prototype.getContext = /**
	     * @param {?} childName
	     * @return {?}
	     */
	    function (childName) { return this.contexts.get(childName) || null; };
	    return ChildrenOutletContexts;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Acts as a placeholder that Angular dynamically fills based on the current router
	 * state.
	 *
	 * \@howToUse
	 *
	 * ```
	 * <router-outlet></router-outlet>
	 * <router-outlet name='left'></router-outlet>
	 * <router-outlet name='right'></router-outlet>
	 * ```
	 *
	 * A router outlet will emit an activate event any time a new component is being instantiated,
	 * and a deactivate event when it is being destroyed.
	 *
	 * ```
	 * <router-outlet
	 *   (activate)='onActivate($event)'
	 *   (deactivate)='onDeactivate($event)'></router-outlet>
	 * ```
	 * \@ngModule RouterModule
	 *
	 * \@stable
	 */
	var RouterOutlet = /** @class */ (function () {
	    function RouterOutlet(parentContexts, location, resolver, name, changeDetector) {
	        this.parentContexts = parentContexts;
	        this.location = location;
	        this.resolver = resolver;
	        this.changeDetector = changeDetector;
	        this.activated = null;
	        this._activatedRoute = null;
	        this.activateEvents = new _angular_core.EventEmitter();
	        this.deactivateEvents = new _angular_core.EventEmitter();
	        this.name = name || PRIMARY_OUTLET;
	        parentContexts.onChildOutletCreated(this.name, this);
	    }
	    /**
	     * @return {?}
	     */
	    RouterOutlet.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this.parentContexts.onChildOutletDestroyed(this.name); };
	    /**
	     * @return {?}
	     */
	    RouterOutlet.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.activated) {
	            // If the outlet was not instantiated at the time the route got activated we need to populate
	            // the outlet when it is initialized (ie inside a NgIf)
	            var /** @type {?} */ context = this.parentContexts.getContext(this.name);
	            if (context && context.route) {
	                if (context.attachRef) {
	                    // `attachRef` is populated when there is an existing component to mount
	                    this.attach(context.attachRef, context.route);
	                }
	                else {
	                    // otherwise the component defined in the configuration is created
	                    this.activateWith(context.route, context.resolver || null);
	                }
	            }
	        }
	    };
	    Object.defineProperty(RouterOutlet.prototype, "isActivated", {
	        get: /**
	         * @return {?}
	         */
	        function () { return !!this.activated; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterOutlet.prototype, "component", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this.activated)
	                throw new Error('Outlet is not activated');
	            return this.activated.instance;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (!this.activated)
	                throw new Error('Outlet is not activated');
	            return /** @type {?} */ (this._activatedRoute);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterOutlet.prototype, "activatedRouteData", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            if (this._activatedRoute) {
	                return this._activatedRoute.snapshot.data;
	            }
	            return {};
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Called when the `RouteReuseStrategy` instructs to detach the subtree
	     */
	    /**
	     * Called when the `RouteReuseStrategy` instructs to detach the subtree
	     * @return {?}
	     */
	    RouterOutlet.prototype.detach = /**
	     * Called when the `RouteReuseStrategy` instructs to detach the subtree
	     * @return {?}
	     */
	    function () {
	        if (!this.activated)
	            throw new Error('Outlet is not activated');
	        this.location.detach();
	        var /** @type {?} */ cmp = this.activated;
	        this.activated = null;
	        this._activatedRoute = null;
	        return cmp;
	    };
	    /**
	     * Called when the `RouteReuseStrategy` instructs to re-attach a previously detached subtree
	     */
	    /**
	     * Called when the `RouteReuseStrategy` instructs to re-attach a previously detached subtree
	     * @param {?} ref
	     * @param {?} activatedRoute
	     * @return {?}
	     */
	    RouterOutlet.prototype.attach = /**
	     * Called when the `RouteReuseStrategy` instructs to re-attach a previously detached subtree
	     * @param {?} ref
	     * @param {?} activatedRoute
	     * @return {?}
	     */
	    function (ref, activatedRoute) {
	        this.activated = ref;
	        this._activatedRoute = activatedRoute;
	        this.location.insert(ref.hostView);
	    };
	    /**
	     * @return {?}
	     */
	    RouterOutlet.prototype.deactivate = /**
	     * @return {?}
	     */
	    function () {
	        if (this.activated) {
	            var /** @type {?} */ c = this.component;
	            this.activated.destroy();
	            this.activated = null;
	            this._activatedRoute = null;
	            this.deactivateEvents.emit(c);
	        }
	    };
	    /**
	     * @param {?} activatedRoute
	     * @param {?} resolver
	     * @return {?}
	     */
	    RouterOutlet.prototype.activateWith = /**
	     * @param {?} activatedRoute
	     * @param {?} resolver
	     * @return {?}
	     */
	    function (activatedRoute, resolver) {
	        if (this.isActivated) {
	            throw new Error('Cannot activate an already activated outlet');
	        }
	        this._activatedRoute = activatedRoute;
	        var /** @type {?} */ snapshot = activatedRoute._futureSnapshot;
	        var /** @type {?} */ component = /** @type {?} */ (/** @type {?} */ ((snapshot.routeConfig)).component);
	        resolver = resolver || this.resolver;
	        var /** @type {?} */ factory = resolver.resolveComponentFactory(component);
	        var /** @type {?} */ childContexts = this.parentContexts.getOrCreateContext(this.name).children;
	        var /** @type {?} */ injector = new OutletInjector(activatedRoute, childContexts, this.location.injector);
	        this.activated = this.location.createComponent(factory, this.location.length, injector);
	        // Calling `markForCheck` to make sure we will run the change detection when the
	        // `RouterOutlet` is inside a `ChangeDetectionStrategy.OnPush` component.
	        this.changeDetector.markForCheck();
	        this.activateEvents.emit(this.activated.instance);
	    };
	    RouterOutlet.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: 'router-outlet', exportAs: 'outlet' },] },
	    ];
	    /** @nocollapse */
	    RouterOutlet.ctorParameters = function () { return [
	        { type: ChildrenOutletContexts, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.ComponentFactoryResolver, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['name',] },] },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    RouterOutlet.propDecorators = {
	        "activateEvents": [{ type: _angular_core.Output, args: ['activate',] },],
	        "deactivateEvents": [{ type: _angular_core.Output, args: ['deactivate',] },],
	    };
	    return RouterOutlet;
	}());
	var OutletInjector = /** @class */ (function () {
	    function OutletInjector(route, childContexts, parent) {
	        this.route = route;
	        this.childContexts = childContexts;
	        this.parent = parent;
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    OutletInjector.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        if (token === ActivatedRoute) {
	            return this.route;
	        }
	        if (token === ChildrenOutletContexts) {
	            return this.childContexts;
	        }
	        return this.parent.get(token, notFoundValue);
	    };
	    return OutletInjector;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	*@license
	*Copyright Google Inc. All Rights Reserved.
	*
	*Use of this source code is governed by an MIT-style license that can be
	*found in the LICENSE file at https://angular.io/license
	*/
	/**
	 * \@whatItDoes Provides a preloading strategy.
	 *
	 * \@experimental
	 * @abstract
	 */
	var PreloadingStrategy = /** @class */ (function () {
	    function PreloadingStrategy() {
	    }
	    return PreloadingStrategy;
	}());
	/**
	 * \@whatItDoes Provides a preloading strategy that preloads all modules as quickly as possible.
	 *
	 * \@howToUse
	 *
	 * ```
	 * RouteModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules})
	 * ```
	 *
	 * \@experimental
	 */
	var PreloadAllModules = /** @class */ (function () {
	    function PreloadAllModules() {
	    }
	    /**
	     * @param {?} route
	     * @param {?} fn
	     * @return {?}
	     */
	    PreloadAllModules.prototype.preload = /**
	     * @param {?} route
	     * @param {?} fn
	     * @return {?}
	     */
	    function (route, fn) {
	        return rxjs_operator_catch._catch.call(fn(), function () { return rxjs_observable_of.of(null); });
	    };
	    return PreloadAllModules;
	}());
	/**
	 * \@whatItDoes Provides a preloading strategy that does not preload any modules.
	 *
	 * \@description
	 *
	 * This strategy is enabled by default.
	 *
	 * \@experimental
	 */
	var NoPreloading = /** @class */ (function () {
	    function NoPreloading() {
	    }
	    /**
	     * @param {?} route
	     * @param {?} fn
	     * @return {?}
	     */
	    NoPreloading.prototype.preload = /**
	     * @param {?} route
	     * @param {?} fn
	     * @return {?}
	     */
	    function (route, fn) { return rxjs_observable_of.of(null); };
	    return NoPreloading;
	}());
	/**
	 * The preloader optimistically loads all router configurations to
	 * make navigations into lazily-loaded sections of the application faster.
	 *
	 * The preloader runs in the background. When the router bootstraps, the preloader
	 * starts listening to all navigation events. After every such event, the preloader
	 * will check if any configurations can be loaded lazily.
	 *
	 * If a route is protected by `canLoad` guards, the preloaded will not load it.
	 *
	 * \@stable
	 */
	var RouterPreloader = /** @class */ (function () {
	    function RouterPreloader(router, moduleLoader, compiler, injector, preloadingStrategy) {
	        this.router = router;
	        this.injector = injector;
	        this.preloadingStrategy = preloadingStrategy;
	        var /** @type {?} */ onStartLoad = function (r) { return router.triggerEvent(new RouteConfigLoadStart(r)); };
	        var /** @type {?} */ onEndLoad = function (r) { return router.triggerEvent(new RouteConfigLoadEnd(r)); };
	        this.loader = new RouterConfigLoader(moduleLoader, compiler, onStartLoad, onEndLoad);
	    }
	    /**
	     * @return {?}
	     */
	    RouterPreloader.prototype.setUpPreloading = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ navigations$ = rxjs_operator_filter.filter.call(this.router.events, function (e) { return e instanceof NavigationEnd; });
	        this.subscription = rxjs_operator_concatMap.concatMap.call(navigations$, function () { return _this.preload(); }).subscribe(function () { });
	    };
	    /**
	     * @return {?}
	     */
	    RouterPreloader.prototype.preload = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ ngModule = this.injector.get(_angular_core.NgModuleRef);
	        return this.processRoutes(ngModule, this.router.config);
	    };
	    // TODO(jasonaden): This class relies on code external to the class to call setUpPreloading. If
	    // this hasn't been done, ngOnDestroy will fail as this.subscription will be undefined. This
	    // should be refactored.
	    /**
	     * @return {?}
	     */
	    RouterPreloader.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this.subscription.unsubscribe(); };
	    /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @return {?}
	     */
	    RouterPreloader.prototype.processRoutes = /**
	     * @param {?} ngModule
	     * @param {?} routes
	     * @return {?}
	     */
	    function (ngModule, routes) {
	        var /** @type {?} */ res = [];
	        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
	            var route = routes_1[_i];
	            // we already have the config loaded, just recurse
	            if (route.loadChildren && !route.canLoad && route._loadedConfig) {
	                var /** @type {?} */ childConfig = route._loadedConfig;
	                res.push(this.processRoutes(childConfig.module, childConfig.routes));
	                // no config loaded, fetch the config
	            }
	            else if (route.loadChildren && !route.canLoad) {
	                res.push(this.preloadConfig(ngModule, route));
	                // recurse into children
	            }
	            else if (route.children) {
	                res.push(this.processRoutes(ngModule, route.children));
	            }
	        }
	        return rxjs_operator_mergeAll.mergeAll.call(rxjs_observable_from.from(res));
	    };
	    /**
	     * @param {?} ngModule
	     * @param {?} route
	     * @return {?}
	     */
	    RouterPreloader.prototype.preloadConfig = /**
	     * @param {?} ngModule
	     * @param {?} route
	     * @return {?}
	     */
	    function (ngModule, route) {
	        var _this = this;
	        return this.preloadingStrategy.preload(route, function () {
	            var /** @type {?} */ loaded$ = _this.loader.load(ngModule.injector, route);
	            return rxjs_operator_mergeMap.mergeMap.call(loaded$, function (config) {
	                route._loadedConfig = config;
	                return _this.processRoutes(config.module, config.routes);
	            });
	        });
	    };
	    RouterPreloader.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    RouterPreloader.ctorParameters = function () { return [
	        { type: Router, },
	        { type: _angular_core.NgModuleFactoryLoader, },
	        { type: _angular_core.Compiler, },
	        { type: _angular_core.Injector, },
	        { type: PreloadingStrategy, },
	    ]; };
	    return RouterPreloader;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Contains a list of directives
	 * \@stable
	 */
	var ROUTER_DIRECTIVES = [RouterOutlet, RouterLink, RouterLinkWithHref, RouterLinkActive];
	/**
	 * \@whatItDoes Is used in DI to configure the router.
	 * \@stable
	 */
	var ROUTER_CONFIGURATION = new _angular_core.InjectionToken('ROUTER_CONFIGURATION');
	/**
	 * \@docsNotRequired
	 */
	var ROUTER_FORROOT_GUARD = new _angular_core.InjectionToken('ROUTER_FORROOT_GUARD');
	var ROUTER_PROVIDERS = [
	    _angular_common.Location,
	    { provide: UrlSerializer, useClass: DefaultUrlSerializer },
	    {
	        provide: Router,
	        useFactory: setupRouter,
	        deps: [
	            _angular_core.ApplicationRef, UrlSerializer, ChildrenOutletContexts, _angular_common.Location, _angular_core.Injector,
	            _angular_core.NgModuleFactoryLoader, _angular_core.Compiler, ROUTES, ROUTER_CONFIGURATION,
	            [UrlHandlingStrategy, new _angular_core.Optional()], [RouteReuseStrategy, new _angular_core.Optional()]
	        ]
	    },
	    ChildrenOutletContexts,
	    { provide: ActivatedRoute, useFactory: rootRoute, deps: [Router] },
	    { provide: _angular_core.NgModuleFactoryLoader, useClass: _angular_core.SystemJsNgModuleLoader },
	    RouterPreloader,
	    NoPreloading,
	    PreloadAllModules,
	    { provide: ROUTER_CONFIGURATION, useValue: { enableTracing: false } },
	];
	/**
	 * @return {?}
	 */
	function routerNgProbeToken() {
	    return new _angular_core.NgProbeToken('Router', Router);
	}
	/**
	 * \@whatItDoes Adds router directives and providers.
	 *
	 * \@howToUse
	 *
	 * RouterModule can be imported multiple times: once per lazily-loaded bundle.
	 * Since the router deals with a global shared resource--location, we cannot have
	 * more than one router service active.
	 *
	 * That is why there are two ways to create the module: `RouterModule.forRoot` and
	 * `RouterModule.forChild`.
	 *
	 * * `forRoot` creates a module that contains all the directives, the given routes, and the router
	 *   service itself.
	 * * `forChild` creates a module that contains all the directives and the given routes, but does not
	 *   include the router service.
	 *
	 * When registered at the root, the module should be used as follows
	 *
	 * ```
	 * \@NgModule({
	 *   imports: [RouterModule.forRoot(ROUTES)]
	 * })
	 * class MyNgModule {}
	 * ```
	 *
	 * For submodules and lazy loaded submodules the module should be used as follows:
	 *
	 * ```
	 * \@NgModule({
	 *   imports: [RouterModule.forChild(ROUTES)]
	 * })
	 * class MyNgModule {}
	 * ```
	 *
	 * \@description
	 *
	 * Managing state transitions is one of the hardest parts of building applications. This is
	 * especially true on the web, where you also need to ensure that the state is reflected in the URL.
	 * In addition, we often want to split applications into multiple bundles and load them on demand.
	 * Doing this transparently is not trivial.
	 *
	 * The Angular router solves these problems. Using the router, you can declaratively specify
	 * application states, manage state transitions while taking care of the URL, and load bundles on
	 * demand.
	 *
	 * [Read this developer guide](https://angular.io/docs/ts/latest/guide/router.html) to get an
	 * overview of how the router should be used.
	 *
	 * \@stable
	 */
	var RouterModule = /** @class */ (function () {
	    // Note: We are injecting the Router so it gets created eagerly...
	    function RouterModule(guard, router) {
	    }
	    /**
	     * Creates a module with all the router providers and directives. It also optionally sets up an
	     * application listener to perform an initial navigation.
	     *
	     * Options (see {@link ExtraOptions}):
	     * * `enableTracing` makes the router log all its internal events to the console.
	     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
	     * API.
	     * * `initialNavigation` disables the initial navigation.
	     * * `errorHandler` provides a custom error handler.
	     * * `preloadingStrategy` configures a preloading strategy (see {@link PreloadAllModules}).
	     * * `onSameUrlNavigation` configures how the router handles navigation to the current URL. See
	     * {@link ExtraOptions} for more details.
	     */
	    /**
	     * Creates a module with all the router providers and directives. It also optionally sets up an
	     * application listener to perform an initial navigation.
	     *
	     * Options (see {\@link ExtraOptions}):
	     * * `enableTracing` makes the router log all its internal events to the console.
	     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
	     * API.
	     * * `initialNavigation` disables the initial navigation.
	     * * `errorHandler` provides a custom error handler.
	     * * `preloadingStrategy` configures a preloading strategy (see {\@link PreloadAllModules}).
	     * * `onSameUrlNavigation` configures how the router handles navigation to the current URL. See
	     * {\@link ExtraOptions} for more details.
	     * @param {?} routes
	     * @param {?=} config
	     * @return {?}
	     */
	    RouterModule.forRoot = /**
	     * Creates a module with all the router providers and directives. It also optionally sets up an
	     * application listener to perform an initial navigation.
	     *
	     * Options (see {\@link ExtraOptions}):
	     * * `enableTracing` makes the router log all its internal events to the console.
	     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
	     * API.
	     * * `initialNavigation` disables the initial navigation.
	     * * `errorHandler` provides a custom error handler.
	     * * `preloadingStrategy` configures a preloading strategy (see {\@link PreloadAllModules}).
	     * * `onSameUrlNavigation` configures how the router handles navigation to the current URL. See
	     * {\@link ExtraOptions} for more details.
	     * @param {?} routes
	     * @param {?=} config
	     * @return {?}
	     */
	    function (routes, config) {
	        return {
	            ngModule: RouterModule,
	            providers: [
	                ROUTER_PROVIDERS,
	                provideRoutes(routes),
	                {
	                    provide: ROUTER_FORROOT_GUARD,
	                    useFactory: provideForRootGuard,
	                    deps: [[Router, new _angular_core.Optional(), new _angular_core.SkipSelf()]]
	                },
	                { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} },
	                {
	                    provide: _angular_common.LocationStrategy,
	                    useFactory: provideLocationStrategy,
	                    deps: [
	                        _angular_common.PlatformLocation, [new _angular_core.Inject(_angular_common.APP_BASE_HREF), new _angular_core.Optional()], ROUTER_CONFIGURATION
	                    ]
	                },
	                {
	                    provide: PreloadingStrategy,
	                    useExisting: config && config.preloadingStrategy ? config.preloadingStrategy :
	                        NoPreloading
	                },
	                { provide: _angular_core.NgProbeToken, multi: true, useFactory: routerNgProbeToken },
	                provideRouterInitializer(),
	            ],
	        };
	    };
	    /**
	     * Creates a module with all the router directives and a provider registering routes.
	     */
	    /**
	     * Creates a module with all the router directives and a provider registering routes.
	     * @param {?} routes
	     * @return {?}
	     */
	    RouterModule.forChild = /**
	     * Creates a module with all the router directives and a provider registering routes.
	     * @param {?} routes
	     * @return {?}
	     */
	    function (routes) {
	        return { ngModule: RouterModule, providers: [provideRoutes(routes)] };
	    };
	    RouterModule.decorators = [
	        { type: _angular_core.NgModule, args: [{ declarations: ROUTER_DIRECTIVES, exports: ROUTER_DIRECTIVES },] },
	    ];
	    /** @nocollapse */
	    RouterModule.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [ROUTER_FORROOT_GUARD,] },] },
	        { type: Router, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    return RouterModule;
	}());
	/**
	 * @param {?} platformLocationStrategy
	 * @param {?} baseHref
	 * @param {?=} options
	 * @return {?}
	 */
	function provideLocationStrategy(platformLocationStrategy, baseHref, options) {
	    if (options === void 0) { options = {}; }
	    return options.useHash ? new _angular_common.HashLocationStrategy(platformLocationStrategy, baseHref) :
	        new _angular_common.PathLocationStrategy(platformLocationStrategy, baseHref);
	}
	/**
	 * @param {?} router
	 * @return {?}
	 */
	function provideForRootGuard(router) {
	    if (router) {
	        throw new Error("RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead.");
	    }
	    return 'guarded';
	}
	/**
	 * \@whatItDoes Registers routes.
	 *
	 * \@howToUse
	 *
	 * ```
	 * \@NgModule({
	 *   imports: [RouterModule.forChild(ROUTES)],
	 *   providers: [provideRoutes(EXTRA_ROUTES)]
	 * })
	 * class MyNgModule {}
	 * ```
	 *
	 * \@stable
	 * @param {?} routes
	 * @return {?}
	 */
	function provideRoutes(routes) {
	    return [
	        { provide: _angular_core.ANALYZE_FOR_ENTRY_COMPONENTS, multi: true, useValue: routes },
	        { provide: ROUTES, multi: true, useValue: routes },
	    ];
	}
	/**
	 * \@whatItDoes Represents options to configure the router.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * @param {?} ref
	 * @param {?} urlSerializer
	 * @param {?} contexts
	 * @param {?} location
	 * @param {?} injector
	 * @param {?} loader
	 * @param {?} compiler
	 * @param {?} config
	 * @param {?=} opts
	 * @param {?=} urlHandlingStrategy
	 * @param {?=} routeReuseStrategy
	 * @return {?}
	 */
	function setupRouter(ref, urlSerializer, contexts, location, injector, loader, compiler, config, opts, urlHandlingStrategy, routeReuseStrategy) {
	    if (opts === void 0) { opts = {}; }
	    var /** @type {?} */ router = new Router(null, urlSerializer, contexts, location, injector, loader, compiler, flatten(config));
	    if (urlHandlingStrategy) {
	        router.urlHandlingStrategy = urlHandlingStrategy;
	    }
	    if (routeReuseStrategy) {
	        router.routeReuseStrategy = routeReuseStrategy;
	    }
	    if (opts.errorHandler) {
	        router.errorHandler = opts.errorHandler;
	    }
	    if (opts.enableTracing) {
	        var /** @type {?} */ dom_1 = _angular_platformBrowser.ɵgetDOM();
	        router.events.subscribe(function (e) {
	            dom_1.logGroup("Router Event: " + ((/** @type {?} */ (e.constructor))).name);
	            dom_1.log(e.toString());
	            dom_1.log(e);
	            dom_1.logGroupEnd();
	        });
	    }
	    if (opts.onSameUrlNavigation) {
	        router.onSameUrlNavigation = opts.onSameUrlNavigation;
	    }
	    if (opts.paramsInheritanceStrategy) {
	        router.paramsInheritanceStrategy = opts.paramsInheritanceStrategy;
	    }
	    return router;
	}
	/**
	 * @param {?} router
	 * @return {?}
	 */
	function rootRoute(router) {
	    return router.routerState.root;
	}
	/**
	 * To initialize the router properly we need to do in two steps:
	 *
	 * We need to start the navigation in a APP_INITIALIZER to block the bootstrap if
	 * a resolver or a guards executes asynchronously. Second, we need to actually run
	 * activation in a BOOTSTRAP_LISTENER. We utilize the afterPreactivation
	 * hook provided by the router to do that.
	 *
	 * The router navigation starts, reaches the point when preactivation is done, and then
	 * pauses. It waits for the hook to be resolved. We then resolve it only in a bootstrap listener.
	 */
	var RouterInitializer = /** @class */ (function () {
	    function RouterInitializer(injector) {
	        this.injector = injector;
	        this.initNavigation = false;
	        this.resultOfPreactivationDone = new rxjs_Subject.Subject();
	    }
	    /**
	     * @return {?}
	     */
	    RouterInitializer.prototype.appInitializer = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ p = this.injector.get(_angular_common.LOCATION_INITIALIZED, Promise.resolve(null));
	        return p.then(function () {
	            var /** @type {?} */ resolve = /** @type {?} */ ((null));
	            var /** @type {?} */ res = new Promise(function (r) { return resolve = r; });
	            var /** @type {?} */ router = _this.injector.get(Router);
	            var /** @type {?} */ opts = _this.injector.get(ROUTER_CONFIGURATION);
	            if (_this.isLegacyDisabled(opts) || _this.isLegacyEnabled(opts)) {
	                resolve(true);
	            }
	            else if (opts.initialNavigation === 'disabled') {
	                router.setUpLocationChangeListener();
	                resolve(true);
	            }
	            else if (opts.initialNavigation === 'enabled') {
	                router.hooks.afterPreactivation = function () {
	                    // only the initial navigation should be delayed
	                    if (!_this.initNavigation) {
	                        _this.initNavigation = true;
	                        resolve(true);
	                        return _this.resultOfPreactivationDone;
	                        // subsequent navigations should not be delayed
	                    }
	                    else {
	                        return /** @type {?} */ (rxjs_observable_of.of(null));
	                    }
	                };
	                router.initialNavigation();
	            }
	            else {
	                throw new Error("Invalid initialNavigation options: '" + opts.initialNavigation + "'");
	            }
	            return res;
	        });
	    };
	    /**
	     * @param {?} bootstrappedComponentRef
	     * @return {?}
	     */
	    RouterInitializer.prototype.bootstrapListener = /**
	     * @param {?} bootstrappedComponentRef
	     * @return {?}
	     */
	    function (bootstrappedComponentRef) {
	        var /** @type {?} */ opts = this.injector.get(ROUTER_CONFIGURATION);
	        var /** @type {?} */ preloader = this.injector.get(RouterPreloader);
	        var /** @type {?} */ router = this.injector.get(Router);
	        var /** @type {?} */ ref = this.injector.get(_angular_core.ApplicationRef);
	        if (bootstrappedComponentRef !== ref.components[0]) {
	            return;
	        }
	        if (this.isLegacyEnabled(opts)) {
	            router.initialNavigation();
	        }
	        else if (this.isLegacyDisabled(opts)) {
	            router.setUpLocationChangeListener();
	        }
	        preloader.setUpPreloading();
	        router.resetRootComponentType(ref.componentTypes[0]);
	        this.resultOfPreactivationDone.next(/** @type {?} */ ((null)));
	        this.resultOfPreactivationDone.complete();
	    };
	    /**
	     * @param {?} opts
	     * @return {?}
	     */
	    RouterInitializer.prototype.isLegacyEnabled = /**
	     * @param {?} opts
	     * @return {?}
	     */
	    function (opts) {
	        return opts.initialNavigation === 'legacy_enabled' || opts.initialNavigation === true ||
	            opts.initialNavigation === undefined;
	    };
	    /**
	     * @param {?} opts
	     * @return {?}
	     */
	    RouterInitializer.prototype.isLegacyDisabled = /**
	     * @param {?} opts
	     * @return {?}
	     */
	    function (opts) {
	        return opts.initialNavigation === 'legacy_disabled' || opts.initialNavigation === false;
	    };
	    RouterInitializer.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    RouterInitializer.ctorParameters = function () { return [
	        { type: _angular_core.Injector, },
	    ]; };
	    return RouterInitializer;
	}());
	/**
	 * @param {?} r
	 * @return {?}
	 */
	function getAppInitializer(r) {
	    return r.appInitializer.bind(r);
	}
	/**
	 * @param {?} r
	 * @return {?}
	 */
	function getBootstrapListener(r) {
	    return r.bootstrapListener.bind(r);
	}
	/**
	 * A token for the router initializer that will be called after the app is bootstrapped.
	 *
	 * \@experimental
	 */
	var ROUTER_INITIALIZER = new _angular_core.InjectionToken('Router Initializer');
	/**
	 * @return {?}
	 */
	function provideRouterInitializer() {
	    return [
	        RouterInitializer,
	        {
	            provide: _angular_core.APP_INITIALIZER,
	            multi: true,
	            useFactory: getAppInitializer,
	            deps: [RouterInitializer]
	        },
	        { provide: ROUTER_INITIALIZER, useFactory: getBootstrapListener, deps: [RouterInitializer] },
	        { provide: _angular_core.APP_BOOTSTRAP_LISTENER, multi: true, useExisting: ROUTER_INITIALIZER },
	    ];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var VERSION = new _angular_core.Version('5.2.11');
	
	exports.RouterLink = RouterLink;
	exports.RouterLinkWithHref = RouterLinkWithHref;
	exports.RouterLinkActive = RouterLinkActive;
	exports.RouterOutlet = RouterOutlet;
	exports.ActivationEnd = ActivationEnd;
	exports.ActivationStart = ActivationStart;
	exports.ChildActivationEnd = ChildActivationEnd;
	exports.ChildActivationStart = ChildActivationStart;
	exports.GuardsCheckEnd = GuardsCheckEnd;
	exports.GuardsCheckStart = GuardsCheckStart;
	exports.NavigationCancel = NavigationCancel;
	exports.NavigationEnd = NavigationEnd;
	exports.NavigationError = NavigationError;
	exports.NavigationStart = NavigationStart;
	exports.ResolveEnd = ResolveEnd;
	exports.ResolveStart = ResolveStart;
	exports.RouteConfigLoadEnd = RouteConfigLoadEnd;
	exports.RouteConfigLoadStart = RouteConfigLoadStart;
	exports.RouterEvent = RouterEvent;
	exports.RoutesRecognized = RoutesRecognized;
	exports.RouteReuseStrategy = RouteReuseStrategy;
	exports.Router = Router;
	exports.ROUTES = ROUTES;
	exports.ROUTER_CONFIGURATION = ROUTER_CONFIGURATION;
	exports.ROUTER_INITIALIZER = ROUTER_INITIALIZER;
	exports.RouterModule = RouterModule;
	exports.provideRoutes = provideRoutes;
	exports.ChildrenOutletContexts = ChildrenOutletContexts;
	exports.OutletContext = OutletContext;
	exports.NoPreloading = NoPreloading;
	exports.PreloadAllModules = PreloadAllModules;
	exports.PreloadingStrategy = PreloadingStrategy;
	exports.RouterPreloader = RouterPreloader;
	exports.ActivatedRoute = ActivatedRoute;
	exports.ActivatedRouteSnapshot = ActivatedRouteSnapshot;
	exports.RouterState = RouterState;
	exports.RouterStateSnapshot = RouterStateSnapshot;
	exports.PRIMARY_OUTLET = PRIMARY_OUTLET;
	exports.convertToParamMap = convertToParamMap;
	exports.UrlHandlingStrategy = UrlHandlingStrategy;
	exports.DefaultUrlSerializer = DefaultUrlSerializer;
	exports.UrlSegment = UrlSegment;
	exports.UrlSegmentGroup = UrlSegmentGroup;
	exports.UrlSerializer = UrlSerializer;
	exports.UrlTree = UrlTree;
	exports.VERSION = VERSION;
	exports.ɵROUTER_PROVIDERS = ROUTER_PROVIDERS;
	exports.ɵflatten = flatten;
	exports.ɵa = ROUTER_FORROOT_GUARD;
	exports.ɵg = RouterInitializer;
	exports.ɵh = getAppInitializer;
	exports.ɵi = getBootstrapListener;
	exports.ɵd = provideForRootGuard;
	exports.ɵc = provideLocationStrategy;
	exports.ɵj = provideRouterInitializer;
	exports.ɵf = rootRoute;
	exports.ɵb = routerNgProbeToken;
	exports.ɵe = setupRouter;
	exports.ɵk = Tree;
	exports.ɵl = TreeNode;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=router.umd.js.map


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var ObjectUnsubscribedError_1 = __webpack_require__(241);
	/**
	 * @class BehaviorSubject<T>
	 */
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        _super.call(this);
	        this._value = _value;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        if (subscription && !subscription.closed) {
	            subscriber.next(this._value);
	        }
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        if (this.hasError) {
	            throw this.thrownError;
	        }
	        else if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return this._value;
	        }
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, this._value = value);
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMap_1 = __webpack_require__(273);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return concatMap_1.concatMap(project, resultSelector)(this);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(228);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return mergeMap_1.mergeMap(project, resultSelector, 1);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(254);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return map_1.map(project, thisArg)(this);
	}
	exports.map = map;
	//# sourceMappingURL=map.js.map

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(228);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
	}
	exports.mergeMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromObservable_1 = __webpack_require__(277);
	exports.from = FromObservable_1.FromObservable.create;
	//# sourceMappingURL=from.js.map

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(212);
	var isArrayLike_1 = __webpack_require__(230);
	var isPromise_1 = __webpack_require__(231);
	var PromiseObservable_1 = __webpack_require__(278);
	var IteratorObservable_1 = __webpack_require__(279);
	var ArrayObservable_1 = __webpack_require__(223);
	var ArrayLikeObservable_1 = __webpack_require__(280);
	var iterator_1 = __webpack_require__(232);
	var Observable_1 = __webpack_require__(206);
	var observeOn_1 = __webpack_require__(281);
	var observable_1 = __webpack_require__(219);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromObservable = (function (_super) {
	    __extends(FromObservable, _super);
	    function FromObservable(ish, scheduler) {
	        _super.call(this, null);
	        this.ish = ish;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable from an Array, an array-like object, a Promise, an
	     * iterable object, or an Observable-like object.
	     *
	     * <span class="informal">Converts almost anything to an Observable.</span>
	     *
	     * <img src="./img/from.png" width="100%">
	     *
	     * Convert various other objects and data types into Observables. `from`
	     * converts a Promise or an array-like or an
	     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	     * object into an Observable that emits the items in that promise or array or
	     * iterable. A String, in this context, is treated as an array of characters.
	     * Observable-like objects (contains a function named with the ES2015 Symbol
	     * for Observable) can also be converted through this operator.
	     *
	     * @example <caption>Converts an array to an Observable</caption>
	     * var array = [10, 20, 30];
	     * var result = Rx.Observable.from(array);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 10 20 30
	     *
	     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
	     * function* generateDoubles(seed) {
	     *   var i = seed;
	     *   while (true) {
	     *     yield i;
	     *     i = 2 * i; // double it
	     *   }
	     * }
	     *
	     * var iterator = generateDoubles(3);
	     * var result = Rx.Observable.from(iterator).take(10);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 3 6 12 24 48 96 192 384 768 1536
	     *
	     * @see {@link create}
	     * @see {@link fromEvent}
	     * @see {@link fromEventPattern}
	     * @see {@link fromPromise}
	     *
	     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
	     * Observable-like, an Array, an iterable or an array-like object to be
	     * converted.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * emissions of values.
	     * @return {Observable<T>} The Observable whose values are originally from the
	     * input object that was converted.
	     * @static true
	     * @name from
	     * @owner Observable
	     */
	    FromObservable.create = function (ish, scheduler) {
	        if (ish != null) {
	            if (typeof ish[observable_1.observable] === 'function') {
	                if (ish instanceof Observable_1.Observable && !scheduler) {
	                    return ish;
	                }
	                return new FromObservable(ish, scheduler);
	            }
	            else if (isArray_1.isArray(ish)) {
	                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
	            }
	            else if (isPromise_1.isPromise(ish)) {
	                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
	            }
	            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
	                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
	            }
	            else if (isArrayLike_1.isArrayLike(ish)) {
	                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
	            }
	        }
	        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
	    };
	    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function (subscriber) {
	        var ish = this.ish;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            return ish[observable_1.observable]().subscribe(subscriber);
	        }
	        else {
	            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
	        }
	    };
	    return FromObservable;
	}(Observable_1.Observable));
	exports.FromObservable = FromObservable;
	//# sourceMappingURL=FromObservable.js.map

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(207);
	var Observable_1 = __webpack_require__(206);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PromiseObservable = (function (_super) {
	    __extends(PromiseObservable, _super);
	    function PromiseObservable(promise, scheduler) {
	        _super.call(this);
	        this.promise = promise;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Converts a Promise to an Observable.
	     *
	     * <span class="informal">Returns an Observable that just emits the Promise's
	     * resolved value, then completes.</span>
	     *
	     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
	     * Observable. If the Promise resolves with a value, the output Observable
	     * emits that resolved value as a `next`, and then completes. If the Promise
	     * is rejected, then the output Observable emits the corresponding Error.
	     *
	     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
	     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     *
	     * @param {PromiseLike<T>} promise The promise to be converted.
	     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
	     * the delivery of the resolved value (or the rejection).
	     * @return {Observable<T>} An Observable which wraps the Promise.
	     * @static true
	     * @name fromPromise
	     * @owner Observable
	     */
	    PromiseObservable.create = function (promise, scheduler) {
	        return new PromiseObservable(promise, scheduler);
	    };
	    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var promise = this.promise;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    subscriber.next(this.value);
	                    subscriber.complete();
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.next(value);
	                        subscriber.complete();
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.error(err);
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	        else {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	    };
	    return PromiseObservable;
	}(Observable_1.Observable));
	exports.PromiseObservable = PromiseObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.next(value);
	        subscriber.complete();
	    }
	}
	function dispatchError(arg) {
	    var err = arg.err, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.error(err);
	    }
	}
	//# sourceMappingURL=PromiseObservable.js.map

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(207);
	var Observable_1 = __webpack_require__(206);
	var iterator_1 = __webpack_require__(232);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IteratorObservable = (function (_super) {
	    __extends(IteratorObservable, _super);
	    function IteratorObservable(iterator, scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	        if (iterator == null) {
	            throw new Error('iterator cannot be null.');
	        }
	        this.iterator = getIterator(iterator);
	    }
	    IteratorObservable.create = function (iterator, scheduler) {
	        return new IteratorObservable(iterator, scheduler);
	    };
	    IteratorObservable.dispatch = function (state) {
	        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
	        if (hasError) {
	            subscriber.error(state.error);
	            return;
	        }
	        var result = iterator.next();
	        if (result.done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(result.value);
	        state.index = index + 1;
	        if (subscriber.closed) {
	            if (typeof iterator.return === 'function') {
	                iterator.return();
	            }
	            return;
	        }
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(IteratorObservable.dispatch, 0, {
	                index: index, iterator: iterator, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                var result = iterator.next();
	                if (result.done) {
	                    subscriber.complete();
	                    break;
	                }
	                else {
	                    subscriber.next(result.value);
	                }
	                if (subscriber.closed) {
	                    if (typeof iterator.return === 'function') {
	                        iterator.return();
	                    }
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return IteratorObservable;
	}(Observable_1.Observable));
	exports.IteratorObservable = IteratorObservable;
	var StringIterator = (function () {
	    function StringIterator(str, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = str.length; }
	        this.str = str;
	        this.idx = idx;
	        this.len = len;
	    }
	    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
	    StringIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.str.charAt(this.idx++)
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return StringIterator;
	}());
	var ArrayIterator = (function () {
	    function ArrayIterator(arr, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = toLength(arr); }
	        this.arr = arr;
	        this.idx = idx;
	        this.len = len;
	    }
	    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
	    ArrayIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.arr[this.idx++]
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return ArrayIterator;
	}());
	function getIterator(obj) {
	    var i = obj[iterator_1.iterator];
	    if (!i && typeof obj === 'string') {
	        return new StringIterator(obj);
	    }
	    if (!i && obj.length !== undefined) {
	        return new ArrayIterator(obj);
	    }
	    if (!i) {
	        throw new TypeError('object is not iterable');
	    }
	    return obj[iterator_1.iterator]();
	}
	var maxSafeInteger = Math.pow(2, 53) - 1;
	function toLength(o) {
	    var len = +o.length;
	    if (isNaN(len)) {
	        return 0;
	    }
	    if (len === 0 || !numberIsFinite(len)) {
	        return len;
	    }
	    len = sign(len) * Math.floor(Math.abs(len));
	    if (len <= 0) {
	        return 0;
	    }
	    if (len > maxSafeInteger) {
	        return maxSafeInteger;
	    }
	    return len;
	}
	function numberIsFinite(value) {
	    return typeof value === 'number' && root_1.root.isFinite(value);
	}
	function sign(value) {
	    var valueAsNumber = +value;
	    if (valueAsNumber === 0) {
	        return valueAsNumber;
	    }
	    if (isNaN(valueAsNumber)) {
	        return valueAsNumber;
	    }
	    return valueAsNumber < 0 ? -1 : 1;
	}
	//# sourceMappingURL=IteratorObservable.js.map

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var ScalarObservable_1 = __webpack_require__(224);
	var EmptyObservable_1 = __webpack_require__(225);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayLikeObservable = (function (_super) {
	    __extends(ArrayLikeObservable, _super);
	    function ArrayLikeObservable(arrayLike, scheduler) {
	        _super.call(this);
	        this.arrayLike = arrayLike;
	        this.scheduler = scheduler;
	        if (!scheduler && arrayLike.length === 1) {
	            this._isScalar = true;
	            this.value = arrayLike[0];
	        }
	    }
	    ArrayLikeObservable.create = function (arrayLike, scheduler) {
	        var length = arrayLike.length;
	        if (length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (length === 1) {
	            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
	        }
	        else {
	            return new ArrayLikeObservable(arrayLike, scheduler);
	        }
	    };
	    ArrayLikeObservable.dispatch = function (state) {
	        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
	        if (subscriber.closed) {
	            return;
	        }
	        if (index >= length) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(arrayLike[index]);
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
	        var length = arrayLike.length;
	        if (scheduler) {
	            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
	                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < length && !subscriber.closed; i++) {
	                subscriber.next(arrayLike[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayLikeObservable;
	}(Observable_1.Observable));
	exports.ArrayLikeObservable = ArrayLikeObservable;
	//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var Notification_1 = __webpack_require__(282);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	exports.observeOn = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	exports.ObserveOnOperator = ObserveOnOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ObserveOnSubscriber = (function (_super) {
	    __extends(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ObserveOnSubscriber = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	exports.ObserveOnMessage = ObserveOnMessage;
	//# sourceMappingURL=observeOn.js.map

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	/**
	 * Represents a push-based event or value that an {@link Observable} can emit.
	 * This class is particularly useful for operators that manage notifications,
	 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
	 * others. Besides wrapping the actual delivered value, it also annotates it
	 * with metadata of, for instance, what type of push message it is (`next`,
	 * `error`, or `complete`).
	 *
	 * @see {@link materialize}
	 * @see {@link dematerialize}
	 * @see {@link observeOn}
	 *
	 * @class Notification<T>
	 */
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    /**
	     * Delivers to the given `observer` the value wrapped by this Notification.
	     * @param {Observer} observer
	     * @return
	     */
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    /**
	     * Given some {@link Observer} callbacks, deliver the value represented by the
	     * current Notification to the correctly corresponding callback.
	     * @param {function(value: T): void} next An Observer `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    /**
	     * Takes an Observer or its individual callback functions, and calls `observe`
	     * or `do` methods accordingly.
	     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
	     * the `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    /**
	     * Returns a simple Observable that just delivers the notification represented
	     * by this Notification instance.
	     * @return {any}
	     */
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return Observable_1.Observable.of(this.value);
	            case 'E':
	                return Observable_1.Observable.throw(this.error);
	            case 'C':
	                return Observable_1.Observable.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `next` from a
	     * given value.
	     * @param {T} value The `next` value.
	     * @return {Notification<T>} The "next" Notification representing the
	     * argument.
	     */
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `error` from a
	     * given error.
	     * @param {any} [err] The `error` error.
	     * @return {Notification<T>} The "error" Notification representing the
	     * argument.
	     */
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `complete`.
	     * @return {Notification<any>} The valueless "complete" Notification.
	     */
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	exports.Notification = Notification;
	//# sourceMappingURL=Notification.js.map

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var catchError_1 = __webpack_require__(284);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 *
	 * <img src="./img/catch.png" width="100%">
	 *
	 * @example <caption>Continues with a different Observable when there's an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n == 4) {
	 * 	     throw 'four!';
	 *     }
	 *	   return n;
	 *   })
	 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, I, II, III, IV, V
	 *
	 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n === 4) {
	 * 	     throw 'four!';
	 *     }
	 * 	   return n;
	 *   })
	 *   .catch((err, caught) => caught)
	 *   .take(30)
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, 1, 2, 3, ...
	 *
	 * @example <caption>Throws a new error when the source Observable throws an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 *     if (n == 4) {
	 *       throw 'four!';
	 *     }
	 *     return n;
	 *   })
	 *   .catch(err => {
	 *     throw 'error in source. Details: ' + err;
	 *   })
	 *   .subscribe(
	 *     x => console.log(x),
	 *     err => console.log(err)
	 *   );
	 *   // 1, 2, 3, error in source. Details: four!
	 *
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} An observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @method catch
	 * @name catch
	 * @owner Observable
	 */
	function _catch(selector) {
	    return catchError_1.catchError(selector)(this);
	}
	exports._catch = _catch;
	//# sourceMappingURL=catch.js.map

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 *
	 * <img src="./img/catch.png" width="100%">
	 *
	 * @example <caption>Continues with a different Observable when there's an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n == 4) {
	 * 	     throw 'four!';
	 *     }
	 *	   return n;
	 *   })
	 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, I, II, III, IV, V
	 *
	 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n === 4) {
	 * 	     throw 'four!';
	 *     }
	 * 	   return n;
	 *   })
	 *   .catch((err, caught) => caught)
	 *   .take(30)
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, 1, 2, 3, ...
	 *
	 * @example <caption>Throws a new error when the source Observable throws an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 *     if (n == 4) {
	 *       throw 'four!';
	 *     }
	 *     return n;
	 *   })
	 *   .catch(err => {
	 *     throw 'error in source. Details: ' + err;
	 *   })
	 *   .subscribe(
	 *     x => console.log(x),
	 *     err => console.log(err)
	 *   );
	 *   // 1, 2, 3, error in source. Details: four!
	 *
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} An observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @name catchError
	 */
	function catchError(selector) {
	    return function catchErrorOperatorFunction(source) {
	        var operator = new CatchOperator(selector);
	        var caught = source.lift(operator);
	        return (operator.caught = caught);
	    };
	}
	exports.catchError = catchError;
	var CatchOperator = (function () {
	    function CatchOperator(selector) {
	        this.selector = selector;
	    }
	    CatchOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
	    };
	    return CatchOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CatchSubscriber = (function (_super) {
	    __extends(CatchSubscriber, _super);
	    function CatchSubscriber(destination, selector, caught) {
	        _super.call(this, destination);
	        this.selector = selector;
	        this.caught = caught;
	    }
	    // NOTE: overriding `error` instead of `_error` because we don't want
	    // to have this flag this subscriber as `isStopped`. We can mimic the
	    // behavior of the RetrySubscriber (from the `retry` operator), where
	    // we unsubscribe from our source chain, reset our Subscriber flags,
	    // then subscribe to the selector result.
	    CatchSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var result = void 0;
	            try {
	                result = this.selector(err, this.caught);
	            }
	            catch (err2) {
	                _super.prototype.error.call(this, err2);
	                return;
	            }
	            this._unsubscribeAndRecycle();
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return CatchSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=catchError.js.map

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatAll_1 = __webpack_require__(286);
	/* tslint:enable:max-line-length */
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return concatAll_1.concatAll()(this);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(227);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var first_1 = __webpack_require__(288);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} An Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return first_1.first(predicate, resultSelector, defaultValue)(this);
	}
	exports.first = first;
	//# sourceMappingURL=first.js.map

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var EmptyError_1 = __webpack_require__(289);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} An Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return function (source) { return source.lift(new FirstOperator(predicate, resultSelector, defaultValue, source)); };
	}
	exports.first = first;
	var FirstOperator = (function () {
	    function FirstOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    FirstOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return FirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FirstSubscriber = (function (_super) {
	    __extends(FirstSubscriber, _super);
	    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.index = 0;
	        this.hasCompleted = false;
	        this._emitted = false;
	    }
	    FirstSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._emit = function (value, index) {
	        if (this.resultSelector) {
	            this._tryResultSelector(value, index);
	            return;
	        }
	        this._emitFinal(value);
	    };
	    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this._emitFinal(result);
	    };
	    FirstSubscriber.prototype._emitFinal = function (value) {
	        var destination = this.destination;
	        if (!this._emitted) {
	            this._emitted = true;
	            destination.next(value);
	            destination.complete();
	            this.hasCompleted = true;
	        }
	    };
	    FirstSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
	            destination.next(this.defaultValue);
	            destination.complete();
	        }
	        else if (!this.hasCompleted) {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return FirstSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=first.js.map

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an Observable or a sequence was queried but has no
	 * elements.
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link single}
	 *
	 * @class EmptyError
	 */
	var EmptyError = (function (_super) {
	    __extends(EmptyError, _super);
	    function EmptyError() {
	        var err = _super.call(this, 'no elements in sequence');
	        this.name = err.name = 'EmptyError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return EmptyError;
	}(Error));
	exports.EmptyError = EmptyError;
	//# sourceMappingURL=EmptyError.js.map

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PromiseObservable_1 = __webpack_require__(278);
	exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var every_1 = __webpack_require__(292);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 *
	 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
	 *  Observable.of(1, 2, 3, 4, 5, 6)
	 *     .every(x => x < 5)
	 *     .subscribe(x => console.log(x)); // -> false
	 *
	 * @param {function} predicate A function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] Optional object to use for `this` in the callback.
	 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return every_1.every(predicate, thisArg)(this);
	}
	exports.every = every;
	//# sourceMappingURL=every.js.map

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 *
	 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
	 *  Observable.of(1, 2, 3, 4, 5, 6)
	 *     .every(x => x < 5)
	 *     .subscribe(x => console.log(x)); // -> false
	 *
	 * @param {function} predicate A function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] Optional object to use for `this` in the callback.
	 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
	}
	exports.every = every;
	var EveryOperator = (function () {
	    function EveryOperator(predicate, thisArg, source) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	    }
	    EveryOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
	    };
	    return EveryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var EverySubscriber = (function (_super) {
	    __extends(EverySubscriber, _super);
	    function EverySubscriber(destination, predicate, thisArg, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	        this.index = 0;
	        this.thisArg = thisArg || this;
	    }
	    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
	        this.destination.next(everyValueMatch);
	        this.destination.complete();
	    };
	    EverySubscriber.prototype._next = function (value) {
	        var result = false;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (!result) {
	            this.notifyComplete(false);
	        }
	    };
	    EverySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return EverySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=every.js.map

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var last_1 = __webpack_require__(294);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - The condition any source emitted item has to satisfy.
	 * @return {Observable} An Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return last_1.last(predicate, resultSelector, defaultValue)(this);
	}
	exports.last = last;
	//# sourceMappingURL=last.js.map

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var EmptyError_1 = __webpack_require__(289);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - The condition any source emitted item has to satisfy.
	 * @return {Observable} An Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return function (source) { return source.lift(new LastOperator(predicate, resultSelector, defaultValue, source)); };
	}
	exports.last = last;
	var LastOperator = (function () {
	    function LastOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    LastOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return LastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var LastSubscriber = (function (_super) {
	    __extends(LastSubscriber, _super);
	    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.hasValue = false;
	        this.index = 0;
	        if (typeof defaultValue !== 'undefined') {
	            this.lastValue = defaultValue;
	            this.hasValue = true;
	        }
	    }
	    LastSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.lastValue = result;
	        this.hasValue = true;
	    };
	    LastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.hasValue) {
	            destination.next(this.lastValue);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return LastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=last.js.map

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(227);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeAll_1.mergeAll(concurrent)(this);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(258);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        return reduce_1.reduce(accumulator, seed)(this);
	    }
	    return reduce_1.reduce(accumulator)(this);
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var filter_1 = __webpack_require__(298);
	/* tslint:enable:max-line-length */
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return filter_1.filter(predicate, thisArg)(this);
	}
	exports.filter = filter;
	//# sourceMappingURL=filter.js.map

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/* tslint:enable:max-line-length */
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return function filterOperatorFunction(source) {
	        return source.lift(new FilterOperator(predicate, thisArg));
	    };
	}
	exports.filter = filter;
	var FilterOperator = (function () {
	    function FilterOperator(predicate, thisArg) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	    }
	    FilterOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
	    };
	    return FilterOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FilterSubscriber = (function (_super) {
	    __extends(FilterSubscriber, _super);
	    function FilterSubscriber(destination, predicate, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.count = 0;
	    }
	    // the try catch block below is left specifically for
	    // optimization and perf reasons. a tryCatcher is not necessary here.
	    FilterSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.destination.next(value);
	        }
	    };
	    return FilterSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=filter.js.map

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ForkJoinObservable_1 = __webpack_require__(324);
	exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var EmptyObservable_1 = __webpack_require__(225);
	var isArray_1 = __webpack_require__(212);
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ForkJoinObservable = (function (_super) {
	    __extends(ForkJoinObservable, _super);
	    function ForkJoinObservable(sources, resultSelector) {
	        _super.call(this);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Joins last values emitted by passed Observables.
	     *
	     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
	     *
	     * <img src="./img/forkJoin.png" width="100%">
	     *
	     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
	     * or directly as arguments. If no input Observables are provided, resulting stream will complete
	     * immediately.
	     *
	     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
	     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
	     * array will have `n` values, where first value is the last thing emitted by the first Observable,
	     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
	     * not emit more than once and it will complete after that. If you need to emit combined values not only
	     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
	     * or {@link zip} instead.
	     *
	     * In order for resulting array to have the same length as the number of input Observables, whenever any of
	     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
	     * and it will not emit anything either, even if it already has some last values from other Observables.
	     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
	     * unless at any point some other Observable completes without emitting value, which brings us back to
	     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
	     * have to emit something at least once and complete.
	     *
	     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
	     * will be immediately unsubscribed.
	     *
	     * Optionally `forkJoin` accepts project function, that will be called with values which normally
	     * would land in emitted array. Whatever is returned by project function, will appear in output
	     * Observable instead. This means that default project can be thought of as a function that takes
	     * all its arguments and puts them into an array. Note that project function will be called only
	     * when output Observable is supposed to emit a result.
	     *
	     * @example <caption>Use forkJoin with operator emitting immediately</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.of(1, 2, 3, 4),
	     *   Rx.Observable.of(5, 6, 7, 8)
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // [4, 8]
	     * // "This is how it ends!"
	     *
	     *
	     * @example <caption>Use forkJoin with operator emitting after some time</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
	     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // [2, 3] after 3 seconds
	     * // "This is how it ends!" immediately after
	     *
	     *
	     * @example <caption>Use forkJoin with project function</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
	     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
	     *   (n, m) => n + m
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // 5 after 3 seconds
	     * // "This is how it ends!" immediately after
	     *
	     * @see {@link combineLatest}
	     * @see {@link zip}
	     *
	     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
	     * passed directly to the operator.
	     * @param {function} [project] Function that takes values emitted by input Observables and returns value
	     * that will appear in resulting Observable instead of default array.
	     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
	     * or value from project function.
	     * @static true
	     * @name forkJoin
	     * @owner Observable
	     */
	    ForkJoinObservable.create = function () {
	        var sources = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            sources[_i - 0] = arguments[_i];
	        }
	        if (sources === null || arguments.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        var resultSelector = null;
	        if (typeof sources[sources.length - 1] === 'function') {
	            resultSelector = sources.pop();
	        }
	        // if the first and only other argument besides the resultSelector is an array
	        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
	        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
	            sources = sources[0];
	        }
	        if (sources.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        return new ForkJoinObservable(sources, resultSelector);
	    };
	    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function (subscriber) {
	        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
	    };
	    return ForkJoinObservable;
	}(Observable_1.Observable));
	exports.ForkJoinObservable = ForkJoinObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ForkJoinSubscriber = (function (_super) {
	    __extends(ForkJoinSubscriber, _super);
	    function ForkJoinSubscriber(destination, sources, resultSelector) {
	        _super.call(this, destination);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	        this.completed = 0;
	        this.haveValues = 0;
	        var len = sources.length;
	        this.total = len;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            var source = sources[i];
	            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
	            if (innerSubscription) {
	                innerSubscription.outerIndex = i;
	                this.add(innerSubscription);
	            }
	        }
	    }
	    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        if (!innerSub._hasValue) {
	            innerSub._hasValue = true;
	            this.haveValues++;
	        }
	    };
	    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
	        var destination = this.destination;
	        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
	        var len = values.length;
	        if (!innerSub._hasValue) {
	            destination.complete();
	            return;
	        }
	        this.completed++;
	        if (this.completed !== len) {
	            return;
	        }
	        if (haveValues === len) {
	            var value = resultSelector ? resultSelector.apply(this, values) : values;
	            destination.next(value);
	        }
	        destination.complete();
	    };
	    return ForkJoinSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=ForkJoinObservable.js.map

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var map_1 = __webpack_require__(274);
	Observable_1.Observable.prototype.map = map_1.map;
	//# sourceMappingURL=map.js.map

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var mergeMap_1 = __webpack_require__(275);
	Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
	Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(323), __webpack_require__(290), __webpack_require__(274), __webpack_require__(247)) :
		typeof define === 'function' && define.amd ? define('@angular/forms', ['exports', '@angular/core', 'rxjs/observable/forkJoin', 'rxjs/observable/fromPromise', 'rxjs/operator/map', '@angular/platform-browser'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.forms = {}),global.ng.core,global.Rx.Observable,global.Rx.Observable,global.Rx.Observable.prototype,global.ng.platformBrowser));
	}(this, (function (exports,_angular_core,rxjs_observable_forkJoin,rxjs_observable_fromPromise,rxjs_operator_map,_angular_platformBrowser) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Base class for control directives.
	 *
	 * Only used internally in the forms module.
	 *
	 * \@stable
	 * @abstract
	 */
	var AbstractControlDirective = /** @class */ (function () {
	    function AbstractControlDirective() {
	    }
	    Object.defineProperty(AbstractControlDirective.prototype, "value", {
	        /** The value of the control. */
	        get: /**
	         * The value of the control.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.value : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	        /**
	         * A control is `valid` when its `status === VALID`.
	         *
	         * In order to have this status, the control must have passed all its
	         * validation checks.
	         */
	        get: /**
	         * A control is `valid` when its `status === VALID`.
	         *
	         * In order to have this status, the control must have passed all its
	         * validation checks.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.valid : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
	        /**
	         * A control is `invalid` when its `status === INVALID`.
	         *
	         * In order to have this status, the control must have failed
	         * at least one of its validation checks.
	         */
	        get: /**
	         * A control is `invalid` when its `status === INVALID`.
	         *
	         * In order to have this status, the control must have failed
	         * at least one of its validation checks.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.invalid : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
	        /**
	         * A control is `pending` when its `status === PENDING`.
	         *
	         * In order to have this status, the control must be in the
	         * middle of conducting a validation check.
	         */
	        get: /**
	         * A control is `pending` when its `status === PENDING`.
	         *
	         * In order to have this status, the control must be in the
	         * middle of conducting a validation check.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.pending : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
	        /**
	         * A control is `disabled` when its `status === DISABLED`.
	         *
	         * Disabled controls are exempt from validation checks and
	         * are not included in the aggregate value of their ancestor
	         * controls.
	         */
	        get: /**
	         * A control is `disabled` when its `status === DISABLED`.
	         *
	         * Disabled controls are exempt from validation checks and
	         * are not included in the aggregate value of their ancestor
	         * controls.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.disabled : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
	        /**
	         * A control is `enabled` as long as its `status !== DISABLED`.
	         *
	         * In other words, it has a status of `VALID`, `INVALID`, or
	         * `PENDING`.
	         */
	        get: /**
	         * A control is `enabled` as long as its `status !== DISABLED`.
	         *
	         * In other words, it has a status of `VALID`, `INVALID`, or
	         * `PENDING`.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.enabled : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	        /**
	         * Returns any errors generated by failing validation. If there
	         * are no errors, it will return null.
	         */
	        get: /**
	         * Returns any errors generated by failing validation. If there
	         * are no errors, it will return null.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.errors : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	        /**
	         * A control is `pristine` if the user has not yet changed
	         * the value in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         */
	        get: /**
	         * A control is `pristine` if the user has not yet changed
	         * the value in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.pristine : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	        /**
	         * A control is `dirty` if the user has changed the value
	         * in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         */
	        get: /**
	         * A control is `dirty` if the user has changed the value
	         * in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.dirty : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	        /**
	         * A control is marked `touched` once the user has triggered
	         * a `blur` event on it.
	         */
	        get: /**
	         * A control is marked `touched` once the user has triggered
	         * a `blur` event on it.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.touched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "status", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.control ? this.control.status : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	        /**
	         * A control is `untouched` if the user has not yet triggered
	         * a `blur` event on it.
	         */
	        get: /**
	         * A control is `untouched` if the user has not yet triggered
	         * a `blur` event on it.
	         * @return {?}
	         */
	        function () { return this.control ? this.control.untouched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	        /**
	         * Emits an event every time the validation status of the control
	         * is re-calculated.
	         */
	        get: /**
	         * Emits an event every time the validation status of the control
	         * is re-calculated.
	         * @return {?}
	         */
	        function () {
	            return this.control ? this.control.statusChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	        /**
	         * Emits an event every time the value of the control changes, in
	         * the UI or programmatically.
	         */
	        get: /**
	         * Emits an event every time the value of the control changes, in
	         * the UI or programmatically.
	         * @return {?}
	         */
	        function () {
	            return this.control ? this.control.valueChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "path", {
	        /**
	         * Returns an array that represents the path from the top-level form
	         * to this control. Each index is the string name of the control on
	         * that level.
	         */
	        get: /**
	         * Returns an array that represents the path from the top-level form
	         * to this control. Each index is the string name of the control on
	         * that level.
	         * @return {?}
	         */
	        function () { return null; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Resets the form control. This means by default:
	     *
	     * * it is marked as `pristine`
	     * * it is marked as `untouched`
	     * * value is set to null
	     *
	     * For more information, see {@link AbstractControl}.
	     */
	    /**
	     * Resets the form control. This means by default:
	     *
	     * * it is marked as `pristine`
	     * * it is marked as `untouched`
	     * * value is set to null
	     *
	     * For more information, see {\@link AbstractControl}.
	     * @param {?=} value
	     * @return {?}
	     */
	    AbstractControlDirective.prototype.reset = /**
	     * Resets the form control. This means by default:
	     *
	     * * it is marked as `pristine`
	     * * it is marked as `untouched`
	     * * value is set to null
	     *
	     * For more information, see {\@link AbstractControl}.
	     * @param {?=} value
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = undefined; }
	        if (this.control)
	            this.control.reset(value);
	    };
	    /**
	     * Returns true if the control with the given path has the error specified. Otherwise
	     * returns false.
	     *
	     * If no path is given, it checks for the error on the present control.
	     */
	    /**
	     * Returns true if the control with the given path has the error specified. Otherwise
	     * returns false.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    AbstractControlDirective.prototype.hasError = /**
	     * Returns true if the control with the given path has the error specified. Otherwise
	     * returns false.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    function (errorCode, path) {
	        return this.control ? this.control.hasError(errorCode, path) : false;
	    };
	    /**
	     * Returns error data if the control with the given path has the error specified. Otherwise
	     * returns null or undefined.
	     *
	     * If no path is given, it checks for the error on the present control.
	     */
	    /**
	     * Returns error data if the control with the given path has the error specified. Otherwise
	     * returns null or undefined.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    AbstractControlDirective.prototype.getError = /**
	     * Returns error data if the control with the given path has the error specified. Otherwise
	     * returns null or undefined.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    function (errorCode, path) {
	        return this.control ? this.control.getError(errorCode, path) : null;
	    };
	    return AbstractControlDirective;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A directive that contains multiple {\@link NgControl}s.
	 *
	 * Only used by the forms module.
	 *
	 * \@stable
	 * @abstract
	 */
	var ControlContainer = /** @class */ (function (_super) {
	    __extends(ControlContainer, _super);
	    function ControlContainer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(ControlContainer.prototype, "formDirective", {
	        /**
	         * Get the form to which this container belongs.
	         */
	        get: /**
	         * Get the form to which this container belongs.
	         * @return {?}
	         */
	        function () { return null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ControlContainer.prototype, "path", {
	        /**
	         * Get the path to this container.
	         */
	        get: /**
	         * Get the path to this container.
	         * @return {?}
	         */
	        function () { return null; },
	        enumerable: true,
	        configurable: true
	    });
	    return ControlContainer;
	}(AbstractControlDirective));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function isEmptyInputValue(value) {
	    // we don't check for string here so it also works with arrays
	    return value == null || value.length === 0;
	}
	/**
	 * Providers for validators to be used for {\@link FormControl}s in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * \@Directive({
	 *   selector: '[custom-validator]',
	 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
	 * })
	 * class CustomValidatorDirective implements Validator {
	 *   validate(control: AbstractControl): ValidationErrors | null {
	 *     return {"custom": true};
	 *   }
	 * }
	 * ```
	 *
	 * \@stable
	 */
	var NG_VALIDATORS = new _angular_core.InjectionToken('NgValidators');
	/**
	 * Providers for asynchronous validators to be used for {\@link FormControl}s
	 * in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * See {\@link NG_VALIDATORS} for more details.
	 *
	 * \@stable
	 */
	var NG_ASYNC_VALIDATORS = new _angular_core.InjectionToken('NgAsyncValidators');
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	/**
	 * Provides a set of validators used by form controls.
	 *
	 * A validator is a function that processes a {\@link FormControl} or collection of
	 * controls and returns a map of errors. A null map means that validation has passed.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * var loginControl = new FormControl("", Validators.required)
	 * ```
	 *
	 * \@stable
	 */
	var Validators = /** @class */ (function () {
	    function Validators() {
	    }
	    /**
	     * Validator that requires controls to have a value greater than a number.
	     *`min()` exists only as a function, not as a directive. For example,
	     * `control = new FormControl('', Validators.min(3));`.
	     */
	    /**
	     * Validator that requires controls to have a value greater than a number.
	     * `min()` exists only as a function, not as a directive. For example,
	     * `control = new FormControl('', Validators.min(3));`.
	     * @param {?} min
	     * @return {?}
	     */
	    Validators.min = /**
	     * Validator that requires controls to have a value greater than a number.
	     * `min()` exists only as a function, not as a directive. For example,
	     * `control = new FormControl('', Validators.min(3));`.
	     * @param {?} min
	     * @return {?}
	     */
	    function (min) {
	        return function (control) {
	            if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
	                return null; // don't validate empty values to allow optional controls
	            }
	            var /** @type {?} */ value = parseFloat(control.value);
	            // Controls with NaN values after parsing should be treated as not having a
	            // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
	            return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
	        };
	    };
	    /**
	     * Validator that requires controls to have a value less than a number.
	     * `max()` exists only as a function, not as a directive. For example,
	     * `control = new FormControl('', Validators.max(15));`.
	     */
	    /**
	     * Validator that requires controls to have a value less than a number.
	     * `max()` exists only as a function, not as a directive. For example,
	     * `control = new FormControl('', Validators.max(15));`.
	     * @param {?} max
	     * @return {?}
	     */
	    Validators.max = /**
	     * Validator that requires controls to have a value less than a number.
	     * `max()` exists only as a function, not as a directive. For example,
	     * `control = new FormControl('', Validators.max(15));`.
	     * @param {?} max
	     * @return {?}
	     */
	    function (max) {
	        return function (control) {
	            if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
	                return null; // don't validate empty values to allow optional controls
	            }
	            var /** @type {?} */ value = parseFloat(control.value);
	            // Controls with NaN values after parsing should be treated as not having a
	            // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
	            return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
	        };
	    };
	    /**
	     * Validator that requires controls to have a non-empty value.
	     */
	    /**
	     * Validator that requires controls to have a non-empty value.
	     * @param {?} control
	     * @return {?}
	     */
	    Validators.required = /**
	     * Validator that requires controls to have a non-empty value.
	     * @param {?} control
	     * @return {?}
	     */
	    function (control) {
	        return isEmptyInputValue(control.value) ? { 'required': true } : null;
	    };
	    /**
	     * Validator that requires control value to be true.
	     */
	    /**
	     * Validator that requires control value to be true.
	     * @param {?} control
	     * @return {?}
	     */
	    Validators.requiredTrue = /**
	     * Validator that requires control value to be true.
	     * @param {?} control
	     * @return {?}
	     */
	    function (control) {
	        return control.value === true ? null : { 'required': true };
	    };
	    /**
	     * Validator that performs email validation.
	     */
	    /**
	     * Validator that performs email validation.
	     * @param {?} control
	     * @return {?}
	     */
	    Validators.email = /**
	     * Validator that performs email validation.
	     * @param {?} control
	     * @return {?}
	     */
	    function (control) {
	        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
	    };
	    /**
	     * Validator that requires controls to have a value of a minimum length.
	     */
	    /**
	     * Validator that requires controls to have a value of a minimum length.
	     * @param {?} minLength
	     * @return {?}
	     */
	    Validators.minLength = /**
	     * Validator that requires controls to have a value of a minimum length.
	     * @param {?} minLength
	     * @return {?}
	     */
	    function (minLength) {
	        return function (control) {
	            if (isEmptyInputValue(control.value)) {
	                return null; // don't validate empty values to allow optional controls
	            }
	            var /** @type {?} */ length = control.value ? control.value.length : 0;
	            return length < minLength ?
	                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires controls to have a value of a maximum length.
	     */
	    /**
	     * Validator that requires controls to have a value of a maximum length.
	     * @param {?} maxLength
	     * @return {?}
	     */
	    Validators.maxLength = /**
	     * Validator that requires controls to have a value of a maximum length.
	     * @param {?} maxLength
	     * @return {?}
	     */
	    function (maxLength) {
	        return function (control) {
	            var /** @type {?} */ length = control.value ? control.value.length : 0;
	            return length > maxLength ?
	                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires a control to match a regex to its value.
	     */
	    /**
	     * Validator that requires a control to match a regex to its value.
	     * @param {?} pattern
	     * @return {?}
	     */
	    Validators.pattern = /**
	     * Validator that requires a control to match a regex to its value.
	     * @param {?} pattern
	     * @return {?}
	     */
	    function (pattern) {
	        if (!pattern)
	            return Validators.nullValidator;
	        var /** @type {?} */ regex;
	        var /** @type {?} */ regexStr;
	        if (typeof pattern === 'string') {
	            regexStr = '';
	            if (pattern.charAt(0) !== '^')
	                regexStr += '^';
	            regexStr += pattern;
	            if (pattern.charAt(pattern.length - 1) !== '$')
	                regexStr += '$';
	            regex = new RegExp(regexStr);
	        }
	        else {
	            regexStr = pattern.toString();
	            regex = pattern;
	        }
	        return function (control) {
	            if (isEmptyInputValue(control.value)) {
	                return null; // don't validate empty values to allow optional controls
	            }
	            var /** @type {?} */ value = control.value;
	            return regex.test(value) ? null :
	                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
	        };
	    };
	    /**
	     * No-op validator.
	     */
	    /**
	     * No-op validator.
	     * @param {?} c
	     * @return {?}
	     */
	    Validators.nullValidator = /**
	     * No-op validator.
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) { return null; };
	    /**
	     * @param {?} validators
	     * @return {?}
	     */
	    Validators.compose = /**
	     * @param {?} validators
	     * @return {?}
	     */
	    function (validators) {
	        if (!validators)
	            return null;
	        var /** @type {?} */ presentValidators = /** @type {?} */ (validators.filter(isPresent));
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            return _mergeErrors(_executeValidators(control, presentValidators));
	        };
	    };
	    /**
	     * @param {?} validators
	     * @return {?}
	     */
	    Validators.composeAsync = /**
	     * @param {?} validators
	     * @return {?}
	     */
	    function (validators) {
	        if (!validators)
	            return null;
	        var /** @type {?} */ presentValidators = /** @type {?} */ (validators.filter(isPresent));
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            var /** @type {?} */ observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
	            return rxjs_operator_map.map.call(rxjs_observable_forkJoin.forkJoin(observables), _mergeErrors);
	        };
	    };
	    return Validators;
	}());
	/**
	 * @param {?} o
	 * @return {?}
	 */
	function isPresent(o) {
	    return o != null;
	}
	/**
	 * @param {?} r
	 * @return {?}
	 */
	function toObservable(r) {
	    var /** @type {?} */ obs = _angular_core.ɵisPromise(r) ? rxjs_observable_fromPromise.fromPromise(r) : r;
	    if (!(_angular_core.ɵisObservable(obs))) {
	        throw new Error("Expected validator to return Promise or Observable.");
	    }
	    return obs;
	}
	/**
	 * @param {?} control
	 * @param {?} validators
	 * @return {?}
	 */
	function _executeValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	/**
	 * @param {?} control
	 * @param {?} validators
	 * @return {?}
	 */
	function _executeAsyncValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	/**
	 * @param {?} arrayOfErrors
	 * @return {?}
	 */
	function _mergeErrors(arrayOfErrors) {
	    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
	        return errors != null ? __assign({}, /** @type {?} */ ((res)), errors) : /** @type {?} */ ((res));
	    }, {});
	    return Object.keys(res).length === 0 ? null : res;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A `ControlValueAccessor` acts as a bridge between the Angular forms API and a
	 * native element in the DOM.
	 *
	 * Implement this interface if you want to create a custom form control directive
	 * that integrates with Angular forms.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Used to provide a {\@link ControlValueAccessor} for form controls.
	 *
	 * See {\@link DefaultValueAccessor} for how to implement one.
	 * \@stable
	 */
	var NG_VALUE_ACCESSOR = new _angular_core.InjectionToken('NgValueAccessor');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var CHECKBOX_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return CheckboxControlValueAccessor; }),
	    multi: true,
	};
	/**
	 * The accessor for writing a value and listening to changes on a checkbox input element.
	 *
	 *  ### Example
	 *  ```
	 *  <input type="checkbox" name="rememberLogin" ngModel>
	 *  ```
	 *
	 *  \@stable
	 */
	var CheckboxControlValueAccessor = /** @class */ (function () {
	    function CheckboxControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    CheckboxControlValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    CheckboxControlValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onChange = fn; };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    CheckboxControlValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    CheckboxControlValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    CheckboxControlValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                    providers: [CHECKBOX_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    CheckboxControlValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return CheckboxControlValueAccessor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var DEFAULT_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return DefaultValueAccessor; }),
	    multi: true
	};
	/**
	 * We must check whether the agent is Android because composition events
	 * behave differently between iOS and Android.
	 * @return {?}
	 */
	function _isAndroid() {
	    var /** @type {?} */ userAgent = _angular_platformBrowser.ɵgetDOM() ? _angular_platformBrowser.ɵgetDOM().getUserAgent() : '';
	    return /android (\d+)/.test(userAgent.toLowerCase());
	}
	/**
	 * Turn this mode on if you want form directives to buffer IME input until compositionend
	 * \@experimental
	 */
	var COMPOSITION_BUFFER_MODE = new _angular_core.InjectionToken('CompositionEventMode');
	/**
	 * The default accessor for writing a value and listening to changes that is used by the
	 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
	 *
	 *  ### Example
	 *  ```
	 *  <input type="text" name="searchQuery" ngModel>
	 *  ```
	 *
	 *  \@stable
	 */
	var DefaultValueAccessor = /** @class */ (function () {
	    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this._compositionMode = _compositionMode;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	        /**
	         * Whether the user is creating a composition string (IME events).
	         */
	        this._composing = false;
	        if (this._compositionMode == null) {
	            this._compositionMode = !_isAndroid();
	        }
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ normalizedValue = value == null ? '' : value;
	        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onChange = fn; };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype._handleInput = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
	            this.onChange(value);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype._compositionStart = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { this._composing = true; };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    DefaultValueAccessor.prototype._compositionEnd = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._composing = false;
	        this._compositionMode && this.onChange(value);
	    };
	    DefaultValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                    // TODO: vsavkin replace the above selector with the one below it once
	                    // https://github.com/angular/angular/issues/3011 is implemented
	                    // selector: '[ngModel],[formControl],[formControlName]',
	                    host: {
	                        '(input)': '$any(this)._handleInput($event.target.value)',
	                        '(blur)': 'onTouched()',
	                        '(compositionstart)': '$any(this)._compositionStart()',
	                        '(compositionend)': '$any(this)._compositionEnd($event.target.value)'
	                    },
	                    providers: [DEFAULT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    DefaultValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [COMPOSITION_BUFFER_MODE,] },] },
	    ]; };
	    return DefaultValueAccessor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} validator
	 * @return {?}
	 */
	function normalizeValidator(validator) {
	    if ((/** @type {?} */ (validator)).validate) {
	        return function (c) { return (/** @type {?} */ (validator)).validate(c); };
	    }
	    else {
	        return /** @type {?} */ (validator);
	    }
	}
	/**
	 * @param {?} validator
	 * @return {?}
	 */
	function normalizeAsyncValidator(validator) {
	    if ((/** @type {?} */ (validator)).validate) {
	        return function (c) { return (/** @type {?} */ (validator)).validate(c); };
	    }
	    else {
	        return /** @type {?} */ (validator);
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var NUMBER_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return NumberValueAccessor; }),
	    multi: true
	};
	/**
	 * The accessor for writing a number value and listening to changes that is used by the
	 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
	 *
	 *  ### Example
	 *  ```
	 *  <input type="number" [(ngModel)]="age">
	 *  ```
	 */
	var NumberValueAccessor = /** @class */ (function () {
	    function NumberValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    NumberValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
	        var /** @type {?} */ normalizedValue = value == null ? '' : value;
	        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NumberValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NumberValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    NumberValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    NumberValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                    host: {
	                        '(change)': 'onChange($event.target.value)',
	                        '(input)': 'onChange($event.target.value)',
	                        '(blur)': 'onTouched()'
	                    },
	                    providers: [NUMBER_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    NumberValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return NumberValueAccessor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @return {?}
	 */
	function unimplemented() {
	    throw new Error('unimplemented');
	}
	/**
	 * A base class that all control directive extend.
	 * It binds a {\@link FormControl} object to a DOM element.
	 *
	 * Used internally by Angular forms.
	 *
	 * \@stable
	 * @abstract
	 */
	var NgControl = /** @class */ (function (_super) {
	    __extends(NgControl, _super);
	    function NgControl() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * \@internal
	         */
	        _this._parent = null;
	        _this.name = null;
	        _this.valueAccessor = null;
	        /**
	         * \@internal
	         */
	        _this._rawValidators = [];
	        /**
	         * \@internal
	         */
	        _this._rawAsyncValidators = [];
	        return _this;
	    }
	    Object.defineProperty(NgControl.prototype, "validator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return /** @type {?} */ (unimplemented()); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControl.prototype, "asyncValidator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return /** @type {?} */ (unimplemented()); },
	        enumerable: true,
	        configurable: true
	    });
	    return NgControl;
	}(AbstractControlDirective));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var RADIO_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return RadioControlValueAccessor; }),
	    multi: true
	};
	/**
	 * Internal class used by Angular to uncheck radio buttons with the matching name.
	 */
	var RadioControlRegistry = /** @class */ (function () {
	    function RadioControlRegistry() {
	        this._accessors = [];
	    }
	    /**
	     * @param {?} control
	     * @param {?} accessor
	     * @return {?}
	     */
	    RadioControlRegistry.prototype.add = /**
	     * @param {?} control
	     * @param {?} accessor
	     * @return {?}
	     */
	    function (control, accessor) {
	        this._accessors.push([control, accessor]);
	    };
	    /**
	     * @param {?} accessor
	     * @return {?}
	     */
	    RadioControlRegistry.prototype.remove = /**
	     * @param {?} accessor
	     * @return {?}
	     */
	    function (accessor) {
	        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
	            if (this._accessors[i][1] === accessor) {
	                this._accessors.splice(i, 1);
	                return;
	            }
	        }
	    };
	    /**
	     * @param {?} accessor
	     * @return {?}
	     */
	    RadioControlRegistry.prototype.select = /**
	     * @param {?} accessor
	     * @return {?}
	     */
	    function (accessor) {
	        var _this = this;
	        this._accessors.forEach(function (c) {
	            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                c[1].fireUncheck(accessor.value);
	            }
	        });
	    };
	    /**
	     * @param {?} controlPair
	     * @param {?} accessor
	     * @return {?}
	     */
	    RadioControlRegistry.prototype._isSameGroup = /**
	     * @param {?} controlPair
	     * @param {?} accessor
	     * @return {?}
	     */
	    function (controlPair, accessor) {
	        if (!controlPair[0].control)
	            return false;
	        return controlPair[0]._parent === accessor._control._parent &&
	            controlPair[1].name === accessor.name;
	    };
	    RadioControlRegistry.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    RadioControlRegistry.ctorParameters = function () { return []; };
	    return RadioControlRegistry;
	}());
	/**
	 * \@whatItDoes Writes radio control values and listens to radio control changes.
	 *
	 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
	 * to keep the view synced with the {\@link FormControl} model.
	 *
	 * \@howToUse
	 *
	 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
	 * value accessor will be active on any radio control that has a form directive. You do
	 * **not** need to add a special selector to activate it.
	 *
	 * ### How to use radio buttons with form directives
	 *
	 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
	 * in the same group have the same `name` attribute.  Radio buttons with different `name`
	 * attributes do not affect each other.
	 *
	 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
	 *
	 * When using radio buttons in a reactive form, radio buttons in the same group should have the
	 * same `formControlName`. You can also add a `name` attribute, but it's optional.
	 *
	 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
	 *
	 *  * **npm package**: `\@angular/forms`
	 *
	 *  \@stable
	 */
	var RadioControlValueAccessor = /** @class */ (function () {
	    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this._registry = _registry;
	        this._injector = _injector;
	        this.onChange = function () { };
	        this.onTouched = function () { };
	    }
	    /**
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._control = this._injector.get(NgControl);
	        this._checkName();
	        this._registry.add(this._control, this);
	    };
	    /**
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this._registry.remove(this); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._state = value === this.value;
	        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var _this = this;
	        this._fn = fn;
	        this.onChange = function () {
	            fn(_this.value);
	            _this._registry.select(_this);
	        };
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.fireUncheck = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { this.writeValue(value); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    /**
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype._checkName = /**
	     * @return {?}
	     */
	    function () {
	        if (this.name && this.formControlName && this.name !== this.formControlName) {
	            this._throwNameError();
	        }
	        if (!this.name && this.formControlName)
	            this.name = this.formControlName;
	    };
	    /**
	     * @return {?}
	     */
	    RadioControlValueAccessor.prototype._throwNameError = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	    };
	    RadioControlValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                    providers: [RADIO_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	        { type: RadioControlRegistry, },
	        { type: _angular_core.Injector, },
	    ]; };
	    RadioControlValueAccessor.propDecorators = {
	        "name": [{ type: _angular_core.Input },],
	        "formControlName": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	    };
	    return RadioControlValueAccessor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var RANGE_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return RangeValueAccessor; }),
	    multi: true
	};
	/**
	 * The accessor for writing a range value and listening to changes that is used by the
	 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
	 *
	 *  ### Example
	 *  ```
	 *  <input type="range" [(ngModel)]="age" >
	 *  ```
	 */
	var RangeValueAccessor = /** @class */ (function () {
	    function RangeValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    RangeValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RangeValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RangeValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    RangeValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    RangeValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
	                    host: {
	                        '(change)': 'onChange($event.target.value)',
	                        '(input)': 'onChange($event.target.value)',
	                        '(blur)': 'onTouched()'
	                    },
	                    providers: [RANGE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    RangeValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return RangeValueAccessor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SELECT_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return SelectControlValueAccessor; }),
	    multi: true
	};
	/**
	 * @param {?} id
	 * @param {?} value
	 * @return {?}
	 */
	function _buildValueString(id, value) {
	    if (id == null)
	        return "" + value;
	    if (value && typeof value === 'object')
	        value = 'Object';
	    return (id + ": " + value).slice(0, 50);
	}
	/**
	 * @param {?} valueString
	 * @return {?}
	 */
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	/**
	 * \@whatItDoes Writes values and listens to changes on a select element.
	 *
	 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
	 * to keep the view synced with the {\@link FormControl} model.
	 *
	 * \@howToUse
	 *
	 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
	 * value accessor will be active on any select control that has a form directive. You do
	 * **not** need to add a special selector to activate it.
	 *
	 * ### How to use select controls with form directives
	 *
	 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
	 * attribute to the main `<select>` tag.
	 *
	 * If your option values are simple strings, you can bind to the normal `value` property
	 * on the option.  If your option values happen to be objects (and you'd like to save the
	 * selection in your form as an object), use `ngValue` instead:
	 *
	 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
	 *
	 * In reactive forms, you'll also want to add your form directive (`formControlName` or
	 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
	 * choice of binding to the  `value` or `ngValue` property on the select's options.
	 *
	 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
	 *
	 * ### Caveat: Option selection
	 *
	 * Angular uses object identity to select option. It's possible for the identities of items
	 * to change while the data does not. This can happen, for example, if the items are produced
	 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
	 * second response will produce objects with different identities.
	 *
	 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
	 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
	 * If `compareWith` is given, Angular selects option by the return value of the function.
	 *
	 * #### Syntax
	 *
	 * ```
	 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
	 *     <option *ngFor="let country of countries" [ngValue]="country">
	 *         {{country.name}}
	 *     </option>
	 * </select>
	 *
	 * compareFn(c1: Country, c2: Country): boolean {
	 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
	 * }
	 * ```
	 *
	 * Note: We listen to the 'change' event because 'input' events aren't fired
	 * for selects in Firefox and IE:
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
	 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * \@stable
	 */
	var SelectControlValueAccessor = /** @class */ (function () {
	    function SelectControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        /**
	         * \@internal
	         */
	        this._optionMap = new Map();
	        /**
	         * \@internal
	         */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	        this._compareWith = _angular_core.ɵlooseIdentical;
	    }
	    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            if (typeof fn !== 'function') {
	                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
	            }
	            this._compareWith = fn;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.value = value;
	        var /** @type {?} */ id = this._getOptionId(value);
	        if (id == null) {
	            this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
	        }
	        var /** @type {?} */ valueString = _buildValueString(id, value);
	        this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var _this = this;
	        this.onChange = function (valueString) {
	            _this.value = _this._getOptionValue(valueString);
	            fn(_this.value);
	        };
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype._registerOption = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { return (this._idCounter++).toString(); };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype._getOptionId = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (this._compareWith(this._optionMap.get(id), value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} valueString
	     * @return {?}
	     */
	    SelectControlValueAccessor.prototype._getOptionValue = /**
	     * \@internal
	     * @param {?} valueString
	     * @return {?}
	     */
	    function (valueString) {
	        var /** @type {?} */ id = _extractId(valueString);
	        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
	    };
	    SelectControlValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [SELECT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectControlValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    SelectControlValueAccessor.propDecorators = {
	        "compareWith": [{ type: _angular_core.Input },],
	    };
	    return SelectControlValueAccessor;
	}());
	/**
	 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
	 *
	 * \@howToUse
	 *
	 * See docs for {\@link SelectControlValueAccessor} for usage examples.
	 *
	 * \@stable
	 */
	var NgSelectOption = /** @class */ (function () {
	    function NgSelectOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (this._select)
	            this.id = this._select._registerOption();
	    }
	    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._select == null)
	                return;
	            this._select._optionMap.set(this.id, value);
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectOption.prototype, "value", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._setElementValue(value);
	            if (this._select)
	                this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    NgSelectOption.prototype._setElementValue = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._renderer.setProperty(this._element.nativeElement, 'value', value);
	    };
	    /**
	     * @return {?}
	     */
	    NgSelectOption.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._select) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    NgSelectOption.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.Renderer2, },
	        { type: SelectControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	    ]; };
	    NgSelectOption.propDecorators = {
	        "ngValue": [{ type: _angular_core.Input, args: ['ngValue',] },],
	        "value": [{ type: _angular_core.Input, args: ['value',] },],
	    };
	    return NgSelectOption;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SELECT_MULTIPLE_VALUE_ACCESSOR = {
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	    multi: true
	};
	/**
	 * @param {?} id
	 * @param {?} value
	 * @return {?}
	 */
	function _buildValueString$1(id, value) {
	    if (id == null)
	        return "" + value;
	    if (typeof value === 'string')
	        value = "'" + value + "'";
	    if (value && typeof value === 'object')
	        value = 'Object';
	    return (id + ": " + value).slice(0, 50);
	}
	/**
	 * @param {?} valueString
	 * @return {?}
	 */
	function _extractId$1(valueString) {
	    return valueString.split(':')[0];
	}
	/**
	 * The accessor for writing a value and listening to changes on a select element.
	 *
	 *  ### Caveat: Options selection
	 *
	 * Angular uses object identity to select options. It's possible for the identities of items
	 * to change while the data does not. This can happen, for example, if the items are produced
	 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
	 * second response will produce objects with different identities.
	 *
	 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
	 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
	 * If `compareWith` is given, Angular selects options by the return value of the function.
	 *
	 * #### Syntax
	 *
	 * ```
	 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
	 *     <option *ngFor="let country of countries" [ngValue]="country">
	 *         {{country.name}}
	 *     </option>
	 * </select>
	 *
	 * compareFn(c1: Country, c2: Country): boolean {
	 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
	 * }
	 * ```
	 *
	 * \@stable
	 */
	var SelectMultipleControlValueAccessor = /** @class */ (function () {
	    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        /**
	         * \@internal
	         */
	        this._optionMap = new Map();
	        /**
	         * \@internal
	         */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	        this._compareWith = _angular_core.ɵlooseIdentical;
	    }
	    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            if (typeof fn !== 'function') {
	                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
	            }
	            this._compareWith = fn;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var _this = this;
	        this.value = value;
	        var /** @type {?} */ optionSelectedStateSetter;
	        if (Array.isArray(value)) {
	            // convert values to ids
	            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
	            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
	        }
	        else {
	            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
	        }
	        this._optionMap.forEach(optionSelectedStateSetter);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var _this = this;
	        this.onChange = function (_) {
	            var /** @type {?} */ selected = [];
	            if (_.hasOwnProperty('selectedOptions')) {
	                var /** @type {?} */ options = _.selectedOptions;
	                for (var /** @type {?} */ i = 0; i < options.length; i++) {
	                    var /** @type {?} */ opt = options.item(i);
	                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
	                    selected.push(val);
	                }
	            }
	            else {
	                var /** @type {?} */ options = /** @type {?} */ (_.options);
	                for (var /** @type {?} */ i = 0; i < options.length; i++) {
	                    var /** @type {?} */ opt = options.item(i);
	                    if (opt.selected) {
	                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	            }
	            _this.value = selected;
	            fn(selected);
	        };
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this.onTouched = fn; };
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype._registerOption = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ id = (this._idCounter++).toString();
	        this._optionMap.set(id, value);
	        return id;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype._getOptionId = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (this._compareWith(/** @type {?} */ ((this._optionMap.get(id)))._value, value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} valueString
	     * @return {?}
	     */
	    SelectMultipleControlValueAccessor.prototype._getOptionValue = /**
	     * \@internal
	     * @param {?} valueString
	     * @return {?}
	     */
	    function (valueString) {
	        var /** @type {?} */ id = _extractId$1(valueString);
	        return this._optionMap.has(id) ? /** @type {?} */ ((this._optionMap.get(id)))._value : valueString;
	    };
	    SelectMultipleControlValueAccessor.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.ctorParameters = function () { return [
	        { type: _angular_core.Renderer2, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    SelectMultipleControlValueAccessor.propDecorators = {
	        "compareWith": [{ type: _angular_core.Input },],
	    };
	    return SelectMultipleControlValueAccessor;
	}());
	/**
	 * Marks `<option>` as dynamic, so Angular can be notified when options change.
	 *
	 * ### Example
	 *
	 * ```
	 * <select multiple name="city" ngModel>
	 *   <option *ngFor="let c of cities" [value]="c"></option>
	 * </select>
	 * ```
	 */
	var NgSelectMultipleOption = /** @class */ (function () {
	    function NgSelectMultipleOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (this._select) {
	            this.id = this._select._registerOption(this);
	        }
	    }
	    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._select == null)
	                return;
	            this._value = value;
	            this._setElementValue(_buildValueString$1(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._select) {
	                this._value = value;
	                this._setElementValue(_buildValueString$1(this.id, value));
	                this._select.writeValue(this._select.value);
	            }
	            else {
	                this._setElementValue(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    NgSelectMultipleOption.prototype._setElementValue = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._renderer.setProperty(this._element.nativeElement, 'value', value);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} selected
	     * @return {?}
	     */
	    NgSelectMultipleOption.prototype._setSelected = /**
	     * \@internal
	     * @param {?} selected
	     * @return {?}
	     */
	    function (selected) {
	        this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
	    };
	    /**
	     * @return {?}
	     */
	    NgSelectMultipleOption.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._select) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    NgSelectMultipleOption.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.Renderer2, },
	        { type: SelectMultipleControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	    ]; };
	    NgSelectMultipleOption.propDecorators = {
	        "ngValue": [{ type: _angular_core.Input, args: ['ngValue',] },],
	        "value": [{ type: _angular_core.Input, args: ['value',] },],
	    };
	    return NgSelectMultipleOption;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} name
	 * @param {?} parent
	 * @return {?}
	 */
	function controlPath(name, parent) {
	    return /** @type {?} */ ((parent.path)).concat([name]);
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function setUpControl(control, dir) {
	    if (!control)
	        _throwError(dir, 'Cannot find control with');
	    if (!dir.valueAccessor)
	        _throwError(dir, 'No value accessor for form control with');
	    control.validator = Validators.compose([/** @type {?} */ ((control.validator)), dir.validator]);
	    control.asyncValidator = Validators.composeAsync([/** @type {?} */ ((control.asyncValidator)), dir.asyncValidator]); /** @type {?} */
	    ((dir.valueAccessor)).writeValue(control.value);
	    setUpViewChangePipeline(control, dir);
	    setUpModelChangePipeline(control, dir);
	    setUpBlurPipeline(control, dir);
	    if (/** @type {?} */ ((dir.valueAccessor)).setDisabledState) {
	        control.registerOnDisabledChange(function (isDisabled) { /** @type {?} */ ((/** @type {?} */ ((dir.valueAccessor)).setDisabledState))(isDisabled); });
	    }
	    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
	    dir._rawValidators.forEach(function (validator) {
	        if ((/** @type {?} */ (validator)).registerOnValidatorChange)
	            /** @type {?} */ (((/** @type {?} */ (validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
	    });
	    dir._rawAsyncValidators.forEach(function (validator) {
	        if ((/** @type {?} */ (validator)).registerOnValidatorChange)
	            /** @type {?} */ (((/** @type {?} */ (validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
	    });
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function cleanUpControl(control, dir) {
	    /** @type {?} */ ((dir.valueAccessor)).registerOnChange(function () { return _noControlError(dir); }); /** @type {?} */
	    ((dir.valueAccessor)).registerOnTouched(function () { return _noControlError(dir); });
	    dir._rawValidators.forEach(function (validator) {
	        if (validator.registerOnValidatorChange) {
	            validator.registerOnValidatorChange(null);
	        }
	    });
	    dir._rawAsyncValidators.forEach(function (validator) {
	        if (validator.registerOnValidatorChange) {
	            validator.registerOnValidatorChange(null);
	        }
	    });
	    if (control)
	        control._clearChangeFns();
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function setUpViewChangePipeline(control, dir) {
	    /** @type {?} */ ((dir.valueAccessor)).registerOnChange(function (newValue) {
	        control._pendingValue = newValue;
	        control._pendingChange = true;
	        control._pendingDirty = true;
	        if (control.updateOn === 'change')
	            updateControl(control, dir);
	    });
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function setUpBlurPipeline(control, dir) {
	    /** @type {?} */ ((dir.valueAccessor)).registerOnTouched(function () {
	        control._pendingTouched = true;
	        if (control.updateOn === 'blur' && control._pendingChange)
	            updateControl(control, dir);
	        if (control.updateOn !== 'submit')
	            control.markAsTouched();
	    });
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function updateControl(control, dir) {
	    dir.viewToModelUpdate(control._pendingValue);
	    if (control._pendingDirty)
	        control.markAsDirty();
	    control.setValue(control._pendingValue, { emitModelToViewChange: false });
	    control._pendingChange = false;
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function setUpModelChangePipeline(control, dir) {
	    control.registerOnChange(function (newValue, emitModelEvent) {
	        /** @type {?} */ ((
	        // control -> view
	        dir.valueAccessor)).writeValue(newValue);
	        // control -> ngModel
	        if (emitModelEvent)
	            dir.viewToModelUpdate(newValue);
	    });
	}
	/**
	 * @param {?} control
	 * @param {?} dir
	 * @return {?}
	 */
	function setUpFormContainer(control, dir) {
	    if (control == null)
	        _throwError(dir, 'Cannot find control with');
	    control.validator = Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	}
	/**
	 * @param {?} dir
	 * @return {?}
	 */
	function _noControlError(dir) {
	    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
	}
	/**
	 * @param {?} dir
	 * @param {?} message
	 * @return {?}
	 */
	function _throwError(dir, message) {
	    var /** @type {?} */ messageEnd;
	    if (/** @type {?} */ ((dir.path)).length > 1) {
	        messageEnd = "path: '" + (/** @type {?} */ ((dir.path))).join(' -> ') + "'";
	    }
	    else if (/** @type {?} */ ((dir.path))[0]) {
	        messageEnd = "name: '" + dir.path + "'";
	    }
	    else {
	        messageEnd = 'unspecified name attribute';
	    }
	    throw new Error(message + " " + messageEnd);
	}
	/**
	 * @param {?} validators
	 * @return {?}
	 */
	function composeValidators(validators) {
	    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
	}
	/**
	 * @param {?} validators
	 * @return {?}
	 */
	function composeAsyncValidators(validators) {
	    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
	        null;
	}
	/**
	 * @param {?} changes
	 * @param {?} viewModel
	 * @return {?}
	 */
	function isPropertyUpdated(changes, viewModel) {
	    if (!changes.hasOwnProperty('model'))
	        return false;
	    var /** @type {?} */ change = changes['model'];
	    if (change.isFirstChange())
	        return true;
	    return !_angular_core.ɵlooseIdentical(viewModel, change.currentValue);
	}
	var BUILTIN_ACCESSORS = [
	    CheckboxControlValueAccessor,
	    RangeValueAccessor,
	    NumberValueAccessor,
	    SelectControlValueAccessor,
	    SelectMultipleControlValueAccessor,
	    RadioControlValueAccessor,
	];
	/**
	 * @param {?} valueAccessor
	 * @return {?}
	 */
	function isBuiltInAccessor(valueAccessor) {
	    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
	}
	/**
	 * @param {?} form
	 * @param {?} directives
	 * @return {?}
	 */
	function syncPendingControls(form, directives) {
	    form._syncPendingControls();
	    directives.forEach(function (dir) {
	        var /** @type {?} */ control = /** @type {?} */ (dir.control);
	        if (control.updateOn === 'submit' && control._pendingChange) {
	            dir.viewToModelUpdate(control._pendingValue);
	            control._pendingChange = false;
	        }
	    });
	}
	/**
	 * @param {?} dir
	 * @param {?} valueAccessors
	 * @return {?}
	 */
	function selectValueAccessor(dir, valueAccessors) {
	    if (!valueAccessors)
	        return null;
	    if (!Array.isArray(valueAccessors))
	        _throwError(dir, 'Value accessor was not provided as an array for form control with');
	    var /** @type {?} */ defaultAccessor = undefined;
	    var /** @type {?} */ builtinAccessor = undefined;
	    var /** @type {?} */ customAccessor = undefined;
	    valueAccessors.forEach(function (v) {
	        if (v.constructor === DefaultValueAccessor) {
	            defaultAccessor = v;
	        }
	        else if (isBuiltInAccessor(v)) {
	            if (builtinAccessor)
	                _throwError(dir, 'More than one built-in value accessor matches form control with');
	            builtinAccessor = v;
	        }
	        else {
	            if (customAccessor)
	                _throwError(dir, 'More than one custom value accessor matches form control with');
	            customAccessor = v;
	        }
	    });
	    if (customAccessor)
	        return customAccessor;
	    if (builtinAccessor)
	        return builtinAccessor;
	    if (defaultAccessor)
	        return defaultAccessor;
	    _throwError(dir, 'No valid value accessor for form control with');
	    return null;
	}
	/**
	 * @template T
	 * @param {?} list
	 * @param {?} el
	 * @return {?}
	 */
	function removeDir(list, el) {
	    var /** @type {?} */ index = list.indexOf(el);
	    if (index > -1)
	        list.splice(index, 1);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
	 *
	 * \@stable
	 */
	var AbstractFormGroupDirective = /** @class */ (function (_super) {
	    __extends(AbstractFormGroupDirective, _super);
	    function AbstractFormGroupDirective() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    AbstractFormGroupDirective.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._checkParentType(); /** @type {?} */
	        ((this.formDirective)).addFormGroup(this);
	    };
	    /**
	     * @return {?}
	     */
	    AbstractFormGroupDirective.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this.formDirective) {
	            this.formDirective.removeFormGroup(this);
	        }
	    };
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	        /**
	         * Get the {@link FormGroup} backing this binding.
	         */
	        get: /**
	         * Get the {\@link FormGroup} backing this binding.
	         * @return {?}
	         */
	        function () { return /** @type {?} */ ((this.formDirective)).getFormGroup(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	        /**
	         * Get the path to this control group.
	         */
	        get: /**
	         * Get the path to this control group.
	         * @return {?}
	         */
	        function () { return controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	        /**
	         * Get the {@link Form} to which this group belongs.
	         */
	        get: /**
	         * Get the {\@link Form} to which this group belongs.
	         * @return {?}
	         */
	        function () { return this._parent ? this._parent.formDirective : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    AbstractFormGroupDirective.prototype._checkParentType = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { };
	    return AbstractFormGroupDirective;
	}(ControlContainer));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var AbstractControlStatus = /** @class */ (function () {
	    function AbstractControlStatus(cd) {
	        this._cd = cd;
	    }
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.untouched : false; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.touched : false; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.pristine : false; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.dirty : false; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.valid : false; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.invalid : false; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._cd.control ? this._cd.control.pending : false; },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractControlStatus;
	}());
	var ngControlStatusHost = {
	    '[class.ng-untouched]': 'ngClassUntouched',
	    '[class.ng-touched]': 'ngClassTouched',
	    '[class.ng-pristine]': 'ngClassPristine',
	    '[class.ng-dirty]': 'ngClassDirty',
	    '[class.ng-valid]': 'ngClassValid',
	    '[class.ng-invalid]': 'ngClassInvalid',
	    '[class.ng-pending]': 'ngClassPending',
	};
	/**
	 * Directive automatically applied to Angular form controls that sets CSS classes
	 * based on control status. The following classes are applied as the properties
	 * become true:
	 *
	 * * ng-valid
	 * * ng-invalid
	 * * ng-pending
	 * * ng-pristine
	 * * ng-dirty
	 * * ng-untouched
	 * * ng-touched
	 *
	 * \@stable
	 */
	var NgControlStatus = /** @class */ (function (_super) {
	    __extends(NgControlStatus, _super);
	    function NgControlStatus(cd) {
	        return _super.call(this, cd) || this;
	    }
	    NgControlStatus.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
	    ];
	    /** @nocollapse */
	    NgControlStatus.ctorParameters = function () { return [
	        { type: NgControl, decorators: [{ type: _angular_core.Self },] },
	    ]; };
	    return NgControlStatus;
	}(AbstractControlStatus));
	/**
	 * Directive automatically applied to Angular form groups that sets CSS classes
	 * based on control status (valid/invalid/dirty/etc).
	 *
	 * \@stable
	 */
	var NgControlStatusGroup = /** @class */ (function (_super) {
	    __extends(NgControlStatusGroup, _super);
	    function NgControlStatusGroup(cd) {
	        return _super.call(this, cd) || this;
	    }
	    NgControlStatusGroup.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
	                    host: ngControlStatusHost
	                },] },
	    ];
	    /** @nocollapse */
	    NgControlStatusGroup.ctorParameters = function () { return [
	        { type: ControlContainer, decorators: [{ type: _angular_core.Self },] },
	    ]; };
	    return NgControlStatusGroup;
	}(AbstractControlStatus));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	 */
	var VALID = 'VALID';
	/**
	 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	 */
	var INVALID = 'INVALID';
	/**
	 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	 * errors are not yet available for the input value.
	 */
	var PENDING = 'PENDING';
	/**
	 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
	 * calculations of validity or value.
	 */
	var DISABLED = 'DISABLED';
	/**
	 * @param {?} control
	 * @param {?} path
	 * @param {?} delimiter
	 * @return {?}
	 */
	function _find(control, path, delimiter) {
	    if (path == null)
	        return null;
	    if (!(path instanceof Array)) {
	        path = (/** @type {?} */ (path)).split(delimiter);
	    }
	    if (path instanceof Array && (path.length === 0))
	        return null;
	    return (/** @type {?} */ (path)).reduce(function (v, name) {
	        if (v instanceof FormGroup) {
	            return v.controls[name] || null;
	        }
	        if (v instanceof FormArray) {
	            return v.at(/** @type {?} */ (name)) || null;
	        }
	        return null;
	    }, control);
	}
	/**
	 * @param {?=} validatorOrOpts
	 * @return {?}
	 */
	function coerceToValidator(validatorOrOpts) {
	    var /** @type {?} */ validator = /** @type {?} */ ((isOptionsObj(validatorOrOpts) ? (/** @type {?} */ (validatorOrOpts)).validators :
	        validatorOrOpts));
	    return Array.isArray(validator) ? composeValidators(validator) : validator || null;
	}
	/**
	 * @param {?=} asyncValidator
	 * @param {?=} validatorOrOpts
	 * @return {?}
	 */
	function coerceToAsyncValidator(asyncValidator, validatorOrOpts) {
	    var /** @type {?} */ origAsyncValidator = /** @type {?} */ ((isOptionsObj(validatorOrOpts) ? (/** @type {?} */ (validatorOrOpts)).asyncValidators :
	        asyncValidator));
	    return Array.isArray(origAsyncValidator) ? composeAsyncValidators(origAsyncValidator) :
	        origAsyncValidator || null;
	}
	/**
	 * @record
	 */
	
	/**
	 * @param {?=} validatorOrOpts
	 * @return {?}
	 */
	function isOptionsObj(validatorOrOpts) {
	    return validatorOrOpts != null && !Array.isArray(validatorOrOpts) &&
	        typeof validatorOrOpts === 'object';
	}
	/**
	 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
	 * {\@link FormArray}.
	 *
	 * It provides some of the shared behavior that all controls and groups of controls have, like
	 * running validators, calculating status, and resetting state. It also defines the properties
	 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
	 * instantiated directly.
	 *
	 * \@stable
	 * @abstract
	 */
	var AbstractControl = /** @class */ (function () {
	    function AbstractControl(validator, asyncValidator) {
	        this.validator = validator;
	        this.asyncValidator = asyncValidator;
	        /**
	         * \@internal
	         */
	        this._onCollectionChange = function () { };
	        /**
	         * A control is `pristine` if the user has not yet changed
	         * the value in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         */
	        this.pristine = true;
	        /**
	         * A control is marked `touched` once the user has triggered
	         * a `blur` event on it.
	         */
	        this.touched = false;
	        /**
	         * \@internal
	         */
	        this._onDisabledChange = [];
	    }
	    Object.defineProperty(AbstractControl.prototype, "parent", {
	        /**
	         * The parent control.
	         */
	        get: /**
	         * The parent control.
	         * @return {?}
	         */
	        function () { return this._parent; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valid", {
	        /**
	         * A control is `valid` when its `status === VALID`.
	         *
	         * In order to have this status, the control must have passed all its
	         * validation checks.
	         */
	        get: /**
	         * A control is `valid` when its `status === VALID`.
	         *
	         * In order to have this status, the control must have passed all its
	         * validation checks.
	         * @return {?}
	         */
	        function () { return this.status === VALID; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "invalid", {
	        /**
	         * A control is `invalid` when its `status === INVALID`.
	         *
	         * In order to have this status, the control must have failed
	         * at least one of its validation checks.
	         */
	        get: /**
	         * A control is `invalid` when its `status === INVALID`.
	         *
	         * In order to have this status, the control must have failed
	         * at least one of its validation checks.
	         * @return {?}
	         */
	        function () { return this.status === INVALID; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pending", {
	        /**
	         * A control is `pending` when its `status === PENDING`.
	         *
	         * In order to have this status, the control must be in the
	         * middle of conducting a validation check.
	         */
	        get: /**
	         * A control is `pending` when its `status === PENDING`.
	         *
	         * In order to have this status, the control must be in the
	         * middle of conducting a validation check.
	         * @return {?}
	         */
	        function () { return this.status == PENDING; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "disabled", {
	        /**
	         * A control is `disabled` when its `status === DISABLED`.
	         *
	         * Disabled controls are exempt from validation checks and
	         * are not included in the aggregate value of their ancestor
	         * controls.
	         */
	        get: /**
	         * A control is `disabled` when its `status === DISABLED`.
	         *
	         * Disabled controls are exempt from validation checks and
	         * are not included in the aggregate value of their ancestor
	         * controls.
	         * @return {?}
	         */
	        function () { return this.status === DISABLED; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "enabled", {
	        /**
	         * A control is `enabled` as long as its `status !== DISABLED`.
	         *
	         * In other words, it has a status of `VALID`, `INVALID`, or
	         * `PENDING`.
	         */
	        get: /**
	         * A control is `enabled` as long as its `status !== DISABLED`.
	         *
	         * In other words, it has a status of `VALID`, `INVALID`, or
	         * `PENDING`.
	         * @return {?}
	         */
	        function () { return this.status !== DISABLED; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "dirty", {
	        /**
	         * A control is `dirty` if the user has changed the value
	         * in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         */
	        get: /**
	         * A control is `dirty` if the user has changed the value
	         * in the UI.
	         *
	         * Note that programmatic changes to a control's value will
	         * *not* mark it dirty.
	         * @return {?}
	         */
	        function () { return !this.pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "untouched", {
	        /**
	         * A control is `untouched` if the user has not yet triggered
	         * a `blur` event on it.
	         */
	        get: /**
	         * A control is `untouched` if the user has not yet triggered
	         * a `blur` event on it.
	         * @return {?}
	         */
	        function () { return !this.touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "updateOn", {
	        /**
	         * Returns the update strategy of the `AbstractControl` (i.e.
	         * the event on which the control will update itself).
	         * Possible values: `'change'` (default) | `'blur'` | `'submit'`
	         */
	        get: /**
	         * Returns the update strategy of the `AbstractControl` (i.e.
	         * the event on which the control will update itself).
	         * Possible values: `'change'` (default) | `'blur'` | `'submit'`
	         * @return {?}
	         */
	        function () {
	            return this._updateOn ? this._updateOn : (this.parent ? this.parent.updateOn : 'change');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the synchronous validators that are active on this control.  Calling
	     * this will overwrite any existing sync validators.
	     */
	    /**
	     * Sets the synchronous validators that are active on this control.  Calling
	     * this will overwrite any existing sync validators.
	     * @param {?} newValidator
	     * @return {?}
	     */
	    AbstractControl.prototype.setValidators = /**
	     * Sets the synchronous validators that are active on this control.  Calling
	     * this will overwrite any existing sync validators.
	     * @param {?} newValidator
	     * @return {?}
	     */
	    function (newValidator) {
	        this.validator = coerceToValidator(newValidator);
	    };
	    /**
	     * Sets the async validators that are active on this control. Calling this
	     * will overwrite any existing async validators.
	     */
	    /**
	     * Sets the async validators that are active on this control. Calling this
	     * will overwrite any existing async validators.
	     * @param {?} newValidator
	     * @return {?}
	     */
	    AbstractControl.prototype.setAsyncValidators = /**
	     * Sets the async validators that are active on this control. Calling this
	     * will overwrite any existing async validators.
	     * @param {?} newValidator
	     * @return {?}
	     */
	    function (newValidator) {
	        this.asyncValidator = coerceToAsyncValidator(newValidator);
	    };
	    /**
	     * Empties out the sync validator list.
	     */
	    /**
	     * Empties out the sync validator list.
	     * @return {?}
	     */
	    AbstractControl.prototype.clearValidators = /**
	     * Empties out the sync validator list.
	     * @return {?}
	     */
	    function () { this.validator = null; };
	    /**
	     * Empties out the async validator list.
	     */
	    /**
	     * Empties out the async validator list.
	     * @return {?}
	     */
	    AbstractControl.prototype.clearAsyncValidators = /**
	     * Empties out the async validator list.
	     * @return {?}
	     */
	    function () { this.asyncValidator = null; };
	    /**
	     * Marks the control as `touched`.
	     *
	     * This will also mark all direct ancestors as `touched` to maintain
	     * the model.
	     */
	    /**
	     * Marks the control as `touched`.
	     *
	     * This will also mark all direct ancestors as `touched` to maintain
	     * the model.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.markAsTouched = /**
	     * Marks the control as `touched`.
	     *
	     * This will also mark all direct ancestors as `touched` to maintain
	     * the model.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).touched = true;
	        if (this._parent && !opts.onlySelf) {
	            this._parent.markAsTouched(opts);
	        }
	    };
	    /**
	     * Marks the control as `untouched`.
	     *
	     * If the control has any children, it will also mark all children as `untouched`
	     * to maintain the model, and re-calculate the `touched` status of all parent
	     * controls.
	     */
	    /**
	     * Marks the control as `untouched`.
	     *
	     * If the control has any children, it will also mark all children as `untouched`
	     * to maintain the model, and re-calculate the `touched` status of all parent
	     * controls.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.markAsUntouched = /**
	     * Marks the control as `untouched`.
	     *
	     * If the control has any children, it will also mark all children as `untouched`
	     * to maintain the model, and re-calculate the `touched` status of all parent
	     * controls.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).touched = false;
	        this._pendingTouched = false;
	        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
	        if (this._parent && !opts.onlySelf) {
	            this._parent._updateTouched(opts);
	        }
	    };
	    /**
	     * Marks the control as `dirty`.
	     *
	     * This will also mark all direct ancestors as `dirty` to maintain
	     * the model.
	     */
	    /**
	     * Marks the control as `dirty`.
	     *
	     * This will also mark all direct ancestors as `dirty` to maintain
	     * the model.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.markAsDirty = /**
	     * Marks the control as `dirty`.
	     *
	     * This will also mark all direct ancestors as `dirty` to maintain
	     * the model.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).pristine = false;
	        if (this._parent && !opts.onlySelf) {
	            this._parent.markAsDirty(opts);
	        }
	    };
	    /**
	     * Marks the control as `pristine`.
	     *
	     * If the control has any children, it will also mark all children as `pristine`
	     * to maintain the model, and re-calculate the `pristine` status of all parent
	     * controls.
	     */
	    /**
	     * Marks the control as `pristine`.
	     *
	     * If the control has any children, it will also mark all children as `pristine`
	     * to maintain the model, and re-calculate the `pristine` status of all parent
	     * controls.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.markAsPristine = /**
	     * Marks the control as `pristine`.
	     *
	     * If the control has any children, it will also mark all children as `pristine`
	     * to maintain the model, and re-calculate the `pristine` status of all parent
	     * controls.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).pristine = true;
	        this._pendingDirty = false;
	        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
	        if (this._parent && !opts.onlySelf) {
	            this._parent._updatePristine(opts);
	        }
	    };
	    /**
	     * Marks the control as `pending`.
	     */
	    /**
	     * Marks the control as `pending`.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.markAsPending = /**
	     * Marks the control as `pending`.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).status = PENDING;
	        if (this._parent && !opts.onlySelf) {
	            this._parent.markAsPending(opts);
	        }
	    };
	    /**
	     * Disables the control. This means the control will be exempt from validation checks and
	     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
	     *
	     * If the control has children, all children will be disabled to maintain the model.
	     */
	    /**
	     * Disables the control. This means the control will be exempt from validation checks and
	     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
	     *
	     * If the control has children, all children will be disabled to maintain the model.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.disable = /**
	     * Disables the control. This means the control will be exempt from validation checks and
	     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
	     *
	     * If the control has children, all children will be disabled to maintain the model.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).status = DISABLED;
	        (/** @type {?} */ (this)).errors = null;
	        this._forEachChild(function (control) { control.disable(__assign({}, opts, { onlySelf: true })); });
	        this._updateValue();
	        if (opts.emitEvent !== false) {
	            (/** @type {?} */ (this.valueChanges)).emit(this.value);
	            (/** @type {?} */ (this.statusChanges)).emit(this.status);
	        }
	        this._updateAncestors(opts);
	        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
	    };
	    /**
	     * Enables the control. This means the control will be included in validation checks and
	     * the aggregate value of its parent. Its status is re-calculated based on its value and
	     * its validators.
	     *
	     * If the control has children, all children will be enabled.
	     */
	    /**
	     * Enables the control. This means the control will be included in validation checks and
	     * the aggregate value of its parent. Its status is re-calculated based on its value and
	     * its validators.
	     *
	     * If the control has children, all children will be enabled.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.enable = /**
	     * Enables the control. This means the control will be included in validation checks and
	     * the aggregate value of its parent. Its status is re-calculated based on its value and
	     * its validators.
	     *
	     * If the control has children, all children will be enabled.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).status = VALID;
	        this._forEachChild(function (control) { control.enable(__assign({}, opts, { onlySelf: true })); });
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
	        this._updateAncestors(opts);
	        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
	    };
	    /**
	     * @param {?} opts
	     * @return {?}
	     */
	    AbstractControl.prototype._updateAncestors = /**
	     * @param {?} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (this._parent && !opts.onlySelf) {
	            this._parent.updateValueAndValidity(opts);
	            this._parent._updatePristine();
	            this._parent._updateTouched();
	        }
	    };
	    /**
	     * @param {?} parent
	     * @return {?}
	     */
	    AbstractControl.prototype.setParent = /**
	     * @param {?} parent
	     * @return {?}
	     */
	    function (parent) { this._parent = parent; };
	    /**
	     * Re-calculates the value and validation status of the control.
	     *
	     * By default, it will also update the value and validity of its ancestors.
	     */
	    /**
	     * Re-calculates the value and validation status of the control.
	     *
	     * By default, it will also update the value and validity of its ancestors.
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.updateValueAndValidity = /**
	     * Re-calculates the value and validation status of the control.
	     *
	     * By default, it will also update the value and validity of its ancestors.
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        this._setInitialStatus();
	        this._updateValue();
	        if (this.enabled) {
	            this._cancelExistingSubscription();
	            (/** @type {?} */ (this)).errors = this._runValidator();
	            (/** @type {?} */ (this)).status = this._calculateStatus();
	            if (this.status === VALID || this.status === PENDING) {
	                this._runAsyncValidator(opts.emitEvent);
	            }
	        }
	        if (opts.emitEvent !== false) {
	            (/** @type {?} */ (this.valueChanges)).emit(this.value);
	            (/** @type {?} */ (this.statusChanges)).emit(this.status);
	        }
	        if (this._parent && !opts.onlySelf) {
	            this._parent.updateValueAndValidity(opts);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype._updateTreeValidity = /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = { emitEvent: true }; }
	        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity(opts); });
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
	    };
	    /**
	     * @return {?}
	     */
	    AbstractControl.prototype._setInitialStatus = /**
	     * @return {?}
	     */
	    function () {
	        (/** @type {?} */ (this)).status = this._allControlsDisabled() ? DISABLED : VALID;
	    };
	    /**
	     * @return {?}
	     */
	    AbstractControl.prototype._runValidator = /**
	     * @return {?}
	     */
	    function () {
	        return this.validator ? this.validator(this) : null;
	    };
	    /**
	     * @param {?=} emitEvent
	     * @return {?}
	     */
	    AbstractControl.prototype._runAsyncValidator = /**
	     * @param {?=} emitEvent
	     * @return {?}
	     */
	    function (emitEvent) {
	        var _this = this;
	        if (this.asyncValidator) {
	            (/** @type {?} */ (this)).status = PENDING;
	            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
	            this._asyncValidationSubscription =
	                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    AbstractControl.prototype._cancelExistingSubscription = /**
	     * @return {?}
	     */
	    function () {
	        if (this._asyncValidationSubscription) {
	            this._asyncValidationSubscription.unsubscribe();
	        }
	    };
	    /**
	     * Sets errors on a form control.
	     *
	     * This is used when validations are run manually by the user, rather than automatically.
	     *
	     * Calling `setErrors` will also update the validity of the parent control.
	     *
	     * ### Example
	     *
	     * ```
	     * const login = new FormControl("someLogin");
	     * login.setErrors({
	     *   "notUnique": true
	     * });
	     *
	     * expect(login.valid).toEqual(false);
	     * expect(login.errors).toEqual({"notUnique": true});
	     *
	     * login.setValue("someOtherLogin");
	     *
	     * expect(login.valid).toEqual(true);
	     * ```
	     */
	    /**
	     * Sets errors on a form control.
	     *
	     * This is used when validations are run manually by the user, rather than automatically.
	     *
	     * Calling `setErrors` will also update the validity of the parent control.
	     *
	     * ### Example
	     *
	     * ```
	     * const login = new FormControl("someLogin");
	     * login.setErrors({
	     *   "notUnique": true
	     * });
	     *
	     * expect(login.valid).toEqual(false);
	     * expect(login.errors).toEqual({"notUnique": true});
	     *
	     * login.setValue("someOtherLogin");
	     *
	     * expect(login.valid).toEqual(true);
	     * ```
	     * @param {?} errors
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype.setErrors = /**
	     * Sets errors on a form control.
	     *
	     * This is used when validations are run manually by the user, rather than automatically.
	     *
	     * Calling `setErrors` will also update the validity of the parent control.
	     *
	     * ### Example
	     *
	     * ```
	     * const login = new FormControl("someLogin");
	     * login.setErrors({
	     *   "notUnique": true
	     * });
	     *
	     * expect(login.valid).toEqual(false);
	     * expect(login.errors).toEqual({"notUnique": true});
	     *
	     * login.setValue("someOtherLogin");
	     *
	     * expect(login.valid).toEqual(true);
	     * ```
	     * @param {?} errors
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (errors, opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).errors = errors;
	        this._updateControlsErrors(opts.emitEvent !== false);
	    };
	    /**
	     * Retrieves a child control given the control's name or path.
	     *
	     * Paths can be passed in as an array or a string delimited by a dot.
	     *
	     * To get a control nested within a `person` sub-group:
	     *
	     * * `this.form.get('person.name');`
	     *
	     * -OR-
	     *
	     * * `this.form.get(['person', 'name']);`
	     */
	    /**
	     * Retrieves a child control given the control's name or path.
	     *
	     * Paths can be passed in as an array or a string delimited by a dot.
	     *
	     * To get a control nested within a `person` sub-group:
	     *
	     * * `this.form.get('person.name');`
	     *
	     * -OR-
	     *
	     * * `this.form.get(['person', 'name']);`
	     * @param {?} path
	     * @return {?}
	     */
	    AbstractControl.prototype.get = /**
	     * Retrieves a child control given the control's name or path.
	     *
	     * Paths can be passed in as an array or a string delimited by a dot.
	     *
	     * To get a control nested within a `person` sub-group:
	     *
	     * * `this.form.get('person.name');`
	     *
	     * -OR-
	     *
	     * * `this.form.get(['person', 'name']);`
	     * @param {?} path
	     * @return {?}
	     */
	    function (path) { return _find(this, path, '.'); };
	    /**
	     * Returns error data if the control with the given path has the error specified. Otherwise
	     * returns null or undefined.
	     *
	     * If no path is given, it checks for the error on the present control.
	     */
	    /**
	     * Returns error data if the control with the given path has the error specified. Otherwise
	     * returns null or undefined.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    AbstractControl.prototype.getError = /**
	     * Returns error data if the control with the given path has the error specified. Otherwise
	     * returns null or undefined.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    function (errorCode, path) {
	        var /** @type {?} */ control = path ? this.get(path) : this;
	        return control && control.errors ? control.errors[errorCode] : null;
	    };
	    /**
	     * Returns true if the control with the given path has the error specified. Otherwise
	     * returns false.
	     *
	     * If no path is given, it checks for the error on the present control.
	     */
	    /**
	     * Returns true if the control with the given path has the error specified. Otherwise
	     * returns false.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    AbstractControl.prototype.hasError = /**
	     * Returns true if the control with the given path has the error specified. Otherwise
	     * returns false.
	     *
	     * If no path is given, it checks for the error on the present control.
	     * @param {?} errorCode
	     * @param {?=} path
	     * @return {?}
	     */
	    function (errorCode, path) { return !!this.getError(errorCode, path); };
	    Object.defineProperty(AbstractControl.prototype, "root", {
	        /**
	         * Retrieves the top-level ancestor of this control.
	         */
	        get: /**
	         * Retrieves the top-level ancestor of this control.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ x = this;
	            while (x._parent) {
	                x = x._parent;
	            }
	            return x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} emitEvent
	     * @return {?}
	     */
	    AbstractControl.prototype._updateControlsErrors = /**
	     * \@internal
	     * @param {?} emitEvent
	     * @return {?}
	     */
	    function (emitEvent) {
	        (/** @type {?} */ (this)).status = this._calculateStatus();
	        if (emitEvent) {
	            (/** @type {?} */ (this.statusChanges)).emit(this.status);
	        }
	        if (this._parent) {
	            this._parent._updateControlsErrors(emitEvent);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    AbstractControl.prototype._initObservables = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        (/** @type {?} */ (this)).valueChanges = new _angular_core.EventEmitter();
	        (/** @type {?} */ (this)).statusChanges = new _angular_core.EventEmitter();
	    };
	    /**
	     * @return {?}
	     */
	    AbstractControl.prototype._calculateStatus = /**
	     * @return {?}
	     */
	    function () {
	        if (this._allControlsDisabled())
	            return DISABLED;
	        if (this.errors)
	            return INVALID;
	        if (this._anyControlsHaveStatus(PENDING))
	            return PENDING;
	        if (this._anyControlsHaveStatus(INVALID))
	            return INVALID;
	        return VALID;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} status
	     * @return {?}
	     */
	    AbstractControl.prototype._anyControlsHaveStatus = /**
	     * \@internal
	     * @param {?} status
	     * @return {?}
	     */
	    function (status) {
	        return this._anyControls(function (control) { return control.status === status; });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    AbstractControl.prototype._anyControlsDirty = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        return this._anyControls(function (control) { return control.dirty; });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    AbstractControl.prototype._anyControlsTouched = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        return this._anyControls(function (control) { return control.touched; });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype._updatePristine = /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).pristine = !this._anyControlsDirty();
	        if (this._parent && !opts.onlySelf) {
	            this._parent._updatePristine(opts);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype._updateTouched = /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (opts === void 0) { opts = {}; }
	        (/** @type {?} */ (this)).touched = this._anyControlsTouched();
	        if (this._parent && !opts.onlySelf) {
	            this._parent._updateTouched(opts);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} formState
	     * @return {?}
	     */
	    AbstractControl.prototype._isBoxedValue = /**
	     * \@internal
	     * @param {?} formState
	     * @return {?}
	     */
	    function (formState) {
	        return typeof formState === 'object' && formState !== null &&
	            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} fn
	     * @return {?}
	     */
	    AbstractControl.prototype._registerOnCollectionChange = /**
	     * \@internal
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onCollectionChange = fn; };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    AbstractControl.prototype._setUpdateStrategy = /**
	     * \@internal
	     * @param {?=} opts
	     * @return {?}
	     */
	    function (opts) {
	        if (isOptionsObj(opts) && (/** @type {?} */ (opts)).updateOn != null) {
	            this._updateOn = /** @type {?} */ (((/** @type {?} */ (opts)).updateOn));
	        }
	    };
	    return AbstractControl;
	}());
	/**
	 * \@whatItDoes Tracks the value and validation status of an individual form control.
	 *
	 * It is one of the three fundamental building blocks of Angular forms, along with
	 * {\@link FormGroup} and {\@link FormArray}.
	 *
	 * \@howToUse
	 *
	 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
	 * first argument. Example:
	 *
	 * ```ts
	 * const ctrl = new FormControl('some value');
	 * console.log(ctrl.value);     // 'some value'
	 * ```
	 *
	 * You can also initialize the control with a form state object on instantiation,
	 * which includes both the value and whether or not the control is disabled.
	 * You can't use the value key without the disabled key; both are required
	 * to use this way of initialization.
	 *
	 * ```ts
	 * const ctrl = new FormControl({value: 'n/a', disabled: true});
	 * console.log(ctrl.value);     // 'n/a'
	 * console.log(ctrl.status);   // 'DISABLED'
	 * ```
	 *
	 * The second {\@link FormControl} argument can accept one of three things:
	 * * a sync validator function
	 * * an array of sync validator functions
	 * * an options object containing validator and/or async validator functions
	 *
	 * Example of a single sync validator function:
	 *
	 * ```ts
	 * const ctrl = new FormControl('', Validators.required);
	 * console.log(ctrl.value);     // ''
	 * console.log(ctrl.status);   // 'INVALID'
	 * ```
	 *
	 * Example using options object:
	 *
	 * ```ts
	 * const ctrl = new FormControl('', {
	 *    validators: Validators.required,
	 *    asyncValidators: myAsyncValidator
	 * });
	 * ```
	 *
	 * The options object can also be used to define when the control should update.
	 * By default, the value and validity of a control updates whenever the value
	 * changes. You can configure it to update on the blur event instead by setting
	 * the `updateOn` option to `'blur'`.
	 *
	 * ```ts
	 * const c = new FormControl('', { updateOn: 'blur' });
	 * ```
	 *
	 * You can also set `updateOn` to `'submit'`, which will delay value and validity
	 * updates until the parent form of the control fires a submit event.
	 *
	 * See its superclass, {\@link AbstractControl}, for more properties and methods.
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * \@stable
	 */
	var FormControl = /** @class */ (function (_super) {
	    __extends(FormControl, _super);
	    function FormControl(formState, validatorOrOpts, asyncValidator) {
	        if (formState === void 0) { formState = null; }
	        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
	        /**
	         * \@internal
	         */
	        _this._onChange = [];
	        _this._applyFormState(formState);
	        _this._setUpdateStrategy(validatorOrOpts);
	        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        _this._initObservables();
	        return _this;
	    }
	    /**
	     * Set the value of the form control to `value`.
	     *
	     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	     * and not its parent component. This defaults to false.
	     *
	     * If `emitEvent` is `true`, this
	     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
	     * to true (as it falls through to `updateValueAndValidity`).
	     *
	     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	     * specified.
	     *
	     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
	     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
	     */
	    /**
	     * Set the value of the form control to `value`.
	     *
	     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	     * and not its parent component. This defaults to false.
	     *
	     * If `emitEvent` is `true`, this
	     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
	     * to true (as it falls through to `updateValueAndValidity`).
	     *
	     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	     * specified.
	     *
	     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
	     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormControl.prototype.setValue = /**
	     * Set the value of the form control to `value`.
	     *
	     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	     * and not its parent component. This defaults to false.
	     *
	     * If `emitEvent` is `true`, this
	     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
	     * to true (as it falls through to `updateValueAndValidity`).
	     *
	     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	     * specified.
	     *
	     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
	     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        (/** @type {?} */ (this)).value = this._pendingValue = value;
	        if (this._onChange.length && options.emitModelToViewChange !== false) {
	            this._onChange.forEach(function (changeFn) { return changeFn(_this.value, options.emitViewToModelChange !== false); });
	        }
	        this.updateValueAndValidity(options);
	    };
	    /**
	     * Patches the value of a control.
	     *
	     * This function is functionally the same as {@link FormControl#setValue setValue} at this level.
	     * It exists for symmetry with {@link FormGroup#patchValue patchValue} on `FormGroups` and
	     * `FormArrays`, where it does behave differently.
	     */
	    /**
	     * Patches the value of a control.
	     *
	     * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
	     * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
	     * `FormArrays`, where it does behave differently.
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormControl.prototype.patchValue = /**
	     * Patches the value of a control.
	     *
	     * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
	     * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
	     * `FormArrays`, where it does behave differently.
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        if (options === void 0) { options = {}; }
	        this.setValue(value, options);
	    };
	    /**
	     * Resets the form control. This means by default:
	     *
	     * * it is marked as `pristine`
	     * * it is marked as `untouched`
	     * * value is set to null
	     *
	     * You can also reset to a specific form state by passing through a standalone
	     * value or a form state object that contains both a value and a disabled state
	     * (these are the only two properties that cannot be calculated).
	     *
	     * Ex:
	     *
	     * ```ts
	     * this.control.reset('Nancy');
	     *
	     * console.log(this.control.value);  // 'Nancy'
	     * ```
	     *
	     * OR
	     *
	     * ```
	     * this.control.reset({value: 'Nancy', disabled: true});
	     *
	     * console.log(this.control.value);  // 'Nancy'
	     * console.log(this.control.status);  // 'DISABLED'
	     * ```
	     */
	    /**
	     * Resets the form control. This means by default:
	     *
	     * * it is marked as `pristine`
	     * * it is marked as `untouched`
	     * * value is set to null
	     *
	     * You can also reset to a specific form state by passing through a standalone
	     * value or a form state object that contains both a value and a disabled state
	     * (these are the only two properties that cannot be calculated).
	     *
	     * Ex:
	     *
	     * ```ts
	     * this.control.reset('Nancy');
	     *
	     * console.log(this.control.value);  // 'Nancy'
	     * ```
	     *
	     * OR
	     *
	     * ```
	     * this.control.reset({value: 'Nancy', disabled: true});
	     *
	     * console.log(this.control.value);  // 'Nancy'
	     * console.log(this.control.status);  // 'DISABLED'
	     * ```
	     * @param {?=} formState
	     * @param {?=} options
	     * @return {?}
	     */
	    FormControl.prototype.reset = /**
	     * Resets the form control. This means by default:
	     *
	     * * it is marked as `pristine`
	     * * it is marked as `untouched`
	     * * value is set to null
	     *
	     * You can also reset to a specific form state by passing through a standalone
	     * value or a form state object that contains both a value and a disabled state
	     * (these are the only two properties that cannot be calculated).
	     *
	     * Ex:
	     *
	     * ```ts
	     * this.control.reset('Nancy');
	     *
	     * console.log(this.control.value);  // 'Nancy'
	     * ```
	     *
	     * OR
	     *
	     * ```
	     * this.control.reset({value: 'Nancy', disabled: true});
	     *
	     * console.log(this.control.value);  // 'Nancy'
	     * console.log(this.control.status);  // 'DISABLED'
	     * ```
	     * @param {?=} formState
	     * @param {?=} options
	     * @return {?}
	     */
	    function (formState, options) {
	        if (formState === void 0) { formState = null; }
	        if (options === void 0) { options = {}; }
	        this._applyFormState(formState);
	        this.markAsPristine(options);
	        this.markAsUntouched(options);
	        this.setValue(this.value, options);
	        this._pendingChange = false;
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormControl.prototype._updateValue = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} condition
	     * @return {?}
	     */
	    FormControl.prototype._anyControls = /**
	     * \@internal
	     * @param {?} condition
	     * @return {?}
	     */
	    function (condition) { return false; };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormControl.prototype._allControlsDisabled = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { return this.disabled; };
	    /**
	     * Register a listener for change events.
	     */
	    /**
	     * Register a listener for change events.
	     * @param {?} fn
	     * @return {?}
	     */
	    FormControl.prototype.registerOnChange = /**
	     * Register a listener for change events.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onChange.push(fn); };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormControl.prototype._clearChangeFns = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        this._onChange = [];
	        this._onDisabledChange = [];
	        this._onCollectionChange = function () { };
	    };
	    /**
	     * Register a listener for disabled events.
	     */
	    /**
	     * Register a listener for disabled events.
	     * @param {?} fn
	     * @return {?}
	     */
	    FormControl.prototype.registerOnDisabledChange = /**
	     * Register a listener for disabled events.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onDisabledChange.push(fn);
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} cb
	     * @return {?}
	     */
	    FormControl.prototype._forEachChild = /**
	     * \@internal
	     * @param {?} cb
	     * @return {?}
	     */
	    function (cb) { };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormControl.prototype._syncPendingControls = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        if (this.updateOn === 'submit') {
	            if (this._pendingDirty)
	                this.markAsDirty();
	            if (this._pendingTouched)
	                this.markAsTouched();
	            if (this._pendingChange) {
	                this.setValue(this._pendingValue, { onlySelf: true, emitModelToViewChange: false });
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * @param {?} formState
	     * @return {?}
	     */
	    FormControl.prototype._applyFormState = /**
	     * @param {?} formState
	     * @return {?}
	     */
	    function (formState) {
	        if (this._isBoxedValue(formState)) {
	            (/** @type {?} */ (this)).value = this._pendingValue = formState.value;
	            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
	                this.enable({ onlySelf: true, emitEvent: false });
	        }
	        else {
	            (/** @type {?} */ (this)).value = this._pendingValue = formState;
	        }
	    };
	    return FormControl;
	}(AbstractControl));
	/**
	 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
	 * instances.
	 *
	 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
	 * with each control name as the key.  It calculates its status by reducing the statuses
	 * of its children. For example, if one of the controls in a group is invalid, the entire
	 * group becomes invalid.
	 *
	 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {\@link FormControl} and {\@link FormArray}.
	 *
	 * \@howToUse
	 *
	 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
	 * argument. The key for each child will be the name under which it is registered.
	 *
	 * ### Example
	 *
	 * ```
	 * const form = new FormGroup({
	 *   first: new FormControl('Nancy', Validators.minLength(2)),
	 *   last: new FormControl('Drew'),
	 * });
	 *
	 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
	 * console.log(form.status);  // 'VALID'
	 * ```
	 *
	 * You can also include group-level validators as the second arg, or group-level async
	 * validators as the third arg. These come in handy when you want to perform validation
	 * that considers the value of more than one child control.
	 *
	 * ### Example
	 *
	 * ```
	 * const form = new FormGroup({
	 *   password: new FormControl('', Validators.minLength(2)),
	 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
	 * }, passwordMatchValidator);
	 *
	 *
	 * function passwordMatchValidator(g: FormGroup) {
	 *    return g.get('password').value === g.get('passwordConfirm').value
	 *       ? null : {'mismatch': true};
	 * }
	 * ```
	 *
	 * Like {\@link FormControl} instances, you can alternatively choose to pass in
	 * validators and async validators as part of an options object.
	 *
	 * ```
	 * const form = new FormGroup({
	 *   password: new FormControl('')
	 *   passwordConfirm: new FormControl('')
	 * }, {validators: passwordMatchValidator, asyncValidators: otherValidator});
	 * ```
	 *
	 * The options object can also be used to set a default value for each child
	 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
	 * group level, all child controls will default to 'blur', unless the child
	 * has explicitly specified a different `updateOn` value.
	 *
	 * ```ts
	 * const c = new FormGroup({
	 *    one: new FormControl()
	 * }, {updateOn: 'blur'});
	 * ```
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * \@stable
	 */
	var FormGroup = /** @class */ (function (_super) {
	    __extends(FormGroup, _super);
	    function FormGroup(controls, validatorOrOpts, asyncValidator) {
	        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
	        _this.controls = controls;
	        _this._initObservables();
	        _this._setUpdateStrategy(validatorOrOpts);
	        _this._setUpControls();
	        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        return _this;
	    }
	    /**
	     * Registers a control with the group's list of controls.
	     *
	     * This method does not update the value or validity of the control, so for most cases you'll want
	     * to use {@link FormGroup#addControl addControl} instead.
	     */
	    /**
	     * Registers a control with the group's list of controls.
	     *
	     * This method does not update the value or validity of the control, so for most cases you'll want
	     * to use {\@link FormGroup#addControl addControl} instead.
	     * @param {?} name
	     * @param {?} control
	     * @return {?}
	     */
	    FormGroup.prototype.registerControl = /**
	     * Registers a control with the group's list of controls.
	     *
	     * This method does not update the value or validity of the control, so for most cases you'll want
	     * to use {\@link FormGroup#addControl addControl} instead.
	     * @param {?} name
	     * @param {?} control
	     * @return {?}
	     */
	    function (name, control) {
	        if (this.controls[name])
	            return this.controls[name];
	        this.controls[name] = control;
	        control.setParent(this);
	        control._registerOnCollectionChange(this._onCollectionChange);
	        return control;
	    };
	    /**
	     * Add a control to this group.
	     */
	    /**
	     * Add a control to this group.
	     * @param {?} name
	     * @param {?} control
	     * @return {?}
	     */
	    FormGroup.prototype.addControl = /**
	     * Add a control to this group.
	     * @param {?} name
	     * @param {?} control
	     * @return {?}
	     */
	    function (name, control) {
	        this.registerControl(name, control);
	        this.updateValueAndValidity();
	        this._onCollectionChange();
	    };
	    /**
	     * Remove a control from this group.
	     */
	    /**
	     * Remove a control from this group.
	     * @param {?} name
	     * @return {?}
	     */
	    FormGroup.prototype.removeControl = /**
	     * Remove a control from this group.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (this.controls[name])
	            this.controls[name]._registerOnCollectionChange(function () { });
	        delete (this.controls[name]);
	        this.updateValueAndValidity();
	        this._onCollectionChange();
	    };
	    /**
	     * Replace an existing control.
	     */
	    /**
	     * Replace an existing control.
	     * @param {?} name
	     * @param {?} control
	     * @return {?}
	     */
	    FormGroup.prototype.setControl = /**
	     * Replace an existing control.
	     * @param {?} name
	     * @param {?} control
	     * @return {?}
	     */
	    function (name, control) {
	        if (this.controls[name])
	            this.controls[name]._registerOnCollectionChange(function () { });
	        delete (this.controls[name]);
	        if (control)
	            this.registerControl(name, control);
	        this.updateValueAndValidity();
	        this._onCollectionChange();
	    };
	    /**
	     * Check whether there is an enabled control with the given name in the group.
	     *
	     * It will return false for disabled controls. If you'd like to check for existence in the group
	     * only, use {@link AbstractControl#get get} instead.
	     */
	    /**
	     * Check whether there is an enabled control with the given name in the group.
	     *
	     * It will return false for disabled controls. If you'd like to check for existence in the group
	     * only, use {\@link AbstractControl#get get} instead.
	     * @param {?} controlName
	     * @return {?}
	     */
	    FormGroup.prototype.contains = /**
	     * Check whether there is an enabled control with the given name in the group.
	     *
	     * It will return false for disabled controls. If you'd like to check for existence in the group
	     * only, use {\@link AbstractControl#get get} instead.
	     * @param {?} controlName
	     * @return {?}
	     */
	    function (controlName) {
	        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
	    };
	    /**
	     *  Sets the value of the {@link FormGroup}. It accepts an object that matches
	     *  the structure of the group, with control names as keys.
	     *
	     * This method performs strict checks, so it will throw an error if you try
	     * to set the value of a control that doesn't exist or if you exclude the
	     * value of a control.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const form = new FormGroup({
	     *     first: new FormControl(),
	     *     last: new FormControl()
	     *  });
	     *  console.log(form.value);   // {first: null, last: null}
	     *
	     *  form.setValue({first: 'Nancy', last: 'Drew'});
	     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
	     *
	     *  ```
	     */
	    /**
	     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
	     *  the structure of the group, with control names as keys.
	     *
	     * This method performs strict checks, so it will throw an error if you try
	     * to set the value of a control that doesn't exist or if you exclude the
	     * value of a control.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const form = new FormGroup({
	     *     first: new FormControl(),
	     *     last: new FormControl()
	     *  });
	     *  console.log(form.value);   // {first: null, last: null}
	     *
	     *  form.setValue({first: 'Nancy', last: 'Drew'});
	     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
	     *
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormGroup.prototype.setValue = /**
	     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
	     *  the structure of the group, with control names as keys.
	     *
	     * This method performs strict checks, so it will throw an error if you try
	     * to set the value of a control that doesn't exist or if you exclude the
	     * value of a control.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const form = new FormGroup({
	     *     first: new FormControl(),
	     *     last: new FormControl()
	     *  });
	     *  console.log(form.value);   // {first: null, last: null}
	     *
	     *  form.setValue({first: 'Nancy', last: 'Drew'});
	     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
	     *
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        this._checkAllValuesPresent(value);
	        Object.keys(value).forEach(function (name) {
	            _this._throwIfControlMissing(name);
	            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
	        });
	        this.updateValueAndValidity(options);
	    };
	    /**
	     *  Patches the value of the {@link FormGroup}. It accepts an object with control
	     *  names as keys, and will do its best to match the values to the correct controls
	     *  in the group.
	     *
	     *  It accepts both super-sets and sub-sets of the group without throwing an error.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const form = new FormGroup({
	     *     first: new FormControl(),
	     *     last: new FormControl()
	     *  });
	     *  console.log(form.value);   // {first: null, last: null}
	     *
	     *  form.patchValue({first: 'Nancy'});
	     *  console.log(form.value);   // {first: 'Nancy', last: null}
	     *
	     *  ```
	     */
	    /**
	     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
	     *  names as keys, and will do its best to match the values to the correct controls
	     *  in the group.
	     *
	     *  It accepts both super-sets and sub-sets of the group without throwing an error.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const form = new FormGroup({
	     *     first: new FormControl(),
	     *     last: new FormControl()
	     *  });
	     *  console.log(form.value);   // {first: null, last: null}
	     *
	     *  form.patchValue({first: 'Nancy'});
	     *  console.log(form.value);   // {first: 'Nancy', last: null}
	     *
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormGroup.prototype.patchValue = /**
	     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
	     *  names as keys, and will do its best to match the values to the correct controls
	     *  in the group.
	     *
	     *  It accepts both super-sets and sub-sets of the group without throwing an error.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const form = new FormGroup({
	     *     first: new FormControl(),
	     *     last: new FormControl()
	     *  });
	     *  console.log(form.value);   // {first: null, last: null}
	     *
	     *  form.patchValue({first: 'Nancy'});
	     *  console.log(form.value);   // {first: 'Nancy', last: null}
	     *
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        Object.keys(value).forEach(function (name) {
	            if (_this.controls[name]) {
	                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
	            }
	        });
	        this.updateValueAndValidity(options);
	    };
	    /**
	     * Resets the {@link FormGroup}. This means by default:
	     *
	     * * The group and all descendants are marked `pristine`
	     * * The group and all descendants are marked `untouched`
	     * * The value of all descendants will be null or null maps
	     *
	     * You can also reset to a specific form state by passing in a map of states
	     * that matches the structure of your form, with control names as keys. The state
	     * can be a standalone value or a form state object with both a value and a disabled
	     * status.
	     *
	     * ### Example
	     *
	     * ```ts
	     * this.form.reset({first: 'name', last: 'last name'});
	     *
	     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	     * ```
	     *
	     * - OR -
	     *
	     * ```
	     * this.form.reset({
	     *   first: {value: 'name', disabled: true},
	     *   last: 'last'
	     * });
	     *
	     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	     * console.log(this.form.get('first').status);  // 'DISABLED'
	     * ```
	     */
	    /**
	     * Resets the {\@link FormGroup}. This means by default:
	     *
	     * * The group and all descendants are marked `pristine`
	     * * The group and all descendants are marked `untouched`
	     * * The value of all descendants will be null or null maps
	     *
	     * You can also reset to a specific form state by passing in a map of states
	     * that matches the structure of your form, with control names as keys. The state
	     * can be a standalone value or a form state object with both a value and a disabled
	     * status.
	     *
	     * ### Example
	     *
	     * ```ts
	     * this.form.reset({first: 'name', last: 'last name'});
	     *
	     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	     * ```
	     *
	     * - OR -
	     *
	     * ```
	     * this.form.reset({
	     *   first: {value: 'name', disabled: true},
	     *   last: 'last'
	     * });
	     *
	     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	     * console.log(this.form.get('first').status);  // 'DISABLED'
	     * ```
	     * @param {?=} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormGroup.prototype.reset = /**
	     * Resets the {\@link FormGroup}. This means by default:
	     *
	     * * The group and all descendants are marked `pristine`
	     * * The group and all descendants are marked `untouched`
	     * * The value of all descendants will be null or null maps
	     *
	     * You can also reset to a specific form state by passing in a map of states
	     * that matches the structure of your form, with control names as keys. The state
	     * can be a standalone value or a form state object with both a value and a disabled
	     * status.
	     *
	     * ### Example
	     *
	     * ```ts
	     * this.form.reset({first: 'name', last: 'last name'});
	     *
	     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	     * ```
	     *
	     * - OR -
	     *
	     * ```
	     * this.form.reset({
	     *   first: {value: 'name', disabled: true},
	     *   last: 'last'
	     * });
	     *
	     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	     * console.log(this.form.get('first').status);  // 'DISABLED'
	     * ```
	     * @param {?=} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        if (value === void 0) { value = {}; }
	        if (options === void 0) { options = {}; }
	        this._forEachChild(function (control, name) {
	            control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
	        });
	        this.updateValueAndValidity(options);
	        this._updatePristine(options);
	        this._updateTouched(options);
	    };
	    /**
	     * The aggregate value of the {@link FormGroup}, including any disabled controls.
	     *
	     * If you'd like to include all values regardless of disabled status, use this method.
	     * Otherwise, the `value` property is the best way to get the value of the group.
	     */
	    /**
	     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
	     *
	     * If you'd like to include all values regardless of disabled status, use this method.
	     * Otherwise, the `value` property is the best way to get the value of the group.
	     * @return {?}
	     */
	    FormGroup.prototype.getRawValue = /**
	     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
	     *
	     * If you'd like to include all values regardless of disabled status, use this method.
	     * Otherwise, the `value` property is the best way to get the value of the group.
	     * @return {?}
	     */
	    function () {
	        return this._reduceChildren({}, function (acc, control, name) {
	            acc[name] = control instanceof FormControl ? control.value : (/** @type {?} */ (control)).getRawValue();
	            return acc;
	        });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroup.prototype._syncPendingControls = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ subtreeUpdated = this._reduceChildren(false, function (updated, child) {
	            return child._syncPendingControls() ? true : updated;
	        });
	        if (subtreeUpdated)
	            this.updateValueAndValidity({ onlySelf: true });
	        return subtreeUpdated;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} name
	     * @return {?}
	     */
	    FormGroup.prototype._throwIfControlMissing = /**
	     * \@internal
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        if (!Object.keys(this.controls).length) {
	            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	        }
	        if (!this.controls[name]) {
	            throw new Error("Cannot find form control with name: " + name + ".");
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} cb
	     * @return {?}
	     */
	    FormGroup.prototype._forEachChild = /**
	     * \@internal
	     * @param {?} cb
	     * @return {?}
	     */
	    function (cb) {
	        var _this = this;
	        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroup.prototype._setUpControls = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._forEachChild(function (control) {
	            control.setParent(_this);
	            control._registerOnCollectionChange(_this._onCollectionChange);
	        });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroup.prototype._updateValue = /**
	     * \@internal
	     * @return {?}
	     */
	    function () { (/** @type {?} */ (this)).value = this._reduceValue(); };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} condition
	     * @return {?}
	     */
	    FormGroup.prototype._anyControls = /**
	     * \@internal
	     * @param {?} condition
	     * @return {?}
	     */
	    function (condition) {
	        var _this = this;
	        var /** @type {?} */ res = false;
	        this._forEachChild(function (control, name) {
	            res = res || (_this.contains(name) && condition(control));
	        });
	        return res;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroup.prototype._reduceValue = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        return this._reduceChildren({}, function (acc, control, name) {
	            if (control.enabled || _this.disabled) {
	                acc[name] = control.value;
	            }
	            return acc;
	        });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} initValue
	     * @param {?} fn
	     * @return {?}
	     */
	    FormGroup.prototype._reduceChildren = /**
	     * \@internal
	     * @param {?} initValue
	     * @param {?} fn
	     * @return {?}
	     */
	    function (initValue, fn) {
	        var /** @type {?} */ res = initValue;
	        this._forEachChild(function (control, name) { res = fn(res, control, name); });
	        return res;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroup.prototype._allControlsDisabled = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
	            var controlName = _a[_i];
	            if (this.controls[controlName].enabled) {
	                return false;
	            }
	        }
	        return Object.keys(this.controls).length > 0 || this.disabled;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    FormGroup.prototype._checkAllValuesPresent = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._forEachChild(function (control, name) {
	            if (value[name] === undefined) {
	                throw new Error("Must supply a value for form control with name: '" + name + "'.");
	            }
	        });
	    };
	    return FormGroup;
	}(AbstractControl));
	/**
	 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
	 * {\@link FormGroup} or {\@link FormArray} instances.
	 *
	 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
	 * It calculates its status by reducing the statuses of its children. For example, if one of
	 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
	 *
	 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {\@link FormControl} and {\@link FormGroup}.
	 *
	 * \@howToUse
	 *
	 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
	 * argument.
	 *
	 * ### Example
	 *
	 * ```
	 * const arr = new FormArray([
	 *   new FormControl('Nancy', Validators.minLength(2)),
	 *   new FormControl('Drew'),
	 * ]);
	 *
	 * console.log(arr.value);   // ['Nancy', 'Drew']
	 * console.log(arr.status);  // 'VALID'
	 * ```
	 *
	 * You can also include array-level validators and async validators. These come in handy
	 * when you want to perform validation that considers the value of more than one child
	 * control.
	 *
	 * The two types of validators can be passed in separately as the second and third arg
	 * respectively, or together as part of an options object.
	 *
	 * ```
	 * const arr = new FormArray([
	 *   new FormControl('Nancy'),
	 *   new FormControl('Drew')
	 * ], {validators: myValidator, asyncValidators: myAsyncValidator});
	 * ```
	 *
	 * The options object can also be used to set a default value for each child
	 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
	 * array level, all child controls will default to 'blur', unless the child
	 * has explicitly specified a different `updateOn` value.
	 *
	 * ```ts
	 * const c = new FormArray([
	 *    new FormControl()
	 * ], {updateOn: 'blur'});
	 * ```
	 *
	 * ### Adding or removing controls
	 *
	 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	 * the `FormArray` directly, as that will result in strange and unexpected behavior such
	 * as broken change detection.
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * \@stable
	 */
	var FormArray = /** @class */ (function (_super) {
	    __extends(FormArray, _super);
	    function FormArray(controls, validatorOrOpts, asyncValidator) {
	        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
	        _this.controls = controls;
	        _this._initObservables();
	        _this._setUpdateStrategy(validatorOrOpts);
	        _this._setUpControls();
	        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        return _this;
	    }
	    /**
	     * Get the {@link AbstractControl} at the given `index` in the array.
	     */
	    /**
	     * Get the {\@link AbstractControl} at the given `index` in the array.
	     * @param {?} index
	     * @return {?}
	     */
	    FormArray.prototype.at = /**
	     * Get the {\@link AbstractControl} at the given `index` in the array.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) { return this.controls[index]; };
	    /**
	     * Insert a new {@link AbstractControl} at the end of the array.
	     */
	    /**
	     * Insert a new {\@link AbstractControl} at the end of the array.
	     * @param {?} control
	     * @return {?}
	     */
	    FormArray.prototype.push = /**
	     * Insert a new {\@link AbstractControl} at the end of the array.
	     * @param {?} control
	     * @return {?}
	     */
	    function (control) {
	        this.controls.push(control);
	        this._registerControl(control);
	        this.updateValueAndValidity();
	        this._onCollectionChange();
	    };
	    /** Insert a new {@link AbstractControl} at the given `index` in the array. */
	    /**
	     * Insert a new {\@link AbstractControl} at the given `index` in the array.
	     * @param {?} index
	     * @param {?} control
	     * @return {?}
	     */
	    FormArray.prototype.insert = /**
	     * Insert a new {\@link AbstractControl} at the given `index` in the array.
	     * @param {?} index
	     * @param {?} control
	     * @return {?}
	     */
	    function (index, control) {
	        this.controls.splice(index, 0, control);
	        this._registerControl(control);
	        this.updateValueAndValidity();
	    };
	    /** Remove the control at the given `index` in the array. */
	    /**
	     * Remove the control at the given `index` in the array.
	     * @param {?} index
	     * @return {?}
	     */
	    FormArray.prototype.removeAt = /**
	     * Remove the control at the given `index` in the array.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        if (this.controls[index])
	            this.controls[index]._registerOnCollectionChange(function () { });
	        this.controls.splice(index, 1);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Replace an existing control.
	     */
	    /**
	     * Replace an existing control.
	     * @param {?} index
	     * @param {?} control
	     * @return {?}
	     */
	    FormArray.prototype.setControl = /**
	     * Replace an existing control.
	     * @param {?} index
	     * @param {?} control
	     * @return {?}
	     */
	    function (index, control) {
	        if (this.controls[index])
	            this.controls[index]._registerOnCollectionChange(function () { });
	        this.controls.splice(index, 1);
	        if (control) {
	            this.controls.splice(index, 0, control);
	            this._registerControl(control);
	        }
	        this.updateValueAndValidity();
	        this._onCollectionChange();
	    };
	    Object.defineProperty(FormArray.prototype, "length", {
	        /**
	         * Length of the control array.
	         */
	        get: /**
	         * Length of the control array.
	         * @return {?}
	         */
	        function () { return this.controls.length; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     *  Sets the value of the {@link FormArray}. It accepts an array that matches
	     *  the structure of the control.
	     *
	     * This method performs strict checks, so it will throw an error if you try
	     * to set the value of a control that doesn't exist or if you exclude the
	     * value of a control.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const arr = new FormArray([
	     *     new FormControl(),
	     *     new FormControl()
	     *  ]);
	     *  console.log(arr.value);   // [null, null]
	     *
	     *  arr.setValue(['Nancy', 'Drew']);
	     *  console.log(arr.value);   // ['Nancy', 'Drew']
	     *  ```
	     */
	    /**
	     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
	     *  the structure of the control.
	     *
	     * This method performs strict checks, so it will throw an error if you try
	     * to set the value of a control that doesn't exist or if you exclude the
	     * value of a control.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const arr = new FormArray([
	     *     new FormControl(),
	     *     new FormControl()
	     *  ]);
	     *  console.log(arr.value);   // [null, null]
	     *
	     *  arr.setValue(['Nancy', 'Drew']);
	     *  console.log(arr.value);   // ['Nancy', 'Drew']
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormArray.prototype.setValue = /**
	     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
	     *  the structure of the control.
	     *
	     * This method performs strict checks, so it will throw an error if you try
	     * to set the value of a control that doesn't exist or if you exclude the
	     * value of a control.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const arr = new FormArray([
	     *     new FormControl(),
	     *     new FormControl()
	     *  ]);
	     *  console.log(arr.value);   // [null, null]
	     *
	     *  arr.setValue(['Nancy', 'Drew']);
	     *  console.log(arr.value);   // ['Nancy', 'Drew']
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        this._checkAllValuesPresent(value);
	        value.forEach(function (newValue, index) {
	            _this._throwIfControlMissing(index);
	            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
	        });
	        this.updateValueAndValidity(options);
	    };
	    /**
	     *  Patches the value of the {@link FormArray}. It accepts an array that matches the
	     *  structure of the control, and will do its best to match the values to the correct
	     *  controls in the group.
	     *
	     *  It accepts both super-sets and sub-sets of the array without throwing an error.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const arr = new FormArray([
	     *     new FormControl(),
	     *     new FormControl()
	     *  ]);
	     *  console.log(arr.value);   // [null, null]
	     *
	     *  arr.patchValue(['Nancy']);
	     *  console.log(arr.value);   // ['Nancy', null]
	     *  ```
	     */
	    /**
	     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
	     *  structure of the control, and will do its best to match the values to the correct
	     *  controls in the group.
	     *
	     *  It accepts both super-sets and sub-sets of the array without throwing an error.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const arr = new FormArray([
	     *     new FormControl(),
	     *     new FormControl()
	     *  ]);
	     *  console.log(arr.value);   // [null, null]
	     *
	     *  arr.patchValue(['Nancy']);
	     *  console.log(arr.value);   // ['Nancy', null]
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormArray.prototype.patchValue = /**
	     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
	     *  structure of the control, and will do its best to match the values to the correct
	     *  controls in the group.
	     *
	     *  It accepts both super-sets and sub-sets of the array without throwing an error.
	     *
	     *  ### Example
	     *
	     *  ```
	     *  const arr = new FormArray([
	     *     new FormControl(),
	     *     new FormControl()
	     *  ]);
	     *  console.log(arr.value);   // [null, null]
	     *
	     *  arr.patchValue(['Nancy']);
	     *  console.log(arr.value);   // ['Nancy', null]
	     *  ```
	     * @param {?} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        value.forEach(function (newValue, index) {
	            if (_this.at(index)) {
	                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
	            }
	        });
	        this.updateValueAndValidity(options);
	    };
	    /**
	     * Resets the {@link FormArray}. This means by default:
	     *
	     * * The array and all descendants are marked `pristine`
	     * * The array and all descendants are marked `untouched`
	     * * The value of all descendants will be null or null maps
	     *
	     * You can also reset to a specific form state by passing in an array of states
	     * that matches the structure of the control. The state can be a standalone value
	     * or a form state object with both a value and a disabled status.
	     *
	     * ### Example
	     *
	     * ```ts
	     * this.arr.reset(['name', 'last name']);
	     *
	     * console.log(this.arr.value);  // ['name', 'last name']
	     * ```
	     *
	     * - OR -
	     *
	     * ```
	     * this.arr.reset([
	     *   {value: 'name', disabled: true},
	     *   'last'
	     * ]);
	     *
	     * console.log(this.arr.value);  // ['name', 'last name']
	     * console.log(this.arr.get(0).status);  // 'DISABLED'
	     * ```
	     */
	    /**
	     * Resets the {\@link FormArray}. This means by default:
	     *
	     * * The array and all descendants are marked `pristine`
	     * * The array and all descendants are marked `untouched`
	     * * The value of all descendants will be null or null maps
	     *
	     * You can also reset to a specific form state by passing in an array of states
	     * that matches the structure of the control. The state can be a standalone value
	     * or a form state object with both a value and a disabled status.
	     *
	     * ### Example
	     *
	     * ```ts
	     * this.arr.reset(['name', 'last name']);
	     *
	     * console.log(this.arr.value);  // ['name', 'last name']
	     * ```
	     *
	     * - OR -
	     *
	     * ```
	     * this.arr.reset([
	     *   {value: 'name', disabled: true},
	     *   'last'
	     * ]);
	     *
	     * console.log(this.arr.value);  // ['name', 'last name']
	     * console.log(this.arr.get(0).status);  // 'DISABLED'
	     * ```
	     * @param {?=} value
	     * @param {?=} options
	     * @return {?}
	     */
	    FormArray.prototype.reset = /**
	     * Resets the {\@link FormArray}. This means by default:
	     *
	     * * The array and all descendants are marked `pristine`
	     * * The array and all descendants are marked `untouched`
	     * * The value of all descendants will be null or null maps
	     *
	     * You can also reset to a specific form state by passing in an array of states
	     * that matches the structure of the control. The state can be a standalone value
	     * or a form state object with both a value and a disabled status.
	     *
	     * ### Example
	     *
	     * ```ts
	     * this.arr.reset(['name', 'last name']);
	     *
	     * console.log(this.arr.value);  // ['name', 'last name']
	     * ```
	     *
	     * - OR -
	     *
	     * ```
	     * this.arr.reset([
	     *   {value: 'name', disabled: true},
	     *   'last'
	     * ]);
	     *
	     * console.log(this.arr.value);  // ['name', 'last name']
	     * console.log(this.arr.get(0).status);  // 'DISABLED'
	     * ```
	     * @param {?=} value
	     * @param {?=} options
	     * @return {?}
	     */
	    function (value, options) {
	        if (value === void 0) { value = []; }
	        if (options === void 0) { options = {}; }
	        this._forEachChild(function (control, index) {
	            control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
	        });
	        this.updateValueAndValidity(options);
	        this._updatePristine(options);
	        this._updateTouched(options);
	    };
	    /**
	     * The aggregate value of the array, including any disabled controls.
	     *
	     * If you'd like to include all values regardless of disabled status, use this method.
	     * Otherwise, the `value` property is the best way to get the value of the array.
	     */
	    /**
	     * The aggregate value of the array, including any disabled controls.
	     *
	     * If you'd like to include all values regardless of disabled status, use this method.
	     * Otherwise, the `value` property is the best way to get the value of the array.
	     * @return {?}
	     */
	    FormArray.prototype.getRawValue = /**
	     * The aggregate value of the array, including any disabled controls.
	     *
	     * If you'd like to include all values regardless of disabled status, use this method.
	     * Otherwise, the `value` property is the best way to get the value of the array.
	     * @return {?}
	     */
	    function () {
	        return this.controls.map(function (control) {
	            return control instanceof FormControl ? control.value : (/** @type {?} */ (control)).getRawValue();
	        });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormArray.prototype._syncPendingControls = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ subtreeUpdated = this.controls.reduce(function (updated, child) {
	            return child._syncPendingControls() ? true : updated;
	        }, false);
	        if (subtreeUpdated)
	            this.updateValueAndValidity({ onlySelf: true });
	        return subtreeUpdated;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} index
	     * @return {?}
	     */
	    FormArray.prototype._throwIfControlMissing = /**
	     * \@internal
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        if (!this.controls.length) {
	            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	        }
	        if (!this.at(index)) {
	            throw new Error("Cannot find form control at index " + index);
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} cb
	     * @return {?}
	     */
	    FormArray.prototype._forEachChild = /**
	     * \@internal
	     * @param {?} cb
	     * @return {?}
	     */
	    function (cb) {
	        this.controls.forEach(function (control, index) { cb(control, index); });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormArray.prototype._updateValue = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        (/** @type {?} */ (this)).value =
	            this.controls.filter(function (control) { return control.enabled || _this.disabled; })
	                .map(function (control) { return control.value; });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} condition
	     * @return {?}
	     */
	    FormArray.prototype._anyControls = /**
	     * \@internal
	     * @param {?} condition
	     * @return {?}
	     */
	    function (condition) {
	        return this.controls.some(function (control) { return control.enabled && condition(control); });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormArray.prototype._setUpControls = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._forEachChild(function (control) { return _this._registerControl(control); });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    FormArray.prototype._checkAllValuesPresent = /**
	     * \@internal
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this._forEachChild(function (control, i) {
	            if (value[i] === undefined) {
	                throw new Error("Must supply a value for form control at index: " + i + ".");
	            }
	        });
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormArray.prototype._allControlsDisabled = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
	            var control = _a[_i];
	            if (control.enabled)
	                return false;
	        }
	        return this.controls.length > 0 || this.disabled;
	    };
	    /**
	     * @param {?} control
	     * @return {?}
	     */
	    FormArray.prototype._registerControl = /**
	     * @param {?} control
	     * @return {?}
	     */
	    function (control) {
	        control.setParent(this);
	        control._registerOnCollectionChange(this._onCollectionChange);
	    };
	    return FormArray;
	}(AbstractControl));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var formDirectiveProvider = {
	    provide: ControlContainer,
	    useExisting: _angular_core.forwardRef(function () { return NgForm; })
	};
	var resolvedPromise = Promise.resolve(null);
	/**
	 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
	 * to track aggregate form value and validation status.
	 *
	 * \@howToUse
	 *
	 * As soon as you import the `FormsModule`, this directive becomes active by default on
	 * all `<form>` tags.  You don't need to add a special selector.
	 *
	 * You can export the directive into a local template variable using `ngForm` as the key
	 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
	 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
	 * will give you access to the aggregate value and validity status of the form, as well as
	 * user interaction properties like `dirty` and `touched`.
	 *
	 * To register child controls with the form, you'll want to use {\@link NgModel} with a
	 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
	 * sub-groups within the form.
	 *
	 * You can listen to the directive's `ngSubmit` event to be notified when the user has
	 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
	 * submission event.
	 *
	 * In template driven forms, all `<form>` tags are automatically tagged as `NgForm`.
	 * If you want to import the `FormsModule` but skip its usage in some forms,
	 * for example, to use native HTML5 validation, you can add `ngNoForm` and the `<form>`
	 * tags won't create an `NgForm` directive. In reactive forms, using `ngNoForm` is
	 * unnecessary because the `<form>` tags are inert. In that case, you would
	 * refrain from using the `formGroup` directive.
	 *
	 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * * **NgModule**: `FormsModule`
	 *
	 *  \@stable
	 */
	var NgForm = /** @class */ (function (_super) {
	    __extends(NgForm, _super);
	    function NgForm(validators, asyncValidators) {
	        var _this = _super.call(this) || this;
	        _this.submitted = false;
	        _this._directives = [];
	        _this.ngSubmit = new _angular_core.EventEmitter();
	        _this.form =
	            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    NgForm.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () { this._setUpdateStrategy(); };
	    Object.defineProperty(NgForm.prototype, "formDirective", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "control", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "path", {
	        get: /**
	         * @return {?}
	         */
	        function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "controls", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.form.controls; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    NgForm.prototype.addControl = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var _this = this;
	        resolvedPromise.then(function () {
	            var /** @type {?} */ container = _this._findContainer(dir.path);
	            (/** @type {?} */ (dir)).control = /** @type {?} */ (container.registerControl(dir.name, dir.control));
	            setUpControl(dir.control, dir);
	            dir.control.updateValueAndValidity({ emitEvent: false });
	            _this._directives.push(dir);
	        });
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    NgForm.prototype.getControl = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    NgForm.prototype.removeControl = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var _this = this;
	        resolvedPromise.then(function () {
	            var /** @type {?} */ container = _this._findContainer(dir.path);
	            if (container) {
	                container.removeControl(dir.name);
	            }
	            removeDir(_this._directives, dir);
	        });
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    NgForm.prototype.addFormGroup = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var _this = this;
	        resolvedPromise.then(function () {
	            var /** @type {?} */ container = _this._findContainer(dir.path);
	            var /** @type {?} */ group = new FormGroup({});
	            setUpFormContainer(group, dir);
	            container.registerControl(dir.name, group);
	            group.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    NgForm.prototype.removeFormGroup = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var _this = this;
	        resolvedPromise.then(function () {
	            var /** @type {?} */ container = _this._findContainer(dir.path);
	            if (container) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    NgForm.prototype.getFormGroup = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
	    /**
	     * @param {?} dir
	     * @param {?} value
	     * @return {?}
	     */
	    NgForm.prototype.updateModel = /**
	     * @param {?} dir
	     * @param {?} value
	     * @return {?}
	     */
	    function (dir, value) {
	        var _this = this;
	        resolvedPromise.then(function () {
	            var /** @type {?} */ ctrl = /** @type {?} */ (_this.form.get(/** @type {?} */ ((dir.path))));
	            ctrl.setValue(value);
	        });
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    NgForm.prototype.setValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { this.control.setValue(value); };
	    /**
	     * @param {?} $event
	     * @return {?}
	     */
	    NgForm.prototype.onSubmit = /**
	     * @param {?} $event
	     * @return {?}
	     */
	    function ($event) {
	        (/** @type {?} */ (this)).submitted = true;
	        syncPendingControls(this.form, this._directives);
	        this.ngSubmit.emit($event);
	        return false;
	    };
	    /**
	     * @return {?}
	     */
	    NgForm.prototype.onReset = /**
	     * @return {?}
	     */
	    function () { this.resetForm(); };
	    /**
	     * @param {?=} value
	     * @return {?}
	     */
	    NgForm.prototype.resetForm = /**
	     * @param {?=} value
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = undefined; }
	        this.form.reset(value);
	        (/** @type {?} */ (this)).submitted = false;
	    };
	    /**
	     * @return {?}
	     */
	    NgForm.prototype._setUpdateStrategy = /**
	     * @return {?}
	     */
	    function () {
	        if (this.options && this.options.updateOn != null) {
	            this.form._updateOn = this.options.updateOn;
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} path
	     * @return {?}
	     */
	    NgForm.prototype._findContainer = /**
	     * \@internal
	     * @param {?} path
	     * @return {?}
	     */
	    function (path) {
	        path.pop();
	        return path.length ? /** @type {?} */ (this.form.get(path)) : this.form;
	    };
	    NgForm.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                    providers: [formDirectiveProvider],
	                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
	                    outputs: ['ngSubmit'],
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    NgForm.ctorParameters = function () { return [
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	    ]; };
	    NgForm.propDecorators = {
	        "options": [{ type: _angular_core.Input, args: ['ngFormOptions',] },],
	    };
	    return NgForm;
	}(ControlContainer));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var FormErrorExamples = {
	    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
	    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
	    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
	    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
	    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var TemplateDrivenErrors = /** @class */ (function () {
	    function TemplateDrivenErrors() {
	    }
	    /**
	     * @return {?}
	     */
	    TemplateDrivenErrors.modelParentException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
	    };
	    /**
	     * @return {?}
	     */
	    TemplateDrivenErrors.formGroupNameException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
	    };
	    /**
	     * @return {?}
	     */
	    TemplateDrivenErrors.missingNameException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
	    };
	    /**
	     * @return {?}
	     */
	    TemplateDrivenErrors.modelGroupParentException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
	    };
	    return TemplateDrivenErrors;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var modelGroupProvider = {
	    provide: ControlContainer,
	    useExisting: _angular_core.forwardRef(function () { return NgModelGroup; })
	};
	/**
	 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
	 *
	 * \@howToUse
	 *
	 * This directive can only be used as a child of {\@link NgForm} (or in other words,
	 * within `<form>` tags).
	 *
	 * Use this directive if you'd like to create a sub-group within a form. This can
	 * come in handy if you want to validate a sub-group of your form separately from
	 * the rest of your form, or if some values in your domain model make more sense to
	 * consume together in a nested object.
	 *
	 * Pass in the name you'd like this sub-group to have and it will become the key
	 * for the sub-group in the form's full value. You can also export the directive into
	 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
	 *
	 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * * **NgModule**: `FormsModule`
	 *
	 * \@stable
	 */
	var NgModelGroup = /** @class */ (function (_super) {
	    __extends(NgModelGroup, _super);
	    function NgModelGroup(parent, validators, asyncValidators) {
	        var _this = _super.call(this) || this;
	        _this._parent = parent;
	        _this._validators = validators;
	        _this._asyncValidators = asyncValidators;
	        return _this;
	    }
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    NgModelGroup.prototype._checkParentType = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	            TemplateDrivenErrors.modelGroupParentException();
	        }
	    };
	    NgModelGroup.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.ctorParameters = function () { return [
	        { type: ControlContainer, decorators: [{ type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	    ]; };
	    NgModelGroup.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['ngModelGroup',] },],
	    };
	    return NgModelGroup;
	}(AbstractFormGroupDirective));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var formControlBinding = {
	    provide: NgControl,
	    useExisting: _angular_core.forwardRef(function () { return NgModel; })
	};
	/**
	 * `ngModel` forces an additional change detection run when its inputs change:
	 * E.g.:
	 * ```
	 * <div>{{myModel.valid}}</div>
	 * <input [(ngModel)]="myValue" #myModel="ngModel">
	 * ```
	 * I.e. `ngModel` can export itself on the element and then be used in the template.
	 * Normally, this would result in expressions before the `input` that use the exported directive
	 * to have and old value as they have been
	 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
	 * detection run.
	 *
	 * Notes:
	 * - this is just one extra run no matter how many `ngModel` have been changed.
	 * - this is a general problem when using `exportAs` for directives!
	 */
	var resolvedPromise$1 = Promise.resolve(null);
	/**
	 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
	 * to a form control element.
	 *
	 * The {\@link FormControl} instance will track the value, user interaction, and
	 * validation status of the control and keep the view synced with the model. If used
	 * within a parent form, the directive will also register itself with the form as a child
	 * control.
	 *
	 * \@howToUse
	 *
	 * This directive can be used by itself or as part of a larger form. All you need is the
	 * `ngModel` selector to activate it.
	 *
	 * It accepts a domain model as an optional {\@link Input}. If you have a one-way binding
	 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
	 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
	 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
	 * the domain model in your class as well.
	 *
	 * If you wish to inspect the properties of the associated {\@link FormControl} (like
	 * validity state), you can also export the directive into a local template variable using
	 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
	 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
	 * will fall through to the control anyway, so you can access them directly. You can see a
	 * full list of properties directly available in {\@link AbstractControlDirective}.
	 *
	 * The following is an example of a simple standalone control using `ngModel`:
	 *
	 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
	 *
	 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
	 * so that the control can be registered with the parent form under that name.
	 *
	 * It's worth noting that in the context of a parent form, you often can skip one-way or
	 * two-way binding because the parent form will sync the value for you. You can access
	 * its properties by exporting it into a local template variable using `ngForm` (ex:
	 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
	 *
	 * If you do need to populate initial values into your form, using a one-way binding for
	 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
	 * than the domain model's value on submit.
	 *
	 * Take a look at an example of using `ngModel` within a form:
	 *
	 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	 *
	 * To see `ngModel` examples with different form control types, see:
	 *
	 * * Radio buttons: {\@link RadioControlValueAccessor}
	 * * Selects: {\@link SelectControlValueAccessor}
	 *
	 * **npm package**: `\@angular/forms`
	 *
	 * **NgModule**: `FormsModule`
	 *
	 *  \@stable
	 */
	var NgModel = /** @class */ (function (_super) {
	    __extends(NgModel, _super);
	    function NgModel(parent, validators, asyncValidators, valueAccessors) {
	        var _this = _super.call(this) || this;
	        _this.control = new FormControl();
	        /**
	         * \@internal
	         */
	        _this._registered = false;
	        _this.update = new _angular_core.EventEmitter();
	        _this._parent = parent;
	        _this._rawValidators = validators || [];
	        _this._rawAsyncValidators = asyncValidators || [];
	        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
	        return _this;
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgModel.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        this._checkForErrors();
	        if (!this._registered)
	            this._setUpControl();
	        if ('isDisabled' in changes) {
	            this._updateDisabled(changes);
	        }
	        if (isPropertyUpdated(changes, this.viewModel)) {
	            this._updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () { this.formDirective && this.formDirective.removeControl(this); };
	    Object.defineProperty(NgModel.prototype, "path", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._parent ? controlPath(this.name, this._parent) : [this.name];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "formDirective", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._parent ? this._parent.formDirective : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "validator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return composeValidators(this._rawValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "asyncValidator", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return composeAsyncValidators(this._rawAsyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} newValue
	     * @return {?}
	     */
	    NgModel.prototype.viewToModelUpdate = /**
	     * @param {?} newValue
	     * @return {?}
	     */
	    function (newValue) {
	        this.viewModel = newValue;
	        this.update.emit(newValue);
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._setUpControl = /**
	     * @return {?}
	     */
	    function () {
	        this._setUpdateStrategy();
	        this._isStandalone() ? this._setUpStandalone() :
	            this.formDirective.addControl(this);
	        this._registered = true;
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._setUpdateStrategy = /**
	     * @return {?}
	     */
	    function () {
	        if (this.options && this.options.updateOn != null) {
	            this.control._updateOn = this.options.updateOn;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._isStandalone = /**
	     * @return {?}
	     */
	    function () {
	        return !this._parent || !!(this.options && this.options.standalone);
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._setUpStandalone = /**
	     * @return {?}
	     */
	    function () {
	        setUpControl(this.control, this);
	        this.control.updateValueAndValidity({ emitEvent: false });
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._checkForErrors = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._isStandalone()) {
	            this._checkParentType();
	        }
	        this._checkName();
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._checkParentType = /**
	     * @return {?}
	     */
	    function () {
	        if (!(this._parent instanceof NgModelGroup) &&
	            this._parent instanceof AbstractFormGroupDirective) {
	            TemplateDrivenErrors.formGroupNameException();
	        }
	        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	            TemplateDrivenErrors.modelParentException();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NgModel.prototype._checkName = /**
	     * @return {?}
	     */
	    function () {
	        if (this.options && this.options.name)
	            this.name = this.options.name;
	        if (!this._isStandalone() && !this.name) {
	            TemplateDrivenErrors.missingNameException();
	        }
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    NgModel.prototype._updateValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var _this = this;
	        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    NgModel.prototype._updateDisabled = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
	        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
	        resolvedPromise$1.then(function () {
	            if (isDisabled && !_this.control.disabled) {
	                _this.control.disable();
	            }
	            else if (!isDisabled && _this.control.disabled) {
	                _this.control.enable();
	            }
	        });
	    };
	    NgModel.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[ngModel]:not([formControlName]):not([formControl])',
	                    providers: [formControlBinding],
	                    exportAs: 'ngModel'
	                },] },
	    ];
	    /** @nocollapse */
	    NgModel.ctorParameters = function () { return [
	        { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	    ]; };
	    NgModel.propDecorators = {
	        "name": [{ type: _angular_core.Input },],
	        "isDisabled": [{ type: _angular_core.Input, args: ['disabled',] },],
	        "model": [{ type: _angular_core.Input, args: ['ngModel',] },],
	        "options": [{ type: _angular_core.Input, args: ['ngModelOptions',] },],
	        "update": [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	    };
	    return NgModel;
	}(NgControl));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ReactiveErrors = /** @class */ (function () {
	    function ReactiveErrors() {
	    }
	    /**
	     * @return {?}
	     */
	    ReactiveErrors.controlParentException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
	    };
	    /**
	     * @return {?}
	     */
	    ReactiveErrors.ngModelGroupException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
	    };
	    /**
	     * @return {?}
	     */
	    ReactiveErrors.missingFormException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
	    };
	    /**
	     * @return {?}
	     */
	    ReactiveErrors.groupParentException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
	    };
	    /**
	     * @return {?}
	     */
	    ReactiveErrors.arrayParentException = /**
	     * @return {?}
	     */
	    function () {
	        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
	    };
	    /**
	     * @return {?}
	     */
	    ReactiveErrors.disabledAttrWarning = /**
	     * @return {?}
	     */
	    function () {
	        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
	    };
	    return ReactiveErrors;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var formControlBinding$1 = {
	    provide: NgControl,
	    useExisting: _angular_core.forwardRef(function () { return FormControlDirective; })
	};
	/**
	 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
	 *
	 * In other words, this directive ensures that any values written to the {\@link FormControl}
	 * instance programmatically will be written to the DOM element (model -> view). Conversely,
	 * any values written to the DOM element through user input will be reflected in the
	 * {\@link FormControl} instance (view -> model).
	 *
	 * \@howToUse
	 *
	 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
	 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
	 * {\@link FormControlDirective}.
	 *
	 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
	 * it does not require that your {\@link FormControl} instance be part of any parent
	 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
	 * exists above it.
	 *
	 * **Get the value**: the `value` property is always synced and available on the
	 * {\@link FormControl} instance. See a full list of available properties in
	 * {\@link AbstractControl}.
	 *
	 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
	 * or you can set it programmatically later using {\@link AbstractControl#setValue setValue} or
	 * {\@link AbstractControl#patchValue patchValue}.
	 *
	 * **Listen to value**: If you want to listen to changes in the value of the control, you can
	 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
	 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
	 * re-calculated.
	 *
	 * ### Example
	 *
	 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * * **NgModule**: `ReactiveFormsModule`
	 *
	 *  \@stable
	 */
	var FormControlDirective = /** @class */ (function (_super) {
	    __extends(FormControlDirective, _super);
	    function FormControlDirective(validators, asyncValidators, valueAccessors) {
	        var _this = _super.call(this) || this;
	        _this.update = new _angular_core.EventEmitter();
	        _this._rawValidators = validators || [];
	        _this._rawAsyncValidators = asyncValidators || [];
	        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
	        return _this;
	    }
	    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
	        set: /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    FormControlDirective.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (this._isControlChanged(changes)) {
	            setUpControl(this.form, this);
	            if (this.control.disabled && /** @type {?} */ ((this.valueAccessor)).setDisabledState) {
	                /** @type {?} */ ((/** @type {?} */ ((this.valueAccessor)).setDisabledState))(true);
	            }
	            this.form.updateValueAndValidity({ emitEvent: false });
	        }
	        if (isPropertyUpdated(changes, this.viewModel)) {
	            this.form.setValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    Object.defineProperty(FormControlDirective.prototype, "path", {
	        get: /**
	         * @return {?}
	         */
	        function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "validator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return composeValidators(this._rawValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return composeAsyncValidators(this._rawAsyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "control", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} newValue
	     * @return {?}
	     */
	    FormControlDirective.prototype.viewToModelUpdate = /**
	     * @param {?} newValue
	     * @return {?}
	     */
	    function (newValue) {
	        this.viewModel = newValue;
	        this.update.emit(newValue);
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    FormControlDirective.prototype._isControlChanged = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        return changes.hasOwnProperty('form');
	    };
	    FormControlDirective.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.ctorParameters = function () { return [
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	    ]; };
	    FormControlDirective.propDecorators = {
	        "form": [{ type: _angular_core.Input, args: ['formControl',] },],
	        "model": [{ type: _angular_core.Input, args: ['ngModel',] },],
	        "update": [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	        "isDisabled": [{ type: _angular_core.Input, args: ['disabled',] },],
	    };
	    return FormControlDirective;
	}(NgControl));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var formDirectiveProvider$1 = {
	    provide: ControlContainer,
	    useExisting: _angular_core.forwardRef(function () { return FormGroupDirective; })
	};
	/**
	 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
	 *
	 * \@howToUse
	 *
	 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
	 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
	 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
	 * and {\@link FormArrayName} directives.
	 *
	 * **Set value**: You can set the form's initial value when instantiating the
	 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
	 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}
	 * methods.
	 *
	 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
	 * to the {\@link FormGroup}'s {\@link AbstractControl#valueChanges valueChanges} event.  You can also
	 * listen to its {\@link AbstractControl#statusChanges statusChanges} event to be notified when the
	 * validation status is re-calculated.
	 *
	 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
	 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
	 * submission event.
	 *
	 * ### Example
	 *
	 * In this example, we create form controls for first name and last name.
	 *
	 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	 *
	 * **npm package**: `\@angular/forms`
	 *
	 * **NgModule**: {\@link ReactiveFormsModule}
	 *
	 *  \@stable
	 */
	var FormGroupDirective = /** @class */ (function (_super) {
	    __extends(FormGroupDirective, _super);
	    function FormGroupDirective(_validators, _asyncValidators) {
	        var _this = _super.call(this) || this;
	        _this._validators = _validators;
	        _this._asyncValidators = _asyncValidators;
	        _this.submitted = false;
	        _this.directives = [];
	        _this.form = /** @type {?} */ ((null));
	        _this.ngSubmit = new _angular_core.EventEmitter();
	        return _this;
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    FormGroupDirective.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        this._checkFormPresent();
	        if (changes.hasOwnProperty('form')) {
	            this._updateValidators();
	            this._updateDomValue();
	            this._updateRegistrations();
	        }
	    };
	    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "control", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "path", {
	        get: /**
	         * @return {?}
	         */
	        function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.addControl = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var /** @type {?} */ ctrl = this.form.get(dir.path);
	        setUpControl(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	        this.directives.push(dir);
	        return ctrl;
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.getControl = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.removeControl = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { removeDir(this.directives, dir); };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.addFormGroup = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var /** @type {?} */ ctrl = this.form.get(dir.path);
	        setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.removeFormGroup = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.getFormGroup = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.addFormArray = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        var /** @type {?} */ ctrl = this.form.get(dir.path);
	        setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.removeFormArray = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { };
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    FormGroupDirective.prototype.getFormArray = /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
	    /**
	     * @param {?} dir
	     * @param {?} value
	     * @return {?}
	     */
	    FormGroupDirective.prototype.updateModel = /**
	     * @param {?} dir
	     * @param {?} value
	     * @return {?}
	     */
	    function (dir, value) {
	        var /** @type {?} */ ctrl = /** @type {?} */ (this.form.get(dir.path));
	        ctrl.setValue(value);
	    };
	    /**
	     * @param {?} $event
	     * @return {?}
	     */
	    FormGroupDirective.prototype.onSubmit = /**
	     * @param {?} $event
	     * @return {?}
	     */
	    function ($event) {
	        (/** @type {?} */ (this)).submitted = true;
	        syncPendingControls(this.form, this.directives);
	        this.ngSubmit.emit($event);
	        return false;
	    };
	    /**
	     * @return {?}
	     */
	    FormGroupDirective.prototype.onReset = /**
	     * @return {?}
	     */
	    function () { this.resetForm(); };
	    /**
	     * @param {?=} value
	     * @return {?}
	     */
	    FormGroupDirective.prototype.resetForm = /**
	     * @param {?=} value
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = undefined; }
	        this.form.reset(value);
	        (/** @type {?} */ (this)).submitted = false;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroupDirective.prototype._updateDomValue = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.directives.forEach(function (dir) {
	            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
	            if (dir.control !== newCtrl) {
	                cleanUpControl(dir.control, dir);
	                if (newCtrl)
	                    setUpControl(newCtrl, dir);
	                (/** @type {?} */ (dir)).control = newCtrl;
	            }
	        });
	        this.form._updateTreeValidity({ emitEvent: false });
	    };
	    /**
	     * @return {?}
	     */
	    FormGroupDirective.prototype._updateRegistrations = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
	        if (this._oldForm)
	            this._oldForm._registerOnCollectionChange(function () { });
	        this._oldForm = this.form;
	    };
	    /**
	     * @return {?}
	     */
	    FormGroupDirective.prototype._updateValidators = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ sync = composeValidators(this._validators);
	        this.form.validator = Validators.compose([/** @type {?} */ ((this.form.validator)), /** @type {?} */ ((sync))]);
	        var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
	        this.form.asyncValidator = Validators.composeAsync([/** @type {?} */ ((this.form.asyncValidator)), /** @type {?} */ ((async))]);
	    };
	    /**
	     * @return {?}
	     */
	    FormGroupDirective.prototype._checkFormPresent = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.form) {
	            ReactiveErrors.missingFormException();
	        }
	    };
	    FormGroupDirective.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[formGroup]',
	                    providers: [formDirectiveProvider$1],
	                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.ctorParameters = function () { return [
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	    ]; };
	    FormGroupDirective.propDecorators = {
	        "form": [{ type: _angular_core.Input, args: ['formGroup',] },],
	        "ngSubmit": [{ type: _angular_core.Output },],
	    };
	    return FormGroupDirective;
	}(ControlContainer));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var formGroupNameProvider = {
	    provide: ControlContainer,
	    useExisting: _angular_core.forwardRef(function () { return FormGroupName; })
	};
	/**
	 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
	 *
	 * \@howToUse
	 *
	 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
	 * `[formGroup]`).
	 *
	 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
	 * will look for a {\@link FormGroup} registered with that name in the parent
	 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
	 *
	 * Nested form groups can come in handy when you want to validate a sub-group of a
	 * form separately from the rest or when you'd like to group the values of certain
	 * controls into their own nested object.
	 *
	 * **Access the group**: You can access the associated {\@link FormGroup} using the
	 * {\@link AbstractControl#get get} method. Ex: `this.form.get('name')`.
	 *
	 * You can also access individual controls within the group using dot syntax.
	 * Ex: `this.form.get('name.first')`
	 *
	 * **Get the value**: the `value` property is always synced and available on the
	 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
	 *
	 * **Set the value**: You can set an initial value for each child control when instantiating
	 * the {\@link FormGroup}, or you can set it programmatically later using
	 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
	 *
	 * **Listen to value**: If you want to listen to changes in the value of the group, you can
	 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
	 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
	 * re-calculated.
	 *
	 * ### Example
	 *
	 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * * **NgModule**: `ReactiveFormsModule`
	 *
	 * \@stable
	 */
	var FormGroupName = /** @class */ (function (_super) {
	    __extends(FormGroupName, _super);
	    function FormGroupName(parent, validators, asyncValidators) {
	        var _this = _super.call(this) || this;
	        _this._parent = parent;
	        _this._validators = validators;
	        _this._asyncValidators = asyncValidators;
	        return _this;
	    }
	    /** @internal */
	    /**
	     * \@internal
	     * @return {?}
	     */
	    FormGroupName.prototype._checkParentType = /**
	     * \@internal
	     * @return {?}
	     */
	    function () {
	        if (_hasInvalidParent(this._parent)) {
	            ReactiveErrors.groupParentException();
	        }
	    };
	    FormGroupName.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.ctorParameters = function () { return [
	        { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	    ]; };
	    FormGroupName.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['formGroupName',] },],
	    };
	    return FormGroupName;
	}(AbstractFormGroupDirective));
	var formArrayNameProvider = {
	    provide: ControlContainer,
	    useExisting: _angular_core.forwardRef(function () { return FormArrayName; })
	};
	/**
	 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
	 *
	 * \@howToUse
	 *
	 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
	 * `[formGroup]`).
	 *
	 * It accepts the string name of the nested {\@link FormArray} you want to link, and
	 * will look for a {\@link FormArray} registered with that name in the parent
	 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
	 *
	 * Nested form arrays can come in handy when you have a group of form controls but
	 * you're not sure how many there will be. Form arrays allow you to create new
	 * form controls dynamically.
	 *
	 * **Access the array**: You can access the associated {\@link FormArray} using the
	 * {\@link AbstractControl#get get} method on the parent {\@link FormGroup}.
	 * Ex: `this.form.get('cities')`.
	 *
	 * **Get the value**: the `value` property is always synced and available on the
	 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
	 *
	 * **Set the value**: You can set an initial value for each child control when instantiating
	 * the {\@link FormArray}, or you can set the value programmatically later using the
	 * {\@link FormArray}'s {\@link AbstractControl#setValue setValue} or
	 * {\@link AbstractControl#patchValue patchValue} methods.
	 *
	 * **Listen to value**: If you want to listen to changes in the value of the array, you can
	 * subscribe to the {\@link FormArray}'s {\@link AbstractControl#valueChanges valueChanges} event.
	 * You can also listen to its {\@link AbstractControl#statusChanges statusChanges} event to be
	 * notified when the validation status is re-calculated.
	 *
	 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by calling
	 * its {\@link FormArray#push push} method.
	 * Ex: `this.form.get('cities').push(new FormControl());`
	 *
	 * ### Example
	 *
	 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
	 *
	 * * **npm package**: `\@angular/forms`
	 *
	 * * **NgModule**: `ReactiveFormsModule`
	 *
	 * \@stable
	 */
	var FormArrayName = /** @class */ (function (_super) {
	    __extends(FormArrayName, _super);
	    function FormArrayName(parent, validators, asyncValidators) {
	        var _this = _super.call(this) || this;
	        _this._parent = parent;
	        _this._validators = validators;
	        _this._asyncValidators = asyncValidators;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    FormArrayName.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._checkParentType(); /** @type {?} */
	        ((this.formDirective)).addFormArray(this);
	    };
	    /**
	     * @return {?}
	     */
	    FormArrayName.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this.formDirective) {
	            this.formDirective.removeFormArray(this);
	        }
	    };
	    Object.defineProperty(FormArrayName.prototype, "control", {
	        get: /**
	         * @return {?}
	         */
	        function () { return /** @type {?} */ ((this.formDirective)).getFormArray(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "formDirective", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._parent ? /** @type {?} */ (this._parent.formDirective) : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "path", {
	        get: /**
	         * @return {?}
	         */
	        function () { return controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "validator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    FormArrayName.prototype._checkParentType = /**
	     * @return {?}
	     */
	    function () {
	        if (_hasInvalidParent(this._parent)) {
	            ReactiveErrors.arrayParentException();
	        }
	    };
	    FormArrayName.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.ctorParameters = function () { return [
	        { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	    ]; };
	    FormArrayName.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['formArrayName',] },],
	    };
	    return FormArrayName;
	}(ControlContainer));
	/**
	 * @param {?} parent
	 * @return {?}
	 */
	function _hasInvalidParent(parent) {
	    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
	        !(parent instanceof FormArrayName);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var controlNameBinding = {
	    provide: NgControl,
	    useExisting: _angular_core.forwardRef(function () { return FormControlName; })
	};
	/**
	 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
	 * element by name.
	 *
	 * In other words, this directive ensures that any values written to the {\@link FormControl}
	 * instance programmatically will be written to the DOM element (model -> view). Conversely,
	 * any values written to the DOM element through user input will be reflected in the
	 * {\@link FormControl} instance (view -> model).
	 *
	 * \@howToUse
	 *
	 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
	 * `[formGroup]`).
	 *
	 * It accepts the string name of the {\@link FormControl} instance you want to
	 * link, and will look for a {\@link FormControl} registered with that name in the
	 * closest {\@link FormGroup} or {\@link FormArray} above it.
	 *
	 * **Access the control**: You can access the {\@link FormControl} associated with
	 * this directive by using the {\@link AbstractControl#get get} method.
	 * Ex: `this.form.get('first');`
	 *
	 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
	 * See a full list of available properties in {\@link AbstractControl}.
	 *
	 *  **Set value**: You can set an initial value for the control when instantiating the
	 *  {\@link FormControl}, or you can set it programmatically later using
	 *  {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
	 *
	 * **Listen to value**: If you want to listen to changes in the value of the control, you can
	 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
	 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
	 * re-calculated.
	 *
	 * ### Example
	 *
	 * In this example, we create form controls for first name and last name.
	 *
	 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	 *
	 * To see `formControlName` examples with different form control types, see:
	 *
	 * * Radio buttons: {\@link RadioControlValueAccessor}
	 * * Selects: {\@link SelectControlValueAccessor}
	 *
	 * **npm package**: `\@angular/forms`
	 *
	 * **NgModule**: {\@link ReactiveFormsModule}
	 *
	 *  \@stable
	 */
	var FormControlName = /** @class */ (function (_super) {
	    __extends(FormControlName, _super);
	    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
	        var _this = _super.call(this) || this;
	        _this._added = false;
	        _this.update = new _angular_core.EventEmitter();
	        _this._parent = parent;
	        _this._rawValidators = validators || [];
	        _this._rawAsyncValidators = asyncValidators || [];
	        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
	        return _this;
	    }
	    Object.defineProperty(FormControlName.prototype, "isDisabled", {
	        set: /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    FormControlName.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (!this._added)
	            this._setUpControl();
	        if (isPropertyUpdated(changes, this.viewModel)) {
	            this.viewModel = this.model;
	            this.formDirective.updateModel(this, this.model);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    FormControlName.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this.formDirective) {
	            this.formDirective.removeControl(this);
	        }
	    };
	    /**
	     * @param {?} newValue
	     * @return {?}
	     */
	    FormControlName.prototype.viewToModelUpdate = /**
	     * @param {?} newValue
	     * @return {?}
	     */
	    function (newValue) {
	        this.viewModel = newValue;
	        this.update.emit(newValue);
	    };
	    Object.defineProperty(FormControlName.prototype, "path", {
	        get: /**
	         * @return {?}
	         */
	        function () { return controlPath(this.name, /** @type {?} */ ((this._parent))); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "formDirective", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._parent ? this._parent.formDirective : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "validator", {
	        get: /**
	         * @return {?}
	         */
	        function () { return composeValidators(this._rawValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return /** @type {?} */ ((composeAsyncValidators(this._rawAsyncValidators)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    FormControlName.prototype._checkParentType = /**
	     * @return {?}
	     */
	    function () {
	        if (!(this._parent instanceof FormGroupName) &&
	            this._parent instanceof AbstractFormGroupDirective) {
	            ReactiveErrors.ngModelGroupException();
	        }
	        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
	            !(this._parent instanceof FormArrayName)) {
	            ReactiveErrors.controlParentException();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    FormControlName.prototype._setUpControl = /**
	     * @return {?}
	     */
	    function () {
	        this._checkParentType();
	        (/** @type {?} */ (this)).control = this.formDirective.addControl(this);
	        if (this.control.disabled && /** @type {?} */ ((this.valueAccessor)).setDisabledState) {
	            /** @type {?} */ ((/** @type {?} */ ((this.valueAccessor)).setDisabledState))(true);
	        }
	        this._added = true;
	    };
	    FormControlName.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.ctorParameters = function () { return [
	        { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	    ]; };
	    FormControlName.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['formControlName',] },],
	        "model": [{ type: _angular_core.Input, args: ['ngModel',] },],
	        "update": [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	        "isDisabled": [{ type: _angular_core.Input, args: ['disabled',] },],
	    };
	    return FormControlName;
	}(NgControl));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An interface that can be implemented by classes that can act as validators.
	 *
	 * ## Usage
	 *
	 * ```typescript
	 * \@Directive({
	 *   selector: '[custom-validator]',
	 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
	 * })
	 * class CustomValidatorDirective implements Validator {
	 *   validate(c: Control): {[key: string]: any} {
	 *     return {"custom": true};
	 *   }
	 * }
	 * ```
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * \@experimental
	 * @record
	 */
	
	var REQUIRED_VALIDATOR = {
	    provide: NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return RequiredValidator; }),
	    multi: true
	};
	var CHECKBOX_REQUIRED_VALIDATOR = {
	    provide: NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return CheckboxRequiredValidator; }),
	    multi: true
	};
	/**
	 * A Directive that adds the `required` validator to any controls marked with the
	 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
	 *
	 * ### Example
	 *
	 * ```
	 * <input name="fullName" ngModel required>
	 * ```
	 *
	 * \@stable
	 */
	var RequiredValidator = /** @class */ (function () {
	    function RequiredValidator() {
	    }
	    Object.defineProperty(RequiredValidator.prototype, "required", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = value != null && value !== false && "" + value !== 'false';
	            if (this._onChange)
	                this._onChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} c
	     * @return {?}
	     */
	    RequiredValidator.prototype.validate = /**
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) {
	        return this.required ? Validators.required(c) : null;
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RequiredValidator.prototype.registerOnValidatorChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onChange = fn; };
	    RequiredValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
	                    providers: [REQUIRED_VALIDATOR],
	                    host: { '[attr.required]': 'required ? "" : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    RequiredValidator.ctorParameters = function () { return []; };
	    RequiredValidator.propDecorators = {
	        "required": [{ type: _angular_core.Input },],
	    };
	    return RequiredValidator;
	}());
	/**
	 * A Directive that adds the `required` validator to checkbox controls marked with the
	 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
	 *
	 * ### Example
	 *
	 * ```
	 * <input type="checkbox" name="active" ngModel required>
	 * ```
	 *
	 * \@experimental
	 */
	var CheckboxRequiredValidator = /** @class */ (function (_super) {
	    __extends(CheckboxRequiredValidator, _super);
	    function CheckboxRequiredValidator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} c
	     * @return {?}
	     */
	    CheckboxRequiredValidator.prototype.validate = /**
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) {
	        return this.required ? Validators.requiredTrue(c) : null;
	    };
	    CheckboxRequiredValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
	                    providers: [CHECKBOX_REQUIRED_VALIDATOR],
	                    host: { '[attr.required]': 'required ? "" : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    CheckboxRequiredValidator.ctorParameters = function () { return []; };
	    return CheckboxRequiredValidator;
	}(RequiredValidator));
	/**
	 * Provider which adds {\@link EmailValidator} to {\@link NG_VALIDATORS}.
	 */
	var EMAIL_VALIDATOR = {
	    provide: NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return EmailValidator; }),
	    multi: true
	};
	/**
	 * A Directive that adds the `email` validator to controls marked with the
	 * `email` attribute, via the {\@link NG_VALIDATORS} binding.
	 *
	 * ### Example
	 *
	 * ```
	 * <input type="email" name="email" ngModel email>
	 * <input type="email" name="email" ngModel email="true">
	 * <input type="email" name="email" ngModel [email]="true">
	 * ```
	 *
	 * \@experimental
	 */
	var EmailValidator = /** @class */ (function () {
	    function EmailValidator() {
	    }
	    Object.defineProperty(EmailValidator.prototype, "email", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._enabled = value === '' || value === true || value === 'true';
	            if (this._onChange)
	                this._onChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} c
	     * @return {?}
	     */
	    EmailValidator.prototype.validate = /**
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) {
	        return this._enabled ? Validators.email(c) : null;
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    EmailValidator.prototype.registerOnValidatorChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onChange = fn; };
	    EmailValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[email][formControlName],[email][formControl],[email][ngModel]',
	                    providers: [EMAIL_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    EmailValidator.ctorParameters = function () { return []; };
	    EmailValidator.propDecorators = {
	        "email": [{ type: _angular_core.Input },],
	    };
	    return EmailValidator;
	}());
	/**
	 * \@stable
	 * @record
	 */
	
	/**
	 * \@stable
	 * @record
	 */
	
	/**
	 * Provider which adds {\@link MinLengthValidator} to {\@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {\@example common/forms/ts/validators/validators.ts region='min'}
	 */
	var MIN_LENGTH_VALIDATOR = {
	    provide: NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return MinLengthValidator; }),
	    multi: true
	};
	/**
	 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
	 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
	 *
	 * \@stable
	 */
	var MinLengthValidator = /** @class */ (function () {
	    function MinLengthValidator() {
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MinLengthValidator.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if ('minlength' in changes) {
	            this._createValidator();
	            if (this._onChange)
	                this._onChange();
	        }
	    };
	    /**
	     * @param {?} c
	     * @return {?}
	     */
	    MinLengthValidator.prototype.validate = /**
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) {
	        return this.minlength == null ? null : this._validator(c);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MinLengthValidator.prototype.registerOnValidatorChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onChange = fn; };
	    /**
	     * @return {?}
	     */
	    MinLengthValidator.prototype._createValidator = /**
	     * @return {?}
	     */
	    function () {
	        this._validator = Validators.minLength(parseInt(this.minlength, 10));
	    };
	    MinLengthValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                    providers: [MIN_LENGTH_VALIDATOR],
	                    host: { '[attr.minlength]': 'minlength ? minlength : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    MinLengthValidator.ctorParameters = function () { return []; };
	    MinLengthValidator.propDecorators = {
	        "minlength": [{ type: _angular_core.Input },],
	    };
	    return MinLengthValidator;
	}());
	/**
	 * Provider which adds {\@link MaxLengthValidator} to {\@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {\@example common/forms/ts/validators/validators.ts region='max'}
	 */
	var MAX_LENGTH_VALIDATOR = {
	    provide: NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return MaxLengthValidator; }),
	    multi: true
	};
	/**
	 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
	 * `formControl`,
	 * or control with `ngModel` that also has a `maxlength` attribute.
	 *
	 * \@stable
	 */
	var MaxLengthValidator = /** @class */ (function () {
	    function MaxLengthValidator() {
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MaxLengthValidator.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if ('maxlength' in changes) {
	            this._createValidator();
	            if (this._onChange)
	                this._onChange();
	        }
	    };
	    /**
	     * @param {?} c
	     * @return {?}
	     */
	    MaxLengthValidator.prototype.validate = /**
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) {
	        return this.maxlength != null ? this._validator(c) : null;
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MaxLengthValidator.prototype.registerOnValidatorChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onChange = fn; };
	    /**
	     * @return {?}
	     */
	    MaxLengthValidator.prototype._createValidator = /**
	     * @return {?}
	     */
	    function () {
	        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
	    };
	    MaxLengthValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                    providers: [MAX_LENGTH_VALIDATOR],
	                    host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    MaxLengthValidator.ctorParameters = function () { return []; };
	    MaxLengthValidator.propDecorators = {
	        "maxlength": [{ type: _angular_core.Input },],
	    };
	    return MaxLengthValidator;
	}());
	var PATTERN_VALIDATOR = {
	    provide: NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return PatternValidator; }),
	    multi: true
	};
	/**
	 * A Directive that adds the `pattern` validator to any controls marked with the
	 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
	 * as the regex to validate Control value against.  Follows pattern attribute
	 * semantics; i.e. regex must match entire Control value.
	 *
	 * ### Example
	 *
	 * ```
	 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
	 * ```
	 * \@stable
	 */
	var PatternValidator = /** @class */ (function () {
	    function PatternValidator() {
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    PatternValidator.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if ('pattern' in changes) {
	            this._createValidator();
	            if (this._onChange)
	                this._onChange();
	        }
	    };
	    /**
	     * @param {?} c
	     * @return {?}
	     */
	    PatternValidator.prototype.validate = /**
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) { return this._validator(c); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    PatternValidator.prototype.registerOnValidatorChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onChange = fn; };
	    /**
	     * @return {?}
	     */
	    PatternValidator.prototype._createValidator = /**
	     * @return {?}
	     */
	    function () { this._validator = Validators.pattern(this.pattern); };
	    PatternValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                    providers: [PATTERN_VALIDATOR],
	                    host: { '[attr.pattern]': 'pattern ? pattern : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    PatternValidator.ctorParameters = function () { return []; };
	    PatternValidator.propDecorators = {
	        "pattern": [{ type: _angular_core.Input },],
	    };
	    return PatternValidator;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
	 *
	 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
	 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
	 * forms.
	 *
	 * \@howToUse
	 *
	 * To use, inject `FormBuilder` into your component class. You can then call its methods
	 * directly.
	 *
	 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
	 *
	 *  * **npm package**: `\@angular/forms`
	 *
	 *  * **NgModule**: {\@link ReactiveFormsModule}
	 *
	 * \@stable
	 */
	var FormBuilder = /** @class */ (function () {
	    function FormBuilder() {
	    }
	    /**
	     * Construct a new {@link FormGroup} with the given map of configuration.
	     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
	     *
	     * See the {@link FormGroup} constructor for more details.
	     */
	    /**
	     * Construct a new {\@link FormGroup} with the given map of configuration.
	     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
	     *
	     * See the {\@link FormGroup} constructor for more details.
	     * @param {?} controlsConfig
	     * @param {?=} extra
	     * @return {?}
	     */
	    FormBuilder.prototype.group = /**
	     * Construct a new {\@link FormGroup} with the given map of configuration.
	     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
	     *
	     * See the {\@link FormGroup} constructor for more details.
	     * @param {?} controlsConfig
	     * @param {?=} extra
	     * @return {?}
	     */
	    function (controlsConfig, extra) {
	        if (extra === void 0) { extra = null; }
	        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
	        var /** @type {?} */ validator = extra != null ? extra['validator'] : null;
	        var /** @type {?} */ asyncValidator = extra != null ? extra['asyncValidator'] : null;
	        return new FormGroup(controls, validator, asyncValidator);
	    };
	    /**
	     * Construct a new {@link FormControl} with the given `formState`,`validator`, and
	     * `asyncValidator`.
	     *
	     * `formState` can either be a standalone value for the form control or an object
	     * that contains both a value and a disabled status.
	     *
	     */
	    /**
	     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
	     * `asyncValidator`.
	     *
	     * `formState` can either be a standalone value for the form control or an object
	     * that contains both a value and a disabled status.
	     *
	     * @param {?} formState
	     * @param {?=} validator
	     * @param {?=} asyncValidator
	     * @return {?}
	     */
	    FormBuilder.prototype.control = /**
	     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
	     * `asyncValidator`.
	     *
	     * `formState` can either be a standalone value for the form control or an object
	     * that contains both a value and a disabled status.
	     *
	     * @param {?} formState
	     * @param {?=} validator
	     * @param {?=} asyncValidator
	     * @return {?}
	     */
	    function (formState, validator, asyncValidator) {
	        return new FormControl(formState, validator, asyncValidator);
	    };
	    /**
	     * Construct a {@link FormArray} from the given `controlsConfig` array of
	     * configuration, with the given optional `validator` and `asyncValidator`.
	     */
	    /**
	     * Construct a {\@link FormArray} from the given `controlsConfig` array of
	     * configuration, with the given optional `validator` and `asyncValidator`.
	     * @param {?} controlsConfig
	     * @param {?=} validator
	     * @param {?=} asyncValidator
	     * @return {?}
	     */
	    FormBuilder.prototype.array = /**
	     * Construct a {\@link FormArray} from the given `controlsConfig` array of
	     * configuration, with the given optional `validator` and `asyncValidator`.
	     * @param {?} controlsConfig
	     * @param {?=} validator
	     * @param {?=} asyncValidator
	     * @return {?}
	     */
	    function (controlsConfig, validator, asyncValidator) {
	        var _this = this;
	        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	        return new FormArray(controls, validator, asyncValidator);
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} controlsConfig
	     * @return {?}
	     */
	    FormBuilder.prototype._reduceControls = /**
	     * \@internal
	     * @param {?} controlsConfig
	     * @return {?}
	     */
	    function (controlsConfig) {
	        var _this = this;
	        var /** @type {?} */ controls = {};
	        Object.keys(controlsConfig).forEach(function (controlName) {
	            controls[controlName] = _this._createControl(controlsConfig[controlName]);
	        });
	        return controls;
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} controlConfig
	     * @return {?}
	     */
	    FormBuilder.prototype._createControl = /**
	     * \@internal
	     * @param {?} controlConfig
	     * @return {?}
	     */
	    function (controlConfig) {
	        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
	            controlConfig instanceof FormArray) {
	            return controlConfig;
	        }
	        else if (Array.isArray(controlConfig)) {
	            var /** @type {?} */ value = controlConfig[0];
	            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
	            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	            return this.control(value, validator, asyncValidator);
	        }
	        else {
	            return this.control(controlConfig);
	        }
	    };
	    FormBuilder.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    FormBuilder.ctorParameters = function () { return []; };
	    return FormBuilder;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@stable
	 */
	var VERSION = new _angular_core.Version('5.2.11');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
	 *
	 * `novalidate` is used to disable browser's native form validation.
	 *
	 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
	 *
	 * ```
	 * <form ngNativeValidate></form>
	 * ```
	 *
	 * \@experimental
	 */
	var NgNoValidate = /** @class */ (function () {
	    function NgNoValidate() {
	    }
	    NgNoValidate.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
	                    host: { 'novalidate': '' },
	                },] },
	    ];
	    /** @nocollapse */
	    NgNoValidate.ctorParameters = function () { return []; };
	    return NgNoValidate;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var SHARED_FORM_DIRECTIVES = [
	    NgNoValidate,
	    NgSelectOption,
	    NgSelectMultipleOption,
	    DefaultValueAccessor,
	    NumberValueAccessor,
	    RangeValueAccessor,
	    CheckboxControlValueAccessor,
	    SelectControlValueAccessor,
	    SelectMultipleControlValueAccessor,
	    RadioControlValueAccessor,
	    NgControlStatus,
	    NgControlStatusGroup,
	    RequiredValidator,
	    MinLengthValidator,
	    MaxLengthValidator,
	    PatternValidator,
	    CheckboxRequiredValidator,
	    EmailValidator,
	];
	var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
	var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
	/**
	 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
	 */
	var InternalFormsSharedModule = /** @class */ (function () {
	    function InternalFormsSharedModule() {
	    }
	    InternalFormsSharedModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: SHARED_FORM_DIRECTIVES,
	                    exports: SHARED_FORM_DIRECTIVES,
	                },] },
	    ];
	    /** @nocollapse */
	    InternalFormsSharedModule.ctorParameters = function () { return []; };
	    return InternalFormsSharedModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * The ng module for forms.
	 * \@stable
	 */
	var FormsModule = /** @class */ (function () {
	    function FormsModule() {
	    }
	    FormsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: TEMPLATE_DRIVEN_DIRECTIVES,
	                    providers: [RadioControlRegistry],
	                    exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
	                },] },
	    ];
	    /** @nocollapse */
	    FormsModule.ctorParameters = function () { return []; };
	    return FormsModule;
	}());
	/**
	 * The ng module for reactive forms.
	 * \@stable
	 */
	var ReactiveFormsModule = /** @class */ (function () {
	    function ReactiveFormsModule() {
	    }
	    ReactiveFormsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [REACTIVE_DRIVEN_DIRECTIVES],
	                    providers: [FormBuilder, RadioControlRegistry],
	                    exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
	                },] },
	    ];
	    /** @nocollapse */
	    ReactiveFormsModule.ctorParameters = function () { return []; };
	    return ReactiveFormsModule;
	}());
	
	exports.AbstractControlDirective = AbstractControlDirective;
	exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	exports.ControlContainer = ControlContainer;
	exports.NG_VALUE_ACCESSOR = NG_VALUE_ACCESSOR;
	exports.COMPOSITION_BUFFER_MODE = COMPOSITION_BUFFER_MODE;
	exports.DefaultValueAccessor = DefaultValueAccessor;
	exports.NgControl = NgControl;
	exports.NgControlStatus = NgControlStatus;
	exports.NgControlStatusGroup = NgControlStatusGroup;
	exports.NgForm = NgForm;
	exports.NgModel = NgModel;
	exports.NgModelGroup = NgModelGroup;
	exports.RadioControlValueAccessor = RadioControlValueAccessor;
	exports.FormControlDirective = FormControlDirective;
	exports.FormControlName = FormControlName;
	exports.FormGroupDirective = FormGroupDirective;
	exports.FormArrayName = FormArrayName;
	exports.FormGroupName = FormGroupName;
	exports.NgSelectOption = NgSelectOption;
	exports.SelectControlValueAccessor = SelectControlValueAccessor;
	exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	exports.CheckboxRequiredValidator = CheckboxRequiredValidator;
	exports.EmailValidator = EmailValidator;
	exports.MaxLengthValidator = MaxLengthValidator;
	exports.MinLengthValidator = MinLengthValidator;
	exports.PatternValidator = PatternValidator;
	exports.RequiredValidator = RequiredValidator;
	exports.FormBuilder = FormBuilder;
	exports.AbstractControl = AbstractControl;
	exports.FormArray = FormArray;
	exports.FormControl = FormControl;
	exports.FormGroup = FormGroup;
	exports.NG_ASYNC_VALIDATORS = NG_ASYNC_VALIDATORS;
	exports.NG_VALIDATORS = NG_VALIDATORS;
	exports.Validators = Validators;
	exports.VERSION = VERSION;
	exports.FormsModule = FormsModule;
	exports.ReactiveFormsModule = ReactiveFormsModule;
	exports.ɵba = InternalFormsSharedModule;
	exports.ɵz = REACTIVE_DRIVEN_DIRECTIVES;
	exports.ɵx = SHARED_FORM_DIRECTIVES;
	exports.ɵy = TEMPLATE_DRIVEN_DIRECTIVES;
	exports.ɵa = CHECKBOX_VALUE_ACCESSOR;
	exports.ɵb = DEFAULT_VALUE_ACCESSOR;
	exports.ɵc = AbstractControlStatus;
	exports.ɵd = ngControlStatusHost;
	exports.ɵe = formDirectiveProvider;
	exports.ɵf = formControlBinding;
	exports.ɵg = modelGroupProvider;
	exports.ɵbf = NgNoValidate;
	exports.ɵbb = NUMBER_VALUE_ACCESSOR;
	exports.ɵbc = NumberValueAccessor;
	exports.ɵh = RADIO_VALUE_ACCESSOR;
	exports.ɵi = RadioControlRegistry;
	exports.ɵbd = RANGE_VALUE_ACCESSOR;
	exports.ɵbe = RangeValueAccessor;
	exports.ɵj = formControlBinding$1;
	exports.ɵk = controlNameBinding;
	exports.ɵl = formDirectiveProvider$1;
	exports.ɵn = formArrayNameProvider;
	exports.ɵm = formGroupNameProvider;
	exports.ɵo = SELECT_VALUE_ACCESSOR;
	exports.ɵq = NgSelectMultipleOption;
	exports.ɵp = SELECT_MULTIPLE_VALUE_ACCESSOR;
	exports.ɵs = CHECKBOX_REQUIRED_VALIDATOR;
	exports.ɵt = EMAIL_VALIDATOR;
	exports.ɵv = MAX_LENGTH_VALIDATOR;
	exports.ɵu = MIN_LENGTH_VALIDATOR;
	exports.ɵw = PATTERN_VALIDATOR;
	exports.ɵr = REQUIRED_VALIDATOR;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=forms.umd.js.map


/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(206), __webpack_require__(247)) :
		typeof define === 'function' && define.amd ? define('@angular/http', ['exports', '@angular/core', 'rxjs/Observable', '@angular/platform-browser'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.http = {}),global.ng.core,global.Rx,global.ng.platformBrowser));
	}(this, (function (exports,_angular_core,rxjs_Observable,_angular_platformBrowser) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A backend for http that uses the `XMLHttpRequest` browser API.
	 *
	 * Take care not to evaluate this in non-browser contexts.
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var BrowserXhr = /** @class */ (function () {
	    function BrowserXhr() {
	    }
	    /**
	     * @return {?}
	     */
	    BrowserXhr.prototype.build = /**
	     * @return {?}
	     */
	    function () { return /** @type {?} */ ((new XMLHttpRequest())); };
	    BrowserXhr.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BrowserXhr.ctorParameters = function () { return []; };
	    return BrowserXhr;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var RequestMethod = {
	    Get: 0,
	    Post: 1,
	    Put: 2,
	    Delete: 3,
	    Options: 4,
	    Head: 5,
	    Patch: 6,
	};
	RequestMethod[RequestMethod.Get] = "Get";
	RequestMethod[RequestMethod.Post] = "Post";
	RequestMethod[RequestMethod.Put] = "Put";
	RequestMethod[RequestMethod.Delete] = "Delete";
	RequestMethod[RequestMethod.Options] = "Options";
	RequestMethod[RequestMethod.Head] = "Head";
	RequestMethod[RequestMethod.Patch] = "Patch";
	/** @enum {number} */
	var ReadyState = {
	    Unsent: 0,
	    Open: 1,
	    HeadersReceived: 2,
	    Loading: 3,
	    Done: 4,
	    Cancelled: 5,
	};
	ReadyState[ReadyState.Unsent] = "Unsent";
	ReadyState[ReadyState.Open] = "Open";
	ReadyState[ReadyState.HeadersReceived] = "HeadersReceived";
	ReadyState[ReadyState.Loading] = "Loading";
	ReadyState[ReadyState.Done] = "Done";
	ReadyState[ReadyState.Cancelled] = "Cancelled";
	/** @enum {number} */
	var ResponseType = {
	    Basic: 0,
	    Cors: 1,
	    Default: 2,
	    Error: 3,
	    Opaque: 4,
	};
	ResponseType[ResponseType.Basic] = "Basic";
	ResponseType[ResponseType.Cors] = "Cors";
	ResponseType[ResponseType.Default] = "Default";
	ResponseType[ResponseType.Error] = "Error";
	ResponseType[ResponseType.Opaque] = "Opaque";
	/** @enum {number} */
	var ContentType = {
	    NONE: 0,
	    JSON: 1,
	    FORM: 2,
	    FORM_DATA: 3,
	    TEXT: 4,
	    BLOB: 5,
	    ARRAY_BUFFER: 6,
	};
	ContentType[ContentType.NONE] = "NONE";
	ContentType[ContentType.JSON] = "JSON";
	ContentType[ContentType.FORM] = "FORM";
	ContentType[ContentType.FORM_DATA] = "FORM_DATA";
	ContentType[ContentType.TEXT] = "TEXT";
	ContentType[ContentType.BLOB] = "BLOB";
	ContentType[ContentType.ARRAY_BUFFER] = "ARRAY_BUFFER";
	/** @enum {number} */
	var ResponseContentType = {
	    Text: 0,
	    Json: 1,
	    ArrayBuffer: 2,
	    Blob: 3,
	};
	ResponseContentType[ResponseContentType.Text] = "Text";
	ResponseContentType[ResponseContentType.Json] = "Json";
	ResponseContentType[ResponseContentType.ArrayBuffer] = "ArrayBuffer";
	ResponseContentType[ResponseContentType.Blob] = "Blob";
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Polyfill for [Headers](https://developer.mozilla.org/en-US/docs/Web/API/Headers/Headers), as
	 * specified in the [Fetch Spec](https://fetch.spec.whatwg.org/#headers-class).
	 *
	 * The only known difference between this `Headers` implementation and the spec is the
	 * lack of an `entries` method.
	 *
	 * ### Example
	 *
	 * ```
	 * import {Headers} from '\@angular/http';
	 *
	 * var firstHeaders = new Headers();
	 * firstHeaders.append('Content-Type', 'image/jpeg');
	 * console.log(firstHeaders.get('Content-Type')) //'image/jpeg'
	 *
	 * // Create headers from Plain Old JavaScript Object
	 * var secondHeaders = new Headers({
	 *   'X-My-Custom-Header': 'Angular'
	 * });
	 * console.log(secondHeaders.get('X-My-Custom-Header')); //'Angular'
	 *
	 * var thirdHeaders = new Headers(secondHeaders);
	 * console.log(thirdHeaders.get('X-My-Custom-Header')); //'Angular'
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var Headers = /** @class */ (function () {
	    // TODO(vicb): any -> string|string[]
	    function Headers(headers) {
	        var _this = this;
	        /**
	         * \@internal header names are lower case
	         */
	        this._headers = new Map();
	        /**
	         * \@internal map lower case names to actual names
	         */
	        this._normalizedNames = new Map();
	        if (!headers) {
	            return;
	        }
	        if (headers instanceof Headers) {
	            headers.forEach(function (values, name) {
	                values.forEach(function (value) { return _this.append(name, value); });
	            });
	            return;
	        }
	        Object.keys(headers).forEach(function (name) {
	            var /** @type {?} */ values = Array.isArray(headers[name]) ? headers[name] : [headers[name]];
	            _this.delete(name);
	            values.forEach(function (value) { return _this.append(name, value); });
	        });
	    }
	    /**
	     * Returns a new Headers instance from the given DOMString of Response Headers
	     */
	    /**
	     * Returns a new Headers instance from the given DOMString of Response Headers
	     * @param {?} headersString
	     * @return {?}
	     */
	    Headers.fromResponseHeaderString = /**
	     * Returns a new Headers instance from the given DOMString of Response Headers
	     * @param {?} headersString
	     * @return {?}
	     */
	    function (headersString) {
	        var /** @type {?} */ headers = new Headers();
	        headersString.split('\n').forEach(function (line) {
	            var /** @type {?} */ index = line.indexOf(':');
	            if (index > 0) {
	                var /** @type {?} */ name_1 = line.slice(0, index);
	                var /** @type {?} */ value = line.slice(index + 1).trim();
	                headers.set(name_1, value);
	            }
	        });
	        return headers;
	    };
	    /**
	     * Appends a header to existing list of header values for a given header name.
	     */
	    /**
	     * Appends a header to existing list of header values for a given header name.
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    Headers.prototype.append = /**
	     * Appends a header to existing list of header values for a given header name.
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (name, value) {
	        var /** @type {?} */ values = this.getAll(name);
	        if (values === null) {
	            this.set(name, value);
	        }
	        else {
	            values.push(value);
	        }
	    };
	    /**
	     * Deletes all header values for the given name.
	     */
	    /**
	     * Deletes all header values for the given name.
	     * @param {?} name
	     * @return {?}
	     */
	    Headers.prototype.delete = /**
	     * Deletes all header values for the given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var /** @type {?} */ lcName = name.toLowerCase();
	        this._normalizedNames.delete(lcName);
	        this._headers.delete(lcName);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    Headers.prototype.forEach = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var _this = this;
	        this._headers.forEach(function (values, lcName) { return fn(values, _this._normalizedNames.get(lcName), _this._headers); });
	    };
	    /**
	     * Returns first header that matches given name.
	     */
	    /**
	     * Returns first header that matches given name.
	     * @param {?} name
	     * @return {?}
	     */
	    Headers.prototype.get = /**
	     * Returns first header that matches given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var /** @type {?} */ values = this.getAll(name);
	        if (values === null) {
	            return null;
	        }
	        return values.length > 0 ? values[0] : null;
	    };
	    /**
	     * Checks for existence of header by given name.
	     */
	    /**
	     * Checks for existence of header by given name.
	     * @param {?} name
	     * @return {?}
	     */
	    Headers.prototype.has = /**
	     * Checks for existence of header by given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) { return this._headers.has(name.toLowerCase()); };
	    /**
	     * Returns the names of the headers
	     */
	    /**
	     * Returns the names of the headers
	     * @return {?}
	     */
	    Headers.prototype.keys = /**
	     * Returns the names of the headers
	     * @return {?}
	     */
	    function () { return Array.from(this._normalizedNames.values()); };
	    /**
	     * Sets or overrides header value for given name.
	     */
	    /**
	     * Sets or overrides header value for given name.
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    Headers.prototype.set = /**
	     * Sets or overrides header value for given name.
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (name, value) {
	        if (Array.isArray(value)) {
	            if (value.length) {
	                this._headers.set(name.toLowerCase(), [value.join(',')]);
	            }
	        }
	        else {
	            this._headers.set(name.toLowerCase(), [value]);
	        }
	        this.mayBeSetNormalizedName(name);
	    };
	    /**
	     * Returns values of all headers.
	     */
	    /**
	     * Returns values of all headers.
	     * @return {?}
	     */
	    Headers.prototype.values = /**
	     * Returns values of all headers.
	     * @return {?}
	     */
	    function () { return Array.from(this._headers.values()); };
	    /**
	     * Returns string of all headers.
	     */
	    // TODO(vicb): returns {[name: string]: string[]}
	    /**
	     * Returns string of all headers.
	     * @return {?}
	     */
	    Headers.prototype.toJSON = /**
	     * Returns string of all headers.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ serialized = {};
	        this._headers.forEach(function (values, name) {
	            var /** @type {?} */ split = [];
	            values.forEach(function (v) { return split.push.apply(split, v.split(',')); });
	            serialized[/** @type {?} */ ((_this._normalizedNames.get(name)))] = split;
	        });
	        return serialized;
	    };
	    /**
	     * Returns list of header values for a given name.
	     */
	    /**
	     * Returns list of header values for a given name.
	     * @param {?} name
	     * @return {?}
	     */
	    Headers.prototype.getAll = /**
	     * Returns list of header values for a given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        return this.has(name) ? this._headers.get(name.toLowerCase()) || null : null;
	    };
	    /**
	     * This method is not implemented.
	     */
	    /**
	     * This method is not implemented.
	     * @return {?}
	     */
	    Headers.prototype.entries = /**
	     * This method is not implemented.
	     * @return {?}
	     */
	    function () { throw new Error('"entries" method is not implemented on Headers class'); };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    Headers.prototype.mayBeSetNormalizedName = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var /** @type {?} */ lcName = name.toLowerCase();
	        if (!this._normalizedNames.has(lcName)) {
	            this._normalizedNames.set(lcName, name);
	        }
	    };
	    return Headers;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Creates a response options object to be optionally provided when instantiating a
	 * {\@link Response}.
	 *
	 * This class is based on the `ResponseInit` description in the [Fetch
	 * Spec](https://fetch.spec.whatwg.org/#responseinit).
	 *
	 * All values are null by default. Typical defaults can be found in the
	 * {\@link BaseResponseOptions} class, which sub-classes `ResponseOptions`.
	 *
	 * This class may be used in tests to build {\@link Response Responses} for
	 * mock responses (see {\@link MockBackend}).
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/P9Jkk8e8cz6NVzbcxEsD?p=preview))
	 *
	 * ```typescript
	 * import {ResponseOptions, Response} from '\@angular/http';
	 *
	 * var options = new ResponseOptions({
	 *   body: '{"name":"Jeff"}'
	 * });
	 * var res = new Response(options);
	 *
	 * console.log('res.json():', res.json()); // Object {name: "Jeff"}
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var ResponseOptions = /** @class */ (function () {
	    function ResponseOptions(opts) {
	        if (opts === void 0) { opts = {}; }
	        var body = opts.body, status = opts.status, headers = opts.headers, statusText = opts.statusText, type = opts.type, url = opts.url;
	        this.body = body != null ? body : null;
	        this.status = status != null ? status : null;
	        this.headers = headers != null ? headers : null;
	        this.statusText = statusText != null ? statusText : null;
	        this.type = type != null ? type : null;
	        this.url = url != null ? url : null;
	    }
	    /**
	     * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
	     * override
	     * existing values. This method will not change the values of the instance on which it is being
	     * called.
	     *
	     * This may be useful when sharing a base `ResponseOptions` object inside tests,
	     * where certain properties may change from test to test.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
	     *
	     * ```typescript
	     * import {ResponseOptions, Response} from '@angular/http';
	     *
	     * var options = new ResponseOptions({
	     *   body: {name: 'Jeff'}
	     * });
	     * var res = new Response(options.merge({
	     *   url: 'https://google.com'
	     * }));
	     * console.log('options.url:', options.url); // null
	     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
	     * console.log('res.url:', res.url); // https://google.com
	     * ```
	     */
	    /**
	     * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
	     * override
	     * existing values. This method will not change the values of the instance on which it is being
	     * called.
	     *
	     * This may be useful when sharing a base `ResponseOptions` object inside tests,
	     * where certain properties may change from test to test.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
	     *
	     * ```typescript
	     * import {ResponseOptions, Response} from '\@angular/http';
	     *
	     * var options = new ResponseOptions({
	     *   body: {name: 'Jeff'}
	     * });
	     * var res = new Response(options.merge({
	     *   url: 'https://google.com'
	     * }));
	     * console.log('options.url:', options.url); // null
	     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
	     * console.log('res.url:', res.url); // https://google.com
	     * ```
	     * @param {?=} options
	     * @return {?}
	     */
	    ResponseOptions.prototype.merge = /**
	     * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
	     * override
	     * existing values. This method will not change the values of the instance on which it is being
	     * called.
	     *
	     * This may be useful when sharing a base `ResponseOptions` object inside tests,
	     * where certain properties may change from test to test.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
	     *
	     * ```typescript
	     * import {ResponseOptions, Response} from '\@angular/http';
	     *
	     * var options = new ResponseOptions({
	     *   body: {name: 'Jeff'}
	     * });
	     * var res = new Response(options.merge({
	     *   url: 'https://google.com'
	     * }));
	     * console.log('options.url:', options.url); // null
	     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
	     * console.log('res.url:', res.url); // https://google.com
	     * ```
	     * @param {?=} options
	     * @return {?}
	     */
	    function (options) {
	        return new ResponseOptions({
	            body: options && options.body != null ? options.body : this.body,
	            status: options && options.status != null ? options.status : this.status,
	            headers: options && options.headers != null ? options.headers : this.headers,
	            statusText: options && options.statusText != null ? options.statusText : this.statusText,
	            type: options && options.type != null ? options.type : this.type,
	            url: options && options.url != null ? options.url : this.url,
	        });
	    };
	    return ResponseOptions;
	}());
	/**
	 * Subclass of {\@link ResponseOptions}, with default values.
	 *
	 * Default values:
	 *  * status: 200
	 *  * headers: empty {\@link Headers} object
	 *
	 * This class could be extended and bound to the {\@link ResponseOptions} class
	 * when configuring an {\@link Injector}, in order to override the default options
	 * used by {\@link Http} to create {\@link Response Responses}.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/qv8DLT?p=preview))
	 *
	 * ```typescript
	 * import {provide} from '\@angular/core';
	 * import {bootstrap} from '\@angular/platform-browser/browser';
	 * import {HTTP_PROVIDERS, Headers, Http, BaseResponseOptions, ResponseOptions} from
	 * '\@angular/http';
	 * import {App} from './myapp';
	 *
	 * class MyOptions extends BaseResponseOptions {
	 *   headers:Headers = new Headers({network: 'github'});
	 * }
	 *
	 * bootstrap(App, [HTTP_PROVIDERS, {provide: ResponseOptions, useClass: MyOptions}]);
	 * ```
	 *
	 * The options could also be extended when manually creating a {\@link Response}
	 * object.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/VngosOWiaExEtbstDoix?p=preview))
	 *
	 * ```
	 * import {BaseResponseOptions, Response} from '\@angular/http';
	 *
	 * var options = new BaseResponseOptions();
	 * var res = new Response(options.merge({
	 *   body: 'Angular',
	 *   headers: new Headers({framework: 'angular'})
	 * }));
	 * console.log('res.headers.get("framework"):', res.headers.get('framework')); // angular
	 * console.log('res.text():', res.text()); // Angular;
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var BaseResponseOptions = /** @class */ (function (_super) {
	    __extends(BaseResponseOptions, _super);
	    function BaseResponseOptions() {
	        return _super.call(this, { status: 200, statusText: 'Ok', type: ResponseType.Default, headers: new Headers() }) || this;
	    }
	    BaseResponseOptions.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BaseResponseOptions.ctorParameters = function () { return []; };
	    return BaseResponseOptions;
	}(ResponseOptions));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Abstract class from which real backends are derived.
	 *
	 * The primary purpose of a `ConnectionBackend` is to create new connections to fulfill a given
	 * {\@link Request}.
	 *
	 * @deprecated use \@angular/common/http instead
	 * @abstract
	 */
	var ConnectionBackend = /** @class */ (function () {
	    function ConnectionBackend() {
	    }
	    return ConnectionBackend;
	}());
	/**
	 * Abstract class from which real connections are derived.
	 *
	 * @deprecated use \@angular/common/http instead
	 * @abstract
	 */
	var Connection = /** @class */ (function () {
	    function Connection() {
	    }
	    return Connection;
	}());
	/**
	 * An XSRFStrategy configures XSRF protection (e.g. via headers) on an HTTP request.
	 *
	 * @deprecated use \@angular/common/http instead
	 * @abstract
	 */
	var XSRFStrategy = /** @class */ (function () {
	    function XSRFStrategy() {
	    }
	    return XSRFStrategy;
	}());
	/**
	 * Interface for options to construct a RequestOptions, based on
	 * [RequestInit](https://fetch.spec.whatwg.org/#requestinit) from the Fetch spec.
	 *
	 * @deprecated use \@angular/common/http instead
	 * @record
	 */
	
	/**
	 * Required structure when constructing new Request();
	 * @record
	 */
	
	/**
	 * Interface for options to construct a Response, based on
	 * [ResponseInit](https://fetch.spec.whatwg.org/#responseinit) from the Fetch spec.
	 *
	 * @deprecated use \@angular/common/http instead
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} method
	 * @return {?}
	 */
	function normalizeMethodName(method) {
	    if (typeof method !== 'string')
	        return method;
	    switch (method.toUpperCase()) {
	        case 'GET':
	            return RequestMethod.Get;
	        case 'POST':
	            return RequestMethod.Post;
	        case 'PUT':
	            return RequestMethod.Put;
	        case 'DELETE':
	            return RequestMethod.Delete;
	        case 'OPTIONS':
	            return RequestMethod.Options;
	        case 'HEAD':
	            return RequestMethod.Head;
	        case 'PATCH':
	            return RequestMethod.Patch;
	    }
	    throw new Error("Invalid request method. The method \"" + method + "\" is not supported.");
	}
	var isSuccess = function (status) { return (status >= 200 && status < 300); };
	/**
	 * @param {?} xhr
	 * @return {?}
	 */
	function getResponseURL(xhr) {
	    if ('responseURL' in xhr) {
	        return xhr.responseURL;
	    }
	    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	        return xhr.getResponseHeader('X-Request-URL');
	    }
	    return null;
	}
	/**
	 * @param {?} input
	 * @return {?}
	 */
	
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function stringToArrayBuffer(input) {
	    var /** @type {?} */ view = new Uint16Array(input.length);
	    for (var /** @type {?} */ i = 0, /** @type {?} */ strLen = input.length; i < strLen; i++) {
	        view[i] = input.charCodeAt(i);
	    }
	    return view.buffer;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?=} rawParams
	 * @return {?}
	 */
	function paramParser(rawParams) {
	    if (rawParams === void 0) { rawParams = ''; }
	    var /** @type {?} */ map = new Map();
	    if (rawParams.length > 0) {
	        var /** @type {?} */ params = rawParams.split('&');
	        params.forEach(function (param) {
	            var /** @type {?} */ eqIdx = param.indexOf('=');
	            var _a = eqIdx == -1 ? [param, ''] : [param.slice(0, eqIdx), param.slice(eqIdx + 1)], key = _a[0], val = _a[1];
	            var /** @type {?} */ list = map.get(key) || [];
	            list.push(val);
	            map.set(key, list);
	        });
	    }
	    return map;
	}
	/**
	 * @deprecated use \@angular/common/http instead
	 *
	 */
	var QueryEncoder = /** @class */ (function () {
	    function QueryEncoder() {
	    }
	    /**
	     * @param {?} k
	     * @return {?}
	     */
	    QueryEncoder.prototype.encodeKey = /**
	     * @param {?} k
	     * @return {?}
	     */
	    function (k) { return standardEncoding(k); };
	    /**
	     * @param {?} v
	     * @return {?}
	     */
	    QueryEncoder.prototype.encodeValue = /**
	     * @param {?} v
	     * @return {?}
	     */
	    function (v) { return standardEncoding(v); };
	    return QueryEncoder;
	}());
	/**
	 * @param {?} v
	 * @return {?}
	 */
	function standardEncoding(v) {
	    return encodeURIComponent(v)
	        .replace(/%40/gi, '@')
	        .replace(/%3A/gi, ':')
	        .replace(/%24/gi, '$')
	        .replace(/%2C/gi, ',')
	        .replace(/%3B/gi, ';')
	        .replace(/%2B/gi, '+')
	        .replace(/%3D/gi, '=')
	        .replace(/%3F/gi, '?')
	        .replace(/%2F/gi, '/');
	}
	/**
	 * Map-like representation of url search parameters, based on
	 * [URLSearchParams](https://url.spec.whatwg.org/#urlsearchparams) in the url living standard,
	 * with several extensions for merging URLSearchParams objects:
	 *   - setAll()
	 *   - appendAll()
	 *   - replaceAll()
	 *
	 * This class accepts an optional second parameter of ${\@link QueryEncoder},
	 * which is used to serialize parameters before making a request. By default,
	 * `QueryEncoder` encodes keys and values of parameters using `encodeURIComponent`,
	 * and then un-encodes certain characters that are allowed to be part of the query
	 * according to IETF RFC 3986: https://tools.ietf.org/html/rfc3986.
	 *
	 * These are the characters that are not encoded: `! $ \' ( ) * + , ; A 9 - . _ ~ ? /`
	 *
	 * If the set of allowed query characters is not acceptable for a particular backend,
	 * `QueryEncoder` can be subclassed and provided as the 2nd argument to URLSearchParams.
	 *
	 * ```
	 * import {URLSearchParams, QueryEncoder} from '\@angular/http';
	 * class MyQueryEncoder extends QueryEncoder {
	 *   encodeKey(k: string): string {
	 *     return myEncodingFunction(k);
	 *   }
	 *
	 *   encodeValue(v: string): string {
	 *     return myEncodingFunction(v);
	 *   }
	 * }
	 *
	 * let params = new URLSearchParams('', new MyQueryEncoder());
	 * ```
	 * @deprecated use \@angular/common/http instead
	 */
	var URLSearchParams = /** @class */ (function () {
	    function URLSearchParams(rawParams, queryEncoder) {
	        if (rawParams === void 0) { rawParams = ''; }
	        if (queryEncoder === void 0) { queryEncoder = new QueryEncoder(); }
	        this.rawParams = rawParams;
	        this.queryEncoder = queryEncoder;
	        this.paramsMap = paramParser(rawParams);
	    }
	    /**
	     * @return {?}
	     */
	    URLSearchParams.prototype.clone = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ clone = new URLSearchParams('', this.queryEncoder);
	        clone.appendAll(this);
	        return clone;
	    };
	    /**
	     * @param {?} param
	     * @return {?}
	     */
	    URLSearchParams.prototype.has = /**
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) { return this.paramsMap.has(param); };
	    /**
	     * @param {?} param
	     * @return {?}
	     */
	    URLSearchParams.prototype.get = /**
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) {
	        var /** @type {?} */ storedParam = this.paramsMap.get(param);
	        return Array.isArray(storedParam) ? storedParam[0] : null;
	    };
	    /**
	     * @param {?} param
	     * @return {?}
	     */
	    URLSearchParams.prototype.getAll = /**
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) { return this.paramsMap.get(param) || []; };
	    /**
	     * @param {?} param
	     * @param {?} val
	     * @return {?}
	     */
	    URLSearchParams.prototype.set = /**
	     * @param {?} param
	     * @param {?} val
	     * @return {?}
	     */
	    function (param, val) {
	        if (val === void 0 || val === null) {
	            this.delete(param);
	            return;
	        }
	        var /** @type {?} */ list = this.paramsMap.get(param) || [];
	        list.length = 0;
	        list.push(val);
	        this.paramsMap.set(param, list);
	    };
	    // A merge operation
	    // For each name-values pair in `searchParams`, perform `set(name, values[0])`
	    //
	    // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4], c=[8], b=[7]"
	    //
	    // TODO(@caitp): document this better
	    /**
	     * @param {?} searchParams
	     * @return {?}
	     */
	    URLSearchParams.prototype.setAll = /**
	     * @param {?} searchParams
	     * @return {?}
	     */
	    function (searchParams) {
	        var _this = this;
	        searchParams.paramsMap.forEach(function (value, param) {
	            var /** @type {?} */ list = _this.paramsMap.get(param) || [];
	            list.length = 0;
	            list.push(value[0]);
	            _this.paramsMap.set(param, list);
	        });
	    };
	    /**
	     * @param {?} param
	     * @param {?} val
	     * @return {?}
	     */
	    URLSearchParams.prototype.append = /**
	     * @param {?} param
	     * @param {?} val
	     * @return {?}
	     */
	    function (param, val) {
	        if (val === void 0 || val === null)
	            return;
	        var /** @type {?} */ list = this.paramsMap.get(param) || [];
	        list.push(val);
	        this.paramsMap.set(param, list);
	    };
	    // A merge operation
	    // For each name-values pair in `searchParams`, perform `append(name, value)`
	    // for each value in `values`.
	    //
	    // E.g: "a=[1,2], c=[8]" + "a=[3,4], b=[7]" = "a=[1,2,3,4], c=[8], b=[7]"
	    //
	    // TODO(@caitp): document this better
	    /**
	     * @param {?} searchParams
	     * @return {?}
	     */
	    URLSearchParams.prototype.appendAll = /**
	     * @param {?} searchParams
	     * @return {?}
	     */
	    function (searchParams) {
	        var _this = this;
	        searchParams.paramsMap.forEach(function (value, param) {
	            var /** @type {?} */ list = _this.paramsMap.get(param) || [];
	            for (var /** @type {?} */ i = 0; i < value.length; ++i) {
	                list.push(value[i]);
	            }
	            _this.paramsMap.set(param, list);
	        });
	    };
	    // A merge operation
	    // For each name-values pair in `searchParams`, perform `delete(name)`,
	    // followed by `set(name, values)`
	    //
	    // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4,5,6], c=[8], b=[7]"
	    //
	    // TODO(@caitp): document this better
	    /**
	     * @param {?} searchParams
	     * @return {?}
	     */
	    URLSearchParams.prototype.replaceAll = /**
	     * @param {?} searchParams
	     * @return {?}
	     */
	    function (searchParams) {
	        var _this = this;
	        searchParams.paramsMap.forEach(function (value, param) {
	            var /** @type {?} */ list = _this.paramsMap.get(param) || [];
	            list.length = 0;
	            for (var /** @type {?} */ i = 0; i < value.length; ++i) {
	                list.push(value[i]);
	            }
	            _this.paramsMap.set(param, list);
	        });
	    };
	    /**
	     * @return {?}
	     */
	    URLSearchParams.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ paramsList = [];
	        this.paramsMap.forEach(function (values, k) {
	            values.forEach(function (v) {
	                return paramsList.push(_this.queryEncoder.encodeKey(k) + '=' + _this.queryEncoder.encodeValue(v));
	            });
	        });
	        return paramsList.join('&');
	    };
	    /**
	     * @param {?} param
	     * @return {?}
	     */
	    URLSearchParams.prototype.delete = /**
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) { this.paramsMap.delete(param); };
	    return URLSearchParams;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * HTTP request body used by both {\@link Request} and {\@link Response}
	 * https://fetch.spec.whatwg.org/#body
	 * @abstract
	 */
	var Body = /** @class */ (function () {
	    function Body() {
	    }
	    /**
	     * Attempts to return body as parsed `JSON` object, or raises an exception.
	     */
	    /**
	     * Attempts to return body as parsed `JSON` object, or raises an exception.
	     * @return {?}
	     */
	    Body.prototype.json = /**
	     * Attempts to return body as parsed `JSON` object, or raises an exception.
	     * @return {?}
	     */
	    function () {
	        if (typeof this._body === 'string') {
	            return JSON.parse(/** @type {?} */ (this._body));
	        }
	        if (this._body instanceof ArrayBuffer) {
	            return JSON.parse(this.text());
	        }
	        return this._body;
	    };
	    /**
	     * Returns the body as a string, presuming `toString()` can be called on the response body.
	     *
	     * When decoding an `ArrayBuffer`, the optional `encodingHint` parameter determines how the
	     * bytes in the buffer will be interpreted. Valid values are:
	     *
	     * - `legacy` - incorrectly interpret the bytes as UTF-16 (technically, UCS-2). Only characters
	     *   in the Basic Multilingual Plane are supported, surrogate pairs are not handled correctly.
	     *   In addition, the endianness of the 16-bit octet pairs in the `ArrayBuffer` is not taken
	     *   into consideration. This is the default behavior to avoid breaking apps, but should be
	     *   considered deprecated.
	     *
	     * - `iso-8859` - interpret the bytes as ISO-8859 (which can be used for ASCII encoded text).
	     */
	    /**
	     * Returns the body as a string, presuming `toString()` can be called on the response body.
	     *
	     * When decoding an `ArrayBuffer`, the optional `encodingHint` parameter determines how the
	     * bytes in the buffer will be interpreted. Valid values are:
	     *
	     * - `legacy` - incorrectly interpret the bytes as UTF-16 (technically, UCS-2). Only characters
	     *   in the Basic Multilingual Plane are supported, surrogate pairs are not handled correctly.
	     *   In addition, the endianness of the 16-bit octet pairs in the `ArrayBuffer` is not taken
	     *   into consideration. This is the default behavior to avoid breaking apps, but should be
	     *   considered deprecated.
	     *
	     * - `iso-8859` - interpret the bytes as ISO-8859 (which can be used for ASCII encoded text).
	     * @param {?=} encodingHint
	     * @return {?}
	     */
	    Body.prototype.text = /**
	     * Returns the body as a string, presuming `toString()` can be called on the response body.
	     *
	     * When decoding an `ArrayBuffer`, the optional `encodingHint` parameter determines how the
	     * bytes in the buffer will be interpreted. Valid values are:
	     *
	     * - `legacy` - incorrectly interpret the bytes as UTF-16 (technically, UCS-2). Only characters
	     *   in the Basic Multilingual Plane are supported, surrogate pairs are not handled correctly.
	     *   In addition, the endianness of the 16-bit octet pairs in the `ArrayBuffer` is not taken
	     *   into consideration. This is the default behavior to avoid breaking apps, but should be
	     *   considered deprecated.
	     *
	     * - `iso-8859` - interpret the bytes as ISO-8859 (which can be used for ASCII encoded text).
	     * @param {?=} encodingHint
	     * @return {?}
	     */
	    function (encodingHint) {
	        if (encodingHint === void 0) { encodingHint = 'legacy'; }
	        if (this._body instanceof URLSearchParams) {
	            return this._body.toString();
	        }
	        if (this._body instanceof ArrayBuffer) {
	            switch (encodingHint) {
	                case 'legacy':
	                    return String.fromCharCode.apply(null, new Uint16Array(/** @type {?} */ (this._body)));
	                case 'iso-8859':
	                    return String.fromCharCode.apply(null, new Uint8Array(/** @type {?} */ (this._body)));
	                default:
	                    throw new Error("Invalid value for encodingHint: " + encodingHint);
	            }
	        }
	        if (this._body == null) {
	            return '';
	        }
	        if (typeof this._body === 'object') {
	            return JSON.stringify(this._body, null, 2);
	        }
	        return this._body.toString();
	    };
	    /**
	     * Return the body as an ArrayBuffer
	     */
	    /**
	     * Return the body as an ArrayBuffer
	     * @return {?}
	     */
	    Body.prototype.arrayBuffer = /**
	     * Return the body as an ArrayBuffer
	     * @return {?}
	     */
	    function () {
	        if (this._body instanceof ArrayBuffer) {
	            return /** @type {?} */ (this._body);
	        }
	        return stringToArrayBuffer(this.text());
	    };
	    /**
	      * Returns the request's body as a Blob, assuming that body exists.
	      */
	    /**
	     * Returns the request's body as a Blob, assuming that body exists.
	     * @return {?}
	     */
	    Body.prototype.blob = /**
	     * Returns the request's body as a Blob, assuming that body exists.
	     * @return {?}
	     */
	    function () {
	        if (this._body instanceof Blob) {
	            return /** @type {?} */ (this._body);
	        }
	        if (this._body instanceof ArrayBuffer) {
	            return new Blob([this._body]);
	        }
	        throw new Error('The request body isn\'t either a blob or an array buffer');
	    };
	    return Body;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Creates `Response` instances from provided values.
	 *
	 * Though this object isn't
	 * usually instantiated by end-users, it is the primary object interacted with when it comes time to
	 * add data to a view.
	 *
	 * ### Example
	 *
	 * ```
	 * http.request('my-friends.txt').subscribe(response => this.friends = response.text());
	 * ```
	 *
	 * The Response's interface is inspired by the Response constructor defined in the [Fetch
	 * Spec](https://fetch.spec.whatwg.org/#response-class), but is considered a static value whose body
	 * can be accessed many times. There are other differences in the implementation, but this is the
	 * most significant.
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var Response = /** @class */ (function (_super) {
	    __extends(Response, _super);
	    function Response(responseOptions) {
	        var _this = _super.call(this) || this;
	        _this._body = responseOptions.body;
	        _this.status = /** @type {?} */ ((responseOptions.status));
	        _this.ok = (_this.status >= 200 && _this.status <= 299);
	        _this.statusText = responseOptions.statusText;
	        _this.headers = responseOptions.headers;
	        _this.type = /** @type {?} */ ((responseOptions.type));
	        _this.url = /** @type {?} */ ((responseOptions.url));
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    Response.prototype.toString = /**
	     * @return {?}
	     */
	    function () {
	        return "Response with status: " + this.status + " " + this.statusText + " for URL: " + this.url;
	    };
	    return Response;
	}(Body));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var _nextRequestId = 0;
	var JSONP_HOME = '__ng_jsonp__';
	var _jsonpConnections = null;
	/**
	 * @return {?}
	 */
	function _getJsonpConnections() {
	    var /** @type {?} */ w = typeof window == 'object' ? window : {};
	    if (_jsonpConnections === null) {
	        _jsonpConnections = w[JSONP_HOME] = {};
	    }
	    return _jsonpConnections;
	}
	var BrowserJsonp = /** @class */ (function () {
	    function BrowserJsonp() {
	    }
	    // Construct a <script> element with the specified URL
	    /**
	     * @param {?} url
	     * @return {?}
	     */
	    BrowserJsonp.prototype.build = /**
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        var /** @type {?} */ node = document.createElement('script');
	        node.src = url;
	        return node;
	    };
	    /**
	     * @return {?}
	     */
	    BrowserJsonp.prototype.nextRequestID = /**
	     * @return {?}
	     */
	    function () { return "__req" + _nextRequestId++; };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    BrowserJsonp.prototype.requestCallback = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) { return JSONP_HOME + "." + id + ".finished"; };
	    /**
	     * @param {?} id
	     * @param {?} connection
	     * @return {?}
	     */
	    BrowserJsonp.prototype.exposeConnection = /**
	     * @param {?} id
	     * @param {?} connection
	     * @return {?}
	     */
	    function (id, connection) {
	        var /** @type {?} */ connections = _getJsonpConnections();
	        connections[id] = connection;
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    BrowserJsonp.prototype.removeConnection = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        var /** @type {?} */ connections = _getJsonpConnections();
	        connections[id] = null;
	    };
	    // Attach the <script> element to the DOM
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserJsonp.prototype.send = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { document.body.appendChild(/** @type {?} */ ((node))); };
	    // Remove <script> element from the DOM
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BrowserJsonp.prototype.cleanup = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) {
	        if (node.parentNode) {
	            node.parentNode.removeChild(/** @type {?} */ ((node)));
	        }
	    };
	    BrowserJsonp.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BrowserJsonp.ctorParameters = function () { return []; };
	    return BrowserJsonp;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
	var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use GET request method.';
	/**
	 * Base class for an in-flight JSONP request.
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var JSONPConnection = /** @class */ (function () {
	    /** @internal */
	    function JSONPConnection(req, _dom, baseResponseOptions) {
	        var _this = this;
	        this._dom = _dom;
	        this.baseResponseOptions = baseResponseOptions;
	        this._finished = false;
	        if (req.method !== RequestMethod.Get) {
	            throw new TypeError(JSONP_ERR_WRONG_METHOD);
	        }
	        this.request = req;
	        this.response = new rxjs_Observable.Observable(function (responseObserver) {
	            _this.readyState = ReadyState.Loading;
	            var /** @type {?} */ id = _this._id = _dom.nextRequestID();
	            _dom.exposeConnection(id, _this);
	            // Workaround Dart
	            // url = url.replace(/=JSONP_CALLBACK(&|$)/, `generated method`);
	            var /** @type {?} */ callback = _dom.requestCallback(_this._id);
	            var /** @type {?} */ url = req.url;
	            if (url.indexOf('=JSONP_CALLBACK&') > -1) {
	                url = url.replace('=JSONP_CALLBACK&', "=" + callback + "&");
	            }
	            else if (url.lastIndexOf('=JSONP_CALLBACK') === url.length - '=JSONP_CALLBACK'.length) {
	                url = url.substring(0, url.length - '=JSONP_CALLBACK'.length) + ("=" + callback);
	            }
	            var /** @type {?} */ script = _this._script = _dom.build(url);
	            var /** @type {?} */ onLoad = function (event) {
	                if (_this.readyState === ReadyState.Cancelled)
	                    return;
	                _this.readyState = ReadyState.Done;
	                _dom.cleanup(script);
	                if (!_this._finished) {
	                    var /** @type {?} */ responseOptions_1 = new ResponseOptions({ body: JSONP_ERR_NO_CALLBACK, type: ResponseType.Error, url: url });
	                    if (baseResponseOptions) {
	                        responseOptions_1 = baseResponseOptions.merge(responseOptions_1);
	                    }
	                    responseObserver.error(new Response(responseOptions_1));
	                    return;
	                }
	                var /** @type {?} */ responseOptions = new ResponseOptions({ body: _this._responseData, url: url });
	                if (_this.baseResponseOptions) {
	                    responseOptions = _this.baseResponseOptions.merge(responseOptions);
	                }
	                responseObserver.next(new Response(responseOptions));
	                responseObserver.complete();
	            };
	            var /** @type {?} */ onError = function (error) {
	                if (_this.readyState === ReadyState.Cancelled)
	                    return;
	                _this.readyState = ReadyState.Done;
	                _dom.cleanup(script);
	                var /** @type {?} */ responseOptions = new ResponseOptions({ body: error.message, type: ResponseType.Error });
	                if (baseResponseOptions) {
	                    responseOptions = baseResponseOptions.merge(responseOptions);
	                }
	                responseObserver.error(new Response(responseOptions));
	            };
	            script.addEventListener('load', onLoad);
	            script.addEventListener('error', onError);
	            _dom.send(script);
	            return function () {
	                _this.readyState = ReadyState.Cancelled;
	                script.removeEventListener('load', onLoad);
	                script.removeEventListener('error', onError);
	                _this._dom.cleanup(script);
	            };
	        });
	    }
	    /**
	     * Callback called when the JSONP request completes, to notify the application
	     * of the new data.
	     */
	    /**
	     * Callback called when the JSONP request completes, to notify the application
	     * of the new data.
	     * @param {?=} data
	     * @return {?}
	     */
	    JSONPConnection.prototype.finished = /**
	     * Callback called when the JSONP request completes, to notify the application
	     * of the new data.
	     * @param {?=} data
	     * @return {?}
	     */
	    function (data) {
	        // Don't leak connections
	        this._finished = true;
	        this._dom.removeConnection(this._id);
	        if (this.readyState === ReadyState.Cancelled)
	            return;
	        this._responseData = data;
	    };
	    return JSONPConnection;
	}());
	/**
	 * A {\@link ConnectionBackend} that uses the JSONP strategy of making requests.
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var JSONPBackend = /** @class */ (function (_super) {
	    __extends(JSONPBackend, _super);
	    /** @internal */
	    function JSONPBackend(_browserJSONP, _baseResponseOptions) {
	        var _this = _super.call(this) || this;
	        _this._browserJSONP = _browserJSONP;
	        _this._baseResponseOptions = _baseResponseOptions;
	        return _this;
	    }
	    /**
	     * @param {?} request
	     * @return {?}
	     */
	    JSONPBackend.prototype.createConnection = /**
	     * @param {?} request
	     * @return {?}
	     */
	    function (request) {
	        return new JSONPConnection(request, this._browserJSONP, this._baseResponseOptions);
	    };
	    JSONPBackend.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    JSONPBackend.ctorParameters = function () { return [
	        { type: BrowserJsonp, },
	        { type: ResponseOptions, },
	    ]; };
	    return JSONPBackend;
	}(ConnectionBackend));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var XSSI_PREFIX = /^\)\]\}',?\n/;
	/**
	 * Creates connections using `XMLHttpRequest`. Given a fully-qualified
	 * request, an `XHRConnection` will immediately create an `XMLHttpRequest` object and send the
	 * request.
	 *
	 * This class would typically not be created or interacted with directly inside applications, though
	 * the {\@link MockConnection} may be interacted with in tests.
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var XHRConnection = /** @class */ (function () {
	    function XHRConnection(req, browserXHR, baseResponseOptions) {
	        var _this = this;
	        this.request = req;
	        this.response = new rxjs_Observable.Observable(function (responseObserver) {
	            var /** @type {?} */ _xhr = browserXHR.build();
	            _xhr.open(RequestMethod[req.method].toUpperCase(), req.url);
	            if (req.withCredentials != null) {
	                _xhr.withCredentials = req.withCredentials;
	            }
	            // load event handler
	            var /** @type {?} */ onLoad = function () {
	                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	                var /** @type {?} */ status = _xhr.status === 1223 ? 204 : _xhr.status;
	                var /** @type {?} */ body = null;
	                // HTTP 204 means no content
	                if (status !== 204) {
	                    // responseText is the old-school way of retrieving response (supported by IE8 & 9)
	                    // response/responseType properties were introduced in ResourceLoader Level2 spec
	                    // (supported by IE10)
	                    body = (typeof _xhr.response === 'undefined') ? _xhr.responseText : _xhr.response;
	                    // Implicitly strip a potential XSSI prefix.
	                    if (typeof body === 'string') {
	                        body = body.replace(XSSI_PREFIX, '');
	                    }
	                }
	                // fix status code when it is 0 (0 status is undocumented).
	                // Occurs when accessing file resources or on Android 4.1 stock browser
	                // while retrieving files from application cache.
	                if (status === 0) {
	                    status = body ? 200 : 0;
	                }
	                var /** @type {?} */ headers = Headers.fromResponseHeaderString(_xhr.getAllResponseHeaders());
	                // IE 9 does not provide the way to get URL of response
	                var /** @type {?} */ url = getResponseURL(_xhr) || req.url;
	                var /** @type {?} */ statusText = _xhr.statusText || 'OK';
	                var /** @type {?} */ responseOptions = new ResponseOptions({ body: body, status: status, headers: headers, statusText: statusText, url: url });
	                if (baseResponseOptions != null) {
	                    responseOptions = baseResponseOptions.merge(responseOptions);
	                }
	                var /** @type {?} */ response = new Response(responseOptions);
	                response.ok = isSuccess(status);
	                if (response.ok) {
	                    responseObserver.next(response);
	                    // TODO(gdi2290): defer complete if array buffer until done
	                    responseObserver.complete();
	                    return;
	                }
	                responseObserver.error(response);
	            };
	            // error event handler
	            var /** @type {?} */ onError = function (err) {
	                var /** @type {?} */ responseOptions = new ResponseOptions({
	                    body: err,
	                    type: ResponseType.Error,
	                    status: _xhr.status,
	                    statusText: _xhr.statusText,
	                });
	                if (baseResponseOptions != null) {
	                    responseOptions = baseResponseOptions.merge(responseOptions);
	                }
	                responseObserver.error(new Response(responseOptions));
	            };
	            _this.setDetectedContentType(req, _xhr);
	            if (req.headers == null) {
	                req.headers = new Headers();
	            }
	            if (!req.headers.has('Accept')) {
	                req.headers.append('Accept', 'application/json, text/plain, */*');
	            }
	            req.headers.forEach(function (values, name) { return _xhr.setRequestHeader(/** @type {?} */ ((name)), values.join(',')); });
	            // Select the correct buffer type to store the response
	            if (req.responseType != null && _xhr.responseType != null) {
	                switch (req.responseType) {
	                    case ResponseContentType.ArrayBuffer:
	                        _xhr.responseType = 'arraybuffer';
	                        break;
	                    case ResponseContentType.Json:
	                        _xhr.responseType = 'json';
	                        break;
	                    case ResponseContentType.Text:
	                        _xhr.responseType = 'text';
	                        break;
	                    case ResponseContentType.Blob:
	                        _xhr.responseType = 'blob';
	                        break;
	                    default:
	                        throw new Error('The selected responseType is not supported');
	                }
	            }
	            _xhr.addEventListener('load', onLoad);
	            _xhr.addEventListener('error', onError);
	            _xhr.send(_this.request.getBody());
	            return function () {
	                _xhr.removeEventListener('load', onLoad);
	                _xhr.removeEventListener('error', onError);
	                _xhr.abort();
	            };
	        });
	    }
	    /**
	     * @param {?} req
	     * @param {?} _xhr
	     * @return {?}
	     */
	    XHRConnection.prototype.setDetectedContentType = /**
	     * @param {?} req
	     * @param {?} _xhr
	     * @return {?}
	     */
	    function (req /** TODO Request */, _xhr /** XMLHttpRequest */) {
	        // Skip if a custom Content-Type header is provided
	        if (req.headers != null && req.headers.get('Content-Type') != null) {
	            return;
	        }
	        // Set the detected content type
	        switch (req.contentType) {
	            case ContentType.NONE:
	                break;
	            case ContentType.JSON:
	                _xhr.setRequestHeader('content-type', 'application/json');
	                break;
	            case ContentType.FORM:
	                _xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	                break;
	            case ContentType.TEXT:
	                _xhr.setRequestHeader('content-type', 'text/plain');
	                break;
	            case ContentType.BLOB:
	                var /** @type {?} */ blob = req.blob();
	                if (blob.type) {
	                    _xhr.setRequestHeader('content-type', blob.type);
	                }
	                break;
	        }
	    };
	    return XHRConnection;
	}());
	/**
	 * `XSRFConfiguration` sets up Cross Site Request Forgery (XSRF) protection for the application
	 * using a cookie. See https://www.owasp.org/index.php/Cross-Site_Request_Forgery_(CSRF)
	 * for more information on XSRF.
	 *
	 * Applications can configure custom cookie and header names by binding an instance of this class
	 * with different `cookieName` and `headerName` values. See the main HTTP documentation for more
	 * details.
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var CookieXSRFStrategy = /** @class */ (function () {
	    function CookieXSRFStrategy(_cookieName, _headerName) {
	        if (_cookieName === void 0) { _cookieName = 'XSRF-TOKEN'; }
	        if (_headerName === void 0) { _headerName = 'X-XSRF-TOKEN'; }
	        this._cookieName = _cookieName;
	        this._headerName = _headerName;
	    }
	    /**
	     * @param {?} req
	     * @return {?}
	     */
	    CookieXSRFStrategy.prototype.configureRequest = /**
	     * @param {?} req
	     * @return {?}
	     */
	    function (req) {
	        var /** @type {?} */ xsrfToken = _angular_platformBrowser.ɵgetDOM().getCookie(this._cookieName);
	        if (xsrfToken) {
	            req.headers.set(this._headerName, xsrfToken);
	        }
	    };
	    return CookieXSRFStrategy;
	}());
	/**
	 * Creates {\@link XHRConnection} instances.
	 *
	 * This class would typically not be used by end users, but could be
	 * overridden if a different backend implementation should be used,
	 * such as in a node backend.
	 *
	 * ### Example
	 *
	 * ```
	 * import {Http, MyNodeBackend, HTTP_PROVIDERS, BaseRequestOptions} from '\@angular/http';
	 * \@Component({
	 *   viewProviders: [
	 *     HTTP_PROVIDERS,
	 *     {provide: Http, useFactory: (backend, options) => {
	 *       return new Http(backend, options);
	 *     }, deps: [MyNodeBackend, BaseRequestOptions]}]
	 * })
	 * class MyComponent {
	 *   constructor(http:Http) {
	 *     http.request('people.json').subscribe(res => this.people = res.json());
	 *   }
	 * }
	 * ```
	 * @deprecated use \@angular/common/http instead
	 */
	var XHRBackend = /** @class */ (function () {
	    function XHRBackend(_browserXHR, _baseResponseOptions, _xsrfStrategy) {
	        this._browserXHR = _browserXHR;
	        this._baseResponseOptions = _baseResponseOptions;
	        this._xsrfStrategy = _xsrfStrategy;
	    }
	    /**
	     * @param {?} request
	     * @return {?}
	     */
	    XHRBackend.prototype.createConnection = /**
	     * @param {?} request
	     * @return {?}
	     */
	    function (request) {
	        this._xsrfStrategy.configureRequest(request);
	        return new XHRConnection(request, this._browserXHR, this._baseResponseOptions);
	    };
	    XHRBackend.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    XHRBackend.ctorParameters = function () { return [
	        { type: BrowserXhr, },
	        { type: ResponseOptions, },
	        { type: XSRFStrategy, },
	    ]; };
	    return XHRBackend;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Creates a request options object to be optionally provided when instantiating a
	 * {\@link Request}.
	 *
	 * This class is based on the `RequestInit` description in the [Fetch
	 * Spec](https://fetch.spec.whatwg.org/#requestinit).
	 *
	 * All values are null by default. Typical defaults can be found in the {\@link BaseRequestOptions}
	 * class, which sub-classes `RequestOptions`.
	 *
	 * ```typescript
	 * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
	 *
	 * const options = new RequestOptions({
	 *   method: RequestMethod.Post,
	 *   url: 'https://google.com'
	 * });
	 * const req = new Request(options);
	 * console.log('req.method:', RequestMethod[req.method]); // Post
	 * console.log('options.url:', options.url); // https://google.com
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var RequestOptions = /** @class */ (function () {
	    // TODO(Dzmitry): remove search when this.search is removed
	    function RequestOptions(opts) {
	        if (opts === void 0) { opts = {}; }
	        var method = opts.method, headers = opts.headers, body = opts.body, url = opts.url, search = opts.search, params = opts.params, withCredentials = opts.withCredentials, responseType = opts.responseType;
	        this.method = method != null ? normalizeMethodName(method) : null;
	        this.headers = headers != null ? headers : null;
	        this.body = body != null ? body : null;
	        this.url = url != null ? url : null;
	        this.params = this._mergeSearchParams(params || search);
	        this.withCredentials = withCredentials != null ? withCredentials : null;
	        this.responseType = responseType != null ? responseType : null;
	    }
	    Object.defineProperty(RequestOptions.prototype, "search", {
	        /**
	         * @deprecated from 4.0.0. Use params instead.
	         */
	        get: /**
	         * @deprecated from 4.0.0. Use params instead.
	         * @return {?}
	         */
	        function () { return this.params; },
	        /**
	         * @deprecated from 4.0.0. Use params instead.
	         */
	        set: /**
	         * @deprecated from 4.0.0. Use params instead.
	         * @param {?} params
	         * @return {?}
	         */
	        function (params) { this.params = params; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
	     * existing values. This method will not change the values of the instance on which it is being
	     * called.
	     *
	     * Note that `headers` and `search` will override existing values completely if present in
	     * the `options` object. If these values should be merged, it should be done prior to calling
	     * `merge` on the `RequestOptions` instance.
	     *
	     * ```typescript
	     * import {RequestOptions, Request, RequestMethod} from '@angular/http';
	     *
	     * const options = new RequestOptions({
	     *   method: RequestMethod.Post
	     * });
	     * const req = new Request(options.merge({
	     *   url: 'https://google.com'
	     * }));
	     * console.log('req.method:', RequestMethod[req.method]); // Post
	     * console.log('options.url:', options.url); // null
	     * console.log('req.url:', req.url); // https://google.com
	     * ```
	     */
	    /**
	     * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
	     * existing values. This method will not change the values of the instance on which it is being
	     * called.
	     *
	     * Note that `headers` and `search` will override existing values completely if present in
	     * the `options` object. If these values should be merged, it should be done prior to calling
	     * `merge` on the `RequestOptions` instance.
	     *
	     * ```typescript
	     * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
	     *
	     * const options = new RequestOptions({
	     *   method: RequestMethod.Post
	     * });
	     * const req = new Request(options.merge({
	     *   url: 'https://google.com'
	     * }));
	     * console.log('req.method:', RequestMethod[req.method]); // Post
	     * console.log('options.url:', options.url); // null
	     * console.log('req.url:', req.url); // https://google.com
	     * ```
	     * @param {?=} options
	     * @return {?}
	     */
	    RequestOptions.prototype.merge = /**
	     * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
	     * existing values. This method will not change the values of the instance on which it is being
	     * called.
	     *
	     * Note that `headers` and `search` will override existing values completely if present in
	     * the `options` object. If these values should be merged, it should be done prior to calling
	     * `merge` on the `RequestOptions` instance.
	     *
	     * ```typescript
	     * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
	     *
	     * const options = new RequestOptions({
	     *   method: RequestMethod.Post
	     * });
	     * const req = new Request(options.merge({
	     *   url: 'https://google.com'
	     * }));
	     * console.log('req.method:', RequestMethod[req.method]); // Post
	     * console.log('options.url:', options.url); // null
	     * console.log('req.url:', req.url); // https://google.com
	     * ```
	     * @param {?=} options
	     * @return {?}
	     */
	    function (options) {
	        return new RequestOptions({
	            method: options && options.method != null ? options.method : this.method,
	            headers: options && options.headers != null ? options.headers : new Headers(this.headers),
	            body: options && options.body != null ? options.body : this.body,
	            url: options && options.url != null ? options.url : this.url,
	            params: options && this._mergeSearchParams(options.params || options.search),
	            withCredentials: options && options.withCredentials != null ? options.withCredentials :
	                this.withCredentials,
	            responseType: options && options.responseType != null ? options.responseType :
	                this.responseType
	        });
	    };
	    /**
	     * @param {?=} params
	     * @return {?}
	     */
	    RequestOptions.prototype._mergeSearchParams = /**
	     * @param {?=} params
	     * @return {?}
	     */
	    function (params) {
	        if (!params)
	            return this.params;
	        if (params instanceof URLSearchParams) {
	            return params.clone();
	        }
	        if (typeof params === 'string') {
	            return new URLSearchParams(params);
	        }
	        return this._parseParams(params);
	    };
	    /**
	     * @param {?=} objParams
	     * @return {?}
	     */
	    RequestOptions.prototype._parseParams = /**
	     * @param {?=} objParams
	     * @return {?}
	     */
	    function (objParams) {
	        var _this = this;
	        if (objParams === void 0) { objParams = {}; }
	        var /** @type {?} */ params = new URLSearchParams();
	        Object.keys(objParams).forEach(function (key) {
	            var /** @type {?} */ value = objParams[key];
	            if (Array.isArray(value)) {
	                value.forEach(function (item) { return _this._appendParam(key, item, params); });
	            }
	            else {
	                _this._appendParam(key, value, params);
	            }
	        });
	        return params;
	    };
	    /**
	     * @param {?} key
	     * @param {?} value
	     * @param {?} params
	     * @return {?}
	     */
	    RequestOptions.prototype._appendParam = /**
	     * @param {?} key
	     * @param {?} value
	     * @param {?} params
	     * @return {?}
	     */
	    function (key, value, params) {
	        if (typeof value !== 'string') {
	            value = JSON.stringify(value);
	        }
	        params.append(key, value);
	    };
	    return RequestOptions;
	}());
	/**
	 * Subclass of {\@link RequestOptions}, with default values.
	 *
	 * Default values:
	 *  * method: {\@link RequestMethod RequestMethod.Get}
	 *  * headers: empty {\@link Headers} object
	 *
	 * This class could be extended and bound to the {\@link RequestOptions} class
	 * when configuring an {\@link Injector}, in order to override the default options
	 * used by {\@link Http} to create and send {\@link Request Requests}.
	 *
	 * ```typescript
	 * import {BaseRequestOptions, RequestOptions} from '\@angular/http';
	 *
	 * class MyOptions extends BaseRequestOptions {
	 *   search: string = 'coreTeam=true';
	 * }
	 *
	 * {provide: RequestOptions, useClass: MyOptions};
	 * ```
	 *
	 * The options could also be extended when manually creating a {\@link Request}
	 * object.
	 *
	 * ```
	 * import {BaseRequestOptions, Request, RequestMethod} from '\@angular/http';
	 *
	 * const options = new BaseRequestOptions();
	 * const req = new Request(options.merge({
	 *   method: RequestMethod.Post,
	 *   url: 'https://google.com'
	 * }));
	 * console.log('req.method:', RequestMethod[req.method]); // Post
	 * console.log('options.url:', options.url); // null
	 * console.log('req.url:', req.url); // https://google.com
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var BaseRequestOptions = /** @class */ (function (_super) {
	    __extends(BaseRequestOptions, _super);
	    function BaseRequestOptions() {
	        return _super.call(this, { method: RequestMethod.Get, headers: new Headers() }) || this;
	    }
	    BaseRequestOptions.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BaseRequestOptions.ctorParameters = function () { return []; };
	    return BaseRequestOptions;
	}(RequestOptions));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Creates `Request` instances from provided values.
	 *
	 * The Request's interface is inspired by the Request constructor defined in the [Fetch
	 * Spec](https://fetch.spec.whatwg.org/#request-class),
	 * but is considered a static value whose body can be accessed many times. There are other
	 * differences in the implementation, but this is the most significant.
	 *
	 * `Request` instances are typically created by higher-level classes, like {\@link Http} and
	 * {\@link Jsonp}, but it may occasionally be useful to explicitly create `Request` instances.
	 * One such example is when creating services that wrap higher-level services, like {\@link Http},
	 * where it may be useful to generate a `Request` with arbitrary headers and search params.
	 *
	 * ```typescript
	 * import {Injectable, Injector} from '\@angular/core';
	 * import {HTTP_PROVIDERS, Http, Request, RequestMethod} from '\@angular/http';
	 *
	 * \@Injectable()
	 * class AutoAuthenticator {
	 *   constructor(public http:Http) {}
	 *   request(url:string) {
	 *     return this.http.request(new Request({
	 *       method: RequestMethod.Get,
	 *       url: url,
	 *       search: 'password=123'
	 *     }));
	 *   }
	 * }
	 *
	 * var injector = Injector.resolveAndCreate([HTTP_PROVIDERS, AutoAuthenticator]);
	 * var authenticator = injector.get(AutoAuthenticator);
	 * authenticator.request('people.json').subscribe(res => {
	 *   //URL should have included '?password=123'
	 *   console.log('people', res.json());
	 * });
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var Request = /** @class */ (function (_super) {
	    __extends(Request, _super);
	    function Request(requestOptions) {
	        var _this = _super.call(this) || this;
	        // TODO: assert that url is present
	        var /** @type {?} */ url = requestOptions.url;
	        _this.url = /** @type {?} */ ((requestOptions.url));
	        var /** @type {?} */ paramsArg = requestOptions.params || requestOptions.search;
	        if (paramsArg) {
	            var /** @type {?} */ params = void 0;
	            if (typeof paramsArg === 'object' && !(paramsArg instanceof URLSearchParams)) {
	                params = urlEncodeParams(paramsArg).toString();
	            }
	            else {
	                params = paramsArg.toString();
	            }
	            if (params.length > 0) {
	                var /** @type {?} */ prefix = '?';
	                if (_this.url.indexOf('?') != -1) {
	                    prefix = (_this.url[_this.url.length - 1] == '&') ? '' : '&';
	                }
	                // TODO: just delete search-query-looking string in url?
	                // TODO: just delete search-query-looking string in url?
	                _this.url = url + prefix + params;
	            }
	        }
	        _this._body = requestOptions.body;
	        _this.method = normalizeMethodName(/** @type {?} */ ((requestOptions.method)));
	        // TODO(jeffbcross): implement behavior
	        // Defaults to 'omit', consistent with browser
	        // TODO(jeffbcross): implement behavior
	        // Defaults to 'omit', consistent with browser
	        _this.headers = new Headers(requestOptions.headers);
	        _this.contentType = _this.detectContentType();
	        _this.withCredentials = /** @type {?} */ ((requestOptions.withCredentials));
	        _this.responseType = /** @type {?} */ ((requestOptions.responseType));
	        return _this;
	    }
	    /**
	     * Returns the content type enum based on header options.
	     */
	    /**
	     * Returns the content type enum based on header options.
	     * @return {?}
	     */
	    Request.prototype.detectContentType = /**
	     * Returns the content type enum based on header options.
	     * @return {?}
	     */
	    function () {
	        switch (this.headers.get('content-type')) {
	            case 'application/json':
	                return ContentType.JSON;
	            case 'application/x-www-form-urlencoded':
	                return ContentType.FORM;
	            case 'multipart/form-data':
	                return ContentType.FORM_DATA;
	            case 'text/plain':
	            case 'text/html':
	                return ContentType.TEXT;
	            case 'application/octet-stream':
	                return this._body instanceof ArrayBuffer$1 ? ContentType.ARRAY_BUFFER : ContentType.BLOB;
	            default:
	                return this.detectContentTypeFromBody();
	        }
	    };
	    /**
	     * Returns the content type of request's body based on its type.
	     */
	    /**
	     * Returns the content type of request's body based on its type.
	     * @return {?}
	     */
	    Request.prototype.detectContentTypeFromBody = /**
	     * Returns the content type of request's body based on its type.
	     * @return {?}
	     */
	    function () {
	        if (this._body == null) {
	            return ContentType.NONE;
	        }
	        else if (this._body instanceof URLSearchParams) {
	            return ContentType.FORM;
	        }
	        else if (this._body instanceof FormData) {
	            return ContentType.FORM_DATA;
	        }
	        else if (this._body instanceof Blob$1) {
	            return ContentType.BLOB;
	        }
	        else if (this._body instanceof ArrayBuffer$1) {
	            return ContentType.ARRAY_BUFFER;
	        }
	        else if (this._body && typeof this._body === 'object') {
	            return ContentType.JSON;
	        }
	        else {
	            return ContentType.TEXT;
	        }
	    };
	    /**
	     * Returns the request's body according to its type. If body is undefined, return
	     * null.
	     */
	    /**
	     * Returns the request's body according to its type. If body is undefined, return
	     * null.
	     * @return {?}
	     */
	    Request.prototype.getBody = /**
	     * Returns the request's body according to its type. If body is undefined, return
	     * null.
	     * @return {?}
	     */
	    function () {
	        switch (this.contentType) {
	            case ContentType.JSON:
	                return this.text();
	            case ContentType.FORM:
	                return this.text();
	            case ContentType.FORM_DATA:
	                return this._body;
	            case ContentType.TEXT:
	                return this.text();
	            case ContentType.BLOB:
	                return this.blob();
	            case ContentType.ARRAY_BUFFER:
	                return this.arrayBuffer();
	            default:
	                return null;
	        }
	    };
	    return Request;
	}(Body));
	/**
	 * @param {?} params
	 * @return {?}
	 */
	function urlEncodeParams(params) {
	    var /** @type {?} */ searchParams = new URLSearchParams();
	    Object.keys(params).forEach(function (key) {
	        var /** @type {?} */ value = params[key];
	        if (value && Array.isArray(value)) {
	            value.forEach(function (element) { return searchParams.append(key, element.toString()); });
	        }
	        else {
	            searchParams.append(key, value.toString());
	        }
	    });
	    return searchParams;
	}
	var noop = function () { };
	var w = typeof window == 'object' ? window : noop;
	var FormData = (/** @type {?} */ (w /** TODO #9100 */) /** TODO #9100 */)['FormData'] || noop;
	var Blob$1 = (/** @type {?} */ (w /** TODO #9100 */) /** TODO #9100 */)['Blob'] || noop;
	var ArrayBuffer$1 = (/** @type {?} */ (w /** TODO #9100 */) /** TODO #9100 */)['ArrayBuffer'] || noop;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @param {?} backend
	 * @param {?} request
	 * @return {?}
	 */
	function httpRequest(backend, request) {
	    return backend.createConnection(request).response;
	}
	/**
	 * @param {?} defaultOpts
	 * @param {?} providedOpts
	 * @param {?} method
	 * @param {?} url
	 * @return {?}
	 */
	function mergeOptions(defaultOpts, providedOpts, method, url) {
	    var /** @type {?} */ newOptions = defaultOpts;
	    if (providedOpts) {
	        // Hack so Dart can used named parameters
	        return /** @type {?} */ (newOptions.merge(new RequestOptions({
	            method: providedOpts.method || method,
	            url: providedOpts.url || url,
	            search: providedOpts.search,
	            params: providedOpts.params,
	            headers: providedOpts.headers,
	            body: providedOpts.body,
	            withCredentials: providedOpts.withCredentials,
	            responseType: providedOpts.responseType
	        })));
	    }
	    return /** @type {?} */ (newOptions.merge(new RequestOptions({ method: method, url: url })));
	}
	/**
	 * Performs http requests using `XMLHttpRequest` as the default backend.
	 *
	 * `Http` is available as an injectable class, with methods to perform http requests. Calling
	 * `request` returns an `Observable` which will emit a single {\@link Response} when a
	 * response is received.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * import {Http, HTTP_PROVIDERS} from '\@angular/http';
	 * import 'rxjs/add/operator/map'
	 * \@Component({
	 *   selector: 'http-app',
	 *   viewProviders: [HTTP_PROVIDERS],
	 *   templateUrl: 'people.html'
	 * })
	 * class PeopleComponent {
	 *   constructor(http: Http) {
	 *     http.get('people.json')
	 *       // Call map on the response observable to get the parsed people object
	 *       .map(res => res.json())
	 *       // Subscribe to the observable to get the parsed people object and attach it to the
	 *       // component
	 *       .subscribe(people => this.people = people);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * ### Example
	 *
	 * ```
	 * http.get('people.json').subscribe((res:Response) => this.people = res.json());
	 * ```
	 *
	 * The default construct used to perform requests, `XMLHttpRequest`, is abstracted as a "Backend" (
	 * {\@link XHRBackend} in this case), which could be mocked with dependency injection by replacing
	 * the {\@link XHRBackend} provider, as in the following example:
	 *
	 * ### Example
	 *
	 * ```typescript
	 * import {BaseRequestOptions, Http} from '\@angular/http';
	 * import {MockBackend} from '\@angular/http/testing';
	 * var injector = Injector.resolveAndCreate([
	 *   BaseRequestOptions,
	 *   MockBackend,
	 *   {provide: Http, useFactory:
	 *       function(backend, defaultOptions) {
	 *         return new Http(backend, defaultOptions);
	 *       },
	 *       deps: [MockBackend, BaseRequestOptions]}
	 * ]);
	 * var http = injector.get(Http);
	 * http.get('request-from-mock-backend.json').subscribe((res:Response) => doSomething(res));
	 * ```
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var Http = /** @class */ (function () {
	    function Http(_backend, _defaultOptions) {
	        this._backend = _backend;
	        this._defaultOptions = _defaultOptions;
	    }
	    /**
	     * Performs any type of http request. First argument is required, and can either be a url or
	     * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
	     * object can be provided as the 2nd argument. The options object will be merged with the values
	     * of {@link BaseRequestOptions} before performing the request.
	     */
	    /**
	     * Performs any type of http request. First argument is required, and can either be a url or
	     * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
	     * object can be provided as the 2nd argument. The options object will be merged with the values
	     * of {\@link BaseRequestOptions} before performing the request.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.request = /**
	     * Performs any type of http request. First argument is required, and can either be a url or
	     * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
	     * object can be provided as the 2nd argument. The options object will be merged with the values
	     * of {\@link BaseRequestOptions} before performing the request.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        var /** @type {?} */ responseObservable;
	        if (typeof url === 'string') {
	            responseObservable = httpRequest(this._backend, new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, /** @type {?} */ (url))));
	        }
	        else if (url instanceof Request) {
	            responseObservable = httpRequest(this._backend, url);
	        }
	        else {
	            throw new Error('First argument must be a url string or Request instance.');
	        }
	        return responseObservable;
	    };
	    /**
	     * Performs a request with `get` http method.
	     */
	    /**
	     * Performs a request with `get` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.get = /**
	     * Performs a request with `get` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, url)));
	    };
	    /**
	     * Performs a request with `post` http method.
	     */
	    /**
	     * Performs a request with `post` http method.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.post = /**
	     * Performs a request with `post` http method.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, body, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Post, url)));
	    };
	    /**
	     * Performs a request with `put` http method.
	     */
	    /**
	     * Performs a request with `put` http method.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.put = /**
	     * Performs a request with `put` http method.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, body, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Put, url)));
	    };
	    /**
	     * Performs a request with `delete` http method.
	     */
	    /**
	     * Performs a request with `delete` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.delete = /**
	     * Performs a request with `delete` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Delete, url)));
	    };
	    /**
	     * Performs a request with `patch` http method.
	     */
	    /**
	     * Performs a request with `patch` http method.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.patch = /**
	     * Performs a request with `patch` http method.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, body, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Patch, url)));
	    };
	    /**
	     * Performs a request with `head` http method.
	     */
	    /**
	     * Performs a request with `head` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.head = /**
	     * Performs a request with `head` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Head, url)));
	    };
	    /**
	     * Performs a request with `options` http method.
	     */
	    /**
	     * Performs a request with `options` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    Http.prototype.options = /**
	     * Performs a request with `options` http method.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Options, url)));
	    };
	    Http.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Http.ctorParameters = function () { return [
	        { type: ConnectionBackend, },
	        { type: RequestOptions, },
	    ]; };
	    return Http;
	}());
	/**
	 * @deprecated use \@angular/common/http instead
	 */
	var Jsonp = /** @class */ (function (_super) {
	    __extends(Jsonp, _super);
	    function Jsonp(backend, defaultOptions) {
	        return _super.call(this, backend, defaultOptions) || this;
	    }
	    /**
	     * Performs any type of http request. First argument is required, and can either be a url or
	     * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
	     * object can be provided as the 2nd argument. The options object will be merged with the values
	     * of {@link BaseRequestOptions} before performing the request.
	     *
	     * @security Regular XHR is the safest alternative to JSONP for most applications, and is
	     * supported by all current browsers. Because JSONP creates a `<script>` element with
	     * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
	     * source could expose your application to XSS risks. Data exposed by JSONP may also be
	     * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
	     * future security issues (e.g. content sniffing).  For more detail, see the
	     * [Security Guide](http://g.co/ng/security).
	     */
	    /**
	     * Performs any type of http request. First argument is required, and can either be a url or
	     * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
	     * object can be provided as the 2nd argument. The options object will be merged with the values
	     * of {\@link BaseRequestOptions} before performing the request.
	     *
	     * \@security Regular XHR is the safest alternative to JSONP for most applications, and is
	     * supported by all current browsers. Because JSONP creates a `<script>` element with
	     * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
	     * source could expose your application to XSS risks. Data exposed by JSONP may also be
	     * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
	     * future security issues (e.g. content sniffing).  For more detail, see the
	     * [Security Guide](http://g.co/ng/security).
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    Jsonp.prototype.request = /**
	     * Performs any type of http request. First argument is required, and can either be a url or
	     * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
	     * object can be provided as the 2nd argument. The options object will be merged with the values
	     * of {\@link BaseRequestOptions} before performing the request.
	     *
	     * \@security Regular XHR is the safest alternative to JSONP for most applications, and is
	     * supported by all current browsers. Because JSONP creates a `<script>` element with
	     * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
	     * source could expose your application to XSS risks. Data exposed by JSONP may also be
	     * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
	     * future security issues (e.g. content sniffing).  For more detail, see the
	     * [Security Guide](http://g.co/ng/security).
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        var /** @type {?} */ responseObservable;
	        if (typeof url === 'string') {
	            url =
	                new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, /** @type {?} */ (url)));
	        }
	        if (url instanceof Request) {
	            if (url.method !== RequestMethod.Get) {
	                throw new Error('JSONP requests must use GET request method.');
	            }
	            responseObservable = httpRequest(this._backend, url);
	        }
	        else {
	            throw new Error('First argument must be a url string or Request instance.');
	        }
	        return responseObservable;
	    };
	    Jsonp.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Jsonp.ctorParameters = function () { return [
	        { type: ConnectionBackend, },
	        { type: RequestOptions, },
	    ]; };
	    return Jsonp;
	}(Http));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @return {?}
	 */
	function _createDefaultCookieXSRFStrategy() {
	    return new CookieXSRFStrategy();
	}
	/**
	 * @param {?} xhrBackend
	 * @param {?} requestOptions
	 * @return {?}
	 */
	function httpFactory(xhrBackend, requestOptions) {
	    return new Http(xhrBackend, requestOptions);
	}
	/**
	 * @param {?} jsonpBackend
	 * @param {?} requestOptions
	 * @return {?}
	 */
	function jsonpFactory(jsonpBackend, requestOptions) {
	    return new Jsonp(jsonpBackend, requestOptions);
	}
	/**
	 * The module that includes http's providers
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var HttpModule = /** @class */ (function () {
	    function HttpModule() {
	    }
	    HttpModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        // TODO(pascal): use factory type annotations once supported in DI
	                        // issue: https://github.com/angular/angular/issues/3183
	                        { provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] },
	                        BrowserXhr,
	                        { provide: RequestOptions, useClass: BaseRequestOptions },
	                        { provide: ResponseOptions, useClass: BaseResponseOptions },
	                        XHRBackend,
	                        { provide: XSRFStrategy, useFactory: _createDefaultCookieXSRFStrategy },
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    HttpModule.ctorParameters = function () { return []; };
	    return HttpModule;
	}());
	/**
	 * The module that includes jsonp's providers
	 *
	 * @deprecated use \@angular/common/http instead
	 */
	var JsonpModule = /** @class */ (function () {
	    function JsonpModule() {
	    }
	    JsonpModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        // TODO(pascal): use factory type annotations once supported in DI
	                        // issue: https://github.com/angular/angular/issues/3183
	                        { provide: Jsonp, useFactory: jsonpFactory, deps: [JSONPBackend, RequestOptions] },
	                        BrowserJsonp,
	                        { provide: RequestOptions, useClass: BaseRequestOptions },
	                        { provide: ResponseOptions, useClass: BaseResponseOptions },
	                        JSONPBackend,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    JsonpModule.ctorParameters = function () { return []; };
	    return JsonpModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @deprecated use \@angular/common/http instead
	 */
	var VERSION = new _angular_core.Version('5.2.11');
	
	exports.BrowserXhr = BrowserXhr;
	exports.JSONPBackend = JSONPBackend;
	exports.JSONPConnection = JSONPConnection;
	exports.CookieXSRFStrategy = CookieXSRFStrategy;
	exports.XHRBackend = XHRBackend;
	exports.XHRConnection = XHRConnection;
	exports.BaseRequestOptions = BaseRequestOptions;
	exports.RequestOptions = RequestOptions;
	exports.BaseResponseOptions = BaseResponseOptions;
	exports.ResponseOptions = ResponseOptions;
	exports.ReadyState = ReadyState;
	exports.RequestMethod = RequestMethod;
	exports.ResponseContentType = ResponseContentType;
	exports.ResponseType = ResponseType;
	exports.Headers = Headers;
	exports.Http = Http;
	exports.Jsonp = Jsonp;
	exports.HttpModule = HttpModule;
	exports.JsonpModule = JsonpModule;
	exports.Connection = Connection;
	exports.ConnectionBackend = ConnectionBackend;
	exports.XSRFStrategy = XSRFStrategy;
	exports.Request = Request;
	exports.Response = Response;
	exports.QueryEncoder = QueryEncoder;
	exports.URLSearchParams = URLSearchParams;
	exports.VERSION = VERSION;
	exports.ɵe = BrowserJsonp;
	exports.ɵf = Body;
	exports.ɵa = _createDefaultCookieXSRFStrategy;
	exports.ɵb = httpFactory;
	exports.ɵc = jsonpFactory;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=http.umd.js.map


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),

/***/ 2607:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 2887:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(247);
	__webpack_require__(244);
	__webpack_require__(205);
	__webpack_require__(246);
	__webpack_require__(836);
	__webpack_require__(270);
	__webpack_require__(768);
	__webpack_require__(495);
	__webpack_require__(508);
	__webpack_require__(2888);
	__webpack_require__(2890);
	__webpack_require__(2893);
	__webpack_require__(2902);
	__webpack_require__(268);
	__webpack_require__(954);
	__webpack_require__(2977);
	__webpack_require__(2982);
	__webpack_require__(2984);
	// import './styles/bootstrap/js/dropdown.js' 


/***/ }),

/***/ 2888:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2889);


/***/ }),

/***/ 2889:
/***/ (function(module, exports) {

	/**
	 * Created by andrey on 01.06.16.
	 */
	
	module.exports = {
	    scripts: {
	        'transition': true,
	        'alert': false,
	        'button': true,
	        'carousel': false,
	        'collapse': true,
	        'dropdown': false,
	        'modal': false,
	        'tooltip': false,
	        'popover': false,
	        'scrollspy': false,
	        'tab': false,
	        'affix': false
	    },
	
	    styles: {
	        'mixins': true,
	
	        'normalize': true,
	        'print': true,
	
	        'scaffolding': true,
	        'type': true,
	        'code': true,
	        'grid': true,
	        'tables': true,
	        'forms': true,
	        'buttons': true,
	
	        'component-animations': true,
	        'glyphicons': true,
	        'dropdowns': true,
	        'button-groups': true,
	        'input-groups': true,
	        'navs': true,
	        'navbar': true,
	        'breadcrumbs': true,
	        'pagination': true,
	        'pager': true,
	        'labels': true,
	        'badges': true,
	        'jumbotron': true,
	        'thumbnails': true,
	        'alerts': true,
	        'progress-bars': true,
	        'media': true,
	        'list-group': true,
	        'panels': true,
	        'wells': true,
	        'close': true,
	
	        'modals': true,
	        'tooltip': true,
	        'popovers': true,
	        'carousel': false,
	
	        'utilities': true,
	        'responsive-utilities': true
	    }
	};


/***/ }),

/***/ 2890:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2891);


/***/ }),

/***/ 2891:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2893:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2894);


/***/ }),

/***/ 2894:
2891,

/***/ 2902:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2903);


/***/ }),

/***/ 2903:
2891,

/***/ 2977:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Created by andrey on 12.07.16.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2978);
	__webpack_require__(2980);


/***/ }),

/***/ 2978:
2891,

/***/ 2980:
2891,

/***/ 2982:
2891,

/***/ 2984:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(2985);


/***/ }),

/***/ 2985:
2891

});


// WEBPACK FOOTER //
// vendor.0000296aa510f63312a8.js